import "./style.css";
import { jsx as C, Fragment as gr, jsxs as Z } from "react/jsx-runtime";
import * as s from "react";
import ke, { useState as gt, useLayoutEffect as CS, useEffect as En, createElement as Yo, Component as ES, useRef as Ww } from "react";
import * as gs from "react-dom";
import D2 from "react-dom";
var bl = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ms(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function zw(t) {
  if (t.__esModule) return t;
  var e = t.default;
  if (typeof e == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    r.prototype = e.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(t).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(t, n);
    Object.defineProperty(r, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return t[n];
      }
    });
  }), r;
}
var Gw = {}, Uw = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "cloneDeep", {
    enumerable: !0,
    get: function() {
      return e;
    }
  });
  function e(r) {
    return Array.isArray(r) ? r.map((n) => e(n)) : typeof r == "object" && r !== null ? Object.fromEntries(Object.entries(r).map(([n, a]) => [
      n,
      e(a)
    ])) : r;
  }
})(Uw);
var SS = {
  content: [],
  presets: [],
  darkMode: "media",
  // or 'class'
  theme: {
    accentColor: ({ theme: t }) => ({
      ...t("colors"),
      auto: "auto"
    }),
    animation: {
      none: "none",
      spin: "spin 1s linear infinite",
      ping: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
      pulse: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
      bounce: "bounce 1s infinite"
    },
    aria: {
      busy: 'busy="true"',
      checked: 'checked="true"',
      disabled: 'disabled="true"',
      expanded: 'expanded="true"',
      hidden: 'hidden="true"',
      pressed: 'pressed="true"',
      readonly: 'readonly="true"',
      required: 'required="true"',
      selected: 'selected="true"'
    },
    aspectRatio: {
      auto: "auto",
      square: "1 / 1",
      video: "16 / 9"
    },
    backdropBlur: ({ theme: t }) => t("blur"),
    backdropBrightness: ({ theme: t }) => t("brightness"),
    backdropContrast: ({ theme: t }) => t("contrast"),
    backdropGrayscale: ({ theme: t }) => t("grayscale"),
    backdropHueRotate: ({ theme: t }) => t("hueRotate"),
    backdropInvert: ({ theme: t }) => t("invert"),
    backdropOpacity: ({ theme: t }) => t("opacity"),
    backdropSaturate: ({ theme: t }) => t("saturate"),
    backdropSepia: ({ theme: t }) => t("sepia"),
    backgroundColor: ({ theme: t }) => t("colors"),
    backgroundImage: {
      none: "none",
      "gradient-to-t": "linear-gradient(to top, var(--tw-gradient-stops))",
      "gradient-to-tr": "linear-gradient(to top right, var(--tw-gradient-stops))",
      "gradient-to-r": "linear-gradient(to right, var(--tw-gradient-stops))",
      "gradient-to-br": "linear-gradient(to bottom right, var(--tw-gradient-stops))",
      "gradient-to-b": "linear-gradient(to bottom, var(--tw-gradient-stops))",
      "gradient-to-bl": "linear-gradient(to bottom left, var(--tw-gradient-stops))",
      "gradient-to-l": "linear-gradient(to left, var(--tw-gradient-stops))",
      "gradient-to-tl": "linear-gradient(to top left, var(--tw-gradient-stops))"
    },
    backgroundOpacity: ({ theme: t }) => t("opacity"),
    backgroundPosition: {
      bottom: "bottom",
      center: "center",
      left: "left",
      "left-bottom": "left bottom",
      "left-top": "left top",
      right: "right",
      "right-bottom": "right bottom",
      "right-top": "right top",
      top: "top"
    },
    backgroundSize: {
      auto: "auto",
      cover: "cover",
      contain: "contain"
    },
    blur: {
      0: "0",
      none: "",
      sm: "4px",
      DEFAULT: "8px",
      md: "12px",
      lg: "16px",
      xl: "24px",
      "2xl": "40px",
      "3xl": "64px"
    },
    borderColor: ({ theme: t }) => ({
      ...t("colors"),
      DEFAULT: t("colors.gray.200", "currentColor")
    }),
    borderOpacity: ({ theme: t }) => t("opacity"),
    borderRadius: {
      none: "0px",
      sm: "0.125rem",
      DEFAULT: "0.25rem",
      md: "0.375rem",
      lg: "0.5rem",
      xl: "0.75rem",
      "2xl": "1rem",
      "3xl": "1.5rem",
      full: "9999px"
    },
    borderSpacing: ({ theme: t }) => ({
      ...t("spacing")
    }),
    borderWidth: {
      DEFAULT: "1px",
      0: "0px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    boxShadow: {
      sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
      md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
      "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
      inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
      none: "none"
    },
    boxShadowColor: ({ theme: t }) => t("colors"),
    brightness: {
      0: "0",
      50: ".5",
      75: ".75",
      90: ".9",
      95: ".95",
      100: "1",
      105: "1.05",
      110: "1.1",
      125: "1.25",
      150: "1.5",
      200: "2"
    },
    caretColor: ({ theme: t }) => t("colors"),
    colors: ({ colors: t }) => ({
      inherit: t.inherit,
      current: t.current,
      transparent: t.transparent,
      black: t.black,
      white: t.white,
      slate: t.slate,
      gray: t.gray,
      zinc: t.zinc,
      neutral: t.neutral,
      stone: t.stone,
      red: t.red,
      orange: t.orange,
      amber: t.amber,
      yellow: t.yellow,
      lime: t.lime,
      green: t.green,
      emerald: t.emerald,
      teal: t.teal,
      cyan: t.cyan,
      sky: t.sky,
      blue: t.blue,
      indigo: t.indigo,
      violet: t.violet,
      purple: t.purple,
      fuchsia: t.fuchsia,
      pink: t.pink,
      rose: t.rose
    }),
    columns: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      "3xs": "16rem",
      "2xs": "18rem",
      xs: "20rem",
      sm: "24rem",
      md: "28rem",
      lg: "32rem",
      xl: "36rem",
      "2xl": "42rem",
      "3xl": "48rem",
      "4xl": "56rem",
      "5xl": "64rem",
      "6xl": "72rem",
      "7xl": "80rem"
    },
    container: {},
    content: {
      none: "none"
    },
    contrast: {
      0: "0",
      50: ".5",
      75: ".75",
      100: "1",
      125: "1.25",
      150: "1.5",
      200: "2"
    },
    cursor: {
      auto: "auto",
      default: "default",
      pointer: "pointer",
      wait: "wait",
      text: "text",
      move: "move",
      help: "help",
      "not-allowed": "not-allowed",
      none: "none",
      "context-menu": "context-menu",
      progress: "progress",
      cell: "cell",
      crosshair: "crosshair",
      "vertical-text": "vertical-text",
      alias: "alias",
      copy: "copy",
      "no-drop": "no-drop",
      grab: "grab",
      grabbing: "grabbing",
      "all-scroll": "all-scroll",
      "col-resize": "col-resize",
      "row-resize": "row-resize",
      "n-resize": "n-resize",
      "e-resize": "e-resize",
      "s-resize": "s-resize",
      "w-resize": "w-resize",
      "ne-resize": "ne-resize",
      "nw-resize": "nw-resize",
      "se-resize": "se-resize",
      "sw-resize": "sw-resize",
      "ew-resize": "ew-resize",
      "ns-resize": "ns-resize",
      "nesw-resize": "nesw-resize",
      "nwse-resize": "nwse-resize",
      "zoom-in": "zoom-in",
      "zoom-out": "zoom-out"
    },
    divideColor: ({ theme: t }) => t("borderColor"),
    divideOpacity: ({ theme: t }) => t("borderOpacity"),
    divideWidth: ({ theme: t }) => t("borderWidth"),
    dropShadow: {
      sm: "0 1px 1px rgb(0 0 0 / 0.05)",
      DEFAULT: ["0 1px 2px rgb(0 0 0 / 0.1)", "0 1px 1px rgb(0 0 0 / 0.06)"],
      md: ["0 4px 3px rgb(0 0 0 / 0.07)", "0 2px 2px rgb(0 0 0 / 0.06)"],
      lg: ["0 10px 8px rgb(0 0 0 / 0.04)", "0 4px 3px rgb(0 0 0 / 0.1)"],
      xl: ["0 20px 13px rgb(0 0 0 / 0.03)", "0 8px 5px rgb(0 0 0 / 0.08)"],
      "2xl": "0 25px 25px rgb(0 0 0 / 0.15)",
      none: "0 0 #0000"
    },
    fill: ({ theme: t }) => ({
      none: "none",
      ...t("colors")
    }),
    flex: {
      1: "1 1 0%",
      auto: "1 1 auto",
      initial: "0 1 auto",
      none: "none"
    },
    flexBasis: ({ theme: t }) => ({
      auto: "auto",
      ...t("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%"
    }),
    flexGrow: {
      0: "0",
      DEFAULT: "1"
    },
    flexShrink: {
      0: "0",
      DEFAULT: "1"
    },
    fontFamily: {
      sans: [
        "ui-sans-serif",
        "system-ui",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
        '"Noto Color Emoji"'
      ],
      serif: ["ui-serif", "Georgia", "Cambria", '"Times New Roman"', "Times", "serif"],
      mono: [
        "ui-monospace",
        "SFMono-Regular",
        "Menlo",
        "Monaco",
        "Consolas",
        '"Liberation Mono"',
        '"Courier New"',
        "monospace"
      ]
    },
    fontSize: {
      xs: ["0.75rem", { lineHeight: "1rem" }],
      sm: ["0.875rem", { lineHeight: "1.25rem" }],
      base: ["1rem", { lineHeight: "1.5rem" }],
      lg: ["1.125rem", { lineHeight: "1.75rem" }],
      xl: ["1.25rem", { lineHeight: "1.75rem" }],
      "2xl": ["1.5rem", { lineHeight: "2rem" }],
      "3xl": ["1.875rem", { lineHeight: "2.25rem" }],
      "4xl": ["2.25rem", { lineHeight: "2.5rem" }],
      "5xl": ["3rem", { lineHeight: "1" }],
      "6xl": ["3.75rem", { lineHeight: "1" }],
      "7xl": ["4.5rem", { lineHeight: "1" }],
      "8xl": ["6rem", { lineHeight: "1" }],
      "9xl": ["8rem", { lineHeight: "1" }]
    },
    fontWeight: {
      thin: "100",
      extralight: "200",
      light: "300",
      normal: "400",
      medium: "500",
      semibold: "600",
      bold: "700",
      extrabold: "800",
      black: "900"
    },
    gap: ({ theme: t }) => t("spacing"),
    gradientColorStops: ({ theme: t }) => t("colors"),
    gradientColorStopPositions: {
      "0%": "0%",
      "5%": "5%",
      "10%": "10%",
      "15%": "15%",
      "20%": "20%",
      "25%": "25%",
      "30%": "30%",
      "35%": "35%",
      "40%": "40%",
      "45%": "45%",
      "50%": "50%",
      "55%": "55%",
      "60%": "60%",
      "65%": "65%",
      "70%": "70%",
      "75%": "75%",
      "80%": "80%",
      "85%": "85%",
      "90%": "90%",
      "95%": "95%",
      "100%": "100%"
    },
    grayscale: {
      0: "0",
      DEFAULT: "100%"
    },
    gridAutoColumns: {
      auto: "auto",
      min: "min-content",
      max: "max-content",
      fr: "minmax(0, 1fr)"
    },
    gridAutoRows: {
      auto: "auto",
      min: "min-content",
      max: "max-content",
      fr: "minmax(0, 1fr)"
    },
    gridColumn: {
      auto: "auto",
      "span-1": "span 1 / span 1",
      "span-2": "span 2 / span 2",
      "span-3": "span 3 / span 3",
      "span-4": "span 4 / span 4",
      "span-5": "span 5 / span 5",
      "span-6": "span 6 / span 6",
      "span-7": "span 7 / span 7",
      "span-8": "span 8 / span 8",
      "span-9": "span 9 / span 9",
      "span-10": "span 10 / span 10",
      "span-11": "span 11 / span 11",
      "span-12": "span 12 / span 12",
      "span-full": "1 / -1"
    },
    gridColumnEnd: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridColumnStart: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridRow: {
      auto: "auto",
      "span-1": "span 1 / span 1",
      "span-2": "span 2 / span 2",
      "span-3": "span 3 / span 3",
      "span-4": "span 4 / span 4",
      "span-5": "span 5 / span 5",
      "span-6": "span 6 / span 6",
      "span-7": "span 7 / span 7",
      "span-8": "span 8 / span 8",
      "span-9": "span 9 / span 9",
      "span-10": "span 10 / span 10",
      "span-11": "span 11 / span 11",
      "span-12": "span 12 / span 12",
      "span-full": "1 / -1"
    },
    gridRowEnd: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridRowStart: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridTemplateColumns: {
      none: "none",
      subgrid: "subgrid",
      1: "repeat(1, minmax(0, 1fr))",
      2: "repeat(2, minmax(0, 1fr))",
      3: "repeat(3, minmax(0, 1fr))",
      4: "repeat(4, minmax(0, 1fr))",
      5: "repeat(5, minmax(0, 1fr))",
      6: "repeat(6, minmax(0, 1fr))",
      7: "repeat(7, minmax(0, 1fr))",
      8: "repeat(8, minmax(0, 1fr))",
      9: "repeat(9, minmax(0, 1fr))",
      10: "repeat(10, minmax(0, 1fr))",
      11: "repeat(11, minmax(0, 1fr))",
      12: "repeat(12, minmax(0, 1fr))"
    },
    gridTemplateRows: {
      none: "none",
      subgrid: "subgrid",
      1: "repeat(1, minmax(0, 1fr))",
      2: "repeat(2, minmax(0, 1fr))",
      3: "repeat(3, minmax(0, 1fr))",
      4: "repeat(4, minmax(0, 1fr))",
      5: "repeat(5, minmax(0, 1fr))",
      6: "repeat(6, minmax(0, 1fr))",
      7: "repeat(7, minmax(0, 1fr))",
      8: "repeat(8, minmax(0, 1fr))",
      9: "repeat(9, minmax(0, 1fr))",
      10: "repeat(10, minmax(0, 1fr))",
      11: "repeat(11, minmax(0, 1fr))",
      12: "repeat(12, minmax(0, 1fr))"
    },
    height: ({ theme: t }) => ({
      auto: "auto",
      ...t("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      full: "100%",
      screen: "100vh",
      svh: "100svh",
      lvh: "100lvh",
      dvh: "100dvh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    hueRotate: {
      0: "0deg",
      15: "15deg",
      30: "30deg",
      60: "60deg",
      90: "90deg",
      180: "180deg"
    },
    inset: ({ theme: t }) => ({
      auto: "auto",
      ...t("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      full: "100%"
    }),
    invert: {
      0: "0",
      DEFAULT: "100%"
    },
    keyframes: {
      spin: {
        to: {
          transform: "rotate(360deg)"
        }
      },
      ping: {
        "75%, 100%": {
          transform: "scale(2)",
          opacity: "0"
        }
      },
      pulse: {
        "50%": {
          opacity: ".5"
        }
      },
      bounce: {
        "0%, 100%": {
          transform: "translateY(-25%)",
          animationTimingFunction: "cubic-bezier(0.8,0,1,1)"
        },
        "50%": {
          transform: "none",
          animationTimingFunction: "cubic-bezier(0,0,0.2,1)"
        }
      }
    },
    letterSpacing: {
      tighter: "-0.05em",
      tight: "-0.025em",
      normal: "0em",
      wide: "0.025em",
      wider: "0.05em",
      widest: "0.1em"
    },
    lineHeight: {
      none: "1",
      tight: "1.25",
      snug: "1.375",
      normal: "1.5",
      relaxed: "1.625",
      loose: "2",
      3: ".75rem",
      4: "1rem",
      5: "1.25rem",
      6: "1.5rem",
      7: "1.75rem",
      8: "2rem",
      9: "2.25rem",
      10: "2.5rem"
    },
    listStyleType: {
      none: "none",
      disc: "disc",
      decimal: "decimal"
    },
    listStyleImage: {
      none: "none"
    },
    margin: ({ theme: t }) => ({
      auto: "auto",
      ...t("spacing")
    }),
    lineClamp: {
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6"
    },
    maxHeight: ({ theme: t }) => ({
      ...t("spacing"),
      none: "none",
      full: "100%",
      screen: "100vh",
      svh: "100svh",
      lvh: "100lvh",
      dvh: "100dvh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    maxWidth: ({ theme: t, breakpoints: e }) => ({
      ...t("spacing"),
      none: "none",
      xs: "20rem",
      sm: "24rem",
      md: "28rem",
      lg: "32rem",
      xl: "36rem",
      "2xl": "42rem",
      "3xl": "48rem",
      "4xl": "56rem",
      "5xl": "64rem",
      "6xl": "72rem",
      "7xl": "80rem",
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content",
      prose: "65ch",
      ...e(t("screens"))
    }),
    minHeight: ({ theme: t }) => ({
      ...t("spacing"),
      full: "100%",
      screen: "100vh",
      svh: "100svh",
      lvh: "100lvh",
      dvh: "100dvh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    minWidth: ({ theme: t }) => ({
      ...t("spacing"),
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    objectPosition: {
      bottom: "bottom",
      center: "center",
      left: "left",
      "left-bottom": "left bottom",
      "left-top": "left top",
      right: "right",
      "right-bottom": "right bottom",
      "right-top": "right top",
      top: "top"
    },
    opacity: {
      0: "0",
      5: "0.05",
      10: "0.1",
      15: "0.15",
      20: "0.2",
      25: "0.25",
      30: "0.3",
      35: "0.35",
      40: "0.4",
      45: "0.45",
      50: "0.5",
      55: "0.55",
      60: "0.6",
      65: "0.65",
      70: "0.7",
      75: "0.75",
      80: "0.8",
      85: "0.85",
      90: "0.9",
      95: "0.95",
      100: "1"
    },
    order: {
      first: "-9999",
      last: "9999",
      none: "0",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12"
    },
    outlineColor: ({ theme: t }) => t("colors"),
    outlineOffset: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    outlineWidth: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    padding: ({ theme: t }) => t("spacing"),
    placeholderColor: ({ theme: t }) => t("colors"),
    placeholderOpacity: ({ theme: t }) => t("opacity"),
    ringColor: ({ theme: t }) => ({
      DEFAULT: t("colors.blue.500", "#3b82f6"),
      ...t("colors")
    }),
    ringOffsetColor: ({ theme: t }) => t("colors"),
    ringOffsetWidth: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    ringOpacity: ({ theme: t }) => ({
      DEFAULT: "0.5",
      ...t("opacity")
    }),
    ringWidth: {
      DEFAULT: "3px",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    rotate: {
      0: "0deg",
      1: "1deg",
      2: "2deg",
      3: "3deg",
      6: "6deg",
      12: "12deg",
      45: "45deg",
      90: "90deg",
      180: "180deg"
    },
    saturate: {
      0: "0",
      50: ".5",
      100: "1",
      150: "1.5",
      200: "2"
    },
    scale: {
      0: "0",
      50: ".5",
      75: ".75",
      90: ".9",
      95: ".95",
      100: "1",
      105: "1.05",
      110: "1.1",
      125: "1.25",
      150: "1.5"
    },
    screens: {
      sm: "640px",
      md: "768px",
      lg: "1024px",
      xl: "1280px",
      "2xl": "1536px"
    },
    scrollMargin: ({ theme: t }) => ({
      ...t("spacing")
    }),
    scrollPadding: ({ theme: t }) => t("spacing"),
    sepia: {
      0: "0",
      DEFAULT: "100%"
    },
    skew: {
      0: "0deg",
      1: "1deg",
      2: "2deg",
      3: "3deg",
      6: "6deg",
      12: "12deg"
    },
    space: ({ theme: t }) => ({
      ...t("spacing")
    }),
    spacing: {
      px: "1px",
      0: "0px",
      0.5: "0.125rem",
      1: "0.25rem",
      1.5: "0.375rem",
      2: "0.5rem",
      2.5: "0.625rem",
      3: "0.75rem",
      3.5: "0.875rem",
      4: "1rem",
      5: "1.25rem",
      6: "1.5rem",
      7: "1.75rem",
      8: "2rem",
      9: "2.25rem",
      10: "2.5rem",
      11: "2.75rem",
      12: "3rem",
      14: "3.5rem",
      16: "4rem",
      20: "5rem",
      24: "6rem",
      28: "7rem",
      32: "8rem",
      36: "9rem",
      40: "10rem",
      44: "11rem",
      48: "12rem",
      52: "13rem",
      56: "14rem",
      60: "15rem",
      64: "16rem",
      72: "18rem",
      80: "20rem",
      96: "24rem"
    },
    stroke: ({ theme: t }) => ({
      none: "none",
      ...t("colors")
    }),
    strokeWidth: {
      0: "0",
      1: "1",
      2: "2"
    },
    supports: {},
    data: {},
    textColor: ({ theme: t }) => t("colors"),
    textDecorationColor: ({ theme: t }) => t("colors"),
    textDecorationThickness: {
      auto: "auto",
      "from-font": "from-font",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    textIndent: ({ theme: t }) => ({
      ...t("spacing")
    }),
    textOpacity: ({ theme: t }) => t("opacity"),
    textUnderlineOffset: {
      auto: "auto",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    transformOrigin: {
      center: "center",
      top: "top",
      "top-right": "top right",
      right: "right",
      "bottom-right": "bottom right",
      bottom: "bottom",
      "bottom-left": "bottom left",
      left: "left",
      "top-left": "top left"
    },
    transitionDelay: {
      0: "0s",
      75: "75ms",
      100: "100ms",
      150: "150ms",
      200: "200ms",
      300: "300ms",
      500: "500ms",
      700: "700ms",
      1e3: "1000ms"
    },
    transitionDuration: {
      DEFAULT: "150ms",
      0: "0s",
      75: "75ms",
      100: "100ms",
      150: "150ms",
      200: "200ms",
      300: "300ms",
      500: "500ms",
      700: "700ms",
      1e3: "1000ms"
    },
    transitionProperty: {
      none: "none",
      all: "all",
      DEFAULT: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
      colors: "color, background-color, border-color, text-decoration-color, fill, stroke",
      opacity: "opacity",
      shadow: "box-shadow",
      transform: "transform"
    },
    transitionTimingFunction: {
      DEFAULT: "cubic-bezier(0.4, 0, 0.2, 1)",
      linear: "linear",
      in: "cubic-bezier(0.4, 0, 1, 1)",
      out: "cubic-bezier(0, 0, 0.2, 1)",
      "in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
    },
    translate: ({ theme: t }) => ({
      ...t("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      full: "100%"
    }),
    size: ({ theme: t }) => ({
      auto: "auto",
      ...t("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    width: ({ theme: t }) => ({
      auto: "auto",
      ...t("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%",
      screen: "100vw",
      svw: "100svw",
      lvw: "100lvw",
      dvw: "100dvw",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    willChange: {
      auto: "auto",
      scroll: "scroll-position",
      contents: "contents",
      transform: "transform"
    },
    zIndex: {
      auto: "auto",
      0: "0",
      10: "10",
      20: "20",
      30: "30",
      40: "40",
      50: "50"
    }
  },
  plugins: []
};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "default", {
    enumerable: !0,
    get: function() {
      return a;
    }
  });
  const e = Uw, r = /* @__PURE__ */ n(SS);
  function n(o) {
    return o && o.__esModule ? o : {
      default: o
    };
  }
  const a = (0, e.cloneDeep)(r.default.theme);
})(Gw);
let y5 = Gw;
var RS = (y5.__esModule ? y5 : { default: y5 }).default;
const MS = /* @__PURE__ */ ms(RS);
var Yw = {}, Xw = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "default", {
    enumerable: !0,
    get: function() {
      return r;
    }
  });
  function e(n, a) {
    return {
      handler: n,
      config: a
    };
  }
  e.withOptions = function(n, a = () => ({})) {
    const o = function(i) {
      return {
        __options: i,
        handler: n(i),
        config: a(i)
      };
    };
    return o.__isOptionsFunction = !0, o.__pluginFunction = n, o.__configFunction = a, o;
  };
  const r = e;
})(Xw);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "default", {
    enumerable: !0,
    get: function() {
      return n;
    }
  });
  const e = /* @__PURE__ */ r(Xw);
  function r(a) {
    return a && a.__esModule ? a : {
      default: a
    };
  }
  const n = e.default;
})(Yw);
let b5 = Yw;
var AS = (b5.__esModule ? b5 : { default: b5 }).default;
const kS = /* @__PURE__ */ ms(AS), LS = {
  brand: {
    primary: {
      0: {
        hex: "#00DF7C",
        id: "L100"
      },
      10: {
        hex: "#E6F9DC",
        id: "L90"
      },
      20: {
        hex: "#BEF4C1",
        id: "L80"
      },
      30: {
        hex: "#96E9B6",
        id: "L70"
      },
      35: {
        hex: "#009954",
        id: "L35"
      },
      40: {
        hex: "#55EC8F",
        id: "L60"
      },
      50: {
        hex: "#19E58A",
        id: "L50"
      },
      60: {
        hex: "#00BF6A",
        id: "L40"
      },
      70: {
        hex: "#008C4C",
        id: "L30"
      },
      90: {
        hex: "#005931",
        id: "L20"
      }
    },
    secondary: {
      0: {
        hex: "#4787FF",
        id: "L100"
      },
      10: {
        hex: "#CFDFFC",
        id: "L90"
      },
      20: {
        hex: "#80ACFF",
        id: "L80"
      },
      30: {
        hex: "#0047CC",
        id: "L70"
      },
      40: {
        hex: "#002C80",
        id: "L60"
      }
    },
    gray: {
      10: {
        hex: "#E8E8E8",
        id: "L90"
      },
      20: {
        hex: "#C5C5C5",
        id: "L80"
      },
      30: {
        hex: "#9C9C9B",
        id: "L70"
      },
      40: {
        hex: "#818181",
        id: "L60"
      },
      50: {
        hex: "#595959",
        id: "L50"
      },
      60: {
        hex: "#404040",
        id: "L40"
      },
      70: {
        hex: "#2E2E2E",
        id: "L30"
      },
      80: {
        hex: "#222222",
        id: "L20"
      }
    },
    light: {
      10: {
        hex: "#FFFFFF",
        id: "L90"
      },
      20: {
        hex: "#FAFAFA",
        id: "L80"
      },
      30: {
        hex: "#F2F2F2",
        id: "L70"
      }
    }
  },
  palette: {
    yellow: {
      10: {
        hex: "#FFF6E0",
        id: "L90"
      },
      20: {
        hex: "#FFD97A",
        id: "L80"
      },
      30: {
        hex: "#FFBC14",
        id: "L70"
      },
      40: {
        hex: "#E0A000",
        id: "L60"
      },
      50: {
        hex: "#AD7C00",
        id: "L50"
      }
    },
    orange: {
      10: {
        hex: "#FFD4CC",
        id: "L90"
      },
      20: {
        hex: "#F5B0A3",
        id: "L80"
      },
      30: {
        hex: "#FF6347",
        id: "L70"
      },
      40: {
        hex: "#E5391A",
        id: "L60"
      },
      50: {
        hex: "#991700",
        id: "L50"
      }
    },
    pink: {
      0: {
        hex: "#FF158A",
        id: "LNS"
      }
    },
    opacity: {
      25: {
        value: 25,
        id: "L90"
      }
    }
  }
}, TS = {
  weight: {
    light: 300,
    regular: 400,
    bold: 700,
    black: 800
  },
  display: {
    fontFamily: "Poppins",
    xLarge: {
      fontSize: 72
    },
    large: {
      fontSize: 64
    },
    medium: {
      fontSize: 56
    },
    small: {
      fontSize: 48
    }
  },
  heading: {
    fontFamily: "Poppins",
    xxLarge: {
      fontSize: 36
    },
    xLarge: {
      fontSize: 32
    },
    large: {
      fontSize: 28
    },
    medium: {
      fontSize: 24
    },
    small: {
      fontSize: 20
    },
    xSmall: {
      fontSize: 18
    }
  },
  paragraph: {
    fontFamily: "Poppins",
    large: {
      fontSize: 16
    },
    medium: {
      fontSize: 14
    },
    small: {
      fontSize: 12
    }
  },
  caption: {
    fontFamily: "Poppins",
    medium: {
      fontSize: 10
    },
    small: {
      fontSize: 8
    }
  }
}, OS = {
  small: 10,
  medium: 20,
  pill: 1e3
}, IS = {
  green: "0px 0px 0px 2px #FAFAFA, 0px 0px 0px 3px #00DF7C",
  orange: "0px 0px 0px 2px #FAFAFA, 0px 0px 0px 3px #FF6347",
  softGray: "0px 0px 0px 1px #E8E8E8",
  gray: "0px 0px 0px 2px #FAFAFA, 0px 0px 0px 3px #C5C5C5;",
  fabElevation: "1px 1px 4px 0px rgba(34, 34, 34, 0.15)",
  dark: "0px 0px 0px 2px #2E2E2E, 0px 0px 0px 3px #818181",
  darkGray: "0px 0px 0px 1px #595959, 0px 0px 0px 1px #595959",
  insetBorderWhite: "inset 0 0 0 1px #FAFAFA",
  insetBorderGray: "inset 0 0 0 1px #C5C5C5",
  insetBorderGreen: "inset 0 0 0 1px #00DF7C",
  insetBorderOrange: "inset 0 0 0 1px #FF6347",
  insetBorderBlack: "inset 0 0 0 1px #222222"
}, PS = {
  extraThin: 0.5,
  thin: 1,
  thick: 2
}, DS = {
  1: 0.5,
  2: 1,
  3: 1.5,
  4: 2,
  5: 2.5,
  6: 3,
  7: 3.5,
  8: 4,
  9: 4.5,
  10: 5,
  11: 5.5,
  12: 6,
  13: 6.5,
  14: 7,
  15: 7.5,
  16: 8
}, NS = {
  "@keyframes slideUpAndFade": {
    from: {
      opacity: 0,
      transform: "translateY(2px)"
    },
    to: {
      opacity: 1,
      transform: "translateY(0)"
    }
  }
}, BS = [
  {
    name: "mobile",
    size: "382x800",
    width: 382,
    height: 800
  },
  {
    name: "tablet",
    size: "703x768",
    width: 703,
    height: 768
  },
  {
    name: "notebook",
    size: "959x768",
    width: 959,
    height: 768
  },
  {
    name: "desktop",
    size: "1135x688",
    width: 1135,
    height: 688
  },
  {
    name: "largeDesktop",
    size: "1128x880",
    width: 1128,
    height: 880
  }
], fo = {
  colors: LS,
  typography: TS,
  border: OS,
  shadow: IS,
  line: PS,
  padding: DS,
  styles: NS,
  resolutions: BS
}, qw = fo.resolutions.reduce((t, e) => (t[e.name] = `${e.width}px`, t), {}), FS = fo.colors, $S = (t) => {
  const e = {};
  for (const r in t) {
    const n = t[r];
    for (const a in n) {
      const o = {};
      for (const i in n[a])
        o[i] = n[a][i].hex;
      e[a] = o;
    }
  }
  return e;
}, VS = fo.typography, ZS = (t) => {
  const e = {};
  for (const r in t) {
    const n = t[r];
    Object.keys(n).filter((o) => o !== "fontFamily").forEach((o) => {
      e[`${r}-${o}`] = [`${n[o].fontSize}px`, n[o].fontWeight];
    });
  }
  return e;
}, HS = fo.line, jS = (t) => {
  const e = {};
  for (const r in t)
    e[r] = `${t[r]}px`;
  return e;
}, WS = fo.border, zS = (t) => {
  const e = {};
  for (const r in t)
    e[r] = `${t[r]}px`;
  return e;
}, GS = fo.shadow, US = (t) => {
  const e = {};
  for (const r in t)
    e[r] = `${t[r]}`;
  return e;
}, YS = fo.spacing, XS = (t) => {
  const e = {};
  for (const r in t)
    e[r] = `${t[r]}px`;
  return e;
}, at = {
  colors: $S(FS),
  fontFamily: {
    sans: ['"Poppins"', ...MS.fontFamily.sans]
  },
  fontSize: ZS(VS),
  borderWidth: jS(HS),
  borderRadius: zS(WS),
  boxShadow: US(GS),
  spacing: XS(YS),
  screens: qw
}, qS = [
  {
    pattern: /^(text|bg|border|ring|outline|fill|stroke)-(primary|secondary|gray|light|yellow|orange|blue|pink|opacity)[^/]+$/,
    variants: ["hover", "active", "disabled", "focus"]
  },
  { pattern: /font-(normal|light|regular|bold|black)/ },
  { pattern: /text-(caption|paragraph|heading|display)-.+/ },
  { pattern: /border-b-.+/ },
  { pattern: /rounded(-.{1,2})?-(small|medium|pill)/ },
  { pattern: /shadow-.+/ },
  { pattern: /space-.+/ },
  { pattern: /(p|m).?-.+/ },
  ...Object.keys(qw).map((t) => `screen-${t}`)
], KS = kS(
  function() {
  },
  { theme: { extend: at } }
), i6e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fotonPlugin: KS,
  safelist: qS,
  themeDefinition: at
}, Symbol.toStringTag, { value: "Module" }));
function QS({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M11.7 2.805a.75.75 0 0 1 .6 0A60.65 60.65 0 0 1 22.83 8.72a.75.75 0 0 1-.231 1.337 49.948 49.948 0 0 0-9.902 3.912l-.003.002c-.114.06-.227.119-.34.18a.75.75 0 0 1-.707 0A50.88 50.88 0 0 0 7.5 12.173v-.224c0-.131.067-.248.172-.311a54.615 54.615 0 0 1 4.653-2.52.75.75 0 0 0-.65-1.352 56.123 56.123 0 0 0-4.78 2.589 1.858 1.858 0 0 0-.859 1.228 49.803 49.803 0 0 0-4.634-1.527.75.75 0 0 1-.231-1.337A60.653 60.653 0 0 1 11.7 2.805Z"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M13.06 15.473a48.45 48.45 0 0 1 7.666-3.282c.134 1.414.22 2.843.255 4.284a.75.75 0 0 1-.46.711 47.87 47.87 0 0 0-8.105 4.342.75.75 0 0 1-.832 0 47.87 47.87 0 0 0-8.104-4.342.75.75 0 0 1-.461-.71c.035-1.442.121-2.87.255-4.286.921.304 1.83.634 2.726.99v1.27a1.5 1.5 0 0 0-.14 2.508c-.09.38-.222.753-.397 1.11.452.213.901.434 1.346.66a6.727 6.727 0 0 0 .551-1.607 1.5 1.5 0 0 0 .14-2.67v-.645a48.549 48.549 0 0 1 3.44 1.667 2.25 2.25 0 0 0 2.12 0Z"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M4.462 19.462c.42-.419.753-.89 1-1.395.453.214.902.435 1.347.662a6.742 6.742 0 0 1-1.286 1.794.75.75 0 0 1-1.06-1.06Z"
  }));
}
const JS = /* @__PURE__ */ s.forwardRef(QS);
function eR({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M18.75 12.75h1.5a.75.75 0 0 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5ZM12 6a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 12 6ZM12 18a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 12 18ZM3.75 6.75h1.5a.75.75 0 1 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5ZM5.25 18.75h-1.5a.75.75 0 0 1 0-1.5h1.5a.75.75 0 0 1 0 1.5ZM3 12a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 3 12ZM9 3.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM12.75 12a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0ZM9 15.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Z"
  }));
}
const tR = /* @__PURE__ */ s.forwardRef(eR);
function rR({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M6 12a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 1 1 1.5 0v7.5A.75.75 0 0 1 6 12ZM18 12a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 0 1 1.5 0v7.5A.75.75 0 0 1 18 12ZM6.75 20.25v-1.5a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0ZM18.75 18.75v1.5a.75.75 0 0 1-1.5 0v-1.5a.75.75 0 0 1 1.5 0ZM12.75 5.25v-1.5a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0ZM12 21a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 0 1 1.5 0v7.5A.75.75 0 0 1 12 21ZM3.75 15a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 0 0-4.5 0ZM12 11.25a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5ZM15.75 15a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 0 0-4.5 0Z"
  }));
}
const nR = /* @__PURE__ */ s.forwardRef(rR);
function aR({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M3.375 3C2.339 3 1.5 3.84 1.5 4.875v.75c0 1.036.84 1.875 1.875 1.875h17.25c1.035 0 1.875-.84 1.875-1.875v-.75C22.5 3.839 21.66 3 20.625 3H3.375Z"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "m3.087 9 .54 9.176A3 3 0 0 0 6.62 21h10.757a3 3 0 0 0 2.995-2.824L20.913 9H3.087ZM12 10.5a.75.75 0 0 1 .75.75v4.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 1 1 1.06-1.06l1.72 1.72v-4.94a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  }));
}
const oR = /* @__PURE__ */ s.forwardRef(aR);
function iR({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M3.375 3C2.339 3 1.5 3.84 1.5 4.875v.75c0 1.036.84 1.875 1.875 1.875h17.25c1.035 0 1.875-.84 1.875-1.875v-.75C22.5 3.839 21.66 3 20.625 3H3.375Z"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "m3.087 9 .54 9.176A3 3 0 0 0 6.62 21h10.757a3 3 0 0 0 2.995-2.824L20.913 9H3.087Zm6.133 2.845a.75.75 0 0 1 1.06 0l1.72 1.72 1.72-1.72a.75.75 0 1 1 1.06 1.06l-1.72 1.72 1.72 1.72a.75.75 0 1 1-1.06 1.06L12 15.685l-1.72 1.72a.75.75 0 1 1-1.06-1.06l1.72-1.72-1.72-1.72a.75.75 0 0 1 0-1.06Z",
    clipRule: "evenodd"
  }));
}
const lR = /* @__PURE__ */ s.forwardRef(iR);
function sR({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M3.375 3C2.339 3 1.5 3.84 1.5 4.875v.75c0 1.036.84 1.875 1.875 1.875h17.25c1.035 0 1.875-.84 1.875-1.875v-.75C22.5 3.839 21.66 3 20.625 3H3.375Z"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "m3.087 9 .54 9.176A3 3 0 0 0 6.62 21h10.757a3 3 0 0 0 2.995-2.824L20.913 9H3.087Zm6.163 3.75A.75.75 0 0 1 10 12h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  }));
}
const cR = /* @__PURE__ */ s.forwardRef(sR);
function uR({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-.53 14.03a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V8.25a.75.75 0 0 0-1.5 0v5.69l-1.72-1.72a.75.75 0 0 0-1.06 1.06l3 3Z",
    clipRule: "evenodd"
  }));
}
const dR = /* @__PURE__ */ s.forwardRef(uR);
function fR({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M20.03 3.97a.75.75 0 0 1 0 1.06L6.31 18.75h9.44a.75.75 0 0 1 0 1.5H4.5a.75.75 0 0 1-.75-.75V8.25a.75.75 0 0 1 1.5 0v9.44L18.97 3.97a.75.75 0 0 1 1.06 0Z",
    clipRule: "evenodd"
  }));
}
const hR = /* @__PURE__ */ s.forwardRef(fR);
function vR({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M9.75 6.75h-3a3 3 0 0 0-3 3v7.5a3 3 0 0 0 3 3h7.5a3 3 0 0 0 3-3v-7.5a3 3 0 0 0-3-3h-3V1.5a.75.75 0 0 0-1.5 0v5.25Zm0 0h1.5v5.69l1.72-1.72a.75.75 0 1 1 1.06 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 1 1 1.06-1.06l1.72 1.72V6.75Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M7.151 21.75a2.999 2.999 0 0 0 2.599 1.5h7.5a3 3 0 0 0 3-3v-7.5c0-1.11-.603-2.08-1.5-2.599v7.099a4.5 4.5 0 0 1-4.5 4.5H7.151Z"
  }));
}
const pR = /* @__PURE__ */ s.forwardRef(vR);
function gR({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M12 1.5a.75.75 0 0 1 .75.75V7.5h-1.5V2.25A.75.75 0 0 1 12 1.5ZM11.25 7.5v5.69l-1.72-1.72a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V7.5h3.75a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3h-9a3 3 0 0 1-3-3v-9a3 3 0 0 1 3-3h3.75Z"
  }));
}
const mR = /* @__PURE__ */ s.forwardRef(gR);
function wR({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3.97 3.97a.75.75 0 0 1 1.06 0l13.72 13.72V8.25a.75.75 0 0 1 1.5 0V19.5a.75.75 0 0 1-.75.75H8.25a.75.75 0 0 1 0-1.5h9.44L3.97 5.03a.75.75 0 0 1 0-1.06Z",
    clipRule: "evenodd"
  }));
}
const yR = /* @__PURE__ */ s.forwardRef(wR);
function bR({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25a.75.75 0 0 1 .75.75v11.69l3.22-3.22a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 1 1 1.06-1.06l3.22 3.22V3a.75.75 0 0 1 .75-.75Zm-9 13.5a.75.75 0 0 1 .75.75v2.25a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5V16.5a.75.75 0 0 1 1.5 0v2.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V16.5a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  }));
}
const _R = /* @__PURE__ */ s.forwardRef(bR);
function xR({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25a.75.75 0 0 1 .75.75v16.19l6.22-6.22a.75.75 0 1 1 1.06 1.06l-7.5 7.5a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 1 1 1.06-1.06l6.22 6.22V3a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  }));
}
const CR = /* @__PURE__ */ s.forwardRef(xR);
function ER({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-4.28 9.22a.75.75 0 0 0 0 1.06l3 3a.75.75 0 1 0 1.06-1.06l-1.72-1.72h5.69a.75.75 0 0 0 0-1.5h-5.69l1.72-1.72a.75.75 0 0 0-1.06-1.06l-3 3Z",
    clipRule: "evenodd"
  }));
}
const SR = /* @__PURE__ */ s.forwardRef(ER);
function RR({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M7.5 3.75A1.5 1.5 0 0 0 6 5.25v13.5a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5V15a.75.75 0 0 1 1.5 0v3.75a3 3 0 0 1-3 3h-6a3 3 0 0 1-3-3V5.25a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3V9A.75.75 0 0 1 15 9V5.25a1.5 1.5 0 0 0-1.5-1.5h-6Zm5.03 4.72a.75.75 0 0 1 0 1.06l-1.72 1.72h10.94a.75.75 0 0 1 0 1.5H10.81l1.72 1.72a.75.75 0 1 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06l3-3a.75.75 0 0 1 1.06 0Z",
    clipRule: "evenodd"
  }));
}
const MR = /* @__PURE__ */ s.forwardRef(RR);
function AR({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M7.5 3.75A1.5 1.5 0 0 0 6 5.25v13.5a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5V15a.75.75 0 0 1 1.5 0v3.75a3 3 0 0 1-3 3h-6a3 3 0 0 1-3-3V5.25a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3V9A.75.75 0 0 1 15 9V5.25a1.5 1.5 0 0 0-1.5-1.5h-6Zm5.03 4.72a.75.75 0 0 1 0 1.06l-1.72 1.72h10.94a.75.75 0 0 1 0 1.5H10.81l1.72 1.72a.75.75 0 1 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06l3-3a.75.75 0 0 1 1.06 0Z",
    clipRule: "evenodd"
  }));
}
const kR = /* @__PURE__ */ s.forwardRef(AR);
function LR({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M16.5 3.75a1.5 1.5 0 0 1 1.5 1.5v13.5a1.5 1.5 0 0 1-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V15a.75.75 0 0 0-1.5 0v3.75a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V5.25a3 3 0 0 0-3-3h-6a3 3 0 0 0-3 3V9A.75.75 0 1 0 9 9V5.25a1.5 1.5 0 0 1 1.5-1.5h6ZM5.78 8.47a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 0 0 0 1.06l3 3a.75.75 0 0 0 1.06-1.06l-1.72-1.72H15a.75.75 0 0 0 0-1.5H4.06l1.72-1.72a.75.75 0 0 0 0-1.06Z",
    clipRule: "evenodd"
  }));
}
const TR = /* @__PURE__ */ s.forwardRef(LR);
function OR({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M11.03 3.97a.75.75 0 0 1 0 1.06l-6.22 6.22H21a.75.75 0 0 1 0 1.5H4.81l6.22 6.22a.75.75 0 1 1-1.06 1.06l-7.5-7.5a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 0 1 1.06 0Z",
    clipRule: "evenodd"
  }));
}
const IR = /* @__PURE__ */ s.forwardRef(OR);
function PR({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25a.75.75 0 0 1 .75.75v16.19l2.47-2.47a.75.75 0 1 1 1.06 1.06l-3.75 3.75a.75.75 0 0 1-1.06 0l-3.75-3.75a.75.75 0 1 1 1.06-1.06l2.47 2.47V3a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  }));
}
const DR = /* @__PURE__ */ s.forwardRef(PR);
function NR({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M7.28 7.72a.75.75 0 0 1 0 1.06l-2.47 2.47H21a.75.75 0 0 1 0 1.5H4.81l2.47 2.47a.75.75 0 1 1-1.06 1.06l-3.75-3.75a.75.75 0 0 1 0-1.06l3.75-3.75a.75.75 0 0 1 1.06 0Z",
    clipRule: "evenodd"
  }));
}
const BR = /* @__PURE__ */ s.forwardRef(NR);
function FR({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M16.72 7.72a.75.75 0 0 1 1.06 0l3.75 3.75a.75.75 0 0 1 0 1.06l-3.75 3.75a.75.75 0 1 1-1.06-1.06l2.47-2.47H3a.75.75 0 0 1 0-1.5h16.19l-2.47-2.47a.75.75 0 0 1 0-1.06Z",
    clipRule: "evenodd"
  }));
}
const $R = /* @__PURE__ */ s.forwardRef(FR);
function VR({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M11.47 2.47a.75.75 0 0 1 1.06 0l3.75 3.75a.75.75 0 0 1-1.06 1.06l-2.47-2.47V21a.75.75 0 0 1-1.5 0V4.81L8.78 7.28a.75.75 0 0 1-1.06-1.06l3.75-3.75Z",
    clipRule: "evenodd"
  }));
}
const ZR = /* @__PURE__ */ s.forwardRef(VR);
function HR({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 5.25c1.213 0 2.415.046 3.605.135a3.256 3.256 0 0 1 3.01 3.01c.044.583.077 1.17.1 1.759L17.03 8.47a.75.75 0 1 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l3-3a.75.75 0 0 0-1.06-1.06l-1.752 1.751c-.023-.65-.06-1.296-.108-1.939a4.756 4.756 0 0 0-4.392-4.392 49.422 49.422 0 0 0-7.436 0A4.756 4.756 0 0 0 3.89 8.282c-.017.224-.033.447-.046.672a.75.75 0 1 0 1.497.092c.013-.217.028-.434.044-.651a3.256 3.256 0 0 1 3.01-3.01c1.19-.09 2.392-.135 3.605-.135Zm-6.97 6.22a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 1 0 1.06 1.06l1.752-1.751c.023.65.06 1.296.108 1.939a4.756 4.756 0 0 0 4.392 4.392 49.413 49.413 0 0 0 7.436 0 4.756 4.756 0 0 0 4.392-4.392c.017-.223.032-.447.046-.672a.75.75 0 0 0-1.497-.092c-.013.217-.028.434-.044.651a3.256 3.256 0 0 1-3.01 3.01 47.953 47.953 0 0 1-7.21 0 3.256 3.256 0 0 1-3.01-3.01 47.759 47.759 0 0 1-.1-1.759L6.97 15.53a.75.75 0 0 0 1.06-1.06l-3-3Z",
    clipRule: "evenodd"
  }));
}
const jR = /* @__PURE__ */ s.forwardRef(HR);
function WR({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M4.755 10.059a7.5 7.5 0 0 1 12.548-3.364l1.903 1.903h-3.183a.75.75 0 1 0 0 1.5h4.992a.75.75 0 0 0 .75-.75V4.356a.75.75 0 0 0-1.5 0v3.18l-1.9-1.9A9 9 0 0 0 3.306 9.67a.75.75 0 1 0 1.45.388Zm15.408 3.352a.75.75 0 0 0-.919.53 7.5 7.5 0 0 1-12.548 3.364l-1.902-1.903h3.183a.75.75 0 0 0 0-1.5H2.984a.75.75 0 0 0-.75.75v4.992a.75.75 0 0 0 1.5 0v-3.18l1.9 1.9a9 9 0 0 0 15.059-4.035.75.75 0 0 0-.53-.918Z",
    clipRule: "evenodd"
  }));
}
const zR = /* @__PURE__ */ s.forwardRef(WR);
function GR({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm4.28 10.28a.75.75 0 0 0 0-1.06l-3-3a.75.75 0 1 0-1.06 1.06l1.72 1.72H8.25a.75.75 0 0 0 0 1.5h5.69l-1.72 1.72a.75.75 0 1 0 1.06 1.06l3-3Z",
    clipRule: "evenodd"
  }));
}
const UR = /* @__PURE__ */ s.forwardRef(GR);
function YR({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M16.5 3.75a1.5 1.5 0 0 1 1.5 1.5v13.5a1.5 1.5 0 0 1-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V15a.75.75 0 0 0-1.5 0v3.75a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V5.25a3 3 0 0 0-3-3h-6a3 3 0 0 0-3 3V9A.75.75 0 1 0 9 9V5.25a1.5 1.5 0 0 1 1.5-1.5h6Zm-5.03 4.72a.75.75 0 0 0 0 1.06l1.72 1.72H2.25a.75.75 0 0 0 0 1.5h10.94l-1.72 1.72a.75.75 0 1 0 1.06 1.06l3-3a.75.75 0 0 0 0-1.06l-3-3a.75.75 0 0 0-1.06 0Z",
    clipRule: "evenodd"
  }));
}
const XR = /* @__PURE__ */ s.forwardRef(YR);
function qR({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M7.5 3.75A1.5 1.5 0 0 0 6 5.25v13.5a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5V15a.75.75 0 0 1 1.5 0v3.75a3 3 0 0 1-3 3h-6a3 3 0 0 1-3-3V5.25a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3V9A.75.75 0 0 1 15 9V5.25a1.5 1.5 0 0 0-1.5-1.5h-6Zm10.72 4.72a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l1.72-1.72H9a.75.75 0 0 1 0-1.5h10.94l-1.72-1.72a.75.75 0 0 1 0-1.06Z",
    clipRule: "evenodd"
  }));
}
const KR = /* @__PURE__ */ s.forwardRef(qR);
function QR({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M7.5 3.75A1.5 1.5 0 0 0 6 5.25v13.5a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5V15a.75.75 0 0 1 1.5 0v3.75a3 3 0 0 1-3 3h-6a3 3 0 0 1-3-3V5.25a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3V9A.75.75 0 0 1 15 9V5.25a1.5 1.5 0 0 0-1.5-1.5h-6Zm10.72 4.72a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l1.72-1.72H9a.75.75 0 0 1 0-1.5h10.94l-1.72-1.72a.75.75 0 0 1 0-1.06Z",
    clipRule: "evenodd"
  }));
}
const JR = /* @__PURE__ */ s.forwardRef(QR);
function eM({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12.97 3.97a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 1 1-1.06-1.06l6.22-6.22H3a.75.75 0 0 1 0-1.5h16.19l-6.22-6.22a.75.75 0 0 1 0-1.06Z",
    clipRule: "evenodd"
  }));
}
const tM = /* @__PURE__ */ s.forwardRef(eM);
function rM({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 3.75a.75.75 0 0 1 .75.75v13.19l5.47-5.47a.75.75 0 1 1 1.06 1.06l-6.75 6.75a.75.75 0 0 1-1.06 0l-6.75-6.75a.75.75 0 1 1 1.06-1.06l5.47 5.47V4.5a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  }));
}
const nM = /* @__PURE__ */ s.forwardRef(rM);
function aM({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M20.25 12a.75.75 0 0 1-.75.75H6.31l5.47 5.47a.75.75 0 1 1-1.06 1.06l-6.75-6.75a.75.75 0 0 1 0-1.06l6.75-6.75a.75.75 0 1 1 1.06 1.06l-5.47 5.47H19.5a.75.75 0 0 1 .75.75Z",
    clipRule: "evenodd"
  }));
}
const oM = /* @__PURE__ */ s.forwardRef(aM);
function iM({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3.75 12a.75.75 0 0 1 .75-.75h13.19l-5.47-5.47a.75.75 0 0 1 1.06-1.06l6.75 6.75a.75.75 0 0 1 0 1.06l-6.75 6.75a.75.75 0 1 1-1.06-1.06l5.47-5.47H4.5a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  }));
}
const lM = /* @__PURE__ */ s.forwardRef(iM);
function sM({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 20.25a.75.75 0 0 1-.75-.75V6.31l-5.47 5.47a.75.75 0 0 1-1.06-1.06l6.75-6.75a.75.75 0 0 1 1.06 0l6.75 6.75a.75.75 0 1 1-1.06 1.06l-5.47-5.47V19.5a.75.75 0 0 1-.75.75Z",
    clipRule: "evenodd"
  }));
}
const cM = /* @__PURE__ */ s.forwardRef(sM);
function uM({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M15.75 2.25H21a.75.75 0 0 1 .75.75v5.25a.75.75 0 0 1-1.5 0V4.81L8.03 17.03a.75.75 0 0 1-1.06-1.06L19.19 3.75h-3.44a.75.75 0 0 1 0-1.5Zm-10.5 4.5a1.5 1.5 0 0 0-1.5 1.5v10.5a1.5 1.5 0 0 0 1.5 1.5h10.5a1.5 1.5 0 0 0 1.5-1.5V10.5a.75.75 0 0 1 1.5 0v8.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V8.25a3 3 0 0 1 3-3h8.25a.75.75 0 0 1 0 1.5H5.25Z",
    clipRule: "evenodd"
  }));
}
const dM = /* @__PURE__ */ s.forwardRef(uM);
function fM({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M1.72 5.47a.75.75 0 0 1 1.06 0L9 11.69l3.756-3.756a.75.75 0 0 1 .985-.066 12.698 12.698 0 0 1 4.575 6.832l.308 1.149 2.277-3.943a.75.75 0 1 1 1.299.75l-3.182 5.51a.75.75 0 0 1-1.025.275l-5.511-3.181a.75.75 0 0 1 .75-1.3l3.943 2.277-.308-1.149a11.194 11.194 0 0 0-3.528-5.617l-3.809 3.81a.75.75 0 0 1-1.06 0L1.72 6.53a.75.75 0 0 1 0-1.061Z",
    clipRule: "evenodd"
  }));
}
const hM = /* @__PURE__ */ s.forwardRef(fM);
function vM({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M15.22 6.268a.75.75 0 0 1 .968-.431l5.942 2.28a.75.75 0 0 1 .431.97l-2.28 5.94a.75.75 0 1 1-1.4-.537l1.63-4.251-1.086.484a11.2 11.2 0 0 0-5.45 5.173.75.75 0 0 1-1.199.19L9 12.312l-6.22 6.22a.75.75 0 0 1-1.06-1.061l6.75-6.75a.75.75 0 0 1 1.06 0l3.606 3.606a12.695 12.695 0 0 1 5.68-4.974l1.086-.483-4.251-1.632a.75.75 0 0 1-.432-.97Z",
    clipRule: "evenodd"
  }));
}
const pM = /* @__PURE__ */ s.forwardRef(vM);
function gM({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M20.239 3.749a.75.75 0 0 0-.75.75V15H5.549l2.47-2.47a.75.75 0 0 0-1.06-1.06l-3.75 3.75a.75.75 0 0 0 0 1.06l3.75 3.75a.75.75 0 1 0 1.06-1.06L5.55 16.5h14.69a.75.75 0 0 0 .75-.75V4.5a.75.75 0 0 0-.75-.751Z",
    clipRule: "evenodd"
  }));
}
const mM = /* @__PURE__ */ s.forwardRef(gM);
function wM({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3.74 3.749a.75.75 0 0 1 .75.75V15h13.938l-2.47-2.47a.75.75 0 0 1 1.061-1.06l3.75 3.75a.75.75 0 0 1 0 1.06l-3.75 3.75a.75.75 0 0 1-1.06-1.06l2.47-2.47H3.738a.75.75 0 0 1-.75-.75V4.5a.75.75 0 0 1 .75-.751Z",
    clipRule: "evenodd"
  }));
}
const yM = /* @__PURE__ */ s.forwardRef(wM);
function bM({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M20.24 3.75a.75.75 0 0 1-.75.75H8.989v13.939l2.47-2.47a.75.75 0 1 1 1.06 1.061l-3.75 3.75a.75.75 0 0 1-1.06 0l-3.751-3.75a.75.75 0 1 1 1.06-1.06l2.47 2.469V3.75a.75.75 0 0 1 .75-.75H19.49a.75.75 0 0 1 .75.75Z",
    clipRule: "evenodd"
  }));
}
const _M = /* @__PURE__ */ s.forwardRef(bM);
function xM({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M20.24 20.249a.75.75 0 0 0-.75-.75H8.989V5.56l2.47 2.47a.75.75 0 0 0 1.06-1.061l-3.75-3.75a.75.75 0 0 0-1.06 0l-3.75 3.75a.75.75 0 1 0 1.06 1.06l2.47-2.469V20.25c0 .414.335.75.75.75h11.25a.75.75 0 0 0 .75-.75Z",
    clipRule: "evenodd"
  }));
}
const CM = /* @__PURE__ */ s.forwardRef(xM);
function EM({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3.738 3.75c0 .414.336.75.75.75H14.99v13.939l-2.47-2.47a.75.75 0 0 0-1.06 1.061l3.75 3.75a.75.75 0 0 0 1.06 0l3.751-3.75a.75.75 0 0 0-1.06-1.06l-2.47 2.469V3.75a.75.75 0 0 0-.75-.75H4.487a.75.75 0 0 0-.75.75Z",
    clipRule: "evenodd"
  }));
}
const SM = /* @__PURE__ */ s.forwardRef(EM);
function RM({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3.738 20.249a.75.75 0 0 1 .75-.75H14.99V5.56l-2.47 2.47a.75.75 0 0 1-1.06-1.061l3.75-3.75a.75.75 0 0 1 1.06 0l3.751 3.75a.75.75 0 0 1-1.06 1.06L16.49 5.56V20.25a.75.75 0 0 1-.75.75H4.487a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  }));
}
const MM = /* @__PURE__ */ s.forwardRef(RM);
function AM({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M20.239 20.25a.75.75 0 0 1-.75-.75V8.999H5.549l2.47 2.47a.75.75 0 0 1-1.06 1.06l-3.75-3.75a.75.75 0 0 1 0-1.06l3.75-3.75a.75.75 0 1 1 1.06 1.06l-2.47 2.47h14.69a.75.75 0 0 1 .75.75V19.5a.75.75 0 0 1-.75.75Z",
    clipRule: "evenodd"
  }));
}
const kM = /* @__PURE__ */ s.forwardRef(AM);
function LM({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3.74 20.25a.75.75 0 0 0 .75-.75V8.999h13.938l-2.47 2.47a.75.75 0 0 0 1.061 1.06l3.75-3.75a.75.75 0 0 0 0-1.06l-3.75-3.75a.75.75 0 0 0-1.06 1.06l2.47 2.47H3.738a.75.75 0 0 0-.75.75V19.5c0 .414.336.75.75.75Z",
    clipRule: "evenodd"
  }));
}
const TM = /* @__PURE__ */ s.forwardRef(LM);
function OM({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm.53 5.47a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 1 0 1.06 1.06l1.72-1.72v5.69a.75.75 0 0 0 1.5 0v-5.69l1.72 1.72a.75.75 0 1 0 1.06-1.06l-3-3Z",
    clipRule: "evenodd"
  }));
}
const IM = /* @__PURE__ */ s.forwardRef(OM);
function PM({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M5.25 6.31v9.44a.75.75 0 0 1-1.5 0V4.5a.75.75 0 0 1 .75-.75h11.25a.75.75 0 0 1 0 1.5H6.31l13.72 13.72a.75.75 0 1 1-1.06 1.06L5.25 6.31Z",
    clipRule: "evenodd"
  }));
}
const DM = /* @__PURE__ */ s.forwardRef(PM);
function NM({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M9.97.97a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06l-1.72-1.72v3.44h-1.5V3.31L8.03 5.03a.75.75 0 0 1-1.06-1.06l3-3ZM9.75 6.75v6a.75.75 0 0 0 1.5 0v-6h3a3 3 0 0 1 3 3v7.5a3 3 0 0 1-3 3h-7.5a3 3 0 0 1-3-3v-7.5a3 3 0 0 1 3-3h3Z"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M7.151 21.75a2.999 2.999 0 0 0 2.599 1.5h7.5a3 3 0 0 0 3-3v-7.5c0-1.11-.603-2.08-1.5-2.599v7.099a4.5 4.5 0 0 1-4.5 4.5H7.151Z"
  }));
}
const BM = /* @__PURE__ */ s.forwardRef(NM);
function FM({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M11.47 1.72a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06l-1.72-1.72V7.5h-1.5V4.06L9.53 5.78a.75.75 0 0 1-1.06-1.06l3-3ZM11.25 7.5V15a.75.75 0 0 0 1.5 0V7.5h3.75a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3h-9a3 3 0 0 1-3-3v-9a3 3 0 0 1 3-3h3.75Z"
  }));
}
const $M = /* @__PURE__ */ s.forwardRef(FM);
function VM({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M8.25 3.75H19.5a.75.75 0 0 1 .75.75v11.25a.75.75 0 0 1-1.5 0V6.31L5.03 20.03a.75.75 0 0 1-1.06-1.06L17.69 5.25H8.25a.75.75 0 0 1 0-1.5Z",
    clipRule: "evenodd"
  }));
}
const ZM = /* @__PURE__ */ s.forwardRef(VM);
function HM({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M11.47 2.47a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 0 1-1.06 1.06l-3.22-3.22V16.5a.75.75 0 0 1-1.5 0V4.81L8.03 8.03a.75.75 0 0 1-1.06-1.06l4.5-4.5ZM3 15.75a.75.75 0 0 1 .75.75v2.25a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5V16.5a.75.75 0 0 1 1.5 0v2.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V16.5a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  }));
}
const jM = /* @__PURE__ */ s.forwardRef(HM);
function WM({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M11.47 2.47a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 1 1-1.06 1.06l-6.22-6.22V21a.75.75 0 0 1-1.5 0V4.81l-6.22 6.22a.75.75 0 1 1-1.06-1.06l7.5-7.5Z",
    clipRule: "evenodd"
  }));
}
const zM = /* @__PURE__ */ s.forwardRef(WM);
function GM({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M15 3.75A5.25 5.25 0 0 0 9.75 9v10.19l4.72-4.72a.75.75 0 1 1 1.06 1.06l-6 6a.75.75 0 0 1-1.06 0l-6-6a.75.75 0 1 1 1.06-1.06l4.72 4.72V9a6.75 6.75 0 0 1 13.5 0v3a.75.75 0 0 1-1.5 0V9c0-2.9-2.35-5.25-5.25-5.25Z",
    clipRule: "evenodd"
  }));
}
const UM = /* @__PURE__ */ s.forwardRef(GM);
function YM({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M9.53 2.47a.75.75 0 0 1 0 1.06L4.81 8.25H15a6.75 6.75 0 0 1 0 13.5h-3a.75.75 0 0 1 0-1.5h3a5.25 5.25 0 1 0 0-10.5H4.81l4.72 4.72a.75.75 0 1 1-1.06 1.06l-6-6a.75.75 0 0 1 0-1.06l6-6a.75.75 0 0 1 1.06 0Z",
    clipRule: "evenodd"
  }));
}
const XM = /* @__PURE__ */ s.forwardRef(YM);
function qM({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M14.47 2.47a.75.75 0 0 1 1.06 0l6 6a.75.75 0 0 1 0 1.06l-6 6a.75.75 0 1 1-1.06-1.06l4.72-4.72H9a5.25 5.25 0 1 0 0 10.5h3a.75.75 0 0 1 0 1.5H9a6.75 6.75 0 0 1 0-13.5h10.19l-4.72-4.72a.75.75 0 0 1 0-1.06Z",
    clipRule: "evenodd"
  }));
}
const KM = /* @__PURE__ */ s.forwardRef(qM);
function QM({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M21.53 9.53a.75.75 0 0 1-1.06 0l-4.72-4.72V15a6.75 6.75 0 0 1-13.5 0v-3a.75.75 0 0 1 1.5 0v3a5.25 5.25 0 1 0 10.5 0V4.81L9.53 9.53a.75.75 0 0 1-1.06-1.06l6-6a.75.75 0 0 1 1.06 0l6 6a.75.75 0 0 1 0 1.06Z",
    clipRule: "evenodd"
  }));
}
const JM = /* @__PURE__ */ s.forwardRef(QM);
function eA({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3.22 3.22a.75.75 0 0 1 1.06 0l3.97 3.97V4.5a.75.75 0 0 1 1.5 0V9a.75.75 0 0 1-.75.75H4.5a.75.75 0 0 1 0-1.5h2.69L3.22 4.28a.75.75 0 0 1 0-1.06Zm17.56 0a.75.75 0 0 1 0 1.06l-3.97 3.97h2.69a.75.75 0 0 1 0 1.5H15a.75.75 0 0 1-.75-.75V4.5a.75.75 0 0 1 1.5 0v2.69l3.97-3.97a.75.75 0 0 1 1.06 0ZM3.75 15a.75.75 0 0 1 .75-.75H9a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-2.69l-3.97 3.97a.75.75 0 0 1-1.06-1.06l3.97-3.97H4.5a.75.75 0 0 1-.75-.75Zm10.5 0a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-2.69l3.97 3.97a.75.75 0 1 1-1.06 1.06l-3.97-3.97v2.69a.75.75 0 0 1-1.5 0V15Z",
    clipRule: "evenodd"
  }));
}
const tA = /* @__PURE__ */ s.forwardRef(eA);
function rA({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M15 3.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0V5.56l-3.97 3.97a.75.75 0 1 1-1.06-1.06l3.97-3.97h-2.69a.75.75 0 0 1-.75-.75Zm-12 0A.75.75 0 0 1 3.75 3h4.5a.75.75 0 0 1 0 1.5H5.56l3.97 3.97a.75.75 0 0 1-1.06 1.06L4.5 5.56v2.69a.75.75 0 0 1-1.5 0v-4.5Zm11.47 11.78a.75.75 0 1 1 1.06-1.06l3.97 3.97v-2.69a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1 0-1.5h2.69l-3.97-3.97Zm-4.94-1.06a.75.75 0 0 1 0 1.06L5.56 19.5h2.69a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 1 1.5 0v2.69l3.97-3.97a.75.75 0 0 1 1.06 0Z",
    clipRule: "evenodd"
  }));
}
const nA = /* @__PURE__ */ s.forwardRef(rA);
function aA({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M15.97 2.47a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5a.75.75 0 1 1-1.06-1.06l3.22-3.22H7.5a.75.75 0 0 1 0-1.5h11.69l-3.22-3.22a.75.75 0 0 1 0-1.06Zm-7.94 9a.75.75 0 0 1 0 1.06l-3.22 3.22H16.5a.75.75 0 0 1 0 1.5H4.81l3.22 3.22a.75.75 0 1 1-1.06 1.06l-4.5-4.5a.75.75 0 0 1 0-1.06l4.5-4.5a.75.75 0 0 1 1.06 0Z",
    clipRule: "evenodd"
  }));
}
const oA = /* @__PURE__ */ s.forwardRef(aA);
function iA({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M6.97 2.47a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 0 1-1.06 1.06L8.25 4.81V16.5a.75.75 0 0 1-1.5 0V4.81L3.53 8.03a.75.75 0 0 1-1.06-1.06l4.5-4.5Zm9.53 4.28a.75.75 0 0 1 .75.75v11.69l3.22-3.22a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 1 1 1.06-1.06l3.22 3.22V7.5a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  }));
}
const lA = /* @__PURE__ */ s.forwardRef(iA);
function sA({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M17.834 6.166a8.25 8.25 0 1 0 0 11.668.75.75 0 0 1 1.06 1.06c-3.807 3.808-9.98 3.808-13.788 0-3.808-3.807-3.808-9.98 0-13.788 3.807-3.808 9.98-3.808 13.788 0A9.722 9.722 0 0 1 21.75 12c0 .975-.296 1.887-.809 2.571-.514.685-1.28 1.179-2.191 1.179-.904 0-1.666-.487-2.18-1.164a5.25 5.25 0 1 1-.82-6.26V8.25a.75.75 0 0 1 1.5 0V12c0 .682.208 1.27.509 1.671.3.401.659.579.991.579.332 0 .69-.178.991-.579.3-.4.509-.99.509-1.671a8.222 8.222 0 0 0-2.416-5.834ZM15.75 12a3.75 3.75 0 1 0-7.5 0 3.75 3.75 0 0 0 7.5 0Z",
    clipRule: "evenodd"
  }));
}
const cA = /* @__PURE__ */ s.forwardRef(sA);
function uA({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M2.515 10.674a1.875 1.875 0 0 0 0 2.652L8.89 19.7c.352.351.829.549 1.326.549H19.5a3 3 0 0 0 3-3V6.75a3 3 0 0 0-3-3h-9.284c-.497 0-.974.198-1.326.55l-6.375 6.374ZM12.53 9.22a.75.75 0 1 0-1.06 1.06L13.19 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06l1.72-1.72 1.72 1.72a.75.75 0 1 0 1.06-1.06L15.31 12l1.72-1.72a.75.75 0 1 0-1.06-1.06l-1.72 1.72-1.72-1.72Z",
    clipRule: "evenodd"
  }));
}
const dA = /* @__PURE__ */ s.forwardRef(uA);
function fA({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M9.195 18.44c1.25.714 2.805-.189 2.805-1.629v-2.34l6.945 3.968c1.25.715 2.805-.188 2.805-1.628V8.69c0-1.44-1.555-2.343-2.805-1.628L12 11.029v-2.34c0-1.44-1.555-2.343-2.805-1.628l-7.108 4.061c-1.26.72-1.26 2.536 0 3.256l7.108 4.061Z"
  }));
}
const hA = /* @__PURE__ */ s.forwardRef(fA);
function vA({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M12 7.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Z"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 4.875C1.5 3.839 2.34 3 3.375 3h17.25c1.035 0 1.875.84 1.875 1.875v9.75c0 1.036-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 0 1 1.5 14.625v-9.75ZM8.25 9.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0ZM18.75 9a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V9.75a.75.75 0 0 0-.75-.75h-.008ZM4.5 9.75A.75.75 0 0 1 5.25 9h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H5.25a.75.75 0 0 1-.75-.75V9.75Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M2.25 18a.75.75 0 0 0 0 1.5c5.4 0 10.63.722 15.6 2.075 1.19.324 2.4-.558 2.4-1.82V18.75a.75.75 0 0 0-.75-.75H2.25Z"
  }));
}
const pA = /* @__PURE__ */ s.forwardRef(vA);
function gA({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3 9a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 9Zm0 6.75a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  }));
}
const mA = /* @__PURE__ */ s.forwardRef(gA);
function wA({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3 6.75A.75.75 0 0 1 3.75 6h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.75ZM3 12a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12Zm0 5.25a.75.75 0 0 1 .75-.75H12a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  }));
}
const yA = /* @__PURE__ */ s.forwardRef(wA);
function bA({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3 6.75A.75.75 0 0 1 3.75 6h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.75ZM3 12a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12Zm8.25 5.25a.75.75 0 0 1 .75-.75h8.25a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  }));
}
const _A = /* @__PURE__ */ s.forwardRef(bA);
function xA({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3 6.75A.75.75 0 0 1 3.75 6h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.75ZM3 12a.75.75 0 0 1 .75-.75H12a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12Zm0 5.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  }));
}
const CA = /* @__PURE__ */ s.forwardRef(xA);
function EA({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3 6.75A.75.75 0 0 1 3.75 6h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.75ZM3 12a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12Zm0 5.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  }));
}
const SA = /* @__PURE__ */ s.forwardRef(EA);
function RA({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3 5.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 5.25Zm0 4.5A.75.75 0 0 1 3.75 9h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 9.75Zm0 4.5a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Zm0 4.5a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  }));
}
const MA = /* @__PURE__ */ s.forwardRef(RA);
function AA({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 4.5A.75.75 0 0 1 3 3.75h14.25a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75Zm0 4.5A.75.75 0 0 1 3 8.25h9.75a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 9Zm15-.75A.75.75 0 0 1 18 9v10.19l2.47-2.47a.75.75 0 1 1 1.06 1.06l-3.75 3.75a.75.75 0 0 1-1.06 0l-3.75-3.75a.75.75 0 1 1 1.06-1.06l2.47 2.47V9a.75.75 0 0 1 .75-.75Zm-15 5.25a.75.75 0 0 1 .75-.75h9.75a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  }));
}
const kA = /* @__PURE__ */ s.forwardRef(AA);
function LA({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 4.5A.75.75 0 0 1 3 3.75h14.25a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75Zm14.47 3.97a.75.75 0 0 1 1.06 0l3.75 3.75a.75.75 0 1 1-1.06 1.06L18 10.81V21a.75.75 0 0 1-1.5 0V10.81l-2.47 2.47a.75.75 0 1 1-1.06-1.06l3.75-3.75ZM2.25 9A.75.75 0 0 1 3 8.25h9.75a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 9Zm0 4.5a.75.75 0 0 1 .75-.75h5.25a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  }));
}
const TA = /* @__PURE__ */ s.forwardRef(LA);
function OA({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M.75 9.75a3 3 0 0 1 3-3h15a3 3 0 0 1 3 3v.038c.856.173 1.5.93 1.5 1.837v2.25c0 .907-.644 1.664-1.5 1.838v.037a3 3 0 0 1-3 3h-15a3 3 0 0 1-3-3v-6Zm19.5 0a1.5 1.5 0 0 0-1.5-1.5h-15a1.5 1.5 0 0 0-1.5 1.5v6a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5v-6Z",
    clipRule: "evenodd"
  }));
}
const IA = /* @__PURE__ */ s.forwardRef(OA);
function PA({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3.75 6.75a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-.037c.856-.174 1.5-.93 1.5-1.838v-2.25c0-.907-.644-1.664-1.5-1.837V9.75a3 3 0 0 0-3-3h-15Zm15 1.5a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-1.5 1.5h-15a1.5 1.5 0 0 1-1.5-1.5v-6a1.5 1.5 0 0 1 1.5-1.5h15ZM4.5 9.75a.75.75 0 0 0-.75.75V15c0 .414.336.75.75.75H18a.75.75 0 0 0 .75-.75v-4.5a.75.75 0 0 0-.75-.75H4.5Z",
    clipRule: "evenodd"
  }));
}
const DA = /* @__PURE__ */ s.forwardRef(PA);
function NA({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M4.5 9.75a.75.75 0 0 0-.75.75V15c0 .414.336.75.75.75h6.75A.75.75 0 0 0 12 15v-4.5a.75.75 0 0 0-.75-.75H4.5Z"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3.75 6.75a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-.037c.856-.174 1.5-.93 1.5-1.838v-2.25c0-.907-.644-1.664-1.5-1.837V9.75a3 3 0 0 0-3-3h-15Zm15 1.5a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-1.5 1.5h-15a1.5 1.5 0 0 1-1.5-1.5v-6a1.5 1.5 0 0 1 1.5-1.5h15Z",
    clipRule: "evenodd"
  }));
}
const BA = /* @__PURE__ */ s.forwardRef(NA);
function FA({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M10.5 3.798v5.02a3 3 0 0 1-.879 2.121l-2.377 2.377a9.845 9.845 0 0 1 5.091 1.013 8.315 8.315 0 0 0 5.713.636l.285-.071-3.954-3.955a3 3 0 0 1-.879-2.121v-5.02a23.614 23.614 0 0 0-3 0Zm4.5.138a.75.75 0 0 0 .093-1.495A24.837 24.837 0 0 0 12 2.25a25.048 25.048 0 0 0-3.093.191A.75.75 0 0 0 9 3.936v4.882a1.5 1.5 0 0 1-.44 1.06l-6.293 6.294c-1.62 1.621-.903 4.475 1.471 4.88 2.686.46 5.447.698 8.262.698 2.816 0 5.576-.239 8.262-.697 2.373-.406 3.092-3.26 1.47-4.881L15.44 9.879A1.5 1.5 0 0 1 15 8.818V3.936Z",
    clipRule: "evenodd"
  }));
}
const $A = /* @__PURE__ */ s.forwardRef(FA);
function VA({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M5.85 3.5a.75.75 0 0 0-1.117-1 9.719 9.719 0 0 0-2.348 4.876.75.75 0 0 0 1.479.248A8.219 8.219 0 0 1 5.85 3.5ZM19.267 2.5a.75.75 0 1 0-1.118 1 8.22 8.22 0 0 1 1.987 4.124.75.75 0 0 0 1.48-.248A9.72 9.72 0 0 0 19.266 2.5Z"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25A6.75 6.75 0 0 0 5.25 9v.75a8.217 8.217 0 0 1-2.119 5.52.75.75 0 0 0 .298 1.206c1.544.57 3.16.99 4.831 1.243a3.75 3.75 0 1 0 7.48 0 24.583 24.583 0 0 0 4.83-1.244.75.75 0 0 0 .298-1.205 8.217 8.217 0 0 1-2.118-5.52V9A6.75 6.75 0 0 0 12 2.25ZM9.75 18c0-.034 0-.067.002-.1a25.05 25.05 0 0 0 4.496 0l.002.1a2.25 2.25 0 1 1-4.5 0Z",
    clipRule: "evenodd"
  }));
}
const ZA = /* @__PURE__ */ s.forwardRef(VA);
function HA({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M3.53 2.47a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06l-18-18ZM20.57 16.476c-.223.082-.448.161-.674.238L7.319 4.137A6.75 6.75 0 0 1 18.75 9v.75c0 2.123.8 4.057 2.118 5.52a.75.75 0 0 1-.297 1.206Z"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M5.25 9c0-.184.007-.366.022-.546l10.384 10.384a3.751 3.751 0 0 1-7.396-1.119 24.585 24.585 0 0 1-4.831-1.244.75.75 0 0 1-.298-1.205A8.217 8.217 0 0 0 5.25 9.75V9Zm4.502 8.9a2.25 2.25 0 1 0 4.496 0 25.057 25.057 0 0 1-4.496 0Z",
    clipRule: "evenodd"
  }));
}
const jA = /* @__PURE__ */ s.forwardRef(HA);
function WA({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25A6.75 6.75 0 0 0 5.25 9v.75a8.217 8.217 0 0 1-2.119 5.52.75.75 0 0 0 .298 1.206c1.544.57 3.16.99 4.831 1.243a3.75 3.75 0 1 0 7.48 0 24.583 24.583 0 0 0 4.83-1.244.75.75 0 0 0 .298-1.205 8.217 8.217 0 0 1-2.118-5.52V9A6.75 6.75 0 0 0 12 2.25ZM9.75 18c0-.034 0-.067.002-.1a25.05 25.05 0 0 0 4.496 0l.002.1a2.25 2.25 0 1 1-4.5 0Zm.75-10.5a.75.75 0 0 0 0 1.5h1.599l-2.223 3.334A.75.75 0 0 0 10.5 13.5h3a.75.75 0 0 0 0-1.5h-1.599l2.223-3.334A.75.75 0 0 0 13.5 7.5h-3Z",
    clipRule: "evenodd"
  }));
}
const zA = /* @__PURE__ */ s.forwardRef(WA);
function GA({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M5.25 9a6.75 6.75 0 0 1 13.5 0v.75c0 2.123.8 4.057 2.118 5.52a.75.75 0 0 1-.297 1.206c-1.544.57-3.16.99-4.831 1.243a3.75 3.75 0 1 1-7.48 0 24.585 24.585 0 0 1-4.831-1.244.75.75 0 0 1-.298-1.205A8.217 8.217 0 0 0 5.25 9.75V9Zm4.502 8.9a2.25 2.25 0 1 0 4.496 0 25.057 25.057 0 0 1-4.496 0Z",
    clipRule: "evenodd"
  }));
}
const UA = /* @__PURE__ */ s.forwardRef(GA);
function YA({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M5.246 3.744a.75.75 0 0 1 .75-.75h7.125a4.875 4.875 0 0 1 3.346 8.422 5.25 5.25 0 0 1-2.97 9.58h-7.5a.75.75 0 0 1-.75-.75V3.744Zm7.125 6.75a2.625 2.625 0 0 0 0-5.25H8.246v5.25h4.125Zm-4.125 2.251v6h4.5a3 3 0 0 0 0-6h-4.5Z",
    clipRule: "evenodd"
  }));
}
const XA = /* @__PURE__ */ s.forwardRef(YA);
function qA({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "m20.798 11.012-3.188 3.416L9.462 6.28l4.24-4.542a.75.75 0 0 1 1.272.71L12.982 9.75h7.268a.75.75 0 0 1 .548 1.262ZM3.202 12.988 6.39 9.572l8.148 8.148-4.24 4.542a.75.75 0 0 1-1.272-.71l1.992-7.302H3.75a.75.75 0 0 1-.548-1.262ZM3.53 2.47a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06l-18-18Z"
  }));
}
const KA = /* @__PURE__ */ s.forwardRef(qA);
function QA({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M14.615 1.595a.75.75 0 0 1 .359.852L12.982 9.75h7.268a.75.75 0 0 1 .548 1.262l-10.5 11.25a.75.75 0 0 1-1.272-.71l1.992-7.302H3.75a.75.75 0 0 1-.548-1.262l10.5-11.25a.75.75 0 0 1 .913-.143Z",
    clipRule: "evenodd"
  }));
}
const JA = /* @__PURE__ */ s.forwardRef(QA);
function ek({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M11.25 4.533A9.707 9.707 0 0 0 6 3a9.735 9.735 0 0 0-3.25.555.75.75 0 0 0-.5.707v14.25a.75.75 0 0 0 1 .707A8.237 8.237 0 0 1 6 18.75c1.995 0 3.823.707 5.25 1.886V4.533ZM12.75 20.636A8.214 8.214 0 0 1 18 18.75c.966 0 1.89.166 2.75.47a.75.75 0 0 0 1-.708V4.262a.75.75 0 0 0-.5-.707A9.735 9.735 0 0 0 18 3a9.707 9.707 0 0 0-5.25 1.533v16.103Z"
  }));
}
const tk = /* @__PURE__ */ s.forwardRef(ek);
function rk({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M3.53 2.47a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06l-18-18ZM20.25 5.507v11.561L5.853 2.671c.15-.043.306-.075.467-.094a49.255 49.255 0 0 1 11.36 0c1.497.174 2.57 1.46 2.57 2.93ZM3.75 21V6.932l14.063 14.063L12 18.088l-7.165 3.583A.75.75 0 0 1 3.75 21Z"
  }));
}
const nk = /* @__PURE__ */ s.forwardRef(rk);
function ak({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M6 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6Zm1.5 1.5a.75.75 0 0 0-.75.75V16.5a.75.75 0 0 0 1.085.67L12 15.089l4.165 2.083a.75.75 0 0 0 1.085-.671V5.25a.75.75 0 0 0-.75-.75h-9Z",
    clipRule: "evenodd"
  }));
}
const ok = /* @__PURE__ */ s.forwardRef(ak);
function ik({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M6.32 2.577a49.255 49.255 0 0 1 11.36 0c1.497.174 2.57 1.46 2.57 2.93V21a.75.75 0 0 1-1.085.67L12 18.089l-7.165 3.583A.75.75 0 0 1 3.75 21V5.507c0-1.47 1.073-2.756 2.57-2.93Z",
    clipRule: "evenodd"
  }));
}
const lk = /* @__PURE__ */ s.forwardRef(ik);
function sk({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M7.5 5.25a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v.205c.933.085 1.857.197 2.774.334 1.454.218 2.476 1.483 2.476 2.917v3.033c0 1.211-.734 2.352-1.936 2.752A24.726 24.726 0 0 1 12 15.75c-2.73 0-5.357-.442-7.814-1.259-1.202-.4-1.936-1.541-1.936-2.752V8.706c0-1.434 1.022-2.7 2.476-2.917A48.814 48.814 0 0 1 7.5 5.455V5.25Zm7.5 0v.09a49.488 49.488 0 0 0-6 0v-.09a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5Zm-3 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M3 18.4v-2.796a4.3 4.3 0 0 0 .713.31A26.226 26.226 0 0 0 12 17.25c2.892 0 5.68-.468 8.287-1.335.252-.084.49-.189.713-.311V18.4c0 1.452-1.047 2.728-2.523 2.923-2.12.282-4.282.427-6.477.427a49.19 49.19 0 0 1-6.477-.427C4.047 21.128 3 19.852 3 18.4Z"
  }));
}
const ck = /* @__PURE__ */ s.forwardRef(sk);
function uk({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M8.478 1.6a.75.75 0 0 1 .273 1.026 3.72 3.72 0 0 0-.425 1.121c.058.058.118.114.18.168A4.491 4.491 0 0 1 12 2.25c1.413 0 2.673.651 3.497 1.668.06-.054.12-.11.178-.167a3.717 3.717 0 0 0-.426-1.125.75.75 0 1 1 1.298-.752 5.22 5.22 0 0 1 .671 2.046.75.75 0 0 1-.187.582c-.241.27-.505.52-.787.749a4.494 4.494 0 0 1 .216 2.1c-.106.792-.753 1.295-1.417 1.403-.182.03-.364.057-.547.081.152.227.273.476.359.742a23.122 23.122 0 0 0 3.832-.803 23.241 23.241 0 0 0-.345-2.634.75.75 0 0 1 1.474-.28c.21 1.115.348 2.256.404 3.418a.75.75 0 0 1-.516.75c-1.527.499-3.119.854-4.76 1.049-.074.38-.22.735-.423 1.05 2.066.209 4.058.672 5.943 1.358a.75.75 0 0 1 .492.75 24.665 24.665 0 0 1-1.189 6.25.75.75 0 0 1-1.425-.47 23.14 23.14 0 0 0 1.077-5.306c-.5-.169-1.009-.32-1.524-.455.068.234.104.484.104.746 0 3.956-2.521 7.5-6 7.5-3.478 0-6-3.544-6-7.5 0-.262.037-.511.104-.746-.514.135-1.022.286-1.522.455.154 1.838.52 3.616 1.077 5.307a.75.75 0 1 1-1.425.468 24.662 24.662 0 0 1-1.19-6.25.75.75 0 0 1 .493-.749 24.586 24.586 0 0 1 4.964-1.24h.01c.321-.046.644-.085.969-.118a2.983 2.983 0 0 1-.424-1.05 24.614 24.614 0 0 1-4.76-1.05.75.75 0 0 1-.516-.75c.057-1.16.194-2.302.405-3.417a.75.75 0 0 1 1.474.28c-.164.862-.28 1.74-.345 2.634 1.237.371 2.517.642 3.832.803.085-.266.207-.515.359-.742a18.698 18.698 0 0 1-.547-.08c-.664-.11-1.311-.612-1.417-1.404a4.535 4.535 0 0 1 .217-2.103 6.788 6.788 0 0 1-.788-.751.75.75 0 0 1-.187-.583 5.22 5.22 0 0 1 .67-2.04.75.75 0 0 1 1.026-.273Z",
    clipRule: "evenodd"
  }));
}
const dk = /* @__PURE__ */ s.forwardRef(uk);
function fk({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M11.584 2.376a.75.75 0 0 1 .832 0l9 6a.75.75 0 1 1-.832 1.248L12 3.901 3.416 9.624a.75.75 0 0 1-.832-1.248l9-6Z"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M20.25 10.332v9.918H21a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1 0-1.5h.75v-9.918a.75.75 0 0 1 .634-.74A49.109 49.109 0 0 1 12 9c2.59 0 5.134.202 7.616.592a.75.75 0 0 1 .634.74Zm-7.5 2.418a.75.75 0 0 0-1.5 0v6.75a.75.75 0 0 0 1.5 0v-6.75Zm3-.75a.75.75 0 0 1 .75.75v6.75a.75.75 0 0 1-1.5 0v-6.75a.75.75 0 0 1 .75-.75ZM9 12.75a.75.75 0 0 0-1.5 0v6.75a.75.75 0 0 0 1.5 0v-6.75Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M12 7.875a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z"
  }));
}
const hk = /* @__PURE__ */ s.forwardRef(fk);
function vk({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3 2.25a.75.75 0 0 0 0 1.5v16.5h-.75a.75.75 0 0 0 0 1.5H15v-18a.75.75 0 0 0 0-1.5H3ZM6.75 19.5v-2.25a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1-.75-.75ZM6 6.75A.75.75 0 0 1 6.75 6h.75a.75.75 0 0 1 0 1.5h-.75A.75.75 0 0 1 6 6.75ZM6.75 9a.75.75 0 0 0 0 1.5h.75a.75.75 0 0 0 0-1.5h-.75ZM6 12.75a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 0 1.5h-.75a.75.75 0 0 1-.75-.75ZM10.5 6a.75.75 0 0 0 0 1.5h.75a.75.75 0 0 0 0-1.5h-.75Zm-.75 3.75A.75.75 0 0 1 10.5 9h.75a.75.75 0 0 1 0 1.5h-.75a.75.75 0 0 1-.75-.75ZM10.5 12a.75.75 0 0 0 0 1.5h.75a.75.75 0 0 0 0-1.5h-.75ZM16.5 6.75v15h5.25a.75.75 0 0 0 0-1.5H21v-12a.75.75 0 0 0 0-1.5h-4.5Zm1.5 4.5a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75v-.008Zm.75 2.25a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75v-.008a.75.75 0 0 0-.75-.75h-.008ZM18 17.25a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75v-.008Z",
    clipRule: "evenodd"
  }));
}
const pk = /* @__PURE__ */ s.forwardRef(vk);
function gk({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 2.25a.75.75 0 0 0 0 1.5v16.5h-.75a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5h-.75V3.75a.75.75 0 0 0 0-1.5h-15ZM9 6a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5H9Zm-.75 3.75A.75.75 0 0 1 9 9h1.5a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75ZM9 12a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5H9Zm3.75-5.25A.75.75 0 0 1 13.5 6H15a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75ZM13.5 9a.75.75 0 0 0 0 1.5H15A.75.75 0 0 0 15 9h-1.5Zm-.75 3.75a.75.75 0 0 1 .75-.75H15a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75ZM9 19.5v-2.25a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-.75.75h-4.5A.75.75 0 0 1 9 19.5Z",
    clipRule: "evenodd"
  }));
}
const mk = /* @__PURE__ */ s.forwardRef(gk);
function wk({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M5.223 2.25c-.497 0-.974.198-1.325.55l-1.3 1.298A3.75 3.75 0 0 0 7.5 9.75c.627.47 1.406.75 2.25.75.844 0 1.624-.28 2.25-.75.626.47 1.406.75 2.25.75.844 0 1.623-.28 2.25-.75a3.75 3.75 0 0 0 4.902-5.652l-1.3-1.299a1.875 1.875 0 0 0-1.325-.549H5.223Z"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3 20.25v-8.755c1.42.674 3.08.673 4.5 0A5.234 5.234 0 0 0 9.75 12c.804 0 1.568-.182 2.25-.506a5.234 5.234 0 0 0 2.25.506c.804 0 1.567-.182 2.25-.506 1.42.674 3.08.675 4.5.001v8.755h.75a.75.75 0 0 1 0 1.5H2.25a.75.75 0 0 1 0-1.5H3Zm3-6a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1-.75-.75v-3Zm8.25-.75a.75.75 0 0 0-.75.75v5.25c0 .414.336.75.75.75h3a.75.75 0 0 0 .75-.75v-5.25a.75.75 0 0 0-.75-.75h-3Z",
    clipRule: "evenodd"
  }));
}
const yk = /* @__PURE__ */ s.forwardRef(wk);
function bk({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "m15 1.784-.796.795a1.125 1.125 0 1 0 1.591 0L15 1.784ZM12 1.784l-.796.795a1.125 1.125 0 1 0 1.591 0L12 1.784ZM9 1.784l-.796.795a1.125 1.125 0 1 0 1.591 0L9 1.784ZM9.75 7.547c.498-.021.998-.035 1.5-.042V6.75a.75.75 0 0 1 1.5 0v.755c.502.007 1.002.021 1.5.042V6.75a.75.75 0 0 1 1.5 0v.88l.307.022c1.55.117 2.693 1.427 2.693 2.946v1.018a62.182 62.182 0 0 0-13.5 0v-1.018c0-1.519 1.143-2.829 2.693-2.946l.307-.022v-.88a.75.75 0 0 1 1.5 0v.797ZM12 12.75c-2.472 0-4.9.184-7.274.54-1.454.217-2.476 1.482-2.476 2.916v.384a4.104 4.104 0 0 1 2.585.364 2.605 2.605 0 0 0 2.33 0 4.104 4.104 0 0 1 3.67 0 2.605 2.605 0 0 0 2.33 0 4.104 4.104 0 0 1 3.67 0 2.605 2.605 0 0 0 2.33 0 4.104 4.104 0 0 1 2.585-.364v-.384c0-1.434-1.022-2.7-2.476-2.917A49.138 49.138 0 0 0 12 12.75ZM21.75 18.131a2.604 2.604 0 0 0-1.915.165 4.104 4.104 0 0 1-3.67 0 2.605 2.605 0 0 0-2.33 0 4.104 4.104 0 0 1-3.67 0 2.605 2.605 0 0 0-2.33 0 4.104 4.104 0 0 1-3.67 0 2.604 2.604 0 0 0-1.915-.165v2.494c0 1.035.84 1.875 1.875 1.875h15.75c1.035 0 1.875-.84 1.875-1.875v-2.494Z"
  }));
}
const _k = /* @__PURE__ */ s.forwardRef(bk);
function xk({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M6.32 1.827a49.255 49.255 0 0 1 11.36 0c1.497.174 2.57 1.46 2.57 2.93V19.5a3 3 0 0 1-3 3H6.75a3 3 0 0 1-3-3V4.757c0-1.47 1.073-2.756 2.57-2.93ZM7.5 11.25a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H8.25a.75.75 0 0 1-.75-.75v-.008Zm.75 1.5a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75H8.25Zm-.75 3a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H8.25a.75.75 0 0 1-.75-.75v-.008Zm.75 1.5a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V18a.75.75 0 0 0-.75-.75H8.25Zm1.748-6a.75.75 0 0 1 .75-.75h.007a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.007a.75.75 0 0 1-.75-.75v-.008Zm.75 1.5a.75.75 0 0 0-.75.75v.008c0 .414.335.75.75.75h.007a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75h-.007Zm-.75 3a.75.75 0 0 1 .75-.75h.007a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.007a.75.75 0 0 1-.75-.75v-.008Zm.75 1.5a.75.75 0 0 0-.75.75v.008c0 .414.335.75.75.75h.007a.75.75 0 0 0 .75-.75V18a.75.75 0 0 0-.75-.75h-.007Zm1.754-6a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75v-.008Zm.75 1.5a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75h-.008Zm-.75 3a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75v-.008Zm.75 1.5a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V18a.75.75 0 0 0-.75-.75h-.008Zm1.748-6a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75v-.008Zm.75 1.5a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75h-.008Zm-8.25-6A.75.75 0 0 1 8.25 6h7.5a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1-.75-.75v-.75Zm9 9a.75.75 0 0 0-1.5 0V18a.75.75 0 0 0 1.5 0v-2.25Z",
    clipRule: "evenodd"
  }));
}
const Ck = /* @__PURE__ */ s.forwardRef(xk);
function Ek({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M12 11.993a.75.75 0 0 0-.75.75v.006c0 .414.336.75.75.75h.006a.75.75 0 0 0 .75-.75v-.006a.75.75 0 0 0-.75-.75H12ZM12 16.494a.75.75 0 0 0-.75.75v.005c0 .414.335.75.75.75h.005a.75.75 0 0 0 .75-.75v-.005a.75.75 0 0 0-.75-.75H12ZM8.999 17.244a.75.75 0 0 1 .75-.75h.006a.75.75 0 0 1 .75.75v.006a.75.75 0 0 1-.75.75h-.006a.75.75 0 0 1-.75-.75v-.006ZM7.499 16.494a.75.75 0 0 0-.75.75v.005c0 .414.336.75.75.75h.005a.75.75 0 0 0 .75-.75v-.005a.75.75 0 0 0-.75-.75H7.5ZM13.499 14.997a.75.75 0 0 1 .75-.75h.006a.75.75 0 0 1 .75.75v.005a.75.75 0 0 1-.75.75h-.006a.75.75 0 0 1-.75-.75v-.005ZM14.25 16.494a.75.75 0 0 0-.75.75v.006c0 .414.335.75.75.75h.005a.75.75 0 0 0 .75-.75v-.006a.75.75 0 0 0-.75-.75h-.005ZM15.75 14.995a.75.75 0 0 1 .75-.75h.005a.75.75 0 0 1 .75.75v.006a.75.75 0 0 1-.75.75H16.5a.75.75 0 0 1-.75-.75v-.006ZM13.498 12.743a.75.75 0 0 1 .75-.75h2.25a.75.75 0 1 1 0 1.5h-2.25a.75.75 0 0 1-.75-.75ZM6.748 14.993a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Z"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M18 2.993a.75.75 0 0 0-1.5 0v1.5h-9V2.994a.75.75 0 1 0-1.5 0v1.497h-.752a3 3 0 0 0-3 3v11.252a3 3 0 0 0 3 3h13.5a3 3 0 0 0 3-3V7.492a3 3 0 0 0-3-3H18V2.993ZM3.748 18.743v-7.5a1.5 1.5 0 0 1 1.5-1.5h13.5a1.5 1.5 0 0 1 1.5 1.5v7.5a1.5 1.5 0 0 1-1.5 1.5h-13.5a1.5 1.5 0 0 1-1.5-1.5Z",
    clipRule: "evenodd"
  }));
}
const Sk = /* @__PURE__ */ s.forwardRef(Ek);
function Rk({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M12.75 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM7.5 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM8.25 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM9.75 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM10.5 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM12.75 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM14.25 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM15 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM16.5 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM15 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM16.5 13.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M6.75 2.25A.75.75 0 0 1 7.5 3v1.5h9V3A.75.75 0 0 1 18 3v1.5h.75a3 3 0 0 1 3 3v11.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V7.5a3 3 0 0 1 3-3H6V3a.75.75 0 0 1 .75-.75Zm13.5 9a1.5 1.5 0 0 0-1.5-1.5H5.25a1.5 1.5 0 0 0-1.5 1.5v7.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-7.5Z",
    clipRule: "evenodd"
  }));
}
const Mk = /* @__PURE__ */ s.forwardRef(Rk);
function Ak({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M6.75 2.25A.75.75 0 0 1 7.5 3v1.5h9V3A.75.75 0 0 1 18 3v1.5h.75a3 3 0 0 1 3 3v11.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V7.5a3 3 0 0 1 3-3H6V3a.75.75 0 0 1 .75-.75Zm13.5 9a1.5 1.5 0 0 0-1.5-1.5H5.25a1.5 1.5 0 0 0-1.5 1.5v7.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-7.5Z",
    clipRule: "evenodd"
  }));
}
const kk = /* @__PURE__ */ s.forwardRef(Ak);
function Lk({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M12 9a3.75 3.75 0 1 0 0 7.5A3.75 3.75 0 0 0 12 9Z"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M9.344 3.071a49.52 49.52 0 0 1 5.312 0c.967.052 1.83.585 2.332 1.39l.821 1.317c.24.383.645.643 1.11.71.386.054.77.113 1.152.177 1.432.239 2.429 1.493 2.429 2.909V18a3 3 0 0 1-3 3h-15a3 3 0 0 1-3-3V9.574c0-1.416.997-2.67 2.429-2.909.382-.064.766-.123 1.151-.178a1.56 1.56 0 0 0 1.11-.71l.822-1.315a2.942 2.942 0 0 1 2.332-1.39ZM6.75 12.75a5.25 5.25 0 1 1 10.5 0 5.25 5.25 0 0 1-10.5 0Zm12-1.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
    clipRule: "evenodd"
  }));
}
const Tk = /* @__PURE__ */ s.forwardRef(Lk);
function Ok({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm4.5 7.5a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-1.5 0v-2.25a.75.75 0 0 1 .75-.75Zm3.75-1.5a.75.75 0 0 0-1.5 0v4.5a.75.75 0 0 0 1.5 0V12Zm2.25-3a.75.75 0 0 1 .75.75v6.75a.75.75 0 0 1-1.5 0V9.75A.75.75 0 0 1 13.5 9Zm3.75-1.5a.75.75 0 0 0-1.5 0v9a.75.75 0 0 0 1.5 0v-9Z",
    clipRule: "evenodd"
  }));
}
const Ik = /* @__PURE__ */ s.forwardRef(Ok);
function Pk({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M18.375 2.25c-1.035 0-1.875.84-1.875 1.875v15.75c0 1.035.84 1.875 1.875 1.875h.75c1.035 0 1.875-.84 1.875-1.875V4.125c0-1.036-.84-1.875-1.875-1.875h-.75ZM9.75 8.625c0-1.036.84-1.875 1.875-1.875h.75c1.036 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-.75a1.875 1.875 0 0 1-1.875-1.875V8.625ZM3 13.125c0-1.036.84-1.875 1.875-1.875h.75c1.036 0 1.875.84 1.875 1.875v6.75c0 1.035-.84 1.875-1.875 1.875h-.75A1.875 1.875 0 0 1 3 19.875v-6.75Z"
  }));
}
const Dk = /* @__PURE__ */ s.forwardRef(Pk);
function Nk({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 13.5a8.25 8.25 0 0 1 8.25-8.25.75.75 0 0 1 .75.75v6.75H18a.75.75 0 0 1 .75.75 8.25 8.25 0 0 1-16.5 0Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12.75 3a.75.75 0 0 1 .75-.75 8.25 8.25 0 0 1 8.25 8.25.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1-.75-.75V3Z",
    clipRule: "evenodd"
  }));
}
const Bk = /* @__PURE__ */ s.forwardRef(Nk);
function Fk({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M4.848 2.771A49.144 49.144 0 0 1 12 2.25c2.43 0 4.817.178 7.152.52 1.978.292 3.348 2.024 3.348 3.97v6.02c0 1.946-1.37 3.678-3.348 3.97a48.901 48.901 0 0 1-3.476.383.39.39 0 0 0-.297.17l-2.755 4.133a.75.75 0 0 1-1.248 0l-2.755-4.133a.39.39 0 0 0-.297-.17 48.9 48.9 0 0 1-3.476-.384c-1.978-.29-3.348-2.024-3.348-3.97V6.741c0-1.946 1.37-3.68 3.348-3.97ZM6.75 8.25a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75Zm.75 2.25a.75.75 0 0 0 0 1.5H12a.75.75 0 0 0 0-1.5H7.5Z",
    clipRule: "evenodd"
  }));
}
const $k = /* @__PURE__ */ s.forwardRef(Fk);
function Vk({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M4.848 2.771A49.144 49.144 0 0 1 12 2.25c2.43 0 4.817.178 7.152.52 1.978.292 3.348 2.024 3.348 3.97v6.02c0 1.946-1.37 3.678-3.348 3.97a48.901 48.901 0 0 1-3.476.383.39.39 0 0 0-.297.17l-2.755 4.133a.75.75 0 0 1-1.248 0l-2.755-4.133a.39.39 0 0 0-.297-.17 48.9 48.9 0 0 1-3.476-.384c-1.978-.29-3.348-2.024-3.348-3.97V6.741c0-1.946 1.37-3.68 3.348-3.97Z",
    clipRule: "evenodd"
  }));
}
const Zk = /* @__PURE__ */ s.forwardRef(Vk);
function Hk({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-2.429 0-4.817.178-7.152.521C2.87 3.061 1.5 4.795 1.5 6.741v6.018c0 1.946 1.37 3.68 3.348 3.97.877.129 1.761.234 2.652.316V21a.75.75 0 0 0 1.28.53l4.184-4.183a.39.39 0 0 1 .266-.112c2.006-.05 3.982-.22 5.922-.506 1.978-.29 3.348-2.023 3.348-3.97V6.741c0-1.947-1.37-3.68-3.348-3.97A49.145 49.145 0 0 0 12 2.25ZM8.25 8.625a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Zm2.625 1.125a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm4.875-1.125a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Z",
    clipRule: "evenodd"
  }));
}
const jk = /* @__PURE__ */ s.forwardRef(Hk);
function Wk({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M4.913 2.658c2.075-.27 4.19-.408 6.337-.408 2.147 0 4.262.139 6.337.408 1.922.25 3.291 1.861 3.405 3.727a4.403 4.403 0 0 0-1.032-.211 50.89 50.89 0 0 0-8.42 0c-2.358.196-4.04 2.19-4.04 4.434v4.286a4.47 4.47 0 0 0 2.433 3.984L7.28 21.53A.75.75 0 0 1 6 21v-4.03a48.527 48.527 0 0 1-1.087-.128C2.905 16.58 1.5 14.833 1.5 12.862V6.638c0-1.97 1.405-3.718 3.413-3.979Z"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M15.75 7.5c-1.376 0-2.739.057-4.086.169C10.124 7.797 9 9.103 9 10.609v4.285c0 1.507 1.128 2.814 2.67 2.94 1.243.102 2.5.157 3.768.165l2.782 2.781a.75.75 0 0 0 1.28-.53v-2.39l.33-.026c1.542-.125 2.67-1.433 2.67-2.94v-4.286c0-1.505-1.125-2.811-2.664-2.94A49.392 49.392 0 0 0 15.75 7.5Z"
  }));
}
const zk = /* @__PURE__ */ s.forwardRef(Wk);
function Gk({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M4.848 2.771A49.144 49.144 0 0 1 12 2.25c2.43 0 4.817.178 7.152.52 1.978.292 3.348 2.024 3.348 3.97v6.02c0 1.946-1.37 3.678-3.348 3.97-1.94.284-3.916.455-5.922.505a.39.39 0 0 0-.266.112L8.78 21.53A.75.75 0 0 1 7.5 21v-3.955a48.842 48.842 0 0 1-2.652-.316c-1.978-.29-3.348-2.024-3.348-3.97V6.741c0-1.946 1.37-3.68 3.348-3.97Z",
    clipRule: "evenodd"
  }));
}
const Uk = /* @__PURE__ */ s.forwardRef(Gk);
function Yk({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M4.804 21.644A6.707 6.707 0 0 0 6 21.75a6.721 6.721 0 0 0 3.583-1.029c.774.182 1.584.279 2.417.279 5.322 0 9.75-3.97 9.75-9 0-5.03-4.428-9-9.75-9s-9.75 3.97-9.75 9c0 2.409 1.025 4.587 2.674 6.192.232.226.277.428.254.543a3.73 3.73 0 0 1-.814 1.686.75.75 0 0 0 .44 1.223ZM8.25 10.875a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25ZM10.875 12a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm4.875-1.125a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Z",
    clipRule: "evenodd"
  }));
}
const Xk = /* @__PURE__ */ s.forwardRef(Yk);
function qk({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M5.337 21.718a6.707 6.707 0 0 1-.533-.074.75.75 0 0 1-.44-1.223 3.73 3.73 0 0 0 .814-1.686c.023-.115-.022-.317-.254-.543C3.274 16.587 2.25 14.41 2.25 12c0-5.03 4.428-9 9.75-9s9.75 3.97 9.75 9c0 5.03-4.428 9-9.75 9-.833 0-1.643-.097-2.417-.279a6.721 6.721 0 0 1-4.246.997Z",
    clipRule: "evenodd"
  }));
}
const Kk = /* @__PURE__ */ s.forwardRef(qk);
function Qk({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M8.603 3.799A4.49 4.49 0 0 1 12 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 0 1 3.498 1.307 4.491 4.491 0 0 1 1.307 3.497A4.49 4.49 0 0 1 21.75 12a4.49 4.49 0 0 1-1.549 3.397 4.491 4.491 0 0 1-1.307 3.497 4.491 4.491 0 0 1-3.497 1.307A4.49 4.49 0 0 1 12 21.75a4.49 4.49 0 0 1-3.397-1.549 4.49 4.49 0 0 1-3.498-1.306 4.491 4.491 0 0 1-1.307-3.498A4.49 4.49 0 0 1 2.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 0 1 1.307-3.497 4.49 4.49 0 0 1 3.497-1.307Zm7.007 6.387a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z",
    clipRule: "evenodd"
  }));
}
const Jk = /* @__PURE__ */ s.forwardRef(Qk);
function eL({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z",
    clipRule: "evenodd"
  }));
}
const tL = /* @__PURE__ */ s.forwardRef(eL);
function rL({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.74a.75.75 0 0 1 1.04-.207Z",
    clipRule: "evenodd"
  }));
}
const nL = /* @__PURE__ */ s.forwardRef(rL);
function aL({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M11.47 13.28a.75.75 0 0 0 1.06 0l7.5-7.5a.75.75 0 0 0-1.06-1.06L12 11.69 5.03 4.72a.75.75 0 0 0-1.06 1.06l7.5 7.5Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M11.47 19.28a.75.75 0 0 0 1.06 0l7.5-7.5a.75.75 0 1 0-1.06-1.06L12 17.69l-6.97-6.97a.75.75 0 0 0-1.06 1.06l7.5 7.5Z",
    clipRule: "evenodd"
  }));
}
const oL = /* @__PURE__ */ s.forwardRef(aL);
function iL({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M10.72 11.47a.75.75 0 0 0 0 1.06l7.5 7.5a.75.75 0 1 0 1.06-1.06L12.31 12l6.97-6.97a.75.75 0 0 0-1.06-1.06l-7.5 7.5Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M4.72 11.47a.75.75 0 0 0 0 1.06l7.5 7.5a.75.75 0 1 0 1.06-1.06L6.31 12l6.97-6.97a.75.75 0 0 0-1.06-1.06l-7.5 7.5Z",
    clipRule: "evenodd"
  }));
}
const lL = /* @__PURE__ */ s.forwardRef(iL);
function sL({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M13.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L11.69 12 4.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M19.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 1 1-1.06-1.06L17.69 12l-6.97-6.97a.75.75 0 0 1 1.06-1.06l7.5 7.5Z",
    clipRule: "evenodd"
  }));
}
const cL = /* @__PURE__ */ s.forwardRef(sL);
function uL({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M11.47 10.72a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 1 1-1.06 1.06L12 12.31l-6.97 6.97a.75.75 0 0 1-1.06-1.06l7.5-7.5Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M11.47 4.72a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 1 1-1.06 1.06L12 6.31l-6.97 6.97a.75.75 0 0 1-1.06-1.06l7.5-7.5Z",
    clipRule: "evenodd"
  }));
}
const dL = /* @__PURE__ */ s.forwardRef(uL);
function fL({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12.53 16.28a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 1.06-1.06L12 14.69l6.97-6.97a.75.75 0 1 1 1.06 1.06l-7.5 7.5Z",
    clipRule: "evenodd"
  }));
}
const hL = /* @__PURE__ */ s.forwardRef(fL);
function vL({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M7.72 12.53a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 1 1 1.06 1.06L9.31 12l6.97 6.97a.75.75 0 1 1-1.06 1.06l-7.5-7.5Z",
    clipRule: "evenodd"
  }));
}
const pL = /* @__PURE__ */ s.forwardRef(vL);
function gL({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z",
    clipRule: "evenodd"
  }));
}
const mL = /* @__PURE__ */ s.forwardRef(gL);
function wL({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M11.47 4.72a.75.75 0 0 1 1.06 0l3.75 3.75a.75.75 0 0 1-1.06 1.06L12 6.31 8.78 9.53a.75.75 0 0 1-1.06-1.06l3.75-3.75Zm-3.75 9.75a.75.75 0 0 1 1.06 0L12 17.69l3.22-3.22a.75.75 0 1 1 1.06 1.06l-3.75 3.75a.75.75 0 0 1-1.06 0l-3.75-3.75a.75.75 0 0 1 0-1.06Z",
    clipRule: "evenodd"
  }));
}
const yL = /* @__PURE__ */ s.forwardRef(wL);
function bL({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M11.47 7.72a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 1 1-1.06 1.06L12 9.31l-6.97 6.97a.75.75 0 0 1-1.06-1.06l7.5-7.5Z",
    clipRule: "evenodd"
  }));
}
const _L = /* @__PURE__ */ s.forwardRef(bL);
function xL({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M21 6.375c0 2.692-4.03 4.875-9 4.875S3 9.067 3 6.375 7.03 1.5 12 1.5s9 2.183 9 4.875Z"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M12 12.75c2.685 0 5.19-.586 7.078-1.609a8.283 8.283 0 0 0 1.897-1.384c.016.121.025.244.025.368C21 12.817 16.97 15 12 15s-9-2.183-9-4.875c0-.124.009-.247.025-.368a8.285 8.285 0 0 0 1.897 1.384C6.809 12.164 9.315 12.75 12 12.75Z"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M12 16.5c2.685 0 5.19-.586 7.078-1.609a8.282 8.282 0 0 0 1.897-1.384c.016.121.025.244.025.368 0 2.692-4.03 4.875-9 4.875s-9-2.183-9-4.875c0-.124.009-.247.025-.368a8.284 8.284 0 0 0 1.897 1.384C6.809 15.914 9.315 16.5 12 16.5Z"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M12 20.25c2.685 0 5.19-.586 7.078-1.609a8.282 8.282 0 0 0 1.897-1.384c.016.121.025.244.025.368 0 2.692-4.03 4.875-9 4.875s-9-2.183-9-4.875c0-.124.009-.247.025-.368a8.284 8.284 0 0 0 1.897 1.384C6.809 19.664 9.315 20.25 12 20.25Z"
  }));
}
const CL = /* @__PURE__ */ s.forwardRef(xL);
function EL({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M7.502 6h7.128A3.375 3.375 0 0 1 18 9.375v9.375a3 3 0 0 0 3-3V6.108c0-1.505-1.125-2.811-2.664-2.94a48.972 48.972 0 0 0-.673-.05A3 3 0 0 0 15 1.5h-1.5a3 3 0 0 0-2.663 1.618c-.225.015-.45.032-.673.05C8.662 3.295 7.554 4.542 7.502 6ZM13.5 3A1.5 1.5 0 0 0 12 4.5h4.5A1.5 1.5 0 0 0 15 3h-1.5Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3 9.375C3 8.339 3.84 7.5 4.875 7.5h9.75c1.036 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 0 1 3 20.625V9.375Zm9.586 4.594a.75.75 0 0 0-1.172-.938l-2.476 3.096-.908-.907a.75.75 0 0 0-1.06 1.06l1.5 1.5a.75.75 0 0 0 1.116-.062l3-3.75Z",
    clipRule: "evenodd"
  }));
}
const SL = /* @__PURE__ */ s.forwardRef(EL);
function RL({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M7.502 6h7.128A3.375 3.375 0 0 1 18 9.375v9.375a3 3 0 0 0 3-3V6.108c0-1.505-1.125-2.811-2.664-2.94a48.972 48.972 0 0 0-.673-.05A3 3 0 0 0 15 1.5h-1.5a3 3 0 0 0-2.663 1.618c-.225.015-.45.032-.673.05C8.662 3.295 7.554 4.542 7.502 6ZM13.5 3A1.5 1.5 0 0 0 12 4.5h4.5A1.5 1.5 0 0 0 15 3h-1.5Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3 9.375C3 8.339 3.84 7.5 4.875 7.5h9.75c1.036 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 0 1 3 20.625V9.375ZM6 12a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H6.75a.75.75 0 0 1-.75-.75V12Zm2.25 0a.75.75 0 0 1 .75-.75h3.75a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75ZM6 15a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H6.75a.75.75 0 0 1-.75-.75V15Zm2.25 0a.75.75 0 0 1 .75-.75h3.75a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75ZM6 18a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H6.75a.75.75 0 0 1-.75-.75V18Zm2.25 0a.75.75 0 0 1 .75-.75h3.75a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  }));
}
const ML = /* @__PURE__ */ s.forwardRef(RL);
function AL({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M17.663 3.118c.225.015.45.032.673.05C19.876 3.298 21 4.604 21 6.109v9.642a3 3 0 0 1-3 3V16.5c0-5.922-4.576-10.775-10.384-11.217.324-1.132 1.3-2.01 2.548-2.114.224-.019.448-.036.673-.051A3 3 0 0 1 13.5 1.5H15a3 3 0 0 1 2.663 1.618ZM12 4.5A1.5 1.5 0 0 1 13.5 3H15a1.5 1.5 0 0 1 1.5 1.5H12Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M3 8.625c0-1.036.84-1.875 1.875-1.875h.375A3.75 3.75 0 0 1 9 10.5v1.875c0 1.036.84 1.875 1.875 1.875h1.875A3.75 3.75 0 0 1 16.5 18v2.625c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 0 1 3 20.625v-12Z"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M10.5 10.5a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963 5.23 5.23 0 0 0-3.434-1.279h-1.875a.375.375 0 0 1-.375-.375V10.5Z"
  }));
}
const kL = /* @__PURE__ */ s.forwardRef(AL);
function LL({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M10.5 3A1.501 1.501 0 0 0 9 4.5h6A1.5 1.5 0 0 0 13.5 3h-3Zm-2.693.178A3 3 0 0 1 10.5 1.5h3a3 3 0 0 1 2.694 1.678c.497.042.992.092 1.486.15 1.497.173 2.57 1.46 2.57 2.929V19.5a3 3 0 0 1-3 3H6.75a3 3 0 0 1-3-3V6.257c0-1.47 1.073-2.756 2.57-2.93.493-.057.989-.107 1.487-.15Z",
    clipRule: "evenodd"
  }));
}
const TL = /* @__PURE__ */ s.forwardRef(LL);
function OL({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 6a.75.75 0 0 0-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 0 0 0-1.5h-3.75V6Z",
    clipRule: "evenodd"
  }));
}
const IL = /* @__PURE__ */ s.forwardRef(OL);
function PL({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M10.5 3.75a6 6 0 0 0-5.98 6.496A5.25 5.25 0 0 0 6.75 20.25H18a4.5 4.5 0 0 0 2.206-8.423 3.75 3.75 0 0 0-4.133-4.303A6.001 6.001 0 0 0 10.5 3.75Zm2.25 6a.75.75 0 0 0-1.5 0v4.94l-1.72-1.72a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V9.75Z",
    clipRule: "evenodd"
  }));
}
const DL = /* @__PURE__ */ s.forwardRef(PL);
function NL({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M10.5 3.75a6 6 0 0 0-5.98 6.496A5.25 5.25 0 0 0 6.75 20.25H18a4.5 4.5 0 0 0 2.206-8.423 3.75 3.75 0 0 0-4.133-4.303A6.001 6.001 0 0 0 10.5 3.75Zm2.03 5.47a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 1 0 1.06 1.06l1.72-1.72v4.94a.75.75 0 0 0 1.5 0v-4.94l1.72 1.72a.75.75 0 1 0 1.06-1.06l-3-3Z",
    clipRule: "evenodd"
  }));
}
const BL = /* @__PURE__ */ s.forwardRef(NL);
function FL({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 9.75a6 6 0 0 1 11.573-2.226 3.75 3.75 0 0 1 4.133 4.303A4.5 4.5 0 0 1 18 20.25H6.75a5.25 5.25 0 0 1-2.23-10.004 6.072 6.072 0 0 1-.02-.496Z",
    clipRule: "evenodd"
  }));
}
const $L = /* @__PURE__ */ s.forwardRef(FL);
function VL({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm14.25 6a.75.75 0 0 1-.22.53l-2.25 2.25a.75.75 0 1 1-1.06-1.06L15.44 12l-1.72-1.72a.75.75 0 1 1 1.06-1.06l2.25 2.25c.141.14.22.331.22.53Zm-10.28-.53a.75.75 0 0 0 0 1.06l2.25 2.25a.75.75 0 1 0 1.06-1.06L8.56 12l1.72-1.72a.75.75 0 1 0-1.06-1.06l-2.25 2.25Z",
    clipRule: "evenodd"
  }));
}
const ZL = /* @__PURE__ */ s.forwardRef(VL);
function HL({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M14.447 3.026a.75.75 0 0 1 .527.921l-4.5 16.5a.75.75 0 0 1-1.448-.394l4.5-16.5a.75.75 0 0 1 .921-.527ZM16.72 6.22a.75.75 0 0 1 1.06 0l5.25 5.25a.75.75 0 0 1 0 1.06l-5.25 5.25a.75.75 0 1 1-1.06-1.06L21.44 12l-4.72-4.72a.75.75 0 0 1 0-1.06Zm-9.44 0a.75.75 0 0 1 0 1.06L2.56 12l4.72 4.72a.75.75 0 0 1-1.06 1.06L.97 12.53a.75.75 0 0 1 0-1.06l5.25-5.25a.75.75 0 0 1 1.06 0Z",
    clipRule: "evenodd"
  }));
}
const jL = /* @__PURE__ */ s.forwardRef(HL);
function WL({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M11.078 2.25c-.917 0-1.699.663-1.85 1.567L9.05 4.889c-.02.12-.115.26-.297.348a7.493 7.493 0 0 0-.986.57c-.166.115-.334.126-.45.083L6.3 5.508a1.875 1.875 0 0 0-2.282.819l-.922 1.597a1.875 1.875 0 0 0 .432 2.385l.84.692c.095.078.17.229.154.43a7.598 7.598 0 0 0 0 1.139c.015.2-.059.352-.153.43l-.841.692a1.875 1.875 0 0 0-.432 2.385l.922 1.597a1.875 1.875 0 0 0 2.282.818l1.019-.382c.115-.043.283-.031.45.082.312.214.641.405.985.57.182.088.277.228.297.35l.178 1.071c.151.904.933 1.567 1.85 1.567h1.844c.916 0 1.699-.663 1.85-1.567l.178-1.072c.02-.12.114-.26.297-.349.344-.165.673-.356.985-.57.167-.114.335-.125.45-.082l1.02.382a1.875 1.875 0 0 0 2.28-.819l.923-1.597a1.875 1.875 0 0 0-.432-2.385l-.84-.692c-.095-.078-.17-.229-.154-.43a7.614 7.614 0 0 0 0-1.139c-.016-.2.059-.352.153-.43l.84-.692c.708-.582.891-1.59.433-2.385l-.922-1.597a1.875 1.875 0 0 0-2.282-.818l-1.02.382c-.114.043-.282.031-.449-.083a7.49 7.49 0 0 0-.985-.57c-.183-.087-.277-.227-.297-.348l-.179-1.072a1.875 1.875 0 0 0-1.85-1.567h-1.843ZM12 15.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z",
    clipRule: "evenodd"
  }));
}
const zL = /* @__PURE__ */ s.forwardRef(WL);
function GL({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M11.828 2.25c-.916 0-1.699.663-1.85 1.567l-.091.549a.798.798 0 0 1-.517.608 7.45 7.45 0 0 0-.478.198.798.798 0 0 1-.796-.064l-.453-.324a1.875 1.875 0 0 0-2.416.2l-.243.243a1.875 1.875 0 0 0-.2 2.416l.324.453a.798.798 0 0 1 .064.796 7.448 7.448 0 0 0-.198.478.798.798 0 0 1-.608.517l-.55.092a1.875 1.875 0 0 0-1.566 1.849v.344c0 .916.663 1.699 1.567 1.85l.549.091c.281.047.508.25.608.517.06.162.127.321.198.478a.798.798 0 0 1-.064.796l-.324.453a1.875 1.875 0 0 0 .2 2.416l.243.243c.648.648 1.67.733 2.416.2l.453-.324a.798.798 0 0 1 .796-.064c.157.071.316.137.478.198.267.1.47.327.517.608l.092.55c.15.903.932 1.566 1.849 1.566h.344c.916 0 1.699-.663 1.85-1.567l.091-.549a.798.798 0 0 1 .517-.608 7.52 7.52 0 0 0 .478-.198.798.798 0 0 1 .796.064l.453.324a1.875 1.875 0 0 0 2.416-.2l.243-.243c.648-.648.733-1.67.2-2.416l-.324-.453a.798.798 0 0 1-.064-.796c.071-.157.137-.316.198-.478.1-.267.327-.47.608-.517l.55-.091a1.875 1.875 0 0 0 1.566-1.85v-.344c0-.916-.663-1.699-1.567-1.85l-.549-.091a.798.798 0 0 1-.608-.517 7.507 7.507 0 0 0-.198-.478.798.798 0 0 1 .064-.796l.324-.453a1.875 1.875 0 0 0-.2-2.416l-.243-.243a1.875 1.875 0 0 0-2.416-.2l-.453.324a.798.798 0 0 1-.796.064 7.462 7.462 0 0 0-.478-.198.798.798 0 0 1-.517-.608l-.091-.55a1.875 1.875 0 0 0-1.85-1.566h-.344ZM12 15.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z",
    clipRule: "evenodd"
  }));
}
const UL = /* @__PURE__ */ s.forwardRef(GL);
function YL({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M17.004 10.407c.138.435-.216.842-.672.842h-3.465a.75.75 0 0 1-.65-.375l-1.732-3c-.229-.396-.053-.907.393-1.004a5.252 5.252 0 0 1 6.126 3.537ZM8.12 8.464c.307-.338.838-.235 1.066.16l1.732 3a.75.75 0 0 1 0 .75l-1.732 3c-.229.397-.76.5-1.067.161A5.23 5.23 0 0 1 6.75 12a5.23 5.23 0 0 1 1.37-3.536ZM10.878 17.13c-.447-.098-.623-.608-.394-1.004l1.733-3.002a.75.75 0 0 1 .65-.375h3.465c.457 0 .81.407.672.842a5.252 5.252 0 0 1-6.126 3.539Z"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M21 12.75a.75.75 0 1 0 0-1.5h-.783a8.22 8.22 0 0 0-.237-1.357l.734-.267a.75.75 0 1 0-.513-1.41l-.735.268a8.24 8.24 0 0 0-.689-1.192l.6-.503a.75.75 0 1 0-.964-1.149l-.6.504a8.3 8.3 0 0 0-1.054-.885l.391-.678a.75.75 0 1 0-1.299-.75l-.39.676a8.188 8.188 0 0 0-1.295-.47l.136-.77a.75.75 0 0 0-1.477-.26l-.136.77a8.36 8.36 0 0 0-1.377 0l-.136-.77a.75.75 0 1 0-1.477.26l.136.77c-.448.121-.88.28-1.294.47l-.39-.676a.75.75 0 0 0-1.3.75l.392.678a8.29 8.29 0 0 0-1.054.885l-.6-.504a.75.75 0 1 0-.965 1.149l.6.503a8.243 8.243 0 0 0-.689 1.192L3.8 8.216a.75.75 0 1 0-.513 1.41l.735.267a8.222 8.222 0 0 0-.238 1.356h-.783a.75.75 0 0 0 0 1.5h.783c.042.464.122.917.238 1.356l-.735.268a.75.75 0 0 0 .513 1.41l.735-.268c.197.417.428.816.69 1.191l-.6.504a.75.75 0 0 0 .963 1.15l.601-.505c.326.323.679.62 1.054.885l-.392.68a.75.75 0 0 0 1.3.75l.39-.679c.414.192.847.35 1.294.471l-.136.77a.75.75 0 0 0 1.477.261l.137-.772a8.332 8.332 0 0 0 1.376 0l.136.772a.75.75 0 1 0 1.477-.26l-.136-.771a8.19 8.19 0 0 0 1.294-.47l.391.677a.75.75 0 0 0 1.3-.75l-.393-.679a8.29 8.29 0 0 0 1.054-.885l.601.504a.75.75 0 0 0 .964-1.15l-.6-.503c.261-.375.492-.774.69-1.191l.735.267a.75.75 0 1 0 .512-1.41l-.734-.267c.115-.439.195-.892.237-1.356h.784Zm-2.657-3.06a6.744 6.744 0 0 0-1.19-2.053 6.784 6.784 0 0 0-1.82-1.51A6.705 6.705 0 0 0 12 5.25a6.8 6.8 0 0 0-1.225.11 6.7 6.7 0 0 0-2.15.793 6.784 6.784 0 0 0-2.952 3.489.76.76 0 0 1-.036.098A6.74 6.74 0 0 0 5.251 12a6.74 6.74 0 0 0 3.366 5.842l.009.005a6.704 6.704 0 0 0 2.18.798l.022.003a6.792 6.792 0 0 0 2.368-.004 6.704 6.704 0 0 0 2.205-.811 6.785 6.785 0 0 0 1.762-1.484l.009-.01.009-.01a6.743 6.743 0 0 0 1.18-2.066c.253-.707.39-1.469.39-2.263a6.74 6.74 0 0 0-.408-2.309Z",
    clipRule: "evenodd"
  }));
}
const XL = /* @__PURE__ */ s.forwardRef(YL);
function qL({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 6a3 3 0 0 1 3-3h13.5a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V6Zm3.97.97a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06l-2.25 2.25a.75.75 0 0 1-1.06-1.06l1.72-1.72-1.72-1.72a.75.75 0 0 1 0-1.06Zm4.28 4.28a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Z",
    clipRule: "evenodd"
  }));
}
const KL = /* @__PURE__ */ s.forwardRef(qL);
function QL({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 5.25a3 3 0 0 1 3-3h13.5a3 3 0 0 1 3 3V15a3 3 0 0 1-3 3h-3v.257c0 .597.237 1.17.659 1.591l.621.622a.75.75 0 0 1-.53 1.28h-9a.75.75 0 0 1-.53-1.28l.621-.622a2.25 2.25 0 0 0 .659-1.59V18h-3a3 3 0 0 1-3-3V5.25Zm1.5 0v7.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-7.5a1.5 1.5 0 0 0-1.5-1.5H5.25a1.5 1.5 0 0 0-1.5 1.5Z",
    clipRule: "evenodd"
  }));
}
const JL = /* @__PURE__ */ s.forwardRef(QL);
function eT({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M16.5 7.5h-9v9h9v-9Z"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M8.25 2.25A.75.75 0 0 1 9 3v.75h2.25V3a.75.75 0 0 1 1.5 0v.75H15V3a.75.75 0 0 1 1.5 0v.75h.75a3 3 0 0 1 3 3v.75H21A.75.75 0 0 1 21 9h-.75v2.25H21a.75.75 0 0 1 0 1.5h-.75V15H21a.75.75 0 0 1 0 1.5h-.75v.75a3 3 0 0 1-3 3h-.75V21a.75.75 0 0 1-1.5 0v-.75h-2.25V21a.75.75 0 0 1-1.5 0v-.75H9V21a.75.75 0 0 1-1.5 0v-.75h-.75a3 3 0 0 1-3-3v-.75H3A.75.75 0 0 1 3 15h.75v-2.25H3a.75.75 0 0 1 0-1.5h.75V9H3a.75.75 0 0 1 0-1.5h.75v-.75a3 3 0 0 1 3-3h.75V3a.75.75 0 0 1 .75-.75ZM6 6.75A.75.75 0 0 1 6.75 6h10.5a.75.75 0 0 1 .75.75v10.5a.75.75 0 0 1-.75.75H6.75a.75.75 0 0 1-.75-.75V6.75Z",
    clipRule: "evenodd"
  }));
}
const tT = /* @__PURE__ */ s.forwardRef(eT);
function rT({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M4.5 3.75a3 3 0 0 0-3 3v.75h21v-.75a3 3 0 0 0-3-3h-15Z"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M22.5 9.75h-21v7.5a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-7.5Zm-18 3.75a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75Zm.75 2.25a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Z",
    clipRule: "evenodd"
  }));
}
const nT = /* @__PURE__ */ s.forwardRef(rT);
function aT({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M11.622 1.602a.75.75 0 0 1 .756 0l2.25 1.313a.75.75 0 0 1-.756 1.295L12 3.118 10.128 4.21a.75.75 0 1 1-.756-1.295l2.25-1.313ZM5.898 5.81a.75.75 0 0 1-.27 1.025l-1.14.665 1.14.665a.75.75 0 1 1-.756 1.295L3.75 8.806v.944a.75.75 0 0 1-1.5 0V7.5a.75.75 0 0 1 .372-.648l2.25-1.312a.75.75 0 0 1 1.026.27Zm12.204 0a.75.75 0 0 1 1.026-.27l2.25 1.312a.75.75 0 0 1 .372.648v2.25a.75.75 0 0 1-1.5 0v-.944l-1.122.654a.75.75 0 1 1-.756-1.295l1.14-.665-1.14-.665a.75.75 0 0 1-.27-1.025Zm-9 5.25a.75.75 0 0 1 1.026-.27L12 11.882l1.872-1.092a.75.75 0 1 1 .756 1.295l-1.878 1.096V15a.75.75 0 0 1-1.5 0v-1.82l-1.878-1.095a.75.75 0 0 1-.27-1.025ZM3 13.5a.75.75 0 0 1 .75.75v1.82l1.878 1.095a.75.75 0 1 1-.756 1.295l-2.25-1.312a.75.75 0 0 1-.372-.648v-2.25A.75.75 0 0 1 3 13.5Zm18 0a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-.372.648l-2.25 1.312a.75.75 0 1 1-.756-1.295l1.878-1.096V14.25a.75.75 0 0 1 .75-.75Zm-9 5.25a.75.75 0 0 1 .75.75v.944l1.122-.654a.75.75 0 1 1 .756 1.295l-2.25 1.313a.75.75 0 0 1-.756 0l-2.25-1.313a.75.75 0 1 1 .756-1.295l1.122.654V19.5a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  }));
}
const oT = /* @__PURE__ */ s.forwardRef(aT);
function iT({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M12.378 1.602a.75.75 0 0 0-.756 0L3 6.632l9 5.25 9-5.25-8.622-5.03ZM21.75 7.93l-9 5.25v9l8.628-5.032a.75.75 0 0 0 .372-.648V7.93ZM11.25 22.18v-9l-9-5.25v8.57a.75.75 0 0 0 .372.648l8.628 5.033Z"
  }));
}
const lT = /* @__PURE__ */ s.forwardRef(iT);
function sT({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 21.75c5.385 0 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25 2.25 6.615 2.25 12s4.365 9.75 9.75 9.75ZM10.5 7.963a1.5 1.5 0 0 0-2.17-1.341l-.415.207a.75.75 0 0 0 .67 1.342L9 7.963V9.75h-.75a.75.75 0 1 0 0 1.5H9v4.688c0 .563.26 1.198.867 1.525A4.501 4.501 0 0 0 16.41 14.4c.199-.977-.636-1.649-1.415-1.649h-.745a.75.75 0 1 0 0 1.5h.656a3.002 3.002 0 0 1-4.327 1.893.113.113 0 0 1-.045-.051.336.336 0 0 1-.034-.154V11.25h5.25a.75.75 0 0 0 0-1.5H10.5V7.963Z",
    clipRule: "evenodd"
  }));
}
const cT = /* @__PURE__ */ s.forwardRef(sT);
function uT({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M10.464 8.746c.227-.18.497-.311.786-.394v2.795a2.252 2.252 0 0 1-.786-.393c-.394-.313-.546-.681-.546-1.004 0-.323.152-.691.546-1.004ZM12.75 15.662v-2.824c.347.085.664.228.921.421.427.32.579.686.579.991 0 .305-.152.671-.579.991a2.534 2.534 0 0 1-.921.42Z"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 6a.75.75 0 0 0-1.5 0v.816a3.836 3.836 0 0 0-1.72.756c-.712.566-1.112 1.35-1.112 2.178 0 .829.4 1.612 1.113 2.178.502.4 1.102.647 1.719.756v2.978a2.536 2.536 0 0 1-.921-.421l-.879-.66a.75.75 0 0 0-.9 1.2l.879.66c.533.4 1.169.645 1.821.75V18a.75.75 0 0 0 1.5 0v-.81a4.124 4.124 0 0 0 1.821-.749c.745-.559 1.179-1.344 1.179-2.191 0-.847-.434-1.632-1.179-2.191a4.122 4.122 0 0 0-1.821-.75V8.354c.29.082.559.213.786.393l.415.33a.75.75 0 0 0 .933-1.175l-.415-.33a3.836 3.836 0 0 0-1.719-.755V6Z",
    clipRule: "evenodd"
  }));
}
const dT = /* @__PURE__ */ s.forwardRef(uT);
function fT({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.902 7.098a3.75 3.75 0 0 1 3.903-.884.75.75 0 1 0 .498-1.415A5.25 5.25 0 0 0 8.005 9.75H7.5a.75.75 0 0 0 0 1.5h.054a5.281 5.281 0 0 0 0 1.5H7.5a.75.75 0 0 0 0 1.5h.505a5.25 5.25 0 0 0 6.494 2.701.75.75 0 1 0-.498-1.415 3.75 3.75 0 0 1-4.252-1.286h3.001a.75.75 0 0 0 0-1.5H9.075a3.77 3.77 0 0 1 0-1.5h3.675a.75.75 0 0 0 0-1.5h-3c.105-.14.221-.274.348-.402Z",
    clipRule: "evenodd"
  }));
}
const hT = /* @__PURE__ */ s.forwardRef(fT);
function vT({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM9.763 9.51a2.25 2.25 0 0 1 3.828-1.351.75.75 0 0 0 1.06-1.06 3.75 3.75 0 0 0-6.38 2.252c-.033.307 0 .595.032.822l.154 1.077H8.25a.75.75 0 0 0 0 1.5h.421l.138.964a3.75 3.75 0 0 1-.358 2.208l-.122.242a.75.75 0 0 0 .908 1.047l1.539-.512a1.5 1.5 0 0 1 .948 0l.655.218a3 3 0 0 0 2.29-.163l.666-.333a.75.75 0 1 0-.67-1.342l-.667.333a1.5 1.5 0 0 1-1.145.082l-.654-.218a3 3 0 0 0-1.898 0l-.06.02a5.25 5.25 0 0 0 .053-1.794l-.108-.752H12a.75.75 0 0 0 0-1.5H9.972l-.184-1.29a1.863 1.863 0 0 1-.025-.45Z",
    clipRule: "evenodd"
  }));
}
const pT = /* @__PURE__ */ s.forwardRef(vT);
function gT({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM9 7.5A.75.75 0 0 0 9 9h1.5c.98 0 1.813.626 2.122 1.5H9A.75.75 0 0 0 9 12h3.622a2.251 2.251 0 0 1-2.122 1.5H9a.75.75 0 0 0-.53 1.28l3 3a.75.75 0 1 0 1.06-1.06L10.8 14.988A3.752 3.752 0 0 0 14.175 12H15a.75.75 0 0 0 0-1.5h-.825A3.733 3.733 0 0 0 13.5 9H15a.75.75 0 0 0 0-1.5H9Z",
    clipRule: "evenodd"
  }));
}
const mT = /* @__PURE__ */ s.forwardRef(gT);
function wT({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM9.624 7.084a.75.75 0 0 0-1.248.832l2.223 3.334H9a.75.75 0 0 0 0 1.5h2.25v1.5H9a.75.75 0 0 0 0 1.5h2.25v1.5a.75.75 0 0 0 1.5 0v-1.5H15a.75.75 0 0 0 0-1.5h-2.25v-1.5H15a.75.75 0 0 0 0-1.5h-1.599l2.223-3.334a.75.75 0 1 0-1.248-.832L12 10.648 9.624 7.084Z",
    clipRule: "evenodd"
  }));
}
const yT = /* @__PURE__ */ s.forwardRef(wT);
function bT({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 1.5a.75.75 0 0 1 .75.75V4.5a.75.75 0 0 1-1.5 0V2.25A.75.75 0 0 1 12 1.5ZM5.636 4.136a.75.75 0 0 1 1.06 0l1.592 1.591a.75.75 0 0 1-1.061 1.06l-1.591-1.59a.75.75 0 0 1 0-1.061Zm12.728 0a.75.75 0 0 1 0 1.06l-1.591 1.592a.75.75 0 0 1-1.06-1.061l1.59-1.591a.75.75 0 0 1 1.061 0Zm-6.816 4.496a.75.75 0 0 1 .82.311l5.228 7.917a.75.75 0 0 1-.777 1.148l-2.097-.43 1.045 3.9a.75.75 0 0 1-1.45.388l-1.044-3.899-1.601 1.42a.75.75 0 0 1-1.247-.606l.569-9.47a.75.75 0 0 1 .554-.68ZM3 10.5a.75.75 0 0 1 .75-.75H6a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 10.5Zm14.25 0a.75.75 0 0 1 .75-.75h2.25a.75.75 0 0 1 0 1.5H18a.75.75 0 0 1-.75-.75Zm-8.962 3.712a.75.75 0 0 1 0 1.061l-1.591 1.591a.75.75 0 1 1-1.061-1.06l1.591-1.592a.75.75 0 0 1 1.06 0Z",
    clipRule: "evenodd"
  }));
}
const _T = /* @__PURE__ */ s.forwardRef(bT);
function xT({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M17.303 5.197A7.5 7.5 0 0 0 6.697 15.803a.75.75 0 0 1-1.061 1.061A9 9 0 1 1 21 10.5a.75.75 0 0 1-1.5 0c0-1.92-.732-3.839-2.197-5.303Zm-2.121 2.121a4.5 4.5 0 0 0-6.364 6.364.75.75 0 1 1-1.06 1.06A6 6 0 1 1 18 10.5a.75.75 0 0 1-1.5 0c0-1.153-.44-2.303-1.318-3.182Zm-3.634 1.314a.75.75 0 0 1 .82.311l5.228 7.917a.75.75 0 0 1-.777 1.148l-2.097-.43 1.045 3.9a.75.75 0 0 1-1.45.388l-1.044-3.899-1.601 1.42a.75.75 0 0 1-1.247-.606l.569-9.47a.75.75 0 0 1 .554-.68Z",
    clipRule: "evenodd"
  }));
}
const CT = /* @__PURE__ */ s.forwardRef(xT);
function ET({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M10.5 18.75a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Z"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M8.625.75A3.375 3.375 0 0 0 5.25 4.125v15.75a3.375 3.375 0 0 0 3.375 3.375h6.75a3.375 3.375 0 0 0 3.375-3.375V4.125A3.375 3.375 0 0 0 15.375.75h-6.75ZM7.5 4.125C7.5 3.504 8.004 3 8.625 3H9.75v.375c0 .621.504 1.125 1.125 1.125h2.25c.621 0 1.125-.504 1.125-1.125V3h1.125c.621 0 1.125.504 1.125 1.125v15.75c0 .621-.504 1.125-1.125 1.125h-6.75A1.125 1.125 0 0 1 7.5 19.875V4.125Z",
    clipRule: "evenodd"
  }));
}
const ST = /* @__PURE__ */ s.forwardRef(ET);
function RT({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M10.5 18a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Z"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M7.125 1.5A3.375 3.375 0 0 0 3.75 4.875v14.25A3.375 3.375 0 0 0 7.125 22.5h9.75a3.375 3.375 0 0 0 3.375-3.375V4.875A3.375 3.375 0 0 0 16.875 1.5h-9.75ZM6 4.875c0-.621.504-1.125 1.125-1.125h9.75c.621 0 1.125.504 1.125 1.125v14.25c0 .621-.504 1.125-1.125 1.125h-9.75A1.125 1.125 0 0 1 6 19.125V4.875Z",
    clipRule: "evenodd"
  }));
}
const MT = /* @__PURE__ */ s.forwardRef(RT);
function AT({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M10.874 5.248a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm-7.125 6.75a.75.75 0 0 1 .75-.75h15a.75.75 0 0 1 0 1.5h-15a.75.75 0 0 1-.75-.75Zm7.125 6.753a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Z",
    clipRule: "evenodd"
  }));
}
const kT = /* @__PURE__ */ s.forwardRef(AT);
function LT({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm5.845 17.03a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V12a.75.75 0 0 0-1.5 0v4.19l-1.72-1.72a.75.75 0 0 0-1.06 1.06l3 3Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z"
  }));
}
const TT = /* @__PURE__ */ s.forwardRef(LT);
function OT({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6.905 9.97a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 1 0 1.06 1.06l1.72-1.72V18a.75.75 0 0 0 1.5 0v-4.19l1.72 1.72a.75.75 0 1 0 1.06-1.06l-3-3Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z"
  }));
}
const IT = /* @__PURE__ */ s.forwardRef(OT);
function PT({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875ZM9.75 17.25a.75.75 0 0 0-1.5 0V18a.75.75 0 0 0 1.5 0v-.75Zm2.25-3a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75Zm3.75-1.5a.75.75 0 0 0-1.5 0V18a.75.75 0 0 0 1.5 0v-5.25Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z"
  }));
}
const DT = /* @__PURE__ */ s.forwardRef(PT);
function NT({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M9 1.5H5.625c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5Zm6.61 10.936a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 14.47a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z"
  }));
}
const BT = /* @__PURE__ */ s.forwardRef(NT);
function FT({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3.75 3.375c0-1.036.84-1.875 1.875-1.875H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375Zm10.5 1.875a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Zm-3.75 5.56c0-1.336-1.616-2.005-2.56-1.06l-.22.22a.75.75 0 0 0 1.06 1.06l.22-.22v1.94h-.75a.75.75 0 0 0 0 1.5H9v3c0 .671.307 1.453 1.068 1.815a4.5 4.5 0 0 0 5.993-2.123c.233-.487.14-1-.136-1.37A1.459 1.459 0 0 0 14.757 15h-.507a.75.75 0 0 0 0 1.5h.349a2.999 2.999 0 0 1-3.887 1.21c-.091-.043-.212-.186-.212-.46v-3h5.25a.75.75 0 1 0 0-1.5H10.5v-1.94Z",
    clipRule: "evenodd"
  }));
}
const $T = /* @__PURE__ */ s.forwardRef(FT);
function VT({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3.75 3.375c0-1.036.84-1.875 1.875-1.875H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375Zm10.5 1.875a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25ZM12 10.5a.75.75 0 0 1 .75.75v.028a9.727 9.727 0 0 1 1.687.28.75.75 0 1 1-.374 1.452 8.207 8.207 0 0 0-1.313-.226v1.68l.969.332c.67.23 1.281.85 1.281 1.704 0 .158-.007.314-.02.468-.083.931-.83 1.582-1.669 1.695a9.776 9.776 0 0 1-.561.059v.028a.75.75 0 0 1-1.5 0v-.029a9.724 9.724 0 0 1-1.687-.278.75.75 0 0 1 .374-1.453c.425.11.864.186 1.313.226v-1.68l-.968-.332C9.612 14.974 9 14.354 9 13.5c0-.158.007-.314.02-.468.083-.931.831-1.582 1.67-1.694.185-.025.372-.045.56-.06v-.028a.75.75 0 0 1 .75-.75Zm-1.11 2.324c.119-.016.239-.03.36-.04v1.166l-.482-.165c-.208-.072-.268-.211-.268-.285 0-.113.005-.225.015-.336.013-.146.14-.309.374-.34Zm1.86 4.392V16.05l.482.165c.208.072.268.211.268.285 0 .113-.005.225-.015.336-.012.146-.14.309-.374.34-.12.016-.24.03-.361.04Z",
    clipRule: "evenodd"
  }));
}
const ZT = /* @__PURE__ */ s.forwardRef(VT);
function HT({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3.75 3.375c0-1.036.84-1.875 1.875-1.875H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375Zm7.464 9.442c.459-.573 1.019-.817 1.536-.817.517 0 1.077.244 1.536.817a.75.75 0 1 0 1.171-.937c-.713-.892-1.689-1.38-2.707-1.38-1.018 0-1.994.488-2.707 1.38a4.61 4.61 0 0 0-.705 1.245H8.25a.75.75 0 0 0 0 1.5h.763c-.017.25-.017.5 0 .75H8.25a.75.75 0 0 0 0 1.5h1.088c.17.449.406.87.705 1.245.713.892 1.689 1.38 2.707 1.38 1.018 0 1.994-.488 2.707-1.38a.75.75 0 0 0-1.171-.937c-.459.573-1.019.817-1.536.817-.517 0-1.077-.244-1.536-.817-.078-.098-.15-.2-.215-.308h1.751a.75.75 0 0 0 0-1.5h-2.232a3.965 3.965 0 0 1 0-.75h2.232a.75.75 0 0 0 0-1.5H11c.065-.107.136-.21.214-.308Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z"
  }));
}
const jT = /* @__PURE__ */ s.forwardRef(HT);
function WT({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3.75 3.375c0-1.036.84-1.875 1.875-1.875H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375Zm10.5 1.875a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Zm-3.674 9.583a2.249 2.249 0 0 1 3.765-2.174.75.75 0 0 0 1.06-1.06A3.75 3.75 0 0 0 9.076 15H8.25a.75.75 0 0 0 0 1.5h1.156a3.75 3.75 0 0 1-.206 1.559l-.156.439a.75.75 0 0 0 1.042.923l.439-.22a2.113 2.113 0 0 1 1.613-.115 3.613 3.613 0 0 0 2.758-.196l.44-.22a.75.75 0 1 0-.671-1.341l-.44.22a2.113 2.113 0 0 1-1.613.114 3.612 3.612 0 0 0-1.745-.134c.048-.341.062-.686.042-1.029H12a.75.75 0 0 0 0-1.5h-1.379l-.045-.167Z",
    clipRule: "evenodd"
  }));
}
const zT = /* @__PURE__ */ s.forwardRef(WT);
function GT({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3.75 3.375c0-1.036.84-1.875 1.875-1.875H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375Zm10.5 1.875a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Zm-4.5 5.25a.75.75 0 0 0 0 1.5h.375c.769 0 1.43.463 1.719 1.125H9.75a.75.75 0 0 0 0 1.5h2.094a1.875 1.875 0 0 1-1.719 1.125H9.75a.75.75 0 0 0-.53 1.28l2.25 2.25a.75.75 0 0 0 1.06-1.06l-1.193-1.194a3.382 3.382 0 0 0 2.08-2.401h.833a.75.75 0 0 0 0-1.5h-.834A3.357 3.357 0 0 0 12.932 12h1.318a.75.75 0 0 0 0-1.5H10.5c-.04 0-.08.003-.12.01a3.425 3.425 0 0 0-.255-.01H9.75Z",
    clipRule: "evenodd"
  }));
}
const UT = /* @__PURE__ */ s.forwardRef(GT);
function YT({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3.75 3.375c0-1.036.84-1.875 1.875-1.875H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375Zm10.5 1.875a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Zm-3.9 5.55a.75.75 0 0 0-1.2.9l1.912 2.55H9.75a.75.75 0 0 0 0 1.5h1.5v.75h-1.5a.75.75 0 0 0 0 1.5h1.5v.75a.75.75 0 1 0 1.5 0V18h1.5a.75.75 0 1 0 0-1.5h-1.5v-.75h1.5a.75.75 0 1 0 0-1.5h-1.313l1.913-2.55a.75.75 0 1 0-1.2-.9L12 13l-1.65-2.2Z",
    clipRule: "evenodd"
  }));
}
const XT = /* @__PURE__ */ s.forwardRef(YT);
function qT({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M7.5 3.375c0-1.036.84-1.875 1.875-1.875h.375a3.75 3.75 0 0 1 3.75 3.75v1.875C13.5 8.161 14.34 9 15.375 9h1.875A3.75 3.75 0 0 1 21 12.75v3.375C21 17.16 20.16 18 19.125 18h-9.75A1.875 1.875 0 0 1 7.5 16.125V3.375Z"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M15 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 17.25 7.5h-1.875A.375.375 0 0 1 15 7.125V5.25ZM4.875 6H6v10.125A3.375 3.375 0 0 0 9.375 19.5H16.5v1.125c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 0 1 3 20.625V7.875C3 6.839 3.84 6 4.875 6Z"
  }));
}
const KT = /* @__PURE__ */ s.forwardRef(qT);
function QT({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z"
  }));
}
const JT = /* @__PURE__ */ s.forwardRef(QT);
function eO({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875ZM9.75 14.25a.75.75 0 0 0 0 1.5H15a.75.75 0 0 0 0-1.5H9.75Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z"
  }));
}
const tO = /* @__PURE__ */ s.forwardRef(eO);
function rO({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875ZM12.75 12a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V18a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V12Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z"
  }));
}
const nO = /* @__PURE__ */ s.forwardRef(rO);
function aO({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5H5.625ZM7.5 15a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 7.5 15Zm.75 2.25a.75.75 0 0 0 0 1.5H12a.75.75 0 0 0 0-1.5H8.25Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z"
  }));
}
const oO = /* @__PURE__ */ s.forwardRef(aO);
function iO({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5H5.625Z"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z"
  }));
}
const lO = /* @__PURE__ */ s.forwardRef(iO);
function sO({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm0 8.625a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25ZM15.375 12a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0ZM7.5 10.875a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Z",
    clipRule: "evenodd"
  }));
}
const cO = /* @__PURE__ */ s.forwardRef(sO);
function uO({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 12a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm6 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm6 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
    clipRule: "evenodd"
  }));
}
const dO = /* @__PURE__ */ s.forwardRef(uO);
function fO({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M10.5 6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm0 6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm0 6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
    clipRule: "evenodd"
  }));
}
const hO = /* @__PURE__ */ s.forwardRef(fO);
function vO({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M19.5 22.5a3 3 0 0 0 3-3v-8.174l-6.879 4.022 3.485 1.876a.75.75 0 1 1-.712 1.321l-5.683-3.06a1.5 1.5 0 0 0-1.422 0l-5.683 3.06a.75.75 0 0 1-.712-1.32l3.485-1.877L1.5 11.326V19.5a3 3 0 0 0 3 3h15Z"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M1.5 9.589v-.745a3 3 0 0 1 1.578-2.642l7.5-4.038a3 3 0 0 1 2.844 0l7.5 4.038A3 3 0 0 1 22.5 8.844v.745l-8.426 4.926-.652-.351a3 3 0 0 0-2.844 0l-.652.351L1.5 9.589Z"
  }));
}
const pO = /* @__PURE__ */ s.forwardRef(vO);
function gO({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M1.5 8.67v8.58a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8.67l-8.928 5.493a3 3 0 0 1-3.144 0L1.5 8.67Z"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M22.5 6.908V6.75a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v.158l9.714 5.978a1.5 1.5 0 0 0 1.572 0L22.5 6.908Z"
  }));
}
const mO = /* @__PURE__ */ s.forwardRef(gO);
function wO({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3.748 8.248a.75.75 0 0 1 .75-.75h15a.75.75 0 0 1 0 1.5h-15a.75.75 0 0 1-.75-.75ZM3.748 15.75a.75.75 0 0 1 .75-.751h15a.75.75 0 0 1 0 1.5h-15a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  }));
}
const yO = /* @__PURE__ */ s.forwardRef(wO);
function bO({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
    clipRule: "evenodd"
  }));
}
const _O = /* @__PURE__ */ s.forwardRef(bO);
function xO({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
    clipRule: "evenodd"
  }));
}
const CO = /* @__PURE__ */ s.forwardRef(xO);
function EO({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M16.098 2.598a3.75 3.75 0 1 1 3.622 6.275l-1.72.46V12a.75.75 0 0 1-.22.53l-.75.75a.75.75 0 0 1-1.06 0l-.97-.97-7.94 7.94a2.56 2.56 0 0 1-1.81.75 1.06 1.06 0 0 0-.75.31l-.97.97a.75.75 0 0 1-1.06 0l-.75-.75a.75.75 0 0 1 0-1.06l.97-.97a1.06 1.06 0 0 0 .31-.75c0-.68.27-1.33.75-1.81L11.69 9l-.97-.97a.75.75 0 0 1 0-1.06l.75-.75A.75.75 0 0 1 12 6h2.666l.461-1.72c.165-.617.49-1.2.971-1.682Zm-3.348 7.463L4.81 18a1.06 1.06 0 0 0-.31.75c0 .318-.06.63-.172.922a2.56 2.56 0 0 1 .922-.172c.281 0 .551-.112.75-.31l7.94-7.94-1.19-1.19Z",
    clipRule: "evenodd"
  }));
}
const SO = /* @__PURE__ */ s.forwardRef(EO);
function RO({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M3.53 2.47a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06l-18-18ZM22.676 12.553a11.249 11.249 0 0 1-2.631 4.31l-3.099-3.099a5.25 5.25 0 0 0-6.71-6.71L7.759 4.577a11.217 11.217 0 0 1 4.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113Z"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0 1 15.75 12ZM12.53 15.713l-4.243-4.244a3.75 3.75 0 0 0 4.244 4.243Z"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 0 0-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 0 1 6.75 12Z"
  }));
}
const MO = /* @__PURE__ */ s.forwardRef(RO);
function AO({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 0 1 0-1.113ZM17.25 12a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z",
    clipRule: "evenodd"
  }));
}
const kO = /* @__PURE__ */ s.forwardRef(AO);
function LO({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-2.625 6c-.54 0-.828.419-.936.634a1.96 1.96 0 0 0-.189.866c0 .298.059.605.189.866.108.215.395.634.936.634.54 0 .828-.419.936-.634.13-.26.189-.568.189-.866 0-.298-.059-.605-.189-.866-.108-.215-.395-.634-.936-.634Zm4.314.634c.108-.215.395-.634.936-.634.54 0 .828.419.936.634.13.26.189.568.189.866 0 .298-.059.605-.189.866-.108.215-.395.634-.936.634-.54 0-.828-.419-.936-.634a1.96 1.96 0 0 1-.189-.866c0-.298.059-.605.189-.866Zm-4.34 7.964a.75.75 0 0 1-1.061-1.06 5.236 5.236 0 0 1 3.73-1.538 5.236 5.236 0 0 1 3.695 1.538.75.75 0 1 1-1.061 1.06 3.736 3.736 0 0 0-2.639-1.098 3.736 3.736 0 0 0-2.664 1.098Z",
    clipRule: "evenodd"
  }));
}
const TO = /* @__PURE__ */ s.forwardRef(LO);
function OO({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-2.625 6c-.54 0-.828.419-.936.634a1.96 1.96 0 0 0-.189.866c0 .298.059.605.189.866.108.215.395.634.936.634.54 0 .828-.419.936-.634.13-.26.189-.568.189-.866 0-.298-.059-.605-.189-.866-.108-.215-.395-.634-.936-.634Zm4.314.634c.108-.215.395-.634.936-.634.54 0 .828.419.936.634.13.26.189.568.189.866 0 .298-.059.605-.189.866-.108.215-.395.634-.936.634-.54 0-.828-.419-.936-.634a1.96 1.96 0 0 1-.189-.866c0-.298.059-.605.189-.866Zm2.023 6.828a.75.75 0 1 0-1.06-1.06 3.75 3.75 0 0 1-5.304 0 .75.75 0 0 0-1.06 1.06 5.25 5.25 0 0 0 7.424 0Z",
    clipRule: "evenodd"
  }));
}
const IO = /* @__PURE__ */ s.forwardRef(OO);
function PO({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 5.625c0-1.036.84-1.875 1.875-1.875h17.25c1.035 0 1.875.84 1.875 1.875v12.75c0 1.035-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 0 1 1.5 18.375V5.625Zm1.5 0v1.5c0 .207.168.375.375.375h1.5a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375h-1.5A.375.375 0 0 0 3 5.625Zm16.125-.375a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5A.375.375 0 0 0 21 7.125v-1.5a.375.375 0 0 0-.375-.375h-1.5ZM21 9.375A.375.375 0 0 0 20.625 9h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5a.375.375 0 0 0 .375-.375v-1.5Zm0 3.75a.375.375 0 0 0-.375-.375h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5a.375.375 0 0 0 .375-.375v-1.5Zm0 3.75a.375.375 0 0 0-.375-.375h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5a.375.375 0 0 0 .375-.375v-1.5ZM4.875 18.75a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5ZM3.375 15h1.5a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375Zm0-3.75h1.5a.375.375 0 0 0 .375-.375v-1.5A.375.375 0 0 0 4.875 9h-1.5A.375.375 0 0 0 3 9.375v1.5c0 .207.168.375.375.375Zm4.125 0a.75.75 0 0 0 0 1.5h9a.75.75 0 0 0 0-1.5h-9Z",
    clipRule: "evenodd"
  }));
}
const DO = /* @__PURE__ */ s.forwardRef(PO);
function NO({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 3.75a6.715 6.715 0 0 0-3.722 1.118.75.75 0 1 1-.828-1.25 8.25 8.25 0 0 1 12.8 6.883c0 3.014-.574 5.897-1.62 8.543a.75.75 0 0 1-1.395-.551A21.69 21.69 0 0 0 18.75 10.5 6.75 6.75 0 0 0 12 3.75ZM6.157 5.739a.75.75 0 0 1 .21 1.04A6.715 6.715 0 0 0 5.25 10.5c0 1.613-.463 3.12-1.265 4.393a.75.75 0 0 1-1.27-.8A6.715 6.715 0 0 0 3.75 10.5c0-1.68.503-3.246 1.367-4.55a.75.75 0 0 1 1.04-.211ZM12 7.5a3 3 0 0 0-3 3c0 3.1-1.176 5.927-3.105 8.056a.75.75 0 1 1-1.112-1.008A10.459 10.459 0 0 0 7.5 10.5a4.5 4.5 0 1 1 9 0c0 .547-.022 1.09-.067 1.626a.75.75 0 0 1-1.495-.123c.041-.495.062-.996.062-1.503a3 3 0 0 0-3-3Zm0 2.25a.75.75 0 0 1 .75.75c0 3.908-1.424 7.485-3.781 10.238a.75.75 0 0 1-1.14-.975A14.19 14.19 0 0 0 11.25 10.5a.75.75 0 0 1 .75-.75Zm3.239 5.183a.75.75 0 0 1 .515.927 19.417 19.417 0 0 1-2.585 5.544.75.75 0 0 1-1.243-.84 17.915 17.915 0 0 0 2.386-5.116.75.75 0 0 1 .927-.515Z",
    clipRule: "evenodd"
  }));
}
const BO = /* @__PURE__ */ s.forwardRef(NO);
function FO({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12.963 2.286a.75.75 0 0 0-1.071-.136 9.742 9.742 0 0 0-3.539 6.176 7.547 7.547 0 0 1-1.705-1.715.75.75 0 0 0-1.152-.082A9 9 0 1 0 15.68 4.534a7.46 7.46 0 0 1-2.717-2.248ZM15.75 14.25a3.75 3.75 0 1 1-7.313-1.172c.628.465 1.35.81 2.133 1a5.99 5.99 0 0 1 1.925-3.546 3.75 3.75 0 0 1 3.255 3.718Z",
    clipRule: "evenodd"
  }));
}
const $O = /* @__PURE__ */ s.forwardRef(FO);
function VO({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3 2.25a.75.75 0 0 1 .75.75v.54l1.838-.46a9.75 9.75 0 0 1 6.725.738l.108.054A8.25 8.25 0 0 0 18 4.524l3.11-.732a.75.75 0 0 1 .917.81 47.784 47.784 0 0 0 .005 10.337.75.75 0 0 1-.574.812l-3.114.733a9.75 9.75 0 0 1-6.594-.77l-.108-.054a8.25 8.25 0 0 0-5.69-.625l-2.202.55V21a.75.75 0 0 1-1.5 0V3A.75.75 0 0 1 3 2.25Z",
    clipRule: "evenodd"
  }));
}
const ZO = /* @__PURE__ */ s.forwardRef(VO);
function HO({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M19.5 21a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3h-5.379a.75.75 0 0 1-.53-.22L11.47 3.66A2.25 2.25 0 0 0 9.879 3H4.5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h15Zm-6.75-10.5a.75.75 0 0 0-1.5 0v4.19l-1.72-1.72a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V10.5Z",
    clipRule: "evenodd"
  }));
}
const jO = /* @__PURE__ */ s.forwardRef(HO);
function WO({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M19.5 21a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3h-5.379a.75.75 0 0 1-.53-.22L11.47 3.66A2.25 2.25 0 0 0 9.879 3H4.5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h15ZM9 12.75a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5H9Z",
    clipRule: "evenodd"
  }));
}
const zO = /* @__PURE__ */ s.forwardRef(WO);
function GO({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M19.906 9c.382 0 .749.057 1.094.162V9a3 3 0 0 0-3-3h-3.879a.75.75 0 0 1-.53-.22L11.47 3.66A2.25 2.25 0 0 0 9.879 3H6a3 3 0 0 0-3 3v3.162A3.756 3.756 0 0 1 4.094 9h15.812ZM4.094 10.5a2.25 2.25 0 0 0-2.227 2.568l.857 6A2.25 2.25 0 0 0 4.951 21H19.05a2.25 2.25 0 0 0 2.227-1.932l.857-6a2.25 2.25 0 0 0-2.227-2.568H4.094Z"
  }));
}
const UO = /* @__PURE__ */ s.forwardRef(GO);
function YO({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M19.5 21a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3h-5.379a.75.75 0 0 1-.53-.22L11.47 3.66A2.25 2.25 0 0 0 9.879 3H4.5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h15Zm-6.75-10.5a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25v2.25a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V10.5Z",
    clipRule: "evenodd"
  }));
}
const XO = /* @__PURE__ */ s.forwardRef(YO);
function qO({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M19.5 21a3 3 0 0 0 3-3v-4.5a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3V18a3 3 0 0 0 3 3h15ZM1.5 10.146V6a3 3 0 0 1 3-3h5.379a2.25 2.25 0 0 1 1.59.659l2.122 2.121c.14.141.331.22.53.22H19.5a3 3 0 0 1 3 3v1.146A4.483 4.483 0 0 0 19.5 9h-15a4.483 4.483 0 0 0-3 1.146Z"
  }));
}
const KO = /* @__PURE__ */ s.forwardRef(qO);
function QO({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M5.055 7.06C3.805 6.347 2.25 7.25 2.25 8.69v8.122c0 1.44 1.555 2.343 2.805 1.628L12 14.471v2.34c0 1.44 1.555 2.343 2.805 1.628l7.108-4.061c1.26-.72 1.26-2.536 0-3.256l-7.108-4.061C13.555 6.346 12 7.249 12 8.689v2.34L5.055 7.061Z"
  }));
}
const JO = /* @__PURE__ */ s.forwardRef(QO);
function eI({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3.792 2.938A49.069 49.069 0 0 1 12 2.25c2.797 0 5.54.236 8.209.688a1.857 1.857 0 0 1 1.541 1.836v1.044a3 3 0 0 1-.879 2.121l-6.182 6.182a1.5 1.5 0 0 0-.439 1.061v2.927a3 3 0 0 1-1.658 2.684l-1.757.878A.75.75 0 0 1 9.75 21v-5.818a1.5 1.5 0 0 0-.44-1.06L3.13 7.938a3 3 0 0 1-.879-2.121V4.774c0-.897.64-1.683 1.542-1.836Z",
    clipRule: "evenodd"
  }));
}
const tI = /* @__PURE__ */ s.forwardRef(eI);
function rI({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 3.75a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V6.75a3 3 0 0 0-3-3h-15Zm9 4.5a.75.75 0 0 0-1.5 0v7.5a.75.75 0 0 0 1.5 0v-7.5Zm1.5 0a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5H16.5v2.25H18a.75.75 0 0 1 0 1.5h-1.5v3a.75.75 0 0 1-1.5 0v-7.5ZM6.636 9.78c.404-.575.867-.78 1.25-.78s.846.205 1.25.78a.75.75 0 0 0 1.228-.863C9.738 8.027 8.853 7.5 7.886 7.5c-.966 0-1.852.527-2.478 1.417-.62.882-.908 2-.908 3.083 0 1.083.288 2.201.909 3.083.625.89 1.51 1.417 2.477 1.417.967 0 1.852-.527 2.478-1.417a.75.75 0 0 0 .136-.431V12a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 0 0 1.5H9v1.648c-.37.44-.774.602-1.114.602-.383 0-.846-.205-1.25-.78C6.226 13.638 6 12.837 6 12c0-.837.226-1.638.636-2.22Z",
    clipRule: "evenodd"
  }));
}
const nI = /* @__PURE__ */ s.forwardRef(rI);
function aI({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M11.25 3v4.046a3 3 0 0 0-4.277 4.204H1.5v-6A2.25 2.25 0 0 1 3.75 3h7.5ZM12.75 3v4.011a3 3 0 0 1 4.239 4.239H22.5v-6A2.25 2.25 0 0 0 20.25 3h-7.5ZM22.5 12.75h-8.983a4.125 4.125 0 0 0 4.108 3.75.75.75 0 0 1 0 1.5 5.623 5.623 0 0 1-4.875-2.817V21h7.5a2.25 2.25 0 0 0 2.25-2.25v-6ZM11.25 21v-5.817A5.623 5.623 0 0 1 6.375 18a.75.75 0 0 1 0-1.5 4.126 4.126 0 0 0 4.108-3.75H1.5v6A2.25 2.25 0 0 0 3.75 21h7.5Z"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M11.085 10.354c.03.297.038.575.036.805a7.484 7.484 0 0 1-.805-.036c-.833-.084-1.677-.325-2.195-.843a1.5 1.5 0 0 1 2.122-2.12c.517.517.759 1.36.842 2.194ZM12.877 10.354c-.03.297-.038.575-.036.805.23.002.508-.006.805-.036.833-.084 1.677-.325 2.195-.843A1.5 1.5 0 0 0 13.72 8.16c-.518.518-.76 1.362-.843 2.194Z"
  }));
}
const oI = /* @__PURE__ */ s.forwardRef(aI);
function iI({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M9.375 3a1.875 1.875 0 0 0 0 3.75h1.875v4.5H3.375A1.875 1.875 0 0 1 1.5 9.375v-.75c0-1.036.84-1.875 1.875-1.875h3.193A3.375 3.375 0 0 1 12 2.753a3.375 3.375 0 0 1 5.432 3.997h3.943c1.035 0 1.875.84 1.875 1.875v.75c0 1.036-.84 1.875-1.875 1.875H12.75v-4.5h1.875a1.875 1.875 0 1 0-1.875-1.875V6.75h-1.5V4.875C11.25 3.839 10.41 3 9.375 3ZM11.25 12.75H3v6.75a2.25 2.25 0 0 0 2.25 2.25h6v-9ZM12.75 12.75v9h6.75a2.25 2.25 0 0 0 2.25-2.25v-6.75h-9Z"
  }));
}
const lI = /* @__PURE__ */ s.forwardRef(iI);
function sI({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M21.721 12.752a9.711 9.711 0 0 0-.945-5.003 12.754 12.754 0 0 1-4.339 2.708 18.991 18.991 0 0 1-.214 4.772 17.165 17.165 0 0 0 5.498-2.477ZM14.634 15.55a17.324 17.324 0 0 0 .332-4.647c-.952.227-1.945.347-2.966.347-1.021 0-2.014-.12-2.966-.347a17.515 17.515 0 0 0 .332 4.647 17.385 17.385 0 0 0 5.268 0ZM9.772 17.119a18.963 18.963 0 0 0 4.456 0A17.182 17.182 0 0 1 12 21.724a17.18 17.18 0 0 1-2.228-4.605ZM7.777 15.23a18.87 18.87 0 0 1-.214-4.774 12.753 12.753 0 0 1-4.34-2.708 9.711 9.711 0 0 0-.944 5.004 17.165 17.165 0 0 0 5.498 2.477ZM21.356 14.752a9.765 9.765 0 0 1-7.478 6.817 18.64 18.64 0 0 0 1.988-4.718 18.627 18.627 0 0 0 5.49-2.098ZM2.644 14.752c1.682.971 3.53 1.688 5.49 2.099a18.64 18.64 0 0 0 1.988 4.718 9.765 9.765 0 0 1-7.478-6.816ZM13.878 2.43a9.755 9.755 0 0 1 6.116 3.986 11.267 11.267 0 0 1-3.746 2.504 18.63 18.63 0 0 0-2.37-6.49ZM12 2.276a17.152 17.152 0 0 1 2.805 7.121c-.897.23-1.837.353-2.805.353-.968 0-1.908-.122-2.805-.353A17.151 17.151 0 0 1 12 2.276ZM10.122 2.43a18.629 18.629 0 0 0-2.37 6.49 11.266 11.266 0 0 1-3.746-2.504 9.754 9.754 0 0 1 6.116-3.985Z"
  }));
}
const cI = /* @__PURE__ */ s.forwardRef(sI);
function uI({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM6.262 6.072a8.25 8.25 0 1 0 10.562-.766 4.5 4.5 0 0 1-1.318 1.357L14.25 7.5l.165.33a.809.809 0 0 1-1.086 1.085l-.604-.302a1.125 1.125 0 0 0-1.298.21l-.132.131c-.439.44-.439 1.152 0 1.591l.296.296c.256.257.622.374.98.314l1.17-.195c.323-.054.654.036.905.245l1.33 1.108c.32.267.46.694.358 1.1a8.7 8.7 0 0 1-2.288 4.04l-.723.724a1.125 1.125 0 0 1-1.298.21l-.153-.076a1.125 1.125 0 0 1-.622-1.006v-1.089c0-.298-.119-.585-.33-.796l-1.347-1.347a1.125 1.125 0 0 1-.21-1.298L9.75 12l-1.64-1.64a6 6 0 0 1-1.676-3.257l-.172-1.03Z",
    clipRule: "evenodd"
  }));
}
const dI = /* @__PURE__ */ s.forwardRef(uI);
function fI({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M15.75 8.25a.75.75 0 0 1 .75.75c0 1.12-.492 2.126-1.27 2.812a.75.75 0 1 1-.992-1.124A2.243 2.243 0 0 0 15 9a.75.75 0 0 1 .75-.75Z"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM4.575 15.6a8.25 8.25 0 0 0 9.348 4.425 1.966 1.966 0 0 0-1.84-1.275.983.983 0 0 1-.97-.822l-.073-.437c-.094-.565.25-1.11.8-1.267l.99-.282c.427-.123.783-.418.982-.816l.036-.073a1.453 1.453 0 0 1 2.328-.377L16.5 15h.628a2.25 2.25 0 0 1 1.983 1.186 8.25 8.25 0 0 0-6.345-12.4c.044.262.18.503.389.676l1.068.89c.442.369.535 1.01.216 1.49l-.51.766a2.25 2.25 0 0 1-1.161.886l-.143.048a1.107 1.107 0 0 0-.57 1.664c.369.555.169 1.307-.427 1.605L9 13.125l.423 1.059a.956.956 0 0 1-1.652.928l-.679-.906a1.125 1.125 0 0 0-1.906.172L4.575 15.6Z",
    clipRule: "evenodd"
  }));
}
const hI = /* @__PURE__ */ s.forwardRef(fI);
function vI({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM8.547 4.505a8.25 8.25 0 1 0 11.672 8.214l-.46-.46a2.252 2.252 0 0 1-.422-.586l-1.08-2.16a.414.414 0 0 0-.663-.107.827.827 0 0 1-.812.21l-1.273-.363a.89.89 0 0 0-.738 1.595l.587.39c.59.395.674 1.23.172 1.732l-.2.2c-.211.212-.33.498-.33.796v.41c0 .409-.11.809-.32 1.158l-1.315 2.191a2.11 2.11 0 0 1-1.81 1.025 1.055 1.055 0 0 1-1.055-1.055v-1.172c0-.92-.56-1.747-1.414-2.089l-.654-.261a2.25 2.25 0 0 1-1.384-2.46l.007-.042a2.25 2.25 0 0 1 .29-.787l.09-.15a2.25 2.25 0 0 1 2.37-1.048l1.178.236a1.125 1.125 0 0 0 1.302-.795l.208-.73a1.125 1.125 0 0 0-.578-1.315l-.665-.332-.091.091a2.25 2.25 0 0 1-1.591.659h-.18c-.249 0-.487.1-.662.274a.931.931 0 0 1-1.458-1.137l1.279-2.132Z",
    clipRule: "evenodd"
  }));
}
const pI = /* @__PURE__ */ s.forwardRef(vI);
function gI({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M2.243 3.743a.75.75 0 0 1 .75.75v6.75h9v-6.75a.75.75 0 1 1 1.5 0v15.002a.75.75 0 1 1-1.5 0v-6.751h-9v6.75a.75.75 0 1 1-1.5 0v-15a.75.75 0 0 1 .75-.75Zm17.605 4.964a.75.75 0 0 1 .396.661v9.376h1.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5h1.5V10.77l-1.084.722a.75.75 0 1 1-.832-1.248l2.25-1.5a.75.75 0 0 1 .77-.037Z",
    clipRule: "evenodd"
  }));
}
const mI = /* @__PURE__ */ s.forwardRef(gI);
function wI({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M2.246 3.743a.75.75 0 0 1 .75.75v6.75h9v-6.75a.75.75 0 0 1 1.5 0v15.002a.75.75 0 1 1-1.5 0v-6.751h-9v6.75a.75.75 0 1 1-1.5 0v-15a.75.75 0 0 1 .75-.75ZM18.75 10.5c-.727 0-1.441.054-2.138.16a.75.75 0 1 1-.223-1.484 15.867 15.867 0 0 1 3.635-.125c1.149.092 2.153.923 2.348 2.115.084.516.128 1.045.128 1.584 0 1.065-.676 1.927-1.531 2.354l-2.89 1.445a1.5 1.5 0 0 0-.829 1.342v.86h4.5a.75.75 0 1 1 0 1.5H16.5a.75.75 0 0 1-.75-.75v-1.61a3 3 0 0 1 1.659-2.684l2.89-1.445c.447-.223.701-.62.701-1.012a8.32 8.32 0 0 0-.108-1.342c-.075-.457-.47-.82-.987-.862a14.45 14.45 0 0 0-1.155-.046Z",
    clipRule: "evenodd"
  }));
}
const yI = /* @__PURE__ */ s.forwardRef(wI);
function bI({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12.749 3.743a.75.75 0 0 1 .75.75v15.002a.75.75 0 1 1-1.5 0v-6.75H2.997v6.75a.75.75 0 0 1-1.5 0V4.494a.75.75 0 1 1 1.5 0v6.75H12v-6.75a.75.75 0 0 1 .75-.75ZM18.75 10.5c-.727 0-1.441.055-2.139.16a.75.75 0 1 1-.223-1.483 15.87 15.87 0 0 1 3.82-.11c.95.088 1.926.705 2.168 1.794a5.265 5.265 0 0 1-.579 3.765 5.265 5.265 0 0 1 .578 3.765c-.24 1.088-1.216 1.706-2.167 1.793a15.942 15.942 0 0 1-3.82-.109.75.75 0 0 1 .223-1.483 14.366 14.366 0 0 0 3.46.099c.467-.043.773-.322.84-.624a3.768 3.768 0 0 0-.413-2.691H18a.75.75 0 0 1 0-1.5h2.498a3.768 3.768 0 0 0 .413-2.69c-.067-.303-.373-.582-.84-.625-.435-.04-.876-.06-1.321-.06Z",
    clipRule: "evenodd"
  }));
}
const _I = /* @__PURE__ */ s.forwardRef(bI);
function xI({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M10.5 1.875a1.125 1.125 0 0 1 2.25 0v8.219c.517.162 1.02.382 1.5.659V3.375a1.125 1.125 0 0 1 2.25 0v10.937a4.505 4.505 0 0 0-3.25 2.373 8.963 8.963 0 0 1 4-.935A.75.75 0 0 0 18 15v-2.266a3.368 3.368 0 0 1 .988-2.37 1.125 1.125 0 0 1 1.591 1.59 1.118 1.118 0 0 0-.329.79v3.006h-.005a6 6 0 0 1-1.752 4.007l-1.736 1.736a6 6 0 0 1-4.242 1.757H10.5a7.5 7.5 0 0 1-7.5-7.5V6.375a1.125 1.125 0 0 1 2.25 0v5.519c.46-.452.965-.832 1.5-1.141V3.375a1.125 1.125 0 0 1 2.25 0v6.526c.495-.1.997-.151 1.5-.151V1.875Z"
  }));
}
const CI = /* @__PURE__ */ s.forwardRef(xI);
function EI({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M15.73 5.5h1.035A7.465 7.465 0 0 1 18 9.625a7.465 7.465 0 0 1-1.235 4.125h-.148c-.806 0-1.534.446-2.031 1.08a9.04 9.04 0 0 1-2.861 2.4c-.723.384-1.35.956-1.653 1.715a4.499 4.499 0 0 0-.322 1.672v.633A.75.75 0 0 1 9 22a2.25 2.25 0 0 1-2.25-2.25c0-1.152.26-2.243.723-3.218.266-.558-.107-1.282-.725-1.282H3.622c-1.026 0-1.945-.694-2.054-1.715A12.137 12.137 0 0 1 1.5 12.25c0-2.848.992-5.464 2.649-7.521C4.537 4.247 5.136 4 5.754 4H9.77a4.5 4.5 0 0 1 1.423.23l3.114 1.04a4.5 4.5 0 0 0 1.423.23ZM21.669 14.023c.536-1.362.831-2.845.831-4.398 0-1.22-.182-2.398-.52-3.507-.26-.85-1.084-1.368-1.973-1.368H19.1c-.445 0-.72.498-.523.898.591 1.2.924 2.55.924 3.977a8.958 8.958 0 0 1-1.302 4.666c-.245.403.028.959.5.959h1.053c.832 0 1.612-.453 1.918-1.227Z"
  }));
}
const SI = /* @__PURE__ */ s.forwardRef(EI);
function RI({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M7.493 18.5c-.425 0-.82-.236-.975-.632A7.48 7.48 0 0 1 6 15.125c0-1.75.599-3.358 1.602-4.634.151-.192.373-.309.6-.397.473-.183.89-.514 1.212-.924a9.042 9.042 0 0 1 2.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 0 0 .322-1.672V2.75A.75.75 0 0 1 15 2a2.25 2.25 0 0 1 2.25 2.25c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 0 1-2.649 7.521c-.388.482-.987.729-1.605.729H14.23c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 0 0-1.423-.23h-.777ZM2.331 10.727a11.969 11.969 0 0 0-.831 4.398 12 12 0 0 0 .52 3.507C2.28 19.482 3.105 20 3.994 20H4.9c.445 0 .72-.498.523-.898a8.963 8.963 0 0 1-.924-3.977c0-1.708.476-3.305 1.302-4.666.245-.403-.028-.959-.5-.959H4.25c-.832 0-1.612.453-1.918 1.227Z"
  }));
}
const MI = /* @__PURE__ */ s.forwardRef(RI);
function AI({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M11.097 1.515a.75.75 0 0 1 .589.882L10.666 7.5h4.47l1.079-5.397a.75.75 0 1 1 1.47.294L16.665 7.5h3.585a.75.75 0 0 1 0 1.5h-3.885l-1.2 6h3.585a.75.75 0 0 1 0 1.5h-3.885l-1.08 5.397a.75.75 0 1 1-1.47-.294l1.02-5.103h-4.47l-1.08 5.397a.75.75 0 1 1-1.47-.294l1.02-5.103H3.75a.75.75 0 0 1 0-1.5h3.885l1.2-6H5.25a.75.75 0 0 1 0-1.5h3.885l1.08-5.397a.75.75 0 0 1 .882-.588ZM10.365 9l-1.2 6h4.47l1.2-6h-4.47Z",
    clipRule: "evenodd"
  }));
}
const kI = /* @__PURE__ */ s.forwardRef(AI);
function LI({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "m11.645 20.91-.007-.003-.022-.012a15.247 15.247 0 0 1-.383-.218 25.18 25.18 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052 5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 0 1-4.244 3.17 15.247 15.247 0 0 1-.383.219l-.022.012-.007.004-.003.001a.752.752 0 0 1-.704 0l-.003-.001Z"
  }));
}
const TI = /* @__PURE__ */ s.forwardRef(LI);
function OI({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M19.006 3.705a.75.75 0 1 0-.512-1.41L6 6.838V3a.75.75 0 0 0-.75-.75h-1.5A.75.75 0 0 0 3 3v4.93l-1.006.365a.75.75 0 0 0 .512 1.41l16.5-6Z"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3.019 11.114 18 5.667v3.421l4.006 1.457a.75.75 0 1 1-.512 1.41l-.494-.18v8.475h.75a.75.75 0 0 1 0 1.5H2.25a.75.75 0 0 1 0-1.5H3v-9.129l.019-.007ZM18 20.25v-9.566l1.5.546v9.02H18Zm-9-6a.75.75 0 0 0-.75.75v4.5c0 .414.336.75.75.75h3a.75.75 0 0 0 .75-.75V15a.75.75 0 0 0-.75-.75H9Z",
    clipRule: "evenodd"
  }));
}
const II = /* @__PURE__ */ s.forwardRef(OI);
function PI({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M11.47 3.841a.75.75 0 0 1 1.06 0l8.69 8.69a.75.75 0 1 0 1.06-1.061l-8.689-8.69a2.25 2.25 0 0 0-3.182 0l-8.69 8.69a.75.75 0 1 0 1.061 1.06l8.69-8.689Z"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "m12 5.432 8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0-.75.75V21a.75.75 0 0 1-.75.75H5.625a1.875 1.875 0 0 1-1.875-1.875v-6.198a2.29 2.29 0 0 0 .091-.086L12 5.432Z"
  }));
}
const DI = /* @__PURE__ */ s.forwardRef(PI);
function NI({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 3.75a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V6.75a3 3 0 0 0-3-3h-15Zm4.125 3a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Zm-3.873 8.703a4.126 4.126 0 0 1 7.746 0 .75.75 0 0 1-.351.92 7.47 7.47 0 0 1-3.522.877 7.47 7.47 0 0 1-3.522-.877.75.75 0 0 1-.351-.92ZM15 8.25a.75.75 0 0 0 0 1.5h3.75a.75.75 0 0 0 0-1.5H15ZM14.25 12a.75.75 0 0 1 .75-.75h3.75a.75.75 0 0 1 0 1.5H15a.75.75 0 0 1-.75-.75Zm.75 2.25a.75.75 0 0 0 0 1.5h3.75a.75.75 0 0 0 0-1.5H15Z",
    clipRule: "evenodd"
  }));
}
const BI = /* @__PURE__ */ s.forwardRef(NI);
function FI({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M5.478 5.559A1.5 1.5 0 0 1 6.912 4.5H9A.75.75 0 0 0 9 3H6.912a3 3 0 0 0-2.868 2.118l-2.411 7.838a3 3 0 0 0-.133.882V18a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-4.162c0-.299-.045-.596-.133-.882l-2.412-7.838A3 3 0 0 0 17.088 3H15a.75.75 0 0 0 0 1.5h2.088a1.5 1.5 0 0 1 1.434 1.059l2.213 7.191H17.89a3 3 0 0 0-2.684 1.658l-.256.513a1.5 1.5 0 0 1-1.342.829h-3.218a1.5 1.5 0 0 1-1.342-.83l-.256-.512a3 3 0 0 0-2.684-1.658H3.265l2.213-7.191Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25a.75.75 0 0 1 .75.75v6.44l1.72-1.72a.75.75 0 1 1 1.06 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 1.06-1.06l1.72 1.72V3a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  }));
}
const $I = /* @__PURE__ */ s.forwardRef(FI);
function VI({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 9.832v1.793c0 1.036.84 1.875 1.875 1.875h17.25c1.035 0 1.875-.84 1.875-1.875V9.832a3 3 0 0 0-.722-1.952l-3.285-3.832A3 3 0 0 0 16.215 3h-8.43a3 3 0 0 0-2.278 1.048L2.222 7.88A3 3 0 0 0 1.5 9.832ZM7.785 4.5a1.5 1.5 0 0 0-1.139.524L3.881 8.25h3.165a3 3 0 0 1 2.496 1.336l.164.246a1.5 1.5 0 0 0 1.248.668h2.092a1.5 1.5 0 0 0 1.248-.668l.164-.246a3 3 0 0 1 2.496-1.336h3.165l-2.765-3.226a1.5 1.5 0 0 0-1.139-.524h-8.43Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M2.813 15c-.725 0-1.313.588-1.313 1.313V18a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-1.688c0-.724-.588-1.312-1.313-1.312h-4.233a3 3 0 0 0-2.496 1.336l-.164.246a1.5 1.5 0 0 1-1.248.668h-2.092a1.5 1.5 0 0 1-1.248-.668l-.164-.246A3 3 0 0 0 7.046 15H2.812Z"
  }));
}
const ZI = /* @__PURE__ */ s.forwardRef(VI);
function HI({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M6.912 3a3 3 0 0 0-2.868 2.118l-2.411 7.838a3 3 0 0 0-.133.882V18a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-4.162c0-.299-.045-.596-.133-.882l-2.412-7.838A3 3 0 0 0 17.088 3H6.912Zm13.823 9.75-2.213-7.191A1.5 1.5 0 0 0 17.088 4.5H6.912a1.5 1.5 0 0 0-1.434 1.059L3.265 12.75H6.11a3 3 0 0 1 2.684 1.658l.256.513a1.5 1.5 0 0 0 1.342.829h3.218a1.5 1.5 0 0 0 1.342-.83l.256-.512a3 3 0 0 1 2.684-1.658h2.844Z",
    clipRule: "evenodd"
  }));
}
const jI = /* @__PURE__ */ s.forwardRef(HI);
function WI({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
    clipRule: "evenodd"
  }));
}
const zI = /* @__PURE__ */ s.forwardRef(WI);
function GI({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M10.497 3.744a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-3.275l-5.357 15.002h2.632a.75.75 0 1 1 0 1.5h-7.5a.75.75 0 1 1 0-1.5h3.275l5.357-15.002h-2.632a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  }));
}
const UI = /* @__PURE__ */ s.forwardRef(GI);
function YI({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M15.75 1.5a6.75 6.75 0 0 0-6.651 7.906c.067.39-.032.717-.221.906l-6.5 6.499a3 3 0 0 0-.878 2.121v2.818c0 .414.336.75.75.75H6a.75.75 0 0 0 .75-.75v-1.5h1.5A.75.75 0 0 0 9 19.5V18h1.5a.75.75 0 0 0 .53-.22l2.658-2.658c.19-.189.517-.288.906-.22A6.75 6.75 0 1 0 15.75 1.5Zm0 3a.75.75 0 0 0 0 1.5A2.25 2.25 0 0 1 18 8.25a.75.75 0 0 0 1.5 0 3.75 3.75 0 0 0-3.75-3.75Z",
    clipRule: "evenodd"
  }));
}
const XI = /* @__PURE__ */ s.forwardRef(YI);
function qI({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M9 2.25a.75.75 0 0 1 .75.75v1.506a49.384 49.384 0 0 1 5.343.371.75.75 0 1 1-.186 1.489c-.66-.083-1.323-.151-1.99-.206a18.67 18.67 0 0 1-2.97 6.323c.318.384.65.753 1 1.107a.75.75 0 0 1-1.07 1.052A18.902 18.902 0 0 1 9 13.687a18.823 18.823 0 0 1-5.656 4.482.75.75 0 0 1-.688-1.333 17.323 17.323 0 0 0 5.396-4.353A18.72 18.72 0 0 1 5.89 8.598a.75.75 0 0 1 1.388-.568A17.21 17.21 0 0 0 9 11.224a17.168 17.168 0 0 0 2.391-5.165 48.04 48.04 0 0 0-8.298.307.75.75 0 0 1-.186-1.489 49.159 49.159 0 0 1 5.343-.371V3A.75.75 0 0 1 9 2.25ZM15.75 9a.75.75 0 0 1 .68.433l5.25 11.25a.75.75 0 1 1-1.36.634l-1.198-2.567h-6.744l-1.198 2.567a.75.75 0 0 1-1.36-.634l5.25-11.25A.75.75 0 0 1 15.75 9Zm-2.672 8.25h5.344l-2.672-5.726-2.672 5.726Z",
    clipRule: "evenodd"
  }));
}
const KI = /* @__PURE__ */ s.forwardRef(qI);
function QI({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M19.449 8.448 16.388 11a4.52 4.52 0 0 1 0 2.002l3.061 2.55a8.275 8.275 0 0 0 0-7.103ZM15.552 19.45 13 16.388a4.52 4.52 0 0 1-2.002 0l-2.55 3.061a8.275 8.275 0 0 0 7.103 0ZM4.55 15.552 7.612 13a4.52 4.52 0 0 1 0-2.002L4.551 8.45a8.275 8.275 0 0 0 0 7.103ZM8.448 4.55 11 7.612a4.52 4.52 0 0 1 2.002 0l2.55-3.061a8.275 8.275 0 0 0-7.103 0Zm8.657-.86a9.776 9.776 0 0 1 1.79 1.415 9.776 9.776 0 0 1 1.414 1.788 9.764 9.764 0 0 1 0 10.211 9.777 9.777 0 0 1-1.415 1.79 9.777 9.777 0 0 1-1.788 1.414 9.764 9.764 0 0 1-10.212 0 9.776 9.776 0 0 1-1.788-1.415 9.776 9.776 0 0 1-1.415-1.788 9.764 9.764 0 0 1 0-10.212 9.774 9.774 0 0 1 1.415-1.788A9.774 9.774 0 0 1 6.894 3.69a9.764 9.764 0 0 1 10.211 0ZM14.121 9.88a2.985 2.985 0 0 0-1.11-.704 3.015 3.015 0 0 0-2.022 0 2.985 2.985 0 0 0-1.11.704c-.326.325-.56.705-.704 1.11a3.015 3.015 0 0 0 0 2.022c.144.405.378.785.704 1.11.325.326.705.56 1.11.704.652.233 1.37.233 2.022 0a2.985 2.985 0 0 0 1.11-.704c.326-.325.56-.705.704-1.11a3.016 3.016 0 0 0 0-2.022 2.985 2.985 0 0 0-.704-1.11Z",
    clipRule: "evenodd"
  }));
}
const JI = /* @__PURE__ */ s.forwardRef(QI);
function eP({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M12 .75a8.25 8.25 0 0 0-4.135 15.39c.686.398 1.115 1.008 1.134 1.623a.75.75 0 0 0 .577.706c.352.083.71.148 1.074.195.323.041.6-.218.6-.544v-4.661a6.714 6.714 0 0 1-.937-.171.75.75 0 1 1 .374-1.453 5.261 5.261 0 0 0 2.626 0 .75.75 0 1 1 .374 1.452 6.712 6.712 0 0 1-.937.172v4.66c0 .327.277.586.6.545.364-.047.722-.112 1.074-.195a.75.75 0 0 0 .577-.706c.02-.615.448-1.225 1.134-1.623A8.25 8.25 0 0 0 12 .75Z"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M9.013 19.9a.75.75 0 0 1 .877-.597 11.319 11.319 0 0 0 4.22 0 .75.75 0 1 1 .28 1.473 12.819 12.819 0 0 1-4.78 0 .75.75 0 0 1-.597-.876ZM9.754 22.344a.75.75 0 0 1 .824-.668 13.682 13.682 0 0 0 2.844 0 .75.75 0 1 1 .156 1.492 15.156 15.156 0 0 1-3.156 0 .75.75 0 0 1-.668-.824Z",
    clipRule: "evenodd"
  }));
}
const tP = /* @__PURE__ */ s.forwardRef(eP);
function rP({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M19.892 4.09a3.75 3.75 0 0 0-5.303 0l-4.5 4.5c-.074.074-.144.15-.21.229l4.965 4.966a3.75 3.75 0 0 0-1.986-4.428.75.75 0 0 1 .646-1.353 5.253 5.253 0 0 1 2.502 6.944l5.515 5.515a.75.75 0 0 1-1.061 1.06l-18-18.001A.75.75 0 0 1 3.521 2.46l5.294 5.295a5.31 5.31 0 0 1 .213-.227l4.5-4.5a5.25 5.25 0 1 1 7.425 7.425l-1.757 1.757a.75.75 0 1 1-1.06-1.06l1.756-1.757a3.75 3.75 0 0 0 0-5.304ZM5.846 11.773a.75.75 0 0 1 0 1.06l-1.757 1.758a3.75 3.75 0 0 0 5.303 5.304l3.129-3.13a.75.75 0 1 1 1.06 1.061l-3.128 3.13a5.25 5.25 0 1 1-7.425-7.426l1.757-1.757a.75.75 0 0 1 1.061 0Zm2.401.26a.75.75 0 0 1 .957.458c.18.512.474.992.885 1.403.31.311.661.555 1.035.733a.75.75 0 0 1-.647 1.354 5.244 5.244 0 0 1-1.449-1.026 5.232 5.232 0 0 1-1.24-1.965.75.75 0 0 1 .46-.957Z",
    clipRule: "evenodd"
  }));
}
const nP = /* @__PURE__ */ s.forwardRef(rP);
function aP({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M19.902 4.098a3.75 3.75 0 0 0-5.304 0l-4.5 4.5a3.75 3.75 0 0 0 1.035 6.037.75.75 0 0 1-.646 1.353 5.25 5.25 0 0 1-1.449-8.45l4.5-4.5a5.25 5.25 0 1 1 7.424 7.424l-1.757 1.757a.75.75 0 1 1-1.06-1.06l1.757-1.757a3.75 3.75 0 0 0 0-5.304Zm-7.389 4.267a.75.75 0 0 1 1-.353 5.25 5.25 0 0 1 1.449 8.45l-4.5 4.5a5.25 5.25 0 1 1-7.424-7.424l1.757-1.757a.75.75 0 1 1 1.06 1.06l-1.757 1.757a3.75 3.75 0 1 0 5.304 5.304l4.5-4.5a3.75 3.75 0 0 0-1.035-6.037.75.75 0 0 1-.354-1Z",
    clipRule: "evenodd"
  }));
}
const oP = /* @__PURE__ */ s.forwardRef(aP);
function iP({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M2.625 6.75a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm4.875 0A.75.75 0 0 1 8.25 6h12a.75.75 0 0 1 0 1.5h-12a.75.75 0 0 1-.75-.75ZM2.625 12a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0ZM7.5 12a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5h-12A.75.75 0 0 1 7.5 12Zm-4.875 5.25a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm4.875 0a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5h-12a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  }));
}
const lP = /* @__PURE__ */ s.forwardRef(iP);
function sP({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z",
    clipRule: "evenodd"
  }));
}
const cP = /* @__PURE__ */ s.forwardRef(sP);
function uP({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M18 1.5c2.9 0 5.25 2.35 5.25 5.25v3.75a.75.75 0 0 1-1.5 0V6.75a3.75 3.75 0 1 0-7.5 0v3a3 3 0 0 1 3 3v6.75a3 3 0 0 1-3 3H3.75a3 3 0 0 1-3-3v-6.75a3 3 0 0 1 3-3h9v-3c0-2.9 2.35-5.25 5.25-5.25Z"
  }));
}
const dP = /* @__PURE__ */ s.forwardRef(uP);
function fP({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M8.25 10.875a2.625 2.625 0 1 1 5.25 0 2.625 2.625 0 0 1-5.25 0Z"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.125 4.5a4.125 4.125 0 1 0 2.338 7.524l2.007 2.006a.75.75 0 1 0 1.06-1.06l-2.006-2.007a4.125 4.125 0 0 0-3.399-6.463Z",
    clipRule: "evenodd"
  }));
}
const hP = /* @__PURE__ */ s.forwardRef(fP);
function vP({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Zm4.5 0a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  }));
}
const pP = /* @__PURE__ */ s.forwardRef(vP);
function gP({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Zm8.25-3.75a.75.75 0 0 1 .75.75v2.25h2.25a.75.75 0 0 1 0 1.5h-2.25v2.25a.75.75 0 0 1-1.5 0v-2.25H7.5a.75.75 0 0 1 0-1.5h2.25V7.5a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  }));
}
const mP = /* @__PURE__ */ s.forwardRef(gP);
function wP({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z",
    clipRule: "evenodd"
  }));
}
const yP = /* @__PURE__ */ s.forwardRef(wP);
function bP({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "m11.54 22.351.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.975 16.975 0 0 0 1.144-.742 19.58 19.58 0 0 0 2.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 0 0-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 0 0 2.682 2.282 16.975 16.975 0 0 0 1.145.742ZM12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
    clipRule: "evenodd"
  }));
}
const _P = /* @__PURE__ */ s.forwardRef(bP);
function xP({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M8.161 2.58a1.875 1.875 0 0 1 1.678 0l4.993 2.498c.106.052.23.052.336 0l3.869-1.935A1.875 1.875 0 0 1 21.75 4.82v12.485c0 .71-.401 1.36-1.037 1.677l-4.875 2.437a1.875 1.875 0 0 1-1.676 0l-4.994-2.497a.375.375 0 0 0-.336 0l-3.868 1.935A1.875 1.875 0 0 1 2.25 19.18V6.695c0-.71.401-1.36 1.036-1.677l4.875-2.437ZM9 6a.75.75 0 0 1 .75.75V15a.75.75 0 0 1-1.5 0V6.75A.75.75 0 0 1 9 6Zm6.75 3a.75.75 0 0 0-1.5 0v8.25a.75.75 0 0 0 1.5 0V9Z",
    clipRule: "evenodd"
  }));
}
const CP = /* @__PURE__ */ s.forwardRef(xP);
function EP({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M16.881 4.345A23.112 23.112 0 0 1 8.25 6H7.5a5.25 5.25 0 0 0-.88 10.427 21.593 21.593 0 0 0 1.378 3.94c.464 1.004 1.674 1.32 2.582.796l.657-.379c.88-.508 1.165-1.593.772-2.468a17.116 17.116 0 0 1-.628-1.607c1.918.258 3.76.75 5.5 1.446A21.727 21.727 0 0 0 18 11.25c0-2.414-.393-4.735-1.119-6.905ZM18.26 3.74a23.22 23.22 0 0 1 1.24 7.51 23.22 23.22 0 0 1-1.41 7.992.75.75 0 1 0 1.409.516 24.555 24.555 0 0 0 1.415-6.43 2.992 2.992 0 0 0 .836-2.078c0-.807-.319-1.54-.836-2.078a24.65 24.65 0 0 0-1.415-6.43.75.75 0 1 0-1.409.516c.059.16.116.321.17.483Z"
  }));
}
const SP = /* @__PURE__ */ s.forwardRef(EP);
function RP({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M8.25 4.5a3.75 3.75 0 1 1 7.5 0v8.25a3.75 3.75 0 1 1-7.5 0V4.5Z"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M6 10.5a.75.75 0 0 1 .75.75v1.5a5.25 5.25 0 1 0 10.5 0v-1.5a.75.75 0 0 1 1.5 0v1.5a6.751 6.751 0 0 1-6 6.709v2.291h3a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5h3v-2.291a6.751 6.751 0 0 1-6-6.709v-1.5A.75.75 0 0 1 6 10.5Z"
  }));
}
const MP = /* @__PURE__ */ s.forwardRef(RP);
function AP({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm3 10.5a.75.75 0 0 0 0-1.5H9a.75.75 0 0 0 0 1.5h6Z",
    clipRule: "evenodd"
  }));
}
const kP = /* @__PURE__ */ s.forwardRef(AP);
function LP({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M5.25 12a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  }));
}
const TP = /* @__PURE__ */ s.forwardRef(LP);
function OP({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M4.25 12a.75.75 0 0 1 .75-.75h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  }));
}
const IP = /* @__PURE__ */ s.forwardRef(OP);
function PP({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M9.528 1.718a.75.75 0 0 1 .162.819A8.97 8.97 0 0 0 9 6a9 9 0 0 0 9 9 8.97 8.97 0 0 0 3.463-.69.75.75 0 0 1 .981.98 10.503 10.503 0 0 1-9.694 6.46c-5.799 0-10.5-4.7-10.5-10.5 0-4.368 2.667-8.112 6.46-9.694a.75.75 0 0 1 .818.162Z",
    clipRule: "evenodd"
  }));
}
const DP = /* @__PURE__ */ s.forwardRef(PP);
function NP({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M19.952 1.651a.75.75 0 0 1 .298.599V16.303a3 3 0 0 1-2.176 2.884l-1.32.377a2.553 2.553 0 1 1-1.403-4.909l2.311-.66a1.5 1.5 0 0 0 1.088-1.442V6.994l-9 2.572v9.737a3 3 0 0 1-2.176 2.884l-1.32.377a2.553 2.553 0 1 1-1.402-4.909l2.31-.66a1.5 1.5 0 0 0 1.088-1.442V5.25a.75.75 0 0 1 .544-.721l10.5-3a.75.75 0 0 1 .658.122Z",
    clipRule: "evenodd"
  }));
}
const BP = /* @__PURE__ */ s.forwardRef(NP);
function FP({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M4.125 3C3.089 3 2.25 3.84 2.25 4.875V18a3 3 0 0 0 3 3h15a3 3 0 0 1-3-3V4.875C17.25 3.839 16.41 3 15.375 3H4.125ZM12 9.75a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5H12Zm-.75-2.25a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75ZM6 12.75a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5H6Zm-.75 3.75a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75ZM6 6.75a.75.75 0 0 0-.75.75v3c0 .414.336.75.75.75h3a.75.75 0 0 0 .75-.75v-3A.75.75 0 0 0 9 6.75H6Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M18.75 6.75h1.875c.621 0 1.125.504 1.125 1.125V18a1.5 1.5 0 0 1-3 0V6.75Z"
  }));
}
const $P = /* @__PURE__ */ s.forwardRef(FP);
function VP({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "m6.72 5.66 11.62 11.62A8.25 8.25 0 0 0 6.72 5.66Zm10.56 12.68L5.66 6.72a8.25 8.25 0 0 0 11.62 11.62ZM5.105 5.106c3.807-3.808 9.98-3.808 13.788 0 3.808 3.807 3.808 9.98 0 13.788-3.807 3.808-9.98 3.808-13.788 0-3.808-3.807-3.808-9.98 0-13.788Z",
    clipRule: "evenodd"
  }));
}
const ZP = /* @__PURE__ */ s.forwardRef(VP);
function HP({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M7.491 5.992a.75.75 0 0 1 .75-.75h12a.75.75 0 1 1 0 1.5h-12a.75.75 0 0 1-.75-.75ZM7.49 11.995a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5h-12a.75.75 0 0 1-.75-.75ZM7.491 17.994a.75.75 0 0 1 .75-.75h12a.75.75 0 1 1 0 1.5h-12a.75.75 0 0 1-.75-.75ZM2.24 3.745a.75.75 0 0 1 .75-.75h1.125a.75.75 0 0 1 .75.75v3h.375a.75.75 0 0 1 0 1.5H2.99a.75.75 0 0 1 0-1.5h.375v-2.25H2.99a.75.75 0 0 1-.75-.75ZM2.79 10.602a.75.75 0 0 1 0-1.06 1.875 1.875 0 1 1 2.652 2.651l-.55.55h.35a.75.75 0 0 1 0 1.5h-2.16a.75.75 0 0 1-.53-1.281l1.83-1.83a.375.375 0 0 0-.53-.53.75.75 0 0 1-1.062 0ZM2.24 15.745a.75.75 0 0 1 .75-.75h1.125a1.875 1.875 0 0 1 1.501 2.999 1.875 1.875 0 0 1-1.501 3H2.99a.75.75 0 0 1 0-1.501h1.125a.375.375 0 0 0 .036-.748H3.74a.75.75 0 0 1-.75-.75v-.002a.75.75 0 0 1 .75-.75h.411a.375.375 0 0 0-.036-.748H2.99a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  }));
}
const jP = /* @__PURE__ */ s.forwardRef(HP);
function WP({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M20.599 1.5c-.376 0-.743.111-1.055.32l-5.08 3.385a18.747 18.747 0 0 0-3.471 2.987 10.04 10.04 0 0 1 4.815 4.815 18.748 18.748 0 0 0 2.987-3.472l3.386-5.079A1.902 1.902 0 0 0 20.599 1.5Zm-8.3 14.025a18.76 18.76 0 0 0 1.896-1.207 8.026 8.026 0 0 0-4.513-4.513A18.75 18.75 0 0 0 8.475 11.7l-.278.5a5.26 5.26 0 0 1 3.601 3.602l.502-.278ZM6.75 13.5A3.75 3.75 0 0 0 3 17.25a1.5 1.5 0 0 1-1.601 1.497.75.75 0 0 0-.7 1.123 5.25 5.25 0 0 0 9.8-2.62 3.75 3.75 0 0 0-3.75-3.75Z",
    clipRule: "evenodd"
  }));
}
const zP = /* @__PURE__ */ s.forwardRef(WP);
function GP({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M3.478 2.404a.75.75 0 0 0-.926.941l2.432 7.905H13.5a.75.75 0 0 1 0 1.5H4.984l-2.432 7.905a.75.75 0 0 0 .926.94 60.519 60.519 0 0 0 18.445-8.986.75.75 0 0 0 0-1.218A60.517 60.517 0 0 0 3.478 2.404Z"
  }));
}
const UP = /* @__PURE__ */ s.forwardRef(GP);
function YP({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M18.97 3.659a2.25 2.25 0 0 0-3.182 0l-10.94 10.94a3.75 3.75 0 1 0 5.304 5.303l7.693-7.693a.75.75 0 0 1 1.06 1.06l-7.693 7.693a5.25 5.25 0 1 1-7.424-7.424l10.939-10.94a3.75 3.75 0 1 1 5.303 5.304L9.097 18.835l-.008.008-.007.007-.002.002-.003.002A2.25 2.25 0 0 1 5.91 15.66l7.81-7.81a.75.75 0 0 1 1.061 1.06l-7.81 7.81a.75.75 0 0 0 1.054 1.068L18.97 6.84a2.25 2.25 0 0 0 0-3.182Z",
    clipRule: "evenodd"
  }));
}
const XP = /* @__PURE__ */ s.forwardRef(YP);
function qP({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM9 8.25a.75.75 0 0 0-.75.75v6c0 .414.336.75.75.75h.75a.75.75 0 0 0 .75-.75V9a.75.75 0 0 0-.75-.75H9Zm5.25 0a.75.75 0 0 0-.75.75v6c0 .414.336.75.75.75H15a.75.75 0 0 0 .75-.75V9a.75.75 0 0 0-.75-.75h-.75Z",
    clipRule: "evenodd"
  }));
}
const KP = /* @__PURE__ */ s.forwardRef(qP);
function QP({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M6.75 5.25a.75.75 0 0 1 .75-.75H9a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H7.5a.75.75 0 0 1-.75-.75V5.25Zm7.5 0A.75.75 0 0 1 15 4.5h1.5a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H15a.75.75 0 0 1-.75-.75V5.25Z",
    clipRule: "evenodd"
  }));
}
const JP = /* @__PURE__ */ s.forwardRef(QP);
function eD({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32l8.4-8.4Z"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M5.25 5.25a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3V13.5a.75.75 0 0 0-1.5 0v5.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5V8.25a1.5 1.5 0 0 1 1.5-1.5h5.25a.75.75 0 0 0 0-1.5H5.25Z"
  }));
}
const tD = /* @__PURE__ */ s.forwardRef(eD);
function rD({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-12.15 12.15a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32L19.513 8.2Z"
  }));
}
const nD = /* @__PURE__ */ s.forwardRef(rD);
function aD({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M11.99 2.243a4.49 4.49 0 0 0-3.398 1.55 4.49 4.49 0 0 0-3.497 1.306 4.491 4.491 0 0 0-1.307 3.498 4.491 4.491 0 0 0-1.548 3.397c0 1.357.6 2.573 1.548 3.397a4.491 4.491 0 0 0 1.307 3.498 4.49 4.49 0 0 0 3.498 1.307 4.49 4.49 0 0 0 3.397 1.549 4.49 4.49 0 0 0 3.397-1.549 4.49 4.49 0 0 0 3.497-1.307 4.491 4.491 0 0 0 1.306-3.497 4.491 4.491 0 0 0 1.55-3.398c0-1.357-.601-2.573-1.549-3.397a4.491 4.491 0 0 0-1.307-3.498 4.49 4.49 0 0 0-3.498-1.307 4.49 4.49 0 0 0-3.396-1.549Zm3.53 7.28a.75.75 0 0 0-1.06-1.06l-6 6a.75.75 0 1 0 1.06 1.06l6-6Zm-5.78-.905a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Zm4.5 4.5a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Z",
    clipRule: "evenodd"
  }));
}
const oD = /* @__PURE__ */ s.forwardRef(aD);
function iD({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M19.5 9.75a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 1 1.5 0v2.69l4.72-4.72a.75.75 0 1 1 1.06 1.06L16.06 9h2.69a.75.75 0 0 1 .75.75Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z",
    clipRule: "evenodd"
  }));
}
const lD = /* @__PURE__ */ s.forwardRef(iD);
function sD({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M15 3.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0V5.56l-4.72 4.72a.75.75 0 1 1-1.06-1.06l4.72-4.72h-2.69a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z",
    clipRule: "evenodd"
  }));
}
const cD = /* @__PURE__ */ s.forwardRef(sD);
function uD({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M15.22 3.22a.75.75 0 0 1 1.06 0L18 4.94l1.72-1.72a.75.75 0 1 1 1.06 1.06L19.06 6l1.72 1.72a.75.75 0 0 1-1.06 1.06L18 7.06l-1.72 1.72a.75.75 0 1 1-1.06-1.06L16.94 6l-1.72-1.72a.75.75 0 0 1 0-1.06ZM1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z",
    clipRule: "evenodd"
  }));
}
const dD = /* @__PURE__ */ s.forwardRef(uD);
function fD({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z",
    clipRule: "evenodd"
  }));
}
const hD = /* @__PURE__ */ s.forwardRef(fD);
function vD({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 6a2.25 2.25 0 0 1 2.25-2.25h16.5A2.25 2.25 0 0 1 22.5 6v12a2.25 2.25 0 0 1-2.25 2.25H3.75A2.25 2.25 0 0 1 1.5 18V6ZM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0 0 21 18v-1.94l-2.69-2.689a1.5 1.5 0 0 0-2.12 0l-.88.879.97.97a.75.75 0 1 1-1.06 1.06l-5.16-5.159a1.5 1.5 0 0 0-2.12 0L3 16.061Zm10.125-7.81a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Z",
    clipRule: "evenodd"
  }));
}
const pD = /* @__PURE__ */ s.forwardRef(vD);
function gD({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm14.024-.983a1.125 1.125 0 0 1 0 1.966l-5.603 3.113A1.125 1.125 0 0 1 9 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113Z",
    clipRule: "evenodd"
  }));
}
const mD = /* @__PURE__ */ s.forwardRef(gD);
function wD({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M15 6.75a.75.75 0 0 0-.75.75V18a.75.75 0 0 0 .75.75h.75a.75.75 0 0 0 .75-.75V7.5a.75.75 0 0 0-.75-.75H15ZM20.25 6.75a.75.75 0 0 0-.75.75V18c0 .414.336.75.75.75H21a.75.75 0 0 0 .75-.75V7.5a.75.75 0 0 0-.75-.75h-.75ZM5.055 7.06C3.805 6.347 2.25 7.25 2.25 8.69v8.122c0 1.44 1.555 2.343 2.805 1.628l7.108-4.061c1.26-.72 1.26-2.536 0-3.256L5.055 7.061Z"
  }));
}
const yD = /* @__PURE__ */ s.forwardRef(wD);
function bD({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z",
    clipRule: "evenodd"
  }));
}
const _D = /* @__PURE__ */ s.forwardRef(bD);
function xD({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 9a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V15a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V9Z",
    clipRule: "evenodd"
  }));
}
const CD = /* @__PURE__ */ s.forwardRef(xD);
function ED({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 5.25a.75.75 0 0 1 .75.75v5.25H18a.75.75 0 0 1 0 1.5h-5.25V18a.75.75 0 0 1-1.5 0v-5.25H6a.75.75 0 0 1 0-1.5h5.25V6a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  }));
}
const SD = /* @__PURE__ */ s.forwardRef(ED);
function RD({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 3.75a.75.75 0 0 1 .75.75v6.75h6.75a.75.75 0 0 1 0 1.5h-6.75v6.75a.75.75 0 0 1-1.5 0v-6.75H4.5a.75.75 0 0 1 0-1.5h6.75V4.5a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  }));
}
const MD = /* @__PURE__ */ s.forwardRef(RD);
function AD({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75ZM6.166 5.106a.75.75 0 0 1 0 1.06 8.25 8.25 0 1 0 11.668 0 .75.75 0 1 1 1.06-1.06c3.808 3.807 3.808 9.98 0 13.788-3.807 3.808-9.98 3.808-13.788 0-3.808-3.807-3.808-9.98 0-13.788a.75.75 0 0 1 1.06 0Z",
    clipRule: "evenodd"
  }));
}
const kD = /* @__PURE__ */ s.forwardRef(AD);
function LD({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 2.25a.75.75 0 0 0 0 1.5H3v10.5a3 3 0 0 0 3 3h1.21l-1.172 3.513a.75.75 0 0 0 1.424.474l.329-.987h8.418l.33.987a.75.75 0 0 0 1.422-.474l-1.17-3.513H18a3 3 0 0 0 3-3V3.75h.75a.75.75 0 0 0 0-1.5H2.25Zm6.04 16.5.5-1.5h6.42l.5 1.5H8.29Zm7.46-12a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0v-6Zm-3 2.25a.75.75 0 0 0-1.5 0v3.75a.75.75 0 0 0 1.5 0V9Zm-3 2.25a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0v-1.5Z",
    clipRule: "evenodd"
  }));
}
const TD = /* @__PURE__ */ s.forwardRef(LD);
function OD({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 2.25a.75.75 0 0 0 0 1.5H3v10.5a3 3 0 0 0 3 3h1.21l-1.172 3.513a.75.75 0 0 0 1.424.474l.329-.987h8.418l.33.987a.75.75 0 0 0 1.422-.474l-1.17-3.513H18a3 3 0 0 0 3-3V3.75h.75a.75.75 0 0 0 0-1.5H2.25Zm6.54 15h6.42l.5 1.5H8.29l.5-1.5Zm8.085-8.995a.75.75 0 1 0-.75-1.299 12.81 12.81 0 0 0-3.558 3.05L11.03 8.47a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 1 0 1.06 1.06l2.47-2.47 1.617 1.618a.75.75 0 0 0 1.146-.102 11.312 11.312 0 0 1 3.612-3.321Z",
    clipRule: "evenodd"
  }));
}
const ID = /* @__PURE__ */ s.forwardRef(OD);
function PD({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M7.875 1.5C6.839 1.5 6 2.34 6 3.375v2.99c-.426.053-.851.11-1.274.174-1.454.218-2.476 1.483-2.476 2.917v6.294a3 3 0 0 0 3 3h.27l-.155 1.705A1.875 1.875 0 0 0 7.232 22.5h9.536a1.875 1.875 0 0 0 1.867-2.045l-.155-1.705h.27a3 3 0 0 0 3-3V9.456c0-1.434-1.022-2.7-2.476-2.917A48.716 48.716 0 0 0 18 6.366V3.375c0-1.036-.84-1.875-1.875-1.875h-8.25ZM16.5 6.205v-2.83A.375.375 0 0 0 16.125 3h-8.25a.375.375 0 0 0-.375.375v2.83a49.353 49.353 0 0 1 9 0Zm-.217 8.265c.178.018.317.16.333.337l.526 5.784a.375.375 0 0 1-.374.409H7.232a.375.375 0 0 1-.374-.409l.526-5.784a.373.373 0 0 1 .333-.337 41.741 41.741 0 0 1 8.566 0Zm.967-3.97a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H18a.75.75 0 0 1-.75-.75V10.5ZM15 9.75a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V10.5a.75.75 0 0 0-.75-.75H15Z",
    clipRule: "evenodd"
  }));
}
const DD = /* @__PURE__ */ s.forwardRef(PD);
function ND({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M11.25 5.337c0-.355-.186-.676-.401-.959a1.647 1.647 0 0 1-.349-1.003c0-1.036 1.007-1.875 2.25-1.875S15 2.34 15 3.375c0 .369-.128.713-.349 1.003-.215.283-.401.604-.401.959 0 .332.278.598.61.578 1.91-.114 3.79-.342 5.632-.676a.75.75 0 0 1 .878.645 49.17 49.17 0 0 1 .376 5.452.657.657 0 0 1-.66.664c-.354 0-.675-.186-.958-.401a1.647 1.647 0 0 0-1.003-.349c-1.035 0-1.875 1.007-1.875 2.25s.84 2.25 1.875 2.25c.369 0 .713-.128 1.003-.349.283-.215.604-.401.959-.401.31 0 .557.262.534.571a48.774 48.774 0 0 1-.595 4.845.75.75 0 0 1-.61.61c-1.82.317-3.673.533-5.555.642a.58.58 0 0 1-.611-.581c0-.355.186-.676.401-.959.221-.29.349-.634.349-1.003 0-1.035-1.007-1.875-2.25-1.875s-2.25.84-2.25 1.875c0 .369.128.713.349 1.003.215.283.401.604.401.959a.641.641 0 0 1-.658.643 49.118 49.118 0 0 1-4.708-.36.75.75 0 0 1-.645-.878c.293-1.614.504-3.257.629-4.924A.53.53 0 0 0 5.337 15c-.355 0-.676.186-.959.401-.29.221-.634.349-1.003.349-1.036 0-1.875-1.007-1.875-2.25s.84-2.25 1.875-2.25c.369 0 .713.128 1.003.349.283.215.604.401.959.401a.656.656 0 0 0 .659-.663 47.703 47.703 0 0 0-.31-4.82.75.75 0 0 1 .83-.832c1.343.155 2.703.254 4.077.294a.64.64 0 0 0 .657-.642Z"
  }));
}
const BD = /* @__PURE__ */ s.forwardRef(ND);
function FD({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3 4.875C3 3.839 3.84 3 4.875 3h4.5c1.036 0 1.875.84 1.875 1.875v4.5c0 1.036-.84 1.875-1.875 1.875h-4.5A1.875 1.875 0 0 1 3 9.375v-4.5ZM4.875 4.5a.375.375 0 0 0-.375.375v4.5c0 .207.168.375.375.375h4.5a.375.375 0 0 0 .375-.375v-4.5a.375.375 0 0 0-.375-.375h-4.5Zm7.875.375c0-1.036.84-1.875 1.875-1.875h4.5C20.16 3 21 3.84 21 4.875v4.5c0 1.036-.84 1.875-1.875 1.875h-4.5a1.875 1.875 0 0 1-1.875-1.875v-4.5Zm1.875-.375a.375.375 0 0 0-.375.375v4.5c0 .207.168.375.375.375h4.5a.375.375 0 0 0 .375-.375v-4.5a.375.375 0 0 0-.375-.375h-4.5ZM6 6.75A.75.75 0 0 1 6.75 6h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75A.75.75 0 0 1 6 7.5v-.75Zm9.75 0A.75.75 0 0 1 16.5 6h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75ZM3 14.625c0-1.036.84-1.875 1.875-1.875h4.5c1.036 0 1.875.84 1.875 1.875v4.5c0 1.035-.84 1.875-1.875 1.875h-4.5A1.875 1.875 0 0 1 3 19.125v-4.5Zm1.875-.375a.375.375 0 0 0-.375.375v4.5c0 .207.168.375.375.375h4.5a.375.375 0 0 0 .375-.375v-4.5a.375.375 0 0 0-.375-.375h-4.5Zm7.875-.75a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75Zm6 0a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75ZM6 16.5a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75Zm9.75 0a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75Zm-3 3a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75Zm6 0a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75Z",
    clipRule: "evenodd"
  }));
}
const $D = /* @__PURE__ */ s.forwardRef(FD);
function VD({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm11.378-3.917c-.89-.777-2.366-.777-3.255 0a.75.75 0 0 1-.988-1.129c1.454-1.272 3.776-1.272 5.23 0 1.513 1.324 1.513 3.518 0 4.842a3.75 3.75 0 0 1-.837.552c-.676.328-1.028.774-1.028 1.152v.75a.75.75 0 0 1-1.5 0v-.75c0-1.279 1.06-2.107 1.875-2.502.182-.088.351-.199.503-.331.83-.727.83-1.857 0-2.584ZM12 18a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
    clipRule: "evenodd"
  }));
}
const ZD = /* @__PURE__ */ s.forwardRef(VD);
function HD({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M5.625 3.75a2.625 2.625 0 1 0 0 5.25h12.75a2.625 2.625 0 0 0 0-5.25H5.625ZM3.75 11.25a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5H3.75ZM3 15.75a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75ZM3.75 18.75a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5H3.75Z"
  }));
}
const jD = /* @__PURE__ */ s.forwardRef(HD);
function WD({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M20.432 4.103a.75.75 0 0 0-.364-1.456L4.128 6.632l-.2.033C2.498 6.904 1.5 8.158 1.5 9.574v9.176a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V9.574c0-1.416-.997-2.67-2.429-2.909a49.017 49.017 0 0 0-7.255-.658l7.616-1.904Zm-9.585 8.56a.75.75 0 0 1 0 1.06l-.005.006a.75.75 0 0 1-1.06 0l-.006-.006a.75.75 0 0 1 0-1.06l.005-.005a.75.75 0 0 1 1.06 0l.006.005ZM9.781 15.85a.75.75 0 0 0 1.061 0l.005-.005a.75.75 0 0 0 0-1.061l-.005-.005a.75.75 0 0 0-1.06 0l-.006.005a.75.75 0 0 0 0 1.06l.005.006Zm-1.055-1.066a.75.75 0 0 1 0 1.06l-.005.006a.75.75 0 0 1-1.061 0l-.005-.005a.75.75 0 0 1 0-1.06l.005-.006a.75.75 0 0 1 1.06 0l.006.005ZM7.66 13.73a.75.75 0 0 0 1.061 0l.005-.006a.75.75 0 0 0 0-1.06l-.005-.006a.75.75 0 0 0-1.06 0l-.006.006a.75.75 0 0 0 0 1.06l.005.006ZM9.255 9.75a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75V10.5a.75.75 0 0 1 .75-.75h.008Zm3.624 3.28a.75.75 0 0 0 .275-1.025L13.15 12a.75.75 0 0 0-1.025-.275l-.006.004a.75.75 0 0 0-.275 1.024l.004.007a.75.75 0 0 0 1.025.274l.006-.003Zm-1.38 5.126a.75.75 0 0 1-1.024-.275l-.004-.006a.75.75 0 0 1 .275-1.025l.006-.004a.75.75 0 0 1 1.025.275l.004.007a.75.75 0 0 1-.275 1.024l-.006.004Zm.282-6.776a.75.75 0 0 0-.274-1.025l-.007-.003a.75.75 0 0 0-1.024.274l-.004.007a.75.75 0 0 0 .274 1.024l.007.004a.75.75 0 0 0 1.024-.275l.004-.006Zm1.369 5.129a.75.75 0 0 1-1.025.274l-.006-.004a.75.75 0 0 1-.275-1.024l.004-.007a.75.75 0 0 1 1.025-.274l.006.004a.75.75 0 0 1 .275 1.024l-.004.007Zm-.145-1.502a.75.75 0 0 0 .75-.75v-.007a.75.75 0 0 0-.75-.75h-.008a.75.75 0 0 0-.75.75v.007c0 .415.336.75.75.75h.008Zm-3.75 2.243a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75V18a.75.75 0 0 1 .75-.75h.008Zm-2.871-.47a.75.75 0 0 0 .274-1.025l-.003-.006a.75.75 0 0 0-1.025-.275l-.006.004a.75.75 0 0 0-.275 1.024l.004.007a.75.75 0 0 0 1.024.274l.007-.003Zm1.366-5.12a.75.75 0 0 1-1.025-.274l-.004-.006a.75.75 0 0 1 .275-1.025l.006-.004a.75.75 0 0 1 1.025.275l.004.006a.75.75 0 0 1-.275 1.025l-.006.004Zm.281 6.215a.75.75 0 0 0-.275-1.024l-.006-.004a.75.75 0 0 0-1.025.274l-.003.007a.75.75 0 0 0 .274 1.024l.007.004a.75.75 0 0 0 1.024-.274l.004-.007Zm-1.376-5.116a.75.75 0 0 1-1.025.274l-.006-.003a.75.75 0 0 1-.275-1.025l.004-.007a.75.75 0 0 1 1.025-.274l.006.004a.75.75 0 0 1 .275 1.024l-.004.007Zm-1.15 2.248a.75.75 0 0 0 .75-.75v-.007a.75.75 0 0 0-.75-.75h-.008a.75.75 0 0 0-.75.75v.007c0 .415.336.75.75.75h.008ZM17.25 10.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm1.5 6a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z",
    clipRule: "evenodd"
  }));
}
const zD = /* @__PURE__ */ s.forwardRef(WD);
function GD({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 1.5c-1.921 0-3.816.111-5.68.327-1.497.174-2.57 1.46-2.57 2.93V21.75a.75.75 0 0 0 1.029.696l3.471-1.388 3.472 1.388a.75.75 0 0 0 .556 0l3.472-1.388 3.471 1.388a.75.75 0 0 0 1.029-.696V4.757c0-1.47-1.073-2.756-2.57-2.93A49.255 49.255 0 0 0 12 1.5Zm3.53 7.28a.75.75 0 0 0-1.06-1.06l-6 6a.75.75 0 1 0 1.06 1.06l6-6ZM8.625 9a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm5.625 3.375a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Z",
    clipRule: "evenodd"
  }));
}
const UD = /* @__PURE__ */ s.forwardRef(GD);
function YD({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 1.5c-1.921 0-3.816.111-5.68.327-1.497.174-2.57 1.46-2.57 2.93V21.75a.75.75 0 0 0 1.029.696l3.471-1.388 3.472 1.388a.75.75 0 0 0 .556 0l3.472-1.388 3.471 1.388a.75.75 0 0 0 1.029-.696V4.757c0-1.47-1.073-2.756-2.57-2.93A49.255 49.255 0 0 0 12 1.5Zm-.97 6.53a.75.75 0 1 0-1.06-1.06L7.72 9.22a.75.75 0 0 0 0 1.06l2.25 2.25a.75.75 0 1 0 1.06-1.06l-.97-.97h3.065a1.875 1.875 0 0 1 0 3.75H12a.75.75 0 0 0 0 1.5h1.125a3.375 3.375 0 1 0 0-6.75h-3.064l.97-.97Z",
    clipRule: "evenodd"
  }));
}
const XD = /* @__PURE__ */ s.forwardRef(YD);
function qD({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 7.125c0-1.036.84-1.875 1.875-1.875h6c1.036 0 1.875.84 1.875 1.875v3.75c0 1.036-.84 1.875-1.875 1.875h-6A1.875 1.875 0 0 1 1.5 10.875v-3.75Zm12 1.5c0-1.036.84-1.875 1.875-1.875h5.25c1.035 0 1.875.84 1.875 1.875v8.25c0 1.035-.84 1.875-1.875 1.875h-5.25a1.875 1.875 0 0 1-1.875-1.875v-8.25ZM3 16.125c0-1.036.84-1.875 1.875-1.875h5.25c1.036 0 1.875.84 1.875 1.875v2.25c0 1.035-.84 1.875-1.875 1.875h-5.25A1.875 1.875 0 0 1 3 18.375v-2.25Z",
    clipRule: "evenodd"
  }));
}
const KD = /* @__PURE__ */ s.forwardRef(qD);
function QD({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M5.566 4.657A4.505 4.505 0 0 1 6.75 4.5h10.5c.41 0 .806.055 1.183.157A3 3 0 0 0 15.75 3h-7.5a3 3 0 0 0-2.684 1.657ZM2.25 12a3 3 0 0 1 3-3h13.5a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3v-6ZM5.25 7.5c-.41 0-.806.055-1.184.157A3 3 0 0 1 6.75 6h10.5a3 3 0 0 1 2.683 1.657A4.505 4.505 0 0 0 18.75 7.5H5.25Z"
  }));
}
const JD = /* @__PURE__ */ s.forwardRef(QD);
function eN({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M9.315 7.584C12.195 3.883 16.695 1.5 21.75 1.5a.75.75 0 0 1 .75.75c0 5.056-2.383 9.555-6.084 12.436A6.75 6.75 0 0 1 9.75 22.5a.75.75 0 0 1-.75-.75v-4.131A15.838 15.838 0 0 1 6.382 15H2.25a.75.75 0 0 1-.75-.75 6.75 6.75 0 0 1 7.815-6.666ZM15 6.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M5.26 17.242a.75.75 0 1 0-.897-1.203 5.243 5.243 0 0 0-2.05 5.022.75.75 0 0 0 .625.627 5.243 5.243 0 0 0 5.022-2.051.75.75 0 1 0-1.202-.897 3.744 3.744 0 0 1-3.008 1.51c0-1.23.592-2.323 1.51-3.008Z"
  }));
}
const tN = /* @__PURE__ */ s.forwardRef(eN);
function rN({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3.75 4.5a.75.75 0 0 1 .75-.75h.75c8.284 0 15 6.716 15 15v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75C18 11.708 12.292 6 5.25 6H4.5a.75.75 0 0 1-.75-.75V4.5Zm0 6.75a.75.75 0 0 1 .75-.75h.75a8.25 8.25 0 0 1 8.25 8.25v.75a.75.75 0 0 1-.75.75H12a.75.75 0 0 1-.75-.75v-.75a6 6 0 0 0-6-6H4.5a.75.75 0 0 1-.75-.75v-.75Zm0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
    clipRule: "evenodd"
  }));
}
const nN = /* @__PURE__ */ s.forwardRef(rN);
function aN({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25a.75.75 0 0 1 .75.75v.756a49.106 49.106 0 0 1 9.152 1 .75.75 0 0 1-.152 1.485h-1.918l2.474 10.124a.75.75 0 0 1-.375.84A6.723 6.723 0 0 1 18.75 18a6.723 6.723 0 0 1-3.181-.795.75.75 0 0 1-.375-.84l2.474-10.124H12.75v13.28c1.293.076 2.534.343 3.697.776a.75.75 0 0 1-.262 1.453h-8.37a.75.75 0 0 1-.262-1.453c1.162-.433 2.404-.7 3.697-.775V6.24H6.332l2.474 10.124a.75.75 0 0 1-.375.84A6.723 6.723 0 0 1 5.25 18a6.723 6.723 0 0 1-3.181-.795.75.75 0 0 1-.375-.84L4.168 6.241H2.25a.75.75 0 0 1-.152-1.485 49.105 49.105 0 0 1 9.152-1V3a.75.75 0 0 1 .75-.75Zm4.878 13.543 1.872-7.662 1.872 7.662h-3.744Zm-9.756 0L5.25 8.131l-1.872 7.662h3.744Z",
    clipRule: "evenodd"
  }));
}
const oN = /* @__PURE__ */ s.forwardRef(aN);
function iN({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M8.128 9.155a3.751 3.751 0 1 1 .713-1.321l1.136.656a.75.75 0 0 1 .222 1.104l-.006.007a.75.75 0 0 1-1.032.157 1.421 1.421 0 0 0-.113-.072l-.92-.531Zm-4.827-3.53a2.25 2.25 0 0 1 3.994 2.063.756.756 0 0 0-.122.23 2.25 2.25 0 0 1-3.872-2.293ZM13.348 8.272a5.073 5.073 0 0 0-3.428 3.57 5.08 5.08 0 0 0-.165 1.202 1.415 1.415 0 0 1-.707 1.201l-.96.554a3.751 3.751 0 1 0 .734 1.309l13.729-7.926a.75.75 0 0 0-.181-1.374l-.803-.215a5.25 5.25 0 0 0-2.894.05l-5.325 1.629Zm-9.223 7.03a2.25 2.25 0 1 0 2.25 3.897 2.25 2.25 0 0 0-2.25-3.897ZM12 12.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M16.372 12.615a.75.75 0 0 1 .75 0l5.43 3.135a.75.75 0 0 1-.182 1.374l-.802.215a5.25 5.25 0 0 1-2.894-.051l-5.147-1.574a.75.75 0 0 1-.156-1.367l3-1.732Z"
  }));
}
const lN = /* @__PURE__ */ s.forwardRef(iN);
function sN({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M5.507 4.048A3 3 0 0 1 7.785 3h8.43a3 3 0 0 1 2.278 1.048l1.722 2.008A4.533 4.533 0 0 0 19.5 6h-15c-.243 0-.482.02-.715.056l1.722-2.008Z"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 10.5a3 3 0 0 1 3-3h15a3 3 0 1 1 0 6h-15a3 3 0 0 1-3-3Zm15 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm2.25.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM4.5 15a3 3 0 1 0 0 6h15a3 3 0 1 0 0-6h-15Zm11.25 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM19.5 18a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z",
    clipRule: "evenodd"
  }));
}
const cN = /* @__PURE__ */ s.forwardRef(sN);
function uN({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M4.08 5.227A3 3 0 0 1 6.979 3H17.02a3 3 0 0 1 2.9 2.227l2.113 7.926A5.228 5.228 0 0 0 18.75 12H5.25a5.228 5.228 0 0 0-3.284 1.153L4.08 5.227Z"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M5.25 13.5a3.75 3.75 0 1 0 0 7.5h13.5a3.75 3.75 0 1 0 0-7.5H5.25Zm10.5 4.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm3.75-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z",
    clipRule: "evenodd"
  }));
}
const dN = /* @__PURE__ */ s.forwardRef(uN);
function fN({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M15.75 4.5a3 3 0 1 1 .825 2.066l-8.421 4.679a3.002 3.002 0 0 1 0 1.51l8.421 4.679a3 3 0 1 1-.729 1.31l-8.421-4.678a3 3 0 1 1 0-4.132l8.421-4.679a3 3 0 0 1-.096-.755Z",
    clipRule: "evenodd"
  }));
}
const hN = /* @__PURE__ */ s.forwardRef(fN);
function vN({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12.516 2.17a.75.75 0 0 0-1.032 0 11.209 11.209 0 0 1-7.877 3.08.75.75 0 0 0-.722.515A12.74 12.74 0 0 0 2.25 9.75c0 5.942 4.064 10.933 9.563 12.348a.749.749 0 0 0 .374 0c5.499-1.415 9.563-6.406 9.563-12.348 0-1.39-.223-2.73-.635-3.985a.75.75 0 0 0-.722-.516l-.143.001c-2.996 0-5.717-1.17-7.734-3.08Zm3.094 8.016a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z",
    clipRule: "evenodd"
  }));
}
const pN = /* @__PURE__ */ s.forwardRef(vN);
function gN({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M11.484 2.17a.75.75 0 0 1 1.032 0 11.209 11.209 0 0 0 7.877 3.08.75.75 0 0 1 .722.515 12.74 12.74 0 0 1 .635 3.985c0 5.942-4.064 10.933-9.563 12.348a.749.749 0 0 1-.374 0C6.314 20.683 2.25 15.692 2.25 9.75c0-1.39.223-2.73.635-3.985a.75.75 0 0 1 .722-.516l.143.001c2.996 0 5.718-1.17 7.734-3.08ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75ZM12 15a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75v-.008a.75.75 0 0 0-.75-.75H12Z",
    clipRule: "evenodd"
  }));
}
const mN = /* @__PURE__ */ s.forwardRef(gN);
function wN({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M7.5 6v.75H5.513c-.96 0-1.764.724-1.865 1.679l-1.263 12A1.875 1.875 0 0 0 4.25 22.5h15.5a1.875 1.875 0 0 0 1.865-2.071l-1.263-12a1.875 1.875 0 0 0-1.865-1.679H16.5V6a4.5 4.5 0 1 0-9 0ZM12 3a3 3 0 0 0-3 3v.75h6V6a3 3 0 0 0-3-3Zm-3 8.25a3 3 0 1 0 6 0v-.75a.75.75 0 0 1 1.5 0v.75a4.5 4.5 0 1 1-9 0v-.75a.75.75 0 0 1 1.5 0v.75Z",
    clipRule: "evenodd"
  }));
}
const yN = /* @__PURE__ */ s.forwardRef(wN);
function bN({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M2.25 2.25a.75.75 0 0 0 0 1.5h1.386c.17 0 .318.114.362.278l2.558 9.592a3.752 3.752 0 0 0-2.806 3.63c0 .414.336.75.75.75h15.75a.75.75 0 0 0 0-1.5H5.378A2.25 2.25 0 0 1 7.5 15h11.218a.75.75 0 0 0 .674-.421 60.358 60.358 0 0 0 2.96-7.228.75.75 0 0 0-.525-.965A60.864 60.864 0 0 0 5.68 4.509l-.232-.867A1.875 1.875 0 0 0 3.636 2.25H2.25ZM3.75 20.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM16.5 20.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z"
  }));
}
const _N = /* @__PURE__ */ s.forwardRef(bN);
function xN({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M2.47 2.47a.75.75 0 0 1 1.06 0l8.407 8.407a1.125 1.125 0 0 1 1.186 1.186l1.462 1.461a3.001 3.001 0 0 0-.464-3.645.75.75 0 1 1 1.061-1.061 4.501 4.501 0 0 1 .486 5.79l1.072 1.072a6.001 6.001 0 0 0-.497-7.923.75.75 0 0 1 1.06-1.06 7.501 7.501 0 0 1 .505 10.05l1.064 1.065a9 9 0 0 0-.508-12.176.75.75 0 0 1 1.06-1.06c3.923 3.922 4.093 10.175.512 14.3l1.594 1.594a.75.75 0 1 1-1.06 1.06l-2.106-2.105-2.121-2.122h-.001l-4.705-4.706a.747.747 0 0 1-.127-.126L2.47 3.53a.75.75 0 0 1 0-1.061Zm1.189 4.422a.75.75 0 0 1 .326 1.01 9.004 9.004 0 0 0 1.651 10.462.75.75 0 1 1-1.06 1.06C1.27 16.12.63 11.165 2.648 7.219a.75.75 0 0 1 1.01-.326ZM5.84 9.134a.75.75 0 0 1 .472.95 6 6 0 0 0 1.444 6.159.75.75 0 0 1-1.06 1.06A7.5 7.5 0 0 1 4.89 9.606a.75.75 0 0 1 .95-.472Zm2.341 2.653a.75.75 0 0 1 .848.638c.088.62.37 1.218.849 1.696a.75.75 0 0 1-1.061 1.061 4.483 4.483 0 0 1-1.273-2.546.75.75 0 0 1 .637-.848Z",
    clipRule: "evenodd"
  }));
}
const CN = /* @__PURE__ */ s.forwardRef(xN);
function EN({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M5.636 4.575a.75.75 0 0 1 0 1.061 9 9 0 0 0 0 12.728.75.75 0 1 1-1.06 1.06c-4.101-4.1-4.101-10.748 0-14.849a.75.75 0 0 1 1.06 0Zm12.728 0a.75.75 0 0 1 1.06 0c4.101 4.1 4.101 10.75 0 14.85a.75.75 0 1 1-1.06-1.061 9 9 0 0 0 0-12.728.75.75 0 0 1 0-1.06ZM7.757 6.697a.75.75 0 0 1 0 1.06 6 6 0 0 0 0 8.486.75.75 0 0 1-1.06 1.06 7.5 7.5 0 0 1 0-10.606.75.75 0 0 1 1.06 0Zm8.486 0a.75.75 0 0 1 1.06 0 7.5 7.5 0 0 1 0 10.606.75.75 0 0 1-1.06-1.06 6 6 0 0 0 0-8.486.75.75 0 0 1 0-1.06ZM9.879 8.818a.75.75 0 0 1 0 1.06 3 3 0 0 0 0 4.243.75.75 0 1 1-1.061 1.061 4.5 4.5 0 0 1 0-6.364.75.75 0 0 1 1.06 0Zm4.242 0a.75.75 0 0 1 1.061 0 4.5 4.5 0 0 1 0 6.364.75.75 0 0 1-1.06-1.06 3 3 0 0 0 0-4.243.75.75 0 0 1 0-1.061ZM10.875 12a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Z",
    clipRule: "evenodd"
  }));
}
const SN = /* @__PURE__ */ s.forwardRef(EN);
function RN({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M15.256 3.042a.75.75 0 0 1 .449.962l-6 16.5a.75.75 0 1 1-1.41-.513l6-16.5a.75.75 0 0 1 .961-.449Z",
    clipRule: "evenodd"
  }));
}
const MN = /* @__PURE__ */ s.forwardRef(RN);
function AN({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M9 4.5a.75.75 0 0 1 .721.544l.813 2.846a3.75 3.75 0 0 0 2.576 2.576l2.846.813a.75.75 0 0 1 0 1.442l-2.846.813a3.75 3.75 0 0 0-2.576 2.576l-.813 2.846a.75.75 0 0 1-1.442 0l-.813-2.846a3.75 3.75 0 0 0-2.576-2.576l-2.846-.813a.75.75 0 0 1 0-1.442l2.846-.813A3.75 3.75 0 0 0 7.466 7.89l.813-2.846A.75.75 0 0 1 9 4.5ZM18 1.5a.75.75 0 0 1 .728.568l.258 1.036c.236.94.97 1.674 1.91 1.91l1.036.258a.75.75 0 0 1 0 1.456l-1.036.258c-.94.236-1.674.97-1.91 1.91l-.258 1.036a.75.75 0 0 1-1.456 0l-.258-1.036a2.625 2.625 0 0 0-1.91-1.91l-1.036-.258a.75.75 0 0 1 0-1.456l1.036-.258a2.625 2.625 0 0 0 1.91-1.91l.258-1.036A.75.75 0 0 1 18 1.5ZM16.5 15a.75.75 0 0 1 .712.513l.394 1.183c.15.447.5.799.948.948l1.183.395a.75.75 0 0 1 0 1.422l-1.183.395c-.447.15-.799.5-.948.948l-.395 1.183a.75.75 0 0 1-1.422 0l-.395-1.183a1.5 1.5 0 0 0-.948-.948l-1.183-.395a.75.75 0 0 1 0-1.422l1.183-.395c.447-.15.799-.5.948-.948l.395-1.183A.75.75 0 0 1 16.5 15Z",
    clipRule: "evenodd"
  }));
}
const kN = /* @__PURE__ */ s.forwardRef(AN);
function LN({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M13.5 4.06c0-1.336-1.616-2.005-2.56-1.06l-4.5 4.5H4.508c-1.141 0-2.318.664-2.66 1.905A9.76 9.76 0 0 0 1.5 12c0 .898.121 1.768.35 2.595.341 1.24 1.518 1.905 2.659 1.905h1.93l4.5 4.5c.945.945 2.561.276 2.561-1.06V4.06ZM18.584 5.106a.75.75 0 0 1 1.06 0c3.808 3.807 3.808 9.98 0 13.788a.75.75 0 0 1-1.06-1.06 8.25 8.25 0 0 0 0-11.668.75.75 0 0 1 0-1.06Z"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M15.932 7.757a.75.75 0 0 1 1.061 0 6 6 0 0 1 0 8.486.75.75 0 0 1-1.06-1.061 4.5 4.5 0 0 0 0-6.364.75.75 0 0 1 0-1.06Z"
  }));
}
const TN = /* @__PURE__ */ s.forwardRef(LN);
function ON({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M13.5 4.06c0-1.336-1.616-2.005-2.56-1.06l-4.5 4.5H4.508c-1.141 0-2.318.664-2.66 1.905A9.76 9.76 0 0 0 1.5 12c0 .898.121 1.768.35 2.595.341 1.24 1.518 1.905 2.659 1.905h1.93l4.5 4.5c.945.945 2.561.276 2.561-1.06V4.06ZM17.78 9.22a.75.75 0 1 0-1.06 1.06L18.44 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06l1.72-1.72 1.72 1.72a.75.75 0 1 0 1.06-1.06L20.56 12l1.72-1.72a.75.75 0 1 0-1.06-1.06l-1.72 1.72-1.72-1.72Z"
  }));
}
const IN = /* @__PURE__ */ s.forwardRef(ON);
function PN({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M16.5 6a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v7.5a3 3 0 0 0 3 3v-6A4.5 4.5 0 0 1 10.5 6h6Z"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M18 7.5a3 3 0 0 1 3 3V18a3 3 0 0 1-3 3h-7.5a3 3 0 0 1-3-3v-7.5a3 3 0 0 1 3-3H18Z"
  }));
}
const DN = /* @__PURE__ */ s.forwardRef(PN);
function NN({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M11.644 1.59a.75.75 0 0 1 .712 0l9.75 5.25a.75.75 0 0 1 0 1.32l-9.75 5.25a.75.75 0 0 1-.712 0l-9.75-5.25a.75.75 0 0 1 0-1.32l9.75-5.25Z"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "m3.265 10.602 7.668 4.129a2.25 2.25 0 0 0 2.134 0l7.668-4.13 1.37.739a.75.75 0 0 1 0 1.32l-9.75 5.25a.75.75 0 0 1-.71 0l-9.75-5.25a.75.75 0 0 1 0-1.32l1.37-.738Z"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "m10.933 19.231-7.668-4.13-1.37.739a.75.75 0 0 0 0 1.32l9.75 5.25c.221.12.489.12.71 0l9.75-5.25a.75.75 0 0 0 0-1.32l-1.37-.738-7.668 4.13a2.25 2.25 0 0 1-2.134-.001Z"
  }));
}
const BN = /* @__PURE__ */ s.forwardRef(NN);
function FN({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3 6a3 3 0 0 1 3-3h2.25a3 3 0 0 1 3 3v2.25a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm9.75 0a3 3 0 0 1 3-3H18a3 3 0 0 1 3 3v2.25a3 3 0 0 1-3 3h-2.25a3 3 0 0 1-3-3V6ZM3 15.75a3 3 0 0 1 3-3h2.25a3 3 0 0 1 3 3V18a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-2.25Zm9.75 0a3 3 0 0 1 3-3H18a3 3 0 0 1 3 3V18a3 3 0 0 1-3 3h-2.25a3 3 0 0 1-3-3v-2.25Z",
    clipRule: "evenodd"
  }));
}
const $N = /* @__PURE__ */ s.forwardRef(FN);
function VN({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M6 3a3 3 0 0 0-3 3v2.25a3 3 0 0 0 3 3h2.25a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6ZM15.75 3a3 3 0 0 0-3 3v2.25a3 3 0 0 0 3 3H18a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3h-2.25ZM6 12.75a3 3 0 0 0-3 3V18a3 3 0 0 0 3 3h2.25a3 3 0 0 0 3-3v-2.25a3 3 0 0 0-3-3H6ZM17.625 13.5a.75.75 0 0 0-1.5 0v2.625H13.5a.75.75 0 0 0 0 1.5h2.625v2.625a.75.75 0 0 0 1.5 0v-2.625h2.625a.75.75 0 0 0 0-1.5h-2.625V13.5Z"
  }));
}
const ZN = /* @__PURE__ */ s.forwardRef(VN);
function HN({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z",
    clipRule: "evenodd"
  }));
}
const jN = /* @__PURE__ */ s.forwardRef(HN);
function WN({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm6-2.438c0-.724.588-1.312 1.313-1.312h4.874c.725 0 1.313.588 1.313 1.313v4.874c0 .725-.588 1.313-1.313 1.313H9.564a1.312 1.312 0 0 1-1.313-1.313V9.564Z",
    clipRule: "evenodd"
  }));
}
const zN = /* @__PURE__ */ s.forwardRef(WN);
function GN({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 7.5a3 3 0 0 1 3-3h9a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3h-9a3 3 0 0 1-3-3v-9Z",
    clipRule: "evenodd"
  }));
}
const UN = /* @__PURE__ */ s.forwardRef(GN);
function YN({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M9.657 4.728c-1.086.385-1.766 1.057-1.979 1.85-.214.8.046 1.733.81 2.616.746.862 1.93 1.612 3.388 2.003.07.019.14.037.21.053h8.163a.75.75 0 0 1 0 1.5h-8.24a.66.66 0 0 1-.02 0H3.75a.75.75 0 0 1 0-1.5h4.78a7.108 7.108 0 0 1-1.175-1.074C6.372 9.042 5.849 7.61 6.229 6.19c.377-1.408 1.528-2.38 2.927-2.876 1.402-.497 3.127-.55 4.855-.086A8.937 8.937 0 0 1 16.94 4.6a.75.75 0 0 1-.881 1.215 7.437 7.437 0 0 0-2.436-1.14c-1.473-.394-2.885-.331-3.966.052Zm6.533 9.632a.75.75 0 0 1 1.03.25c.592.974.846 2.094.55 3.2-.378 1.408-1.529 2.38-2.927 2.876-1.402.497-3.127.55-4.855.087-1.712-.46-3.168-1.354-4.134-2.47a.75.75 0 0 1 1.134-.982c.746.862 1.93 1.612 3.388 2.003 1.473.394 2.884.331 3.966-.052 1.085-.384 1.766-1.056 1.978-1.85.169-.628.046-1.33-.381-2.032a.75.75 0 0 1 .25-1.03Z",
    clipRule: "evenodd"
  }));
}
const XN = /* @__PURE__ */ s.forwardRef(YN);
function qN({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M12 2.25a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75ZM7.5 12a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM18.894 6.166a.75.75 0 0 0-1.06-1.06l-1.591 1.59a.75.75 0 1 0 1.06 1.061l1.591-1.59ZM21.75 12a.75.75 0 0 1-.75.75h-2.25a.75.75 0 0 1 0-1.5H21a.75.75 0 0 1 .75.75ZM17.834 18.894a.75.75 0 0 0 1.06-1.06l-1.59-1.591a.75.75 0 1 0-1.061 1.06l1.59 1.591ZM12 18a.75.75 0 0 1 .75.75V21a.75.75 0 0 1-1.5 0v-2.25A.75.75 0 0 1 12 18ZM7.758 17.303a.75.75 0 0 0-1.061-1.06l-1.591 1.59a.75.75 0 0 0 1.06 1.061l1.591-1.59ZM6 12a.75.75 0 0 1-.75.75H3a.75.75 0 0 1 0-1.5h2.25A.75.75 0 0 1 6 12ZM6.697 7.757a.75.75 0 0 0 1.06-1.06l-1.59-1.591a.75.75 0 0 0-1.061 1.06l1.59 1.591Z"
  }));
}
const KN = /* @__PURE__ */ s.forwardRef(qN);
function QN({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 4.125c0-1.036.84-1.875 1.875-1.875h5.25c1.036 0 1.875.84 1.875 1.875V17.25a4.5 4.5 0 1 1-9 0V4.125Zm4.5 14.25a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M10.719 21.75h9.156c1.036 0 1.875-.84 1.875-1.875v-5.25c0-1.036-.84-1.875-1.875-1.875h-.14l-8.742 8.743c-.09.089-.18.175-.274.257ZM12.738 17.625l6.474-6.474a1.875 1.875 0 0 0 0-2.651L15.5 4.787a1.875 1.875 0 0 0-2.651 0l-.1.099V17.25c0 .126-.003.251-.01.375Z"
  }));
}
const JN = /* @__PURE__ */ s.forwardRef(QN);
function eB({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 5.625c0-1.036.84-1.875 1.875-1.875h17.25c1.035 0 1.875.84 1.875 1.875v12.75c0 1.035-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 0 1 1.5 18.375V5.625ZM21 9.375A.375.375 0 0 0 20.625 9h-7.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h7.5a.375.375 0 0 0 .375-.375v-1.5Zm0 3.75a.375.375 0 0 0-.375-.375h-7.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h7.5a.375.375 0 0 0 .375-.375v-1.5Zm0 3.75a.375.375 0 0 0-.375-.375h-7.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h7.5a.375.375 0 0 0 .375-.375v-1.5ZM10.875 18.75a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375h-7.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h7.5ZM3.375 15h7.5a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375h-7.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375Zm0-3.75h7.5a.375.375 0 0 0 .375-.375v-1.5A.375.375 0 0 0 10.875 9h-7.5A.375.375 0 0 0 3 9.375v1.5c0 .207.168.375.375.375Z",
    clipRule: "evenodd"
  }));
}
const tB = /* @__PURE__ */ s.forwardRef(eB);
function rB({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M5.25 2.25a3 3 0 0 0-3 3v4.318a3 3 0 0 0 .879 2.121l9.58 9.581c.92.92 2.39 1.186 3.548.428a18.849 18.849 0 0 0 5.441-5.44c.758-1.16.492-2.629-.428-3.548l-9.58-9.581a3 3 0 0 0-2.122-.879H5.25ZM6.375 7.5a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z",
    clipRule: "evenodd"
  }));
}
const nB = /* @__PURE__ */ s.forwardRef(rB);
function aB({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 6.375c0-1.036.84-1.875 1.875-1.875h17.25c1.035 0 1.875.84 1.875 1.875v3.026a.75.75 0 0 1-.375.65 2.249 2.249 0 0 0 0 3.898.75.75 0 0 1 .375.65v3.026c0 1.035-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 0 1 1.5 17.625v-3.026a.75.75 0 0 1 .374-.65 2.249 2.249 0 0 0 0-3.898.75.75 0 0 1-.374-.65V6.375Zm15-1.125a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-1.5 0V6a.75.75 0 0 1 .75-.75Zm.75 4.5a.75.75 0 0 0-1.5 0v.75a.75.75 0 0 0 1.5 0v-.75Zm-.75 3a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-1.5 0v-.75a.75.75 0 0 1 .75-.75Zm.75 4.5a.75.75 0 0 0-1.5 0V18a.75.75 0 0 0 1.5 0v-.75ZM6 12a.75.75 0 0 1 .75-.75H12a.75.75 0 0 1 0 1.5H6.75A.75.75 0 0 1 6 12Zm.75 2.25a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Z",
    clipRule: "evenodd"
  }));
}
const oB = /* @__PURE__ */ s.forwardRef(aB);
function iB({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M16.5 4.478v.227a48.816 48.816 0 0 1 3.878.512.75.75 0 1 1-.256 1.478l-.209-.035-1.005 13.07a3 3 0 0 1-2.991 2.77H8.084a3 3 0 0 1-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 0 1-.256-1.478A48.567 48.567 0 0 1 7.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 0 1 3.369 0c1.603.051 2.815 1.387 2.815 2.951Zm-6.136-1.452a51.196 51.196 0 0 1 3.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 0 0-6 0v-.113c0-.794.609-1.428 1.364-1.452Zm-.355 5.945a.75.75 0 1 0-1.5.058l.347 9a.75.75 0 1 0 1.499-.058l-.346-9Zm5.48.058a.75.75 0 1 0-1.498-.058l-.347 9a.75.75 0 0 0 1.5.058l.345-9Z",
    clipRule: "evenodd"
  }));
}
const lB = /* @__PURE__ */ s.forwardRef(iB);
function sB({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M5.166 2.621v.858c-1.035.148-2.059.33-3.071.543a.75.75 0 0 0-.584.859 6.753 6.753 0 0 0 6.138 5.6 6.73 6.73 0 0 0 2.743 1.346A6.707 6.707 0 0 1 9.279 15H8.54c-1.036 0-1.875.84-1.875 1.875V19.5h-.75a2.25 2.25 0 0 0-2.25 2.25c0 .414.336.75.75.75h15a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-2.25-2.25h-.75v-2.625c0-1.036-.84-1.875-1.875-1.875h-.739a6.706 6.706 0 0 1-1.112-3.173 6.73 6.73 0 0 0 2.743-1.347 6.753 6.753 0 0 0 6.139-5.6.75.75 0 0 0-.585-.858 47.077 47.077 0 0 0-3.07-.543V2.62a.75.75 0 0 0-.658-.744 49.22 49.22 0 0 0-6.093-.377c-2.063 0-4.096.128-6.093.377a.75.75 0 0 0-.657.744Zm0 2.629c0 1.196.312 2.32.857 3.294A5.266 5.266 0 0 1 3.16 5.337a45.6 45.6 0 0 1 2.006-.343v.256Zm13.5 0v-.256c.674.1 1.343.214 2.006.343a5.265 5.265 0 0 1-2.863 3.207 6.72 6.72 0 0 0 .857-3.294Z",
    clipRule: "evenodd"
  }));
}
const cB = /* @__PURE__ */ s.forwardRef(sB);
function uB({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M3.375 4.5C2.339 4.5 1.5 5.34 1.5 6.375V13.5h12V6.375c0-1.036-.84-1.875-1.875-1.875h-8.25ZM13.5 15h-12v2.625c0 1.035.84 1.875 1.875 1.875h.375a3 3 0 1 1 6 0h3a.75.75 0 0 0 .75-.75V15Z"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M8.25 19.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0ZM15.75 6.75a.75.75 0 0 0-.75.75v11.25c0 .087.015.17.042.248a3 3 0 0 1 5.958.464c.853-.175 1.522-.935 1.464-1.883a18.659 18.659 0 0 0-3.732-10.104 1.837 1.837 0 0 0-1.47-.725H15.75Z"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M19.5 19.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z"
  }));
}
const dB = /* @__PURE__ */ s.forwardRef(uB);
function fB({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M19.5 6h-15v9h15V6Z"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M3.375 3C2.339 3 1.5 3.84 1.5 4.875v11.25C1.5 17.16 2.34 18 3.375 18H9.75v1.5H6A.75.75 0 0 0 6 21h12a.75.75 0 0 0 0-1.5h-3.75V18h6.375c1.035 0 1.875-.84 1.875-1.875V4.875C22.5 3.839 21.66 3 20.625 3H3.375Zm0 13.5h17.25a.375.375 0 0 0 .375-.375V4.875a.375.375 0 0 0-.375-.375H3.375A.375.375 0 0 0 3 4.875v11.25c0 .207.168.375.375.375Z",
    clipRule: "evenodd"
  }));
}
const hB = /* @__PURE__ */ s.forwardRef(fB);
function vB({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M5.995 2.994a.75.75 0 0 1 .75.75v7.5a5.25 5.25 0 1 0 10.5 0v-7.5a.75.75 0 0 1 1.5 0v7.5a6.75 6.75 0 1 1-13.5 0v-7.5a.75.75 0 0 1 .75-.75Zm-3 17.252a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5h-16.5a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  }));
}
const pB = /* @__PURE__ */ s.forwardRef(vB);
function gB({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M18.685 19.097A9.723 9.723 0 0 0 21.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 0 0 3.065 7.097A9.716 9.716 0 0 0 12 21.75a9.716 9.716 0 0 0 6.685-2.653Zm-12.54-1.285A7.486 7.486 0 0 1 12 15a7.486 7.486 0 0 1 5.855 2.812A8.224 8.224 0 0 1 12 20.25a8.224 8.224 0 0 1-5.855-2.438ZM15.75 9a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z",
    clipRule: "evenodd"
  }));
}
const mB = /* @__PURE__ */ s.forwardRef(gB);
function wB({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M8.25 6.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0ZM15.75 9.75a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM2.25 9.75a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM6.31 15.117A6.745 6.745 0 0 1 12 12a6.745 6.745 0 0 1 6.709 7.498.75.75 0 0 1-.372.568A12.696 12.696 0 0 1 12 21.75c-2.305 0-4.47-.612-6.337-1.684a.75.75 0 0 1-.372-.568 6.787 6.787 0 0 1 1.019-4.38Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "M5.082 14.254a8.287 8.287 0 0 0-1.308 5.135 9.687 9.687 0 0 1-1.764-.44l-.115-.04a.563.563 0 0 1-.373-.487l-.01-.121a3.75 3.75 0 0 1 3.57-4.047ZM20.226 19.389a8.287 8.287 0 0 0-1.308-5.135 3.75 3.75 0 0 1 3.57 4.047l-.01.121a.563.563 0 0 1-.373.486l-.115.04c-.567.2-1.156.349-1.764.441Z"
  }));
}
const yB = /* @__PURE__ */ s.forwardRef(wB);
function bB({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M10.375 2.25a4.125 4.125 0 1 0 0 8.25 4.125 4.125 0 0 0 0-8.25ZM10.375 12a7.125 7.125 0 0 0-7.124 7.247.75.75 0 0 0 .363.63 13.067 13.067 0 0 0 6.761 1.873c2.472 0 4.786-.684 6.76-1.873a.75.75 0 0 0 .364-.63l.001-.12v-.002A7.125 7.125 0 0 0 10.375 12ZM16 9.75a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5h-6Z"
  }));
}
const _B = /* @__PURE__ */ s.forwardRef(bB);
function xB({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M5.25 6.375a4.125 4.125 0 1 1 8.25 0 4.125 4.125 0 0 1-8.25 0ZM2.25 19.125a7.125 7.125 0 0 1 14.25 0v.003l-.001.119a.75.75 0 0 1-.363.63 13.067 13.067 0 0 1-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 0 1-.364-.63l-.001-.122ZM18.75 7.5a.75.75 0 0 0-1.5 0v2.25H15a.75.75 0 0 0 0 1.5h2.25v2.25a.75.75 0 0 0 1.5 0v-2.25H21a.75.75 0 0 0 0-1.5h-2.25V7.5Z"
  }));
}
const CB = /* @__PURE__ */ s.forwardRef(xB);
function EB({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.683 18.683 0 0 1 12 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 0 1-.437-.695Z",
    clipRule: "evenodd"
  }));
}
const SB = /* @__PURE__ */ s.forwardRef(EB);
function RB({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M4.5 6.375a4.125 4.125 0 1 1 8.25 0 4.125 4.125 0 0 1-8.25 0ZM14.25 8.625a3.375 3.375 0 1 1 6.75 0 3.375 3.375 0 0 1-6.75 0ZM1.5 19.125a7.125 7.125 0 0 1 14.25 0v.003l-.001.119a.75.75 0 0 1-.363.63 13.067 13.067 0 0 1-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 0 1-.364-.63l-.001-.122ZM17.25 19.128l-.001.144a2.25 2.25 0 0 1-.233.96 10.088 10.088 0 0 0 5.06-1.01.75.75 0 0 0 .42-.643 4.875 4.875 0 0 0-6.957-4.611 8.586 8.586 0 0 1 1.71 5.157v.003Z"
  }));
}
const MB = /* @__PURE__ */ s.forwardRef(RB);
function AB({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M19.253 2.292a.75.75 0 0 1 .955.461A28.123 28.123 0 0 1 21.75 12c0 3.266-.547 6.388-1.542 9.247a.75.75 0 1 1-1.416-.494c.94-2.7 1.458-5.654 1.458-8.753s-.519-6.054-1.458-8.754a.75.75 0 0 1 .461-.954Zm-14.227.013a.75.75 0 0 1 .414.976A23.183 23.183 0 0 0 3.75 12c0 3.085.6 6.027 1.69 8.718a.75.75 0 0 1-1.39.563c-1.161-2.867-1.8-6-1.8-9.281 0-3.28.639-6.414 1.8-9.281a.75.75 0 0 1 .976-.414Zm4.275 5.052a1.5 1.5 0 0 1 2.21.803l.716 2.148L13.6 8.246a2.438 2.438 0 0 1 2.978-.892l.213.09a.75.75 0 1 1-.584 1.381l-.214-.09a.937.937 0 0 0-1.145.343l-2.021 3.033 1.084 3.255 1.445-.89a.75.75 0 1 1 .786 1.278l-1.444.889a1.5 1.5 0 0 1-2.21-.803l-.716-2.148-1.374 2.062a2.437 2.437 0 0 1-2.978.892l-.213-.09a.75.75 0 0 1 .584-1.381l.214.09a.938.938 0 0 0 1.145-.344l2.021-3.032-1.084-3.255-1.445.89a.75.75 0 1 1-.786-1.278l1.444-.89Z",
    clipRule: "evenodd"
  }));
}
const kB = /* @__PURE__ */ s.forwardRef(AB);
function LB({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M.97 3.97a.75.75 0 0 1 1.06 0l15 15a.75.75 0 1 1-1.06 1.06l-15-15a.75.75 0 0 1 0-1.06ZM17.25 16.06l2.69 2.69c.944.945 2.56.276 2.56-1.06V6.31c0-1.336-1.616-2.005-2.56-1.06l-2.69 2.69v8.12ZM15.75 7.5v8.068L4.682 4.5h8.068a3 3 0 0 1 3 3ZM1.5 16.5V7.682l11.773 11.773c-.17.03-.345.045-.523.045H4.5a3 3 0 0 1-3-3Z"
  }));
}
const TB = /* @__PURE__ */ s.forwardRef(LB);
function OB({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M4.5 4.5a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h8.25a3 3 0 0 0 3-3v-9a3 3 0 0 0-3-3H4.5ZM19.94 18.75l-2.69-2.69V7.94l2.69-2.69c.944-.945 2.56-.276 2.56 1.06v11.38c0 1.336-1.616 2.005-2.56 1.06Z"
  }));
}
const IB = /* @__PURE__ */ s.forwardRef(OB);
function PB({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M15 3.75H9v16.5h6V3.75ZM16.5 20.25h3.375c1.035 0 1.875-.84 1.875-1.875V5.625c0-1.036-.84-1.875-1.875-1.875H16.5v16.5ZM4.125 3.75H7.5v16.5H4.125a1.875 1.875 0 0 1-1.875-1.875V5.625c0-1.036.84-1.875 1.875-1.875Z"
  }));
}
const DB = /* @__PURE__ */ s.forwardRef(PB);
function NB({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M6 3a3 3 0 0 0-3 3v1.5a.75.75 0 0 0 1.5 0V6A1.5 1.5 0 0 1 6 4.5h1.5a.75.75 0 0 0 0-1.5H6ZM16.5 3a.75.75 0 0 0 0 1.5H18A1.5 1.5 0 0 1 19.5 6v1.5a.75.75 0 0 0 1.5 0V6a3 3 0 0 0-3-3h-1.5ZM12 8.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5ZM4.5 16.5a.75.75 0 0 0-1.5 0V18a3 3 0 0 0 3 3h1.5a.75.75 0 0 0 0-1.5H6A1.5 1.5 0 0 1 4.5 18v-1.5ZM21 16.5a.75.75 0 0 0-1.5 0V18a1.5 1.5 0 0 1-1.5 1.5h-1.5a.75.75 0 0 0 0 1.5H18a3 3 0 0 0 3-3v-1.5Z"
  }));
}
const BB = /* @__PURE__ */ s.forwardRef(NB);
function FB({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    d: "M2.273 5.625A4.483 4.483 0 0 1 5.25 4.5h13.5c1.141 0 2.183.425 2.977 1.125A3 3 0 0 0 18.75 3H5.25a3 3 0 0 0-2.977 2.625ZM2.273 8.625A4.483 4.483 0 0 1 5.25 7.5h13.5c1.141 0 2.183.425 2.977 1.125A3 3 0 0 0 18.75 6H5.25a3 3 0 0 0-2.977 2.625ZM5.25 9a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h13.5a3 3 0 0 0 3-3v-6a3 3 0 0 0-3-3H15a.75.75 0 0 0-.75.75 2.25 2.25 0 0 1-4.5 0A.75.75 0 0 0 9 9H5.25Z"
  }));
}
const $B = /* @__PURE__ */ s.forwardRef(FB);
function VB({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M1.371 8.143c5.858-5.857 15.356-5.857 21.213 0a.75.75 0 0 1 0 1.061l-.53.53a.75.75 0 0 1-1.06 0c-4.98-4.979-13.053-4.979-18.032 0a.75.75 0 0 1-1.06 0l-.53-.53a.75.75 0 0 1 0-1.06Zm3.182 3.182c4.1-4.1 10.749-4.1 14.85 0a.75.75 0 0 1 0 1.061l-.53.53a.75.75 0 0 1-1.062 0 8.25 8.25 0 0 0-11.667 0 .75.75 0 0 1-1.06 0l-.53-.53a.75.75 0 0 1 0-1.06Zm3.204 3.182a6 6 0 0 1 8.486 0 .75.75 0 0 1 0 1.061l-.53.53a.75.75 0 0 1-1.061 0 3.75 3.75 0 0 0-5.304 0 .75.75 0 0 1-1.06 0l-.53-.53a.75.75 0 0 1 0-1.06Zm3.182 3.182a1.5 1.5 0 0 1 2.122 0 .75.75 0 0 1 0 1.061l-.53.53a.75.75 0 0 1-1.061 0l-.53-.53a.75.75 0 0 1 0-1.06Z",
    clipRule: "evenodd"
  }));
}
const ZB = /* @__PURE__ */ s.forwardRef(VB);
function HB({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 6a3 3 0 0 1 3-3h13.5a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V6Zm18 3H3.75v9a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5V9Zm-15-3.75A.75.75 0 0 0 4.5 6v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V6a.75.75 0 0 0-.75-.75H5.25Zm1.5.75a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H7.5a.75.75 0 0 1-.75-.75V6Zm3-.75A.75.75 0 0 0 9 6v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V6a.75.75 0 0 0-.75-.75H9.75Z",
    clipRule: "evenodd"
  }));
}
const jB = /* @__PURE__ */ s.forwardRef(HB);
function WB({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 6.75a5.25 5.25 0 0 1 6.775-5.025.75.75 0 0 1 .313 1.248l-3.32 3.319c.063.475.276.934.641 1.299.365.365.824.578 1.3.64l3.318-3.319a.75.75 0 0 1 1.248.313 5.25 5.25 0 0 1-5.472 6.756c-1.018-.086-1.87.1-2.309.634L7.344 21.3A3.298 3.298 0 1 1 2.7 16.657l8.684-7.151c.533-.44.72-1.291.634-2.309A5.342 5.342 0 0 1 12 6.75ZM4.117 19.125a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75v-.008Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ s.createElement("path", {
    d: "m10.076 8.64-2.201-2.2V4.874a.75.75 0 0 0-.364-.643l-3.75-2.25a.75.75 0 0 0-.916.113l-.75.75a.75.75 0 0 0-.113.916l2.25 3.75a.75.75 0 0 0 .643.364h1.564l2.062 2.062 1.575-1.297Z"
  }), /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "m12.556 17.329 4.183 4.182a3.375 3.375 0 0 0 4.773-4.773l-3.306-3.305a6.803 6.803 0 0 1-1.53.043c-.394-.034-.682-.006-.867.042a.589.589 0 0 0-.167.063l-3.086 3.748Zm3.414-1.36a.75.75 0 0 1 1.06 0l1.875 1.876a.75.75 0 1 1-1.06 1.06L15.97 17.03a.75.75 0 0 1 0-1.06Z",
    clipRule: "evenodd"
  }));
}
const zB = /* @__PURE__ */ s.forwardRef(WB);
function GB({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 6.75a5.25 5.25 0 0 1 6.775-5.025.75.75 0 0 1 .313 1.248l-3.32 3.319c.063.475.276.934.641 1.299.365.365.824.578 1.3.64l3.318-3.319a.75.75 0 0 1 1.248.313 5.25 5.25 0 0 1-5.472 6.756c-1.018-.086-1.87.1-2.309.634L7.344 21.3A3.298 3.298 0 1 1 2.7 16.657l8.684-7.151c.533-.44.72-1.291.634-2.309A5.342 5.342 0 0 1 12 6.75ZM4.117 19.125a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75v-.008Z",
    clipRule: "evenodd"
  }));
}
const UB = /* @__PURE__ */ s.forwardRef(GB);
function YB({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z",
    clipRule: "evenodd"
  }));
}
const XB = /* @__PURE__ */ s.forwardRef(YB);
function qB({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z",
    clipRule: "evenodd"
  }));
}
const KB = /* @__PURE__ */ s.forwardRef(qB), Kw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AcademicCapIcon: JS,
  AdjustmentsHorizontalIcon: tR,
  AdjustmentsVerticalIcon: nR,
  ArchiveBoxArrowDownIcon: oR,
  ArchiveBoxIcon: cR,
  ArchiveBoxXMarkIcon: lR,
  ArrowDownCircleIcon: dR,
  ArrowDownIcon: CR,
  ArrowDownLeftIcon: hR,
  ArrowDownOnSquareIcon: mR,
  ArrowDownOnSquareStackIcon: pR,
  ArrowDownRightIcon: yR,
  ArrowDownTrayIcon: _R,
  ArrowLeftCircleIcon: SR,
  ArrowLeftEndOnRectangleIcon: MR,
  ArrowLeftIcon: IR,
  ArrowLeftOnRectangleIcon: kR,
  ArrowLeftStartOnRectangleIcon: TR,
  ArrowLongDownIcon: DR,
  ArrowLongLeftIcon: BR,
  ArrowLongRightIcon: $R,
  ArrowLongUpIcon: ZR,
  ArrowPathIcon: zR,
  ArrowPathRoundedSquareIcon: jR,
  ArrowRightCircleIcon: UR,
  ArrowRightEndOnRectangleIcon: XR,
  ArrowRightIcon: tM,
  ArrowRightOnRectangleIcon: KR,
  ArrowRightStartOnRectangleIcon: JR,
  ArrowSmallDownIcon: nM,
  ArrowSmallLeftIcon: oM,
  ArrowSmallRightIcon: lM,
  ArrowSmallUpIcon: cM,
  ArrowTopRightOnSquareIcon: dM,
  ArrowTrendingDownIcon: hM,
  ArrowTrendingUpIcon: pM,
  ArrowTurnDownLeftIcon: mM,
  ArrowTurnDownRightIcon: yM,
  ArrowTurnLeftDownIcon: _M,
  ArrowTurnLeftUpIcon: CM,
  ArrowTurnRightDownIcon: SM,
  ArrowTurnRightUpIcon: MM,
  ArrowTurnUpLeftIcon: kM,
  ArrowTurnUpRightIcon: TM,
  ArrowUpCircleIcon: IM,
  ArrowUpIcon: zM,
  ArrowUpLeftIcon: DM,
  ArrowUpOnSquareIcon: $M,
  ArrowUpOnSquareStackIcon: BM,
  ArrowUpRightIcon: ZM,
  ArrowUpTrayIcon: jM,
  ArrowUturnDownIcon: UM,
  ArrowUturnLeftIcon: XM,
  ArrowUturnRightIcon: KM,
  ArrowUturnUpIcon: JM,
  ArrowsPointingInIcon: tA,
  ArrowsPointingOutIcon: nA,
  ArrowsRightLeftIcon: oA,
  ArrowsUpDownIcon: lA,
  AtSymbolIcon: cA,
  BackspaceIcon: dA,
  BackwardIcon: hA,
  BanknotesIcon: pA,
  Bars2Icon: mA,
  Bars3BottomLeftIcon: yA,
  Bars3BottomRightIcon: _A,
  Bars3CenterLeftIcon: CA,
  Bars3Icon: SA,
  Bars4Icon: MA,
  BarsArrowDownIcon: kA,
  BarsArrowUpIcon: TA,
  Battery0Icon: IA,
  Battery100Icon: DA,
  Battery50Icon: BA,
  BeakerIcon: $A,
  BellAlertIcon: ZA,
  BellIcon: UA,
  BellSlashIcon: jA,
  BellSnoozeIcon: zA,
  BoldIcon: XA,
  BoltIcon: JA,
  BoltSlashIcon: KA,
  BookOpenIcon: tk,
  BookmarkIcon: lk,
  BookmarkSlashIcon: nk,
  BookmarkSquareIcon: ok,
  BriefcaseIcon: ck,
  BugAntIcon: dk,
  BuildingLibraryIcon: hk,
  BuildingOffice2Icon: pk,
  BuildingOfficeIcon: mk,
  BuildingStorefrontIcon: yk,
  CakeIcon: _k,
  CalculatorIcon: Ck,
  CalendarDateRangeIcon: Sk,
  CalendarDaysIcon: Mk,
  CalendarIcon: kk,
  CameraIcon: Tk,
  ChartBarIcon: Dk,
  ChartBarSquareIcon: Ik,
  ChartPieIcon: Bk,
  ChatBubbleBottomCenterIcon: Zk,
  ChatBubbleBottomCenterTextIcon: $k,
  ChatBubbleLeftEllipsisIcon: jk,
  ChatBubbleLeftIcon: Uk,
  ChatBubbleLeftRightIcon: zk,
  ChatBubbleOvalLeftEllipsisIcon: Xk,
  ChatBubbleOvalLeftIcon: Kk,
  CheckBadgeIcon: Jk,
  CheckCircleIcon: tL,
  CheckIcon: nL,
  ChevronDoubleDownIcon: oL,
  ChevronDoubleLeftIcon: lL,
  ChevronDoubleRightIcon: cL,
  ChevronDoubleUpIcon: dL,
  ChevronDownIcon: hL,
  ChevronLeftIcon: pL,
  ChevronRightIcon: mL,
  ChevronUpDownIcon: yL,
  ChevronUpIcon: _L,
  CircleStackIcon: CL,
  ClipboardDocumentCheckIcon: SL,
  ClipboardDocumentIcon: kL,
  ClipboardDocumentListIcon: ML,
  ClipboardIcon: TL,
  ClockIcon: IL,
  CloudArrowDownIcon: DL,
  CloudArrowUpIcon: BL,
  CloudIcon: $L,
  CodeBracketIcon: jL,
  CodeBracketSquareIcon: ZL,
  Cog6ToothIcon: zL,
  Cog8ToothIcon: UL,
  CogIcon: XL,
  CommandLineIcon: KL,
  ComputerDesktopIcon: JL,
  CpuChipIcon: tT,
  CreditCardIcon: nT,
  CubeIcon: lT,
  CubeTransparentIcon: oT,
  CurrencyBangladeshiIcon: cT,
  CurrencyDollarIcon: dT,
  CurrencyEuroIcon: hT,
  CurrencyPoundIcon: pT,
  CurrencyRupeeIcon: mT,
  CurrencyYenIcon: yT,
  CursorArrowRaysIcon: _T,
  CursorArrowRippleIcon: CT,
  DevicePhoneMobileIcon: ST,
  DeviceTabletIcon: MT,
  DivideIcon: kT,
  DocumentArrowDownIcon: TT,
  DocumentArrowUpIcon: IT,
  DocumentChartBarIcon: DT,
  DocumentCheckIcon: BT,
  DocumentCurrencyBangladeshiIcon: $T,
  DocumentCurrencyDollarIcon: ZT,
  DocumentCurrencyEuroIcon: jT,
  DocumentCurrencyPoundIcon: zT,
  DocumentCurrencyRupeeIcon: UT,
  DocumentCurrencyYenIcon: XT,
  DocumentDuplicateIcon: KT,
  DocumentIcon: lO,
  DocumentMagnifyingGlassIcon: JT,
  DocumentMinusIcon: tO,
  DocumentPlusIcon: nO,
  DocumentTextIcon: oO,
  EllipsisHorizontalCircleIcon: cO,
  EllipsisHorizontalIcon: dO,
  EllipsisVerticalIcon: hO,
  EnvelopeIcon: mO,
  EnvelopeOpenIcon: pO,
  EqualsIcon: yO,
  ExclamationCircleIcon: _O,
  ExclamationTriangleIcon: CO,
  EyeDropperIcon: SO,
  EyeIcon: kO,
  EyeSlashIcon: MO,
  FaceFrownIcon: TO,
  FaceSmileIcon: IO,
  FilmIcon: DO,
  FingerPrintIcon: BO,
  FireIcon: $O,
  FlagIcon: ZO,
  FolderArrowDownIcon: jO,
  FolderIcon: KO,
  FolderMinusIcon: zO,
  FolderOpenIcon: UO,
  FolderPlusIcon: XO,
  ForwardIcon: JO,
  FunnelIcon: tI,
  GifIcon: nI,
  GiftIcon: lI,
  GiftTopIcon: oI,
  GlobeAltIcon: cI,
  GlobeAmericasIcon: dI,
  GlobeAsiaAustraliaIcon: hI,
  GlobeEuropeAfricaIcon: pI,
  H1Icon: mI,
  H2Icon: yI,
  H3Icon: _I,
  HandRaisedIcon: CI,
  HandThumbDownIcon: SI,
  HandThumbUpIcon: MI,
  HashtagIcon: kI,
  HeartIcon: TI,
  HomeIcon: DI,
  HomeModernIcon: II,
  IdentificationIcon: BI,
  InboxArrowDownIcon: $I,
  InboxIcon: jI,
  InboxStackIcon: ZI,
  InformationCircleIcon: zI,
  ItalicIcon: UI,
  KeyIcon: XI,
  LanguageIcon: KI,
  LifebuoyIcon: JI,
  LightBulbIcon: tP,
  LinkIcon: oP,
  LinkSlashIcon: nP,
  ListBulletIcon: lP,
  LockClosedIcon: cP,
  LockOpenIcon: dP,
  MagnifyingGlassCircleIcon: hP,
  MagnifyingGlassIcon: yP,
  MagnifyingGlassMinusIcon: pP,
  MagnifyingGlassPlusIcon: mP,
  MapIcon: CP,
  MapPinIcon: _P,
  MegaphoneIcon: SP,
  MicrophoneIcon: MP,
  MinusCircleIcon: kP,
  MinusIcon: IP,
  MinusSmallIcon: TP,
  MoonIcon: DP,
  MusicalNoteIcon: BP,
  NewspaperIcon: $P,
  NoSymbolIcon: ZP,
  NumberedListIcon: jP,
  PaintBrushIcon: zP,
  PaperAirplaneIcon: UP,
  PaperClipIcon: XP,
  PauseCircleIcon: KP,
  PauseIcon: JP,
  PencilIcon: nD,
  PencilSquareIcon: tD,
  PercentBadgeIcon: oD,
  PhoneArrowDownLeftIcon: lD,
  PhoneArrowUpRightIcon: cD,
  PhoneIcon: hD,
  PhoneXMarkIcon: dD,
  PhotoIcon: pD,
  PlayCircleIcon: mD,
  PlayIcon: _D,
  PlayPauseIcon: yD,
  PlusCircleIcon: CD,
  PlusIcon: MD,
  PlusSmallIcon: SD,
  PowerIcon: kD,
  PresentationChartBarIcon: TD,
  PresentationChartLineIcon: ID,
  PrinterIcon: DD,
  PuzzlePieceIcon: BD,
  QrCodeIcon: $D,
  QuestionMarkCircleIcon: ZD,
  QueueListIcon: jD,
  RadioIcon: zD,
  ReceiptPercentIcon: UD,
  ReceiptRefundIcon: XD,
  RectangleGroupIcon: KD,
  RectangleStackIcon: JD,
  RocketLaunchIcon: tN,
  RssIcon: nN,
  ScaleIcon: oN,
  ScissorsIcon: lN,
  ServerIcon: dN,
  ServerStackIcon: cN,
  ShareIcon: hN,
  ShieldCheckIcon: pN,
  ShieldExclamationIcon: mN,
  ShoppingBagIcon: yN,
  ShoppingCartIcon: _N,
  SignalIcon: SN,
  SignalSlashIcon: CN,
  SlashIcon: MN,
  SparklesIcon: kN,
  SpeakerWaveIcon: TN,
  SpeakerXMarkIcon: IN,
  Square2StackIcon: DN,
  Square3Stack3DIcon: BN,
  Squares2X2Icon: $N,
  SquaresPlusIcon: ZN,
  StarIcon: jN,
  StopCircleIcon: zN,
  StopIcon: UN,
  StrikethroughIcon: XN,
  SunIcon: KN,
  SwatchIcon: JN,
  TableCellsIcon: tB,
  TagIcon: nB,
  TicketIcon: oB,
  TrashIcon: lB,
  TrophyIcon: cB,
  TruckIcon: dB,
  TvIcon: hB,
  UnderlineIcon: pB,
  UserCircleIcon: mB,
  UserGroupIcon: yB,
  UserIcon: SB,
  UserMinusIcon: _B,
  UserPlusIcon: CB,
  UsersIcon: MB,
  VariableIcon: kB,
  VideoCameraIcon: IB,
  VideoCameraSlashIcon: TB,
  ViewColumnsIcon: DB,
  ViewfinderCircleIcon: BB,
  WalletIcon: $B,
  WifiIcon: ZB,
  WindowIcon: jB,
  WrenchIcon: UB,
  WrenchScrewdriverIcon: zB,
  XCircleIcon: XB,
  XMarkIcon: KB
}, Symbol.toStringTag, { value: "Module" }));
function QB({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.26 10.147a60.438 60.438 0 0 0-.491 6.347A48.62 48.62 0 0 1 12 20.904a48.62 48.62 0 0 1 8.232-4.41 60.46 60.46 0 0 0-.491-6.347m-15.482 0a50.636 50.636 0 0 0-2.658-.813A59.906 59.906 0 0 1 12 3.493a59.903 59.903 0 0 1 10.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.717 50.717 0 0 1 12 13.489a50.702 50.702 0 0 1 7.74-3.342M6.75 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm0 0v-3.675A55.378 55.378 0 0 1 12 8.443m-7.007 11.55A5.981 5.981 0 0 0 6.75 15.75v-1.5"
  }));
}
const JB = /* @__PURE__ */ s.forwardRef(QB);
function eF({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75"
  }));
}
const tF = /* @__PURE__ */ s.forwardRef(eF);
function rF({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 13.5V3.75m0 9.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 3.75V16.5m12-3V3.75m0 9.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 3.75V16.5m-6-9V3.75m0 3.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 9.75V10.5"
  }));
}
const nF = /* @__PURE__ */ s.forwardRef(rF);
function aF({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5m8.25 3v6.75m0 0-3-3m3 3 3-3M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z"
  }));
}
const oF = /* @__PURE__ */ s.forwardRef(aF);
function iF({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5m6 4.125 2.25 2.25m0 0 2.25 2.25M12 13.875l2.25-2.25M12 13.875l-2.25 2.25M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z"
  }));
}
const lF = /* @__PURE__ */ s.forwardRef(iF);
function sF({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z"
  }));
}
const cF = /* @__PURE__ */ s.forwardRef(sF);
function uF({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m9 12.75 3 3m0 0 3-3m-3 3v-7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
  }));
}
const dF = /* @__PURE__ */ s.forwardRef(uF);
function fF({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m19.5 4.5-15 15m0 0h11.25m-11.25 0V8.25"
  }));
}
const hF = /* @__PURE__ */ s.forwardRef(fF);
function vF({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.5 7.5h-.75A2.25 2.25 0 0 0 4.5 9.75v7.5a2.25 2.25 0 0 0 2.25 2.25h7.5a2.25 2.25 0 0 0 2.25-2.25v-7.5a2.25 2.25 0 0 0-2.25-2.25h-.75m-6 3.75 3 3m0 0 3-3m-3 3V1.5m6 9h.75a2.25 2.25 0 0 1 2.25 2.25v7.5a2.25 2.25 0 0 1-2.25 2.25h-7.5a2.25 2.25 0 0 1-2.25-2.25v-.75"
  }));
}
const pF = /* @__PURE__ */ s.forwardRef(vF);
function gF({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15M9 12l3 3m0 0 3-3m-3 3V2.25"
  }));
}
const mF = /* @__PURE__ */ s.forwardRef(gF);
function wF({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m4.5 4.5 15 15m0 0V8.25m0 11.25H8.25"
  }));
}
const yF = /* @__PURE__ */ s.forwardRef(wF);
function bF({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
  }));
}
const _F = /* @__PURE__ */ s.forwardRef(bF);
function xF({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3"
  }));
}
const CF = /* @__PURE__ */ s.forwardRef(xF);
function EF({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m11.25 9-3 3m0 0 3 3m-3-3h7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
  }));
}
const SF = /* @__PURE__ */ s.forwardRef(EF);
function RF({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0 3 3m-3-3h12.75"
  }));
}
const MF = /* @__PURE__ */ s.forwardRef(RF);
function AF({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0 3 3m-3-3h12.75"
  }));
}
const kF = /* @__PURE__ */ s.forwardRef(AF);
function LF({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15m-3 0-3-3m0 0 3-3m-3 3H15"
  }));
}
const TF = /* @__PURE__ */ s.forwardRef(LF);
function OF({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
  }));
}
const IF = /* @__PURE__ */ s.forwardRef(OF);
function PF({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 17.25 12 21m0 0-3.75-3.75M12 21V3"
  }));
}
const DF = /* @__PURE__ */ s.forwardRef(PF);
function NF({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18"
  }));
}
const BF = /* @__PURE__ */ s.forwardRef(NF);
function FF({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3"
  }));
}
const $F = /* @__PURE__ */ s.forwardRef(FF);
function VF({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.25 6.75 12 3m0 0 3.75 3.75M12 3v18"
  }));
}
const ZF = /* @__PURE__ */ s.forwardRef(VF);
function HF({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 12c0-1.232-.046-2.453-.138-3.662a4.006 4.006 0 0 0-3.7-3.7 48.678 48.678 0 0 0-7.324 0 4.006 4.006 0 0 0-3.7 3.7c-.017.22-.032.441-.046.662M19.5 12l3-3m-3 3-3-3m-12 3c0 1.232.046 2.453.138 3.662a4.006 4.006 0 0 0 3.7 3.7 48.656 48.656 0 0 0 7.324 0 4.006 4.006 0 0 0 3.7-3.7c.017-.22.032-.441.046-.662M4.5 12l3 3m-3-3-3 3"
  }));
}
const jF = /* @__PURE__ */ s.forwardRef(HF);
function WF({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
  }));
}
const zF = /* @__PURE__ */ s.forwardRef(WF);
function GF({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m12.75 15 3-3m0 0-3-3m3 3h-7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
  }));
}
const UF = /* @__PURE__ */ s.forwardRef(GF);
function YF({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15M12 9l3 3m0 0-3 3m3-3H2.25"
  }));
}
const XF = /* @__PURE__ */ s.forwardRef(YF);
function qF({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9"
  }));
}
const KF = /* @__PURE__ */ s.forwardRef(qF);
function QF({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9"
  }));
}
const JF = /* @__PURE__ */ s.forwardRef(QF);
function e$({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
  }));
}
const t$ = /* @__PURE__ */ s.forwardRef(e$);
function r$({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 4.5v15m0 0 6.75-6.75M12 19.5l-6.75-6.75"
  }));
}
const n$ = /* @__PURE__ */ s.forwardRef(r$);
function a$({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 12h-15m0 0 6.75 6.75M4.5 12l6.75-6.75"
  }));
}
const o$ = /* @__PURE__ */ s.forwardRef(a$);
function i$({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.5 12h15m0 0-6.75-6.75M19.5 12l-6.75 6.75"
  }));
}
const l$ = /* @__PURE__ */ s.forwardRef(i$);
function s$({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 19.5v-15m0 0-6.75 6.75M12 4.5l6.75 6.75"
  }));
}
const c$ = /* @__PURE__ */ s.forwardRef(s$);
function u$({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
  }));
}
const d$ = /* @__PURE__ */ s.forwardRef(u$);
function f$({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 6 9 12.75l4.286-4.286a11.948 11.948 0 0 1 4.306 6.43l.776 2.898m0 0 3.182-5.511m-3.182 5.51-5.511-3.181"
  }));
}
const h$ = /* @__PURE__ */ s.forwardRef(f$);
function v$({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 18 9 11.25l4.306 4.306a11.95 11.95 0 0 1 5.814-5.518l2.74-1.22m0 0-5.94-2.281m5.94 2.28-2.28 5.941"
  }));
}
const p$ = /* @__PURE__ */ s.forwardRef(v$);
function g$({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m7.49 12-3.75 3.75m0 0 3.75 3.75m-3.75-3.75h16.5V4.499"
  }));
}
const m$ = /* @__PURE__ */ s.forwardRef(g$);
function w$({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m16.49 12 3.75 3.75m0 0-3.75 3.75m3.75-3.75H3.74V4.499"
  }));
}
const y$ = /* @__PURE__ */ s.forwardRef(w$);
function b$({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m11.99 16.5-3.75 3.75m0 0L4.49 16.5m3.75 3.75V3.75h11.25"
  }));
}
const _$ = /* @__PURE__ */ s.forwardRef(b$);
function x$({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.99 7.5 8.24 3.75m0 0L4.49 7.5m3.75-3.75v16.499h11.25"
  }));
}
const C$ = /* @__PURE__ */ s.forwardRef(x$);
function E$({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m11.99 16.5 3.75 3.75m0 0 3.75-3.75m-3.75 3.75V3.75H4.49"
  }));
}
const S$ = /* @__PURE__ */ s.forwardRef(E$);
function R$({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m11.99 7.5 3.75-3.75m0 0 3.75 3.75m-3.75-3.75v16.499H4.49"
  }));
}
const M$ = /* @__PURE__ */ s.forwardRef(R$);
function A$({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.49 12 3.74 8.248m0 0 3.75-3.75m-3.75 3.75h16.5V19.5"
  }));
}
const k$ = /* @__PURE__ */ s.forwardRef(A$);
function L$({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m16.49 12 3.75-3.751m0 0-3.75-3.75m3.75 3.75H3.74V19.5"
  }));
}
const T$ = /* @__PURE__ */ s.forwardRef(L$);
function O$({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m15 11.25-3-3m0 0-3 3m3-3v7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
  }));
}
const I$ = /* @__PURE__ */ s.forwardRef(O$);
function P$({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m19.5 19.5-15-15m0 0v11.25m0-11.25h11.25"
  }));
}
const D$ = /* @__PURE__ */ s.forwardRef(P$);
function N$({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.5 7.5h-.75A2.25 2.25 0 0 0 4.5 9.75v7.5a2.25 2.25 0 0 0 2.25 2.25h7.5a2.25 2.25 0 0 0 2.25-2.25v-7.5a2.25 2.25 0 0 0-2.25-2.25h-.75m0-3-3-3m0 0-3 3m3-3v11.25m6-2.25h.75a2.25 2.25 0 0 1 2.25 2.25v7.5a2.25 2.25 0 0 1-2.25 2.25h-7.5a2.25 2.25 0 0 1-2.25-2.25v-.75"
  }));
}
const B$ = /* @__PURE__ */ s.forwardRef(N$);
function F$({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15m0-3-3-3m0 0-3 3m3-3V15"
  }));
}
const $$ = /* @__PURE__ */ s.forwardRef(F$);
function V$({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25"
  }));
}
const Z$ = /* @__PURE__ */ s.forwardRef(V$);
function H$({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5"
  }));
}
const j$ = /* @__PURE__ */ s.forwardRef(H$);
function W$({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.5 10.5 12 3m0 0 7.5 7.5M12 3v18"
  }));
}
const z$ = /* @__PURE__ */ s.forwardRef(W$);
function G$({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m15 15-6 6m0 0-6-6m6 6V9a6 6 0 0 1 12 0v3"
  }));
}
const U$ = /* @__PURE__ */ s.forwardRef(G$);
function Y$({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3"
  }));
}
const X$ = /* @__PURE__ */ s.forwardRef(Y$);
function q$({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m15 15 6-6m0 0-6-6m6 6H9a6 6 0 0 0 0 12h3"
  }));
}
const K$ = /* @__PURE__ */ s.forwardRef(q$);
function Q$({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m9 9 6-6m0 0 6 6m-6-6v12a6 6 0 0 1-12 0v-3"
  }));
}
const J$ = /* @__PURE__ */ s.forwardRef(Q$);
function eV({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 9V4.5M9 9H4.5M9 9 3.75 3.75M9 15v4.5M9 15H4.5M9 15l-5.25 5.25M15 9h4.5M15 9V4.5M15 9l5.25-5.25M15 15h4.5M15 15v4.5m0-4.5 5.25 5.25"
  }));
}
const tV = /* @__PURE__ */ s.forwardRef(eV);
function rV({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15"
  }));
}
const nV = /* @__PURE__ */ s.forwardRef(rV);
function aV({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.5 21 3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5"
  }));
}
const oV = /* @__PURE__ */ s.forwardRef(aV);
function iV({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 7.5 7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5"
  }));
}
const lV = /* @__PURE__ */ s.forwardRef(iV);
function sV({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.5 12a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm0 0c0 1.657 1.007 3 2.25 3S21 13.657 21 12a9 9 0 1 0-2.636 6.364M16.5 12V8.25"
  }));
}
const cV = /* @__PURE__ */ s.forwardRef(sV);
function uV({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 9.75 14.25 12m0 0 2.25 2.25M14.25 12l2.25-2.25M14.25 12 12 14.25m-2.58 4.92-6.374-6.375a1.125 1.125 0 0 1 0-1.59L9.42 4.83c.21-.211.497-.33.795-.33H19.5a2.25 2.25 0 0 1 2.25 2.25v10.5a2.25 2.25 0 0 1-2.25 2.25h-9.284c-.298 0-.585-.119-.795-.33Z"
  }));
}
const dV = /* @__PURE__ */ s.forwardRef(uV);
function fV({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 16.811c0 .864-.933 1.406-1.683.977l-7.108-4.061a1.125 1.125 0 0 1 0-1.954l7.108-4.061A1.125 1.125 0 0 1 21 8.689v8.122ZM11.25 16.811c0 .864-.933 1.406-1.683.977l-7.108-4.061a1.125 1.125 0 0 1 0-1.954l7.108-4.061a1.125 1.125 0 0 1 1.683.977v8.122Z"
  }));
}
const hV = /* @__PURE__ */ s.forwardRef(fV);
function vV({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z"
  }));
}
const pV = /* @__PURE__ */ s.forwardRef(vV);
function gV({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 9h16.5m-16.5 6.75h16.5"
  }));
}
const mV = /* @__PURE__ */ s.forwardRef(gV);
function wV({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12"
  }));
}
const yV = /* @__PURE__ */ s.forwardRef(wV);
function bV({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 6.75h16.5M3.75 12h16.5M12 17.25h8.25"
  }));
}
const _V = /* @__PURE__ */ s.forwardRef(bV);
function xV({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 6.75h16.5M3.75 12H12m-8.25 5.25h16.5"
  }));
}
const CV = /* @__PURE__ */ s.forwardRef(xV);
function EV({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
  }));
}
const SV = /* @__PURE__ */ s.forwardRef(EV);
function RV({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 5.25h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5"
  }));
}
const MV = /* @__PURE__ */ s.forwardRef(RV);
function AV({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 4.5h14.25M3 9h9.75M3 13.5h9.75m4.5-4.5v12m0 0-3.75-3.75M17.25 21 21 17.25"
  }));
}
const kV = /* @__PURE__ */ s.forwardRef(AV);
function LV({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 4.5h14.25M3 9h9.75M3 13.5h5.25m5.25-.75L17.25 9m0 0L21 12.75M17.25 9v12"
  }));
}
const TV = /* @__PURE__ */ s.forwardRef(LV);
function OV({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 10.5h.375c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125H21M3.75 18h15A2.25 2.25 0 0 0 21 15.75v-6a2.25 2.25 0 0 0-2.25-2.25h-15A2.25 2.25 0 0 0 1.5 9.75v6A2.25 2.25 0 0 0 3.75 18Z"
  }));
}
const IV = /* @__PURE__ */ s.forwardRef(OV);
function PV({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 10.5h.375c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125H21M4.5 10.5H18V15H4.5v-4.5ZM3.75 18h15A2.25 2.25 0 0 0 21 15.75v-6a2.25 2.25 0 0 0-2.25-2.25h-15A2.25 2.25 0 0 0 1.5 9.75v6A2.25 2.25 0 0 0 3.75 18Z"
  }));
}
const DV = /* @__PURE__ */ s.forwardRef(PV);
function NV({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 10.5h.375c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125H21M4.5 10.5h6.75V15H4.5v-4.5ZM3.75 18h15A2.25 2.25 0 0 0 21 15.75v-6a2.25 2.25 0 0 0-2.25-2.25h-15A2.25 2.25 0 0 0 1.5 9.75v6A2.25 2.25 0 0 0 3.75 18Z"
  }));
}
const BV = /* @__PURE__ */ s.forwardRef(NV);
function FV({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.75 3.104v5.714a2.25 2.25 0 0 1-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 0 1 4.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0 1 12 15a9.065 9.065 0 0 0-6.23-.693L5 14.5m14.8.8 1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0 1 12 21c-2.773 0-5.491-.235-8.135-.687-1.718-.293-2.3-2.379-1.067-3.61L5 14.5"
  }));
}
const $V = /* @__PURE__ */ s.forwardRef(FV);
function VV({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0M3.124 7.5A8.969 8.969 0 0 1 5.292 3m13.416 0a8.969 8.969 0 0 1 2.168 4.5"
  }));
}
const ZV = /* @__PURE__ */ s.forwardRef(VV);
function HV({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.143 17.082a24.248 24.248 0 0 0 3.844.148m-3.844-.148a23.856 23.856 0 0 1-5.455-1.31 8.964 8.964 0 0 0 2.3-5.542m3.155 6.852a3 3 0 0 0 5.667 1.97m1.965-2.277L21 21m-4.225-4.225a23.81 23.81 0 0 0 3.536-1.003A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6.53 6.53m10.245 10.245L6.53 6.53M3 3l3.53 3.53"
  }));
}
const jV = /* @__PURE__ */ s.forwardRef(HV);
function WV({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0M10.5 8.25h3l-3 4.5h3"
  }));
}
const zV = /* @__PURE__ */ s.forwardRef(WV);
function GV({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0"
  }));
}
const UV = /* @__PURE__ */ s.forwardRef(GV);
function YV({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinejoin: "round",
    d: "M6.75 3.744h-.753v8.25h7.125a4.125 4.125 0 0 0 0-8.25H6.75Zm0 0v.38m0 16.122h6.747a4.5 4.5 0 0 0 0-9.001h-7.5v9h.753Zm0 0v-.37m0-15.751h6a3.75 3.75 0 1 1 0 7.5h-6m0-7.5v7.5m0 0v8.25m0-8.25h6.375a4.125 4.125 0 0 1 0 8.25H6.75m.747-15.38h4.875a3.375 3.375 0 0 1 0 6.75H7.497v-6.75Zm0 7.5h5.25a3.75 3.75 0 0 1 0 7.5h-5.25v-7.5Z"
  }));
}
const XV = /* @__PURE__ */ s.forwardRef(YV);
function qV({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.412 15.655 9.75 21.75l3.745-4.012M9.257 13.5H3.75l2.659-2.849m2.048-2.194L14.25 2.25 12 10.5h8.25l-4.707 5.043M8.457 8.457 3 3m5.457 5.457 7.086 7.086m0 0L21 21"
  }));
}
const KV = /* @__PURE__ */ s.forwardRef(qV);
function QV({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m3.75 13.5 10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75Z"
  }));
}
const JV = /* @__PURE__ */ s.forwardRef(QV);
function eZ({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25"
  }));
}
const tZ = /* @__PURE__ */ s.forwardRef(eZ);
function rZ({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m3 3 1.664 1.664M21 21l-1.5-1.5m-5.485-1.242L12 17.25 4.5 21V8.742m.164-4.078a2.15 2.15 0 0 1 1.743-1.342 48.507 48.507 0 0 1 11.186 0c1.1.128 1.907 1.077 1.907 2.185V19.5M4.664 4.664 19.5 19.5"
  }));
}
const nZ = /* @__PURE__ */ s.forwardRef(rZ);
function aZ({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.5 3.75V16.5L12 14.25 7.5 16.5V3.75m9 0H18A2.25 2.25 0 0 1 20.25 6v12A2.25 2.25 0 0 1 18 20.25H6A2.25 2.25 0 0 1 3.75 18V6A2.25 2.25 0 0 1 6 3.75h1.5m9 0h-9"
  }));
}
const oZ = /* @__PURE__ */ s.forwardRef(aZ);
function iZ({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0Z"
  }));
}
const lZ = /* @__PURE__ */ s.forwardRef(iZ);
function sZ({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z"
  }));
}
const cZ = /* @__PURE__ */ s.forwardRef(sZ);
function uZ({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 12.75c1.148 0 2.278.08 3.383.237 1.037.146 1.866.966 1.866 2.013 0 3.728-2.35 6.75-5.25 6.75S6.75 18.728 6.75 15c0-1.046.83-1.867 1.866-2.013A24.204 24.204 0 0 1 12 12.75Zm0 0c2.883 0 5.647.508 8.207 1.44a23.91 23.91 0 0 1-1.152 6.06M12 12.75c-2.883 0-5.647.508-8.208 1.44.125 2.104.52 4.136 1.153 6.06M12 12.75a2.25 2.25 0 0 0 2.248-2.354M12 12.75a2.25 2.25 0 0 1-2.248-2.354M12 8.25c.995 0 1.971-.08 2.922-.236.403-.066.74-.358.795-.762a3.778 3.778 0 0 0-.399-2.25M12 8.25c-.995 0-1.97-.08-2.922-.236-.402-.066-.74-.358-.795-.762a3.734 3.734 0 0 1 .4-2.253M12 8.25a2.25 2.25 0 0 0-2.248 2.146M12 8.25a2.25 2.25 0 0 1 2.248 2.146M8.683 5a6.032 6.032 0 0 1-1.155-1.002c.07-.63.27-1.222.574-1.747m.581 2.749A3.75 3.75 0 0 1 15.318 5m0 0c.427-.283.815-.62 1.155-.999a4.471 4.471 0 0 0-.575-1.752M4.921 6a24.048 24.048 0 0 0-.392 3.314c1.668.546 3.416.914 5.223 1.082M19.08 6c.205 1.08.337 2.187.392 3.314a23.882 23.882 0 0 1-5.223 1.082"
  }));
}
const dZ = /* @__PURE__ */ s.forwardRef(uZ);
function fZ({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0 0 12 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75Z"
  }));
}
const hZ = /* @__PURE__ */ s.forwardRef(fZ);
function vZ({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Z"
  }));
}
const pZ = /* @__PURE__ */ s.forwardRef(vZ);
function gZ({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21"
  }));
}
const mZ = /* @__PURE__ */ s.forwardRef(gZ);
function wZ({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.5 21v-7.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349M3.75 21V9.349m0 0a3.001 3.001 0 0 0 3.75-.615A2.993 2.993 0 0 0 9.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 0 0 2.25 1.016c.896 0 1.7-.393 2.25-1.015a3.001 3.001 0 0 0 3.75.614m-16.5 0a3.004 3.004 0 0 1-.621-4.72l1.189-1.19A1.5 1.5 0 0 1 5.378 3h13.243a1.5 1.5 0 0 1 1.06.44l1.19 1.189a3 3 0 0 1-.621 4.72M6.75 18h3.75a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75H6.75a.75.75 0 0 0-.75.75v3.75c0 .414.336.75.75.75Z"
  }));
}
const yZ = /* @__PURE__ */ s.forwardRef(wZ);
function bZ({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 8.25v-1.5m0 1.5c-1.355 0-2.697.056-4.024.166C6.845 8.51 6 9.473 6 10.608v2.513m6-4.871c1.355 0 2.697.056 4.024.166C17.155 8.51 18 9.473 18 10.608v2.513M15 8.25v-1.5m-6 1.5v-1.5m12 9.75-1.5.75a3.354 3.354 0 0 1-3 0 3.354 3.354 0 0 0-3 0 3.354 3.354 0 0 1-3 0 3.354 3.354 0 0 0-3 0 3.354 3.354 0 0 1-3 0L3 16.5m15-3.379a48.474 48.474 0 0 0-6-.371c-2.032 0-4.034.126-6 .371m12 0c.39.049.777.102 1.163.16 1.07.16 1.837 1.094 1.837 2.175v5.169c0 .621-.504 1.125-1.125 1.125H4.125A1.125 1.125 0 0 1 3 20.625v-5.17c0-1.08.768-2.014 1.837-2.174A47.78 47.78 0 0 1 6 13.12M12.265 3.11a.375.375 0 1 1-.53 0L12 2.845l.265.265Zm-3 0a.375.375 0 1 1-.53 0L9 2.845l.265.265Zm6 0a.375.375 0 1 1-.53 0L15 2.845l.265.265Z"
  }));
}
const _Z = /* @__PURE__ */ s.forwardRef(bZ);
function xZ({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008Zm0 2.25h.008v.008H8.25V13.5Zm0 2.25h.008v.008H8.25v-.008Zm0 2.25h.008v.008H8.25V18Zm2.498-6.75h.007v.008h-.007v-.008Zm0 2.25h.007v.008h-.007V13.5Zm0 2.25h.007v.008h-.007v-.008Zm0 2.25h.007v.008h-.007V18Zm2.504-6.75h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V13.5Zm0 2.25h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V18Zm2.498-6.75h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V13.5ZM8.25 6h7.5v2.25h-7.5V6ZM12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 0 0 2.25 2.25h10.5a2.25 2.25 0 0 0 2.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0 0 12 2.25Z"
  }));
}
const CZ = /* @__PURE__ */ s.forwardRef(xZ);
function EZ({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.75 2.994v2.25m10.5-2.25v2.25m-14.252 13.5V7.491a2.25 2.25 0 0 1 2.25-2.25h13.5a2.25 2.25 0 0 1 2.25 2.25v11.251m-18 0a2.25 2.25 0 0 0 2.25 2.25h13.5a2.25 2.25 0 0 0 2.25-2.25m-18 0v-7.5a2.25 2.25 0 0 1 2.25-2.25h13.5a2.25 2.25 0 0 1 2.25 2.25v7.5m-6.75-6h2.25m-9 2.25h4.5m.002-2.25h.005v.006H12v-.006Zm-.001 4.5h.006v.006h-.006v-.005Zm-2.25.001h.005v.006H9.75v-.006Zm-2.25 0h.005v.005h-.006v-.005Zm6.75-2.247h.005v.005h-.005v-.005Zm0 2.247h.006v.006h-.006v-.006Zm2.25-2.248h.006V15H16.5v-.005Z"
  }));
}
const SZ = /* @__PURE__ */ s.forwardRef(EZ);
function RZ({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"
  }));
}
const MZ = /* @__PURE__ */ s.forwardRef(RZ);
function AZ({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
  }));
}
const kZ = /* @__PURE__ */ s.forwardRef(AZ);
function LZ({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.827 6.175A2.31 2.31 0 0 1 5.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 0 0-1.134-.175 2.31 2.31 0 0 1-1.64-1.055l-.822-1.316a2.192 2.192 0 0 0-1.736-1.039 48.774 48.774 0 0 0-5.232 0 2.192 2.192 0 0 0-1.736 1.039l-.821 1.316Z"
  }), /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.5 12.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM18.75 10.5h.008v.008h-.008V10.5Z"
  }));
}
const TZ = /* @__PURE__ */ s.forwardRef(LZ);
function OZ({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0 0 20.25 18V6A2.25 2.25 0 0 0 18 3.75H6A2.25 2.25 0 0 0 3.75 6v12A2.25 2.25 0 0 0 6 20.25Z"
  }));
}
const IZ = /* @__PURE__ */ s.forwardRef(OZ);
function PZ({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z"
  }));
}
const DZ = /* @__PURE__ */ s.forwardRef(PZ);
function NZ({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.5 6a7.5 7.5 0 1 0 7.5 7.5h-7.5V6Z"
  }), /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.5 10.5H21A7.5 7.5 0 0 0 13.5 3v7.5Z"
  }));
}
const BZ = /* @__PURE__ */ s.forwardRef(NZ);
function FZ({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
  }));
}
const $Z = /* @__PURE__ */ s.forwardRef(FZ);
function VZ({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.068.157 2.148.279 3.238.364.466.037.893.281 1.153.671L12 21l2.652-3.978c.26-.39.687-.634 1.153-.67 1.09-.086 2.17-.208 3.238-.365 1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
  }));
}
const ZZ = /* @__PURE__ */ s.forwardRef(VZ);
function HZ({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.625 9.75a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 0 1 .778-.332 48.294 48.294 0 0 0 5.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
  }));
}
const jZ = /* @__PURE__ */ s.forwardRef(HZ);
function WZ({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 0 1-.825-.242m9.345-8.334a2.126 2.126 0 0 0-.476-.095 48.64 48.64 0 0 0-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0 0 11.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155"
  }));
}
const zZ = /* @__PURE__ */ s.forwardRef(WZ);
function GZ({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.076-4.076a1.526 1.526 0 0 1 1.037-.443 48.282 48.282 0 0 0 5.68-.494c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
  }));
}
const UZ = /* @__PURE__ */ s.forwardRef(GZ);
function YZ({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 0 1-2.555-.337A5.972 5.972 0 0 1 5.41 20.97a5.969 5.969 0 0 1-.474-.065 4.48 4.48 0 0 0 .978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25Z"
  }));
}
const XZ = /* @__PURE__ */ s.forwardRef(YZ);
function qZ({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 20.25c4.97 0 9-3.694 9-8.25s-4.03-8.25-9-8.25S3 7.444 3 12c0 2.104.859 4.023 2.273 5.48.432.447.74 1.04.586 1.641a4.483 4.483 0 0 1-.923 1.785A5.969 5.969 0 0 0 6 21c1.282 0 2.47-.402 3.445-1.087.81.22 1.668.337 2.555.337Z"
  }));
}
const KZ = /* @__PURE__ */ s.forwardRef(qZ);
function QZ({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z"
  }));
}
const JZ = /* @__PURE__ */ s.forwardRef(QZ);
function eH({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
  }));
}
const tH = /* @__PURE__ */ s.forwardRef(eH);
function rH({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m4.5 12.75 6 6 9-13.5"
  }));
}
const nH = /* @__PURE__ */ s.forwardRef(rH);
function aH({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m4.5 5.25 7.5 7.5 7.5-7.5m-15 6 7.5 7.5 7.5-7.5"
  }));
}
const oH = /* @__PURE__ */ s.forwardRef(aH);
function iH({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m18.75 4.5-7.5 7.5 7.5 7.5m-6-15L5.25 12l7.5 7.5"
  }));
}
const lH = /* @__PURE__ */ s.forwardRef(iH);
function sH({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5"
  }));
}
const cH = /* @__PURE__ */ s.forwardRef(sH);
function uH({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m4.5 18.75 7.5-7.5 7.5 7.5"
  }), /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m4.5 12.75 7.5-7.5 7.5 7.5"
  }));
}
const dH = /* @__PURE__ */ s.forwardRef(uH);
function fH({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m19.5 8.25-7.5 7.5-7.5-7.5"
  }));
}
const hH = /* @__PURE__ */ s.forwardRef(fH);
function vH({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 19.5 8.25 12l7.5-7.5"
  }));
}
const pH = /* @__PURE__ */ s.forwardRef(vH);
function gH({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m8.25 4.5 7.5 7.5-7.5 7.5"
  }));
}
const mH = /* @__PURE__ */ s.forwardRef(gH);
function wH({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
  }));
}
const yH = /* @__PURE__ */ s.forwardRef(wH);
function bH({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m4.5 15.75 7.5-7.5 7.5 7.5"
  }));
}
const _H = /* @__PURE__ */ s.forwardRef(bH);
function xH({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125"
  }));
}
const CH = /* @__PURE__ */ s.forwardRef(xH);
function EH({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0 1 18 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3 1.5 1.5 3-3.75"
  }));
}
const SH = /* @__PURE__ */ s.forwardRef(EH);
function RH({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z"
  }));
}
const MH = /* @__PURE__ */ s.forwardRef(RH);
function AH({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5A3.375 3.375 0 0 0 6.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0 0 15 2.25h-1.5a2.251 2.251 0 0 0-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 0 0-9-9Z"
  }));
}
const kH = /* @__PURE__ */ s.forwardRef(AH);
function LH({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184"
  }));
}
const TH = /* @__PURE__ */ s.forwardRef(LH);
function OH({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
  }));
}
const IH = /* @__PURE__ */ s.forwardRef(OH);
function PH({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 9.75v6.75m0 0-3-3m3 3 3-3m-8.25 6a4.5 4.5 0 0 1-1.41-8.775 5.25 5.25 0 0 1 10.233-2.33 3 3 0 0 1 3.758 3.848A3.752 3.752 0 0 1 18 19.5H6.75Z"
  }));
}
const DH = /* @__PURE__ */ s.forwardRef(PH);
function NH({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 16.5V9.75m0 0 3 3m-3-3-3 3M6.75 19.5a4.5 4.5 0 0 1-1.41-8.775 5.25 5.25 0 0 1 10.233-2.33 3 3 0 0 1 3.758 3.848A3.752 3.752 0 0 1 18 19.5H6.75Z"
  }));
}
const BH = /* @__PURE__ */ s.forwardRef(NH);
function FH({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 15a4.5 4.5 0 0 0 4.5 4.5H18a3.75 3.75 0 0 0 1.332-7.257 3 3 0 0 0-3.758-3.848 5.25 5.25 0 0 0-10.233 2.33A4.502 4.502 0 0 0 2.25 15Z"
  }));
}
const $H = /* @__PURE__ */ s.forwardRef(FH);
function VH({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.25 9.75 16.5 12l-2.25 2.25m-4.5 0L7.5 12l2.25-2.25M6 20.25h12A2.25 2.25 0 0 0 20.25 18V6A2.25 2.25 0 0 0 18 3.75H6A2.25 2.25 0 0 0 3.75 6v12A2.25 2.25 0 0 0 6 20.25Z"
  }));
}
const ZH = /* @__PURE__ */ s.forwardRef(VH);
function HH({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.25 6.75 22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3-4.5 16.5"
  }));
}
const jH = /* @__PURE__ */ s.forwardRef(HH);
function WH({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z"
  }), /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
  }));
}
const zH = /* @__PURE__ */ s.forwardRef(WH);
function GH({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 0 1 1.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.559.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.894.149c-.424.07-.764.383-.929.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 0 1-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.398.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 0 1-.12-1.45l.527-.737c.25-.35.272-.806.108-1.204-.165-.397-.506-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.108-1.204l-.526-.738a1.125 1.125 0 0 1 .12-1.45l.773-.773a1.125 1.125 0 0 1 1.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894Z"
  }), /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
  }));
}
const UH = /* @__PURE__ */ s.forwardRef(GH);
function YH({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.5 12a7.5 7.5 0 0 0 15 0m-15 0a7.5 7.5 0 1 1 15 0m-15 0H3m16.5 0H21m-1.5 0H12m-8.457 3.077 1.41-.513m14.095-5.13 1.41-.513M5.106 17.785l1.15-.964m11.49-9.642 1.149-.964M7.501 19.795l.75-1.3m7.5-12.99.75-1.3m-6.063 16.658.26-1.477m2.605-14.772.26-1.477m0 17.726-.26-1.477M10.698 4.614l-.26-1.477M16.5 19.794l-.75-1.299M7.5 4.205 12 12m6.894 5.785-1.149-.964M6.256 7.178l-1.15-.964m15.352 8.864-1.41-.513M4.954 9.435l-1.41-.514M12.002 12l-3.75 6.495"
  }));
}
const XH = /* @__PURE__ */ s.forwardRef(YH);
function qH({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m6.75 7.5 3 2.25-3 2.25m4.5 0h3m-9 8.25h13.5A2.25 2.25 0 0 0 21 18V6a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 6v12a2.25 2.25 0 0 0 2.25 2.25Z"
  }));
}
const KH = /* @__PURE__ */ s.forwardRef(qH);
function QH({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 17.25v1.007a3 3 0 0 1-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0 1 15 18.257V17.25m6-12V15a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 15V5.25m18 0A2.25 2.25 0 0 0 18.75 3H5.25A2.25 2.25 0 0 0 3 5.25m18 0V12a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 12V5.25"
  }));
}
const JH = /* @__PURE__ */ s.forwardRef(QH);
function ej({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.25 3v1.5M4.5 8.25H3m18 0h-1.5M4.5 12H3m18 0h-1.5m-15 3.75H3m18 0h-1.5M8.25 19.5V21M12 3v1.5m0 15V21m3.75-18v1.5m0 15V21m-9-1.5h10.5a2.25 2.25 0 0 0 2.25-2.25V6.75a2.25 2.25 0 0 0-2.25-2.25H6.75A2.25 2.25 0 0 0 4.5 6.75v10.5a2.25 2.25 0 0 0 2.25 2.25Zm.75-12h9v9h-9v-9Z"
  }));
}
const tj = /* @__PURE__ */ s.forwardRef(ej);
function rj({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z"
  }));
}
const nj = /* @__PURE__ */ s.forwardRef(rj);
function aj({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m21 7.5-2.25-1.313M21 7.5v2.25m0-2.25-2.25 1.313M3 7.5l2.25-1.313M3 7.5l2.25 1.313M3 7.5v2.25m9 3 2.25-1.313M12 12.75l-2.25-1.313M12 12.75V15m0 6.75 2.25-1.313M12 21.75V19.5m0 2.25-2.25-1.313m0-16.875L12 2.25l2.25 1.313M21 14.25v2.25l-2.25 1.313m-13.5 0L3 16.5v-2.25"
  }));
}
const oj = /* @__PURE__ */ s.forwardRef(aj);
function ij({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m21 7.5-9-5.25L3 7.5m18 0-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9"
  }));
}
const lj = /* @__PURE__ */ s.forwardRef(ij);
function sj({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m8.25 7.5.415-.207a.75.75 0 0 1 1.085.67V10.5m0 0h6m-6 0h-1.5m1.5 0v5.438c0 .354.161.697.473.865a3.751 3.751 0 0 0 5.452-2.553c.083-.409-.263-.75-.68-.75h-.745M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
  }));
}
const cj = /* @__PURE__ */ s.forwardRef(sj);
function uj({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
  }));
}
const dj = /* @__PURE__ */ s.forwardRef(uj);
function fj({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.25 7.756a4.5 4.5 0 1 0 0 8.488M7.5 10.5h5.25m-5.25 3h5.25M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
  }));
}
const hj = /* @__PURE__ */ s.forwardRef(fj);
function vj({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.121 7.629A3 3 0 0 0 9.017 9.43c-.023.212-.002.425.028.636l.506 3.541a4.5 4.5 0 0 1-.43 2.65L9 16.5l1.539-.513a2.25 2.25 0 0 1 1.422 0l.655.218a2.25 2.25 0 0 0 1.718-.122L15 15.75M8.25 12H12m9 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
  }));
}
const pj = /* @__PURE__ */ s.forwardRef(vj);
function gj({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 8.25H9m6 3H9m3 6-3-3h1.5a3 3 0 1 0 0-6M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
  }));
}
const mj = /* @__PURE__ */ s.forwardRef(gj);
function wj({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m9 7.5 3 4.5m0 0 3-4.5M12 12v5.25M15 12H9m6 3H9m12-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
  }));
}
const yj = /* @__PURE__ */ s.forwardRef(wj);
function bj({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.042 21.672 13.684 16.6m0 0-2.51 2.225.569-9.47 5.227 7.917-3.286-.672ZM12 2.25V4.5m5.834.166-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243-1.59-1.59"
  }));
}
const _j = /* @__PURE__ */ s.forwardRef(bj);
function xj({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.042 21.672 13.684 16.6m0 0-2.51 2.225.569-9.47 5.227 7.917-3.286-.672Zm-7.518-.267A8.25 8.25 0 1 1 20.25 10.5M8.288 14.212A5.25 5.25 0 1 1 17.25 10.5"
  }));
}
const Cj = /* @__PURE__ */ s.forwardRef(xj);
function Ej({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.5 1.5H8.25A2.25 2.25 0 0 0 6 3.75v16.5a2.25 2.25 0 0 0 2.25 2.25h7.5A2.25 2.25 0 0 0 18 20.25V3.75a2.25 2.25 0 0 0-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3"
  }));
}
const Sj = /* @__PURE__ */ s.forwardRef(Ej);
function Rj({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.5 19.5h3m-6.75 2.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-15a2.25 2.25 0 0 0-2.25-2.25H6.75A2.25 2.25 0 0 0 4.5 4.5v15a2.25 2.25 0 0 0 2.25 2.25Z"
  }));
}
const Mj = /* @__PURE__ */ s.forwardRef(Rj);
function Aj({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.499 11.998h15m-7.5-6.75h.008v.008h-.008v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM12 18.751h.007v.007H12v-.007Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
  }));
}
const kj = /* @__PURE__ */ s.forwardRef(Aj);
function Lj({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m.75 12 3 3m0 0 3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
  }));
}
const Tj = /* @__PURE__ */ s.forwardRef(Lj);
function Oj({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m6.75 12-3-3m0 0-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
  }));
}
const Ij = /* @__PURE__ */ s.forwardRef(Oj);
function Pj({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25M9 16.5v.75m3-3v3M15 12v5.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
  }));
}
const Dj = /* @__PURE__ */ s.forwardRef(Pj);
function Nj({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.125 2.25h-4.5c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125v-9M10.125 2.25h.375a9 9 0 0 1 9 9v.375M10.125 2.25A3.375 3.375 0 0 1 13.5 5.625v1.5c0 .621.504 1.125 1.125 1.125h1.5a3.375 3.375 0 0 1 3.375 3.375M9 15l2.25 2.25L15 12"
  }));
}
const Bj = /* @__PURE__ */ s.forwardRef(Nj);
function Fj({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 8.25.22-.22a.75.75 0 0 1 1.28.53v6.441c0 .472.214.934.64 1.137a3.75 3.75 0 0 0 4.994-1.77c.205-.428-.152-.868-.627-.868h-.507m-6-2.25h7.5M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
  }));
}
const $j = /* @__PURE__ */ s.forwardRef(Fj);
function Vj({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m3.75 9v7.5m2.25-6.466a9.016 9.016 0 0 0-3.461-.203c-.536.072-.974.478-1.021 1.017a4.559 4.559 0 0 0-.018.402c0 .464.336.844.775.994l2.95 1.012c.44.15.775.53.775.994 0 .136-.006.27-.018.402-.047.539-.485.945-1.021 1.017a9.077 9.077 0 0 1-3.461-.203M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
  }));
}
const Zj = /* @__PURE__ */ s.forwardRef(Vj);
function Hj({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 11.625h4.5m-4.5 2.25h4.5m2.121 1.527c-1.171 1.464-3.07 1.464-4.242 0-1.172-1.465-1.172-3.84 0-5.304 1.171-1.464 3.07-1.464 4.242 0M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
  }));
}
const jj = /* @__PURE__ */ s.forwardRef(Hj);
function Wj({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m6.621 9.879a3 3 0 0 0-5.02 2.897l.164.609a4.5 4.5 0 0 1-.108 2.676l-.157.439.44-.22a2.863 2.863 0 0 1 2.185-.155c.72.24 1.507.184 2.186-.155L15 18M8.25 15.75H12m-1.5-13.5H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
  }));
}
const zj = /* @__PURE__ */ s.forwardRef(Wj);
function Gj({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 9h3.75m-4.5 2.625h4.5M12 18.75 9.75 16.5h.375a2.625 2.625 0 0 0 0-5.25H9.75m.75-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
  }));
}
const Uj = /* @__PURE__ */ s.forwardRef(Gj);
function Yj({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m1.5 9 2.25 3m0 0 2.25-3m-2.25 3v4.5M9.75 15h4.5m-4.5 2.25h4.5m-3.75-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
  }));
}
const Xj = /* @__PURE__ */ s.forwardRef(Yj);
function qj({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75"
  }));
}
const Kj = /* @__PURE__ */ s.forwardRef(qj);
function Qj({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m5.231 13.481L15 17.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v16.5c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Zm3.75 11.625a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
  }));
}
const Jj = /* @__PURE__ */ s.forwardRef(Qj);
function eW({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m6.75 12H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
  }));
}
const tW = /* @__PURE__ */ s.forwardRef(eW);
function rW({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m3.75 9v6m3-3H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
  }));
}
const nW = /* @__PURE__ */ s.forwardRef(rW);
function aW({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
  }));
}
const oW = /* @__PURE__ */ s.forwardRef(aW);
function iW({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
  }));
}
const lW = /* @__PURE__ */ s.forwardRef(iW);
function sW({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
  }));
}
const cW = /* @__PURE__ */ s.forwardRef(sW);
function uW({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM18.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
  }));
}
const dW = /* @__PURE__ */ s.forwardRef(uW);
function fW({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z"
  }));
}
const hW = /* @__PURE__ */ s.forwardRef(fW);
function vW({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21.75 9v.906a2.25 2.25 0 0 1-1.183 1.981l-6.478 3.488M2.25 9v.906a2.25 2.25 0 0 0 1.183 1.981l6.478 3.488m8.839 2.51-4.66-2.51m0 0-1.023-.55a2.25 2.25 0 0 0-2.134 0l-1.022.55m0 0-4.661 2.51m16.5 1.615a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V8.844a2.25 2.25 0 0 1 1.183-1.981l7.5-4.039a2.25 2.25 0 0 1 2.134 0l7.5 4.039a2.25 2.25 0 0 1 1.183 1.98V19.5Z"
  }));
}
const pW = /* @__PURE__ */ s.forwardRef(vW);
function gW({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
  }));
}
const mW = /* @__PURE__ */ s.forwardRef(gW);
function wW({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.499 8.248h15m-15 7.501h15"
  }));
}
const yW = /* @__PURE__ */ s.forwardRef(wW);
function bW({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
  }));
}
const _W = /* @__PURE__ */ s.forwardRef(bW);
function xW({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
  }));
}
const CW = /* @__PURE__ */ s.forwardRef(xW);
function EW({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m15 11.25 1.5 1.5.75-.75V8.758l2.276-.61a3 3 0 1 0-3.675-3.675l-.61 2.277H12l-.75.75 1.5 1.5M15 11.25l-8.47 8.47c-.34.34-.8.53-1.28.53s-.94.19-1.28.53l-.97.97-.75-.75.97-.97c.34-.34.53-.8.53-1.28s.19-.94.53-1.28L12.75 9M15 11.25 12.75 9"
  }));
}
const SW = /* @__PURE__ */ s.forwardRef(EW);
function RW({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
  }));
}
const MW = /* @__PURE__ */ s.forwardRef(RW);
function AW({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
  }), /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
  }));
}
const kW = /* @__PURE__ */ s.forwardRef(AW);
function LW({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.182 16.318A4.486 4.486 0 0 0 12.016 15a4.486 4.486 0 0 0-3.198 1.318M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Z"
  }));
}
const TW = /* @__PURE__ */ s.forwardRef(LW);
function OW({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.182 15.182a4.5 4.5 0 0 1-6.364 0M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Z"
  }));
}
const IW = /* @__PURE__ */ s.forwardRef(OW);
function PW({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h1.5C5.496 19.5 6 18.996 6 18.375m-3.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-1.5A1.125 1.125 0 0 1 18 18.375M20.625 4.5H3.375m17.25 0c.621 0 1.125.504 1.125 1.125M20.625 4.5h-1.5C18.504 4.5 18 5.004 18 5.625m3.75 0v1.5c0 .621-.504 1.125-1.125 1.125M3.375 4.5c-.621 0-1.125.504-1.125 1.125M3.375 4.5h1.5C5.496 4.5 6 5.004 6 5.625m-3.75 0v1.5c0 .621.504 1.125 1.125 1.125m0 0h1.5m-1.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m1.5-3.75C5.496 8.25 6 7.746 6 7.125v-1.5M4.875 8.25C5.496 8.25 6 8.754 6 9.375v1.5m0-5.25v5.25m0-5.25C6 5.004 6.504 4.5 7.125 4.5h9.75c.621 0 1.125.504 1.125 1.125m1.125 2.625h1.5m-1.5 0A1.125 1.125 0 0 1 18 7.125v-1.5m1.125 2.625c-.621 0-1.125.504-1.125 1.125v1.5m2.625-2.625c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125M18 5.625v5.25M7.125 12h9.75m-9.75 0A1.125 1.125 0 0 1 6 10.875M7.125 12C6.504 12 6 12.504 6 13.125m0-2.25C6 11.496 5.496 12 4.875 12M18 10.875c0 .621-.504 1.125-1.125 1.125M18 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m-12 5.25v-5.25m0 5.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125m-12 0v-1.5c0-.621-.504-1.125-1.125-1.125M18 18.375v-5.25m0 5.25v-1.5c0-.621.504-1.125 1.125-1.125M18 13.125v1.5c0 .621.504 1.125 1.125 1.125M18 13.125c0-.621.504-1.125 1.125-1.125M6 13.125v1.5c0 .621-.504 1.125-1.125 1.125M6 13.125C6 12.504 5.496 12 4.875 12m-1.5 0h1.5m-1.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M19.125 12h1.5m0 0c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h1.5m14.25 0h1.5"
  }));
}
const DW = /* @__PURE__ */ s.forwardRef(PW);
function NW({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.864 4.243A7.5 7.5 0 0 1 19.5 10.5c0 2.92-.556 5.709-1.568 8.268M5.742 6.364A7.465 7.465 0 0 0 4.5 10.5a7.464 7.464 0 0 1-1.15 3.993m1.989 3.559A11.209 11.209 0 0 0 8.25 10.5a3.75 3.75 0 1 1 7.5 0c0 .527-.021 1.049-.064 1.565M12 10.5a14.94 14.94 0 0 1-3.6 9.75m6.633-4.596a18.666 18.666 0 0 1-2.485 5.33"
  }));
}
const BW = /* @__PURE__ */ s.forwardRef(NW);
function FW({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.362 5.214A8.252 8.252 0 0 1 12 21 8.25 8.25 0 0 1 6.038 7.047 8.287 8.287 0 0 0 9 9.601a8.983 8.983 0 0 1 3.361-6.867 8.21 8.21 0 0 0 3 2.48Z"
  }), /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 18a3.75 3.75 0 0 0 .495-7.468 5.99 5.99 0 0 0-1.925 3.547 5.975 5.975 0 0 1-2.133-1.001A3.75 3.75 0 0 0 12 18Z"
  }));
}
const $W = /* @__PURE__ */ s.forwardRef(FW);
function VW({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 3v1.5M3 21v-6m0 0 2.77-.693a9 9 0 0 1 6.208.682l.108.054a9 9 0 0 0 6.086.71l3.114-.732a48.524 48.524 0 0 1-.005-10.499l-3.11.732a9 9 0 0 1-6.085-.711l-.108-.054a9 9 0 0 0-6.208-.682L3 4.5M3 15V4.5"
  }));
}
const ZW = /* @__PURE__ */ s.forwardRef(VW);
function HW({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m9 13.5 3 3m0 0 3-3m-3 3v-6m1.06-4.19-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z"
  }));
}
const jW = /* @__PURE__ */ s.forwardRef(HW);
function WW({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 13.5H9m4.06-7.19-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z"
  }));
}
const zW = /* @__PURE__ */ s.forwardRef(WW);
function GW({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 9.776c.112-.017.227-.026.344-.026h15.812c.117 0 .232.009.344.026m-16.5 0a2.25 2.25 0 0 0-1.883 2.542l.857 6a2.25 2.25 0 0 0 2.227 1.932H19.05a2.25 2.25 0 0 0 2.227-1.932l.857-6a2.25 2.25 0 0 0-1.883-2.542m-16.5 0V6A2.25 2.25 0 0 1 6 3.75h3.879a1.5 1.5 0 0 1 1.06.44l2.122 2.12a1.5 1.5 0 0 0 1.06.44H18A2.25 2.25 0 0 1 20.25 9v.776"
  }));
}
const UW = /* @__PURE__ */ s.forwardRef(GW);
function YW({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 10.5v6m3-3H9m4.06-7.19-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z"
  }));
}
const XW = /* @__PURE__ */ s.forwardRef(YW);
function qW({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 12.75V12A2.25 2.25 0 0 1 4.5 9.75h15A2.25 2.25 0 0 1 21.75 12v.75m-8.69-6.44-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z"
  }));
}
const KW = /* @__PURE__ */ s.forwardRef(qW);
function QW({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 8.689c0-.864.933-1.406 1.683-.977l7.108 4.061a1.125 1.125 0 0 1 0 1.954l-7.108 4.061A1.125 1.125 0 0 1 3 16.811V8.69ZM12.75 8.689c0-.864.933-1.406 1.683-.977l7.108 4.061a1.125 1.125 0 0 1 0 1.954l-7.108 4.061a1.125 1.125 0 0 1-1.683-.977V8.69Z"
  }));
}
const JW = /* @__PURE__ */ s.forwardRef(QW);
function ez({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z"
  }));
}
const tz = /* @__PURE__ */ s.forwardRef(ez);
function rz({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.75 8.25v7.5m6-7.5h-3V12m0 0v3.75m0-3.75H18M9.75 9.348c-1.03-1.464-2.698-1.464-3.728 0-1.03 1.465-1.03 3.84 0 5.304 1.03 1.464 2.699 1.464 3.728 0V12h-1.5M4.5 19.5h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z"
  }));
}
const nz = /* @__PURE__ */ s.forwardRef(rz);
function az({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 3.75v16.5M2.25 12h19.5M6.375 17.25a4.875 4.875 0 0 0 4.875-4.875V12m6.375 5.25a4.875 4.875 0 0 1-4.875-4.875V12m-9 8.25h16.5a1.5 1.5 0 0 0 1.5-1.5V5.25a1.5 1.5 0 0 0-1.5-1.5H3.75a1.5 1.5 0 0 0-1.5 1.5v13.5a1.5 1.5 0 0 0 1.5 1.5Zm12.621-9.44c-1.409 1.41-4.242 1.061-4.242 1.061s-.349-2.833 1.06-4.242a2.25 2.25 0 0 1 3.182 3.182ZM10.773 7.63c1.409 1.409 1.06 4.242 1.06 4.242S9 12.22 7.592 10.811a2.25 2.25 0 1 1 3.182-3.182Z"
  }));
}
const oz = /* @__PURE__ */ s.forwardRef(az);
function iz({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 11.25v8.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 1 0 9.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1 1 14.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z"
  }));
}
const lz = /* @__PURE__ */ s.forwardRef(iz);
function sz({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
  }));
}
const cz = /* @__PURE__ */ s.forwardRef(sz);
function uz({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m6.115 5.19.319 1.913A6 6 0 0 0 8.11 10.36L9.75 12l-.387.775c-.217.433-.132.956.21 1.298l1.348 1.348c.21.21.329.497.329.795v1.089c0 .426.24.815.622 1.006l.153.076c.433.217.956.132 1.298-.21l.723-.723a8.7 8.7 0 0 0 2.288-4.042 1.087 1.087 0 0 0-.358-1.099l-1.33-1.108c-.251-.21-.582-.299-.905-.245l-1.17.195a1.125 1.125 0 0 1-.98-.314l-.295-.295a1.125 1.125 0 0 1 0-1.591l.13-.132a1.125 1.125 0 0 1 1.3-.21l.603.302a.809.809 0 0 0 1.086-1.086L14.25 7.5l1.256-.837a4.5 4.5 0 0 0 1.528-1.732l.146-.292M6.115 5.19A9 9 0 1 0 17.18 4.64M6.115 5.19A8.965 8.965 0 0 1 12 3c1.929 0 3.716.607 5.18 1.64"
  }));
}
const dz = /* @__PURE__ */ s.forwardRef(uz);
function fz({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.75 3.03v.568c0 .334.148.65.405.864l1.068.89c.442.369.535 1.01.216 1.49l-.51.766a2.25 2.25 0 0 1-1.161.886l-.143.048a1.107 1.107 0 0 0-.57 1.664c.369.555.169 1.307-.427 1.605L9 13.125l.423 1.059a.956.956 0 0 1-1.652.928l-.679-.906a1.125 1.125 0 0 0-1.906.172L4.5 15.75l-.612.153M12.75 3.031a9 9 0 0 0-8.862 12.872M12.75 3.031a9 9 0 0 1 6.69 14.036m0 0-.177-.529A2.25 2.25 0 0 0 17.128 15H16.5l-.324-.324a1.453 1.453 0 0 0-2.328.377l-.036.073a1.586 1.586 0 0 1-.982.816l-.99.282c-.55.157-.894.702-.8 1.267l.073.438c.08.474.49.821.97.821.846 0 1.598.542 1.865 1.345l.215.643m5.276-3.67a9.012 9.012 0 0 1-5.276 3.67m0 0a9 9 0 0 1-10.275-4.835M15.75 9c0 .896-.393 1.7-1.016 2.25"
  }));
}
const hz = /* @__PURE__ */ s.forwardRef(fz);
function vz({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m20.893 13.393-1.135-1.135a2.252 2.252 0 0 1-.421-.585l-1.08-2.16a.414.414 0 0 0-.663-.107.827.827 0 0 1-.812.21l-1.273-.363a.89.89 0 0 0-.738 1.595l.587.39c.59.395.674 1.23.172 1.732l-.2.2c-.212.212-.33.498-.33.796v.41c0 .409-.11.809-.32 1.158l-1.315 2.191a2.11 2.11 0 0 1-1.81 1.025 1.055 1.055 0 0 1-1.055-1.055v-1.172c0-.92-.56-1.747-1.414-2.089l-.655-.261a2.25 2.25 0 0 1-1.383-2.46l.007-.042a2.25 2.25 0 0 1 .29-.787l.09-.15a2.25 2.25 0 0 1 2.37-1.048l1.178.236a1.125 1.125 0 0 0 1.302-.795l.208-.73a1.125 1.125 0 0 0-.578-1.315l-.665-.332-.091.091a2.25 2.25 0 0 1-1.591.659h-.18c-.249 0-.487.1-.662.274a.931.931 0 0 1-1.458-1.137l1.411-2.353a2.25 2.25 0 0 0 .286-.76m11.928 9.869A9 9 0 0 0 8.965 3.525m11.928 9.868A9 9 0 1 1 8.965 3.525"
  }));
}
const pz = /* @__PURE__ */ s.forwardRef(vz);
function gz({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.243 4.493v7.5m0 0v7.502m0-7.501h10.5m0-7.5v7.5m0 0v7.501m4.501-8.627 2.25-1.5v10.126m0 0h-2.25m2.25 0h2.25"
  }));
}
const mz = /* @__PURE__ */ s.forwardRef(gz);
function wz({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21.75 19.5H16.5v-1.609a2.25 2.25 0 0 1 1.244-2.012l2.89-1.445c.651-.326 1.116-.955 1.116-1.683 0-.498-.04-.987-.118-1.463-.135-.825-.835-1.422-1.668-1.489a15.202 15.202 0 0 0-3.464.12M2.243 4.492v7.5m0 0v7.502m0-7.501h10.5m0-7.5v7.5m0 0v7.501"
  }));
}
const yz = /* @__PURE__ */ s.forwardRef(wz);
function bz({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.905 14.626a4.52 4.52 0 0 1 .738 3.603c-.154.695-.794 1.143-1.504 1.208a15.194 15.194 0 0 1-3.639-.104m4.405-4.707a4.52 4.52 0 0 0 .738-3.603c-.154-.696-.794-1.144-1.504-1.209a15.19 15.19 0 0 0-3.639.104m4.405 4.708H18M2.243 4.493v7.5m0 0v7.502m0-7.501h10.5m0-7.5v7.5m0 0v7.501"
  }));
}
const _z = /* @__PURE__ */ s.forwardRef(bz);
function xz({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.05 4.575a1.575 1.575 0 1 0-3.15 0v3m3.15-3v-1.5a1.575 1.575 0 0 1 3.15 0v1.5m-3.15 0 .075 5.925m3.075.75V4.575m0 0a1.575 1.575 0 0 1 3.15 0V15M6.9 7.575a1.575 1.575 0 1 0-3.15 0v8.175a6.75 6.75 0 0 0 6.75 6.75h2.018a5.25 5.25 0 0 0 3.712-1.538l1.732-1.732a5.25 5.25 0 0 0 1.538-3.712l.003-2.024a.668.668 0 0 1 .198-.471 1.575 1.575 0 1 0-2.228-2.228 3.818 3.818 0 0 0-1.12 2.687M6.9 7.575V12m6.27 4.318A4.49 4.49 0 0 1 16.35 15m.002 0h-.002"
  }));
}
const Cz = /* @__PURE__ */ s.forwardRef(xz);
function Ez({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.498 15.25H4.372c-1.026 0-1.945-.694-2.054-1.715a12.137 12.137 0 0 1-.068-1.285c0-2.848.992-5.464 2.649-7.521C5.287 4.247 5.886 4 6.504 4h4.016a4.5 4.5 0 0 1 1.423.23l3.114 1.04a4.5 4.5 0 0 0 1.423.23h1.294M7.498 15.25c.618 0 .991.724.725 1.282A7.471 7.471 0 0 0 7.5 19.75 2.25 2.25 0 0 0 9.75 22a.75.75 0 0 0 .75-.75v-.633c0-.573.11-1.14.322-1.672.304-.76.93-1.33 1.653-1.715a9.04 9.04 0 0 0 2.86-2.4c.498-.634 1.226-1.08 2.032-1.08h.384m-10.253 1.5H9.7m8.075-9.75c.01.05.027.1.05.148.593 1.2.925 2.55.925 3.977 0 1.487-.36 2.89-.999 4.125m.023-8.25c-.076-.365.183-.75.575-.75h.908c.889 0 1.713.518 1.972 1.368.339 1.11.521 2.287.521 3.507 0 1.553-.295 3.036-.831 4.398-.306.774-1.086 1.227-1.918 1.227h-1.053c-.472 0-.745-.556-.5-.96a8.95 8.95 0 0 0 .303-.54"
  }));
}
const Sz = /* @__PURE__ */ s.forwardRef(Ez);
function Rz({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.633 10.25c.806 0 1.533-.446 2.031-1.08a9.041 9.041 0 0 1 2.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 0 0 .322-1.672V2.75a.75.75 0 0 1 .75-.75 2.25 2.25 0 0 1 2.25 2.25c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282m0 0h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 0 1-2.649 7.521c-.388.482-.987.729-1.605.729H13.48c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 0 0-1.423-.23H5.904m10.598-9.75H14.25M5.904 18.5c.083.205.173.405.27.602.197.4-.078.898-.523.898h-.908c-.889 0-1.713-.518-1.972-1.368a12 12 0 0 1-.521-3.507c0-1.553.295-3.036.831-4.398C3.387 9.953 4.167 9.5 5 9.5h1.053c.472 0 .745.556.5.96a8.958 8.958 0 0 0-1.302 4.665c0 1.194.232 2.333.654 3.375Z"
  }));
}
const Mz = /* @__PURE__ */ s.forwardRef(Rz);
function Az({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.25 8.25h15m-16.5 7.5h15m-1.8-13.5-3.9 19.5m-2.1-19.5-3.9 19.5"
  }));
}
const kz = /* @__PURE__ */ s.forwardRef(Az);
function Lz({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"
  }));
}
const Tz = /* @__PURE__ */ s.forwardRef(Lz);
function Oz({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.25 21v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21m0 0h4.5V3.545M12.75 21h7.5V10.75M2.25 21h1.5m18 0h-18M2.25 9l4.5-1.636M18.75 3l-1.5.545m0 6.205 3 1m1.5.5-1.5-.5M6.75 7.364V3h-3v18m3-13.636 10.5-3.819"
  }));
}
const Iz = /* @__PURE__ */ s.forwardRef(Oz);
function Pz({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
  }));
}
const Dz = /* @__PURE__ */ s.forwardRef(Pz);
function Nz({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Zm6-10.125a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Zm1.294 6.336a6.721 6.721 0 0 1-3.17.789 6.721 6.721 0 0 1-3.168-.789 3.376 3.376 0 0 1 6.338 0Z"
  }));
}
const Bz = /* @__PURE__ */ s.forwardRef(Nz);
function Fz({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 3.75H6.912a2.25 2.25 0 0 0-2.15 1.588L2.35 13.177a2.25 2.25 0 0 0-.1.661V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 0 0-2.15-1.588H15M2.25 13.5h3.86a2.25 2.25 0 0 1 2.012 1.244l.256.512a2.25 2.25 0 0 0 2.013 1.244h3.218a2.25 2.25 0 0 0 2.013-1.244l.256-.512a2.25 2.25 0 0 1 2.013-1.244h3.859M12 3v8.25m0 0-3-3m3 3 3-3"
  }));
}
const $z = /* @__PURE__ */ s.forwardRef(Fz);
function Vz({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m7.875 14.25 1.214 1.942a2.25 2.25 0 0 0 1.908 1.058h2.006c.776 0 1.497-.4 1.908-1.058l1.214-1.942M2.41 9h4.636a2.25 2.25 0 0 1 1.872 1.002l.164.246a2.25 2.25 0 0 0 1.872 1.002h2.092a2.25 2.25 0 0 0 1.872-1.002l.164-.246A2.25 2.25 0 0 1 16.954 9h4.636M2.41 9a2.25 2.25 0 0 0-.16.832V12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 12V9.832c0-.287-.055-.57-.16-.832M2.41 9a2.25 2.25 0 0 1 .382-.632l3.285-3.832a2.25 2.25 0 0 1 1.708-.786h8.43c.657 0 1.281.287 1.709.786l3.284 3.832c.163.19.291.404.382.632M4.5 20.25h15A2.25 2.25 0 0 0 21.75 18v-2.625c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125V18a2.25 2.25 0 0 0 2.25 2.25Z"
  }));
}
const Zz = /* @__PURE__ */ s.forwardRef(Vz);
function Hz({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 13.5h3.86a2.25 2.25 0 0 1 2.012 1.244l.256.512a2.25 2.25 0 0 0 2.013 1.244h3.218a2.25 2.25 0 0 0 2.013-1.244l.256-.512a2.25 2.25 0 0 1 2.013-1.244h3.859m-19.5.338V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 0 0-2.15-1.588H6.911a2.25 2.25 0 0 0-2.15 1.588L2.35 13.177a2.25 2.25 0 0 0-.1.661Z"
  }));
}
const jz = /* @__PURE__ */ s.forwardRef(Hz);
function Wz({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
  }));
}
const zz = /* @__PURE__ */ s.forwardRef(Wz);
function Gz({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.248 20.246H9.05m0 0h3.696m-3.696 0 5.893-16.502m0 0h-3.697m3.697 0h3.803"
  }));
}
const Uz = /* @__PURE__ */ s.forwardRef(Gz);
function Yz({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 5.25a3 3 0 0 1 3 3m3 0a6 6 0 0 1-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1 1 21.75 8.25Z"
  }));
}
const Xz = /* @__PURE__ */ s.forwardRef(Yz);
function qz({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m10.5 21 5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 0 1 6-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 0 1-3.827-5.802"
  }));
}
const Kz = /* @__PURE__ */ s.forwardRef(qz);
function Qz({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.712 4.33a9.027 9.027 0 0 1 1.652 1.306c.51.51.944 1.064 1.306 1.652M16.712 4.33l-3.448 4.138m3.448-4.138a9.014 9.014 0 0 0-9.424 0M19.67 7.288l-4.138 3.448m4.138-3.448a9.014 9.014 0 0 1 0 9.424m-4.138-5.976a3.736 3.736 0 0 0-.88-1.388 3.737 3.737 0 0 0-1.388-.88m2.268 2.268a3.765 3.765 0 0 1 0 2.528m-2.268-4.796a3.765 3.765 0 0 0-2.528 0m4.796 4.796c-.181.506-.475.982-.88 1.388a3.736 3.736 0 0 1-1.388.88m2.268-2.268 4.138 3.448m0 0a9.027 9.027 0 0 1-1.306 1.652c-.51.51-1.064.944-1.652 1.306m0 0-3.448-4.138m3.448 4.138a9.014 9.014 0 0 1-9.424 0m5.976-4.138a3.765 3.765 0 0 1-2.528 0m0 0a3.736 3.736 0 0 1-1.388-.88 3.737 3.737 0 0 1-.88-1.388m2.268 2.268L7.288 19.67m0 0a9.024 9.024 0 0 1-1.652-1.306 9.027 9.027 0 0 1-1.306-1.652m0 0 4.138-3.448M4.33 16.712a9.014 9.014 0 0 1 0-9.424m4.138 5.976a3.765 3.765 0 0 1 0-2.528m0 0c.181-.506.475-.982.88-1.388a3.736 3.736 0 0 1 1.388-.88m-2.268 2.268L4.33 7.288m6.406 1.18L7.288 4.33m0 0a9.024 9.024 0 0 0-1.652 1.306A9.025 9.025 0 0 0 4.33 7.288"
  }));
}
const Jz = /* @__PURE__ */ s.forwardRef(Qz);
function eG({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 18v-5.25m0 0a6.01 6.01 0 0 0 1.5-.189m-1.5.189a6.01 6.01 0 0 1-1.5-.189m3.75 7.478a12.06 12.06 0 0 1-4.5 0m3.75 2.383a14.406 14.406 0 0 1-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 1 0-7.517 0c.85.493 1.509 1.333 1.509 2.316V18"
  }));
}
const tG = /* @__PURE__ */ s.forwardRef(eG);
function rG({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.181 8.68a4.503 4.503 0 0 1 1.903 6.405m-9.768-2.782L3.56 14.06a4.5 4.5 0 0 0 6.364 6.365l3.129-3.129m5.614-5.615 1.757-1.757a4.5 4.5 0 0 0-6.364-6.365l-4.5 4.5c-.258.26-.479.541-.661.84m1.903 6.405a4.495 4.495 0 0 1-1.242-.88 4.483 4.483 0 0 1-1.062-1.683m6.587 2.345 5.907 5.907m-5.907-5.907L8.898 8.898M2.991 2.99 8.898 8.9"
  }));
}
const nG = /* @__PURE__ */ s.forwardRef(rG);
function aG({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244"
  }));
}
const oG = /* @__PURE__ */ s.forwardRef(aG);
function iG({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
  }));
}
const lG = /* @__PURE__ */ s.forwardRef(iG);
function sG({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
  }));
}
const cG = /* @__PURE__ */ s.forwardRef(sG);
function uG({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.5 10.5V6.75a4.5 4.5 0 1 1 9 0v3.75M3.75 21.75h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H3.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
  }));
}
const dG = /* @__PURE__ */ s.forwardRef(uG);
function fG({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m15.75 15.75-2.489-2.489m0 0a3.375 3.375 0 1 0-4.773-4.773 3.375 3.375 0 0 0 4.774 4.774ZM21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
  }));
}
const hG = /* @__PURE__ */ s.forwardRef(fG);
function vG({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607ZM13.5 10.5h-6"
  }));
}
const pG = /* @__PURE__ */ s.forwardRef(vG);
function gG({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607ZM10.5 7.5v6m3-3h-6"
  }));
}
const mG = /* @__PURE__ */ s.forwardRef(gG);
function wG({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
  }));
}
const yG = /* @__PURE__ */ s.forwardRef(wG);
function bG({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
  }), /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
  }));
}
const _G = /* @__PURE__ */ s.forwardRef(bG);
function xG({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 6.75V15m6-6v8.25m.503 3.498 4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 0 0-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0Z"
  }));
}
const CG = /* @__PURE__ */ s.forwardRef(xG);
function EG({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.34 15.84c-.688-.06-1.386-.09-2.09-.09H7.5a4.5 4.5 0 1 1 0-9h.75c.704 0 1.402-.03 2.09-.09m0 9.18c.253.962.584 1.892.985 2.783.247.55.06 1.21-.463 1.511l-.657.38c-.551.318-1.26.117-1.527-.461a20.845 20.845 0 0 1-1.44-4.282m3.102.069a18.03 18.03 0 0 1-.59-4.59c0-1.586.205-3.124.59-4.59m0 9.18a23.848 23.848 0 0 1 8.835 2.535M10.34 6.66a23.847 23.847 0 0 0 8.835-2.535m0 0A23.74 23.74 0 0 0 18.795 3m.38 1.125a23.91 23.91 0 0 1 1.014 5.395m-1.014 8.855c-.118.38-.245.754-.38 1.125m.38-1.125a23.91 23.91 0 0 0 1.014-5.395m0-3.46c.495.413.811 1.035.811 1.73 0 .695-.316 1.317-.811 1.73m0-3.46a24.347 24.347 0 0 1 0 3.46"
  }));
}
const SG = /* @__PURE__ */ s.forwardRef(EG);
function RG({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 18.75a6 6 0 0 0 6-6v-1.5m-6 7.5a6 6 0 0 1-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 0 1-3-3V4.5a3 3 0 1 1 6 0v8.25a3 3 0 0 1-3 3Z"
  }));
}
const MG = /* @__PURE__ */ s.forwardRef(RG);
function AG({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 12H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
  }));
}
const kG = /* @__PURE__ */ s.forwardRef(AG);
function LG({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18 12H6"
  }));
}
const TG = /* @__PURE__ */ s.forwardRef(LG);
function OG({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5 12h14"
  }));
}
const IG = /* @__PURE__ */ s.forwardRef(OG);
function PG({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z"
  }));
}
const DG = /* @__PURE__ */ s.forwardRef(PG);
function NG({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m9 9 10.5-3m0 6.553v3.75a2.25 2.25 0 0 1-1.632 2.163l-1.32.377a1.803 1.803 0 1 1-.99-3.467l2.31-.66a2.25 2.25 0 0 0 1.632-2.163Zm0 0V2.25L9 5.25v10.303m0 0v3.75a2.25 2.25 0 0 1-1.632 2.163l-1.32.377a1.803 1.803 0 0 1-.99-3.467l2.31-.66A2.25 2.25 0 0 0 9 15.553Z"
  }));
}
const BG = /* @__PURE__ */ s.forwardRef(NG);
function FG({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 0 1-2.25 2.25M16.5 7.5V18a2.25 2.25 0 0 0 2.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 0 0 2.25 2.25h13.5M6 7.5h3v3H6v-3Z"
  }));
}
const $G = /* @__PURE__ */ s.forwardRef(FG);
function VG({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.364 18.364A9 9 0 0 0 5.636 5.636m12.728 12.728A9 9 0 0 1 5.636 5.636m12.728 12.728L5.636 5.636"
  }));
}
const ZG = /* @__PURE__ */ s.forwardRef(VG);
function HG({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.242 5.992h12m-12 6.003H20.24m-12 5.999h12M4.117 7.495v-3.75H2.99m1.125 3.75H2.99m1.125 0H5.24m-1.92 2.577a1.125 1.125 0 1 1 1.591 1.59l-1.83 1.83h2.16M2.99 15.745h1.125a1.125 1.125 0 0 1 0 2.25H3.74m0-.002h.375a1.125 1.125 0 0 1 0 2.25H2.99"
  }));
}
const jG = /* @__PURE__ */ s.forwardRef(HG);
function WG({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.53 16.122a3 3 0 0 0-5.78 1.128 2.25 2.25 0 0 1-2.4 2.245 4.5 4.5 0 0 0 8.4-2.245c0-.399-.078-.78-.22-1.128Zm0 0a15.998 15.998 0 0 0 3.388-1.62m-5.043-.025a15.994 15.994 0 0 1 1.622-3.395m3.42 3.42a15.995 15.995 0 0 0 4.764-4.648l3.876-5.814a1.151 1.151 0 0 0-1.597-1.597L14.146 6.32a15.996 15.996 0 0 0-4.649 4.763m3.42 3.42a6.776 6.776 0 0 0-3.42-3.42"
  }));
}
const zG = /* @__PURE__ */ s.forwardRef(WG);
function GG({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"
  }));
}
const UG = /* @__PURE__ */ s.forwardRef(GG);
function YG({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13"
  }));
}
const XG = /* @__PURE__ */ s.forwardRef(YG);
function qG({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.25 9v6m-4.5 0V9M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
  }));
}
const KG = /* @__PURE__ */ s.forwardRef(qG);
function QG({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 5.25v13.5m-7.5-13.5v13.5"
  }));
}
const JG = /* @__PURE__ */ s.forwardRef(QG);
function eU({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
  }));
}
const tU = /* @__PURE__ */ s.forwardRef(eU);
function rU({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"
  }));
}
const nU = /* @__PURE__ */ s.forwardRef(rU);
function aU({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m8.99 14.993 6-6m6 3.001c0 1.268-.63 2.39-1.593 3.069a3.746 3.746 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043 3.745 3.745 0 0 1-3.068 1.593c-1.268 0-2.39-.63-3.068-1.593a3.745 3.745 0 0 1-3.296-1.043 3.746 3.746 0 0 1-1.043-3.297 3.746 3.746 0 0 1-1.593-3.068c0-1.268.63-2.39 1.593-3.068a3.746 3.746 0 0 1 1.043-3.297 3.745 3.745 0 0 1 3.296-1.042 3.745 3.745 0 0 1 3.068-1.594c1.268 0 2.39.63 3.068 1.593a3.745 3.745 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.297 3.746 3.746 0 0 1 1.593 3.068ZM9.74 9.743h.008v.007H9.74v-.007Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm4.125 4.5h.008v.008h-.008v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
  }));
}
const oU = /* @__PURE__ */ s.forwardRef(aU);
function iU({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.25 9.75v-4.5m0 4.5h4.5m-4.5 0 6-6m-3 18c-8.284 0-15-6.716-15-15V4.5A2.25 2.25 0 0 1 4.5 2.25h1.372c.516 0 .966.351 1.091.852l1.106 4.423c.11.44-.054.902-.417 1.173l-1.293.97a1.062 1.062 0 0 0-.38 1.21 12.035 12.035 0 0 0 7.143 7.143c.441.162.928-.004 1.21-.38l.97-1.293a1.125 1.125 0 0 1 1.173-.417l4.423 1.106c.5.125.852.575.852 1.091V19.5a2.25 2.25 0 0 1-2.25 2.25h-2.25Z"
  }));
}
const lU = /* @__PURE__ */ s.forwardRef(iU);
function sU({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.25 3.75v4.5m0-4.5h-4.5m4.5 0-6 6m3 12c-8.284 0-15-6.716-15-15V4.5A2.25 2.25 0 0 1 4.5 2.25h1.372c.516 0 .966.351 1.091.852l1.106 4.423c.11.44-.054.902-.417 1.173l-1.293.97a1.062 1.062 0 0 0-.38 1.21 12.035 12.035 0 0 0 7.143 7.143c.441.162.928-.004 1.21-.38l.97-1.293a1.125 1.125 0 0 1 1.173-.417l4.423 1.106c.5.125.852.575.852 1.091V19.5a2.25 2.25 0 0 1-2.25 2.25h-2.25Z"
  }));
}
const cU = /* @__PURE__ */ s.forwardRef(sU);
function uU({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 3.75 18 6m0 0 2.25 2.25M18 6l2.25-2.25M18 6l-2.25 2.25m1.5 13.5c-8.284 0-15-6.716-15-15V4.5A2.25 2.25 0 0 1 4.5 2.25h1.372c.516 0 .966.351 1.091.852l1.106 4.423c.11.44-.054.902-.417 1.173l-1.293.97a1.062 1.062 0 0 0-.38 1.21 12.035 12.035 0 0 0 7.143 7.143c.441.162.928-.004 1.21-.38l.97-1.293a1.125 1.125 0 0 1 1.173-.417l4.423 1.106c.5.125.852.575.852 1.091V19.5a2.25 2.25 0 0 1-2.25 2.25h-2.25Z"
  }));
}
const dU = /* @__PURE__ */ s.forwardRef(uU);
function fU({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z"
  }));
}
const hU = /* @__PURE__ */ s.forwardRef(fU);
function vU({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
  }));
}
const pU = /* @__PURE__ */ s.forwardRef(vU);
function gU({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
  }), /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.91 11.672a.375.375 0 0 1 0 .656l-5.603 3.113a.375.375 0 0 1-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112Z"
  }));
}
const mU = /* @__PURE__ */ s.forwardRef(gU);
function wU({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 7.5V18M15 7.5V18M3 16.811V8.69c0-.864.933-1.406 1.683-.977l7.108 4.061a1.125 1.125 0 0 1 0 1.954l-7.108 4.061A1.125 1.125 0 0 1 3 16.811Z"
  }));
}
const yU = /* @__PURE__ */ s.forwardRef(wU);
function bU({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.347a1.125 1.125 0 0 1 0 1.972l-11.54 6.347a1.125 1.125 0 0 1-1.667-.986V5.653Z"
  }));
}
const _U = /* @__PURE__ */ s.forwardRef(bU);
function xU({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
  }));
}
const CU = /* @__PURE__ */ s.forwardRef(xU);
function EU({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 6v12m6-6H6"
  }));
}
const SU = /* @__PURE__ */ s.forwardRef(EU);
function RU({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 4.5v15m7.5-7.5h-15"
  }));
}
const MU = /* @__PURE__ */ s.forwardRef(RU);
function AU({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.636 5.636a9 9 0 1 0 12.728 0M12 3v9"
  }));
}
const kU = /* @__PURE__ */ s.forwardRef(AU);
function LU({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 3v11.25A2.25 2.25 0 0 0 6 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0 1 18 16.5h-2.25m-7.5 0h7.5m-7.5 0-1 3m8.5-3 1 3m0 0 .5 1.5m-.5-1.5h-9.5m0 0-.5 1.5M9 11.25v1.5M12 9v3.75m3-6v6"
  }));
}
const TU = /* @__PURE__ */ s.forwardRef(LU);
function OU({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 3v11.25A2.25 2.25 0 0 0 6 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0 1 18 16.5h-2.25m-7.5 0h7.5m-7.5 0-1 3m8.5-3 1 3m0 0 .5 1.5m-.5-1.5h-9.5m0 0-.5 1.5m.75-9 3-3 2.148 2.148A12.061 12.061 0 0 1 16.5 7.605"
  }));
}
const IU = /* @__PURE__ */ s.forwardRef(OU);
function PU({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0 1 10.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0 .229 2.523a1.125 1.125 0 0 1-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0 0 21 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 0 0-1.913-.247M6.34 18H5.25A2.25 2.25 0 0 1 3 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 0 1 1.913-.247m10.5 0a48.536 48.536 0 0 0-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5Zm-3 0h.008v.008H15V10.5Z"
  }));
}
const DU = /* @__PURE__ */ s.forwardRef(PU);
function NU({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.25 6.087c0-.355.186-.676.401-.959.221-.29.349-.634.349-1.003 0-1.036-1.007-1.875-2.25-1.875s-2.25.84-2.25 1.875c0 .369.128.713.349 1.003.215.283.401.604.401.959v0a.64.64 0 0 1-.657.643 48.39 48.39 0 0 1-4.163-.3c.186 1.613.293 3.25.315 4.907a.656.656 0 0 1-.658.663v0c-.355 0-.676-.186-.959-.401a1.647 1.647 0 0 0-1.003-.349c-1.036 0-1.875 1.007-1.875 2.25s.84 2.25 1.875 2.25c.369 0 .713-.128 1.003-.349.283-.215.604-.401.959-.401v0c.31 0 .555.26.532.57a48.039 48.039 0 0 1-.642 5.056c1.518.19 3.058.309 4.616.354a.64.64 0 0 0 .657-.643v0c0-.355-.186-.676-.401-.959a1.647 1.647 0 0 1-.349-1.003c0-1.035 1.008-1.875 2.25-1.875 1.243 0 2.25.84 2.25 1.875 0 .369-.128.713-.349 1.003-.215.283-.4.604-.4.959v0c0 .333.277.599.61.58a48.1 48.1 0 0 0 5.427-.63 48.05 48.05 0 0 0 .582-4.717.532.532 0 0 0-.533-.57v0c-.355 0-.676.186-.959.401-.29.221-.634.349-1.003.349-1.035 0-1.875-1.007-1.875-2.25s.84-2.25 1.875-2.25c.37 0 .713.128 1.003.349.283.215.604.401.96.401v0a.656.656 0 0 0 .658-.663 48.422 48.422 0 0 0-.37-5.36c-1.886.342-3.81.574-5.766.689a.578.578 0 0 1-.61-.58v0Z"
  }));
}
const BU = /* @__PURE__ */ s.forwardRef(NU);
function FU({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 3.75 9.375v-4.5ZM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 0 1-1.125-1.125v-4.5ZM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 13.5 9.375v-4.5Z"
  }), /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.75 6.75h.75v.75h-.75v-.75ZM6.75 16.5h.75v.75h-.75v-.75ZM16.5 6.75h.75v.75h-.75v-.75ZM13.5 13.5h.75v.75h-.75v-.75ZM13.5 19.5h.75v.75h-.75v-.75ZM19.5 13.5h.75v.75h-.75v-.75ZM19.5 19.5h.75v.75h-.75v-.75ZM16.5 16.5h.75v.75h-.75v-.75Z"
  }));
}
const $U = /* @__PURE__ */ s.forwardRef(FU);
function VU({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z"
  }));
}
const ZU = /* @__PURE__ */ s.forwardRef(VU);
function HU({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 0 1 0 3.75H5.625a1.875 1.875 0 0 1 0-3.75Z"
  }));
}
const jU = /* @__PURE__ */ s.forwardRef(HU);
function WU({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m3.75 7.5 16.5-4.125M12 6.75c-2.708 0-5.363.224-7.948.655C2.999 7.58 2.25 8.507 2.25 9.574v9.176A2.25 2.25 0 0 0 4.5 21h15a2.25 2.25 0 0 0 2.25-2.25V9.574c0-1.067-.75-1.994-1.802-2.169A48.329 48.329 0 0 0 12 6.75Zm-1.683 6.443-.005.005-.006-.005.006-.005.005.005Zm-.005 2.127-.005-.006.005-.005.005.005-.005.005Zm-2.116-.006-.005.006-.006-.006.005-.005.006.005Zm-.005-2.116-.006-.005.006-.005.005.005-.005.005ZM9.255 10.5v.008h-.008V10.5h.008Zm3.249 1.88-.007.004-.003-.007.006-.003.004.006Zm-1.38 5.126-.003-.006.006-.004.004.007-.006.003Zm.007-6.501-.003.006-.007-.003.004-.007.006.004Zm1.37 5.129-.007-.004.004-.006.006.003-.004.007Zm.504-1.877h-.008v-.007h.008v.007ZM9.255 18v.008h-.008V18h.008Zm-3.246-1.87-.007.004L6 16.127l.006-.003.004.006Zm1.366-5.119-.004-.006.006-.004.004.007-.006.003ZM7.38 17.5l-.003.006-.007-.003.004-.007.006.004Zm-1.376-5.116L6 12.38l.003-.007.007.004-.004.007Zm-.5 1.873h-.008v-.007h.008v.007ZM17.25 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Zm0 4.5a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z"
  }));
}
const zU = /* @__PURE__ */ s.forwardRef(WU);
function GU({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m9 14.25 6-6m4.5-3.493V21.75l-3.75-1.5-3.75 1.5-3.75-1.5-3.75 1.5V4.757c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0c1.1.128 1.907 1.077 1.907 2.185ZM9.75 9h.008v.008H9.75V9Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm4.125 4.5h.008v.008h-.008V13.5Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
  }));
}
const UU = /* @__PURE__ */ s.forwardRef(GU);
function YU({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.25 9.75h4.875a2.625 2.625 0 0 1 0 5.25H12M8.25 9.75 10.5 7.5M8.25 9.75 10.5 12m9-7.243V21.75l-3.75-1.5-3.75 1.5-3.75-1.5-3.75 1.5V4.757c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0c1.1.128 1.907 1.077 1.907 2.185Z"
  }));
}
const XU = /* @__PURE__ */ s.forwardRef(YU);
function qU({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 7.125C2.25 6.504 2.754 6 3.375 6h6c.621 0 1.125.504 1.125 1.125v3.75c0 .621-.504 1.125-1.125 1.125h-6a1.125 1.125 0 0 1-1.125-1.125v-3.75ZM14.25 8.625c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v8.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125v-8.25ZM3.75 16.125c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125v-2.25Z"
  }));
}
const KU = /* @__PURE__ */ s.forwardRef(qU);
function QU({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 6.878V6a2.25 2.25 0 0 1 2.25-2.25h7.5A2.25 2.25 0 0 1 18 6v.878m-12 0c.235-.083.487-.128.75-.128h10.5c.263 0 .515.045.75.128m-12 0A2.25 2.25 0 0 0 4.5 9v.878m13.5-3A2.25 2.25 0 0 1 19.5 9v.878m0 0a2.246 2.246 0 0 0-.75-.128H5.25c-.263 0-.515.045-.75.128m15 0A2.25 2.25 0 0 1 21 12v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6c0-.98.626-1.813 1.5-2.122"
  }));
}
const JU = /* @__PURE__ */ s.forwardRef(QU);
function eY({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.59 14.37a6 6 0 0 1-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 0 0 6.16-12.12A14.98 14.98 0 0 0 9.631 8.41m5.96 5.96a14.926 14.926 0 0 1-5.841 2.58m-.119-8.54a6 6 0 0 0-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 0 0-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 0 1-2.448-2.448 14.9 14.9 0 0 1 .06-.312m-2.24 2.39a4.493 4.493 0 0 0-1.757 4.306 4.493 4.493 0 0 0 4.306-1.758M16.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
  }));
}
const tY = /* @__PURE__ */ s.forwardRef(eY);
function rY({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.75 19.5v-.75a7.5 7.5 0 0 0-7.5-7.5H4.5m0-6.75h.75c7.87 0 14.25 6.38 14.25 14.25v.75M6 18.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
  }));
}
const nY = /* @__PURE__ */ s.forwardRef(rY);
function aY({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 3v17.25m0 0c-1.472 0-2.882.265-4.185.75M12 20.25c1.472 0 2.882.265 4.185.75M18.75 4.97A48.416 48.416 0 0 0 12 4.5c-2.291 0-4.545.16-6.75.47m13.5 0c1.01.143 2.01.317 3 .52m-3-.52 2.62 10.726c.122.499-.106 1.028-.589 1.202a5.988 5.988 0 0 1-2.031.352 5.988 5.988 0 0 1-2.031-.352c-.483-.174-.711-.703-.59-1.202L18.75 4.971Zm-16.5.52c.99-.203 1.99-.377 3-.52m0 0 2.62 10.726c.122.499-.106 1.028-.589 1.202a5.989 5.989 0 0 1-2.031.352 5.989 5.989 0 0 1-2.031-.352c-.483-.174-.711-.703-.59-1.202L5.25 4.971Z"
  }));
}
const oY = /* @__PURE__ */ s.forwardRef(aY);
function iY({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m7.848 8.25 1.536.887M7.848 8.25a3 3 0 1 1-5.196-3 3 3 0 0 1 5.196 3Zm1.536.887a2.165 2.165 0 0 1 1.083 1.839c.005.351.054.695.14 1.024M9.384 9.137l2.077 1.199M7.848 15.75l1.536-.887m-1.536.887a3 3 0 1 1-5.196 3 3 3 0 0 1 5.196-3Zm1.536-.887a2.165 2.165 0 0 0 1.083-1.838c.005-.352.054-.695.14-1.025m-1.223 2.863 2.077-1.199m0-3.328a4.323 4.323 0 0 1 2.068-1.379l5.325-1.628a4.5 4.5 0 0 1 2.48-.044l.803.215-7.794 4.5m-2.882-1.664A4.33 4.33 0 0 0 10.607 12m3.736 0 7.794 4.5-.802.215a4.5 4.5 0 0 1-2.48-.043l-5.326-1.629a4.324 4.324 0 0 1-2.068-1.379M14.343 12l-2.882 1.664"
  }));
}
const lY = /* @__PURE__ */ s.forwardRef(iY);
function sY({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.25 14.25h13.5m-13.5 0a3 3 0 0 1-3-3m3 3a3 3 0 1 0 0 6h13.5a3 3 0 1 0 0-6m-16.5-3a3 3 0 0 1 3-3h13.5a3 3 0 0 1 3 3m-19.5 0a4.5 4.5 0 0 1 .9-2.7L5.737 5.1a3.375 3.375 0 0 1 2.7-1.35h7.126c1.062 0 2.062.5 2.7 1.35l2.587 3.45a4.5 4.5 0 0 1 .9 2.7m0 0a3 3 0 0 1-3 3m0 3h.008v.008h-.008v-.008Zm0-6h.008v.008h-.008v-.008Zm-3 6h.008v.008h-.008v-.008Zm0-6h.008v.008h-.008v-.008Z"
  }));
}
const cY = /* @__PURE__ */ s.forwardRef(sY);
function uY({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21.75 17.25v-.228a4.5 4.5 0 0 0-.12-1.03l-2.268-9.64a3.375 3.375 0 0 0-3.285-2.602H7.923a3.375 3.375 0 0 0-3.285 2.602l-2.268 9.64a4.5 4.5 0 0 0-.12 1.03v.228m19.5 0a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3m19.5 0a3 3 0 0 0-3-3H5.25a3 3 0 0 0-3 3m16.5 0h.008v.008h-.008v-.008Zm-3 0h.008v.008h-.008v-.008Z"
  }));
}
const dY = /* @__PURE__ */ s.forwardRef(uY);
function fY({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"
  }));
}
const hY = /* @__PURE__ */ s.forwardRef(fY);
function vY({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z"
  }));
}
const pY = /* @__PURE__ */ s.forwardRef(vY);
function gY({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 9v3.75m0-10.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.75c0 5.592 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.57-.598-3.75h-.152c-3.196 0-6.1-1.25-8.25-3.286Zm0 13.036h.008v.008H12v-.008Z"
  }));
}
const mY = /* @__PURE__ */ s.forwardRef(gY);
function wY({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 10.5V6a3.75 3.75 0 1 0-7.5 0v4.5m11.356-1.993 1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 0 1-1.12-1.243l1.264-12A1.125 1.125 0 0 1 5.513 7.5h12.974c.576 0 1.059.435 1.119 1.007ZM8.625 10.5a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm7.5 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
  }));
}
const yY = /* @__PURE__ */ s.forwardRef(wY);
function bY({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
  }));
}
const _Y = /* @__PURE__ */ s.forwardRef(bY);
function xY({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m3 3 8.735 8.735m0 0a.374.374 0 1 1 .53.53m-.53-.53.53.53m0 0L21 21M14.652 9.348a3.75 3.75 0 0 1 0 5.304m2.121-7.425a6.75 6.75 0 0 1 0 9.546m2.121-11.667c3.808 3.807 3.808 9.98 0 13.788m-9.546-4.242a3.733 3.733 0 0 1-1.06-2.122m-1.061 4.243a6.75 6.75 0 0 1-1.625-6.929m-.496 9.05c-3.068-3.067-3.664-7.67-1.79-11.334M12 12h.008v.008H12V12Z"
  }));
}
const CY = /* @__PURE__ */ s.forwardRef(xY);
function EY({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.348 14.652a3.75 3.75 0 0 1 0-5.304m5.304 0a3.75 3.75 0 0 1 0 5.304m-7.425 2.121a6.75 6.75 0 0 1 0-9.546m9.546 0a6.75 6.75 0 0 1 0 9.546M5.106 18.894c-3.808-3.807-3.808-9.98 0-13.788m13.788 0c3.808 3.807 3.808 9.98 0 13.788M12 12h.008v.008H12V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
  }));
}
const SY = /* @__PURE__ */ s.forwardRef(EY);
function RY({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m9 20.247 6-16.5"
  }));
}
const MY = /* @__PURE__ */ s.forwardRef(RY);
function AY({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
  }));
}
const kY = /* @__PURE__ */ s.forwardRef(AY);
function LY({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.114 5.636a9 9 0 0 1 0 12.728M16.463 8.288a5.25 5.25 0 0 1 0 7.424M6.75 8.25l4.72-4.72a.75.75 0 0 1 1.28.53v15.88a.75.75 0 0 1-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.009 9.009 0 0 1 2.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75Z"
  }));
}
const TY = /* @__PURE__ */ s.forwardRef(LY);
function OY({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.25 9.75 19.5 12m0 0 2.25 2.25M19.5 12l2.25-2.25M19.5 12l-2.25 2.25m-10.5-6 4.72-4.72a.75.75 0 0 1 1.28.53v15.88a.75.75 0 0 1-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.009 9.009 0 0 1 2.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75Z"
  }));
}
const IY = /* @__PURE__ */ s.forwardRef(OY);
function PY({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.5 8.25V6a2.25 2.25 0 0 0-2.25-2.25H6A2.25 2.25 0 0 0 3.75 6v8.25A2.25 2.25 0 0 0 6 16.5h2.25m8.25-8.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-7.5A2.25 2.25 0 0 1 8.25 18v-1.5m8.25-8.25h-6a2.25 2.25 0 0 0-2.25 2.25v6"
  }));
}
const DY = /* @__PURE__ */ s.forwardRef(PY);
function NY({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.429 9.75 2.25 12l4.179 2.25m0-4.5 5.571 3 5.571-3m-11.142 0L2.25 7.5 12 2.25l9.75 5.25-4.179 2.25m0 0L21.75 12l-4.179 2.25m0 0 4.179 2.25L12 21.75 2.25 16.5l4.179-2.25m11.142 0-5.571 3-5.571-3"
  }));
}
const BY = /* @__PURE__ */ s.forwardRef(NY);
function FY({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V6ZM3.75 15.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18v-2.25ZM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25V6ZM13.5 15.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25A2.25 2.25 0 0 1 13.5 18v-2.25Z"
  }));
}
const $Y = /* @__PURE__ */ s.forwardRef(FY);
function VY({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.5 16.875h3.375m0 0h3.375m-3.375 0V13.5m0 3.375v3.375M6 10.5h2.25a2.25 2.25 0 0 0 2.25-2.25V6a2.25 2.25 0 0 0-2.25-2.25H6A2.25 2.25 0 0 0 3.75 6v2.25A2.25 2.25 0 0 0 6 10.5Zm0 9.75h2.25A2.25 2.25 0 0 0 10.5 18v-2.25a2.25 2.25 0 0 0-2.25-2.25H6a2.25 2.25 0 0 0-2.25 2.25V18A2.25 2.25 0 0 0 6 20.25Zm9.75-9.75H18a2.25 2.25 0 0 0 2.25-2.25V6A2.25 2.25 0 0 0 18 3.75h-2.25A2.25 2.25 0 0 0 13.5 6v2.25a2.25 2.25 0 0 0 2.25 2.25Z"
  }));
}
const ZY = /* @__PURE__ */ s.forwardRef(VY);
function HY({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z"
  }));
}
const jY = /* @__PURE__ */ s.forwardRef(HY);
function WY({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
  }), /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 9.563C9 9.252 9.252 9 9.563 9h4.874c.311 0 .563.252.563.563v4.874c0 .311-.252.563-.563.563H9.564A.562.562 0 0 1 9 14.437V9.564Z"
  }));
}
const zY = /* @__PURE__ */ s.forwardRef(WY);
function GY({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.25 7.5A2.25 2.25 0 0 1 7.5 5.25h9a2.25 2.25 0 0 1 2.25 2.25v9a2.25 2.25 0 0 1-2.25 2.25h-9a2.25 2.25 0 0 1-2.25-2.25v-9Z"
  }));
}
const UY = /* @__PURE__ */ s.forwardRef(GY);
function YY({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 12a8.912 8.912 0 0 1-.318-.079c-1.585-.424-2.904-1.247-3.76-2.236-.873-1.009-1.265-2.19-.968-3.301.59-2.2 3.663-3.29 6.863-2.432A8.186 8.186 0 0 1 16.5 5.21M6.42 17.81c.857.99 2.176 1.812 3.761 2.237 3.2.858 6.274-.23 6.863-2.431.233-.868.044-1.779-.465-2.617M3.75 12h16.5"
  }));
}
const XY = /* @__PURE__ */ s.forwardRef(YY);
function qY({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"
  }));
}
const KY = /* @__PURE__ */ s.forwardRef(qY);
function QY({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.098 19.902a3.75 3.75 0 0 0 5.304 0l6.401-6.402M6.75 21A3.75 3.75 0 0 1 3 17.25V4.125C3 3.504 3.504 3 4.125 3h5.25c.621 0 1.125.504 1.125 1.125v4.072M6.75 21a3.75 3.75 0 0 0 3.75-3.75V8.197M6.75 21h13.125c.621 0 1.125-.504 1.125-1.125v-5.25c0-.621-.504-1.125-1.125-1.125h-4.072M10.5 8.197l2.88-2.88c.438-.439 1.15-.439 1.59 0l3.712 3.713c.44.44.44 1.152 0 1.59l-2.879 2.88M6.75 17.25h.008v.008H6.75v-.008Z"
  }));
}
const JY = /* @__PURE__ */ s.forwardRef(QY);
function eX({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5"
  }));
}
const tX = /* @__PURE__ */ s.forwardRef(eX);
function rX({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.568 3H5.25A2.25 2.25 0 0 0 3 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 0 0 5.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 0 0 9.568 3Z"
  }), /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 6h.008v.008H6V6Z"
  }));
}
const nX = /* @__PURE__ */ s.forwardRef(rX);
function aX({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 0 1 0 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 0 1 0-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375Z"
  }));
}
const oX = /* @__PURE__ */ s.forwardRef(aX);
function iX({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
  }));
}
const lX = /* @__PURE__ */ s.forwardRef(iX);
function sX({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.5 18.75h-9m9 0a3 3 0 0 1 3 3h-15a3 3 0 0 1 3-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 0 1-.982-3.172M9.497 14.25a7.454 7.454 0 0 0 .981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 0 0 7.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M7.73 9.728a6.726 6.726 0 0 0 2.748 1.35m8.272-6.842V4.5c0 2.108-.966 3.99-2.48 5.228m2.48-5.492a46.32 46.32 0 0 1 2.916.52 6.003 6.003 0 0 1-5.395 4.972m0 0a6.726 6.726 0 0 1-2.749 1.35m0 0a6.772 6.772 0 0 1-3.044 0"
  }));
}
const cX = /* @__PURE__ */ s.forwardRef(sX);
function uX({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.25 18.75a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 0 0-3.213-9.193 2.056 2.056 0 0 0-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 0 0-10.026 0 1.106 1.106 0 0 0-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12"
  }));
}
const dX = /* @__PURE__ */ s.forwardRef(uX);
function fX({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 20.25h12m-7.5-3v3m3-3v3m-10.125-3h17.25c.621 0 1.125-.504 1.125-1.125V4.875c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125Z"
  }));
}
const hX = /* @__PURE__ */ s.forwardRef(fX);
function vX({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.995 3.744v7.5a6 6 0 1 1-12 0v-7.5m-2.25 16.502h16.5"
  }));
}
const pX = /* @__PURE__ */ s.forwardRef(vX);
function gX({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
  }));
}
const mX = /* @__PURE__ */ s.forwardRef(gX);
function wX({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
  }));
}
const yX = /* @__PURE__ */ s.forwardRef(wX);
function bX({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M22 10.5h-6m-2.25-4.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0ZM4 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.318 12.318 0 0 1 10.374 21c-2.331 0-4.512-.645-6.374-1.766Z"
  }));
}
const _X = /* @__PURE__ */ s.forwardRef(bX);
function xX({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0ZM3 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.318 12.318 0 0 1 9.374 21c-2.331 0-4.512-.645-6.374-1.766Z"
  }));
}
const CX = /* @__PURE__ */ s.forwardRef(xX);
function EX({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
  }));
}
const SX = /* @__PURE__ */ s.forwardRef(EX);
function RX({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
  }));
}
const MX = /* @__PURE__ */ s.forwardRef(RX);
function AX({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.745 3A23.933 23.933 0 0 0 3 12c0 3.183.62 6.22 1.745 9M19.5 3c.967 2.78 1.5 5.817 1.5 9s-.533 6.22-1.5 9M8.25 8.885l1.444-.89a.75.75 0 0 1 1.105.402l2.402 7.206a.75.75 0 0 0 1.104.401l1.445-.889m-8.25.75.213.09a1.687 1.687 0 0 0 2.062-.617l4.45-6.676a1.688 1.688 0 0 1 2.062-.618l.213.09"
  }));
}
const kX = /* @__PURE__ */ s.forwardRef(AX);
function LX({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m15.75 10.5 4.72-4.72a.75.75 0 0 1 1.28.53v11.38a.75.75 0 0 1-1.28.53l-4.72-4.72M12 18.75H4.5a2.25 2.25 0 0 1-2.25-2.25V9m12.841 9.091L16.5 19.5m-1.409-1.409c.407-.407.659-.97.659-1.591v-9a2.25 2.25 0 0 0-2.25-2.25h-9c-.621 0-1.184.252-1.591.659m12.182 12.182L2.909 5.909M1.5 4.5l1.409 1.409"
  }));
}
const TX = /* @__PURE__ */ s.forwardRef(LX);
function OX({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m15.75 10.5 4.72-4.72a.75.75 0 0 1 1.28.53v11.38a.75.75 0 0 1-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25h-9A2.25 2.25 0 0 0 2.25 7.5v9a2.25 2.25 0 0 0 2.25 2.25Z"
  }));
}
const IX = /* @__PURE__ */ s.forwardRef(OX);
function PX({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 4.5v15m6-15v15m-10.875 0h15.75c.621 0 1.125-.504 1.125-1.125V5.625c0-.621-.504-1.125-1.125-1.125H4.125C3.504 4.5 3 5.004 3 5.625v12.75c0 .621.504 1.125 1.125 1.125Z"
  }));
}
const DX = /* @__PURE__ */ s.forwardRef(PX);
function NX({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.5 3.75H6A2.25 2.25 0 0 0 3.75 6v1.5M16.5 3.75H18A2.25 2.25 0 0 1 20.25 6v1.5m0 9V18A2.25 2.25 0 0 1 18 20.25h-1.5m-9 0H6A2.25 2.25 0 0 1 3.75 18v-1.5M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
  }));
}
const BX = /* @__PURE__ */ s.forwardRef(NX);
function FX({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 12a2.25 2.25 0 0 0-2.25-2.25H15a3 3 0 1 1-6 0H5.25A2.25 2.25 0 0 0 3 12m18 0v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 9m18 0V6a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 6v3"
  }));
}
const $X = /* @__PURE__ */ s.forwardRef(FX);
function VX({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.288 15.038a5.25 5.25 0 0 1 7.424 0M5.106 11.856c3.807-3.808 9.98-3.808 13.788 0M1.924 8.674c5.565-5.565 14.587-5.565 20.152 0M12.53 18.22l-.53.53-.53-.53a.75.75 0 0 1 1.06 0Z"
  }));
}
const ZX = /* @__PURE__ */ s.forwardRef(VX);
function HX({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 8.25V18a2.25 2.25 0 0 0 2.25 2.25h13.5A2.25 2.25 0 0 0 21 18V8.25m-18 0V6a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 6v2.25m-18 0h18M5.25 6h.008v.008H5.25V6ZM7.5 6h.008v.008H7.5V6Zm2.25 0h.008v.008H9.75V6Z"
  }));
}
const jX = /* @__PURE__ */ s.forwardRef(HX);
function WX({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.42 15.17 17.25 21A2.652 2.652 0 0 0 21 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 1 1-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 0 0 4.486-6.336l-3.276 3.277a3.004 3.004 0 0 1-2.25-2.25l3.276-3.276a4.5 4.5 0 0 0-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437 1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008Z"
  }));
}
const zX = /* @__PURE__ */ s.forwardRef(WX);
function GX({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21.75 6.75a4.5 4.5 0 0 1-4.884 4.484c-1.076-.091-2.264.071-2.95.904l-7.152 8.684a2.548 2.548 0 1 1-3.586-3.586l8.684-7.152c.833-.686.995-1.874.904-2.95a4.5 4.5 0 0 1 6.336-4.486l-3.276 3.276a3.004 3.004 0 0 0 2.25 2.25l3.276-3.276c.256.565.398 1.192.398 1.852Z"
  }), /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.867 19.125h.008v.008h-.008v-.008Z"
  }));
}
const UX = /* @__PURE__ */ s.forwardRef(GX);
function YX({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
  }));
}
const XX = /* @__PURE__ */ s.forwardRef(YX);
function qX({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 18 18 6M6 6l12 12"
  }));
}
const KX = /* @__PURE__ */ s.forwardRef(qX), Qw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AcademicCapIcon: JB,
  AdjustmentsHorizontalIcon: tF,
  AdjustmentsVerticalIcon: nF,
  ArchiveBoxArrowDownIcon: oF,
  ArchiveBoxIcon: cF,
  ArchiveBoxXMarkIcon: lF,
  ArrowDownCircleIcon: dF,
  ArrowDownIcon: CF,
  ArrowDownLeftIcon: hF,
  ArrowDownOnSquareIcon: mF,
  ArrowDownOnSquareStackIcon: pF,
  ArrowDownRightIcon: yF,
  ArrowDownTrayIcon: _F,
  ArrowLeftCircleIcon: SF,
  ArrowLeftEndOnRectangleIcon: MF,
  ArrowLeftIcon: IF,
  ArrowLeftOnRectangleIcon: kF,
  ArrowLeftStartOnRectangleIcon: TF,
  ArrowLongDownIcon: DF,
  ArrowLongLeftIcon: BF,
  ArrowLongRightIcon: $F,
  ArrowLongUpIcon: ZF,
  ArrowPathIcon: zF,
  ArrowPathRoundedSquareIcon: jF,
  ArrowRightCircleIcon: UF,
  ArrowRightEndOnRectangleIcon: XF,
  ArrowRightIcon: t$,
  ArrowRightOnRectangleIcon: KF,
  ArrowRightStartOnRectangleIcon: JF,
  ArrowSmallDownIcon: n$,
  ArrowSmallLeftIcon: o$,
  ArrowSmallRightIcon: l$,
  ArrowSmallUpIcon: c$,
  ArrowTopRightOnSquareIcon: d$,
  ArrowTrendingDownIcon: h$,
  ArrowTrendingUpIcon: p$,
  ArrowTurnDownLeftIcon: m$,
  ArrowTurnDownRightIcon: y$,
  ArrowTurnLeftDownIcon: _$,
  ArrowTurnLeftUpIcon: C$,
  ArrowTurnRightDownIcon: S$,
  ArrowTurnRightUpIcon: M$,
  ArrowTurnUpLeftIcon: k$,
  ArrowTurnUpRightIcon: T$,
  ArrowUpCircleIcon: I$,
  ArrowUpIcon: z$,
  ArrowUpLeftIcon: D$,
  ArrowUpOnSquareIcon: $$,
  ArrowUpOnSquareStackIcon: B$,
  ArrowUpRightIcon: Z$,
  ArrowUpTrayIcon: j$,
  ArrowUturnDownIcon: U$,
  ArrowUturnLeftIcon: X$,
  ArrowUturnRightIcon: K$,
  ArrowUturnUpIcon: J$,
  ArrowsPointingInIcon: tV,
  ArrowsPointingOutIcon: nV,
  ArrowsRightLeftIcon: oV,
  ArrowsUpDownIcon: lV,
  AtSymbolIcon: cV,
  BackspaceIcon: dV,
  BackwardIcon: hV,
  BanknotesIcon: pV,
  Bars2Icon: mV,
  Bars3BottomLeftIcon: yV,
  Bars3BottomRightIcon: _V,
  Bars3CenterLeftIcon: CV,
  Bars3Icon: SV,
  Bars4Icon: MV,
  BarsArrowDownIcon: kV,
  BarsArrowUpIcon: TV,
  Battery0Icon: IV,
  Battery100Icon: DV,
  Battery50Icon: BV,
  BeakerIcon: $V,
  BellAlertIcon: ZV,
  BellIcon: UV,
  BellSlashIcon: jV,
  BellSnoozeIcon: zV,
  BoldIcon: XV,
  BoltIcon: JV,
  BoltSlashIcon: KV,
  BookOpenIcon: tZ,
  BookmarkIcon: lZ,
  BookmarkSlashIcon: nZ,
  BookmarkSquareIcon: oZ,
  BriefcaseIcon: cZ,
  BugAntIcon: dZ,
  BuildingLibraryIcon: hZ,
  BuildingOffice2Icon: pZ,
  BuildingOfficeIcon: mZ,
  BuildingStorefrontIcon: yZ,
  CakeIcon: _Z,
  CalculatorIcon: CZ,
  CalendarDateRangeIcon: SZ,
  CalendarDaysIcon: MZ,
  CalendarIcon: kZ,
  CameraIcon: TZ,
  ChartBarIcon: DZ,
  ChartBarSquareIcon: IZ,
  ChartPieIcon: BZ,
  ChatBubbleBottomCenterIcon: ZZ,
  ChatBubbleBottomCenterTextIcon: $Z,
  ChatBubbleLeftEllipsisIcon: jZ,
  ChatBubbleLeftIcon: UZ,
  ChatBubbleLeftRightIcon: zZ,
  ChatBubbleOvalLeftEllipsisIcon: XZ,
  ChatBubbleOvalLeftIcon: KZ,
  CheckBadgeIcon: JZ,
  CheckCircleIcon: tH,
  CheckIcon: nH,
  ChevronDoubleDownIcon: oH,
  ChevronDoubleLeftIcon: lH,
  ChevronDoubleRightIcon: cH,
  ChevronDoubleUpIcon: dH,
  ChevronDownIcon: hH,
  ChevronLeftIcon: pH,
  ChevronRightIcon: mH,
  ChevronUpDownIcon: yH,
  ChevronUpIcon: _H,
  CircleStackIcon: CH,
  ClipboardDocumentCheckIcon: SH,
  ClipboardDocumentIcon: kH,
  ClipboardDocumentListIcon: MH,
  ClipboardIcon: TH,
  ClockIcon: IH,
  CloudArrowDownIcon: DH,
  CloudArrowUpIcon: BH,
  CloudIcon: $H,
  CodeBracketIcon: jH,
  CodeBracketSquareIcon: ZH,
  Cog6ToothIcon: zH,
  Cog8ToothIcon: UH,
  CogIcon: XH,
  CommandLineIcon: KH,
  ComputerDesktopIcon: JH,
  CpuChipIcon: tj,
  CreditCardIcon: nj,
  CubeIcon: lj,
  CubeTransparentIcon: oj,
  CurrencyBangladeshiIcon: cj,
  CurrencyDollarIcon: dj,
  CurrencyEuroIcon: hj,
  CurrencyPoundIcon: pj,
  CurrencyRupeeIcon: mj,
  CurrencyYenIcon: yj,
  CursorArrowRaysIcon: _j,
  CursorArrowRippleIcon: Cj,
  DevicePhoneMobileIcon: Sj,
  DeviceTabletIcon: Mj,
  DivideIcon: kj,
  DocumentArrowDownIcon: Tj,
  DocumentArrowUpIcon: Ij,
  DocumentChartBarIcon: Dj,
  DocumentCheckIcon: Bj,
  DocumentCurrencyBangladeshiIcon: $j,
  DocumentCurrencyDollarIcon: Zj,
  DocumentCurrencyEuroIcon: jj,
  DocumentCurrencyPoundIcon: zj,
  DocumentCurrencyRupeeIcon: Uj,
  DocumentCurrencyYenIcon: Xj,
  DocumentDuplicateIcon: Kj,
  DocumentIcon: lW,
  DocumentMagnifyingGlassIcon: Jj,
  DocumentMinusIcon: tW,
  DocumentPlusIcon: nW,
  DocumentTextIcon: oW,
  EllipsisHorizontalCircleIcon: cW,
  EllipsisHorizontalIcon: dW,
  EllipsisVerticalIcon: hW,
  EnvelopeIcon: mW,
  EnvelopeOpenIcon: pW,
  EqualsIcon: yW,
  ExclamationCircleIcon: _W,
  ExclamationTriangleIcon: CW,
  EyeDropperIcon: SW,
  EyeIcon: kW,
  EyeSlashIcon: MW,
  FaceFrownIcon: TW,
  FaceSmileIcon: IW,
  FilmIcon: DW,
  FingerPrintIcon: BW,
  FireIcon: $W,
  FlagIcon: ZW,
  FolderArrowDownIcon: jW,
  FolderIcon: KW,
  FolderMinusIcon: zW,
  FolderOpenIcon: UW,
  FolderPlusIcon: XW,
  ForwardIcon: JW,
  FunnelIcon: tz,
  GifIcon: nz,
  GiftIcon: lz,
  GiftTopIcon: oz,
  GlobeAltIcon: cz,
  GlobeAmericasIcon: dz,
  GlobeAsiaAustraliaIcon: hz,
  GlobeEuropeAfricaIcon: pz,
  H1Icon: mz,
  H2Icon: yz,
  H3Icon: _z,
  HandRaisedIcon: Cz,
  HandThumbDownIcon: Sz,
  HandThumbUpIcon: Mz,
  HashtagIcon: kz,
  HeartIcon: Tz,
  HomeIcon: Dz,
  HomeModernIcon: Iz,
  IdentificationIcon: Bz,
  InboxArrowDownIcon: $z,
  InboxIcon: jz,
  InboxStackIcon: Zz,
  InformationCircleIcon: zz,
  ItalicIcon: Uz,
  KeyIcon: Xz,
  LanguageIcon: Kz,
  LifebuoyIcon: Jz,
  LightBulbIcon: tG,
  LinkIcon: oG,
  LinkSlashIcon: nG,
  ListBulletIcon: lG,
  LockClosedIcon: cG,
  LockOpenIcon: dG,
  MagnifyingGlassCircleIcon: hG,
  MagnifyingGlassIcon: yG,
  MagnifyingGlassMinusIcon: pG,
  MagnifyingGlassPlusIcon: mG,
  MapIcon: CG,
  MapPinIcon: _G,
  MegaphoneIcon: SG,
  MicrophoneIcon: MG,
  MinusCircleIcon: kG,
  MinusIcon: IG,
  MinusSmallIcon: TG,
  MoonIcon: DG,
  MusicalNoteIcon: BG,
  NewspaperIcon: $G,
  NoSymbolIcon: ZG,
  NumberedListIcon: jG,
  PaintBrushIcon: zG,
  PaperAirplaneIcon: UG,
  PaperClipIcon: XG,
  PauseCircleIcon: KG,
  PauseIcon: JG,
  PencilIcon: nU,
  PencilSquareIcon: tU,
  PercentBadgeIcon: oU,
  PhoneArrowDownLeftIcon: lU,
  PhoneArrowUpRightIcon: cU,
  PhoneIcon: hU,
  PhoneXMarkIcon: dU,
  PhotoIcon: pU,
  PlayCircleIcon: mU,
  PlayIcon: _U,
  PlayPauseIcon: yU,
  PlusCircleIcon: CU,
  PlusIcon: MU,
  PlusSmallIcon: SU,
  PowerIcon: kU,
  PresentationChartBarIcon: TU,
  PresentationChartLineIcon: IU,
  PrinterIcon: DU,
  PuzzlePieceIcon: BU,
  QrCodeIcon: $U,
  QuestionMarkCircleIcon: ZU,
  QueueListIcon: jU,
  RadioIcon: zU,
  ReceiptPercentIcon: UU,
  ReceiptRefundIcon: XU,
  RectangleGroupIcon: KU,
  RectangleStackIcon: JU,
  RocketLaunchIcon: tY,
  RssIcon: nY,
  ScaleIcon: oY,
  ScissorsIcon: lY,
  ServerIcon: dY,
  ServerStackIcon: cY,
  ShareIcon: hY,
  ShieldCheckIcon: pY,
  ShieldExclamationIcon: mY,
  ShoppingBagIcon: yY,
  ShoppingCartIcon: _Y,
  SignalIcon: SY,
  SignalSlashIcon: CY,
  SlashIcon: MY,
  SparklesIcon: kY,
  SpeakerWaveIcon: TY,
  SpeakerXMarkIcon: IY,
  Square2StackIcon: DY,
  Square3Stack3DIcon: BY,
  Squares2X2Icon: $Y,
  SquaresPlusIcon: ZY,
  StarIcon: jY,
  StopCircleIcon: zY,
  StopIcon: UY,
  StrikethroughIcon: XY,
  SunIcon: KY,
  SwatchIcon: JY,
  TableCellsIcon: tX,
  TagIcon: nX,
  TicketIcon: oX,
  TrashIcon: lX,
  TrophyIcon: cX,
  TruckIcon: dX,
  TvIcon: hX,
  UnderlineIcon: pX,
  UserCircleIcon: mX,
  UserGroupIcon: yX,
  UserIcon: SX,
  UserMinusIcon: _X,
  UserPlusIcon: CX,
  UsersIcon: MX,
  VariableIcon: kX,
  VideoCameraIcon: IX,
  VideoCameraSlashIcon: TX,
  ViewColumnsIcon: DX,
  ViewfinderCircleIcon: BX,
  WalletIcon: $X,
  WifiIcon: ZX,
  WindowIcon: jX,
  WrenchIcon: UX,
  WrenchScrewdriverIcon: zX,
  XCircleIcon: XX,
  XMarkIcon: KX
}, Symbol.toStringTag, { value: "Module" })), QX = ({ ...t }) => /* @__PURE__ */ C(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "-0.49 -0.01 25 24.1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "currentColor",
    ...t,
    children: /* @__PURE__ */ C(
      "path",
      {
        d: "M23.9308 1.00889C23.9165 0.764252 23.8129 0.533371 23.6396 0.360088C23.4664 0.186804 23.2355 0.0831818 22.9908 0.068895C13.4746 -0.489855 5.85208 2.37514 2.60208 7.75014C1.47561 9.58882 0.920477 11.7206 1.00708 13.8751C1.07833 15.8651 1.65833 17.8751 2.73083 19.8564L0.292079 22.2939C0.104439 22.4815 -0.000976569 22.736 -0.000976562 23.0014C-0.000976556 23.2668 0.104439 23.5213 0.292079 23.7089C0.47972 23.8965 0.734215 24.0019 0.999579 24.0019C1.26494 24.0019 1.51944 23.8965 1.70708 23.7089L4.14458 21.2701C6.12458 22.3414 8.13583 22.9214 10.1246 22.9926C10.2637 22.9976 10.4025 23.0001 10.5408 23.0001C12.5555 23.0055 14.532 22.4507 16.2496 21.3976C21.6246 18.1476 24.4908 10.5264 23.9308 1.00889ZM15.2183 19.6876C12.3746 21.4101 9.00833 21.4376 5.62958 19.7839L16.7083 8.70639C16.8012 8.61348 16.8749 8.50318 16.9252 8.38179C16.9755 8.2604 17.0014 8.13029 17.0014 7.99889C17.0014 7.8675 16.9755 7.73739 16.9252 7.616C16.8749 7.4946 16.8012 7.38431 16.7083 7.29139C16.6154 7.19848 16.5051 7.12478 16.3837 7.0745C16.2623 7.02422 16.1322 6.99834 16.0008 6.99834C15.8694 6.99834 15.7393 7.02422 15.6179 7.0745C15.4965 7.12478 15.3862 7.19848 15.2933 7.29139L4.21583 18.3751C2.56708 15.0001 2.59083 11.6251 4.31208 8.78639C7.07333 4.22764 13.6371 1.7314 21.9758 2.02889C22.2746 10.3614 19.7771 16.9264 15.2183 19.6876Z",
        fill: "currentColor",
        strokeLinecap: "round"
      }
    )
  }
), JX = ({ ...t }) => /* @__PURE__ */ C(
  "svg",
  {
    width: "14",
    height: "15",
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "currentColor",
    ...t,
    children: /* @__PURE__ */ C(
      "path",
      {
        d: "M11.3813 3.41209C11.0196 2.54849 10.4107 1.81105 9.63121 1.29241C8.8517 0.773772 7.9363 0.49707 7.00001 0.49707C6.06373 0.49707 5.14833 0.773772 4.36882 1.29241C3.58931 1.81105 2.98046 2.54849 2.61876 3.41209C1.83764 3.76911 1.17555 4.34305 0.711288 5.0656C0.247023 5.78815 0.00013797 6.62887 1.45636e-05 7.48772C-0.00623544 9.87522 2.00001 11.9377 4.38376 12.0002C5.11697 12.0179 5.84341 11.8563 6.50001 11.5296V14.0002C6.50001 14.1328 6.55269 14.26 6.64646 14.3538C6.74023 14.4475 6.86741 14.5002 7.00001 14.5002C7.13262 14.5002 7.2598 14.4475 7.35357 14.3538C7.44734 14.26 7.50001 14.1328 7.50001 14.0002V11.5296C8.12162 11.8382 8.80603 11.9992 9.50001 12.0002H9.61376C12 11.9377 14.0069 9.87522 14 7.48772C13.9999 6.62887 13.753 5.78815 13.2887 5.0656C12.8245 4.34305 12.1624 3.76911 11.3813 3.41209ZM9.59064 11.0002C8.84501 11.0196 8.11264 10.8007 7.50001 10.3752V7.81272L10.2238 6.45147C10.2825 6.42208 10.3349 6.38141 10.378 6.33178C10.421 6.28214 10.4539 6.22451 10.4747 6.16218C10.4954 6.09985 10.5037 6.03404 10.4991 5.9685C10.4944 5.90296 10.4769 5.83898 10.4475 5.78022C10.4181 5.72145 10.3775 5.66905 10.3278 5.626C10.2782 5.58295 10.2206 5.5501 10.1582 5.52932C10.0959 5.50854 10.0301 5.50025 9.96455 5.5049C9.89901 5.50956 9.83503 5.52708 9.77626 5.55647L7.50001 6.69147V5.00022C7.50001 4.86761 7.44734 4.74043 7.35357 4.64666C7.2598 4.55289 7.13262 4.50022 7.00001 4.50022C6.86741 4.50022 6.74023 4.55289 6.64646 4.64666C6.55269 4.74043 6.50001 4.86761 6.50001 5.00022V8.19147L4.22376 7.05272C4.10508 6.99337 3.96768 6.98361 3.8418 7.02557C3.71592 7.06753 3.61186 7.15778 3.55251 7.27647C3.49317 7.39515 3.48341 7.53255 3.52537 7.65843C3.56733 7.78432 3.65758 7.88837 3.77626 7.94772L6.50001 9.30897V10.3715C5.88755 10.7973 5.15506 11.0162 4.40939 10.9965C2.55626 10.9521 0.995015 9.34522 1.00001 7.49022C0.99954 6.79258 1.20842 6.11085 1.59963 5.53322C1.99085 4.9556 2.54639 4.50866 3.19439 4.25022C3.25939 4.22411 3.31819 4.18464 3.36696 4.13436C3.41574 4.08408 3.4534 4.02411 3.47751 3.95834C3.74125 3.23609 4.22064 2.61236 4.85071 2.17166C5.48079 1.73097 6.23111 1.49461 7.00001 1.49461C7.76892 1.49461 8.51924 1.73097 9.14931 2.17166C9.77939 2.61236 10.2588 3.23609 10.5225 3.95834C10.5466 4.02411 10.5843 4.08408 10.6331 4.13436C10.6818 4.18464 10.7406 4.22411 10.8056 4.25022C11.4535 4.5088 12.009 4.95578 12.4002 5.53337C12.7914 6.11096 13.0003 6.79262 13 7.49022C13.005 9.34522 11.4438 10.9521 9.59064 11.0002Z",
        strokeLinecap: "round"
      }
    )
  }
), eq = ({ ...t }) => /* @__PURE__ */ C(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    stroke: "currentColor",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t,
    children: /* @__PURE__ */ C(
      "path",
      {
        d: "M13 12C12.2 12.8889 11.4 12.8889 10.6 12C9.8 11.1112 9 11.1112 8.2 12C7.4 12.8889 6.6 12.8889 5.8 12C5 11.1112 4.2 11.1112 3.4 12C2.6 12.8889 1.8 12.8889 1 12M13 8.66671C12.2 9.5556 11.4 9.5556 10.6 8.66671C9.8 7.77782 9 7.77782 8.2 8.66671C7.4 9.5556 6.6 9.5556 5.8 8.66671C5 7.77782 4.2 7.77782 3.4 8.66671C2.6 9.5556 1.8 9.5556 1 8.66671M13 5.33337C12.2 6.22226 11.4 6.22226 10.6 5.33337C9.8 4.44449 9 4.44449 8.2 5.33337C7.4 6.22226 6.6 6.22226 5.8 5.33337C5 4.44449 4.2 4.44448 3.4 5.33337C2.6 6.22226 1.8 6.22226 1 5.33337M13 2.00004C12.2 2.88893 11.4 2.88893 10.6 2.00004C9.8 1.11115 9 1.11115 8.2 2.00004C7.4 2.88893 6.6 2.88893 5.8 2.00004C5 1.11115 4.2 1.11115 3.4 2.00004C2.6 2.88893 1.8 2.88893 1 2.00004",
        strokeLinecap: "round"
      }
    )
  }
), tq = ({ ...t }) => /* @__PURE__ */ C(
  "svg",
  {
    width: "18",
    height: "14",
    viewBox: "0 0 18 14",
    stroke: "currentColor",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t,
    children: /* @__PURE__ */ C(
      "path",
      {
        d: "M6.83353 7.42487L7.87503 0.5H9.95753L11.103 7.42487M8.9741 10.8812L2.04125 13.5L1 11.8132L6.83937 7.423M11.1087 7.42505L17 11.7311L15.9587 13.4179L8.97393 10.8832M11.3124 8.60233C11.3124 9.81018 10.2655 10.7893 8.97405 10.7893C7.68263 10.7893 6.63572 9.81018 6.63572 8.60233C6.63572 7.39449 7.68263 6.41533 8.97405 6.41533C10.2655 6.41533 11.3124 7.39449 11.3124 8.60233Z",
        strokeLinecap: "round"
      }
    )
  }
), N2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LeafIcon: QX,
  RiverIcon: eq,
  TreeIcon: JX,
  WindTurbineIcon: tq
}, Symbol.toStringTag, { value: "Module" }));
[
  ...Object.keys(Qw),
  ...Object.keys(Kw),
  ...Object.keys(N2)
];
const rq = { ...Kw, ...N2 }, nq = { ...Qw, ...N2 }, Me = ({ icon: t, extraClassNames: e, ariaLabel: r, solid: n = !1, ...a }) => {
  const o = n ? rq[t] : nq[t];
  return o ? /* @__PURE__ */ C(o, { className: `${e}`, "aria-label": r, ...a }) : null;
};
function j(t, e, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(a) {
    if (t == null || t(a), r === !1 || !a.defaultPrevented)
      return e == null ? void 0 : e(a);
  };
}
function aq(t, e = []) {
  let r = [];
  function n(o, i) {
    const l = s.createContext(i), c = r.length;
    r = [...r, i];
    const u = (f) => {
      var w;
      const { scope: h, children: v, ...p } = f, g = ((w = h == null ? void 0 : h[t]) == null ? void 0 : w[c]) || l, m = s.useMemo(() => p, Object.values(p));
      return /* @__PURE__ */ C(g.Provider, { value: m, children: v });
    };
    u.displayName = o + "Provider";
    function d(f, h) {
      var g;
      const v = ((g = h == null ? void 0 : h[t]) == null ? void 0 : g[c]) || l, p = s.useContext(v);
      if (p) return p;
      if (i !== void 0) return i;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [u, d];
  }
  const a = () => {
    const o = r.map((i) => s.createContext(i));
    return function(l) {
      const c = (l == null ? void 0 : l[t]) || o;
      return s.useMemo(
        () => ({ [`__scope${t}`]: { ...l, [t]: c } }),
        [l, c]
      );
    };
  };
  return a.scopeName = t, [n, oq(a, ...e)];
}
function oq(...t) {
  const e = t[0];
  if (t.length === 1) return e;
  const r = () => {
    const n = t.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(o) {
      const i = n.reduce((l, { useScope: c, scopeName: u }) => {
        const f = c(o)[`__scope${u}`];
        return { ...l, ...f };
      }, {});
      return s.useMemo(() => ({ [`__scope${e.scopeName}`]: i }), [i]);
    };
  };
  return r.scopeName = e.scopeName, r;
}
function Ke(t) {
  const e = s.useRef(t);
  return s.useEffect(() => {
    e.current = t;
  }), s.useMemo(() => (...r) => {
    var n;
    return (n = e.current) == null ? void 0 : n.call(e, ...r);
  }, []);
}
function mr({
  prop: t,
  defaultProp: e,
  onChange: r = () => {
  }
}) {
  const [n, a] = iq({ defaultProp: e, onChange: r }), o = t !== void 0, i = o ? t : n, l = Ke(r), c = s.useCallback(
    (u) => {
      if (o) {
        const f = typeof u == "function" ? u(t) : u;
        f !== t && l(f);
      } else
        a(u);
    },
    [o, t, a, l]
  );
  return [i, c];
}
function iq({
  defaultProp: t,
  onChange: e
}) {
  const r = s.useState(t), [n] = r, a = s.useRef(n), o = Ke(e);
  return s.useEffect(() => {
    a.current !== n && (o(n), a.current = n);
  }, [n, a, o]), r;
}
var Fe = globalThis != null && globalThis.document ? s.useLayoutEffect : () => {
};
function lq(t, e) {
  typeof t == "function" ? t(e) : t != null && (t.current = e);
}
function B2(...t) {
  return (e) => t.forEach((r) => lq(r, e));
}
function ce(...t) {
  return s.useCallback(B2(...t), t);
}
var Nr = s.forwardRef((t, e) => {
  const { children: r, ...n } = t, a = s.Children.toArray(r), o = a.find(sq);
  if (o) {
    const i = o.props.children, l = a.map((c) => c === o ? s.Children.count(i) > 1 ? s.Children.only(null) : s.isValidElement(i) ? i.props.children : null : c);
    return /* @__PURE__ */ C(Bf, { ...n, ref: e, children: s.isValidElement(i) ? s.cloneElement(i, void 0, l) : null });
  }
  return /* @__PURE__ */ C(Bf, { ...n, ref: e, children: r });
});
Nr.displayName = "Slot";
var Bf = s.forwardRef((t, e) => {
  const { children: r, ...n } = t;
  if (s.isValidElement(r)) {
    const a = uq(r);
    return s.cloneElement(r, {
      ...cq(n, r.props),
      // @ts-ignore
      ref: e ? B2(e, a) : a
    });
  }
  return s.Children.count(r) > 1 ? s.Children.only(null) : null;
});
Bf.displayName = "SlotClone";
var Jw = ({ children: t }) => /* @__PURE__ */ C(gr, { children: t });
function sq(t) {
  return s.isValidElement(t) && t.type === Jw;
}
function cq(t, e) {
  const r = { ...e };
  for (const n in e) {
    const a = t[n], o = e[n];
    /^on[A-Z]/.test(n) ? a && o ? r[n] = (...l) => {
      o(...l), a(...l);
    } : a && (r[n] = a) : n === "style" ? r[n] = { ...a, ...o } : n === "className" && (r[n] = [a, o].filter(Boolean).join(" "));
  }
  return { ...t, ...r };
}
function uq(t) {
  var n, a;
  let e = (n = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : n.get, r = e && "isReactWarning" in e && e.isReactWarning;
  return r ? t.ref : (e = (a = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : a.get, r = e && "isReactWarning" in e && e.isReactWarning, r ? t.props.ref : t.props.ref || t.ref);
}
var dq = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], te = dq.reduce((t, e) => {
  const r = s.forwardRef((n, a) => {
    const { asChild: o, ...i } = n, l = o ? Nr : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ C(l, { ...i, ref: a });
  });
  return r.displayName = `Primitive.${e}`, { ...t, [e]: r };
}, {});
function $u(t, e) {
  t && gs.flushSync(() => t.dispatchEvent(e));
}
function fq(t, e) {
  return s.useReducer((r, n) => e[r][n] ?? r, t);
}
var e6 = (t) => {
  const { present: e, children: r } = t, n = hq(e), a = typeof r == "function" ? r({ present: n.isPresent }) : s.Children.only(r), o = ce(n.ref, vq(a));
  return typeof r == "function" || n.isPresent ? s.cloneElement(a, { ref: o }) : null;
};
e6.displayName = "Presence";
function hq(t) {
  const [e, r] = s.useState(), n = s.useRef({}), a = s.useRef(t), o = s.useRef("none"), i = t ? "mounted" : "unmounted", [l, c] = fq(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return s.useEffect(() => {
    const u = Ys(n.current);
    o.current = l === "mounted" ? u : "none";
  }, [l]), Fe(() => {
    const u = n.current, d = a.current;
    if (d !== t) {
      const h = o.current, v = Ys(u);
      t ? c("MOUNT") : v === "none" || (u == null ? void 0 : u.display) === "none" ? c("UNMOUNT") : c(d && h !== v ? "ANIMATION_OUT" : "UNMOUNT"), a.current = t;
    }
  }, [t, c]), Fe(() => {
    if (e) {
      let u;
      const d = e.ownerDocument.defaultView ?? window, f = (v) => {
        const g = Ys(n.current).includes(v.animationName);
        if (v.target === e && g && (c("ANIMATION_END"), !a.current)) {
          const m = e.style.animationFillMode;
          e.style.animationFillMode = "forwards", u = d.setTimeout(() => {
            e.style.animationFillMode === "forwards" && (e.style.animationFillMode = m);
          });
        }
      }, h = (v) => {
        v.target === e && (o.current = Ys(n.current));
      };
      return e.addEventListener("animationstart", h), e.addEventListener("animationcancel", f), e.addEventListener("animationend", f), () => {
        d.clearTimeout(u), e.removeEventListener("animationstart", h), e.removeEventListener("animationcancel", f), e.removeEventListener("animationend", f);
      };
    } else
      c("ANIMATION_END");
  }, [e, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(l),
    ref: s.useCallback((u) => {
      u && (n.current = getComputedStyle(u)), r(u);
    }, [])
  };
}
function Ys(t) {
  return (t == null ? void 0 : t.animationName) || "none";
}
function vq(t) {
  var n, a;
  let e = (n = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : n.get, r = e && "isReactWarning" in e && e.isReactWarning;
  return r ? t.ref : (e = (a = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : a.get, r = e && "isReactWarning" in e && e.isReactWarning, r ? t.props.ref : t.props.ref || t.ref);
}
var pq = s.useId || (() => {
}), gq = 0;
function Kt(t) {
  const [e, r] = s.useState(pq());
  return Fe(() => {
    r((n) => n ?? String(gq++));
  }, [t]), e ? `radix-${e}` : "";
}
var F2 = "Collapsible", [mq, l6e] = aq(F2), [wq, $2] = mq(F2), t6 = s.forwardRef(
  (t, e) => {
    const {
      __scopeCollapsible: r,
      open: n,
      defaultOpen: a,
      disabled: o,
      onOpenChange: i,
      ...l
    } = t, [c = !1, u] = mr({
      prop: n,
      defaultProp: a,
      onChange: i
    });
    return /* @__PURE__ */ C(
      wq,
      {
        scope: r,
        disabled: o,
        contentId: Kt(),
        open: c,
        onOpenToggle: s.useCallback(() => u((d) => !d), [u]),
        children: /* @__PURE__ */ C(
          te.div,
          {
            "data-state": Z2(c),
            "data-disabled": o ? "" : void 0,
            ...l,
            ref: e
          }
        )
      }
    );
  }
);
t6.displayName = F2;
var r6 = "CollapsibleTrigger", n6 = s.forwardRef(
  (t, e) => {
    const { __scopeCollapsible: r, ...n } = t, a = $2(r6, r);
    return /* @__PURE__ */ C(
      te.button,
      {
        type: "button",
        "aria-controls": a.contentId,
        "aria-expanded": a.open || !1,
        "data-state": Z2(a.open),
        "data-disabled": a.disabled ? "" : void 0,
        disabled: a.disabled,
        ...n,
        ref: e,
        onClick: j(t.onClick, a.onOpenToggle)
      }
    );
  }
);
n6.displayName = r6;
var V2 = "CollapsibleContent", a6 = s.forwardRef(
  (t, e) => {
    const { forceMount: r, ...n } = t, a = $2(V2, t.__scopeCollapsible);
    return /* @__PURE__ */ C(e6, { present: r || a.open, children: ({ present: o }) => /* @__PURE__ */ C(yq, { ...n, ref: e, present: o }) });
  }
);
a6.displayName = V2;
var yq = s.forwardRef((t, e) => {
  const { __scopeCollapsible: r, present: n, children: a, ...o } = t, i = $2(V2, r), [l, c] = s.useState(n), u = s.useRef(null), d = ce(e, u), f = s.useRef(0), h = f.current, v = s.useRef(0), p = v.current, g = i.open || l, m = s.useRef(g), w = s.useRef();
  return s.useEffect(() => {
    const y = requestAnimationFrame(() => m.current = !1);
    return () => cancelAnimationFrame(y);
  }, []), Fe(() => {
    const y = u.current;
    if (y) {
      w.current = w.current || {
        transitionDuration: y.style.transitionDuration,
        animationName: y.style.animationName
      }, y.style.transitionDuration = "0s", y.style.animationName = "none";
      const b = y.getBoundingClientRect();
      f.current = b.height, v.current = b.width, m.current || (y.style.transitionDuration = w.current.transitionDuration, y.style.animationName = w.current.animationName), c(n);
    }
  }, [i.open, n]), /* @__PURE__ */ C(
    te.div,
    {
      "data-state": Z2(i.open),
      "data-disabled": i.disabled ? "" : void 0,
      id: i.contentId,
      hidden: !g,
      ...o,
      ref: d,
      style: {
        "--radix-collapsible-content-height": h ? `${h}px` : void 0,
        "--radix-collapsible-content-width": p ? `${p}px` : void 0,
        ...t.style
      },
      children: g && a
    }
  );
});
function Z2(t) {
  return t ? "open" : "closed";
}
var bq = t6, _q = n6, xq = a6;
const H2 = "-", Cq = (t) => {
  const e = Sq(t), {
    conflictingClassGroups: r,
    conflictingClassGroupModifiers: n
  } = t;
  return {
    getClassGroupId: (i) => {
      const l = i.split(H2);
      return l[0] === "" && l.length !== 1 && l.shift(), o6(l, e) || Eq(i);
    },
    getConflictingClassGroupIds: (i, l) => {
      const c = r[i] || [];
      return l && n[i] ? [...c, ...n[i]] : c;
    }
  };
}, o6 = (t, e) => {
  var i;
  if (t.length === 0)
    return e.classGroupId;
  const r = t[0], n = e.nextPart.get(r), a = n ? o6(t.slice(1), n) : void 0;
  if (a)
    return a;
  if (e.validators.length === 0)
    return;
  const o = t.join(H2);
  return (i = e.validators.find(({
    validator: l
  }) => l(o))) == null ? void 0 : i.classGroupId;
}, pp = /^\[(.+)\]$/, Eq = (t) => {
  if (pp.test(t)) {
    const e = pp.exec(t)[1], r = e == null ? void 0 : e.substring(0, e.indexOf(":"));
    if (r)
      return "arbitrary.." + r;
  }
}, Sq = (t) => {
  const {
    theme: e,
    prefix: r
  } = t, n = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return Mq(Object.entries(t.classGroups), r).forEach(([o, i]) => {
    Ff(i, n, o, e);
  }), n;
}, Ff = (t, e, r, n) => {
  t.forEach((a) => {
    if (typeof a == "string") {
      const o = a === "" ? e : gp(e, a);
      o.classGroupId = r;
      return;
    }
    if (typeof a == "function") {
      if (Rq(a)) {
        Ff(a(n), e, r, n);
        return;
      }
      e.validators.push({
        validator: a,
        classGroupId: r
      });
      return;
    }
    Object.entries(a).forEach(([o, i]) => {
      Ff(i, gp(e, o), r, n);
    });
  });
}, gp = (t, e) => {
  let r = t;
  return e.split(H2).forEach((n) => {
    r.nextPart.has(n) || r.nextPart.set(n, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), r = r.nextPart.get(n);
  }), r;
}, Rq = (t) => t.isThemeGetter, Mq = (t, e) => e ? t.map(([r, n]) => {
  const a = n.map((o) => typeof o == "string" ? e + o : typeof o == "object" ? Object.fromEntries(Object.entries(o).map(([i, l]) => [e + i, l])) : o);
  return [r, a];
}) : t, Aq = (t) => {
  if (t < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let e = 0, r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  const a = (o, i) => {
    r.set(o, i), e++, e > t && (e = 0, n = r, r = /* @__PURE__ */ new Map());
  };
  return {
    get(o) {
      let i = r.get(o);
      if (i !== void 0)
        return i;
      if ((i = n.get(o)) !== void 0)
        return a(o, i), i;
    },
    set(o, i) {
      r.has(o) ? r.set(o, i) : a(o, i);
    }
  };
}, i6 = "!", kq = (t) => {
  const {
    separator: e,
    experimentalParseClassName: r
  } = t, n = e.length === 1, a = e[0], o = e.length, i = (l) => {
    const c = [];
    let u = 0, d = 0, f;
    for (let m = 0; m < l.length; m++) {
      let w = l[m];
      if (u === 0) {
        if (w === a && (n || l.slice(m, m + o) === e)) {
          c.push(l.slice(d, m)), d = m + o;
          continue;
        }
        if (w === "/") {
          f = m;
          continue;
        }
      }
      w === "[" ? u++ : w === "]" && u--;
    }
    const h = c.length === 0 ? l : l.substring(d), v = h.startsWith(i6), p = v ? h.substring(1) : h, g = f && f > d ? f - d : void 0;
    return {
      modifiers: c,
      hasImportantModifier: v,
      baseClassName: p,
      maybePostfixModifierPosition: g
    };
  };
  return r ? (l) => r({
    className: l,
    parseClassName: i
  }) : i;
}, Lq = (t) => {
  if (t.length <= 1)
    return t;
  const e = [];
  let r = [];
  return t.forEach((n) => {
    n[0] === "[" ? (e.push(...r.sort(), n), r = []) : r.push(n);
  }), e.push(...r.sort()), e;
}, Tq = (t) => ({
  cache: Aq(t.cacheSize),
  parseClassName: kq(t),
  ...Cq(t)
}), Oq = /\s+/, Iq = (t, e) => {
  const {
    parseClassName: r,
    getClassGroupId: n,
    getConflictingClassGroupIds: a
  } = e, o = [], i = t.trim().split(Oq);
  let l = "";
  for (let c = i.length - 1; c >= 0; c -= 1) {
    const u = i[c], {
      modifiers: d,
      hasImportantModifier: f,
      baseClassName: h,
      maybePostfixModifierPosition: v
    } = r(u);
    let p = !!v, g = n(p ? h.substring(0, v) : h);
    if (!g) {
      if (!p) {
        l = u + (l.length > 0 ? " " + l : l);
        continue;
      }
      if (g = n(h), !g) {
        l = u + (l.length > 0 ? " " + l : l);
        continue;
      }
      p = !1;
    }
    const m = Lq(d).join(":"), w = f ? m + i6 : m, y = w + g;
    if (o.includes(y))
      continue;
    o.push(y);
    const b = a(g, p);
    for (let _ = 0; _ < b.length; ++_) {
      const x = b[_];
      o.push(w + x);
    }
    l = u + (l.length > 0 ? " " + l : l);
  }
  return l;
};
function Pq() {
  let t = 0, e, r, n = "";
  for (; t < arguments.length; )
    (e = arguments[t++]) && (r = l6(e)) && (n && (n += " "), n += r);
  return n;
}
const l6 = (t) => {
  if (typeof t == "string")
    return t;
  let e, r = "";
  for (let n = 0; n < t.length; n++)
    t[n] && (e = l6(t[n])) && (r && (r += " "), r += e);
  return r;
};
function Dq(t, ...e) {
  let r, n, a, o = i;
  function i(c) {
    const u = e.reduce((d, f) => f(d), t());
    return r = Tq(u), n = r.cache.get, a = r.cache.set, o = l, l(c);
  }
  function l(c) {
    const u = n(c);
    if (u)
      return u;
    const d = Iq(c, r);
    return a(c, d), d;
  }
  return function() {
    return o(Pq.apply(null, arguments));
  };
}
const $e = (t) => {
  const e = (r) => r[t] || [];
  return e.isThemeGetter = !0, e;
}, s6 = /^\[(?:([a-z-]+):)?(.+)\]$/i, Nq = /^\d+\/\d+$/, Bq = /* @__PURE__ */ new Set(["px", "full", "screen"]), Fq = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, $q = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Vq = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, Zq = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Hq = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, sn = (t) => ri(t) || Bq.has(t) || Nq.test(t), Mn = (t) => Pi(t, "length", qq), ri = (t) => !!t && !Number.isNaN(Number(t)), _5 = (t) => Pi(t, "number", ri), Xi = (t) => !!t && Number.isInteger(Number(t)), jq = (t) => t.endsWith("%") && ri(t.slice(0, -1)), ye = (t) => s6.test(t), An = (t) => Fq.test(t), Wq = /* @__PURE__ */ new Set(["length", "size", "percentage"]), zq = (t) => Pi(t, Wq, c6), Gq = (t) => Pi(t, "position", c6), Uq = /* @__PURE__ */ new Set(["image", "url"]), Yq = (t) => Pi(t, Uq, Qq), Xq = (t) => Pi(t, "", Kq), qi = () => !0, Pi = (t, e, r) => {
  const n = s6.exec(t);
  return n ? n[1] ? typeof e == "string" ? n[1] === e : e.has(n[1]) : r(n[2]) : !1;
}, qq = (t) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  $q.test(t) && !Vq.test(t)
), c6 = () => !1, Kq = (t) => Zq.test(t), Qq = (t) => Hq.test(t), Jq = () => {
  const t = $e("colors"), e = $e("spacing"), r = $e("blur"), n = $e("brightness"), a = $e("borderColor"), o = $e("borderRadius"), i = $e("borderSpacing"), l = $e("borderWidth"), c = $e("contrast"), u = $e("grayscale"), d = $e("hueRotate"), f = $e("invert"), h = $e("gap"), v = $e("gradientColorStops"), p = $e("gradientColorStopPositions"), g = $e("inset"), m = $e("margin"), w = $e("opacity"), y = $e("padding"), b = $e("saturate"), _ = $e("scale"), x = $e("sepia"), E = $e("skew"), S = $e("space"), M = $e("translate"), R = () => ["auto", "contain", "none"], A = () => ["auto", "hidden", "clip", "visible", "scroll"], k = () => ["auto", ye, e], L = () => [ye, e], T = () => ["", sn, Mn], O = () => ["auto", ri, ye], D = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], P = () => ["solid", "dashed", "dotted", "double", "none"], F = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], B = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], N = () => ["", "0", ye], $ = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], V = () => [ri, ye];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [qi],
      spacing: [sn, Mn],
      blur: ["none", "", An, ye],
      brightness: V(),
      borderColor: [t],
      borderRadius: ["none", "", "full", An, ye],
      borderSpacing: L(),
      borderWidth: T(),
      contrast: V(),
      grayscale: N(),
      hueRotate: V(),
      invert: N(),
      gap: L(),
      gradientColorStops: [t],
      gradientColorStopPositions: [jq, Mn],
      inset: k(),
      margin: k(),
      opacity: V(),
      padding: L(),
      saturate: V(),
      scale: V(),
      sepia: N(),
      skew: V(),
      space: L(),
      translate: L()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", ye]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [An]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": $()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": $()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...D(), ye]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: A()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": A()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": A()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: R()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": R()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": R()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [g]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [g]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [g]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [g]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [g]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [g]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [g]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [g]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [g]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Xi, ye]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: k()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", ye]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: N()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: N()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Xi, ye]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [qi]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Xi, ye]
        }, ye]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": O()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": O()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [qi]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Xi, ye]
        }, ye]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": O()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": O()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", ye]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", ye]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [h]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [h]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [h]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...B()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...B(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...B(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [y]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [y]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [y]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [y]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [y]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [y]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [y]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [y]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [y]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [m]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [m]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [m]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [m]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [m]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [m]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [m]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [m]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [m]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [S]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [S]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", ye, e]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [ye, e, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [ye, e, "none", "full", "min", "max", "fit", "prose", {
          screen: [An]
        }, An]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [ye, e, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [ye, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [ye, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [ye, e, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", An, Mn]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", _5]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [qi]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", ye]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", ri, _5]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", sn, ye]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", ye]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", ye]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [t]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [w]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [t]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [w]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...P(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", sn, Mn]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", sn, ye]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [t]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: L()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", ye]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", ye]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [w]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...D(), Gq]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", zq]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, Yq]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [t]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [p]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [v]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [v]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [v]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [o]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [o]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [o]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [o]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [o]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [o]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [o]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [o]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [o]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [o]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [o]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [o]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [o]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [o]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [o]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [l]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [l]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [l]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [l]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [l]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [l]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [l]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [l]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [l]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [w]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...P(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [l]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [l]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [w]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: P()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [a]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [a]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [a]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [a]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [a]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [a]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [a]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [a]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [a]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [a]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...P()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [sn, ye]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [sn, Mn]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [t]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: T()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [t]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [w]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [sn, Mn]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [t]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", An, Xq]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [qi]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [w]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...F(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": F()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [r]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [n]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [c]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", An, ye]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [d]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [f]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [b]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [x]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [r]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [n]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [c]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [d]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [f]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [w]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [b]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [x]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [i]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [i]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [i]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", ye]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: V()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", ye]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: V()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", ye]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [_]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [_]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [_]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Xi, ye]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [M]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [M]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [E]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [E]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", ye]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", t]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", ye]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [t]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": L()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": L()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": L()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": L()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": L()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": L()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": L()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": L()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": L()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": L()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": L()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": L()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": L()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": L()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": L()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": L()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": L()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": L()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", ye]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [t, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [sn, Mn, _5]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [t, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, G = /* @__PURE__ */ Dq(Jq), eK = "foton__collapsibleRoot___lbuj0", tK = "foton__iconButton___ZeWlG", rK = "foton__collapsibleTriggerContainer___SKBSH", nK = "foton__collapsibleContent___ceSML", Xs = {
  collapsibleRoot: eK,
  iconButton: tK,
  collapsibleTriggerContainer: rK,
  collapsibleContent: nK
}, s6e = ({ iconSide: t = "right", header: e, content: r, ...n }) => {
  const [a, o] = gt(!1), { className: i } = n;
  return /* @__PURE__ */ Z(
    bq,
    {
      className: G(i ?? "bg-light-20", Xs.collapsibleRoot),
      open: a,
      onOpenChange: o,
      children: [
        /* @__PURE__ */ Z("div", { className: Xs.collapsibleTriggerContainer, onClick: () => o(!a), children: [
          t === "right" && e,
          /* @__PURE__ */ C(_q, { asChild: !0, children: /* @__PURE__ */ C("button", { className: Xs.iconButton, children: /* @__PURE__ */ C(Me, { icon: a ? "ChevronUpIcon" : "ChevronDownIcon" }) }) }),
          t === "left" && e
        ] }),
        /* @__PURE__ */ C(xq, { className: Xs.collapsibleContent, children: r })
      ]
    }
  );
}, aK = "foton__loadingCircle___EBjd-", oK = "foton__spin___due-k", iK = {
  loadingCircle: aK,
  spin: oK
}, lK = () => /* @__PURE__ */ C("div", { className: iK.loadingCircle }), sK = "foton__icon___0tKAy", cK = "foton__button___hOSfs", uK = "foton__loading___DjDpA", dK = "foton__buttonContent___49yTY", fK = "foton__loadingItem___J40At", hK = "foton__smallButton___ujla0", vK = "foton__mediumButton___VhFcu", pK = "foton__bigButton___VKFgr", gK = "foton__primaryButton___c72Eu", mK = "foton__secondaryButton___S40Tn", wK = "foton__tertiaryButton___QXCi9", yK = "foton__defaultButtonVariant___XtK1q", bK = "foton__circleButtonVariant___muU-n", _K = "foton__ghostButtonVariant___zAmNk", xK = "foton__mobileLongButtonVariant___XqpP4", CK = "foton__elevatedButton___IuKVb", lt = {
  icon: sK,
  button: cK,
  loading: uK,
  buttonContent: dK,
  loadingItem: fK,
  smallButton: hK,
  mediumButton: vK,
  bigButton: pK,
  primaryButton: gK,
  secondaryButton: mK,
  tertiaryButton: wK,
  defaultButtonVariant: yK,
  circleButtonVariant: bK,
  ghostButtonVariant: _K,
  mobileLongButtonVariant: xK,
  elevatedButton: CK
}, EK = {
  primary: lt.primaryButton,
  secondary: lt.secondaryButton,
  tertiary: lt.tertiaryButton
}, SK = {
  ghost: lt.ghostButtonVariant,
  circle: lt.circleButtonVariant,
  default: lt.defaultButtonVariant,
  fab: lt.fabButtonVariant,
  "mobile-long": lt.mobileLongButtonVariant
}, RK = {
  small: lt.smallButton,
  medium: lt.mediumButton,
  big: lt.bigButton
}, Vu = ({
  children: t,
  size: e = "small",
  variant: r = "default",
  kind: n = "primary",
  leftIcon: a,
  rightIcon: o,
  loading: i,
  disabled: l,
  elevated: c,
  className: u,
  onClick: d
}) => /* @__PURE__ */ Z(
  "button",
  {
    className: G(
      lt.button,
      EK[n],
      SK[r],
      RK[e],
      i ? lt.loading : "",
      c ? lt.elevatedButton : "",
      u || ""
    ),
    disabled: l,
    onClick: () => {
      !i && d && d();
    },
    children: [
      a && /* @__PURE__ */ C(Me, { icon: a, className: lt.icon }),
      i && /* @__PURE__ */ C("span", { className: lt.loadingItem, children: /* @__PURE__ */ C(lK, {}) }),
      /* @__PURE__ */ C("span", { className: lt.buttonContent, children: t }),
      o && /* @__PURE__ */ C(Me, { icon: o, className: lt.icon })
    ]
  }
), k0 = (t) => /* @__PURE__ */ C(Vu, { ...t }), MK = "foton__small___0yXyK", AK = "foton__medium___4IYLW", kK = "foton__big___Zuz5b", LK = {
  small: MK,
  medium: AK,
  big: kK
}, gi = (t) => /* @__PURE__ */ C(Vu, { variant: "circle", ...t, children: /* @__PURE__ */ C(Me, { icon: t.icon, extraClassNames: G(LK[t.size || "small"], t.iconColor) }) });
var TK = "VisuallyHidden", j2 = s.forwardRef(
  (t, e) => /* @__PURE__ */ C(
    te.span,
    {
      ...t,
      ref: e,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...t.style
      }
    }
  )
);
j2.displayName = TK;
var OK = j2, u6 = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(t) {
  (function() {
    var e = {}.hasOwnProperty;
    function r() {
      for (var n = [], a = 0; a < arguments.length; a++) {
        var o = arguments[a];
        if (o) {
          var i = typeof o;
          if (i === "string" || i === "number")
            n.push(o);
          else if (Array.isArray(o)) {
            if (o.length) {
              var l = r.apply(null, o);
              l && n.push(l);
            }
          } else if (i === "object") {
            if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]")) {
              n.push(o.toString());
              continue;
            }
            for (var c in o)
              e.call(o, c) && o[c] && n.push(c);
          }
        }
      }
      return n.join(" ");
    }
    t.exports ? (r.default = r, t.exports = r) : window.classNames = r;
  })();
})(u6);
var IK = u6.exports;
const Hn = /* @__PURE__ */ ms(IK);
function Sn(t, e = []) {
  let r = [];
  function n(o, i) {
    const l = s.createContext(i), c = r.length;
    r = [...r, i];
    function u(f) {
      const { scope: h, children: v, ...p } = f, g = (h == null ? void 0 : h[t][c]) || l, m = s.useMemo(() => p, Object.values(p));
      return /* @__PURE__ */ C(g.Provider, { value: m, children: v });
    }
    function d(f, h) {
      const v = (h == null ? void 0 : h[t][c]) || l, p = s.useContext(v);
      if (p) return p;
      if (i !== void 0) return i;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return u.displayName = o + "Provider", [u, d];
  }
  const a = () => {
    const o = r.map((i) => s.createContext(i));
    return function(l) {
      const c = (l == null ? void 0 : l[t]) || o;
      return s.useMemo(
        () => ({ [`__scope${t}`]: { ...l, [t]: c } }),
        [l, c]
      );
    };
  };
  return a.scopeName = t, [n, PK(a, ...e)];
}
function PK(...t) {
  const e = t[0];
  if (t.length === 1) return e;
  const r = () => {
    const n = t.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(o) {
      const i = n.reduce((l, { useScope: c, scopeName: u }) => {
        const f = c(o)[`__scope${u}`];
        return { ...l, ...f };
      }, {});
      return s.useMemo(() => ({ [`__scope${e.scopeName}`]: i }), [i]);
    };
  };
  return r.scopeName = e.scopeName, r;
}
function W2(t, e = globalThis == null ? void 0 : globalThis.document) {
  const r = Ke(t);
  s.useEffect(() => {
    const n = (a) => {
      a.key === "Escape" && r(a);
    };
    return e.addEventListener("keydown", n, { capture: !0 }), () => e.removeEventListener("keydown", n, { capture: !0 });
  }, [r, e]);
}
var DK = "DismissableLayer", $f = "dismissableLayer.update", NK = "dismissableLayer.pointerDownOutside", BK = "dismissableLayer.focusOutside", mp, d6 = s.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Zu = s.forwardRef(
  (t, e) => {
    const {
      disableOutsidePointerEvents: r = !1,
      onEscapeKeyDown: n,
      onPointerDownOutside: a,
      onFocusOutside: o,
      onInteractOutside: i,
      onDismiss: l,
      ...c
    } = t, u = s.useContext(d6), [d, f] = s.useState(null), h = (d == null ? void 0 : d.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, v] = s.useState({}), p = ce(e, (S) => f(S)), g = Array.from(u.layers), [m] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), w = g.indexOf(m), y = d ? g.indexOf(d) : -1, b = u.layersWithOutsidePointerEventsDisabled.size > 0, _ = y >= w, x = VK((S) => {
      const M = S.target, R = [...u.branches].some((A) => A.contains(M));
      !_ || R || (a == null || a(S), i == null || i(S), S.defaultPrevented || l == null || l());
    }, h), E = ZK((S) => {
      const M = S.target;
      [...u.branches].some((A) => A.contains(M)) || (o == null || o(S), i == null || i(S), S.defaultPrevented || l == null || l());
    }, h);
    return W2((S) => {
      y === u.layers.size - 1 && (n == null || n(S), !S.defaultPrevented && l && (S.preventDefault(), l()));
    }, h), s.useEffect(() => {
      if (d)
        return r && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (mp = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), wp(), () => {
          r && u.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = mp);
        };
    }, [d, h, r, u]), s.useEffect(() => () => {
      d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), wp());
    }, [d, u]), s.useEffect(() => {
      const S = () => v({});
      return document.addEventListener($f, S), () => document.removeEventListener($f, S);
    }, []), /* @__PURE__ */ C(
      te.div,
      {
        ...c,
        ref: p,
        style: {
          pointerEvents: b ? _ ? "auto" : "none" : void 0,
          ...t.style
        },
        onFocusCapture: j(t.onFocusCapture, E.onFocusCapture),
        onBlurCapture: j(t.onBlurCapture, E.onBlurCapture),
        onPointerDownCapture: j(
          t.onPointerDownCapture,
          x.onPointerDownCapture
        )
      }
    );
  }
);
Zu.displayName = DK;
var FK = "DismissableLayerBranch", $K = s.forwardRef((t, e) => {
  const r = s.useContext(d6), n = s.useRef(null), a = ce(e, n);
  return s.useEffect(() => {
    const o = n.current;
    if (o)
      return r.branches.add(o), () => {
        r.branches.delete(o);
      };
  }, [r.branches]), /* @__PURE__ */ C(te.div, { ...t, ref: a });
});
$K.displayName = FK;
function VK(t, e = globalThis == null ? void 0 : globalThis.document) {
  const r = Ke(t), n = s.useRef(!1), a = s.useRef(() => {
  });
  return s.useEffect(() => {
    const o = (l) => {
      if (l.target && !n.current) {
        let c = function() {
          f6(
            NK,
            r,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: l };
        l.pointerType === "touch" ? (e.removeEventListener("click", a.current), a.current = c, e.addEventListener("click", a.current, { once: !0 })) : c();
      } else
        e.removeEventListener("click", a.current);
      n.current = !1;
    }, i = window.setTimeout(() => {
      e.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(i), e.removeEventListener("pointerdown", o), e.removeEventListener("click", a.current);
    };
  }, [e, r]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => n.current = !0
  };
}
function ZK(t, e = globalThis == null ? void 0 : globalThis.document) {
  const r = Ke(t), n = s.useRef(!1);
  return s.useEffect(() => {
    const a = (o) => {
      o.target && !n.current && f6(BK, r, { originalEvent: o }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", a), () => e.removeEventListener("focusin", a);
  }, [e, r]), {
    onFocusCapture: () => n.current = !0,
    onBlurCapture: () => n.current = !1
  };
}
function wp() {
  const t = new CustomEvent($f);
  document.dispatchEvent(t);
}
function f6(t, e, r, { discrete: n }) {
  const a = r.originalEvent.target, o = new CustomEvent(t, { bubbles: !1, cancelable: !0, detail: r });
  e && a.addEventListener(t, e, { once: !0 }), n ? $u(a, o) : a.dispatchEvent(o);
}
var x5 = "focusScope.autoFocusOnMount", C5 = "focusScope.autoFocusOnUnmount", yp = { bubbles: !1, cancelable: !0 }, HK = "FocusScope", ws = s.forwardRef((t, e) => {
  const {
    loop: r = !1,
    trapped: n = !1,
    onMountAutoFocus: a,
    onUnmountAutoFocus: o,
    ...i
  } = t, [l, c] = s.useState(null), u = Ke(a), d = Ke(o), f = s.useRef(null), h = ce(e, (g) => c(g)), v = s.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  s.useEffect(() => {
    if (n) {
      let g = function(b) {
        if (v.paused || !l) return;
        const _ = b.target;
        l.contains(_) ? f.current = _ : Fn(f.current, { select: !0 });
      }, m = function(b) {
        if (v.paused || !l) return;
        const _ = b.relatedTarget;
        _ !== null && (l.contains(_) || Fn(f.current, { select: !0 }));
      }, w = function(b) {
        if (document.activeElement === document.body)
          for (const x of b)
            x.removedNodes.length > 0 && Fn(l);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", m);
      const y = new MutationObserver(w);
      return l && y.observe(l, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", m), y.disconnect();
      };
    }
  }, [n, l, v.paused]), s.useEffect(() => {
    if (l) {
      _p.add(v);
      const g = document.activeElement;
      if (!l.contains(g)) {
        const w = new CustomEvent(x5, yp);
        l.addEventListener(x5, u), l.dispatchEvent(w), w.defaultPrevented || (jK(YK(h6(l)), { select: !0 }), document.activeElement === g && Fn(l));
      }
      return () => {
        l.removeEventListener(x5, u), setTimeout(() => {
          const w = new CustomEvent(C5, yp);
          l.addEventListener(C5, d), l.dispatchEvent(w), w.defaultPrevented || Fn(g ?? document.body, { select: !0 }), l.removeEventListener(C5, d), _p.remove(v);
        }, 0);
      };
    }
  }, [l, u, d, v]);
  const p = s.useCallback(
    (g) => {
      if (!r && !n || v.paused) return;
      const m = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, w = document.activeElement;
      if (m && w) {
        const y = g.currentTarget, [b, _] = WK(y);
        b && _ ? !g.shiftKey && w === _ ? (g.preventDefault(), r && Fn(b, { select: !0 })) : g.shiftKey && w === b && (g.preventDefault(), r && Fn(_, { select: !0 })) : w === y && g.preventDefault();
      }
    },
    [r, n, v.paused]
  );
  return /* @__PURE__ */ C(te.div, { tabIndex: -1, ...i, ref: h, onKeyDown: p });
});
ws.displayName = HK;
function jK(t, { select: e = !1 } = {}) {
  const r = document.activeElement;
  for (const n of t)
    if (Fn(n, { select: e }), document.activeElement !== r) return;
}
function WK(t) {
  const e = h6(t), r = bp(e, t), n = bp(e.reverse(), t);
  return [r, n];
}
function h6(t) {
  const e = [], r = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const a = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || a ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) e.push(r.currentNode);
  return e;
}
function bp(t, e) {
  for (const r of t)
    if (!zK(r, { upTo: e })) return r;
}
function zK(t, { upTo: e }) {
  if (getComputedStyle(t).visibility === "hidden") return !0;
  for (; t; ) {
    if (e !== void 0 && t === e) return !1;
    if (getComputedStyle(t).display === "none") return !0;
    t = t.parentElement;
  }
  return !1;
}
function GK(t) {
  return t instanceof HTMLInputElement && "select" in t;
}
function Fn(t, { select: e = !1 } = {}) {
  if (t && t.focus) {
    const r = document.activeElement;
    t.focus({ preventScroll: !0 }), t !== r && GK(t) && e && t.select();
  }
}
var _p = UK();
function UK() {
  let t = [];
  return {
    add(e) {
      const r = t[0];
      e !== r && (r == null || r.pause()), t = xp(t, e), t.unshift(e);
    },
    remove(e) {
      var r;
      t = xp(t, e), (r = t[0]) == null || r.resume();
    }
  };
}
function xp(t, e) {
  const r = [...t], n = r.indexOf(e);
  return n !== -1 && r.splice(n, 1), r;
}
function YK(t) {
  return t.filter((e) => e.tagName !== "A");
}
var XK = "Portal", z2 = s.forwardRef((t, e) => {
  var l;
  const { container: r, ...n } = t, [a, o] = s.useState(!1);
  Fe(() => o(!0), []);
  const i = r || a && ((l = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : l.body);
  return i ? D2.createPortal(/* @__PURE__ */ C(te.div, { ...n, ref: e }), i) : null;
});
z2.displayName = XK;
function qK(t, e) {
  return s.useReducer((r, n) => e[r][n] ?? r, t);
}
var Hu = (t) => {
  const { present: e, children: r } = t, n = KK(e), a = typeof r == "function" ? r({ present: n.isPresent }) : s.Children.only(r), o = ce(n.ref, QK(a));
  return typeof r == "function" || n.isPresent ? s.cloneElement(a, { ref: o }) : null;
};
Hu.displayName = "Presence";
function KK(t) {
  const [e, r] = s.useState(), n = s.useRef({}), a = s.useRef(t), o = s.useRef("none"), i = t ? "mounted" : "unmounted", [l, c] = qK(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return s.useEffect(() => {
    const u = qs(n.current);
    o.current = l === "mounted" ? u : "none";
  }, [l]), Fe(() => {
    const u = n.current, d = a.current;
    if (d !== t) {
      const h = o.current, v = qs(u);
      t ? c("MOUNT") : v === "none" || (u == null ? void 0 : u.display) === "none" ? c("UNMOUNT") : c(d && h !== v ? "ANIMATION_OUT" : "UNMOUNT"), a.current = t;
    }
  }, [t, c]), Fe(() => {
    if (e) {
      const u = (f) => {
        const v = qs(n.current).includes(f.animationName);
        f.target === e && v && gs.flushSync(() => c("ANIMATION_END"));
      }, d = (f) => {
        f.target === e && (o.current = qs(n.current));
      };
      return e.addEventListener("animationstart", d), e.addEventListener("animationcancel", u), e.addEventListener("animationend", u), () => {
        e.removeEventListener("animationstart", d), e.removeEventListener("animationcancel", u), e.removeEventListener("animationend", u);
      };
    } else
      c("ANIMATION_END");
  }, [e, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(l),
    ref: s.useCallback((u) => {
      u && (n.current = getComputedStyle(u)), r(u);
    }, [])
  };
}
function qs(t) {
  return (t == null ? void 0 : t.animationName) || "none";
}
function QK(t) {
  var n, a;
  let e = (n = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : n.get, r = e && "isReactWarning" in e && e.isReactWarning;
  return r ? t.ref : (e = (a = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : a.get, r = e && "isReactWarning" in e && e.isReactWarning, r ? t.props.ref : t.props.ref || t.ref);
}
var E5 = 0;
function v6() {
  s.useEffect(() => {
    const t = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", t[0] ?? Cp()), document.body.insertAdjacentElement("beforeend", t[1] ?? Cp()), E5++, () => {
      E5 === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((e) => e.remove()), E5--;
    };
  }, []);
}
function Cp() {
  const t = document.createElement("span");
  return t.setAttribute("data-radix-focus-guard", ""), t.tabIndex = 0, t.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", t;
}
var Vf = function(t, e) {
  return Vf = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (r[a] = n[a]);
  }, Vf(t, e);
};
function p6(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  Vf(t, e);
  function r() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
}
var Ue = function() {
  return Ue = Object.assign || function(e) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, Ue.apply(this, arguments);
};
function Di(t, e) {
  var r = {};
  for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(t); a < n.length; a++)
      e.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[a]) && (r[n[a]] = t[n[a]]);
  return r;
}
function g6(t, e, r, n) {
  var a = arguments.length, o = a < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, r) : n, i;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") o = Reflect.decorate(t, e, r, n);
  else for (var l = t.length - 1; l >= 0; l--) (i = t[l]) && (o = (a < 3 ? i(o) : a > 3 ? i(e, r, o) : i(e, r)) || o);
  return a > 3 && o && Object.defineProperty(e, r, o), o;
}
function m6(t, e) {
  return function(r, n) {
    e(r, n, t);
  };
}
function JK(t, e, r, n, a, o) {
  function i(w) {
    if (w !== void 0 && typeof w != "function") throw new TypeError("Function expected");
    return w;
  }
  for (var l = n.kind, c = l === "getter" ? "get" : l === "setter" ? "set" : "value", u = !e && t ? n.static ? t : t.prototype : null, d = e || (u ? Object.getOwnPropertyDescriptor(u, n.name) : {}), f, h = !1, v = r.length - 1; v >= 0; v--) {
    var p = {};
    for (var g in n) p[g] = g === "access" ? {} : n[g];
    for (var g in n.access) p.access[g] = n.access[g];
    p.addInitializer = function(w) {
      if (h) throw new TypeError("Cannot add initializers after decoration has completed");
      o.push(i(w || null));
    };
    var m = (0, r[v])(l === "accessor" ? { get: d.get, set: d.set } : d[c], p);
    if (l === "accessor") {
      if (m === void 0) continue;
      if (m === null || typeof m != "object") throw new TypeError("Object expected");
      (f = i(m.get)) && (d.get = f), (f = i(m.set)) && (d.set = f), (f = i(m.init)) && a.unshift(f);
    } else (f = i(m)) && (l === "field" ? a.unshift(f) : d[c] = f);
  }
  u && Object.defineProperty(u, n.name, d), h = !0;
}
function eQ(t, e, r) {
  for (var n = arguments.length > 2, a = 0; a < e.length; a++)
    r = n ? e[a].call(t, r) : e[a].call(t);
  return n ? r : void 0;
}
function tQ(t) {
  return typeof t == "symbol" ? t : "".concat(t);
}
function rQ(t, e, r) {
  return typeof e == "symbol" && (e = e.description ? "[".concat(e.description, "]") : ""), Object.defineProperty(t, "name", { configurable: !0, value: r ? "".concat(r, " ", e) : e });
}
function w6(t, e) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function") return Reflect.metadata(t, e);
}
function y6(t, e, r, n) {
  function a(o) {
    return o instanceof r ? o : new r(function(i) {
      i(o);
    });
  }
  return new (r || (r = Promise))(function(o, i) {
    function l(d) {
      try {
        u(n.next(d));
      } catch (f) {
        i(f);
      }
    }
    function c(d) {
      try {
        u(n.throw(d));
      } catch (f) {
        i(f);
      }
    }
    function u(d) {
      d.done ? o(d.value) : a(d.value).then(l, c);
    }
    u((n = n.apply(t, e || [])).next());
  });
}
function b6(t, e) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, a, o, i;
  return i = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function l(u) {
    return function(d) {
      return c([u, d]);
    };
  }
  function c(u) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; i && (i = 0, u[0] && (r = 0)), r; ) try {
      if (n = 1, a && (o = u[0] & 2 ? a.return : u[0] ? a.throw || ((o = a.return) && o.call(a), 0) : a.next) && !(o = o.call(a, u[1])).done) return o;
      switch (a = 0, o && (u = [u[0] & 2, o.value]), u[0]) {
        case 0:
        case 1:
          o = u;
          break;
        case 4:
          return r.label++, { value: u[1], done: !1 };
        case 5:
          r.label++, a = u[1], u = [0];
          continue;
        case 7:
          u = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            r = 0;
            continue;
          }
          if (u[0] === 3 && (!o || u[1] > o[0] && u[1] < o[3])) {
            r.label = u[1];
            break;
          }
          if (u[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = u;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(u);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      u = e.call(t, r);
    } catch (d) {
      u = [6, d], a = 0;
    } finally {
      n = o = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
var ju = Object.create ? function(t, e, r, n) {
  n === void 0 && (n = r);
  var a = Object.getOwnPropertyDescriptor(e, r);
  (!a || ("get" in a ? !e.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return e[r];
  } }), Object.defineProperty(t, n, a);
} : function(t, e, r, n) {
  n === void 0 && (n = r), t[n] = e[r];
};
function _6(t, e) {
  for (var r in t) r !== "default" && !Object.prototype.hasOwnProperty.call(e, r) && ju(e, t, r);
}
function L0(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], n = 0;
  if (r) return r.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function G2(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r) return t;
  var n = r.call(t), a, o = [], i;
  try {
    for (; (e === void 0 || e-- > 0) && !(a = n.next()).done; ) o.push(a.value);
  } catch (l) {
    i = { error: l };
  } finally {
    try {
      a && !a.done && (r = n.return) && r.call(n);
    } finally {
      if (i) throw i.error;
    }
  }
  return o;
}
function x6() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t = t.concat(G2(arguments[e]));
  return t;
}
function C6() {
  for (var t = 0, e = 0, r = arguments.length; e < r; e++) t += arguments[e].length;
  for (var n = Array(t), a = 0, e = 0; e < r; e++)
    for (var o = arguments[e], i = 0, l = o.length; i < l; i++, a++)
      n[a] = o[i];
  return n;
}
function ys(t, e, r) {
  if (r || arguments.length === 2) for (var n = 0, a = e.length, o; n < a; n++)
    (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return t.concat(o || Array.prototype.slice.call(e));
}
function mi(t) {
  return this instanceof mi ? (this.v = t, this) : new mi(t);
}
function E6(t, e, r) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var n = r.apply(t, e || []), a, o = [];
  return a = {}, i("next"), i("throw"), i("return"), a[Symbol.asyncIterator] = function() {
    return this;
  }, a;
  function i(h) {
    n[h] && (a[h] = function(v) {
      return new Promise(function(p, g) {
        o.push([h, v, p, g]) > 1 || l(h, v);
      });
    });
  }
  function l(h, v) {
    try {
      c(n[h](v));
    } catch (p) {
      f(o[0][3], p);
    }
  }
  function c(h) {
    h.value instanceof mi ? Promise.resolve(h.value.v).then(u, d) : f(o[0][2], h);
  }
  function u(h) {
    l("next", h);
  }
  function d(h) {
    l("throw", h);
  }
  function f(h, v) {
    h(v), o.shift(), o.length && l(o[0][0], o[0][1]);
  }
}
function S6(t) {
  var e, r;
  return e = {}, n("next"), n("throw", function(a) {
    throw a;
  }), n("return"), e[Symbol.iterator] = function() {
    return this;
  }, e;
  function n(a, o) {
    e[a] = t[a] ? function(i) {
      return (r = !r) ? { value: mi(t[a](i)), done: !1 } : o ? o(i) : i;
    } : o;
  }
}
function R6(t) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var e = t[Symbol.asyncIterator], r;
  return e ? e.call(t) : (t = typeof L0 == "function" ? L0(t) : t[Symbol.iterator](), r = {}, n("next"), n("throw"), n("return"), r[Symbol.asyncIterator] = function() {
    return this;
  }, r);
  function n(o) {
    r[o] = t[o] && function(i) {
      return new Promise(function(l, c) {
        i = t[o](i), a(l, c, i.done, i.value);
      });
    };
  }
  function a(o, i, l, c) {
    Promise.resolve(c).then(function(u) {
      o({ value: u, done: l });
    }, i);
  }
}
function M6(t, e) {
  return Object.defineProperty ? Object.defineProperty(t, "raw", { value: e }) : t.raw = e, t;
}
var nQ = Object.create ? function(t, e) {
  Object.defineProperty(t, "default", { enumerable: !0, value: e });
} : function(t, e) {
  t.default = e;
};
function A6(t) {
  if (t && t.__esModule) return t;
  var e = {};
  if (t != null) for (var r in t) r !== "default" && Object.prototype.hasOwnProperty.call(t, r) && ju(e, t, r);
  return nQ(e, t), e;
}
function k6(t) {
  return t && t.__esModule ? t : { default: t };
}
function L6(t, e, r, n) {
  if (r === "a" && !n) throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? t !== e || !n : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r === "m" ? n : r === "a" ? n.call(t) : n ? n.value : e.get(t);
}
function T6(t, e, r, n, a) {
  if (n === "m") throw new TypeError("Private method is not writable");
  if (n === "a" && !a) throw new TypeError("Private accessor was defined without a setter");
  if (typeof e == "function" ? t !== e || !a : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return n === "a" ? a.call(t, r) : a ? a.value = r : e.set(t, r), r;
}
function O6(t, e) {
  if (e === null || typeof e != "object" && typeof e != "function") throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof t == "function" ? e === t : t.has(e);
}
function I6(t, e, r) {
  if (e != null) {
    if (typeof e != "object" && typeof e != "function") throw new TypeError("Object expected.");
    var n;
    if (r) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      n = e[Symbol.asyncDispose];
    }
    if (n === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      n = e[Symbol.dispose];
    }
    if (typeof n != "function") throw new TypeError("Object not disposable.");
    t.stack.push({ value: e, dispose: n, async: r });
  } else r && t.stack.push({ async: !0 });
  return e;
}
var aQ = typeof SuppressedError == "function" ? SuppressedError : function(t, e, r) {
  var n = new Error(r);
  return n.name = "SuppressedError", n.error = t, n.suppressed = e, n;
};
function P6(t) {
  function e(n) {
    t.error = t.hasError ? new aQ(n, t.error, "An error was suppressed during disposal.") : n, t.hasError = !0;
  }
  function r() {
    for (; t.stack.length; ) {
      var n = t.stack.pop();
      try {
        var a = n.dispose && n.dispose.call(n.value);
        if (n.async) return Promise.resolve(a).then(r, function(o) {
          return e(o), r();
        });
      } catch (o) {
        e(o);
      }
    }
    if (t.hasError) throw t.error;
  }
  return r();
}
const oQ = {
  __extends: p6,
  __assign: Ue,
  __rest: Di,
  __decorate: g6,
  __param: m6,
  __metadata: w6,
  __awaiter: y6,
  __generator: b6,
  __createBinding: ju,
  __exportStar: _6,
  __values: L0,
  __read: G2,
  __spread: x6,
  __spreadArrays: C6,
  __spreadArray: ys,
  __await: mi,
  __asyncGenerator: E6,
  __asyncDelegator: S6,
  __asyncValues: R6,
  __makeTemplateObject: M6,
  __importStar: A6,
  __importDefault: k6,
  __classPrivateFieldGet: L6,
  __classPrivateFieldSet: T6,
  __classPrivateFieldIn: O6,
  __addDisposableResource: I6,
  __disposeResources: P6
}, iQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  __addDisposableResource: I6,
  get __assign() {
    return Ue;
  },
  __asyncDelegator: S6,
  __asyncGenerator: E6,
  __asyncValues: R6,
  __await: mi,
  __awaiter: y6,
  __classPrivateFieldGet: L6,
  __classPrivateFieldIn: O6,
  __classPrivateFieldSet: T6,
  __createBinding: ju,
  __decorate: g6,
  __disposeResources: P6,
  __esDecorate: JK,
  __exportStar: _6,
  __extends: p6,
  __generator: b6,
  __importDefault: k6,
  __importStar: A6,
  __makeTemplateObject: M6,
  __metadata: w6,
  __param: m6,
  __propKey: tQ,
  __read: G2,
  __rest: Di,
  __runInitializers: eQ,
  __setFunctionName: rQ,
  __spread: x6,
  __spreadArray: ys,
  __spreadArrays: C6,
  __values: L0,
  default: oQ
}, Symbol.toStringTag, { value: "Module" }));
var i0 = "right-scroll-bar-position", l0 = "width-before-scroll-bar", lQ = "with-scroll-bars-hidden", sQ = "--removed-body-scroll-bar-size";
function S5(t, e) {
  return typeof t == "function" ? t(e) : t && (t.current = e), t;
}
function cQ(t, e) {
  var r = gt(function() {
    return {
      // value
      value: t,
      // last callback
      callback: e,
      // "memoized" public interface
      facade: {
        get current() {
          return r.value;
        },
        set current(n) {
          var a = r.value;
          a !== n && (r.value = n, r.callback(n, a));
        }
      }
    };
  })[0];
  return r.callback = e, r.facade;
}
var uQ = typeof window < "u" ? s.useLayoutEffect : s.useEffect, Ep = /* @__PURE__ */ new WeakMap();
function U2(t, e) {
  var r = cQ(null, function(n) {
    return t.forEach(function(a) {
      return S5(a, n);
    });
  });
  return uQ(function() {
    var n = Ep.get(r);
    if (n) {
      var a = new Set(n), o = new Set(t), i = r.current;
      a.forEach(function(l) {
        o.has(l) || S5(l, null);
      }), o.forEach(function(l) {
        a.has(l) || S5(l, i);
      });
    }
    Ep.set(r, t);
  }, [t]), r;
}
function dQ(t) {
  return t;
}
function fQ(t, e) {
  e === void 0 && (e = dQ);
  var r = [], n = !1, a = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return r.length ? r[r.length - 1] : t;
    },
    useMedium: function(o) {
      var i = e(o, n);
      return r.push(i), function() {
        r = r.filter(function(l) {
          return l !== i;
        });
      };
    },
    assignSyncMedium: function(o) {
      for (n = !0; r.length; ) {
        var i = r;
        r = [], i.forEach(o);
      }
      r = {
        push: function(l) {
          return o(l);
        },
        filter: function() {
          return r;
        }
      };
    },
    assignMedium: function(o) {
      n = !0;
      var i = [];
      if (r.length) {
        var l = r;
        r = [], l.forEach(o), i = r;
      }
      var c = function() {
        var d = i;
        i = [], d.forEach(o);
      }, u = function() {
        return Promise.resolve().then(c);
      };
      u(), r = {
        push: function(d) {
          i.push(d), u();
        },
        filter: function(d) {
          return i = i.filter(d), r;
        }
      };
    }
  };
  return a;
}
function Y2(t) {
  t === void 0 && (t = {});
  var e = fQ(null);
  return e.options = Ue({ async: !0, ssr: !1 }, t), e;
}
var D6 = function(t) {
  var e = t.sideCar, r = Di(t, ["sideCar"]);
  if (!e)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = e.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return s.createElement(n, Ue({}, r));
};
D6.isSideCarExport = !0;
function X2(t, e) {
  return t.useMedium(e), D6;
}
var N6 = Y2(), R5 = function() {
}, Wu = s.forwardRef(function(t, e) {
  var r = s.useRef(null), n = s.useState({
    onScrollCapture: R5,
    onWheelCapture: R5,
    onTouchMoveCapture: R5
  }), a = n[0], o = n[1], i = t.forwardProps, l = t.children, c = t.className, u = t.removeScrollBar, d = t.enabled, f = t.shards, h = t.sideCar, v = t.noIsolation, p = t.inert, g = t.allowPinchZoom, m = t.as, w = m === void 0 ? "div" : m, y = t.gapMode, b = Di(t, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), _ = h, x = U2([r, e]), E = Ue(Ue({}, b), a);
  return s.createElement(
    s.Fragment,
    null,
    d && s.createElement(_, { sideCar: N6, removeScrollBar: u, shards: f, noIsolation: v, inert: p, setCallbacks: o, allowPinchZoom: !!g, lockRef: r, gapMode: y }),
    i ? s.cloneElement(s.Children.only(l), Ue(Ue({}, E), { ref: x })) : s.createElement(w, Ue({}, E, { className: c, ref: x }), l)
  );
});
Wu.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Wu.classNames = {
  fullWidth: l0,
  zeroRight: i0
};
var hQ = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function vQ() {
  if (!document)
    return null;
  var t = document.createElement("style");
  t.type = "text/css";
  var e = hQ();
  return e && t.setAttribute("nonce", e), t;
}
function pQ(t, e) {
  t.styleSheet ? t.styleSheet.cssText = e : t.appendChild(document.createTextNode(e));
}
function gQ(t) {
  var e = document.head || document.getElementsByTagName("head")[0];
  e.appendChild(t);
}
var mQ = function() {
  var t = 0, e = null;
  return {
    add: function(r) {
      t == 0 && (e = vQ()) && (pQ(e, r), gQ(e)), t++;
    },
    remove: function() {
      t--, !t && e && (e.parentNode && e.parentNode.removeChild(e), e = null);
    }
  };
}, wQ = function() {
  var t = mQ();
  return function(e, r) {
    s.useEffect(function() {
      return t.add(e), function() {
        t.remove();
      };
    }, [e && r]);
  };
}, Ni = function() {
  var t = wQ(), e = function(r) {
    var n = r.styles, a = r.dynamic;
    return t(n, a), null;
  };
  return e;
}, yQ = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, M5 = function(t) {
  return parseInt(t || "", 10) || 0;
}, bQ = function(t) {
  var e = window.getComputedStyle(document.body), r = e[t === "padding" ? "paddingLeft" : "marginLeft"], n = e[t === "padding" ? "paddingTop" : "marginTop"], a = e[t === "padding" ? "paddingRight" : "marginRight"];
  return [M5(r), M5(n), M5(a)];
}, _Q = function(t) {
  if (t === void 0 && (t = "margin"), typeof window > "u")
    return yQ;
  var e = bQ(t), r = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: e[0],
    top: e[1],
    right: e[2],
    gap: Math.max(0, n - r + e[2] - e[0])
  };
}, xQ = Ni(), CQ = function(t, e, r, n) {
  var a = t.left, o = t.top, i = t.right, l = t.gap;
  return r === void 0 && (r = "margin"), `
  .`.concat(lQ, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(l, "px ").concat(n, `;
  }
  body {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    e && "position: relative ".concat(n, ";"),
    r === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(o, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(l, "px ").concat(n, `;
    `),
    r === "padding" && "padding-right: ".concat(l, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(i0, ` {
    right: `).concat(l, "px ").concat(n, `;
  }
  
  .`).concat(l0, ` {
    margin-right: `).concat(l, "px ").concat(n, `;
  }
  
  .`).concat(i0, " .").concat(i0, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(l0, " .").concat(l0, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body {
    `).concat(sQ, ": ").concat(l, `px;
  }
`);
}, EQ = function(t) {
  var e = t.noRelative, r = t.noImportant, n = t.gapMode, a = n === void 0 ? "margin" : n, o = s.useMemo(function() {
    return _Q(a);
  }, [a]);
  return s.createElement(xQ, { styles: CQ(o, !e, a, r ? "" : "!important") });
}, Zf = !1;
if (typeof window < "u")
  try {
    var Ks = Object.defineProperty({}, "passive", {
      get: function() {
        return Zf = !0, !0;
      }
    });
    window.addEventListener("test", Ks, Ks), window.removeEventListener("test", Ks, Ks);
  } catch {
    Zf = !1;
  }
var yo = Zf ? { passive: !1 } : !1, SQ = function(t) {
  return t.tagName === "TEXTAREA";
}, B6 = function(t, e) {
  var r = window.getComputedStyle(t);
  return (
    // not-not-scrollable
    r[e] !== "hidden" && // contains scroll inside self
    !(r.overflowY === r.overflowX && !SQ(t) && r[e] === "visible")
  );
}, RQ = function(t) {
  return B6(t, "overflowY");
}, MQ = function(t) {
  return B6(t, "overflowX");
}, Sp = function(t, e) {
  var r = e.ownerDocument, n = e;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var a = F6(t, n);
    if (a) {
      var o = $6(t, n), i = o[1], l = o[2];
      if (i > l)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== r.body);
  return !1;
}, AQ = function(t) {
  var e = t.scrollTop, r = t.scrollHeight, n = t.clientHeight;
  return [
    e,
    r,
    n
  ];
}, kQ = function(t) {
  var e = t.scrollLeft, r = t.scrollWidth, n = t.clientWidth;
  return [
    e,
    r,
    n
  ];
}, F6 = function(t, e) {
  return t === "v" ? RQ(e) : MQ(e);
}, $6 = function(t, e) {
  return t === "v" ? AQ(e) : kQ(e);
}, LQ = function(t, e) {
  return t === "h" && e === "rtl" ? -1 : 1;
}, TQ = function(t, e, r, n, a) {
  var o = LQ(t, window.getComputedStyle(e).direction), i = o * n, l = r.target, c = e.contains(l), u = !1, d = i > 0, f = 0, h = 0;
  do {
    var v = $6(t, l), p = v[0], g = v[1], m = v[2], w = g - m - o * p;
    (p || w) && F6(t, l) && (f += w, h += p), l instanceof ShadowRoot ? l = l.host : l = l.parentNode;
  } while (
    // portaled content
    !c && l !== document.body || // self content
    c && (e.contains(l) || e === l)
  );
  return (d && (Math.abs(f) < 1 || !a) || !d && (Math.abs(h) < 1 || !a)) && (u = !0), u;
}, Qs = function(t) {
  return "changedTouches" in t ? [t.changedTouches[0].clientX, t.changedTouches[0].clientY] : [0, 0];
}, Rp = function(t) {
  return [t.deltaX, t.deltaY];
}, Mp = function(t) {
  return t && "current" in t ? t.current : t;
}, OQ = function(t, e) {
  return t[0] === e[0] && t[1] === e[1];
}, IQ = function(t) {
  return `
  .block-interactivity-`.concat(t, ` {pointer-events: none;}
  .allow-interactivity-`).concat(t, ` {pointer-events: all;}
`);
}, PQ = 0, bo = [];
function DQ(t) {
  var e = s.useRef([]), r = s.useRef([0, 0]), n = s.useRef(), a = s.useState(PQ++)[0], o = s.useState(Ni)[0], i = s.useRef(t);
  s.useEffect(function() {
    i.current = t;
  }, [t]), s.useEffect(function() {
    if (t.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var g = ys([t.lockRef.current], (t.shards || []).map(Mp), !0).filter(Boolean);
      return g.forEach(function(m) {
        return m.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), g.forEach(function(m) {
          return m.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [t.inert, t.lockRef.current, t.shards]);
  var l = s.useCallback(function(g, m) {
    if ("touches" in g && g.touches.length === 2)
      return !i.current.allowPinchZoom;
    var w = Qs(g), y = r.current, b = "deltaX" in g ? g.deltaX : y[0] - w[0], _ = "deltaY" in g ? g.deltaY : y[1] - w[1], x, E = g.target, S = Math.abs(b) > Math.abs(_) ? "h" : "v";
    if ("touches" in g && S === "h" && E.type === "range")
      return !1;
    var M = Sp(S, E);
    if (!M)
      return !0;
    if (M ? x = S : (x = S === "v" ? "h" : "v", M = Sp(S, E)), !M)
      return !1;
    if (!n.current && "changedTouches" in g && (b || _) && (n.current = x), !x)
      return !0;
    var R = n.current || x;
    return TQ(R, m, g, R === "h" ? b : _, !0);
  }, []), c = s.useCallback(function(g) {
    var m = g;
    if (!(!bo.length || bo[bo.length - 1] !== o)) {
      var w = "deltaY" in m ? Rp(m) : Qs(m), y = e.current.filter(function(x) {
        return x.name === m.type && (x.target === m.target || m.target === x.shadowParent) && OQ(x.delta, w);
      })[0];
      if (y && y.should) {
        m.cancelable && m.preventDefault();
        return;
      }
      if (!y) {
        var b = (i.current.shards || []).map(Mp).filter(Boolean).filter(function(x) {
          return x.contains(m.target);
        }), _ = b.length > 0 ? l(m, b[0]) : !i.current.noIsolation;
        _ && m.cancelable && m.preventDefault();
      }
    }
  }, []), u = s.useCallback(function(g, m, w, y) {
    var b = { name: g, delta: m, target: w, should: y, shadowParent: NQ(w) };
    e.current.push(b), setTimeout(function() {
      e.current = e.current.filter(function(_) {
        return _ !== b;
      });
    }, 1);
  }, []), d = s.useCallback(function(g) {
    r.current = Qs(g), n.current = void 0;
  }, []), f = s.useCallback(function(g) {
    u(g.type, Rp(g), g.target, l(g, t.lockRef.current));
  }, []), h = s.useCallback(function(g) {
    u(g.type, Qs(g), g.target, l(g, t.lockRef.current));
  }, []);
  s.useEffect(function() {
    return bo.push(o), t.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", c, yo), document.addEventListener("touchmove", c, yo), document.addEventListener("touchstart", d, yo), function() {
      bo = bo.filter(function(g) {
        return g !== o;
      }), document.removeEventListener("wheel", c, yo), document.removeEventListener("touchmove", c, yo), document.removeEventListener("touchstart", d, yo);
    };
  }, []);
  var v = t.removeScrollBar, p = t.inert;
  return s.createElement(
    s.Fragment,
    null,
    p ? s.createElement(o, { styles: IQ(a) }) : null,
    v ? s.createElement(EQ, { gapMode: t.gapMode }) : null
  );
}
function NQ(t) {
  for (var e = null; t !== null; )
    t instanceof ShadowRoot && (e = t.host, t = t.host), t = t.parentNode;
  return e;
}
const BQ = X2(N6, DQ);
var q2 = s.forwardRef(function(t, e) {
  return s.createElement(Wu, Ue({}, t, { ref: e, sideCar: BQ }));
});
q2.classNames = Wu.classNames;
var FQ = function(t) {
  if (typeof document > "u")
    return null;
  var e = Array.isArray(t) ? t[0] : t;
  return e.ownerDocument.body;
}, _o = /* @__PURE__ */ new WeakMap(), Js = /* @__PURE__ */ new WeakMap(), ec = {}, A5 = 0, V6 = function(t) {
  return t && (t.host || V6(t.parentNode));
}, $Q = function(t, e) {
  return e.map(function(r) {
    if (t.contains(r))
      return r;
    var n = V6(r);
    return n && t.contains(n) ? n : (console.error("aria-hidden", r, "in not contained inside", t, ". Doing nothing"), null);
  }).filter(function(r) {
    return !!r;
  });
}, VQ = function(t, e, r, n) {
  var a = $Q(e, Array.isArray(t) ? t : [t]);
  ec[r] || (ec[r] = /* @__PURE__ */ new WeakMap());
  var o = ec[r], i = [], l = /* @__PURE__ */ new Set(), c = new Set(a), u = function(f) {
    !f || l.has(f) || (l.add(f), u(f.parentNode));
  };
  a.forEach(u);
  var d = function(f) {
    !f || c.has(f) || Array.prototype.forEach.call(f.children, function(h) {
      if (l.has(h))
        d(h);
      else
        try {
          var v = h.getAttribute(n), p = v !== null && v !== "false", g = (_o.get(h) || 0) + 1, m = (o.get(h) || 0) + 1;
          _o.set(h, g), o.set(h, m), i.push(h), g === 1 && p && Js.set(h, !0), m === 1 && h.setAttribute(r, "true"), p || h.setAttribute(n, "true");
        } catch (w) {
          console.error("aria-hidden: cannot operate on ", h, w);
        }
    });
  };
  return d(e), l.clear(), A5++, function() {
    i.forEach(function(f) {
      var h = _o.get(f) - 1, v = o.get(f) - 1;
      _o.set(f, h), o.set(f, v), h || (Js.has(f) || f.removeAttribute(n), Js.delete(f)), v || f.removeAttribute(r);
    }), A5--, A5 || (_o = /* @__PURE__ */ new WeakMap(), _o = /* @__PURE__ */ new WeakMap(), Js = /* @__PURE__ */ new WeakMap(), ec = {});
  };
}, zu = function(t, e, r) {
  r === void 0 && (r = "data-aria-hidden");
  var n = Array.from(Array.isArray(t) ? t : [t]), a = FQ(t);
  return a ? (n.push.apply(n, Array.from(a.querySelectorAll("[aria-live]"))), VQ(n, a, r, "aria-hidden")) : function() {
    return null;
  };
};
const K2 = { asChild: { type: "boolean" } }, k5 = { width: { type: "string", className: "rt-r-w", customProperties: ["--width"], responsive: !0 }, minWidth: { type: "string", className: "rt-r-min-w", customProperties: ["--min-width"], responsive: !0 }, maxWidth: { type: "string", className: "rt-r-max-w", customProperties: ["--max-width"], responsive: !0 } }, Q2 = ["gray", "gold", "bronze", "brown", "yellow", "amber", "orange", "tomato", "red", "ruby", "crimson", "pink", "plum", "purple", "violet", "iris", "indigo", "blue", "cyan", "teal", "jade", "green", "grass", "lime", "mint", "sky"], ZQ = ["auto", "gray", "mauve", "slate", "sage", "olive", "sand"], HQ = { color: { type: "enum", values: Q2, default: void 0 } }, jQ = { color: { type: "enum", values: Q2, default: "" } }, Z6 = { highContrast: { type: "boolean", className: "rt-high-contrast", default: void 0 } }, WQ = ["normal", "start", "end", "both"], zQ = { trim: { type: "enum", className: "rt-r-lt", values: WQ, responsive: !0 } }, GQ = ["left", "center", "right"], UQ = { align: { type: "enum", className: "rt-r-ta", values: GQ, responsive: !0 } }, YQ = ["wrap", "nowrap", "pretty", "balance"], XQ = { wrap: { type: "enum", className: "rt-r-tw", values: YQ, responsive: !0 } }, qQ = { truncate: { type: "boolean", className: "rt-truncate" } }, KQ = ["light", "regular", "medium", "bold"], QQ = { weight: { type: "enum", className: "rt-r-weight", values: KQ, responsive: !0 } }, J2 = ["initial", "xs", "sm", "md", "lg", "xl"];
function H6(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
function Ol(t) {
  return typeof t == "object" && Object.keys(t).some((e) => J2.includes(e));
}
function JQ({ className: t, customProperties: e, ...r }) {
  const n = j6({ allowArbitraryValues: !0, className: t, ...r }), a = eJ({ customProperties: e, ...r });
  return [n, a];
}
function j6({ allowArbitraryValues: t, value: e, className: r, propValues: n, parseValue: a = (o) => o }) {
  const o = [];
  if (e) {
    if (typeof e == "string" && n.includes(e)) return Ap(r, e, a);
    if (Ol(e)) {
      const i = e;
      for (const l in i) {
        if (!H6(i, l) || !J2.includes(l)) continue;
        const c = i[l];
        if (c !== void 0) {
          if (n.includes(c)) {
            const u = Ap(r, c, a), d = l === "initial" ? u : `${l}:${u}`;
            o.push(d);
          } else if (t) {
            const u = l === "initial" ? r : `${l}:${r}`;
            o.push(u);
          }
        }
      }
      return o.join(" ");
    }
    if (t) return r;
  }
}
function Ap(t, e, r) {
  const n = t ? "-" : "", a = r(e), o = a == null ? void 0 : a.startsWith("-"), i = o ? "-" : "", l = o ? a == null ? void 0 : a.substring(1) : a;
  return `${i}${t}${n}${l}`;
}
function eJ({ customProperties: t, value: e, propValues: r, parseValue: n = (a) => a }) {
  let a = {};
  if (!(!e || typeof e == "string" && r.includes(e))) {
    if (typeof e == "string" && (a = Object.fromEntries(t.map((o) => [o, e]))), Ol(e)) {
      const o = e;
      for (const i in o) {
        if (!H6(o, i) || !J2.includes(i)) continue;
        const l = o[i];
        if (!r.includes(l)) for (const c of t) a = { [i === "initial" ? c : `${c}-${i}`]: l, ...a };
      }
    }
    for (const o in a) {
      const i = a[o];
      i !== void 0 && (a[o] = n(i));
    }
    return a;
  }
}
function kp(...t) {
  let e = {};
  for (const r of t) r && (e = { ...e, ...r });
  return Object.keys(e).length ? e : void 0;
}
function tJ(...t) {
  return Object.assign({}, ...t);
}
function ev(t, ...e) {
  let r, n;
  const a = { ...t }, o = tJ(...e);
  for (const i in o) {
    let l = a[i];
    const c = o[i];
    if (c.default !== void 0 && l === void 0 && (l = c.default), c.type === "enum" && ![c.default, ...c.values].includes(l) && !Ol(l) && (l = c.default), a[i] = l, "className" in c && c.className) {
      delete a[i];
      const u = "responsive" in c;
      if (!l || Ol(l) && !u) continue;
      if (Ol(l) && (c.default !== void 0 && l.initial === void 0 && (l.initial = c.default), c.type === "enum" && ([c.default, ...c.values].includes(l.initial) || (l.initial = c.default))), c.type === "enum") {
        const d = j6({ allowArbitraryValues: !1, value: l, className: c.className, propValues: c.values, parseValue: c.parseValue });
        r = Hn(r, d);
        continue;
      }
      if (c.type === "string" || c.type === "enum | string") {
        const d = c.type === "string" ? [] : c.values, [f, h] = JQ({ className: c.className, customProperties: c.customProperties, propValues: d, parseValue: c.parseValue, value: l });
        n = kp(n, h), r = Hn(r, f);
        continue;
      }
      if (c.type === "boolean" && l) {
        r = Hn(r, c.className);
        continue;
      }
    }
  }
  return a.className = Hn(r, t.className), a.style = kp(n, t.style), a;
}
const ya = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "-1", "-2", "-3", "-4", "-5", "-6", "-7", "-8", "-9"], W6 = { m: { type: "enum | string", values: ya, responsive: !0, className: "rt-r-m", customProperties: ["--m"] }, mx: { type: "enum | string", values: ya, responsive: !0, className: "rt-r-mx", customProperties: ["--ml", "--mr"] }, my: { type: "enum | string", values: ya, responsive: !0, className: "rt-r-my", customProperties: ["--mt", "--mb"] }, mt: { type: "enum | string", values: ya, responsive: !0, className: "rt-r-mt", customProperties: ["--mt"] }, mr: { type: "enum | string", values: ya, responsive: !0, className: "rt-r-mr", customProperties: ["--mr"] }, mb: { type: "enum | string", values: ya, responsive: !0, className: "rt-r-mb", customProperties: ["--mb"] }, ml: { type: "enum | string", values: ya, responsive: !0, className: "rt-r-ml", customProperties: ["--ml"] } }, rJ = ["span", "div", "label", "p"], nJ = ["1", "2", "3", "4", "5", "6", "7", "8", "9"], aJ = { as: { type: "enum", values: rJ, default: "span" }, ...K2, size: { type: "enum", className: "rt-r-size", values: nJ, responsive: !0 }, ...QQ, ...UQ, ...zQ, ...qQ, ...XQ, ...HQ, ...Z6 }, z6 = s.forwardRef((t, e) => {
  const { children: r, className: n, asChild: a, as: o = "span", color: i, ...l } = ev(t, aJ, W6);
  return s.createElement(Nr, { "data-accent-color": i, ...l, ref: e, className: Hn("rt-Text", n) }, a ? r : s.createElement(o, null, r));
});
z6.displayName = "Text";
const oJ = ["top", "right", "bottom", "left"], oa = Math.min, Xt = Math.max, T0 = Math.round, tc = Math.floor, ia = (t) => ({
  x: t,
  y: t
}), iJ = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, lJ = {
  start: "end",
  end: "start"
};
function Hf(t, e, r) {
  return Xt(t, oa(e, r));
}
function bn(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function _n(t) {
  return t.split("-")[0];
}
function Bi(t) {
  return t.split("-")[1];
}
function tv(t) {
  return t === "x" ? "y" : "x";
}
function rv(t) {
  return t === "y" ? "height" : "width";
}
function la(t) {
  return ["top", "bottom"].includes(_n(t)) ? "y" : "x";
}
function nv(t) {
  return tv(la(t));
}
function sJ(t, e, r) {
  r === void 0 && (r = !1);
  const n = Bi(t), a = nv(t), o = rv(a);
  let i = a === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return e.reference[o] > e.floating[o] && (i = O0(i)), [i, O0(i)];
}
function cJ(t) {
  const e = O0(t);
  return [jf(t), e, jf(e)];
}
function jf(t) {
  return t.replace(/start|end/g, (e) => lJ[e]);
}
function uJ(t, e, r) {
  const n = ["left", "right"], a = ["right", "left"], o = ["top", "bottom"], i = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return r ? e ? a : n : e ? n : a;
    case "left":
    case "right":
      return e ? o : i;
    default:
      return [];
  }
}
function dJ(t, e, r, n) {
  const a = Bi(t);
  let o = uJ(_n(t), r === "start", n);
  return a && (o = o.map((i) => i + "-" + a), e && (o = o.concat(o.map(jf)))), o;
}
function O0(t) {
  return t.replace(/left|right|bottom|top/g, (e) => iJ[e]);
}
function fJ(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function G6(t) {
  return typeof t != "number" ? fJ(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function I0(t) {
  const {
    x: e,
    y: r,
    width: n,
    height: a
  } = t;
  return {
    width: n,
    height: a,
    top: r,
    left: e,
    right: e + n,
    bottom: r + a,
    x: e,
    y: r
  };
}
function Lp(t, e, r) {
  let {
    reference: n,
    floating: a
  } = t;
  const o = la(e), i = nv(e), l = rv(i), c = _n(e), u = o === "y", d = n.x + n.width / 2 - a.width / 2, f = n.y + n.height / 2 - a.height / 2, h = n[l] / 2 - a[l] / 2;
  let v;
  switch (c) {
    case "top":
      v = {
        x: d,
        y: n.y - a.height
      };
      break;
    case "bottom":
      v = {
        x: d,
        y: n.y + n.height
      };
      break;
    case "right":
      v = {
        x: n.x + n.width,
        y: f
      };
      break;
    case "left":
      v = {
        x: n.x - a.width,
        y: f
      };
      break;
    default:
      v = {
        x: n.x,
        y: n.y
      };
  }
  switch (Bi(e)) {
    case "start":
      v[i] -= h * (r && u ? -1 : 1);
      break;
    case "end":
      v[i] += h * (r && u ? -1 : 1);
      break;
  }
  return v;
}
const hJ = async (t, e, r) => {
  const {
    placement: n = "bottom",
    strategy: a = "absolute",
    middleware: o = [],
    platform: i
  } = r, l = o.filter(Boolean), c = await (i.isRTL == null ? void 0 : i.isRTL(e));
  let u = await i.getElementRects({
    reference: t,
    floating: e,
    strategy: a
  }), {
    x: d,
    y: f
  } = Lp(u, n, c), h = n, v = {}, p = 0;
  for (let g = 0; g < l.length; g++) {
    const {
      name: m,
      fn: w
    } = l[g], {
      x: y,
      y: b,
      data: _,
      reset: x
    } = await w({
      x: d,
      y: f,
      initialPlacement: n,
      placement: h,
      strategy: a,
      middlewareData: v,
      rects: u,
      platform: i,
      elements: {
        reference: t,
        floating: e
      }
    });
    d = y ?? d, f = b ?? f, v = {
      ...v,
      [m]: {
        ...v[m],
        ..._
      }
    }, x && p <= 50 && (p++, typeof x == "object" && (x.placement && (h = x.placement), x.rects && (u = x.rects === !0 ? await i.getElementRects({
      reference: t,
      floating: e,
      strategy: a
    }) : x.rects), {
      x: d,
      y: f
    } = Lp(u, h, c)), g = -1);
  }
  return {
    x: d,
    y: f,
    placement: h,
    strategy: a,
    middlewareData: v
  };
};
async function Wl(t, e) {
  var r;
  e === void 0 && (e = {});
  const {
    x: n,
    y: a,
    platform: o,
    rects: i,
    elements: l,
    strategy: c
  } = t, {
    boundary: u = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: f = "floating",
    altBoundary: h = !1,
    padding: v = 0
  } = bn(e, t), p = G6(v), m = l[h ? f === "floating" ? "reference" : "floating" : f], w = I0(await o.getClippingRect({
    element: (r = await (o.isElement == null ? void 0 : o.isElement(m))) == null || r ? m : m.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(l.floating)),
    boundary: u,
    rootBoundary: d,
    strategy: c
  })), y = f === "floating" ? {
    x: n,
    y: a,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, b = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(l.floating)), _ = await (o.isElement == null ? void 0 : o.isElement(b)) ? await (o.getScale == null ? void 0 : o.getScale(b)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, x = I0(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: y,
    offsetParent: b,
    strategy: c
  }) : y);
  return {
    top: (w.top - x.top + p.top) / _.y,
    bottom: (x.bottom - w.bottom + p.bottom) / _.y,
    left: (w.left - x.left + p.left) / _.x,
    right: (x.right - w.right + p.right) / _.x
  };
}
const vJ = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: r,
      y: n,
      placement: a,
      rects: o,
      platform: i,
      elements: l,
      middlewareData: c
    } = e, {
      element: u,
      padding: d = 0
    } = bn(t, e) || {};
    if (u == null)
      return {};
    const f = G6(d), h = {
      x: r,
      y: n
    }, v = nv(a), p = rv(v), g = await i.getDimensions(u), m = v === "y", w = m ? "top" : "left", y = m ? "bottom" : "right", b = m ? "clientHeight" : "clientWidth", _ = o.reference[p] + o.reference[v] - h[v] - o.floating[p], x = h[v] - o.reference[v], E = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(u));
    let S = E ? E[b] : 0;
    (!S || !await (i.isElement == null ? void 0 : i.isElement(E))) && (S = l.floating[b] || o.floating[p]);
    const M = _ / 2 - x / 2, R = S / 2 - g[p] / 2 - 1, A = oa(f[w], R), k = oa(f[y], R), L = A, T = S - g[p] - k, O = S / 2 - g[p] / 2 + M, D = Hf(L, O, T), P = !c.arrow && Bi(a) != null && O !== D && o.reference[p] / 2 - (O < L ? A : k) - g[p] / 2 < 0, F = P ? O < L ? O - L : O - T : 0;
    return {
      [v]: h[v] + F,
      data: {
        [v]: D,
        centerOffset: O - D - F,
        ...P && {
          alignmentOffset: F
        }
      },
      reset: P
    };
  }
}), pJ = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var r, n;
      const {
        placement: a,
        middlewareData: o,
        rects: i,
        initialPlacement: l,
        platform: c,
        elements: u
      } = e, {
        mainAxis: d = !0,
        crossAxis: f = !0,
        fallbackPlacements: h,
        fallbackStrategy: v = "bestFit",
        fallbackAxisSideDirection: p = "none",
        flipAlignment: g = !0,
        ...m
      } = bn(t, e);
      if ((r = o.arrow) != null && r.alignmentOffset)
        return {};
      const w = _n(a), y = la(l), b = _n(l) === l, _ = await (c.isRTL == null ? void 0 : c.isRTL(u.floating)), x = h || (b || !g ? [O0(l)] : cJ(l)), E = p !== "none";
      !h && E && x.push(...dJ(l, g, p, _));
      const S = [l, ...x], M = await Wl(e, m), R = [];
      let A = ((n = o.flip) == null ? void 0 : n.overflows) || [];
      if (d && R.push(M[w]), f) {
        const O = sJ(a, i, _);
        R.push(M[O[0]], M[O[1]]);
      }
      if (A = [...A, {
        placement: a,
        overflows: R
      }], !R.every((O) => O <= 0)) {
        var k, L;
        const O = (((k = o.flip) == null ? void 0 : k.index) || 0) + 1, D = S[O];
        if (D)
          return {
            data: {
              index: O,
              overflows: A
            },
            reset: {
              placement: D
            }
          };
        let P = (L = A.filter((F) => F.overflows[0] <= 0).sort((F, B) => F.overflows[1] - B.overflows[1])[0]) == null ? void 0 : L.placement;
        if (!P)
          switch (v) {
            case "bestFit": {
              var T;
              const F = (T = A.filter((B) => {
                if (E) {
                  const N = la(B.placement);
                  return N === y || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  N === "y";
                }
                return !0;
              }).map((B) => [B.placement, B.overflows.filter((N) => N > 0).reduce((N, $) => N + $, 0)]).sort((B, N) => B[1] - N[1])[0]) == null ? void 0 : T[0];
              F && (P = F);
              break;
            }
            case "initialPlacement":
              P = l;
              break;
          }
        if (a !== P)
          return {
            reset: {
              placement: P
            }
          };
      }
      return {};
    }
  };
};
function Tp(t, e) {
  return {
    top: t.top - e.height,
    right: t.right - e.width,
    bottom: t.bottom - e.height,
    left: t.left - e.width
  };
}
function Op(t) {
  return oJ.some((e) => t[e] >= 0);
}
const gJ = function(t) {
  return t === void 0 && (t = {}), {
    name: "hide",
    options: t,
    async fn(e) {
      const {
        rects: r
      } = e, {
        strategy: n = "referenceHidden",
        ...a
      } = bn(t, e);
      switch (n) {
        case "referenceHidden": {
          const o = await Wl(e, {
            ...a,
            elementContext: "reference"
          }), i = Tp(o, r.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: Op(i)
            }
          };
        }
        case "escaped": {
          const o = await Wl(e, {
            ...a,
            altBoundary: !0
          }), i = Tp(o, r.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: Op(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function mJ(t, e) {
  const {
    placement: r,
    platform: n,
    elements: a
  } = t, o = await (n.isRTL == null ? void 0 : n.isRTL(a.floating)), i = _n(r), l = Bi(r), c = la(r) === "y", u = ["left", "top"].includes(i) ? -1 : 1, d = o && c ? -1 : 1, f = bn(e, t);
  let {
    mainAxis: h,
    crossAxis: v,
    alignmentAxis: p
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return l && typeof p == "number" && (v = l === "end" ? p * -1 : p), c ? {
    x: v * d,
    y: h * u
  } : {
    x: h * u,
    y: v * d
  };
}
const wJ = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var r, n;
      const {
        x: a,
        y: o,
        placement: i,
        middlewareData: l
      } = e, c = await mJ(e, t);
      return i === ((r = l.offset) == null ? void 0 : r.placement) && (n = l.arrow) != null && n.alignmentOffset ? {} : {
        x: a + c.x,
        y: o + c.y,
        data: {
          ...c,
          placement: i
        }
      };
    }
  };
}, yJ = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: r,
        y: n,
        placement: a
      } = e, {
        mainAxis: o = !0,
        crossAxis: i = !1,
        limiter: l = {
          fn: (m) => {
            let {
              x: w,
              y
            } = m;
            return {
              x: w,
              y
            };
          }
        },
        ...c
      } = bn(t, e), u = {
        x: r,
        y: n
      }, d = await Wl(e, c), f = la(_n(a)), h = tv(f);
      let v = u[h], p = u[f];
      if (o) {
        const m = h === "y" ? "top" : "left", w = h === "y" ? "bottom" : "right", y = v + d[m], b = v - d[w];
        v = Hf(y, v, b);
      }
      if (i) {
        const m = f === "y" ? "top" : "left", w = f === "y" ? "bottom" : "right", y = p + d[m], b = p - d[w];
        p = Hf(y, p, b);
      }
      const g = l.fn({
        ...e,
        [h]: v,
        [f]: p
      });
      return {
        ...g,
        data: {
          x: g.x - r,
          y: g.y - n,
          enabled: {
            [h]: o,
            [f]: i
          }
        }
      };
    }
  };
}, bJ = function(t) {
  return t === void 0 && (t = {}), {
    options: t,
    fn(e) {
      const {
        x: r,
        y: n,
        placement: a,
        rects: o,
        middlewareData: i
      } = e, {
        offset: l = 0,
        mainAxis: c = !0,
        crossAxis: u = !0
      } = bn(t, e), d = {
        x: r,
        y: n
      }, f = la(a), h = tv(f);
      let v = d[h], p = d[f];
      const g = bn(l, e), m = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (c) {
        const b = h === "y" ? "height" : "width", _ = o.reference[h] - o.floating[b] + m.mainAxis, x = o.reference[h] + o.reference[b] - m.mainAxis;
        v < _ ? v = _ : v > x && (v = x);
      }
      if (u) {
        var w, y;
        const b = h === "y" ? "width" : "height", _ = ["top", "left"].includes(_n(a)), x = o.reference[f] - o.floating[b] + (_ && ((w = i.offset) == null ? void 0 : w[f]) || 0) + (_ ? 0 : m.crossAxis), E = o.reference[f] + o.reference[b] + (_ ? 0 : ((y = i.offset) == null ? void 0 : y[f]) || 0) - (_ ? m.crossAxis : 0);
        p < x ? p = x : p > E && (p = E);
      }
      return {
        [h]: v,
        [f]: p
      };
    }
  };
}, _J = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(e) {
      var r, n;
      const {
        placement: a,
        rects: o,
        platform: i,
        elements: l
      } = e, {
        apply: c = () => {
        },
        ...u
      } = bn(t, e), d = await Wl(e, u), f = _n(a), h = Bi(a), v = la(a) === "y", {
        width: p,
        height: g
      } = o.floating;
      let m, w;
      f === "top" || f === "bottom" ? (m = f, w = h === (await (i.isRTL == null ? void 0 : i.isRTL(l.floating)) ? "start" : "end") ? "left" : "right") : (w = f, m = h === "end" ? "top" : "bottom");
      const y = g - d.top - d.bottom, b = p - d.left - d.right, _ = oa(g - d[m], y), x = oa(p - d[w], b), E = !e.middlewareData.shift;
      let S = _, M = x;
      if ((r = e.middlewareData.shift) != null && r.enabled.x && (M = b), (n = e.middlewareData.shift) != null && n.enabled.y && (S = y), E && !h) {
        const A = Xt(d.left, 0), k = Xt(d.right, 0), L = Xt(d.top, 0), T = Xt(d.bottom, 0);
        v ? M = p - 2 * (A !== 0 || k !== 0 ? A + k : Xt(d.left, d.right)) : S = g - 2 * (L !== 0 || T !== 0 ? L + T : Xt(d.top, d.bottom));
      }
      await c({
        ...e,
        availableWidth: M,
        availableHeight: S
      });
      const R = await i.getDimensions(l.floating);
      return p !== R.width || g !== R.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Gu() {
  return typeof window < "u";
}
function Fi(t) {
  return U6(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function Qt(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function rn(t) {
  var e;
  return (e = (U6(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function U6(t) {
  return Gu() ? t instanceof Node || t instanceof Qt(t).Node : !1;
}
function Br(t) {
  return Gu() ? t instanceof Element || t instanceof Qt(t).Element : !1;
}
function en(t) {
  return Gu() ? t instanceof HTMLElement || t instanceof Qt(t).HTMLElement : !1;
}
function Ip(t) {
  return !Gu() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof Qt(t).ShadowRoot;
}
function bs(t) {
  const {
    overflow: e,
    overflowX: r,
    overflowY: n,
    display: a
  } = Fr(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + n + r) && !["inline", "contents"].includes(a);
}
function xJ(t) {
  return ["table", "td", "th"].includes(Fi(t));
}
function Uu(t) {
  return [":popover-open", ":modal"].some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
function av(t) {
  const e = ov(), r = Br(t) ? Fr(t) : t;
  return r.transform !== "none" || r.perspective !== "none" || (r.containerType ? r.containerType !== "normal" : !1) || !e && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !e && (r.filter ? r.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((n) => (r.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (r.contain || "").includes(n));
}
function CJ(t) {
  let e = sa(t);
  for (; en(e) && !wi(e); ) {
    if (av(e))
      return e;
    if (Uu(e))
      return null;
    e = sa(e);
  }
  return null;
}
function ov() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function wi(t) {
  return ["html", "body", "#document"].includes(Fi(t));
}
function Fr(t) {
  return Qt(t).getComputedStyle(t);
}
function Yu(t) {
  return Br(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function sa(t) {
  if (Fi(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    Ip(t) && t.host || // Fallback.
    rn(t)
  );
  return Ip(e) ? e.host : e;
}
function Y6(t) {
  const e = sa(t);
  return wi(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : en(e) && bs(e) ? e : Y6(e);
}
function zl(t, e, r) {
  var n;
  e === void 0 && (e = []), r === void 0 && (r = !0);
  const a = Y6(t), o = a === ((n = t.ownerDocument) == null ? void 0 : n.body), i = Qt(a);
  if (o) {
    const l = Wf(i);
    return e.concat(i, i.visualViewport || [], bs(a) ? a : [], l && r ? zl(l) : []);
  }
  return e.concat(a, zl(a, [], r));
}
function Wf(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function X6(t) {
  const e = Fr(t);
  let r = parseFloat(e.width) || 0, n = parseFloat(e.height) || 0;
  const a = en(t), o = a ? t.offsetWidth : r, i = a ? t.offsetHeight : n, l = T0(r) !== o || T0(n) !== i;
  return l && (r = o, n = i), {
    width: r,
    height: n,
    $: l
  };
}
function iv(t) {
  return Br(t) ? t : t.contextElement;
}
function ni(t) {
  const e = iv(t);
  if (!en(e))
    return ia(1);
  const r = e.getBoundingClientRect(), {
    width: n,
    height: a,
    $: o
  } = X6(e);
  let i = (o ? T0(r.width) : r.width) / n, l = (o ? T0(r.height) : r.height) / a;
  return (!i || !Number.isFinite(i)) && (i = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: i,
    y: l
  };
}
const EJ = /* @__PURE__ */ ia(0);
function q6(t) {
  const e = Qt(t);
  return !ov() || !e.visualViewport ? EJ : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function SJ(t, e, r) {
  return e === void 0 && (e = !1), !r || e && r !== Qt(t) ? !1 : e;
}
function eo(t, e, r, n) {
  e === void 0 && (e = !1), r === void 0 && (r = !1);
  const a = t.getBoundingClientRect(), o = iv(t);
  let i = ia(1);
  e && (n ? Br(n) && (i = ni(n)) : i = ni(t));
  const l = SJ(o, r, n) ? q6(o) : ia(0);
  let c = (a.left + l.x) / i.x, u = (a.top + l.y) / i.y, d = a.width / i.x, f = a.height / i.y;
  if (o) {
    const h = Qt(o), v = n && Br(n) ? Qt(n) : n;
    let p = h, g = Wf(p);
    for (; g && n && v !== p; ) {
      const m = ni(g), w = g.getBoundingClientRect(), y = Fr(g), b = w.left + (g.clientLeft + parseFloat(y.paddingLeft)) * m.x, _ = w.top + (g.clientTop + parseFloat(y.paddingTop)) * m.y;
      c *= m.x, u *= m.y, d *= m.x, f *= m.y, c += b, u += _, p = Qt(g), g = Wf(p);
    }
  }
  return I0({
    width: d,
    height: f,
    x: c,
    y: u
  });
}
function RJ(t) {
  let {
    elements: e,
    rect: r,
    offsetParent: n,
    strategy: a
  } = t;
  const o = a === "fixed", i = rn(n), l = e ? Uu(e.floating) : !1;
  if (n === i || l && o)
    return r;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = ia(1);
  const d = ia(0), f = en(n);
  if ((f || !f && !o) && ((Fi(n) !== "body" || bs(i)) && (c = Yu(n)), en(n))) {
    const h = eo(n);
    u = ni(n), d.x = h.x + n.clientLeft, d.y = h.y + n.clientTop;
  }
  return {
    width: r.width * u.x,
    height: r.height * u.y,
    x: r.x * u.x - c.scrollLeft * u.x + d.x,
    y: r.y * u.y - c.scrollTop * u.y + d.y
  };
}
function MJ(t) {
  return Array.from(t.getClientRects());
}
function zf(t, e) {
  const r = Yu(t).scrollLeft;
  return e ? e.left + r : eo(rn(t)).left + r;
}
function AJ(t) {
  const e = rn(t), r = Yu(t), n = t.ownerDocument.body, a = Xt(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), o = Xt(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight);
  let i = -r.scrollLeft + zf(t);
  const l = -r.scrollTop;
  return Fr(n).direction === "rtl" && (i += Xt(e.clientWidth, n.clientWidth) - a), {
    width: a,
    height: o,
    x: i,
    y: l
  };
}
function kJ(t, e) {
  const r = Qt(t), n = rn(t), a = r.visualViewport;
  let o = n.clientWidth, i = n.clientHeight, l = 0, c = 0;
  if (a) {
    o = a.width, i = a.height;
    const u = ov();
    (!u || u && e === "fixed") && (l = a.offsetLeft, c = a.offsetTop);
  }
  return {
    width: o,
    height: i,
    x: l,
    y: c
  };
}
function LJ(t, e) {
  const r = eo(t, !0, e === "fixed"), n = r.top + t.clientTop, a = r.left + t.clientLeft, o = en(t) ? ni(t) : ia(1), i = t.clientWidth * o.x, l = t.clientHeight * o.y, c = a * o.x, u = n * o.y;
  return {
    width: i,
    height: l,
    x: c,
    y: u
  };
}
function Pp(t, e, r) {
  let n;
  if (e === "viewport")
    n = kJ(t, r);
  else if (e === "document")
    n = AJ(rn(t));
  else if (Br(e))
    n = LJ(e, r);
  else {
    const a = q6(t);
    n = {
      ...e,
      x: e.x - a.x,
      y: e.y - a.y
    };
  }
  return I0(n);
}
function K6(t, e) {
  const r = sa(t);
  return r === e || !Br(r) || wi(r) ? !1 : Fr(r).position === "fixed" || K6(r, e);
}
function TJ(t, e) {
  const r = e.get(t);
  if (r)
    return r;
  let n = zl(t, [], !1).filter((l) => Br(l) && Fi(l) !== "body"), a = null;
  const o = Fr(t).position === "fixed";
  let i = o ? sa(t) : t;
  for (; Br(i) && !wi(i); ) {
    const l = Fr(i), c = av(i);
    !c && l.position === "fixed" && (a = null), (o ? !c && !a : !c && l.position === "static" && !!a && ["absolute", "fixed"].includes(a.position) || bs(i) && !c && K6(t, i)) ? n = n.filter((d) => d !== i) : a = l, i = sa(i);
  }
  return e.set(t, n), n;
}
function OJ(t) {
  let {
    element: e,
    boundary: r,
    rootBoundary: n,
    strategy: a
  } = t;
  const i = [...r === "clippingAncestors" ? Uu(e) ? [] : TJ(e, this._c) : [].concat(r), n], l = i[0], c = i.reduce((u, d) => {
    const f = Pp(e, d, a);
    return u.top = Xt(f.top, u.top), u.right = oa(f.right, u.right), u.bottom = oa(f.bottom, u.bottom), u.left = Xt(f.left, u.left), u;
  }, Pp(e, l, a));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function IJ(t) {
  const {
    width: e,
    height: r
  } = X6(t);
  return {
    width: e,
    height: r
  };
}
function PJ(t, e, r) {
  const n = en(e), a = rn(e), o = r === "fixed", i = eo(t, !0, o, e);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = ia(0);
  if (n || !n && !o)
    if ((Fi(e) !== "body" || bs(a)) && (l = Yu(e)), n) {
      const v = eo(e, !0, o, e);
      c.x = v.x + e.clientLeft, c.y = v.y + e.clientTop;
    } else a && (c.x = zf(a));
  let u = 0, d = 0;
  if (a && !n && !o) {
    const v = a.getBoundingClientRect();
    d = v.top + l.scrollTop, u = v.left + l.scrollLeft - // RTL <body> scrollbar.
    zf(a, v);
  }
  const f = i.left + l.scrollLeft - c.x - u, h = i.top + l.scrollTop - c.y - d;
  return {
    x: f,
    y: h,
    width: i.width,
    height: i.height
  };
}
function L5(t) {
  return Fr(t).position === "static";
}
function Dp(t, e) {
  if (!en(t) || Fr(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let r = t.offsetParent;
  return rn(t) === r && (r = r.ownerDocument.body), r;
}
function Q6(t, e) {
  const r = Qt(t);
  if (Uu(t))
    return r;
  if (!en(t)) {
    let a = sa(t);
    for (; a && !wi(a); ) {
      if (Br(a) && !L5(a))
        return a;
      a = sa(a);
    }
    return r;
  }
  let n = Dp(t, e);
  for (; n && xJ(n) && L5(n); )
    n = Dp(n, e);
  return n && wi(n) && L5(n) && !av(n) ? r : n || CJ(t) || r;
}
const DJ = async function(t) {
  const e = this.getOffsetParent || Q6, r = this.getDimensions, n = await r(t.floating);
  return {
    reference: PJ(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function NJ(t) {
  return Fr(t).direction === "rtl";
}
const BJ = {
  convertOffsetParentRelativeRectToViewportRelativeRect: RJ,
  getDocumentElement: rn,
  getClippingRect: OJ,
  getOffsetParent: Q6,
  getElementRects: DJ,
  getClientRects: MJ,
  getDimensions: IJ,
  getScale: ni,
  isElement: Br,
  isRTL: NJ
};
function FJ(t, e) {
  let r = null, n;
  const a = rn(t);
  function o() {
    var l;
    clearTimeout(n), (l = r) == null || l.disconnect(), r = null;
  }
  function i(l, c) {
    l === void 0 && (l = !1), c === void 0 && (c = 1), o();
    const {
      left: u,
      top: d,
      width: f,
      height: h
    } = t.getBoundingClientRect();
    if (l || e(), !f || !h)
      return;
    const v = tc(d), p = tc(a.clientWidth - (u + f)), g = tc(a.clientHeight - (d + h)), m = tc(u), y = {
      rootMargin: -v + "px " + -p + "px " + -g + "px " + -m + "px",
      threshold: Xt(0, oa(1, c)) || 1
    };
    let b = !0;
    function _(x) {
      const E = x[0].intersectionRatio;
      if (E !== c) {
        if (!b)
          return i();
        E ? i(!1, E) : n = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      b = !1;
    }
    try {
      r = new IntersectionObserver(_, {
        ...y,
        // Handle <iframe>s
        root: a.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(_, y);
    }
    r.observe(t);
  }
  return i(!0), o;
}
function $J(t, e, r, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: a = !0,
    ancestorResize: o = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = n, u = iv(t), d = a || o ? [...u ? zl(u) : [], ...zl(e)] : [];
  d.forEach((w) => {
    a && w.addEventListener("scroll", r, {
      passive: !0
    }), o && w.addEventListener("resize", r);
  });
  const f = u && l ? FJ(u, r) : null;
  let h = -1, v = null;
  i && (v = new ResizeObserver((w) => {
    let [y] = w;
    y && y.target === u && v && (v.unobserve(e), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var b;
      (b = v) == null || b.observe(e);
    })), r();
  }), u && !c && v.observe(u), v.observe(e));
  let p, g = c ? eo(t) : null;
  c && m();
  function m() {
    const w = eo(t);
    g && (w.x !== g.x || w.y !== g.y || w.width !== g.width || w.height !== g.height) && r(), g = w, p = requestAnimationFrame(m);
  }
  return r(), () => {
    var w;
    d.forEach((y) => {
      a && y.removeEventListener("scroll", r), o && y.removeEventListener("resize", r);
    }), f == null || f(), (w = v) == null || w.disconnect(), v = null, c && cancelAnimationFrame(p);
  };
}
const VJ = wJ, ZJ = yJ, HJ = pJ, jJ = _J, WJ = gJ, Np = vJ, zJ = bJ, GJ = (t, e, r) => {
  const n = /* @__PURE__ */ new Map(), a = {
    platform: BJ,
    ...r
  }, o = {
    ...a.platform,
    _c: n
  };
  return hJ(t, e, {
    ...a,
    platform: o
  });
};
var s0 = typeof document < "u" ? CS : En;
function P0(t, e) {
  if (t === e)
    return !0;
  if (typeof t != typeof e)
    return !1;
  if (typeof t == "function" && t.toString() === e.toString())
    return !0;
  let r, n, a;
  if (t && e && typeof t == "object") {
    if (Array.isArray(t)) {
      if (r = t.length, r !== e.length) return !1;
      for (n = r; n-- !== 0; )
        if (!P0(t[n], e[n]))
          return !1;
      return !0;
    }
    if (a = Object.keys(t), r = a.length, r !== Object.keys(e).length)
      return !1;
    for (n = r; n-- !== 0; )
      if (!{}.hasOwnProperty.call(e, a[n]))
        return !1;
    for (n = r; n-- !== 0; ) {
      const o = a[n];
      if (!(o === "_owner" && t.$$typeof) && !P0(t[o], e[o]))
        return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
}
function J6(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Bp(t, e) {
  const r = J6(t);
  return Math.round(e * r) / r;
}
function T5(t) {
  const e = s.useRef(t);
  return s0(() => {
    e.current = t;
  }), e;
}
function UJ(t) {
  t === void 0 && (t = {});
  const {
    placement: e = "bottom",
    strategy: r = "absolute",
    middleware: n = [],
    platform: a,
    elements: {
      reference: o,
      floating: i
    } = {},
    transform: l = !0,
    whileElementsMounted: c,
    open: u
  } = t, [d, f] = s.useState({
    x: 0,
    y: 0,
    strategy: r,
    placement: e,
    middlewareData: {},
    isPositioned: !1
  }), [h, v] = s.useState(n);
  P0(h, n) || v(n);
  const [p, g] = s.useState(null), [m, w] = s.useState(null), y = s.useCallback((B) => {
    B !== E.current && (E.current = B, g(B));
  }, []), b = s.useCallback((B) => {
    B !== S.current && (S.current = B, w(B));
  }, []), _ = o || p, x = i || m, E = s.useRef(null), S = s.useRef(null), M = s.useRef(d), R = c != null, A = T5(c), k = T5(a), L = T5(u), T = s.useCallback(() => {
    if (!E.current || !S.current)
      return;
    const B = {
      placement: e,
      strategy: r,
      middleware: h
    };
    k.current && (B.platform = k.current), GJ(E.current, S.current, B).then((N) => {
      const $ = {
        ...N,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: L.current !== !1
      };
      O.current && !P0(M.current, $) && (M.current = $, gs.flushSync(() => {
        f($);
      }));
    });
  }, [h, e, r, k, L]);
  s0(() => {
    u === !1 && M.current.isPositioned && (M.current.isPositioned = !1, f((B) => ({
      ...B,
      isPositioned: !1
    })));
  }, [u]);
  const O = s.useRef(!1);
  s0(() => (O.current = !0, () => {
    O.current = !1;
  }), []), s0(() => {
    if (_ && (E.current = _), x && (S.current = x), _ && x) {
      if (A.current)
        return A.current(_, x, T);
      T();
    }
  }, [_, x, T, A, R]);
  const D = s.useMemo(() => ({
    reference: E,
    floating: S,
    setReference: y,
    setFloating: b
  }), [y, b]), P = s.useMemo(() => ({
    reference: _,
    floating: x
  }), [_, x]), F = s.useMemo(() => {
    const B = {
      position: r,
      left: 0,
      top: 0
    };
    if (!P.floating)
      return B;
    const N = Bp(P.floating, d.x), $ = Bp(P.floating, d.y);
    return l ? {
      ...B,
      transform: "translate(" + N + "px, " + $ + "px)",
      ...J6(P.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: r,
      left: N,
      top: $
    };
  }, [r, l, P.floating, d.x, d.y]);
  return s.useMemo(() => ({
    ...d,
    update: T,
    refs: D,
    elements: P,
    floatingStyles: F
  }), [d, T, D, P, F]);
}
const YJ = (t) => {
  function e(r) {
    return {}.hasOwnProperty.call(r, "current");
  }
  return {
    name: "arrow",
    options: t,
    fn(r) {
      const {
        element: n,
        padding: a
      } = typeof t == "function" ? t(r) : t;
      return n && e(n) ? n.current != null ? Np({
        element: n.current,
        padding: a
      }).fn(r) : {} : n ? Np({
        element: n,
        padding: a
      }).fn(r) : {};
    }
  };
}, XJ = (t, e) => ({
  ...VJ(t),
  options: [t, e]
}), qJ = (t, e) => ({
  ...ZJ(t),
  options: [t, e]
}), KJ = (t, e) => ({
  ...zJ(t),
  options: [t, e]
}), QJ = (t, e) => ({
  ...HJ(t),
  options: [t, e]
}), JJ = (t, e) => ({
  ...jJ(t),
  options: [t, e]
}), eee = (t, e) => ({
  ...WJ(t),
  options: [t, e]
}), tee = (t, e) => ({
  ...YJ(t),
  options: [t, e]
});
var ree = "Arrow", ey = s.forwardRef((t, e) => {
  const { children: r, width: n = 10, height: a = 5, ...o } = t;
  return /* @__PURE__ */ C(
    te.svg,
    {
      ...o,
      ref: e,
      width: n,
      height: a,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: t.asChild ? r : /* @__PURE__ */ C("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
ey.displayName = ree;
var nee = ey;
function ty(t) {
  const [e, r] = s.useState(void 0);
  return Fe(() => {
    if (t) {
      r({ width: t.offsetWidth, height: t.offsetHeight });
      const n = new ResizeObserver((a) => {
        if (!Array.isArray(a) || !a.length)
          return;
        const o = a[0];
        let i, l;
        if ("borderBoxSize" in o) {
          const c = o.borderBoxSize, u = Array.isArray(c) ? c[0] : c;
          i = u.inlineSize, l = u.blockSize;
        } else
          i = t.offsetWidth, l = t.offsetHeight;
        r({ width: i, height: l });
      });
      return n.observe(t, { box: "border-box" }), () => n.unobserve(t);
    } else
      r(void 0);
  }, [t]), e;
}
var lv = "Popper", [ry, ha] = Sn(lv), [aee, ny] = ry(lv), ay = (t) => {
  const { __scopePopper: e, children: r } = t, [n, a] = s.useState(null);
  return /* @__PURE__ */ C(aee, { scope: e, anchor: n, onAnchorChange: a, children: r });
};
ay.displayName = lv;
var oy = "PopperAnchor", iy = s.forwardRef(
  (t, e) => {
    const { __scopePopper: r, virtualRef: n, ...a } = t, o = ny(oy, r), i = s.useRef(null), l = ce(e, i);
    return s.useEffect(() => {
      o.onAnchorChange((n == null ? void 0 : n.current) || i.current);
    }), n ? null : /* @__PURE__ */ C(te.div, { ...a, ref: l });
  }
);
iy.displayName = oy;
var sv = "PopperContent", [oee, iee] = ry(sv), ly = s.forwardRef(
  (t, e) => {
    var X, me, ve, ae, Y, q;
    const {
      __scopePopper: r,
      side: n = "bottom",
      sideOffset: a = 0,
      align: o = "center",
      alignOffset: i = 0,
      arrowPadding: l = 0,
      avoidCollisions: c = !0,
      collisionBoundary: u = [],
      collisionPadding: d = 0,
      sticky: f = "partial",
      hideWhenDetached: h = !1,
      updatePositionStrategy: v = "optimized",
      onPlaced: p,
      ...g
    } = t, m = ny(sv, r), [w, y] = s.useState(null), b = ce(e, (We) => y(We)), [_, x] = s.useState(null), E = ty(_), S = (E == null ? void 0 : E.width) ?? 0, M = (E == null ? void 0 : E.height) ?? 0, R = n + (o !== "center" ? "-" + o : ""), A = typeof d == "number" ? d : { top: 0, right: 0, bottom: 0, left: 0, ...d }, k = Array.isArray(u) ? u : [u], L = k.length > 0, T = {
      padding: A,
      boundary: k.filter(see),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: L
    }, { refs: O, floatingStyles: D, placement: P, isPositioned: F, middlewareData: B } = UJ({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: R,
      whileElementsMounted: (...We) => $J(...We, {
        animationFrame: v === "always"
      }),
      elements: {
        reference: m.anchor
      },
      middleware: [
        XJ({ mainAxis: a + M, alignmentAxis: i }),
        c && qJ({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? KJ() : void 0,
          ...T
        }),
        c && QJ({ ...T }),
        JJ({
          ...T,
          apply: ({ elements: We, rects: Ne, availableWidth: It, availableHeight: xt }) => {
            const { width: Sr, height: m5 } = Ne.reference, Rr = We.floating.style;
            Rr.setProperty("--radix-popper-available-width", `${It}px`), Rr.setProperty("--radix-popper-available-height", `${xt}px`), Rr.setProperty("--radix-popper-anchor-width", `${Sr}px`), Rr.setProperty("--radix-popper-anchor-height", `${m5}px`);
          }
        }),
        _ && tee({ element: _, padding: l }),
        cee({ arrowWidth: S, arrowHeight: M }),
        h && eee({ strategy: "referenceHidden", ...T })
      ]
    }), [N, $] = uy(P), V = Ke(p);
    Fe(() => {
      F && (V == null || V());
    }, [F, V]);
    const W = (X = B.arrow) == null ? void 0 : X.x, ee = (me = B.arrow) == null ? void 0 : me.y, ne = ((ve = B.arrow) == null ? void 0 : ve.centerOffset) !== 0, [we, pe] = s.useState();
    return Fe(() => {
      w && pe(window.getComputedStyle(w).zIndex);
    }, [w]), /* @__PURE__ */ C(
      "div",
      {
        ref: O.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...D,
          transform: F ? D.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: we,
          "--radix-popper-transform-origin": [
            (ae = B.transformOrigin) == null ? void 0 : ae.x,
            (Y = B.transformOrigin) == null ? void 0 : Y.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((q = B.hide) == null ? void 0 : q.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: t.dir,
        children: /* @__PURE__ */ C(
          oee,
          {
            scope: r,
            placedSide: N,
            onArrowChange: x,
            arrowX: W,
            arrowY: ee,
            shouldHideArrow: ne,
            children: /* @__PURE__ */ C(
              te.div,
              {
                "data-side": N,
                "data-align": $,
                ...g,
                ref: b,
                style: {
                  ...g.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: F ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
ly.displayName = sv;
var sy = "PopperArrow", lee = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, cy = s.forwardRef(function(e, r) {
  const { __scopePopper: n, ...a } = e, o = iee(sy, n), i = lee[o.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ C(
      "span",
      {
        ref: o.onArrowChange,
        style: {
          position: "absolute",
          left: o.arrowX,
          top: o.arrowY,
          [i]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[o.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[o.placedSide],
          visibility: o.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ C(
          nee,
          {
            ...a,
            ref: r,
            style: {
              ...a.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
cy.displayName = sy;
function see(t) {
  return t !== null;
}
var cee = (t) => ({
  name: "transformOrigin",
  options: t,
  fn(e) {
    var m, w, y;
    const { placement: r, rects: n, middlewareData: a } = e, i = ((m = a.arrow) == null ? void 0 : m.centerOffset) !== 0, l = i ? 0 : t.arrowWidth, c = i ? 0 : t.arrowHeight, [u, d] = uy(r), f = { start: "0%", center: "50%", end: "100%" }[d], h = (((w = a.arrow) == null ? void 0 : w.x) ?? 0) + l / 2, v = (((y = a.arrow) == null ? void 0 : y.y) ?? 0) + c / 2;
    let p = "", g = "";
    return u === "bottom" ? (p = i ? f : `${h}px`, g = `${-c}px`) : u === "top" ? (p = i ? f : `${h}px`, g = `${n.floating.height + c}px`) : u === "right" ? (p = `${-c}px`, g = i ? f : `${v}px`) : u === "left" && (p = `${n.floating.width + c}px`, g = i ? f : `${v}px`), { data: { x: p, y: g } };
  }
});
function uy(t) {
  const [e, r = "center"] = t.split("-");
  return [e, r];
}
var Xu = ay, _s = iy, qu = ly, Ku = cy, [Qu, c6e] = Sn("Tooltip", [
  ha
]), Ju = ha(), dy = "TooltipProvider", uee = 700, Gf = "tooltip.open", [dee, cv] = Qu(dy), fy = (t) => {
  const {
    __scopeTooltip: e,
    delayDuration: r = uee,
    skipDelayDuration: n = 300,
    disableHoverableContent: a = !1,
    children: o
  } = t, [i, l] = s.useState(!0), c = s.useRef(!1), u = s.useRef(0);
  return s.useEffect(() => {
    const d = u.current;
    return () => window.clearTimeout(d);
  }, []), /* @__PURE__ */ C(
    dee,
    {
      scope: e,
      isOpenDelayed: i,
      delayDuration: r,
      onOpen: s.useCallback(() => {
        window.clearTimeout(u.current), l(!1);
      }, []),
      onClose: s.useCallback(() => {
        window.clearTimeout(u.current), u.current = window.setTimeout(
          () => l(!0),
          n
        );
      }, [n]),
      isPointerInTransitRef: c,
      onPointerInTransitChange: s.useCallback((d) => {
        c.current = d;
      }, []),
      disableHoverableContent: a,
      children: o
    }
  );
};
fy.displayName = dy;
var e1 = "Tooltip", [fee, xs] = Qu(e1), hy = (t) => {
  const {
    __scopeTooltip: e,
    children: r,
    open: n,
    defaultOpen: a = !1,
    onOpenChange: o,
    disableHoverableContent: i,
    delayDuration: l
  } = t, c = cv(e1, t.__scopeTooltip), u = Ju(e), [d, f] = s.useState(null), h = Kt(), v = s.useRef(0), p = i ?? c.disableHoverableContent, g = l ?? c.delayDuration, m = s.useRef(!1), [w = !1, y] = mr({
    prop: n,
    defaultProp: a,
    onChange: (S) => {
      S ? (c.onOpen(), document.dispatchEvent(new CustomEvent(Gf))) : c.onClose(), o == null || o(S);
    }
  }), b = s.useMemo(() => w ? m.current ? "delayed-open" : "instant-open" : "closed", [w]), _ = s.useCallback(() => {
    window.clearTimeout(v.current), m.current = !1, y(!0);
  }, [y]), x = s.useCallback(() => {
    window.clearTimeout(v.current), y(!1);
  }, [y]), E = s.useCallback(() => {
    window.clearTimeout(v.current), v.current = window.setTimeout(() => {
      m.current = !0, y(!0);
    }, g);
  }, [g, y]);
  return s.useEffect(() => () => window.clearTimeout(v.current), []), /* @__PURE__ */ C(Xu, { ...u, children: /* @__PURE__ */ C(
    fee,
    {
      scope: e,
      contentId: h,
      open: w,
      stateAttribute: b,
      trigger: d,
      onTriggerChange: f,
      onTriggerEnter: s.useCallback(() => {
        c.isOpenDelayed ? E() : _();
      }, [c.isOpenDelayed, E, _]),
      onTriggerLeave: s.useCallback(() => {
        p ? x() : window.clearTimeout(v.current);
      }, [x, p]),
      onOpen: _,
      onClose: x,
      disableHoverableContent: p,
      children: r
    }
  ) });
};
hy.displayName = e1;
var Uf = "TooltipTrigger", vy = s.forwardRef(
  (t, e) => {
    const { __scopeTooltip: r, ...n } = t, a = xs(Uf, r), o = cv(Uf, r), i = Ju(r), l = s.useRef(null), c = ce(e, l, a.onTriggerChange), u = s.useRef(!1), d = s.useRef(!1), f = s.useCallback(() => u.current = !1, []);
    return s.useEffect(() => () => document.removeEventListener("pointerup", f), [f]), /* @__PURE__ */ C(_s, { asChild: !0, ...i, children: /* @__PURE__ */ C(
      te.button,
      {
        "aria-describedby": a.open ? a.contentId : void 0,
        "data-state": a.stateAttribute,
        ...n,
        ref: c,
        onPointerMove: j(t.onPointerMove, (h) => {
          h.pointerType !== "touch" && !d.current && !o.isPointerInTransitRef.current && (a.onTriggerEnter(), d.current = !0);
        }),
        onPointerLeave: j(t.onPointerLeave, () => {
          a.onTriggerLeave(), d.current = !1;
        }),
        onPointerDown: j(t.onPointerDown, () => {
          u.current = !0, document.addEventListener("pointerup", f, { once: !0 });
        }),
        onFocus: j(t.onFocus, () => {
          u.current || a.onOpen();
        }),
        onBlur: j(t.onBlur, a.onClose),
        onClick: j(t.onClick, a.onClose)
      }
    ) });
  }
);
vy.displayName = Uf;
var uv = "TooltipPortal", [hee, vee] = Qu(uv, {
  forceMount: void 0
}), py = (t) => {
  const { __scopeTooltip: e, forceMount: r, children: n, container: a } = t, o = xs(uv, e);
  return /* @__PURE__ */ C(hee, { scope: e, forceMount: r, children: /* @__PURE__ */ C(Hu, { present: r || o.open, children: /* @__PURE__ */ C(z2, { asChild: !0, container: a, children: n }) }) });
};
py.displayName = uv;
var yi = "TooltipContent", gy = s.forwardRef(
  (t, e) => {
    const r = vee(yi, t.__scopeTooltip), { forceMount: n = r.forceMount, side: a = "top", ...o } = t, i = xs(yi, t.__scopeTooltip);
    return /* @__PURE__ */ C(Hu, { present: n || i.open, children: i.disableHoverableContent ? /* @__PURE__ */ C(my, { side: a, ...o, ref: e }) : /* @__PURE__ */ C(pee, { side: a, ...o, ref: e }) });
  }
), pee = s.forwardRef((t, e) => {
  const r = xs(yi, t.__scopeTooltip), n = cv(yi, t.__scopeTooltip), a = s.useRef(null), o = ce(e, a), [i, l] = s.useState(null), { trigger: c, onClose: u } = r, d = a.current, { onPointerInTransitChange: f } = n, h = s.useCallback(() => {
    l(null), f(!1);
  }, [f]), v = s.useCallback(
    (p, g) => {
      const m = p.currentTarget, w = { x: p.clientX, y: p.clientY }, y = wee(w, m.getBoundingClientRect()), b = yee(w, y), _ = bee(g.getBoundingClientRect()), x = xee([...b, ..._]);
      l(x), f(!0);
    },
    [f]
  );
  return s.useEffect(() => () => h(), [h]), s.useEffect(() => {
    if (c && d) {
      const p = (m) => v(m, d), g = (m) => v(m, c);
      return c.addEventListener("pointerleave", p), d.addEventListener("pointerleave", g), () => {
        c.removeEventListener("pointerleave", p), d.removeEventListener("pointerleave", g);
      };
    }
  }, [c, d, v, h]), s.useEffect(() => {
    if (i) {
      const p = (g) => {
        const m = g.target, w = { x: g.clientX, y: g.clientY }, y = (c == null ? void 0 : c.contains(m)) || (d == null ? void 0 : d.contains(m)), b = !_ee(w, i);
        y ? h() : b && (h(), u());
      };
      return document.addEventListener("pointermove", p), () => document.removeEventListener("pointermove", p);
    }
  }, [c, d, i, u, h]), /* @__PURE__ */ C(my, { ...t, ref: o });
}), [gee, mee] = Qu(e1, { isInside: !1 }), my = s.forwardRef(
  (t, e) => {
    const {
      __scopeTooltip: r,
      children: n,
      "aria-label": a,
      onEscapeKeyDown: o,
      onPointerDownOutside: i,
      ...l
    } = t, c = xs(yi, r), u = Ju(r), { onClose: d } = c;
    return s.useEffect(() => (document.addEventListener(Gf, d), () => document.removeEventListener(Gf, d)), [d]), s.useEffect(() => {
      if (c.trigger) {
        const f = (h) => {
          const v = h.target;
          v != null && v.contains(c.trigger) && d();
        };
        return window.addEventListener("scroll", f, { capture: !0 }), () => window.removeEventListener("scroll", f, { capture: !0 });
      }
    }, [c.trigger, d]), /* @__PURE__ */ C(
      Zu,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: o,
        onPointerDownOutside: i,
        onFocusOutside: (f) => f.preventDefault(),
        onDismiss: d,
        children: /* @__PURE__ */ Z(
          qu,
          {
            "data-state": c.stateAttribute,
            ...u,
            ...l,
            ref: e,
            style: {
              ...l.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ C(Jw, { children: n }),
              /* @__PURE__ */ C(gee, { scope: r, isInside: !0, children: /* @__PURE__ */ C(OK, { id: c.contentId, role: "tooltip", children: a || n }) })
            ]
          }
        )
      }
    );
  }
);
gy.displayName = yi;
var wy = "TooltipArrow", yy = s.forwardRef(
  (t, e) => {
    const { __scopeTooltip: r, ...n } = t, a = Ju(r);
    return mee(
      wy,
      r
    ).isInside ? null : /* @__PURE__ */ C(Ku, { ...a, ...n, ref: e });
  }
);
yy.displayName = wy;
function wee(t, e) {
  const r = Math.abs(e.top - t.y), n = Math.abs(e.bottom - t.y), a = Math.abs(e.right - t.x), o = Math.abs(e.left - t.x);
  switch (Math.min(r, n, a, o)) {
    case o:
      return "left";
    case a:
      return "right";
    case r:
      return "top";
    case n:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function yee(t, e, r = 5) {
  const n = [];
  switch (e) {
    case "top":
      n.push(
        { x: t.x - r, y: t.y + r },
        { x: t.x + r, y: t.y + r }
      );
      break;
    case "bottom":
      n.push(
        { x: t.x - r, y: t.y - r },
        { x: t.x + r, y: t.y - r }
      );
      break;
    case "left":
      n.push(
        { x: t.x + r, y: t.y - r },
        { x: t.x + r, y: t.y + r }
      );
      break;
    case "right":
      n.push(
        { x: t.x - r, y: t.y - r },
        { x: t.x - r, y: t.y + r }
      );
      break;
  }
  return n;
}
function bee(t) {
  const { top: e, right: r, bottom: n, left: a } = t;
  return [
    { x: a, y: e },
    { x: r, y: e },
    { x: r, y: n },
    { x: a, y: n }
  ];
}
function _ee(t, e) {
  const { x: r, y: n } = t;
  let a = !1;
  for (let o = 0, i = e.length - 1; o < e.length; i = o++) {
    const l = e[o].x, c = e[o].y, u = e[i].x, d = e[i].y;
    c > n != d > n && r < (u - l) * (n - c) / (d - c) + l && (a = !a);
  }
  return a;
}
function xee(t) {
  const e = t.slice();
  return e.sort((r, n) => r.x < n.x ? -1 : r.x > n.x ? 1 : r.y < n.y ? -1 : r.y > n.y ? 1 : 0), Cee(e);
}
function Cee(t) {
  if (t.length <= 1) return t.slice();
  const e = [];
  for (let n = 0; n < t.length; n++) {
    const a = t[n];
    for (; e.length >= 2; ) {
      const o = e[e.length - 1], i = e[e.length - 2];
      if ((o.x - i.x) * (a.y - i.y) >= (o.y - i.y) * (a.x - i.x)) e.pop();
      else break;
    }
    e.push(a);
  }
  e.pop();
  const r = [];
  for (let n = t.length - 1; n >= 0; n--) {
    const a = t[n];
    for (; r.length >= 2; ) {
      const o = r[r.length - 1], i = r[r.length - 2];
      if ((o.x - i.x) * (a.y - i.y) >= (o.y - i.y) * (a.x - i.x)) r.pop();
      else break;
    }
    r.push(a);
  }
  return r.pop(), e.length === 1 && r.length === 1 && e[0].x === r[0].x && e[0].y === r[0].y ? e : e.concat(r);
}
var by = fy, _y = hy, xy = vy, Cy = py, Ey = gy, Sy = yy, Ry = s.createContext(void 0), Eee = (t) => {
  const { dir: e, children: r } = t;
  return /* @__PURE__ */ C(Ry.Provider, { value: e, children: r });
};
function $i(t) {
  const e = s.useContext(Ry);
  return t || e || "ltr";
}
function See(t) {
  switch (t) {
    case "tomato":
    case "red":
    case "ruby":
    case "crimson":
    case "pink":
    case "plum":
    case "purple":
    case "violet":
      return "mauve";
    case "iris":
    case "indigo":
    case "blue":
    case "sky":
    case "cyan":
      return "slate";
    case "teal":
    case "jade":
    case "mint":
    case "green":
      return "sage";
    case "grass":
    case "lime":
      return "olive";
    case "yellow":
    case "amber":
    case "orange":
    case "brown":
    case "gold":
    case "bronze":
      return "sand";
    case "gray":
      return "gray";
  }
}
const My = ["none", "small", "medium", "large", "full"], Ree = { radius: { type: "enum", values: My, default: void 0 } }, Mee = ["inherit", "light", "dark"], Aee = ["solid", "translucent"], kee = ["90%", "95%", "100%", "105%", "110%"], Yt = { ...K2, hasBackground: { type: "boolean", default: !0 }, appearance: { type: "enum", values: Mee, default: "inherit" }, accentColor: { type: "enum", values: Q2, default: "indigo" }, grayColor: { type: "enum", values: ZQ, default: "auto" }, panelBackground: { type: "enum", values: Aee, default: "translucent" }, radius: { type: "enum", values: My, default: "medium" }, scaling: { type: "enum", values: kee, default: "100%" } }, xo = () => {
}, Yf = s.createContext(void 0), t1 = s.forwardRef((t, e) => s.useContext(Yf) === void 0 ? s.createElement(by, { delayDuration: 200 }, s.createElement(Eee, { dir: "ltr" }, s.createElement(Ay, { ...t, ref: e }))) : s.createElement(dv, { ...t, ref: e }));
t1.displayName = "Theme";
const Ay = s.forwardRef((t, e) => {
  const { appearance: r = Yt.appearance.default, accentColor: n = Yt.accentColor.default, grayColor: a = Yt.grayColor.default, panelBackground: o = Yt.panelBackground.default, radius: i = Yt.radius.default, scaling: l = Yt.scaling.default, hasBackground: c = Yt.hasBackground.default, ...u } = t, [d, f] = s.useState(r);
  s.useEffect(() => f(r), [r]);
  const [h, v] = s.useState(n);
  s.useEffect(() => v(n), [n]);
  const [p, g] = s.useState(a);
  s.useEffect(() => g(a), [a]);
  const [m, w] = s.useState(o);
  s.useEffect(() => w(o), [o]);
  const [y, b] = s.useState(i);
  s.useEffect(() => b(i), [i]);
  const [_, x] = s.useState(l);
  return s.useEffect(() => x(l), [l]), s.createElement(dv, { ...u, ref: e, isRoot: !0, hasBackground: c, appearance: d, accentColor: h, grayColor: p, panelBackground: m, radius: y, scaling: _, onAppearanceChange: f, onAccentColorChange: v, onGrayColorChange: g, onPanelBackgroundChange: w, onRadiusChange: b, onScalingChange: x });
});
Ay.displayName = "ThemeRoot";
const dv = s.forwardRef((t, e) => {
  const r = s.useContext(Yf), { asChild: n, isRoot: a, hasBackground: o, appearance: i = (r == null ? void 0 : r.appearance) ?? Yt.appearance.default, accentColor: l = (r == null ? void 0 : r.accentColor) ?? Yt.accentColor.default, grayColor: c = (r == null ? void 0 : r.resolvedGrayColor) ?? Yt.grayColor.default, panelBackground: u = (r == null ? void 0 : r.panelBackground) ?? Yt.panelBackground.default, radius: d = (r == null ? void 0 : r.radius) ?? Yt.radius.default, scaling: f = (r == null ? void 0 : r.scaling) ?? Yt.scaling.default, onAppearanceChange: h = xo, onAccentColorChange: v = xo, onGrayColorChange: p = xo, onPanelBackgroundChange: g = xo, onRadiusChange: m = xo, onScalingChange: w = xo, ...y } = t, b = n ? Nr : "div", _ = c === "auto" ? See(l) : c, x = t.appearance === "light" || t.appearance === "dark", E = o === void 0 ? a || x : o;
  return s.createElement(Yf.Provider, { value: s.useMemo(() => ({ appearance: i, accentColor: l, grayColor: c, resolvedGrayColor: _, panelBackground: u, radius: d, scaling: f, onAppearanceChange: h, onAccentColorChange: v, onGrayColorChange: p, onPanelBackgroundChange: g, onRadiusChange: m, onScalingChange: w }), [i, l, c, _, u, d, f, h, v, p, g, m, w]) }, s.createElement(b, { "data-is-root-theme": a ? "true" : "false", "data-accent-color": l, "data-gray-color": _, "data-has-background": E ? "true" : "false", "data-panel-background": u, "data-radius": d, "data-scaling": f, ref: e, ...y, className: Hn("radix-themes", { light: i === "light", dark: i === "dark" }, y.className) }));
});
dv.displayName = "ThemeImpl";
const Lee = ["1", "2", "3"], Tee = ["solid", "soft", "surface", "outline"], Oee = { ...K2, size: { type: "enum", className: "rt-r-size", values: Lee, default: "1", responsive: !0 }, variant: { type: "enum", className: "rt-variant", values: Tee, default: "soft" }, ...jQ, ...Z6, ...Ree }, ky = s.forwardRef((t, e) => {
  const { asChild: r, className: n, color: a, radius: o, ...i } = ev(t, Oee, W6);
  return s.createElement(r ? Nr : "span", { "data-accent-color": a, "data-radius": o, ...i, ref: e, className: Hn("rt-reset", "rt-Badge", n) });
});
ky.displayName = "Badge";
function Ly(t) {
  const e = s.useRef({ value: t, previous: t });
  return s.useMemo(() => (e.current.value !== t && (e.current.previous = e.current.value, e.current.value = t), e.current.previous), [t]);
}
function r1(t) {
  const e = t + "CollectionProvider", [r, n] = Sn(e), [a, o] = r(
    e,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (v) => {
    const { scope: p, children: g } = v, m = ke.useRef(null), w = ke.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ C(a, { scope: p, itemMap: w, collectionRef: m, children: g });
  };
  i.displayName = e;
  const l = t + "CollectionSlot", c = ke.forwardRef(
    (v, p) => {
      const { scope: g, children: m } = v, w = o(l, g), y = ce(p, w.collectionRef);
      return /* @__PURE__ */ C(Nr, { ref: y, children: m });
    }
  );
  c.displayName = l;
  const u = t + "CollectionItemSlot", d = "data-radix-collection-item", f = ke.forwardRef(
    (v, p) => {
      const { scope: g, children: m, ...w } = v, y = ke.useRef(null), b = ce(p, y), _ = o(u, g);
      return ke.useEffect(() => (_.itemMap.set(y, { ref: y, ...w }), () => void _.itemMap.delete(y))), /* @__PURE__ */ C(Nr, { [d]: "", ref: b, children: m });
    }
  );
  f.displayName = u;
  function h(v) {
    const p = o(t + "CollectionConsumer", v);
    return ke.useCallback(() => {
      const m = p.collectionRef.current;
      if (!m) return [];
      const w = Array.from(m.querySelectorAll(`[${d}]`));
      return Array.from(p.itemMap.values()).sort(
        (_, x) => w.indexOf(_.ref.current) - w.indexOf(x.ref.current)
      );
    }, [p.collectionRef, p.itemMap]);
  }
  return [
    { Provider: i, Slot: c, ItemSlot: f },
    h,
    n
  ];
}
var O5 = "rovingFocusGroup.onEntryFocus", Iee = { bubbles: !1, cancelable: !0 }, n1 = "RovingFocusGroup", [Xf, Ty, Pee] = r1(n1), [Dee, Vi] = Sn(
  n1,
  [Pee]
), [Nee, Bee] = Dee(n1), Oy = s.forwardRef(
  (t, e) => /* @__PURE__ */ C(Xf.Provider, { scope: t.__scopeRovingFocusGroup, children: /* @__PURE__ */ C(Xf.Slot, { scope: t.__scopeRovingFocusGroup, children: /* @__PURE__ */ C(Fee, { ...t, ref: e }) }) })
);
Oy.displayName = n1;
var Fee = s.forwardRef((t, e) => {
  const {
    __scopeRovingFocusGroup: r,
    orientation: n,
    loop: a = !1,
    dir: o,
    currentTabStopId: i,
    defaultCurrentTabStopId: l,
    onCurrentTabStopIdChange: c,
    onEntryFocus: u,
    preventScrollOnEntryFocus: d = !1,
    ...f
  } = t, h = s.useRef(null), v = ce(e, h), p = $i(o), [g = null, m] = mr({
    prop: i,
    defaultProp: l,
    onChange: c
  }), [w, y] = s.useState(!1), b = Ke(u), _ = Ty(r), x = s.useRef(!1), [E, S] = s.useState(0);
  return s.useEffect(() => {
    const M = h.current;
    if (M)
      return M.addEventListener(O5, b), () => M.removeEventListener(O5, b);
  }, [b]), /* @__PURE__ */ C(
    Nee,
    {
      scope: r,
      orientation: n,
      dir: p,
      loop: a,
      currentTabStopId: g,
      onItemFocus: s.useCallback(
        (M) => m(M),
        [m]
      ),
      onItemShiftTab: s.useCallback(() => y(!0), []),
      onFocusableItemAdd: s.useCallback(
        () => S((M) => M + 1),
        []
      ),
      onFocusableItemRemove: s.useCallback(
        () => S((M) => M - 1),
        []
      ),
      children: /* @__PURE__ */ C(
        te.div,
        {
          tabIndex: w || E === 0 ? -1 : 0,
          "data-orientation": n,
          ...f,
          ref: v,
          style: { outline: "none", ...t.style },
          onMouseDown: j(t.onMouseDown, () => {
            x.current = !0;
          }),
          onFocus: j(t.onFocus, (M) => {
            const R = !x.current;
            if (M.target === M.currentTarget && R && !w) {
              const A = new CustomEvent(O5, Iee);
              if (M.currentTarget.dispatchEvent(A), !A.defaultPrevented) {
                const k = _().filter((P) => P.focusable), L = k.find((P) => P.active), T = k.find((P) => P.id === g), D = [L, T, ...k].filter(
                  Boolean
                ).map((P) => P.ref.current);
                Dy(D, d);
              }
            }
            x.current = !1;
          }),
          onBlur: j(t.onBlur, () => y(!1))
        }
      )
    }
  );
}), Iy = "RovingFocusGroupItem", Py = s.forwardRef(
  (t, e) => {
    const {
      __scopeRovingFocusGroup: r,
      focusable: n = !0,
      active: a = !1,
      tabStopId: o,
      ...i
    } = t, l = Kt(), c = o || l, u = Bee(Iy, r), d = u.currentTabStopId === c, f = Ty(r), { onFocusableItemAdd: h, onFocusableItemRemove: v } = u;
    return s.useEffect(() => {
      if (n)
        return h(), () => v();
    }, [n, h, v]), /* @__PURE__ */ C(
      Xf.ItemSlot,
      {
        scope: r,
        id: c,
        focusable: n,
        active: a,
        children: /* @__PURE__ */ C(
          te.span,
          {
            tabIndex: d ? 0 : -1,
            "data-orientation": u.orientation,
            ...i,
            ref: e,
            onMouseDown: j(t.onMouseDown, (p) => {
              n ? u.onItemFocus(c) : p.preventDefault();
            }),
            onFocus: j(t.onFocus, () => u.onItemFocus(c)),
            onKeyDown: j(t.onKeyDown, (p) => {
              if (p.key === "Tab" && p.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (p.target !== p.currentTarget) return;
              const g = Zee(p, u.orientation, u.dir);
              if (g !== void 0) {
                if (p.metaKey || p.ctrlKey || p.altKey || p.shiftKey) return;
                p.preventDefault();
                let w = f().filter((y) => y.focusable).map((y) => y.ref.current);
                if (g === "last") w.reverse();
                else if (g === "prev" || g === "next") {
                  g === "prev" && w.reverse();
                  const y = w.indexOf(p.currentTarget);
                  w = u.loop ? Hee(w, y + 1) : w.slice(y + 1);
                }
                setTimeout(() => Dy(w));
              }
            })
          }
        )
      }
    );
  }
);
Py.displayName = Iy;
var $ee = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Vee(t, e) {
  return e !== "rtl" ? t : t === "ArrowLeft" ? "ArrowRight" : t === "ArrowRight" ? "ArrowLeft" : t;
}
function Zee(t, e, r) {
  const n = Vee(t.key, r);
  if (!(e === "vertical" && ["ArrowLeft", "ArrowRight"].includes(n)) && !(e === "horizontal" && ["ArrowUp", "ArrowDown"].includes(n)))
    return $ee[n];
}
function Dy(t, e = !1) {
  const r = document.activeElement;
  for (const n of t)
    if (n === r || (n.focus({ preventScroll: e }), document.activeElement !== r)) return;
}
function Hee(t, e) {
  return t.map((r, n) => t[(e + n) % t.length]);
}
var fv = Oy, hv = Py;
function qf(t, [e, r]) {
  return Math.min(r, Math.max(e, t));
}
var vv = "Popover", [Ny, u6e] = Sn(vv, [
  ha
]), Cs = ha(), [jee, ho] = Ny(vv), By = (t) => {
  const {
    __scopePopover: e,
    children: r,
    open: n,
    defaultOpen: a,
    onOpenChange: o,
    modal: i = !1
  } = t, l = Cs(e), c = s.useRef(null), [u, d] = s.useState(!1), [f = !1, h] = mr({
    prop: n,
    defaultProp: a,
    onChange: o
  });
  return /* @__PURE__ */ C(Xu, { ...l, children: /* @__PURE__ */ C(
    jee,
    {
      scope: e,
      contentId: Kt(),
      triggerRef: c,
      open: f,
      onOpenChange: h,
      onOpenToggle: s.useCallback(() => h((v) => !v), [h]),
      hasCustomAnchor: u,
      onCustomAnchorAdd: s.useCallback(() => d(!0), []),
      onCustomAnchorRemove: s.useCallback(() => d(!1), []),
      modal: i,
      children: r
    }
  ) });
};
By.displayName = vv;
var Fy = "PopoverAnchor", Wee = s.forwardRef(
  (t, e) => {
    const { __scopePopover: r, ...n } = t, a = ho(Fy, r), o = Cs(r), { onCustomAnchorAdd: i, onCustomAnchorRemove: l } = a;
    return s.useEffect(() => (i(), () => l()), [i, l]), /* @__PURE__ */ C(_s, { ...o, ...n, ref: e });
  }
);
Wee.displayName = Fy;
var $y = "PopoverTrigger", Vy = s.forwardRef(
  (t, e) => {
    const { __scopePopover: r, ...n } = t, a = ho($y, r), o = Cs(r), i = ce(e, a.triggerRef), l = /* @__PURE__ */ C(
      te.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": a.open,
        "aria-controls": a.contentId,
        "data-state": Wy(a.open),
        ...n,
        ref: i,
        onClick: j(t.onClick, a.onOpenToggle)
      }
    );
    return a.hasCustomAnchor ? l : /* @__PURE__ */ C(_s, { asChild: !0, ...o, children: l });
  }
);
Vy.displayName = $y;
var zee = "PopoverPortal", [d6e, Gee] = Ny(zee, {
  forceMount: void 0
}), bi = "PopoverContent", Zy = s.forwardRef(
  (t, e) => {
    const r = Gee(bi, t.__scopePopover), { forceMount: n = r.forceMount, ...a } = t, o = ho(bi, t.__scopePopover);
    return /* @__PURE__ */ C(Hu, { present: n || o.open, children: o.modal ? /* @__PURE__ */ C(Uee, { ...a, ref: e }) : /* @__PURE__ */ C(Yee, { ...a, ref: e }) });
  }
);
Zy.displayName = bi;
var Uee = s.forwardRef(
  (t, e) => {
    const r = ho(bi, t.__scopePopover), n = s.useRef(null), a = ce(e, n), o = s.useRef(!1);
    return s.useEffect(() => {
      const i = n.current;
      if (i) return zu(i);
    }, []), /* @__PURE__ */ C(q2, { as: Nr, allowPinchZoom: !0, children: /* @__PURE__ */ C(
      Hy,
      {
        ...t,
        ref: a,
        trapFocus: r.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: j(t.onCloseAutoFocus, (i) => {
          var l;
          i.preventDefault(), o.current || (l = r.triggerRef.current) == null || l.focus();
        }),
        onPointerDownOutside: j(
          t.onPointerDownOutside,
          (i) => {
            const l = i.detail.originalEvent, c = l.button === 0 && l.ctrlKey === !0, u = l.button === 2 || c;
            o.current = u;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: j(
          t.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), Yee = s.forwardRef(
  (t, e) => {
    const r = ho(bi, t.__scopePopover), n = s.useRef(!1), a = s.useRef(!1);
    return /* @__PURE__ */ C(
      Hy,
      {
        ...t,
        ref: e,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (o) => {
          var i, l;
          (i = t.onCloseAutoFocus) == null || i.call(t, o), o.defaultPrevented || (n.current || (l = r.triggerRef.current) == null || l.focus(), o.preventDefault()), n.current = !1, a.current = !1;
        },
        onInteractOutside: (o) => {
          var c, u;
          (c = t.onInteractOutside) == null || c.call(t, o), o.defaultPrevented || (n.current = !0, o.detail.originalEvent.type === "pointerdown" && (a.current = !0));
          const i = o.target;
          ((u = r.triggerRef.current) == null ? void 0 : u.contains(i)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && a.current && o.preventDefault();
        }
      }
    );
  }
), Hy = s.forwardRef(
  (t, e) => {
    const {
      __scopePopover: r,
      trapFocus: n,
      onOpenAutoFocus: a,
      onCloseAutoFocus: o,
      disableOutsidePointerEvents: i,
      onEscapeKeyDown: l,
      onPointerDownOutside: c,
      onFocusOutside: u,
      onInteractOutside: d,
      ...f
    } = t, h = ho(bi, r), v = Cs(r);
    return v6(), /* @__PURE__ */ C(
      ws,
      {
        asChild: !0,
        loop: !0,
        trapped: n,
        onMountAutoFocus: a,
        onUnmountAutoFocus: o,
        children: /* @__PURE__ */ C(
          Zu,
          {
            asChild: !0,
            disableOutsidePointerEvents: i,
            onInteractOutside: d,
            onEscapeKeyDown: l,
            onPointerDownOutside: c,
            onFocusOutside: u,
            onDismiss: () => h.onOpenChange(!1),
            children: /* @__PURE__ */ C(
              qu,
              {
                "data-state": Wy(h.open),
                role: "dialog",
                id: h.contentId,
                ...v,
                ...f,
                ref: e,
                style: {
                  ...f.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), jy = "PopoverClose", Xee = s.forwardRef(
  (t, e) => {
    const { __scopePopover: r, ...n } = t, a = ho(jy, r);
    return /* @__PURE__ */ C(
      te.button,
      {
        type: "button",
        ...n,
        ref: e,
        onClick: j(t.onClick, () => a.onOpenChange(!1))
      }
    );
  }
);
Xee.displayName = jy;
var qee = "PopoverArrow", Kee = s.forwardRef(
  (t, e) => {
    const { __scopePopover: r, ...n } = t, a = Cs(r);
    return /* @__PURE__ */ C(Ku, { ...a, ...n, ref: e });
  }
);
Kee.displayName = qee;
function Wy(t) {
  return t ? "open" : "closed";
}
var Qee = By, Jee = Vy, ete = Zy, pv = "Progress", gv = 100, [tte, f6e] = Sn(pv), [rte, nte] = tte(pv), zy = s.forwardRef(
  (t, e) => {
    const {
      __scopeProgress: r,
      value: n = null,
      max: a,
      getValueLabel: o = ate,
      ...i
    } = t;
    (a || a === 0) && !Fp(a) && console.error(ote(`${a}`, "Progress"));
    const l = Fp(a) ? a : gv;
    n !== null && !$p(n, l) && console.error(ite(`${n}`, "Progress"));
    const c = $p(n, l) ? n : null, u = D0(c) ? o(c, l) : void 0;
    return /* @__PURE__ */ C(rte, { scope: r, value: c, max: l, children: /* @__PURE__ */ C(
      te.div,
      {
        "aria-valuemax": l,
        "aria-valuemin": 0,
        "aria-valuenow": D0(c) ? c : void 0,
        "aria-valuetext": u,
        role: "progressbar",
        "data-state": Yy(c, l),
        "data-value": c ?? void 0,
        "data-max": l,
        ...i,
        ref: e
      }
    ) });
  }
);
zy.displayName = pv;
var Gy = "ProgressIndicator", Uy = s.forwardRef(
  (t, e) => {
    const { __scopeProgress: r, ...n } = t, a = nte(Gy, r);
    return /* @__PURE__ */ C(
      te.div,
      {
        "data-state": Yy(a.value, a.max),
        "data-value": a.value ?? void 0,
        "data-max": a.max,
        ...n,
        ref: e
      }
    );
  }
);
Uy.displayName = Gy;
function ate(t, e) {
  return `${Math.round(t / e * 100)}%`;
}
function Yy(t, e) {
  return t == null ? "indeterminate" : t === e ? "complete" : "loading";
}
function D0(t) {
  return typeof t == "number";
}
function Fp(t) {
  return D0(t) && !isNaN(t) && t > 0;
}
function $p(t, e) {
  return D0(t) && !isNaN(t) && t <= e && t >= 0;
}
function ote(t, e) {
  return `Invalid prop \`max\` of value \`${t}\` supplied to \`${e}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${gv}\`.`;
}
function ite(t, e) {
  return `Invalid prop \`value\` of value \`${t}\` supplied to \`${e}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${gv} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
var lte = zy, ste = Uy, cte = "Toggle", Xy = s.forwardRef((t, e) => {
  const { pressed: r, defaultPressed: n = !1, onPressedChange: a, ...o } = t, [i = !1, l] = mr({
    prop: r,
    onChange: a,
    defaultProp: n
  });
  return /* @__PURE__ */ C(
    te.button,
    {
      type: "button",
      "aria-pressed": i,
      "data-state": i ? "on" : "off",
      "data-disabled": t.disabled ? "" : void 0,
      ...o,
      ref: e,
      onClick: j(t.onClick, () => {
        t.disabled || l(!i);
      })
    }
  );
});
Xy.displayName = cte;
var Zi = "ToggleGroup", [qy, h6e] = Sn(Zi, [
  Vi
]), Ky = Vi(), mv = ke.forwardRef((t, e) => {
  const { type: r, ...n } = t;
  if (r === "single")
    return /* @__PURE__ */ C(ute, { ...n, ref: e });
  if (r === "multiple")
    return /* @__PURE__ */ C(dte, { ...n, ref: e });
  throw new Error(`Missing prop \`type\` expected on \`${Zi}\``);
});
mv.displayName = Zi;
var [Qy, Jy] = qy(Zi), ute = ke.forwardRef((t, e) => {
  const {
    value: r,
    defaultValue: n,
    onValueChange: a = () => {
    },
    ...o
  } = t, [i, l] = mr({
    prop: r,
    defaultProp: n,
    onChange: a
  });
  return /* @__PURE__ */ C(
    Qy,
    {
      scope: t.__scopeToggleGroup,
      type: "single",
      value: i ? [i] : [],
      onItemActivate: l,
      onItemDeactivate: ke.useCallback(() => l(""), [l]),
      children: /* @__PURE__ */ C(e8, { ...o, ref: e })
    }
  );
}), dte = ke.forwardRef((t, e) => {
  const {
    value: r,
    defaultValue: n,
    onValueChange: a = () => {
    },
    ...o
  } = t, [i = [], l] = mr({
    prop: r,
    defaultProp: n,
    onChange: a
  }), c = ke.useCallback(
    (d) => l((f = []) => [...f, d]),
    [l]
  ), u = ke.useCallback(
    (d) => l((f = []) => f.filter((h) => h !== d)),
    [l]
  );
  return /* @__PURE__ */ C(
    Qy,
    {
      scope: t.__scopeToggleGroup,
      type: "multiple",
      value: i,
      onItemActivate: c,
      onItemDeactivate: u,
      children: /* @__PURE__ */ C(e8, { ...o, ref: e })
    }
  );
});
mv.displayName = Zi;
var [fte, hte] = qy(Zi), e8 = ke.forwardRef(
  (t, e) => {
    const {
      __scopeToggleGroup: r,
      disabled: n = !1,
      rovingFocus: a = !0,
      orientation: o,
      dir: i,
      loop: l = !0,
      ...c
    } = t, u = Ky(r), d = $i(i), f = { role: "group", dir: d, ...c };
    return /* @__PURE__ */ C(fte, { scope: r, rovingFocus: a, disabled: n, children: a ? /* @__PURE__ */ C(
      fv,
      {
        asChild: !0,
        ...u,
        orientation: o,
        dir: d,
        loop: l,
        children: /* @__PURE__ */ C(te.div, { ...f, ref: e })
      }
    ) : /* @__PURE__ */ C(te.div, { ...f, ref: e }) });
  }
), N0 = "ToggleGroupItem", t8 = ke.forwardRef(
  (t, e) => {
    const r = Jy(N0, t.__scopeToggleGroup), n = hte(N0, t.__scopeToggleGroup), a = Ky(t.__scopeToggleGroup), o = r.value.includes(t.value), i = n.disabled || t.disabled, l = { ...t, pressed: o, disabled: i }, c = ke.useRef(null);
    return n.rovingFocus ? /* @__PURE__ */ C(
      hv,
      {
        asChild: !0,
        ...a,
        focusable: !i,
        active: o,
        ref: c,
        children: /* @__PURE__ */ C(Vp, { ...l, ref: e })
      }
    ) : /* @__PURE__ */ C(Vp, { ...l, ref: e });
  }
);
t8.displayName = N0;
var Vp = ke.forwardRef(
  (t, e) => {
    const { __scopeToggleGroup: r, value: n, ...a } = t, o = Jy(N0, r), i = { role: "radio", "aria-checked": t.pressed, "aria-pressed": void 0 }, l = o.type === "single" ? i : void 0;
    return /* @__PURE__ */ C(
      Xy,
      {
        ...l,
        ...a,
        ref: e,
        onPressedChange: (c) => {
          c ? o.onItemActivate(n) : o.onItemDeactivate(n);
        }
      }
    );
  }
), vte = mv, pte = t8, gte = [" ", "Enter", "ArrowUp", "ArrowDown"], mte = [" ", "Enter"], Es = "Select", [a1, o1, wte] = r1(Es), [Hi, v6e] = Sn(Es, [
  wte,
  ha
]), i1 = ha(), [yte, va] = Hi(Es), [bte, _te] = Hi(Es), r8 = (t) => {
  const {
    __scopeSelect: e,
    children: r,
    open: n,
    defaultOpen: a,
    onOpenChange: o,
    value: i,
    defaultValue: l,
    onValueChange: c,
    dir: u,
    name: d,
    autoComplete: f,
    disabled: h,
    required: v
  } = t, p = i1(e), [g, m] = s.useState(null), [w, y] = s.useState(null), [b, _] = s.useState(!1), x = $i(u), [E = !1, S] = mr({
    prop: n,
    defaultProp: a,
    onChange: o
  }), [M, R] = mr({
    prop: i,
    defaultProp: l,
    onChange: c
  }), A = s.useRef(null), k = g ? !!g.closest("form") : !0, [L, T] = s.useState(/* @__PURE__ */ new Set()), O = Array.from(L).map((D) => D.props.value).join(";");
  return /* @__PURE__ */ C(Xu, { ...p, children: /* @__PURE__ */ Z(
    yte,
    {
      required: v,
      scope: e,
      trigger: g,
      onTriggerChange: m,
      valueNode: w,
      onValueNodeChange: y,
      valueNodeHasChildren: b,
      onValueNodeHasChildrenChange: _,
      contentId: Kt(),
      value: M,
      onValueChange: R,
      open: E,
      onOpenChange: S,
      dir: x,
      triggerPointerDownPosRef: A,
      disabled: h,
      children: [
        /* @__PURE__ */ C(a1.Provider, { scope: e, children: /* @__PURE__ */ C(
          bte,
          {
            scope: t.__scopeSelect,
            onNativeOptionAdd: s.useCallback((D) => {
              T((P) => new Set(P).add(D));
            }, []),
            onNativeOptionRemove: s.useCallback((D) => {
              T((P) => {
                const F = new Set(P);
                return F.delete(D), F;
              });
            }, []),
            children: r
          }
        ) }),
        k ? /* @__PURE__ */ Z(
          S8,
          {
            "aria-hidden": !0,
            required: v,
            tabIndex: -1,
            name: d,
            autoComplete: f,
            value: M,
            onChange: (D) => R(D.target.value),
            disabled: h,
            children: [
              M === void 0 ? /* @__PURE__ */ C("option", { value: "" }) : null,
              Array.from(L)
            ]
          },
          O
        ) : null
      ]
    }
  ) });
};
r8.displayName = Es;
var n8 = "SelectTrigger", a8 = s.forwardRef(
  (t, e) => {
    const { __scopeSelect: r, disabled: n = !1, ...a } = t, o = i1(r), i = va(n8, r), l = i.disabled || n, c = ce(e, i.onTriggerChange), u = o1(r), [d, f, h] = R8((p) => {
      const g = u().filter((y) => !y.disabled), m = g.find((y) => y.value === i.value), w = M8(g, p, m);
      w !== void 0 && i.onValueChange(w.value);
    }), v = () => {
      l || (i.onOpenChange(!0), h());
    };
    return /* @__PURE__ */ C(_s, { asChild: !0, ...o, children: /* @__PURE__ */ C(
      te.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": i.contentId,
        "aria-expanded": i.open,
        "aria-required": i.required,
        "aria-autocomplete": "none",
        dir: i.dir,
        "data-state": i.open ? "open" : "closed",
        disabled: l,
        "data-disabled": l ? "" : void 0,
        "data-placeholder": E8(i.value) ? "" : void 0,
        ...a,
        ref: c,
        onClick: j(a.onClick, (p) => {
          p.currentTarget.focus();
        }),
        onPointerDown: j(a.onPointerDown, (p) => {
          const g = p.target;
          g.hasPointerCapture(p.pointerId) && g.releasePointerCapture(p.pointerId), p.button === 0 && p.ctrlKey === !1 && (v(), i.triggerPointerDownPosRef.current = {
            x: Math.round(p.pageX),
            y: Math.round(p.pageY)
          }, p.preventDefault());
        }),
        onKeyDown: j(a.onKeyDown, (p) => {
          const g = d.current !== "";
          !(p.ctrlKey || p.altKey || p.metaKey) && p.key.length === 1 && f(p.key), !(g && p.key === " ") && gte.includes(p.key) && (v(), p.preventDefault());
        })
      }
    ) });
  }
);
a8.displayName = n8;
var o8 = "SelectValue", i8 = s.forwardRef(
  (t, e) => {
    const { __scopeSelect: r, className: n, style: a, children: o, placeholder: i = "", ...l } = t, c = va(o8, r), { onValueNodeHasChildrenChange: u } = c, d = o !== void 0, f = ce(e, c.onValueNodeChange);
    return Fe(() => {
      u(d);
    }, [u, d]), /* @__PURE__ */ C(
      te.span,
      {
        ...l,
        ref: f,
        style: { pointerEvents: "none" },
        children: E8(c.value) ? /* @__PURE__ */ C(gr, { children: i }) : o
      }
    );
  }
);
i8.displayName = o8;
var xte = "SelectIcon", l8 = s.forwardRef(
  (t, e) => {
    const { __scopeSelect: r, children: n, ...a } = t;
    return /* @__PURE__ */ C(te.span, { "aria-hidden": !0, ...a, ref: e, children: n || "▼" });
  }
);
l8.displayName = xte;
var Cte = "SelectPortal", s8 = (t) => /* @__PURE__ */ C(z2, { asChild: !0, ...t });
s8.displayName = Cte;
var to = "SelectContent", c8 = s.forwardRef(
  (t, e) => {
    const r = va(to, t.__scopeSelect), [n, a] = s.useState();
    if (Fe(() => {
      a(new DocumentFragment());
    }, []), !r.open) {
      const o = n;
      return o ? gs.createPortal(
        /* @__PURE__ */ C(u8, { scope: t.__scopeSelect, children: /* @__PURE__ */ C(a1.Slot, { scope: t.__scopeSelect, children: /* @__PURE__ */ C("div", { children: t.children }) }) }),
        o
      ) : null;
    }
    return /* @__PURE__ */ C(d8, { ...t, ref: e });
  }
);
c8.displayName = to;
var fn = 10, [u8, pa] = Hi(to), Ete = "SelectContentImpl", d8 = s.forwardRef(
  (t, e) => {
    const {
      __scopeSelect: r,
      position: n = "item-aligned",
      onCloseAutoFocus: a,
      onEscapeKeyDown: o,
      onPointerDownOutside: i,
      //
      // PopperContent props
      side: l,
      sideOffset: c,
      align: u,
      alignOffset: d,
      arrowPadding: f,
      collisionBoundary: h,
      collisionPadding: v,
      sticky: p,
      hideWhenDetached: g,
      avoidCollisions: m,
      //
      ...w
    } = t, y = va(to, r), [b, _] = s.useState(null), [x, E] = s.useState(null), S = ce(e, (X) => _(X)), [M, R] = s.useState(null), [A, k] = s.useState(
      null
    ), L = o1(r), [T, O] = s.useState(!1), D = s.useRef(!1);
    s.useEffect(() => {
      if (b) return zu(b);
    }, [b]), v6();
    const P = s.useCallback(
      (X) => {
        const [me, ...ve] = L().map((q) => q.ref.current), [ae] = ve.slice(-1), Y = document.activeElement;
        for (const q of X)
          if (q === Y || (q == null || q.scrollIntoView({ block: "nearest" }), q === me && x && (x.scrollTop = 0), q === ae && x && (x.scrollTop = x.scrollHeight), q == null || q.focus(), document.activeElement !== Y)) return;
      },
      [L, x]
    ), F = s.useCallback(
      () => P([M, b]),
      [P, M, b]
    );
    s.useEffect(() => {
      T && F();
    }, [T, F]);
    const { onOpenChange: B, triggerPointerDownPosRef: N } = y;
    s.useEffect(() => {
      if (b) {
        let X = { x: 0, y: 0 };
        const me = (ae) => {
          var Y, q;
          X = {
            x: Math.abs(Math.round(ae.pageX) - (((Y = N.current) == null ? void 0 : Y.x) ?? 0)),
            y: Math.abs(Math.round(ae.pageY) - (((q = N.current) == null ? void 0 : q.y) ?? 0))
          };
        }, ve = (ae) => {
          X.x <= 10 && X.y <= 10 ? ae.preventDefault() : b.contains(ae.target) || B(!1), document.removeEventListener("pointermove", me), N.current = null;
        };
        return N.current !== null && (document.addEventListener("pointermove", me), document.addEventListener("pointerup", ve, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", me), document.removeEventListener("pointerup", ve, { capture: !0 });
        };
      }
    }, [b, B, N]), s.useEffect(() => {
      const X = () => B(!1);
      return window.addEventListener("blur", X), window.addEventListener("resize", X), () => {
        window.removeEventListener("blur", X), window.removeEventListener("resize", X);
      };
    }, [B]);
    const [$, V] = R8((X) => {
      const me = L().filter((Y) => !Y.disabled), ve = me.find((Y) => Y.ref.current === document.activeElement), ae = M8(me, X, ve);
      ae && setTimeout(() => ae.ref.current.focus());
    }), W = s.useCallback(
      (X, me, ve) => {
        const ae = !D.current && !ve;
        (y.value !== void 0 && y.value === me || ae) && (R(X), ae && (D.current = !0));
      },
      [y.value]
    ), ee = s.useCallback(() => b == null ? void 0 : b.focus(), [b]), ne = s.useCallback(
      (X, me, ve) => {
        const ae = !D.current && !ve;
        (y.value !== void 0 && y.value === me || ae) && k(X);
      },
      [y.value]
    ), we = n === "popper" ? Kf : f8, pe = we === Kf ? {
      side: l,
      sideOffset: c,
      align: u,
      alignOffset: d,
      arrowPadding: f,
      collisionBoundary: h,
      collisionPadding: v,
      sticky: p,
      hideWhenDetached: g,
      avoidCollisions: m
    } : {};
    return /* @__PURE__ */ C(
      u8,
      {
        scope: r,
        content: b,
        viewport: x,
        onViewportChange: E,
        itemRefCallback: W,
        selectedItem: M,
        onItemLeave: ee,
        itemTextRefCallback: ne,
        focusSelectedItem: F,
        selectedItemText: A,
        position: n,
        isPositioned: T,
        searchRef: $,
        children: /* @__PURE__ */ C(q2, { as: Nr, allowPinchZoom: !0, children: /* @__PURE__ */ C(
          ws,
          {
            asChild: !0,
            trapped: y.open,
            onMountAutoFocus: (X) => {
              X.preventDefault();
            },
            onUnmountAutoFocus: j(a, (X) => {
              var me;
              (me = y.trigger) == null || me.focus({ preventScroll: !0 }), X.preventDefault();
            }),
            children: /* @__PURE__ */ C(
              Zu,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: o,
                onPointerDownOutside: i,
                onFocusOutside: (X) => X.preventDefault(),
                onDismiss: () => y.onOpenChange(!1),
                children: /* @__PURE__ */ C(
                  we,
                  {
                    role: "listbox",
                    id: y.contentId,
                    "data-state": y.open ? "open" : "closed",
                    dir: y.dir,
                    onContextMenu: (X) => X.preventDefault(),
                    ...w,
                    ...pe,
                    onPlaced: () => O(!0),
                    ref: S,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...w.style
                    },
                    onKeyDown: j(w.onKeyDown, (X) => {
                      const me = X.ctrlKey || X.altKey || X.metaKey;
                      if (X.key === "Tab" && X.preventDefault(), !me && X.key.length === 1 && V(X.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(X.key)) {
                        let ae = L().filter((Y) => !Y.disabled).map((Y) => Y.ref.current);
                        if (["ArrowUp", "End"].includes(X.key) && (ae = ae.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(X.key)) {
                          const Y = X.target, q = ae.indexOf(Y);
                          ae = ae.slice(q + 1);
                        }
                        setTimeout(() => P(ae)), X.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
d8.displayName = Ete;
var Ste = "SelectItemAlignedPosition", f8 = s.forwardRef((t, e) => {
  const { __scopeSelect: r, onPlaced: n, ...a } = t, o = va(to, r), i = pa(to, r), [l, c] = s.useState(null), [u, d] = s.useState(null), f = ce(e, (S) => d(S)), h = o1(r), v = s.useRef(!1), p = s.useRef(!0), { viewport: g, selectedItem: m, selectedItemText: w, focusSelectedItem: y } = i, b = s.useCallback(() => {
    if (o.trigger && o.valueNode && l && u && g && m && w) {
      const S = o.trigger.getBoundingClientRect(), M = u.getBoundingClientRect(), R = o.valueNode.getBoundingClientRect(), A = w.getBoundingClientRect();
      if (o.dir !== "rtl") {
        const Y = A.left - M.left, q = R.left - Y, We = S.left - q, Ne = S.width + We, It = Math.max(Ne, M.width), xt = window.innerWidth - fn, Sr = qf(q, [fn, xt - It]);
        l.style.minWidth = Ne + "px", l.style.left = Sr + "px";
      } else {
        const Y = M.right - A.right, q = window.innerWidth - R.right - Y, We = window.innerWidth - S.right - q, Ne = S.width + We, It = Math.max(Ne, M.width), xt = window.innerWidth - fn, Sr = qf(q, [fn, xt - It]);
        l.style.minWidth = Ne + "px", l.style.right = Sr + "px";
      }
      const k = h(), L = window.innerHeight - fn * 2, T = g.scrollHeight, O = window.getComputedStyle(u), D = parseInt(O.borderTopWidth, 10), P = parseInt(O.paddingTop, 10), F = parseInt(O.borderBottomWidth, 10), B = parseInt(O.paddingBottom, 10), N = D + P + T + B + F, $ = Math.min(m.offsetHeight * 5, N), V = window.getComputedStyle(g), W = parseInt(V.paddingTop, 10), ee = parseInt(V.paddingBottom, 10), ne = S.top + S.height / 2 - fn, we = L - ne, pe = m.offsetHeight / 2, X = m.offsetTop + pe, me = D + P + X, ve = N - me;
      if (me <= ne) {
        const Y = m === k[k.length - 1].ref.current;
        l.style.bottom = "0px";
        const q = u.clientHeight - g.offsetTop - g.offsetHeight, We = Math.max(
          we,
          pe + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (Y ? ee : 0) + q + F
        ), Ne = me + We;
        l.style.height = Ne + "px";
      } else {
        const Y = m === k[0].ref.current;
        l.style.top = "0px";
        const We = Math.max(
          ne,
          D + g.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (Y ? W : 0) + pe
        ) + ve;
        l.style.height = We + "px", g.scrollTop = me - ne + g.offsetTop;
      }
      l.style.margin = `${fn}px 0`, l.style.minHeight = $ + "px", l.style.maxHeight = L + "px", n == null || n(), requestAnimationFrame(() => v.current = !0);
    }
  }, [
    h,
    o.trigger,
    o.valueNode,
    l,
    u,
    g,
    m,
    w,
    o.dir,
    n
  ]);
  Fe(() => b(), [b]);
  const [_, x] = s.useState();
  Fe(() => {
    u && x(window.getComputedStyle(u).zIndex);
  }, [u]);
  const E = s.useCallback(
    (S) => {
      S && p.current === !0 && (b(), y == null || y(), p.current = !1);
    },
    [b, y]
  );
  return /* @__PURE__ */ C(
    Mte,
    {
      scope: r,
      contentWrapper: l,
      shouldExpandOnScrollRef: v,
      onScrollButtonChange: E,
      children: /* @__PURE__ */ C(
        "div",
        {
          ref: c,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: _
          },
          children: /* @__PURE__ */ C(
            te.div,
            {
              ...a,
              ref: f,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...a.style
              }
            }
          )
        }
      )
    }
  );
});
f8.displayName = Ste;
var Rte = "SelectPopperPosition", Kf = s.forwardRef((t, e) => {
  const {
    __scopeSelect: r,
    align: n = "start",
    collisionPadding: a = fn,
    ...o
  } = t, i = i1(r);
  return /* @__PURE__ */ C(
    qu,
    {
      ...i,
      ...o,
      ref: e,
      align: n,
      collisionPadding: a,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...o.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Kf.displayName = Rte;
var [Mte, wv] = Hi(to, {}), Qf = "SelectViewport", h8 = s.forwardRef(
  (t, e) => {
    const { __scopeSelect: r, nonce: n, ...a } = t, o = pa(Qf, r), i = wv(Qf, r), l = ce(e, o.onViewportChange), c = s.useRef(0);
    return /* @__PURE__ */ Z(gr, { children: [
      /* @__PURE__ */ C(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: n
        }
      ),
      /* @__PURE__ */ C(a1.Slot, { scope: r, children: /* @__PURE__ */ C(
        te.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...a,
          ref: l,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            overflow: "auto",
            ...a.style
          },
          onScroll: j(a.onScroll, (u) => {
            const d = u.currentTarget, { contentWrapper: f, shouldExpandOnScrollRef: h } = i;
            if (h != null && h.current && f) {
              const v = Math.abs(c.current - d.scrollTop);
              if (v > 0) {
                const p = window.innerHeight - fn * 2, g = parseFloat(f.style.minHeight), m = parseFloat(f.style.height), w = Math.max(g, m);
                if (w < p) {
                  const y = w + v, b = Math.min(p, y), _ = y - b;
                  f.style.height = b + "px", f.style.bottom === "0px" && (d.scrollTop = _ > 0 ? _ : 0, f.style.justifyContent = "flex-end");
                }
              }
            }
            c.current = d.scrollTop;
          })
        }
      ) })
    ] });
  }
);
h8.displayName = Qf;
var v8 = "SelectGroup", [Ate, kte] = Hi(v8), Lte = s.forwardRef(
  (t, e) => {
    const { __scopeSelect: r, ...n } = t, a = Kt();
    return /* @__PURE__ */ C(Ate, { scope: r, id: a, children: /* @__PURE__ */ C(te.div, { role: "group", "aria-labelledby": a, ...n, ref: e }) });
  }
);
Lte.displayName = v8;
var p8 = "SelectLabel", Tte = s.forwardRef(
  (t, e) => {
    const { __scopeSelect: r, ...n } = t, a = kte(p8, r);
    return /* @__PURE__ */ C(te.div, { id: a.id, ...n, ref: e });
  }
);
Tte.displayName = p8;
var B0 = "SelectItem", [Ote, g8] = Hi(B0), m8 = s.forwardRef(
  (t, e) => {
    const {
      __scopeSelect: r,
      value: n,
      disabled: a = !1,
      textValue: o,
      ...i
    } = t, l = va(B0, r), c = pa(B0, r), u = l.value === n, [d, f] = s.useState(o ?? ""), [h, v] = s.useState(!1), p = ce(
      e,
      (w) => {
        var y;
        return (y = c.itemRefCallback) == null ? void 0 : y.call(c, w, n, a);
      }
    ), g = Kt(), m = () => {
      a || (l.onValueChange(n), l.onOpenChange(!1));
    };
    if (n === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ C(
      Ote,
      {
        scope: r,
        value: n,
        disabled: a,
        textId: g,
        isSelected: u,
        onItemTextChange: s.useCallback((w) => {
          f((y) => y || ((w == null ? void 0 : w.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ C(
          a1.ItemSlot,
          {
            scope: r,
            value: n,
            disabled: a,
            textValue: d,
            children: /* @__PURE__ */ C(
              te.div,
              {
                role: "option",
                "aria-labelledby": g,
                "data-highlighted": h ? "" : void 0,
                "aria-selected": u && h,
                "data-state": u ? "checked" : "unchecked",
                "aria-disabled": a || void 0,
                "data-disabled": a ? "" : void 0,
                tabIndex: a ? void 0 : -1,
                ...i,
                ref: p,
                onFocus: j(i.onFocus, () => v(!0)),
                onBlur: j(i.onBlur, () => v(!1)),
                onPointerUp: j(i.onPointerUp, m),
                onPointerMove: j(i.onPointerMove, (w) => {
                  var y;
                  a ? (y = c.onItemLeave) == null || y.call(c) : w.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: j(i.onPointerLeave, (w) => {
                  var y;
                  w.currentTarget === document.activeElement && ((y = c.onItemLeave) == null || y.call(c));
                }),
                onKeyDown: j(i.onKeyDown, (w) => {
                  var b;
                  ((b = c.searchRef) == null ? void 0 : b.current) !== "" && w.key === " " || (mte.includes(w.key) && m(), w.key === " " && w.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
m8.displayName = B0;
var _l = "SelectItemText", w8 = s.forwardRef(
  (t, e) => {
    const { __scopeSelect: r, className: n, style: a, ...o } = t, i = va(_l, r), l = pa(_l, r), c = g8(_l, r), u = _te(_l, r), [d, f] = s.useState(null), h = ce(
      e,
      (w) => f(w),
      c.onItemTextChange,
      (w) => {
        var y;
        return (y = l.itemTextRefCallback) == null ? void 0 : y.call(l, w, c.value, c.disabled);
      }
    ), v = d == null ? void 0 : d.textContent, p = s.useMemo(
      () => /* @__PURE__ */ C("option", { value: c.value, disabled: c.disabled, children: v }, c.value),
      [c.disabled, c.value, v]
    ), { onNativeOptionAdd: g, onNativeOptionRemove: m } = u;
    return Fe(() => (g(p), () => m(p)), [g, m, p]), /* @__PURE__ */ Z(gr, { children: [
      /* @__PURE__ */ C(te.span, { id: c.textId, ...o, ref: h }),
      c.isSelected && i.valueNode && !i.valueNodeHasChildren ? gs.createPortal(o.children, i.valueNode) : null
    ] });
  }
);
w8.displayName = _l;
var y8 = "SelectItemIndicator", b8 = s.forwardRef(
  (t, e) => {
    const { __scopeSelect: r, ...n } = t;
    return g8(y8, r).isSelected ? /* @__PURE__ */ C(te.span, { "aria-hidden": !0, ...n, ref: e }) : null;
  }
);
b8.displayName = y8;
var Jf = "SelectScrollUpButton", _8 = s.forwardRef((t, e) => {
  const r = pa(Jf, t.__scopeSelect), n = wv(Jf, t.__scopeSelect), [a, o] = s.useState(!1), i = ce(e, n.onScrollButtonChange);
  return Fe(() => {
    if (r.viewport && r.isPositioned) {
      let l = function() {
        const u = c.scrollTop > 0;
        o(u);
      };
      const c = r.viewport;
      return l(), c.addEventListener("scroll", l), () => c.removeEventListener("scroll", l);
    }
  }, [r.viewport, r.isPositioned]), a ? /* @__PURE__ */ C(
    C8,
    {
      ...t,
      ref: i,
      onAutoScroll: () => {
        const { viewport: l, selectedItem: c } = r;
        l && c && (l.scrollTop = l.scrollTop - c.offsetHeight);
      }
    }
  ) : null;
});
_8.displayName = Jf;
var eh = "SelectScrollDownButton", x8 = s.forwardRef((t, e) => {
  const r = pa(eh, t.__scopeSelect), n = wv(eh, t.__scopeSelect), [a, o] = s.useState(!1), i = ce(e, n.onScrollButtonChange);
  return Fe(() => {
    if (r.viewport && r.isPositioned) {
      let l = function() {
        const u = c.scrollHeight - c.clientHeight, d = Math.ceil(c.scrollTop) < u;
        o(d);
      };
      const c = r.viewport;
      return l(), c.addEventListener("scroll", l), () => c.removeEventListener("scroll", l);
    }
  }, [r.viewport, r.isPositioned]), a ? /* @__PURE__ */ C(
    C8,
    {
      ...t,
      ref: i,
      onAutoScroll: () => {
        const { viewport: l, selectedItem: c } = r;
        l && c && (l.scrollTop = l.scrollTop + c.offsetHeight);
      }
    }
  ) : null;
});
x8.displayName = eh;
var C8 = s.forwardRef((t, e) => {
  const { __scopeSelect: r, onAutoScroll: n, ...a } = t, o = pa("SelectScrollButton", r), i = s.useRef(null), l = o1(r), c = s.useCallback(() => {
    i.current !== null && (window.clearInterval(i.current), i.current = null);
  }, []);
  return s.useEffect(() => () => c(), [c]), Fe(() => {
    var d;
    const u = l().find((f) => f.ref.current === document.activeElement);
    (d = u == null ? void 0 : u.ref.current) == null || d.scrollIntoView({ block: "nearest" });
  }, [l]), /* @__PURE__ */ C(
    te.div,
    {
      "aria-hidden": !0,
      ...a,
      ref: e,
      style: { flexShrink: 0, ...a.style },
      onPointerDown: j(a.onPointerDown, () => {
        i.current === null && (i.current = window.setInterval(n, 50));
      }),
      onPointerMove: j(a.onPointerMove, () => {
        var u;
        (u = o.onItemLeave) == null || u.call(o), i.current === null && (i.current = window.setInterval(n, 50));
      }),
      onPointerLeave: j(a.onPointerLeave, () => {
        c();
      })
    }
  );
}), Ite = "SelectSeparator", Pte = s.forwardRef(
  (t, e) => {
    const { __scopeSelect: r, ...n } = t;
    return /* @__PURE__ */ C(te.div, { "aria-hidden": !0, ...n, ref: e });
  }
);
Pte.displayName = Ite;
var th = "SelectArrow", Dte = s.forwardRef(
  (t, e) => {
    const { __scopeSelect: r, ...n } = t, a = i1(r), o = va(th, r), i = pa(th, r);
    return o.open && i.position === "popper" ? /* @__PURE__ */ C(Ku, { ...a, ...n, ref: e }) : null;
  }
);
Dte.displayName = th;
function E8(t) {
  return t === "" || t === void 0;
}
var S8 = s.forwardRef(
  (t, e) => {
    const { value: r, ...n } = t, a = s.useRef(null), o = ce(e, a), i = Ly(r);
    return s.useEffect(() => {
      const l = a.current, c = window.HTMLSelectElement.prototype, d = Object.getOwnPropertyDescriptor(
        c,
        "value"
      ).set;
      if (i !== r && d) {
        const f = new Event("change", { bubbles: !0 });
        d.call(l, r), l.dispatchEvent(f);
      }
    }, [i, r]), /* @__PURE__ */ C(j2, { asChild: !0, children: /* @__PURE__ */ C("select", { ...n, ref: o, defaultValue: r }) });
  }
);
S8.displayName = "BubbleSelect";
function R8(t) {
  const e = Ke(t), r = s.useRef(""), n = s.useRef(0), a = s.useCallback(
    (i) => {
      const l = r.current + i;
      e(l), function c(u) {
        r.current = u, window.clearTimeout(n.current), u !== "" && (n.current = window.setTimeout(() => c(""), 1e3));
      }(l);
    },
    [e]
  ), o = s.useCallback(() => {
    r.current = "", window.clearTimeout(n.current);
  }, []);
  return s.useEffect(() => () => window.clearTimeout(n.current), []), [r, a, o];
}
function M8(t, e, r) {
  const a = e.length > 1 && Array.from(e).every((u) => u === e[0]) ? e[0] : e, o = r ? t.indexOf(r) : -1;
  let i = Nte(t, Math.max(o, 0));
  a.length === 1 && (i = i.filter((u) => u !== r));
  const c = i.find(
    (u) => u.textValue.toLowerCase().startsWith(a.toLowerCase())
  );
  return c !== r ? c : void 0;
}
function Nte(t, e) {
  return t.map((r, n) => t[(e + n) % t.length]);
}
var Bte = r8, Fte = a8, $te = i8, Zp = l8, Vte = s8, Zte = c8, Hte = h8, jte = m8, Wte = w8, zte = b8, Gte = _8, Ute = x8, yv = "Switch", [Yte, p6e] = Sn(yv), [Xte, qte] = Yte(yv), A8 = s.forwardRef(
  (t, e) => {
    const {
      __scopeSwitch: r,
      name: n,
      checked: a,
      defaultChecked: o,
      required: i,
      disabled: l,
      value: c = "on",
      onCheckedChange: u,
      ...d
    } = t, [f, h] = s.useState(null), v = ce(e, (y) => h(y)), p = s.useRef(!1), g = f ? !!f.closest("form") : !0, [m = !1, w] = mr({
      prop: a,
      defaultProp: o,
      onChange: u
    });
    return /* @__PURE__ */ Z(Xte, { scope: r, checked: m, disabled: l, children: [
      /* @__PURE__ */ C(
        te.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": m,
          "aria-required": i,
          "data-state": T8(m),
          "data-disabled": l ? "" : void 0,
          disabled: l,
          value: c,
          ...d,
          ref: v,
          onClick: j(t.onClick, (y) => {
            w((b) => !b), g && (p.current = y.isPropagationStopped(), p.current || y.stopPropagation());
          })
        }
      ),
      g && /* @__PURE__ */ C(
        Kte,
        {
          control: f,
          bubbles: !p.current,
          name: n,
          value: c,
          checked: m,
          required: i,
          disabled: l,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
A8.displayName = yv;
var k8 = "SwitchThumb", L8 = s.forwardRef(
  (t, e) => {
    const { __scopeSwitch: r, ...n } = t, a = qte(k8, r);
    return /* @__PURE__ */ C(
      te.span,
      {
        "data-state": T8(a.checked),
        "data-disabled": a.disabled ? "" : void 0,
        ...n,
        ref: e
      }
    );
  }
);
L8.displayName = k8;
var Kte = (t) => {
  const { control: e, checked: r, bubbles: n = !0, ...a } = t, o = s.useRef(null), i = Ly(r), l = ty(e);
  return s.useEffect(() => {
    const c = o.current, u = window.HTMLInputElement.prototype, f = Object.getOwnPropertyDescriptor(u, "checked").set;
    if (i !== r && f) {
      const h = new Event("click", { bubbles: n });
      f.call(c, r), c.dispatchEvent(h);
    }
  }, [i, r, n]), /* @__PURE__ */ C(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: r,
      ...a,
      tabIndex: -1,
      ref: o,
      style: {
        ...t.style,
        ...l,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function T8(t) {
  return t ? "checked" : "unchecked";
}
var Qte = A8, Jte = L8;
const ere = { content: { type: "ReactNode", required: !0 }, width: k5.width, minWidth: k5.minWidth, maxWidth: { ...k5.maxWidth, default: "360px" } }, O8 = s.forwardRef((t, e) => {
  const { children: r, className: n, open: a, defaultOpen: o, onOpenChange: i, delayDuration: l, disableHoverableContent: c, content: u, container: d, forceMount: f, ...h } = ev(t, ere), v = { open: a, defaultOpen: o, onOpenChange: i, delayDuration: l, disableHoverableContent: c };
  return s.createElement(_y, { ...v }, s.createElement(xy, { asChild: !0 }, r), s.createElement(Cy, { container: d, forceMount: f }, s.createElement(t1, { asChild: !0 }, s.createElement(Ey, { sideOffset: 4, collisionPadding: 10, ...h, asChild: !1, ref: e, className: Hn("rt-TooltipContent", n) }, s.createElement(z6, { as: "p", className: "rt-TooltipText", size: "1" }, u), s.createElement(Sy, { className: "rt-TooltipArrow" })))));
});
O8.displayName = "Tooltip";
const tre = "foton__tag___0-LrM", rre = "foton__tagDesktop___HYuqw", nre = "foton__tagMobile___Gn7ew", rh = {
  tag: tre,
  tagDesktop: rre,
  tagMobile: nre
}, are = {
  default: {
    text: "text-gray-50",
    background: "bg-gray-10"
  },
  primaryLight: {
    text: "text-primary-70",
    background: "bg-primary-10"
  },
  orangeLight: {
    text: "text-orange-30",
    background: "bg-orange-10"
  },
  yellowLight: {
    text: "text-yellow-30",
    background: "bg-yellow-10"
  },
  grayLight: {
    text: "text-gray-20",
    background: "bg-light-10"
  },
  primary: {
    text: "text-light-10",
    background: "bg-primary-0"
  },
  gray: {
    text: "text-light-10",
    background: "bg-gray-30"
  },
  secondary: {
    text: "text-secondary-30",
    background: "bg-secondary-10"
  }
}, ore = {
  desktop: rh.tagDesktop,
  mobile: rh.tagMobile
}, Hp = {
  mobile: {
    size: "1",
    badgeIconSize: "w-[14px] h-[14px]"
  },
  desktop: {
    size: "2",
    badgeIconSize: "w-[16px] h-[16px]"
  }
}, jp = (t) => t.icon ? /* @__PURE__ */ C(
  Me,
  {
    ...t.icon,
    extraClassNames: G(`place-self-center ${t.badgeIconSize} rounded-full`, t.icon.extraClassNames)
  }
) : null, I8 = ({
  kind: t,
  color: e,
  label: r,
  id: n,
  icon: a,
  customAttrs: o,
  position: i = "start",
  size: l = "desktop",
  className: c,
  ...u
}) => {
  const d = e && are[e], f = e === "grayLight" ? { boxShadow: "inset 0 0 0 1px #C5C5C5" } : {}, h = Hp[l].badgeIconSize, v = Hp[l].size, p = ore[l];
  return /* @__PURE__ */ Z(
    ky,
    {
      ...o,
      ...u,
      size: v,
      className: G(
        rh.tag,
        d && d.background,
        d && d.text,
        p,
        c
      ),
      style: { ...f },
      children: [
        t === "icon" && i == "start" && /* @__PURE__ */ C(jp, { icon: a, badgeIconSize: h }),
        r,
        t === "icon" && i == "end" && /* @__PURE__ */ C(jp, { icon: a, badgeIconSize: h })
      ]
    }
  );
}, g6e = ({ children: t, ...e }) => !e.label && e.icon ? /* @__PURE__ */ C(gi, { icon: e.icon, ...e, elevated: !0 }) : /* @__PURE__ */ C(Vu, { ...e, elevated: !0, leftIcon: e.icon, children: e.label }), ire = "foton__buttonGroup___MVqub", lre = "foton__buttonGroupContent___A7cP5", sre = "foton__buttonGroupItem___Jzks3", I5 = {
  buttonGroup: ire,
  buttonGroupContent: lre,
  buttonGroupItem: sre
}, m6e = (t) => /* @__PURE__ */ C(t1, { children: /* @__PURE__ */ C(
  vte,
  {
    className: I5.buttonGroup,
    type: "single",
    value: t.value,
    onValueChange: t.onChange,
    children: t.options.map((e) => /* @__PURE__ */ C(pte, { value: e.value, className: I5.buttonGroupItem, children: /* @__PURE__ */ Z("div", { className: I5.buttonGroupContent, children: [
      e.icon && /* @__PURE__ */ C(Me, { icon: e.icon, extraClassNames: "w-[18px] h-[18px]" }),
      /* @__PURE__ */ C("span", { children: e.label })
    ] }) }, `button-option-${e.value}`))
  }
) }), cre = "foton__contentContainer___MTFUW", ure = "foton__contentText___IW4d-", dre = "foton__contentArrow___iImGT", fre = "foton__triggerIcon___vdGcZ", P5 = {
  contentContainer: cre,
  contentText: ure,
  contentArrow: dre,
  triggerIcon: fre
}, Gl = ({ content: t, side: e, icon: r, extraClassName: n }) => /* @__PURE__ */ C(by, { children: /* @__PURE__ */ Z(_y, { children: [
  /* @__PURE__ */ C(xy, { asChild: !0, className: n, type: "button", children: /* @__PURE__ */ C("button", { children: /* @__PURE__ */ C(Me, { ...r, extraClassNames: G(r.extraClassNames ?? P5.triggerIcon) }) }) }),
  /* @__PURE__ */ C(Cy, { children: /* @__PURE__ */ Z(Ey, { className: P5.contentContainer, side: e, children: [
    /* @__PURE__ */ C("span", { className: P5.contentText, children: t }),
    /* @__PURE__ */ C(Sy, {})
  ] }) })
] }) }), hre = "foton__nuggetContainer___bRWK7", vre = "foton__iconContainer___xcce1", pre = "foton__contentContainer___dDh7w", gre = "foton__nuggetTitleContainer___LYIsE", mre = "foton__title___NdeyE", wre = "foton__content___lkWaU", yre = "foton__onlyInfoMode___XUxyw", ba = {
  nuggetContainer: hre,
  iconContainer: vre,
  contentContainer: pre,
  nuggetTitleContainer: gre,
  title: mre,
  content: wre,
  onlyInfoMode: yre
}, kn = {
  title: 12,
  info: 14,
  contentSpace: 4,
  icon: 16
}, w6e = ({
  icon: t,
  title: e,
  info: r,
  tooltip: n,
  strongInfo: a,
  sizes: o,
  ...i
}) => {
  const { className: l, ...c } = i, u = ke.isValidElement(t), d = ((o == null ? void 0 : o.title) || kn.title) + ((o == null ? void 0 : o.info) || kn.info) + ((o == null ? void 0 : o.contentSpace) || kn.contentSpace);
  return /* @__PURE__ */ Z("div", { className: G(ba.nuggetContainer, l, !e && ba.onlyInfoMode), ...c, children: [
    t && /* @__PURE__ */ C(
      "div",
      {
        className: G(ba.iconContainer, t == null ? void 0 : t.extraClassNames),
        style: {
          height: `${d}px`,
          width: `${d}px`,
          minWidth: `${d}px`,
          minHeight: `${d}px`
        },
        children: u ? t : /* @__PURE__ */ C(
          "span",
          {
            style: {
              width: `${(o == null ? void 0 : o.icon) || kn.icon}px`,
              height: `${(o == null ? void 0 : o.icon) || kn.icon}px`
            },
            children: /* @__PURE__ */ C(Me, { ...t })
          }
        )
      }
    ),
    /* @__PURE__ */ Z(
      "div",
      {
        className: ba.contentContainer,
        style: {
          gap: `${(o == null ? void 0 : o.contentSpace) || kn.contentSpace}px`
        },
        children: [
          e && /* @__PURE__ */ Z("div", { className: ba.nuggetTitleContainer, children: [
            /* @__PURE__ */ C(
              "p",
              {
                className: ba.title,
                style: {
                  fontSize: `${(o == null ? void 0 : o.title) || kn.title}px`
                },
                children: e
              }
            ),
            n && /* @__PURE__ */ C(Gl, { ...n })
          ] }),
          /* @__PURE__ */ C(
            "p",
            {
              className: G(ba.content, a && "font-bold"),
              style: {
                fontSize: `${(o == null ? void 0 : o.info) || kn.info}px`
              },
              children: r
            }
          ),
          !e && n && /* @__PURE__ */ C(Gl, { ...n })
        ]
      }
    )
  ] });
}, bre = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3ccircle%20cx='20'%20cy='20'%20r='20'%20fill='url(%23pattern0_1067_15880)'/%3e%3cdefs%3e%3cpattern%20id='pattern0_1067_15880'%20patternContentUnits='objectBoundingBox'%20width='1'%20height='1'%3e%3cuse%20xlink:href='%23image0_1067_15880'%20transform='scale(0.015625)'/%3e%3c/pattern%3e%3cimage%20id='image0_1067_15880'%20width='64'%20height='64'%20xlink:href='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAAONJREFUeF7t20EOhEAIRFG4/6F7DvEnYeFzryQIv6pBd2behOu9dPvsbog+k+NLgArQAqmJcw9iAAhSgZKB3IJkkAySQTJ4CiE+gA8oBeg0mH3Ai084P89HhqwEqIA209ICsQdjAeaZIgaAYKxBDMCAYy8fXwAIgiAIcoJpJEYGI4VjB3YrbC9gL2AvkCB43cM5PgZgAAZgQFnNZAhdGykQBEEQBEEQDBmgAm2glM/z+QUYisYUGoldO7kY32IEAzCg6RgIRgjFAsw+AgRBMNYgBmCAT2TCYfoPPz/HCqQCX1eBHzHnv7C7WhBSAAAAAElFTkSuQmCC'/%3e%3c/defs%3e%3c/svg%3e", _re = "foton__picture___USyj7", xre = "foton__containerProfile___l-K5L", Cre = "foton__profileName___e2q9C", Ere = "foton__email___-C1v6", rc = {
  picture: _re,
  containerProfile: xre,
  profileName: Cre,
  email: Ere
}, P8 = ({ picture: t, name: e, email: r, ...n }) => {
  const { className: a, ...o } = n;
  return /* @__PURE__ */ Z("div", { className: G(rc.containerProfile, a), ...o, children: [
    /* @__PURE__ */ C(
      "img",
      {
        className: G(rc.picture, t.className),
        src: t.src || bre,
        alt: t.alt || "Foto de perfil do Usuário",
        role: t.role || "img",
        "aria-label": t["aria-label"] || "Foto de perfil do Usuário"
      }
    ),
    /* @__PURE__ */ Z("div", { className: rc.profileName, children: [
      /* @__PURE__ */ C("span", { children: e }),
      /* @__PURE__ */ C("div", { className: rc.email, children: /* @__PURE__ */ C("span", { children: r }) })
    ] })
  ] });
}, Sre = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M9.06639%2018.4286V5.57143M9.06639%2018.4286C9.06639%2019.8487%207.86257%2021%206.37759%2021H5.6888C4.20382%2021%203%2019.8487%203%2018.4286V5.57143C3%204.15127%204.20382%203%205.6888%203H6.37759C7.86257%203%209.06639%204.15127%209.06639%205.57143M9.06639%2018.4286C9.06639%2019.8487%2010.2702%2021%2011.7552%2021H18.3112C19.7962%2021%2021%2019.8487%2021%2018.4286V5.57143C21%204.15127%2019.7962%203%2018.3112%203H11.7552C10.2702%203%209.06639%204.15127%209.06639%205.57143'%20stroke='black'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", Rre = "data:image/svg+xml,%3csvg%20width='45'%20height='45'%20viewBox='0%200%2045%2045'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M22.4965%2044.9931C34.921%2044.9931%2044.9931%2034.921%2044.9931%2022.4965C44.9931%2010.072%2034.921%200%2022.4965%200C10.072%200%200%2010.072%200%2022.4965C0%2034.921%2010.072%2044.9931%2022.4965%2044.9931Z'%20fill='%2300E17B'/%3e%3cpath%20d='M14.354%2022.5035C14.3739%2024.8541%2015.3166%2027.1027%2016.9787%2028.7648C18.6409%2030.427%2020.8895%2031.3696%2023.2401%2031.3896C24.7316%2031.3961%2026.2004%2031.0241%2027.5091%2030.3085C28.8177%2029.5928%2029.9234%2028.5568%2030.7227%2027.2974C31.1522%2026.6586%2031.8118%2026.2103%2032.5638%2026.0459C33.3159%2025.8815%2034.1024%2026.0138%2034.7593%2026.4151C35.0777%2026.6267%2035.3514%2026.899%2035.5646%2027.2164C35.7778%2027.5338%2035.9264%2027.8901%2036.0019%2028.265C36.0774%2028.6398%2036.0783%2029.0259%2036.0046%2029.4011C35.9308%2029.7763%2035.7839%2030.1332%2035.5722%2030.4516C34.2486%2032.5198%2032.4244%2034.2205%2030.2687%2035.3961C28.113%2036.5717%2025.6955%2037.1843%2023.2401%2037.177C19.3623%2037.1568%2015.6504%2035.6017%2012.9162%2032.8519C10.182%2030.1021%208.64807%2026.3813%208.64996%2022.5035C8.64448%2020.5821%209.01751%2018.6784%209.74777%2016.9011C10.478%2015.1237%2011.5512%2013.5076%2012.906%2012.1451C14.2608%2010.7825%2015.8707%209.70012%2017.6439%208.95975C19.417%208.21938%2021.3186%207.83554%2023.2401%207.83008C25.8161%207.831%2028.3472%208.50529%2030.5823%209.78614C32.8174%2011.067%2034.6789%2012.9099%2035.9821%2015.1321C36.3617%2015.8012%2036.4644%2016.5923%2036.2684%2017.3362C36.0723%2018.0801%2035.593%2018.7179%2034.933%2019.1131C34.2613%2019.4794%2033.4747%2019.574%2032.7353%2019.3775C31.9959%2019.181%2031.3601%2018.7084%2030.9589%2018.057C30.1782%2016.7019%2029.0529%2015.5775%2027.6973%2014.7978C26.3417%2014.0181%2024.8039%2013.6109%2023.2401%2013.6174C20.8861%2013.6266%2018.6312%2014.5658%2016.9668%2016.2303C15.3023%2017.8948%2014.3631%2020.1496%2014.354%2022.5035Z'%20fill='%231C1134'/%3e%3c/svg%3e", Mre = "foton__logoContainer___Xhvzk", Are = "foton__logoSize___ZtI17", Wp = {
  logoContainer: Mre,
  logoSize: Are
}, D8 = () => /* @__PURE__ */ C("div", { className: Wp.logoContainer, children: /* @__PURE__ */ C("img", { className: Wp.logoSize, src: Rre, alt: "Clarke logo" }) }), kre = "foton__itemContainer___UIVwj", Lre = "foton__itemCollapsed___JBvdb", Tre = "foton__itemsContent___2CgPn", Ore = "foton__itemDefaultActive___h5L7Z", Ire = "foton__itemGreenActiveCollapsed___XiF5p", Pre = "foton__itemGreenActive___LRuNy", Dre = "foton__iconDefault___ehWRp", Nre = "foton__iconDefaultColor___L8Q7W", Bre = "foton__iconHover___YGkaO", Fre = "foton__iconGreenCollapsed___MBjNV", $re = "foton__iconContainer___DM6iF", Vre = "foton__iconSize___aOlJ9", Zre = "foton__iconGreenActiveCollapsed___P-ylm", Hre = "foton__iconGreenActive___kvZi5", jre = "foton__iconDefaultActive___FmPFF", Wre = "foton__labelContainer___68ZVG", it = {
  itemContainer: kre,
  itemCollapsed: Lre,
  itemsContent: Tre,
  itemDefaultActive: Ore,
  itemGreenActiveCollapsed: Ire,
  itemGreenActive: Pre,
  iconDefault: Dre,
  iconDefaultColor: Nre,
  iconHover: Bre,
  iconGreenCollapsed: Fre,
  iconContainer: $re,
  iconSize: Vre,
  iconGreenActiveCollapsed: Zre,
  iconGreenActive: Hre,
  iconDefaultActive: jre,
  labelContainer: Wre
}, zre = ({ to: t, className: e, children: r }) => /* @__PURE__ */ C("a", { href: t, className: e, children: r }), Co = {
  default: {
    itemActive: it.itemDefaultActive,
    iconActive: it.iconDefaultActive,
    icon: `${it.iconDefaultColor} ${it.iconDefault}`,
    activeCollapsed: it.itemDefaultActive,
    iconCollapsed: `${it.iconDefaultColor} ${it.iconDefault}`
  },
  green: {
    itemActive: it.itemGreenActive,
    iconActive: it.iconGreenActive,
    icon: it.iconDefaultColor,
    activeCollapsed: it.itemGreenActiveCollapsed,
    iconCollapsed: it.iconGreenCollapsed
  }
}, N8 = ({
  iconName: t,
  iconPath: e,
  label: r,
  collapsed: n,
  path: a,
  LinkComponent: o,
  isActive: i,
  color: l = "default"
}) => {
  const [c, u] = ke.useState(!1), d = n ? Co[l].iconCollapsed : Co[l].icon, f = i && n ? Co[l].activeCollapsed : Co[l].iconActive, h = i ? f : d, v = i && n ? Co[l].activeCollapsed : "", p = i && !v ? Co[l].itemActive : v, g = o || zre, m = () => {
    !i && !n && l === "green" && u(!c);
  };
  return /* @__PURE__ */ C("div", { onMouseEnter: m, onMouseLeave: m, children: /* @__PURE__ */ Z(
    g,
    {
      to: a,
      className: G(
        n ? it.itemCollapsed : it.itemContainer,
        !c && l === "default" ? "hover:bg-light-30 hover:rounded-pill" : "",
        p
      ),
      children: [
        /* @__PURE__ */ C("div", { className: G(it.iconContainer, c ? "bg-primary-30 rounded-pill" : ""), children: e ? /* @__PURE__ */ C("img", { src: e, alt: r, className: it.iconItems }) : t && /* @__PURE__ */ C(Me, { icon: t, solid: i, extraClassNames: G(it.iconSize, h) }) }),
        /* @__PURE__ */ C("div", { className: it.labelContainer, children: !n && /* @__PURE__ */ C("p", { children: r }) })
      ]
    }
  ) });
}, Gre = "foton__root___w0fKk", Ure = "foton__labelContent___igAg3", Yre = "foton__icon___64cMk", Xre = "foton__iconOnError___vLOHC", qre = "foton__iconPositionInsideContent___EAOOs", Kre = "foton__labelContainer___qumD9", Qre = "foton__content___B-eYK", Jre = "foton__inputContainer___gH-Iy", ene = "foton__contentFocus___gsUYC", tne = "foton__contentFocusOnError___3F-4y", rne = "foton__disabledBorder___srj97", nne = "foton__messageError___lbRvE", Ae = {
  root: Gre,
  labelContent: Ure,
  icon: Yre,
  iconOnError: Xre,
  iconPositionInsideContent: qre,
  labelContainer: Kre,
  content: Qre,
  inputContainer: Jre,
  contentFocus: ene,
  contentFocusOnError: tne,
  disabledBorder: rne,
  messageError: nne
}, ane = ({ content: t, tooltipContent: e, required: r, className: n }) => /* @__PURE__ */ Z("div", { className: Ae.labelContainer, children: [
  /* @__PURE__ */ C("label", { className: G(Ae.labelContent, n), children: t }),
  r && /* @__PURE__ */ C("span", { className: "text-orange-30", children: "*" }),
  e && /* @__PURE__ */ C(
    Gl,
    {
      side: "top",
      icon: {
        icon: "InformationCircleIcon",
        extraClassNames: "text-light-20 fill-gray-50 size-5"
      },
      content: e
    }
  )
] }), one = ({ children: t, className: e }) => /* @__PURE__ */ C("div", { className: G(Ae.root, e), children: t }), ine = ({ inputRef: t, ...e }) => {
  const { id: r, className: n, disabled: a, required: o, placeholder: i, error: l, icon: c, ...u } = e, d = !!l, f = d ? Ae.contentFocusOnError : Ae.contentFocus, h = a && !d ? Ae.disabledBorder : f, v = G(f, n, h);
  return /* @__PURE__ */ Z("div", { className: Ae.inputContainer, children: [
    /* @__PURE__ */ C(
      "input",
      {
        ...u,
        id: r,
        type: "text",
        className: G(Ae.content, v),
        disabled: a,
        required: o,
        placeholder: i,
        ref: t
      }
    ),
    d && /* @__PURE__ */ C(
      Me,
      {
        extraClassNames: G(Ae.iconOnError, Ae.icon, Ae.iconPositionInsideContent),
        icon: "ExclamationCircleIcon"
      }
    ),
    c && !d && /* @__PURE__ */ C(
      Me,
      {
        extraClassNames: G(Ae.icon, Ae.iconPositionInsideContent, c.extraClassNames),
        icon: c.name
      }
    )
  ] });
}, lne = ({ inputRef: t, error: e, ...r }) => {
  const { id: n, className: a, disabled: o, required: i, placeholder: l, ...c } = r, [u, d] = gt(!0), f = e ? Ae.contentFocusOnError : Ae.contentFocus, h = o ? Ae.disabledBorder : "", v = G(f, a, h);
  return /* @__PURE__ */ Z("div", { className: Ae.inputContainer, children: [
    /* @__PURE__ */ C(
      "input",
      {
        id: n,
        type: u ? "password" : "text",
        className: G(Ae.content, v),
        disabled: o,
        required: i,
        placeholder: l,
        ...c,
        ref: t
      }
    ),
    /* @__PURE__ */ Z("div", { className: G(Ae.iconPositionInsideContent, "flex gap-1"), children: [
      e && /* @__PURE__ */ C(Me, { className: G(Ae.icon, Ae.iconOnError), icon: "ExclamationCircleIcon" }),
      /* @__PURE__ */ C("button", { type: "button", onClick: () => d(!u), children: /* @__PURE__ */ C(Me, { className: Ae.icon, icon: u ? "EyeIcon" : "EyeSlashIcon" }) })
    ] })
  ] });
}, sne = ({ error: t }) => /* @__PURE__ */ C("div", { className: Ae.messageError, children: t });
function Eo() {
}
function cne() {
  return !0;
}
function Ki(t) {
  return !!(t || "").match(/\d/);
}
function zp(t) {
  return t == null;
}
function Gp(t) {
  return t.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
}
function une(t) {
  switch (t) {
    case "lakh":
      return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
    case "wan":
      return /(\d)(?=(\d{4})+(?!\d))/g;
    case "thousand":
    default:
      return /(\d)(?=(\d{3})+(?!\d))/g;
  }
}
function dne(t, e, r) {
  var n = une(r), a = t.search(/[1-9]/);
  return a = a === -1 ? t.length : a, t.substring(0, a) + t.substring(a, t.length).replace(n, "$1" + e);
}
function nh(t, e) {
  e === void 0 && (e = !0);
  var r = t[0] === "-", n = r && e;
  t = t.replace("-", "");
  var a = t.split("."), o = a[0], i = a[1] || "";
  return {
    beforeDecimal: o,
    afterDecimal: i,
    hasNagation: r,
    addNegation: n
  };
}
function fne(t) {
  if (!t)
    return t;
  var e = t[0] === "-";
  e && (t = t.substring(1, t.length));
  var r = t.split("."), n = r[0].replace(/^0+/, "") || "0", a = r[1] || "";
  return (e ? "-" : "") + n + (a ? "." + a : "");
}
function B8(t, e, r) {
  for (var n = "", a = r ? "0" : "", o = 0; o <= e - 1; o++)
    n += t[o] || a;
  return n;
}
function Up(t, e) {
  return Array(e + 1).join(t);
}
function hne(t) {
  t += "";
  var e = t[0] === "-" ? "-" : "";
  e && (t = t.substring(1));
  var r = t.split(/[eE]/g), n = r[0], a = r[1];
  if (a = Number(a), !a)
    return e + n;
  n = n.replace(".", "");
  var o = 1 + a, i = n.length;
  return o < 0 ? n = "0." + Up("0", Math.abs(o)) + n : o >= i ? n = n + Up("0", o - i) : n = (n.substring(0, o) || "0") + "." + n.substring(o), e + n;
}
function vne(t, e, r) {
  if (["", "-"].indexOf(t) !== -1)
    return t;
  var n = t.indexOf(".") !== -1 && e, a = nh(t), o = a.beforeDecimal, i = a.afterDecimal, l = a.hasNagation, c = parseFloat("0." + (i || "0")), u = i.length <= e ? "0." + i : c.toFixed(e), d = u.split("."), f = o.split("").reverse().reduce(function(g, m, w) {
    return g.length > w ? (Number(g[0]) + Number(m)).toString() + g.substring(1, g.length) : m + g;
  }, d[0]), h = B8(
    d[1] || "",
    Math.min(e, i.length),
    r
  ), v = l ? "-" : "", p = n ? "." : "";
  return "" + v + f + p + h;
}
function Yp(t, e) {
  if (t.value = t.value, t !== null) {
    if (t.createTextRange) {
      var r = t.createTextRange();
      return r.move("character", e), r.select(), !0;
    }
    return t.selectionStart || t.selectionStart === 0 ? (t.focus(), t.setSelectionRange(e, e), !0) : (t.focus(), !1);
  }
}
function pne(t, e) {
  for (var r = 0, n = 0, a = t.length, o = e.length; t[r] === e[r] && r < a; )
    r++;
  for (; t[a - 1 - n] === e[o - 1 - n] && o - n > r && a - n > r; )
    n++;
  return { start: r, end: a - n };
}
function D5(t, e, r) {
  return Math.min(Math.max(t, e), r);
}
function Xp(t) {
  return Math.max(t.selectionStart, t.selectionEnd);
}
function gne(t) {
  return t || typeof navigator < "u" && !(navigator.platform && /iPhone|iPod/.test(navigator.platform));
}
function mne(t, e) {
  var r = {};
  for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) === -1 && (r[n] = t[n]);
  return r;
}
var wne = {
  displayType: "input",
  decimalSeparator: ".",
  thousandsGroupStyle: "thousand",
  fixedDecimalScale: !1,
  prefix: "",
  suffix: "",
  allowNegative: !0,
  allowEmptyFormatting: !1,
  allowLeadingZeros: !1,
  isNumericString: !1,
  type: "text",
  onValueChange: Eo,
  onChange: Eo,
  onKeyDown: Eo,
  onMouseUp: Eo,
  onFocus: Eo,
  onBlur: Eo,
  isAllowed: cne
}, F8 = /* @__PURE__ */ function(t) {
  function e(r) {
    t.call(this, r);
    var n = r.defaultValue;
    this.validateProps();
    var a = this.formatValueProp(n);
    this.state = {
      value: a,
      numAsString: this.removeFormatting(a),
      mounted: !1
    }, this.selectionBeforeInput = {
      selectionStart: 0,
      selectionEnd: 0
    }, this.onChange = this.onChange.bind(this), this.onKeyDown = this.onKeyDown.bind(this), this.onMouseUp = this.onMouseUp.bind(this), this.onFocus = this.onFocus.bind(this), this.onBlur = this.onBlur.bind(this);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.componentDidMount = function() {
    this.setState({
      mounted: !0
    });
  }, e.prototype.componentDidUpdate = function(n) {
    this.updateValueIfRequired(n);
  }, e.prototype.componentWillUnmount = function() {
    clearTimeout(this.focusTimeout), clearTimeout(this.caretPositionTimeout);
  }, e.prototype.updateValueIfRequired = function(n) {
    var a = this, o = a.props, i = a.state, l = a.focusedElm, c = i.value, u = i.numAsString;
    if (u === void 0 && (u = ""), n !== o) {
      this.validateProps();
      var d = this.formatNumString(u), f = zp(o.value) ? d : this.formatValueProp(), h = this.removeFormatting(f), v = parseFloat(h), p = parseFloat(u);
      //while typing set state only when float value changes
      ((!isNaN(v) || !isNaN(p)) && v !== p || //can also set state when float value is same and the format props changes
      d !== c || //set state always when not in focus and formatted value is changed
      l === null && f !== c) && this.updateValue({
        formattedValue: f,
        numAsString: h,
        input: l,
        source: "prop",
        event: null
      });
    }
  }, e.prototype.getFloatString = function(n) {
    n === void 0 && (n = "");
    var a = this.props, o = a.decimalScale, i = this.getSeparators(), l = i.decimalSeparator, c = this.getNumberRegex(!0), u = n[0] === "-";
    u && (n = n.replace("-", "")), l && o === 0 && (n = n.split(l)[0]), n = (n.match(c) || []).join("").replace(l, ".");
    var d = n.indexOf(".");
    return d !== -1 && (n = n.substring(0, d) + "." + n.substring(d + 1, n.length).replace(new RegExp(Gp(l), "g"), "")), u && (n = "-" + n), n;
  }, e.prototype.getNumberRegex = function(n, a) {
    var o = this.props, i = o.format, l = o.decimalScale, c = o.customNumerals, u = this.getSeparators(), d = u.decimalSeparator;
    return new RegExp(
      "[0-9" + (c ? c.join("") : "") + "]" + (d && l !== 0 && !a && !i ? "|" + Gp(d) : ""),
      n ? "g" : void 0
    );
  }, e.prototype.getSeparators = function() {
    var n = this.props, a = n.decimalSeparator, o = this.props, i = o.thousandSeparator, l = o.allowedDecimalSeparators;
    return i === !0 && (i = ","), l || (l = [a, "."]), {
      decimalSeparator: a,
      thousandSeparator: i,
      allowedDecimalSeparators: l
    };
  }, e.prototype.getMaskAtIndex = function(n) {
    var a = this.props, o = a.mask;
    return o === void 0 && (o = " "), typeof o == "string" ? o : o[n] || " ";
  }, e.prototype.getValueObject = function(n, a) {
    var o = parseFloat(a);
    return {
      formattedValue: n,
      value: a,
      floatValue: isNaN(o) ? void 0 : o
    };
  }, e.prototype.validateProps = function() {
    var n = this.props, a = n.mask, o = this.getSeparators(), i = o.decimalSeparator, l = o.thousandSeparator;
    if (i === l)
      throw new Error(`
          Decimal separator can't be same as thousand separator.
          thousandSeparator: ` + l + ` (thousandSeparator = {true} is same as thousandSeparator = ",")
          decimalSeparator: ` + i + ` (default value for decimalSeparator is .)
       `);
    if (a) {
      var c = a === "string" ? a : a.toString();
      if (c.match(/\d/g))
        throw new Error(`
          Mask ` + a + ` should not contain numeric character;
        `);
    }
  }, e.prototype.setPatchedCaretPosition = function(n, a, o) {
    Yp(n, a), this.caretPositionTimeout = setTimeout(function() {
      n.value === o && Yp(n, a);
    }, 0);
  }, e.prototype.correctCaretPosition = function(n, a, o) {
    var i = this.props, l = i.prefix, c = i.suffix, u = i.format;
    if (n === "")
      return 0;
    if (a = D5(a, 0, n.length), !u) {
      var d = n[0] === "-";
      return D5(a, l.length + (d ? 1 : 0), n.length - c.length);
    }
    if (typeof u == "function" || u[a] === "#" && Ki(n[a]) || u[a - 1] === "#" && Ki(n[a - 1]))
      return a;
    var f = u.indexOf("#"), h = u.lastIndexOf("#");
    a = D5(a, f, h + 1);
    for (var v = u.substring(a, u.length).indexOf("#"), p = a, g = a + (v === -1 ? 0 : v); p > f && (u[p] !== "#" || !Ki(n[p])); )
      p -= 1;
    var m = !Ki(n[g]) || o === "left" && a !== f || a - p < g - a;
    return m ? Ki(n[p]) ? p + 1 : p : g;
  }, e.prototype.getCaretPosition = function(n, a, o) {
    var i = this.props, l = i.format, c = this.state.value, u = this.getNumberRegex(!0), d = (n.match(u) || []).join(""), f = (a.match(u) || []).join(""), h, v;
    for (h = 0, v = 0; v < o; v++) {
      var p = n[v] || "", g = a[h] || "";
      if (!(!p.match(u) && p !== g) && !(p === "0" && g.match(u) && g !== "0" && d.length !== f.length)) {
        for (; p !== a[h] && h < a.length; )
          h++;
        h++;
      }
    }
    return typeof l == "string" && !c && (h = a.length), h = this.correctCaretPosition(a, h), h;
  }, e.prototype.removePrefixAndSuffix = function(n) {
    var a = this.props, o = a.format, i = a.prefix, l = a.suffix;
    if (!o && n) {
      var c = n[0] === "-";
      c && (n = n.substring(1, n.length)), n = i && n.indexOf(i) === 0 ? n.substring(i.length, n.length) : n;
      var u = n.lastIndexOf(l);
      n = l && u !== -1 && u === n.length - l.length ? n.substring(0, u) : n, c && (n = "-" + n);
    }
    return n;
  }, e.prototype.removePatternFormatting = function(n) {
    for (var a = this.props, o = a.format, i = o.split("#").filter(function(v) {
      return v !== "";
    }), l = 0, c = "", u = 0, d = i.length; u <= d; u++) {
      var f = i[u] || "", h = u === d ? n.length : n.indexOf(f, l);
      if (h === -1) {
        c = n;
        break;
      } else
        c += n.substring(l, h), l = h + f.length;
    }
    return (c.match(this.getNumberRegex(!0)) || []).join("");
  }, e.prototype.removeFormatting = function(n) {
    var a = this.props, o = a.format, i = a.removeFormatting;
    return n && (o ? typeof o == "string" ? n = this.removePatternFormatting(n) : typeof i == "function" ? n = i(n) : n = (n.match(this.getNumberRegex(!0)) || []).join("") : (n = this.removePrefixAndSuffix(n), n = this.getFloatString(n)), n);
  }, e.prototype.formatWithPattern = function(n) {
    for (var a = this.props, o = a.format, i = 0, l = o.split(""), c = 0, u = o.length; c < u; c++)
      o[c] === "#" && (l[c] = n[i] || this.getMaskAtIndex(i), i += 1);
    return l.join("");
  }, e.prototype.formatAsNumber = function(n) {
    var a = this.props, o = a.decimalScale, i = a.fixedDecimalScale, l = a.prefix, c = a.suffix, u = a.allowNegative, d = a.thousandsGroupStyle, f = this.getSeparators(), h = f.thousandSeparator, v = f.decimalSeparator, p = n.indexOf(".") !== -1 || o && i, g = nh(n, u), m = g.beforeDecimal, w = g.afterDecimal, y = g.addNegation;
    return o !== void 0 && (w = B8(w, o, i)), h && (m = dne(m, h, d)), l && (m = l + m), c && (w = w + c), y && (m = "-" + m), n = m + (p && v || "") + w, n;
  }, e.prototype.formatNumString = function(n) {
    n === void 0 && (n = "");
    var a = this.props, o = a.format, i = a.allowEmptyFormatting, l = a.customNumerals, c = n;
    if (l && l.length === 10) {
      var u = new RegExp("[" + l.join("") + "]", "g");
      c = n.replace(
        u,
        function(d) {
          return l.indexOf(d).toString();
        }
      );
    }
    return n === "" && !i ? c = "" : n === "-" && !o ? c = "-" : typeof o == "string" ? c = this.formatWithPattern(c) : typeof o == "function" ? c = o(c) : c = this.formatAsNumber(c), c;
  }, e.prototype.formatValueProp = function(n) {
    var a = this.props, o = a.format, i = a.decimalScale, l = a.fixedDecimalScale, c = a.allowEmptyFormatting, u = this.props, d = u.value, f = u.isNumericString;
    d = zp(d) ? n : d;
    var h = !d && d !== 0;
    if (h && c && (d = ""), h && !c)
      return "";
    typeof d == "number" && (d = hne(d), f = !0), d === "Infinity" && f && (d = ""), f && !o && typeof i == "number" && (d = vne(d, i, l));
    var v = f ? this.formatNumString(d) : this.formatInput(d);
    return v;
  }, e.prototype.formatNegation = function(n) {
    n === void 0 && (n = "");
    var a = this.props, o = a.allowNegative, i = new RegExp("(-)"), l = new RegExp("(-)(.)*(-)"), c = i.test(n), u = l.test(n);
    return n = n.replace(/-/g, ""), c && !u && o && (n = "-" + n), n;
  }, e.prototype.formatInput = function(n) {
    n === void 0 && (n = "");
    var a = this.props, o = a.format;
    return o || (n = this.removePrefixAndSuffix(n), n = this.formatNegation(n)), n = this.removeFormatting(n), this.formatNumString(n);
  }, e.prototype.isCharacterAFormat = function(n, a) {
    var o = this.props, i = o.format, l = o.prefix, c = o.suffix, u = o.decimalScale, d = o.fixedDecimalScale, f = this.getSeparators(), h = f.decimalSeparator;
    return !!(typeof i == "string" && i[n] !== "#" || !i && (n < l.length || n >= a.length - c.length || u && d && a[n] === h));
  }, e.prototype.correctInputValue = function(n, a, o) {
    var i = this, l = this.props, c = l.format, u = l.allowNegative, d = l.prefix, f = l.suffix, h = l.decimalScale, v = this.getSeparators(), p = v.allowedDecimalSeparators, g = v.decimalSeparator, m = this.state.numAsString || "", w = this.selectionBeforeInput, y = w.selectionStart, b = w.selectionEnd, _ = pne(a, o), x = _.start, E = _.end;
    if (!c && x === E && p.indexOf(o[y]) !== -1) {
      var S = h === 0 ? "" : g;
      return o.substr(0, y) + S + o.substr(y + 1, o.length);
    }
    var M = c ? 0 : d.length, R = a.length - (c ? 0 : f.length);
    if (
      // don't do anything if something got added
      o.length > a.length || // or if the new value is an empty string
      !o.length || // or if nothing has changed, in which case start will be same as end
      x === E || // or in case if whole input is selected and new value is typed
      y === 0 && b === a.length || // or in case if the whole content is replaced by browser, example (autocomplete)
      x === 0 && E === a.length || // or if charcters between prefix and suffix is selected.
      // For numeric inputs we apply the format so, prefix and suffix can be ignored
      y === M && b === R
    )
      return o;
    var A = a.substr(x, E - x), k = !![].concat(A).find(
      function(V, W) {
        return i.isCharacterAFormat(W + x, a);
      }
    );
    if (k) {
      var L = a.substr(x), T = {}, O = [];
      [].concat(L).forEach(function(V, W) {
        i.isCharacterAFormat(W + x, a) ? T[W] = V : W > A.length - 1 && O.push(V);
      }), Object.keys(T).forEach(function(V) {
        O.length > V ? O.splice(V, 0, T[V]) : O.push(T[V]);
      }), o = a.substr(0, x) + O.join("");
    }
    if (!c) {
      var D = this.removeFormatting(o), P = nh(
        D,
        u
      ), F = P.beforeDecimal, B = P.afterDecimal, N = P.addNegation, $ = n < o.indexOf(g) + 1;
      if (D.length < m.length && $ && F === "" && !parseFloat(B))
        return N ? "-" : "";
    }
    return o;
  }, e.prototype.updateValue = function(n) {
    var a = n.formattedValue, o = n.input, i = n.setCaretPosition;
    i === void 0 && (i = !0);
    var l = n.source, c = n.event, u = n.numAsString, d = n.caretPos, f = this.props, h = f.onValueChange, v = this.state, p = v.value;
    if (o) {
      if (d === void 0 && i) {
        var g = n.inputValue || o.value, m = Xp(o);
        o.value = a, d = this.getCaretPosition(g, a, m);
      }
      o.value = a, i && this.setPatchedCaretPosition(o, d, a);
    }
    u === void 0 && (u = this.removeFormatting(a)), a !== p && (this.setState({ value: a, numAsString: u }), h(this.getValueObject(a, u), { event: c, source: l }));
  }, e.prototype.onChange = function(n) {
    var a = n.target, o = a.value, i = this, l = i.state, c = i.props, u = c.isAllowed, d = l.value || "", f = Xp(a);
    o = this.correctInputValue(f, d, o);
    var h = this.formatInput(o) || "", v = this.removeFormatting(h), p = this.getValueObject(h, v), g = u(p);
    g || (h = d), this.updateValue({
      formattedValue: h,
      numAsString: v,
      inputValue: o,
      input: a,
      event: n,
      source: "event"
    }), g && c.onChange(n);
  }, e.prototype.onBlur = function(n) {
    var a = this, o = a.props, i = a.state, l = o.format, c = o.onBlur, u = o.allowLeadingZeros, d = i.numAsString, f = i.value;
    if (this.focusedElm = null, clearTimeout(this.focusTimeout), clearTimeout(this.caretPositionTimeout), !l) {
      isNaN(parseFloat(d)) && (d = ""), u || (d = fne(d));
      var h = this.formatNumString(d);
      if (h !== f) {
        this.updateValue({
          formattedValue: h,
          numAsString: d,
          input: n.target,
          setCaretPosition: !1,
          event: n,
          source: "event"
        }), c(n);
        return;
      }
    }
    c(n);
  }, e.prototype.onKeyDown = function(n) {
    var a = n.target, o = n.key, i = a.selectionStart, l = a.selectionEnd, c = a.value;
    c === void 0 && (c = "");
    var u, d = this.props, f = d.decimalScale, h = d.fixedDecimalScale, v = d.prefix, p = d.suffix, g = d.format, m = d.onKeyDown, w = f !== void 0 && h, y = this.getNumberRegex(!1, w), b = new RegExp("-"), _ = typeof g == "string";
    if (this.selectionBeforeInput = {
      selectionStart: i,
      selectionEnd: l
    }, o === "ArrowLeft" || o === "Backspace" ? u = i - 1 : o === "ArrowRight" ? u = i + 1 : o === "Delete" && (u = i), u === void 0 || i !== l) {
      m(n);
      return;
    }
    var x = u, E = _ ? g.indexOf("#") : v.length, S = _ ? g.lastIndexOf("#") + 1 : c.length - p.length;
    if (o === "ArrowLeft" || o === "ArrowRight") {
      var M = o === "ArrowLeft" ? "left" : "right";
      x = this.correctCaretPosition(c, u, M);
    } else if (o === "Delete" && !y.test(c[u]) && !b.test(c[u]))
      for (; !y.test(c[x]) && x < S; )
        x++;
    else if (o === "Backspace" && !y.test(c[u])) {
      if (i <= E + 1 && c[0] === "-" && typeof g > "u") {
        var R = c.substring(1);
        this.updateValue({
          formattedValue: R,
          caretPos: x,
          input: a,
          event: n,
          source: "event"
        });
      } else if (!b.test(c[u])) {
        for (; !y.test(c[x - 1]) && x > E; )
          x--;
        x = this.correctCaretPosition(c, x, "left");
      }
    }
    (x !== u || u < E || u > S) && (n.preventDefault(), this.setPatchedCaretPosition(a, x, c)), n.isUnitTestRun && this.setPatchedCaretPosition(a, x, c), m(n);
  }, e.prototype.onMouseUp = function(n) {
    var a = n.target, o = a.selectionStart, i = a.selectionEnd, l = a.value;
    if (l === void 0 && (l = ""), o === i) {
      var c = this.correctCaretPosition(l, o);
      c !== o && this.setPatchedCaretPosition(a, c, l);
    }
    this.props.onMouseUp(n);
  }, e.prototype.onFocus = function(n) {
    var a = this;
    n.persist(), this.focusedElm = n.target, this.focusTimeout = setTimeout(function() {
      var o = n.target, i = o.selectionStart, l = o.selectionEnd, c = o.value;
      c === void 0 && (c = "");
      var u = a.correctCaretPosition(c, i);
      u !== i && !(i === 0 && l === c.length) && a.setPatchedCaretPosition(o, u, c), a.props.onFocus(n);
    }, 0);
  }, e.prototype.render = function() {
    var n = this.props, a = n.type, o = n.displayType, i = n.customInput, l = n.renderText, c = n.getInputRef, u = n.format;
    n.thousandSeparator, n.decimalSeparator, n.allowedDecimalSeparators, n.thousandsGroupStyle, n.decimalScale, n.fixedDecimalScale, n.prefix, n.suffix, n.removeFormatting, n.mask, n.defaultValue, n.isNumericString, n.allowNegative, n.allowEmptyFormatting, n.allowLeadingZeros, n.onValueChange, n.isAllowed, n.customNumerals, n.onChange, n.onKeyDown, n.onMouseUp, n.onFocus, n.onBlur, n.value;
    var d = mne(n, ["type", "displayType", "customInput", "renderText", "getInputRef", "format", "thousandSeparator", "decimalSeparator", "allowedDecimalSeparators", "thousandsGroupStyle", "decimalScale", "fixedDecimalScale", "prefix", "suffix", "removeFormatting", "mask", "defaultValue", "isNumericString", "allowNegative", "allowEmptyFormatting", "allowLeadingZeros", "onValueChange", "isAllowed", "customNumerals", "onChange", "onKeyDown", "onMouseUp", "onFocus", "onBlur", "value"]), f = d, h = this.state, v = h.value, p = h.mounted, g = p && gne(u) ? "numeric" : void 0, m = Object.assign({ inputMode: g }, f, {
      type: a,
      value: v,
      onChange: this.onChange,
      onKeyDown: this.onKeyDown,
      onMouseUp: this.onMouseUp,
      onFocus: this.onFocus,
      onBlur: this.onBlur
    });
    if (o === "text")
      return l ? l(v, f) || null : ke.createElement(
        "span",
        Object.assign({}, f, { ref: c }),
        v
      );
    if (i) {
      var w = i;
      return ke.createElement(w, Object.assign({}, m, { ref: c }));
    }
    return ke.createElement("input", Object.assign({}, m, { ref: c }));
  }, e;
}(ke.Component);
F8.defaultProps = wne;
const yne = ({ inputRef: t, onChange: e, ...r }) => {
  const { id: n, className: a, disabled: o, error: i, icon: l, formatProps: c } = r, u = !!i, d = u ? Ae.contentFocusOnError : Ae.contentFocus, f = o && !u ? Ae.disabledBorder : d, h = G(d, a, f);
  return /* @__PURE__ */ Z("div", { className: Ae.inputContainer, children: [
    /* @__PURE__ */ C(
      F8,
      {
        ...c,
        id: n,
        className: G(Ae.content, h),
        disabled: o,
        getInputRef: t,
        onValueChange: (v) => {
          if (e.valueArgType === "string") return e.callback(v.value);
          const p = v.floatValue === void 0 ? null : v.floatValue;
          p && !c.allowNegative ? e.callback(Math.abs(p)) : e.callback(p);
        },
        "data-cy": n
      }
    ),
    u && /* @__PURE__ */ C(
      Me,
      {
        extraClassNames: G(Ae.iconOnError, Ae.icon, Ae.iconPositionInsideContent),
        icon: "ExclamationCircleIcon"
      }
    ),
    l && !u && /* @__PURE__ */ C(
      Me,
      {
        extraClassNames: G(Ae.icon, Ae.iconPositionInsideContent, l.extraClassNames),
        icon: l.name
      }
    )
  ] });
}, qp = {
  Root: one,
  Label: ane,
  TextContent: ine,
  NumericContent: yne,
  PasswordContent: lne,
  Error: sne
}, bne = "foton__trigger___u9qUl", _ne = "foton__bordered___Py-hO", xne = "foton__error___AmABX", Cne = "foton__triggerIconContainer___TOd9v", Ene = "foton__content___zDFtJ", Sne = "foton__input___W1uNB", Rne = "foton__optionsContainer___bSrds", Mne = "foton__optionButton___1vLYC", Ane = "foton__truncateText___ttDDO", jr = {
  trigger: bne,
  bordered: _ne,
  error: xne,
  triggerIconContainer: Cne,
  content: Ene,
  input: Sne,
  optionsContainer: Rne,
  optionButton: Mne,
  truncateText: Ane
}, $8 = ({
  options: t,
  placeholder: e = "Selecione...",
  prependIcon: r,
  error: n,
  bordered: a = !1,
  appendIcon: o = "ChevronDownIcon",
  triggerClassName: i,
  onChange: l,
  value: c = ""
}) => {
  const [u, d] = gt(!1), [f, h] = gt(""), [v, p] = gt(c);
  En(() => {
    c && p(c);
  }, [c]);
  const g = t.find((y) => y.value === v), m = g ? "!bg-gray-20" : "", w = (y) => {
    p(y), l == null || l(y), d(!1);
  };
  return /* @__PURE__ */ Z(Qee, { open: u, onOpenChange: d, children: [
    /* @__PURE__ */ Z(
      Jee,
      {
        className: G(
          jr.trigger,
          a && jr.bordered,
          n && jr.error,
          i,
          m
        ),
        children: [
          /* @__PURE__ */ Z("div", { className: jr.triggerIconContainer, children: [
            r && /* @__PURE__ */ C(Me, { icon: r, extraClassNames: "size-5" }),
            /* @__PURE__ */ C("span", { className: G(jr.truncateText, v ? "text-black" : "text-gray-400"), children: g ? g.label : e })
          ] }),
          o && /* @__PURE__ */ C(Me, { icon: o, extraClassNames: "size-5" })
        ]
      }
    ),
    /* @__PURE__ */ Z(ete, { align: "start", className: jr.content, children: [
      /* @__PURE__ */ C(qp.Root, { children: /* @__PURE__ */ C(
        qp.TextContent,
        {
          placeholder: "Buscar...",
          value: f,
          onChange: (y) => h(y.target.value),
          className: jr.input,
          icon: { name: "MagnifyingGlassIcon", extraClassNames: "text-primary-0" }
        }
      ) }),
      /* @__PURE__ */ C("div", { className: jr.optionsContainer, children: t.filter((y) => y.label.toLowerCase().includes(f.toLowerCase())).map((y) => /* @__PURE__ */ Z("button", { onClick: () => w(y.value), className: jr.optionButton, children: [
        /* @__PURE__ */ C("span", { className: jr.truncateText, children: y.label }),
        v === y.value && /* @__PURE__ */ C(Me, { icon: "CheckIcon", extraClassNames: "size-5 text-green-500" })
      ] }, y.value)) })
    ] })
  ] });
}, kne = "foton__sidebarContainer___lnCcr", Lne = "foton__sidebarContainerCollapsed___N2oUC", Tne = "foton__sidebarContent___pTYPI", One = "foton__logoContainer___3co6j", Ine = "foton__textSubMenu___MxWhk", Pne = "foton__hiddenContent___4yVk3", Dne = "foton__collapseButton___S8j-L", Nne = "foton__sessionContainer___AAGQa", Bne = "foton__groupSelectContainer___B25-d", Fne = "foton__icon___rwutQ", $ne = "foton__profileContainer___lh3EO", Vne = "foton__endContainer___dKjQ3", Wr = {
  sidebarContainer: kne,
  sidebarContainerCollapsed: Lne,
  sidebarContent: Tne,
  logoContainer: One,
  textSubMenu: Ine,
  hiddenContent: Pne,
  collapseButton: Dne,
  sessionContainer: Nne,
  groupSelectContainer: Bne,
  icon: Fne,
  profileContainer: $ne,
  endContainer: Vne
}, Zne = ({
  userInfo: t,
  menuItem: e,
  handleLogout: r,
  actionButton: n,
  groupListSelect: a,
  collapsed: o,
  variant: i = "fixed",
  menuColor: l = "default",
  showCollapsedButton: c = !0,
  onChangeCollapse: u,
  ...d
}) => {
  const { className: f, ...h } = d, [v, p] = gt(o ?? !1), g = i === "fixed", m = !v || v && !c, w = v ? Wr.sidebarContainerCollapsed : "";
  return En(() => {
    o !== void 0 && p(o);
  }, [o]), /* @__PURE__ */ Z(
    "menu",
    {
      className: G(
        Wr.sidebarContainer,
        w,
        g ? "min-h-screen max-h-screen sticky top-0" : "",
        f
      ),
      ...h,
      role: "navigation",
      "aria-label": "Menu",
      children: [
        /* @__PURE__ */ Z("div", { className: G(Wr.sidebarContent), children: [
          /* @__PURE__ */ Z(
            "div",
            {
              className: G(
                Wr.logoContainer,
                v ? "justify-center" : "justify-between",
                m ? "" : "justify-center"
              ),
              children: [
                m && /* @__PURE__ */ C(D8, {}),
                c && /* @__PURE__ */ C(
                  "button",
                  {
                    onClick: () => {
                      u ? u && u(!v) : p(!v);
                    },
                    children: /* @__PURE__ */ C("img", { src: Sre, alt: "Icone do Menu" })
                  }
                )
              ]
            }
          ),
          !v && /* @__PURE__ */ C("div", { className: Wr.groupSelectContainer, children: /* @__PURE__ */ C($8, { ...a, appendIcon: "ChevronUpDownIcon", triggerClassName: "w-full" }) })
        ] }),
        /* @__PURE__ */ C("nav", { className: G(g ? "overflow-y-auto no-scrollbar" : ""), children: /* @__PURE__ */ C("ul", { children: e.map(({ sessionTitle: y, links: b }, _) => /* @__PURE__ */ Z("li", { className: Wr.sessionContainer, children: [
          y && /* @__PURE__ */ C(
            "span",
            {
              className: `${G(Wr.textSubMenu)} ${v ? G(Wr.hiddenContent) : ""}`,
              role: "text",
              children: y
            }
          ),
          b.map((x, E) => /* @__PURE__ */ C(
            N8,
            {
              label: x.label,
              iconName: x.iconName,
              path: x.path,
              collapsed: v,
              isActive: x.isActive,
              LinkComponent: x.LinkComponent,
              color: l
            },
            `${x.label}-${x.path}-${E}`
          ))
        ] }, `menu-item-list-${_}`)) }) }),
        /* @__PURE__ */ Z("div", { className: Wr.endContainer, children: [
          /* @__PURE__ */ C("div", { className: Wr.profileContainer, children: /* @__PURE__ */ C(
            P8,
            {
              name: v ? "" : t.name,
              picture: t.picture,
              email: v ? "" : t.email
            }
          ) }),
          v ? /* @__PURE__ */ Z(gr, { children: [
            (n == null ? void 0 : n.show) && /* @__PURE__ */ C(
              gi,
              {
                icon: n.icon,
                onClick: n.onClick,
                kind: "secondary",
                size: "medium",
                className: "mt-2",
                iconColor: l === "green" ? "text-primary-70" : ""
              }
            ),
            /* @__PURE__ */ C(
              gi,
              {
                icon: "ArrowLeftStartOnRectangleIcon",
                onClick: r,
                kind: "secondary",
                size: "medium",
                className: "mt-2",
                iconColor: l === "green" ? "text-primary-70" : ""
              }
            )
          ] }) : /* @__PURE__ */ Z(gr, { children: [
            (n == null ? void 0 : n.show) && /* @__PURE__ */ C(
              k0,
              {
                leftIcon: n.icon,
                onClick: n.onClick,
                kind: "secondary",
                size: "small",
                className: "w-full mb-2",
                children: n.label
              }
            ),
            /* @__PURE__ */ C(
              k0,
              {
                rightIcon: "ArrowLeftStartOnRectangleIcon",
                kind: "secondary",
                size: "small",
                onClick: r,
                className: "w-full",
                children: "Sair"
              }
            )
          ] })
        ] })
      ]
    }
  );
};
function V8(t, e = []) {
  let r = [];
  function n(o, i) {
    const l = s.createContext(i), c = r.length;
    r = [...r, i];
    const u = (f) => {
      var w;
      const { scope: h, children: v, ...p } = f, g = ((w = h == null ? void 0 : h[t]) == null ? void 0 : w[c]) || l, m = s.useMemo(() => p, Object.values(p));
      return /* @__PURE__ */ C(g.Provider, { value: m, children: v });
    };
    u.displayName = o + "Provider";
    function d(f, h) {
      var g;
      const v = ((g = h == null ? void 0 : h[t]) == null ? void 0 : g[c]) || l, p = s.useContext(v);
      if (p) return p;
      if (i !== void 0) return i;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [u, d];
  }
  const a = () => {
    const o = r.map((i) => s.createContext(i));
    return function(l) {
      const c = (l == null ? void 0 : l[t]) || o;
      return s.useMemo(
        () => ({ [`__scope${t}`]: { ...l, [t]: c } }),
        [l, c]
      );
    };
  };
  return a.scopeName = t, [n, Hne(a, ...e)];
}
function Hne(...t) {
  const e = t[0];
  if (t.length === 1) return e;
  const r = () => {
    const n = t.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(o) {
      const i = n.reduce((l, { useScope: c, scopeName: u }) => {
        const f = c(o)[`__scope${u}`];
        return { ...l, ...f };
      }, {});
      return s.useMemo(() => ({ [`__scope${e.scopeName}`]: i }), [i]);
    };
  };
  return r.scopeName = e.scopeName, r;
}
var jne = "DismissableLayer", ah = "dismissableLayer.update", Wne = "dismissableLayer.pointerDownOutside", zne = "dismissableLayer.focusOutside", Kp, Z8 = s.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), H8 = s.forwardRef(
  (t, e) => {
    const {
      disableOutsidePointerEvents: r = !1,
      onEscapeKeyDown: n,
      onPointerDownOutside: a,
      onFocusOutside: o,
      onInteractOutside: i,
      onDismiss: l,
      ...c
    } = t, u = s.useContext(Z8), [d, f] = s.useState(null), h = (d == null ? void 0 : d.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, v] = s.useState({}), p = ce(e, (S) => f(S)), g = Array.from(u.layers), [m] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), w = g.indexOf(m), y = d ? g.indexOf(d) : -1, b = u.layersWithOutsidePointerEventsDisabled.size > 0, _ = y >= w, x = Yne((S) => {
      const M = S.target, R = [...u.branches].some((A) => A.contains(M));
      !_ || R || (a == null || a(S), i == null || i(S), S.defaultPrevented || l == null || l());
    }, h), E = Xne((S) => {
      const M = S.target;
      [...u.branches].some((A) => A.contains(M)) || (o == null || o(S), i == null || i(S), S.defaultPrevented || l == null || l());
    }, h);
    return W2((S) => {
      y === u.layers.size - 1 && (n == null || n(S), !S.defaultPrevented && l && (S.preventDefault(), l()));
    }, h), s.useEffect(() => {
      if (d)
        return r && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (Kp = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), Qp(), () => {
          r && u.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = Kp);
        };
    }, [d, h, r, u]), s.useEffect(() => () => {
      d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), Qp());
    }, [d, u]), s.useEffect(() => {
      const S = () => v({});
      return document.addEventListener(ah, S), () => document.removeEventListener(ah, S);
    }, []), /* @__PURE__ */ C(
      te.div,
      {
        ...c,
        ref: p,
        style: {
          pointerEvents: b ? _ ? "auto" : "none" : void 0,
          ...t.style
        },
        onFocusCapture: j(t.onFocusCapture, E.onFocusCapture),
        onBlurCapture: j(t.onBlurCapture, E.onBlurCapture),
        onPointerDownCapture: j(
          t.onPointerDownCapture,
          x.onPointerDownCapture
        )
      }
    );
  }
);
H8.displayName = jne;
var Gne = "DismissableLayerBranch", Une = s.forwardRef((t, e) => {
  const r = s.useContext(Z8), n = s.useRef(null), a = ce(e, n);
  return s.useEffect(() => {
    const o = n.current;
    if (o)
      return r.branches.add(o), () => {
        r.branches.delete(o);
      };
  }, [r.branches]), /* @__PURE__ */ C(te.div, { ...t, ref: a });
});
Une.displayName = Gne;
function Yne(t, e = globalThis == null ? void 0 : globalThis.document) {
  const r = Ke(t), n = s.useRef(!1), a = s.useRef(() => {
  });
  return s.useEffect(() => {
    const o = (l) => {
      if (l.target && !n.current) {
        let c = function() {
          j8(
            Wne,
            r,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: l };
        l.pointerType === "touch" ? (e.removeEventListener("click", a.current), a.current = c, e.addEventListener("click", a.current, { once: !0 })) : c();
      } else
        e.removeEventListener("click", a.current);
      n.current = !1;
    }, i = window.setTimeout(() => {
      e.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(i), e.removeEventListener("pointerdown", o), e.removeEventListener("click", a.current);
    };
  }, [e, r]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => n.current = !0
  };
}
function Xne(t, e = globalThis == null ? void 0 : globalThis.document) {
  const r = Ke(t), n = s.useRef(!1);
  return s.useEffect(() => {
    const a = (o) => {
      o.target && !n.current && j8(zne, r, { originalEvent: o }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", a), () => e.removeEventListener("focusin", a);
  }, [e, r]), {
    onFocusCapture: () => n.current = !0,
    onBlurCapture: () => n.current = !1
  };
}
function Qp() {
  const t = new CustomEvent(ah);
  document.dispatchEvent(t);
}
function j8(t, e, r, { discrete: n }) {
  const a = r.originalEvent.target, o = new CustomEvent(t, { bubbles: !1, cancelable: !0, detail: r });
  e && a.addEventListener(t, e, { once: !0 }), n ? $u(a, o) : a.dispatchEvent(o);
}
var N5 = 0;
function qne() {
  s.useEffect(() => {
    const t = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", t[0] ?? Jp()), document.body.insertAdjacentElement("beforeend", t[1] ?? Jp()), N5++, () => {
      N5 === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((e) => e.remove()), N5--;
    };
  }, []);
}
function Jp() {
  const t = document.createElement("span");
  return t.setAttribute("data-radix-focus-guard", ""), t.tabIndex = 0, t.style.outline = "none", t.style.opacity = "0", t.style.position = "fixed", t.style.pointerEvents = "none", t;
}
var Kne = "Portal", W8 = s.forwardRef((t, e) => {
  var l;
  const { container: r, ...n } = t, [a, o] = s.useState(!1);
  Fe(() => o(!0), []);
  const i = r || a && ((l = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : l.body);
  return i ? D2.createPortal(/* @__PURE__ */ C(te.div, { ...n, ref: e }), i) : null;
});
W8.displayName = Kne;
function Qne(t, e) {
  return s.useReducer((r, n) => e[r][n] ?? r, t);
}
var Ss = (t) => {
  const { present: e, children: r } = t, n = Jne(e), a = typeof r == "function" ? r({ present: n.isPresent }) : s.Children.only(r), o = ce(n.ref, eae(a));
  return typeof r == "function" || n.isPresent ? s.cloneElement(a, { ref: o }) : null;
};
Ss.displayName = "Presence";
function Jne(t) {
  const [e, r] = s.useState(), n = s.useRef({}), a = s.useRef(t), o = s.useRef("none"), i = t ? "mounted" : "unmounted", [l, c] = Qne(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return s.useEffect(() => {
    const u = nc(n.current);
    o.current = l === "mounted" ? u : "none";
  }, [l]), Fe(() => {
    const u = n.current, d = a.current;
    if (d !== t) {
      const h = o.current, v = nc(u);
      t ? c("MOUNT") : v === "none" || (u == null ? void 0 : u.display) === "none" ? c("UNMOUNT") : c(d && h !== v ? "ANIMATION_OUT" : "UNMOUNT"), a.current = t;
    }
  }, [t, c]), Fe(() => {
    if (e) {
      let u;
      const d = e.ownerDocument.defaultView ?? window, f = (v) => {
        const g = nc(n.current).includes(v.animationName);
        if (v.target === e && g && (c("ANIMATION_END"), !a.current)) {
          const m = e.style.animationFillMode;
          e.style.animationFillMode = "forwards", u = d.setTimeout(() => {
            e.style.animationFillMode === "forwards" && (e.style.animationFillMode = m);
          });
        }
      }, h = (v) => {
        v.target === e && (o.current = nc(n.current));
      };
      return e.addEventListener("animationstart", h), e.addEventListener("animationcancel", f), e.addEventListener("animationend", f), () => {
        d.clearTimeout(u), e.removeEventListener("animationstart", h), e.removeEventListener("animationcancel", f), e.removeEventListener("animationend", f);
      };
    } else
      c("ANIMATION_END");
  }, [e, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(l),
    ref: s.useCallback((u) => {
      u && (n.current = getComputedStyle(u)), r(u);
    }, [])
  };
}
function nc(t) {
  return (t == null ? void 0 : t.animationName) || "none";
}
function eae(t) {
  var n, a;
  let e = (n = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : n.get, r = e && "isReactWarning" in e && e.isReactWarning;
  return r ? t.ref : (e = (a = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : a.get, r = e && "isReactWarning" in e && e.isReactWarning, r ? t.props.ref : t.props.ref || t.ref);
}
var c0 = "right-scroll-bar-position", u0 = "width-before-scroll-bar", tae = "with-scroll-bars-hidden", rae = "--removed-body-scroll-bar-size", z8 = Y2(), B5 = function() {
}, l1 = s.forwardRef(function(t, e) {
  var r = s.useRef(null), n = s.useState({
    onScrollCapture: B5,
    onWheelCapture: B5,
    onTouchMoveCapture: B5
  }), a = n[0], o = n[1], i = t.forwardProps, l = t.children, c = t.className, u = t.removeScrollBar, d = t.enabled, f = t.shards, h = t.sideCar, v = t.noIsolation, p = t.inert, g = t.allowPinchZoom, m = t.as, w = m === void 0 ? "div" : m, y = t.gapMode, b = Di(t, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), _ = h, x = U2([r, e]), E = Ue(Ue({}, b), a);
  return s.createElement(
    s.Fragment,
    null,
    d && s.createElement(_, { sideCar: z8, removeScrollBar: u, shards: f, noIsolation: v, inert: p, setCallbacks: o, allowPinchZoom: !!g, lockRef: r, gapMode: y }),
    i ? s.cloneElement(s.Children.only(l), Ue(Ue({}, E), { ref: x })) : s.createElement(w, Ue({}, E, { className: c, ref: x }), l)
  );
});
l1.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
l1.classNames = {
  fullWidth: u0,
  zeroRight: c0
};
var nae = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, F5 = function(t) {
  return parseInt(t || "", 10) || 0;
}, aae = function(t) {
  var e = window.getComputedStyle(document.body), r = e[t === "padding" ? "paddingLeft" : "marginLeft"], n = e[t === "padding" ? "paddingTop" : "marginTop"], a = e[t === "padding" ? "paddingRight" : "marginRight"];
  return [F5(r), F5(n), F5(a)];
}, oae = function(t) {
  if (t === void 0 && (t = "margin"), typeof window > "u")
    return nae;
  var e = aae(t), r = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: e[0],
    top: e[1],
    right: e[2],
    gap: Math.max(0, n - r + e[2] - e[0])
  };
}, iae = Ni(), ai = "data-scroll-locked", lae = function(t, e, r, n) {
  var a = t.left, o = t.top, i = t.right, l = t.gap;
  return r === void 0 && (r = "margin"), `
  .`.concat(tae, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(l, "px ").concat(n, `;
  }
  body[`).concat(ai, `] {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    e && "position: relative ".concat(n, ";"),
    r === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(o, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(l, "px ").concat(n, `;
    `),
    r === "padding" && "padding-right: ".concat(l, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(c0, ` {
    right: `).concat(l, "px ").concat(n, `;
  }
  
  .`).concat(u0, ` {
    margin-right: `).concat(l, "px ").concat(n, `;
  }
  
  .`).concat(c0, " .").concat(c0, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(u0, " .").concat(u0, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body[`).concat(ai, `] {
    `).concat(rae, ": ").concat(l, `px;
  }
`);
}, eg = function() {
  var t = parseInt(document.body.getAttribute(ai) || "0", 10);
  return isFinite(t) ? t : 0;
}, sae = function() {
  s.useEffect(function() {
    return document.body.setAttribute(ai, (eg() + 1).toString()), function() {
      var t = eg() - 1;
      t <= 0 ? document.body.removeAttribute(ai) : document.body.setAttribute(ai, t.toString());
    };
  }, []);
}, cae = function(t) {
  var e = t.noRelative, r = t.noImportant, n = t.gapMode, a = n === void 0 ? "margin" : n;
  sae();
  var o = s.useMemo(function() {
    return oae(a);
  }, [a]);
  return s.createElement(iae, { styles: lae(o, !e, a, r ? "" : "!important") });
}, oh = !1;
if (typeof window < "u")
  try {
    var ac = Object.defineProperty({}, "passive", {
      get: function() {
        return oh = !0, !0;
      }
    });
    window.addEventListener("test", ac, ac), window.removeEventListener("test", ac, ac);
  } catch {
    oh = !1;
  }
var So = oh ? { passive: !1 } : !1, uae = function(t) {
  return t.tagName === "TEXTAREA";
}, G8 = function(t, e) {
  if (!(t instanceof Element))
    return !1;
  var r = window.getComputedStyle(t);
  return (
    // not-not-scrollable
    r[e] !== "hidden" && // contains scroll inside self
    !(r.overflowY === r.overflowX && !uae(t) && r[e] === "visible")
  );
}, dae = function(t) {
  return G8(t, "overflowY");
}, fae = function(t) {
  return G8(t, "overflowX");
}, tg = function(t, e) {
  var r = e.ownerDocument, n = e;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var a = U8(t, n);
    if (a) {
      var o = Y8(t, n), i = o[1], l = o[2];
      if (i > l)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== r.body);
  return !1;
}, hae = function(t) {
  var e = t.scrollTop, r = t.scrollHeight, n = t.clientHeight;
  return [
    e,
    r,
    n
  ];
}, vae = function(t) {
  var e = t.scrollLeft, r = t.scrollWidth, n = t.clientWidth;
  return [
    e,
    r,
    n
  ];
}, U8 = function(t, e) {
  return t === "v" ? dae(e) : fae(e);
}, Y8 = function(t, e) {
  return t === "v" ? hae(e) : vae(e);
}, pae = function(t, e) {
  return t === "h" && e === "rtl" ? -1 : 1;
}, gae = function(t, e, r, n, a) {
  var o = pae(t, window.getComputedStyle(e).direction), i = o * n, l = r.target, c = e.contains(l), u = !1, d = i > 0, f = 0, h = 0;
  do {
    var v = Y8(t, l), p = v[0], g = v[1], m = v[2], w = g - m - o * p;
    (p || w) && U8(t, l) && (f += w, h += p), l instanceof ShadowRoot ? l = l.host : l = l.parentNode;
  } while (
    // portaled content
    !c && l !== document.body || // self content
    c && (e.contains(l) || e === l)
  );
  return (d && (Math.abs(f) < 1 || !a) || !d && (Math.abs(h) < 1 || !a)) && (u = !0), u;
}, oc = function(t) {
  return "changedTouches" in t ? [t.changedTouches[0].clientX, t.changedTouches[0].clientY] : [0, 0];
}, rg = function(t) {
  return [t.deltaX, t.deltaY];
}, ng = function(t) {
  return t && "current" in t ? t.current : t;
}, mae = function(t, e) {
  return t[0] === e[0] && t[1] === e[1];
}, wae = function(t) {
  return `
  .block-interactivity-`.concat(t, ` {pointer-events: none;}
  .allow-interactivity-`).concat(t, ` {pointer-events: all;}
`);
}, yae = 0, Ro = [];
function bae(t) {
  var e = s.useRef([]), r = s.useRef([0, 0]), n = s.useRef(), a = s.useState(yae++)[0], o = s.useState(Ni)[0], i = s.useRef(t);
  s.useEffect(function() {
    i.current = t;
  }, [t]), s.useEffect(function() {
    if (t.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var g = ys([t.lockRef.current], (t.shards || []).map(ng), !0).filter(Boolean);
      return g.forEach(function(m) {
        return m.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), g.forEach(function(m) {
          return m.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [t.inert, t.lockRef.current, t.shards]);
  var l = s.useCallback(function(g, m) {
    if ("touches" in g && g.touches.length === 2 || g.type === "wheel" && g.ctrlKey)
      return !i.current.allowPinchZoom;
    var w = oc(g), y = r.current, b = "deltaX" in g ? g.deltaX : y[0] - w[0], _ = "deltaY" in g ? g.deltaY : y[1] - w[1], x, E = g.target, S = Math.abs(b) > Math.abs(_) ? "h" : "v";
    if ("touches" in g && S === "h" && E.type === "range")
      return !1;
    var M = tg(S, E);
    if (!M)
      return !0;
    if (M ? x = S : (x = S === "v" ? "h" : "v", M = tg(S, E)), !M)
      return !1;
    if (!n.current && "changedTouches" in g && (b || _) && (n.current = x), !x)
      return !0;
    var R = n.current || x;
    return gae(R, m, g, R === "h" ? b : _, !0);
  }, []), c = s.useCallback(function(g) {
    var m = g;
    if (!(!Ro.length || Ro[Ro.length - 1] !== o)) {
      var w = "deltaY" in m ? rg(m) : oc(m), y = e.current.filter(function(x) {
        return x.name === m.type && (x.target === m.target || m.target === x.shadowParent) && mae(x.delta, w);
      })[0];
      if (y && y.should) {
        m.cancelable && m.preventDefault();
        return;
      }
      if (!y) {
        var b = (i.current.shards || []).map(ng).filter(Boolean).filter(function(x) {
          return x.contains(m.target);
        }), _ = b.length > 0 ? l(m, b[0]) : !i.current.noIsolation;
        _ && m.cancelable && m.preventDefault();
      }
    }
  }, []), u = s.useCallback(function(g, m, w, y) {
    var b = { name: g, delta: m, target: w, should: y, shadowParent: _ae(w) };
    e.current.push(b), setTimeout(function() {
      e.current = e.current.filter(function(_) {
        return _ !== b;
      });
    }, 1);
  }, []), d = s.useCallback(function(g) {
    r.current = oc(g), n.current = void 0;
  }, []), f = s.useCallback(function(g) {
    u(g.type, rg(g), g.target, l(g, t.lockRef.current));
  }, []), h = s.useCallback(function(g) {
    u(g.type, oc(g), g.target, l(g, t.lockRef.current));
  }, []);
  s.useEffect(function() {
    return Ro.push(o), t.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", c, So), document.addEventListener("touchmove", c, So), document.addEventListener("touchstart", d, So), function() {
      Ro = Ro.filter(function(g) {
        return g !== o;
      }), document.removeEventListener("wheel", c, So), document.removeEventListener("touchmove", c, So), document.removeEventListener("touchstart", d, So);
    };
  }, []);
  var v = t.removeScrollBar, p = t.inert;
  return s.createElement(
    s.Fragment,
    null,
    p ? s.createElement(o, { styles: wae(a) }) : null,
    v ? s.createElement(cae, { gapMode: t.gapMode }) : null
  );
}
function _ae(t) {
  for (var e = null; t !== null; )
    t instanceof ShadowRoot && (e = t.host, t = t.host), t = t.parentNode;
  return e;
}
const xae = X2(z8, bae);
var X8 = s.forwardRef(function(t, e) {
  return s.createElement(l1, Ue({}, t, { ref: e, sideCar: xae }));
});
X8.classNames = l1.classNames;
var ih = ["Enter", " "], Cae = ["ArrowDown", "PageUp", "Home"], q8 = ["ArrowUp", "PageDown", "End"], Eae = [...Cae, ...q8], Sae = {
  ltr: [...ih, "ArrowRight"],
  rtl: [...ih, "ArrowLeft"]
}, Rae = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, Rs = "Menu", [Ul, Mae, Aae] = r1(Rs), [vo, kae] = V8(Rs, [
  Aae,
  ha,
  Vi
]), s1 = ha(), K8 = Vi(), [Lae, po] = vo(Rs), [Tae, Ms] = vo(Rs), Q8 = (t) => {
  const { __scopeMenu: e, open: r = !1, children: n, dir: a, onOpenChange: o, modal: i = !0 } = t, l = s1(e), [c, u] = s.useState(null), d = s.useRef(!1), f = Ke(o), h = $i(a);
  return s.useEffect(() => {
    const v = () => {
      d.current = !0, document.addEventListener("pointerdown", p, { capture: !0, once: !0 }), document.addEventListener("pointermove", p, { capture: !0, once: !0 });
    }, p = () => d.current = !1;
    return document.addEventListener("keydown", v, { capture: !0 }), () => {
      document.removeEventListener("keydown", v, { capture: !0 }), document.removeEventListener("pointerdown", p, { capture: !0 }), document.removeEventListener("pointermove", p, { capture: !0 });
    };
  }, []), /* @__PURE__ */ C(Xu, { ...l, children: /* @__PURE__ */ C(
    Lae,
    {
      scope: e,
      open: r,
      onOpenChange: f,
      content: c,
      onContentChange: u,
      children: /* @__PURE__ */ C(
        Tae,
        {
          scope: e,
          onClose: s.useCallback(() => f(!1), [f]),
          isUsingKeyboardRef: d,
          dir: h,
          modal: i,
          children: n
        }
      )
    }
  ) });
};
Q8.displayName = Rs;
var Oae = "MenuAnchor", bv = s.forwardRef(
  (t, e) => {
    const { __scopeMenu: r, ...n } = t, a = s1(r);
    return /* @__PURE__ */ C(_s, { ...a, ...n, ref: e });
  }
);
bv.displayName = Oae;
var _v = "MenuPortal", [Iae, J8] = vo(_v, {
  forceMount: void 0
}), eb = (t) => {
  const { __scopeMenu: e, forceMount: r, children: n, container: a } = t, o = po(_v, e);
  return /* @__PURE__ */ C(Iae, { scope: e, forceMount: r, children: /* @__PURE__ */ C(Ss, { present: r || o.open, children: /* @__PURE__ */ C(W8, { asChild: !0, container: a, children: n }) }) });
};
eb.displayName = _v;
var pr = "MenuContent", [Pae, xv] = vo(pr), tb = s.forwardRef(
  (t, e) => {
    const r = J8(pr, t.__scopeMenu), { forceMount: n = r.forceMount, ...a } = t, o = po(pr, t.__scopeMenu), i = Ms(pr, t.__scopeMenu);
    return /* @__PURE__ */ C(Ul.Provider, { scope: t.__scopeMenu, children: /* @__PURE__ */ C(Ss, { present: n || o.open, children: /* @__PURE__ */ C(Ul.Slot, { scope: t.__scopeMenu, children: i.modal ? /* @__PURE__ */ C(Dae, { ...a, ref: e }) : /* @__PURE__ */ C(Nae, { ...a, ref: e }) }) }) });
  }
), Dae = s.forwardRef(
  (t, e) => {
    const r = po(pr, t.__scopeMenu), n = s.useRef(null), a = ce(e, n);
    return s.useEffect(() => {
      const o = n.current;
      if (o) return zu(o);
    }, []), /* @__PURE__ */ C(
      Cv,
      {
        ...t,
        ref: a,
        trapFocus: r.open,
        disableOutsidePointerEvents: r.open,
        disableOutsideScroll: !0,
        onFocusOutside: j(
          t.onFocusOutside,
          (o) => o.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => r.onOpenChange(!1)
      }
    );
  }
), Nae = s.forwardRef((t, e) => {
  const r = po(pr, t.__scopeMenu);
  return /* @__PURE__ */ C(
    Cv,
    {
      ...t,
      ref: e,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => r.onOpenChange(!1)
    }
  );
}), Cv = s.forwardRef(
  (t, e) => {
    const {
      __scopeMenu: r,
      loop: n = !1,
      trapFocus: a,
      onOpenAutoFocus: o,
      onCloseAutoFocus: i,
      disableOutsidePointerEvents: l,
      onEntryFocus: c,
      onEscapeKeyDown: u,
      onPointerDownOutside: d,
      onFocusOutside: f,
      onInteractOutside: h,
      onDismiss: v,
      disableOutsideScroll: p,
      ...g
    } = t, m = po(pr, r), w = Ms(pr, r), y = s1(r), b = K8(r), _ = Mae(r), [x, E] = s.useState(null), S = s.useRef(null), M = ce(e, S, m.onContentChange), R = s.useRef(0), A = s.useRef(""), k = s.useRef(0), L = s.useRef(null), T = s.useRef("right"), O = s.useRef(0), D = p ? X8 : s.Fragment, P = p ? { as: Nr, allowPinchZoom: !0 } : void 0, F = (N) => {
      var X, me;
      const $ = A.current + N, V = _().filter((ve) => !ve.disabled), W = document.activeElement, ee = (X = V.find((ve) => ve.ref.current === W)) == null ? void 0 : X.textValue, ne = V.map((ve) => ve.textValue), we = Yae(ne, $, ee), pe = (me = V.find((ve) => ve.textValue === we)) == null ? void 0 : me.ref.current;
      (function ve(ae) {
        A.current = ae, window.clearTimeout(R.current), ae !== "" && (R.current = window.setTimeout(() => ve(""), 1e3));
      })($), pe && setTimeout(() => pe.focus());
    };
    s.useEffect(() => () => window.clearTimeout(R.current), []), qne();
    const B = s.useCallback((N) => {
      var V, W;
      return T.current === ((V = L.current) == null ? void 0 : V.side) && qae(N, (W = L.current) == null ? void 0 : W.area);
    }, []);
    return /* @__PURE__ */ C(
      Pae,
      {
        scope: r,
        searchRef: A,
        onItemEnter: s.useCallback(
          (N) => {
            B(N) && N.preventDefault();
          },
          [B]
        ),
        onItemLeave: s.useCallback(
          (N) => {
            var $;
            B(N) || (($ = S.current) == null || $.focus(), E(null));
          },
          [B]
        ),
        onTriggerLeave: s.useCallback(
          (N) => {
            B(N) && N.preventDefault();
          },
          [B]
        ),
        pointerGraceTimerRef: k,
        onPointerGraceIntentChange: s.useCallback((N) => {
          L.current = N;
        }, []),
        children: /* @__PURE__ */ C(D, { ...P, children: /* @__PURE__ */ C(
          ws,
          {
            asChild: !0,
            trapped: a,
            onMountAutoFocus: j(o, (N) => {
              var $;
              N.preventDefault(), ($ = S.current) == null || $.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: i,
            children: /* @__PURE__ */ C(
              H8,
              {
                asChild: !0,
                disableOutsidePointerEvents: l,
                onEscapeKeyDown: u,
                onPointerDownOutside: d,
                onFocusOutside: f,
                onInteractOutside: h,
                onDismiss: v,
                children: /* @__PURE__ */ C(
                  fv,
                  {
                    asChild: !0,
                    ...b,
                    dir: w.dir,
                    orientation: "vertical",
                    loop: n,
                    currentTabStopId: x,
                    onCurrentTabStopIdChange: E,
                    onEntryFocus: j(c, (N) => {
                      w.isUsingKeyboardRef.current || N.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ C(
                      qu,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": mb(m.open),
                        "data-radix-menu-content": "",
                        dir: w.dir,
                        ...y,
                        ...g,
                        ref: M,
                        style: { outline: "none", ...g.style },
                        onKeyDown: j(g.onKeyDown, (N) => {
                          const V = N.target.closest("[data-radix-menu-content]") === N.currentTarget, W = N.ctrlKey || N.altKey || N.metaKey, ee = N.key.length === 1;
                          V && (N.key === "Tab" && N.preventDefault(), !W && ee && F(N.key));
                          const ne = S.current;
                          if (N.target !== ne || !Eae.includes(N.key)) return;
                          N.preventDefault();
                          const pe = _().filter((X) => !X.disabled).map((X) => X.ref.current);
                          q8.includes(N.key) && pe.reverse(), Gae(pe);
                        }),
                        onBlur: j(t.onBlur, (N) => {
                          N.currentTarget.contains(N.target) || (window.clearTimeout(R.current), A.current = "");
                        }),
                        onPointerMove: j(
                          t.onPointerMove,
                          Yl((N) => {
                            const $ = N.target, V = O.current !== N.clientX;
                            if (N.currentTarget.contains($) && V) {
                              const W = N.clientX > O.current ? "right" : "left";
                              T.current = W, O.current = N.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
tb.displayName = pr;
var Bae = "MenuGroup", Ev = s.forwardRef(
  (t, e) => {
    const { __scopeMenu: r, ...n } = t;
    return /* @__PURE__ */ C(te.div, { role: "group", ...n, ref: e });
  }
);
Ev.displayName = Bae;
var Fae = "MenuLabel", rb = s.forwardRef(
  (t, e) => {
    const { __scopeMenu: r, ...n } = t;
    return /* @__PURE__ */ C(te.div, { ...n, ref: e });
  }
);
rb.displayName = Fae;
var F0 = "MenuItem", ag = "menu.itemSelect", c1 = s.forwardRef(
  (t, e) => {
    const { disabled: r = !1, onSelect: n, ...a } = t, o = s.useRef(null), i = Ms(F0, t.__scopeMenu), l = xv(F0, t.__scopeMenu), c = ce(e, o), u = s.useRef(!1), d = () => {
      const f = o.current;
      if (!r && f) {
        const h = new CustomEvent(ag, { bubbles: !0, cancelable: !0 });
        f.addEventListener(ag, (v) => n == null ? void 0 : n(v), { once: !0 }), $u(f, h), h.defaultPrevented ? u.current = !1 : i.onClose();
      }
    };
    return /* @__PURE__ */ C(
      nb,
      {
        ...a,
        ref: c,
        disabled: r,
        onClick: j(t.onClick, d),
        onPointerDown: (f) => {
          var h;
          (h = t.onPointerDown) == null || h.call(t, f), u.current = !0;
        },
        onPointerUp: j(t.onPointerUp, (f) => {
          var h;
          u.current || (h = f.currentTarget) == null || h.click();
        }),
        onKeyDown: j(t.onKeyDown, (f) => {
          const h = l.searchRef.current !== "";
          r || h && f.key === " " || ih.includes(f.key) && (f.currentTarget.click(), f.preventDefault());
        })
      }
    );
  }
);
c1.displayName = F0;
var nb = s.forwardRef(
  (t, e) => {
    const { __scopeMenu: r, disabled: n = !1, textValue: a, ...o } = t, i = xv(F0, r), l = K8(r), c = s.useRef(null), u = ce(e, c), [d, f] = s.useState(!1), [h, v] = s.useState("");
    return s.useEffect(() => {
      const p = c.current;
      p && v((p.textContent ?? "").trim());
    }, [o.children]), /* @__PURE__ */ C(
      Ul.ItemSlot,
      {
        scope: r,
        disabled: n,
        textValue: a ?? h,
        children: /* @__PURE__ */ C(hv, { asChild: !0, ...l, focusable: !n, children: /* @__PURE__ */ C(
          te.div,
          {
            role: "menuitem",
            "data-highlighted": d ? "" : void 0,
            "aria-disabled": n || void 0,
            "data-disabled": n ? "" : void 0,
            ...o,
            ref: u,
            onPointerMove: j(
              t.onPointerMove,
              Yl((p) => {
                n ? i.onItemLeave(p) : (i.onItemEnter(p), p.defaultPrevented || p.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: j(
              t.onPointerLeave,
              Yl((p) => i.onItemLeave(p))
            ),
            onFocus: j(t.onFocus, () => f(!0)),
            onBlur: j(t.onBlur, () => f(!1))
          }
        ) })
      }
    );
  }
), $ae = "MenuCheckboxItem", ab = s.forwardRef(
  (t, e) => {
    const { checked: r = !1, onCheckedChange: n, ...a } = t;
    return /* @__PURE__ */ C(cb, { scope: t.__scopeMenu, checked: r, children: /* @__PURE__ */ C(
      c1,
      {
        role: "menuitemcheckbox",
        "aria-checked": $0(r) ? "mixed" : r,
        ...a,
        ref: e,
        "data-state": Rv(r),
        onSelect: j(
          a.onSelect,
          () => n == null ? void 0 : n($0(r) ? !0 : !r),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
ab.displayName = $ae;
var ob = "MenuRadioGroup", [Vae, Zae] = vo(
  ob,
  { value: void 0, onValueChange: () => {
  } }
), ib = s.forwardRef(
  (t, e) => {
    const { value: r, onValueChange: n, ...a } = t, o = Ke(n);
    return /* @__PURE__ */ C(Vae, { scope: t.__scopeMenu, value: r, onValueChange: o, children: /* @__PURE__ */ C(Ev, { ...a, ref: e }) });
  }
);
ib.displayName = ob;
var lb = "MenuRadioItem", sb = s.forwardRef(
  (t, e) => {
    const { value: r, ...n } = t, a = Zae(lb, t.__scopeMenu), o = r === a.value;
    return /* @__PURE__ */ C(cb, { scope: t.__scopeMenu, checked: o, children: /* @__PURE__ */ C(
      c1,
      {
        role: "menuitemradio",
        "aria-checked": o,
        ...n,
        ref: e,
        "data-state": Rv(o),
        onSelect: j(
          n.onSelect,
          () => {
            var i;
            return (i = a.onValueChange) == null ? void 0 : i.call(a, r);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
sb.displayName = lb;
var Sv = "MenuItemIndicator", [cb, Hae] = vo(
  Sv,
  { checked: !1 }
), ub = s.forwardRef(
  (t, e) => {
    const { __scopeMenu: r, forceMount: n, ...a } = t, o = Hae(Sv, r);
    return /* @__PURE__ */ C(
      Ss,
      {
        present: n || $0(o.checked) || o.checked === !0,
        children: /* @__PURE__ */ C(
          te.span,
          {
            ...a,
            ref: e,
            "data-state": Rv(o.checked)
          }
        )
      }
    );
  }
);
ub.displayName = Sv;
var jae = "MenuSeparator", db = s.forwardRef(
  (t, e) => {
    const { __scopeMenu: r, ...n } = t;
    return /* @__PURE__ */ C(
      te.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...n,
        ref: e
      }
    );
  }
);
db.displayName = jae;
var Wae = "MenuArrow", fb = s.forwardRef(
  (t, e) => {
    const { __scopeMenu: r, ...n } = t, a = s1(r);
    return /* @__PURE__ */ C(Ku, { ...a, ...n, ref: e });
  }
);
fb.displayName = Wae;
var zae = "MenuSub", [y6e, hb] = vo(zae), xl = "MenuSubTrigger", vb = s.forwardRef(
  (t, e) => {
    const r = po(xl, t.__scopeMenu), n = Ms(xl, t.__scopeMenu), a = hb(xl, t.__scopeMenu), o = xv(xl, t.__scopeMenu), i = s.useRef(null), { pointerGraceTimerRef: l, onPointerGraceIntentChange: c } = o, u = { __scopeMenu: t.__scopeMenu }, d = s.useCallback(() => {
      i.current && window.clearTimeout(i.current), i.current = null;
    }, []);
    return s.useEffect(() => d, [d]), s.useEffect(() => {
      const f = l.current;
      return () => {
        window.clearTimeout(f), c(null);
      };
    }, [l, c]), /* @__PURE__ */ C(bv, { asChild: !0, ...u, children: /* @__PURE__ */ C(
      nb,
      {
        id: a.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": r.open,
        "aria-controls": a.contentId,
        "data-state": mb(r.open),
        ...t,
        ref: B2(e, a.onTriggerChange),
        onClick: (f) => {
          var h;
          (h = t.onClick) == null || h.call(t, f), !(t.disabled || f.defaultPrevented) && (f.currentTarget.focus(), r.open || r.onOpenChange(!0));
        },
        onPointerMove: j(
          t.onPointerMove,
          Yl((f) => {
            o.onItemEnter(f), !f.defaultPrevented && !t.disabled && !r.open && !i.current && (o.onPointerGraceIntentChange(null), i.current = window.setTimeout(() => {
              r.onOpenChange(!0), d();
            }, 100));
          })
        ),
        onPointerLeave: j(
          t.onPointerLeave,
          Yl((f) => {
            var v, p;
            d();
            const h = (v = r.content) == null ? void 0 : v.getBoundingClientRect();
            if (h) {
              const g = (p = r.content) == null ? void 0 : p.dataset.side, m = g === "right", w = m ? -5 : 5, y = h[m ? "left" : "right"], b = h[m ? "right" : "left"];
              o.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: f.clientX + w, y: f.clientY },
                  { x: y, y: h.top },
                  { x: b, y: h.top },
                  { x: b, y: h.bottom },
                  { x: y, y: h.bottom }
                ],
                side: g
              }), window.clearTimeout(l.current), l.current = window.setTimeout(
                () => o.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (o.onTriggerLeave(f), f.defaultPrevented) return;
              o.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: j(t.onKeyDown, (f) => {
          var v;
          const h = o.searchRef.current !== "";
          t.disabled || h && f.key === " " || Sae[n.dir].includes(f.key) && (r.onOpenChange(!0), (v = r.content) == null || v.focus(), f.preventDefault());
        })
      }
    ) });
  }
);
vb.displayName = xl;
var pb = "MenuSubContent", gb = s.forwardRef(
  (t, e) => {
    const r = J8(pr, t.__scopeMenu), { forceMount: n = r.forceMount, ...a } = t, o = po(pr, t.__scopeMenu), i = Ms(pr, t.__scopeMenu), l = hb(pb, t.__scopeMenu), c = s.useRef(null), u = ce(e, c);
    return /* @__PURE__ */ C(Ul.Provider, { scope: t.__scopeMenu, children: /* @__PURE__ */ C(Ss, { present: n || o.open, children: /* @__PURE__ */ C(Ul.Slot, { scope: t.__scopeMenu, children: /* @__PURE__ */ C(
      Cv,
      {
        id: l.contentId,
        "aria-labelledby": l.triggerId,
        ...a,
        ref: u,
        align: "start",
        side: i.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (d) => {
          var f;
          i.isUsingKeyboardRef.current && ((f = c.current) == null || f.focus()), d.preventDefault();
        },
        onCloseAutoFocus: (d) => d.preventDefault(),
        onFocusOutside: j(t.onFocusOutside, (d) => {
          d.target !== l.trigger && o.onOpenChange(!1);
        }),
        onEscapeKeyDown: j(t.onEscapeKeyDown, (d) => {
          i.onClose(), d.preventDefault();
        }),
        onKeyDown: j(t.onKeyDown, (d) => {
          var v;
          const f = d.currentTarget.contains(d.target), h = Rae[i.dir].includes(d.key);
          f && h && (o.onOpenChange(!1), (v = l.trigger) == null || v.focus(), d.preventDefault());
        })
      }
    ) }) }) });
  }
);
gb.displayName = pb;
function mb(t) {
  return t ? "open" : "closed";
}
function $0(t) {
  return t === "indeterminate";
}
function Rv(t) {
  return $0(t) ? "indeterminate" : t ? "checked" : "unchecked";
}
function Gae(t) {
  const e = document.activeElement;
  for (const r of t)
    if (r === e || (r.focus(), document.activeElement !== e)) return;
}
function Uae(t, e) {
  return t.map((r, n) => t[(e + n) % t.length]);
}
function Yae(t, e, r) {
  const a = e.length > 1 && Array.from(e).every((u) => u === e[0]) ? e[0] : e, o = r ? t.indexOf(r) : -1;
  let i = Uae(t, Math.max(o, 0));
  a.length === 1 && (i = i.filter((u) => u !== r));
  const c = i.find(
    (u) => u.toLowerCase().startsWith(a.toLowerCase())
  );
  return c !== r ? c : void 0;
}
function Xae(t, e) {
  const { x: r, y: n } = t;
  let a = !1;
  for (let o = 0, i = e.length - 1; o < e.length; i = o++) {
    const l = e[o].x, c = e[o].y, u = e[i].x, d = e[i].y;
    c > n != d > n && r < (u - l) * (n - c) / (d - c) + l && (a = !a);
  }
  return a;
}
function qae(t, e) {
  if (!e) return !1;
  const r = { x: t.clientX, y: t.clientY };
  return Xae(r, e);
}
function Yl(t) {
  return (e) => e.pointerType === "mouse" ? t(e) : void 0;
}
var Kae = Q8, Qae = bv, Jae = eb, eoe = tb, toe = Ev, roe = rb, noe = c1, aoe = ab, ooe = ib, ioe = sb, loe = ub, soe = db, coe = fb, uoe = vb, doe = gb, u1 = "Menubar", [lh, foe, hoe] = r1(u1), [wb, b6e] = V8(u1, [
  hoe,
  Vi
]), Ot = kae(), yb = Vi(), [voe, Mv] = wb(u1), bb = s.forwardRef(
  (t, e) => {
    const {
      __scopeMenubar: r,
      value: n,
      onValueChange: a,
      defaultValue: o,
      loop: i = !0,
      dir: l,
      ...c
    } = t, u = $i(l), d = yb(r), [f = "", h] = mr({
      prop: n,
      onChange: a,
      defaultProp: o
    }), [v, p] = s.useState(null);
    return /* @__PURE__ */ C(
      voe,
      {
        scope: r,
        value: f,
        onMenuOpen: s.useCallback(
          (g) => {
            h(g), p(g);
          },
          [h]
        ),
        onMenuClose: s.useCallback(() => h(""), [h]),
        onMenuToggle: s.useCallback(
          (g) => {
            h((m) => m ? "" : g), p(g);
          },
          [h]
        ),
        dir: u,
        loop: i,
        children: /* @__PURE__ */ C(lh.Provider, { scope: r, children: /* @__PURE__ */ C(lh.Slot, { scope: r, children: /* @__PURE__ */ C(
          fv,
          {
            asChild: !0,
            ...d,
            orientation: "horizontal",
            loop: i,
            dir: u,
            currentTabStopId: v,
            onCurrentTabStopIdChange: p,
            children: /* @__PURE__ */ C(te.div, { role: "menubar", ...c, ref: e })
          }
        ) }) })
      }
    );
  }
);
bb.displayName = u1;
var Av = "MenubarMenu", [poe, _b] = wb(Av), xb = (t) => {
  const { __scopeMenubar: e, value: r, ...n } = t, a = Kt(), o = r || a || "LEGACY_REACT_AUTO_VALUE", i = Mv(Av, e), l = Ot(e), c = s.useRef(null), u = s.useRef(!1), d = i.value === o;
  return s.useEffect(() => {
    d || (u.current = !1);
  }, [d]), /* @__PURE__ */ C(
    poe,
    {
      scope: e,
      value: o,
      triggerId: Kt(),
      triggerRef: c,
      contentId: Kt(),
      wasKeyboardTriggerOpenRef: u,
      children: /* @__PURE__ */ C(
        Kae,
        {
          ...l,
          open: d,
          onOpenChange: (f) => {
            f || i.onMenuClose();
          },
          modal: !1,
          dir: i.dir,
          ...n
        }
      )
    }
  );
};
xb.displayName = Av;
var sh = "MenubarTrigger", Cb = s.forwardRef(
  (t, e) => {
    const { __scopeMenubar: r, disabled: n = !1, ...a } = t, o = yb(r), i = Ot(r), l = Mv(sh, r), c = _b(sh, r), u = s.useRef(null), d = ce(e, u, c.triggerRef), [f, h] = s.useState(!1), v = l.value === c.value;
    return /* @__PURE__ */ C(lh.ItemSlot, { scope: r, value: c.value, disabled: n, children: /* @__PURE__ */ C(
      hv,
      {
        asChild: !0,
        ...o,
        focusable: !n,
        tabStopId: c.value,
        children: /* @__PURE__ */ C(Qae, { asChild: !0, ...i, children: /* @__PURE__ */ C(
          te.button,
          {
            type: "button",
            role: "menuitem",
            id: c.triggerId,
            "aria-haspopup": "menu",
            "aria-expanded": v,
            "aria-controls": v ? c.contentId : void 0,
            "data-highlighted": f ? "" : void 0,
            "data-state": v ? "open" : "closed",
            "data-disabled": n ? "" : void 0,
            disabled: n,
            ...a,
            ref: d,
            onPointerDown: j(t.onPointerDown, (p) => {
              !n && p.button === 0 && p.ctrlKey === !1 && (l.onMenuOpen(c.value), v || p.preventDefault());
            }),
            onPointerEnter: j(t.onPointerEnter, () => {
              var g;
              !!l.value && !v && (l.onMenuOpen(c.value), (g = u.current) == null || g.focus());
            }),
            onKeyDown: j(t.onKeyDown, (p) => {
              n || (["Enter", " "].includes(p.key) && l.onMenuToggle(c.value), p.key === "ArrowDown" && l.onMenuOpen(c.value), ["Enter", " ", "ArrowDown"].includes(p.key) && (c.wasKeyboardTriggerOpenRef.current = !0, p.preventDefault()));
            }),
            onFocus: j(t.onFocus, () => h(!0)),
            onBlur: j(t.onBlur, () => h(!1))
          }
        ) })
      }
    ) });
  }
);
Cb.displayName = sh;
var goe = "MenubarPortal", Eb = (t) => {
  const { __scopeMenubar: e, ...r } = t, n = Ot(e);
  return /* @__PURE__ */ C(Jae, { ...n, ...r });
};
Eb.displayName = goe;
var ch = "MenubarContent", Sb = s.forwardRef(
  (t, e) => {
    const { __scopeMenubar: r, align: n = "start", ...a } = t, o = Ot(r), i = Mv(ch, r), l = _b(ch, r), c = foe(r), u = s.useRef(!1);
    return /* @__PURE__ */ C(
      eoe,
      {
        id: l.contentId,
        "aria-labelledby": l.triggerId,
        "data-radix-menubar-content": "",
        ...o,
        ...a,
        ref: e,
        align: n,
        onCloseAutoFocus: j(t.onCloseAutoFocus, (d) => {
          var h;
          !!!i.value && !u.current && ((h = l.triggerRef.current) == null || h.focus()), u.current = !1, d.preventDefault();
        }),
        onFocusOutside: j(t.onFocusOutside, (d) => {
          const f = d.target;
          c().some((v) => {
            var p;
            return (p = v.ref.current) == null ? void 0 : p.contains(f);
          }) && d.preventDefault();
        }),
        onInteractOutside: j(t.onInteractOutside, () => {
          u.current = !0;
        }),
        onEntryFocus: (d) => {
          l.wasKeyboardTriggerOpenRef.current || d.preventDefault();
        },
        onKeyDown: j(
          t.onKeyDown,
          (d) => {
            if (["ArrowRight", "ArrowLeft"].includes(d.key)) {
              const f = d.target, h = f.hasAttribute("data-radix-menubar-subtrigger"), v = f.closest("[data-radix-menubar-content]") !== d.currentTarget, g = (i.dir === "rtl" ? "ArrowRight" : "ArrowLeft") === d.key;
              if (!g && h || v && g) return;
              let y = c().filter((x) => !x.disabled).map((x) => x.value);
              g && y.reverse();
              const b = y.indexOf(l.value);
              y = i.loop ? $oe(y, b + 1) : y.slice(b + 1);
              const [_] = y;
              _ && i.onMenuOpen(_);
            }
          },
          { checkForDefaultPrevented: !1 }
        ),
        style: {
          ...t.style,
          "--radix-menubar-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-menubar-content-available-width": "var(--radix-popper-available-width)",
          "--radix-menubar-content-available-height": "var(--radix-popper-available-height)",
          "--radix-menubar-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-menubar-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
Sb.displayName = ch;
var moe = "MenubarGroup", woe = s.forwardRef(
  (t, e) => {
    const { __scopeMenubar: r, ...n } = t, a = Ot(r);
    return /* @__PURE__ */ C(toe, { ...a, ...n, ref: e });
  }
);
woe.displayName = moe;
var yoe = "MenubarLabel", boe = s.forwardRef(
  (t, e) => {
    const { __scopeMenubar: r, ...n } = t, a = Ot(r);
    return /* @__PURE__ */ C(roe, { ...a, ...n, ref: e });
  }
);
boe.displayName = yoe;
var _oe = "MenubarItem", xoe = s.forwardRef(
  (t, e) => {
    const { __scopeMenubar: r, ...n } = t, a = Ot(r);
    return /* @__PURE__ */ C(noe, { ...a, ...n, ref: e });
  }
);
xoe.displayName = _oe;
var Coe = "MenubarCheckboxItem", Eoe = s.forwardRef(
  (t, e) => {
    const { __scopeMenubar: r, ...n } = t, a = Ot(r);
    return /* @__PURE__ */ C(aoe, { ...a, ...n, ref: e });
  }
);
Eoe.displayName = Coe;
var Soe = "MenubarRadioGroup", Roe = s.forwardRef(
  (t, e) => {
    const { __scopeMenubar: r, ...n } = t, a = Ot(r);
    return /* @__PURE__ */ C(ooe, { ...a, ...n, ref: e });
  }
);
Roe.displayName = Soe;
var Moe = "MenubarRadioItem", Aoe = s.forwardRef(
  (t, e) => {
    const { __scopeMenubar: r, ...n } = t, a = Ot(r);
    return /* @__PURE__ */ C(ioe, { ...a, ...n, ref: e });
  }
);
Aoe.displayName = Moe;
var koe = "MenubarItemIndicator", Loe = s.forwardRef((t, e) => {
  const { __scopeMenubar: r, ...n } = t, a = Ot(r);
  return /* @__PURE__ */ C(loe, { ...a, ...n, ref: e });
});
Loe.displayName = koe;
var Toe = "MenubarSeparator", Ooe = s.forwardRef(
  (t, e) => {
    const { __scopeMenubar: r, ...n } = t, a = Ot(r);
    return /* @__PURE__ */ C(soe, { ...a, ...n, ref: e });
  }
);
Ooe.displayName = Toe;
var Ioe = "MenubarArrow", Poe = s.forwardRef(
  (t, e) => {
    const { __scopeMenubar: r, ...n } = t, a = Ot(r);
    return /* @__PURE__ */ C(coe, { ...a, ...n, ref: e });
  }
);
Poe.displayName = Ioe;
var Doe = "MenubarSubTrigger", Noe = s.forwardRef(
  (t, e) => {
    const { __scopeMenubar: r, ...n } = t, a = Ot(r);
    return /* @__PURE__ */ C(
      uoe,
      {
        "data-radix-menubar-subtrigger": "",
        ...a,
        ...n,
        ref: e
      }
    );
  }
);
Noe.displayName = Doe;
var Boe = "MenubarSubContent", Foe = s.forwardRef(
  (t, e) => {
    const { __scopeMenubar: r, ...n } = t, a = Ot(r);
    return /* @__PURE__ */ C(
      doe,
      {
        ...a,
        "data-radix-menubar-content": "",
        ...n,
        ref: e,
        style: {
          ...t.style,
          "--radix-menubar-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-menubar-content-available-width": "var(--radix-popper-available-width)",
          "--radix-menubar-content-available-height": "var(--radix-popper-available-height)",
          "--radix-menubar-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-menubar-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
Foe.displayName = Boe;
function $oe(t, e) {
  return t.map((r, n) => t[(e + n) % t.length]);
}
var Voe = bb, Zoe = xb, Hoe = Cb, joe = Eb, Woe = Sb;
const zoe = "foton__overlay___IjWJz", Goe = "foton__menubarRoot___q6I6X", Uoe = "foton__menubarTrigger___mR9UQ", Yoe = "foton__menubarContent___7RV9E", Xoe = "foton__menubarSubContent___Jbf83", qoe = "foton__slideUpAndFade___E1aik", Koe = "foton__iconButton___OrCGo", Qoe = "foton__line___x7dEf", Joe = "foton__menuBarmainLeft___xWDLg", eie = "foton__menuBarmainRight___TfXGz", tie = "foton__textSubmenu___9--u-", rie = "foton__sessionConatainer___Gc4xg", nie = "foton__icon___J4kYn", aie = "foton__profileContainer___VKs-V", cn = {
  overlay: zoe,
  menubarRoot: Goe,
  menubarTrigger: Uoe,
  menubarContent: Yoe,
  menubarSubContent: Xoe,
  slideUpAndFade: qoe,
  iconButton: Koe,
  line: Qoe,
  menuBarmainLeft: Joe,
  menuBarmainRight: eie,
  textSubmenu: tie,
  sessionConatainer: rie,
  icon: nie,
  profileContainer: aie
}, oie = ({
  userInfo: t,
  menuItem: e,
  handleLogout: r,
  isOpen: n,
  setIsOpen: a,
  groupListSelect: o
}) => {
  const [i, l] = gt(!1);
  return /* @__PURE__ */ C(Voe, { className: cn.menubarRoot, children: /* @__PURE__ */ Z(Zoe, { children: [
    /* @__PURE__ */ C(Hoe, { className: cn.menubarTrigger, onPointerDown: () => a && a(!n), children: /* @__PURE__ */ C("div", { className: cn.iconButton, "aria-label": "Icone de Menu", children: /* @__PURE__ */ C(Me, { icon: "Bars3Icon", extraClassNames: "place-self-center w-[18px] h-[18px]" }) }) }),
    /* @__PURE__ */ C(joe, { children: /* @__PURE__ */ Z("div", { children: [
      /* @__PURE__ */ C("span", { className: cn.overlay }),
      /* @__PURE__ */ Z(
        Woe,
        {
          className: cn.menubarContent,
          align: "start",
          onBlur: () => a && a(!1),
          children: [
            /* @__PURE__ */ Z("div", { className: cn.profileContainer, onClick: () => l(!i), children: [
              /* @__PURE__ */ C(P8, { name: t.name, picture: t.picture, email: t.email }),
              /* @__PURE__ */ C(Me, { icon: "ChevronUpDownIcon", className: cn.icon })
            ] }),
            i && /* @__PURE__ */ C("div", { children: /* @__PURE__ */ C(
              k0,
              {
                leftIcon: "ArrowLeftStartOnRectangleIcon",
                kind: "secondary",
                size: "small",
                className: "w-full my-3",
                onClick: r,
                children: "Sair"
              }
            ) }),
            /* @__PURE__ */ C($8, { ...o, appendIcon: "ChevronUpDownIcon", triggerClassName: "w-full z-50 mb-2" }),
            e.map(({ sessionTitle: c, links: u }, d) => /* @__PURE__ */ Z("div", { className: cn.sessionConatainer, children: [
              c && /* @__PURE__ */ C("span", { className: cn.textSubmenu, role: "text", children: c }),
              u.map((f, h) => /* @__PURE__ */ C(
                N8,
                {
                  label: f.label,
                  iconName: f.iconName,
                  path: f.path,
                  collapsed: !1,
                  isActive: f.isActive,
                  LinkComponent: f.LinkComponent
                },
                `menu-link-item-${h}`
              ))
            ] }, `menu-item-${d}`))
          ]
        }
      )
    ] }) })
  ] }) });
}, iie = "foton__switchRoot___RYmkb", lie = "foton__switchLabel___9DxId", sie = "foton__switchLabelText___vPkXM", cie = "foton__switchSmall___kyfXn", uie = "foton__switchMedium___OjrqB", die = "foton__switchThumb___e3ehC", Mo = {
  switchRoot: iie,
  switchLabel: lie,
  switchLabelText: sie,
  switchSmall: cie,
  switchMedium: uie,
  switchThumb: die
}, _6e = ({ label: t, size: e = "small", disabled: r, checked: n, onCheckedChange: a }) => /* @__PURE__ */ C(t1, { children: /* @__PURE__ */ C("span", { className: e === "small" ? Mo.switchSmall : Mo.switchMedium, children: /* @__PURE__ */ Z("label", { className: Mo.switchLabel, children: [
  /* @__PURE__ */ C(
    Qte,
    {
      className: Mo.switchRoot,
      disabled: r,
      tabIndex: 0,
      "aria-label": t,
      checked: n,
      onCheckedChange: a,
      children: /* @__PURE__ */ C(Jte, { className: Mo.switchThumb })
    }
  ),
  /* @__PURE__ */ C("span", { className: Mo.switchLabelText, children: t })
] }) }) });
function fie({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z",
    clipRule: "evenodd"
  }));
}
const hie = /* @__PURE__ */ s.forwardRef(fie);
function vie({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ s.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ s.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ s.createElement("path", {
    fillRule: "evenodd",
    d: "M11.78 9.78a.75.75 0 0 1-1.06 0L8 7.06 5.28 9.78a.75.75 0 0 1-1.06-1.06l3.25-3.25a.75.75 0 0 1 1.06 0l3.25 3.25a.75.75 0 0 1 0 1.06Z",
    clipRule: "evenodd"
  }));
}
const pie = /* @__PURE__ */ s.forwardRef(vie), gie = "foton__table___W-zyS", mie = "foton__tableStriped___JeBVa", wie = "foton__tableRow___BLwhk", yie = "foton__tableHeader___VQHhO", bie = "foton__tableHeaderContent___fVhPt", _ie = "foton__tableOrderButton___rADCj", xie = "foton__ascOrderIcon___2FuIN", Cie = "foton__descOrderIcon___mHA0o", Eie = "foton__tableCell___d3Qen", Sie = "foton__tableNoData___PAiOo", Mr = {
  table: gie,
  tableStriped: mie,
  tableRow: wie,
  tableHeader: yie,
  tableHeaderContent: bie,
  tableOrderButton: _ie,
  ascOrderIcon: xie,
  descOrderIcon: Cie,
  tableCell: Eie,
  tableNoData: Sie
}, x6e = ({
  data: t,
  tableColumns: e,
  striped: r,
  fullWidth: n,
  noDataMessage: a = "Sem registros disponíveis",
  onRowClick: o,
  onRowDoubleClick: i,
  onSort: l,
  ...c
}) => {
  const { className: u, ...d } = c;
  return /* @__PURE__ */ Z(
    "table",
    {
      className: G(u, Mr.table, r && Mr.tableStriped, n && "w-full"),
      ...d,
      children: [
        /* @__PURE__ */ C("thead", { children: /* @__PURE__ */ C("tr", { children: e.map((f, h) => /* @__PURE__ */ C("th", { className: Mr.tableHeader, colSpan: f.colSpan, children: /* @__PURE__ */ Z("div", { className: Mr.tableHeaderContent, children: [
          f.header,
          f.sortable && /* @__PURE__ */ Z("div", { className: "flex flex-col", children: [
            /* @__PURE__ */ C("button", { onClick: () => l == null ? void 0 : l(f.accessor, "asc"), className: Mr.tableOrderButton, children: /* @__PURE__ */ C(
              pie,
              {
                className: G(Mr.ascOrderIcon, f.sorted === "asc" && "text-gray-30"),
                "aria-hidden": "true"
              }
            ) }),
            /* @__PURE__ */ C("button", { onClick: () => l == null ? void 0 : l(f.accessor, "desc"), className: Mr.tableOrderButton, children: /* @__PURE__ */ C(
              hie,
              {
                className: G(Mr.descOrderIcon, f.sorted === "desc" && "text-gray-30"),
                "aria-hidden": "true"
              }
            ) })
          ] })
        ] }) }, h)) }) }),
        /* @__PURE__ */ C("tbody", { children: (t == null ? void 0 : t.length) > 0 ? t == null ? void 0 : t.map((f, h) => /* @__PURE__ */ C(
          "tr",
          {
            className: G(Mr.tableRow, (i || o) && "cursor-pointer"),
            children: e.map(({ accessor: v, header: p, ...g }, m) => /* @__PURE__ */ C(
              "td",
              {
                onClick: () => o == null ? void 0 : o(f),
                onDoubleClick: () => i == null ? void 0 : i(f),
                className: G(Mr.tableCell),
                ...g,
                children: /* @__PURE__ */ C("div", { children: f[v] || "" })
              },
              v
            ))
          },
          h
        )) : /* @__PURE__ */ C("tr", { className: Mr.tableNoData, children: /* @__PURE__ */ C("td", { children: /* @__PURE__ */ C("span", { children: a }) }) }) })
      ]
    }
  );
};
var Rb = {};
const Mb = /* @__PURE__ */ zw(iQ);
var Qn = {}, Jn = {}, Ab = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var e = 1, r = function() {
    return "".concat(e++);
  };
  t.default = r;
})(Ab);
var d1 = {}, f1 = {}, kv = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var e = function(n) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 60, o = null;
    return function() {
      for (var i = this, l = arguments.length, c = new Array(l), u = 0; u < l; u++)
        c[u] = arguments[u];
      clearTimeout(o), o = setTimeout(function() {
        n.apply(i, c);
      }, a);
    };
  };
  t.default = e;
})(kv);
var Qr = {};
Object.defineProperty(Qr, "__esModule", {
  value: !0
});
Qr.SizeSensorId = Qr.SensorTabIndex = Qr.SensorClassName = void 0;
var Rie = "size-sensor-id";
Qr.SizeSensorId = Rie;
var Mie = "size-sensor-object";
Qr.SensorClassName = Mie;
var Aie = "-1";
Qr.SensorTabIndex = Aie;
Object.defineProperty(f1, "__esModule", {
  value: !0
});
f1.createSensor = void 0;
var kie = Lie(kv), $5 = Qr;
function Lie(t) {
  return t && t.__esModule ? t : { default: t };
}
var Tie = function(e, r) {
  var n = void 0, a = [], o = function() {
    getComputedStyle(e).position === "static" && (e.style.position = "relative");
    var f = document.createElement("object");
    return f.onload = function() {
      f.contentDocument.defaultView.addEventListener("resize", i), i();
    }, f.style.display = "block", f.style.position = "absolute", f.style.top = "0", f.style.left = "0", f.style.height = "100%", f.style.width = "100%", f.style.overflow = "hidden", f.style.pointerEvents = "none", f.style.zIndex = "-1", f.style.opacity = "0", f.setAttribute("class", $5.SensorClassName), f.setAttribute("tabindex", $5.SensorTabIndex), f.type = "text/html", e.appendChild(f), f.data = "about:blank", f;
  }, i = (0, kie.default)(function() {
    a.forEach(function(d) {
      d(e);
    });
  }), l = function(f) {
    n || (n = o()), a.indexOf(f) === -1 && a.push(f);
  }, c = function() {
    n && n.parentNode && (n.contentDocument && n.contentDocument.defaultView.removeEventListener("resize", i), n.parentNode.removeChild(n), e.removeAttribute($5.SizeSensorId), n = void 0, a = [], r && r());
  }, u = function(f) {
    var h = a.indexOf(f);
    h !== -1 && a.splice(h, 1), a.length === 0 && n && c();
  };
  return {
    element: e,
    bind: l,
    destroy: c,
    unbind: u
  };
};
f1.createSensor = Tie;
var h1 = {};
Object.defineProperty(h1, "__esModule", {
  value: !0
});
h1.createSensor = void 0;
var Oie = Qr, Iie = Pie(kv);
function Pie(t) {
  return t && t.__esModule ? t : { default: t };
}
var Die = function(e, r) {
  var n = void 0, a = [], o = (0, Iie.default)(function() {
    a.forEach(function(d) {
      d(e);
    });
  }), i = function() {
    var f = new ResizeObserver(o);
    return f.observe(e), o(), f;
  }, l = function(f) {
    n || (n = i()), a.indexOf(f) === -1 && a.push(f);
  }, c = function() {
    n.disconnect(), a = [], n = void 0, e.removeAttribute(Oie.SizeSensorId), r && r();
  }, u = function(f) {
    var h = a.indexOf(f);
    h !== -1 && a.splice(h, 1), a.length === 0 && n && c();
  };
  return {
    element: e,
    bind: l,
    destroy: c,
    unbind: u
  };
};
h1.createSensor = Die;
Object.defineProperty(d1, "__esModule", {
  value: !0
});
d1.createSensor = void 0;
var Nie = f1, Bie = h1, Fie = typeof ResizeObserver < "u" ? Bie.createSensor : Nie.createSensor;
d1.createSensor = Fie;
Object.defineProperty(Jn, "__esModule", {
  value: !0
});
Jn.removeSensor = Jn.getSensor = Jn.Sensors = void 0;
var $ie = Zie(Ab), Vie = d1, uh = Qr;
function Zie(t) {
  return t && t.__esModule ? t : { default: t };
}
var oi = {};
Jn.Sensors = oi;
function kb(t) {
  t && oi[t] && delete oi[t];
}
var Hie = function(e) {
  var r = e.getAttribute(uh.SizeSensorId);
  if (r && oi[r])
    return oi[r];
  var n = (0, $ie.default)();
  e.setAttribute(uh.SizeSensorId, n);
  var a = (0, Vie.createSensor)(e, function() {
    return kb(n);
  });
  return oi[n] = a, a;
};
Jn.getSensor = Hie;
var jie = function(e) {
  var r = e.element.getAttribute(uh.SizeSensorId);
  e.destroy(), kb(r);
};
Jn.removeSensor = jie;
Object.defineProperty(Qn, "__esModule", {
  value: !0
});
Qn.ver = Qn.clear = Qn.bind = void 0;
var dh = Jn, Wie = function(e, r) {
  var n = (0, dh.getSensor)(e);
  return n.bind(r), function() {
    n.unbind(r);
  };
};
Qn.bind = Wie;
var zie = function(e) {
  var r = (0, dh.getSensor)(e);
  (0, dh.removeSensor)(r);
};
Qn.clear = zie;
var Gie = "1.0.2";
Qn.ver = Gie;
var v1 = {};
Object.defineProperty(v1, "__esModule", { value: !0 });
v1.pick = void 0;
function Uie(t, e) {
  var r = {};
  return e.forEach(function(n) {
    r[n] = t[n];
  }), r;
}
v1.pick = Uie;
var p1 = {};
Object.defineProperty(p1, "__esModule", { value: !0 });
p1.isFunction = void 0;
function Yie(t) {
  return typeof t == "function";
}
p1.isFunction = Yie;
var g1 = {};
Object.defineProperty(g1, "__esModule", { value: !0 });
g1.isString = void 0;
function Xie(t) {
  return typeof t == "string";
}
g1.isString = Xie;
var m1 = {}, qie = function t(e, r) {
  if (e === r) return !0;
  if (e && r && typeof e == "object" && typeof r == "object") {
    if (e.constructor !== r.constructor) return !1;
    var n, a, o;
    if (Array.isArray(e)) {
      if (n = e.length, n != r.length) return !1;
      for (a = n; a-- !== 0; )
        if (!t(e[a], r[a])) return !1;
      return !0;
    }
    if (e.constructor === RegExp) return e.source === r.source && e.flags === r.flags;
    if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === r.valueOf();
    if (e.toString !== Object.prototype.toString) return e.toString() === r.toString();
    if (o = Object.keys(e), n = o.length, n !== Object.keys(r).length) return !1;
    for (a = n; a-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(r, o[a])) return !1;
    for (a = n; a-- !== 0; ) {
      var i = o[a];
      if (!t(e[i], r[i])) return !1;
    }
    return !0;
  }
  return e !== e && r !== r;
};
Object.defineProperty(m1, "__esModule", { value: !0 });
m1.isEqual = void 0;
var Kie = Mb, Qie = (0, Kie.__importDefault)(qie);
m1.isEqual = Qie.default;
Object.defineProperty(Rb, "__esModule", { value: !0 });
var fh = Mb, og = (0, fh.__importStar)(ke), ig = Qn, lg = v1, V5 = p1, Jie = g1, Ao = m1, ele = (
  /** @class */
  function(t) {
    (0, fh.__extends)(e, t);
    function e(r) {
      var n = t.call(this, r) || this;
      return n.echarts = r.echarts, n.ele = null, n.isInitialResize = !0, n;
    }
    return e.prototype.componentDidMount = function() {
      this.renderNewEcharts();
    }, e.prototype.componentDidUpdate = function(r) {
      var n = this.props.shouldSetOption;
      if (!((0, V5.isFunction)(n) && !n(r, this.props))) {
        if (!(0, Ao.isEqual)(r.theme, this.props.theme) || !(0, Ao.isEqual)(r.opts, this.props.opts) || !(0, Ao.isEqual)(r.onEvents, this.props.onEvents)) {
          this.dispose(), this.renderNewEcharts();
          return;
        }
        var a = ["option", "notMerge", "lazyUpdate", "showLoading", "loadingOption"];
        (0, Ao.isEqual)((0, lg.pick)(this.props, a), (0, lg.pick)(r, a)) || this.updateEChartsOption(), (!(0, Ao.isEqual)(r.style, this.props.style) || !(0, Ao.isEqual)(r.className, this.props.className)) && this.resize();
      }
    }, e.prototype.componentWillUnmount = function() {
      this.dispose();
    }, e.prototype.getEchartsInstance = function() {
      return this.echarts.getInstanceByDom(this.ele) || this.echarts.init(this.ele, this.props.theme, this.props.opts);
    }, e.prototype.dispose = function() {
      if (this.ele) {
        try {
          (0, ig.clear)(this.ele);
        } catch (r) {
          console.warn(r);
        }
        this.echarts.dispose(this.ele);
      }
    }, e.prototype.renderNewEcharts = function() {
      var r = this, n = this.props, a = n.onEvents, o = n.onChartReady, i = this.updateEChartsOption();
      this.bindEvents(i, a || {}), (0, V5.isFunction)(o) && o(i), this.ele && (0, ig.bind)(this.ele, function() {
        r.resize();
      });
    }, e.prototype.bindEvents = function(r, n) {
      function a(i, l) {
        (0, Jie.isString)(i) && (0, V5.isFunction)(l) && r.on(i, function(c) {
          l(c, r);
        });
      }
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && a(o, n[o]);
    }, e.prototype.updateEChartsOption = function() {
      var r = this.props, n = r.option, a = r.notMerge, o = a === void 0 ? !1 : a, i = r.lazyUpdate, l = i === void 0 ? !1 : i, c = r.showLoading, u = r.loadingOption, d = u === void 0 ? null : u, f = this.getEchartsInstance();
      return f.setOption(n, o, l), c ? f.showLoading(d) : f.hideLoading(), f;
    }, e.prototype.resize = function() {
      var r = this.getEchartsInstance();
      if (!this.isInitialResize)
        try {
          r.resize();
        } catch (n) {
          console.warn(n);
        }
      this.isInitialResize = !1;
    }, e.prototype.render = function() {
      var r = this, n = this.props, a = n.style, o = n.className, i = o === void 0 ? "" : o, l = (0, fh.__assign)({ height: 300 }, a);
      return og.default.createElement("div", { ref: function(c) {
        r.ele = c;
      }, style: l, className: "echarts-for-react " + i });
    }, e;
  }(og.PureComponent)
), w1 = Rb.default = ele;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var hh = function(t, e) {
  return hh = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (r[a] = n[a]);
  }, hh(t, e);
};
function K(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  hh(t, e);
  function r() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
}
var tle = /* @__PURE__ */ function() {
  function t() {
    this.firefox = !1, this.ie = !1, this.edge = !1, this.newEdge = !1, this.weChat = !1;
  }
  return t;
}(), rle = /* @__PURE__ */ function() {
  function t() {
    this.browser = new tle(), this.node = !1, this.wxa = !1, this.worker = !1, this.svgSupported = !1, this.touchEventsSupported = !1, this.pointerEventsSupported = !1, this.domSupported = !1, this.transformSupported = !1, this.transform3dSupported = !1, this.hasGlobalWindow = typeof window < "u";
  }
  return t;
}(), ue = new rle();
typeof wx == "object" && typeof wx.getSystemInfoSync == "function" ? (ue.wxa = !0, ue.touchEventsSupported = !0) : typeof document > "u" && typeof self < "u" ? ue.worker = !0 : typeof navigator > "u" || navigator.userAgent.indexOf("Node.js") === 0 ? (ue.node = !0, ue.svgSupported = !0) : nle(navigator.userAgent, ue);
function nle(t, e) {
  var r = e.browser, n = t.match(/Firefox\/([\d.]+)/), a = t.match(/MSIE\s([\d.]+)/) || t.match(/Trident\/.+?rv:(([\d.]+))/), o = t.match(/Edge?\/([\d.]+)/), i = /micromessenger/i.test(t);
  n && (r.firefox = !0, r.version = n[1]), a && (r.ie = !0, r.version = a[1]), o && (r.edge = !0, r.version = o[1], r.newEdge = +o[1].split(".")[0] > 18), i && (r.weChat = !0), e.svgSupported = typeof SVGRect < "u", e.touchEventsSupported = "ontouchstart" in window && !r.ie && !r.edge, e.pointerEventsSupported = "onpointerdown" in window && (r.edge || r.ie && +r.version >= 11), e.domSupported = typeof document < "u";
  var l = document.documentElement.style;
  e.transform3dSupported = (r.ie && "transition" in l || r.edge || "WebKitCSSMatrix" in window && "m11" in new WebKitCSSMatrix() || "MozPerspective" in l) && !("OTransition" in l), e.transformSupported = e.transform3dSupported || r.ie && +r.version >= 9;
}
var Lv = 12, ale = "sans-serif", ro = Lv + "px " + ale, ole = 20, ile = 100, lle = "007LLmW'55;N0500LLLLLLLLLL00NNNLzWW\\\\WQb\\0FWLg\\bWb\\WQ\\WrWWQ000CL5LLFLL0LL**F*gLLLL5F0LF\\FFF5.5N";
function sle(t) {
  var e = {};
  if (typeof JSON > "u")
    return e;
  for (var r = 0; r < t.length; r++) {
    var n = String.fromCharCode(r + 32), a = (t.charCodeAt(r) - ole) / ile;
    e[n] = a;
  }
  return e;
}
var cle = sle(lle), xn = {
  createCanvas: function() {
    return typeof document < "u" && document.createElement("canvas");
  },
  measureText: /* @__PURE__ */ function() {
    var t, e;
    return function(r, n) {
      if (!t) {
        var a = xn.createCanvas();
        t = a && a.getContext("2d");
      }
      if (t)
        return e !== n && (e = t.font = n || ro), t.measureText(r);
      r = r || "", n = n || ro;
      var o = /((?:\d+)?\.?\d*)px/.exec(n), i = o && +o[1] || Lv, l = 0;
      if (n.indexOf("mono") >= 0)
        l = i * r.length;
      else
        for (var c = 0; c < r.length; c++) {
          var u = cle[r[c]];
          l += u == null ? i : u * i;
        }
      return { width: l };
    };
  }(),
  loadImage: function(t, e, r) {
    var n = new Image();
    return n.onload = e, n.onerror = r, n.src = t, n;
  }
};
function Lb(t) {
  for (var e in xn)
    t[e] && (xn[e] = t[e]);
}
var Tb = tn([
  "Function",
  "RegExp",
  "Date",
  "Error",
  "CanvasGradient",
  "CanvasPattern",
  "Image",
  "Canvas"
], function(t, e) {
  return t["[object " + e + "]"] = !0, t;
}, {}), Ob = tn([
  "Int8",
  "Uint8",
  "Uint8Clamped",
  "Int16",
  "Uint16",
  "Int32",
  "Uint32",
  "Float32",
  "Float64"
], function(t, e) {
  return t["[object " + e + "Array]"] = !0, t;
}, {}), ji = Object.prototype.toString, y1 = Array.prototype, ule = y1.forEach, dle = y1.filter, Tv = y1.slice, fle = y1.map, sg = (function() {
}).constructor, ic = sg ? sg.prototype : null, Ov = "__proto__", hle = 2311;
function Iv() {
  return hle++;
}
function mn() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  typeof console < "u" && console.error.apply(console, t);
}
function be(t) {
  if (t == null || typeof t != "object")
    return t;
  var e = t, r = ji.call(t);
  if (r === "[object Array]") {
    if (!ii(t)) {
      e = [];
      for (var n = 0, a = t.length; n < a; n++)
        e[n] = be(t[n]);
    }
  } else if (Ob[r]) {
    if (!ii(t)) {
      var o = t.constructor;
      if (o.from)
        e = o.from(t);
      else {
        e = new o(t.length);
        for (var n = 0, a = t.length; n < a; n++)
          e[n] = t[n];
      }
    }
  } else if (!Tb[r] && !ii(t) && !no(t)) {
    e = {};
    for (var i in t)
      t.hasOwnProperty(i) && i !== Ov && (e[i] = be(t[i]));
  }
  return e;
}
function Ce(t, e, r) {
  if (!re(e) || !re(t))
    return r ? be(e) : t;
  for (var n in e)
    if (e.hasOwnProperty(n) && n !== Ov) {
      var a = t[n], o = e[n];
      re(o) && re(a) && !z(o) && !z(a) && !no(o) && !no(a) && !vh(o) && !vh(a) && !ii(o) && !ii(a) ? Ce(a, o, r) : (r || !(n in t)) && (t[n] = be(e[n]));
    }
  return t;
}
function vle(t, e) {
  for (var r = t[0], n = 1, a = t.length; n < a; n++)
    r = Ce(r, t[n], e);
  return r;
}
function H(t, e) {
  if (Object.assign)
    Object.assign(t, e);
  else
    for (var r in e)
      e.hasOwnProperty(r) && r !== Ov && (t[r] = e[r]);
  return t;
}
function Te(t, e, r) {
  for (var n = Ze(e), a = 0; a < n.length; a++) {
    var o = n[a];
    (r ? e[o] != null : t[o] == null) && (t[o] = e[o]);
  }
  return t;
}
var ple = xn.createCanvas;
function Re(t, e) {
  if (t) {
    if (t.indexOf)
      return t.indexOf(e);
    for (var r = 0, n = t.length; r < n; r++)
      if (t[r] === e)
        return r;
  }
  return -1;
}
function Pv(t, e) {
  var r = t.prototype;
  function n() {
  }
  n.prototype = e.prototype, t.prototype = new n();
  for (var a in r)
    r.hasOwnProperty(a) && (t.prototype[a] = r[a]);
  t.prototype.constructor = t, t.superClass = e;
}
function tr(t, e, r) {
  if (t = "prototype" in t ? t.prototype : t, e = "prototype" in e ? e.prototype : e, Object.getOwnPropertyNames)
    for (var n = Object.getOwnPropertyNames(e), a = 0; a < n.length; a++) {
      var o = n[a];
      o !== "constructor" && (r ? e[o] != null : t[o] == null) && (t[o] = e[o]);
    }
  else
    Te(t, e, r);
}
function Lt(t) {
  return !t || typeof t == "string" ? !1 : typeof t.length == "number";
}
function I(t, e, r) {
  if (t && e)
    if (t.forEach && t.forEach === ule)
      t.forEach(e, r);
    else if (t.length === +t.length)
      for (var n = 0, a = t.length; n < a; n++)
        e.call(r, t[n], n, t);
    else
      for (var o in t)
        t.hasOwnProperty(o) && e.call(r, t[o], o, t);
}
function J(t, e, r) {
  if (!t)
    return [];
  if (!e)
    return b1(t);
  if (t.map && t.map === fle)
    return t.map(e, r);
  for (var n = [], a = 0, o = t.length; a < o; a++)
    n.push(e.call(r, t[a], a, t));
  return n;
}
function tn(t, e, r, n) {
  if (t && e) {
    for (var a = 0, o = t.length; a < o; a++)
      r = e.call(n, r, t[a], a, t);
    return r;
  }
}
function ot(t, e, r) {
  if (!t)
    return [];
  if (!e)
    return b1(t);
  if (t.filter && t.filter === dle)
    return t.filter(e, r);
  for (var n = [], a = 0, o = t.length; a < o; a++)
    e.call(r, t[a], a, t) && n.push(t[a]);
  return n;
}
function gle(t, e, r) {
  if (t && e) {
    for (var n = 0, a = t.length; n < a; n++)
      if (e.call(r, t[n], n, t))
        return t[n];
  }
}
function Ze(t) {
  if (!t)
    return [];
  if (Object.keys)
    return Object.keys(t);
  var e = [];
  for (var r in t)
    t.hasOwnProperty(r) && e.push(r);
  return e;
}
function mle(t, e) {
  for (var r = [], n = 2; n < arguments.length; n++)
    r[n - 2] = arguments[n];
  return function() {
    return t.apply(e, r.concat(Tv.call(arguments)));
  };
}
var le = ic && ie(ic.bind) ? ic.call.bind(ic.bind) : mle;
function Oe(t) {
  for (var e = [], r = 1; r < arguments.length; r++)
    e[r - 1] = arguments[r];
  return function() {
    return t.apply(this, e.concat(Tv.call(arguments)));
  };
}
function z(t) {
  return Array.isArray ? Array.isArray(t) : ji.call(t) === "[object Array]";
}
function ie(t) {
  return typeof t == "function";
}
function Q(t) {
  return typeof t == "string";
}
function Xl(t) {
  return ji.call(t) === "[object String]";
}
function De(t) {
  return typeof t == "number";
}
function re(t) {
  var e = typeof t;
  return e === "function" || !!t && e === "object";
}
function vh(t) {
  return !!Tb[ji.call(t)];
}
function yt(t) {
  return !!Ob[ji.call(t)];
}
function no(t) {
  return typeof t == "object" && typeof t.nodeType == "number" && typeof t.ownerDocument == "object";
}
function As(t) {
  return t.colorStops != null;
}
function Ib(t) {
  return t.image != null;
}
function Pb(t) {
  return ji.call(t) === "[object RegExp]";
}
function _i(t) {
  return t !== t;
}
function Cn() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  for (var r = 0, n = t.length; r < n; r++)
    if (t[r] != null)
      return t[r];
}
function de(t, e) {
  return t ?? e;
}
function ea(t, e, r) {
  return t ?? e ?? r;
}
function b1(t) {
  for (var e = [], r = 1; r < arguments.length; r++)
    e[r - 1] = arguments[r];
  return Tv.apply(t, e);
}
function Dv(t) {
  if (typeof t == "number")
    return [t, t, t, t];
  var e = t.length;
  return e === 2 ? [t[0], t[1], t[0], t[1]] : e === 3 ? [t[0], t[1], t[2], t[1]] : t;
}
function ge(t, e) {
  if (!t)
    throw new Error(e);
}
function Ir(t) {
  return t == null ? null : typeof t.trim == "function" ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
}
var Db = "__ec_primitive__";
function V0(t) {
  t[Db] = !0;
}
function ii(t) {
  return t[Db];
}
var wle = function() {
  function t() {
    this.data = {};
  }
  return t.prototype.delete = function(e) {
    var r = this.has(e);
    return r && delete this.data[e], r;
  }, t.prototype.has = function(e) {
    return this.data.hasOwnProperty(e);
  }, t.prototype.get = function(e) {
    return this.data[e];
  }, t.prototype.set = function(e, r) {
    return this.data[e] = r, this;
  }, t.prototype.keys = function() {
    return Ze(this.data);
  }, t.prototype.forEach = function(e) {
    var r = this.data;
    for (var n in r)
      r.hasOwnProperty(n) && e(r[n], n);
  }, t;
}(), Nb = typeof Map == "function";
function yle() {
  return Nb ? /* @__PURE__ */ new Map() : new wle();
}
var Bb = function() {
  function t(e) {
    var r = z(e);
    this.data = yle();
    var n = this;
    e instanceof t ? e.each(a) : e && I(e, a);
    function a(o, i) {
      r ? n.set(o, i) : n.set(i, o);
    }
  }
  return t.prototype.hasKey = function(e) {
    return this.data.has(e);
  }, t.prototype.get = function(e) {
    return this.data.get(e);
  }, t.prototype.set = function(e, r) {
    return this.data.set(e, r), r;
  }, t.prototype.each = function(e, r) {
    this.data.forEach(function(n, a) {
      e.call(r, n, a);
    });
  }, t.prototype.keys = function() {
    var e = this.data.keys();
    return Nb ? Array.from(e) : e;
  }, t.prototype.removeKey = function(e) {
    this.data.delete(e);
  }, t;
}();
function se(t) {
  return new Bb(t);
}
function Fb(t, e) {
  for (var r = new t.constructor(t.length + e.length), n = 0; n < t.length; n++)
    r[n] = t[n];
  for (var a = t.length, n = 0; n < e.length; n++)
    r[n + a] = e[n];
  return r;
}
function ks(t, e) {
  var r;
  if (Object.create)
    r = Object.create(t);
  else {
    var n = function() {
    };
    n.prototype = t, r = new n();
  }
  return e && H(r, e), r;
}
function Nv(t) {
  var e = t.style;
  e.webkitUserSelect = "none", e.userSelect = "none", e.webkitTapHighlightColor = "rgba(0,0,0,0)", e["-webkit-touch-callout"] = "none";
}
function ao(t, e) {
  return t.hasOwnProperty(e);
}
function mt() {
}
var $b = 180 / Math.PI;
const ble = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  HashMap: Bb,
  RADIAN_TO_DEGREE: $b,
  assert: ge,
  bind: le,
  clone: be,
  concatArray: Fb,
  createCanvas: ple,
  createHashMap: se,
  createObject: ks,
  curry: Oe,
  defaults: Te,
  disableUserSelect: Nv,
  each: I,
  eqNaN: _i,
  extend: H,
  filter: ot,
  find: gle,
  guid: Iv,
  hasOwn: ao,
  indexOf: Re,
  inherits: Pv,
  isArray: z,
  isArrayLike: Lt,
  isBuiltInObject: vh,
  isDom: no,
  isFunction: ie,
  isGradientObject: As,
  isImagePatternObject: Ib,
  isNumber: De,
  isObject: re,
  isPrimitive: ii,
  isRegExp: Pb,
  isString: Q,
  isStringSafe: Xl,
  isTypedArray: yt,
  keys: Ze,
  logError: mn,
  map: J,
  merge: Ce,
  mergeAll: vle,
  mixin: tr,
  noop: mt,
  normalizeCssArray: Dv,
  reduce: tn,
  retrieve: Cn,
  retrieve2: de,
  retrieve3: ea,
  setAsPrimitive: V0,
  slice: b1,
  trim: Ir
}, Symbol.toStringTag, { value: "Module" }));
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var ph = function(t, e) {
  return ph = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (r[a] = n[a]);
  }, ph(t, e);
};
function Be(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  ph(t, e);
  function r() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
}
function go(t, e) {
  return t == null && (t = 0), e == null && (e = 0), [t, e];
}
function _le(t, e) {
  return t[0] = e[0], t[1] = e[1], t;
}
function Vb(t) {
  return [t[0], t[1]];
}
function xle(t, e, r) {
  return t[0] = e, t[1] = r, t;
}
function gh(t, e, r) {
  return t[0] = e[0] + r[0], t[1] = e[1] + r[1], t;
}
function Cle(t, e, r, n) {
  return t[0] = e[0] + r[0] * n, t[1] = e[1] + r[1] * n, t;
}
function Bv(t, e, r) {
  return t[0] = e[0] - r[0], t[1] = e[1] - r[1], t;
}
function Fv(t) {
  return Math.sqrt($v(t));
}
var Ele = Fv;
function $v(t) {
  return t[0] * t[0] + t[1] * t[1];
}
var Sle = $v;
function Rle(t, e, r) {
  return t[0] = e[0] * r[0], t[1] = e[1] * r[1], t;
}
function Mle(t, e, r) {
  return t[0] = e[0] / r[0], t[1] = e[1] / r[1], t;
}
function Ale(t, e) {
  return t[0] * e[0] + t[1] * e[1];
}
function d0(t, e, r) {
  return t[0] = e[0] * r, t[1] = e[1] * r, t;
}
function _1(t, e) {
  var r = Fv(e);
  return r === 0 ? (t[0] = 0, t[1] = 0) : (t[0] = e[0] / r, t[1] = e[1] / r), t;
}
function Z0(t, e) {
  return Math.sqrt((t[0] - e[0]) * (t[0] - e[0]) + (t[1] - e[1]) * (t[1] - e[1]));
}
var H0 = Z0;
function Zb(t, e) {
  return (t[0] - e[0]) * (t[0] - e[0]) + (t[1] - e[1]) * (t[1] - e[1]);
}
var Ya = Zb;
function kle(t, e) {
  return t[0] = -e[0], t[1] = -e[1], t;
}
function f0(t, e, r, n) {
  return t[0] = e[0] + n * (r[0] - e[0]), t[1] = e[1] + n * (r[1] - e[1]), t;
}
function At(t, e, r) {
  var n = e[0], a = e[1];
  return t[0] = r[0] * n + r[2] * a + r[4], t[1] = r[1] * n + r[3] * a + r[5], t;
}
function jn(t, e, r) {
  return t[0] = Math.min(e[0], r[0]), t[1] = Math.min(e[1], r[1]), t;
}
function Wn(t, e, r) {
  return t[0] = Math.max(e[0], r[0]), t[1] = Math.max(e[1], r[1]), t;
}
const Lle = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  add: gh,
  applyTransform: At,
  clone: Vb,
  copy: _le,
  create: go,
  dist: H0,
  distSquare: Ya,
  distance: Z0,
  distanceSquare: Zb,
  div: Mle,
  dot: Ale,
  len: Fv,
  lenSquare: $v,
  length: Ele,
  lengthSquare: Sle,
  lerp: f0,
  max: Wn,
  min: jn,
  mul: Rle,
  negate: kle,
  normalize: _1,
  scale: d0,
  scaleAndAdd: Cle,
  set: xle,
  sub: Bv
}, Symbol.toStringTag, { value: "Module" }));
var ko = /* @__PURE__ */ function() {
  function t(e, r) {
    this.target = e, this.topTarget = r && r.topTarget;
  }
  return t;
}(), Tle = function() {
  function t(e) {
    this.handler = e, e.on("mousedown", this._dragStart, this), e.on("mousemove", this._drag, this), e.on("mouseup", this._dragEnd, this);
  }
  return t.prototype._dragStart = function(e) {
    for (var r = e.target; r && !r.draggable; )
      r = r.parent || r.__hostTarget;
    r && (this._draggingTarget = r, r.dragging = !0, this._x = e.offsetX, this._y = e.offsetY, this.handler.dispatchToElement(new ko(r, e), "dragstart", e.event));
  }, t.prototype._drag = function(e) {
    var r = this._draggingTarget;
    if (r) {
      var n = e.offsetX, a = e.offsetY, o = n - this._x, i = a - this._y;
      this._x = n, this._y = a, r.drift(o, i, e), this.handler.dispatchToElement(new ko(r, e), "drag", e.event);
      var l = this.handler.findHover(n, a, r).target, c = this._dropTarget;
      this._dropTarget = l, r !== l && (c && l !== c && this.handler.dispatchToElement(new ko(c, e), "dragleave", e.event), l && l !== c && this.handler.dispatchToElement(new ko(l, e), "dragenter", e.event));
    }
  }, t.prototype._dragEnd = function(e) {
    var r = this._draggingTarget;
    r && (r.dragging = !1), this.handler.dispatchToElement(new ko(r, e), "dragend", e.event), this._dropTarget && this.handler.dispatchToElement(new ko(this._dropTarget, e), "drop", e.event), this._draggingTarget = null, this._dropTarget = null;
  }, t;
}(), Vr = function() {
  function t(e) {
    e && (this._$eventProcessor = e);
  }
  return t.prototype.on = function(e, r, n, a) {
    this._$handlers || (this._$handlers = {});
    var o = this._$handlers;
    if (typeof r == "function" && (a = n, n = r, r = null), !n || !e)
      return this;
    var i = this._$eventProcessor;
    r != null && i && i.normalizeQuery && (r = i.normalizeQuery(r)), o[e] || (o[e] = []);
    for (var l = 0; l < o[e].length; l++)
      if (o[e][l].h === n)
        return this;
    var c = {
      h: n,
      query: r,
      ctx: a || this,
      callAtLast: n.zrEventfulCallAtLast
    }, u = o[e].length - 1, d = o[e][u];
    return d && d.callAtLast ? o[e].splice(u, 0, c) : o[e].push(c), this;
  }, t.prototype.isSilent = function(e) {
    var r = this._$handlers;
    return !r || !r[e] || !r[e].length;
  }, t.prototype.off = function(e, r) {
    var n = this._$handlers;
    if (!n)
      return this;
    if (!e)
      return this._$handlers = {}, this;
    if (r) {
      if (n[e]) {
        for (var a = [], o = 0, i = n[e].length; o < i; o++)
          n[e][o].h !== r && a.push(n[e][o]);
        n[e] = a;
      }
      n[e] && n[e].length === 0 && delete n[e];
    } else
      delete n[e];
    return this;
  }, t.prototype.trigger = function(e) {
    for (var r = [], n = 1; n < arguments.length; n++)
      r[n - 1] = arguments[n];
    if (!this._$handlers)
      return this;
    var a = this._$handlers[e], o = this._$eventProcessor;
    if (a)
      for (var i = r.length, l = a.length, c = 0; c < l; c++) {
        var u = a[c];
        if (!(o && o.filter && u.query != null && !o.filter(e, u.query)))
          switch (i) {
            case 0:
              u.h.call(u.ctx);
              break;
            case 1:
              u.h.call(u.ctx, r[0]);
              break;
            case 2:
              u.h.call(u.ctx, r[0], r[1]);
              break;
            default:
              u.h.apply(u.ctx, r);
              break;
          }
      }
    return o && o.afterTrigger && o.afterTrigger(e), this;
  }, t.prototype.triggerWithContext = function(e) {
    for (var r = [], n = 1; n < arguments.length; n++)
      r[n - 1] = arguments[n];
    if (!this._$handlers)
      return this;
    var a = this._$handlers[e], o = this._$eventProcessor;
    if (a)
      for (var i = r.length, l = r[i - 1], c = a.length, u = 0; u < c; u++) {
        var d = a[u];
        if (!(o && o.filter && d.query != null && !o.filter(e, d.query)))
          switch (i) {
            case 0:
              d.h.call(l);
              break;
            case 1:
              d.h.call(l, r[0]);
              break;
            case 2:
              d.h.call(l, r[0], r[1]);
              break;
            default:
              d.h.apply(l, r.slice(1, i - 1));
              break;
          }
      }
    return o && o.afterTrigger && o.afterTrigger(e), this;
  }, t;
}(), Ole = Math.log(2);
function mh(t, e, r, n, a, o) {
  var i = n + "-" + a, l = t.length;
  if (o.hasOwnProperty(i))
    return o[i];
  if (e === 1) {
    var c = Math.round(Math.log((1 << l) - 1 & ~a) / Ole);
    return t[r][c];
  }
  for (var u = n | 1 << r, d = r + 1; n & 1 << d; )
    d++;
  for (var f = 0, h = 0, v = 0; h < l; h++) {
    var p = 1 << h;
    p & a || (f += (v % 2 ? -1 : 1) * t[r][h] * mh(t, e - 1, d, u, a | p, o), v++);
  }
  return o[i] = f, f;
}
function cg(t, e) {
  var r = [
    [t[0], t[1], 1, 0, 0, 0, -e[0] * t[0], -e[0] * t[1]],
    [0, 0, 0, t[0], t[1], 1, -e[1] * t[0], -e[1] * t[1]],
    [t[2], t[3], 1, 0, 0, 0, -e[2] * t[2], -e[2] * t[3]],
    [0, 0, 0, t[2], t[3], 1, -e[3] * t[2], -e[3] * t[3]],
    [t[4], t[5], 1, 0, 0, 0, -e[4] * t[4], -e[4] * t[5]],
    [0, 0, 0, t[4], t[5], 1, -e[5] * t[4], -e[5] * t[5]],
    [t[6], t[7], 1, 0, 0, 0, -e[6] * t[6], -e[6] * t[7]],
    [0, 0, 0, t[6], t[7], 1, -e[7] * t[6], -e[7] * t[7]]
  ], n = {}, a = mh(r, 8, 0, 0, 0, n);
  if (a !== 0) {
    for (var o = [], i = 0; i < 8; i++)
      for (var l = 0; l < 8; l++)
        o[l] == null && (o[l] = 0), o[l] += ((i + l) % 2 ? -1 : 1) * mh(r, 7, i === 0 ? 1 : 0, 1 << i, 1 << l, n) / a * e[i];
    return function(c, u, d) {
      var f = u * o[6] + d * o[7] + 1;
      c[0] = (u * o[0] + d * o[1] + o[2]) / f, c[1] = (u * o[3] + d * o[4] + o[5]) / f;
    };
  }
}
var ug = "___zrEVENTSAVED", Z5 = [];
function Ile(t, e, r, n, a) {
  return wh(Z5, e, n, a, !0) && wh(t, r, Z5[0], Z5[1]);
}
function wh(t, e, r, n, a) {
  if (e.getBoundingClientRect && ue.domSupported && !Hb(e)) {
    var o = e[ug] || (e[ug] = {}), i = Ple(e, o), l = Dle(i, o, a);
    if (l)
      return l(t, r, n), !0;
  }
  return !1;
}
function Ple(t, e) {
  var r = e.markers;
  if (r)
    return r;
  r = e.markers = [];
  for (var n = ["left", "right"], a = ["top", "bottom"], o = 0; o < 4; o++) {
    var i = document.createElement("div"), l = i.style, c = o % 2, u = (o >> 1) % 2;
    l.cssText = [
      "position: absolute",
      "visibility: hidden",
      "padding: 0",
      "margin: 0",
      "border-width: 0",
      "user-select: none",
      "width:0",
      "height:0",
      n[c] + ":0",
      a[u] + ":0",
      n[1 - c] + ":auto",
      a[1 - u] + ":auto",
      ""
    ].join("!important;"), t.appendChild(i), r.push(i);
  }
  return r;
}
function Dle(t, e, r) {
  for (var n = r ? "invTrans" : "trans", a = e[n], o = e.srcCoords, i = [], l = [], c = !0, u = 0; u < 4; u++) {
    var d = t[u].getBoundingClientRect(), f = 2 * u, h = d.left, v = d.top;
    i.push(h, v), c = c && o && h === o[f] && v === o[f + 1], l.push(t[u].offsetLeft, t[u].offsetTop);
  }
  return c && a ? a : (e.srcCoords = i, e[n] = r ? cg(l, i) : cg(i, l));
}
function Hb(t) {
  return t.nodeName.toUpperCase() === "CANVAS";
}
var Nle = /([&<>"'])/g, Ble = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
};
function Ft(t) {
  return t == null ? "" : (t + "").replace(Nle, function(e, r) {
    return Ble[r];
  });
}
var Fle = /^(?:mouse|pointer|contextmenu|drag|drop)|click/, H5 = [], $le = ue.browser.firefox && +ue.browser.version.split(".")[0] < 39;
function yh(t, e, r, n) {
  return r = r || {}, n ? dg(t, e, r) : $le && e.layerX != null && e.layerX !== e.offsetX ? (r.zrX = e.layerX, r.zrY = e.layerY) : e.offsetX != null ? (r.zrX = e.offsetX, r.zrY = e.offsetY) : dg(t, e, r), r;
}
function dg(t, e, r) {
  if (ue.domSupported && t.getBoundingClientRect) {
    var n = e.clientX, a = e.clientY;
    if (Hb(t)) {
      var o = t.getBoundingClientRect();
      r.zrX = n - o.left, r.zrY = a - o.top;
      return;
    } else if (wh(H5, t, n, a)) {
      r.zrX = H5[0], r.zrY = H5[1];
      return;
    }
  }
  r.zrX = r.zrY = 0;
}
function Vv(t) {
  return t || window.event;
}
function sr(t, e, r) {
  if (e = Vv(e), e.zrX != null)
    return e;
  var n = e.type, a = n && n.indexOf("touch") >= 0;
  if (a) {
    var i = n !== "touchend" ? e.targetTouches[0] : e.changedTouches[0];
    i && yh(t, i, e, r);
  } else {
    yh(t, e, e, r);
    var o = Vle(e);
    e.zrDelta = o ? o / 120 : -(e.detail || 0) / 3;
  }
  var l = e.button;
  return e.which == null && l !== void 0 && Fle.test(e.type) && (e.which = l & 1 ? 1 : l & 2 ? 3 : l & 4 ? 2 : 0), e;
}
function Vle(t) {
  var e = t.wheelDelta;
  if (e)
    return e;
  var r = t.deltaX, n = t.deltaY;
  if (r == null || n == null)
    return e;
  var a = Math.abs(n !== 0 ? n : r), o = n > 0 ? -1 : n < 0 ? 1 : r > 0 ? -1 : 1;
  return 3 * a * o;
}
function Zle(t, e, r, n) {
  t.addEventListener(e, r, n);
}
function Hle(t, e, r, n) {
  t.removeEventListener(e, r, n);
}
var xi = function(t) {
  t.preventDefault(), t.stopPropagation(), t.cancelBubble = !0;
};
function fg(t) {
  return t.which === 2 || t.which === 3;
}
var jle = function() {
  function t() {
    this._track = [];
  }
  return t.prototype.recognize = function(e, r, n) {
    return this._doTrack(e, r, n), this._recognize(e);
  }, t.prototype.clear = function() {
    return this._track.length = 0, this;
  }, t.prototype._doTrack = function(e, r, n) {
    var a = e.touches;
    if (a) {
      for (var o = {
        points: [],
        touches: [],
        target: r,
        event: e
      }, i = 0, l = a.length; i < l; i++) {
        var c = a[i], u = yh(n, c, {});
        o.points.push([u.zrX, u.zrY]), o.touches.push(c);
      }
      this._track.push(o);
    }
  }, t.prototype._recognize = function(e) {
    for (var r in j5)
      if (j5.hasOwnProperty(r)) {
        var n = j5[r](this._track, e);
        if (n)
          return n;
      }
  }, t;
}();
function hg(t) {
  var e = t[1][0] - t[0][0], r = t[1][1] - t[0][1];
  return Math.sqrt(e * e + r * r);
}
function Wle(t) {
  return [
    (t[0][0] + t[1][0]) / 2,
    (t[0][1] + t[1][1]) / 2
  ];
}
var j5 = {
  pinch: function(t, e) {
    var r = t.length;
    if (r) {
      var n = (t[r - 1] || {}).points, a = (t[r - 2] || {}).points || n;
      if (a && a.length > 1 && n && n.length > 1) {
        var o = hg(n) / hg(a);
        !isFinite(o) && (o = 1), e.pinchScale = o;
        var i = Wle(n);
        return e.pinchX = i[0], e.pinchY = i[1], {
          type: "pinch",
          target: t[0].target,
          event: e
        };
      }
    }
  }
};
function ta() {
  return [1, 0, 0, 1, 0, 0];
}
function Ls(t) {
  return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 1, t[4] = 0, t[5] = 0, t;
}
function Zv(t, e) {
  return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4], t[5] = e[5], t;
}
function ra(t, e, r) {
  var n = e[0] * r[0] + e[2] * r[1], a = e[1] * r[0] + e[3] * r[1], o = e[0] * r[2] + e[2] * r[3], i = e[1] * r[2] + e[3] * r[3], l = e[0] * r[4] + e[2] * r[5] + e[4], c = e[1] * r[4] + e[3] * r[5] + e[5];
  return t[0] = n, t[1] = a, t[2] = o, t[3] = i, t[4] = l, t[5] = c, t;
}
function j0(t, e, r) {
  return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4] + r[0], t[5] = e[5] + r[1], t;
}
function x1(t, e, r, n) {
  n === void 0 && (n = [0, 0]);
  var a = e[0], o = e[2], i = e[4], l = e[1], c = e[3], u = e[5], d = Math.sin(r), f = Math.cos(r);
  return t[0] = a * f + l * d, t[1] = -a * d + l * f, t[2] = o * f + c * d, t[3] = -o * d + f * c, t[4] = f * (i - n[0]) + d * (u - n[1]) + n[0], t[5] = f * (u - n[1]) - d * (i - n[0]) + n[1], t;
}
function jb(t, e, r) {
  var n = r[0], a = r[1];
  return t[0] = e[0] * n, t[1] = e[1] * a, t[2] = e[2] * n, t[3] = e[3] * a, t[4] = e[4] * n, t[5] = e[5] * a, t;
}
function Ts(t, e) {
  var r = e[0], n = e[2], a = e[4], o = e[1], i = e[3], l = e[5], c = r * i - o * n;
  return c ? (c = 1 / c, t[0] = i * c, t[1] = -o * c, t[2] = -n * c, t[3] = r * c, t[4] = (n * l - i * a) * c, t[5] = (o * a - r * l) * c, t) : null;
}
function zle(t) {
  var e = ta();
  return Zv(e, t), e;
}
const Gle = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clone: zle,
  copy: Zv,
  create: ta,
  identity: Ls,
  invert: Ts,
  mul: ra,
  rotate: x1,
  scale: jb,
  translate: j0
}, Symbol.toStringTag, { value: "Module" }));
var he = function() {
  function t(e, r) {
    this.x = e || 0, this.y = r || 0;
  }
  return t.prototype.copy = function(e) {
    return this.x = e.x, this.y = e.y, this;
  }, t.prototype.clone = function() {
    return new t(this.x, this.y);
  }, t.prototype.set = function(e, r) {
    return this.x = e, this.y = r, this;
  }, t.prototype.equal = function(e) {
    return e.x === this.x && e.y === this.y;
  }, t.prototype.add = function(e) {
    return this.x += e.x, this.y += e.y, this;
  }, t.prototype.scale = function(e) {
    this.x *= e, this.y *= e;
  }, t.prototype.scaleAndAdd = function(e, r) {
    this.x += e.x * r, this.y += e.y * r;
  }, t.prototype.sub = function(e) {
    return this.x -= e.x, this.y -= e.y, this;
  }, t.prototype.dot = function(e) {
    return this.x * e.x + this.y * e.y;
  }, t.prototype.len = function() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }, t.prototype.lenSquare = function() {
    return this.x * this.x + this.y * this.y;
  }, t.prototype.normalize = function() {
    var e = this.len();
    return this.x /= e, this.y /= e, this;
  }, t.prototype.distance = function(e) {
    var r = this.x - e.x, n = this.y - e.y;
    return Math.sqrt(r * r + n * n);
  }, t.prototype.distanceSquare = function(e) {
    var r = this.x - e.x, n = this.y - e.y;
    return r * r + n * n;
  }, t.prototype.negate = function() {
    return this.x = -this.x, this.y = -this.y, this;
  }, t.prototype.transform = function(e) {
    if (e) {
      var r = this.x, n = this.y;
      return this.x = e[0] * r + e[2] * n + e[4], this.y = e[1] * r + e[3] * n + e[5], this;
    }
  }, t.prototype.toArray = function(e) {
    return e[0] = this.x, e[1] = this.y, e;
  }, t.prototype.fromArray = function(e) {
    this.x = e[0], this.y = e[1];
  }, t.set = function(e, r, n) {
    e.x = r, e.y = n;
  }, t.copy = function(e, r) {
    e.x = r.x, e.y = r.y;
  }, t.len = function(e) {
    return Math.sqrt(e.x * e.x + e.y * e.y);
  }, t.lenSquare = function(e) {
    return e.x * e.x + e.y * e.y;
  }, t.dot = function(e, r) {
    return e.x * r.x + e.y * r.y;
  }, t.add = function(e, r, n) {
    e.x = r.x + n.x, e.y = r.y + n.y;
  }, t.sub = function(e, r, n) {
    e.x = r.x - n.x, e.y = r.y - n.y;
  }, t.scale = function(e, r, n) {
    e.x = r.x * n, e.y = r.y * n;
  }, t.scaleAndAdd = function(e, r, n, a) {
    e.x = r.x + n.x * a, e.y = r.y + n.y * a;
  }, t.lerp = function(e, r, n, a) {
    var o = 1 - a;
    e.x = o * r.x + a * n.x, e.y = o * r.y + a * n.y;
  }, t;
}(), lc = Math.min, sc = Math.max, _a = new he(), xa = new he(), Ca = new he(), Ea = new he(), Qi = new he(), Ji = new he(), Le = function() {
  function t(e, r, n, a) {
    n < 0 && (e = e + n, n = -n), a < 0 && (r = r + a, a = -a), this.x = e, this.y = r, this.width = n, this.height = a;
  }
  return t.prototype.union = function(e) {
    var r = lc(e.x, this.x), n = lc(e.y, this.y);
    isFinite(this.x) && isFinite(this.width) ? this.width = sc(e.x + e.width, this.x + this.width) - r : this.width = e.width, isFinite(this.y) && isFinite(this.height) ? this.height = sc(e.y + e.height, this.y + this.height) - n : this.height = e.height, this.x = r, this.y = n;
  }, t.prototype.applyTransform = function(e) {
    t.applyTransform(this, this, e);
  }, t.prototype.calculateTransform = function(e) {
    var r = this, n = e.width / r.width, a = e.height / r.height, o = ta();
    return j0(o, o, [-r.x, -r.y]), jb(o, o, [n, a]), j0(o, o, [e.x, e.y]), o;
  }, t.prototype.intersect = function(e, r) {
    if (!e)
      return !1;
    e instanceof t || (e = t.create(e));
    var n = this, a = n.x, o = n.x + n.width, i = n.y, l = n.y + n.height, c = e.x, u = e.x + e.width, d = e.y, f = e.y + e.height, h = !(o < c || u < a || l < d || f < i);
    if (r) {
      var v = 1 / 0, p = 0, g = Math.abs(o - c), m = Math.abs(u - a), w = Math.abs(l - d), y = Math.abs(f - i), b = Math.min(g, m), _ = Math.min(w, y);
      o < c || u < a ? b > p && (p = b, g < m ? he.set(Ji, -g, 0) : he.set(Ji, m, 0)) : b < v && (v = b, g < m ? he.set(Qi, g, 0) : he.set(Qi, -m, 0)), l < d || f < i ? _ > p && (p = _, w < y ? he.set(Ji, 0, -w) : he.set(Ji, 0, y)) : b < v && (v = b, w < y ? he.set(Qi, 0, w) : he.set(Qi, 0, -y));
    }
    return r && he.copy(r, h ? Qi : Ji), h;
  }, t.prototype.contain = function(e, r) {
    var n = this;
    return e >= n.x && e <= n.x + n.width && r >= n.y && r <= n.y + n.height;
  }, t.prototype.clone = function() {
    return new t(this.x, this.y, this.width, this.height);
  }, t.prototype.copy = function(e) {
    t.copy(this, e);
  }, t.prototype.plain = function() {
    return {
      x: this.x,
      y: this.y,
      width: this.width,
      height: this.height
    };
  }, t.prototype.isFinite = function() {
    return isFinite(this.x) && isFinite(this.y) && isFinite(this.width) && isFinite(this.height);
  }, t.prototype.isZero = function() {
    return this.width === 0 || this.height === 0;
  }, t.create = function(e) {
    return new t(e.x, e.y, e.width, e.height);
  }, t.copy = function(e, r) {
    e.x = r.x, e.y = r.y, e.width = r.width, e.height = r.height;
  }, t.applyTransform = function(e, r, n) {
    if (!n) {
      e !== r && t.copy(e, r);
      return;
    }
    if (n[1] < 1e-5 && n[1] > -1e-5 && n[2] < 1e-5 && n[2] > -1e-5) {
      var a = n[0], o = n[3], i = n[4], l = n[5];
      e.x = r.x * a + i, e.y = r.y * o + l, e.width = r.width * a, e.height = r.height * o, e.width < 0 && (e.x += e.width, e.width = -e.width), e.height < 0 && (e.y += e.height, e.height = -e.height);
      return;
    }
    _a.x = Ca.x = r.x, _a.y = Ea.y = r.y, xa.x = Ea.x = r.x + r.width, xa.y = Ca.y = r.y + r.height, _a.transform(n), Ea.transform(n), xa.transform(n), Ca.transform(n), e.x = lc(_a.x, xa.x, Ca.x, Ea.x), e.y = lc(_a.y, xa.y, Ca.y, Ea.y);
    var c = sc(_a.x, xa.x, Ca.x, Ea.x), u = sc(_a.y, xa.y, Ca.y, Ea.y);
    e.width = c - e.x, e.height = u - e.y;
  }, t;
}(), Wb = "silent";
function Ule(t, e, r) {
  return {
    type: t,
    event: r,
    target: e.target,
    topTarget: e.topTarget,
    cancelBubble: !1,
    offsetX: r.zrX,
    offsetY: r.zrY,
    gestureEvent: r.gestureEvent,
    pinchX: r.pinchX,
    pinchY: r.pinchY,
    pinchScale: r.pinchScale,
    wheelDelta: r.zrDelta,
    zrByTouch: r.zrByTouch,
    which: r.which,
    stop: Yle
  };
}
function Yle() {
  xi(this.event);
}
var Xle = function(t) {
  Be(e, t);
  function e() {
    var r = t !== null && t.apply(this, arguments) || this;
    return r.handler = null, r;
  }
  return e.prototype.dispose = function() {
  }, e.prototype.setCursor = function() {
  }, e;
}(Vr), el = /* @__PURE__ */ function() {
  function t(e, r) {
    this.x = e, this.y = r;
  }
  return t;
}(), qle = [
  "click",
  "dblclick",
  "mousewheel",
  "mouseout",
  "mouseup",
  "mousedown",
  "mousemove",
  "contextmenu"
], W5 = new Le(0, 0, 0, 0), zb = function(t) {
  Be(e, t);
  function e(r, n, a, o, i) {
    var l = t.call(this) || this;
    return l._hovered = new el(0, 0), l.storage = r, l.painter = n, l.painterRoot = o, l._pointerSize = i, a = a || new Xle(), l.proxy = null, l.setHandlerProxy(a), l._draggingMgr = new Tle(l), l;
  }
  return e.prototype.setHandlerProxy = function(r) {
    this.proxy && this.proxy.dispose(), r && (I(qle, function(n) {
      r.on && r.on(n, this[n], this);
    }, this), r.handler = this), this.proxy = r;
  }, e.prototype.mousemove = function(r) {
    var n = r.zrX, a = r.zrY, o = Gb(this, n, a), i = this._hovered, l = i.target;
    l && !l.__zr && (i = this.findHover(i.x, i.y), l = i.target);
    var c = this._hovered = o ? new el(n, a) : this.findHover(n, a), u = c.target, d = this.proxy;
    d.setCursor && d.setCursor(u ? u.cursor : "default"), l && u !== l && this.dispatchToElement(i, "mouseout", r), this.dispatchToElement(c, "mousemove", r), u && u !== l && this.dispatchToElement(c, "mouseover", r);
  }, e.prototype.mouseout = function(r) {
    var n = r.zrEventControl;
    n !== "only_globalout" && this.dispatchToElement(this._hovered, "mouseout", r), n !== "no_globalout" && this.trigger("globalout", { type: "globalout", event: r });
  }, e.prototype.resize = function() {
    this._hovered = new el(0, 0);
  }, e.prototype.dispatch = function(r, n) {
    var a = this[r];
    a && a.call(this, n);
  }, e.prototype.dispose = function() {
    this.proxy.dispose(), this.storage = null, this.proxy = null, this.painter = null;
  }, e.prototype.setCursorStyle = function(r) {
    var n = this.proxy;
    n.setCursor && n.setCursor(r);
  }, e.prototype.dispatchToElement = function(r, n, a) {
    r = r || {};
    var o = r.target;
    if (!(o && o.silent)) {
      for (var i = "on" + n, l = Ule(n, r, a); o && (o[i] && (l.cancelBubble = !!o[i].call(o, l)), o.trigger(n, l), o = o.__hostTarget ? o.__hostTarget : o.parent, !l.cancelBubble); )
        ;
      l.cancelBubble || (this.trigger(n, l), this.painter && this.painter.eachOtherLayer && this.painter.eachOtherLayer(function(c) {
        typeof c[i] == "function" && c[i].call(c, l), c.trigger && c.trigger(n, l);
      }));
    }
  }, e.prototype.findHover = function(r, n, a) {
    var o = this.storage.getDisplayList(), i = new el(r, n);
    if (vg(o, i, r, n, a), this._pointerSize && !i.target) {
      for (var l = [], c = this._pointerSize, u = c / 2, d = new Le(r - u, n - u, c, c), f = o.length - 1; f >= 0; f--) {
        var h = o[f];
        h !== a && !h.ignore && !h.ignoreCoarsePointer && (!h.parent || !h.parent.ignoreCoarsePointer) && (W5.copy(h.getBoundingRect()), h.transform && W5.applyTransform(h.transform), W5.intersect(d) && l.push(h));
      }
      if (l.length)
        for (var v = 4, p = Math.PI / 12, g = Math.PI * 2, m = 0; m < u; m += v)
          for (var w = 0; w < g; w += p) {
            var y = r + m * Math.cos(w), b = n + m * Math.sin(w);
            if (vg(l, i, y, b, a), i.target)
              return i;
          }
    }
    return i;
  }, e.prototype.processGesture = function(r, n) {
    this._gestureMgr || (this._gestureMgr = new jle());
    var a = this._gestureMgr;
    n === "start" && a.clear();
    var o = a.recognize(r, this.findHover(r.zrX, r.zrY, null).target, this.proxy.dom);
    if (n === "end" && a.clear(), o) {
      var i = o.type;
      r.gestureEvent = i;
      var l = new el();
      l.target = o.target, this.dispatchToElement(l, i, o.event);
    }
  }, e;
}(Vr);
I(["click", "mousedown", "mouseup", "mousewheel", "dblclick", "contextmenu"], function(t) {
  zb.prototype[t] = function(e) {
    var r = e.zrX, n = e.zrY, a = Gb(this, r, n), o, i;
    if ((t !== "mouseup" || !a) && (o = this.findHover(r, n), i = o.target), t === "mousedown")
      this._downEl = i, this._downPoint = [e.zrX, e.zrY], this._upEl = i;
    else if (t === "mouseup")
      this._upEl = i;
    else if (t === "click") {
      if (this._downEl !== this._upEl || !this._downPoint || H0(this._downPoint, [e.zrX, e.zrY]) > 4)
        return;
      this._downPoint = null;
    }
    this.dispatchToElement(o, t, e);
  };
});
function Kle(t, e, r) {
  if (t[t.rectHover ? "rectContain" : "contain"](e, r)) {
    for (var n = t, a = void 0, o = !1; n; ) {
      if (n.ignoreClip && (o = !0), !o) {
        var i = n.getClipPath();
        if (i && !i.contain(e, r))
          return !1;
      }
      n.silent && (a = !0);
      var l = n.__hostTarget;
      n = l || n.parent;
    }
    return a ? Wb : !0;
  }
  return !1;
}
function vg(t, e, r, n, a) {
  for (var o = t.length - 1; o >= 0; o--) {
    var i = t[o], l = void 0;
    if (i !== a && !i.ignore && (l = Kle(i, r, n)) && (!e.topTarget && (e.topTarget = i), l !== Wb)) {
      e.target = i;
      break;
    }
  }
}
function Gb(t, e, r) {
  var n = t.painter;
  return e < 0 || e > n.getWidth() || r < 0 || r > n.getHeight();
}
var Ub = 32, tl = 7;
function Qle(t) {
  for (var e = 0; t >= Ub; )
    e |= t & 1, t >>= 1;
  return t + e;
}
function pg(t, e, r, n) {
  var a = e + 1;
  if (a === r)
    return 1;
  if (n(t[a++], t[e]) < 0) {
    for (; a < r && n(t[a], t[a - 1]) < 0; )
      a++;
    Jle(t, e, a);
  } else
    for (; a < r && n(t[a], t[a - 1]) >= 0; )
      a++;
  return a - e;
}
function Jle(t, e, r) {
  for (r--; e < r; ) {
    var n = t[e];
    t[e++] = t[r], t[r--] = n;
  }
}
function gg(t, e, r, n, a) {
  for (n === e && n++; n < r; n++) {
    for (var o = t[n], i = e, l = n, c; i < l; )
      c = i + l >>> 1, a(o, t[c]) < 0 ? l = c : i = c + 1;
    var u = n - i;
    switch (u) {
      case 3:
        t[i + 3] = t[i + 2];
      case 2:
        t[i + 2] = t[i + 1];
      case 1:
        t[i + 1] = t[i];
        break;
      default:
        for (; u > 0; )
          t[i + u] = t[i + u - 1], u--;
    }
    t[i] = o;
  }
}
function z5(t, e, r, n, a, o) {
  var i = 0, l = 0, c = 1;
  if (o(t, e[r + a]) > 0) {
    for (l = n - a; c < l && o(t, e[r + a + c]) > 0; )
      i = c, c = (c << 1) + 1, c <= 0 && (c = l);
    c > l && (c = l), i += a, c += a;
  } else {
    for (l = a + 1; c < l && o(t, e[r + a - c]) <= 0; )
      i = c, c = (c << 1) + 1, c <= 0 && (c = l);
    c > l && (c = l);
    var u = i;
    i = a - c, c = a - u;
  }
  for (i++; i < c; ) {
    var d = i + (c - i >>> 1);
    o(t, e[r + d]) > 0 ? i = d + 1 : c = d;
  }
  return c;
}
function G5(t, e, r, n, a, o) {
  var i = 0, l = 0, c = 1;
  if (o(t, e[r + a]) < 0) {
    for (l = a + 1; c < l && o(t, e[r + a - c]) < 0; )
      i = c, c = (c << 1) + 1, c <= 0 && (c = l);
    c > l && (c = l);
    var u = i;
    i = a - c, c = a - u;
  } else {
    for (l = n - a; c < l && o(t, e[r + a + c]) >= 0; )
      i = c, c = (c << 1) + 1, c <= 0 && (c = l);
    c > l && (c = l), i += a, c += a;
  }
  for (i++; i < c; ) {
    var d = i + (c - i >>> 1);
    o(t, e[r + d]) < 0 ? c = d : i = d + 1;
  }
  return c;
}
function ese(t, e) {
  var r = tl, n, a, o = 0, i = [];
  n = [], a = [];
  function l(v, p) {
    n[o] = v, a[o] = p, o += 1;
  }
  function c() {
    for (; o > 1; ) {
      var v = o - 2;
      if (v >= 1 && a[v - 1] <= a[v] + a[v + 1] || v >= 2 && a[v - 2] <= a[v] + a[v - 1])
        a[v - 1] < a[v + 1] && v--;
      else if (a[v] > a[v + 1])
        break;
      d(v);
    }
  }
  function u() {
    for (; o > 1; ) {
      var v = o - 2;
      v > 0 && a[v - 1] < a[v + 1] && v--, d(v);
    }
  }
  function d(v) {
    var p = n[v], g = a[v], m = n[v + 1], w = a[v + 1];
    a[v] = g + w, v === o - 3 && (n[v + 1] = n[v + 2], a[v + 1] = a[v + 2]), o--;
    var y = G5(t[m], t, p, g, 0, e);
    p += y, g -= y, g !== 0 && (w = z5(t[p + g - 1], t, m, w, w - 1, e), w !== 0 && (g <= w ? f(p, g, m, w) : h(p, g, m, w)));
  }
  function f(v, p, g, m) {
    var w = 0;
    for (w = 0; w < p; w++)
      i[w] = t[v + w];
    var y = 0, b = g, _ = v;
    if (t[_++] = t[b++], --m === 0) {
      for (w = 0; w < p; w++)
        t[_ + w] = i[y + w];
      return;
    }
    if (p === 1) {
      for (w = 0; w < m; w++)
        t[_ + w] = t[b + w];
      t[_ + m] = i[y];
      return;
    }
    for (var x = r, E, S, M; ; ) {
      E = 0, S = 0, M = !1;
      do
        if (e(t[b], i[y]) < 0) {
          if (t[_++] = t[b++], S++, E = 0, --m === 0) {
            M = !0;
            break;
          }
        } else if (t[_++] = i[y++], E++, S = 0, --p === 1) {
          M = !0;
          break;
        }
      while ((E | S) < x);
      if (M)
        break;
      do {
        if (E = G5(t[b], i, y, p, 0, e), E !== 0) {
          for (w = 0; w < E; w++)
            t[_ + w] = i[y + w];
          if (_ += E, y += E, p -= E, p <= 1) {
            M = !0;
            break;
          }
        }
        if (t[_++] = t[b++], --m === 0) {
          M = !0;
          break;
        }
        if (S = z5(i[y], t, b, m, 0, e), S !== 0) {
          for (w = 0; w < S; w++)
            t[_ + w] = t[b + w];
          if (_ += S, b += S, m -= S, m === 0) {
            M = !0;
            break;
          }
        }
        if (t[_++] = i[y++], --p === 1) {
          M = !0;
          break;
        }
        x--;
      } while (E >= tl || S >= tl);
      if (M)
        break;
      x < 0 && (x = 0), x += 2;
    }
    if (r = x, r < 1 && (r = 1), p === 1) {
      for (w = 0; w < m; w++)
        t[_ + w] = t[b + w];
      t[_ + m] = i[y];
    } else {
      if (p === 0)
        throw new Error();
      for (w = 0; w < p; w++)
        t[_ + w] = i[y + w];
    }
  }
  function h(v, p, g, m) {
    var w = 0;
    for (w = 0; w < m; w++)
      i[w] = t[g + w];
    var y = v + p - 1, b = m - 1, _ = g + m - 1, x = 0, E = 0;
    if (t[_--] = t[y--], --p === 0) {
      for (x = _ - (m - 1), w = 0; w < m; w++)
        t[x + w] = i[w];
      return;
    }
    if (m === 1) {
      for (_ -= p, y -= p, E = _ + 1, x = y + 1, w = p - 1; w >= 0; w--)
        t[E + w] = t[x + w];
      t[_] = i[b];
      return;
    }
    for (var S = r; ; ) {
      var M = 0, R = 0, A = !1;
      do
        if (e(i[b], t[y]) < 0) {
          if (t[_--] = t[y--], M++, R = 0, --p === 0) {
            A = !0;
            break;
          }
        } else if (t[_--] = i[b--], R++, M = 0, --m === 1) {
          A = !0;
          break;
        }
      while ((M | R) < S);
      if (A)
        break;
      do {
        if (M = p - G5(i[b], t, v, p, p - 1, e), M !== 0) {
          for (_ -= M, y -= M, p -= M, E = _ + 1, x = y + 1, w = M - 1; w >= 0; w--)
            t[E + w] = t[x + w];
          if (p === 0) {
            A = !0;
            break;
          }
        }
        if (t[_--] = i[b--], --m === 1) {
          A = !0;
          break;
        }
        if (R = m - z5(t[y], i, 0, m, m - 1, e), R !== 0) {
          for (_ -= R, b -= R, m -= R, E = _ + 1, x = b + 1, w = 0; w < R; w++)
            t[E + w] = i[x + w];
          if (m <= 1) {
            A = !0;
            break;
          }
        }
        if (t[_--] = t[y--], --p === 0) {
          A = !0;
          break;
        }
        S--;
      } while (M >= tl || R >= tl);
      if (A)
        break;
      S < 0 && (S = 0), S += 2;
    }
    if (r = S, r < 1 && (r = 1), m === 1) {
      for (_ -= p, y -= p, E = _ + 1, x = y + 1, w = p - 1; w >= 0; w--)
        t[E + w] = t[x + w];
      t[_] = i[b];
    } else {
      if (m === 0)
        throw new Error();
      for (x = _ - (m - 1), w = 0; w < m; w++)
        t[x + w] = i[w];
    }
  }
  return {
    mergeRuns: c,
    forceMergeRuns: u,
    pushRun: l
  };
}
function h0(t, e, r, n) {
  r || (r = 0), n || (n = t.length);
  var a = n - r;
  if (!(a < 2)) {
    var o = 0;
    if (a < Ub) {
      o = pg(t, r, n, e), gg(t, r, n, r + o, e);
      return;
    }
    var i = ese(t, e), l = Qle(a);
    do {
      if (o = pg(t, r, n, e), o < l) {
        var c = a;
        c > l && (c = l), gg(t, r, r + c, r + o, e), o = c;
      }
      i.pushRun(r, o), i.mergeRuns(), a -= o, r += o;
    } while (a !== 0);
    i.forceMergeRuns();
  }
}
var qt = 1, Cl = 2, Xo = 4, mg = !1;
function U5() {
  mg || (mg = !0, console.warn("z / z2 / zlevel of displayable is invalid, which may cause unexpected errors"));
}
function wg(t, e) {
  return t.zlevel === e.zlevel ? t.z === e.z ? t.z2 - e.z2 : t.z - e.z : t.zlevel - e.zlevel;
}
var tse = function() {
  function t() {
    this._roots = [], this._displayList = [], this._displayListLen = 0, this.displayableSortFunc = wg;
  }
  return t.prototype.traverse = function(e, r) {
    for (var n = 0; n < this._roots.length; n++)
      this._roots[n].traverse(e, r);
  }, t.prototype.getDisplayList = function(e, r) {
    r = r || !1;
    var n = this._displayList;
    return (e || !n.length) && this.updateDisplayList(r), n;
  }, t.prototype.updateDisplayList = function(e) {
    this._displayListLen = 0;
    for (var r = this._roots, n = this._displayList, a = 0, o = r.length; a < o; a++)
      this._updateAndAddDisplayable(r[a], null, e);
    n.length = this._displayListLen, h0(n, wg);
  }, t.prototype._updateAndAddDisplayable = function(e, r, n) {
    if (!(e.ignore && !n)) {
      e.beforeUpdate(), e.update(), e.afterUpdate();
      var a = e.getClipPath();
      if (e.ignoreClip)
        r = null;
      else if (a) {
        r ? r = r.slice() : r = [];
        for (var o = a, i = e; o; )
          o.parent = i, o.updateTransform(), r.push(o), i = o, o = o.getClipPath();
      }
      if (e.childrenRef) {
        for (var l = e.childrenRef(), c = 0; c < l.length; c++) {
          var u = l[c];
          e.__dirty && (u.__dirty |= qt), this._updateAndAddDisplayable(u, r, n);
        }
        e.__dirty = 0;
      } else {
        var d = e;
        r && r.length ? d.__clipPaths = r : d.__clipPaths && d.__clipPaths.length > 0 && (d.__clipPaths = []), isNaN(d.z) && (U5(), d.z = 0), isNaN(d.z2) && (U5(), d.z2 = 0), isNaN(d.zlevel) && (U5(), d.zlevel = 0), this._displayList[this._displayListLen++] = d;
      }
      var f = e.getDecalElement && e.getDecalElement();
      f && this._updateAndAddDisplayable(f, r, n);
      var h = e.getTextGuideLine();
      h && this._updateAndAddDisplayable(h, r, n);
      var v = e.getTextContent();
      v && this._updateAndAddDisplayable(v, r, n);
    }
  }, t.prototype.addRoot = function(e) {
    e.__zr && e.__zr.storage === this || this._roots.push(e);
  }, t.prototype.delRoot = function(e) {
    if (e instanceof Array) {
      for (var r = 0, n = e.length; r < n; r++)
        this.delRoot(e[r]);
      return;
    }
    var a = Re(this._roots, e);
    a >= 0 && this._roots.splice(a, 1);
  }, t.prototype.delAllRoots = function() {
    this._roots = [], this._displayList = [], this._displayListLen = 0;
  }, t.prototype.getRoots = function() {
    return this._roots;
  }, t.prototype.dispose = function() {
    this._displayList = null, this._roots = null;
  }, t;
}(), W0;
W0 = ue.hasGlobalWindow && (window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window) || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame) || function(t) {
  return setTimeout(t, 16);
};
var Il = {
  linear: function(t) {
    return t;
  },
  quadraticIn: function(t) {
    return t * t;
  },
  quadraticOut: function(t) {
    return t * (2 - t);
  },
  quadraticInOut: function(t) {
    return (t *= 2) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1);
  },
  cubicIn: function(t) {
    return t * t * t;
  },
  cubicOut: function(t) {
    return --t * t * t + 1;
  },
  cubicInOut: function(t) {
    return (t *= 2) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2);
  },
  quarticIn: function(t) {
    return t * t * t * t;
  },
  quarticOut: function(t) {
    return 1 - --t * t * t * t;
  },
  quarticInOut: function(t) {
    return (t *= 2) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2);
  },
  quinticIn: function(t) {
    return t * t * t * t * t;
  },
  quinticOut: function(t) {
    return --t * t * t * t * t + 1;
  },
  quinticInOut: function(t) {
    return (t *= 2) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2);
  },
  sinusoidalIn: function(t) {
    return 1 - Math.cos(t * Math.PI / 2);
  },
  sinusoidalOut: function(t) {
    return Math.sin(t * Math.PI / 2);
  },
  sinusoidalInOut: function(t) {
    return 0.5 * (1 - Math.cos(Math.PI * t));
  },
  exponentialIn: function(t) {
    return t === 0 ? 0 : Math.pow(1024, t - 1);
  },
  exponentialOut: function(t) {
    return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
  },
  exponentialInOut: function(t) {
    return t === 0 ? 0 : t === 1 ? 1 : (t *= 2) < 1 ? 0.5 * Math.pow(1024, t - 1) : 0.5 * (-Math.pow(2, -10 * (t - 1)) + 2);
  },
  circularIn: function(t) {
    return 1 - Math.sqrt(1 - t * t);
  },
  circularOut: function(t) {
    return Math.sqrt(1 - --t * t);
  },
  circularInOut: function(t) {
    return (t *= 2) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
  },
  elasticIn: function(t) {
    var e, r = 0.1, n = 0.4;
    return t === 0 ? 0 : t === 1 ? 1 : (!r || r < 1 ? (r = 1, e = n / 4) : e = n * Math.asin(1 / r) / (2 * Math.PI), -(r * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - e) * (2 * Math.PI) / n)));
  },
  elasticOut: function(t) {
    var e, r = 0.1, n = 0.4;
    return t === 0 ? 0 : t === 1 ? 1 : (!r || r < 1 ? (r = 1, e = n / 4) : e = n * Math.asin(1 / r) / (2 * Math.PI), r * Math.pow(2, -10 * t) * Math.sin((t - e) * (2 * Math.PI) / n) + 1);
  },
  elasticInOut: function(t) {
    var e, r = 0.1, n = 0.4;
    return t === 0 ? 0 : t === 1 ? 1 : (!r || r < 1 ? (r = 1, e = n / 4) : e = n * Math.asin(1 / r) / (2 * Math.PI), (t *= 2) < 1 ? -0.5 * (r * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - e) * (2 * Math.PI) / n)) : r * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - e) * (2 * Math.PI) / n) * 0.5 + 1);
  },
  backIn: function(t) {
    var e = 1.70158;
    return t * t * ((e + 1) * t - e);
  },
  backOut: function(t) {
    var e = 1.70158;
    return --t * t * ((e + 1) * t + e) + 1;
  },
  backInOut: function(t) {
    var e = 2.5949095;
    return (t *= 2) < 1 ? 0.5 * (t * t * ((e + 1) * t - e)) : 0.5 * ((t -= 2) * t * ((e + 1) * t + e) + 2);
  },
  bounceIn: function(t) {
    return 1 - Il.bounceOut(1 - t);
  },
  bounceOut: function(t) {
    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + 0.75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375 : 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
  },
  bounceInOut: function(t) {
    return t < 0.5 ? Il.bounceIn(t * 2) * 0.5 : Il.bounceOut(t * 2 - 1) * 0.5 + 0.5;
  }
}, cc = Math.pow, na = Math.sqrt, z0 = 1e-8, Yb = 1e-4, yg = na(3), uc = 1 / 3, Xr = go(), dr = go(), li = go();
function zn(t) {
  return t > -z0 && t < z0;
}
function Xb(t) {
  return t > z0 || t < -z0;
}
function ut(t, e, r, n, a) {
  var o = 1 - a;
  return o * o * (o * t + 3 * a * e) + a * a * (a * n + 3 * o * r);
}
function bg(t, e, r, n, a) {
  var o = 1 - a;
  return 3 * (((e - t) * o + 2 * (r - e) * a) * o + (n - r) * a * a);
}
function G0(t, e, r, n, a, o) {
  var i = n + 3 * (e - r) - t, l = 3 * (r - e * 2 + t), c = 3 * (e - t), u = t - a, d = l * l - 3 * i * c, f = l * c - 9 * i * u, h = c * c - 3 * l * u, v = 0;
  if (zn(d) && zn(f))
    if (zn(l))
      o[0] = 0;
    else {
      var p = -c / l;
      p >= 0 && p <= 1 && (o[v++] = p);
    }
  else {
    var g = f * f - 4 * d * h;
    if (zn(g)) {
      var m = f / d, p = -l / i + m, w = -m / 2;
      p >= 0 && p <= 1 && (o[v++] = p), w >= 0 && w <= 1 && (o[v++] = w);
    } else if (g > 0) {
      var y = na(g), b = d * l + 1.5 * i * (-f + y), _ = d * l + 1.5 * i * (-f - y);
      b < 0 ? b = -cc(-b, uc) : b = cc(b, uc), _ < 0 ? _ = -cc(-_, uc) : _ = cc(_, uc);
      var p = (-l - (b + _)) / (3 * i);
      p >= 0 && p <= 1 && (o[v++] = p);
    } else {
      var x = (2 * d * l - 3 * i * f) / (2 * na(d * d * d)), E = Math.acos(x) / 3, S = na(d), M = Math.cos(E), p = (-l - 2 * S * M) / (3 * i), w = (-l + S * (M + yg * Math.sin(E))) / (3 * i), R = (-l + S * (M - yg * Math.sin(E))) / (3 * i);
      p >= 0 && p <= 1 && (o[v++] = p), w >= 0 && w <= 1 && (o[v++] = w), R >= 0 && R <= 1 && (o[v++] = R);
    }
  }
  return v;
}
function qb(t, e, r, n, a) {
  var o = 6 * r - 12 * e + 6 * t, i = 9 * e + 3 * n - 3 * t - 9 * r, l = 3 * e - 3 * t, c = 0;
  if (zn(i)) {
    if (Xb(o)) {
      var u = -l / o;
      u >= 0 && u <= 1 && (a[c++] = u);
    }
  } else {
    var d = o * o - 4 * i * l;
    if (zn(d))
      a[0] = -o / (2 * i);
    else if (d > 0) {
      var f = na(d), u = (-o + f) / (2 * i), h = (-o - f) / (2 * i);
      u >= 0 && u <= 1 && (a[c++] = u), h >= 0 && h <= 1 && (a[c++] = h);
    }
  }
  return c;
}
function U0(t, e, r, n, a, o) {
  var i = (e - t) * a + t, l = (r - e) * a + e, c = (n - r) * a + r, u = (l - i) * a + i, d = (c - l) * a + l, f = (d - u) * a + u;
  o[0] = t, o[1] = i, o[2] = u, o[3] = f, o[4] = f, o[5] = d, o[6] = c, o[7] = n;
}
function rse(t, e, r, n, a, o, i, l, c, u, d) {
  var f, h = 5e-3, v = 1 / 0, p, g, m, w;
  Xr[0] = c, Xr[1] = u;
  for (var y = 0; y < 1; y += 0.05)
    dr[0] = ut(t, r, a, i, y), dr[1] = ut(e, n, o, l, y), m = Ya(Xr, dr), m < v && (f = y, v = m);
  v = 1 / 0;
  for (var b = 0; b < 32 && !(h < Yb); b++)
    p = f - h, g = f + h, dr[0] = ut(t, r, a, i, p), dr[1] = ut(e, n, o, l, p), m = Ya(dr, Xr), p >= 0 && m < v ? (f = p, v = m) : (li[0] = ut(t, r, a, i, g), li[1] = ut(e, n, o, l, g), w = Ya(li, Xr), g <= 1 && w < v ? (f = g, v = w) : h *= 0.5);
  return na(v);
}
function nse(t, e, r, n, a, o, i, l, c) {
  for (var u = t, d = e, f = 0, h = 1 / c, v = 1; v <= c; v++) {
    var p = v * h, g = ut(t, r, a, i, p), m = ut(e, n, o, l, p), w = g - u, y = m - d;
    f += Math.sqrt(w * w + y * y), u = g, d = m;
  }
  return f;
}
function $t(t, e, r, n) {
  var a = 1 - n;
  return a * (a * t + 2 * n * e) + n * n * r;
}
function _g(t, e, r, n) {
  return 2 * ((1 - n) * (e - t) + n * (r - e));
}
function ase(t, e, r, n, a) {
  var o = t - 2 * e + r, i = 2 * (e - t), l = t - n, c = 0;
  if (zn(o)) {
    if (Xb(i)) {
      var u = -l / i;
      u >= 0 && u <= 1 && (a[c++] = u);
    }
  } else {
    var d = i * i - 4 * o * l;
    if (zn(d)) {
      var u = -i / (2 * o);
      u >= 0 && u <= 1 && (a[c++] = u);
    } else if (d > 0) {
      var f = na(d), u = (-i + f) / (2 * o), h = (-i - f) / (2 * o);
      u >= 0 && u <= 1 && (a[c++] = u), h >= 0 && h <= 1 && (a[c++] = h);
    }
  }
  return c;
}
function Kb(t, e, r) {
  var n = t + r - 2 * e;
  return n === 0 ? 0.5 : (t - e) / n;
}
function Y0(t, e, r, n, a) {
  var o = (e - t) * n + t, i = (r - e) * n + e, l = (i - o) * n + o;
  a[0] = t, a[1] = o, a[2] = l, a[3] = l, a[4] = i, a[5] = r;
}
function ose(t, e, r, n, a, o, i, l, c) {
  var u, d = 5e-3, f = 1 / 0;
  Xr[0] = i, Xr[1] = l;
  for (var h = 0; h < 1; h += 0.05) {
    dr[0] = $t(t, r, a, h), dr[1] = $t(e, n, o, h);
    var v = Ya(Xr, dr);
    v < f && (u = h, f = v);
  }
  f = 1 / 0;
  for (var p = 0; p < 32 && !(d < Yb); p++) {
    var g = u - d, m = u + d;
    dr[0] = $t(t, r, a, g), dr[1] = $t(e, n, o, g);
    var v = Ya(dr, Xr);
    if (g >= 0 && v < f)
      u = g, f = v;
    else {
      li[0] = $t(t, r, a, m), li[1] = $t(e, n, o, m);
      var w = Ya(li, Xr);
      m <= 1 && w < f ? (u = m, f = w) : d *= 0.5;
    }
  }
  return na(f);
}
function ise(t, e, r, n, a, o, i) {
  for (var l = t, c = e, u = 0, d = 1 / i, f = 1; f <= i; f++) {
    var h = f * d, v = $t(t, r, a, h), p = $t(e, n, o, h), g = v - l, m = p - c;
    u += Math.sqrt(g * g + m * m), l = v, c = p;
  }
  return u;
}
var lse = /cubic-bezier\(([0-9,\.e ]+)\)/;
function Qb(t) {
  var e = t && lse.exec(t);
  if (e) {
    var r = e[1].split(","), n = +Ir(r[0]), a = +Ir(r[1]), o = +Ir(r[2]), i = +Ir(r[3]);
    if (isNaN(n + a + o + i))
      return;
    var l = [];
    return function(c) {
      return c <= 0 ? 0 : c >= 1 ? 1 : G0(0, n, o, 1, c, l) && ut(0, a, i, 1, l[0]);
    };
  }
}
var sse = function() {
  function t(e) {
    this._inited = !1, this._startTime = 0, this._pausedTime = 0, this._paused = !1, this._life = e.life || 1e3, this._delay = e.delay || 0, this.loop = e.loop || !1, this.onframe = e.onframe || mt, this.ondestroy = e.ondestroy || mt, this.onrestart = e.onrestart || mt, e.easing && this.setEasing(e.easing);
  }
  return t.prototype.step = function(e, r) {
    if (this._inited || (this._startTime = e + this._delay, this._inited = !0), this._paused) {
      this._pausedTime += r;
      return;
    }
    var n = this._life, a = e - this._startTime - this._pausedTime, o = a / n;
    o < 0 && (o = 0), o = Math.min(o, 1);
    var i = this.easingFunc, l = i ? i(o) : o;
    if (this.onframe(l), o === 1)
      if (this.loop) {
        var c = a % n;
        this._startTime = e - c, this._pausedTime = 0, this.onrestart();
      } else
        return !0;
    return !1;
  }, t.prototype.pause = function() {
    this._paused = !0;
  }, t.prototype.resume = function() {
    this._paused = !1;
  }, t.prototype.setEasing = function(e) {
    this.easing = e, this.easingFunc = ie(e) ? e : Il[e] || Qb(e);
  }, t;
}(), Jb = /* @__PURE__ */ function() {
  function t(e) {
    this.value = e;
  }
  return t;
}(), cse = function() {
  function t() {
    this._len = 0;
  }
  return t.prototype.insert = function(e) {
    var r = new Jb(e);
    return this.insertEntry(r), r;
  }, t.prototype.insertEntry = function(e) {
    this.head ? (this.tail.next = e, e.prev = this.tail, e.next = null, this.tail = e) : this.head = this.tail = e, this._len++;
  }, t.prototype.remove = function(e) {
    var r = e.prev, n = e.next;
    r ? r.next = n : this.head = n, n ? n.prev = r : this.tail = r, e.next = e.prev = null, this._len--;
  }, t.prototype.len = function() {
    return this._len;
  }, t.prototype.clear = function() {
    this.head = this.tail = null, this._len = 0;
  }, t;
}(), Os = function() {
  function t(e) {
    this._list = new cse(), this._maxSize = 10, this._map = {}, this._maxSize = e;
  }
  return t.prototype.put = function(e, r) {
    var n = this._list, a = this._map, o = null;
    if (a[e] == null) {
      var i = n.len(), l = this._lastRemovedEntry;
      if (i >= this._maxSize && i > 0) {
        var c = n.head;
        n.remove(c), delete a[c.key], o = c.value, this._lastRemovedEntry = c;
      }
      l ? l.value = r : l = new Jb(r), l.key = e, n.insertEntry(l), a[e] = l;
    }
    return o;
  }, t.prototype.get = function(e) {
    var r = this._map[e], n = this._list;
    if (r != null)
      return r !== n.tail && (n.remove(r), n.insertEntry(r)), r.value;
  }, t.prototype.clear = function() {
    this._list.clear(), this._map = {};
  }, t.prototype.len = function() {
    return this._list.len();
  }, t;
}(), xg = {
  transparent: [0, 0, 0, 0],
  aliceblue: [240, 248, 255, 1],
  antiquewhite: [250, 235, 215, 1],
  aqua: [0, 255, 255, 1],
  aquamarine: [127, 255, 212, 1],
  azure: [240, 255, 255, 1],
  beige: [245, 245, 220, 1],
  bisque: [255, 228, 196, 1],
  black: [0, 0, 0, 1],
  blanchedalmond: [255, 235, 205, 1],
  blue: [0, 0, 255, 1],
  blueviolet: [138, 43, 226, 1],
  brown: [165, 42, 42, 1],
  burlywood: [222, 184, 135, 1],
  cadetblue: [95, 158, 160, 1],
  chartreuse: [127, 255, 0, 1],
  chocolate: [210, 105, 30, 1],
  coral: [255, 127, 80, 1],
  cornflowerblue: [100, 149, 237, 1],
  cornsilk: [255, 248, 220, 1],
  crimson: [220, 20, 60, 1],
  cyan: [0, 255, 255, 1],
  darkblue: [0, 0, 139, 1],
  darkcyan: [0, 139, 139, 1],
  darkgoldenrod: [184, 134, 11, 1],
  darkgray: [169, 169, 169, 1],
  darkgreen: [0, 100, 0, 1],
  darkgrey: [169, 169, 169, 1],
  darkkhaki: [189, 183, 107, 1],
  darkmagenta: [139, 0, 139, 1],
  darkolivegreen: [85, 107, 47, 1],
  darkorange: [255, 140, 0, 1],
  darkorchid: [153, 50, 204, 1],
  darkred: [139, 0, 0, 1],
  darksalmon: [233, 150, 122, 1],
  darkseagreen: [143, 188, 143, 1],
  darkslateblue: [72, 61, 139, 1],
  darkslategray: [47, 79, 79, 1],
  darkslategrey: [47, 79, 79, 1],
  darkturquoise: [0, 206, 209, 1],
  darkviolet: [148, 0, 211, 1],
  deeppink: [255, 20, 147, 1],
  deepskyblue: [0, 191, 255, 1],
  dimgray: [105, 105, 105, 1],
  dimgrey: [105, 105, 105, 1],
  dodgerblue: [30, 144, 255, 1],
  firebrick: [178, 34, 34, 1],
  floralwhite: [255, 250, 240, 1],
  forestgreen: [34, 139, 34, 1],
  fuchsia: [255, 0, 255, 1],
  gainsboro: [220, 220, 220, 1],
  ghostwhite: [248, 248, 255, 1],
  gold: [255, 215, 0, 1],
  goldenrod: [218, 165, 32, 1],
  gray: [128, 128, 128, 1],
  green: [0, 128, 0, 1],
  greenyellow: [173, 255, 47, 1],
  grey: [128, 128, 128, 1],
  honeydew: [240, 255, 240, 1],
  hotpink: [255, 105, 180, 1],
  indianred: [205, 92, 92, 1],
  indigo: [75, 0, 130, 1],
  ivory: [255, 255, 240, 1],
  khaki: [240, 230, 140, 1],
  lavender: [230, 230, 250, 1],
  lavenderblush: [255, 240, 245, 1],
  lawngreen: [124, 252, 0, 1],
  lemonchiffon: [255, 250, 205, 1],
  lightblue: [173, 216, 230, 1],
  lightcoral: [240, 128, 128, 1],
  lightcyan: [224, 255, 255, 1],
  lightgoldenrodyellow: [250, 250, 210, 1],
  lightgray: [211, 211, 211, 1],
  lightgreen: [144, 238, 144, 1],
  lightgrey: [211, 211, 211, 1],
  lightpink: [255, 182, 193, 1],
  lightsalmon: [255, 160, 122, 1],
  lightseagreen: [32, 178, 170, 1],
  lightskyblue: [135, 206, 250, 1],
  lightslategray: [119, 136, 153, 1],
  lightslategrey: [119, 136, 153, 1],
  lightsteelblue: [176, 196, 222, 1],
  lightyellow: [255, 255, 224, 1],
  lime: [0, 255, 0, 1],
  limegreen: [50, 205, 50, 1],
  linen: [250, 240, 230, 1],
  magenta: [255, 0, 255, 1],
  maroon: [128, 0, 0, 1],
  mediumaquamarine: [102, 205, 170, 1],
  mediumblue: [0, 0, 205, 1],
  mediumorchid: [186, 85, 211, 1],
  mediumpurple: [147, 112, 219, 1],
  mediumseagreen: [60, 179, 113, 1],
  mediumslateblue: [123, 104, 238, 1],
  mediumspringgreen: [0, 250, 154, 1],
  mediumturquoise: [72, 209, 204, 1],
  mediumvioletred: [199, 21, 133, 1],
  midnightblue: [25, 25, 112, 1],
  mintcream: [245, 255, 250, 1],
  mistyrose: [255, 228, 225, 1],
  moccasin: [255, 228, 181, 1],
  navajowhite: [255, 222, 173, 1],
  navy: [0, 0, 128, 1],
  oldlace: [253, 245, 230, 1],
  olive: [128, 128, 0, 1],
  olivedrab: [107, 142, 35, 1],
  orange: [255, 165, 0, 1],
  orangered: [255, 69, 0, 1],
  orchid: [218, 112, 214, 1],
  palegoldenrod: [238, 232, 170, 1],
  palegreen: [152, 251, 152, 1],
  paleturquoise: [175, 238, 238, 1],
  palevioletred: [219, 112, 147, 1],
  papayawhip: [255, 239, 213, 1],
  peachpuff: [255, 218, 185, 1],
  peru: [205, 133, 63, 1],
  pink: [255, 192, 203, 1],
  plum: [221, 160, 221, 1],
  powderblue: [176, 224, 230, 1],
  purple: [128, 0, 128, 1],
  red: [255, 0, 0, 1],
  rosybrown: [188, 143, 143, 1],
  royalblue: [65, 105, 225, 1],
  saddlebrown: [139, 69, 19, 1],
  salmon: [250, 128, 114, 1],
  sandybrown: [244, 164, 96, 1],
  seagreen: [46, 139, 87, 1],
  seashell: [255, 245, 238, 1],
  sienna: [160, 82, 45, 1],
  silver: [192, 192, 192, 1],
  skyblue: [135, 206, 235, 1],
  slateblue: [106, 90, 205, 1],
  slategray: [112, 128, 144, 1],
  slategrey: [112, 128, 144, 1],
  snow: [255, 250, 250, 1],
  springgreen: [0, 255, 127, 1],
  steelblue: [70, 130, 180, 1],
  tan: [210, 180, 140, 1],
  teal: [0, 128, 128, 1],
  thistle: [216, 191, 216, 1],
  tomato: [255, 99, 71, 1],
  turquoise: [64, 224, 208, 1],
  violet: [238, 130, 238, 1],
  wheat: [245, 222, 179, 1],
  white: [255, 255, 255, 1],
  whitesmoke: [245, 245, 245, 1],
  yellow: [255, 255, 0, 1],
  yellowgreen: [154, 205, 50, 1]
};
function Dr(t) {
  return t = Math.round(t), t < 0 ? 0 : t > 255 ? 255 : t;
}
function use(t) {
  return t = Math.round(t), t < 0 ? 0 : t > 360 ? 360 : t;
}
function ql(t) {
  return t < 0 ? 0 : t > 1 ? 1 : t;
}
function Y5(t) {
  var e = t;
  return e.length && e.charAt(e.length - 1) === "%" ? Dr(parseFloat(e) / 100 * 255) : Dr(parseInt(e, 10));
}
function Xa(t) {
  var e = t;
  return e.length && e.charAt(e.length - 1) === "%" ? ql(parseFloat(e) / 100) : ql(parseFloat(e));
}
function X5(t, e, r) {
  return r < 0 ? r += 1 : r > 1 && (r -= 1), r * 6 < 1 ? t + (e - t) * r * 6 : r * 2 < 1 ? e : r * 3 < 2 ? t + (e - t) * (2 / 3 - r) * 6 : t;
}
function Gn(t, e, r) {
  return t + (e - t) * r;
}
function ir(t, e, r, n, a) {
  return t[0] = e, t[1] = r, t[2] = n, t[3] = a, t;
}
function bh(t, e) {
  return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t;
}
var e9 = new Os(20), dc = null;
function Lo(t, e) {
  dc && bh(dc, e), dc = e9.put(t, dc || e.slice());
}
function Jt(t, e) {
  if (t) {
    e = e || [];
    var r = e9.get(t);
    if (r)
      return bh(e, r);
    t = t + "";
    var n = t.replace(/ /g, "").toLowerCase();
    if (n in xg)
      return bh(e, xg[n]), Lo(t, e), e;
    var a = n.length;
    if (n.charAt(0) === "#") {
      if (a === 4 || a === 5) {
        var o = parseInt(n.slice(1, 4), 16);
        if (!(o >= 0 && o <= 4095)) {
          ir(e, 0, 0, 0, 1);
          return;
        }
        return ir(e, (o & 3840) >> 4 | (o & 3840) >> 8, o & 240 | (o & 240) >> 4, o & 15 | (o & 15) << 4, a === 5 ? parseInt(n.slice(4), 16) / 15 : 1), Lo(t, e), e;
      } else if (a === 7 || a === 9) {
        var o = parseInt(n.slice(1, 7), 16);
        if (!(o >= 0 && o <= 16777215)) {
          ir(e, 0, 0, 0, 1);
          return;
        }
        return ir(e, (o & 16711680) >> 16, (o & 65280) >> 8, o & 255, a === 9 ? parseInt(n.slice(7), 16) / 255 : 1), Lo(t, e), e;
      }
      return;
    }
    var i = n.indexOf("("), l = n.indexOf(")");
    if (i !== -1 && l + 1 === a) {
      var c = n.substr(0, i), u = n.substr(i + 1, l - (i + 1)).split(","), d = 1;
      switch (c) {
        case "rgba":
          if (u.length !== 4)
            return u.length === 3 ? ir(e, +u[0], +u[1], +u[2], 1) : ir(e, 0, 0, 0, 1);
          d = Xa(u.pop());
        case "rgb":
          if (u.length >= 3)
            return ir(e, Y5(u[0]), Y5(u[1]), Y5(u[2]), u.length === 3 ? d : Xa(u[3])), Lo(t, e), e;
          ir(e, 0, 0, 0, 1);
          return;
        case "hsla":
          if (u.length !== 4) {
            ir(e, 0, 0, 0, 1);
            return;
          }
          return u[3] = Xa(u[3]), _h(u, e), Lo(t, e), e;
        case "hsl":
          if (u.length !== 3) {
            ir(e, 0, 0, 0, 1);
            return;
          }
          return _h(u, e), Lo(t, e), e;
        default:
          return;
      }
    }
    ir(e, 0, 0, 0, 1);
  }
}
function _h(t, e) {
  var r = (parseFloat(t[0]) % 360 + 360) % 360 / 360, n = Xa(t[1]), a = Xa(t[2]), o = a <= 0.5 ? a * (n + 1) : a + n - a * n, i = a * 2 - o;
  return e = e || [], ir(e, Dr(X5(i, o, r + 1 / 3) * 255), Dr(X5(i, o, r) * 255), Dr(X5(i, o, r - 1 / 3) * 255), 1), t.length === 4 && (e[3] = t[3]), e;
}
function dse(t) {
  if (t) {
    var e = t[0] / 255, r = t[1] / 255, n = t[2] / 255, a = Math.min(e, r, n), o = Math.max(e, r, n), i = o - a, l = (o + a) / 2, c, u;
    if (i === 0)
      c = 0, u = 0;
    else {
      l < 0.5 ? u = i / (o + a) : u = i / (2 - o - a);
      var d = ((o - e) / 6 + i / 2) / i, f = ((o - r) / 6 + i / 2) / i, h = ((o - n) / 6 + i / 2) / i;
      e === o ? c = h - f : r === o ? c = 1 / 3 + d - h : n === o && (c = 2 / 3 + f - d), c < 0 && (c += 1), c > 1 && (c -= 1);
    }
    var v = [c * 360, u, l];
    return t[3] != null && v.push(t[3]), v;
  }
}
function xh(t, e) {
  var r = Jt(t);
  if (r) {
    for (var n = 0; n < 3; n++)
      e < 0 ? r[n] = r[n] * (1 - e) | 0 : r[n] = (255 - r[n]) * e + r[n] | 0, r[n] > 255 ? r[n] = 255 : r[n] < 0 && (r[n] = 0);
    return ga(r, r.length === 4 ? "rgba" : "rgb");
  }
}
function fse(t) {
  var e = Jt(t);
  if (e)
    return ((1 << 24) + (e[0] << 16) + (e[1] << 8) + +e[2]).toString(16).slice(1);
}
function t9(t, e, r) {
  if (!(!(e && e.length) || !(t >= 0 && t <= 1))) {
    r = r || [];
    var n = t * (e.length - 1), a = Math.floor(n), o = Math.ceil(n), i = e[a], l = e[o], c = n - a;
    return r[0] = Dr(Gn(i[0], l[0], c)), r[1] = Dr(Gn(i[1], l[1], c)), r[2] = Dr(Gn(i[2], l[2], c)), r[3] = ql(Gn(i[3], l[3], c)), r;
  }
}
var hse = t9;
function Hv(t, e, r) {
  if (!(!(e && e.length) || !(t >= 0 && t <= 1))) {
    var n = t * (e.length - 1), a = Math.floor(n), o = Math.ceil(n), i = Jt(e[a]), l = Jt(e[o]), c = n - a, u = ga([
      Dr(Gn(i[0], l[0], c)),
      Dr(Gn(i[1], l[1], c)),
      Dr(Gn(i[2], l[2], c)),
      ql(Gn(i[3], l[3], c))
    ], "rgba");
    return r ? {
      color: u,
      leftIndex: a,
      rightIndex: o,
      value: n
    } : u;
  }
}
var vse = Hv;
function pse(t, e, r, n) {
  var a = Jt(t);
  if (t)
    return a = dse(a), e != null && (a[0] = use(e)), r != null && (a[1] = Xa(r)), n != null && (a[2] = Xa(n)), ga(_h(a), "rgba");
}
function gse(t, e) {
  var r = Jt(t);
  if (r && e != null)
    return r[3] = ql(e), ga(r, "rgba");
}
function ga(t, e) {
  if (!(!t || !t.length)) {
    var r = t[0] + "," + t[1] + "," + t[2];
    return (e === "rgba" || e === "hsva" || e === "hsla") && (r += "," + t[3]), e + "(" + r + ")";
  }
}
function Kl(t, e) {
  var r = Jt(t);
  return r ? (0.299 * r[0] + 0.587 * r[1] + 0.114 * r[2]) * r[3] / 255 + (1 - r[3]) * e : 0;
}
function mse() {
  return ga([
    Math.round(Math.random() * 255),
    Math.round(Math.random() * 255),
    Math.round(Math.random() * 255)
  ], "rgb");
}
var Cg = new Os(100);
function Ch(t) {
  if (Q(t)) {
    var e = Cg.get(t);
    return e || (e = xh(t, -0.1), Cg.put(t, e)), e;
  } else if (As(t)) {
    var r = H({}, t);
    return r.colorStops = J(t.colorStops, function(n) {
      return {
        offset: n.offset,
        color: xh(n.color, -0.1)
      };
    }), r;
  }
  return t;
}
const wse = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fastLerp: t9,
  fastMapToColor: hse,
  lerp: Hv,
  lift: xh,
  liftColor: Ch,
  lum: Kl,
  mapToColor: vse,
  modifyAlpha: gse,
  modifyHSL: pse,
  parse: Jt,
  random: mse,
  stringify: ga,
  toHex: fse
}, Symbol.toStringTag, { value: "Module" }));
function yse(t) {
  return t.type === "linear";
}
function bse(t) {
  return t.type === "radial";
}
(function() {
  return ue.hasGlobalWindow && ie(window.btoa) ? function(t) {
    return window.btoa(unescape(encodeURIComponent(t)));
  } : typeof Buffer < "u" ? function(t) {
    return Buffer.from(t).toString("base64");
  } : function(t) {
    return process.env.NODE_ENV !== "production" && mn("Base64 isn't natively supported in the current environment."), null;
  };
})();
var Eh = Array.prototype.slice;
function hn(t, e, r) {
  return (e - t) * r + t;
}
function q5(t, e, r, n) {
  for (var a = e.length, o = 0; o < a; o++)
    t[o] = hn(e[o], r[o], n);
  return t;
}
function _se(t, e, r, n) {
  for (var a = e.length, o = a && e[0].length, i = 0; i < a; i++) {
    t[i] || (t[i] = []);
    for (var l = 0; l < o; l++)
      t[i][l] = hn(e[i][l], r[i][l], n);
  }
  return t;
}
function fc(t, e, r, n) {
  for (var a = e.length, o = 0; o < a; o++)
    t[o] = e[o] + r[o] * n;
  return t;
}
function Eg(t, e, r, n) {
  for (var a = e.length, o = a && e[0].length, i = 0; i < a; i++) {
    t[i] || (t[i] = []);
    for (var l = 0; l < o; l++)
      t[i][l] = e[i][l] + r[i][l] * n;
  }
  return t;
}
function xse(t, e) {
  for (var r = t.length, n = e.length, a = r > n ? e : t, o = Math.min(r, n), i = a[o - 1] || { color: [0, 0, 0, 0], offset: 0 }, l = o; l < Math.max(r, n); l++)
    a.push({
      offset: i.offset,
      color: i.color.slice()
    });
}
function Cse(t, e, r) {
  var n = t, a = e;
  if (!(!n.push || !a.push)) {
    var o = n.length, i = a.length;
    if (o !== i) {
      var l = o > i;
      if (l)
        n.length = i;
      else
        for (var c = o; c < i; c++)
          n.push(r === 1 ? a[c] : Eh.call(a[c]));
    }
    for (var u = n[0] && n[0].length, c = 0; c < n.length; c++)
      if (r === 1)
        isNaN(n[c]) && (n[c] = a[c]);
      else
        for (var d = 0; d < u; d++)
          isNaN(n[c][d]) && (n[c][d] = a[c][d]);
  }
}
function v0(t) {
  if (Lt(t)) {
    var e = t.length;
    if (Lt(t[0])) {
      for (var r = [], n = 0; n < e; n++)
        r.push(Eh.call(t[n]));
      return r;
    }
    return Eh.call(t);
  }
  return t;
}
function p0(t) {
  return t[0] = Math.floor(t[0]) || 0, t[1] = Math.floor(t[1]) || 0, t[2] = Math.floor(t[2]) || 0, t[3] = t[3] == null ? 1 : t[3], "rgba(" + t.join(",") + ")";
}
function Ese(t) {
  return Lt(t && t[0]) ? 2 : 1;
}
var hc = 0, g0 = 1, r9 = 2, El = 3, Sh = 4, Rh = 5, Sg = 6;
function Rg(t) {
  return t === Sh || t === Rh;
}
function vc(t) {
  return t === g0 || t === r9;
}
var rl = [0, 0, 0, 0], Sse = function() {
  function t(e) {
    this.keyframes = [], this.discrete = !1, this._invalid = !1, this._needsSort = !1, this._lastFr = 0, this._lastFrP = 0, this.propName = e;
  }
  return t.prototype.isFinished = function() {
    return this._finished;
  }, t.prototype.setFinished = function() {
    this._finished = !0, this._additiveTrack && this._additiveTrack.setFinished();
  }, t.prototype.needsAnimate = function() {
    return this.keyframes.length >= 1;
  }, t.prototype.getAdditiveTrack = function() {
    return this._additiveTrack;
  }, t.prototype.addKeyframe = function(e, r, n) {
    this._needsSort = !0;
    var a = this.keyframes, o = a.length, i = !1, l = Sg, c = r;
    if (Lt(r)) {
      var u = Ese(r);
      l = u, (u === 1 && !De(r[0]) || u === 2 && !De(r[0][0])) && (i = !0);
    } else if (De(r) && !_i(r))
      l = hc;
    else if (Q(r))
      if (!isNaN(+r))
        l = hc;
      else {
        var d = Jt(r);
        d && (c = d, l = El);
      }
    else if (As(r)) {
      var f = H({}, c);
      f.colorStops = J(r.colorStops, function(v) {
        return {
          offset: v.offset,
          color: Jt(v.color)
        };
      }), yse(r) ? l = Sh : bse(r) && (l = Rh), c = f;
    }
    o === 0 ? this.valType = l : (l !== this.valType || l === Sg) && (i = !0), this.discrete = this.discrete || i;
    var h = {
      time: e,
      value: c,
      rawValue: r,
      percent: 0
    };
    return n && (h.easing = n, h.easingFunc = ie(n) ? n : Il[n] || Qb(n)), a.push(h), h;
  }, t.prototype.prepare = function(e, r) {
    var n = this.keyframes;
    this._needsSort && n.sort(function(g, m) {
      return g.time - m.time;
    });
    for (var a = this.valType, o = n.length, i = n[o - 1], l = this.discrete, c = vc(a), u = Rg(a), d = 0; d < o; d++) {
      var f = n[d], h = f.value, v = i.value;
      f.percent = f.time / e, l || (c && d !== o - 1 ? Cse(h, v, a) : u && xse(h.colorStops, v.colorStops));
    }
    if (!l && a !== Rh && r && this.needsAnimate() && r.needsAnimate() && a === r.valType && !r._finished) {
      this._additiveTrack = r;
      for (var p = n[0].value, d = 0; d < o; d++)
        a === hc ? n[d].additiveValue = n[d].value - p : a === El ? n[d].additiveValue = fc([], n[d].value, p, -1) : vc(a) && (n[d].additiveValue = a === g0 ? fc([], n[d].value, p, -1) : Eg([], n[d].value, p, -1));
    }
  }, t.prototype.step = function(e, r) {
    if (!this._finished) {
      this._additiveTrack && this._additiveTrack._finished && (this._additiveTrack = null);
      var n = this._additiveTrack != null, a = n ? "additiveValue" : "value", o = this.valType, i = this.keyframes, l = i.length, c = this.propName, u = o === El, d, f = this._lastFr, h = Math.min, v, p;
      if (l === 1)
        v = p = i[0];
      else {
        if (r < 0)
          d = 0;
        else if (r < this._lastFrP) {
          var g = h(f + 1, l - 1);
          for (d = g; d >= 0 && !(i[d].percent <= r); d--)
            ;
          d = h(d, l - 2);
        } else {
          for (d = f; d < l && !(i[d].percent > r); d++)
            ;
          d = h(d - 1, l - 2);
        }
        p = i[d + 1], v = i[d];
      }
      if (v && p) {
        this._lastFr = d, this._lastFrP = r;
        var m = p.percent - v.percent, w = m === 0 ? 1 : h((r - v.percent) / m, 1);
        p.easingFunc && (w = p.easingFunc(w));
        var y = n ? this._additiveValue : u ? rl : e[c];
        if ((vc(o) || u) && !y && (y = this._additiveValue = []), this.discrete)
          e[c] = w < 1 ? v.rawValue : p.rawValue;
        else if (vc(o))
          o === g0 ? q5(y, v[a], p[a], w) : _se(y, v[a], p[a], w);
        else if (Rg(o)) {
          var b = v[a], _ = p[a], x = o === Sh;
          e[c] = {
            type: x ? "linear" : "radial",
            x: hn(b.x, _.x, w),
            y: hn(b.y, _.y, w),
            colorStops: J(b.colorStops, function(S, M) {
              var R = _.colorStops[M];
              return {
                offset: hn(S.offset, R.offset, w),
                color: p0(q5([], S.color, R.color, w))
              };
            }),
            global: _.global
          }, x ? (e[c].x2 = hn(b.x2, _.x2, w), e[c].y2 = hn(b.y2, _.y2, w)) : e[c].r = hn(b.r, _.r, w);
        } else if (u)
          q5(y, v[a], p[a], w), n || (e[c] = p0(y));
        else {
          var E = hn(v[a], p[a], w);
          n ? this._additiveValue = E : e[c] = E;
        }
        n && this._addToTarget(e);
      }
    }
  }, t.prototype._addToTarget = function(e) {
    var r = this.valType, n = this.propName, a = this._additiveValue;
    r === hc ? e[n] = e[n] + a : r === El ? (Jt(e[n], rl), fc(rl, rl, a, 1), e[n] = p0(rl)) : r === g0 ? fc(e[n], e[n], a, 1) : r === r9 && Eg(e[n], e[n], a, 1);
  }, t;
}(), jv = function() {
  function t(e, r, n, a) {
    if (this._tracks = {}, this._trackKeys = [], this._maxTime = 0, this._started = 0, this._clip = null, this._target = e, this._loop = r, r && a) {
      mn("Can' use additive animation on looped animation.");
      return;
    }
    this._additiveAnimators = a, this._allowDiscrete = n;
  }
  return t.prototype.getMaxTime = function() {
    return this._maxTime;
  }, t.prototype.getDelay = function() {
    return this._delay;
  }, t.prototype.getLoop = function() {
    return this._loop;
  }, t.prototype.getTarget = function() {
    return this._target;
  }, t.prototype.changeTarget = function(e) {
    this._target = e;
  }, t.prototype.when = function(e, r, n) {
    return this.whenWithKeys(e, r, Ze(r), n);
  }, t.prototype.whenWithKeys = function(e, r, n, a) {
    for (var o = this._tracks, i = 0; i < n.length; i++) {
      var l = n[i], c = o[l];
      if (!c) {
        c = o[l] = new Sse(l);
        var u = void 0, d = this._getAdditiveTrack(l);
        if (d) {
          var f = d.keyframes, h = f[f.length - 1];
          u = h && h.value, d.valType === El && u && (u = p0(u));
        } else
          u = this._target[l];
        if (u == null)
          continue;
        e > 0 && c.addKeyframe(0, v0(u), a), this._trackKeys.push(l);
      }
      c.addKeyframe(e, v0(r[l]), a);
    }
    return this._maxTime = Math.max(this._maxTime, e), this;
  }, t.prototype.pause = function() {
    this._clip.pause(), this._paused = !0;
  }, t.prototype.resume = function() {
    this._clip.resume(), this._paused = !1;
  }, t.prototype.isPaused = function() {
    return !!this._paused;
  }, t.prototype.duration = function(e) {
    return this._maxTime = e, this._force = !0, this;
  }, t.prototype._doneCallback = function() {
    this._setTracksFinished(), this._clip = null;
    var e = this._doneCbs;
    if (e)
      for (var r = e.length, n = 0; n < r; n++)
        e[n].call(this);
  }, t.prototype._abortedCallback = function() {
    this._setTracksFinished();
    var e = this.animation, r = this._abortedCbs;
    if (e && e.removeClip(this._clip), this._clip = null, r)
      for (var n = 0; n < r.length; n++)
        r[n].call(this);
  }, t.prototype._setTracksFinished = function() {
    for (var e = this._tracks, r = this._trackKeys, n = 0; n < r.length; n++)
      e[r[n]].setFinished();
  }, t.prototype._getAdditiveTrack = function(e) {
    var r, n = this._additiveAnimators;
    if (n)
      for (var a = 0; a < n.length; a++) {
        var o = n[a].getTrack(e);
        o && (r = o);
      }
    return r;
  }, t.prototype.start = function(e) {
    if (!(this._started > 0)) {
      this._started = 1;
      for (var r = this, n = [], a = this._maxTime || 0, o = 0; o < this._trackKeys.length; o++) {
        var i = this._trackKeys[o], l = this._tracks[i], c = this._getAdditiveTrack(i), u = l.keyframes, d = u.length;
        if (l.prepare(a, c), l.needsAnimate())
          if (!this._allowDiscrete && l.discrete) {
            var f = u[d - 1];
            f && (r._target[l.propName] = f.rawValue), l.setFinished();
          } else
            n.push(l);
      }
      if (n.length || this._force) {
        var h = new sse({
          life: a,
          loop: this._loop,
          delay: this._delay || 0,
          onframe: function(v) {
            r._started = 2;
            var p = r._additiveAnimators;
            if (p) {
              for (var g = !1, m = 0; m < p.length; m++)
                if (p[m]._clip) {
                  g = !0;
                  break;
                }
              g || (r._additiveAnimators = null);
            }
            for (var m = 0; m < n.length; m++)
              n[m].step(r._target, v);
            var w = r._onframeCbs;
            if (w)
              for (var m = 0; m < w.length; m++)
                w[m](r._target, v);
          },
          ondestroy: function() {
            r._doneCallback();
          }
        });
        this._clip = h, this.animation && this.animation.addClip(h), e && h.setEasing(e);
      } else
        this._doneCallback();
      return this;
    }
  }, t.prototype.stop = function(e) {
    if (this._clip) {
      var r = this._clip;
      e && r.onframe(1), this._abortedCallback();
    }
  }, t.prototype.delay = function(e) {
    return this._delay = e, this;
  }, t.prototype.during = function(e) {
    return e && (this._onframeCbs || (this._onframeCbs = []), this._onframeCbs.push(e)), this;
  }, t.prototype.done = function(e) {
    return e && (this._doneCbs || (this._doneCbs = []), this._doneCbs.push(e)), this;
  }, t.prototype.aborted = function(e) {
    return e && (this._abortedCbs || (this._abortedCbs = []), this._abortedCbs.push(e)), this;
  }, t.prototype.getClip = function() {
    return this._clip;
  }, t.prototype.getTrack = function(e) {
    return this._tracks[e];
  }, t.prototype.getTracks = function() {
    var e = this;
    return J(this._trackKeys, function(r) {
      return e._tracks[r];
    });
  }, t.prototype.stopTracks = function(e, r) {
    if (!e.length || !this._clip)
      return !0;
    for (var n = this._tracks, a = this._trackKeys, o = 0; o < e.length; o++) {
      var i = n[e[o]];
      i && !i.isFinished() && (r ? i.step(this._target, 1) : this._started === 1 && i.step(this._target, 0), i.setFinished());
    }
    for (var l = !0, o = 0; o < a.length; o++)
      if (!n[a[o]].isFinished()) {
        l = !1;
        break;
      }
    return l && this._abortedCallback(), l;
  }, t.prototype.saveTo = function(e, r, n) {
    if (e) {
      r = r || this._trackKeys;
      for (var a = 0; a < r.length; a++) {
        var o = r[a], i = this._tracks[o];
        if (!(!i || i.isFinished())) {
          var l = i.keyframes, c = l[n ? 0 : l.length - 1];
          c && (e[o] = v0(c.rawValue));
        }
      }
    }
  }, t.prototype.__changeFinalValue = function(e, r) {
    r = r || Ze(e);
    for (var n = 0; n < r.length; n++) {
      var a = r[n], o = this._tracks[a];
      if (o) {
        var i = o.keyframes;
        if (i.length > 1) {
          var l = i.pop();
          o.addKeyframe(l.time, e[a]), o.prepare(this._maxTime, o.getAdditiveTrack());
        }
      }
    }
  }, t;
}();
function Qo() {
  return (/* @__PURE__ */ new Date()).getTime();
}
var Rse = function(t) {
  Be(e, t);
  function e(r) {
    var n = t.call(this) || this;
    return n._running = !1, n._time = 0, n._pausedTime = 0, n._pauseStart = 0, n._paused = !1, r = r || {}, n.stage = r.stage || {}, n;
  }
  return e.prototype.addClip = function(r) {
    r.animation && this.removeClip(r), this._head ? (this._tail.next = r, r.prev = this._tail, r.next = null, this._tail = r) : this._head = this._tail = r, r.animation = this;
  }, e.prototype.addAnimator = function(r) {
    r.animation = this;
    var n = r.getClip();
    n && this.addClip(n);
  }, e.prototype.removeClip = function(r) {
    if (r.animation) {
      var n = r.prev, a = r.next;
      n ? n.next = a : this._head = a, a ? a.prev = n : this._tail = n, r.next = r.prev = r.animation = null;
    }
  }, e.prototype.removeAnimator = function(r) {
    var n = r.getClip();
    n && this.removeClip(n), r.animation = null;
  }, e.prototype.update = function(r) {
    for (var n = Qo() - this._pausedTime, a = n - this._time, o = this._head; o; ) {
      var i = o.next, l = o.step(n, a);
      l && (o.ondestroy(), this.removeClip(o)), o = i;
    }
    this._time = n, r || (this.trigger("frame", a), this.stage.update && this.stage.update());
  }, e.prototype._startLoop = function() {
    var r = this;
    this._running = !0;
    function n() {
      r._running && (W0(n), !r._paused && r.update());
    }
    W0(n);
  }, e.prototype.start = function() {
    this._running || (this._time = Qo(), this._pausedTime = 0, this._startLoop());
  }, e.prototype.stop = function() {
    this._running = !1;
  }, e.prototype.pause = function() {
    this._paused || (this._pauseStart = Qo(), this._paused = !0);
  }, e.prototype.resume = function() {
    this._paused && (this._pausedTime += Qo() - this._pauseStart, this._paused = !1);
  }, e.prototype.clear = function() {
    for (var r = this._head; r; ) {
      var n = r.next;
      r.prev = r.next = r.animation = null, r = n;
    }
    this._head = this._tail = null;
  }, e.prototype.isFinished = function() {
    return this._head == null;
  }, e.prototype.animate = function(r, n) {
    n = n || {}, this.start();
    var a = new jv(r, n.loop);
    return this.addAnimator(a), a;
  }, e;
}(Vr), Mse = 300, K5 = ue.domSupported, Q5 = function() {
  var t = [
    "click",
    "dblclick",
    "mousewheel",
    "wheel",
    "mouseout",
    "mouseup",
    "mousedown",
    "mousemove",
    "contextmenu"
  ], e = [
    "touchstart",
    "touchend",
    "touchmove"
  ], r = {
    pointerdown: 1,
    pointerup: 1,
    pointermove: 1,
    pointerout: 1
  }, n = J(t, function(a) {
    var o = a.replace("mouse", "pointer");
    return r.hasOwnProperty(o) ? o : a;
  });
  return {
    mouse: t,
    touch: e,
    pointer: n
  };
}(), Mg = {
  mouse: ["mousemove", "mouseup"],
  pointer: ["pointermove", "pointerup"]
}, Ag = !1;
function Mh(t) {
  var e = t.pointerType;
  return e === "pen" || e === "touch";
}
function Ase(t) {
  t.touching = !0, t.touchTimer != null && (clearTimeout(t.touchTimer), t.touchTimer = null), t.touchTimer = setTimeout(function() {
    t.touching = !1, t.touchTimer = null;
  }, 700);
}
function J5(t) {
  t && (t.zrByTouch = !0);
}
function kse(t, e) {
  return sr(t.dom, new Lse(t, e), !0);
}
function n9(t, e) {
  for (var r = e, n = !1; r && r.nodeType !== 9 && !(n = r.domBelongToZr || r !== e && r === t.painterRoot); )
    r = r.parentNode;
  return n;
}
var Lse = /* @__PURE__ */ function() {
  function t(e, r) {
    this.stopPropagation = mt, this.stopImmediatePropagation = mt, this.preventDefault = mt, this.type = r.type, this.target = this.currentTarget = e.dom, this.pointerType = r.pointerType, this.clientX = r.clientX, this.clientY = r.clientY;
  }
  return t;
}(), Lr = {
  mousedown: function(t) {
    t = sr(this.dom, t), this.__mayPointerCapture = [t.zrX, t.zrY], this.trigger("mousedown", t);
  },
  mousemove: function(t) {
    t = sr(this.dom, t);
    var e = this.__mayPointerCapture;
    e && (t.zrX !== e[0] || t.zrY !== e[1]) && this.__togglePointerCapture(!0), this.trigger("mousemove", t);
  },
  mouseup: function(t) {
    t = sr(this.dom, t), this.__togglePointerCapture(!1), this.trigger("mouseup", t);
  },
  mouseout: function(t) {
    t = sr(this.dom, t);
    var e = t.toElement || t.relatedTarget;
    n9(this, e) || (this.__pointerCapturing && (t.zrEventControl = "no_globalout"), this.trigger("mouseout", t));
  },
  wheel: function(t) {
    Ag = !0, t = sr(this.dom, t), this.trigger("mousewheel", t);
  },
  mousewheel: function(t) {
    Ag || (t = sr(this.dom, t), this.trigger("mousewheel", t));
  },
  touchstart: function(t) {
    t = sr(this.dom, t), J5(t), this.__lastTouchMoment = /* @__PURE__ */ new Date(), this.handler.processGesture(t, "start"), Lr.mousemove.call(this, t), Lr.mousedown.call(this, t);
  },
  touchmove: function(t) {
    t = sr(this.dom, t), J5(t), this.handler.processGesture(t, "change"), Lr.mousemove.call(this, t);
  },
  touchend: function(t) {
    t = sr(this.dom, t), J5(t), this.handler.processGesture(t, "end"), Lr.mouseup.call(this, t), +/* @__PURE__ */ new Date() - +this.__lastTouchMoment < Mse && Lr.click.call(this, t);
  },
  pointerdown: function(t) {
    Lr.mousedown.call(this, t);
  },
  pointermove: function(t) {
    Mh(t) || Lr.mousemove.call(this, t);
  },
  pointerup: function(t) {
    Lr.mouseup.call(this, t);
  },
  pointerout: function(t) {
    Mh(t) || Lr.mouseout.call(this, t);
  }
};
I(["click", "dblclick", "contextmenu"], function(t) {
  Lr[t] = function(e) {
    e = sr(this.dom, e), this.trigger(t, e);
  };
});
var Ah = {
  pointermove: function(t) {
    Mh(t) || Ah.mousemove.call(this, t);
  },
  pointerup: function(t) {
    Ah.mouseup.call(this, t);
  },
  mousemove: function(t) {
    this.trigger("mousemove", t);
  },
  mouseup: function(t) {
    var e = this.__pointerCapturing;
    this.__togglePointerCapture(!1), this.trigger("mouseup", t), e && (t.zrEventControl = "only_globalout", this.trigger("mouseout", t));
  }
};
function Tse(t, e) {
  var r = e.domHandlers;
  ue.pointerEventsSupported ? I(Q5.pointer, function(n) {
    m0(e, n, function(a) {
      r[n].call(t, a);
    });
  }) : (ue.touchEventsSupported && I(Q5.touch, function(n) {
    m0(e, n, function(a) {
      r[n].call(t, a), Ase(e);
    });
  }), I(Q5.mouse, function(n) {
    m0(e, n, function(a) {
      a = Vv(a), e.touching || r[n].call(t, a);
    });
  }));
}
function Ose(t, e) {
  ue.pointerEventsSupported ? I(Mg.pointer, r) : ue.touchEventsSupported || I(Mg.mouse, r);
  function r(n) {
    function a(o) {
      o = Vv(o), n9(t, o.target) || (o = kse(t, o), e.domHandlers[n].call(t, o));
    }
    m0(e, n, a, { capture: !0 });
  }
}
function m0(t, e, r, n) {
  t.mounted[e] = r, t.listenerOpts[e] = n, Zle(t.domTarget, e, r, n);
}
function ed(t) {
  var e = t.mounted;
  for (var r in e)
    e.hasOwnProperty(r) && Hle(t.domTarget, r, e[r], t.listenerOpts[r]);
  t.mounted = {};
}
var kg = /* @__PURE__ */ function() {
  function t(e, r) {
    this.mounted = {}, this.listenerOpts = {}, this.touching = !1, this.domTarget = e, this.domHandlers = r;
  }
  return t;
}(), Ise = function(t) {
  Be(e, t);
  function e(r, n) {
    var a = t.call(this) || this;
    return a.__pointerCapturing = !1, a.dom = r, a.painterRoot = n, a._localHandlerScope = new kg(r, Lr), K5 && (a._globalHandlerScope = new kg(document, Ah)), Tse(a, a._localHandlerScope), a;
  }
  return e.prototype.dispose = function() {
    ed(this._localHandlerScope), K5 && ed(this._globalHandlerScope);
  }, e.prototype.setCursor = function(r) {
    this.dom.style && (this.dom.style.cursor = r || "default");
  }, e.prototype.__togglePointerCapture = function(r) {
    if (this.__mayPointerCapture = null, K5 && +this.__pointerCapturing ^ +r) {
      this.__pointerCapturing = r;
      var n = this._globalHandlerScope;
      r ? Ose(this, n) : ed(n);
    }
  }, e;
}(Vr), a9 = 1;
ue.hasGlobalWindow && (a9 = Math.max(window.devicePixelRatio || window.screen && window.screen.deviceXDPI / window.screen.logicalXDPI || 1, 1));
var X0 = a9, kh = 0.4, Lh = "#333", Th = "#ccc", Pse = "#eee", Lg = Ls, Tg = 5e-5;
function Sa(t) {
  return t > Tg || t < -Tg;
}
var Ra = [], To = [], td = ta(), rd = Math.abs, Wv = function() {
  function t() {
  }
  return t.prototype.getLocalTransform = function(e) {
    return t.getLocalTransform(this, e);
  }, t.prototype.setPosition = function(e) {
    this.x = e[0], this.y = e[1];
  }, t.prototype.setScale = function(e) {
    this.scaleX = e[0], this.scaleY = e[1];
  }, t.prototype.setSkew = function(e) {
    this.skewX = e[0], this.skewY = e[1];
  }, t.prototype.setOrigin = function(e) {
    this.originX = e[0], this.originY = e[1];
  }, t.prototype.needLocalTransform = function() {
    return Sa(this.rotation) || Sa(this.x) || Sa(this.y) || Sa(this.scaleX - 1) || Sa(this.scaleY - 1) || Sa(this.skewX) || Sa(this.skewY);
  }, t.prototype.updateTransform = function() {
    var e = this.parent && this.parent.transform, r = this.needLocalTransform(), n = this.transform;
    if (!(r || e)) {
      n && (Lg(n), this.invTransform = null);
      return;
    }
    n = n || ta(), r ? this.getLocalTransform(n) : Lg(n), e && (r ? ra(n, e, n) : Zv(n, e)), this.transform = n, this._resolveGlobalScaleRatio(n);
  }, t.prototype._resolveGlobalScaleRatio = function(e) {
    var r = this.globalScaleRatio;
    if (r != null && r !== 1) {
      this.getGlobalScale(Ra);
      var n = Ra[0] < 0 ? -1 : 1, a = Ra[1] < 0 ? -1 : 1, o = ((Ra[0] - n) * r + n) / Ra[0] || 0, i = ((Ra[1] - a) * r + a) / Ra[1] || 0;
      e[0] *= o, e[1] *= o, e[2] *= i, e[3] *= i;
    }
    this.invTransform = this.invTransform || ta(), Ts(this.invTransform, e);
  }, t.prototype.getComputedTransform = function() {
    for (var e = this, r = []; e; )
      r.push(e), e = e.parent;
    for (; e = r.pop(); )
      e.updateTransform();
    return this.transform;
  }, t.prototype.setLocalTransform = function(e) {
    if (e) {
      var r = e[0] * e[0] + e[1] * e[1], n = e[2] * e[2] + e[3] * e[3], a = Math.atan2(e[1], e[0]), o = Math.PI / 2 + a - Math.atan2(e[3], e[2]);
      n = Math.sqrt(n) * Math.cos(o), r = Math.sqrt(r), this.skewX = o, this.skewY = 0, this.rotation = -a, this.x = +e[4], this.y = +e[5], this.scaleX = r, this.scaleY = n, this.originX = 0, this.originY = 0;
    }
  }, t.prototype.decomposeTransform = function() {
    if (this.transform) {
      var e = this.parent, r = this.transform;
      e && e.transform && (e.invTransform = e.invTransform || ta(), ra(To, e.invTransform, r), r = To);
      var n = this.originX, a = this.originY;
      (n || a) && (td[4] = n, td[5] = a, ra(To, r, td), To[4] -= n, To[5] -= a, r = To), this.setLocalTransform(r);
    }
  }, t.prototype.getGlobalScale = function(e) {
    var r = this.transform;
    return e = e || [], r ? (e[0] = Math.sqrt(r[0] * r[0] + r[1] * r[1]), e[1] = Math.sqrt(r[2] * r[2] + r[3] * r[3]), r[0] < 0 && (e[0] = -e[0]), r[3] < 0 && (e[1] = -e[1]), e) : (e[0] = 1, e[1] = 1, e);
  }, t.prototype.transformCoordToLocal = function(e, r) {
    var n = [e, r], a = this.invTransform;
    return a && At(n, n, a), n;
  }, t.prototype.transformCoordToGlobal = function(e, r) {
    var n = [e, r], a = this.transform;
    return a && At(n, n, a), n;
  }, t.prototype.getLineScale = function() {
    var e = this.transform;
    return e && rd(e[0] - 1) > 1e-10 && rd(e[3] - 1) > 1e-10 ? Math.sqrt(rd(e[0] * e[3] - e[2] * e[1])) : 1;
  }, t.prototype.copyTransform = function(e) {
    Dse(this, e);
  }, t.getLocalTransform = function(e, r) {
    r = r || [];
    var n = e.originX || 0, a = e.originY || 0, o = e.scaleX, i = e.scaleY, l = e.anchorX, c = e.anchorY, u = e.rotation || 0, d = e.x, f = e.y, h = e.skewX ? Math.tan(e.skewX) : 0, v = e.skewY ? Math.tan(-e.skewY) : 0;
    if (n || a || l || c) {
      var p = n + l, g = a + c;
      r[4] = -p * o - h * g * i, r[5] = -g * i - v * p * o;
    } else
      r[4] = r[5] = 0;
    return r[0] = o, r[3] = i, r[1] = v * o, r[2] = h * i, u && x1(r, r, u), r[4] += n + d, r[5] += a + f, r;
  }, t.initDefaultProps = function() {
    var e = t.prototype;
    e.scaleX = e.scaleY = e.globalScaleRatio = 1, e.x = e.y = e.originX = e.originY = e.skewX = e.skewY = e.rotation = e.anchorX = e.anchorY = 0;
  }(), t;
}(), Ql = [
  "x",
  "y",
  "originX",
  "originY",
  "anchorX",
  "anchorY",
  "rotation",
  "scaleX",
  "scaleY",
  "skewX",
  "skewY"
];
function Dse(t, e) {
  for (var r = 0; r < Ql.length; r++) {
    var n = Ql[r];
    t[n] = e[n];
  }
}
var Og = {};
function er(t, e) {
  e = e || ro;
  var r = Og[e];
  r || (r = Og[e] = new Os(500));
  var n = r.get(t);
  return n == null && (n = xn.measureText(t, e).width, r.put(t, n)), n;
}
function Ig(t, e, r, n) {
  var a = er(t, e), o = Gv(e), i = Sl(0, a, r), l = qo(0, o, n), c = new Le(i, l, a, o);
  return c;
}
function zv(t, e, r, n) {
  var a = ((t || "") + "").split(`
`), o = a.length;
  if (o === 1)
    return Ig(a[0], e, r, n);
  for (var i = new Le(0, 0, 0, 0), l = 0; l < a.length; l++) {
    var c = Ig(a[l], e, r, n);
    l === 0 ? i.copy(c) : i.union(c);
  }
  return i;
}
function Sl(t, e, r) {
  return r === "right" ? t -= e : r === "center" && (t -= e / 2), t;
}
function qo(t, e, r) {
  return r === "middle" ? t -= e / 2 : r === "bottom" && (t -= e), t;
}
function Gv(t) {
  return er("国", t);
}
function ca(t, e) {
  return typeof t == "string" ? t.lastIndexOf("%") >= 0 ? parseFloat(t) / 100 * e : parseFloat(t) : t;
}
function q0(t, e, r) {
  var n = e.position || "inside", a = e.distance != null ? e.distance : 5, o = r.height, i = r.width, l = o / 2, c = r.x, u = r.y, d = "left", f = "top";
  if (n instanceof Array)
    c += ca(n[0], r.width), u += ca(n[1], r.height), d = null, f = null;
  else
    switch (n) {
      case "left":
        c -= a, u += l, d = "right", f = "middle";
        break;
      case "right":
        c += a + i, u += l, f = "middle";
        break;
      case "top":
        c += i / 2, u -= a, d = "center", f = "bottom";
        break;
      case "bottom":
        c += i / 2, u += o + a, d = "center";
        break;
      case "inside":
        c += i / 2, u += l, d = "center", f = "middle";
        break;
      case "insideLeft":
        c += a, u += l, f = "middle";
        break;
      case "insideRight":
        c += i - a, u += l, d = "right", f = "middle";
        break;
      case "insideTop":
        c += i / 2, u += a, d = "center";
        break;
      case "insideBottom":
        c += i / 2, u += o - a, d = "center", f = "bottom";
        break;
      case "insideTopLeft":
        c += a, u += a;
        break;
      case "insideTopRight":
        c += i - a, u += a, d = "right";
        break;
      case "insideBottomLeft":
        c += a, u += o - a, f = "bottom";
        break;
      case "insideBottomRight":
        c += i - a, u += o - a, d = "right", f = "bottom";
        break;
    }
  return t = t || {}, t.x = c, t.y = u, t.align = d, t.verticalAlign = f, t;
}
var nd = "__zr_normal__", ad = Ql.concat(["ignore"]), Nse = tn(Ql, function(t, e) {
  return t[e] = !0, t;
}, { ignore: !1 }), Oo = {}, Bse = new Le(0, 0, 0, 0), C1 = function() {
  function t(e) {
    this.id = Iv(), this.animators = [], this.currentStates = [], this.states = {}, this._init(e);
  }
  return t.prototype._init = function(e) {
    this.attr(e);
  }, t.prototype.drift = function(e, r, n) {
    switch (this.draggable) {
      case "horizontal":
        r = 0;
        break;
      case "vertical":
        e = 0;
        break;
    }
    var a = this.transform;
    a || (a = this.transform = [1, 0, 0, 1, 0, 0]), a[4] += e, a[5] += r, this.decomposeTransform(), this.markRedraw();
  }, t.prototype.beforeUpdate = function() {
  }, t.prototype.afterUpdate = function() {
  }, t.prototype.update = function() {
    this.updateTransform(), this.__dirty && this.updateInnerText();
  }, t.prototype.updateInnerText = function(e) {
    var r = this._textContent;
    if (r && (!r.ignore || e)) {
      this.textConfig || (this.textConfig = {});
      var n = this.textConfig, a = n.local, o = r.innerTransformable, i = void 0, l = void 0, c = !1;
      o.parent = a ? this : null;
      var u = !1;
      if (o.copyTransform(r), n.position != null) {
        var d = Bse;
        n.layoutRect ? d.copy(n.layoutRect) : d.copy(this.getBoundingRect()), a || d.applyTransform(this.transform), this.calculateTextPosition ? this.calculateTextPosition(Oo, n, d) : q0(Oo, n, d), o.x = Oo.x, o.y = Oo.y, i = Oo.align, l = Oo.verticalAlign;
        var f = n.origin;
        if (f && n.rotation != null) {
          var h = void 0, v = void 0;
          f === "center" ? (h = d.width * 0.5, v = d.height * 0.5) : (h = ca(f[0], d.width), v = ca(f[1], d.height)), u = !0, o.originX = -o.x + h + (a ? 0 : d.x), o.originY = -o.y + v + (a ? 0 : d.y);
        }
      }
      n.rotation != null && (o.rotation = n.rotation);
      var p = n.offset;
      p && (o.x += p[0], o.y += p[1], u || (o.originX = -p[0], o.originY = -p[1]));
      var g = n.inside == null ? typeof n.position == "string" && n.position.indexOf("inside") >= 0 : n.inside, m = this._innerTextDefaultStyle || (this._innerTextDefaultStyle = {}), w = void 0, y = void 0, b = void 0;
      g && this.canBeInsideText() ? (w = n.insideFill, y = n.insideStroke, (w == null || w === "auto") && (w = this.getInsideTextFill()), (y == null || y === "auto") && (y = this.getInsideTextStroke(w), b = !0)) : (w = n.outsideFill, y = n.outsideStroke, (w == null || w === "auto") && (w = this.getOutsideFill()), (y == null || y === "auto") && (y = this.getOutsideStroke(w), b = !0)), w = w || "#000", (w !== m.fill || y !== m.stroke || b !== m.autoStroke || i !== m.align || l !== m.verticalAlign) && (c = !0, m.fill = w, m.stroke = y, m.autoStroke = b, m.align = i, m.verticalAlign = l, r.setDefaultTextStyle(m)), r.__dirty |= qt, c && r.dirtyStyle(!0);
    }
  }, t.prototype.canBeInsideText = function() {
    return !0;
  }, t.prototype.getInsideTextFill = function() {
    return "#fff";
  }, t.prototype.getInsideTextStroke = function(e) {
    return "#000";
  }, t.prototype.getOutsideFill = function() {
    return this.__zr && this.__zr.isDarkMode() ? Th : Lh;
  }, t.prototype.getOutsideStroke = function(e) {
    var r = this.__zr && this.__zr.getBackgroundColor(), n = typeof r == "string" && Jt(r);
    n || (n = [255, 255, 255, 1]);
    for (var a = n[3], o = this.__zr.isDarkMode(), i = 0; i < 3; i++)
      n[i] = n[i] * a + (o ? 0 : 255) * (1 - a);
    return n[3] = 1, ga(n, "rgba");
  }, t.prototype.traverse = function(e, r) {
  }, t.prototype.attrKV = function(e, r) {
    e === "textConfig" ? this.setTextConfig(r) : e === "textContent" ? this.setTextContent(r) : e === "clipPath" ? this.setClipPath(r) : e === "extra" ? (this.extra = this.extra || {}, H(this.extra, r)) : this[e] = r;
  }, t.prototype.hide = function() {
    this.ignore = !0, this.markRedraw();
  }, t.prototype.show = function() {
    this.ignore = !1, this.markRedraw();
  }, t.prototype.attr = function(e, r) {
    if (typeof e == "string")
      this.attrKV(e, r);
    else if (re(e))
      for (var n = e, a = Ze(n), o = 0; o < a.length; o++) {
        var i = a[o];
        this.attrKV(i, e[i]);
      }
    return this.markRedraw(), this;
  }, t.prototype.saveCurrentToNormalState = function(e) {
    this._innerSaveToNormal(e);
    for (var r = this._normalState, n = 0; n < this.animators.length; n++) {
      var a = this.animators[n], o = a.__fromStateTransition;
      if (!(a.getLoop() || o && o !== nd)) {
        var i = a.targetName, l = i ? r[i] : r;
        a.saveTo(l);
      }
    }
  }, t.prototype._innerSaveToNormal = function(e) {
    var r = this._normalState;
    r || (r = this._normalState = {}), e.textConfig && !r.textConfig && (r.textConfig = this.textConfig), this._savePrimaryToNormal(e, r, ad);
  }, t.prototype._savePrimaryToNormal = function(e, r, n) {
    for (var a = 0; a < n.length; a++) {
      var o = n[a];
      e[o] != null && !(o in r) && (r[o] = this[o]);
    }
  }, t.prototype.hasState = function() {
    return this.currentStates.length > 0;
  }, t.prototype.getState = function(e) {
    return this.states[e];
  }, t.prototype.ensureState = function(e) {
    var r = this.states;
    return r[e] || (r[e] = {}), r[e];
  }, t.prototype.clearStates = function(e) {
    this.useState(nd, !1, e);
  }, t.prototype.useState = function(e, r, n, a) {
    var o = e === nd, i = this.hasState();
    if (!(!i && o)) {
      var l = this.currentStates, c = this.stateTransition;
      if (!(Re(l, e) >= 0 && (r || l.length === 1))) {
        var u;
        if (this.stateProxy && !o && (u = this.stateProxy(e)), u || (u = this.states && this.states[e]), !u && !o) {
          mn("State " + e + " not exists.");
          return;
        }
        o || this.saveCurrentToNormalState(u);
        var d = !!(u && u.hoverLayer || a);
        d && this._toggleHoverLayerFlag(!0), this._applyStateObj(e, u, this._normalState, r, !n && !this.__inHover && c && c.duration > 0, c);
        var f = this._textContent, h = this._textGuide;
        return f && f.useState(e, r, n, d), h && h.useState(e, r, n, d), o ? (this.currentStates = [], this._normalState = {}) : r ? this.currentStates.push(e) : this.currentStates = [e], this._updateAnimationTargets(), this.markRedraw(), !d && this.__inHover && (this._toggleHoverLayerFlag(!1), this.__dirty &= ~qt), u;
      }
    }
  }, t.prototype.useStates = function(e, r, n) {
    if (!e.length)
      this.clearStates();
    else {
      var a = [], o = this.currentStates, i = e.length, l = i === o.length;
      if (l) {
        for (var c = 0; c < i; c++)
          if (e[c] !== o[c]) {
            l = !1;
            break;
          }
      }
      if (l)
        return;
      for (var c = 0; c < i; c++) {
        var u = e[c], d = void 0;
        this.stateProxy && (d = this.stateProxy(u, e)), d || (d = this.states[u]), d && a.push(d);
      }
      var f = a[i - 1], h = !!(f && f.hoverLayer || n);
      h && this._toggleHoverLayerFlag(!0);
      var v = this._mergeStates(a), p = this.stateTransition;
      this.saveCurrentToNormalState(v), this._applyStateObj(e.join(","), v, this._normalState, !1, !r && !this.__inHover && p && p.duration > 0, p);
      var g = this._textContent, m = this._textGuide;
      g && g.useStates(e, r, h), m && m.useStates(e, r, h), this._updateAnimationTargets(), this.currentStates = e.slice(), this.markRedraw(), !h && this.__inHover && (this._toggleHoverLayerFlag(!1), this.__dirty &= ~qt);
    }
  }, t.prototype.isSilent = function() {
    for (var e = this.silent, r = this.parent; !e && r; ) {
      if (r.silent) {
        e = !0;
        break;
      }
      r = r.parent;
    }
    return e;
  }, t.prototype._updateAnimationTargets = function() {
    for (var e = 0; e < this.animators.length; e++) {
      var r = this.animators[e];
      r.targetName && r.changeTarget(this[r.targetName]);
    }
  }, t.prototype.removeState = function(e) {
    var r = Re(this.currentStates, e);
    if (r >= 0) {
      var n = this.currentStates.slice();
      n.splice(r, 1), this.useStates(n);
    }
  }, t.prototype.replaceState = function(e, r, n) {
    var a = this.currentStates.slice(), o = Re(a, e), i = Re(a, r) >= 0;
    o >= 0 ? i ? a.splice(o, 1) : a[o] = r : n && !i && a.push(r), this.useStates(a);
  }, t.prototype.toggleState = function(e, r) {
    r ? this.useState(e, !0) : this.removeState(e);
  }, t.prototype._mergeStates = function(e) {
    for (var r = {}, n, a = 0; a < e.length; a++) {
      var o = e[a];
      H(r, o), o.textConfig && (n = n || {}, H(n, o.textConfig));
    }
    return n && (r.textConfig = n), r;
  }, t.prototype._applyStateObj = function(e, r, n, a, o, i) {
    var l = !(r && a);
    r && r.textConfig ? (this.textConfig = H({}, a ? this.textConfig : n.textConfig), H(this.textConfig, r.textConfig)) : l && n.textConfig && (this.textConfig = n.textConfig);
    for (var c = {}, u = !1, d = 0; d < ad.length; d++) {
      var f = ad[d], h = o && Nse[f];
      r && r[f] != null ? h ? (u = !0, c[f] = r[f]) : this[f] = r[f] : l && n[f] != null && (h ? (u = !0, c[f] = n[f]) : this[f] = n[f]);
    }
    if (!o)
      for (var d = 0; d < this.animators.length; d++) {
        var v = this.animators[d], p = v.targetName;
        v.getLoop() || v.__changeFinalValue(p ? (r || n)[p] : r || n);
      }
    u && this._transitionState(e, c, i);
  }, t.prototype._attachComponent = function(e) {
    if (e.__zr && !e.__hostTarget) {
      if (process.env.NODE_ENV !== "production")
        throw new Error("Text element has been added to zrender.");
      return;
    }
    if (e === this) {
      if (process.env.NODE_ENV !== "production")
        throw new Error("Recursive component attachment.");
      return;
    }
    var r = this.__zr;
    r && e.addSelfToZr(r), e.__zr = r, e.__hostTarget = this;
  }, t.prototype._detachComponent = function(e) {
    e.__zr && e.removeSelfFromZr(e.__zr), e.__zr = null, e.__hostTarget = null;
  }, t.prototype.getClipPath = function() {
    return this._clipPath;
  }, t.prototype.setClipPath = function(e) {
    this._clipPath && this._clipPath !== e && this.removeClipPath(), this._attachComponent(e), this._clipPath = e, this.markRedraw();
  }, t.prototype.removeClipPath = function() {
    var e = this._clipPath;
    e && (this._detachComponent(e), this._clipPath = null, this.markRedraw());
  }, t.prototype.getTextContent = function() {
    return this._textContent;
  }, t.prototype.setTextContent = function(e) {
    var r = this._textContent;
    if (r !== e) {
      if (r && r !== e && this.removeTextContent(), process.env.NODE_ENV !== "production" && e.__zr && !e.__hostTarget)
        throw new Error("Text element has been added to zrender.");
      e.innerTransformable = new Wv(), this._attachComponent(e), this._textContent = e, this.markRedraw();
    }
  }, t.prototype.setTextConfig = function(e) {
    this.textConfig || (this.textConfig = {}), H(this.textConfig, e), this.markRedraw();
  }, t.prototype.removeTextConfig = function() {
    this.textConfig = null, this.markRedraw();
  }, t.prototype.removeTextContent = function() {
    var e = this._textContent;
    e && (e.innerTransformable = null, this._detachComponent(e), this._textContent = null, this._innerTextDefaultStyle = null, this.markRedraw());
  }, t.prototype.getTextGuideLine = function() {
    return this._textGuide;
  }, t.prototype.setTextGuideLine = function(e) {
    this._textGuide && this._textGuide !== e && this.removeTextGuideLine(), this._attachComponent(e), this._textGuide = e, this.markRedraw();
  }, t.prototype.removeTextGuideLine = function() {
    var e = this._textGuide;
    e && (this._detachComponent(e), this._textGuide = null, this.markRedraw());
  }, t.prototype.markRedraw = function() {
    this.__dirty |= qt;
    var e = this.__zr;
    e && (this.__inHover ? e.refreshHover() : e.refresh()), this.__hostTarget && this.__hostTarget.markRedraw();
  }, t.prototype.dirty = function() {
    this.markRedraw();
  }, t.prototype._toggleHoverLayerFlag = function(e) {
    this.__inHover = e;
    var r = this._textContent, n = this._textGuide;
    r && (r.__inHover = e), n && (n.__inHover = e);
  }, t.prototype.addSelfToZr = function(e) {
    if (this.__zr !== e) {
      this.__zr = e;
      var r = this.animators;
      if (r)
        for (var n = 0; n < r.length; n++)
          e.animation.addAnimator(r[n]);
      this._clipPath && this._clipPath.addSelfToZr(e), this._textContent && this._textContent.addSelfToZr(e), this._textGuide && this._textGuide.addSelfToZr(e);
    }
  }, t.prototype.removeSelfFromZr = function(e) {
    if (this.__zr) {
      this.__zr = null;
      var r = this.animators;
      if (r)
        for (var n = 0; n < r.length; n++)
          e.animation.removeAnimator(r[n]);
      this._clipPath && this._clipPath.removeSelfFromZr(e), this._textContent && this._textContent.removeSelfFromZr(e), this._textGuide && this._textGuide.removeSelfFromZr(e);
    }
  }, t.prototype.animate = function(e, r, n) {
    var a = e ? this[e] : this;
    if (process.env.NODE_ENV !== "production" && !a) {
      mn('Property "' + e + '" is not existed in element ' + this.id);
      return;
    }
    var o = new jv(a, r, n);
    return e && (o.targetName = e), this.addAnimator(o, e), o;
  }, t.prototype.addAnimator = function(e, r) {
    var n = this.__zr, a = this;
    e.during(function() {
      a.updateDuringAnimation(r);
    }).done(function() {
      var o = a.animators, i = Re(o, e);
      i >= 0 && o.splice(i, 1);
    }), this.animators.push(e), n && n.animation.addAnimator(e), n && n.wakeUp();
  }, t.prototype.updateDuringAnimation = function(e) {
    this.markRedraw();
  }, t.prototype.stopAnimation = function(e, r) {
    for (var n = this.animators, a = n.length, o = [], i = 0; i < a; i++) {
      var l = n[i];
      !e || e === l.scope ? l.stop(r) : o.push(l);
    }
    return this.animators = o, this;
  }, t.prototype.animateTo = function(e, r, n) {
    od(this, e, r, n);
  }, t.prototype.animateFrom = function(e, r, n) {
    od(this, e, r, n, !0);
  }, t.prototype._transitionState = function(e, r, n, a) {
    for (var o = od(this, r, n, a), i = 0; i < o.length; i++)
      o[i].__fromStateTransition = e;
  }, t.prototype.getBoundingRect = function() {
    return null;
  }, t.prototype.getPaintRect = function() {
    return null;
  }, t.initDefaultProps = function() {
    var e = t.prototype;
    e.type = "element", e.name = "", e.ignore = e.silent = e.isGroup = e.draggable = e.dragging = e.ignoreClip = e.__inHover = !1, e.__dirty = qt;
    var r = {};
    function n(o, i, l) {
      r[o + i + l] || (console.warn("DEPRECATED: '" + o + "' has been deprecated. use '" + i + "', '" + l + "' instead"), r[o + i + l] = !0);
    }
    function a(o, i, l, c) {
      Object.defineProperty(e, o, {
        get: function() {
          if (process.env.NODE_ENV !== "production" && n(o, l, c), !this[i]) {
            var d = this[i] = [];
            u(this, d);
          }
          return this[i];
        },
        set: function(d) {
          process.env.NODE_ENV !== "production" && n(o, l, c), this[l] = d[0], this[c] = d[1], this[i] = d, u(this, d);
        }
      });
      function u(d, f) {
        Object.defineProperty(f, 0, {
          get: function() {
            return d[l];
          },
          set: function(h) {
            d[l] = h;
          }
        }), Object.defineProperty(f, 1, {
          get: function() {
            return d[c];
          },
          set: function(h) {
            d[c] = h;
          }
        });
      }
    }
    Object.defineProperty && (a("position", "_legacyPos", "x", "y"), a("scale", "_legacyScale", "scaleX", "scaleY"), a("origin", "_legacyOrigin", "originX", "originY"));
  }(), t;
}();
tr(C1, Vr);
tr(C1, Wv);
function od(t, e, r, n, a) {
  r = r || {};
  var o = [];
  o9(t, "", t, e, r, n, o, a);
  var i = o.length, l = !1, c = r.done, u = r.aborted, d = function() {
    l = !0, i--, i <= 0 && (l ? c && c() : u && u());
  }, f = function() {
    i--, i <= 0 && (l ? c && c() : u && u());
  };
  i || c && c(), o.length > 0 && r.during && o[0].during(function(p, g) {
    r.during(g);
  });
  for (var h = 0; h < o.length; h++) {
    var v = o[h];
    d && v.done(d), f && v.aborted(f), r.force && v.duration(r.duration), v.start(r.easing);
  }
  return o;
}
function id(t, e, r) {
  for (var n = 0; n < r; n++)
    t[n] = e[n];
}
function Fse(t) {
  return Lt(t[0]);
}
function $se(t, e, r) {
  if (Lt(e[r]))
    if (Lt(t[r]) || (t[r] = []), yt(e[r])) {
      var n = e[r].length;
      t[r].length !== n && (t[r] = new e[r].constructor(n), id(t[r], e[r], n));
    } else {
      var a = e[r], o = t[r], i = a.length;
      if (Fse(a))
        for (var l = a[0].length, c = 0; c < i; c++)
          o[c] ? id(o[c], a[c], l) : o[c] = Array.prototype.slice.call(a[c]);
      else
        id(o, a, i);
      o.length = a.length;
    }
  else
    t[r] = e[r];
}
function Vse(t, e) {
  return t === e || Lt(t) && Lt(e) && Zse(t, e);
}
function Zse(t, e) {
  var r = t.length;
  if (r !== e.length)
    return !1;
  for (var n = 0; n < r; n++)
    if (t[n] !== e[n])
      return !1;
  return !0;
}
function o9(t, e, r, n, a, o, i, l) {
  for (var c = Ze(n), u = a.duration, d = a.delay, f = a.additive, h = a.setToFinal, v = !re(o), p = t.animators, g = [], m = 0; m < c.length; m++) {
    var w = c[m], y = n[w];
    if (y != null && r[w] != null && (v || o[w]))
      if (re(y) && !Lt(y) && !As(y)) {
        if (e) {
          l || (r[w] = y, t.updateDuringAnimation(e));
          continue;
        }
        o9(t, w, r[w], y, a, o && o[w], i, l);
      } else
        g.push(w);
    else l || (r[w] = y, t.updateDuringAnimation(e), g.push(w));
  }
  var b = g.length;
  if (!f && b)
    for (var _ = 0; _ < p.length; _++) {
      var x = p[_];
      if (x.targetName === e) {
        var E = x.stopTracks(g);
        if (E) {
          var S = Re(p, x);
          p.splice(S, 1);
        }
      }
    }
  if (a.force || (g = ot(g, function(k) {
    return !Vse(n[k], r[k]);
  }), b = g.length), b > 0 || a.force && !i.length) {
    var M = void 0, R = void 0, A = void 0;
    if (l) {
      R = {}, h && (M = {});
      for (var _ = 0; _ < b; _++) {
        var w = g[_];
        R[w] = r[w], h ? M[w] = n[w] : r[w] = n[w];
      }
    } else if (h) {
      A = {};
      for (var _ = 0; _ < b; _++) {
        var w = g[_];
        A[w] = v0(r[w]), $se(r, n, w);
      }
    }
    var x = new jv(r, !1, !1, f ? ot(p, function(L) {
      return L.targetName === e;
    }) : null);
    x.targetName = e, a.scope && (x.scope = a.scope), h && M && x.whenWithKeys(0, M, g), A && x.whenWithKeys(0, A, g), x.whenWithKeys(u ?? 500, l ? R : n, g).delay(d || 0), t.addAnimator(x, e), i.push(x);
  }
}
var Xe = function(t) {
  Be(e, t);
  function e(r) {
    var n = t.call(this) || this;
    return n.isGroup = !0, n._children = [], n.attr(r), n;
  }
  return e.prototype.childrenRef = function() {
    return this._children;
  }, e.prototype.children = function() {
    return this._children.slice();
  }, e.prototype.childAt = function(r) {
    return this._children[r];
  }, e.prototype.childOfName = function(r) {
    for (var n = this._children, a = 0; a < n.length; a++)
      if (n[a].name === r)
        return n[a];
  }, e.prototype.childCount = function() {
    return this._children.length;
  }, e.prototype.add = function(r) {
    if (r && (r !== this && r.parent !== this && (this._children.push(r), this._doAdd(r)), process.env.NODE_ENV !== "production" && r.__hostTarget))
      throw "This elemenet has been used as an attachment";
    return this;
  }, e.prototype.addBefore = function(r, n) {
    if (r && r !== this && r.parent !== this && n && n.parent === this) {
      var a = this._children, o = a.indexOf(n);
      o >= 0 && (a.splice(o, 0, r), this._doAdd(r));
    }
    return this;
  }, e.prototype.replace = function(r, n) {
    var a = Re(this._children, r);
    return a >= 0 && this.replaceAt(n, a), this;
  }, e.prototype.replaceAt = function(r, n) {
    var a = this._children, o = a[n];
    if (r && r !== this && r.parent !== this && r !== o) {
      a[n] = r, o.parent = null;
      var i = this.__zr;
      i && o.removeSelfFromZr(i), this._doAdd(r);
    }
    return this;
  }, e.prototype._doAdd = function(r) {
    r.parent && r.parent.remove(r), r.parent = this;
    var n = this.__zr;
    n && n !== r.__zr && r.addSelfToZr(n), n && n.refresh();
  }, e.prototype.remove = function(r) {
    var n = this.__zr, a = this._children, o = Re(a, r);
    return o < 0 ? this : (a.splice(o, 1), r.parent = null, n && r.removeSelfFromZr(n), n && n.refresh(), this);
  }, e.prototype.removeAll = function() {
    for (var r = this._children, n = this.__zr, a = 0; a < r.length; a++) {
      var o = r[a];
      n && o.removeSelfFromZr(n), o.parent = null;
    }
    return r.length = 0, this;
  }, e.prototype.eachChild = function(r, n) {
    for (var a = this._children, o = 0; o < a.length; o++) {
      var i = a[o];
      r.call(n, i, o);
    }
    return this;
  }, e.prototype.traverse = function(r, n) {
    for (var a = 0; a < this._children.length; a++) {
      var o = this._children[a], i = r.call(n, o);
      o.isGroup && !i && o.traverse(r, n);
    }
    return this;
  }, e.prototype.addSelfToZr = function(r) {
    t.prototype.addSelfToZr.call(this, r);
    for (var n = 0; n < this._children.length; n++) {
      var a = this._children[n];
      a.addSelfToZr(r);
    }
  }, e.prototype.removeSelfFromZr = function(r) {
    t.prototype.removeSelfFromZr.call(this, r);
    for (var n = 0; n < this._children.length; n++) {
      var a = this._children[n];
      a.removeSelfFromZr(r);
    }
  }, e.prototype.getBoundingRect = function(r) {
    for (var n = new Le(0, 0, 0, 0), a = r || this._children, o = [], i = null, l = 0; l < a.length; l++) {
      var c = a[l];
      if (!(c.ignore || c.invisible)) {
        var u = c.getBoundingRect(), d = c.getLocalTransform(o);
        d ? (Le.applyTransform(n, u, d), i = i || n.clone(), i.union(n)) : (i = i || u.clone(), i.union(u));
      }
    }
    return i || n;
  }, e;
}(C1);
Xe.prototype.type = "group";
/*!
* ZRender, a high performance 2d drawing library.
*
* Copyright (c) 2013, Baidu Inc.
* All rights reserved.
*
* LICENSE
* https://github.com/ecomfe/zrender/blob/master/LICENSE.txt
*/
var Rl = {}, Wa = {};
function Hse(t) {
  delete Wa[t];
}
function jse(t) {
  if (!t)
    return !1;
  if (typeof t == "string")
    return Kl(t, 1) < kh;
  if (t.colorStops) {
    for (var e = t.colorStops, r = 0, n = e.length, a = 0; a < n; a++)
      r += Kl(e[a].color, 1);
    return r /= n, r < kh;
  }
  return !1;
}
var Wse = function() {
  function t(e, r, n) {
    var a = this;
    this._sleepAfterStill = 10, this._stillFrameAccum = 0, this._needsRefresh = !0, this._needsRefreshHover = !0, this._darkMode = !1, n = n || {}, this.dom = r, this.id = e;
    var o = new tse(), i = n.renderer || "canvas";
    if (Rl[i] || (i = Ze(Rl)[0]), process.env.NODE_ENV !== "production" && !Rl[i])
      throw new Error("Renderer '" + i + "' is not imported. Please import it first.");
    n.useDirtyRect = n.useDirtyRect == null ? !1 : n.useDirtyRect;
    var l = new Rl[i](r, o, n, e), c = n.ssr || l.ssrOnly;
    this.storage = o, this.painter = l;
    var u = !ue.node && !ue.worker && !c ? new Ise(l.getViewportRoot(), l.root) : null, d = n.useCoarsePointer, f = d == null || d === "auto" ? ue.touchEventsSupported : !!d, h = 44, v;
    f && (v = de(n.pointerSize, h)), this.handler = new zb(o, l, u, l.root, v), this.animation = new Rse({
      stage: {
        update: c ? null : function() {
          return a._flush(!0);
        }
      }
    }), c || this.animation.start();
  }
  return t.prototype.add = function(e) {
    this._disposed || !e || (this.storage.addRoot(e), e.addSelfToZr(this), this.refresh());
  }, t.prototype.remove = function(e) {
    this._disposed || !e || (this.storage.delRoot(e), e.removeSelfFromZr(this), this.refresh());
  }, t.prototype.configLayer = function(e, r) {
    this._disposed || (this.painter.configLayer && this.painter.configLayer(e, r), this.refresh());
  }, t.prototype.setBackgroundColor = function(e) {
    this._disposed || (this.painter.setBackgroundColor && this.painter.setBackgroundColor(e), this.refresh(), this._backgroundColor = e, this._darkMode = jse(e));
  }, t.prototype.getBackgroundColor = function() {
    return this._backgroundColor;
  }, t.prototype.setDarkMode = function(e) {
    this._darkMode = e;
  }, t.prototype.isDarkMode = function() {
    return this._darkMode;
  }, t.prototype.refreshImmediately = function(e) {
    this._disposed || (e || this.animation.update(!0), this._needsRefresh = !1, this.painter.refresh(), this._needsRefresh = !1);
  }, t.prototype.refresh = function() {
    this._disposed || (this._needsRefresh = !0, this.animation.start());
  }, t.prototype.flush = function() {
    this._disposed || this._flush(!1);
  }, t.prototype._flush = function(e) {
    var r, n = Qo();
    this._needsRefresh && (r = !0, this.refreshImmediately(e)), this._needsRefreshHover && (r = !0, this.refreshHoverImmediately());
    var a = Qo();
    r ? (this._stillFrameAccum = 0, this.trigger("rendered", {
      elapsedTime: a - n
    })) : this._sleepAfterStill > 0 && (this._stillFrameAccum++, this._stillFrameAccum > this._sleepAfterStill && this.animation.stop());
  }, t.prototype.setSleepAfterStill = function(e) {
    this._sleepAfterStill = e;
  }, t.prototype.wakeUp = function() {
    this._disposed || (this.animation.start(), this._stillFrameAccum = 0);
  }, t.prototype.refreshHover = function() {
    this._needsRefreshHover = !0;
  }, t.prototype.refreshHoverImmediately = function() {
    this._disposed || (this._needsRefreshHover = !1, this.painter.refreshHover && this.painter.getType() === "canvas" && this.painter.refreshHover());
  }, t.prototype.resize = function(e) {
    this._disposed || (e = e || {}, this.painter.resize(e.width, e.height), this.handler.resize());
  }, t.prototype.clearAnimation = function() {
    this._disposed || this.animation.clear();
  }, t.prototype.getWidth = function() {
    if (!this._disposed)
      return this.painter.getWidth();
  }, t.prototype.getHeight = function() {
    if (!this._disposed)
      return this.painter.getHeight();
  }, t.prototype.setCursorStyle = function(e) {
    this._disposed || this.handler.setCursorStyle(e);
  }, t.prototype.findHover = function(e, r) {
    if (!this._disposed)
      return this.handler.findHover(e, r);
  }, t.prototype.on = function(e, r, n) {
    return this._disposed || this.handler.on(e, r, n), this;
  }, t.prototype.off = function(e, r) {
    this._disposed || this.handler.off(e, r);
  }, t.prototype.trigger = function(e, r) {
    this._disposed || this.handler.trigger(e, r);
  }, t.prototype.clear = function() {
    if (!this._disposed) {
      for (var e = this.storage.getRoots(), r = 0; r < e.length; r++)
        e[r] instanceof Xe && e[r].removeSelfFromZr(this);
      this.storage.delAllRoots(), this.painter.clear();
    }
  }, t.prototype.dispose = function() {
    this._disposed || (this.animation.stop(), this.clear(), this.storage.dispose(), this.painter.dispose(), this.handler.dispose(), this.animation = this.storage = this.painter = this.handler = null, this._disposed = !0, Hse(this.id));
  }, t;
}();
function Oh(t, e) {
  var r = new Wse(Iv(), t, e);
  return Wa[r.id] = r, r;
}
function zse(t) {
  t.dispose();
}
function Gse() {
  for (var t in Wa)
    Wa.hasOwnProperty(t) && Wa[t].dispose();
  Wa = {};
}
function Use(t) {
  return Wa[t];
}
function i9(t, e) {
  Rl[t] = e;
}
var Ih;
function Yse(t) {
  if (typeof Ih == "function")
    return Ih(t);
}
function l9(t) {
  Ih = t;
}
var Xse = "5.6.0";
const qse = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  dispose: zse,
  disposeAll: Gse,
  getElementSSRData: Yse,
  getInstance: Use,
  init: Oh,
  registerPainter: i9,
  registerSSRDataGetter: l9,
  version: Xse
}, Symbol.toStringTag, { value: "Module" }));
var Pg = 1e-4, s9 = 20;
function Kse(t) {
  return t.replace(/^\s+|\s+$/g, "");
}
function Ge(t, e, r, n) {
  var a = e[0], o = e[1], i = r[0], l = r[1], c = o - a, u = l - i;
  if (c === 0)
    return u === 0 ? i : (i + l) / 2;
  if (n)
    if (c > 0) {
      if (t <= a)
        return i;
      if (t >= o)
        return l;
    } else {
      if (t >= a)
        return i;
      if (t <= o)
        return l;
    }
  else {
    if (t === a)
      return i;
    if (t === o)
      return l;
  }
  return (t - a) / c * u + i;
}
function fe(t, e) {
  switch (t) {
    case "center":
    case "middle":
      t = "50%";
      break;
    case "left":
    case "top":
      t = "0%";
      break;
    case "right":
    case "bottom":
      t = "100%";
      break;
  }
  return Q(t) ? Kse(t).match(/%$/) ? parseFloat(t) / 100 * e : parseFloat(t) : t == null ? NaN : +t;
}
function Qe(t, e, r) {
  return e == null && (e = 10), e = Math.min(Math.max(0, e), s9), t = (+t).toFixed(e), r ? t : +t;
}
function Jo(t) {
  return t.sort(function(e, r) {
    return e - r;
  }), t;
}
function Pr(t) {
  if (t = +t, isNaN(t))
    return 0;
  if (t > 1e-14) {
    for (var e = 1, r = 0; r < 15; r++, e *= 10)
      if (Math.round(t * e) / e === t)
        return r;
  }
  return K0(t);
}
function K0(t) {
  var e = t.toString().toLowerCase(), r = e.indexOf("e"), n = r > 0 ? +e.slice(r + 1) : 0, a = r > 0 ? r : e.length, o = e.indexOf("."), i = o < 0 ? 0 : a - 1 - o;
  return Math.max(0, i - n);
}
function Uv(t, e) {
  var r = Math.log, n = Math.LN10, a = Math.floor(r(t[1] - t[0]) / n), o = Math.round(r(Math.abs(e[1] - e[0])) / n), i = Math.min(Math.max(-a + o, 0), 20);
  return isFinite(i) ? i : 20;
}
function Qse(t, e, r) {
  if (!t[e])
    return 0;
  var n = c9(t, r);
  return n[e] || 0;
}
function c9(t, e) {
  var r = tn(t, function(v, p) {
    return v + (isNaN(p) ? 0 : p);
  }, 0);
  if (r === 0)
    return [];
  for (var n = Math.pow(10, e), a = J(t, function(v) {
    return (isNaN(v) ? 0 : v) / r * n * 100;
  }), o = n * 100, i = J(a, function(v) {
    return Math.floor(v);
  }), l = tn(i, function(v, p) {
    return v + p;
  }, 0), c = J(a, function(v, p) {
    return v - i[p];
  }); l < o; ) {
    for (var u = Number.NEGATIVE_INFINITY, d = null, f = 0, h = c.length; f < h; ++f)
      c[f] > u && (u = c[f], d = f);
    ++i[d], c[d] = 0, ++l;
  }
  return J(i, function(v) {
    return v / n;
  });
}
function Jse(t, e) {
  var r = Math.max(Pr(t), Pr(e)), n = t + e;
  return r > s9 ? n : Qe(n, r);
}
var ece = 9007199254740991;
function Yv(t) {
  var e = Math.PI * 2;
  return (t % e + e) % e;
}
function Jl(t) {
  return t > -Pg && t < Pg;
}
var tce = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d{1,2})(?::(\d{1,2})(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/;
function wr(t) {
  if (t instanceof Date)
    return t;
  if (Q(t)) {
    var e = tce.exec(t);
    if (!e)
      return /* @__PURE__ */ new Date(NaN);
    if (e[8]) {
      var r = +e[4] || 0;
      return e[8].toUpperCase() !== "Z" && (r -= +e[8].slice(0, 3)), new Date(Date.UTC(+e[1], +(e[2] || 1) - 1, +e[3] || 1, r, +(e[5] || 0), +e[6] || 0, e[7] ? +e[7].substring(0, 3) : 0));
    } else
      return new Date(+e[1], +(e[2] || 1) - 1, +e[3] || 1, +e[4] || 0, +(e[5] || 0), +e[6] || 0, e[7] ? +e[7].substring(0, 3) : 0);
  } else if (t == null)
    return /* @__PURE__ */ new Date(NaN);
  return new Date(Math.round(t));
}
function u9(t) {
  return Math.pow(10, Is(t));
}
function Is(t) {
  if (t === 0)
    return 0;
  var e = Math.floor(Math.log(t) / Math.LN10);
  return t / Math.pow(10, e) >= 10 && e++, e;
}
function Xv(t, e) {
  var r = Is(t), n = Math.pow(10, r), a = t / n, o;
  return e ? a < 1.5 ? o = 1 : a < 2.5 ? o = 2 : a < 4 ? o = 3 : a < 7 ? o = 5 : o = 10 : a < 1 ? o = 1 : a < 2 ? o = 2 : a < 3 ? o = 3 : a < 5 ? o = 5 : o = 10, t = o * n, r >= -20 ? +t.toFixed(r < 0 ? -r : 0) : t;
}
function rce(t, e) {
  var r = (t.length - 1) * e + 1, n = Math.floor(r), a = +t[n - 1], o = r - n;
  return o ? a + o * (t[n] - a) : a;
}
function nce(t) {
  t.sort(function(c, u) {
    return l(c, u, 0) ? -1 : 1;
  });
  for (var e = -1 / 0, r = 1, n = 0; n < t.length; ) {
    for (var a = t[n].interval, o = t[n].close, i = 0; i < 2; i++)
      a[i] <= e && (a[i] = e, o[i] = i ? 1 : 1 - r), e = a[i], r = o[i];
    a[0] === a[1] && o[0] * o[1] !== 1 ? t.splice(n, 1) : n++;
  }
  return t;
  function l(c, u, d) {
    return c.interval[d] < u.interval[d] || c.interval[d] === u.interval[d] && (c.close[d] - u.close[d] === (d ? -1 : 1) || !d && l(c, u, 1));
  }
}
function es(t) {
  var e = parseFloat(t);
  return e == t && (e !== 0 || !Q(t) || t.indexOf("x") <= 0) ? e : NaN;
}
function qv(t) {
  return !isNaN(es(t));
}
function d9() {
  return Math.round(Math.random() * 9);
}
function f9(t, e) {
  return e === 0 ? t : f9(e, t % e);
}
function Dg(t, e) {
  return t == null ? e : e == null ? t : t * e / f9(t, e);
}
var ace = "[ECharts] ", Ng = {}, oce = typeof console < "u" && console.warn && console.log;
function E1(t, e, r) {
  if (oce) {
    if (r) {
      if (Ng[e])
        return;
      Ng[e] = !0;
    }
    console[t](ace + e);
  }
}
function ice(t, e) {
  E1("log", t, e);
}
function pt(t, e) {
  E1("warn", t, e);
}
function bt(t, e) {
  E1("error", t, e);
}
function yr(t) {
  process.env.NODE_ENV !== "production" && E1("warn", "DEPRECATED: " + t, !0);
}
function tt(t, e, r) {
  process.env.NODE_ENV !== "production" && yr((r ? "[" + r + "]" : "") + (t + " is deprecated, use " + e + " instead."));
}
function Q0() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  var r = "";
  if (process.env.NODE_ENV !== "production") {
    var n = function(a) {
      return a === void 0 ? "undefined" : a === 1 / 0 ? "Infinity" : a === -1 / 0 ? "-Infinity" : _i(a) ? "NaN" : a instanceof Date ? "Date(" + a.toISOString() + ")" : ie(a) ? "function () { ... }" : Pb(a) ? a + "" : null;
    };
    r = J(t, function(a) {
      if (Q(a))
        return a;
      var o = n(a);
      if (o != null)
        return o;
      if (typeof JSON < "u" && JSON.stringify)
        try {
          return JSON.stringify(a, function(i, l) {
            var c = n(l);
            return c ?? l;
          });
        } catch {
          return "?";
        }
      else
        return "?";
    }).join(" ");
  }
  return r;
}
function Vt(t) {
  throw new Error(t);
}
function Bg(t, e, r) {
  return (e - t) * r + t;
}
var h9 = "series\0", lce = "\0_ec_\0";
function kt(t) {
  return t instanceof Array ? t : t == null ? [] : [t];
}
function J0(t, e, r) {
  if (t) {
    t[e] = t[e] || {}, t.emphasis = t.emphasis || {}, t.emphasis[e] = t.emphasis[e] || {};
    for (var n = 0, a = r.length; n < a; n++) {
      var o = r[n];
      !t.emphasis[e].hasOwnProperty(o) && t[e].hasOwnProperty(o) && (t.emphasis[e][o] = t[e][o]);
    }
  }
}
var Fg = ["fontStyle", "fontWeight", "fontSize", "fontFamily", "rich", "tag", "color", "textBorderColor", "textBorderWidth", "width", "height", "lineHeight", "align", "verticalAlign", "baseline", "shadowColor", "shadowBlur", "shadowOffsetX", "shadowOffsetY", "textShadowColor", "textShadowBlur", "textShadowOffsetX", "textShadowOffsetY", "backgroundColor", "borderColor", "borderWidth", "borderRadius", "padding"];
function Ps(t) {
  return re(t) && !z(t) && !(t instanceof Date) ? t.value : t;
}
function sce(t) {
  return re(t) && !(t instanceof Array);
}
function cce(t, e, r) {
  var n = r === "normalMerge", a = r === "replaceMerge", o = r === "replaceAll";
  t = t || [], e = (e || []).slice();
  var i = se();
  I(e, function(c, u) {
    if (!re(c)) {
      e[u] = null;
      return;
    }
    process.env.NODE_ENV !== "production" && (c.id != null && !Vg(c.id) && $g(c.id), c.name != null && !Vg(c.name) && $g(c.name));
  });
  var l = uce(t, i, r);
  return (n || a) && dce(l, t, i, e), n && fce(l, e), n || a ? hce(l, e, a) : o && vce(l, e), pce(l), l;
}
function uce(t, e, r) {
  var n = [];
  if (r === "replaceAll")
    return n;
  for (var a = 0; a < t.length; a++) {
    var o = t[a];
    o && o.id != null && e.set(o.id, a), n.push({
      existing: r === "replaceMerge" || Ci(o) ? null : o,
      newOption: null,
      keyInfo: null,
      brandNew: null
    });
  }
  return n;
}
function dce(t, e, r, n) {
  I(n, function(a, o) {
    if (!(!a || a.id == null)) {
      var i = Pl(a.id), l = r.get(i);
      if (l != null) {
        var c = t[l];
        ge(!c.newOption, 'Duplicated option on id "' + i + '".'), c.newOption = a, c.existing = e[l], n[o] = null;
      }
    }
  });
}
function fce(t, e) {
  I(e, function(r, n) {
    if (!(!r || r.name == null))
      for (var a = 0; a < t.length; a++) {
        var o = t[a].existing;
        if (!t[a].newOption && o && (o.id == null || r.id == null) && !Ci(r) && !Ci(o) && v9("name", o, r)) {
          t[a].newOption = r, e[n] = null;
          return;
        }
      }
  });
}
function hce(t, e, r) {
  I(e, function(n) {
    if (n) {
      for (
        var a, o = 0;
        // Be `!resultItem` only when `nextIdx >= result.length`.
        (a = t[o]) && (a.newOption || Ci(a.existing) || // In mode "replaceMerge", here no not-mapped-non-internal-existing.
        a.existing && n.id != null && !v9("id", n, a.existing));
      )
        o++;
      a ? (a.newOption = n, a.brandNew = r) : t.push({
        newOption: n,
        brandNew: r,
        existing: null,
        keyInfo: null
      }), o++;
    }
  });
}
function vce(t, e) {
  I(e, function(r) {
    t.push({
      newOption: r,
      brandNew: !0,
      existing: null,
      keyInfo: null
    });
  });
}
function pce(t) {
  var e = se();
  I(t, function(r) {
    var n = r.existing;
    n && e.set(n.id, r);
  }), I(t, function(r) {
    var n = r.newOption;
    ge(!n || n.id == null || !e.get(n.id) || e.get(n.id) === r, "id duplicates: " + (n && n.id)), n && n.id != null && e.set(n.id, r), !r.keyInfo && (r.keyInfo = {});
  }), I(t, function(r, n) {
    var a = r.existing, o = r.newOption, i = r.keyInfo;
    if (re(o)) {
      if (i.name = o.name != null ? Pl(o.name) : a ? a.name : h9 + n, a)
        i.id = Pl(a.id);
      else if (o.id != null)
        i.id = Pl(o.id);
      else {
        var l = 0;
        do
          i.id = "\0" + i.name + "\0" + l++;
        while (e.get(i.id));
      }
      e.set(i.id, r);
    }
  });
}
function v9(t, e, r) {
  var n = Jr(e[t], null), a = Jr(r[t], null);
  return n != null && a != null && n === a;
}
function Pl(t) {
  if (process.env.NODE_ENV !== "production" && t == null)
    throw new Error();
  return Jr(t, "");
}
function Jr(t, e) {
  return t == null ? e : Q(t) ? t : De(t) || Xl(t) ? t + "" : e;
}
function $g(t) {
  process.env.NODE_ENV !== "production" && pt("`" + t + "` is invalid id or name. Must be a string or number.");
}
function Vg(t) {
  return Xl(t) || qv(t);
}
function Kv(t) {
  var e = t.name;
  return !!(e && e.indexOf(h9));
}
function Ci(t) {
  return t && t.id != null && Pl(t.id).indexOf(lce) === 0;
}
function gce(t, e, r) {
  I(t, function(n) {
    var a = n.newOption;
    re(a) && (n.keyInfo.mainType = e, n.keyInfo.subType = mce(e, a, n.existing, r));
  });
}
function mce(t, e, r, n) {
  var a = e.type ? e.type : r ? r.subType : n.determineSubType(t, e);
  return a;
}
function oo(t, e) {
  if (e.dataIndexInside != null)
    return e.dataIndexInside;
  if (e.dataIndex != null)
    return z(e.dataIndex) ? J(e.dataIndex, function(r) {
      return t.indexOfRawIndex(r);
    }) : t.indexOfRawIndex(e.dataIndex);
  if (e.name != null)
    return z(e.name) ? J(e.name, function(r) {
      return t.indexOfName(r);
    }) : t.indexOfName(e.name);
}
function je() {
  var t = "__ec_inner_" + wce++;
  return function(e) {
    return e[t] || (e[t] = {});
  };
}
var wce = d9();
function ld(t, e, r) {
  var n = Qv(e, r), a = n.mainTypeSpecified, o = n.queryOptionMap, i = n.others, l = i, c = r ? r.defaultMainType : null;
  return !a && c && o.set(c, {}), o.each(function(u, d) {
    var f = Ds(t, d, u, {
      useDefault: c === d,
      enableAll: r && r.enableAll != null ? r.enableAll : !0,
      enableNone: r && r.enableNone != null ? r.enableNone : !0
    });
    l[d + "Models"] = f.models, l[d + "Model"] = f.models[0];
  }), l;
}
function Qv(t, e) {
  var r;
  if (Q(t)) {
    var n = {};
    n[t + "Index"] = 0, r = n;
  } else
    r = t;
  var a = se(), o = {}, i = !1;
  return I(r, function(l, c) {
    if (c === "dataIndex" || c === "dataIndexInside") {
      o[c] = l;
      return;
    }
    var u = c.match(/^(\w+)(Index|Id|Name)$/) || [], d = u[1], f = (u[2] || "").toLowerCase();
    if (!(!d || !f || e && e.includeMainTypes && Re(e.includeMainTypes, d) < 0)) {
      i = i || !!d;
      var h = a.get(d) || a.set(d, {});
      h[f] = l;
    }
  }), {
    mainTypeSpecified: i,
    queryOptionMap: a,
    others: o
  };
}
var Ht = {
  useDefault: !0,
  enableAll: !1,
  enableNone: !1
}, yce = {
  useDefault: !1,
  enableAll: !0,
  enableNone: !0
};
function Ds(t, e, r, n) {
  n = n || Ht;
  var a = r.index, o = r.id, i = r.name, l = {
    models: null,
    specified: a != null || o != null || i != null
  };
  if (!l.specified) {
    var c = void 0;
    return l.models = n.useDefault && (c = t.getComponent(e)) ? [c] : [], l;
  }
  return a === "none" || a === !1 ? (ge(n.enableNone, '`"none"` or `false` is not a valid value on index option.'), l.models = [], l) : (a === "all" && (ge(n.enableAll, '`"all"` is not a valid value on index option.'), a = o = i = null), l.models = t.queryComponents({
    mainType: e,
    index: a,
    id: o,
    name: i
  }), l);
}
function p9(t, e, r) {
  t.setAttribute ? t.setAttribute(e, r) : t[e] = r;
}
function bce(t, e) {
  return t.getAttribute ? t.getAttribute(e) : t[e];
}
function _ce(t) {
  return t === "auto" ? ue.domSupported ? "html" : "richText" : t || "html";
}
function g9(t, e, r, n, a) {
  var o = e == null || e === "auto";
  if (n == null)
    return n;
  if (De(n)) {
    var i = Bg(r || 0, n, a);
    return Qe(i, o ? Math.max(Pr(r || 0), Pr(n)) : e);
  } else {
    if (Q(n))
      return a < 1 ? r : n;
    for (var l = [], c = r, u = n, d = Math.max(c ? c.length : 0, u.length), f = 0; f < d; ++f) {
      var h = t.getDimensionInfo(f);
      if (h && h.type === "ordinal")
        l[f] = (a < 1 && c ? c : u)[f];
      else {
        var v = c && c[f] ? c[f] : 0, p = u[f], i = Bg(v, p, a);
        l[f] = Qe(i, o ? Math.max(Pr(v), Pr(p)) : e);
      }
    }
    return l;
  }
}
var xce = ".", Ma = "___EC__COMPONENT__CONTAINER___", m9 = "___EC__EXTENDED_CLASS___";
function Kr(t) {
  var e = {
    main: "",
    sub: ""
  };
  if (t) {
    var r = t.split(xce);
    e.main = r[0] || "", e.sub = r[1] || "";
  }
  return e;
}
function Cce(t) {
  ge(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(t), 'componentType "' + t + '" illegal');
}
function Ece(t) {
  return !!(t && t[m9]);
}
function Jv(t, e) {
  t.$constructor = t, t.extend = function(r) {
    process.env.NODE_ENV !== "production" && I(e, function(o) {
      r[o] || console.warn("Method `" + o + "` should be implemented" + (r.type ? " in " + r.type : "") + ".");
    });
    var n = this, a;
    return Sce(n) ? a = /** @class */
    function(o) {
      K(i, o);
      function i() {
        return o.apply(this, arguments) || this;
      }
      return i;
    }(n) : (a = function() {
      (r.$constructor || n).apply(this, arguments);
    }, Pv(a, this)), H(a.prototype, r), a[m9] = !0, a.extend = this.extend, a.superCall = Ace, a.superApply = kce, a.superClass = n, a;
  };
}
function Sce(t) {
  return ie(t) && /^class\s/.test(Function.prototype.toString.call(t));
}
function w9(t, e) {
  t.extend = e.extend;
}
var Rce = Math.round(Math.random() * 10);
function Mce(t) {
  var e = ["__\0is_clz", Rce++].join("_");
  t.prototype[e] = !0, process.env.NODE_ENV !== "production" && ge(!t.isInstance, 'The method "is" can not be defined.'), t.isInstance = function(r) {
    return !!(r && r[e]);
  };
}
function Ace(t, e) {
  for (var r = [], n = 2; n < arguments.length; n++)
    r[n - 2] = arguments[n];
  return this.superClass.prototype[e].apply(t, r);
}
function kce(t, e, r) {
  return this.superClass.prototype[e].apply(t, r);
}
function S1(t) {
  var e = {};
  t.registerClass = function(n) {
    var a = n.type || n.prototype.type;
    if (a) {
      Cce(a), n.prototype.type = a;
      var o = Kr(a);
      if (!o.sub)
        process.env.NODE_ENV !== "production" && e[o.main] && console.warn(o.main + " exists."), e[o.main] = n;
      else if (o.sub !== Ma) {
        var i = r(o);
        i[o.sub] = n;
      }
    }
    return n;
  }, t.getClass = function(n, a, o) {
    var i = e[n];
    if (i && i[Ma] && (i = a ? i[a] : null), o && !i)
      throw new Error(a ? "Component " + n + "." + (a || "") + " is used but not imported." : n + ".type should be specified.");
    return i;
  }, t.getClassesByMainType = function(n) {
    var a = Kr(n), o = [], i = e[a.main];
    return i && i[Ma] ? I(i, function(l, c) {
      c !== Ma && o.push(l);
    }) : o.push(i), o;
  }, t.hasClass = function(n) {
    var a = Kr(n);
    return !!e[a.main];
  }, t.getAllClassMainTypes = function() {
    var n = [];
    return I(e, function(a, o) {
      n.push(o);
    }), n;
  }, t.hasSubTypes = function(n) {
    var a = Kr(n), o = e[a.main];
    return o && o[Ma];
  };
  function r(n) {
    var a = e[n.main];
    return (!a || !a[Ma]) && (a = e[n.main] = {}, a[Ma] = !0), a;
  }
}
function ts(t, e) {
  for (var r = 0; r < t.length; r++)
    t[r][1] || (t[r][1] = t[r][0]);
  return e = e || !1, function(n, a, o) {
    for (var i = {}, l = 0; l < t.length; l++) {
      var c = t[l][1];
      if (!(a && Re(a, c) >= 0 || o && Re(o, c) < 0)) {
        var u = n.getShallow(c, e);
        u != null && (i[t[l][0]] = u);
      }
    }
    return i;
  };
}
var Lce = [
  ["fill", "color"],
  ["shadowBlur"],
  ["shadowOffsetX"],
  ["shadowOffsetY"],
  ["opacity"],
  ["shadowColor"]
  // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
  // So do not transfer decal directly.
], Tce = ts(Lce), Oce = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getAreaStyle = function(e, r) {
      return Tce(this, e, r);
    }, t;
  }()
), Ph = new Os(50);
function Ice(t) {
  if (typeof t == "string") {
    var e = Ph.get(t);
    return e && e.image;
  } else
    return t;
}
function y9(t, e, r, n, a) {
  if (t)
    if (typeof t == "string") {
      if (e && e.__zrImageSrc === t || !r)
        return e;
      var o = Ph.get(t), i = { hostEl: r, cb: n, cbPayload: a };
      return o ? (e = o.image, !R1(e) && o.pending.push(i)) : (e = xn.loadImage(t, Zg, Zg), e.__zrImageSrc = t, Ph.put(t, e.__cachedImgObj = {
        image: e,
        pending: [i]
      })), e;
    } else
      return t;
  else return e;
}
function Zg() {
  var t = this.__cachedImgObj;
  this.onload = this.onerror = this.__cachedImgObj = null;
  for (var e = 0; e < t.pending.length; e++) {
    var r = t.pending[e], n = r.cb;
    n && n(this, r.cbPayload), r.hostEl.dirty();
  }
  t.pending.length = 0;
}
function R1(t) {
  return t && t.width && t.height;
}
var sd = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
function b9(t, e, r, n, a) {
  if (!e)
    return "";
  var o = (t + "").split(`
`);
  a = _9(e, r, n, a);
  for (var i = 0, l = o.length; i < l; i++)
    o[i] = x9(o[i], a);
  return o.join(`
`);
}
function _9(t, e, r, n) {
  n = n || {};
  var a = H({}, n);
  a.font = e, r = de(r, "..."), a.maxIterations = de(n.maxIterations, 2);
  var o = a.minChar = de(n.minChar, 0);
  a.cnCharWidth = er("国", e);
  var i = a.ascCharWidth = er("a", e);
  a.placeholder = de(n.placeholder, "");
  for (var l = t = Math.max(0, t - 1), c = 0; c < o && l >= i; c++)
    l -= i;
  var u = er(r, e);
  return u > l && (r = "", u = 0), l = t - u, a.ellipsis = r, a.ellipsisWidth = u, a.contentWidth = l, a.containerWidth = t, a;
}
function x9(t, e) {
  var r = e.containerWidth, n = e.font, a = e.contentWidth;
  if (!r)
    return "";
  var o = er(t, n);
  if (o <= r)
    return t;
  for (var i = 0; ; i++) {
    if (o <= a || i >= e.maxIterations) {
      t += e.ellipsis;
      break;
    }
    var l = i === 0 ? Pce(t, a, e.ascCharWidth, e.cnCharWidth) : o > 0 ? Math.floor(t.length * a / o) : 0;
    t = t.substr(0, l), o = er(t, n);
  }
  return t === "" && (t = e.placeholder), t;
}
function Pce(t, e, r, n) {
  for (var a = 0, o = 0, i = t.length; o < i && a < e; o++) {
    var l = t.charCodeAt(o);
    a += 0 <= l && l <= 127 ? r : n;
  }
  return o;
}
function Dce(t, e) {
  t != null && (t += "");
  var r = e.overflow, n = e.padding, a = e.font, o = r === "truncate", i = Gv(a), l = de(e.lineHeight, i), c = !!e.backgroundColor, u = e.lineOverflow === "truncate", d = e.width, f;
  d != null && (r === "break" || r === "breakAll") ? f = t ? C9(t, e.font, d, r === "breakAll", 0).lines : [] : f = t ? t.split(`
`) : [];
  var h = f.length * l, v = de(e.height, h);
  if (h > v && u) {
    var p = Math.floor(v / l);
    f = f.slice(0, p);
  }
  if (t && o && d != null)
    for (var g = _9(d, a, e.ellipsis, {
      minChar: e.truncateMinChar,
      placeholder: e.placeholder
    }), m = 0; m < f.length; m++)
      f[m] = x9(f[m], g);
  for (var w = v, y = 0, m = 0; m < f.length; m++)
    y = Math.max(er(f[m], a), y);
  d == null && (d = y);
  var b = y;
  return n && (w += n[0] + n[2], b += n[1] + n[3], d += n[1] + n[3]), c && (b = d), {
    lines: f,
    height: v,
    outerWidth: b,
    outerHeight: w,
    lineHeight: l,
    calculatedLineHeight: i,
    contentWidth: y,
    contentHeight: h,
    width: d
  };
}
var Nce = /* @__PURE__ */ function() {
  function t() {
  }
  return t;
}(), Hg = /* @__PURE__ */ function() {
  function t(e) {
    this.tokens = [], e && (this.tokens = e);
  }
  return t;
}(), Bce = /* @__PURE__ */ function() {
  function t() {
    this.width = 0, this.height = 0, this.contentWidth = 0, this.contentHeight = 0, this.outerWidth = 0, this.outerHeight = 0, this.lines = [];
  }
  return t;
}();
function Fce(t, e) {
  var r = new Bce();
  if (t != null && (t += ""), !t)
    return r;
  for (var n = e.width, a = e.height, o = e.overflow, i = (o === "break" || o === "breakAll") && n != null ? { width: n, accumWidth: 0, breakAll: o === "breakAll" } : null, l = sd.lastIndex = 0, c; (c = sd.exec(t)) != null; ) {
    var u = c.index;
    u > l && cd(r, t.substring(l, u), e, i), cd(r, c[2], e, i, c[1]), l = sd.lastIndex;
  }
  l < t.length && cd(r, t.substring(l, t.length), e, i);
  var d = [], f = 0, h = 0, v = e.padding, p = o === "truncate", g = e.lineOverflow === "truncate";
  function m(B, N, $) {
    B.width = N, B.lineHeight = $, f += $, h = Math.max(h, N);
  }
  e: for (var w = 0; w < r.lines.length; w++) {
    for (var y = r.lines[w], b = 0, _ = 0, x = 0; x < y.tokens.length; x++) {
      var E = y.tokens[x], S = E.styleName && e.rich[E.styleName] || {}, M = E.textPadding = S.padding, R = M ? M[1] + M[3] : 0, A = E.font = S.font || e.font;
      E.contentHeight = Gv(A);
      var k = de(S.height, E.contentHeight);
      if (E.innerHeight = k, M && (k += M[0] + M[2]), E.height = k, E.lineHeight = ea(S.lineHeight, e.lineHeight, k), E.align = S && S.align || e.align, E.verticalAlign = S && S.verticalAlign || "middle", g && a != null && f + E.lineHeight > a) {
        x > 0 ? (y.tokens = y.tokens.slice(0, x), m(y, _, b), r.lines = r.lines.slice(0, w + 1)) : r.lines = r.lines.slice(0, w);
        break e;
      }
      var L = S.width, T = L == null || L === "auto";
      if (typeof L == "string" && L.charAt(L.length - 1) === "%")
        E.percentWidth = L, d.push(E), E.contentWidth = er(E.text, A);
      else {
        if (T) {
          var O = S.backgroundColor, D = O && O.image;
          D && (D = Ice(D), R1(D) && (E.width = Math.max(E.width, D.width * k / D.height)));
        }
        var P = p && n != null ? n - _ : null;
        P != null && P < E.width ? !T || P < R ? (E.text = "", E.width = E.contentWidth = 0) : (E.text = b9(E.text, P - R, A, e.ellipsis, { minChar: e.truncateMinChar }), E.width = E.contentWidth = er(E.text, A)) : E.contentWidth = er(E.text, A);
      }
      E.width += R, _ += E.width, S && (b = Math.max(b, E.lineHeight));
    }
    m(y, _, b);
  }
  r.outerWidth = r.width = de(n, h), r.outerHeight = r.height = de(a, f), r.contentHeight = f, r.contentWidth = h, v && (r.outerWidth += v[1] + v[3], r.outerHeight += v[0] + v[2]);
  for (var w = 0; w < d.length; w++) {
    var E = d[w], F = E.percentWidth;
    E.width = parseInt(F, 10) / 100 * r.width;
  }
  return r;
}
function cd(t, e, r, n, a) {
  var o = e === "", i = a && r.rich[a] || {}, l = t.lines, c = i.font || r.font, u = !1, d, f;
  if (n) {
    var h = i.padding, v = h ? h[1] + h[3] : 0;
    if (i.width != null && i.width !== "auto") {
      var p = ca(i.width, n.width) + v;
      l.length > 0 && p + n.accumWidth > n.width && (d = e.split(`
`), u = !0), n.accumWidth = p;
    } else {
      var g = C9(e, c, n.width, n.breakAll, n.accumWidth);
      n.accumWidth = g.accumWidth + v, f = g.linesWidths, d = g.lines;
    }
  } else
    d = e.split(`
`);
  for (var m = 0; m < d.length; m++) {
    var w = d[m], y = new Nce();
    if (y.styleName = a, y.text = w, y.isLineHolder = !w && !o, typeof i.width == "number" ? y.width = i.width : y.width = f ? f[m] : er(w, c), !m && !u) {
      var b = (l[l.length - 1] || (l[0] = new Hg())).tokens, _ = b.length;
      _ === 1 && b[0].isLineHolder ? b[0] = y : (w || !_ || o) && b.push(y);
    } else
      l.push(new Hg([y]));
  }
}
function $ce(t) {
  var e = t.charCodeAt(0);
  return e >= 32 && e <= 591 || e >= 880 && e <= 4351 || e >= 4608 && e <= 5119 || e >= 7680 && e <= 8303;
}
var Vce = tn(",&?/;] ".split(""), function(t, e) {
  return t[e] = !0, t;
}, {});
function Zce(t) {
  return $ce(t) ? !!Vce[t] : !0;
}
function C9(t, e, r, n, a) {
  for (var o = [], i = [], l = "", c = "", u = 0, d = 0, f = 0; f < t.length; f++) {
    var h = t.charAt(f);
    if (h === `
`) {
      c && (l += c, d += u), o.push(l), i.push(d), l = "", c = "", u = 0, d = 0;
      continue;
    }
    var v = er(h, e), p = n ? !1 : !Zce(h);
    if (o.length ? d + v > r : a + d + v > r) {
      d ? (l || c) && (p ? (l || (l = c, c = "", u = 0, d = u), o.push(l), i.push(d - u), c += h, u += v, l = "", d = u) : (c && (l += c, c = "", u = 0), o.push(l), i.push(d), l = h, d = v)) : p ? (o.push(c), i.push(u), c = h, u = v) : (o.push(h), i.push(v));
      continue;
    }
    d += v, p ? (c += h, u += v) : (c && (l += c, c = "", u = 0), l += h);
  }
  return !o.length && !l && (l = t, c = "", u = 0), c && (l += c), l && (o.push(l), i.push(d)), o.length === 1 && (d += a), {
    accumWidth: d,
    lines: o,
    linesWidths: i
  };
}
var Dh = "__zr_style_" + Math.round(Math.random() * 10), qa = {
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  shadowColor: "#000",
  opacity: 1,
  blend: "source-over"
}, M1 = {
  style: {
    shadowBlur: !0,
    shadowOffsetX: !0,
    shadowOffsetY: !0,
    shadowColor: !0,
    opacity: !0
  }
};
qa[Dh] = !0;
var jg = ["z", "z2", "invisible"], Hce = ["invisible"], Ns = function(t) {
  Be(e, t);
  function e(r) {
    return t.call(this, r) || this;
  }
  return e.prototype._init = function(r) {
    for (var n = Ze(r), a = 0; a < n.length; a++) {
      var o = n[a];
      o === "style" ? this.useStyle(r[o]) : t.prototype.attrKV.call(this, o, r[o]);
    }
    this.style || this.useStyle({});
  }, e.prototype.beforeBrush = function() {
  }, e.prototype.afterBrush = function() {
  }, e.prototype.innerBeforeBrush = function() {
  }, e.prototype.innerAfterBrush = function() {
  }, e.prototype.shouldBePainted = function(r, n, a, o) {
    var i = this.transform;
    if (this.ignore || this.invisible || this.style.opacity === 0 || this.culling && jce(this, r, n) || i && !i[0] && !i[3])
      return !1;
    if (a && this.__clipPaths) {
      for (var l = 0; l < this.__clipPaths.length; ++l)
        if (this.__clipPaths[l].isZeroArea())
          return !1;
    }
    if (o && this.parent)
      for (var c = this.parent; c; ) {
        if (c.ignore)
          return !1;
        c = c.parent;
      }
    return !0;
  }, e.prototype.contain = function(r, n) {
    return this.rectContain(r, n);
  }, e.prototype.traverse = function(r, n) {
    r.call(n, this);
  }, e.prototype.rectContain = function(r, n) {
    var a = this.transformCoordToLocal(r, n), o = this.getBoundingRect();
    return o.contain(a[0], a[1]);
  }, e.prototype.getPaintRect = function() {
    var r = this._paintRect;
    if (!this._paintRect || this.__dirty) {
      var n = this.transform, a = this.getBoundingRect(), o = this.style, i = o.shadowBlur || 0, l = o.shadowOffsetX || 0, c = o.shadowOffsetY || 0;
      r = this._paintRect || (this._paintRect = new Le(0, 0, 0, 0)), n ? Le.applyTransform(r, a, n) : r.copy(a), (i || l || c) && (r.width += i * 2 + Math.abs(l), r.height += i * 2 + Math.abs(c), r.x = Math.min(r.x, r.x + l - i), r.y = Math.min(r.y, r.y + c - i));
      var u = this.dirtyRectTolerance;
      r.isZero() || (r.x = Math.floor(r.x - u), r.y = Math.floor(r.y - u), r.width = Math.ceil(r.width + 1 + u * 2), r.height = Math.ceil(r.height + 1 + u * 2));
    }
    return r;
  }, e.prototype.setPrevPaintRect = function(r) {
    r ? (this._prevPaintRect = this._prevPaintRect || new Le(0, 0, 0, 0), this._prevPaintRect.copy(r)) : this._prevPaintRect = null;
  }, e.prototype.getPrevPaintRect = function() {
    return this._prevPaintRect;
  }, e.prototype.animateStyle = function(r) {
    return this.animate("style", r);
  }, e.prototype.updateDuringAnimation = function(r) {
    r === "style" ? this.dirtyStyle() : this.markRedraw();
  }, e.prototype.attrKV = function(r, n) {
    r !== "style" ? t.prototype.attrKV.call(this, r, n) : this.style ? this.setStyle(n) : this.useStyle(n);
  }, e.prototype.setStyle = function(r, n) {
    return typeof r == "string" ? this.style[r] = n : H(this.style, r), this.dirtyStyle(), this;
  }, e.prototype.dirtyStyle = function(r) {
    r || this.markRedraw(), this.__dirty |= Cl, this._rect && (this._rect = null);
  }, e.prototype.dirty = function() {
    this.dirtyStyle();
  }, e.prototype.styleChanged = function() {
    return !!(this.__dirty & Cl);
  }, e.prototype.styleUpdated = function() {
    this.__dirty &= ~Cl;
  }, e.prototype.createStyle = function(r) {
    return ks(qa, r);
  }, e.prototype.useStyle = function(r) {
    r[Dh] || (r = this.createStyle(r)), this.__inHover ? this.__hoverStyle = r : this.style = r, this.dirtyStyle();
  }, e.prototype.isStyleObject = function(r) {
    return r[Dh];
  }, e.prototype._innerSaveToNormal = function(r) {
    t.prototype._innerSaveToNormal.call(this, r);
    var n = this._normalState;
    r.style && !n.style && (n.style = this._mergeStyle(this.createStyle(), this.style)), this._savePrimaryToNormal(r, n, jg);
  }, e.prototype._applyStateObj = function(r, n, a, o, i, l) {
    t.prototype._applyStateObj.call(this, r, n, a, o, i, l);
    var c = !(n && o), u;
    if (n && n.style ? i ? o ? u = n.style : (u = this._mergeStyle(this.createStyle(), a.style), this._mergeStyle(u, n.style)) : (u = this._mergeStyle(this.createStyle(), o ? this.style : a.style), this._mergeStyle(u, n.style)) : c && (u = a.style), u)
      if (i) {
        var d = this.style;
        if (this.style = this.createStyle(c ? {} : d), c)
          for (var f = Ze(d), h = 0; h < f.length; h++) {
            var v = f[h];
            v in u && (u[v] = u[v], this.style[v] = d[v]);
          }
        for (var p = Ze(u), h = 0; h < p.length; h++) {
          var v = p[h];
          this.style[v] = this.style[v];
        }
        this._transitionState(r, {
          style: u
        }, l, this.getAnimationStyleProps());
      } else
        this.useStyle(u);
    for (var g = this.__inHover ? Hce : jg, h = 0; h < g.length; h++) {
      var v = g[h];
      n && n[v] != null ? this[v] = n[v] : c && a[v] != null && (this[v] = a[v]);
    }
  }, e.prototype._mergeStates = function(r) {
    for (var n = t.prototype._mergeStates.call(this, r), a, o = 0; o < r.length; o++) {
      var i = r[o];
      i.style && (a = a || {}, this._mergeStyle(a, i.style));
    }
    return a && (n.style = a), n;
  }, e.prototype._mergeStyle = function(r, n) {
    return H(r, n), r;
  }, e.prototype.getAnimationStyleProps = function() {
    return M1;
  }, e.initDefaultProps = function() {
    var r = e.prototype;
    r.type = "displayable", r.invisible = !1, r.z = 0, r.z2 = 0, r.zlevel = 0, r.culling = !1, r.cursor = "pointer", r.rectHover = !1, r.incremental = !1, r._rect = null, r.dirtyRectTolerance = 0, r.__dirty = qt | Cl;
  }(), e;
}(C1), ud = new Le(0, 0, 0, 0), dd = new Le(0, 0, 0, 0);
function jce(t, e, r) {
  return ud.copy(t.getBoundingRect()), t.transform && ud.applyTransform(t.transform), dd.width = e, dd.height = r, !ud.intersect(dd);
}
var fr = Math.min, hr = Math.max, fd = Math.sin, hd = Math.cos, Aa = Math.PI * 2, pc = go(), gc = go(), mc = go();
function Wg(t, e, r, n, a, o) {
  a[0] = fr(t, r), a[1] = fr(e, n), o[0] = hr(t, r), o[1] = hr(e, n);
}
var zg = [], Gg = [];
function Wce(t, e, r, n, a, o, i, l, c, u) {
  var d = qb, f = ut, h = d(t, r, a, i, zg);
  c[0] = 1 / 0, c[1] = 1 / 0, u[0] = -1 / 0, u[1] = -1 / 0;
  for (var v = 0; v < h; v++) {
    var p = f(t, r, a, i, zg[v]);
    c[0] = fr(p, c[0]), u[0] = hr(p, u[0]);
  }
  h = d(e, n, o, l, Gg);
  for (var v = 0; v < h; v++) {
    var g = f(e, n, o, l, Gg[v]);
    c[1] = fr(g, c[1]), u[1] = hr(g, u[1]);
  }
  c[0] = fr(t, c[0]), u[0] = hr(t, u[0]), c[0] = fr(i, c[0]), u[0] = hr(i, u[0]), c[1] = fr(e, c[1]), u[1] = hr(e, u[1]), c[1] = fr(l, c[1]), u[1] = hr(l, u[1]);
}
function zce(t, e, r, n, a, o, i, l) {
  var c = Kb, u = $t, d = hr(fr(c(t, r, a), 1), 0), f = hr(fr(c(e, n, o), 1), 0), h = u(t, r, a, d), v = u(e, n, o, f);
  i[0] = fr(t, a, h), i[1] = fr(e, o, v), l[0] = hr(t, a, h), l[1] = hr(e, o, v);
}
function Gce(t, e, r, n, a, o, i, l, c) {
  var u = jn, d = Wn, f = Math.abs(a - o);
  if (f % Aa < 1e-4 && f > 1e-4) {
    l[0] = t - r, l[1] = e - n, c[0] = t + r, c[1] = e + n;
    return;
  }
  if (pc[0] = hd(a) * r + t, pc[1] = fd(a) * n + e, gc[0] = hd(o) * r + t, gc[1] = fd(o) * n + e, u(l, pc, gc), d(c, pc, gc), a = a % Aa, a < 0 && (a = a + Aa), o = o % Aa, o < 0 && (o = o + Aa), a > o && !i ? o += Aa : a < o && i && (a += Aa), i) {
    var h = o;
    o = a, a = h;
  }
  for (var v = 0; v < o; v += Math.PI / 2)
    v > a && (mc[0] = hd(v) * r + t, mc[1] = fd(v) * n + e, u(l, mc, l), d(c, mc, c));
}
var Pe = {
  M: 1,
  L: 2,
  C: 3,
  Q: 4,
  A: 5,
  Z: 6,
  R: 7
}, ka = [], La = [], zr = [], Ln = [], Gr = [], Ur = [], vd = Math.min, pd = Math.max, Ta = Math.cos, Oa = Math.sin, un = Math.abs, Nh = Math.PI, $n = Nh * 2, gd = typeof Float32Array < "u", nl = [];
function md(t) {
  var e = Math.round(t / Nh * 1e8) / 1e8;
  return e % 2 * Nh;
}
function e7(t, e) {
  var r = md(t[0]);
  r < 0 && (r += $n);
  var n = r - t[0], a = t[1];
  a += n, !e && a - r >= $n ? a = r + $n : e && r - a >= $n ? a = r - $n : !e && r > a ? a = r + ($n - md(r - a)) : e && r < a && (a = r - ($n - md(a - r))), t[0] = r, t[1] = a;
}
var io = function() {
  function t(e) {
    this.dpr = 1, this._xi = 0, this._yi = 0, this._x0 = 0, this._y0 = 0, this._len = 0, e && (this._saveData = !1), this._saveData && (this.data = []);
  }
  return t.prototype.increaseVersion = function() {
    this._version++;
  }, t.prototype.getVersion = function() {
    return this._version;
  }, t.prototype.setScale = function(e, r, n) {
    n = n || 0, n > 0 && (this._ux = un(n / X0 / e) || 0, this._uy = un(n / X0 / r) || 0);
  }, t.prototype.setDPR = function(e) {
    this.dpr = e;
  }, t.prototype.setContext = function(e) {
    this._ctx = e;
  }, t.prototype.getContext = function() {
    return this._ctx;
  }, t.prototype.beginPath = function() {
    return this._ctx && this._ctx.beginPath(), this.reset(), this;
  }, t.prototype.reset = function() {
    this._saveData && (this._len = 0), this._pathSegLen && (this._pathSegLen = null, this._pathLen = 0), this._version++;
  }, t.prototype.moveTo = function(e, r) {
    return this._drawPendingPt(), this.addData(Pe.M, e, r), this._ctx && this._ctx.moveTo(e, r), this._x0 = e, this._y0 = r, this._xi = e, this._yi = r, this;
  }, t.prototype.lineTo = function(e, r) {
    var n = un(e - this._xi), a = un(r - this._yi), o = n > this._ux || a > this._uy;
    if (this.addData(Pe.L, e, r), this._ctx && o && this._ctx.lineTo(e, r), o)
      this._xi = e, this._yi = r, this._pendingPtDist = 0;
    else {
      var i = n * n + a * a;
      i > this._pendingPtDist && (this._pendingPtX = e, this._pendingPtY = r, this._pendingPtDist = i);
    }
    return this;
  }, t.prototype.bezierCurveTo = function(e, r, n, a, o, i) {
    return this._drawPendingPt(), this.addData(Pe.C, e, r, n, a, o, i), this._ctx && this._ctx.bezierCurveTo(e, r, n, a, o, i), this._xi = o, this._yi = i, this;
  }, t.prototype.quadraticCurveTo = function(e, r, n, a) {
    return this._drawPendingPt(), this.addData(Pe.Q, e, r, n, a), this._ctx && this._ctx.quadraticCurveTo(e, r, n, a), this._xi = n, this._yi = a, this;
  }, t.prototype.arc = function(e, r, n, a, o, i) {
    this._drawPendingPt(), nl[0] = a, nl[1] = o, e7(nl, i), a = nl[0], o = nl[1];
    var l = o - a;
    return this.addData(Pe.A, e, r, n, n, a, l, 0, i ? 0 : 1), this._ctx && this._ctx.arc(e, r, n, a, o, i), this._xi = Ta(o) * n + e, this._yi = Oa(o) * n + r, this;
  }, t.prototype.arcTo = function(e, r, n, a, o) {
    return this._drawPendingPt(), this._ctx && this._ctx.arcTo(e, r, n, a, o), this;
  }, t.prototype.rect = function(e, r, n, a) {
    return this._drawPendingPt(), this._ctx && this._ctx.rect(e, r, n, a), this.addData(Pe.R, e, r, n, a), this;
  }, t.prototype.closePath = function() {
    this._drawPendingPt(), this.addData(Pe.Z);
    var e = this._ctx, r = this._x0, n = this._y0;
    return e && e.closePath(), this._xi = r, this._yi = n, this;
  }, t.prototype.fill = function(e) {
    e && e.fill(), this.toStatic();
  }, t.prototype.stroke = function(e) {
    e && e.stroke(), this.toStatic();
  }, t.prototype.len = function() {
    return this._len;
  }, t.prototype.setData = function(e) {
    var r = e.length;
    !(this.data && this.data.length === r) && gd && (this.data = new Float32Array(r));
    for (var n = 0; n < r; n++)
      this.data[n] = e[n];
    this._len = r;
  }, t.prototype.appendPath = function(e) {
    e instanceof Array || (e = [e]);
    for (var r = e.length, n = 0, a = this._len, o = 0; o < r; o++)
      n += e[o].len();
    gd && this.data instanceof Float32Array && (this.data = new Float32Array(a + n));
    for (var o = 0; o < r; o++)
      for (var i = e[o].data, l = 0; l < i.length; l++)
        this.data[a++] = i[l];
    this._len = a;
  }, t.prototype.addData = function(e, r, n, a, o, i, l, c, u) {
    if (this._saveData) {
      var d = this.data;
      this._len + arguments.length > d.length && (this._expandData(), d = this.data);
      for (var f = 0; f < arguments.length; f++)
        d[this._len++] = arguments[f];
    }
  }, t.prototype._drawPendingPt = function() {
    this._pendingPtDist > 0 && (this._ctx && this._ctx.lineTo(this._pendingPtX, this._pendingPtY), this._pendingPtDist = 0);
  }, t.prototype._expandData = function() {
    if (!(this.data instanceof Array)) {
      for (var e = [], r = 0; r < this._len; r++)
        e[r] = this.data[r];
      this.data = e;
    }
  }, t.prototype.toStatic = function() {
    if (this._saveData) {
      this._drawPendingPt();
      var e = this.data;
      e instanceof Array && (e.length = this._len, gd && this._len > 11 && (this.data = new Float32Array(e)));
    }
  }, t.prototype.getBoundingRect = function() {
    zr[0] = zr[1] = Gr[0] = Gr[1] = Number.MAX_VALUE, Ln[0] = Ln[1] = Ur[0] = Ur[1] = -Number.MAX_VALUE;
    var e = this.data, r = 0, n = 0, a = 0, o = 0, i;
    for (i = 0; i < this._len; ) {
      var l = e[i++], c = i === 1;
      switch (c && (r = e[i], n = e[i + 1], a = r, o = n), l) {
        case Pe.M:
          r = a = e[i++], n = o = e[i++], Gr[0] = a, Gr[1] = o, Ur[0] = a, Ur[1] = o;
          break;
        case Pe.L:
          Wg(r, n, e[i], e[i + 1], Gr, Ur), r = e[i++], n = e[i++];
          break;
        case Pe.C:
          Wce(r, n, e[i++], e[i++], e[i++], e[i++], e[i], e[i + 1], Gr, Ur), r = e[i++], n = e[i++];
          break;
        case Pe.Q:
          zce(r, n, e[i++], e[i++], e[i], e[i + 1], Gr, Ur), r = e[i++], n = e[i++];
          break;
        case Pe.A:
          var u = e[i++], d = e[i++], f = e[i++], h = e[i++], v = e[i++], p = e[i++] + v;
          i += 1;
          var g = !e[i++];
          c && (a = Ta(v) * f + u, o = Oa(v) * h + d), Gce(u, d, f, h, v, p, g, Gr, Ur), r = Ta(p) * f + u, n = Oa(p) * h + d;
          break;
        case Pe.R:
          a = r = e[i++], o = n = e[i++];
          var m = e[i++], w = e[i++];
          Wg(a, o, a + m, o + w, Gr, Ur);
          break;
        case Pe.Z:
          r = a, n = o;
          break;
      }
      jn(zr, zr, Gr), Wn(Ln, Ln, Ur);
    }
    return i === 0 && (zr[0] = zr[1] = Ln[0] = Ln[1] = 0), new Le(zr[0], zr[1], Ln[0] - zr[0], Ln[1] - zr[1]);
  }, t.prototype._calculateLength = function() {
    var e = this.data, r = this._len, n = this._ux, a = this._uy, o = 0, i = 0, l = 0, c = 0;
    this._pathSegLen || (this._pathSegLen = []);
    for (var u = this._pathSegLen, d = 0, f = 0, h = 0; h < r; ) {
      var v = e[h++], p = h === 1;
      p && (o = e[h], i = e[h + 1], l = o, c = i);
      var g = -1;
      switch (v) {
        case Pe.M:
          o = l = e[h++], i = c = e[h++];
          break;
        case Pe.L: {
          var m = e[h++], w = e[h++], y = m - o, b = w - i;
          (un(y) > n || un(b) > a || h === r - 1) && (g = Math.sqrt(y * y + b * b), o = m, i = w);
          break;
        }
        case Pe.C: {
          var _ = e[h++], x = e[h++], m = e[h++], w = e[h++], E = e[h++], S = e[h++];
          g = nse(o, i, _, x, m, w, E, S, 10), o = E, i = S;
          break;
        }
        case Pe.Q: {
          var _ = e[h++], x = e[h++], m = e[h++], w = e[h++];
          g = ise(o, i, _, x, m, w, 10), o = m, i = w;
          break;
        }
        case Pe.A:
          var M = e[h++], R = e[h++], A = e[h++], k = e[h++], L = e[h++], T = e[h++], O = T + L;
          h += 1, p && (l = Ta(L) * A + M, c = Oa(L) * k + R), g = pd(A, k) * vd($n, Math.abs(T)), o = Ta(O) * A + M, i = Oa(O) * k + R;
          break;
        case Pe.R: {
          l = o = e[h++], c = i = e[h++];
          var D = e[h++], P = e[h++];
          g = D * 2 + P * 2;
          break;
        }
        case Pe.Z: {
          var y = l - o, b = c - i;
          g = Math.sqrt(y * y + b * b), o = l, i = c;
          break;
        }
      }
      g >= 0 && (u[f++] = g, d += g);
    }
    return this._pathLen = d, d;
  }, t.prototype.rebuildPath = function(e, r) {
    var n = this.data, a = this._ux, o = this._uy, i = this._len, l, c, u, d, f, h, v = r < 1, p, g, m = 0, w = 0, y, b = 0, _, x;
    if (!(v && (this._pathSegLen || this._calculateLength(), p = this._pathSegLen, g = this._pathLen, y = r * g, !y)))
      e: for (var E = 0; E < i; ) {
        var S = n[E++], M = E === 1;
        switch (M && (u = n[E], d = n[E + 1], l = u, c = d), S !== Pe.L && b > 0 && (e.lineTo(_, x), b = 0), S) {
          case Pe.M:
            l = u = n[E++], c = d = n[E++], e.moveTo(u, d);
            break;
          case Pe.L: {
            f = n[E++], h = n[E++];
            var R = un(f - u), A = un(h - d);
            if (R > a || A > o) {
              if (v) {
                var k = p[w++];
                if (m + k > y) {
                  var L = (y - m) / k;
                  e.lineTo(u * (1 - L) + f * L, d * (1 - L) + h * L);
                  break e;
                }
                m += k;
              }
              e.lineTo(f, h), u = f, d = h, b = 0;
            } else {
              var T = R * R + A * A;
              T > b && (_ = f, x = h, b = T);
            }
            break;
          }
          case Pe.C: {
            var O = n[E++], D = n[E++], P = n[E++], F = n[E++], B = n[E++], N = n[E++];
            if (v) {
              var k = p[w++];
              if (m + k > y) {
                var L = (y - m) / k;
                U0(u, O, P, B, L, ka), U0(d, D, F, N, L, La), e.bezierCurveTo(ka[1], La[1], ka[2], La[2], ka[3], La[3]);
                break e;
              }
              m += k;
            }
            e.bezierCurveTo(O, D, P, F, B, N), u = B, d = N;
            break;
          }
          case Pe.Q: {
            var O = n[E++], D = n[E++], P = n[E++], F = n[E++];
            if (v) {
              var k = p[w++];
              if (m + k > y) {
                var L = (y - m) / k;
                Y0(u, O, P, L, ka), Y0(d, D, F, L, La), e.quadraticCurveTo(ka[1], La[1], ka[2], La[2]);
                break e;
              }
              m += k;
            }
            e.quadraticCurveTo(O, D, P, F), u = P, d = F;
            break;
          }
          case Pe.A:
            var $ = n[E++], V = n[E++], W = n[E++], ee = n[E++], ne = n[E++], we = n[E++], pe = n[E++], X = !n[E++], me = W > ee ? W : ee, ve = un(W - ee) > 1e-3, ae = ne + we, Y = !1;
            if (v) {
              var k = p[w++];
              m + k > y && (ae = ne + we * (y - m) / k, Y = !0), m += k;
            }
            if (ve && e.ellipse ? e.ellipse($, V, W, ee, pe, ne, ae, X) : e.arc($, V, me, ne, ae, X), Y)
              break e;
            M && (l = Ta(ne) * W + $, c = Oa(ne) * ee + V), u = Ta(ae) * W + $, d = Oa(ae) * ee + V;
            break;
          case Pe.R:
            l = u = n[E], c = d = n[E + 1], f = n[E++], h = n[E++];
            var q = n[E++], We = n[E++];
            if (v) {
              var k = p[w++];
              if (m + k > y) {
                var Ne = y - m;
                e.moveTo(f, h), e.lineTo(f + vd(Ne, q), h), Ne -= q, Ne > 0 && e.lineTo(f + q, h + vd(Ne, We)), Ne -= We, Ne > 0 && e.lineTo(f + pd(q - Ne, 0), h + We), Ne -= q, Ne > 0 && e.lineTo(f, h + pd(We - Ne, 0));
                break e;
              }
              m += k;
            }
            e.rect(f, h, q, We);
            break;
          case Pe.Z:
            if (v) {
              var k = p[w++];
              if (m + k > y) {
                var L = (y - m) / k;
                e.lineTo(u * (1 - L) + l * L, d * (1 - L) + c * L);
                break e;
              }
              m += k;
            }
            e.closePath(), u = l, d = c;
        }
      }
  }, t.prototype.clone = function() {
    var e = new t(), r = this.data;
    return e.data = r.slice ? r.slice() : Array.prototype.slice.call(r), e._len = this._len, e;
  }, t.CMD = Pe, t.initDefaultProps = function() {
    var e = t.prototype;
    e._saveData = !0, e._ux = 0, e._uy = 0, e._pendingPtDist = 0, e._version = 0;
  }(), t;
}();
function Io(t, e, r, n, a, o, i) {
  if (a === 0)
    return !1;
  var l = a, c = 0, u = t;
  if (i > e + l && i > n + l || i < e - l && i < n - l || o > t + l && o > r + l || o < t - l && o < r - l)
    return !1;
  if (t !== r)
    c = (e - n) / (t - r), u = (t * n - r * e) / (t - r);
  else
    return Math.abs(o - t) <= l / 2;
  var d = c * o - i + u, f = d * d / (c * c + 1);
  return f <= l / 2 * l / 2;
}
function Uce(t, e, r, n, a, o, i, l, c, u, d) {
  if (c === 0)
    return !1;
  var f = c;
  if (d > e + f && d > n + f && d > o + f && d > l + f || d < e - f && d < n - f && d < o - f && d < l - f || u > t + f && u > r + f && u > a + f && u > i + f || u < t - f && u < r - f && u < a - f && u < i - f)
    return !1;
  var h = rse(t, e, r, n, a, o, i, l, u, d);
  return h <= f / 2;
}
function Yce(t, e, r, n, a, o, i, l, c) {
  if (i === 0)
    return !1;
  var u = i;
  if (c > e + u && c > n + u && c > o + u || c < e - u && c < n - u && c < o - u || l > t + u && l > r + u && l > a + u || l < t - u && l < r - u && l < a - u)
    return !1;
  var d = ose(t, e, r, n, a, o, l, c);
  return d <= u / 2;
}
var Ug = Math.PI * 2;
function wc(t) {
  return t %= Ug, t < 0 && (t += Ug), t;
}
var al = Math.PI * 2;
function Xce(t, e, r, n, a, o, i, l, c) {
  if (i === 0)
    return !1;
  var u = i;
  l -= t, c -= e;
  var d = Math.sqrt(l * l + c * c);
  if (d - u > r || d + u < r)
    return !1;
  if (Math.abs(n - a) % al < 1e-4)
    return !0;
  if (o) {
    var f = n;
    n = wc(a), a = wc(f);
  } else
    n = wc(n), a = wc(a);
  n > a && (a += al);
  var h = Math.atan2(c, l);
  return h < 0 && (h += al), h >= n && h <= a || h + al >= n && h + al <= a;
}
function vn(t, e, r, n, a, o) {
  if (o > e && o > n || o < e && o < n || n === e)
    return 0;
  var i = (o - e) / (n - e), l = n < e ? 1 : -1;
  (i === 1 || i === 0) && (l = n < e ? 0.5 : -0.5);
  var c = i * (r - t) + t;
  return c === a ? 1 / 0 : c > a ? l : 0;
}
var Tn = io.CMD, Ia = Math.PI * 2, qce = 1e-4;
function Kce(t, e) {
  return Math.abs(t - e) < qce;
}
var St = [-1, -1, -1], ur = [-1, -1];
function Qce() {
  var t = ur[0];
  ur[0] = ur[1], ur[1] = t;
}
function Jce(t, e, r, n, a, o, i, l, c, u) {
  if (u > e && u > n && u > o && u > l || u < e && u < n && u < o && u < l)
    return 0;
  var d = G0(e, n, o, l, u, St);
  if (d === 0)
    return 0;
  for (var f = 0, h = -1, v = void 0, p = void 0, g = 0; g < d; g++) {
    var m = St[g], w = m === 0 || m === 1 ? 0.5 : 1, y = ut(t, r, a, i, m);
    y < c || (h < 0 && (h = qb(e, n, o, l, ur), ur[1] < ur[0] && h > 1 && Qce(), v = ut(e, n, o, l, ur[0]), h > 1 && (p = ut(e, n, o, l, ur[1]))), h === 2 ? m < ur[0] ? f += v < e ? w : -w : m < ur[1] ? f += p < v ? w : -w : f += l < p ? w : -w : m < ur[0] ? f += v < e ? w : -w : f += l < v ? w : -w);
  }
  return f;
}
function e0e(t, e, r, n, a, o, i, l) {
  if (l > e && l > n && l > o || l < e && l < n && l < o)
    return 0;
  var c = ase(e, n, o, l, St);
  if (c === 0)
    return 0;
  var u = Kb(e, n, o);
  if (u >= 0 && u <= 1) {
    for (var d = 0, f = $t(e, n, o, u), h = 0; h < c; h++) {
      var v = St[h] === 0 || St[h] === 1 ? 0.5 : 1, p = $t(t, r, a, St[h]);
      p < i || (St[h] < u ? d += f < e ? v : -v : d += o < f ? v : -v);
    }
    return d;
  } else {
    var v = St[0] === 0 || St[0] === 1 ? 0.5 : 1, p = $t(t, r, a, St[0]);
    return p < i ? 0 : o < e ? v : -v;
  }
}
function t0e(t, e, r, n, a, o, i, l) {
  if (l -= e, l > r || l < -r)
    return 0;
  var c = Math.sqrt(r * r - l * l);
  St[0] = -c, St[1] = c;
  var u = Math.abs(n - a);
  if (u < 1e-4)
    return 0;
  if (u >= Ia - 1e-4) {
    n = 0, a = Ia;
    var d = o ? 1 : -1;
    return i >= St[0] + t && i <= St[1] + t ? d : 0;
  }
  if (n > a) {
    var f = n;
    n = a, a = f;
  }
  n < 0 && (n += Ia, a += Ia);
  for (var h = 0, v = 0; v < 2; v++) {
    var p = St[v];
    if (p + t > i) {
      var g = Math.atan2(l, p), d = o ? 1 : -1;
      g < 0 && (g = Ia + g), (g >= n && g <= a || g + Ia >= n && g + Ia <= a) && (g > Math.PI / 2 && g < Math.PI * 1.5 && (d = -d), h += d);
    }
  }
  return h;
}
function E9(t, e, r, n, a) {
  for (var o = t.data, i = t.len(), l = 0, c = 0, u = 0, d = 0, f = 0, h, v, p = 0; p < i; ) {
    var g = o[p++], m = p === 1;
    switch (g === Tn.M && p > 1 && (r || (l += vn(c, u, d, f, n, a))), m && (c = o[p], u = o[p + 1], d = c, f = u), g) {
      case Tn.M:
        d = o[p++], f = o[p++], c = d, u = f;
        break;
      case Tn.L:
        if (r) {
          if (Io(c, u, o[p], o[p + 1], e, n, a))
            return !0;
        } else
          l += vn(c, u, o[p], o[p + 1], n, a) || 0;
        c = o[p++], u = o[p++];
        break;
      case Tn.C:
        if (r) {
          if (Uce(c, u, o[p++], o[p++], o[p++], o[p++], o[p], o[p + 1], e, n, a))
            return !0;
        } else
          l += Jce(c, u, o[p++], o[p++], o[p++], o[p++], o[p], o[p + 1], n, a) || 0;
        c = o[p++], u = o[p++];
        break;
      case Tn.Q:
        if (r) {
          if (Yce(c, u, o[p++], o[p++], o[p], o[p + 1], e, n, a))
            return !0;
        } else
          l += e0e(c, u, o[p++], o[p++], o[p], o[p + 1], n, a) || 0;
        c = o[p++], u = o[p++];
        break;
      case Tn.A:
        var w = o[p++], y = o[p++], b = o[p++], _ = o[p++], x = o[p++], E = o[p++];
        p += 1;
        var S = !!(1 - o[p++]);
        h = Math.cos(x) * b + w, v = Math.sin(x) * _ + y, m ? (d = h, f = v) : l += vn(c, u, h, v, n, a);
        var M = (n - w) * _ / b + w;
        if (r) {
          if (Xce(w, y, _, x, x + E, S, e, M, a))
            return !0;
        } else
          l += t0e(w, y, _, x, x + E, S, M, a);
        c = Math.cos(x + E) * b + w, u = Math.sin(x + E) * _ + y;
        break;
      case Tn.R:
        d = c = o[p++], f = u = o[p++];
        var R = o[p++], A = o[p++];
        if (h = d + R, v = f + A, r) {
          if (Io(d, f, h, f, e, n, a) || Io(h, f, h, v, e, n, a) || Io(h, v, d, v, e, n, a) || Io(d, v, d, f, e, n, a))
            return !0;
        } else
          l += vn(h, f, h, v, n, a), l += vn(d, v, d, f, n, a);
        break;
      case Tn.Z:
        if (r) {
          if (Io(c, u, d, f, e, n, a))
            return !0;
        } else
          l += vn(c, u, d, f, n, a);
        c = d, u = f;
        break;
    }
  }
  return !r && !Kce(u, f) && (l += vn(c, u, d, f, n, a) || 0), l !== 0;
}
function r0e(t, e, r) {
  return E9(t, 0, !1, e, r);
}
function n0e(t, e, r, n) {
  return E9(t, e, !0, r, n);
}
var S9 = Te({
  fill: "#000",
  stroke: null,
  strokePercent: 1,
  fillOpacity: 1,
  strokeOpacity: 1,
  lineDashOffset: 0,
  lineWidth: 1,
  lineCap: "butt",
  miterLimit: 10,
  strokeNoScale: !1,
  strokeFirst: !1
}, qa), a0e = {
  style: Te({
    fill: !0,
    stroke: !0,
    strokePercent: !0,
    fillOpacity: !0,
    strokeOpacity: !0,
    lineDashOffset: !0,
    lineWidth: !0,
    miterLimit: !0
  }, M1.style)
}, wd = Ql.concat([
  "invisible",
  "culling",
  "z",
  "z2",
  "zlevel",
  "parent"
]), Ie = function(t) {
  Be(e, t);
  function e(r) {
    return t.call(this, r) || this;
  }
  return e.prototype.update = function() {
    var r = this;
    t.prototype.update.call(this);
    var n = this.style;
    if (n.decal) {
      var a = this._decalEl = this._decalEl || new e();
      a.buildPath === e.prototype.buildPath && (a.buildPath = function(c) {
        r.buildPath(c, r.shape);
      }), a.silent = !0;
      var o = a.style;
      for (var i in n)
        o[i] !== n[i] && (o[i] = n[i]);
      o.fill = n.fill ? n.decal : null, o.decal = null, o.shadowColor = null, n.strokeFirst && (o.stroke = null);
      for (var l = 0; l < wd.length; ++l)
        a[wd[l]] = this[wd[l]];
      a.__dirty |= qt;
    } else this._decalEl && (this._decalEl = null);
  }, e.prototype.getDecalElement = function() {
    return this._decalEl;
  }, e.prototype._init = function(r) {
    var n = Ze(r);
    this.shape = this.getDefaultShape();
    var a = this.getDefaultStyle();
    a && this.useStyle(a);
    for (var o = 0; o < n.length; o++) {
      var i = n[o], l = r[i];
      i === "style" ? this.style ? H(this.style, l) : this.useStyle(l) : i === "shape" ? H(this.shape, l) : t.prototype.attrKV.call(this, i, l);
    }
    this.style || this.useStyle({});
  }, e.prototype.getDefaultStyle = function() {
    return null;
  }, e.prototype.getDefaultShape = function() {
    return {};
  }, e.prototype.canBeInsideText = function() {
    return this.hasFill();
  }, e.prototype.getInsideTextFill = function() {
    var r = this.style.fill;
    if (r !== "none") {
      if (Q(r)) {
        var n = Kl(r, 0);
        return n > 0.5 ? Lh : n > 0.2 ? Pse : Th;
      } else if (r)
        return Th;
    }
    return Lh;
  }, e.prototype.getInsideTextStroke = function(r) {
    var n = this.style.fill;
    if (Q(n)) {
      var a = this.__zr, o = !!(a && a.isDarkMode()), i = Kl(r, 0) < kh;
      if (o === i)
        return n;
    }
  }, e.prototype.buildPath = function(r, n, a) {
  }, e.prototype.pathUpdated = function() {
    this.__dirty &= ~Xo;
  }, e.prototype.getUpdatedPathProxy = function(r) {
    return !this.path && this.createPathProxy(), this.path.beginPath(), this.buildPath(this.path, this.shape, r), this.path;
  }, e.prototype.createPathProxy = function() {
    this.path = new io(!1);
  }, e.prototype.hasStroke = function() {
    var r = this.style, n = r.stroke;
    return !(n == null || n === "none" || !(r.lineWidth > 0));
  }, e.prototype.hasFill = function() {
    var r = this.style, n = r.fill;
    return n != null && n !== "none";
  }, e.prototype.getBoundingRect = function() {
    var r = this._rect, n = this.style, a = !r;
    if (a) {
      var o = !1;
      this.path || (o = !0, this.createPathProxy());
      var i = this.path;
      (o || this.__dirty & Xo) && (i.beginPath(), this.buildPath(i, this.shape, !1), this.pathUpdated()), r = i.getBoundingRect();
    }
    if (this._rect = r, this.hasStroke() && this.path && this.path.len() > 0) {
      var l = this._rectStroke || (this._rectStroke = r.clone());
      if (this.__dirty || a) {
        l.copy(r);
        var c = n.strokeNoScale ? this.getLineScale() : 1, u = n.lineWidth;
        if (!this.hasFill()) {
          var d = this.strokeContainThreshold;
          u = Math.max(u, d ?? 4);
        }
        c > 1e-10 && (l.width += u / c, l.height += u / c, l.x -= u / c / 2, l.y -= u / c / 2);
      }
      return l;
    }
    return r;
  }, e.prototype.contain = function(r, n) {
    var a = this.transformCoordToLocal(r, n), o = this.getBoundingRect(), i = this.style;
    if (r = a[0], n = a[1], o.contain(r, n)) {
      var l = this.path;
      if (this.hasStroke()) {
        var c = i.lineWidth, u = i.strokeNoScale ? this.getLineScale() : 1;
        if (u > 1e-10 && (this.hasFill() || (c = Math.max(c, this.strokeContainThreshold)), n0e(l, c / u, r, n)))
          return !0;
      }
      if (this.hasFill())
        return r0e(l, r, n);
    }
    return !1;
  }, e.prototype.dirtyShape = function() {
    this.__dirty |= Xo, this._rect && (this._rect = null), this._decalEl && this._decalEl.dirtyShape(), this.markRedraw();
  }, e.prototype.dirty = function() {
    this.dirtyStyle(), this.dirtyShape();
  }, e.prototype.animateShape = function(r) {
    return this.animate("shape", r);
  }, e.prototype.updateDuringAnimation = function(r) {
    r === "style" ? this.dirtyStyle() : r === "shape" ? this.dirtyShape() : this.markRedraw();
  }, e.prototype.attrKV = function(r, n) {
    r === "shape" ? this.setShape(n) : t.prototype.attrKV.call(this, r, n);
  }, e.prototype.setShape = function(r, n) {
    var a = this.shape;
    return a || (a = this.shape = {}), typeof r == "string" ? a[r] = n : H(a, r), this.dirtyShape(), this;
  }, e.prototype.shapeChanged = function() {
    return !!(this.__dirty & Xo);
  }, e.prototype.createStyle = function(r) {
    return ks(S9, r);
  }, e.prototype._innerSaveToNormal = function(r) {
    t.prototype._innerSaveToNormal.call(this, r);
    var n = this._normalState;
    r.shape && !n.shape && (n.shape = H({}, this.shape));
  }, e.prototype._applyStateObj = function(r, n, a, o, i, l) {
    t.prototype._applyStateObj.call(this, r, n, a, o, i, l);
    var c = !(n && o), u;
    if (n && n.shape ? i ? o ? u = n.shape : (u = H({}, a.shape), H(u, n.shape)) : (u = H({}, o ? this.shape : a.shape), H(u, n.shape)) : c && (u = a.shape), u)
      if (i) {
        this.shape = H({}, this.shape);
        for (var d = {}, f = Ze(u), h = 0; h < f.length; h++) {
          var v = f[h];
          typeof u[v] == "object" ? this.shape[v] = u[v] : d[v] = u[v];
        }
        this._transitionState(r, {
          shape: d
        }, l);
      } else
        this.shape = u, this.dirtyShape();
  }, e.prototype._mergeStates = function(r) {
    for (var n = t.prototype._mergeStates.call(this, r), a, o = 0; o < r.length; o++) {
      var i = r[o];
      i.shape && (a = a || {}, this._mergeStyle(a, i.shape));
    }
    return a && (n.shape = a), n;
  }, e.prototype.getAnimationStyleProps = function() {
    return a0e;
  }, e.prototype.isZeroArea = function() {
    return !1;
  }, e.extend = function(r) {
    var n = function(o) {
      Be(i, o);
      function i(l) {
        var c = o.call(this, l) || this;
        return r.init && r.init.call(c, l), c;
      }
      return i.prototype.getDefaultStyle = function() {
        return be(r.style);
      }, i.prototype.getDefaultShape = function() {
        return be(r.shape);
      }, i;
    }(e);
    for (var a in r)
      typeof r[a] == "function" && (n.prototype[a] = r[a]);
    return n;
  }, e.initDefaultProps = function() {
    var r = e.prototype;
    r.type = "path", r.strokeContainThreshold = 5, r.segmentIgnoreThreshold = 0, r.subPixelOptimize = !1, r.autoBatch = !1, r.__dirty = qt | Cl | Xo;
  }(), e;
}(Ns), o0e = Te({
  strokeFirst: !0,
  font: ro,
  x: 0,
  y: 0,
  textAlign: "left",
  textBaseline: "top",
  miterLimit: 2
}, S9), eu = function(t) {
  Be(e, t);
  function e() {
    return t !== null && t.apply(this, arguments) || this;
  }
  return e.prototype.hasStroke = function() {
    var r = this.style, n = r.stroke;
    return n != null && n !== "none" && r.lineWidth > 0;
  }, e.prototype.hasFill = function() {
    var r = this.style, n = r.fill;
    return n != null && n !== "none";
  }, e.prototype.createStyle = function(r) {
    return ks(o0e, r);
  }, e.prototype.setBoundingRect = function(r) {
    this._rect = r;
  }, e.prototype.getBoundingRect = function() {
    var r = this.style;
    if (!this._rect) {
      var n = r.text;
      n != null ? n += "" : n = "";
      var a = zv(n, r.font, r.textAlign, r.textBaseline);
      if (a.x += r.x || 0, a.y += r.y || 0, this.hasStroke()) {
        var o = r.lineWidth;
        a.x -= o / 2, a.y -= o / 2, a.width += o, a.height += o;
      }
      this._rect = a;
    }
    return this._rect;
  }, e.initDefaultProps = function() {
    var r = e.prototype;
    r.dirtyRectTolerance = 10;
  }(), e;
}(Ns);
eu.prototype.type = "tspan";
var i0e = Te({
  x: 0,
  y: 0
}, qa), l0e = {
  style: Te({
    x: !0,
    y: !0,
    width: !0,
    height: !0,
    sx: !0,
    sy: !0,
    sWidth: !0,
    sHeight: !0
  }, M1.style)
};
function s0e(t) {
  return !!(t && typeof t != "string" && t.width && t.height);
}
var nn = function(t) {
  Be(e, t);
  function e() {
    return t !== null && t.apply(this, arguments) || this;
  }
  return e.prototype.createStyle = function(r) {
    return ks(i0e, r);
  }, e.prototype._getSize = function(r) {
    var n = this.style, a = n[r];
    if (a != null)
      return a;
    var o = s0e(n.image) ? n.image : this.__image;
    if (!o)
      return 0;
    var i = r === "width" ? "height" : "width", l = n[i];
    return l == null ? o[r] : o[r] / o[i] * l;
  }, e.prototype.getWidth = function() {
    return this._getSize("width");
  }, e.prototype.getHeight = function() {
    return this._getSize("height");
  }, e.prototype.getAnimationStyleProps = function() {
    return l0e;
  }, e.prototype.getBoundingRect = function() {
    var r = this.style;
    return this._rect || (this._rect = new Le(r.x || 0, r.y || 0, this.getWidth(), this.getHeight())), this._rect;
  }, e;
}(Ns);
nn.prototype.type = "image";
function c0e(t, e) {
  var r = e.x, n = e.y, a = e.width, o = e.height, i = e.r, l, c, u, d;
  a < 0 && (r = r + a, a = -a), o < 0 && (n = n + o, o = -o), typeof i == "number" ? l = c = u = d = i : i instanceof Array ? i.length === 1 ? l = c = u = d = i[0] : i.length === 2 ? (l = u = i[0], c = d = i[1]) : i.length === 3 ? (l = i[0], c = d = i[1], u = i[2]) : (l = i[0], c = i[1], u = i[2], d = i[3]) : l = c = u = d = 0;
  var f;
  l + c > a && (f = l + c, l *= a / f, c *= a / f), u + d > a && (f = u + d, u *= a / f, d *= a / f), c + u > o && (f = c + u, c *= o / f, u *= o / f), l + d > o && (f = l + d, l *= o / f, d *= o / f), t.moveTo(r + l, n), t.lineTo(r + a - c, n), c !== 0 && t.arc(r + a - c, n + c, c, -Math.PI / 2, 0), t.lineTo(r + a, n + o - u), u !== 0 && t.arc(r + a - u, n + o - u, u, 0, Math.PI / 2), t.lineTo(r + d, n + o), d !== 0 && t.arc(r + d, n + o - d, d, Math.PI / 2, Math.PI), t.lineTo(r, n + l), l !== 0 && t.arc(r + l, n + l, l, Math.PI, Math.PI * 1.5);
}
var ei = Math.round;
function R9(t, e, r) {
  if (e) {
    var n = e.x1, a = e.x2, o = e.y1, i = e.y2;
    t.x1 = n, t.x2 = a, t.y1 = o, t.y2 = i;
    var l = r && r.lineWidth;
    return l && (ei(n * 2) === ei(a * 2) && (t.x1 = t.x2 = za(n, l, !0)), ei(o * 2) === ei(i * 2) && (t.y1 = t.y2 = za(o, l, !0))), t;
  }
}
function M9(t, e, r) {
  if (e) {
    var n = e.x, a = e.y, o = e.width, i = e.height;
    t.x = n, t.y = a, t.width = o, t.height = i;
    var l = r && r.lineWidth;
    return l && (t.x = za(n, l, !0), t.y = za(a, l, !0), t.width = Math.max(za(n + o, l, !1) - t.x, o === 0 ? 0 : 1), t.height = Math.max(za(a + i, l, !1) - t.y, i === 0 ? 0 : 1)), t;
  }
}
function za(t, e, r) {
  if (!e)
    return t;
  var n = ei(t * 2);
  return (n + ei(e)) % 2 === 0 ? n / 2 : (n + (r ? 1 : -1)) / 2;
}
var u0e = /* @__PURE__ */ function() {
  function t() {
    this.x = 0, this.y = 0, this.width = 0, this.height = 0;
  }
  return t;
}(), d0e = {}, He = function(t) {
  Be(e, t);
  function e(r) {
    return t.call(this, r) || this;
  }
  return e.prototype.getDefaultShape = function() {
    return new u0e();
  }, e.prototype.buildPath = function(r, n) {
    var a, o, i, l;
    if (this.subPixelOptimize) {
      var c = M9(d0e, n, this.style);
      a = c.x, o = c.y, i = c.width, l = c.height, c.r = n.r, n = c;
    } else
      a = n.x, o = n.y, i = n.width, l = n.height;
    n.r ? c0e(r, n) : r.rect(a, o, i, l);
  }, e.prototype.isZeroArea = function() {
    return !this.shape.width || !this.shape.height;
  }, e;
}(Ie);
He.prototype.type = "rect";
var Yg = {
  fill: "#000"
}, Xg = 2, f0e = {
  style: Te({
    fill: !0,
    stroke: !0,
    fillOpacity: !0,
    strokeOpacity: !0,
    lineWidth: !0,
    fontSize: !0,
    lineHeight: !0,
    width: !0,
    height: !0,
    textShadowColor: !0,
    textShadowBlur: !0,
    textShadowOffsetX: !0,
    textShadowOffsetY: !0,
    backgroundColor: !0,
    padding: !0,
    borderColor: !0,
    borderWidth: !0,
    borderRadius: !0
  }, M1.style)
}, Ye = function(t) {
  Be(e, t);
  function e(r) {
    var n = t.call(this) || this;
    return n.type = "text", n._children = [], n._defaultStyle = Yg, n.attr(r), n;
  }
  return e.prototype.childrenRef = function() {
    return this._children;
  }, e.prototype.update = function() {
    t.prototype.update.call(this), this.styleChanged() && this._updateSubTexts();
    for (var r = 0; r < this._children.length; r++) {
      var n = this._children[r];
      n.zlevel = this.zlevel, n.z = this.z, n.z2 = this.z2, n.culling = this.culling, n.cursor = this.cursor, n.invisible = this.invisible;
    }
  }, e.prototype.updateTransform = function() {
    var r = this.innerTransformable;
    r ? (r.updateTransform(), r.transform && (this.transform = r.transform)) : t.prototype.updateTransform.call(this);
  }, e.prototype.getLocalTransform = function(r) {
    var n = this.innerTransformable;
    return n ? n.getLocalTransform(r) : t.prototype.getLocalTransform.call(this, r);
  }, e.prototype.getComputedTransform = function() {
    return this.__hostTarget && (this.__hostTarget.getComputedTransform(), this.__hostTarget.updateInnerText(!0)), t.prototype.getComputedTransform.call(this);
  }, e.prototype._updateSubTexts = function() {
    this._childCursor = 0, m0e(this.style), this.style.rich ? this._updateRichTexts() : this._updatePlainTexts(), this._children.length = this._childCursor, this.styleUpdated();
  }, e.prototype.addSelfToZr = function(r) {
    t.prototype.addSelfToZr.call(this, r);
    for (var n = 0; n < this._children.length; n++)
      this._children[n].__zr = r;
  }, e.prototype.removeSelfFromZr = function(r) {
    t.prototype.removeSelfFromZr.call(this, r);
    for (var n = 0; n < this._children.length; n++)
      this._children[n].__zr = null;
  }, e.prototype.getBoundingRect = function() {
    if (this.styleChanged() && this._updateSubTexts(), !this._rect) {
      for (var r = new Le(0, 0, 0, 0), n = this._children, a = [], o = null, i = 0; i < n.length; i++) {
        var l = n[i], c = l.getBoundingRect(), u = l.getLocalTransform(a);
        u ? (r.copy(c), r.applyTransform(u), o = o || r.clone(), o.union(r)) : (o = o || c.clone(), o.union(c));
      }
      this._rect = o || r;
    }
    return this._rect;
  }, e.prototype.setDefaultTextStyle = function(r) {
    this._defaultStyle = r || Yg;
  }, e.prototype.setTextContent = function(r) {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Can't attach text on another text");
  }, e.prototype._mergeStyle = function(r, n) {
    if (!n)
      return r;
    var a = n.rich, o = r.rich || a && {};
    return H(r, n), a && o ? (this._mergeRich(o, a), r.rich = o) : o && (r.rich = o), r;
  }, e.prototype._mergeRich = function(r, n) {
    for (var a = Ze(n), o = 0; o < a.length; o++) {
      var i = a[o];
      r[i] = r[i] || {}, H(r[i], n[i]);
    }
  }, e.prototype.getAnimationStyleProps = function() {
    return f0e;
  }, e.prototype._getOrCreateChild = function(r) {
    var n = this._children[this._childCursor];
    return (!n || !(n instanceof r)) && (n = new r()), this._children[this._childCursor++] = n, n.__zr = this.__zr, n.parent = this, n;
  }, e.prototype._updatePlainTexts = function() {
    var r = this.style, n = r.font || ro, a = r.padding, o = rm(r), i = Dce(o, r), l = yd(r), c = !!r.backgroundColor, u = i.outerHeight, d = i.outerWidth, f = i.contentWidth, h = i.lines, v = i.lineHeight, p = this._defaultStyle, g = r.x || 0, m = r.y || 0, w = r.align || p.align || "left", y = r.verticalAlign || p.verticalAlign || "top", b = g, _ = qo(m, i.contentHeight, y);
    if (l || a) {
      var x = Sl(g, d, w), E = qo(m, u, y);
      l && this._renderBackground(r, r, x, E, d, u);
    }
    _ += v / 2, a && (b = tm(g, w, a), y === "top" ? _ += a[0] : y === "bottom" && (_ -= a[2]));
    for (var S = 0, M = !1, R = em("fill" in r ? r.fill : (M = !0, p.fill)), A = Jg("stroke" in r ? r.stroke : !c && (!p.autoStroke || M) ? (S = Xg, p.stroke) : null), k = r.textShadowBlur > 0, L = r.width != null && (r.overflow === "truncate" || r.overflow === "break" || r.overflow === "breakAll"), T = i.calculatedLineHeight, O = 0; O < h.length; O++) {
      var D = this._getOrCreateChild(eu), P = D.createStyle();
      D.useStyle(P), P.text = h[O], P.x = b, P.y = _, w && (P.textAlign = w), P.textBaseline = "middle", P.opacity = r.opacity, P.strokeFirst = !0, k && (P.shadowBlur = r.textShadowBlur || 0, P.shadowColor = r.textShadowColor || "transparent", P.shadowOffsetX = r.textShadowOffsetX || 0, P.shadowOffsetY = r.textShadowOffsetY || 0), P.stroke = A, P.fill = R, A && (P.lineWidth = r.lineWidth || S, P.lineDash = r.lineDash, P.lineDashOffset = r.lineDashOffset || 0), P.font = n, Kg(P, r), _ += v, L && D.setBoundingRect(new Le(Sl(P.x, r.width, P.textAlign), qo(P.y, T, P.textBaseline), f, T));
    }
  }, e.prototype._updateRichTexts = function() {
    var r = this.style, n = rm(r), a = Fce(n, r), o = a.width, i = a.outerWidth, l = a.outerHeight, c = r.padding, u = r.x || 0, d = r.y || 0, f = this._defaultStyle, h = r.align || f.align, v = r.verticalAlign || f.verticalAlign, p = Sl(u, i, h), g = qo(d, l, v), m = p, w = g;
    c && (m += c[3], w += c[0]);
    var y = m + o;
    yd(r) && this._renderBackground(r, r, p, g, i, l);
    for (var b = !!r.backgroundColor, _ = 0; _ < a.lines.length; _++) {
      for (var x = a.lines[_], E = x.tokens, S = E.length, M = x.lineHeight, R = x.width, A = 0, k = m, L = y, T = S - 1, O = void 0; A < S && (O = E[A], !O.align || O.align === "left"); )
        this._placeToken(O, r, M, w, k, "left", b), R -= O.width, k += O.width, A++;
      for (; T >= 0 && (O = E[T], O.align === "right"); )
        this._placeToken(O, r, M, w, L, "right", b), R -= O.width, L -= O.width, T--;
      for (k += (o - (k - m) - (y - L) - R) / 2; A <= T; )
        O = E[A], this._placeToken(O, r, M, w, k + O.width / 2, "center", b), k += O.width, A++;
      w += M;
    }
  }, e.prototype._placeToken = function(r, n, a, o, i, l, c) {
    var u = n.rich[r.styleName] || {};
    u.text = r.text;
    var d = r.verticalAlign, f = o + a / 2;
    d === "top" ? f = o + r.height / 2 : d === "bottom" && (f = o + a - r.height / 2);
    var h = !r.isLineHolder && yd(u);
    h && this._renderBackground(u, n, l === "right" ? i - r.width : l === "center" ? i - r.width / 2 : i, f - r.height / 2, r.width, r.height);
    var v = !!u.backgroundColor, p = r.textPadding;
    p && (i = tm(i, l, p), f -= r.height / 2 - p[0] - r.innerHeight / 2);
    var g = this._getOrCreateChild(eu), m = g.createStyle();
    g.useStyle(m);
    var w = this._defaultStyle, y = !1, b = 0, _ = em("fill" in u ? u.fill : "fill" in n ? n.fill : (y = !0, w.fill)), x = Jg("stroke" in u ? u.stroke : "stroke" in n ? n.stroke : !v && !c && (!w.autoStroke || y) ? (b = Xg, w.stroke) : null), E = u.textShadowBlur > 0 || n.textShadowBlur > 0;
    m.text = r.text, m.x = i, m.y = f, E && (m.shadowBlur = u.textShadowBlur || n.textShadowBlur || 0, m.shadowColor = u.textShadowColor || n.textShadowColor || "transparent", m.shadowOffsetX = u.textShadowOffsetX || n.textShadowOffsetX || 0, m.shadowOffsetY = u.textShadowOffsetY || n.textShadowOffsetY || 0), m.textAlign = l, m.textBaseline = "middle", m.font = r.font || ro, m.opacity = ea(u.opacity, n.opacity, 1), Kg(m, u), x && (m.lineWidth = ea(u.lineWidth, n.lineWidth, b), m.lineDash = de(u.lineDash, n.lineDash), m.lineDashOffset = n.lineDashOffset || 0, m.stroke = x), _ && (m.fill = _);
    var S = r.contentWidth, M = r.contentHeight;
    g.setBoundingRect(new Le(Sl(m.x, S, m.textAlign), qo(m.y, M, m.textBaseline), S, M));
  }, e.prototype._renderBackground = function(r, n, a, o, i, l) {
    var c = r.backgroundColor, u = r.borderWidth, d = r.borderColor, f = c && c.image, h = c && !f, v = r.borderRadius, p = this, g, m;
    if (h || r.lineHeight || u && d) {
      g = this._getOrCreateChild(He), g.useStyle(g.createStyle()), g.style.fill = null;
      var w = g.shape;
      w.x = a, w.y = o, w.width = i, w.height = l, w.r = v, g.dirtyShape();
    }
    if (h) {
      var y = g.style;
      y.fill = c || null, y.fillOpacity = de(r.fillOpacity, 1);
    } else if (f) {
      m = this._getOrCreateChild(nn), m.onload = function() {
        p.dirtyStyle();
      };
      var b = m.style;
      b.image = c.image, b.x = a, b.y = o, b.width = i, b.height = l;
    }
    if (u && d) {
      var y = g.style;
      y.lineWidth = u, y.stroke = d, y.strokeOpacity = de(r.strokeOpacity, 1), y.lineDash = r.borderDash, y.lineDashOffset = r.borderDashOffset || 0, g.strokeContainThreshold = 0, g.hasFill() && g.hasStroke() && (y.strokeFirst = !0, y.lineWidth *= 2);
    }
    var _ = (g || m).style;
    _.shadowBlur = r.shadowBlur || 0, _.shadowColor = r.shadowColor || "transparent", _.shadowOffsetX = r.shadowOffsetX || 0, _.shadowOffsetY = r.shadowOffsetY || 0, _.opacity = ea(r.opacity, n.opacity, 1);
  }, e.makeFont = function(r) {
    var n = "";
    return g0e(r) && (n = [
      r.fontStyle,
      r.fontWeight,
      p0e(r.fontSize),
      r.fontFamily || "sans-serif"
    ].join(" ")), n && Ir(n) || r.textFont || r.font;
  }, e;
}(Ns), h0e = { left: !0, right: 1, center: 1 }, v0e = { top: 1, bottom: 1, middle: 1 }, qg = ["fontStyle", "fontWeight", "fontSize", "fontFamily"];
function p0e(t) {
  return typeof t == "string" && (t.indexOf("px") !== -1 || t.indexOf("rem") !== -1 || t.indexOf("em") !== -1) ? t : isNaN(+t) ? Lv + "px" : t + "px";
}
function Kg(t, e) {
  for (var r = 0; r < qg.length; r++) {
    var n = qg[r], a = e[n];
    a != null && (t[n] = a);
  }
}
function g0e(t) {
  return t.fontSize != null || t.fontFamily || t.fontWeight;
}
function m0e(t) {
  return Qg(t), I(t.rich, Qg), t;
}
function Qg(t) {
  if (t) {
    t.font = Ye.makeFont(t);
    var e = t.align;
    e === "middle" && (e = "center"), t.align = e == null || h0e[e] ? e : "left";
    var r = t.verticalAlign;
    r === "center" && (r = "middle"), t.verticalAlign = r == null || v0e[r] ? r : "top";
    var n = t.padding;
    n && (t.padding = Dv(t.padding));
  }
}
function Jg(t, e) {
  return t == null || e <= 0 || t === "transparent" || t === "none" ? null : t.image || t.colorStops ? "#000" : t;
}
function em(t) {
  return t == null || t === "none" ? null : t.image || t.colorStops ? "#000" : t;
}
function tm(t, e, r) {
  return e === "right" ? t - r[1] : e === "center" ? t + r[3] / 2 - r[1] / 2 : t + r[3];
}
function rm(t) {
  var e = t.text;
  return e != null && (e += ""), e;
}
function yd(t) {
  return !!(t.backgroundColor || t.lineHeight || t.borderWidth && t.borderColor);
}
var Se = je(), Bh = function(t, e, r, n) {
  if (n) {
    var a = Se(n);
    a.dataIndex = r, a.dataType = e, a.seriesIndex = t, a.ssrType = "chart", n.type === "group" && n.traverse(function(o) {
      var i = Se(o);
      i.seriesIndex = t, i.dataIndex = r, i.dataType = e, i.ssrType = "chart";
    });
  }
}, nm = 1, am = {}, A9 = je(), t7 = je(), r7 = 0, A1 = 1, k1 = 2, Wt = ["emphasis", "blur", "select"], tu = ["normal", "emphasis", "blur", "select"], w0e = 10, y0e = 9, Ka = "highlight", w0 = "downplay", Dl = "select", y0 = "unselect", Nl = "toggleSelect";
function Po(t) {
  return t != null && t !== "none";
}
function L1(t, e, r) {
  t.onHoverStateChange && (t.hoverState || 0) !== r && t.onHoverStateChange(e), t.hoverState = r;
}
function k9(t) {
  L1(t, "emphasis", k1);
}
function L9(t) {
  t.hoverState === k1 && L1(t, "normal", r7);
}
function n7(t) {
  L1(t, "blur", A1);
}
function T9(t) {
  t.hoverState === A1 && L1(t, "normal", r7);
}
function b0e(t) {
  t.selected = !0;
}
function _0e(t) {
  t.selected = !1;
}
function om(t, e, r) {
  e(t, r);
}
function Rn(t, e, r) {
  om(t, e, r), t.isGroup && t.traverse(function(n) {
    om(n, e, r);
  });
}
function im(t, e) {
  switch (e) {
    case "emphasis":
      t.hoverState = k1;
      break;
    case "normal":
      t.hoverState = r7;
      break;
    case "blur":
      t.hoverState = A1;
      break;
    case "select":
      t.selected = !0;
  }
}
function x0e(t, e, r, n) {
  for (var a = t.style, o = {}, i = 0; i < e.length; i++) {
    var l = e[i], c = a[l];
    o[l] = c ?? (n && n[l]);
  }
  for (var i = 0; i < t.animators.length; i++) {
    var u = t.animators[i];
    u.__fromStateTransition && u.__fromStateTransition.indexOf(r) < 0 && u.targetName === "style" && u.saveTo(o, e);
  }
  return o;
}
function C0e(t, e, r, n) {
  var a = r && Re(r, "select") >= 0, o = !1;
  if (t instanceof Ie) {
    var i = A9(t), l = a && i.selectFill || i.normalFill, c = a && i.selectStroke || i.normalStroke;
    if (Po(l) || Po(c)) {
      n = n || {};
      var u = n.style || {};
      u.fill === "inherit" ? (o = !0, n = H({}, n), u = H({}, u), u.fill = l) : !Po(u.fill) && Po(l) ? (o = !0, n = H({}, n), u = H({}, u), u.fill = Ch(l)) : !Po(u.stroke) && Po(c) && (o || (n = H({}, n), u = H({}, u)), u.stroke = Ch(c)), n.style = u;
    }
  }
  if (n && n.z2 == null) {
    o || (n = H({}, n));
    var d = t.z2EmphasisLift;
    n.z2 = t.z2 + (d ?? w0e);
  }
  return n;
}
function E0e(t, e, r) {
  if (r && r.z2 == null) {
    r = H({}, r);
    var n = t.z2SelectLift;
    r.z2 = t.z2 + (n ?? y0e);
  }
  return r;
}
function S0e(t, e, r) {
  var n = Re(t.currentStates, e) >= 0, a = t.style.opacity, o = n ? null : x0e(t, ["opacity"], e, {
    opacity: 1
  });
  r = r || {};
  var i = r.style || {};
  return i.opacity == null && (r = H({}, r), i = H({
    // Already being applied 'emphasis'. DON'T mul opacity multiple times.
    opacity: n ? a : o.opacity * 0.1
  }, i), r.style = i), r;
}
function bd(t, e) {
  var r = this.states[t];
  if (this.style) {
    if (t === "emphasis")
      return C0e(this, t, e, r);
    if (t === "blur")
      return S0e(this, t, r);
    if (t === "select")
      return E0e(this, t, r);
  }
  return r;
}
function R0e(t) {
  t.stateProxy = bd;
  var e = t.getTextContent(), r = t.getTextGuideLine();
  e && (e.stateProxy = bd), r && (r.stateProxy = bd);
}
function lm(t, e) {
  !D9(t, e) && !t.__highByOuter && Rn(t, k9);
}
function sm(t, e) {
  !D9(t, e) && !t.__highByOuter && Rn(t, L9);
}
function rs(t, e) {
  t.__highByOuter |= 1 << (e || 0), Rn(t, k9);
}
function ns(t, e) {
  !(t.__highByOuter &= ~(1 << (e || 0))) && Rn(t, L9);
}
function O9(t) {
  Rn(t, n7);
}
function a7(t) {
  Rn(t, T9);
}
function I9(t) {
  Rn(t, b0e);
}
function P9(t) {
  Rn(t, _0e);
}
function D9(t, e) {
  return t.__highDownSilentOnTouch && e.zrByTouch;
}
function N9(t) {
  var e = t.getModel(), r = [], n = [];
  e.eachComponent(function(a, o) {
    var i = t7(o), l = a === "series", c = l ? t.getViewOfSeriesModel(o) : t.getViewOfComponentModel(o);
    !l && n.push(c), i.isBlured && (c.group.traverse(function(u) {
      T9(u);
    }), l && r.push(o)), i.isBlured = !1;
  }), I(n, function(a) {
    a && a.toggleBlurSeries && a.toggleBlurSeries(r, !1, e);
  });
}
function Fh(t, e, r, n) {
  var a = n.getModel();
  r = r || "coordinateSystem";
  function o(u, d) {
    for (var f = 0; f < d.length; f++) {
      var h = u.getItemGraphicEl(d[f]);
      h && a7(h);
    }
  }
  if (t != null && !(!e || e === "none")) {
    var i = a.getSeriesByIndex(t), l = i.coordinateSystem;
    l && l.master && (l = l.master);
    var c = [];
    a.eachSeries(function(u) {
      var d = i === u, f = u.coordinateSystem;
      f && f.master && (f = f.master);
      var h = f && l ? f === l : d;
      if (!// Not blur other series if blurScope series
      (r === "series" && !d || r === "coordinateSystem" && !h || e === "series" && d)) {
        var v = n.getViewOfSeriesModel(u);
        if (v.group.traverse(function(m) {
          m.__highByOuter && d && e === "self" || n7(m);
        }), Lt(e))
          o(u.getData(), e);
        else if (re(e))
          for (var p = Ze(e), g = 0; g < p.length; g++)
            o(u.getData(p[g]), e[p[g]]);
        c.push(u), t7(u).isBlured = !0;
      }
    }), a.eachComponent(function(u, d) {
      if (u !== "series") {
        var f = n.getViewOfComponentModel(d);
        f && f.toggleBlurSeries && f.toggleBlurSeries(c, !0, a);
      }
    });
  }
}
function $h(t, e, r) {
  if (!(t == null || e == null)) {
    var n = r.getModel().getComponent(t, e);
    if (n) {
      t7(n).isBlured = !0;
      var a = r.getViewOfComponentModel(n);
      !a || !a.focusBlurEnabled || a.group.traverse(function(o) {
        n7(o);
      });
    }
  }
}
function M0e(t, e, r) {
  var n = t.seriesIndex, a = t.getData(e.dataType);
  if (!a) {
    process.env.NODE_ENV !== "production" && bt("Unknown dataType " + e.dataType);
    return;
  }
  var o = oo(a, e);
  o = (z(o) ? o[0] : o) || 0;
  var i = a.getItemGraphicEl(o);
  if (!i)
    for (var l = a.count(), c = 0; !i && c < l; )
      i = a.getItemGraphicEl(c++);
  if (i) {
    var u = Se(i);
    Fh(n, u.focus, u.blurScope, r);
  } else {
    var d = t.get(["emphasis", "focus"]), f = t.get(["emphasis", "blurScope"]);
    d != null && Fh(n, d, f, r);
  }
}
function o7(t, e, r, n) {
  var a = {
    focusSelf: !1,
    dispatchers: null
  };
  if (t == null || t === "series" || e == null || r == null)
    return a;
  var o = n.getModel().getComponent(t, e);
  if (!o)
    return a;
  var i = n.getViewOfComponentModel(o);
  if (!i || !i.findHighDownDispatchers)
    return a;
  for (var l = i.findHighDownDispatchers(r), c, u = 0; u < l.length; u++)
    if (process.env.NODE_ENV !== "production" && !Si(l[u]) && bt("param should be highDownDispatcher"), Se(l[u]).focus === "self") {
      c = !0;
      break;
    }
  return {
    focusSelf: c,
    dispatchers: l
  };
}
function A0e(t, e, r) {
  process.env.NODE_ENV !== "production" && !Si(t) && bt("param should be highDownDispatcher");
  var n = Se(t), a = o7(n.componentMainType, n.componentIndex, n.componentHighDownName, r), o = a.dispatchers, i = a.focusSelf;
  o ? (i && $h(n.componentMainType, n.componentIndex, r), I(o, function(l) {
    return lm(l, e);
  })) : (Fh(n.seriesIndex, n.focus, n.blurScope, r), n.focus === "self" && $h(n.componentMainType, n.componentIndex, r), lm(t, e));
}
function k0e(t, e, r) {
  process.env.NODE_ENV !== "production" && !Si(t) && bt("param should be highDownDispatcher"), N9(r);
  var n = Se(t), a = o7(n.componentMainType, n.componentIndex, n.componentHighDownName, r).dispatchers;
  a ? I(a, function(o) {
    return sm(o, e);
  }) : sm(t, e);
}
function L0e(t, e, r) {
  if (Vh(e)) {
    var n = e.dataType, a = t.getData(n), o = oo(a, e);
    z(o) || (o = [o]), t[e.type === Nl ? "toggleSelect" : e.type === Dl ? "select" : "unselect"](o, n);
  }
}
function cm(t) {
  var e = t.getAllData();
  I(e, function(r) {
    var n = r.data, a = r.type;
    n.eachItemGraphicEl(function(o, i) {
      t.isSelected(i, a) ? I9(o) : P9(o);
    });
  });
}
function T0e(t) {
  var e = [];
  return t.eachSeries(function(r) {
    var n = r.getAllData();
    I(n, function(a) {
      a.data;
      var o = a.type, i = r.getSelectedDataIndices();
      if (i.length > 0) {
        var l = {
          dataIndex: i,
          seriesIndex: r.seriesIndex
        };
        o != null && (l.dataType = o), e.push(l);
      }
    });
  }), e;
}
function as(t, e, r) {
  B9(t, !0), Rn(t, R0e), I0e(t, e, r);
}
function O0e(t) {
  B9(t, !1);
}
function ua(t, e, r, n) {
  n ? O0e(t) : as(t, e, r);
}
function I0e(t, e, r) {
  var n = Se(t);
  e != null ? (n.focus = e, n.blurScope = r) : n.focus && (n.focus = null);
}
var um = ["emphasis", "blur", "select"], P0e = {
  itemStyle: "getItemStyle",
  lineStyle: "getLineStyle",
  areaStyle: "getAreaStyle"
};
function Ei(t, e, r, n) {
  r = r || "itemStyle";
  for (var a = 0; a < um.length; a++) {
    var o = um[a], i = e.getModel([o, r]), l = t.ensureState(o);
    l.style = i[P0e[r]]();
  }
}
function B9(t, e) {
  var r = e === !1, n = t;
  t.highDownSilentOnTouch && (n.__highDownSilentOnTouch = t.highDownSilentOnTouch), (!r || n.__highDownDispatcher) && (n.__highByOuter = n.__highByOuter || 0, n.__highDownDispatcher = !r);
}
function Si(t) {
  return !!(t && t.__highDownDispatcher);
}
function D0e(t) {
  var e = am[t];
  return e == null && nm <= 32 && (e = am[t] = nm++), e;
}
function Vh(t) {
  var e = t.type;
  return e === Dl || e === y0 || e === Nl;
}
function dm(t) {
  var e = t.type;
  return e === Ka || e === w0;
}
function N0e(t) {
  var e = A9(t);
  e.normalFill = t.style.fill, e.normalStroke = t.style.stroke;
  var r = t.states.select || {};
  e.selectFill = r.style && r.style.fill || null, e.selectStroke = r.style && r.style.stroke || null;
}
var Do = io.CMD, B0e = [[], [], []], fm = Math.sqrt, F0e = Math.atan2;
function $0e(t, e) {
  if (e) {
    var r = t.data, n = t.len(), a, o, i, l, c, u, d = Do.M, f = Do.C, h = Do.L, v = Do.R, p = Do.A, g = Do.Q;
    for (i = 0, l = 0; i < n; ) {
      switch (a = r[i++], l = i, o = 0, a) {
        case d:
          o = 1;
          break;
        case h:
          o = 1;
          break;
        case f:
          o = 3;
          break;
        case g:
          o = 2;
          break;
        case p:
          var m = e[4], w = e[5], y = fm(e[0] * e[0] + e[1] * e[1]), b = fm(e[2] * e[2] + e[3] * e[3]), _ = F0e(-e[1] / b, e[0] / y);
          r[i] *= y, r[i++] += m, r[i] *= b, r[i++] += w, r[i++] *= y, r[i++] *= b, r[i++] += _, r[i++] += _, i += 2, l = i;
          break;
        case v:
          u[0] = r[i++], u[1] = r[i++], At(u, u, e), r[l++] = u[0], r[l++] = u[1], u[0] += r[i++], u[1] += r[i++], At(u, u, e), r[l++] = u[0], r[l++] = u[1];
      }
      for (c = 0; c < o; c++) {
        var x = B0e[c];
        x[0] = r[i++], x[1] = r[i++], At(x, x, e), r[l++] = x[0], r[l++] = x[1];
      }
    }
    t.increaseVersion();
  }
}
var _d = Math.sqrt, yc = Math.sin, bc = Math.cos, ol = Math.PI;
function hm(t) {
  return Math.sqrt(t[0] * t[0] + t[1] * t[1]);
}
function Zh(t, e) {
  return (t[0] * e[0] + t[1] * e[1]) / (hm(t) * hm(e));
}
function vm(t, e) {
  return (t[0] * e[1] < t[1] * e[0] ? -1 : 1) * Math.acos(Zh(t, e));
}
function pm(t, e, r, n, a, o, i, l, c, u, d) {
  var f = c * (ol / 180), h = bc(f) * (t - r) / 2 + yc(f) * (e - n) / 2, v = -1 * yc(f) * (t - r) / 2 + bc(f) * (e - n) / 2, p = h * h / (i * i) + v * v / (l * l);
  p > 1 && (i *= _d(p), l *= _d(p));
  var g = (a === o ? -1 : 1) * _d((i * i * (l * l) - i * i * (v * v) - l * l * (h * h)) / (i * i * (v * v) + l * l * (h * h))) || 0, m = g * i * v / l, w = g * -l * h / i, y = (t + r) / 2 + bc(f) * m - yc(f) * w, b = (e + n) / 2 + yc(f) * m + bc(f) * w, _ = vm([1, 0], [(h - m) / i, (v - w) / l]), x = [(h - m) / i, (v - w) / l], E = [(-1 * h - m) / i, (-1 * v - w) / l], S = vm(x, E);
  if (Zh(x, E) <= -1 && (S = ol), Zh(x, E) >= 1 && (S = 0), S < 0) {
    var M = Math.round(S / ol * 1e6) / 1e6;
    S = ol * 2 + M % 2 * ol;
  }
  d.addData(u, y, b, i, l, _, S, f, o);
}
var V0e = /([mlvhzcqtsa])([^mlvhzcqtsa]*)/ig, Z0e = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
function H0e(t) {
  var e = new io();
  if (!t)
    return e;
  var r = 0, n = 0, a = r, o = n, i, l = io.CMD, c = t.match(V0e);
  if (!c)
    return e;
  for (var u = 0; u < c.length; u++) {
    for (var d = c[u], f = d.charAt(0), h = void 0, v = d.match(Z0e) || [], p = v.length, g = 0; g < p; g++)
      v[g] = parseFloat(v[g]);
    for (var m = 0; m < p; ) {
      var w = void 0, y = void 0, b = void 0, _ = void 0, x = void 0, E = void 0, S = void 0, M = r, R = n, A = void 0, k = void 0;
      switch (f) {
        case "l":
          r += v[m++], n += v[m++], h = l.L, e.addData(h, r, n);
          break;
        case "L":
          r = v[m++], n = v[m++], h = l.L, e.addData(h, r, n);
          break;
        case "m":
          r += v[m++], n += v[m++], h = l.M, e.addData(h, r, n), a = r, o = n, f = "l";
          break;
        case "M":
          r = v[m++], n = v[m++], h = l.M, e.addData(h, r, n), a = r, o = n, f = "L";
          break;
        case "h":
          r += v[m++], h = l.L, e.addData(h, r, n);
          break;
        case "H":
          r = v[m++], h = l.L, e.addData(h, r, n);
          break;
        case "v":
          n += v[m++], h = l.L, e.addData(h, r, n);
          break;
        case "V":
          n = v[m++], h = l.L, e.addData(h, r, n);
          break;
        case "C":
          h = l.C, e.addData(h, v[m++], v[m++], v[m++], v[m++], v[m++], v[m++]), r = v[m - 2], n = v[m - 1];
          break;
        case "c":
          h = l.C, e.addData(h, v[m++] + r, v[m++] + n, v[m++] + r, v[m++] + n, v[m++] + r, v[m++] + n), r += v[m - 2], n += v[m - 1];
          break;
        case "S":
          w = r, y = n, A = e.len(), k = e.data, i === l.C && (w += r - k[A - 4], y += n - k[A - 3]), h = l.C, M = v[m++], R = v[m++], r = v[m++], n = v[m++], e.addData(h, w, y, M, R, r, n);
          break;
        case "s":
          w = r, y = n, A = e.len(), k = e.data, i === l.C && (w += r - k[A - 4], y += n - k[A - 3]), h = l.C, M = r + v[m++], R = n + v[m++], r += v[m++], n += v[m++], e.addData(h, w, y, M, R, r, n);
          break;
        case "Q":
          M = v[m++], R = v[m++], r = v[m++], n = v[m++], h = l.Q, e.addData(h, M, R, r, n);
          break;
        case "q":
          M = v[m++] + r, R = v[m++] + n, r += v[m++], n += v[m++], h = l.Q, e.addData(h, M, R, r, n);
          break;
        case "T":
          w = r, y = n, A = e.len(), k = e.data, i === l.Q && (w += r - k[A - 4], y += n - k[A - 3]), r = v[m++], n = v[m++], h = l.Q, e.addData(h, w, y, r, n);
          break;
        case "t":
          w = r, y = n, A = e.len(), k = e.data, i === l.Q && (w += r - k[A - 4], y += n - k[A - 3]), r += v[m++], n += v[m++], h = l.Q, e.addData(h, w, y, r, n);
          break;
        case "A":
          b = v[m++], _ = v[m++], x = v[m++], E = v[m++], S = v[m++], M = r, R = n, r = v[m++], n = v[m++], h = l.A, pm(M, R, r, n, E, S, b, _, x, h, e);
          break;
        case "a":
          b = v[m++], _ = v[m++], x = v[m++], E = v[m++], S = v[m++], M = r, R = n, r += v[m++], n += v[m++], h = l.A, pm(M, R, r, n, E, S, b, _, x, h, e);
          break;
      }
    }
    (f === "z" || f === "Z") && (h = l.Z, e.addData(h), r = a, n = o), i = h;
  }
  return e.toStatic(), e;
}
var F9 = function(t) {
  Be(e, t);
  function e() {
    return t !== null && t.apply(this, arguments) || this;
  }
  return e.prototype.applyTransform = function(r) {
  }, e;
}(Ie);
function $9(t) {
  return t.setData != null;
}
function V9(t, e) {
  var r = H0e(t), n = H({}, e);
  return n.buildPath = function(a) {
    if ($9(a)) {
      a.setData(r.data);
      var o = a.getContext();
      o && a.rebuildPath(o, 1);
    } else {
      var o = a;
      r.rebuildPath(o, 1);
    }
  }, n.applyTransform = function(a) {
    $0e(r, a), this.dirtyShape();
  }, n;
}
function j0e(t, e) {
  return new F9(V9(t, e));
}
function W0e(t, e) {
  var r = V9(t, e), n = function(a) {
    Be(o, a);
    function o(i) {
      var l = a.call(this, i) || this;
      return l.applyTransform = r.applyTransform, l.buildPath = r.buildPath, l;
    }
    return o;
  }(F9);
  return n;
}
function z0e(t, e) {
  for (var r = [], n = t.length, a = 0; a < n; a++) {
    var o = t[a];
    r.push(o.getUpdatedPathProxy(!0));
  }
  var i = new Ie(e);
  return i.createPathProxy(), i.buildPath = function(l) {
    if ($9(l)) {
      l.appendPath(r);
      var c = l.getContext();
      c && l.rebuildPath(c, 1);
    }
  }, i;
}
var G0e = /* @__PURE__ */ function() {
  function t() {
    this.cx = 0, this.cy = 0, this.r = 0;
  }
  return t;
}(), Bs = function(t) {
  Be(e, t);
  function e(r) {
    return t.call(this, r) || this;
  }
  return e.prototype.getDefaultShape = function() {
    return new G0e();
  }, e.prototype.buildPath = function(r, n) {
    r.moveTo(n.cx + n.r, n.cy), r.arc(n.cx, n.cy, n.r, 0, Math.PI * 2);
  }, e;
}(Ie);
Bs.prototype.type = "circle";
var U0e = /* @__PURE__ */ function() {
  function t() {
    this.cx = 0, this.cy = 0, this.rx = 0, this.ry = 0;
  }
  return t;
}(), T1 = function(t) {
  Be(e, t);
  function e(r) {
    return t.call(this, r) || this;
  }
  return e.prototype.getDefaultShape = function() {
    return new U0e();
  }, e.prototype.buildPath = function(r, n) {
    var a = 0.5522848, o = n.cx, i = n.cy, l = n.rx, c = n.ry, u = l * a, d = c * a;
    r.moveTo(o - l, i), r.bezierCurveTo(o - l, i - d, o - u, i - c, o, i - c), r.bezierCurveTo(o + u, i - c, o + l, i - d, o + l, i), r.bezierCurveTo(o + l, i + d, o + u, i + c, o, i + c), r.bezierCurveTo(o - u, i + c, o - l, i + d, o - l, i), r.closePath();
  }, e;
}(Ie);
T1.prototype.type = "ellipse";
var Z9 = Math.PI, xd = Z9 * 2, Pa = Math.sin, No = Math.cos, Y0e = Math.acos, ft = Math.atan2, gm = Math.abs, Bl = Math.sqrt, Ml = Math.max, Yr = Math.min, kr = 1e-4;
function X0e(t, e, r, n, a, o, i, l) {
  var c = r - t, u = n - e, d = i - a, f = l - o, h = f * c - d * u;
  if (!(h * h < kr))
    return h = (d * (e - o) - f * (t - a)) / h, [t + h * c, e + h * u];
}
function _c(t, e, r, n, a, o, i) {
  var l = t - r, c = e - n, u = (i ? o : -o) / Bl(l * l + c * c), d = u * c, f = -u * l, h = t + d, v = e + f, p = r + d, g = n + f, m = (h + p) / 2, w = (v + g) / 2, y = p - h, b = g - v, _ = y * y + b * b, x = a - o, E = h * g - p * v, S = (b < 0 ? -1 : 1) * Bl(Ml(0, x * x * _ - E * E)), M = (E * b - y * S) / _, R = (-E * y - b * S) / _, A = (E * b + y * S) / _, k = (-E * y + b * S) / _, L = M - m, T = R - w, O = A - m, D = k - w;
  return L * L + T * T > O * O + D * D && (M = A, R = k), {
    cx: M,
    cy: R,
    x0: -d,
    y0: -f,
    x1: M * (a / x - 1),
    y1: R * (a / x - 1)
  };
}
function q0e(t) {
  var e;
  if (z(t)) {
    var r = t.length;
    if (!r)
      return t;
    r === 1 ? e = [t[0], t[0], 0, 0] : r === 2 ? e = [t[0], t[0], t[1], t[1]] : r === 3 ? e = t.concat(t[2]) : e = t;
  } else
    e = [t, t, t, t];
  return e;
}
function K0e(t, e) {
  var r, n = Ml(e.r, 0), a = Ml(e.r0 || 0, 0), o = n > 0, i = a > 0;
  if (!(!o && !i)) {
    if (o || (n = a, a = 0), a > n) {
      var l = n;
      n = a, a = l;
    }
    var c = e.startAngle, u = e.endAngle;
    if (!(isNaN(c) || isNaN(u))) {
      var d = e.cx, f = e.cy, h = !!e.clockwise, v = gm(u - c), p = v > xd && v % xd;
      if (p > kr && (v = p), !(n > kr))
        t.moveTo(d, f);
      else if (v > xd - kr)
        t.moveTo(d + n * No(c), f + n * Pa(c)), t.arc(d, f, n, c, u, !h), a > kr && (t.moveTo(d + a * No(u), f + a * Pa(u)), t.arc(d, f, a, u, c, h));
      else {
        var g = void 0, m = void 0, w = void 0, y = void 0, b = void 0, _ = void 0, x = void 0, E = void 0, S = void 0, M = void 0, R = void 0, A = void 0, k = void 0, L = void 0, T = void 0, O = void 0, D = n * No(c), P = n * Pa(c), F = a * No(u), B = a * Pa(u), N = v > kr;
        if (N) {
          var $ = e.cornerRadius;
          $ && (r = q0e($), g = r[0], m = r[1], w = r[2], y = r[3]);
          var V = gm(n - a) / 2;
          if (b = Yr(V, w), _ = Yr(V, y), x = Yr(V, g), E = Yr(V, m), R = S = Ml(b, _), A = M = Ml(x, E), (S > kr || M > kr) && (k = n * No(u), L = n * Pa(u), T = a * No(c), O = a * Pa(c), v < Z9)) {
            var W = X0e(D, P, T, O, k, L, F, B);
            if (W) {
              var ee = D - W[0], ne = P - W[1], we = k - W[0], pe = L - W[1], X = 1 / Pa(Y0e((ee * we + ne * pe) / (Bl(ee * ee + ne * ne) * Bl(we * we + pe * pe))) / 2), me = Bl(W[0] * W[0] + W[1] * W[1]);
              R = Yr(S, (n - me) / (X + 1)), A = Yr(M, (a - me) / (X - 1));
            }
          }
        }
        if (!N)
          t.moveTo(d + D, f + P);
        else if (R > kr) {
          var ve = Yr(w, R), ae = Yr(y, R), Y = _c(T, O, D, P, n, ve, h), q = _c(k, L, F, B, n, ae, h);
          t.moveTo(d + Y.cx + Y.x0, f + Y.cy + Y.y0), R < S && ve === ae ? t.arc(d + Y.cx, f + Y.cy, R, ft(Y.y0, Y.x0), ft(q.y0, q.x0), !h) : (ve > 0 && t.arc(d + Y.cx, f + Y.cy, ve, ft(Y.y0, Y.x0), ft(Y.y1, Y.x1), !h), t.arc(d, f, n, ft(Y.cy + Y.y1, Y.cx + Y.x1), ft(q.cy + q.y1, q.cx + q.x1), !h), ae > 0 && t.arc(d + q.cx, f + q.cy, ae, ft(q.y1, q.x1), ft(q.y0, q.x0), !h));
        } else
          t.moveTo(d + D, f + P), t.arc(d, f, n, c, u, !h);
        if (!(a > kr) || !N)
          t.lineTo(d + F, f + B);
        else if (A > kr) {
          var ve = Yr(g, A), ae = Yr(m, A), Y = _c(F, B, k, L, a, -ae, h), q = _c(D, P, T, O, a, -ve, h);
          t.lineTo(d + Y.cx + Y.x0, f + Y.cy + Y.y0), A < M && ve === ae ? t.arc(d + Y.cx, f + Y.cy, A, ft(Y.y0, Y.x0), ft(q.y0, q.x0), !h) : (ae > 0 && t.arc(d + Y.cx, f + Y.cy, ae, ft(Y.y0, Y.x0), ft(Y.y1, Y.x1), !h), t.arc(d, f, a, ft(Y.cy + Y.y1, Y.cx + Y.x1), ft(q.cy + q.y1, q.cx + q.x1), h), ve > 0 && t.arc(d + q.cx, f + q.cy, ve, ft(q.y1, q.x1), ft(q.y0, q.x0), !h));
        } else
          t.lineTo(d + F, f + B), t.arc(d, f, a, u, c, h);
      }
      t.closePath();
    }
  }
}
var Q0e = /* @__PURE__ */ function() {
  function t() {
    this.cx = 0, this.cy = 0, this.r0 = 0, this.r = 0, this.startAngle = 0, this.endAngle = Math.PI * 2, this.clockwise = !0, this.cornerRadius = 0;
  }
  return t;
}(), $r = function(t) {
  Be(e, t);
  function e(r) {
    return t.call(this, r) || this;
  }
  return e.prototype.getDefaultShape = function() {
    return new Q0e();
  }, e.prototype.buildPath = function(r, n) {
    K0e(r, n);
  }, e.prototype.isZeroArea = function() {
    return this.shape.startAngle === this.shape.endAngle || this.shape.r === this.shape.r0;
  }, e;
}(Ie);
$r.prototype.type = "sector";
var J0e = /* @__PURE__ */ function() {
  function t() {
    this.cx = 0, this.cy = 0, this.r = 0, this.r0 = 0;
  }
  return t;
}(), O1 = function(t) {
  Be(e, t);
  function e(r) {
    return t.call(this, r) || this;
  }
  return e.prototype.getDefaultShape = function() {
    return new J0e();
  }, e.prototype.buildPath = function(r, n) {
    var a = n.cx, o = n.cy, i = Math.PI * 2;
    r.moveTo(a + n.r, o), r.arc(a, o, n.r, 0, i, !1), r.moveTo(a + n.r0, o), r.arc(a, o, n.r0, 0, i, !0);
  }, e;
}(Ie);
O1.prototype.type = "ring";
function eue(t, e, r, n) {
  var a = [], o = [], i = [], l = [], c, u, d, f;
  if (n) {
    d = [1 / 0, 1 / 0], f = [-1 / 0, -1 / 0];
    for (var h = 0, v = t.length; h < v; h++)
      jn(d, d, t[h]), Wn(f, f, t[h]);
    jn(d, d, n[0]), Wn(f, f, n[1]);
  }
  for (var h = 0, v = t.length; h < v; h++) {
    var p = t[h];
    if (r)
      c = t[h ? h - 1 : v - 1], u = t[(h + 1) % v];
    else if (h === 0 || h === v - 1) {
      a.push(Vb(t[h]));
      continue;
    } else
      c = t[h - 1], u = t[h + 1];
    Bv(o, u, c), d0(o, o, e);
    var g = Z0(p, c), m = Z0(p, u), w = g + m;
    w !== 0 && (g /= w, m /= w), d0(i, o, -g), d0(l, o, m);
    var y = gh([], p, i), b = gh([], p, l);
    n && (Wn(y, y, d), jn(y, y, f), Wn(b, b, d), jn(b, b, f)), a.push(y), a.push(b);
  }
  return r && a.push(a.shift()), a;
}
function H9(t, e, r) {
  var n = e.smooth, a = e.points;
  if (a && a.length >= 2) {
    if (n) {
      var o = eue(a, n, r, e.smoothConstraint);
      t.moveTo(a[0][0], a[0][1]);
      for (var i = a.length, l = 0; l < (r ? i : i - 1); l++) {
        var c = o[l * 2], u = o[l * 2 + 1], d = a[(l + 1) % i];
        t.bezierCurveTo(c[0], c[1], u[0], u[1], d[0], d[1]);
      }
    } else {
      t.moveTo(a[0][0], a[0][1]);
      for (var l = 1, f = a.length; l < f; l++)
        t.lineTo(a[l][0], a[l][1]);
    }
    r && t.closePath();
  }
}
var tue = /* @__PURE__ */ function() {
  function t() {
    this.points = null, this.smooth = 0, this.smoothConstraint = null;
  }
  return t;
}(), Fs = function(t) {
  Be(e, t);
  function e(r) {
    return t.call(this, r) || this;
  }
  return e.prototype.getDefaultShape = function() {
    return new tue();
  }, e.prototype.buildPath = function(r, n) {
    H9(r, n, !0);
  }, e;
}(Ie);
Fs.prototype.type = "polygon";
var rue = /* @__PURE__ */ function() {
  function t() {
    this.points = null, this.percent = 1, this.smooth = 0, this.smoothConstraint = null;
  }
  return t;
}(), mo = function(t) {
  Be(e, t);
  function e(r) {
    return t.call(this, r) || this;
  }
  return e.prototype.getDefaultStyle = function() {
    return {
      stroke: "#000",
      fill: null
    };
  }, e.prototype.getDefaultShape = function() {
    return new rue();
  }, e.prototype.buildPath = function(r, n) {
    H9(r, n, !1);
  }, e;
}(Ie);
mo.prototype.type = "polyline";
var nue = {}, aue = /* @__PURE__ */ function() {
  function t() {
    this.x1 = 0, this.y1 = 0, this.x2 = 0, this.y2 = 0, this.percent = 1;
  }
  return t;
}(), br = function(t) {
  Be(e, t);
  function e(r) {
    return t.call(this, r) || this;
  }
  return e.prototype.getDefaultStyle = function() {
    return {
      stroke: "#000",
      fill: null
    };
  }, e.prototype.getDefaultShape = function() {
    return new aue();
  }, e.prototype.buildPath = function(r, n) {
    var a, o, i, l;
    if (this.subPixelOptimize) {
      var c = R9(nue, n, this.style);
      a = c.x1, o = c.y1, i = c.x2, l = c.y2;
    } else
      a = n.x1, o = n.y1, i = n.x2, l = n.y2;
    var u = n.percent;
    u !== 0 && (r.moveTo(a, o), u < 1 && (i = a * (1 - u) + i * u, l = o * (1 - u) + l * u), r.lineTo(i, l));
  }, e.prototype.pointAt = function(r) {
    var n = this.shape;
    return [
      n.x1 * (1 - r) + n.x2 * r,
      n.y1 * (1 - r) + n.y2 * r
    ];
  }, e;
}(Ie);
br.prototype.type = "line";
var Pt = [], oue = /* @__PURE__ */ function() {
  function t() {
    this.x1 = 0, this.y1 = 0, this.x2 = 0, this.y2 = 0, this.cpx1 = 0, this.cpy1 = 0, this.percent = 1;
  }
  return t;
}();
function mm(t, e, r) {
  var n = t.cpx2, a = t.cpy2;
  return n != null || a != null ? [
    (r ? bg : ut)(t.x1, t.cpx1, t.cpx2, t.x2, e),
    (r ? bg : ut)(t.y1, t.cpy1, t.cpy2, t.y2, e)
  ] : [
    (r ? _g : $t)(t.x1, t.cpx1, t.x2, e),
    (r ? _g : $t)(t.y1, t.cpy1, t.y2, e)
  ];
}
var $s = function(t) {
  Be(e, t);
  function e(r) {
    return t.call(this, r) || this;
  }
  return e.prototype.getDefaultStyle = function() {
    return {
      stroke: "#000",
      fill: null
    };
  }, e.prototype.getDefaultShape = function() {
    return new oue();
  }, e.prototype.buildPath = function(r, n) {
    var a = n.x1, o = n.y1, i = n.x2, l = n.y2, c = n.cpx1, u = n.cpy1, d = n.cpx2, f = n.cpy2, h = n.percent;
    h !== 0 && (r.moveTo(a, o), d == null || f == null ? (h < 1 && (Y0(a, c, i, h, Pt), c = Pt[1], i = Pt[2], Y0(o, u, l, h, Pt), u = Pt[1], l = Pt[2]), r.quadraticCurveTo(c, u, i, l)) : (h < 1 && (U0(a, c, d, i, h, Pt), c = Pt[1], d = Pt[2], i = Pt[3], U0(o, u, f, l, h, Pt), u = Pt[1], f = Pt[2], l = Pt[3]), r.bezierCurveTo(c, u, d, f, i, l)));
  }, e.prototype.pointAt = function(r) {
    return mm(this.shape, r, !1);
  }, e.prototype.tangentAt = function(r) {
    var n = mm(this.shape, r, !0);
    return _1(n, n);
  }, e;
}(Ie);
$s.prototype.type = "bezier-curve";
var iue = /* @__PURE__ */ function() {
  function t() {
    this.cx = 0, this.cy = 0, this.r = 0, this.startAngle = 0, this.endAngle = Math.PI * 2, this.clockwise = !0;
  }
  return t;
}(), Vs = function(t) {
  Be(e, t);
  function e(r) {
    return t.call(this, r) || this;
  }
  return e.prototype.getDefaultStyle = function() {
    return {
      stroke: "#000",
      fill: null
    };
  }, e.prototype.getDefaultShape = function() {
    return new iue();
  }, e.prototype.buildPath = function(r, n) {
    var a = n.cx, o = n.cy, i = Math.max(n.r, 0), l = n.startAngle, c = n.endAngle, u = n.clockwise, d = Math.cos(l), f = Math.sin(l);
    r.moveTo(d * i + a, f * i + o), r.arc(a, o, i, l, c, !u);
  }, e;
}(Ie);
Vs.prototype.type = "arc";
var j9 = function(t) {
  Be(e, t);
  function e() {
    var r = t !== null && t.apply(this, arguments) || this;
    return r.type = "compound", r;
  }
  return e.prototype._updatePathDirty = function() {
    for (var r = this.shape.paths, n = this.shapeChanged(), a = 0; a < r.length; a++)
      n = n || r[a].shapeChanged();
    n && this.dirtyShape();
  }, e.prototype.beforeBrush = function() {
    this._updatePathDirty();
    for (var r = this.shape.paths || [], n = this.getGlobalScale(), a = 0; a < r.length; a++)
      r[a].path || r[a].createPathProxy(), r[a].path.setScale(n[0], n[1], r[a].segmentIgnoreThreshold);
  }, e.prototype.buildPath = function(r, n) {
    for (var a = n.paths || [], o = 0; o < a.length; o++)
      a[o].buildPath(r, a[o].shape, !0);
  }, e.prototype.afterBrush = function() {
    for (var r = this.shape.paths || [], n = 0; n < r.length; n++)
      r[n].pathUpdated();
  }, e.prototype.getBoundingRect = function() {
    return this._updatePathDirty.call(this), Ie.prototype.getBoundingRect.call(this);
  }, e;
}(Ie), W9 = function() {
  function t(e) {
    this.colorStops = e || [];
  }
  return t.prototype.addColorStop = function(e, r) {
    this.colorStops.push({
      offset: e,
      color: r
    });
  }, t;
}(), i7 = function(t) {
  Be(e, t);
  function e(r, n, a, o, i, l) {
    var c = t.call(this, i) || this;
    return c.x = r ?? 0, c.y = n ?? 0, c.x2 = a ?? 1, c.y2 = o ?? 0, c.type = "linear", c.global = l || !1, c;
  }
  return e;
}(W9), z9 = function(t) {
  Be(e, t);
  function e(r, n, a, o, i) {
    var l = t.call(this, o) || this;
    return l.x = r ?? 0.5, l.y = n ?? 0.5, l.r = a ?? 0.5, l.type = "radial", l.global = i || !1, l;
  }
  return e;
}(W9), Da = [0, 0], Na = [0, 0], xc = new he(), Cc = new he(), ru = function() {
  function t(e, r) {
    this._corners = [], this._axes = [], this._origin = [0, 0];
    for (var n = 0; n < 4; n++)
      this._corners[n] = new he();
    for (var n = 0; n < 2; n++)
      this._axes[n] = new he();
    e && this.fromBoundingRect(e, r);
  }
  return t.prototype.fromBoundingRect = function(e, r) {
    var n = this._corners, a = this._axes, o = e.x, i = e.y, l = o + e.width, c = i + e.height;
    if (n[0].set(o, i), n[1].set(l, i), n[2].set(l, c), n[3].set(o, c), r)
      for (var u = 0; u < 4; u++)
        n[u].transform(r);
    he.sub(a[0], n[1], n[0]), he.sub(a[1], n[3], n[0]), a[0].normalize(), a[1].normalize();
    for (var u = 0; u < 2; u++)
      this._origin[u] = a[u].dot(n[0]);
  }, t.prototype.intersect = function(e, r) {
    var n = !0, a = !r;
    return xc.set(1 / 0, 1 / 0), Cc.set(0, 0), !this._intersectCheckOneSide(this, e, xc, Cc, a, 1) && (n = !1, a) || !this._intersectCheckOneSide(e, this, xc, Cc, a, -1) && (n = !1, a) || a || he.copy(r, n ? xc : Cc), n;
  }, t.prototype._intersectCheckOneSide = function(e, r, n, a, o, i) {
    for (var l = !0, c = 0; c < 2; c++) {
      var u = this._axes[c];
      if (this._getProjMinMaxOnAxis(c, e._corners, Da), this._getProjMinMaxOnAxis(c, r._corners, Na), Da[1] < Na[0] || Da[0] > Na[1]) {
        if (l = !1, o)
          return l;
        var d = Math.abs(Na[0] - Da[1]), f = Math.abs(Da[0] - Na[1]);
        Math.min(d, f) > a.len() && (d < f ? he.scale(a, u, -d * i) : he.scale(a, u, f * i));
      } else if (n) {
        var d = Math.abs(Na[0] - Da[1]), f = Math.abs(Da[0] - Na[1]);
        Math.min(d, f) < n.len() && (d < f ? he.scale(n, u, d * i) : he.scale(n, u, -f * i));
      }
    }
    return l;
  }, t.prototype._getProjMinMaxOnAxis = function(e, r, n) {
    for (var a = this._axes[e], o = this._origin, i = r[0].dot(a) + o[e], l = i, c = i, u = 1; u < r.length; u++) {
      var d = r[u].dot(a) + o[e];
      l = Math.min(d, l), c = Math.max(d, c);
    }
    n[0] = l, n[1] = c;
  }, t;
}(), lue = [], G9 = function(t) {
  Be(e, t);
  function e() {
    var r = t !== null && t.apply(this, arguments) || this;
    return r.notClear = !0, r.incremental = !0, r._displayables = [], r._temporaryDisplayables = [], r._cursor = 0, r;
  }
  return e.prototype.traverse = function(r, n) {
    r.call(n, this);
  }, e.prototype.useStyle = function() {
    this.style = {};
  }, e.prototype.getCursor = function() {
    return this._cursor;
  }, e.prototype.innerAfterBrush = function() {
    this._cursor = this._displayables.length;
  }, e.prototype.clearDisplaybles = function() {
    this._displayables = [], this._temporaryDisplayables = [], this._cursor = 0, this.markRedraw(), this.notClear = !1;
  }, e.prototype.clearTemporalDisplayables = function() {
    this._temporaryDisplayables = [];
  }, e.prototype.addDisplayable = function(r, n) {
    n ? this._temporaryDisplayables.push(r) : this._displayables.push(r), this.markRedraw();
  }, e.prototype.addDisplayables = function(r, n) {
    n = n || !1;
    for (var a = 0; a < r.length; a++)
      this.addDisplayable(r[a], n);
  }, e.prototype.getDisplayables = function() {
    return this._displayables;
  }, e.prototype.getTemporalDisplayables = function() {
    return this._temporaryDisplayables;
  }, e.prototype.eachPendingDisplayable = function(r) {
    for (var n = this._cursor; n < this._displayables.length; n++)
      r && r(this._displayables[n]);
    for (var n = 0; n < this._temporaryDisplayables.length; n++)
      r && r(this._temporaryDisplayables[n]);
  }, e.prototype.update = function() {
    this.updateTransform();
    for (var r = this._cursor; r < this._displayables.length; r++) {
      var n = this._displayables[r];
      n.parent = this, n.update(), n.parent = null;
    }
    for (var r = 0; r < this._temporaryDisplayables.length; r++) {
      var n = this._temporaryDisplayables[r];
      n.parent = this, n.update(), n.parent = null;
    }
  }, e.prototype.getBoundingRect = function() {
    if (!this._rect) {
      for (var r = new Le(1 / 0, 1 / 0, -1 / 0, -1 / 0), n = 0; n < this._displayables.length; n++) {
        var a = this._displayables[n], o = a.getBoundingRect().clone();
        a.needLocalTransform() && o.applyTransform(a.getLocalTransform(lue)), r.union(o);
      }
      this._rect = r;
    }
    return this._rect;
  }, e.prototype.contain = function(r, n) {
    var a = this.transformCoordToLocal(r, n), o = this.getBoundingRect();
    if (o.contain(a[0], a[1]))
      for (var i = 0; i < this._displayables.length; i++) {
        var l = this._displayables[i];
        if (l.contain(r, n))
          return !0;
      }
    return !1;
  }, e;
}(Ns), sue = je();
function cue(t, e, r, n, a) {
  var o;
  if (e && e.ecModel) {
    var i = e.ecModel.getUpdatePayload();
    o = i && i.animation;
  }
  var l = e && e.isAnimationEnabled(), c = t === "update";
  if (l) {
    var u = void 0, d = void 0, f = void 0;
    n ? (u = de(n.duration, 200), d = de(n.easing, "cubicOut"), f = 0) : (u = e.getShallow(c ? "animationDurationUpdate" : "animationDuration"), d = e.getShallow(c ? "animationEasingUpdate" : "animationEasing"), f = e.getShallow(c ? "animationDelayUpdate" : "animationDelay")), o && (o.duration != null && (u = o.duration), o.easing != null && (d = o.easing), o.delay != null && (f = o.delay)), ie(f) && (f = f(r, a)), ie(u) && (u = u(r));
    var h = {
      duration: u || 0,
      delay: f,
      easing: d
    };
    return h;
  } else
    return null;
}
function l7(t, e, r, n, a, o, i) {
  var l = !1, c;
  ie(a) ? (i = o, o = a, a = null) : re(a) && (o = a.cb, i = a.during, l = a.isFrom, c = a.removeOpt, a = a.dataIndex);
  var u = t === "leave";
  u || e.stopAnimation("leave");
  var d = cue(t, n, a, u ? c || {} : null, n && n.getAnimationDelayParams ? n.getAnimationDelayParams(e, a) : null);
  if (d && d.duration > 0) {
    var f = d.duration, h = d.delay, v = d.easing, p = {
      duration: f,
      delay: h || 0,
      easing: v,
      done: o,
      force: !!o || !!i,
      // Set to final state in update/init animation.
      // So the post processing based on the path shape can be done correctly.
      setToFinal: !u,
      scope: t,
      during: i
    };
    l ? e.animateFrom(r, p) : e.animateTo(r, p);
  } else
    e.stopAnimation(), !l && e.attr(r), i && i(1), o && o();
}
function rt(t, e, r, n, a, o) {
  l7("update", t, e, r, n, a, o);
}
function dt(t, e, r, n, a, o) {
  l7("enter", t, e, r, n, a, o);
}
function Fl(t) {
  if (!t.__zr)
    return !0;
  for (var e = 0; e < t.animators.length; e++) {
    var r = t.animators[e];
    if (r.scope === "leave")
      return !0;
  }
  return !1;
}
function nu(t, e, r, n, a, o) {
  Fl(t) || l7("leave", t, e, r, n, a, o);
}
function wm(t, e, r, n) {
  t.removeTextContent(), t.removeTextGuideLine(), nu(t, {
    style: {
      opacity: 0
    }
  }, e, r, n);
}
function au(t, e, r) {
  function n() {
    t.parent && t.parent.remove(t);
  }
  t.isGroup ? t.traverse(function(a) {
    a.isGroup || wm(a, e, r, n);
  }) : wm(t, e, r, n);
}
function s7(t) {
  sue(t).oldStyle = t.style;
}
var ou = Math.max, iu = Math.min, Hh = {};
function U9(t) {
  return Ie.extend(t);
}
var uue = W0e;
function Y9(t, e) {
  return uue(t, e);
}
function xr(t, e) {
  Hh[t] = e;
}
function X9(t) {
  if (Hh.hasOwnProperty(t))
    return Hh[t];
}
function I1(t, e, r, n) {
  var a = j0e(t, e);
  return r && (n === "center" && (r = q9(r, a.getBoundingRect())), u7(a, r)), a;
}
function c7(t, e, r) {
  var n = new nn({
    style: {
      image: t,
      x: e.x,
      y: e.y,
      width: e.width,
      height: e.height
    },
    onload: function(a) {
      if (r === "center") {
        var o = {
          width: a.width,
          height: a.height
        };
        n.setStyle(q9(e, o));
      }
    }
  });
  return n;
}
function q9(t, e) {
  var r = e.width / e.height, n = t.height * r, a;
  n <= t.width ? a = t.height : (n = t.width, a = n / r);
  var o = t.x + t.width / 2, i = t.y + t.height / 2;
  return {
    x: o - n / 2,
    y: i - a / 2,
    width: n,
    height: a
  };
}
var K9 = z0e;
function u7(t, e) {
  if (t.applyTransform) {
    var r = t.getBoundingRect(), n = r.calculateTransform(e);
    t.applyTransform(n);
  }
}
function os(t, e) {
  return R9(t, t, {
    lineWidth: e
  }), t;
}
function due(t) {
  return M9(t.shape, t.shape, t.style), t;
}
var fue = za;
function d7(t, e) {
  for (var r = Ls([]); t && t !== e; )
    ra(r, t.getLocalTransform(), r), t = t.parent;
  return r;
}
function is(t, e, r) {
  return e && !Lt(e) && (e = Wv.getLocalTransform(e)), r && (e = Ts([], e)), At([], t, e);
}
function Q9(t, e, r) {
  var n = e[4] === 0 || e[5] === 0 || e[0] === 0 ? 1 : Math.abs(2 * e[4] / e[0]), a = e[4] === 0 || e[5] === 0 || e[2] === 0 ? 1 : Math.abs(2 * e[4] / e[2]), o = [t === "left" ? -n : t === "right" ? n : 0, t === "top" ? -a : t === "bottom" ? a : 0];
  return o = is(o, e, r), Math.abs(o[0]) > Math.abs(o[1]) ? o[0] > 0 ? "right" : "left" : o[1] > 0 ? "bottom" : "top";
}
function ym(t) {
  return !t.isGroup;
}
function hue(t) {
  return t.shape != null;
}
function J9(t, e, r) {
  if (!t || !e)
    return;
  function n(i) {
    var l = {};
    return i.traverse(function(c) {
      ym(c) && c.anid && (l[c.anid] = c);
    }), l;
  }
  function a(i) {
    var l = {
      x: i.x,
      y: i.y,
      rotation: i.rotation
    };
    return hue(i) && (l.shape = H({}, i.shape)), l;
  }
  var o = n(t);
  e.traverse(function(i) {
    if (ym(i) && i.anid) {
      var l = o[i.anid];
      if (l) {
        var c = a(i);
        i.attr(a(l)), rt(i, c, r, Se(i).dataIndex);
      }
    }
  });
}
function e_(t, e) {
  return J(t, function(r) {
    var n = r[0];
    n = ou(n, e.x), n = iu(n, e.x + e.width);
    var a = r[1];
    return a = ou(a, e.y), a = iu(a, e.y + e.height), [n, a];
  });
}
function t_(t, e) {
  var r = ou(t.x, e.x), n = iu(t.x + t.width, e.x + e.width), a = ou(t.y, e.y), o = iu(t.y + t.height, e.y + e.height);
  if (n >= r && o >= a)
    return {
      x: r,
      y: a,
      width: n - r,
      height: o - a
    };
}
function P1(t, e, r) {
  var n = H({
    rectHover: !0
  }, e), a = n.style = {
    strokeNoScale: !0
  };
  if (r = r || {
    x: -1,
    y: -1,
    width: 2,
    height: 2
  }, t)
    return t.indexOf("image://") === 0 ? (a.image = t.slice(8), Te(a, r), new nn(n)) : I1(t.replace("path://", ""), n, r, "center");
}
function vue(t, e, r, n, a) {
  for (var o = 0, i = a[a.length - 1]; o < a.length; o++) {
    var l = a[o];
    if (r_(t, e, r, n, l[0], l[1], i[0], i[1]))
      return !0;
    i = l;
  }
}
function r_(t, e, r, n, a, o, i, l) {
  var c = r - t, u = n - e, d = i - a, f = l - o, h = Cd(d, f, c, u);
  if (pue(h))
    return !1;
  var v = t - a, p = e - o, g = Cd(v, p, c, u) / h;
  if (g < 0 || g > 1)
    return !1;
  var m = Cd(v, p, d, f) / h;
  return !(m < 0 || m > 1);
}
function Cd(t, e, r, n) {
  return t * n - r * e;
}
function pue(t) {
  return t <= 1e-6 && t >= -1e-6;
}
function f7(t) {
  var e = t.itemTooltipOption, r = t.componentModel, n = t.itemName, a = Q(e) ? {
    formatter: e
  } : e, o = r.mainType, i = r.componentIndex, l = {
    componentType: o,
    name: n,
    $vars: ["name"]
  };
  l[o + "Index"] = i;
  var c = t.formatterParamsExtra;
  c && I(Ze(c), function(d) {
    ao(l, d) || (l[d] = c[d], l.$vars.push(d));
  });
  var u = Se(t.el);
  u.componentMainType = o, u.componentIndex = i, u.tooltipConfig = {
    name: n,
    option: Te({
      content: n,
      encodeHTMLContent: !0,
      formatterParams: l
    }, a)
  };
}
function bm(t, e) {
  var r;
  t.isGroup && (r = e(t)), r || t.traverse(e);
}
function Zs(t, e) {
  if (t)
    if (z(t))
      for (var r = 0; r < t.length; r++)
        bm(t[r], e);
    else
      bm(t, e);
}
xr("circle", Bs);
xr("ellipse", T1);
xr("sector", $r);
xr("ring", O1);
xr("polygon", Fs);
xr("polyline", mo);
xr("rect", He);
xr("line", br);
xr("bezierCurve", $s);
xr("arc", Vs);
const gue = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Arc: Vs,
  BezierCurve: $s,
  BoundingRect: Le,
  Circle: Bs,
  CompoundPath: j9,
  Ellipse: T1,
  Group: Xe,
  Image: nn,
  IncrementalDisplayable: G9,
  Line: br,
  LinearGradient: i7,
  OrientedBoundingRect: ru,
  Path: Ie,
  Point: he,
  Polygon: Fs,
  Polyline: mo,
  RadialGradient: z9,
  Rect: He,
  Ring: O1,
  Sector: $r,
  Text: Ye,
  applyTransform: is,
  clipPointsByRect: e_,
  clipRectByRect: t_,
  createIcon: P1,
  extendPath: Y9,
  extendShape: U9,
  getShapeClass: X9,
  getTransform: d7,
  groupTransition: J9,
  initProps: dt,
  isElementRemoved: Fl,
  lineLineIntersect: r_,
  linePolygonIntersect: vue,
  makeImage: c7,
  makePath: I1,
  mergePath: K9,
  registerShape: xr,
  removeElement: nu,
  removeElementWithFadeOut: au,
  resizePath: u7,
  setTooltipConfig: f7,
  subPixelOptimize: fue,
  subPixelOptimizeLine: os,
  subPixelOptimizeRect: due,
  transformDirection: Q9,
  traverseElements: Zs,
  updateProps: rt
}, Symbol.toStringTag, { value: "Module" }));
var D1 = {};
function n_(t, e) {
  for (var r = 0; r < Wt.length; r++) {
    var n = Wt[r], a = e[n], o = t.ensureState(n);
    o.style = o.style || {}, o.style.text = a;
  }
  var i = t.currentStates.slice();
  t.clearStates(!0), t.setStyle({
    text: e.normal
  }), t.useStates(i, !0);
}
function jh(t, e, r) {
  var n = t.labelFetcher, a = t.labelDataIndex, o = t.labelDimIndex, i = e.normal, l;
  n && (l = n.getFormattedLabel(a, "normal", null, o, i && i.get("formatter"), r != null ? {
    interpolatedValue: r
  } : null)), l == null && (l = ie(t.defaultText) ? t.defaultText(a, t, r) : t.defaultText);
  for (var c = {
    normal: l
  }, u = 0; u < Wt.length; u++) {
    var d = Wt[u], f = e[d];
    c[d] = de(n ? n.getFormattedLabel(a, d, null, o, f && f.get("formatter")) : null, l);
  }
  return c;
}
function Wi(t, e, r, n) {
  r = r || D1;
  for (var a = t instanceof Ye, o = !1, i = 0; i < tu.length; i++) {
    var l = e[tu[i]];
    if (l && l.getShallow("show")) {
      o = !0;
      break;
    }
  }
  var c = a ? t : t.getTextContent();
  if (o) {
    a || (c || (c = new Ye(), t.setTextContent(c)), t.stateProxy && (c.stateProxy = t.stateProxy));
    var u = jh(r, e), d = e.normal, f = !!d.getShallow("show"), h = jt(d, n && n.normal, r, !1, !a);
    h.text = u.normal, a || t.setTextConfig(_m(d, r, !1));
    for (var i = 0; i < Wt.length; i++) {
      var v = Wt[i], l = e[v];
      if (l) {
        var p = c.ensureState(v), g = !!de(l.getShallow("show"), f);
        if (g !== f && (p.ignore = !g), p.style = jt(l, n && n[v], r, !0, !a), p.style.text = u[v], !a) {
          var m = t.ensureState(v);
          m.textConfig = _m(l, r, !0);
        }
      }
    }
    c.silent = !!d.getShallow("silent"), c.style.x != null && (h.x = c.style.x), c.style.y != null && (h.y = c.style.y), c.ignore = !f, c.useStyle(h), c.dirty(), r.enableTextSetter && (Hs(c).setLabelText = function(w) {
      var y = jh(r, e, w);
      n_(c, y);
    });
  } else c && (c.ignore = !0);
  t.dirty();
}
function wo(t, e) {
  e = e || "label";
  for (var r = {
    normal: t.getModel(e)
  }, n = 0; n < Wt.length; n++) {
    var a = Wt[n];
    r[a] = t.getModel([a, e]);
  }
  return r;
}
function jt(t, e, r, n, a) {
  var o = {};
  return mue(o, t, r, n, a), e && H(o, e), o;
}
function _m(t, e, r) {
  e = e || {};
  var n = {}, a, o = t.getShallow("rotate"), i = de(t.getShallow("distance"), r ? null : 5), l = t.getShallow("offset");
  return a = t.getShallow("position") || (r ? null : "inside"), a === "outside" && (a = e.defaultOutsidePosition || "top"), a != null && (n.position = a), l != null && (n.offset = l), o != null && (o *= Math.PI / 180, n.rotation = o), i != null && (n.distance = i), n.outsideFill = t.get("color") === "inherit" ? e.inheritColor || null : "auto", n;
}
function mue(t, e, r, n, a) {
  r = r || D1;
  var o = e.ecModel, i = o && o.option.textStyle, l = wue(e), c;
  if (l) {
    c = {};
    for (var u in l)
      if (l.hasOwnProperty(u)) {
        var d = e.getModel(["rich", u]);
        Sm(c[u] = {}, d, i, r, n, a, !1, !0);
      }
  }
  c && (t.rich = c);
  var f = e.get("overflow");
  f && (t.overflow = f);
  var h = e.get("minMargin");
  h != null && (t.margin = h), Sm(t, e, i, r, n, a, !0, !1);
}
function wue(t) {
  for (var e; t && t !== t.ecModel; ) {
    var r = (t.option || D1).rich;
    if (r) {
      e = e || {};
      for (var n = Ze(r), a = 0; a < n.length; a++) {
        var o = n[a];
        e[o] = 1;
      }
    }
    t = t.parentModel;
  }
  return e;
}
var xm = ["fontStyle", "fontWeight", "fontSize", "fontFamily", "textShadowColor", "textShadowBlur", "textShadowOffsetX", "textShadowOffsetY"], Cm = ["align", "lineHeight", "width", "height", "tag", "verticalAlign", "ellipsis"], Em = ["padding", "borderWidth", "borderRadius", "borderDashOffset", "backgroundColor", "borderColor", "shadowColor", "shadowBlur", "shadowOffsetX", "shadowOffsetY"];
function Sm(t, e, r, n, a, o, i, l) {
  r = !a && r || D1;
  var c = n && n.inheritColor, u = e.getShallow("color"), d = e.getShallow("textBorderColor"), f = de(e.getShallow("opacity"), r.opacity);
  (u === "inherit" || u === "auto") && (process.env.NODE_ENV !== "production" && u === "auto" && tt("color: 'auto'", "color: 'inherit'"), c ? u = c : u = null), (d === "inherit" || d === "auto") && (process.env.NODE_ENV !== "production" && d === "auto" && tt("color: 'auto'", "color: 'inherit'"), c ? d = c : d = null), o || (u = u || r.color, d = d || r.textBorderColor), u != null && (t.fill = u), d != null && (t.stroke = d);
  var h = de(e.getShallow("textBorderWidth"), r.textBorderWidth);
  h != null && (t.lineWidth = h);
  var v = de(e.getShallow("textBorderType"), r.textBorderType);
  v != null && (t.lineDash = v);
  var p = de(e.getShallow("textBorderDashOffset"), r.textBorderDashOffset);
  p != null && (t.lineDashOffset = p), !a && f == null && !l && (f = n && n.defaultOpacity), f != null && (t.opacity = f), !a && !o && t.fill == null && n.inheritColor && (t.fill = n.inheritColor);
  for (var g = 0; g < xm.length; g++) {
    var m = xm[g], w = de(e.getShallow(m), r[m]);
    w != null && (t[m] = w);
  }
  for (var g = 0; g < Cm.length; g++) {
    var m = Cm[g], w = e.getShallow(m);
    w != null && (t[m] = w);
  }
  if (t.verticalAlign == null) {
    var y = e.getShallow("baseline");
    y != null && (t.verticalAlign = y);
  }
  if (!i || !n.disableBox) {
    for (var g = 0; g < Em.length; g++) {
      var m = Em[g], w = e.getShallow(m);
      w != null && (t[m] = w);
    }
    var b = e.getShallow("borderType");
    b != null && (t.borderDash = b), (t.backgroundColor === "auto" || t.backgroundColor === "inherit") && c && (process.env.NODE_ENV !== "production" && t.backgroundColor === "auto" && tt("backgroundColor: 'auto'", "backgroundColor: 'inherit'"), t.backgroundColor = c), (t.borderColor === "auto" || t.borderColor === "inherit") && c && (process.env.NODE_ENV !== "production" && t.borderColor === "auto" && tt("borderColor: 'auto'", "borderColor: 'inherit'"), t.borderColor = c);
  }
}
function yue(t, e) {
  var r = e && e.getModel("textStyle");
  return Ir([
    // FIXME in node-canvas fontWeight is before fontStyle
    t.fontStyle || r && r.getShallow("fontStyle") || "",
    t.fontWeight || r && r.getShallow("fontWeight") || "",
    (t.fontSize || r && r.getShallow("fontSize") || 12) + "px",
    t.fontFamily || r && r.getShallow("fontFamily") || "sans-serif"
  ].join(" "));
}
var Hs = je();
function a_(t, e, r, n) {
  if (t) {
    var a = Hs(t);
    a.prevValue = a.value, a.value = r;
    var o = e.normal;
    a.valueAnimation = o.get("valueAnimation"), a.valueAnimation && (a.precision = o.get("precision"), a.defaultInterpolatedText = n, a.statesModels = e);
  }
}
function bue(t, e, r, n, a) {
  var o = Hs(t);
  if (!o.valueAnimation || o.prevValue === o.value)
    return;
  var i = o.defaultInterpolatedText, l = de(o.interpolatedValue, o.prevValue), c = o.value;
  function u(d) {
    var f = g9(r, o.precision, l, c, d);
    o.interpolatedValue = d === 1 ? null : f;
    var h = jh({
      labelDataIndex: e,
      labelFetcher: a,
      defaultText: i ? i(f) : f + ""
    }, o.statesModels, f);
    n_(t, h);
  }
  t.percent = 0, (o.prevValue == null ? dt : rt)(t, {
    // percent is used to prevent animation from being aborted #15916
    percent: 1
  }, n, e, null, u);
}
var _ue = ["textStyle", "color"], Ed = ["fontStyle", "fontWeight", "fontSize", "fontFamily", "padding", "lineHeight", "rich", "width", "height", "overflow"], Sd = new Ye(), xue = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getTextColor = function(e) {
      var r = this.ecModel;
      return this.getShallow("color") || (!e && r ? r.get(_ue) : null);
    }, t.prototype.getFont = function() {
      return yue({
        fontStyle: this.getShallow("fontStyle"),
        fontWeight: this.getShallow("fontWeight"),
        fontSize: this.getShallow("fontSize"),
        fontFamily: this.getShallow("fontFamily")
      }, this.ecModel);
    }, t.prototype.getTextRect = function(e) {
      for (var r = {
        text: e,
        verticalAlign: this.getShallow("verticalAlign") || this.getShallow("baseline")
      }, n = 0; n < Ed.length; n++)
        r[Ed[n]] = this.getShallow(Ed[n]);
      return Sd.useStyle(r), Sd.update(), Sd.getBoundingRect();
    }, t;
  }()
), o_ = [
  ["lineWidth", "width"],
  ["stroke", "color"],
  ["opacity"],
  ["shadowBlur"],
  ["shadowOffsetX"],
  ["shadowOffsetY"],
  ["shadowColor"],
  ["lineDash", "type"],
  ["lineDashOffset", "dashOffset"],
  ["lineCap", "cap"],
  ["lineJoin", "join"],
  ["miterLimit"]
  // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
  // So do not transfer decal directly.
], Cue = ts(o_), Eue = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getLineStyle = function(e) {
      return Cue(this, e);
    }, t;
  }()
), i_ = [
  ["fill", "color"],
  ["stroke", "borderColor"],
  ["lineWidth", "borderWidth"],
  ["opacity"],
  ["shadowBlur"],
  ["shadowOffsetX"],
  ["shadowOffsetY"],
  ["shadowColor"],
  ["lineDash", "borderType"],
  ["lineDashOffset", "borderDashOffset"],
  ["lineCap", "borderCap"],
  ["lineJoin", "borderJoin"],
  ["miterLimit", "borderMiterLimit"]
  // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
  // So do not transfer decal directly.
], Sue = ts(i_), Rue = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getItemStyle = function(e, r) {
      return Sue(this, e, r);
    }, t;
  }()
), Ve = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.parentModel = r, this.ecModel = n, this.option = e;
    }
    return t.prototype.init = function(e, r, n) {
    }, t.prototype.mergeOption = function(e, r) {
      Ce(this.option, e, !0);
    }, t.prototype.get = function(e, r) {
      return e == null ? this.option : this._doGet(this.parsePath(e), !r && this.parentModel);
    }, t.prototype.getShallow = function(e, r) {
      var n = this.option, a = n == null ? n : n[e];
      if (a == null && !r) {
        var o = this.parentModel;
        o && (a = o.getShallow(e));
      }
      return a;
    }, t.prototype.getModel = function(e, r) {
      var n = e != null, a = n ? this.parsePath(e) : null, o = n ? this._doGet(a) : this.option;
      return r = r || this.parentModel && this.parentModel.getModel(this.resolveParentPath(a)), new t(o, r, this.ecModel);
    }, t.prototype.isEmpty = function() {
      return this.option == null;
    }, t.prototype.restoreData = function() {
    }, t.prototype.clone = function() {
      var e = this.constructor;
      return new e(be(this.option));
    }, t.prototype.parsePath = function(e) {
      return typeof e == "string" ? e.split(".") : e;
    }, t.prototype.resolveParentPath = function(e) {
      return e;
    }, t.prototype.isAnimationEnabled = function() {
      if (!ue.node && this.option) {
        if (this.option.animation != null)
          return !!this.option.animation;
        if (this.parentModel)
          return this.parentModel.isAnimationEnabled();
      }
    }, t.prototype._doGet = function(e, r) {
      var n = this.option;
      if (!e)
        return n;
      for (var a = 0; a < e.length && !(e[a] && (n = n && typeof n == "object" ? n[e[a]] : null, n == null)); a++)
        ;
      return n == null && r && (n = r._doGet(this.resolveParentPath(e), r.parentModel)), n;
    }, t;
  }()
);
Jv(Ve);
Mce(Ve);
tr(Ve, Eue);
tr(Ve, Rue);
tr(Ve, Oce);
tr(Ve, xue);
var Mue = Math.round(Math.random() * 10);
function N1(t) {
  return [t || "", Mue++].join("_");
}
function Aue(t) {
  var e = {};
  t.registerSubTypeDefaulter = function(r, n) {
    var a = Kr(r);
    e[a.main] = n;
  }, t.determineSubType = function(r, n) {
    var a = n.type;
    if (!a) {
      var o = Kr(r).main;
      t.hasSubTypes(r) && e[o] && (a = e[o](n));
    }
    return a;
  };
}
function kue(t, e) {
  t.topologicalTravel = function(o, i, l, c) {
    if (!o.length)
      return;
    var u = r(i), d = u.graph, f = u.noEntryList, h = {};
    for (I(o, function(y) {
      h[y] = !0;
    }); f.length; ) {
      var v = f.pop(), p = d[v], g = !!h[v];
      g && (l.call(c, v, p.originalDeps.slice()), delete h[v]), I(p.successor, g ? w : m);
    }
    I(h, function() {
      var y = "";
      throw process.env.NODE_ENV !== "production" && (y = Q0("Circular dependency may exists: ", h, o, i)), new Error(y);
    });
    function m(y) {
      d[y].entryCount--, d[y].entryCount === 0 && f.push(y);
    }
    function w(y) {
      h[y] = !0, m(y);
    }
  };
  function r(o) {
    var i = {}, l = [];
    return I(o, function(c) {
      var u = n(i, c), d = u.originalDeps = e(c), f = a(d, o);
      u.entryCount = f.length, u.entryCount === 0 && l.push(c), I(f, function(h) {
        Re(u.predecessor, h) < 0 && u.predecessor.push(h);
        var v = n(i, h);
        Re(v.successor, h) < 0 && v.successor.push(c);
      });
    }), {
      graph: i,
      noEntryList: l
    };
  }
  function n(o, i) {
    return o[i] || (o[i] = {
      predecessor: [],
      successor: []
    }), o[i];
  }
  function a(o, i) {
    var l = [];
    return I(o, function(c) {
      Re(i, c) >= 0 && l.push(c);
    }), l;
  }
}
function B1(t, e) {
  return Ce(Ce({}, t, !0), e, !0);
}
const Lue = {
  time: {
    month: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    monthAbbr: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    dayOfWeek: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    dayOfWeekAbbr: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
  },
  legend: {
    selector: {
      all: "All",
      inverse: "Inv"
    }
  },
  toolbox: {
    brush: {
      title: {
        rect: "Box Select",
        polygon: "Lasso Select",
        lineX: "Horizontally Select",
        lineY: "Vertically Select",
        keep: "Keep Selections",
        clear: "Clear Selections"
      }
    },
    dataView: {
      title: "Data View",
      lang: ["Data View", "Close", "Refresh"]
    },
    dataZoom: {
      title: {
        zoom: "Zoom",
        back: "Zoom Reset"
      }
    },
    magicType: {
      title: {
        line: "Switch to Line Chart",
        bar: "Switch to Bar Chart",
        stack: "Stack",
        tiled: "Tile"
      }
    },
    restore: {
      title: "Restore"
    },
    saveAsImage: {
      title: "Save as Image",
      lang: ["Right Click to Save Image"]
    }
  },
  series: {
    typeNames: {
      pie: "Pie chart",
      bar: "Bar chart",
      line: "Line chart",
      scatter: "Scatter plot",
      effectScatter: "Ripple scatter plot",
      radar: "Radar chart",
      tree: "Tree",
      treemap: "Treemap",
      boxplot: "Boxplot",
      candlestick: "Candlestick",
      k: "K line chart",
      heatmap: "Heat map",
      map: "Map",
      parallel: "Parallel coordinate map",
      lines: "Line graph",
      graph: "Relationship graph",
      sankey: "Sankey diagram",
      funnel: "Funnel chart",
      gauge: "Gauge",
      pictorialBar: "Pictorial bar",
      themeRiver: "Theme River Map",
      sunburst: "Sunburst",
      custom: "Custom chart",
      chart: "Chart"
    }
  },
  aria: {
    general: {
      withTitle: 'This is a chart about "{title}"',
      withoutTitle: "This is a chart"
    },
    series: {
      single: {
        prefix: "",
        withName: " with type {seriesType} named {seriesName}.",
        withoutName: " with type {seriesType}."
      },
      multiple: {
        prefix: ". It consists of {seriesCount} series count.",
        withName: " The {seriesId} series is a {seriesType} representing {seriesName}.",
        withoutName: " The {seriesId} series is a {seriesType}.",
        separator: {
          middle: "",
          end: ""
        }
      }
    },
    data: {
      allData: "The data is as follows: ",
      partialData: "The first {displayCnt} items are: ",
      withName: "the data for {name} is {value}",
      withoutName: "{value}",
      separator: {
        middle: ", ",
        end: ". "
      }
    }
  }
}, Tue = {
  time: {
    month: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
    monthAbbr: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
    dayOfWeek: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
    dayOfWeekAbbr: ["日", "一", "二", "三", "四", "五", "六"]
  },
  legend: {
    selector: {
      all: "全选",
      inverse: "反选"
    }
  },
  toolbox: {
    brush: {
      title: {
        rect: "矩形选择",
        polygon: "圈选",
        lineX: "横向选择",
        lineY: "纵向选择",
        keep: "保持选择",
        clear: "清除选择"
      }
    },
    dataView: {
      title: "数据视图",
      lang: ["数据视图", "关闭", "刷新"]
    },
    dataZoom: {
      title: {
        zoom: "区域缩放",
        back: "区域缩放还原"
      }
    },
    magicType: {
      title: {
        line: "切换为折线图",
        bar: "切换为柱状图",
        stack: "切换为堆叠",
        tiled: "切换为平铺"
      }
    },
    restore: {
      title: "还原"
    },
    saveAsImage: {
      title: "保存为图片",
      lang: ["右键另存为图片"]
    }
  },
  series: {
    typeNames: {
      pie: "饼图",
      bar: "柱状图",
      line: "折线图",
      scatter: "散点图",
      effectScatter: "涟漪散点图",
      radar: "雷达图",
      tree: "树图",
      treemap: "矩形树图",
      boxplot: "箱型图",
      candlestick: "K线图",
      k: "K线图",
      heatmap: "热力图",
      map: "地图",
      parallel: "平行坐标图",
      lines: "线图",
      graph: "关系图",
      sankey: "桑基图",
      funnel: "漏斗图",
      gauge: "仪表盘图",
      pictorialBar: "象形柱图",
      themeRiver: "主题河流图",
      sunburst: "旭日图",
      custom: "自定义图表",
      chart: "图表"
    }
  },
  aria: {
    general: {
      withTitle: "这是一个关于“{title}”的图表。",
      withoutTitle: "这是一个图表，"
    },
    series: {
      single: {
        prefix: "",
        withName: "图表类型是{seriesType}，表示{seriesName}。",
        withoutName: "图表类型是{seriesType}。"
      },
      multiple: {
        prefix: "它由{seriesCount}个图表系列组成。",
        withName: "第{seriesId}个系列是一个表示{seriesName}的{seriesType}，",
        withoutName: "第{seriesId}个系列是一个{seriesType}，",
        separator: {
          middle: "；",
          end: "。"
        }
      }
    },
    data: {
      allData: "其数据是——",
      partialData: "其中，前{displayCnt}项是——",
      withName: "{name}的数据是{value}",
      withoutName: "{value}",
      separator: {
        middle: "，",
        end: ""
      }
    }
  }
};
var lu = "ZH", h7 = "EN", si = h7, b0 = {}, v7 = {}, l_ = ue.domSupported ? function() {
  var t = (
    /* eslint-disable-next-line */
    (document.documentElement.lang || navigator.language || navigator.browserLanguage || si).toUpperCase()
  );
  return t.indexOf(lu) > -1 ? lu : si;
}() : si;
function p7(t, e) {
  t = t.toUpperCase(), v7[t] = new Ve(e), b0[t] = e;
}
function Oue(t) {
  if (Q(t)) {
    var e = b0[t.toUpperCase()] || {};
    return t === lu || t === h7 ? be(e) : Ce(be(e), be(b0[si]), !1);
  } else
    return Ce(be(t), be(b0[si]), !1);
}
function Iue(t) {
  return v7[t];
}
function Pue() {
  return v7[si];
}
p7(h7, Lue);
p7(lu, Tue);
var g7 = 1e3, m7 = g7 * 60, $l = m7 * 60, vr = $l * 24, Rm = vr * 365, Al = {
  year: "{yyyy}",
  month: "{MMM}",
  day: "{d}",
  hour: "{HH}:{mm}",
  minute: "{HH}:{mm}",
  second: "{HH}:{mm}:{ss}",
  millisecond: "{HH}:{mm}:{ss} {SSS}",
  none: "{yyyy}-{MM}-{dd} {HH}:{mm}:{ss} {SSS}"
}, Ec = "{yyyy}-{MM}-{dd}", Mm = {
  year: "{yyyy}",
  month: "{yyyy}-{MM}",
  day: Ec,
  hour: Ec + " " + Al.hour,
  minute: Ec + " " + Al.minute,
  second: Ec + " " + Al.second,
  millisecond: Al.none
}, Rd = ["year", "month", "day", "hour", "minute", "second", "millisecond"], s_ = ["year", "half-year", "quarter", "month", "week", "half-week", "day", "half-day", "quarter-day", "hour", "minute", "second", "millisecond"];
function Rt(t, e) {
  return t += "", "0000".substr(0, e - t.length) + t;
}
function ci(t) {
  switch (t) {
    case "half-year":
    case "quarter":
      return "month";
    case "week":
    case "half-week":
      return "day";
    case "half-day":
    case "quarter-day":
      return "hour";
    default:
      return t;
  }
}
function Due(t) {
  return t === ci(t);
}
function Nue(t) {
  switch (t) {
    case "year":
    case "month":
      return "day";
    case "millisecond":
      return "millisecond";
    default:
      return "second";
  }
}
function js(t, e, r, n) {
  var a = wr(t), o = a[w7(r)](), i = a[ui(r)]() + 1, l = Math.floor((i - 1) / 3) + 1, c = a[F1(r)](), u = a["get" + (r ? "UTC" : "") + "Day"](), d = a[ls(r)](), f = (d - 1) % 12 + 1, h = a[$1(r)](), v = a[V1(r)](), p = a[Z1(r)](), g = d >= 12 ? "pm" : "am", m = g.toUpperCase(), w = n instanceof Ve ? n : Iue(n || l_) || Pue(), y = w.getModel("time"), b = y.get("month"), _ = y.get("monthAbbr"), x = y.get("dayOfWeek"), E = y.get("dayOfWeekAbbr");
  return (e || "").replace(/{a}/g, g + "").replace(/{A}/g, m + "").replace(/{yyyy}/g, o + "").replace(/{yy}/g, Rt(o % 100 + "", 2)).replace(/{Q}/g, l + "").replace(/{MMMM}/g, b[i - 1]).replace(/{MMM}/g, _[i - 1]).replace(/{MM}/g, Rt(i, 2)).replace(/{M}/g, i + "").replace(/{dd}/g, Rt(c, 2)).replace(/{d}/g, c + "").replace(/{eeee}/g, x[u]).replace(/{ee}/g, E[u]).replace(/{e}/g, u + "").replace(/{HH}/g, Rt(d, 2)).replace(/{H}/g, d + "").replace(/{hh}/g, Rt(f + "", 2)).replace(/{h}/g, f + "").replace(/{mm}/g, Rt(h, 2)).replace(/{m}/g, h + "").replace(/{ss}/g, Rt(v, 2)).replace(/{s}/g, v + "").replace(/{SSS}/g, Rt(p, 3)).replace(/{S}/g, p + "");
}
function Bue(t, e, r, n, a) {
  var o = null;
  if (Q(r))
    o = r;
  else if (ie(r))
    o = r(t.value, e, {
      level: t.level
    });
  else {
    var i = H({}, Al);
    if (t.level > 0)
      for (var l = 0; l < Rd.length; ++l)
        i[Rd[l]] = "{primary|" + i[Rd[l]] + "}";
    var c = r ? r.inherit === !1 ? r : Te(r, i) : i, u = c_(t.value, a);
    if (c[u])
      o = c[u];
    else if (c.inherit) {
      for (var d = s_.indexOf(u), l = d - 1; l >= 0; --l)
        if (c[u]) {
          o = c[u];
          break;
        }
      o = o || i.none;
    }
    if (z(o)) {
      var f = t.level == null ? 0 : t.level >= 0 ? t.level : o.length + t.level;
      f = Math.min(f, o.length - 1), o = o[f];
    }
  }
  return js(new Date(t.value), o, a, n);
}
function c_(t, e) {
  var r = wr(t), n = r[ui(e)]() + 1, a = r[F1(e)](), o = r[ls(e)](), i = r[$1(e)](), l = r[V1(e)](), c = r[Z1(e)](), u = c === 0, d = u && l === 0, f = d && i === 0, h = f && o === 0, v = h && a === 1, p = v && n === 1;
  return p ? "year" : v ? "month" : h ? "day" : f ? "hour" : d ? "minute" : u ? "second" : "millisecond";
}
function Am(t, e, r) {
  var n = De(t) ? wr(t) : t;
  switch (e = e || c_(t, r), e) {
    case "year":
      return n[w7(r)]();
    case "half-year":
      return n[ui(r)]() >= 6 ? 1 : 0;
    case "quarter":
      return Math.floor((n[ui(r)]() + 1) / 4);
    case "month":
      return n[ui(r)]();
    case "day":
      return n[F1(r)]();
    case "half-day":
      return n[ls(r)]() / 24;
    case "hour":
      return n[ls(r)]();
    case "minute":
      return n[$1(r)]();
    case "second":
      return n[V1(r)]();
    case "millisecond":
      return n[Z1(r)]();
  }
}
function w7(t) {
  return t ? "getUTCFullYear" : "getFullYear";
}
function ui(t) {
  return t ? "getUTCMonth" : "getMonth";
}
function F1(t) {
  return t ? "getUTCDate" : "getDate";
}
function ls(t) {
  return t ? "getUTCHours" : "getHours";
}
function $1(t) {
  return t ? "getUTCMinutes" : "getMinutes";
}
function V1(t) {
  return t ? "getUTCSeconds" : "getSeconds";
}
function Z1(t) {
  return t ? "getUTCMilliseconds" : "getMilliseconds";
}
function Fue(t) {
  return t ? "setUTCFullYear" : "setFullYear";
}
function u_(t) {
  return t ? "setUTCMonth" : "setMonth";
}
function d_(t) {
  return t ? "setUTCDate" : "setDate";
}
function f_(t) {
  return t ? "setUTCHours" : "setHours";
}
function h_(t) {
  return t ? "setUTCMinutes" : "setMinutes";
}
function v_(t) {
  return t ? "setUTCSeconds" : "setSeconds";
}
function p_(t) {
  return t ? "setUTCMilliseconds" : "setMilliseconds";
}
function $ue(t, e, r, n, a, o, i, l) {
  var c = new Ye({
    style: {
      text: t,
      font: e,
      align: r,
      verticalAlign: n,
      padding: a,
      rich: o,
      overflow: i ? "truncate" : null,
      lineHeight: l
    }
  });
  return c.getBoundingRect();
}
function y7(t) {
  if (!qv(t))
    return Q(t) ? t : "-";
  var e = (t + "").split(".");
  return e[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, "$1,") + (e.length > 1 ? "." + e[1] : "");
}
function b7(t, e) {
  return t = (t || "").toLowerCase().replace(/-(.)/g, function(r, n) {
    return n.toUpperCase();
  }), e && t && (t = t.charAt(0).toUpperCase() + t.slice(1)), t;
}
var Ws = Dv;
function Wh(t, e, r) {
  var n = "{yyyy}-{MM}-{dd} {HH}:{mm}:{ss}";
  function a(d) {
    return d && Ir(d) ? d : "-";
  }
  function o(d) {
    return !!(d != null && !isNaN(d) && isFinite(d));
  }
  var i = e === "time", l = t instanceof Date;
  if (i || l) {
    var c = i ? wr(t) : t;
    if (isNaN(+c)) {
      if (l)
        return "-";
    } else return js(c, n, r);
  }
  if (e === "ordinal")
    return Xl(t) ? a(t) : De(t) && o(t) ? t + "" : "-";
  var u = es(t);
  return o(u) ? y7(u) : Xl(t) ? a(t) : typeof t == "boolean" ? t + "" : "-";
}
var km = ["a", "b", "c", "d", "e", "f", "g"], Md = function(t, e) {
  return "{" + t + (e ?? "") + "}";
};
function _7(t, e, r) {
  z(e) || (e = [e]);
  var n = e.length;
  if (!n)
    return "";
  for (var a = e[0].$vars || [], o = 0; o < a.length; o++) {
    var i = km[o];
    t = t.replace(Md(i), Md(i, 0));
  }
  for (var l = 0; l < n; l++)
    for (var c = 0; c < a.length; c++) {
      var u = e[l][a[c]];
      t = t.replace(Md(km[c], l), r ? Ft(u) : u);
    }
  return t;
}
function g_(t, e) {
  var r = Q(t) ? {
    color: t,
    extraCssText: e
  } : t || {}, n = r.color, a = r.type;
  e = r.extraCssText;
  var o = r.renderMode || "html";
  if (!n)
    return "";
  if (o === "html")
    return a === "subItem" ? '<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;border-radius:4px;width:4px;height:4px;background-color:' + Ft(n) + ";" + (e || "") + '"></span>' : '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:' + Ft(n) + ";" + (e || "") + '"></span>';
  var i = r.markerId || "markerX";
  return {
    renderMode: o,
    content: "{" + i + "|}  ",
    style: a === "subItem" ? {
      width: 4,
      height: 4,
      borderRadius: 2,
      backgroundColor: n
    } : {
      width: 10,
      height: 10,
      borderRadius: 5,
      backgroundColor: n
    }
  };
}
function Vue(t, e, r) {
  process.env.NODE_ENV !== "production" && tt("echarts.format.formatTime", "echarts.time.format"), (t === "week" || t === "month" || t === "quarter" || t === "half-year" || t === "year") && (t = `MM-dd
yyyy`);
  var n = wr(e), a = r ? "getUTC" : "get", o = n[a + "FullYear"](), i = n[a + "Month"]() + 1, l = n[a + "Date"](), c = n[a + "Hours"](), u = n[a + "Minutes"](), d = n[a + "Seconds"](), f = n[a + "Milliseconds"]();
  return t = t.replace("MM", Rt(i, 2)).replace("M", i).replace("yyyy", o).replace("yy", Rt(o % 100 + "", 2)).replace("dd", Rt(l, 2)).replace("d", l).replace("hh", Rt(c, 2)).replace("h", c).replace("mm", Rt(u, 2)).replace("m", u).replace("ss", Rt(d, 2)).replace("s", d).replace("SSS", Rt(f, 3)), t;
}
function Zue(t) {
  return t && t.charAt(0).toUpperCase() + t.substr(1);
}
function lo(t, e) {
  return e = e || "transparent", Q(t) ? t : re(t) && t.colorStops && (t.colorStops[0] || {}).color || e;
}
function Lm(t, e) {
  if (e === "_blank" || e === "blank") {
    var r = window.open();
    r.opener = null, r.location.href = t;
  } else
    window.open(t, e);
}
var _0 = I, Hue = ["left", "right", "top", "bottom", "width", "height"], Sc = [["width", "left", "right"], ["height", "top", "bottom"]];
function x7(t, e, r, n, a) {
  var o = 0, i = 0;
  n == null && (n = 1 / 0), a == null && (a = 1 / 0);
  var l = 0;
  e.eachChild(function(c, u) {
    var d = c.getBoundingRect(), f = e.childAt(u + 1), h = f && f.getBoundingRect(), v, p;
    if (t === "horizontal") {
      var g = d.width + (h ? -h.x + d.x : 0);
      v = o + g, v > n || c.newline ? (o = 0, v = g, i += l + r, l = d.height) : l = Math.max(l, d.height);
    } else {
      var m = d.height + (h ? -h.y + d.y : 0);
      p = i + m, p > a || c.newline ? (o += l + r, i = 0, p = m, l = d.width) : l = Math.max(l, d.width);
    }
    c.newline || (c.x = o, c.y = i, c.markRedraw(), t === "horizontal" ? o = v + r : i = p + r);
  });
}
var Vl = x7;
Oe(x7, "vertical");
Oe(x7, "horizontal");
function da(t, e, r) {
  r = Ws(r || 0);
  var n = e.width, a = e.height, o = fe(t.left, n), i = fe(t.top, a), l = fe(t.right, n), c = fe(t.bottom, a), u = fe(t.width, n), d = fe(t.height, a), f = r[2] + r[0], h = r[1] + r[3], v = t.aspect;
  switch (isNaN(u) && (u = n - l - h - o), isNaN(d) && (d = a - c - f - i), v != null && (isNaN(u) && isNaN(d) && (v > n / a ? u = n * 0.8 : d = a * 0.8), isNaN(u) && (u = v * d), isNaN(d) && (d = u / v)), isNaN(o) && (o = n - l - u - h), isNaN(i) && (i = a - c - d - f), t.left || t.right) {
    case "center":
      o = n / 2 - u / 2 - r[3];
      break;
    case "right":
      o = n - u - h;
      break;
  }
  switch (t.top || t.bottom) {
    case "middle":
    case "center":
      i = a / 2 - d / 2 - r[0];
      break;
    case "bottom":
      i = a - d - f;
      break;
  }
  o = o || 0, i = i || 0, isNaN(u) && (u = n - h - o - (l || 0)), isNaN(d) && (d = a - f - i - (c || 0));
  var p = new Le(o + r[3], i + r[0], u, d);
  return p.margin = r, p;
}
function ss(t) {
  var e = t.layoutMode || t.constructor.layoutMode;
  return re(e) ? e : e ? {
    type: e
  } : null;
}
function Ri(t, e, r) {
  var n = r && r.ignoreSize;
  !z(n) && (n = [n, n]);
  var a = i(Sc[0], 0), o = i(Sc[1], 1);
  u(Sc[0], t, a), u(Sc[1], t, o);
  function i(d, f) {
    var h = {}, v = 0, p = {}, g = 0, m = 2;
    if (_0(d, function(b) {
      p[b] = t[b];
    }), _0(d, function(b) {
      l(e, b) && (h[b] = p[b] = e[b]), c(h, b) && v++, c(p, b) && g++;
    }), n[f])
      return c(e, d[1]) ? p[d[2]] = null : c(e, d[2]) && (p[d[1]] = null), p;
    if (g === m || !v)
      return p;
    if (v >= m)
      return h;
    for (var w = 0; w < d.length; w++) {
      var y = d[w];
      if (!l(h, y) && l(t, y)) {
        h[y] = t[y];
        break;
      }
    }
    return h;
  }
  function l(d, f) {
    return d.hasOwnProperty(f);
  }
  function c(d, f) {
    return d[f] != null && d[f] !== "auto";
  }
  function u(d, f, h) {
    _0(d, function(v) {
      f[v] = h[v];
    });
  }
}
function zs(t) {
  return jue({}, t);
}
function jue(t, e) {
  return e && t && _0(Hue, function(r) {
    e.hasOwnProperty(r) && (t[r] = e[r]);
  }), t;
}
var Wue = je(), Ee = (
  /** @class */
  function(t) {
    K(e, t);
    function e(r, n, a) {
      var o = t.call(this, r, n, a) || this;
      return o.uid = N1("ec_cpt_model"), o;
    }
    return e.prototype.init = function(r, n, a) {
      this.mergeDefaultAndTheme(r, a);
    }, e.prototype.mergeDefaultAndTheme = function(r, n) {
      var a = ss(this), o = a ? zs(r) : {}, i = n.getTheme();
      Ce(r, i.get(this.mainType)), Ce(r, this.getDefaultOption()), a && Ri(r, o, a);
    }, e.prototype.mergeOption = function(r, n) {
      Ce(this.option, r, !0);
      var a = ss(this);
      a && Ri(this.option, r, a);
    }, e.prototype.optionUpdated = function(r, n) {
    }, e.prototype.getDefaultOption = function() {
      var r = this.constructor;
      if (!Ece(r))
        return r.defaultOption;
      var n = Wue(this);
      if (!n.defaultOption) {
        for (var a = [], o = r; o; ) {
          var i = o.prototype.defaultOption;
          i && a.push(i), o = o.superClass;
        }
        for (var l = {}, c = a.length - 1; c >= 0; c--)
          l = Ce(l, a[c], !0);
        n.defaultOption = l;
      }
      return n.defaultOption;
    }, e.prototype.getReferringComponents = function(r, n) {
      var a = r + "Index", o = r + "Id";
      return Ds(this.ecModel, r, {
        index: this.get(a, !0),
        id: this.get(o, !0)
      }, n);
    }, e.prototype.getBoxLayoutParams = function() {
      var r = this;
      return {
        left: r.get("left"),
        top: r.get("top"),
        right: r.get("right"),
        bottom: r.get("bottom"),
        width: r.get("width"),
        height: r.get("height")
      };
    }, e.prototype.getZLevelKey = function() {
      return "";
    }, e.prototype.setZLevel = function(r) {
      this.option.zlevel = r;
    }, e.protoInitialize = function() {
      var r = e.prototype;
      r.type = "component", r.id = "", r.name = "", r.mainType = "", r.subType = "", r.componentIndex = 0;
    }(), e;
  }(Ve)
);
w9(Ee, Ve);
S1(Ee);
Aue(Ee);
kue(Ee, zue);
function zue(t) {
  var e = [];
  return I(Ee.getClassesByMainType(t), function(r) {
    e = e.concat(r.dependencies || r.prototype.dependencies || []);
  }), e = J(e, function(r) {
    return Kr(r).main;
  }), t !== "dataset" && Re(e, "dataset") <= 0 && e.unshift("dataset"), e;
}
var m_ = "";
typeof navigator < "u" && (m_ = navigator.platform || "");
var Bo = "rgba(0, 0, 0, 0.2)";
const Gue = {
  darkMode: "auto",
  // backgroundColor: 'rgba(0,0,0,0)',
  colorBy: "series",
  color: ["#5470c6", "#91cc75", "#fac858", "#ee6666", "#73c0de", "#3ba272", "#fc8452", "#9a60b4", "#ea7ccc"],
  gradientColor: ["#f6efa6", "#d88273", "#bf444c"],
  aria: {
    decal: {
      decals: [{
        color: Bo,
        dashArrayX: [1, 0],
        dashArrayY: [2, 5],
        symbolSize: 1,
        rotation: Math.PI / 6
      }, {
        color: Bo,
        symbol: "circle",
        dashArrayX: [[8, 8], [0, 8, 8, 0]],
        dashArrayY: [6, 0],
        symbolSize: 0.8
      }, {
        color: Bo,
        dashArrayX: [1, 0],
        dashArrayY: [4, 3],
        rotation: -Math.PI / 4
      }, {
        color: Bo,
        dashArrayX: [[6, 6], [0, 6, 6, 0]],
        dashArrayY: [6, 0]
      }, {
        color: Bo,
        dashArrayX: [[1, 0], [1, 6]],
        dashArrayY: [1, 0, 6, 0],
        rotation: Math.PI / 4
      }, {
        color: Bo,
        symbol: "triangle",
        dashArrayX: [[9, 9], [0, 9, 9, 0]],
        dashArrayY: [7, 2],
        symbolSize: 0.75
      }]
    }
  },
  // If xAxis and yAxis declared, grid is created by default.
  // grid: {},
  textStyle: {
    // color: '#000',
    // decoration: 'none',
    // PENDING
    fontFamily: m_.match(/^Win/) ? "Microsoft YaHei" : "sans-serif",
    // fontFamily: 'Arial, Verdana, sans-serif',
    fontSize: 12,
    fontStyle: "normal",
    fontWeight: "normal"
  },
  // http://blogs.adobe.com/webplatform/2014/02/24/using-blend-modes-in-html-canvas/
  // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
  // Default is source-over
  blendMode: null,
  stateAnimation: {
    duration: 300,
    easing: "cubicOut"
  },
  animation: "auto",
  animationDuration: 1e3,
  animationDurationUpdate: 500,
  animationEasing: "cubicInOut",
  animationEasingUpdate: "cubicInOut",
  animationThreshold: 2e3,
  // Configuration for progressive/incremental rendering
  progressiveThreshold: 3e3,
  progressive: 400,
  // Threshold of if use single hover layer to optimize.
  // It is recommended that `hoverLayerThreshold` is equivalent to or less than
  // `progressiveThreshold`, otherwise hover will cause restart of progressive,
  // which is unexpected.
  // see example <echarts/test/heatmap-large.html>.
  hoverLayerThreshold: 3e3,
  // See: module:echarts/scale/Time
  useUTC: !1
};
var zh = se(["tooltip", "label", "itemName", "itemId", "itemGroupId", "itemChildGroupId", "seriesName"]), Cr = "original", zt = "arrayRows", Zr = "objectRows", an = "keyedColumns", wn = "typedArray", w_ = "unknown", yn = "column", zi = "row", st = {
  Must: 1,
  Might: 2,
  Not: 3
  // Other cases
}, y_ = je();
function Uue(t) {
  y_(t).datasetMap = se();
}
function Yue(t, e, r) {
  var n = {}, a = C7(e);
  if (!a || !t)
    return n;
  var o = [], i = [], l = e.ecModel, c = y_(l).datasetMap, u = a.uid + "_" + r.seriesLayoutBy, d, f;
  t = t.slice(), I(t, function(g, m) {
    var w = re(g) ? g : t[m] = {
      name: g
    };
    w.type === "ordinal" && d == null && (d = m, f = p(w)), n[w.name] = [];
  });
  var h = c.get(u) || c.set(u, {
    categoryWayDim: f,
    valueWayDim: 0
  });
  I(t, function(g, m) {
    var w = g.name, y = p(g);
    if (d == null) {
      var b = h.valueWayDim;
      v(n[w], b, y), v(i, b, y), h.valueWayDim += y;
    } else if (d === m)
      v(n[w], 0, y), v(o, 0, y);
    else {
      var b = h.categoryWayDim;
      v(n[w], b, y), v(i, b, y), h.categoryWayDim += y;
    }
  });
  function v(g, m, w) {
    for (var y = 0; y < w; y++)
      g.push(m + y);
  }
  function p(g) {
    var m = g.dimsDef;
    return m ? m.length : 1;
  }
  return o.length && (n.itemName = o), i.length && (n.seriesName = i), n;
}
function Xue(t, e, r) {
  var n = {}, a = C7(t);
  if (!a)
    return n;
  var o = e.sourceFormat, i = e.dimensionsDefine, l;
  (o === Zr || o === an) && I(i, function(d, f) {
    (re(d) ? d.name : d) === "name" && (l = f);
  });
  var c = function() {
    for (var d = {}, f = {}, h = [], v = 0, p = Math.min(5, r); v < p; v++) {
      var g = __(e.data, o, e.seriesLayoutBy, i, e.startIndex, v);
      h.push(g);
      var m = g === st.Not;
      if (m && d.v == null && v !== l && (d.v = v), (d.n == null || d.n === d.v || !m && h[d.n] === st.Not) && (d.n = v), w(d) && h[d.n] !== st.Not)
        return d;
      m || (g === st.Might && f.v == null && v !== l && (f.v = v), (f.n == null || f.n === f.v) && (f.n = v));
    }
    function w(y) {
      return y.v != null && y.n != null;
    }
    return w(d) ? d : w(f) ? f : null;
  }();
  if (c) {
    n.value = [c.v];
    var u = l ?? c.n;
    n.itemName = [u], n.seriesName = [u];
  }
  return n;
}
function C7(t) {
  var e = t.get("data", !0);
  if (!e)
    return Ds(t.ecModel, "dataset", {
      index: t.get("datasetIndex", !0),
      id: t.get("datasetId", !0)
    }, Ht).models[0];
}
function que(t) {
  return !t.get("transform", !0) && !t.get("fromTransformResult", !0) ? [] : Ds(t.ecModel, "dataset", {
    index: t.get("fromDatasetIndex", !0),
    id: t.get("fromDatasetId", !0)
  }, Ht).models;
}
function b_(t, e) {
  return __(t.data, t.sourceFormat, t.seriesLayoutBy, t.dimensionsDefine, t.startIndex, e);
}
function __(t, e, r, n, a, o) {
  var i, l = 5;
  if (yt(t))
    return st.Not;
  var c, u;
  if (n) {
    var d = n[o];
    re(d) ? (c = d.name, u = d.type) : Q(d) && (c = d);
  }
  if (u != null)
    return u === "ordinal" ? st.Must : st.Not;
  if (e === zt) {
    var f = t;
    if (r === zi) {
      for (var h = f[o], v = 0; v < (h || []).length && v < l; v++)
        if ((i = _(h[a + v])) != null)
          return i;
    } else
      for (var v = 0; v < f.length && v < l; v++) {
        var p = f[a + v];
        if (p && (i = _(p[o])) != null)
          return i;
      }
  } else if (e === Zr) {
    var g = t;
    if (!c)
      return st.Not;
    for (var v = 0; v < g.length && v < l; v++) {
      var m = g[v];
      if (m && (i = _(m[c])) != null)
        return i;
    }
  } else if (e === an) {
    var w = t;
    if (!c)
      return st.Not;
    var h = w[c];
    if (!h || yt(h))
      return st.Not;
    for (var v = 0; v < h.length && v < l; v++)
      if ((i = _(h[v])) != null)
        return i;
  } else if (e === Cr)
    for (var y = t, v = 0; v < y.length && v < l; v++) {
      var m = y[v], b = Ps(m);
      if (!z(b))
        return st.Not;
      if ((i = _(b[o])) != null)
        return i;
    }
  function _(x) {
    var E = Q(x);
    if (x != null && Number.isFinite(Number(x)) && x !== "")
      return E ? st.Might : st.Not;
    if (E && x !== "-")
      return st.Must;
  }
  return st.Not;
}
var Kue = se();
function Que(t, e, r) {
  var n = Kue.get(e);
  if (!n)
    return r;
  var a = n(t);
  if (!a)
    return r;
  if (process.env.NODE_ENV !== "production")
    for (var o = 0; o < a.length; o++)
      ge(Ci(a[o]));
  return r.concat(a);
}
var Tm = je();
je();
var E7 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getColorFromPalette = function(e, r, n) {
      var a = kt(this.get("color", !0)), o = this.get("colorLayer", !0);
      return e1e(this, Tm, a, o, e, r, n);
    }, t.prototype.clearColorPalette = function() {
      t1e(this, Tm);
    }, t;
  }()
);
function Jue(t, e) {
  for (var r = t.length, n = 0; n < r; n++)
    if (t[n].length > e)
      return t[n];
  return t[r - 1];
}
function e1e(t, e, r, n, a, o, i) {
  o = o || t;
  var l = e(o), c = l.paletteIdx || 0, u = l.paletteNameMap = l.paletteNameMap || {};
  if (u.hasOwnProperty(a))
    return u[a];
  var d = i == null || !n ? r : Jue(n, i);
  if (d = d || r, !(!d || !d.length)) {
    var f = d[c];
    return a && (u[a] = f), l.paletteIdx = (c + 1) % d.length, f;
  }
}
function t1e(t, e) {
  e(t).paletteIdx = 0, e(t).paletteNameMap = {};
}
var Rc, il, Om, Ad = "\0_ec_inner", Im = 1, r1e = {
  grid: "GridComponent",
  polar: "PolarComponent",
  geo: "GeoComponent",
  singleAxis: "SingleAxisComponent",
  parallel: "ParallelComponent",
  calendar: "CalendarComponent",
  graphic: "GraphicComponent",
  toolbox: "ToolboxComponent",
  tooltip: "TooltipComponent",
  axisPointer: "AxisPointerComponent",
  brush: "BrushComponent",
  title: "TitleComponent",
  timeline: "TimelineComponent",
  markPoint: "MarkPointComponent",
  markLine: "MarkLineComponent",
  markArea: "MarkAreaComponent",
  legend: "LegendComponent",
  dataZoom: "DataZoomComponent",
  visualMap: "VisualMapComponent",
  // aria: 'AriaComponent',
  // dataset: 'DatasetComponent',
  // Dependencies
  xAxis: "GridComponent",
  yAxis: "GridComponent",
  angleAxis: "PolarComponent",
  radiusAxis: "PolarComponent"
}, n1e = {
  line: "LineChart",
  bar: "BarChart",
  pie: "PieChart",
  scatter: "ScatterChart",
  radar: "RadarChart",
  map: "MapChart",
  tree: "TreeChart",
  treemap: "TreemapChart",
  graph: "GraphChart",
  gauge: "GaugeChart",
  funnel: "FunnelChart",
  parallel: "ParallelChart",
  sankey: "SankeyChart",
  boxplot: "BoxplotChart",
  candlestick: "CandlestickChart",
  effectScatter: "EffectScatterChart",
  lines: "LinesChart",
  heatmap: "HeatmapChart",
  pictorialBar: "PictorialBarChart",
  themeRiver: "ThemeRiverChart",
  sunburst: "SunburstChart",
  custom: "CustomChart"
}, su = {};
function a1e(t) {
  I(t, function(e, r) {
    if (!Ee.hasClass(r)) {
      var n = r1e[r];
      n && !su[n] && (bt("Component " + r + ` is used but not imported.
import { ` + n + ` } from 'echarts/components';
echarts.use([` + n + "]);"), su[n] = !0);
    }
  });
}
var S7 = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.init = function(r, n, a, o, i, l) {
      o = o || {}, this.option = null, this._theme = new Ve(o), this._locale = new Ve(i), this._optionManager = l;
    }, e.prototype.setOption = function(r, n, a) {
      process.env.NODE_ENV !== "production" && (ge(r != null, "option is null/undefined"), ge(r[Ad] !== Im, "please use chart.getOption()"));
      var o = Nm(n);
      this._optionManager.setOption(r, a, o), this._resetOption(null, o);
    }, e.prototype.resetOption = function(r, n) {
      return this._resetOption(r, Nm(n));
    }, e.prototype._resetOption = function(r, n) {
      var a = !1, o = this._optionManager;
      if (!r || r === "recreate") {
        var i = o.mountOption(r === "recreate");
        process.env.NODE_ENV !== "production" && a1e(i), !this.option || r === "recreate" ? Om(this, i) : (this.restoreData(), this._mergeOption(i, n)), a = !0;
      }
      if ((r === "timeline" || r === "media") && this.restoreData(), !r || r === "recreate" || r === "timeline") {
        var l = o.getTimelineOption(this);
        l && (a = !0, this._mergeOption(l, n));
      }
      if (!r || r === "recreate" || r === "media") {
        var c = o.getMediaOption(this);
        c.length && I(c, function(u) {
          a = !0, this._mergeOption(u, n);
        }, this);
      }
      return a;
    }, e.prototype.mergeOption = function(r) {
      this._mergeOption(r, null);
    }, e.prototype._mergeOption = function(r, n) {
      var a = this.option, o = this._componentsMap, i = this._componentsCount, l = [], c = se(), u = n && n.replaceMergeMainTypeMap;
      Uue(this), I(r, function(f, h) {
        f != null && (Ee.hasClass(h) ? h && (l.push(h), c.set(h, !0)) : a[h] = a[h] == null ? be(f) : Ce(a[h], f, !0));
      }), u && u.each(function(f, h) {
        Ee.hasClass(h) && !c.get(h) && (l.push(h), c.set(h, !0));
      }), Ee.topologicalTravel(l, Ee.getAllClassMainTypes(), d, this);
      function d(f) {
        var h = Que(this, f, kt(r[f])), v = o.get(f), p = (
          // `!oldCmptList` means init. See the comment in `mappingToExists`
          v ? u && u.get(f) ? "replaceMerge" : "normalMerge" : "replaceAll"
        ), g = cce(v, h, p);
        gce(g, f, Ee), a[f] = null, o.set(f, null), i.set(f, 0);
        var m = [], w = [], y = 0, b, _;
        I(g, function(x, E) {
          var S = x.existing, M = x.newOption;
          if (!M)
            S && (S.mergeOption({}, this), S.optionUpdated({}, !1));
          else {
            var R = f === "series", A = Ee.getClass(
              f,
              x.keyInfo.subType,
              !R
              // Give a more detailed warn later if series don't exists
            );
            if (!A) {
              if (process.env.NODE_ENV !== "production") {
                var k = x.keyInfo.subType, L = n1e[k];
                su[k] || (su[k] = !0, bt(L ? "Series " + k + ` is used but not imported.
import { ` + L + ` } from 'echarts/charts';
echarts.use([` + L + "]);" : "Unknown series " + k));
              }
              return;
            }
            if (f === "tooltip") {
              if (b) {
                process.env.NODE_ENV !== "production" && (_ || (pt("Currently only one tooltip component is allowed."), _ = !0));
                return;
              }
              b = !0;
            }
            if (S && S.constructor === A)
              S.name = x.keyInfo.name, S.mergeOption(M, this), S.optionUpdated(M, !1);
            else {
              var T = H({
                componentIndex: E
              }, x.keyInfo);
              S = new A(M, this, this, T), H(S, T), x.brandNew && (S.__requireNewView = !0), S.init(M, this, this), S.optionUpdated(null, !0);
            }
          }
          S ? (m.push(S.option), w.push(S), y++) : (m.push(void 0), w.push(void 0));
        }, this), a[f] = m, o.set(f, w), i.set(f, y), f === "series" && Rc(this);
      }
      this._seriesIndices || Rc(this);
    }, e.prototype.getOption = function() {
      var r = be(this.option);
      return I(r, function(n, a) {
        if (Ee.hasClass(a)) {
          for (var o = kt(n), i = o.length, l = !1, c = i - 1; c >= 0; c--)
            o[c] && !Ci(o[c]) ? l = !0 : (o[c] = null, !l && i--);
          o.length = i, r[a] = o;
        }
      }), delete r[Ad], r;
    }, e.prototype.getTheme = function() {
      return this._theme;
    }, e.prototype.getLocaleModel = function() {
      return this._locale;
    }, e.prototype.setUpdatePayload = function(r) {
      this._payload = r;
    }, e.prototype.getUpdatePayload = function() {
      return this._payload;
    }, e.prototype.getComponent = function(r, n) {
      var a = this._componentsMap.get(r);
      if (a) {
        var o = a[n || 0];
        if (o)
          return o;
        if (n == null) {
          for (var i = 0; i < a.length; i++)
            if (a[i])
              return a[i];
        }
      }
    }, e.prototype.queryComponents = function(r) {
      var n = r.mainType;
      if (!n)
        return [];
      var a = r.index, o = r.id, i = r.name, l = this._componentsMap.get(n);
      if (!l || !l.length)
        return [];
      var c;
      return a != null ? (c = [], I(kt(a), function(u) {
        l[u] && c.push(l[u]);
      })) : o != null ? c = Pm("id", o, l) : i != null ? c = Pm("name", i, l) : c = ot(l, function(u) {
        return !!u;
      }), Dm(c, r);
    }, e.prototype.findComponents = function(r) {
      var n = r.query, a = r.mainType, o = l(n), i = o ? this.queryComponents(o) : ot(this._componentsMap.get(a), function(u) {
        return !!u;
      });
      return c(Dm(i, r));
      function l(u) {
        var d = a + "Index", f = a + "Id", h = a + "Name";
        return u && (u[d] != null || u[f] != null || u[h] != null) ? {
          mainType: a,
          // subType will be filtered finally.
          index: u[d],
          id: u[f],
          name: u[h]
        } : null;
      }
      function c(u) {
        return r.filter ? ot(u, r.filter) : u;
      }
    }, e.prototype.eachComponent = function(r, n, a) {
      var o = this._componentsMap;
      if (ie(r)) {
        var i = n, l = r;
        o.each(function(f, h) {
          for (var v = 0; f && v < f.length; v++) {
            var p = f[v];
            p && l.call(i, h, p, p.componentIndex);
          }
        });
      } else
        for (var c = Q(r) ? o.get(r) : re(r) ? this.findComponents(r) : null, u = 0; c && u < c.length; u++) {
          var d = c[u];
          d && n.call(a, d, d.componentIndex);
        }
    }, e.prototype.getSeriesByName = function(r) {
      var n = Jr(r, null);
      return ot(this._componentsMap.get("series"), function(a) {
        return !!a && n != null && a.name === n;
      });
    }, e.prototype.getSeriesByIndex = function(r) {
      return this._componentsMap.get("series")[r];
    }, e.prototype.getSeriesByType = function(r) {
      return ot(this._componentsMap.get("series"), function(n) {
        return !!n && n.subType === r;
      });
    }, e.prototype.getSeries = function() {
      return ot(this._componentsMap.get("series"), function(r) {
        return !!r;
      });
    }, e.prototype.getSeriesCount = function() {
      return this._componentsCount.get("series");
    }, e.prototype.eachSeries = function(r, n) {
      il(this), I(this._seriesIndices, function(a) {
        var o = this._componentsMap.get("series")[a];
        r.call(n, o, a);
      }, this);
    }, e.prototype.eachRawSeries = function(r, n) {
      I(this._componentsMap.get("series"), function(a) {
        a && r.call(n, a, a.componentIndex);
      });
    }, e.prototype.eachSeriesByType = function(r, n, a) {
      il(this), I(this._seriesIndices, function(o) {
        var i = this._componentsMap.get("series")[o];
        i.subType === r && n.call(a, i, o);
      }, this);
    }, e.prototype.eachRawSeriesByType = function(r, n, a) {
      return I(this.getSeriesByType(r), n, a);
    }, e.prototype.isSeriesFiltered = function(r) {
      return il(this), this._seriesIndicesMap.get(r.componentIndex) == null;
    }, e.prototype.getCurrentSeriesIndices = function() {
      return (this._seriesIndices || []).slice();
    }, e.prototype.filterSeries = function(r, n) {
      il(this);
      var a = [];
      I(this._seriesIndices, function(o) {
        var i = this._componentsMap.get("series")[o];
        r.call(n, i, o) && a.push(o);
      }, this), this._seriesIndices = a, this._seriesIndicesMap = se(a);
    }, e.prototype.restoreData = function(r) {
      Rc(this);
      var n = this._componentsMap, a = [];
      n.each(function(o, i) {
        Ee.hasClass(i) && a.push(i);
      }), Ee.topologicalTravel(a, Ee.getAllClassMainTypes(), function(o) {
        I(n.get(o), function(i) {
          i && (o !== "series" || !o1e(i, r)) && i.restoreData();
        });
      });
    }, e.internalField = function() {
      Rc = function(r) {
        var n = r._seriesIndices = [];
        I(r._componentsMap.get("series"), function(a) {
          a && n.push(a.componentIndex);
        }), r._seriesIndicesMap = se(n);
      }, il = function(r) {
        if (process.env.NODE_ENV !== "production" && !r._seriesIndices)
          throw new Error("Option should contains series.");
      }, Om = function(r, n) {
        r.option = {}, r.option[Ad] = Im, r._componentsMap = se({
          series: []
        }), r._componentsCount = se();
        var a = n.aria;
        re(a) && a.enabled == null && (a.enabled = !0), i1e(n, r._theme.option), Ce(n, Gue, !1), r._mergeOption(n, null);
      };
    }(), e;
  }(Ve)
);
function o1e(t, e) {
  if (e) {
    var r = e.seriesIndex, n = e.seriesId, a = e.seriesName;
    return r != null && t.componentIndex !== r || n != null && t.id !== n || a != null && t.name !== a;
  }
}
function i1e(t, e) {
  var r = t.color && !t.colorLayer;
  I(e, function(n, a) {
    a === "colorLayer" && r || Ee.hasClass(a) || (typeof n == "object" ? t[a] = t[a] ? Ce(t[a], n, !1) : be(n) : t[a] == null && (t[a] = n));
  });
}
function Pm(t, e, r) {
  if (z(e)) {
    var n = se();
    return I(e, function(o) {
      if (o != null) {
        var i = Jr(o, null);
        i != null && n.set(o, !0);
      }
    }), ot(r, function(o) {
      return o && n.get(o[t]);
    });
  } else {
    var a = Jr(e, null);
    return ot(r, function(o) {
      return o && a != null && o[t] === a;
    });
  }
}
function Dm(t, e) {
  return e.hasOwnProperty("subType") ? ot(t, function(r) {
    return r && r.subType === e.subType;
  }) : t;
}
function Nm(t) {
  var e = se();
  return t && I(kt(t.replaceMerge), function(r) {
    process.env.NODE_ENV !== "production" && ge(Ee.hasClass(r), '"' + r + '" is not valid component main type in "replaceMerge"'), e.set(r, !0);
  }), {
    replaceMergeMainTypeMap: e
  };
}
tr(S7, E7);
var l1e = [
  "getDom",
  "getZr",
  "getWidth",
  "getHeight",
  "getDevicePixelRatio",
  "dispatchAction",
  "isSSR",
  "isDisposed",
  "on",
  "off",
  "getDataURL",
  "getConnectedDataURL",
  // 'getModel',
  "getOption",
  // 'getViewOfComponentModel',
  // 'getViewOfSeriesModel',
  "getId",
  "updateLabelLayout"
], x_ = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e) {
      I(l1e, function(r) {
        this[r] = le(e[r], e);
      }, this);
    }
    return t;
  }()
), kd = {}, H1 = (
  /** @class */
  function() {
    function t() {
      this._coordinateSystems = [];
    }
    return t.prototype.create = function(e, r) {
      var n = [];
      I(kd, function(a, o) {
        var i = a.create(e, r);
        n = n.concat(i || []);
      }), this._coordinateSystems = n;
    }, t.prototype.update = function(e, r) {
      I(this._coordinateSystems, function(n) {
        n.update && n.update(e, r);
      });
    }, t.prototype.getCoordinateSystems = function() {
      return this._coordinateSystems.slice();
    }, t.register = function(e, r) {
      kd[e] = r;
    }, t.get = function(e) {
      return kd[e];
    }, t;
  }()
), s1e = /^(min|max)?(.+)$/, c1e = (
  /** @class */
  function() {
    function t(e) {
      this._timelineOptions = [], this._mediaList = [], this._currentMediaIndices = [], this._api = e;
    }
    return t.prototype.setOption = function(e, r, n) {
      e && (I(kt(e.series), function(i) {
        i && i.data && yt(i.data) && V0(i.data);
      }), I(kt(e.dataset), function(i) {
        i && i.source && yt(i.source) && V0(i.source);
      })), e = be(e);
      var a = this._optionBackup, o = u1e(e, r, !a);
      this._newBaseOption = o.baseOption, a ? (o.timelineOptions.length && (a.timelineOptions = o.timelineOptions), o.mediaList.length && (a.mediaList = o.mediaList), o.mediaDefault && (a.mediaDefault = o.mediaDefault)) : this._optionBackup = o;
    }, t.prototype.mountOption = function(e) {
      var r = this._optionBackup;
      return this._timelineOptions = r.timelineOptions, this._mediaList = r.mediaList, this._mediaDefault = r.mediaDefault, this._currentMediaIndices = [], be(e ? r.baseOption : this._newBaseOption);
    }, t.prototype.getTimelineOption = function(e) {
      var r, n = this._timelineOptions;
      if (n.length) {
        var a = e.getComponent("timeline");
        a && (r = be(
          // FIXME:TS as TimelineModel or quivlant interface
          n[a.getCurrentIndex()]
        ));
      }
      return r;
    }, t.prototype.getMediaOption = function(e) {
      var r = this._api.getWidth(), n = this._api.getHeight(), a = this._mediaList, o = this._mediaDefault, i = [], l = [];
      if (!a.length && !o)
        return l;
      for (var c = 0, u = a.length; c < u; c++)
        d1e(a[c].query, r, n) && i.push(c);
      return !i.length && o && (i = [-1]), i.length && !h1e(i, this._currentMediaIndices) && (l = J(i, function(d) {
        return be(d === -1 ? o.option : a[d].option);
      })), this._currentMediaIndices = i, l;
    }, t;
  }()
);
function u1e(t, e, r) {
  var n = [], a, o, i = t.baseOption, l = t.timeline, c = t.options, u = t.media, d = !!t.media, f = !!(c || l || i && i.timeline);
  i ? (o = i, o.timeline || (o.timeline = l)) : ((f || d) && (t.options = t.media = null), o = t), d && (z(u) ? I(u, function(v) {
    process.env.NODE_ENV !== "production" && v && !v.option && re(v.query) && re(v.query.option) && bt("Illegal media option. Must be like { media: [ { query: {}, option: {} } ] }"), v && v.option && (v.query ? n.push(v) : a || (a = v));
  }) : process.env.NODE_ENV !== "production" && bt("Illegal media option. Must be an array. Like { media: [ {...}, {...} ] }")), h(o), I(c, function(v) {
    return h(v);
  }), I(n, function(v) {
    return h(v.option);
  });
  function h(v) {
    I(e, function(p) {
      p(v, r);
    });
  }
  return {
    baseOption: o,
    timelineOptions: c || [],
    mediaDefault: a,
    mediaList: n
  };
}
function d1e(t, e, r) {
  var n = {
    width: e,
    height: r,
    aspectratio: e / r
    // lower case for convenience.
  }, a = !0;
  return I(t, function(o, i) {
    var l = i.match(s1e);
    if (!(!l || !l[1] || !l[2])) {
      var c = l[1], u = l[2].toLowerCase();
      f1e(n[u], o, c) || (a = !1);
    }
  }), a;
}
function f1e(t, e, r) {
  return r === "min" ? t >= e : r === "max" ? t <= e : t === e;
}
function h1e(t, e) {
  return t.join(",") === e.join(",");
}
var rr = I, cs = re, Bm = ["areaStyle", "lineStyle", "nodeStyle", "linkStyle", "chordStyle", "label", "labelLine"];
function Ld(t) {
  var e = t && t.itemStyle;
  if (e)
    for (var r = 0, n = Bm.length; r < n; r++) {
      var a = Bm[r], o = e.normal, i = e.emphasis;
      o && o[a] && (process.env.NODE_ENV !== "production" && tt("itemStyle.normal." + a, a), t[a] = t[a] || {}, t[a].normal ? Ce(t[a].normal, o[a]) : t[a].normal = o[a], o[a] = null), i && i[a] && (process.env.NODE_ENV !== "production" && tt("itemStyle.emphasis." + a, "emphasis." + a), t[a] = t[a] || {}, t[a].emphasis ? Ce(t[a].emphasis, i[a]) : t[a].emphasis = i[a], i[a] = null);
    }
}
function vt(t, e, r) {
  if (t && t[e] && (t[e].normal || t[e].emphasis)) {
    var n = t[e].normal, a = t[e].emphasis;
    n && (process.env.NODE_ENV !== "production" && yr("'normal' hierarchy in " + e + " has been removed since 4.0. All style properties are configured in " + e + " directly now."), r ? (t[e].normal = t[e].emphasis = null, Te(t[e], n)) : t[e] = n), a && (process.env.NODE_ENV !== "production" && yr(e + ".emphasis has been changed to emphasis." + e + " since 4.0"), t.emphasis = t.emphasis || {}, t.emphasis[e] = a, a.focus && (t.emphasis.focus = a.focus), a.blurScope && (t.emphasis.blurScope = a.blurScope));
  }
}
function kl(t) {
  vt(t, "itemStyle"), vt(t, "lineStyle"), vt(t, "areaStyle"), vt(t, "label"), vt(t, "labelLine"), vt(t, "upperLabel"), vt(t, "edgeLabel");
}
function et(t, e) {
  var r = cs(t) && t[e], n = cs(r) && r.textStyle;
  if (n) {
    process.env.NODE_ENV !== "production" && yr("textStyle hierarchy in " + e + " has been removed since 4.0. All textStyle properties are configured in " + e + " directly now.");
    for (var a = 0, o = Fg.length; a < o; a++) {
      var i = Fg[a];
      n.hasOwnProperty(i) && (r[i] = n[i]);
    }
  }
}
function cr(t) {
  t && (kl(t), et(t, "label"), t.emphasis && et(t.emphasis, "label"));
}
function v1e(t) {
  if (cs(t)) {
    Ld(t), kl(t), et(t, "label"), et(t, "upperLabel"), et(t, "edgeLabel"), t.emphasis && (et(t.emphasis, "label"), et(t.emphasis, "upperLabel"), et(t.emphasis, "edgeLabel"));
    var e = t.markPoint;
    e && (Ld(e), cr(e));
    var r = t.markLine;
    r && (Ld(r), cr(r));
    var n = t.markArea;
    n && cr(n);
    var a = t.data;
    if (t.type === "graph") {
      a = a || t.nodes;
      var o = t.links || t.edges;
      if (o && !yt(o))
        for (var i = 0; i < o.length; i++)
          cr(o[i]);
      I(t.categories, function(u) {
        kl(u);
      });
    }
    if (a && !yt(a))
      for (var i = 0; i < a.length; i++)
        cr(a[i]);
    if (e = t.markPoint, e && e.data)
      for (var l = e.data, i = 0; i < l.length; i++)
        cr(l[i]);
    if (r = t.markLine, r && r.data)
      for (var c = r.data, i = 0; i < c.length; i++)
        z(c[i]) ? (cr(c[i][0]), cr(c[i][1])) : cr(c[i]);
    t.type === "gauge" ? (et(t, "axisLabel"), et(t, "title"), et(t, "detail")) : t.type === "treemap" ? (vt(t.breadcrumb, "itemStyle"), I(t.levels, function(u) {
      kl(u);
    })) : t.type === "tree" && kl(t.leaves);
  }
}
function dn(t) {
  return z(t) ? t : t ? [t] : [];
}
function Fm(t) {
  return (z(t) ? t[0] : t) || {};
}
function p1e(t, e) {
  rr(dn(t.series), function(n) {
    cs(n) && v1e(n);
  });
  var r = ["xAxis", "yAxis", "radiusAxis", "angleAxis", "singleAxis", "parallelAxis", "radar"];
  e && r.push("valueAxis", "categoryAxis", "logAxis", "timeAxis"), rr(r, function(n) {
    rr(dn(t[n]), function(a) {
      a && (et(a, "axisLabel"), et(a.axisPointer, "label"));
    });
  }), rr(dn(t.parallel), function(n) {
    var a = n && n.parallelAxisDefault;
    et(a, "axisLabel"), et(a && a.axisPointer, "label");
  }), rr(dn(t.calendar), function(n) {
    vt(n, "itemStyle"), et(n, "dayLabel"), et(n, "monthLabel"), et(n, "yearLabel");
  }), rr(dn(t.radar), function(n) {
    et(n, "name"), n.name && n.axisName == null && (n.axisName = n.name, delete n.name, process.env.NODE_ENV !== "production" && yr("name property in radar component has been changed to axisName")), n.nameGap != null && n.axisNameGap == null && (n.axisNameGap = n.nameGap, delete n.nameGap, process.env.NODE_ENV !== "production" && yr("nameGap property in radar component has been changed to axisNameGap")), process.env.NODE_ENV !== "production" && rr(n.indicator, function(a) {
      a.text && tt("text", "name", "radar.indicator");
    });
  }), rr(dn(t.geo), function(n) {
    cs(n) && (cr(n), rr(dn(n.regions), function(a) {
      cr(a);
    }));
  }), rr(dn(t.timeline), function(n) {
    cr(n), vt(n, "label"), vt(n, "itemStyle"), vt(n, "controlStyle", !0);
    var a = n.data;
    z(a) && I(a, function(o) {
      re(o) && (vt(o, "label"), vt(o, "itemStyle"));
    });
  }), rr(dn(t.toolbox), function(n) {
    vt(n, "iconStyle"), rr(n.feature, function(a) {
      vt(a, "iconStyle");
    });
  }), et(Fm(t.axisPointer), "label"), et(Fm(t.tooltip).axisPointer, "label");
}
function g1e(t, e) {
  for (var r = e.split(","), n = t, a = 0; a < r.length && (n = n && n[r[a]], n != null); a++)
    ;
  return n;
}
function m1e(t, e, r, n) {
  for (var a = e.split(","), o = t, i, l = 0; l < a.length - 1; l++)
    i = a[l], o[i] == null && (o[i] = {}), o = o[i];
  o[a[l]] == null && (o[a[l]] = r);
}
function $m(t) {
  t && I(w1e, function(e) {
    e[0] in t && !(e[1] in t) && (t[e[1]] = t[e[0]]);
  });
}
var w1e = [["x", "left"], ["y", "top"], ["x2", "right"], ["y2", "bottom"]], y1e = ["grid", "geo", "parallel", "legend", "toolbox", "title", "visualMap", "dataZoom", "timeline"], Td = [["borderRadius", "barBorderRadius"], ["borderColor", "barBorderColor"], ["borderWidth", "barBorderWidth"]];
function ll(t) {
  var e = t && t.itemStyle;
  if (e)
    for (var r = 0; r < Td.length; r++) {
      var n = Td[r][1], a = Td[r][0];
      e[n] != null && (e[a] = e[n], process.env.NODE_ENV !== "production" && tt(n, a));
    }
}
function Vm(t) {
  t && t.alignTo === "edge" && t.margin != null && t.edgeDistance == null && (process.env.NODE_ENV !== "production" && tt("label.margin", "label.edgeDistance", "pie"), t.edgeDistance = t.margin);
}
function Zm(t) {
  t && t.downplay && !t.blur && (t.blur = t.downplay, process.env.NODE_ENV !== "production" && tt("downplay", "blur", "sunburst"));
}
function b1e(t) {
  t && t.focusNodeAdjacency != null && (t.emphasis = t.emphasis || {}, t.emphasis.focus == null && (process.env.NODE_ENV !== "production" && tt("focusNodeAdjacency", "emphasis: { focus: 'adjacency'}", "graph/sankey"), t.emphasis.focus = "adjacency"));
}
function C_(t, e) {
  if (t)
    for (var r = 0; r < t.length; r++)
      e(t[r]), t[r] && C_(t[r].children, e);
}
function E_(t, e) {
  p1e(t, e), t.series = kt(t.series), I(t.series, function(r) {
    if (re(r)) {
      var n = r.type;
      if (n === "line")
        r.clipOverflow != null && (r.clip = r.clipOverflow, process.env.NODE_ENV !== "production" && tt("clipOverflow", "clip", "line"));
      else if (n === "pie" || n === "gauge") {
        r.clockWise != null && (r.clockwise = r.clockWise, process.env.NODE_ENV !== "production" && tt("clockWise", "clockwise")), Vm(r.label);
        var a = r.data;
        if (a && !yt(a))
          for (var o = 0; o < a.length; o++)
            Vm(a[o]);
        r.hoverOffset != null && (r.emphasis = r.emphasis || {}, (r.emphasis.scaleSize = null) && (process.env.NODE_ENV !== "production" && tt("hoverOffset", "emphasis.scaleSize"), r.emphasis.scaleSize = r.hoverOffset));
      } else if (n === "gauge") {
        var i = g1e(r, "pointer.color");
        i != null && m1e(r, "itemStyle.color", i);
      } else if (n === "bar") {
        ll(r), ll(r.backgroundStyle), ll(r.emphasis);
        var a = r.data;
        if (a && !yt(a))
          for (var o = 0; o < a.length; o++)
            typeof a[o] == "object" && (ll(a[o]), ll(a[o] && a[o].emphasis));
      } else if (n === "sunburst") {
        var l = r.highlightPolicy;
        l && (r.emphasis = r.emphasis || {}, r.emphasis.focus || (r.emphasis.focus = l, process.env.NODE_ENV !== "production" && tt("highlightPolicy", "emphasis.focus", "sunburst"))), Zm(r), C_(r.data, Zm);
      } else n === "graph" || n === "sankey" ? b1e(r) : n === "map" && (r.mapType && !r.map && (process.env.NODE_ENV !== "production" && tt("mapType", "map", "map"), r.map = r.mapType), r.mapLocation && (process.env.NODE_ENV !== "production" && yr("`mapLocation` is not used anymore."), Te(r, r.mapLocation)));
      r.hoverAnimation != null && (r.emphasis = r.emphasis || {}, r.emphasis && r.emphasis.scale == null && (process.env.NODE_ENV !== "production" && tt("hoverAnimation", "emphasis.scale"), r.emphasis.scale = r.hoverAnimation)), $m(r);
    }
  }), t.dataRange && (t.visualMap = t.dataRange), I(y1e, function(r) {
    var n = t[r];
    n && (z(n) || (n = [n]), I(n, function(a) {
      $m(a);
    }));
  });
}
function _1e(t) {
  var e = se();
  t.eachSeries(function(r) {
    var n = r.get("stack");
    if (n) {
      var a = e.get(n) || e.set(n, []), o = r.getData(), i = {
        // Used for calculate axis extent automatically.
        // TODO: Type getCalculationInfo return more specific type?
        stackResultDimension: o.getCalculationInfo("stackResultDimension"),
        stackedOverDimension: o.getCalculationInfo("stackedOverDimension"),
        stackedDimension: o.getCalculationInfo("stackedDimension"),
        stackedByDimension: o.getCalculationInfo("stackedByDimension"),
        isStackedByIndex: o.getCalculationInfo("isStackedByIndex"),
        data: o,
        seriesModel: r
      };
      if (!i.stackedDimension || !(i.isStackedByIndex || i.stackedByDimension))
        return;
      a.length && o.setCalculationInfo("stackedOnSeries", a[a.length - 1].seriesModel), a.push(i);
    }
  }), e.each(x1e);
}
function x1e(t) {
  I(t, function(e, r) {
    var n = [], a = [NaN, NaN], o = [e.stackResultDimension, e.stackedOverDimension], i = e.data, l = e.isStackedByIndex, c = e.seriesModel.get("stackStrategy") || "samesign";
    i.modify(o, function(u, d, f) {
      var h = i.get(e.stackedDimension, f);
      if (isNaN(h))
        return a;
      var v, p;
      l ? p = i.getRawIndex(f) : v = i.get(e.stackedByDimension, f);
      for (var g = NaN, m = r - 1; m >= 0; m--) {
        var w = t[m];
        if (l || (p = w.data.rawIndexOf(w.stackedByDimension, v)), p >= 0) {
          var y = w.data.getByRawIndex(w.stackResultDimension, p);
          if (c === "all" || c === "positive" && y > 0 || c === "negative" && y < 0 || c === "samesign" && h >= 0 && y > 0 || c === "samesign" && h <= 0 && y < 0) {
            h = Jse(h, y), g = y;
            break;
          }
        }
      }
      return n[0] = h, n[1] = g, n;
    });
  });
}
var j1 = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e) {
      this.data = e.data || (e.sourceFormat === an ? {} : []), this.sourceFormat = e.sourceFormat || w_, this.seriesLayoutBy = e.seriesLayoutBy || yn, this.startIndex = e.startIndex || 0, this.dimensionsDetectedCount = e.dimensionsDetectedCount, this.metaRawOption = e.metaRawOption;
      var r = this.dimensionsDefine = e.dimensionsDefine;
      if (r)
        for (var n = 0; n < r.length; n++) {
          var a = r[n];
          a.type == null && b_(this, n) === st.Must && (a.type = "ordinal");
        }
    }
    return t;
  }()
);
function R7(t) {
  return t instanceof j1;
}
function Gh(t, e, r) {
  r = r || R_(t);
  var n = e.seriesLayoutBy, a = E1e(t, r, n, e.sourceHeader, e.dimensions), o = new j1({
    data: t,
    sourceFormat: r,
    seriesLayoutBy: n,
    dimensionsDefine: a.dimensionsDefine,
    startIndex: a.startIndex,
    dimensionsDetectedCount: a.dimensionsDetectedCount,
    metaRawOption: be(e)
  });
  return o;
}
function S_(t) {
  return new j1({
    data: t,
    sourceFormat: yt(t) ? wn : Cr
  });
}
function C1e(t) {
  return new j1({
    data: t.data,
    sourceFormat: t.sourceFormat,
    seriesLayoutBy: t.seriesLayoutBy,
    dimensionsDefine: be(t.dimensionsDefine),
    startIndex: t.startIndex,
    dimensionsDetectedCount: t.dimensionsDetectedCount
  });
}
function R_(t) {
  var e = w_;
  if (yt(t))
    e = wn;
  else if (z(t)) {
    t.length === 0 && (e = zt);
    for (var r = 0, n = t.length; r < n; r++) {
      var a = t[r];
      if (a != null) {
        if (z(a) || yt(a)) {
          e = zt;
          break;
        } else if (re(a)) {
          e = Zr;
          break;
        }
      }
    }
  } else if (re(t)) {
    for (var o in t)
      if (ao(t, o) && Lt(t[o])) {
        e = an;
        break;
      }
  }
  return e;
}
function E1e(t, e, r, n, a) {
  var o, i;
  if (!t)
    return {
      dimensionsDefine: Hm(a),
      startIndex: i,
      dimensionsDetectedCount: o
    };
  if (e === zt) {
    var l = t;
    n === "auto" || n == null ? jm(function(u) {
      u != null && u !== "-" && (Q(u) ? i == null && (i = 1) : i = 0);
    }, r, l, 10) : i = De(n) ? n : n ? 1 : 0, !a && i === 1 && (a = [], jm(function(u, d) {
      a[d] = u != null ? u + "" : "";
    }, r, l, 1 / 0)), o = a ? a.length : r === zi ? l.length : l[0] ? l[0].length : null;
  } else if (e === Zr)
    a || (a = S1e(t));
  else if (e === an)
    a || (a = [], I(t, function(u, d) {
      a.push(d);
    }));
  else if (e === Cr) {
    var c = Ps(t[0]);
    o = z(c) && c.length || 1;
  } else e === wn && process.env.NODE_ENV !== "production" && ge(!!a, "dimensions must be given if data is TypedArray.");
  return {
    startIndex: i,
    dimensionsDefine: Hm(a),
    dimensionsDetectedCount: o
  };
}
function S1e(t) {
  for (var e = 0, r; e < t.length && !(r = t[e++]); )
    ;
  if (r)
    return Ze(r);
}
function Hm(t) {
  if (t) {
    var e = se();
    return J(t, function(r, n) {
      r = re(r) ? r : {
        name: r
      };
      var a = {
        name: r.name,
        displayName: r.displayName,
        type: r.type
      };
      if (a.name == null)
        return a;
      a.name += "", a.displayName == null && (a.displayName = a.name);
      var o = e.get(a.name);
      return o ? a.name += "-" + o.count++ : e.set(a.name, {
        count: 1
      }), a;
    });
  }
}
function jm(t, e, r, n) {
  if (e === zi)
    for (var a = 0; a < r.length && a < n; a++)
      t(r[a] ? r[a][0] : null, a);
  else
    for (var o = r[0] || [], a = 0; a < o.length && a < n; a++)
      t(o[a], a);
}
function M_(t) {
  var e = t.sourceFormat;
  return e === Zr || e === an;
}
var Ba, Fa, $a, Wm, zm, A_ = (
  /** @class */
  function() {
    function t(e, r) {
      var n = R7(e) ? e : S_(e);
      this._source = n;
      var a = this._data = n.data;
      if (n.sourceFormat === wn) {
        if (process.env.NODE_ENV !== "production" && r == null)
          throw new Error("Typed array data must specify dimension size");
        this._offset = 0, this._dimSize = r, this._data = a;
      }
      zm(this, a, n);
    }
    return t.prototype.getSource = function() {
      return this._source;
    }, t.prototype.count = function() {
      return 0;
    }, t.prototype.getItem = function(e, r) {
    }, t.prototype.appendData = function(e) {
    }, t.prototype.clean = function() {
    }, t.protoInitialize = function() {
      var e = t.prototype;
      e.pure = !1, e.persistent = !0;
    }(), t.internalField = function() {
      var e;
      zm = function(i, l, c) {
        var u = c.sourceFormat, d = c.seriesLayoutBy, f = c.startIndex, h = c.dimensionsDefine, v = Wm[M7(u, d)];
        if (process.env.NODE_ENV !== "production" && ge(v, "Invalide sourceFormat: " + u), H(i, v), u === wn)
          i.getItem = r, i.count = a, i.fillStorage = n;
        else {
          var p = k_(u, d);
          i.getItem = le(p, null, l, f, h);
          var g = L_(u, d);
          i.count = le(g, null, l, f, h);
        }
      };
      var r = function(i, l) {
        i = i - this._offset, l = l || [];
        for (var c = this._data, u = this._dimSize, d = u * i, f = 0; f < u; f++)
          l[f] = c[d + f];
        return l;
      }, n = function(i, l, c, u) {
        for (var d = this._data, f = this._dimSize, h = 0; h < f; h++) {
          for (var v = u[h], p = v[0] == null ? 1 / 0 : v[0], g = v[1] == null ? -1 / 0 : v[1], m = l - i, w = c[h], y = 0; y < m; y++) {
            var b = d[y * f + h];
            w[i + y] = b, b < p && (p = b), b > g && (g = b);
          }
          v[0] = p, v[1] = g;
        }
      }, a = function() {
        return this._data ? this._data.length / this._dimSize : 0;
      };
      Wm = (e = {}, e[zt + "_" + yn] = {
        pure: !0,
        appendData: o
      }, e[zt + "_" + zi] = {
        pure: !0,
        appendData: function() {
          throw new Error('Do not support appendData when set seriesLayoutBy: "row".');
        }
      }, e[Zr] = {
        pure: !0,
        appendData: o
      }, e[an] = {
        pure: !0,
        appendData: function(i) {
          var l = this._data;
          I(i, function(c, u) {
            for (var d = l[u] || (l[u] = []), f = 0; f < (c || []).length; f++)
              d.push(c[f]);
          });
        }
      }, e[Cr] = {
        appendData: o
      }, e[wn] = {
        persistent: !1,
        pure: !0,
        appendData: function(i) {
          process.env.NODE_ENV !== "production" && ge(yt(i), "Added data must be TypedArray if data in initialization is TypedArray"), this._data = i;
        },
        // Clean self if data is already used.
        clean: function() {
          this._offset += this.count(), this._data = null;
        }
      }, e);
      function o(i) {
        for (var l = 0; l < i.length; l++)
          this._data.push(i[l]);
      }
    }(), t;
  }()
), Gm = function(t, e, r, n) {
  return t[n];
}, R1e = (Ba = {}, Ba[zt + "_" + yn] = function(t, e, r, n) {
  return t[n + e];
}, Ba[zt + "_" + zi] = function(t, e, r, n, a) {
  n += e;
  for (var o = a || [], i = t, l = 0; l < i.length; l++) {
    var c = i[l];
    o[l] = c ? c[n] : null;
  }
  return o;
}, Ba[Zr] = Gm, Ba[an] = function(t, e, r, n, a) {
  for (var o = a || [], i = 0; i < r.length; i++) {
    var l = r[i].name;
    if (process.env.NODE_ENV !== "production" && l == null)
      throw new Error();
    var c = t[l];
    o[i] = c ? c[n] : null;
  }
  return o;
}, Ba[Cr] = Gm, Ba);
function k_(t, e) {
  var r = R1e[M7(t, e)];
  return process.env.NODE_ENV !== "production" && ge(r, 'Do not support get item on "' + t + '", "' + e + '".'), r;
}
var Um = function(t, e, r) {
  return t.length;
}, M1e = (Fa = {}, Fa[zt + "_" + yn] = function(t, e, r) {
  return Math.max(0, t.length - e);
}, Fa[zt + "_" + zi] = function(t, e, r) {
  var n = t[0];
  return n ? Math.max(0, n.length - e) : 0;
}, Fa[Zr] = Um, Fa[an] = function(t, e, r) {
  var n = r[0].name;
  if (process.env.NODE_ENV !== "production" && n == null)
    throw new Error();
  var a = t[n];
  return a ? a.length : 0;
}, Fa[Cr] = Um, Fa);
function L_(t, e) {
  var r = M1e[M7(t, e)];
  return process.env.NODE_ENV !== "production" && ge(r, 'Do not support count on "' + t + '", "' + e + '".'), r;
}
var Od = function(t, e, r) {
  return t[e];
}, A1e = ($a = {}, $a[zt] = Od, $a[Zr] = function(t, e, r) {
  return t[r];
}, $a[an] = Od, $a[Cr] = function(t, e, r) {
  var n = Ps(t);
  return n instanceof Array ? n[e] : n;
}, $a[wn] = Od, $a);
function T_(t) {
  var e = A1e[t];
  return process.env.NODE_ENV !== "production" && ge(e, 'Do not support get value on "' + t + '".'), e;
}
function M7(t, e) {
  return t === zt ? t + "_" + e : t;
}
function Mi(t, e, r) {
  if (t) {
    var n = t.getRawDataItem(e);
    if (n != null) {
      var a = t.getStore(), o = a.getSource().sourceFormat;
      if (r != null) {
        var i = t.getDimensionIndex(r), l = a.getDimensionProperty(i);
        return T_(o)(n, i, l);
      } else {
        var c = n;
        return o === Cr && (c = Ps(n)), c;
      }
    }
  }
}
var k1e = /\{@(.+?)\}/g, A7 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getDataParams = function(e, r) {
      var n = this.getData(r), a = this.getRawValue(e, r), o = n.getRawIndex(e), i = n.getName(e), l = n.getRawDataItem(e), c = n.getItemVisual(e, "style"), u = c && c[n.getItemVisual(e, "drawType") || "fill"], d = c && c.stroke, f = this.mainType, h = f === "series", v = n.userOutput && n.userOutput.get();
      return {
        componentType: f,
        componentSubType: this.subType,
        componentIndex: this.componentIndex,
        seriesType: h ? this.subType : null,
        seriesIndex: this.seriesIndex,
        seriesId: h ? this.id : null,
        seriesName: h ? this.name : null,
        name: i,
        dataIndex: o,
        data: l,
        dataType: r,
        value: a,
        color: u,
        borderColor: d,
        dimensionNames: v ? v.fullDimensions : null,
        encode: v ? v.encode : null,
        // Param name list for mapping `a`, `b`, `c`, `d`, `e`
        $vars: ["seriesName", "name", "value"]
      };
    }, t.prototype.getFormattedLabel = function(e, r, n, a, o, i) {
      r = r || "normal";
      var l = this.getData(n), c = this.getDataParams(e, n);
      if (i && (c.value = i.interpolatedValue), a != null && z(c.value) && (c.value = c.value[a]), !o) {
        var u = l.getItemModel(e);
        o = u.get(r === "normal" ? ["label", "formatter"] : [r, "label", "formatter"]);
      }
      if (ie(o))
        return c.status = r, c.dimensionIndex = a, o(c);
      if (Q(o)) {
        var d = _7(o, c);
        return d.replace(k1e, function(f, h) {
          var v = h.length, p = h;
          p.charAt(0) === "[" && p.charAt(v - 1) === "]" && (p = +p.slice(1, v - 1), process.env.NODE_ENV !== "production" && isNaN(p) && bt("Invalide label formatter: @" + h + ", only support @[0], @[1], @[2], ..."));
          var g = Mi(l, e, p);
          if (i && z(i.interpolatedValue)) {
            var m = l.getDimensionIndex(p);
            m >= 0 && (g = i.interpolatedValue[m]);
          }
          return g != null ? g + "" : "";
        });
      }
    }, t.prototype.getRawValue = function(e, r) {
      return Mi(this.getData(r), e);
    }, t.prototype.formatTooltip = function(e, r, n) {
    }, t;
  }()
);
function Ym(t) {
  var e, r;
  return re(t) ? t.type ? r = t : process.env.NODE_ENV !== "production" && console.warn("The return type of `formatTooltip` is not supported: " + Q0(t)) : e = t, {
    text: e,
    // markers: markers || markersExisting,
    frag: r
  };
}
function Zl(t) {
  return new L1e(t);
}
var L1e = (
  /** @class */
  function() {
    function t(e) {
      e = e || {}, this._reset = e.reset, this._plan = e.plan, this._count = e.count, this._onDirty = e.onDirty, this._dirty = !0;
    }
    return t.prototype.perform = function(e) {
      var r = this._upstream, n = e && e.skip;
      if (this._dirty && r) {
        var a = this.context;
        a.data = a.outputData = r.context.outputData;
      }
      this.__pipeline && (this.__pipeline.currentTask = this);
      var o;
      this._plan && !n && (o = this._plan(this.context));
      var i = d(this._modBy), l = this._modDataCount || 0, c = d(e && e.modBy), u = e && e.modDataCount || 0;
      (i !== c || l !== u) && (o = "reset");
      function d(y) {
        return !(y >= 1) && (y = 1), y;
      }
      var f;
      (this._dirty || o === "reset") && (this._dirty = !1, f = this._doReset(n)), this._modBy = c, this._modDataCount = u;
      var h = e && e.step;
      if (r ? (process.env.NODE_ENV !== "production" && ge(r._outputDueEnd != null), this._dueEnd = r._outputDueEnd) : (process.env.NODE_ENV !== "production" && ge(!this._progress || this._count), this._dueEnd = this._count ? this._count(this.context) : 1 / 0), this._progress) {
        var v = this._dueIndex, p = Math.min(h != null ? this._dueIndex + h : 1 / 0, this._dueEnd);
        if (!n && (f || v < p)) {
          var g = this._progress;
          if (z(g))
            for (var m = 0; m < g.length; m++)
              this._doProgress(g[m], v, p, c, u);
          else
            this._doProgress(g, v, p, c, u);
        }
        this._dueIndex = p;
        var w = this._settedOutputEnd != null ? this._settedOutputEnd : p;
        process.env.NODE_ENV !== "production" && ge(w >= this._outputDueEnd), this._outputDueEnd = w;
      } else
        this._dueIndex = this._outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : this._dueEnd;
      return this.unfinished();
    }, t.prototype.dirty = function() {
      this._dirty = !0, this._onDirty && this._onDirty(this.context);
    }, t.prototype._doProgress = function(e, r, n, a, o) {
      Xm.reset(r, n, a, o), this._callingProgress = e, this._callingProgress({
        start: r,
        end: n,
        count: n - r,
        next: Xm.next
      }, this.context);
    }, t.prototype._doReset = function(e) {
      this._dueIndex = this._outputDueEnd = this._dueEnd = 0, this._settedOutputEnd = null;
      var r, n;
      !e && this._reset && (r = this._reset(this.context), r && r.progress && (n = r.forceFirstProgress, r = r.progress), z(r) && !r.length && (r = null)), this._progress = r, this._modBy = this._modDataCount = null;
      var a = this._downstream;
      return a && a.dirty(), n;
    }, t.prototype.unfinished = function() {
      return this._progress && this._dueIndex < this._dueEnd;
    }, t.prototype.pipe = function(e) {
      process.env.NODE_ENV !== "production" && ge(e && !e._disposed && e !== this), (this._downstream !== e || this._dirty) && (this._downstream = e, e._upstream = this, e.dirty());
    }, t.prototype.dispose = function() {
      this._disposed || (this._upstream && (this._upstream._downstream = null), this._downstream && (this._downstream._upstream = null), this._dirty = !1, this._disposed = !0);
    }, t.prototype.getUpstream = function() {
      return this._upstream;
    }, t.prototype.getDownstream = function() {
      return this._downstream;
    }, t.prototype.setOutputEnd = function(e) {
      this._outputDueEnd = this._settedOutputEnd = e;
    }, t;
  }()
), Xm = /* @__PURE__ */ function() {
  var t, e, r, n, a, o = {
    reset: function(c, u, d, f) {
      e = c, t = u, r = d, n = f, a = Math.ceil(n / r), o.next = r > 1 && n > 0 ? l : i;
    }
  };
  return o;
  function i() {
    return e < t ? e++ : null;
  }
  function l() {
    var c = e % a * r + Math.ceil(e / a), u = e >= t ? null : c < n ? c : e;
    return e++, u;
  }
}();
function di(t, e) {
  var r = e && e.type;
  return r === "ordinal" ? t : (r === "time" && !De(t) && t != null && t !== "-" && (t = +wr(t)), t == null || t === "" ? NaN : Number(t));
}
se({
  number: function(t) {
    return parseFloat(t);
  },
  time: function(t) {
    return +wr(t);
  },
  trim: function(t) {
    return Q(t) ? Ir(t) : t;
  }
});
var T1e = (
  /** @class */
  function() {
    function t(e, r) {
      var n = e === "desc";
      this._resultLT = n ? 1 : -1, r == null && (r = n ? "min" : "max"), this._incomparable = r === "min" ? -1 / 0 : 1 / 0;
    }
    return t.prototype.evaluate = function(e, r) {
      var n = De(e) ? e : es(e), a = De(r) ? r : es(r), o = isNaN(n), i = isNaN(a);
      if (o && (n = this._incomparable), i && (a = this._incomparable), o && i) {
        var l = Q(e), c = Q(r);
        l && (n = c ? e : 0), c && (a = l ? r : 0);
      }
      return n < a ? this._resultLT : n > a ? -this._resultLT : 0;
    }, t;
  }()
), O1e = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getRawData = function() {
      throw new Error("not supported");
    }, t.prototype.getRawDataItem = function(e) {
      throw new Error("not supported");
    }, t.prototype.cloneRawData = function() {
    }, t.prototype.getDimensionInfo = function(e) {
    }, t.prototype.cloneAllDimensionInfo = function() {
    }, t.prototype.count = function() {
    }, t.prototype.retrieveValue = function(e, r) {
    }, t.prototype.retrieveValueFromItem = function(e, r) {
    }, t.prototype.convertValue = function(e, r) {
      return di(e, r);
    }, t;
  }()
);
function I1e(t, e) {
  var r = new O1e(), n = t.data, a = r.sourceFormat = t.sourceFormat, o = t.startIndex, i = "";
  t.seriesLayoutBy !== yn && (process.env.NODE_ENV !== "production" && (i = '`seriesLayoutBy` of upstream dataset can only be "column" in data transform.'), Vt(i));
  var l = [], c = {}, u = t.dimensionsDefine;
  if (u)
    I(u, function(g, m) {
      var w = g.name, y = {
        index: m,
        name: w,
        displayName: g.displayName
      };
      if (l.push(y), w != null) {
        var b = "";
        ao(c, w) && (process.env.NODE_ENV !== "production" && (b = 'dimension name "' + w + '" duplicated.'), Vt(b)), c[w] = y;
      }
    });
  else
    for (var d = 0; d < t.dimensionsDetectedCount; d++)
      l.push({
        index: d
      });
  var f = k_(a, yn);
  e.__isBuiltIn && (r.getRawDataItem = function(g) {
    return f(n, o, l, g);
  }, r.getRawData = le(P1e, null, t)), r.cloneRawData = le(D1e, null, t);
  var h = L_(a, yn);
  r.count = le(h, null, n, o, l);
  var v = T_(a);
  r.retrieveValue = function(g, m) {
    var w = f(n, o, l, g);
    return p(w, m);
  };
  var p = r.retrieveValueFromItem = function(g, m) {
    if (g != null) {
      var w = l[m];
      if (w)
        return v(g, m, w.name);
    }
  };
  return r.getDimensionInfo = le(N1e, null, l, c), r.cloneAllDimensionInfo = le(B1e, null, l), r;
}
function P1e(t) {
  var e = t.sourceFormat;
  if (!k7(e)) {
    var r = "";
    process.env.NODE_ENV !== "production" && (r = "`getRawData` is not supported in source format " + e), Vt(r);
  }
  return t.data;
}
function D1e(t) {
  var e = t.sourceFormat, r = t.data;
  if (!k7(e)) {
    var n = "";
    process.env.NODE_ENV !== "production" && (n = "`cloneRawData` is not supported in source format " + e), Vt(n);
  }
  if (e === zt) {
    for (var a = [], o = 0, i = r.length; o < i; o++)
      a.push(r[o].slice());
    return a;
  } else if (e === Zr) {
    for (var a = [], o = 0, i = r.length; o < i; o++)
      a.push(H({}, r[o]));
    return a;
  }
}
function N1e(t, e, r) {
  if (r != null) {
    if (De(r) || !isNaN(r) && !ao(e, r))
      return t[r];
    if (ao(e, r))
      return e[r];
  }
}
function B1e(t) {
  return be(t);
}
var O_ = se();
function F1e(t) {
  t = be(t);
  var e = t.type, r = "";
  e || (process.env.NODE_ENV !== "production" && (r = "Must have a `type` when `registerTransform`."), Vt(r));
  var n = e.split(":");
  n.length !== 2 && (process.env.NODE_ENV !== "production" && (r = 'Name must include namespace like "ns:regression".'), Vt(r));
  var a = !1;
  n[0] === "echarts" && (e = n[1], a = !0), t.__isBuiltIn = a, O_.set(e, t);
}
function $1e(t, e, r) {
  var n = kt(t), a = n.length, o = "";
  a || (process.env.NODE_ENV !== "production" && (o = "If `transform` declared, it should at least contain one transform."), Vt(o));
  for (var i = 0, l = a; i < l; i++) {
    var c = n[i];
    e = V1e(c, e, r, a === 1 ? null : i), i !== l - 1 && (e.length = Math.max(e.length, 1));
  }
  return e;
}
function V1e(t, e, r, n) {
  var a = "";
  e.length || (process.env.NODE_ENV !== "production" && (a = "Must have at least one upstream dataset."), Vt(a)), re(t) || (process.env.NODE_ENV !== "production" && (a = "transform declaration must be an object rather than " + typeof t + "."), Vt(a));
  var o = t.type, i = O_.get(o);
  i || (process.env.NODE_ENV !== "production" && (a = 'Can not find transform on type "' + o + '".'), Vt(a));
  var l = J(e, function(d) {
    return I1e(d, i);
  }), c = kt(i.transform({
    upstream: l[0],
    upstreamList: l,
    config: be(t.config)
  }));
  if (process.env.NODE_ENV !== "production" && t.print) {
    var u = J(c, function(d) {
      var f = n != null ? " === pipe index: " + n : "";
      return ["=== dataset index: " + r.datasetIndex + f + " ===", "- transform result data:", Q0(d.data), "- transform result dimensions:", Q0(d.dimensions)].join(`
`);
    }).join(`
`);
    ice(u);
  }
  return J(c, function(d, f) {
    var h = "";
    re(d) || (process.env.NODE_ENV !== "production" && (h = "A transform should not return some empty results."), Vt(h)), d.data || (process.env.NODE_ENV !== "production" && (h = "Transform result data should be not be null or undefined"), Vt(h));
    var v = R_(d.data);
    k7(v) || (process.env.NODE_ENV !== "production" && (h = "Transform result data should be array rows or object rows."), Vt(h));
    var p, g = e[0];
    if (g && f === 0 && !d.dimensions) {
      var m = g.startIndex;
      m && (d.data = g.data.slice(0, m).concat(d.data)), p = {
        seriesLayoutBy: yn,
        sourceHeader: m,
        dimensions: g.metaRawOption.dimensions
      };
    } else
      p = {
        seriesLayoutBy: yn,
        sourceHeader: 0,
        dimensions: d.dimensions
      };
    return Gh(d.data, p, null);
  });
}
function k7(t) {
  return t === zt || t === Zr;
}
var W1 = "undefined", Z1e = typeof Uint32Array === W1 ? Array : Uint32Array, H1e = typeof Uint16Array === W1 ? Array : Uint16Array, I_ = typeof Int32Array === W1 ? Array : Int32Array, qm = typeof Float64Array === W1 ? Array : Float64Array, P_ = {
  float: qm,
  int: I_,
  // Ordinal data type can be string or int
  ordinal: Array,
  number: Array,
  time: qm
}, Id;
function sl(t) {
  return t > 65535 ? Z1e : H1e;
}
function Fo() {
  return [1 / 0, -1 / 0];
}
function j1e(t) {
  var e = t.constructor;
  return e === Array ? t.slice() : new e(t);
}
function Km(t, e, r, n, a) {
  var o = P_[r || "float"];
  if (a) {
    var i = t[e], l = i && i.length;
    if (l !== n) {
      for (var c = new o(n), u = 0; u < l; u++)
        c[u] = i[u];
      t[e] = c;
    }
  } else
    t[e] = new o(n);
}
var Uh = (
  /** @class */
  function() {
    function t() {
      this._chunks = [], this._rawExtent = [], this._extent = [], this._count = 0, this._rawCount = 0, this._calcDimNameToIdx = se();
    }
    return t.prototype.initData = function(e, r, n) {
      process.env.NODE_ENV !== "production" && ge(ie(e.getItem) && ie(e.count), "Invalid data provider."), this._provider = e, this._chunks = [], this._indices = null, this.getRawIndex = this._getRawIdxIdentity;
      var a = e.getSource(), o = this.defaultDimValueGetter = Id[a.sourceFormat];
      this._dimValueGetter = n || o, this._rawExtent = [];
      var i = M_(a);
      this._dimensions = J(r, function(l) {
        return process.env.NODE_ENV !== "production" && i && ge(l.property != null), {
          // Only pick these two props. Not leak other properties like orderMeta.
          type: l.type,
          property: l.property
        };
      }), this._initDataFromProvider(0, e.count());
    }, t.prototype.getProvider = function() {
      return this._provider;
    }, t.prototype.getSource = function() {
      return this._provider.getSource();
    }, t.prototype.ensureCalculationDimension = function(e, r) {
      var n = this._calcDimNameToIdx, a = this._dimensions, o = n.get(e);
      if (o != null) {
        if (a[o].type === r)
          return o;
      } else
        o = a.length;
      return a[o] = {
        type: r
      }, n.set(e, o), this._chunks[o] = new P_[r || "float"](this._rawCount), this._rawExtent[o] = Fo(), o;
    }, t.prototype.collectOrdinalMeta = function(e, r) {
      var n = this._chunks[e], a = this._dimensions[e], o = this._rawExtent, i = a.ordinalOffset || 0, l = n.length;
      i === 0 && (o[e] = Fo());
      for (var c = o[e], u = i; u < l; u++) {
        var d = n[u] = r.parseAndCollect(n[u]);
        isNaN(d) || (c[0] = Math.min(d, c[0]), c[1] = Math.max(d, c[1]));
      }
      a.ordinalMeta = r, a.ordinalOffset = l, a.type = "ordinal";
    }, t.prototype.getOrdinalMeta = function(e) {
      var r = this._dimensions[e], n = r.ordinalMeta;
      return n;
    }, t.prototype.getDimensionProperty = function(e) {
      var r = this._dimensions[e];
      return r && r.property;
    }, t.prototype.appendData = function(e) {
      process.env.NODE_ENV !== "production" && ge(!this._indices, "appendData can only be called on raw data.");
      var r = this._provider, n = this.count();
      r.appendData(e);
      var a = r.count();
      return r.persistent || (a += n), n < a && this._initDataFromProvider(n, a, !0), [n, a];
    }, t.prototype.appendValues = function(e, r) {
      for (var n = this._chunks, a = this._dimensions, o = a.length, i = this._rawExtent, l = this.count(), c = l + Math.max(e.length, r || 0), u = 0; u < o; u++) {
        var d = a[u];
        Km(n, u, d.type, c, !0);
      }
      for (var f = [], h = l; h < c; h++)
        for (var v = h - l, p = 0; p < o; p++) {
          var d = a[p], g = Id.arrayRows.call(this, e[v] || f, d.property, v, p);
          n[p][h] = g;
          var m = i[p];
          g < m[0] && (m[0] = g), g > m[1] && (m[1] = g);
        }
      return this._rawCount = this._count = c, {
        start: l,
        end: c
      };
    }, t.prototype._initDataFromProvider = function(e, r, n) {
      for (var a = this._provider, o = this._chunks, i = this._dimensions, l = i.length, c = this._rawExtent, u = J(i, function(y) {
        return y.property;
      }), d = 0; d < l; d++) {
        var f = i[d];
        c[d] || (c[d] = Fo()), Km(o, d, f.type, r, n);
      }
      if (a.fillStorage)
        a.fillStorage(e, r, o, c);
      else
        for (var h = [], v = e; v < r; v++) {
          h = a.getItem(v, h);
          for (var p = 0; p < l; p++) {
            var g = o[p], m = this._dimValueGetter(h, u[p], v, p);
            g[v] = m;
            var w = c[p];
            m < w[0] && (w[0] = m), m > w[1] && (w[1] = m);
          }
        }
      !a.persistent && a.clean && a.clean(), this._rawCount = this._count = r, this._extent = [];
    }, t.prototype.count = function() {
      return this._count;
    }, t.prototype.get = function(e, r) {
      if (!(r >= 0 && r < this._count))
        return NaN;
      var n = this._chunks[e];
      return n ? n[this.getRawIndex(r)] : NaN;
    }, t.prototype.getValues = function(e, r) {
      var n = [], a = [];
      if (r == null) {
        r = e, e = [];
        for (var o = 0; o < this._dimensions.length; o++)
          a.push(o);
      } else
        a = e;
      for (var o = 0, i = a.length; o < i; o++)
        n.push(this.get(a[o], r));
      return n;
    }, t.prototype.getByRawIndex = function(e, r) {
      if (!(r >= 0 && r < this._rawCount))
        return NaN;
      var n = this._chunks[e];
      return n ? n[r] : NaN;
    }, t.prototype.getSum = function(e) {
      var r = this._chunks[e], n = 0;
      if (r)
        for (var a = 0, o = this.count(); a < o; a++) {
          var i = this.get(e, a);
          isNaN(i) || (n += i);
        }
      return n;
    }, t.prototype.getMedian = function(e) {
      var r = [];
      this.each([e], function(o) {
        isNaN(o) || r.push(o);
      });
      var n = r.sort(function(o, i) {
        return o - i;
      }), a = this.count();
      return a === 0 ? 0 : a % 2 === 1 ? n[(a - 1) / 2] : (n[a / 2] + n[a / 2 - 1]) / 2;
    }, t.prototype.indexOfRawIndex = function(e) {
      if (e >= this._rawCount || e < 0)
        return -1;
      if (!this._indices)
        return e;
      var r = this._indices, n = r[e];
      if (n != null && n < this._count && n === e)
        return e;
      for (var a = 0, o = this._count - 1; a <= o; ) {
        var i = (a + o) / 2 | 0;
        if (r[i] < e)
          a = i + 1;
        else if (r[i] > e)
          o = i - 1;
        else
          return i;
      }
      return -1;
    }, t.prototype.indicesOfNearest = function(e, r, n) {
      var a = this._chunks, o = a[e], i = [];
      if (!o)
        return i;
      n == null && (n = 1 / 0);
      for (var l = 1 / 0, c = -1, u = 0, d = 0, f = this.count(); d < f; d++) {
        var h = this.getRawIndex(d), v = r - o[h], p = Math.abs(v);
        p <= n && ((p < l || p === l && v >= 0 && c < 0) && (l = p, c = v, u = 0), v === c && (i[u++] = d));
      }
      return i.length = u, i;
    }, t.prototype.getIndices = function() {
      var e, r = this._indices;
      if (r) {
        var n = r.constructor, a = this._count;
        if (n === Array) {
          e = new n(a);
          for (var o = 0; o < a; o++)
            e[o] = r[o];
        } else
          e = new n(r.buffer, 0, a);
      } else {
        var n = sl(this._rawCount);
        e = new n(this.count());
        for (var o = 0; o < e.length; o++)
          e[o] = o;
      }
      return e;
    }, t.prototype.filter = function(e, r) {
      if (!this._count)
        return this;
      for (var n = this.clone(), a = n.count(), o = sl(n._rawCount), i = new o(a), l = [], c = e.length, u = 0, d = e[0], f = n._chunks, h = 0; h < a; h++) {
        var v = void 0, p = n.getRawIndex(h);
        if (c === 0)
          v = r(h);
        else if (c === 1) {
          var g = f[d][p];
          v = r(g, h);
        } else {
          for (var m = 0; m < c; m++)
            l[m] = f[e[m]][p];
          l[m] = h, v = r.apply(null, l);
        }
        v && (i[u++] = p);
      }
      return u < a && (n._indices = i), n._count = u, n._extent = [], n._updateGetRawIdx(), n;
    }, t.prototype.selectRange = function(e) {
      var r = this.clone(), n = r._count;
      if (!n)
        return this;
      var a = Ze(e), o = a.length;
      if (!o)
        return this;
      var i = r.count(), l = sl(r._rawCount), c = new l(i), u = 0, d = a[0], f = e[d][0], h = e[d][1], v = r._chunks, p = !1;
      if (!r._indices) {
        var g = 0;
        if (o === 1) {
          for (var m = v[a[0]], w = 0; w < n; w++) {
            var y = m[w];
            (y >= f && y <= h || isNaN(y)) && (c[u++] = g), g++;
          }
          p = !0;
        } else if (o === 2) {
          for (var m = v[a[0]], b = v[a[1]], _ = e[a[1]][0], x = e[a[1]][1], w = 0; w < n; w++) {
            var y = m[w], E = b[w];
            (y >= f && y <= h || isNaN(y)) && (E >= _ && E <= x || isNaN(E)) && (c[u++] = g), g++;
          }
          p = !0;
        }
      }
      if (!p)
        if (o === 1)
          for (var w = 0; w < i; w++) {
            var S = r.getRawIndex(w), y = v[a[0]][S];
            (y >= f && y <= h || isNaN(y)) && (c[u++] = S);
          }
        else
          for (var w = 0; w < i; w++) {
            for (var M = !0, S = r.getRawIndex(w), R = 0; R < o; R++) {
              var A = a[R], y = v[A][S];
              (y < e[A][0] || y > e[A][1]) && (M = !1);
            }
            M && (c[u++] = r.getRawIndex(w));
          }
      return u < i && (r._indices = c), r._count = u, r._extent = [], r._updateGetRawIdx(), r;
    }, t.prototype.map = function(e, r) {
      var n = this.clone(e);
      return this._updateDims(n, e, r), n;
    }, t.prototype.modify = function(e, r) {
      this._updateDims(this, e, r);
    }, t.prototype._updateDims = function(e, r, n) {
      for (var a = e._chunks, o = [], i = r.length, l = e.count(), c = [], u = e._rawExtent, d = 0; d < r.length; d++)
        u[r[d]] = Fo();
      for (var f = 0; f < l; f++) {
        for (var h = e.getRawIndex(f), v = 0; v < i; v++)
          c[v] = a[r[v]][h];
        c[i] = f;
        var p = n && n.apply(null, c);
        if (p != null) {
          typeof p != "object" && (o[0] = p, p = o);
          for (var d = 0; d < p.length; d++) {
            var g = r[d], m = p[d], w = u[g], y = a[g];
            y && (y[h] = m), m < w[0] && (w[0] = m), m > w[1] && (w[1] = m);
          }
        }
      }
    }, t.prototype.lttbDownSample = function(e, r) {
      var n = this.clone([e], !0), a = n._chunks, o = a[e], i = this.count(), l = 0, c = Math.floor(1 / r), u = this.getRawIndex(0), d, f, h, v = new (sl(this._rawCount))(Math.min((Math.ceil(i / c) + 2) * 2, i));
      v[l++] = u;
      for (var p = 1; p < i - 1; p += c) {
        for (var g = Math.min(p + c, i - 1), m = Math.min(p + c * 2, i), w = (m + g) / 2, y = 0, b = g; b < m; b++) {
          var _ = this.getRawIndex(b), x = o[_];
          isNaN(x) || (y += x);
        }
        y /= m - g;
        var E = p, S = Math.min(p + c, i), M = p - 1, R = o[u];
        d = -1, h = E;
        for (var A = -1, k = 0, b = E; b < S; b++) {
          var _ = this.getRawIndex(b), x = o[_];
          if (isNaN(x)) {
            k++, A < 0 && (A = _);
            continue;
          }
          f = Math.abs((M - w) * (x - R) - (M - b) * (y - R)), f > d && (d = f, h = _);
        }
        k > 0 && k < S - E && (v[l++] = Math.min(A, h), h = Math.max(A, h)), v[l++] = h, u = h;
      }
      return v[l++] = this.getRawIndex(i - 1), n._count = l, n._indices = v, n.getRawIndex = this._getRawIdx, n;
    }, t.prototype.downSample = function(e, r, n, a) {
      for (var o = this.clone([e], !0), i = o._chunks, l = [], c = Math.floor(1 / r), u = i[e], d = this.count(), f = o._rawExtent[e] = Fo(), h = new (sl(this._rawCount))(Math.ceil(d / c)), v = 0, p = 0; p < d; p += c) {
        c > d - p && (c = d - p, l.length = c);
        for (var g = 0; g < c; g++) {
          var m = this.getRawIndex(p + g);
          l[g] = u[m];
        }
        var w = n(l), y = this.getRawIndex(Math.min(p + a(l, w) || 0, d - 1));
        u[y] = w, w < f[0] && (f[0] = w), w > f[1] && (f[1] = w), h[v++] = y;
      }
      return o._count = v, o._indices = h, o._updateGetRawIdx(), o;
    }, t.prototype.each = function(e, r) {
      if (this._count)
        for (var n = e.length, a = this._chunks, o = 0, i = this.count(); o < i; o++) {
          var l = this.getRawIndex(o);
          switch (n) {
            case 0:
              r(o);
              break;
            case 1:
              r(a[e[0]][l], o);
              break;
            case 2:
              r(a[e[0]][l], a[e[1]][l], o);
              break;
            default:
              for (var c = 0, u = []; c < n; c++)
                u[c] = a[e[c]][l];
              u[c] = o, r.apply(null, u);
          }
        }
    }, t.prototype.getDataExtent = function(e) {
      var r = this._chunks[e], n = Fo();
      if (!r)
        return n;
      var a = this.count(), o = !this._indices, i;
      if (o)
        return this._rawExtent[e].slice();
      if (i = this._extent[e], i)
        return i.slice();
      i = n;
      for (var l = i[0], c = i[1], u = 0; u < a; u++) {
        var d = this.getRawIndex(u), f = r[d];
        f < l && (l = f), f > c && (c = f);
      }
      return i = [l, c], this._extent[e] = i, i;
    }, t.prototype.getRawDataItem = function(e) {
      var r = this.getRawIndex(e);
      if (this._provider.persistent)
        return this._provider.getItem(r);
      for (var n = [], a = this._chunks, o = 0; o < a.length; o++)
        n.push(a[o][r]);
      return n;
    }, t.prototype.clone = function(e, r) {
      var n = new t(), a = this._chunks, o = e && tn(e, function(l, c) {
        return l[c] = !0, l;
      }, {});
      if (o)
        for (var i = 0; i < a.length; i++)
          n._chunks[i] = o[i] ? j1e(a[i]) : a[i];
      else
        n._chunks = a;
      return this._copyCommonProps(n), r || (n._indices = this._cloneIndices()), n._updateGetRawIdx(), n;
    }, t.prototype._copyCommonProps = function(e) {
      e._count = this._count, e._rawCount = this._rawCount, e._provider = this._provider, e._dimensions = this._dimensions, e._extent = be(this._extent), e._rawExtent = be(this._rawExtent);
    }, t.prototype._cloneIndices = function() {
      if (this._indices) {
        var e = this._indices.constructor, r = void 0;
        if (e === Array) {
          var n = this._indices.length;
          r = new e(n);
          for (var a = 0; a < n; a++)
            r[a] = this._indices[a];
        } else
          r = new e(this._indices);
        return r;
      }
      return null;
    }, t.prototype._getRawIdxIdentity = function(e) {
      return e;
    }, t.prototype._getRawIdx = function(e) {
      return e < this._count && e >= 0 ? this._indices[e] : -1;
    }, t.prototype._updateGetRawIdx = function() {
      this.getRawIndex = this._indices ? this._getRawIdx : this._getRawIdxIdentity;
    }, t.internalField = function() {
      function e(r, n, a, o) {
        return di(r[o], this._dimensions[o]);
      }
      Id = {
        arrayRows: e,
        objectRows: function(r, n, a, o) {
          return di(r[n], this._dimensions[o]);
        },
        keyedColumns: e,
        original: function(r, n, a, o) {
          var i = r && (r.value == null ? r : r.value);
          return di(i instanceof Array ? i[o] : i, this._dimensions[o]);
        },
        typedArray: function(r, n, a, o) {
          return r[o];
        }
      };
    }(), t;
  }()
), W1e = (
  /** @class */
  function() {
    function t(e) {
      this._sourceList = [], this._storeList = [], this._upstreamSignList = [], this._versionSignBase = 0, this._dirty = !0, this._sourceHost = e;
    }
    return t.prototype.dirty = function() {
      this._setLocalSource([], []), this._storeList = [], this._dirty = !0;
    }, t.prototype._setLocalSource = function(e, r) {
      this._sourceList = e, this._upstreamSignList = r, this._versionSignBase++, this._versionSignBase > 9e10 && (this._versionSignBase = 0);
    }, t.prototype._getVersionSign = function() {
      return this._sourceHost.uid + "_" + this._versionSignBase;
    }, t.prototype.prepareSource = function() {
      this._isDirty() && (this._createSource(), this._dirty = !1);
    }, t.prototype._createSource = function() {
      this._setLocalSource([], []);
      var e = this._sourceHost, r = this._getUpstreamSourceManagers(), n = !!r.length, a, o;
      if (cl(e)) {
        var i = e, l = void 0, c = void 0, u = void 0;
        if (n) {
          var d = r[0];
          d.prepareSource(), u = d.getSource(), l = u.data, c = u.sourceFormat, o = [d._getVersionSign()];
        } else
          l = i.get("data", !0), c = yt(l) ? wn : Cr, o = [];
        var f = this._getSourceMetaRawOption() || {}, h = u && u.metaRawOption || {}, v = de(f.seriesLayoutBy, h.seriesLayoutBy) || null, p = de(f.sourceHeader, h.sourceHeader), g = de(f.dimensions, h.dimensions), m = v !== h.seriesLayoutBy || !!p != !!h.sourceHeader || g;
        a = m ? [Gh(l, {
          seriesLayoutBy: v,
          sourceHeader: p,
          dimensions: g
        }, c)] : [];
      } else {
        var w = e;
        if (n) {
          var y = this._applyTransform(r);
          a = y.sourceList, o = y.upstreamSignList;
        } else {
          var b = w.get("source", !0);
          a = [Gh(b, this._getSourceMetaRawOption(), null)], o = [];
        }
      }
      process.env.NODE_ENV !== "production" && ge(a && o), this._setLocalSource(a, o);
    }, t.prototype._applyTransform = function(e) {
      var r = this._sourceHost, n = r.get("transform", !0), a = r.get("fromTransformResult", !0);
      if (process.env.NODE_ENV !== "production" && ge(a != null || n != null), a != null) {
        var o = "";
        e.length !== 1 && (process.env.NODE_ENV !== "production" && (o = "When using `fromTransformResult`, there should be only one upstream dataset"), Qm(o));
      }
      var i, l = [], c = [];
      return I(e, function(u) {
        u.prepareSource();
        var d = u.getSource(a || 0), f = "";
        a != null && !d && (process.env.NODE_ENV !== "production" && (f = "Can not retrieve result by `fromTransformResult`: " + a), Qm(f)), l.push(d), c.push(u._getVersionSign());
      }), n ? i = $1e(n, l, {
        datasetIndex: r.componentIndex
      }) : a != null && (i = [C1e(l[0])]), {
        sourceList: i,
        upstreamSignList: c
      };
    }, t.prototype._isDirty = function() {
      if (this._dirty)
        return !0;
      for (var e = this._getUpstreamSourceManagers(), r = 0; r < e.length; r++) {
        var n = e[r];
        if (
          // Consider the case that there is ancestor diry, call it recursively.
          // The performance is probably not an issue because usually the chain is not long.
          n._isDirty() || this._upstreamSignList[r] !== n._getVersionSign()
        )
          return !0;
      }
    }, t.prototype.getSource = function(e) {
      e = e || 0;
      var r = this._sourceList[e];
      if (!r) {
        var n = this._getUpstreamSourceManagers();
        return n[0] && n[0].getSource(e);
      }
      return r;
    }, t.prototype.getSharedDataStore = function(e) {
      process.env.NODE_ENV !== "production" && ge(cl(this._sourceHost), "Can only call getDataStore on series source manager.");
      var r = e.makeStoreSchema();
      return this._innerGetDataStore(r.dimensions, e.source, r.hash);
    }, t.prototype._innerGetDataStore = function(e, r, n) {
      var a = 0, o = this._storeList, i = o[a];
      i || (i = o[a] = {});
      var l = i[n];
      if (!l) {
        var c = this._getUpstreamSourceManagers()[0];
        cl(this._sourceHost) && c ? l = c._innerGetDataStore(e, r, n) : (l = new Uh(), l.initData(new A_(r, e.length), e)), i[n] = l;
      }
      return l;
    }, t.prototype._getUpstreamSourceManagers = function() {
      var e = this._sourceHost;
      if (cl(e)) {
        var r = C7(e);
        return r ? [r.getSourceManager()] : [];
      } else
        return J(que(e), function(n) {
          return n.getSourceManager();
        });
    }, t.prototype._getSourceMetaRawOption = function() {
      var e = this._sourceHost, r, n, a;
      if (cl(e))
        r = e.get("seriesLayoutBy", !0), n = e.get("sourceHeader", !0), a = e.get("dimensions", !0);
      else if (!this._getUpstreamSourceManagers().length) {
        var o = e;
        r = o.get("seriesLayoutBy", !0), n = o.get("sourceHeader", !0), a = o.get("dimensions", !0);
      }
      return {
        seriesLayoutBy: r,
        sourceHeader: n,
        dimensions: a
      };
    }, t;
  }()
);
function cl(t) {
  return t.mainType === "series";
}
function Qm(t) {
  throw new Error(t);
}
var D_ = "line-height:1";
function N_(t, e) {
  var r = t.color || "#6e7079", n = t.fontSize || 12, a = t.fontWeight || "400", o = t.color || "#464646", i = t.fontSize || 14, l = t.fontWeight || "900";
  return e === "html" ? {
    // eslint-disable-next-line max-len
    nameStyle: "font-size:" + Ft(n + "") + "px;color:" + Ft(r) + ";font-weight:" + Ft(a + ""),
    // eslint-disable-next-line max-len
    valueStyle: "font-size:" + Ft(i + "") + "px;color:" + Ft(o) + ";font-weight:" + Ft(l + "")
  } : {
    nameStyle: {
      fontSize: n,
      fill: r,
      fontWeight: a
    },
    valueStyle: {
      fontSize: i,
      fill: o,
      fontWeight: l
    }
  };
}
var z1e = [0, 10, 20, 30], G1e = ["", `
`, `

`, `


`];
function so(t, e) {
  return e.type = t, e;
}
function Yh(t) {
  return t.type === "section";
}
function B_(t) {
  return Yh(t) ? U1e : Y1e;
}
function F_(t) {
  if (Yh(t)) {
    var e = 0, r = t.blocks.length, n = r > 1 || r > 0 && !t.noHeader;
    return I(t.blocks, function(a) {
      var o = F_(a);
      o >= e && (e = o + +(n && // 0 always can not be readable gap level.
      (!o || Yh(a) && !a.noHeader)));
    }), e;
  }
  return 0;
}
function U1e(t, e, r, n) {
  var a = e.noHeader, o = X1e(F_(e)), i = [], l = e.blocks || [];
  ge(!l || z(l)), l = l || [];
  var c = t.orderMode;
  if (e.sortBlocks && c) {
    l = l.slice();
    var u = {
      valueAsc: "asc",
      valueDesc: "desc"
    };
    if (ao(u, c)) {
      var d = new T1e(u[c], null);
      l.sort(function(p, g) {
        return d.evaluate(p.sortParam, g.sortParam);
      });
    } else c === "seriesDesc" && l.reverse();
  }
  I(l, function(p, g) {
    var m = e.valueFormatter, w = B_(p)(
      // Inherit valueFormatter
      m ? H(H({}, t), {
        valueFormatter: m
      }) : t,
      p,
      g > 0 ? o.html : 0,
      n
    );
    w != null && i.push(w);
  });
  var f = t.renderMode === "richText" ? i.join(o.richText) : Xh(i.join(""), a ? r : o.html);
  if (a)
    return f;
  var h = Wh(e.header, "ordinal", t.useUTC), v = N_(n, t.renderMode).nameStyle;
  return t.renderMode === "richText" ? $_(t, h, v) + o.richText + f : Xh('<div style="' + v + ";" + D_ + ';">' + Ft(h) + "</div>" + f, r);
}
function Y1e(t, e, r, n) {
  var a = t.renderMode, o = e.noName, i = e.noValue, l = !e.markerType, c = e.name, u = t.useUTC, d = e.valueFormatter || t.valueFormatter || function(_) {
    return _ = z(_) ? _ : [_], J(_, function(x, E) {
      return Wh(x, z(v) ? v[E] : v, u);
    });
  };
  if (!(o && i)) {
    var f = l ? "" : t.markupStyleCreator.makeTooltipMarker(e.markerType, e.markerColor || "#333", a), h = o ? "" : Wh(c, "ordinal", u), v = e.valueType, p = i ? [] : d(e.value, e.dataIndex), g = !l || !o, m = !l && o, w = N_(n, a), y = w.nameStyle, b = w.valueStyle;
    return a === "richText" ? (l ? "" : f) + (o ? "" : $_(t, h, y)) + (i ? "" : Q1e(t, p, g, m, b)) : Xh((l ? "" : f) + (o ? "" : q1e(h, !l, y)) + (i ? "" : K1e(p, g, m, b)), r);
  }
}
function Jm(t, e, r, n, a, o) {
  if (t) {
    var i = B_(t), l = {
      useUTC: a,
      renderMode: r,
      orderMode: n,
      markupStyleCreator: e,
      valueFormatter: t.valueFormatter
    };
    return i(l, t, 0, o);
  }
}
function X1e(t) {
  return {
    html: z1e[t],
    richText: G1e[t]
  };
}
function Xh(t, e) {
  var r = '<div style="clear:both"></div>', n = "margin: " + e + "px 0 0";
  return '<div style="' + n + ";" + D_ + ';">' + t + r + "</div>";
}
function q1e(t, e, r) {
  var n = e ? "margin-left:2px" : "";
  return '<span style="' + r + ";" + n + '">' + Ft(t) + "</span>";
}
function K1e(t, e, r, n) {
  var a = r ? "10px" : "20px", o = e ? "float:right;margin-left:" + a : "";
  return t = z(t) ? t : [t], '<span style="' + o + ";" + n + '">' + J(t, function(i) {
    return Ft(i);
  }).join("&nbsp;&nbsp;") + "</span>";
}
function $_(t, e, r) {
  return t.markupStyleCreator.wrapRichTextStyle(e, r);
}
function Q1e(t, e, r, n, a) {
  var o = [a], i = n ? 10 : 20;
  return r && o.push({
    padding: [0, 0, 0, i],
    align: "right"
  }), t.markupStyleCreator.wrapRichTextStyle(z(e) ? e.join("  ") : e, o);
}
function J1e(t, e) {
  var r = t.getData().getItemVisual(e, "style"), n = r[t.visualDrawType];
  return lo(n);
}
function V_(t, e) {
  var r = t.get("padding");
  return r ?? (e === "richText" ? [8, 10] : 10);
}
var Pd = (
  /** @class */
  function() {
    function t() {
      this.richTextStyles = {}, this._nextStyleNameId = d9();
    }
    return t.prototype._generateStyleName = function() {
      return "__EC_aUTo_" + this._nextStyleNameId++;
    }, t.prototype.makeTooltipMarker = function(e, r, n) {
      var a = n === "richText" ? this._generateStyleName() : null, o = g_({
        color: r,
        type: e,
        renderMode: n,
        markerId: a
      });
      return Q(o) ? o : (process.env.NODE_ENV !== "production" && ge(a), this.richTextStyles[a] = o.style, o.content);
    }, t.prototype.wrapRichTextStyle = function(e, r) {
      var n = {};
      z(r) ? I(r, function(o) {
        return H(n, o);
      }) : H(n, r);
      var a = this._generateStyleName();
      return this.richTextStyles[a] = n, "{" + a + "|" + e + "}";
    }, t;
  }()
);
function e5e(t) {
  var e = t.series, r = t.dataIndex, n = t.multipleSeries, a = e.getData(), o = a.mapDimensionsAll("defaultedTooltip"), i = o.length, l = e.getRawValue(r), c = z(l), u = J1e(e, r), d, f, h, v;
  if (i > 1 || c && !i) {
    var p = t5e(l, e, r, o, u);
    d = p.inlineValues, f = p.inlineValueTypes, h = p.blocks, v = p.inlineValues[0];
  } else if (i) {
    var g = a.getDimensionInfo(o[0]);
    v = d = Mi(a, r, o[0]), f = g.type;
  } else
    v = d = c ? l[0] : l;
  var m = Kv(e), w = m && e.name || "", y = a.getName(r), b = n ? w : y;
  return so("section", {
    header: w,
    // When series name is not specified, do not show a header line with only '-'.
    // This case always happens in tooltip.trigger: 'item'.
    noHeader: n || !m,
    sortParam: v,
    blocks: [so("nameValue", {
      markerType: "item",
      markerColor: u,
      // Do not mix display seriesName and itemName in one tooltip,
      // which might confuses users.
      name: b,
      // name dimension might be auto assigned, where the name might
      // be not readable. So we check trim here.
      noName: !Ir(b),
      value: d,
      valueType: f,
      dataIndex: r
    })].concat(h || [])
  });
}
function t5e(t, e, r, n, a) {
  var o = e.getData(), i = tn(t, function(f, h, v) {
    var p = o.getDimensionInfo(v);
    return f = f || p && p.tooltip !== !1 && p.displayName != null;
  }, !1), l = [], c = [], u = [];
  n.length ? I(n, function(f) {
    d(Mi(o, r, f), f);
  }) : I(t, d);
  function d(f, h) {
    var v = o.getDimensionInfo(h);
    !v || v.otherDims.tooltip === !1 || (i ? u.push(so("nameValue", {
      markerType: "subItem",
      markerColor: a,
      name: v.displayName,
      value: f,
      valueType: v.type
    })) : (l.push(f), c.push(v.type)));
  }
  return {
    inlineValues: l,
    inlineValueTypes: c,
    blocks: u
  };
}
var On = je();
function Mc(t, e) {
  return t.getName(e) || t.getId(e);
}
var r5e = "__universalTransitionEnabled", Tt = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r._selectedDataIndicesMap = {}, r;
    }
    return e.prototype.init = function(r, n, a) {
      this.seriesIndex = this.componentIndex, this.dataTask = Zl({
        count: a5e,
        reset: o5e
      }), this.dataTask.context = {
        model: this
      }, this.mergeDefaultAndTheme(r, a);
      var o = On(this).sourceManager = new W1e(this);
      o.prepareSource();
      var i = this.getInitialData(r, a);
      t3(i, this), this.dataTask.context.data = i, process.env.NODE_ENV !== "production" && ge(i, "getInitialData returned invalid data."), On(this).dataBeforeProcessed = i, e3(this), this._initSelectedMapFromData(i);
    }, e.prototype.mergeDefaultAndTheme = function(r, n) {
      var a = ss(this), o = a ? zs(r) : {}, i = this.subType;
      Ee.hasClass(i) && (i += "Series"), Ce(r, n.getTheme().get(this.subType)), Ce(r, this.getDefaultOption()), J0(r, "label", ["show"]), this.fillDataTextStyle(r.data), a && Ri(r, o, a);
    }, e.prototype.mergeOption = function(r, n) {
      r = Ce(this.option, r, !0), this.fillDataTextStyle(r.data);
      var a = ss(this);
      a && Ri(this.option, r, a);
      var o = On(this).sourceManager;
      o.dirty(), o.prepareSource();
      var i = this.getInitialData(r, n);
      t3(i, this), this.dataTask.dirty(), this.dataTask.context.data = i, On(this).dataBeforeProcessed = i, e3(this), this._initSelectedMapFromData(i);
    }, e.prototype.fillDataTextStyle = function(r) {
      if (r && !yt(r))
        for (var n = ["show"], a = 0; a < r.length; a++)
          r[a] && r[a].label && J0(r[a], "label", n);
    }, e.prototype.getInitialData = function(r, n) {
    }, e.prototype.appendData = function(r) {
      var n = this.getRawData();
      n.appendData(r.data);
    }, e.prototype.getData = function(r) {
      var n = qh(this);
      if (n) {
        var a = n.context.data;
        return r == null || !a.getLinkedData ? a : a.getLinkedData(r);
      } else
        return On(this).data;
    }, e.prototype.getAllData = function() {
      var r = this.getData();
      return r && r.getLinkedDataAll ? r.getLinkedDataAll() : [{
        data: r
      }];
    }, e.prototype.setData = function(r) {
      var n = qh(this);
      if (n) {
        var a = n.context;
        a.outputData = r, n !== this.dataTask && (a.data = r);
      }
      On(this).data = r;
    }, e.prototype.getEncode = function() {
      var r = this.get("encode", !0);
      if (r)
        return se(r);
    }, e.prototype.getSourceManager = function() {
      return On(this).sourceManager;
    }, e.prototype.getSource = function() {
      return this.getSourceManager().getSource();
    }, e.prototype.getRawData = function() {
      return On(this).dataBeforeProcessed;
    }, e.prototype.getColorBy = function() {
      var r = this.get("colorBy");
      return r || "series";
    }, e.prototype.isColorBySeries = function() {
      return this.getColorBy() === "series";
    }, e.prototype.getBaseAxis = function() {
      var r = this.coordinateSystem;
      return r && r.getBaseAxis && r.getBaseAxis();
    }, e.prototype.formatTooltip = function(r, n, a) {
      return e5e({
        series: this,
        dataIndex: r,
        multipleSeries: n
      });
    }, e.prototype.isAnimationEnabled = function() {
      var r = this.ecModel;
      if (ue.node && !(r && r.ssr))
        return !1;
      var n = this.getShallow("animation");
      return n && this.getData().count() > this.getShallow("animationThreshold") && (n = !1), !!n;
    }, e.prototype.restoreData = function() {
      this.dataTask.dirty();
    }, e.prototype.getColorFromPalette = function(r, n, a) {
      var o = this.ecModel, i = E7.prototype.getColorFromPalette.call(this, r, n, a);
      return i || (i = o.getColorFromPalette(r, n, a)), i;
    }, e.prototype.coordDimToDataDim = function(r) {
      return this.getRawData().mapDimensionsAll(r);
    }, e.prototype.getProgressive = function() {
      return this.get("progressive");
    }, e.prototype.getProgressiveThreshold = function() {
      return this.get("progressiveThreshold");
    }, e.prototype.select = function(r, n) {
      this._innerSelect(this.getData(n), r);
    }, e.prototype.unselect = function(r, n) {
      var a = this.option.selectedMap;
      if (a) {
        var o = this.option.selectedMode, i = this.getData(n);
        if (o === "series" || a === "all") {
          this.option.selectedMap = {}, this._selectedDataIndicesMap = {};
          return;
        }
        for (var l = 0; l < r.length; l++) {
          var c = r[l], u = Mc(i, c);
          a[u] = !1, this._selectedDataIndicesMap[u] = -1;
        }
      }
    }, e.prototype.toggleSelect = function(r, n) {
      for (var a = [], o = 0; o < r.length; o++)
        a[0] = r[o], this.isSelected(r[o], n) ? this.unselect(a, n) : this.select(a, n);
    }, e.prototype.getSelectedDataIndices = function() {
      if (this.option.selectedMap === "all")
        return [].slice.call(this.getData().getIndices());
      for (var r = this._selectedDataIndicesMap, n = Ze(r), a = [], o = 0; o < n.length; o++) {
        var i = r[n[o]];
        i >= 0 && a.push(i);
      }
      return a;
    }, e.prototype.isSelected = function(r, n) {
      var a = this.option.selectedMap;
      if (!a)
        return !1;
      var o = this.getData(n);
      return (a === "all" || a[Mc(o, r)]) && !o.getItemModel(r).get(["select", "disabled"]);
    }, e.prototype.isUniversalTransitionEnabled = function() {
      if (this[r5e])
        return !0;
      var r = this.option.universalTransition;
      return r ? r === !0 ? !0 : r && r.enabled : !1;
    }, e.prototype._innerSelect = function(r, n) {
      var a, o, i = this.option, l = i.selectedMode, c = n.length;
      if (!(!l || !c)) {
        if (l === "series")
          i.selectedMap = "all";
        else if (l === "multiple") {
          re(i.selectedMap) || (i.selectedMap = {});
          for (var u = i.selectedMap, d = 0; d < c; d++) {
            var f = n[d], h = Mc(r, f);
            u[h] = !0, this._selectedDataIndicesMap[h] = r.getRawIndex(f);
          }
        } else if (l === "single" || l === !0) {
          var v = n[c - 1], h = Mc(r, v);
          i.selectedMap = (a = {}, a[h] = !0, a), this._selectedDataIndicesMap = (o = {}, o[h] = r.getRawIndex(v), o);
        }
      }
    }, e.prototype._initSelectedMapFromData = function(r) {
      if (!this.option.selectedMap) {
        var n = [];
        r.hasItemOption && r.each(function(a) {
          var o = r.getRawDataItem(a);
          o && o.selected && n.push(a);
        }), n.length > 0 && this._innerSelect(r, n);
      }
    }, e.registerClass = function(r) {
      return Ee.registerClass(r);
    }, e.protoInitialize = function() {
      var r = e.prototype;
      r.type = "series.__base__", r.seriesIndex = 0, r.ignoreStyleOnData = !1, r.hasSymbolVisual = !1, r.defaultSymbol = "circle", r.visualStyleAccessPath = "itemStyle", r.visualDrawType = "fill";
    }(), e;
  }(Ee)
);
tr(Tt, A7);
tr(Tt, E7);
w9(Tt, Ee);
function e3(t) {
  var e = t.name;
  Kv(t) || (t.name = n5e(t) || e);
}
function n5e(t) {
  var e = t.getRawData(), r = e.mapDimensionsAll("seriesName"), n = [];
  return I(r, function(a) {
    var o = e.getDimensionInfo(a);
    o.displayName && n.push(o.displayName);
  }), n.join(" ");
}
function a5e(t) {
  return t.model.getRawData().count();
}
function o5e(t) {
  var e = t.model;
  return e.setData(e.getRawData().cloneShallow()), i5e;
}
function i5e(t, e) {
  e.outputData && t.end > e.outputData.count() && e.model.getRawData().cloneShallow(e.outputData);
}
function t3(t, e) {
  I(Fb(t.CHANGABLE_METHODS, t.DOWNSAMPLE_METHODS), function(r) {
    t.wrapMethod(r, Oe(l5e, e));
  });
}
function l5e(t, e) {
  var r = qh(t);
  return r && r.setOutputEnd((e || this).count()), e;
}
function qh(t) {
  var e = (t.ecModel || {}).scheduler, r = e && e.getPipeline(t.uid);
  if (r) {
    var n = r.currentTask;
    if (n) {
      var a = n.agentStubMap;
      a && (n = a.get(t.uid));
    }
    return n;
  }
}
var _t = (
  /** @class */
  function() {
    function t() {
      this.group = new Xe(), this.uid = N1("viewComponent");
    }
    return t.prototype.init = function(e, r) {
    }, t.prototype.render = function(e, r, n, a) {
    }, t.prototype.dispose = function(e, r) {
    }, t.prototype.updateView = function(e, r, n, a) {
    }, t.prototype.updateLayout = function(e, r, n, a) {
    }, t.prototype.updateVisual = function(e, r, n, a) {
    }, t.prototype.toggleBlurSeries = function(e, r, n) {
    }, t.prototype.eachRendered = function(e) {
      var r = this.group;
      r && r.traverse(e);
    }, t;
  }()
);
Jv(_t);
S1(_t);
function L7() {
  var t = je();
  return function(e) {
    var r = t(e), n = e.pipelineContext, a = !!r.large, o = !!r.progressiveRender, i = r.large = !!(n && n.large), l = r.progressiveRender = !!(n && n.progressiveRender);
    return (a !== i || o !== l) && "reset";
  };
}
var Z_ = je(), s5e = L7(), wt = (
  /** @class */
  function() {
    function t() {
      this.group = new Xe(), this.uid = N1("viewChart"), this.renderTask = Zl({
        plan: c5e,
        reset: u5e
      }), this.renderTask.context = {
        view: this
      };
    }
    return t.prototype.init = function(e, r) {
    }, t.prototype.render = function(e, r, n, a) {
      if (process.env.NODE_ENV !== "production")
        throw new Error("render method must been implemented");
    }, t.prototype.highlight = function(e, r, n, a) {
      var o = e.getData(a && a.dataType);
      if (!o) {
        process.env.NODE_ENV !== "production" && bt("Unknown dataType " + a.dataType);
        return;
      }
      n3(o, a, "emphasis");
    }, t.prototype.downplay = function(e, r, n, a) {
      var o = e.getData(a && a.dataType);
      if (!o) {
        process.env.NODE_ENV !== "production" && bt("Unknown dataType " + a.dataType);
        return;
      }
      n3(o, a, "normal");
    }, t.prototype.remove = function(e, r) {
      this.group.removeAll();
    }, t.prototype.dispose = function(e, r) {
    }, t.prototype.updateView = function(e, r, n, a) {
      this.render(e, r, n, a);
    }, t.prototype.updateLayout = function(e, r, n, a) {
      this.render(e, r, n, a);
    }, t.prototype.updateVisual = function(e, r, n, a) {
      this.render(e, r, n, a);
    }, t.prototype.eachRendered = function(e) {
      Zs(this.group, e);
    }, t.markUpdateMethod = function(e, r) {
      Z_(e).updateMethod = r;
    }, t.protoInitialize = function() {
      var e = t.prototype;
      e.type = "chart";
    }(), t;
  }()
);
function r3(t, e, r) {
  t && Si(t) && (e === "emphasis" ? rs : ns)(t, r);
}
function n3(t, e, r) {
  var n = oo(t, e), a = e && e.highlightKey != null ? D0e(e.highlightKey) : null;
  n != null ? I(kt(n), function(o) {
    r3(t.getItemGraphicEl(o), r, a);
  }) : t.eachItemGraphicEl(function(o) {
    r3(o, r, a);
  });
}
Jv(wt, ["dispose"]);
S1(wt);
function c5e(t) {
  return s5e(t.model);
}
function u5e(t) {
  var e = t.model, r = t.ecModel, n = t.api, a = t.payload, o = e.pipelineContext.progressiveRender, i = t.view, l = a && Z_(a).updateMethod, c = o ? "incrementalPrepareRender" : l && i[l] ? l : "render";
  return c !== "render" && i[c](e, r, n, a), d5e[c];
}
var d5e = {
  incrementalPrepareRender: {
    progress: function(t, e) {
      e.view.incrementalRender(t, e.model, e.ecModel, e.api, e.payload);
    }
  },
  render: {
    // Put view.render in `progress` to support appendData. But in this case
    // view.render should not be called in reset, otherwise it will be called
    // twise. Use `forceFirstProgress` to make sure that view.render is called
    // in any cases.
    forceFirstProgress: !0,
    progress: function(t, e) {
      e.view.render(e.model, e.ecModel, e.api, e.payload);
    }
  }
}, cu = "\0__throttleOriginMethod", a3 = "\0__throttleRate", o3 = "\0__throttleType";
function z1(t, e, r) {
  var n, a = 0, o = 0, i = null, l, c, u, d;
  e = e || 0;
  function f() {
    o = (/* @__PURE__ */ new Date()).getTime(), i = null, t.apply(c, u || []);
  }
  var h = function() {
    for (var v = [], p = 0; p < arguments.length; p++)
      v[p] = arguments[p];
    n = (/* @__PURE__ */ new Date()).getTime(), c = this, u = v;
    var g = d || e, m = d || r;
    d = null, l = n - (m ? a : o) - g, clearTimeout(i), m ? i = setTimeout(f, g) : l >= 0 ? f() : i = setTimeout(f, -l), a = n;
  };
  return h.clear = function() {
    i && (clearTimeout(i), i = null);
  }, h.debounceNextCall = function(v) {
    d = v;
  }, h;
}
function G1(t, e, r, n) {
  var a = t[e];
  if (a) {
    var o = a[cu] || a, i = a[o3], l = a[a3];
    if (l !== r || i !== n) {
      if (r == null || !n)
        return t[e] = o;
      a = t[e] = z1(o, r, n === "debounce"), a[cu] = o, a[o3] = n, a[a3] = r;
    }
    return a;
  }
}
function uu(t, e) {
  var r = t[e];
  r && r[cu] && (r.clear && r.clear(), t[e] = r[cu]);
}
var i3 = je(), l3 = {
  itemStyle: ts(i_, !0),
  lineStyle: ts(o_, !0)
}, f5e = {
  lineStyle: "stroke",
  itemStyle: "fill"
};
function H_(t, e) {
  var r = t.visualStyleMapper || l3[e];
  return r || (console.warn("Unknown style type '" + e + "'."), l3.itemStyle);
}
function j_(t, e) {
  var r = t.visualDrawType || f5e[e];
  return r || (console.warn("Unknown style type '" + e + "'."), "fill");
}
var h5e = {
  createOnAllSeries: !0,
  performRawSeries: !0,
  reset: function(t, e) {
    var r = t.getData(), n = t.visualStyleAccessPath || "itemStyle", a = t.getModel(n), o = H_(t, n), i = o(a), l = a.getShallow("decal");
    l && (r.setVisual("decal", l), l.dirty = !0);
    var c = j_(t, n), u = i[c], d = ie(u) ? u : null, f = i.fill === "auto" || i.stroke === "auto";
    if (!i[c] || d || f) {
      var h = t.getColorFromPalette(
        // TODO series count changed.
        t.name,
        null,
        e.getSeriesCount()
      );
      i[c] || (i[c] = h, r.setVisual("colorFromPalette", !0)), i.fill = i.fill === "auto" || ie(i.fill) ? h : i.fill, i.stroke = i.stroke === "auto" || ie(i.stroke) ? h : i.stroke;
    }
    if (r.setVisual("style", i), r.setVisual("drawType", c), !e.isSeriesFiltered(t) && d)
      return r.setVisual("colorFromPalette", !1), {
        dataEach: function(v, p) {
          var g = t.getDataParams(p), m = H({}, i);
          m[c] = d(g), v.setItemVisual(p, "style", m);
        }
      };
  }
}, ul = new Ve(), v5e = {
  createOnAllSeries: !0,
  performRawSeries: !0,
  reset: function(t, e) {
    if (!(t.ignoreStyleOnData || e.isSeriesFiltered(t))) {
      var r = t.getData(), n = t.visualStyleAccessPath || "itemStyle", a = H_(t, n), o = r.getVisual("drawType");
      return {
        dataEach: r.hasItemOption ? function(i, l) {
          var c = i.getRawDataItem(l);
          if (c && c[n]) {
            ul.option = c[n];
            var u = a(ul), d = i.ensureUniqueItemVisual(l, "style");
            H(d, u), ul.option.decal && (i.setItemVisual(l, "decal", ul.option.decal), ul.option.decal.dirty = !0), o in u && i.setItemVisual(l, "colorFromPalette", !1);
          }
        } : null
      };
    }
  }
}, p5e = {
  performRawSeries: !0,
  overallReset: function(t) {
    var e = se();
    t.eachSeries(function(r) {
      var n = r.getColorBy();
      if (!r.isColorBySeries()) {
        var a = r.type + "-" + n, o = e.get(a);
        o || (o = {}, e.set(a, o)), i3(r).scope = o;
      }
    }), t.eachSeries(function(r) {
      if (!(r.isColorBySeries() || t.isSeriesFiltered(r))) {
        var n = r.getRawData(), a = {}, o = r.getData(), i = i3(r).scope, l = r.visualStyleAccessPath || "itemStyle", c = j_(r, l);
        o.each(function(u) {
          var d = o.getRawIndex(u);
          a[d] = u;
        }), n.each(function(u) {
          var d = a[u], f = o.getItemVisual(d, "colorFromPalette");
          if (f) {
            var h = o.ensureUniqueItemVisual(d, "style"), v = n.getName(u) || u + "", p = n.count();
            h[c] = r.getColorFromPalette(v, i, p);
          }
        });
      }
    });
  }
}, Ac = Math.PI;
function g5e(t, e) {
  e = e || {}, Te(e, {
    text: "loading",
    textColor: "#000",
    fontSize: 12,
    fontWeight: "normal",
    fontStyle: "normal",
    fontFamily: "sans-serif",
    maskColor: "rgba(255, 255, 255, 0.8)",
    showSpinner: !0,
    color: "#5470c6",
    spinnerRadius: 10,
    lineWidth: 5,
    zlevel: 0
  });
  var r = new Xe(), n = new He({
    style: {
      fill: e.maskColor
    },
    zlevel: e.zlevel,
    z: 1e4
  });
  r.add(n);
  var a = new Ye({
    style: {
      text: e.text,
      fill: e.textColor,
      fontSize: e.fontSize,
      fontWeight: e.fontWeight,
      fontStyle: e.fontStyle,
      fontFamily: e.fontFamily
    },
    zlevel: e.zlevel,
    z: 10001
  }), o = new He({
    style: {
      fill: "none"
    },
    textContent: a,
    textConfig: {
      position: "right",
      distance: 10
    },
    zlevel: e.zlevel,
    z: 10001
  });
  r.add(o);
  var i;
  return e.showSpinner && (i = new Vs({
    shape: {
      startAngle: -Ac / 2,
      endAngle: -Ac / 2 + 0.1,
      r: e.spinnerRadius
    },
    style: {
      stroke: e.color,
      lineCap: "round",
      lineWidth: e.lineWidth
    },
    zlevel: e.zlevel,
    z: 10001
  }), i.animateShape(!0).when(1e3, {
    endAngle: Ac * 3 / 2
  }).start("circularInOut"), i.animateShape(!0).when(1e3, {
    startAngle: Ac * 3 / 2
  }).delay(300).start("circularInOut"), r.add(i)), r.resize = function() {
    var l = a.getBoundingRect().width, c = e.showSpinner ? e.spinnerRadius : 0, u = (t.getWidth() - c * 2 - (e.showSpinner && l ? 10 : 0) - l) / 2 - (e.showSpinner && l ? 0 : 5 + l / 2) + (e.showSpinner ? 0 : l / 2) + (l ? 0 : c), d = t.getHeight() / 2;
    e.showSpinner && i.setShape({
      cx: u,
      cy: d
    }), o.setShape({
      x: u - c,
      y: d - c,
      width: c * 2,
      height: c * 2
    }), n.setShape({
      x: 0,
      y: 0,
      width: t.getWidth(),
      height: t.getHeight()
    });
  }, r.resize(), r;
}
var W_ = (
  /** @class */
  function() {
    function t(e, r, n, a) {
      this._stageTaskMap = se(), this.ecInstance = e, this.api = r, n = this._dataProcessorHandlers = n.slice(), a = this._visualHandlers = a.slice(), this._allHandlers = n.concat(a);
    }
    return t.prototype.restoreData = function(e, r) {
      e.restoreData(r), this._stageTaskMap.each(function(n) {
        var a = n.overallTask;
        a && a.dirty();
      });
    }, t.prototype.getPerformArgs = function(e, r) {
      if (e.__pipeline) {
        var n = this._pipelineMap.get(e.__pipeline.id), a = n.context, o = !r && n.progressiveEnabled && (!a || a.progressiveRender) && e.__idxInPipeline > n.blockIndex, i = o ? n.step : null, l = a && a.modDataCount, c = l != null ? Math.ceil(l / i) : null;
        return {
          step: i,
          modBy: c,
          modDataCount: l
        };
      }
    }, t.prototype.getPipeline = function(e) {
      return this._pipelineMap.get(e);
    }, t.prototype.updateStreamModes = function(e, r) {
      var n = this._pipelineMap.get(e.uid), a = e.getData(), o = a.count(), i = n.progressiveEnabled && r.incrementalPrepareRender && o >= n.threshold, l = e.get("large") && o >= e.get("largeThreshold"), c = e.get("progressiveChunkMode") === "mod" ? o : null;
      e.pipelineContext = n.context = {
        progressiveRender: i,
        modDataCount: c,
        large: l
      };
    }, t.prototype.restorePipelines = function(e) {
      var r = this, n = r._pipelineMap = se();
      e.eachSeries(function(a) {
        var o = a.getProgressive(), i = a.uid;
        n.set(i, {
          id: i,
          head: null,
          tail: null,
          threshold: a.getProgressiveThreshold(),
          progressiveEnabled: o && !(a.preventIncremental && a.preventIncremental()),
          blockIndex: -1,
          step: Math.round(o || 700),
          count: 0
        }), r._pipe(a, a.dataTask);
      });
    }, t.prototype.prepareStageTasks = function() {
      var e = this._stageTaskMap, r = this.api.getModel(), n = this.api;
      I(this._allHandlers, function(a) {
        var o = e.get(a.uid) || e.set(a.uid, {}), i = "";
        process.env.NODE_ENV !== "production" && (i = '"reset" and "overallReset" must not be both specified.'), ge(!(a.reset && a.overallReset), i), a.reset && this._createSeriesStageTask(a, o, r, n), a.overallReset && this._createOverallStageTask(a, o, r, n);
      }, this);
    }, t.prototype.prepareView = function(e, r, n, a) {
      var o = e.renderTask, i = o.context;
      i.model = r, i.ecModel = n, i.api = a, o.__block = !e.incrementalPrepareRender, this._pipe(r, o);
    }, t.prototype.performDataProcessorTasks = function(e, r) {
      this._performStageTasks(this._dataProcessorHandlers, e, r, {
        block: !0
      });
    }, t.prototype.performVisualTasks = function(e, r, n) {
      this._performStageTasks(this._visualHandlers, e, r, n);
    }, t.prototype._performStageTasks = function(e, r, n, a) {
      a = a || {};
      var o = !1, i = this;
      I(e, function(c, u) {
        if (!(a.visualType && a.visualType !== c.visualType)) {
          var d = i._stageTaskMap.get(c.uid), f = d.seriesTaskMap, h = d.overallTask;
          if (h) {
            var v, p = h.agentStubMap;
            p.each(function(m) {
              l(a, m) && (m.dirty(), v = !0);
            }), v && h.dirty(), i.updatePayload(h, n);
            var g = i.getPerformArgs(h, a.block);
            p.each(function(m) {
              m.perform(g);
            }), h.perform(g) && (o = !0);
          } else f && f.each(function(m, w) {
            l(a, m) && m.dirty();
            var y = i.getPerformArgs(m, a.block);
            y.skip = !c.performRawSeries && r.isSeriesFiltered(m.context.model), i.updatePayload(m, n), m.perform(y) && (o = !0);
          });
        }
      });
      function l(c, u) {
        return c.setDirty && (!c.dirtyMap || c.dirtyMap.get(u.__pipeline.id));
      }
      this.unfinished = o || this.unfinished;
    }, t.prototype.performSeriesTasks = function(e) {
      var r;
      e.eachSeries(function(n) {
        r = n.dataTask.perform() || r;
      }), this.unfinished = r || this.unfinished;
    }, t.prototype.plan = function() {
      this._pipelineMap.each(function(e) {
        var r = e.tail;
        do {
          if (r.__block) {
            e.blockIndex = r.__idxInPipeline;
            break;
          }
          r = r.getUpstream();
        } while (r);
      });
    }, t.prototype.updatePayload = function(e, r) {
      r !== "remain" && (e.context.payload = r);
    }, t.prototype._createSeriesStageTask = function(e, r, n, a) {
      var o = this, i = r.seriesTaskMap, l = r.seriesTaskMap = se(), c = e.seriesType, u = e.getTargetSeries;
      e.createOnAllSeries ? n.eachRawSeries(d) : c ? n.eachRawSeriesByType(c, d) : u && u(n, a).each(d);
      function d(f) {
        var h = f.uid, v = l.set(h, i && i.get(h) || Zl({
          plan: _5e,
          reset: x5e,
          count: E5e
        }));
        v.context = {
          model: f,
          ecModel: n,
          api: a,
          // PENDING: `useClearVisual` not used?
          useClearVisual: e.isVisual && !e.isLayout,
          plan: e.plan,
          reset: e.reset,
          scheduler: o
        }, o._pipe(f, v);
      }
    }, t.prototype._createOverallStageTask = function(e, r, n, a) {
      var o = this, i = r.overallTask = r.overallTask || Zl({
        reset: m5e
      });
      i.context = {
        ecModel: n,
        api: a,
        overallReset: e.overallReset,
        scheduler: o
      };
      var l = i.agentStubMap, c = i.agentStubMap = se(), u = e.seriesType, d = e.getTargetSeries, f = !0, h = !1, v = "";
      process.env.NODE_ENV !== "production" && (v = '"createOnAllSeries" is not supported for "overallReset", because it will block all streams.'), ge(!e.createOnAllSeries, v), u ? n.eachRawSeriesByType(u, p) : d ? d(n, a).each(p) : (f = !1, I(n.getSeries(), p));
      function p(g) {
        var m = g.uid, w = c.set(m, l && l.get(m) || // When the result of `getTargetSeries` changed, the overallTask
        // should be set as dirty and re-performed.
        (h = !0, Zl({
          reset: w5e,
          onDirty: b5e
        })));
        w.context = {
          model: g,
          overallProgress: f
          // FIXME:TS never used, so comment it
          // modifyOutputEnd: modifyOutputEnd
        }, w.agent = i, w.__block = f, o._pipe(g, w);
      }
      h && i.dirty();
    }, t.prototype._pipe = function(e, r) {
      var n = e.uid, a = this._pipelineMap.get(n);
      !a.head && (a.head = r), a.tail && a.tail.pipe(r), a.tail = r, r.__idxInPipeline = a.count++, r.__pipeline = a;
    }, t.wrapStageHandler = function(e, r) {
      return ie(e) && (e = {
        overallReset: e,
        seriesType: S5e(e)
      }), e.uid = N1("stageHandler"), r && (e.visualType = r), e;
    }, t;
  }()
);
function m5e(t) {
  t.overallReset(t.ecModel, t.api, t.payload);
}
function w5e(t) {
  return t.overallProgress && y5e;
}
function y5e() {
  this.agent.dirty(), this.getDownstream().dirty();
}
function b5e() {
  this.agent && this.agent.dirty();
}
function _5e(t) {
  return t.plan ? t.plan(t.model, t.ecModel, t.api, t.payload) : null;
}
function x5e(t) {
  t.useClearVisual && t.data.clearAllVisual();
  var e = t.resetDefines = kt(t.reset(t.model, t.ecModel, t.api, t.payload));
  return e.length > 1 ? J(e, function(r, n) {
    return z_(n);
  }) : C5e;
}
var C5e = z_(0);
function z_(t) {
  return function(e, r) {
    var n = r.data, a = r.resetDefines[t];
    if (a && a.dataEach)
      for (var o = e.start; o < e.end; o++)
        a.dataEach(n, o);
    else a && a.progress && a.progress(e, n);
  };
}
function E5e(t) {
  return t.data.count();
}
function S5e(t) {
  du = null;
  try {
    t(us, G_);
  } catch {
  }
  return du;
}
var us = {}, G_ = {}, du;
U_(us, S7);
U_(G_, x_);
us.eachSeriesByType = us.eachRawSeriesByType = function(t) {
  du = t;
};
us.eachComponent = function(t) {
  t.mainType === "series" && t.subType && (du = t.subType);
};
function U_(t, e) {
  for (var r in e.prototype)
    t[r] = mt;
}
var s3 = ["#37A2DA", "#32C5E9", "#67E0E3", "#9FE6B8", "#FFDB5C", "#ff9f7f", "#fb7293", "#E062AE", "#E690D1", "#e7bcf3", "#9d96f5", "#8378EA", "#96BFFF"];
const R5e = {
  color: s3,
  colorLayer: [["#37A2DA", "#ffd85c", "#fd7b5f"], ["#37A2DA", "#67E0E3", "#FFDB5C", "#ff9f7f", "#E062AE", "#9d96f5"], ["#37A2DA", "#32C5E9", "#9FE6B8", "#FFDB5C", "#ff9f7f", "#fb7293", "#e7bcf3", "#8378EA", "#96BFFF"], s3]
};
var Et = "#B9B8CE", c3 = "#100C2A", kc = function() {
  return {
    axisLine: {
      lineStyle: {
        color: Et
      }
    },
    splitLine: {
      lineStyle: {
        color: "#484753"
      }
    },
    splitArea: {
      areaStyle: {
        color: ["rgba(255,255,255,0.02)", "rgba(255,255,255,0.05)"]
      }
    },
    minorSplitLine: {
      lineStyle: {
        color: "#20203B"
      }
    }
  };
}, u3 = ["#4992ff", "#7cffb2", "#fddd60", "#ff6e76", "#58d9f9", "#05c091", "#ff8a45", "#8d48e3", "#dd79ff"], Y_ = {
  darkMode: !0,
  color: u3,
  backgroundColor: c3,
  axisPointer: {
    lineStyle: {
      color: "#817f91"
    },
    crossStyle: {
      color: "#817f91"
    },
    label: {
      // TODO Contrast of label backgorundColor
      color: "#fff"
    }
  },
  legend: {
    textStyle: {
      color: Et
    }
  },
  textStyle: {
    color: Et
  },
  title: {
    textStyle: {
      color: "#EEF1FA"
    },
    subtextStyle: {
      color: "#B9B8CE"
    }
  },
  toolbox: {
    iconStyle: {
      borderColor: Et
    }
  },
  dataZoom: {
    borderColor: "#71708A",
    textStyle: {
      color: Et
    },
    brushStyle: {
      color: "rgba(135,163,206,0.3)"
    },
    handleStyle: {
      color: "#353450",
      borderColor: "#C5CBE3"
    },
    moveHandleStyle: {
      color: "#B0B6C3",
      opacity: 0.3
    },
    fillerColor: "rgba(135,163,206,0.2)",
    emphasis: {
      handleStyle: {
        borderColor: "#91B7F2",
        color: "#4D587D"
      },
      moveHandleStyle: {
        color: "#636D9A",
        opacity: 0.7
      }
    },
    dataBackground: {
      lineStyle: {
        color: "#71708A",
        width: 1
      },
      areaStyle: {
        color: "#71708A"
      }
    },
    selectedDataBackground: {
      lineStyle: {
        color: "#87A3CE"
      },
      areaStyle: {
        color: "#87A3CE"
      }
    }
  },
  visualMap: {
    textStyle: {
      color: Et
    }
  },
  timeline: {
    lineStyle: {
      color: Et
    },
    label: {
      color: Et
    },
    controlStyle: {
      color: Et,
      borderColor: Et
    }
  },
  calendar: {
    itemStyle: {
      color: c3
    },
    dayLabel: {
      color: Et
    },
    monthLabel: {
      color: Et
    },
    yearLabel: {
      color: Et
    }
  },
  timeAxis: kc(),
  logAxis: kc(),
  valueAxis: kc(),
  categoryAxis: kc(),
  line: {
    symbol: "circle"
  },
  graph: {
    color: u3
  },
  gauge: {
    title: {
      color: Et
    },
    axisLine: {
      lineStyle: {
        color: [[1, "rgba(207,212,219,0.2)"]]
      }
    },
    axisLabel: {
      color: Et
    },
    detail: {
      color: "#EEF1FA"
    }
  },
  candlestick: {
    itemStyle: {
      color: "#f64e56",
      color0: "#54ea92",
      borderColor: "#f64e56",
      borderColor0: "#54ea92"
      // borderColor: '#ca2824',
      // borderColor0: '#09a443'
    }
  }
};
Y_.categoryAxis.splitLine.show = !1;
var M5e = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.normalizeQuery = function(e) {
      var r = {}, n = {}, a = {};
      if (Q(e)) {
        var o = Kr(e);
        r.mainType = o.main || null, r.subType = o.sub || null;
      } else {
        var i = ["Index", "Name", "Id"], l = {
          name: 1,
          dataIndex: 1,
          dataType: 1
        };
        I(e, function(c, u) {
          for (var d = !1, f = 0; f < i.length; f++) {
            var h = i[f], v = u.lastIndexOf(h);
            if (v > 0 && v === u.length - h.length) {
              var p = u.slice(0, v);
              p !== "data" && (r.mainType = p, r[h.toLowerCase()] = c, d = !0);
            }
          }
          l.hasOwnProperty(u) && (n[u] = c, d = !0), d || (a[u] = c);
        });
      }
      return {
        cptQuery: r,
        dataQuery: n,
        otherQuery: a
      };
    }, t.prototype.filter = function(e, r) {
      var n = this.eventInfo;
      if (!n)
        return !0;
      var a = n.targetEl, o = n.packedEvent, i = n.model, l = n.view;
      if (!i || !l)
        return !0;
      var c = r.cptQuery, u = r.dataQuery;
      return d(c, i, "mainType") && d(c, i, "subType") && d(c, i, "index", "componentIndex") && d(c, i, "name") && d(c, i, "id") && d(u, o, "name") && d(u, o, "dataIndex") && d(u, o, "dataType") && (!l.filterForExposedEvent || l.filterForExposedEvent(e, r.otherQuery, a, o));
      function d(f, h, v, p) {
        return f[v] == null || h[p || v] === f[v];
      }
    }, t.prototype.afterTrigger = function() {
      this.eventInfo = null;
    }, t;
  }()
), Kh = ["symbol", "symbolSize", "symbolRotate", "symbolOffset"], d3 = Kh.concat(["symbolKeepAspect"]), A5e = {
  createOnAllSeries: !0,
  // For legend.
  performRawSeries: !0,
  reset: function(t, e) {
    var r = t.getData();
    if (t.legendIcon && r.setVisual("legendIcon", t.legendIcon), !t.hasSymbolVisual)
      return;
    for (var n = {}, a = {}, o = !1, i = 0; i < Kh.length; i++) {
      var l = Kh[i], c = t.get(l);
      ie(c) ? (o = !0, a[l] = c) : n[l] = c;
    }
    if (n.symbol = n.symbol || t.defaultSymbol, r.setVisual(H({
      legendIcon: t.legendIcon || n.symbol,
      symbolKeepAspect: t.get("symbolKeepAspect")
    }, n)), e.isSeriesFiltered(t))
      return;
    var u = Ze(a);
    function d(f, h) {
      for (var v = t.getRawValue(h), p = t.getDataParams(h), g = 0; g < u.length; g++) {
        var m = u[g];
        f.setItemVisual(h, m, a[m](v, p));
      }
    }
    return {
      dataEach: o ? d : null
    };
  }
}, k5e = {
  createOnAllSeries: !0,
  // For legend.
  performRawSeries: !0,
  reset: function(t, e) {
    if (!t.hasSymbolVisual || e.isSeriesFiltered(t))
      return;
    var r = t.getData();
    function n(a, o) {
      for (var i = a.getItemModel(o), l = 0; l < d3.length; l++) {
        var c = d3[l], u = i.getShallow(c, !0);
        u != null && a.setItemVisual(o, c, u);
      }
    }
    return {
      dataEach: r.hasItemOption ? n : null
    };
  }
};
function L5e(t, e, r) {
  switch (r) {
    case "color":
      var n = t.getItemVisual(e, "style");
      return n[t.getVisual("drawType")];
    case "opacity":
      return t.getItemVisual(e, "style").opacity;
    case "symbol":
    case "symbolSize":
    case "liftZ":
      return t.getItemVisual(e, r);
    default:
      process.env.NODE_ENV !== "production" && console.warn("Unknown visual type " + r);
  }
}
function X_(t, e) {
  switch (e) {
    case "color":
      var r = t.getVisual("style");
      return r[t.getVisual("drawType")];
    case "opacity":
      return t.getVisual("style").opacity;
    case "symbol":
    case "symbolSize":
    case "liftZ":
      return t.getVisual(e);
    default:
      process.env.NODE_ENV !== "production" && console.warn("Unknown visual type " + e);
  }
}
function T5e(t, e) {
  function r(n, a) {
    var o = [];
    return n.eachComponent({
      mainType: "series",
      subType: t,
      query: a
    }, function(i) {
      o.push(i.seriesIndex);
    }), o;
  }
  I([[t + "ToggleSelect", "toggleSelect"], [t + "Select", "select"], [t + "UnSelect", "unselect"]], function(n) {
    e(n[0], function(a, o, i) {
      a = H({}, a), process.env.NODE_ENV !== "production" && tt(a.type, n[1]), i.dispatchAction(H(a, {
        type: n[1],
        seriesIndex: r(o, a)
      }));
    });
  });
}
function $o(t, e, r, n, a) {
  var o = t + e;
  r.isSilent(o) || (process.env.NODE_ENV !== "production" && yr("event " + o + " is deprecated."), n.eachComponent({
    mainType: "series",
    subType: "pie"
  }, function(i) {
    for (var l = i.seriesIndex, c = i.option.selectedMap, u = a.selected, d = 0; d < u.length; d++)
      if (u[d].seriesIndex === l) {
        var f = i.getData(), h = oo(f, a.fromActionPayload);
        r.trigger(o, {
          type: o,
          seriesId: i.id,
          name: z(h) ? f.getName(h[0]) : f.getName(h),
          selected: Q(c) ? c : H({}, c)
        });
      }
  }));
}
function O5e(t, e, r) {
  t.on("selectchanged", function(n) {
    var a = r.getModel();
    n.isFromClick ? ($o("map", "selectchanged", e, a, n), $o("pie", "selectchanged", e, a, n)) : n.fromAction === "select" ? ($o("map", "selected", e, a, n), $o("pie", "selected", e, a, n)) : n.fromAction === "unselect" && ($o("map", "unselected", e, a, n), $o("pie", "unselected", e, a, n));
  });
}
function Ll(t, e, r) {
  for (var n; t && !(e(t) && (n = t, r)); )
    t = t.__hostTarget || t.parent;
  return n;
}
var I5e = Math.round(Math.random() * 9), P5e = typeof Object.defineProperty == "function", D5e = function() {
  function t() {
    this._id = "__ec_inner_" + I5e++;
  }
  return t.prototype.get = function(e) {
    return this._guard(e)[this._id];
  }, t.prototype.set = function(e, r) {
    var n = this._guard(e);
    return P5e ? Object.defineProperty(n, this._id, {
      value: r,
      enumerable: !1,
      configurable: !0
    }) : n[this._id] = r, this;
  }, t.prototype.delete = function(e) {
    return this.has(e) ? (delete this._guard(e)[this._id], !0) : !1;
  }, t.prototype.has = function(e) {
    return !!this._guard(e)[this._id];
  }, t.prototype._guard = function(e) {
    if (e !== Object(e))
      throw TypeError("Value of WeakMap is not a non-null object.");
    return e;
  }, t;
}(), N5e = Ie.extend({
  type: "triangle",
  shape: {
    cx: 0,
    cy: 0,
    width: 0,
    height: 0
  },
  buildPath: function(t, e) {
    var r = e.cx, n = e.cy, a = e.width / 2, o = e.height / 2;
    t.moveTo(r, n - o), t.lineTo(r + a, n + o), t.lineTo(r - a, n + o), t.closePath();
  }
}), B5e = Ie.extend({
  type: "diamond",
  shape: {
    cx: 0,
    cy: 0,
    width: 0,
    height: 0
  },
  buildPath: function(t, e) {
    var r = e.cx, n = e.cy, a = e.width / 2, o = e.height / 2;
    t.moveTo(r, n - o), t.lineTo(r + a, n), t.lineTo(r, n + o), t.lineTo(r - a, n), t.closePath();
  }
}), F5e = Ie.extend({
  type: "pin",
  shape: {
    // x, y on the cusp
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  buildPath: function(t, e) {
    var r = e.x, n = e.y, a = e.width / 5 * 3, o = Math.max(a, e.height), i = a / 2, l = i * i / (o - i), c = n - o + i + l, u = Math.asin(l / i), d = Math.cos(u) * i, f = Math.sin(u), h = Math.cos(u), v = i * 0.6, p = i * 0.7;
    t.moveTo(r - d, c + l), t.arc(r, c, i, Math.PI - u, Math.PI * 2 + u), t.bezierCurveTo(r + d - f * v, c + l + h * v, r, n - p, r, n), t.bezierCurveTo(r, n - p, r - d + f * v, c + l + h * v, r - d, c + l), t.closePath();
  }
}), $5e = Ie.extend({
  type: "arrow",
  shape: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  buildPath: function(t, e) {
    var r = e.height, n = e.width, a = e.x, o = e.y, i = n / 3 * 2;
    t.moveTo(a, o), t.lineTo(a + i, o + r), t.lineTo(a, o + r / 4 * 3), t.lineTo(a - i, o + r), t.lineTo(a, o), t.closePath();
  }
}), V5e = {
  line: br,
  rect: He,
  roundRect: He,
  square: He,
  circle: Bs,
  diamond: B5e,
  pin: F5e,
  arrow: $5e,
  triangle: N5e
}, Z5e = {
  line: function(t, e, r, n, a) {
    a.x1 = t, a.y1 = e + n / 2, a.x2 = t + r, a.y2 = e + n / 2;
  },
  rect: function(t, e, r, n, a) {
    a.x = t, a.y = e, a.width = r, a.height = n;
  },
  roundRect: function(t, e, r, n, a) {
    a.x = t, a.y = e, a.width = r, a.height = n, a.r = Math.min(r, n) / 4;
  },
  square: function(t, e, r, n, a) {
    var o = Math.min(r, n);
    a.x = t, a.y = e, a.width = o, a.height = o;
  },
  circle: function(t, e, r, n, a) {
    a.cx = t + r / 2, a.cy = e + n / 2, a.r = Math.min(r, n) / 2;
  },
  diamond: function(t, e, r, n, a) {
    a.cx = t + r / 2, a.cy = e + n / 2, a.width = r, a.height = n;
  },
  pin: function(t, e, r, n, a) {
    a.x = t + r / 2, a.y = e + n / 2, a.width = r, a.height = n;
  },
  arrow: function(t, e, r, n, a) {
    a.x = t + r / 2, a.y = e + n / 2, a.width = r, a.height = n;
  },
  triangle: function(t, e, r, n, a) {
    a.cx = t + r / 2, a.cy = e + n / 2, a.width = r, a.height = n;
  }
}, fu = {};
I(V5e, function(t, e) {
  fu[e] = new t();
});
var H5e = Ie.extend({
  type: "symbol",
  shape: {
    symbolType: "",
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  calculateTextPosition: function(t, e, r) {
    var n = q0(t, e, r), a = this.shape;
    return a && a.symbolType === "pin" && e.position === "inside" && (n.y = r.y + r.height * 0.4), n;
  },
  buildPath: function(t, e, r) {
    var n = e.symbolType;
    if (n !== "none") {
      var a = fu[n];
      a || (n = "rect", a = fu[n]), Z5e[n](e.x, e.y, e.width, e.height, a.shape), a.buildPath(t, a.shape, r);
    }
  }
});
function j5e(t, e) {
  if (this.type !== "image") {
    var r = this.style;
    this.__isEmptyBrush ? (r.stroke = t, r.fill = e || "#fff", r.lineWidth = 2) : this.shape.symbolType === "line" ? r.stroke = t : r.fill = t, this.markRedraw();
  }
}
function _r(t, e, r, n, a, o, i) {
  var l = t.indexOf("empty") === 0;
  l && (t = t.substr(5, 1).toLowerCase() + t.substr(6));
  var c;
  return t.indexOf("image://") === 0 ? c = c7(t.slice(8), new Le(e, r, n, a), i ? "center" : "cover") : t.indexOf("path://") === 0 ? c = I1(t.slice(7), {}, new Le(e, r, n, a), i ? "center" : "cover") : c = new H5e({
    shape: {
      symbolType: t,
      x: e,
      y: r,
      width: n,
      height: a
    }
  }), c.__isEmptyBrush = l, c.setColor = j5e, o && c.setColor(o), c;
}
function T7(t) {
  return z(t) || (t = [+t, +t]), [t[0] || 0, t[1] || 0];
}
function U1(t, e) {
  if (t != null)
    return z(t) || (t = [t, t]), [fe(t[0], e[0]) || 0, fe(de(t[1], t[0]), e[1]) || 0];
}
function Ga(t) {
  return isFinite(t);
}
function W5e(t, e, r) {
  var n = e.x == null ? 0 : e.x, a = e.x2 == null ? 1 : e.x2, o = e.y == null ? 0 : e.y, i = e.y2 == null ? 0 : e.y2;
  e.global || (n = n * r.width + r.x, a = a * r.width + r.x, o = o * r.height + r.y, i = i * r.height + r.y), n = Ga(n) ? n : 0, a = Ga(a) ? a : 1, o = Ga(o) ? o : 0, i = Ga(i) ? i : 0;
  var l = t.createLinearGradient(n, o, a, i);
  return l;
}
function z5e(t, e, r) {
  var n = r.width, a = r.height, o = Math.min(n, a), i = e.x == null ? 0.5 : e.x, l = e.y == null ? 0.5 : e.y, c = e.r == null ? 0.5 : e.r;
  e.global || (i = i * n + r.x, l = l * a + r.y, c = c * o), i = Ga(i) ? i : 0.5, l = Ga(l) ? l : 0.5, c = c >= 0 && Ga(c) ? c : 0.5;
  var u = t.createRadialGradient(i, l, 0, i, l, c);
  return u;
}
function Qh(t, e, r) {
  for (var n = e.type === "radial" ? z5e(t, e, r) : W5e(t, e, r), a = e.colorStops, o = 0; o < a.length; o++)
    n.addColorStop(a[o].offset, a[o].color);
  return n;
}
function G5e(t, e) {
  if (t === e || !t && !e)
    return !1;
  if (!t || !e || t.length !== e.length)
    return !0;
  for (var r = 0; r < t.length; r++)
    if (t[r] !== e[r])
      return !0;
  return !1;
}
function Lc(t) {
  return parseInt(t, 10);
}
function Tc(t, e, r) {
  var n = ["width", "height"][e], a = ["clientWidth", "clientHeight"][e], o = ["paddingLeft", "paddingTop"][e], i = ["paddingRight", "paddingBottom"][e];
  if (r[n] != null && r[n] !== "auto")
    return parseFloat(r[n]);
  var l = document.defaultView.getComputedStyle(t);
  return (t[a] || Lc(l[n]) || Lc(t.style[n])) - (Lc(l[o]) || 0) - (Lc(l[i]) || 0) | 0;
}
function U5e(t, e) {
  return !t || t === "solid" || !(e > 0) ? null : t === "dashed" ? [4 * e, 2 * e] : t === "dotted" ? [e] : De(t) ? [t] : z(t) ? t : null;
}
function q_(t) {
  var e = t.style, r = e.lineDash && e.lineWidth > 0 && U5e(e.lineDash, e.lineWidth), n = e.lineDashOffset;
  if (r) {
    var a = e.strokeNoScale && t.getLineScale ? t.getLineScale() : 1;
    a && a !== 1 && (r = J(r, function(o) {
      return o / a;
    }), n /= a);
  }
  return [r, n];
}
var Y5e = new io(!0);
function hu(t) {
  var e = t.stroke;
  return !(e == null || e === "none" || !(t.lineWidth > 0));
}
function f3(t) {
  return typeof t == "string" && t !== "none";
}
function vu(t) {
  var e = t.fill;
  return e != null && e !== "none";
}
function h3(t, e) {
  if (e.fillOpacity != null && e.fillOpacity !== 1) {
    var r = t.globalAlpha;
    t.globalAlpha = e.fillOpacity * e.opacity, t.fill(), t.globalAlpha = r;
  } else
    t.fill();
}
function v3(t, e) {
  if (e.strokeOpacity != null && e.strokeOpacity !== 1) {
    var r = t.globalAlpha;
    t.globalAlpha = e.strokeOpacity * e.opacity, t.stroke(), t.globalAlpha = r;
  } else
    t.stroke();
}
function Jh(t, e, r) {
  var n = y9(e.image, e.__image, r);
  if (R1(n)) {
    var a = t.createPattern(n, e.repeat || "repeat");
    if (typeof DOMMatrix == "function" && a && a.setTransform) {
      var o = new DOMMatrix();
      o.translateSelf(e.x || 0, e.y || 0), o.rotateSelf(0, 0, (e.rotation || 0) * $b), o.scaleSelf(e.scaleX || 1, e.scaleY || 1), a.setTransform(o);
    }
    return a;
  }
}
function X5e(t, e, r, n) {
  var a, o = hu(r), i = vu(r), l = r.strokePercent, c = l < 1, u = !e.path;
  (!e.silent || c) && u && e.createPathProxy();
  var d = e.path || Y5e, f = e.__dirty;
  if (!n) {
    var h = r.fill, v = r.stroke, p = i && !!h.colorStops, g = o && !!v.colorStops, m = i && !!h.image, w = o && !!v.image, y = void 0, b = void 0, _ = void 0, x = void 0, E = void 0;
    (p || g) && (E = e.getBoundingRect()), p && (y = f ? Qh(t, h, E) : e.__canvasFillGradient, e.__canvasFillGradient = y), g && (b = f ? Qh(t, v, E) : e.__canvasStrokeGradient, e.__canvasStrokeGradient = b), m && (_ = f || !e.__canvasFillPattern ? Jh(t, h, e) : e.__canvasFillPattern, e.__canvasFillPattern = _), w && (x = f || !e.__canvasStrokePattern ? Jh(t, v, e) : e.__canvasStrokePattern, e.__canvasStrokePattern = _), p ? t.fillStyle = y : m && (_ ? t.fillStyle = _ : i = !1), g ? t.strokeStyle = b : w && (x ? t.strokeStyle = x : o = !1);
  }
  var S = e.getGlobalScale();
  d.setScale(S[0], S[1], e.segmentIgnoreThreshold);
  var M, R;
  t.setLineDash && r.lineDash && (a = q_(e), M = a[0], R = a[1]);
  var A = !0;
  (u || f & Xo) && (d.setDPR(t.dpr), c ? d.setContext(null) : (d.setContext(t), A = !1), d.reset(), e.buildPath(d, e.shape, n), d.toStatic(), e.pathUpdated()), A && d.rebuildPath(t, c ? l : 1), M && (t.setLineDash(M), t.lineDashOffset = R), n || (r.strokeFirst ? (o && v3(t, r), i && h3(t, r)) : (i && h3(t, r), o && v3(t, r))), M && t.setLineDash([]);
}
function q5e(t, e, r) {
  var n = e.__image = y9(r.image, e.__image, e, e.onload);
  if (!(!n || !R1(n))) {
    var a = r.x || 0, o = r.y || 0, i = e.getWidth(), l = e.getHeight(), c = n.width / n.height;
    if (i == null && l != null ? i = l * c : l == null && i != null ? l = i / c : i == null && l == null && (i = n.width, l = n.height), r.sWidth && r.sHeight) {
      var u = r.sx || 0, d = r.sy || 0;
      t.drawImage(n, u, d, r.sWidth, r.sHeight, a, o, i, l);
    } else if (r.sx && r.sy) {
      var u = r.sx, d = r.sy, f = i - u, h = l - d;
      t.drawImage(n, u, d, f, h, a, o, i, l);
    } else
      t.drawImage(n, a, o, i, l);
  }
}
function K5e(t, e, r) {
  var n, a = r.text;
  if (a != null && (a += ""), a) {
    t.font = r.font || ro, t.textAlign = r.textAlign, t.textBaseline = r.textBaseline;
    var o = void 0, i = void 0;
    t.setLineDash && r.lineDash && (n = q_(e), o = n[0], i = n[1]), o && (t.setLineDash(o), t.lineDashOffset = i), r.strokeFirst ? (hu(r) && t.strokeText(a, r.x, r.y), vu(r) && t.fillText(a, r.x, r.y)) : (vu(r) && t.fillText(a, r.x, r.y), hu(r) && t.strokeText(a, r.x, r.y)), o && t.setLineDash([]);
  }
}
var p3 = ["shadowBlur", "shadowOffsetX", "shadowOffsetY"], g3 = [
  ["lineCap", "butt"],
  ["lineJoin", "miter"],
  ["miterLimit", 10]
];
function K_(t, e, r, n, a) {
  var o = !1;
  if (!n && (r = r || {}, e === r))
    return !1;
  if (n || e.opacity !== r.opacity) {
    Zt(t, a), o = !0;
    var i = Math.max(Math.min(e.opacity, 1), 0);
    t.globalAlpha = isNaN(i) ? qa.opacity : i;
  }
  (n || e.blend !== r.blend) && (o || (Zt(t, a), o = !0), t.globalCompositeOperation = e.blend || qa.blend);
  for (var l = 0; l < p3.length; l++) {
    var c = p3[l];
    (n || e[c] !== r[c]) && (o || (Zt(t, a), o = !0), t[c] = t.dpr * (e[c] || 0));
  }
  return (n || e.shadowColor !== r.shadowColor) && (o || (Zt(t, a), o = !0), t.shadowColor = e.shadowColor || qa.shadowColor), o;
}
function m3(t, e, r, n, a) {
  var o = ds(e, a.inHover), i = n ? null : r && ds(r, a.inHover) || {};
  if (o === i)
    return !1;
  var l = K_(t, o, i, n, a);
  if ((n || o.fill !== i.fill) && (l || (Zt(t, a), l = !0), f3(o.fill) && (t.fillStyle = o.fill)), (n || o.stroke !== i.stroke) && (l || (Zt(t, a), l = !0), f3(o.stroke) && (t.strokeStyle = o.stroke)), (n || o.opacity !== i.opacity) && (l || (Zt(t, a), l = !0), t.globalAlpha = o.opacity == null ? 1 : o.opacity), e.hasStroke()) {
    var c = o.lineWidth, u = c / (o.strokeNoScale && e.getLineScale ? e.getLineScale() : 1);
    t.lineWidth !== u && (l || (Zt(t, a), l = !0), t.lineWidth = u);
  }
  for (var d = 0; d < g3.length; d++) {
    var f = g3[d], h = f[0];
    (n || o[h] !== i[h]) && (l || (Zt(t, a), l = !0), t[h] = o[h] || f[1]);
  }
  return l;
}
function Q5e(t, e, r, n, a) {
  return K_(t, ds(e, a.inHover), r && ds(r, a.inHover), n, a);
}
function Q_(t, e) {
  var r = e.transform, n = t.dpr || 1;
  r ? t.setTransform(n * r[0], n * r[1], n * r[2], n * r[3], n * r[4], n * r[5]) : t.setTransform(n, 0, 0, n, 0, 0);
}
function J5e(t, e, r) {
  for (var n = !1, a = 0; a < t.length; a++) {
    var o = t[a];
    n = n || o.isZeroArea(), Q_(e, o), e.beginPath(), o.buildPath(e, o.shape), e.clip();
  }
  r.allClipped = n;
}
function ede(t, e) {
  return t && e ? t[0] !== e[0] || t[1] !== e[1] || t[2] !== e[2] || t[3] !== e[3] || t[4] !== e[4] || t[5] !== e[5] : !(!t && !e);
}
var w3 = 1, y3 = 2, b3 = 3, _3 = 4;
function tde(t) {
  var e = vu(t), r = hu(t);
  return !(t.lineDash || !(+e ^ +r) || e && typeof t.fill != "string" || r && typeof t.stroke != "string" || t.strokePercent < 1 || t.strokeOpacity < 1 || t.fillOpacity < 1);
}
function Zt(t, e) {
  e.batchFill && t.fill(), e.batchStroke && t.stroke(), e.batchFill = "", e.batchStroke = "";
}
function ds(t, e) {
  return e && t.__hoverStyle || t.style;
}
function O7(t, e) {
  Ua(t, e, { inHover: !1, viewWidth: 0, viewHeight: 0 }, !0);
}
function Ua(t, e, r, n) {
  var a = e.transform;
  if (!e.shouldBePainted(r.viewWidth, r.viewHeight, !1, !1)) {
    e.__dirty &= ~qt, e.__isRendered = !1;
    return;
  }
  var o = e.__clipPaths, i = r.prevElClipPaths, l = !1, c = !1;
  if ((!i || G5e(o, i)) && (i && i.length && (Zt(t, r), t.restore(), c = l = !0, r.prevElClipPaths = null, r.allClipped = !1, r.prevEl = null), o && o.length && (Zt(t, r), t.save(), J5e(o, t, r), l = !0), r.prevElClipPaths = o), r.allClipped) {
    e.__isRendered = !1;
    return;
  }
  e.beforeBrush && e.beforeBrush(), e.innerBeforeBrush();
  var u = r.prevEl;
  u || (c = l = !0);
  var d = e instanceof Ie && e.autoBatch && tde(e.style);
  l || ede(a, u.transform) ? (Zt(t, r), Q_(t, e)) : d || Zt(t, r);
  var f = ds(e, r.inHover);
  e instanceof Ie ? (r.lastDrawType !== w3 && (c = !0, r.lastDrawType = w3), m3(t, e, u, c, r), (!d || !r.batchFill && !r.batchStroke) && t.beginPath(), X5e(t, e, f, d), d && (r.batchFill = f.fill || "", r.batchStroke = f.stroke || "")) : e instanceof eu ? (r.lastDrawType !== b3 && (c = !0, r.lastDrawType = b3), m3(t, e, u, c, r), K5e(t, e, f)) : e instanceof nn ? (r.lastDrawType !== y3 && (c = !0, r.lastDrawType = y3), Q5e(t, e, u, c, r), q5e(t, e, f)) : e.getTemporalDisplayables && (r.lastDrawType !== _3 && (c = !0, r.lastDrawType = _3), rde(t, e, r)), d && n && Zt(t, r), e.innerAfterBrush(), e.afterBrush && e.afterBrush(), r.prevEl = e, e.__dirty = 0, e.__isRendered = !0;
}
function rde(t, e, r) {
  var n = e.getDisplayables(), a = e.getTemporalDisplayables();
  t.save();
  var o = {
    prevElClipPaths: null,
    prevEl: null,
    allClipped: !1,
    viewWidth: r.viewWidth,
    viewHeight: r.viewHeight,
    inHover: r.inHover
  }, i, l;
  for (i = e.getCursor(), l = n.length; i < l; i++) {
    var c = n[i];
    c.beforeBrush && c.beforeBrush(), c.innerBeforeBrush(), Ua(t, c, o, i === l - 1), c.innerAfterBrush(), c.afterBrush && c.afterBrush(), o.prevEl = c;
  }
  for (var u = 0, d = a.length; u < d; u++) {
    var c = a[u];
    c.beforeBrush && c.beforeBrush(), c.innerBeforeBrush(), Ua(t, c, o, u === d - 1), c.innerAfterBrush(), c.afterBrush && c.afterBrush(), o.prevEl = c;
  }
  e.clearTemporalDisplayables(), e.notClear = !0, t.restore();
}
var Dd = new D5e(), x3 = new Os(100), C3 = ["symbol", "symbolSize", "symbolKeepAspect", "color", "backgroundColor", "dashArrayX", "dashArrayY", "maxTileWidth", "maxTileHeight"];
function e2(t, e) {
  if (t === "none")
    return null;
  var r = e.getDevicePixelRatio(), n = e.getZr(), a = n.painter.type === "svg";
  t.dirty && Dd.delete(t);
  var o = Dd.get(t);
  if (o)
    return o;
  var i = Te(t, {
    symbol: "rect",
    symbolSize: 1,
    symbolKeepAspect: !0,
    color: "rgba(0, 0, 0, 0.2)",
    backgroundColor: null,
    dashArrayX: 5,
    dashArrayY: 5,
    rotation: 0,
    maxTileWidth: 512,
    maxTileHeight: 512
  });
  i.backgroundColor === "none" && (i.backgroundColor = null);
  var l = {
    repeat: "repeat"
  };
  return c(l), l.rotation = i.rotation, l.scaleX = l.scaleY = a ? 1 : 1 / r, Dd.set(t, l), t.dirty = !1, l;
  function c(u) {
    for (var d = [r], f = !0, h = 0; h < C3.length; ++h) {
      var v = i[C3[h]];
      if (v != null && !z(v) && !Q(v) && !De(v) && typeof v != "boolean") {
        f = !1;
        break;
      }
      d.push(v);
    }
    var p;
    if (f) {
      p = d.join(",") + (a ? "-svg" : "");
      var g = x3.get(p);
      g && (a ? u.svgElement = g : u.image = g);
    }
    var m = ex(i.dashArrayX), w = nde(i.dashArrayY), y = J_(i.symbol), b = ade(m), _ = tx(w), x = !a && xn.createCanvas(), E = a && {
      tag: "g",
      attrs: {},
      key: "dcl",
      children: []
    }, S = R(), M;
    x && (x.width = S.width * r, x.height = S.height * r, M = x.getContext("2d")), A(), f && x3.put(p, x || E), u.image = x, u.svgElement = E, u.svgWidth = S.width, u.svgHeight = S.height;
    function R() {
      for (var k = 1, L = 0, T = b.length; L < T; ++L)
        k = Dg(k, b[L]);
      for (var O = 1, L = 0, T = y.length; L < T; ++L)
        O = Dg(O, y[L].length);
      k *= O;
      var D = _ * b.length * y.length;
      if (process.env.NODE_ENV !== "production") {
        var P = function(F) {
          console.warn("Calculated decal size is greater than " + F + " due to decal option settings so " + F + " is used for the decal size. Please consider changing the decal option to make a smaller decal or set " + F + " to be larger to avoid incontinuity.");
        };
        k > i.maxTileWidth && P("maxTileWidth"), D > i.maxTileHeight && P("maxTileHeight");
      }
      return {
        width: Math.max(1, Math.min(k, i.maxTileWidth)),
        height: Math.max(1, Math.min(D, i.maxTileHeight))
      };
    }
    function A() {
      M && (M.clearRect(0, 0, x.width, x.height), i.backgroundColor && (M.fillStyle = i.backgroundColor, M.fillRect(0, 0, x.width, x.height)));
      for (var k = 0, L = 0; L < w.length; ++L)
        k += w[L];
      if (k <= 0)
        return;
      for (var T = -_, O = 0, D = 0, P = 0; T < S.height; ) {
        if (O % 2 === 0) {
          for (var F = D / 2 % y.length, B = 0, N = 0, $ = 0; B < S.width * 2; ) {
            for (var V = 0, L = 0; L < m[P].length; ++L)
              V += m[P][L];
            if (V <= 0)
              break;
            if (N % 2 === 0) {
              var W = (1 - i.symbolSize) * 0.5, ee = B + m[P][N] * W, ne = T + w[O] * W, we = m[P][N] * i.symbolSize, pe = w[O] * i.symbolSize, X = $ / 2 % y[F].length;
              me(ee, ne, we, pe, y[F][X]);
            }
            B += m[P][N], ++$, ++N, N === m[P].length && (N = 0);
          }
          ++P, P === m.length && (P = 0);
        }
        T += w[O], ++D, ++O, O === w.length && (O = 0);
      }
      function me(ve, ae, Y, q, We) {
        var Ne = a ? 1 : r, It = _r(We, ve * Ne, ae * Ne, Y * Ne, q * Ne, i.color, i.symbolKeepAspect);
        if (a) {
          var xt = n.painter.renderOneToVNode(It);
          xt && E.children.push(xt);
        } else
          O7(M, It);
      }
    }
  }
}
function J_(t) {
  if (!t || t.length === 0)
    return [["rect"]];
  if (Q(t))
    return [[t]];
  for (var e = !0, r = 0; r < t.length; ++r)
    if (!Q(t[r])) {
      e = !1;
      break;
    }
  if (e)
    return J_([t]);
  for (var n = [], r = 0; r < t.length; ++r)
    Q(t[r]) ? n.push([t[r]]) : n.push(t[r]);
  return n;
}
function ex(t) {
  if (!t || t.length === 0)
    return [[0, 0]];
  if (De(t)) {
    var e = Math.ceil(t);
    return [[e, e]];
  }
  for (var r = !0, n = 0; n < t.length; ++n)
    if (!De(t[n])) {
      r = !1;
      break;
    }
  if (r)
    return ex([t]);
  for (var a = [], n = 0; n < t.length; ++n)
    if (De(t[n])) {
      var e = Math.ceil(t[n]);
      a.push([e, e]);
    } else {
      var e = J(t[n], function(l) {
        return Math.ceil(l);
      });
      e.length % 2 === 1 ? a.push(e.concat(e)) : a.push(e);
    }
  return a;
}
function nde(t) {
  if (!t || typeof t == "object" && t.length === 0)
    return [0, 0];
  if (De(t)) {
    var e = Math.ceil(t);
    return [e, e];
  }
  var r = J(t, function(n) {
    return Math.ceil(n);
  });
  return t.length % 2 ? r.concat(r) : r;
}
function ade(t) {
  return J(t, function(e) {
    return tx(e);
  });
}
function tx(t) {
  for (var e = 0, r = 0; r < t.length; ++r)
    e += t[r];
  return t.length % 2 === 1 ? e * 2 : e;
}
function ode(t, e) {
  t.eachRawSeries(function(r) {
    if (!t.isSeriesFiltered(r)) {
      var n = r.getData();
      n.hasItemVisual() && n.each(function(i) {
        var l = n.getItemVisual(i, "decal");
        if (l) {
          var c = n.ensureUniqueItemVisual(i, "style");
          c.decal = e2(l, e);
        }
      });
      var a = n.getVisual("decal");
      if (a) {
        var o = n.getVisual("style");
        o.decal = e2(a, e);
      }
    }
  });
}
var Tr = new Vr(), pu = {};
function ide(t, e) {
  process.env.NODE_ENV !== "production" && pu[t] && bt("Already has an implementation of " + t + "."), pu[t] = e;
}
function rx(t) {
  return process.env.NODE_ENV !== "production" && (pu[t] || bt("Implementation of " + t + " doesn't exists.")), pu[t];
}
var lde = "5.5.1", sde = {
  zrender: "5.6.0"
}, cde = 1, ude = 800, dde = 900, fde = 1e3, hde = 2e3, vde = 5e3, nx = 1e3, pde = 1100, I7 = 2e3, ax = 3e3, gde = 4e3, Y1 = 4500, mde = 4600, wde = 5e3, yde = 6e3, ox = 7e3, ix = {
  PROCESSOR: {
    FILTER: fde,
    SERIES_FILTER: ude,
    STATISTIC: vde
  },
  VISUAL: {
    LAYOUT: nx,
    PROGRESSIVE_LAYOUT: pde,
    GLOBAL: I7,
    CHART: ax,
    POST_CHART_LAYOUT: mde,
    COMPONENT: gde,
    BRUSH: wde,
    CHART_ITEM: Y1,
    ARIA: yde,
    DECAL: ox
  }
}, ht = "__flagInMainProcess", Dt = "__pendingUpdate", Nd = "__needsUpdateStatus", E3 = /^[a-zA-Z0-9_]+$/, Bd = "__connectUpdateStatus", S3 = 0, bde = 1, _de = 2;
function lx(t) {
  return function() {
    for (var e = [], r = 0; r < arguments.length; r++)
      e[r] = arguments[r];
    if (this.isDisposed()) {
      Ut(this.id);
      return;
    }
    return cx(this, t, e);
  };
}
function sx(t) {
  return function() {
    for (var e = [], r = 0; r < arguments.length; r++)
      e[r] = arguments[r];
    return cx(this, t, e);
  };
}
function cx(t, e, r) {
  return r[0] = r[0] && r[0].toLowerCase(), Vr.prototype[e].apply(t, r);
}
var ux = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e;
  }(Vr)
), dx = ux.prototype;
dx.on = sx("on");
dx.off = sx("off");
var Vo, Fd, Oc, In, $d, Vd, Zd, dl, fl, R3, M3, Hd, A3, Ic, k3, fx, nr, L3, gu = (
  /** @class */
  function(t) {
    K(e, t);
    function e(r, n, a) {
      var o = t.call(this, new M5e()) || this;
      o._chartsViews = [], o._chartsMap = {}, o._componentsViews = [], o._componentsMap = {}, o._pendingActions = [], a = a || {}, Q(n) && (n = hx[n]), o._dom = r;
      var i = "canvas", l = "auto", c = !1;
      if (process.env.NODE_ENV !== "production") {
        var u = (
          /* eslint-disable-next-line */
          ue.hasGlobalWindow ? window : global
        );
        u && (i = de(u.__ECHARTS__DEFAULT__RENDERER__, i), l = de(u.__ECHARTS__DEFAULT__COARSE_POINTER, l), c = de(u.__ECHARTS__DEFAULT__USE_DIRTY_RECT__, c));
      }
      a.ssr && l9(function(v) {
        var p = Se(v), g = p.dataIndex;
        if (g != null) {
          var m = se();
          return m.set("series_index", p.seriesIndex), m.set("data_index", g), p.ssrType && m.set("ssr_type", p.ssrType), m;
        }
      });
      var d = o._zr = Oh(r, {
        renderer: a.renderer || i,
        devicePixelRatio: a.devicePixelRatio,
        width: a.width,
        height: a.height,
        ssr: a.ssr,
        useDirtyRect: de(a.useDirtyRect, c),
        useCoarsePointer: de(a.useCoarsePointer, l),
        pointerSize: a.pointerSize
      });
      o._ssr = a.ssr, o._throttledZrFlush = z1(le(d.flush, d), 17), n = be(n), n && E_(n, !0), o._theme = n, o._locale = Oue(a.locale || l_), o._coordSysMgr = new H1();
      var f = o._api = k3(o);
      function h(v, p) {
        return v.__prio - p.__prio;
      }
      return h0(wu, h), h0(t2, h), o._scheduler = new W_(o, f, t2, wu), o._messageCenter = new ux(), o._initEvents(), o.resize = le(o.resize, o), d.animation.on("frame", o._onframe, o), R3(d, o), M3(d, o), V0(o), o;
    }
    return e.prototype._onframe = function() {
      if (!this._disposed) {
        L3(this);
        var r = this._scheduler;
        if (this[Dt]) {
          var n = this[Dt].silent;
          this[ht] = !0;
          try {
            Vo(this), In.update.call(this, null, this[Dt].updateParams);
          } catch (c) {
            throw this[ht] = !1, this[Dt] = null, c;
          }
          this._zr.flush(), this[ht] = !1, this[Dt] = null, dl.call(this, n), fl.call(this, n);
        } else if (r.unfinished) {
          var a = cde, o = this._model, i = this._api;
          r.unfinished = !1;
          do {
            var l = +/* @__PURE__ */ new Date();
            r.performSeriesTasks(o), r.performDataProcessorTasks(o), Vd(this, o), r.performVisualTasks(o), Ic(this, this._model, i, "remain", {}), a -= +/* @__PURE__ */ new Date() - l;
          } while (a > 0 && r.unfinished);
          r.unfinished || this._zr.flush();
        }
      }
    }, e.prototype.getDom = function() {
      return this._dom;
    }, e.prototype.getId = function() {
      return this.id;
    }, e.prototype.getZr = function() {
      return this._zr;
    }, e.prototype.isSSR = function() {
      return this._ssr;
    }, e.prototype.setOption = function(r, n, a) {
      if (this[ht]) {
        process.env.NODE_ENV !== "production" && bt("`setOption` should not be called during main process.");
        return;
      }
      if (this._disposed) {
        Ut(this.id);
        return;
      }
      var o, i, l;
      if (re(n) && (a = n.lazyUpdate, o = n.silent, i = n.replaceMerge, l = n.transition, n = n.notMerge), this[ht] = !0, !this._model || n) {
        var c = new c1e(this._api), u = this._theme, d = this._model = new S7();
        d.scheduler = this._scheduler, d.ssr = this._ssr, d.init(null, null, null, u, this._locale, c);
      }
      this._model.setOption(r, {
        replaceMerge: i
      }, r2);
      var f = {
        seriesTransition: l,
        optionChanged: !0
      };
      if (a)
        this[Dt] = {
          silent: o,
          updateParams: f
        }, this[ht] = !1, this.getZr().wakeUp();
      else {
        try {
          Vo(this), In.update.call(this, null, f);
        } catch (h) {
          throw this[Dt] = null, this[ht] = !1, h;
        }
        this._ssr || this._zr.flush(), this[Dt] = null, this[ht] = !1, dl.call(this, o), fl.call(this, o);
      }
    }, e.prototype.setTheme = function() {
      yr("ECharts#setTheme() is DEPRECATED in ECharts 3.0");
    }, e.prototype.getModel = function() {
      return this._model;
    }, e.prototype.getOption = function() {
      return this._model && this._model.getOption();
    }, e.prototype.getWidth = function() {
      return this._zr.getWidth();
    }, e.prototype.getHeight = function() {
      return this._zr.getHeight();
    }, e.prototype.getDevicePixelRatio = function() {
      return this._zr.painter.dpr || ue.hasGlobalWindow && window.devicePixelRatio || 1;
    }, e.prototype.getRenderedCanvas = function(r) {
      return process.env.NODE_ENV !== "production" && tt("getRenderedCanvas", "renderToCanvas"), this.renderToCanvas(r);
    }, e.prototype.renderToCanvas = function(r) {
      r = r || {};
      var n = this._zr.painter;
      if (process.env.NODE_ENV !== "production" && n.type !== "canvas")
        throw new Error("renderToCanvas can only be used in the canvas renderer.");
      return n.getRenderedCanvas({
        backgroundColor: r.backgroundColor || this._model.get("backgroundColor"),
        pixelRatio: r.pixelRatio || this.getDevicePixelRatio()
      });
    }, e.prototype.renderToSVGString = function(r) {
      r = r || {};
      var n = this._zr.painter;
      if (process.env.NODE_ENV !== "production" && n.type !== "svg")
        throw new Error("renderToSVGString can only be used in the svg renderer.");
      return n.renderToString({
        useViewBox: r.useViewBox
      });
    }, e.prototype.getSvgDataURL = function() {
      if (ue.svgSupported) {
        var r = this._zr, n = r.storage.getDisplayList();
        return I(n, function(a) {
          a.stopAnimation(null, !0);
        }), r.painter.toDataURL();
      }
    }, e.prototype.getDataURL = function(r) {
      if (this._disposed) {
        Ut(this.id);
        return;
      }
      r = r || {};
      var n = r.excludeComponents, a = this._model, o = [], i = this;
      I(n, function(c) {
        a.eachComponent({
          mainType: c
        }, function(u) {
          var d = i._componentsMap[u.__viewId];
          d.group.ignore || (o.push(d), d.group.ignore = !0);
        });
      });
      var l = this._zr.painter.getType() === "svg" ? this.getSvgDataURL() : this.renderToCanvas(r).toDataURL("image/" + (r && r.type || "png"));
      return I(o, function(c) {
        c.group.ignore = !1;
      }), l;
    }, e.prototype.getConnectedDataURL = function(r) {
      if (this._disposed) {
        Ut(this.id);
        return;
      }
      var n = r.type === "svg", a = this.group, o = Math.min, i = Math.max, l = 1 / 0;
      if (yu[a]) {
        var c = l, u = l, d = -l, f = -l, h = [], v = r && r.pixelRatio || this.getDevicePixelRatio();
        I(Qa, function(b, _) {
          if (b.group === a) {
            var x = n ? b.getZr().painter.getSvgDom().innerHTML : b.renderToCanvas(be(r)), E = b.getDom().getBoundingClientRect();
            c = o(E.left, c), u = o(E.top, u), d = i(E.right, d), f = i(E.bottom, f), h.push({
              dom: x,
              left: E.left,
              top: E.top
            });
          }
        }), c *= v, u *= v, d *= v, f *= v;
        var p = d - c, g = f - u, m = xn.createCanvas(), w = Oh(m, {
          renderer: n ? "svg" : "canvas"
        });
        if (w.resize({
          width: p,
          height: g
        }), n) {
          var y = "";
          return I(h, function(b) {
            var _ = b.left - c, x = b.top - u;
            y += '<g transform="translate(' + _ + "," + x + ')">' + b.dom + "</g>";
          }), w.painter.getSvgRoot().innerHTML = y, r.connectedBackgroundColor && w.painter.setBackgroundColor(r.connectedBackgroundColor), w.refreshImmediately(), w.painter.toDataURL();
        } else
          return r.connectedBackgroundColor && w.add(new He({
            shape: {
              x: 0,
              y: 0,
              width: p,
              height: g
            },
            style: {
              fill: r.connectedBackgroundColor
            }
          })), I(h, function(b) {
            var _ = new nn({
              style: {
                x: b.left * v - c,
                y: b.top * v - u,
                image: b.dom
              }
            });
            w.add(_);
          }), w.refreshImmediately(), m.toDataURL("image/" + (r && r.type || "png"));
      } else
        return this.getDataURL(r);
    }, e.prototype.convertToPixel = function(r, n) {
      return $d(this, "convertToPixel", r, n);
    }, e.prototype.convertFromPixel = function(r, n) {
      return $d(this, "convertFromPixel", r, n);
    }, e.prototype.containPixel = function(r, n) {
      if (this._disposed) {
        Ut(this.id);
        return;
      }
      var a = this._model, o, i = ld(a, r);
      return I(i, function(l, c) {
        c.indexOf("Models") >= 0 && I(l, function(u) {
          var d = u.coordinateSystem;
          if (d && d.containPoint)
            o = o || !!d.containPoint(n);
          else if (c === "seriesModels") {
            var f = this._chartsMap[u.__viewId];
            f && f.containPoint ? o = o || f.containPoint(n, u) : process.env.NODE_ENV !== "production" && pt(c + ": " + (f ? "The found component do not support containPoint." : "No view mapping to the found component."));
          } else
            process.env.NODE_ENV !== "production" && pt(c + ": containPoint is not supported");
        }, this);
      }, this), !!o;
    }, e.prototype.getVisual = function(r, n) {
      var a = this._model, o = ld(a, r, {
        defaultMainType: "series"
      }), i = o.seriesModel;
      process.env.NODE_ENV !== "production" && (i || pt("There is no specified series model"));
      var l = i.getData(), c = o.hasOwnProperty("dataIndexInside") ? o.dataIndexInside : o.hasOwnProperty("dataIndex") ? l.indexOfRawIndex(o.dataIndex) : null;
      return c != null ? L5e(l, c, n) : X_(l, n);
    }, e.prototype.getViewOfComponentModel = function(r) {
      return this._componentsMap[r.__viewId];
    }, e.prototype.getViewOfSeriesModel = function(r) {
      return this._chartsMap[r.__viewId];
    }, e.prototype._initEvents = function() {
      var r = this;
      I(xde, function(n) {
        var a = function(o) {
          var i = r.getModel(), l = o.target, c, u = n === "globalout";
          if (u ? c = {} : l && Ll(l, function(p) {
            var g = Se(p);
            if (g && g.dataIndex != null) {
              var m = g.dataModel || i.getSeriesByIndex(g.seriesIndex);
              return c = m && m.getDataParams(g.dataIndex, g.dataType, l) || {}, !0;
            } else if (g.eventData)
              return c = H({}, g.eventData), !0;
          }, !0), c) {
            var d = c.componentType, f = c.componentIndex;
            (d === "markLine" || d === "markPoint" || d === "markArea") && (d = "series", f = c.seriesIndex);
            var h = d && f != null && i.getComponent(d, f), v = h && r[h.mainType === "series" ? "_chartsMap" : "_componentsMap"][h.__viewId];
            process.env.NODE_ENV !== "production" && !u && !(h && v) && pt("model or view can not be found by params"), c.event = o, c.type = n, r._$eventProcessor.eventInfo = {
              targetEl: l,
              packedEvent: c,
              model: h,
              view: v
            }, r.trigger(n, c);
          }
        };
        a.zrEventfulCallAtLast = !0, r._zr.on(n, a, r);
      }), I(Hl, function(n, a) {
        r._messageCenter.on(a, function(o) {
          this.trigger(a, o);
        }, r);
      }), I(["selectchanged"], function(n) {
        r._messageCenter.on(n, function(a) {
          this.trigger(n, a);
        }, r);
      }), O5e(this._messageCenter, this, this._api);
    }, e.prototype.isDisposed = function() {
      return this._disposed;
    }, e.prototype.clear = function() {
      if (this._disposed) {
        Ut(this.id);
        return;
      }
      this.setOption({
        series: []
      }, !0);
    }, e.prototype.dispose = function() {
      if (this._disposed) {
        Ut(this.id);
        return;
      }
      this._disposed = !0;
      var r = this.getDom();
      r && p9(this.getDom(), D7, "");
      var n = this, a = n._api, o = n._model;
      I(n._componentsViews, function(i) {
        i.dispose(o, a);
      }), I(n._chartsViews, function(i) {
        i.dispose(o, a);
      }), n._zr.dispose(), n._dom = n._model = n._chartsMap = n._componentsMap = n._chartsViews = n._componentsViews = n._scheduler = n._api = n._zr = n._throttledZrFlush = n._theme = n._coordSysMgr = n._messageCenter = null, delete Qa[n.id];
    }, e.prototype.resize = function(r) {
      if (this[ht]) {
        process.env.NODE_ENV !== "production" && bt("`resize` should not be called during main process.");
        return;
      }
      if (this._disposed) {
        Ut(this.id);
        return;
      }
      this._zr.resize(r);
      var n = this._model;
      if (this._loadingFX && this._loadingFX.resize(), !!n) {
        var a = n.resetOption("media"), o = r && r.silent;
        this[Dt] && (o == null && (o = this[Dt].silent), a = !0, this[Dt] = null), this[ht] = !0;
        try {
          a && Vo(this), In.update.call(this, {
            type: "resize",
            animation: H({
              // Disable animation
              duration: 0
            }, r && r.animation)
          });
        } catch (i) {
          throw this[ht] = !1, i;
        }
        this[ht] = !1, dl.call(this, o), fl.call(this, o);
      }
    }, e.prototype.showLoading = function(r, n) {
      if (this._disposed) {
        Ut(this.id);
        return;
      }
      if (re(r) && (n = r, r = ""), r = r || "default", this.hideLoading(), !n2[r]) {
        process.env.NODE_ENV !== "production" && pt("Loading effects " + r + " not exists.");
        return;
      }
      var a = n2[r](this._api, n), o = this._zr;
      this._loadingFX = a, o.add(a);
    }, e.prototype.hideLoading = function() {
      if (this._disposed) {
        Ut(this.id);
        return;
      }
      this._loadingFX && this._zr.remove(this._loadingFX), this._loadingFX = null;
    }, e.prototype.makeActionFromEvent = function(r) {
      var n = H({}, r);
      return n.type = Hl[r.type], n;
    }, e.prototype.dispatchAction = function(r, n) {
      if (this._disposed) {
        Ut(this.id);
        return;
      }
      if (re(n) || (n = {
        silent: !!n
      }), !!mu[r.type] && this._model) {
        if (this[ht]) {
          this._pendingActions.push(r);
          return;
        }
        var a = n.silent;
        Zd.call(this, r, a);
        var o = n.flush;
        o ? this._zr.flush() : o !== !1 && ue.browser.weChat && this._throttledZrFlush(), dl.call(this, a), fl.call(this, a);
      }
    }, e.prototype.updateLabelLayout = function() {
      Tr.trigger("series:layoutlabels", this._model, this._api, {
        // Not adding series labels.
        // TODO
        updatedSeries: []
      });
    }, e.prototype.appendData = function(r) {
      if (this._disposed) {
        Ut(this.id);
        return;
      }
      var n = r.seriesIndex, a = this.getModel(), o = a.getSeriesByIndex(n);
      process.env.NODE_ENV !== "production" && ge(r.data && o), o.appendData(r), this._scheduler.unfinished = !0, this.getZr().wakeUp();
    }, e.internalField = function() {
      Vo = function(f) {
        var h = f._scheduler;
        h.restorePipelines(f._model), h.prepareStageTasks(), Fd(f, !0), Fd(f, !1), h.plan();
      }, Fd = function(f, h) {
        for (var v = f._model, p = f._scheduler, g = h ? f._componentsViews : f._chartsViews, m = h ? f._componentsMap : f._chartsMap, w = f._zr, y = f._api, b = 0; b < g.length; b++)
          g[b].__alive = !1;
        h ? v.eachComponent(function(E, S) {
          E !== "series" && _(S);
        }) : v.eachSeries(_);
        function _(E) {
          var S = E.__requireNewView;
          E.__requireNewView = !1;
          var M = "_ec_" + E.id + "_" + E.type, R = !S && m[M];
          if (!R) {
            var A = Kr(E.type), k = h ? _t.getClass(A.main, A.sub) : (
              // FIXME:TS
              // (ChartView as ChartViewConstructor).getClass('series', classType.sub)
              // For backward compat, still support a chart type declared as only subType
              // like "liquidfill", but recommend "series.liquidfill"
              // But need a base class to make a type series.
              wt.getClass(A.sub)
            );
            process.env.NODE_ENV !== "production" && ge(k, A.sub + " does not exist."), R = new k(), R.init(v, y), m[M] = R, g.push(R), w.add(R.group);
          }
          E.__viewId = R.__id = M, R.__alive = !0, R.__model = E, R.group.__ecComponentInfo = {
            mainType: E.mainType,
            index: E.componentIndex
          }, !h && p.prepareView(R, E, v, y);
        }
        for (var b = 0; b < g.length; ) {
          var x = g[b];
          x.__alive ? b++ : (!h && x.renderTask.dispose(), w.remove(x.group), x.dispose(v, y), g.splice(b, 1), m[x.__id] === x && delete m[x.__id], x.__id = x.group.__ecComponentInfo = null);
        }
      }, Oc = function(f, h, v, p, g) {
        var m = f._model;
        if (m.setUpdatePayload(v), !p) {
          I([].concat(f._componentsViews).concat(f._chartsViews), x);
          return;
        }
        var w = {};
        w[p + "Id"] = v[p + "Id"], w[p + "Index"] = v[p + "Index"], w[p + "Name"] = v[p + "Name"];
        var y = {
          mainType: p,
          query: w
        };
        g && (y.subType = g);
        var b = v.excludeSeriesId, _;
        b != null && (_ = se(), I(kt(b), function(E) {
          var S = Jr(E, null);
          S != null && _.set(S, !0);
        })), m && m.eachComponent(y, function(E) {
          var S = _ && _.get(E.id) != null;
          if (!S)
            if (dm(v))
              if (E instanceof Tt)
                v.type === Ka && !v.notBlur && !E.get(["emphasis", "disabled"]) && M0e(E, v, f._api);
              else {
                var M = o7(E.mainType, E.componentIndex, v.name, f._api), R = M.focusSelf, A = M.dispatchers;
                v.type === Ka && R && !v.notBlur && $h(E.mainType, E.componentIndex, f._api), A && I(A, function(k) {
                  v.type === Ka ? rs(k) : ns(k);
                });
              }
            else Vh(v) && E instanceof Tt && (L0e(E, v, f._api), cm(E), nr(f));
        }, f), m && m.eachComponent(y, function(E) {
          var S = _ && _.get(E.id) != null;
          S || x(f[p === "series" ? "_chartsMap" : "_componentsMap"][E.__viewId]);
        }, f);
        function x(E) {
          E && E.__alive && E[h] && E[h](E.__model, m, f._api, v);
        }
      }, In = {
        prepareAndUpdate: function(f) {
          Vo(this), In.update.call(this, f, {
            // Needs to mark option changed if newOption is given.
            // It's from MagicType.
            // TODO If use a separate flag optionChanged in payload?
            optionChanged: f.newOption != null
          });
        },
        update: function(f, h) {
          var v = this._model, p = this._api, g = this._zr, m = this._coordSysMgr, w = this._scheduler;
          if (v) {
            v.setUpdatePayload(f), w.restoreData(v, f), w.performSeriesTasks(v), m.create(v, p), w.performDataProcessorTasks(v, f), Vd(this, v), m.update(v, p), r(v), w.performVisualTasks(v, f), Hd(this, v, p, f, h);
            var y = v.get("backgroundColor") || "transparent", b = v.get("darkMode");
            g.setBackgroundColor(y), b != null && b !== "auto" && g.setDarkMode(b), Tr.trigger("afterupdate", v, p);
          }
        },
        updateTransform: function(f) {
          var h = this, v = this._model, p = this._api;
          if (v) {
            v.setUpdatePayload(f);
            var g = [];
            v.eachComponent(function(w, y) {
              if (w !== "series") {
                var b = h.getViewOfComponentModel(y);
                if (b && b.__alive)
                  if (b.updateTransform) {
                    var _ = b.updateTransform(y, v, p, f);
                    _ && _.update && g.push(b);
                  } else
                    g.push(b);
              }
            });
            var m = se();
            v.eachSeries(function(w) {
              var y = h._chartsMap[w.__viewId];
              if (y.updateTransform) {
                var b = y.updateTransform(w, v, p, f);
                b && b.update && m.set(w.uid, 1);
              } else
                m.set(w.uid, 1);
            }), r(v), this._scheduler.performVisualTasks(v, f, {
              setDirty: !0,
              dirtyMap: m
            }), Ic(this, v, p, f, {}, m), Tr.trigger("afterupdate", v, p);
          }
        },
        updateView: function(f) {
          var h = this._model;
          h && (h.setUpdatePayload(f), wt.markUpdateMethod(f, "updateView"), r(h), this._scheduler.performVisualTasks(h, f, {
            setDirty: !0
          }), Hd(this, h, this._api, f, {}), Tr.trigger("afterupdate", h, this._api));
        },
        updateVisual: function(f) {
          var h = this, v = this._model;
          v && (v.setUpdatePayload(f), v.eachSeries(function(p) {
            p.getData().clearAllVisual();
          }), wt.markUpdateMethod(f, "updateVisual"), r(v), this._scheduler.performVisualTasks(v, f, {
            visualType: "visual",
            setDirty: !0
          }), v.eachComponent(function(p, g) {
            if (p !== "series") {
              var m = h.getViewOfComponentModel(g);
              m && m.__alive && m.updateVisual(g, v, h._api, f);
            }
          }), v.eachSeries(function(p) {
            var g = h._chartsMap[p.__viewId];
            g.updateVisual(p, v, h._api, f);
          }), Tr.trigger("afterupdate", v, this._api));
        },
        updateLayout: function(f) {
          In.update.call(this, f);
        }
      }, $d = function(f, h, v, p) {
        if (f._disposed) {
          Ut(f.id);
          return;
        }
        for (var g = f._model, m = f._coordSysMgr.getCoordinateSystems(), w, y = ld(g, v), b = 0; b < m.length; b++) {
          var _ = m[b];
          if (_[h] && (w = _[h](g, y, p)) != null)
            return w;
        }
        process.env.NODE_ENV !== "production" && pt("No coordinate system that supports " + h + " found by the given finder.");
      }, Vd = function(f, h) {
        var v = f._chartsMap, p = f._scheduler;
        h.eachSeries(function(g) {
          p.updateStreamModes(g, v[g.__viewId]);
        });
      }, Zd = function(f, h) {
        var v = this, p = this.getModel(), g = f.type, m = f.escapeConnect, w = mu[g], y = w.actionInfo, b = (y.update || "update").split(":"), _ = b.pop(), x = b[0] != null && Kr(b[0]);
        this[ht] = !0;
        var E = [f], S = !1;
        f.batch && (S = !0, E = J(f.batch, function(O) {
          return O = Te(H({}, O), f), O.batch = null, O;
        }));
        var M = [], R, A = Vh(f), k = dm(f);
        if (k && N9(this._api), I(E, function(O) {
          if (R = w.action(O, v._model, v._api), R = R || H({}, O), R.type = y.event || R.type, M.push(R), k) {
            var D = Qv(f), P = D.queryOptionMap, F = D.mainTypeSpecified, B = F ? P.keys()[0] : "series";
            Oc(v, _, O, B), nr(v);
          } else A ? (Oc(v, _, O, "series"), nr(v)) : x && Oc(v, _, O, x.main, x.sub);
        }), _ !== "none" && !k && !A && !x)
          try {
            this[Dt] ? (Vo(this), In.update.call(this, f), this[Dt] = null) : In[_].call(this, f);
          } catch (O) {
            throw this[ht] = !1, O;
          }
        if (S ? R = {
          type: y.event || g,
          escapeConnect: m,
          batch: M
        } : R = M[0], this[ht] = !1, !h) {
          var L = this._messageCenter;
          if (L.trigger(R.type, R), A) {
            var T = {
              type: "selectchanged",
              escapeConnect: m,
              selected: T0e(p),
              isFromClick: f.isFromClick || !1,
              fromAction: f.type,
              fromActionPayload: f
            };
            L.trigger(T.type, T);
          }
        }
      }, dl = function(f) {
        for (var h = this._pendingActions; h.length; ) {
          var v = h.shift();
          Zd.call(this, v, f);
        }
      }, fl = function(f) {
        !f && this.trigger("updated");
      }, R3 = function(f, h) {
        f.on("rendered", function(v) {
          h.trigger("rendered", v), // Although zr is dirty if initial animation is not finished
          // and this checking is called on frame, we also check
          // animation finished for robustness.
          f.animation.isFinished() && !h[Dt] && !h._scheduler.unfinished && !h._pendingActions.length && h.trigger("finished");
        });
      }, M3 = function(f, h) {
        f.on("mouseover", function(v) {
          var p = v.target, g = Ll(p, Si);
          g && (A0e(g, v, h._api), nr(h));
        }).on("mouseout", function(v) {
          var p = v.target, g = Ll(p, Si);
          g && (k0e(g, v, h._api), nr(h));
        }).on("click", function(v) {
          var p = v.target, g = Ll(p, function(y) {
            return Se(y).dataIndex != null;
          }, !0);
          if (g) {
            var m = g.selected ? "unselect" : "select", w = Se(g);
            h._api.dispatchAction({
              type: m,
              dataType: w.dataType,
              dataIndexInside: w.dataIndex,
              seriesIndex: w.seriesIndex,
              isFromClick: !0
            });
          }
        });
      };
      function r(f) {
        f.clearColorPalette(), f.eachSeries(function(h) {
          h.clearColorPalette();
        });
      }
      function n(f) {
        var h = [], v = [], p = !1;
        if (f.eachComponent(function(y, b) {
          var _ = b.get("zlevel") || 0, x = b.get("z") || 0, E = b.getZLevelKey();
          p = p || !!E, (y === "series" ? v : h).push({
            zlevel: _,
            z: x,
            idx: b.componentIndex,
            type: y,
            key: E
          });
        }), p) {
          var g = h.concat(v), m, w;
          h0(g, function(y, b) {
            return y.zlevel === b.zlevel ? y.z - b.z : y.zlevel - b.zlevel;
          }), I(g, function(y) {
            var b = f.getComponent(y.type, y.idx), _ = y.zlevel, x = y.key;
            m != null && (_ = Math.max(m, _)), x ? (_ === m && x !== w && _++, w = x) : w && (_ === m && _++, w = ""), m = _, b.setZLevel(_);
          });
        }
      }
      Hd = function(f, h, v, p, g) {
        n(h), A3(f, h, v, p, g), I(f._chartsViews, function(m) {
          m.__alive = !1;
        }), Ic(f, h, v, p, g), I(f._chartsViews, function(m) {
          m.__alive || m.remove(h, v);
        });
      }, A3 = function(f, h, v, p, g, m) {
        I(m || f._componentsViews, function(w) {
          var y = w.__model;
          u(y, w), w.render(y, h, v, p), l(y, w), d(y, w);
        });
      }, Ic = function(f, h, v, p, g, m) {
        var w = f._scheduler;
        g = H(g || {}, {
          updatedSeries: h.getSeries()
        }), Tr.trigger("series:beforeupdate", h, v, g);
        var y = !1;
        h.eachSeries(function(b) {
          var _ = f._chartsMap[b.__viewId];
          _.__alive = !0;
          var x = _.renderTask;
          w.updatePayload(x, p), u(b, _), m && m.get(b.uid) && x.dirty(), x.perform(w.getPerformArgs(x)) && (y = !0), _.group.silent = !!b.get("silent"), i(b, _), cm(b);
        }), w.unfinished = y || w.unfinished, Tr.trigger("series:layoutlabels", h, v, g), Tr.trigger("series:transition", h, v, g), h.eachSeries(function(b) {
          var _ = f._chartsMap[b.__viewId];
          l(b, _), d(b, _);
        }), o(f, h), Tr.trigger("series:afterupdate", h, v, g);
      }, nr = function(f) {
        f[Nd] = !0, f.getZr().wakeUp();
      }, L3 = function(f) {
        f[Nd] && (f.getZr().storage.traverse(function(h) {
          Fl(h) || a(h);
        }), f[Nd] = !1);
      };
      function a(f) {
        for (var h = [], v = f.currentStates, p = 0; p < v.length; p++) {
          var g = v[p];
          g === "emphasis" || g === "blur" || g === "select" || h.push(g);
        }
        f.selected && f.states.select && h.push("select"), f.hoverState === k1 && f.states.emphasis ? h.push("emphasis") : f.hoverState === A1 && f.states.blur && h.push("blur"), f.useStates(h);
      }
      function o(f, h) {
        var v = f._zr, p = v.storage, g = 0;
        p.traverse(function(m) {
          m.isGroup || g++;
        }), g > h.get("hoverLayerThreshold") && !ue.node && !ue.worker && h.eachSeries(function(m) {
          if (!m.preventUsingHoverLayer) {
            var w = f._chartsMap[m.__viewId];
            w.__alive && w.eachRendered(function(y) {
              y.states.emphasis && (y.states.emphasis.hoverLayer = !0);
            });
          }
        });
      }
      function i(f, h) {
        var v = f.get("blendMode") || null;
        h.eachRendered(function(p) {
          p.isGroup || (p.style.blend = v);
        });
      }
      function l(f, h) {
        if (!f.preventAutoZ) {
          var v = f.get("z") || 0, p = f.get("zlevel") || 0;
          h.eachRendered(function(g) {
            return c(g, v, p, -1 / 0), !0;
          });
        }
      }
      function c(f, h, v, p) {
        var g = f.getTextContent(), m = f.getTextGuideLine(), w = f.isGroup;
        if (w)
          for (var y = f.childrenRef(), b = 0; b < y.length; b++)
            p = Math.max(c(y[b], h, v, p), p);
        else
          f.z = h, f.zlevel = v, p = Math.max(f.z2, p);
        if (g && (g.z = h, g.zlevel = v, isFinite(p) && (g.z2 = p + 2)), m) {
          var _ = f.textGuideLineConfig;
          m.z = h, m.zlevel = v, isFinite(p) && (m.z2 = p + (_ && _.showAbove ? 1 : -1));
        }
        return p;
      }
      function u(f, h) {
        h.eachRendered(function(v) {
          if (!Fl(v)) {
            var p = v.getTextContent(), g = v.getTextGuideLine();
            v.stateTransition && (v.stateTransition = null), p && p.stateTransition && (p.stateTransition = null), g && g.stateTransition && (g.stateTransition = null), v.hasState() ? (v.prevStates = v.currentStates, v.clearStates()) : v.prevStates && (v.prevStates = null);
          }
        });
      }
      function d(f, h) {
        var v = f.getModel("stateAnimation"), p = f.isAnimationEnabled(), g = v.get("duration"), m = g > 0 ? {
          duration: g,
          delay: v.get("delay"),
          easing: v.get("easing")
          // additive: stateAnimationModel.get('additive')
        } : null;
        h.eachRendered(function(w) {
          if (w.states && w.states.emphasis) {
            if (Fl(w))
              return;
            if (w instanceof Ie && N0e(w), w.__dirty) {
              var y = w.prevStates;
              y && w.useStates(y);
            }
            if (p) {
              w.stateTransition = m;
              var b = w.getTextContent(), _ = w.getTextGuideLine();
              b && (b.stateTransition = m), _ && (_.stateTransition = m);
            }
            w.__dirty && a(w);
          }
        });
      }
      k3 = function(f) {
        return new /** @class */
        (function(h) {
          K(v, h);
          function v() {
            return h !== null && h.apply(this, arguments) || this;
          }
          return v.prototype.getCoordinateSystems = function() {
            return f._coordSysMgr.getCoordinateSystems();
          }, v.prototype.getComponentByElement = function(p) {
            for (; p; ) {
              var g = p.__ecComponentInfo;
              if (g != null)
                return f._model.getComponent(g.mainType, g.index);
              p = p.parent;
            }
          }, v.prototype.enterEmphasis = function(p, g) {
            rs(p, g), nr(f);
          }, v.prototype.leaveEmphasis = function(p, g) {
            ns(p, g), nr(f);
          }, v.prototype.enterBlur = function(p) {
            O9(p), nr(f);
          }, v.prototype.leaveBlur = function(p) {
            a7(p), nr(f);
          }, v.prototype.enterSelect = function(p) {
            I9(p), nr(f);
          }, v.prototype.leaveSelect = function(p) {
            P9(p), nr(f);
          }, v.prototype.getModel = function() {
            return f.getModel();
          }, v.prototype.getViewOfComponentModel = function(p) {
            return f.getViewOfComponentModel(p);
          }, v.prototype.getViewOfSeriesModel = function(p) {
            return f.getViewOfSeriesModel(p);
          }, v;
        }(x_))(f);
      }, fx = function(f) {
        function h(v, p) {
          for (var g = 0; g < v.length; g++) {
            var m = v[g];
            m[Bd] = p;
          }
        }
        I(Hl, function(v, p) {
          f._messageCenter.on(p, function(g) {
            if (yu[f.group] && f[Bd] !== S3) {
              if (g && g.escapeConnect)
                return;
              var m = f.makeActionFromEvent(g), w = [];
              I(Qa, function(y) {
                y !== f && y.group === f.group && w.push(y);
              }), h(w, S3), I(w, function(y) {
                y[Bd] !== bde && y.dispatchAction(m);
              }), h(w, _de);
            }
          });
        });
      };
    }(), e;
  }(Vr)
), P7 = gu.prototype;
P7.on = lx("on");
P7.off = lx("off");
P7.one = function(t, e, r) {
  var n = this;
  yr("ECharts#one is deprecated.");
  function a() {
    for (var o = [], i = 0; i < arguments.length; i++)
      o[i] = arguments[i];
    e && e.apply && e.apply(this, o), n.off(t, a);
  }
  this.on.call(this, t, a, r);
};
var xde = ["click", "dblclick", "mouseover", "mouseout", "mousemove", "mousedown", "mouseup", "globalout", "contextmenu"];
function Ut(t) {
  process.env.NODE_ENV !== "production" && pt("Instance " + t + " has been disposed");
}
var mu = {}, Hl = {}, t2 = [], r2 = [], wu = [], hx = {}, n2 = {}, Qa = {}, yu = {}, Cde = +/* @__PURE__ */ new Date() - 0, Ede = +/* @__PURE__ */ new Date() - 0, D7 = "_echarts_instance_";
function Sde(t, e, r) {
  var n = !(r && r.ssr);
  if (n) {
    if (process.env.NODE_ENV !== "production" && !t)
      throw new Error("Initialize failed: invalid dom.");
    var a = N7(t);
    if (a)
      return process.env.NODE_ENV !== "production" && pt("There is a chart instance already initialized on the dom."), a;
    process.env.NODE_ENV !== "production" && no(t) && t.nodeName.toUpperCase() !== "CANVAS" && (!t.clientWidth && (!r || r.width == null) || !t.clientHeight && (!r || r.height == null)) && pt("Can't get DOM width or height. Please check dom.clientWidth and dom.clientHeight. They should not be 0.For example, you may need to call this in the callback of window.onload.");
  }
  var o = new gu(t, e, r);
  return o.id = "ec_" + Cde++, Qa[o.id] = o, n && p9(t, D7, o.id), fx(o), Tr.trigger("afterinit", o), o;
}
function Rde(t) {
  if (z(t)) {
    var e = t;
    t = null, I(e, function(r) {
      r.group != null && (t = r.group);
    }), t = t || "g_" + Ede++, I(e, function(r) {
      r.group = t;
    });
  }
  return yu[t] = !0, t;
}
function vx(t) {
  yu[t] = !1;
}
var Mde = vx;
function Ade(t) {
  Q(t) ? t = Qa[t] : t instanceof gu || (t = N7(t)), t instanceof gu && !t.isDisposed() && t.dispose();
}
function N7(t) {
  return Qa[bce(t, D7)];
}
function kde(t) {
  return Qa[t];
}
function B7(t, e) {
  hx[t] = e;
}
function F7(t) {
  Re(r2, t) < 0 && r2.push(t);
}
function $7(t, e) {
  V7(t2, t, e, hde);
}
function px(t) {
  X1("afterinit", t);
}
function gx(t) {
  X1("afterupdate", t);
}
function X1(t, e) {
  Tr.on(t, e);
}
function ma(t, e, r) {
  ie(e) && (r = e, e = "");
  var n = re(t) ? t.type : [t, t = {
    event: e
  }][0];
  t.event = (t.event || n).toLowerCase(), e = t.event, !Hl[e] && (ge(E3.test(n) && E3.test(e)), mu[n] || (mu[n] = {
    action: r,
    actionInfo: t
  }), Hl[e] = n);
}
function mx(t, e) {
  H1.register(t, e);
}
function Lde(t) {
  var e = H1.get(t);
  if (e)
    return e.getDimensionsInfo ? e.getDimensionsInfo() : e.dimensions.slice();
}
function yx(t, e) {
  V7(wu, t, e, nx, "layout");
}
function wa(t, e) {
  V7(wu, t, e, ax, "visual");
}
var T3 = [];
function V7(t, e, r, n, a) {
  if ((ie(e) || re(e)) && (r = e, e = n), process.env.NODE_ENV !== "production") {
    if (isNaN(e) || e == null)
      throw new Error("Illegal priority");
    I(t, function(i) {
      ge(i.__raw !== r);
    });
  }
  if (!(Re(T3, r) >= 0)) {
    T3.push(r);
    var o = W_.wrapStageHandler(r, a);
    o.__prio = e, o.__raw = r, t.push(o);
  }
}
function Z7(t, e) {
  n2[t] = e;
}
function Tde(t) {
  process.env.NODE_ENV !== "production" && yr("setCanvasCreator is deprecated. Use setPlatformAPI({ createCanvas }) instead."), Lb({
    createCanvas: t
  });
}
function bx(t, e, r) {
  var n = rx("registerMap");
  n && n(t, e, r);
}
function Ode(t) {
  var e = rx("getMap");
  return e && e(t);
}
var _x = F1e;
wa(I7, h5e);
wa(Y1, v5e);
wa(Y1, p5e);
wa(I7, A5e);
wa(Y1, k5e);
wa(ox, ode);
F7(E_);
$7(dde, _1e);
Z7("default", g5e);
ma({
  type: Ka,
  event: Ka,
  update: Ka
}, mt);
ma({
  type: w0,
  event: w0,
  update: w0
}, mt);
ma({
  type: Dl,
  event: Dl,
  update: Dl
}, mt);
ma({
  type: y0,
  event: y0,
  update: y0
}, mt);
ma({
  type: Nl,
  event: Nl,
  update: Nl
}, mt);
B7("light", R5e);
B7("dark", Y_);
var Ide = {};
function hl(t) {
  return t == null ? 0 : t.length || 1;
}
function O3(t) {
  return t;
}
var Pde = (
  /** @class */
  function() {
    function t(e, r, n, a, o, i) {
      this._old = e, this._new = r, this._oldKeyGetter = n || O3, this._newKeyGetter = a || O3, this.context = o, this._diffModeMultiple = i === "multiple";
    }
    return t.prototype.add = function(e) {
      return this._add = e, this;
    }, t.prototype.update = function(e) {
      return this._update = e, this;
    }, t.prototype.updateManyToOne = function(e) {
      return this._updateManyToOne = e, this;
    }, t.prototype.updateOneToMany = function(e) {
      return this._updateOneToMany = e, this;
    }, t.prototype.updateManyToMany = function(e) {
      return this._updateManyToMany = e, this;
    }, t.prototype.remove = function(e) {
      return this._remove = e, this;
    }, t.prototype.execute = function() {
      this[this._diffModeMultiple ? "_executeMultiple" : "_executeOneToOne"]();
    }, t.prototype._executeOneToOne = function() {
      var e = this._old, r = this._new, n = {}, a = new Array(e.length), o = new Array(r.length);
      this._initIndexMap(e, null, a, "_oldKeyGetter"), this._initIndexMap(r, n, o, "_newKeyGetter");
      for (var i = 0; i < e.length; i++) {
        var l = a[i], c = n[l], u = hl(c);
        if (u > 1) {
          var d = c.shift();
          c.length === 1 && (n[l] = c[0]), this._update && this._update(d, i);
        } else u === 1 ? (n[l] = null, this._update && this._update(c, i)) : this._remove && this._remove(i);
      }
      this._performRestAdd(o, n);
    }, t.prototype._executeMultiple = function() {
      var e = this._old, r = this._new, n = {}, a = {}, o = [], i = [];
      this._initIndexMap(e, n, o, "_oldKeyGetter"), this._initIndexMap(r, a, i, "_newKeyGetter");
      for (var l = 0; l < o.length; l++) {
        var c = o[l], u = n[c], d = a[c], f = hl(u), h = hl(d);
        if (f > 1 && h === 1)
          this._updateManyToOne && this._updateManyToOne(d, u), a[c] = null;
        else if (f === 1 && h > 1)
          this._updateOneToMany && this._updateOneToMany(d, u), a[c] = null;
        else if (f === 1 && h === 1)
          this._update && this._update(d, u), a[c] = null;
        else if (f > 1 && h > 1)
          this._updateManyToMany && this._updateManyToMany(d, u), a[c] = null;
        else if (f > 1)
          for (var v = 0; v < f; v++)
            this._remove && this._remove(u[v]);
        else
          this._remove && this._remove(u);
      }
      this._performRestAdd(i, a);
    }, t.prototype._performRestAdd = function(e, r) {
      for (var n = 0; n < e.length; n++) {
        var a = e[n], o = r[a], i = hl(o);
        if (i > 1)
          for (var l = 0; l < i; l++)
            this._add && this._add(o[l]);
        else i === 1 && this._add && this._add(o);
        r[a] = null;
      }
    }, t.prototype._initIndexMap = function(e, r, n, a) {
      for (var o = this._diffModeMultiple, i = 0; i < e.length; i++) {
        var l = "_ec_" + this[a](e[i], i);
        if (o || (n[i] = l), !!r) {
          var c = r[l], u = hl(c);
          u === 0 ? (r[l] = i, o && n.push(l)) : u === 1 ? r[l] = [c, i] : c.push(i);
        }
      }
    }, t;
  }()
), Dde = (
  /** @class */
  function() {
    function t(e, r) {
      this._encode = e, this._schema = r;
    }
    return t.prototype.get = function() {
      return {
        // Do not generate full dimension name until fist used.
        fullDimensions: this._getFullDimensionNames(),
        encode: this._encode
      };
    }, t.prototype._getFullDimensionNames = function() {
      return this._cachedDimNames || (this._cachedDimNames = this._schema ? this._schema.makeOutputDimensionNames() : []), this._cachedDimNames;
    }, t;
  }()
);
function Nde(t, e) {
  var r = {}, n = r.encode = {}, a = se(), o = [], i = [], l = {};
  I(t.dimensions, function(h) {
    var v = t.getDimensionInfo(h), p = v.coordDim;
    if (p) {
      process.env.NODE_ENV !== "production" && ge(zh.get(p) == null);
      var g = v.coordDimIndex;
      jd(n, p)[g] = h, v.isExtraCoord || (a.set(p, 1), Fde(v.type) && (o[0] = h), jd(l, p)[g] = t.getDimensionIndex(v.name)), v.defaultTooltip && i.push(h);
    }
    zh.each(function(m, w) {
      var y = jd(n, w), b = v.otherDims[w];
      b != null && b !== !1 && (y[b] = v.name);
    });
  });
  var c = [], u = {};
  a.each(function(h, v) {
    var p = n[v];
    u[v] = p[0], c = c.concat(p);
  }), r.dataDimsOnCoord = c, r.dataDimIndicesOnCoord = J(c, function(h) {
    return t.getDimensionInfo(h).storeDimIndex;
  }), r.encodeFirstDimNotExtra = u;
  var d = n.label;
  d && d.length && (o = d.slice());
  var f = n.tooltip;
  return f && f.length ? i = f.slice() : i.length || (i = o.slice()), n.defaultedLabel = o, n.defaultedTooltip = i, r.userOutput = new Dde(l, e), r;
}
function jd(t, e) {
  return t.hasOwnProperty(e) || (t[e] = []), t[e];
}
function Bde(t) {
  return t === "category" ? "ordinal" : t === "time" ? "time" : "float";
}
function Fde(t) {
  return !(t === "ordinal" || t === "time");
}
var x0 = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e) {
      this.otherDims = {}, e != null && H(this, e);
    }
    return t;
  }()
), $de = je(), Vde = {
  float: "f",
  int: "i",
  ordinal: "o",
  number: "n",
  time: "t"
}, xx = (
  /** @class */
  function() {
    function t(e) {
      this.dimensions = e.dimensions, this._dimOmitted = e.dimensionOmitted, this.source = e.source, this._fullDimCount = e.fullDimensionCount, this._updateDimOmitted(e.dimensionOmitted);
    }
    return t.prototype.isDimensionOmitted = function() {
      return this._dimOmitted;
    }, t.prototype._updateDimOmitted = function(e) {
      this._dimOmitted = e, e && (this._dimNameMap || (this._dimNameMap = Sx(this.source)));
    }, t.prototype.getSourceDimensionIndex = function(e) {
      return de(this._dimNameMap.get(e), -1);
    }, t.prototype.getSourceDimension = function(e) {
      var r = this.source.dimensionsDefine;
      if (r)
        return r[e];
    }, t.prototype.makeStoreSchema = function() {
      for (var e = this._fullDimCount, r = M_(this.source), n = !Rx(e), a = "", o = [], i = 0, l = 0; i < e; i++) {
        var c = void 0, u = void 0, d = void 0, f = this.dimensions[l];
        if (f && f.storeDimIndex === i)
          c = r ? f.name : null, u = f.type, d = f.ordinalMeta, l++;
        else {
          var h = this.getSourceDimension(i);
          h && (c = r ? h.name : null, u = h.type);
        }
        o.push({
          property: c,
          type: u,
          ordinalMeta: d
        }), r && c != null && (!f || !f.isCalculationCoord) && (a += n ? c.replace(/\`/g, "`1").replace(/\$/g, "`2") : c), a += "$", a += Vde[u] || "f", d && (a += d.uid), a += "$";
      }
      var v = this.source, p = [v.seriesLayoutBy, v.startIndex, a].join("$$");
      return {
        dimensions: o,
        hash: p
      };
    }, t.prototype.makeOutputDimensionNames = function() {
      for (var e = [], r = 0, n = 0; r < this._fullDimCount; r++) {
        var a = void 0, o = this.dimensions[n];
        if (o && o.storeDimIndex === r)
          o.isCalculationCoord || (a = o.name), n++;
        else {
          var i = this.getSourceDimension(r);
          i && (a = i.name);
        }
        e.push(a);
      }
      return e;
    }, t.prototype.appendCalculationDimension = function(e) {
      this.dimensions.push(e), e.isCalculationCoord = !0, this._fullDimCount++, this._updateDimOmitted(!0);
    }, t;
  }()
);
function Cx(t) {
  return t instanceof xx;
}
function Ex(t) {
  for (var e = se(), r = 0; r < (t || []).length; r++) {
    var n = t[r], a = re(n) ? n.name : n;
    a != null && e.get(a) == null && e.set(a, r);
  }
  return e;
}
function Sx(t) {
  var e = $de(t);
  return e.dimNameMap || (e.dimNameMap = Ex(t.dimensionsDefine));
}
function Rx(t) {
  return t > 30;
}
var vl = re, Pn = J, Zde = typeof Int32Array > "u" ? Array : Int32Array, Hde = "e\0\0", I3 = -1, jde = ["hasItemOption", "_nameList", "_idList", "_invertedIndicesMap", "_dimSummary", "userOutput", "_rawData", "_dimValueGetter", "_nameDimIdx", "_idDimIdx", "_nameRepeatCount"], Wde = ["_approximateExtent"], P3, Pc, pl, Zo, Wd, Dc, zd, fi = (
  /** @class */
  function() {
    function t(e, r) {
      this.type = "list", this._dimOmitted = !1, this._nameList = [], this._idList = [], this._visual = {}, this._layout = {}, this._itemVisuals = [], this._itemLayouts = [], this._graphicEls = [], this._approximateExtent = {}, this._calculationInfo = {}, this.hasItemOption = !1, this.TRANSFERABLE_METHODS = ["cloneShallow", "downSample", "lttbDownSample", "map"], this.CHANGABLE_METHODS = ["filterSelf", "selectRange"], this.DOWNSAMPLE_METHODS = ["downSample", "lttbDownSample"];
      var n, a = !1;
      Cx(e) ? (n = e.dimensions, this._dimOmitted = e.isDimensionOmitted(), this._schema = e) : (a = !0, n = e), n = n || ["x", "y"];
      for (var o = {}, i = [], l = {}, c = !1, u = {}, d = 0; d < n.length; d++) {
        var f = n[d], h = Q(f) ? new x0({
          name: f
        }) : f instanceof x0 ? f : new x0(f), v = h.name;
        h.type = h.type || "float", h.coordDim || (h.coordDim = v, h.coordDimIndex = 0);
        var p = h.otherDims = h.otherDims || {};
        i.push(v), o[v] = h, u[v] != null && (c = !0), h.createInvertedIndices && (l[v] = []), p.itemName === 0 && (this._nameDimIdx = d), p.itemId === 0 && (this._idDimIdx = d), process.env.NODE_ENV !== "production" && ge(a || h.storeDimIndex >= 0), a && (h.storeDimIndex = d);
      }
      if (this.dimensions = i, this._dimInfos = o, this._initGetDimensionInfo(c), this.hostModel = r, this._invertedIndicesMap = l, this._dimOmitted) {
        var g = this._dimIdxToName = se();
        I(i, function(m) {
          g.set(o[m].storeDimIndex, m);
        });
      }
    }
    return t.prototype.getDimension = function(e) {
      var r = this._recognizeDimIndex(e);
      if (r == null)
        return e;
      if (r = e, !this._dimOmitted)
        return this.dimensions[r];
      var n = this._dimIdxToName.get(r);
      if (n != null)
        return n;
      var a = this._schema.getSourceDimension(r);
      if (a)
        return a.name;
    }, t.prototype.getDimensionIndex = function(e) {
      var r = this._recognizeDimIndex(e);
      if (r != null)
        return r;
      if (e == null)
        return -1;
      var n = this._getDimInfo(e);
      return n ? n.storeDimIndex : this._dimOmitted ? this._schema.getSourceDimensionIndex(e) : -1;
    }, t.prototype._recognizeDimIndex = function(e) {
      if (De(e) || e != null && !isNaN(e) && !this._getDimInfo(e) && (!this._dimOmitted || this._schema.getSourceDimensionIndex(e) < 0))
        return +e;
    }, t.prototype._getStoreDimIndex = function(e) {
      var r = this.getDimensionIndex(e);
      if (process.env.NODE_ENV !== "production" && r == null)
        throw new Error("Unknown dimension " + e);
      return r;
    }, t.prototype.getDimensionInfo = function(e) {
      return this._getDimInfo(this.getDimension(e));
    }, t.prototype._initGetDimensionInfo = function(e) {
      var r = this._dimInfos;
      this._getDimInfo = e ? function(n) {
        return r.hasOwnProperty(n) ? r[n] : void 0;
      } : function(n) {
        return r[n];
      };
    }, t.prototype.getDimensionsOnCoord = function() {
      return this._dimSummary.dataDimsOnCoord.slice();
    }, t.prototype.mapDimension = function(e, r) {
      var n = this._dimSummary;
      if (r == null)
        return n.encodeFirstDimNotExtra[e];
      var a = n.encode[e];
      return a ? a[r] : null;
    }, t.prototype.mapDimensionsAll = function(e) {
      var r = this._dimSummary, n = r.encode[e];
      return (n || []).slice();
    }, t.prototype.getStore = function() {
      return this._store;
    }, t.prototype.initData = function(e, r, n) {
      var a = this, o;
      if (e instanceof Uh && (o = e), !o) {
        var i = this.dimensions, l = R7(e) || Lt(e) ? new A_(e, i.length) : e;
        o = new Uh();
        var c = Pn(i, function(u) {
          return {
            type: a._dimInfos[u].type,
            property: u
          };
        });
        o.initData(l, c, n);
      }
      this._store = o, this._nameList = (r || []).slice(), this._idList = [], this._nameRepeatCount = {}, this._doInit(0, o.count()), this._dimSummary = Nde(this, this._schema), this.userOutput = this._dimSummary.userOutput;
    }, t.prototype.appendData = function(e) {
      var r = this._store.appendData(e);
      this._doInit(r[0], r[1]);
    }, t.prototype.appendValues = function(e, r) {
      var n = this._store.appendValues(e, r.length), a = n.start, o = n.end, i = this._shouldMakeIdFromName();
      if (this._updateOrdinalMeta(), r)
        for (var l = a; l < o; l++) {
          var c = l - a;
          this._nameList[l] = r[c], i && zd(this, l);
        }
    }, t.prototype._updateOrdinalMeta = function() {
      for (var e = this._store, r = this.dimensions, n = 0; n < r.length; n++) {
        var a = this._dimInfos[r[n]];
        a.ordinalMeta && e.collectOrdinalMeta(a.storeDimIndex, a.ordinalMeta);
      }
    }, t.prototype._shouldMakeIdFromName = function() {
      var e = this._store.getProvider();
      return this._idDimIdx == null && e.getSource().sourceFormat !== wn && !e.fillStorage;
    }, t.prototype._doInit = function(e, r) {
      if (!(e >= r)) {
        var n = this._store, a = n.getProvider();
        this._updateOrdinalMeta();
        var o = this._nameList, i = this._idList, l = a.getSource().sourceFormat, c = l === Cr;
        if (c && !a.pure)
          for (var u = [], d = e; d < r; d++) {
            var f = a.getItem(d, u);
            if (!this.hasItemOption && sce(f) && (this.hasItemOption = !0), f) {
              var h = f.name;
              o[d] == null && h != null && (o[d] = Jr(h, null));
              var v = f.id;
              i[d] == null && v != null && (i[d] = Jr(v, null));
            }
          }
        if (this._shouldMakeIdFromName())
          for (var d = e; d < r; d++)
            zd(this, d);
        P3(this);
      }
    }, t.prototype.getApproximateExtent = function(e) {
      return this._approximateExtent[e] || this._store.getDataExtent(this._getStoreDimIndex(e));
    }, t.prototype.setApproximateExtent = function(e, r) {
      r = this.getDimension(r), this._approximateExtent[r] = e.slice();
    }, t.prototype.getCalculationInfo = function(e) {
      return this._calculationInfo[e];
    }, t.prototype.setCalculationInfo = function(e, r) {
      vl(e) ? H(this._calculationInfo, e) : this._calculationInfo[e] = r;
    }, t.prototype.getName = function(e) {
      var r = this.getRawIndex(e), n = this._nameList[r];
      return n == null && this._nameDimIdx != null && (n = pl(this, this._nameDimIdx, r)), n == null && (n = ""), n;
    }, t.prototype._getCategory = function(e, r) {
      var n = this._store.get(e, r), a = this._store.getOrdinalMeta(e);
      return a ? a.categories[n] : n;
    }, t.prototype.getId = function(e) {
      return Pc(this, this.getRawIndex(e));
    }, t.prototype.count = function() {
      return this._store.count();
    }, t.prototype.get = function(e, r) {
      var n = this._store, a = this._dimInfos[e];
      if (a)
        return n.get(a.storeDimIndex, r);
    }, t.prototype.getByRawIndex = function(e, r) {
      var n = this._store, a = this._dimInfos[e];
      if (a)
        return n.getByRawIndex(a.storeDimIndex, r);
    }, t.prototype.getIndices = function() {
      return this._store.getIndices();
    }, t.prototype.getDataExtent = function(e) {
      return this._store.getDataExtent(this._getStoreDimIndex(e));
    }, t.prototype.getSum = function(e) {
      return this._store.getSum(this._getStoreDimIndex(e));
    }, t.prototype.getMedian = function(e) {
      return this._store.getMedian(this._getStoreDimIndex(e));
    }, t.prototype.getValues = function(e, r) {
      var n = this, a = this._store;
      return z(e) ? a.getValues(Pn(e, function(o) {
        return n._getStoreDimIndex(o);
      }), r) : a.getValues(e);
    }, t.prototype.hasValue = function(e) {
      for (var r = this._dimSummary.dataDimIndicesOnCoord, n = 0, a = r.length; n < a; n++)
        if (isNaN(this._store.get(r[n], e)))
          return !1;
      return !0;
    }, t.prototype.indexOfName = function(e) {
      for (var r = 0, n = this._store.count(); r < n; r++)
        if (this.getName(r) === e)
          return r;
      return -1;
    }, t.prototype.getRawIndex = function(e) {
      return this._store.getRawIndex(e);
    }, t.prototype.indexOfRawIndex = function(e) {
      return this._store.indexOfRawIndex(e);
    }, t.prototype.rawIndexOf = function(e, r) {
      var n = e && this._invertedIndicesMap[e];
      if (process.env.NODE_ENV !== "production" && !n)
        throw new Error("Do not supported yet");
      var a = n[r];
      return a == null || isNaN(a) ? I3 : a;
    }, t.prototype.indicesOfNearest = function(e, r, n) {
      return this._store.indicesOfNearest(this._getStoreDimIndex(e), r, n);
    }, t.prototype.each = function(e, r, n) {
      ie(e) && (n = r, r = e, e = []);
      var a = n || this, o = Pn(Zo(e), this._getStoreDimIndex, this);
      this._store.each(o, a ? le(r, a) : r);
    }, t.prototype.filterSelf = function(e, r, n) {
      ie(e) && (n = r, r = e, e = []);
      var a = n || this, o = Pn(Zo(e), this._getStoreDimIndex, this);
      return this._store = this._store.filter(o, a ? le(r, a) : r), this;
    }, t.prototype.selectRange = function(e) {
      var r = this, n = {}, a = Ze(e);
      return I(a, function(o) {
        var i = r._getStoreDimIndex(o);
        n[i] = e[o];
      }), this._store = this._store.selectRange(n), this;
    }, t.prototype.mapArray = function(e, r, n) {
      ie(e) && (n = r, r = e, e = []), n = n || this;
      var a = [];
      return this.each(e, function() {
        a.push(r && r.apply(this, arguments));
      }, n), a;
    }, t.prototype.map = function(e, r, n, a) {
      var o = n || a || this, i = Pn(Zo(e), this._getStoreDimIndex, this), l = Dc(this);
      return l._store = this._store.map(i, o ? le(r, o) : r), l;
    }, t.prototype.modify = function(e, r, n, a) {
      var o = this, i = n || a || this;
      process.env.NODE_ENV !== "production" && I(Zo(e), function(c) {
        var u = o.getDimensionInfo(c);
        u.isCalculationCoord || console.error("Danger: only stack dimension can be modified");
      });
      var l = Pn(Zo(e), this._getStoreDimIndex, this);
      this._store.modify(l, i ? le(r, i) : r);
    }, t.prototype.downSample = function(e, r, n, a) {
      var o = Dc(this);
      return o._store = this._store.downSample(this._getStoreDimIndex(e), r, n, a), o;
    }, t.prototype.lttbDownSample = function(e, r) {
      var n = Dc(this);
      return n._store = this._store.lttbDownSample(this._getStoreDimIndex(e), r), n;
    }, t.prototype.getRawDataItem = function(e) {
      return this._store.getRawDataItem(e);
    }, t.prototype.getItemModel = function(e) {
      var r = this.hostModel, n = this.getRawDataItem(e);
      return new Ve(n, r, r && r.ecModel);
    }, t.prototype.diff = function(e) {
      var r = this;
      return new Pde(e ? e.getStore().getIndices() : [], this.getStore().getIndices(), function(n) {
        return Pc(e, n);
      }, function(n) {
        return Pc(r, n);
      });
    }, t.prototype.getVisual = function(e) {
      var r = this._visual;
      return r && r[e];
    }, t.prototype.setVisual = function(e, r) {
      this._visual = this._visual || {}, vl(e) ? H(this._visual, e) : this._visual[e] = r;
    }, t.prototype.getItemVisual = function(e, r) {
      var n = this._itemVisuals[e], a = n && n[r];
      return a ?? this.getVisual(r);
    }, t.prototype.hasItemVisual = function() {
      return this._itemVisuals.length > 0;
    }, t.prototype.ensureUniqueItemVisual = function(e, r) {
      var n = this._itemVisuals, a = n[e];
      a || (a = n[e] = {});
      var o = a[r];
      return o == null && (o = this.getVisual(r), z(o) ? o = o.slice() : vl(o) && (o = H({}, o)), a[r] = o), o;
    }, t.prototype.setItemVisual = function(e, r, n) {
      var a = this._itemVisuals[e] || {};
      this._itemVisuals[e] = a, vl(r) ? H(a, r) : a[r] = n;
    }, t.prototype.clearAllVisual = function() {
      this._visual = {}, this._itemVisuals = [];
    }, t.prototype.setLayout = function(e, r) {
      vl(e) ? H(this._layout, e) : this._layout[e] = r;
    }, t.prototype.getLayout = function(e) {
      return this._layout[e];
    }, t.prototype.getItemLayout = function(e) {
      return this._itemLayouts[e];
    }, t.prototype.setItemLayout = function(e, r, n) {
      this._itemLayouts[e] = n ? H(this._itemLayouts[e] || {}, r) : r;
    }, t.prototype.clearItemLayouts = function() {
      this._itemLayouts.length = 0;
    }, t.prototype.setItemGraphicEl = function(e, r) {
      var n = this.hostModel && this.hostModel.seriesIndex;
      Bh(n, this.dataType, e, r), this._graphicEls[e] = r;
    }, t.prototype.getItemGraphicEl = function(e) {
      return this._graphicEls[e];
    }, t.prototype.eachItemGraphicEl = function(e, r) {
      I(this._graphicEls, function(n, a) {
        n && e && e.call(r, n, a);
      });
    }, t.prototype.cloneShallow = function(e) {
      return e || (e = new t(this._schema ? this._schema : Pn(this.dimensions, this._getDimInfo, this), this.hostModel)), Wd(e, this), e._store = this._store, e;
    }, t.prototype.wrapMethod = function(e, r) {
      var n = this[e];
      ie(n) && (this.__wrappedMethods = this.__wrappedMethods || [], this.__wrappedMethods.push(e), this[e] = function() {
        var a = n.apply(this, arguments);
        return r.apply(this, [a].concat(b1(arguments)));
      });
    }, t.internalField = function() {
      P3 = function(e) {
        var r = e._invertedIndicesMap;
        I(r, function(n, a) {
          var o = e._dimInfos[a], i = o.ordinalMeta, l = e._store;
          if (i) {
            n = r[a] = new Zde(i.categories.length);
            for (var c = 0; c < n.length; c++)
              n[c] = I3;
            for (var c = 0; c < l.count(); c++)
              n[l.get(o.storeDimIndex, c)] = c;
          }
        });
      }, pl = function(e, r, n) {
        return Jr(e._getCategory(r, n), null);
      }, Pc = function(e, r) {
        var n = e._idList[r];
        return n == null && e._idDimIdx != null && (n = pl(e, e._idDimIdx, r)), n == null && (n = Hde + r), n;
      }, Zo = function(e) {
        return z(e) || (e = e != null ? [e] : []), e;
      }, Dc = function(e) {
        var r = new t(e._schema ? e._schema : Pn(e.dimensions, e._getDimInfo, e), e.hostModel);
        return Wd(r, e), r;
      }, Wd = function(e, r) {
        I(jde.concat(r.__wrappedMethods || []), function(n) {
          r.hasOwnProperty(n) && (e[n] = r[n]);
        }), e.__wrappedMethods = r.__wrappedMethods, I(Wde, function(n) {
          e[n] = be(r[n]);
        }), e._calculationInfo = H({}, r._calculationInfo);
      }, zd = function(e, r) {
        var n = e._nameList, a = e._idList, o = e._nameDimIdx, i = e._idDimIdx, l = n[r], c = a[r];
        if (l == null && o != null && (n[r] = l = pl(e, o, r)), c == null && i != null && (a[r] = c = pl(e, i, r)), c == null && l != null) {
          var u = e._nameRepeatCount, d = u[l] = (u[l] || 0) + 1;
          c = l, d > 1 && (c += "__ec__" + d), a[r] = c;
        }
      };
    }(), t;
  }()
);
function zde(t, e) {
  return H7(t, e).dimensions;
}
function H7(t, e) {
  R7(t) || (t = S_(t)), e = e || {};
  var r = e.coordDimensions || [], n = e.dimensionsDefine || t.dimensionsDefine || [], a = se(), o = [], i = Ude(t, r, n, e.dimensionsCount), l = e.canOmitUnusedDimensions && Rx(i), c = n === t.dimensionsDefine, u = c ? Sx(t) : Ex(n), d = e.encodeDefine;
  !d && e.encodeDefaulter && (d = e.encodeDefaulter(t, i));
  for (var f = se(d), h = new I_(i), v = 0; v < h.length; v++)
    h[v] = -1;
  function p(R) {
    var A = h[R];
    if (A < 0) {
      var k = n[R], L = re(k) ? k : {
        name: k
      }, T = new x0(), O = L.name;
      O != null && u.get(O) != null && (T.name = T.displayName = O), L.type != null && (T.type = L.type), L.displayName != null && (T.displayName = L.displayName);
      var D = o.length;
      return h[R] = D, T.storeDimIndex = R, o.push(T), T;
    }
    return o[A];
  }
  if (!l)
    for (var v = 0; v < i; v++)
      p(v);
  f.each(function(R, A) {
    var k = kt(R).slice();
    if (k.length === 1 && !Q(k[0]) && k[0] < 0) {
      f.set(A, !1);
      return;
    }
    var L = f.set(A, []);
    I(k, function(T, O) {
      var D = Q(T) ? u.get(T) : T;
      D != null && D < i && (L[O] = D, m(p(D), A, O));
    });
  });
  var g = 0;
  I(r, function(R) {
    var A, k, L, T;
    if (Q(R))
      A = R, T = {};
    else {
      T = R, A = T.name;
      var O = T.ordinalMeta;
      T.ordinalMeta = null, T = H({}, T), T.ordinalMeta = O, k = T.dimsDef, L = T.otherDims, T.name = T.coordDim = T.coordDimIndex = T.dimsDef = T.otherDims = null;
    }
    var D = f.get(A);
    if (D !== !1) {
      if (D = kt(D), !D.length)
        for (var P = 0; P < (k && k.length || 1); P++) {
          for (; g < i && p(g).coordDim != null; )
            g++;
          g < i && D.push(g++);
        }
      I(D, function(F, B) {
        var N = p(F);
        if (c && T.type != null && (N.type = T.type), m(Te(N, T), A, B), N.name == null && k) {
          var $ = k[B];
          !re($) && ($ = {
            name: $
          }), N.name = N.displayName = $.name, N.defaultTooltip = $.defaultTooltip;
        }
        L && Te(N.otherDims, L);
      });
    }
  });
  function m(R, A, k) {
    zh.get(A) != null ? R.otherDims[A] = k : (R.coordDim = A, R.coordDimIndex = k, a.set(A, !0));
  }
  var w = e.generateCoord, y = e.generateCoordCount, b = y != null;
  y = w ? y || 1 : 0;
  var _ = w || "value";
  function x(R) {
    R.name == null && (R.name = R.coordDim);
  }
  if (l)
    I(o, function(R) {
      x(R);
    }), o.sort(function(R, A) {
      return R.storeDimIndex - A.storeDimIndex;
    });
  else
    for (var E = 0; E < i; E++) {
      var S = p(E), M = S.coordDim;
      M == null && (S.coordDim = Yde(_, a, b), S.coordDimIndex = 0, (!w || y <= 0) && (S.isExtraCoord = !0), y--), x(S), S.type == null && (b_(t, E) === st.Must || S.isExtraCoord && (S.otherDims.itemName != null || S.otherDims.seriesName != null)) && (S.type = "ordinal");
    }
  return Gde(o), new xx({
    source: t,
    dimensions: o,
    fullDimensionCount: i,
    dimensionOmitted: l
  });
}
function Gde(t) {
  for (var e = se(), r = 0; r < t.length; r++) {
    var n = t[r], a = n.name, o = e.get(a) || 0;
    o > 0 && (n.name = a + (o - 1)), o++, e.set(a, o);
  }
}
function Ude(t, e, r, n) {
  var a = Math.max(t.dimensionsDetectedCount || 1, e.length, r.length, n || 0);
  return I(e, function(o) {
    var i;
    re(o) && (i = o.dimsDef) && (a = Math.max(a, i.length));
  }), a;
}
function Yde(t, e, r) {
  if (r || e.hasKey(t)) {
    for (var n = 0; e.hasKey(t + n); )
      n++;
    t += n;
  }
  return e.set(t, !0), t;
}
var Xde = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e) {
      this.coordSysDims = [], this.axisMap = se(), this.categoryAxisMap = se(), this.coordSysName = e;
    }
    return t;
  }()
);
function qde(t) {
  var e = t.get("coordinateSystem"), r = new Xde(e), n = Kde[e];
  if (n)
    return n(t, r, r.axisMap, r.categoryAxisMap), r;
}
var Kde = {
  cartesian2d: function(t, e, r, n) {
    var a = t.getReferringComponents("xAxis", Ht).models[0], o = t.getReferringComponents("yAxis", Ht).models[0];
    if (process.env.NODE_ENV !== "production") {
      if (!a)
        throw new Error('xAxis "' + Cn(t.get("xAxisIndex"), t.get("xAxisId"), 0) + '" not found');
      if (!o)
        throw new Error('yAxis "' + Cn(t.get("xAxisIndex"), t.get("yAxisId"), 0) + '" not found');
    }
    e.coordSysDims = ["x", "y"], r.set("x", a), r.set("y", o), Ho(a) && (n.set("x", a), e.firstCategoryDimIndex = 0), Ho(o) && (n.set("y", o), e.firstCategoryDimIndex == null && (e.firstCategoryDimIndex = 1));
  },
  singleAxis: function(t, e, r, n) {
    var a = t.getReferringComponents("singleAxis", Ht).models[0];
    if (process.env.NODE_ENV !== "production" && !a)
      throw new Error("singleAxis should be specified.");
    e.coordSysDims = ["single"], r.set("single", a), Ho(a) && (n.set("single", a), e.firstCategoryDimIndex = 0);
  },
  polar: function(t, e, r, n) {
    var a = t.getReferringComponents("polar", Ht).models[0], o = a.findAxisModel("radiusAxis"), i = a.findAxisModel("angleAxis");
    if (process.env.NODE_ENV !== "production") {
      if (!i)
        throw new Error("angleAxis option not found");
      if (!o)
        throw new Error("radiusAxis option not found");
    }
    e.coordSysDims = ["radius", "angle"], r.set("radius", o), r.set("angle", i), Ho(o) && (n.set("radius", o), e.firstCategoryDimIndex = 0), Ho(i) && (n.set("angle", i), e.firstCategoryDimIndex == null && (e.firstCategoryDimIndex = 1));
  },
  geo: function(t, e, r, n) {
    e.coordSysDims = ["lng", "lat"];
  },
  parallel: function(t, e, r, n) {
    var a = t.ecModel, o = a.getComponent("parallel", t.get("parallelIndex")), i = e.coordSysDims = o.dimensions.slice();
    I(o.parallelAxisIndex, function(l, c) {
      var u = a.getComponent("parallelAxis", l), d = i[c];
      r.set(d, u), Ho(u) && (n.set(d, u), e.firstCategoryDimIndex == null && (e.firstCategoryDimIndex = c));
    });
  }
};
function Ho(t) {
  return t.get("type") === "category";
}
function Mx(t, e, r) {
  r = r || {};
  var n = r.byIndex, a = r.stackedCoordDimension, o, i, l;
  Qde(e) ? o = e : (i = e.schema, o = i.dimensions, l = e.store);
  var c = !!(t && t.get("stack")), u, d, f, h;
  if (I(o, function(y, b) {
    Q(y) && (o[b] = y = {
      name: y
    }), c && !y.isExtraCoord && (!n && !u && y.ordinalMeta && (u = y), !d && y.type !== "ordinal" && y.type !== "time" && (!a || a === y.coordDim) && (d = y));
  }), d && !n && !u && (n = !0), d) {
    f = "__\0ecstackresult_" + t.id, h = "__\0ecstackedover_" + t.id, u && (u.createInvertedIndices = !0);
    var v = d.coordDim, p = d.type, g = 0;
    I(o, function(y) {
      y.coordDim === v && g++;
    });
    var m = {
      name: f,
      coordDim: v,
      coordDimIndex: g,
      type: p,
      isExtraCoord: !0,
      isCalculationCoord: !0,
      storeDimIndex: o.length
    }, w = {
      name: h,
      // This dimension contains stack base (generally, 0), so do not set it as
      // `stackedDimCoordDim` to avoid extent calculation, consider log scale.
      coordDim: h,
      coordDimIndex: g + 1,
      type: p,
      isExtraCoord: !0,
      isCalculationCoord: !0,
      storeDimIndex: o.length + 1
    };
    i ? (l && (m.storeDimIndex = l.ensureCalculationDimension(h, p), w.storeDimIndex = l.ensureCalculationDimension(f, p)), i.appendCalculationDimension(m), i.appendCalculationDimension(w)) : (o.push(m), o.push(w));
  }
  return {
    stackedDimension: d && d.name,
    stackedByDimension: u && u.name,
    isStackedByIndex: n,
    stackedOverDimension: h,
    stackResultDimension: f
  };
}
function Qde(t) {
  return !Cx(t.schema);
}
function fa(t, e) {
  return !!e && e === t.getCalculationInfo("stackedDimension");
}
function j7(t, e) {
  return fa(t, e) ? t.getCalculationInfo("stackResultDimension") : e;
}
function Jde(t, e) {
  var r = t.get("coordinateSystem"), n = H1.get(r), a;
  return e && e.coordSysDims && (a = J(e.coordSysDims, function(o) {
    var i = {
      name: o
    }, l = e.axisMap.get(o);
    if (l) {
      var c = l.get("type");
      i.type = Bde(c);
    }
    return i;
  })), a || (a = n && (n.getDimensionsInfo ? n.getDimensionsInfo() : n.dimensions.slice()) || ["x", "y"]), a;
}
function efe(t, e, r) {
  var n, a;
  return r && I(t, function(o, i) {
    var l = o.coordDim, c = r.categoryAxisMap.get(l);
    c && (n == null && (n = i), o.ordinalMeta = c.getOrdinalMeta(), e && (o.createInvertedIndices = !0)), o.otherDims.itemName != null && (a = !0);
  }), !a && n != null && (t[n].otherDims.itemName = 0), n;
}
function q1(t, e, r) {
  r = r || {};
  var n = e.getSourceManager(), a, o = !1;
  a = n.getSource(), o = a.sourceFormat === Cr;
  var i = qde(e), l = Jde(e, i), c = r.useEncodeDefaulter, u = ie(c) ? c : c ? Oe(Yue, l, e) : null, d = {
    coordDimensions: l,
    generateCoord: r.generateCoord,
    encodeDefine: e.getEncode(),
    encodeDefaulter: u,
    canOmitUnusedDimensions: !o
  }, f = H7(a, d), h = efe(f.dimensions, r.createInvertedIndices, i), v = o ? null : n.getSharedDataStore(f), p = Mx(e, {
    schema: f,
    store: v
  }), g = new fi(f, e);
  g.setCalculationInfo(p);
  var m = h != null && tfe(a) ? function(w, y, b, _) {
    return _ === h ? b : this.defaultDimValueGetter(w, y, b, _);
  } : null;
  return g.hasItemOption = !1, g.initData(
    // Try to reuse the data store in sourceManager if using dataset.
    o ? a : v,
    null,
    m
  ), g;
}
function tfe(t) {
  if (t.sourceFormat === Cr) {
    var e = rfe(t.data || []);
    return !z(Ps(e));
  }
}
function rfe(t) {
  for (var e = 0; e < t.length && t[e] == null; )
    e++;
  return t[e];
}
var on = (
  /** @class */
  function() {
    function t(e) {
      this._setting = e || {}, this._extent = [1 / 0, -1 / 0];
    }
    return t.prototype.getSetting = function(e) {
      return this._setting[e];
    }, t.prototype.unionExtent = function(e) {
      var r = this._extent;
      e[0] < r[0] && (r[0] = e[0]), e[1] > r[1] && (r[1] = e[1]);
    }, t.prototype.unionExtentFromData = function(e, r) {
      this.unionExtent(e.getApproximateExtent(r));
    }, t.prototype.getExtent = function() {
      return this._extent.slice();
    }, t.prototype.setExtent = function(e, r) {
      var n = this._extent;
      isNaN(e) || (n[0] = e), isNaN(r) || (n[1] = r);
    }, t.prototype.isInExtentRange = function(e) {
      return this._extent[0] <= e && this._extent[1] >= e;
    }, t.prototype.isBlank = function() {
      return this._isBlank;
    }, t.prototype.setBlank = function(e) {
      this._isBlank = e;
    }, t;
  }()
);
S1(on);
var nfe = 0, a2 = (
  /** @class */
  function() {
    function t(e) {
      this.categories = e.categories || [], this._needCollect = e.needCollect, this._deduplication = e.deduplication, this.uid = ++nfe;
    }
    return t.createByAxisModel = function(e) {
      var r = e.option, n = r.data, a = n && J(n, afe);
      return new t({
        categories: a,
        needCollect: !a,
        // deduplication is default in axis.
        deduplication: r.dedplication !== !1
      });
    }, t.prototype.getOrdinal = function(e) {
      return this._getOrCreateMap().get(e);
    }, t.prototype.parseAndCollect = function(e) {
      var r, n = this._needCollect;
      if (!Q(e) && !n)
        return e;
      if (n && !this._deduplication)
        return r = this.categories.length, this.categories[r] = e, r;
      var a = this._getOrCreateMap();
      return r = a.get(e), r == null && (n ? (r = this.categories.length, this.categories[r] = e, a.set(e, r)) : r = NaN), r;
    }, t.prototype._getOrCreateMap = function() {
      return this._map || (this._map = se(this.categories));
    }, t;
  }()
);
function afe(t) {
  return re(t) && t.value != null ? t.value : t + "";
}
function ofe(t) {
  var e = Math.pow(10, Is(Math.abs(t))), r = Math.abs(t / e);
  return r === 0 || r === 1 || r === 2 || r === 3 || r === 5;
}
function o2(t) {
  return t.type === "interval" || t.type === "log";
}
function ife(t, e, r, n) {
  var a = {}, o = t[1] - t[0], i = a.interval = Xv(o / e, !0);
  r != null && i < r && (i = a.interval = r), n != null && i > n && (i = a.interval = n);
  var l = a.intervalPrecision = Ax(i), c = a.niceTickExtent = [Qe(Math.ceil(t[0] / i) * i, l), Qe(Math.floor(t[1] / i) * i, l)];
  return lfe(c, t), a;
}
function Gd(t) {
  var e = Math.pow(10, Is(t)), r = t / e;
  return r ? r === 2 ? r = 3 : r === 3 ? r = 5 : r *= 2 : r = 1, Qe(r * e);
}
function Ax(t) {
  return Pr(t) + 2;
}
function D3(t, e, r) {
  t[e] = Math.max(Math.min(t[e], r[1]), r[0]);
}
function lfe(t, e) {
  !isFinite(t[0]) && (t[0] = e[0]), !isFinite(t[1]) && (t[1] = e[1]), D3(t, 0, e), D3(t, 1, e), t[0] > t[1] && (t[0] = t[1]);
}
function K1(t, e) {
  return t >= e[0] && t <= e[1];
}
function Q1(t, e) {
  return e[1] === e[0] ? 0.5 : (t - e[0]) / (e[1] - e[0]);
}
function J1(t, e) {
  return t * (e[1] - e[0]) + e[0];
}
var W7 = (
  /** @class */
  function(t) {
    K(e, t);
    function e(r) {
      var n = t.call(this, r) || this;
      n.type = "ordinal";
      var a = n.getSetting("ordinalMeta");
      return a || (a = new a2({})), z(a) && (a = new a2({
        categories: J(a, function(o) {
          return re(o) ? o.value : o;
        })
      })), n._ordinalMeta = a, n._extent = n.getSetting("extent") || [0, a.categories.length - 1], n;
    }
    return e.prototype.parse = function(r) {
      return r == null ? NaN : Q(r) ? this._ordinalMeta.getOrdinal(r) : Math.round(r);
    }, e.prototype.contain = function(r) {
      return r = this.parse(r), K1(r, this._extent) && this._ordinalMeta.categories[r] != null;
    }, e.prototype.normalize = function(r) {
      return r = this._getTickNumber(this.parse(r)), Q1(r, this._extent);
    }, e.prototype.scale = function(r) {
      return r = Math.round(J1(r, this._extent)), this.getRawOrdinalNumber(r);
    }, e.prototype.getTicks = function() {
      for (var r = [], n = this._extent, a = n[0]; a <= n[1]; )
        r.push({
          value: a
        }), a++;
      return r;
    }, e.prototype.getMinorTicks = function(r) {
    }, e.prototype.setSortInfo = function(r) {
      if (r == null) {
        this._ordinalNumbersByTick = this._ticksByOrdinalNumber = null;
        return;
      }
      for (var n = r.ordinalNumbers, a = this._ordinalNumbersByTick = [], o = this._ticksByOrdinalNumber = [], i = 0, l = this._ordinalMeta.categories.length, c = Math.min(l, n.length); i < c; ++i) {
        var u = n[i];
        a[i] = u, o[u] = i;
      }
      for (var d = 0; i < l; ++i) {
        for (; o[d] != null; )
          d++;
        a.push(d), o[d] = i;
      }
    }, e.prototype._getTickNumber = function(r) {
      var n = this._ticksByOrdinalNumber;
      return n && r >= 0 && r < n.length ? n[r] : r;
    }, e.prototype.getRawOrdinalNumber = function(r) {
      var n = this._ordinalNumbersByTick;
      return n && r >= 0 && r < n.length ? n[r] : r;
    }, e.prototype.getLabel = function(r) {
      if (!this.isBlank()) {
        var n = this.getRawOrdinalNumber(r.value), a = this._ordinalMeta.categories[n];
        return a == null ? "" : a + "";
      }
    }, e.prototype.count = function() {
      return this._extent[1] - this._extent[0] + 1;
    }, e.prototype.unionExtentFromData = function(r, n) {
      this.unionExtent(r.getApproximateExtent(n));
    }, e.prototype.isInExtentRange = function(r) {
      return r = this._getTickNumber(r), this._extent[0] <= r && this._extent[1] >= r;
    }, e.prototype.getOrdinalMeta = function() {
      return this._ordinalMeta;
    }, e.prototype.calcNiceTicks = function() {
    }, e.prototype.calcNiceExtent = function() {
    }, e.type = "ordinal", e;
  }(on)
);
on.registerClass(W7);
var Va = Qe, Gi = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = "interval", r._interval = 0, r._intervalPrecision = 2, r;
    }
    return e.prototype.parse = function(r) {
      return r;
    }, e.prototype.contain = function(r) {
      return K1(r, this._extent);
    }, e.prototype.normalize = function(r) {
      return Q1(r, this._extent);
    }, e.prototype.scale = function(r) {
      return J1(r, this._extent);
    }, e.prototype.setExtent = function(r, n) {
      var a = this._extent;
      isNaN(r) || (a[0] = parseFloat(r)), isNaN(n) || (a[1] = parseFloat(n));
    }, e.prototype.unionExtent = function(r) {
      var n = this._extent;
      r[0] < n[0] && (n[0] = r[0]), r[1] > n[1] && (n[1] = r[1]), this.setExtent(n[0], n[1]);
    }, e.prototype.getInterval = function() {
      return this._interval;
    }, e.prototype.setInterval = function(r) {
      this._interval = r, this._niceExtent = this._extent.slice(), this._intervalPrecision = Ax(r);
    }, e.prototype.getTicks = function(r) {
      var n = this._interval, a = this._extent, o = this._niceExtent, i = this._intervalPrecision, l = [];
      if (!n)
        return l;
      var c = 1e4;
      a[0] < o[0] && (r ? l.push({
        value: Va(o[0] - n, i)
      }) : l.push({
        value: a[0]
      }));
      for (var u = o[0]; u <= o[1] && (l.push({
        value: u
      }), u = Va(u + n, i), u !== l[l.length - 1].value); )
        if (l.length > c)
          return [];
      var d = l.length ? l[l.length - 1].value : o[1];
      return a[1] > d && (r ? l.push({
        value: Va(d + n, i)
      }) : l.push({
        value: a[1]
      })), l;
    }, e.prototype.getMinorTicks = function(r) {
      for (var n = this.getTicks(!0), a = [], o = this.getExtent(), i = 1; i < n.length; i++) {
        for (var l = n[i], c = n[i - 1], u = 0, d = [], f = l.value - c.value, h = f / r; u < r - 1; ) {
          var v = Va(c.value + (u + 1) * h);
          v > o[0] && v < o[1] && d.push(v), u++;
        }
        a.push(d);
      }
      return a;
    }, e.prototype.getLabel = function(r, n) {
      if (r == null)
        return "";
      var a = n && n.precision;
      a == null ? a = Pr(r.value) || 0 : a === "auto" && (a = this._intervalPrecision);
      var o = Va(r.value, a, !0);
      return y7(o);
    }, e.prototype.calcNiceTicks = function(r, n, a) {
      r = r || 5;
      var o = this._extent, i = o[1] - o[0];
      if (isFinite(i)) {
        i < 0 && (i = -i, o.reverse());
        var l = ife(o, r, n, a);
        this._intervalPrecision = l.intervalPrecision, this._interval = l.interval, this._niceExtent = l.niceTickExtent;
      }
    }, e.prototype.calcNiceExtent = function(r) {
      var n = this._extent;
      if (n[0] === n[1])
        if (n[0] !== 0) {
          var a = Math.abs(n[0]);
          r.fixMax || (n[1] += a / 2), n[0] -= a / 2;
        } else
          n[1] = 1;
      var o = n[1] - n[0];
      isFinite(o) || (n[0] = 0, n[1] = 1), this.calcNiceTicks(r.splitNumber, r.minInterval, r.maxInterval);
      var i = this._interval;
      r.fixMin || (n[0] = Va(Math.floor(n[0] / i) * i)), r.fixMax || (n[1] = Va(Math.ceil(n[1] / i) * i));
    }, e.prototype.setNiceExtent = function(r, n) {
      this._niceExtent = [r, n];
    }, e.type = "interval", e;
  }(on)
);
on.registerClass(Gi);
var kx = typeof Float32Array < "u", sfe = kx ? Float32Array : Array;
function pn(t) {
  return z(t) ? kx ? new Float32Array(t) : t : new sfe(t);
}
var cfe = "__ec_stack_";
function z7(t) {
  return t.get("stack") || cfe + t.seriesIndex;
}
function G7(t) {
  return t.dim + t.index;
}
function Lx(t, e) {
  var r = [];
  return e.eachSeriesByType(t, function(n) {
    Ox(n) && r.push(n);
  }), r;
}
function ufe(t) {
  var e = {};
  I(t, function(c) {
    var u = c.coordinateSystem, d = u.getBaseAxis();
    if (!(d.type !== "time" && d.type !== "value"))
      for (var f = c.getData(), h = d.dim + "_" + d.index, v = f.getDimensionIndex(f.mapDimension(d.dim)), p = f.getStore(), g = 0, m = p.count(); g < m; ++g) {
        var w = p.get(v, g);
        e[h] ? e[h].push(w) : e[h] = [w];
      }
  });
  var r = {};
  for (var n in e)
    if (e.hasOwnProperty(n)) {
      var a = e[n];
      if (a) {
        a.sort(function(c, u) {
          return c - u;
        });
        for (var o = null, i = 1; i < a.length; ++i) {
          var l = a[i] - a[i - 1];
          l > 0 && (o = o === null ? l : Math.min(o, l));
        }
        r[n] = o;
      }
    }
  return r;
}
function Tx(t) {
  var e = ufe(t), r = [];
  return I(t, function(n) {
    var a = n.coordinateSystem, o = a.getBaseAxis(), i = o.getExtent(), l;
    if (o.type === "category")
      l = o.getBandWidth();
    else if (o.type === "value" || o.type === "time") {
      var c = o.dim + "_" + o.index, u = e[c], d = Math.abs(i[1] - i[0]), f = o.scale.getExtent(), h = Math.abs(f[1] - f[0]);
      l = u ? d / h * u : d;
    } else {
      var v = n.getData();
      l = Math.abs(i[1] - i[0]) / v.count();
    }
    var p = fe(n.get("barWidth"), l), g = fe(n.get("barMaxWidth"), l), m = fe(
      // barMinWidth by default is 0.5 / 1 in cartesian. Because in value axis,
      // the auto-calculated bar width might be less than 0.5 / 1.
      n.get("barMinWidth") || (Ix(n) ? 0.5 : 1),
      l
    ), w = n.get("barGap"), y = n.get("barCategoryGap");
    r.push({
      bandWidth: l,
      barWidth: p,
      barMaxWidth: g,
      barMinWidth: m,
      barGap: w,
      barCategoryGap: y,
      axisKey: G7(o),
      stackId: z7(n)
    });
  }), dfe(r);
}
function dfe(t) {
  var e = {};
  I(t, function(n, a) {
    var o = n.axisKey, i = n.bandWidth, l = e[o] || {
      bandWidth: i,
      remainedWidth: i,
      autoWidthCount: 0,
      categoryGap: null,
      gap: "20%",
      stacks: {}
    }, c = l.stacks;
    e[o] = l;
    var u = n.stackId;
    c[u] || l.autoWidthCount++, c[u] = c[u] || {
      width: 0,
      maxWidth: 0
    };
    var d = n.barWidth;
    d && !c[u].width && (c[u].width = d, d = Math.min(l.remainedWidth, d), l.remainedWidth -= d);
    var f = n.barMaxWidth;
    f && (c[u].maxWidth = f);
    var h = n.barMinWidth;
    h && (c[u].minWidth = h);
    var v = n.barGap;
    v != null && (l.gap = v);
    var p = n.barCategoryGap;
    p != null && (l.categoryGap = p);
  });
  var r = {};
  return I(e, function(n, a) {
    r[a] = {};
    var o = n.stacks, i = n.bandWidth, l = n.categoryGap;
    if (l == null) {
      var c = Ze(o).length;
      l = Math.max(35 - c * 4, 15) + "%";
    }
    var u = fe(l, i), d = fe(n.gap, 1), f = n.remainedWidth, h = n.autoWidthCount, v = (f - u) / (h + (h - 1) * d);
    v = Math.max(v, 0), I(o, function(w) {
      var y = w.maxWidth, b = w.minWidth;
      if (w.width) {
        var _ = w.width;
        y && (_ = Math.min(_, y)), b && (_ = Math.max(_, b)), w.width = _, f -= _ + d * _, h--;
      } else {
        var _ = v;
        y && y < _ && (_ = Math.min(y, f)), b && b > _ && (_ = b), _ !== v && (w.width = _, f -= _ + d * _, h--);
      }
    }), v = (f - u) / (h + (h - 1) * d), v = Math.max(v, 0);
    var p = 0, g;
    I(o, function(w, y) {
      w.width || (w.width = v), g = w, p += w.width * (1 + d);
    }), g && (p -= g.width * d);
    var m = -p / 2;
    I(o, function(w, y) {
      r[a][y] = r[a][y] || {
        bandWidth: i,
        offset: m,
        width: w.width
      }, m += w.width * (1 + d);
    });
  }), r;
}
function ffe(t, e, r) {
  if (t && e) {
    var n = t[G7(e)];
    return n != null && r != null ? n[z7(r)] : n;
  }
}
function hfe(t, e) {
  var r = Lx(t, e), n = Tx(r);
  I(r, function(a) {
    var o = a.getData(), i = a.coordinateSystem, l = i.getBaseAxis(), c = z7(a), u = n[G7(l)][c], d = u.offset, f = u.width;
    o.setLayout({
      bandWidth: u.bandWidth,
      offset: d,
      size: f
    });
  });
}
function vfe(t) {
  return {
    seriesType: t,
    plan: L7(),
    reset: function(e) {
      if (Ox(e)) {
        var r = e.getData(), n = e.coordinateSystem, a = n.getBaseAxis(), o = n.getOtherAxis(a), i = r.getDimensionIndex(r.mapDimension(o.dim)), l = r.getDimensionIndex(r.mapDimension(a.dim)), c = e.get("showBackground", !0), u = r.mapDimension(o.dim), d = r.getCalculationInfo("stackResultDimension"), f = fa(r, u) && !!r.getCalculationInfo("stackedOnSeries"), h = o.isHorizontal(), v = pfe(a, o), p = Ix(e), g = e.get("barMinHeight") || 0, m = d && r.getDimensionIndex(d), w = r.getLayout("size"), y = r.getLayout("offset");
        return {
          progress: function(b, _) {
            for (var x = b.count, E = p && pn(x * 3), S = p && c && pn(x * 3), M = p && pn(x), R = n.master.getRect(), A = h ? R.width : R.height, k, L = _.getStore(), T = 0; (k = b.next()) != null; ) {
              var O = L.get(f ? m : i, k), D = L.get(l, k), P = v, F = void 0;
              f && (F = +O - L.get(i, k));
              var B = void 0, N = void 0, $ = void 0, V = void 0;
              if (h) {
                var W = n.dataToPoint([O, D]);
                if (f) {
                  var ee = n.dataToPoint([F, D]);
                  P = ee[0];
                }
                B = P, N = W[1] + y, $ = W[0] - P, V = w, Math.abs($) < g && ($ = ($ < 0 ? -1 : 1) * g);
              } else {
                var W = n.dataToPoint([D, O]);
                if (f) {
                  var ee = n.dataToPoint([D, F]);
                  P = ee[1];
                }
                B = W[0] + y, N = P, $ = w, V = W[1] - P, Math.abs(V) < g && (V = (V <= 0 ? -1 : 1) * g);
              }
              p ? (E[T] = B, E[T + 1] = N, E[T + 2] = h ? $ : V, S && (S[T] = h ? R.x : B, S[T + 1] = h ? N : R.y, S[T + 2] = A), M[k] = k) : _.setItemLayout(k, {
                x: B,
                y: N,
                width: $,
                height: V
              }), T += 3;
            }
            p && _.setLayout({
              largePoints: E,
              largeDataIndices: M,
              largeBackgroundPoints: S,
              valueAxisHorizontal: h
            });
          }
        };
      }
    }
  };
}
function Ox(t) {
  return t.coordinateSystem && t.coordinateSystem.type === "cartesian2d";
}
function Ix(t) {
  return t.pipelineContext && t.pipelineContext.large;
}
function pfe(t, e) {
  var r = e.model.get("startValue");
  return r || (r = 0), e.toGlobalCoord(e.dataToCoord(e.type === "log" ? r > 0 ? r : 1 : r));
}
var gfe = function(t, e, r, n) {
  for (; r < n; ) {
    var a = r + n >>> 1;
    t[a][1] < e ? r = a + 1 : n = a;
  }
  return r;
}, Px = (
  /** @class */
  function(t) {
    K(e, t);
    function e(r) {
      var n = t.call(this, r) || this;
      return n.type = "time", n;
    }
    return e.prototype.getLabel = function(r) {
      var n = this.getSetting("useUTC");
      return js(r.value, Mm[Nue(ci(this._minLevelUnit))] || Mm.second, n, this.getSetting("locale"));
    }, e.prototype.getFormattedLabel = function(r, n, a) {
      var o = this.getSetting("useUTC"), i = this.getSetting("locale");
      return Bue(r, n, a, i, o);
    }, e.prototype.getTicks = function() {
      var r = this._interval, n = this._extent, a = [];
      if (!r)
        return a;
      a.push({
        value: n[0],
        level: 0
      });
      var o = this.getSetting("useUTC"), i = Cfe(this._minLevelUnit, this._approxInterval, o, n);
      return a = a.concat(i), a.push({
        value: n[1],
        level: 0
      }), a;
    }, e.prototype.calcNiceExtent = function(r) {
      var n = this._extent;
      if (n[0] === n[1] && (n[0] -= vr, n[1] += vr), n[1] === -1 / 0 && n[0] === 1 / 0) {
        var a = /* @__PURE__ */ new Date();
        n[1] = +new Date(a.getFullYear(), a.getMonth(), a.getDate()), n[0] = n[1] - vr;
      }
      this.calcNiceTicks(r.splitNumber, r.minInterval, r.maxInterval);
    }, e.prototype.calcNiceTicks = function(r, n, a) {
      r = r || 10;
      var o = this._extent, i = o[1] - o[0];
      this._approxInterval = i / r, n != null && this._approxInterval < n && (this._approxInterval = n), a != null && this._approxInterval > a && (this._approxInterval = a);
      var l = Nc.length, c = Math.min(gfe(Nc, this._approxInterval, 0, l), l - 1);
      this._interval = Nc[c][1], this._minLevelUnit = Nc[Math.max(c - 1, 0)][0];
    }, e.prototype.parse = function(r) {
      return De(r) ? r : +wr(r);
    }, e.prototype.contain = function(r) {
      return K1(this.parse(r), this._extent);
    }, e.prototype.normalize = function(r) {
      return Q1(this.parse(r), this._extent);
    }, e.prototype.scale = function(r) {
      return J1(r, this._extent);
    }, e.type = "time", e;
  }(Gi)
), Nc = [
  // Format                           interval
  ["second", g7],
  ["minute", m7],
  ["hour", $l],
  ["quarter-day", $l * 6],
  ["half-day", $l * 12],
  ["day", vr * 1.2],
  ["half-week", vr * 3.5],
  ["week", vr * 7],
  ["month", vr * 31],
  ["quarter", vr * 95],
  ["half-year", Rm / 2],
  ["year", Rm]
  // 1Y
];
function mfe(t, e, r, n) {
  var a = wr(e), o = wr(r), i = function(p) {
    return Am(a, p, n) === Am(o, p, n);
  }, l = function() {
    return i("year");
  }, c = function() {
    return l() && i("month");
  }, u = function() {
    return c() && i("day");
  }, d = function() {
    return u() && i("hour");
  }, f = function() {
    return d() && i("minute");
  }, h = function() {
    return f() && i("second");
  }, v = function() {
    return h() && i("millisecond");
  };
  switch (t) {
    case "year":
      return l();
    case "month":
      return c();
    case "day":
      return u();
    case "hour":
      return d();
    case "minute":
      return f();
    case "second":
      return h();
    case "millisecond":
      return v();
  }
}
function wfe(t, e) {
  return t /= vr, t > 16 ? 16 : t > 7.5 ? 7 : t > 3.5 ? 4 : t > 1.5 ? 2 : 1;
}
function yfe(t) {
  var e = 30 * vr;
  return t /= e, t > 6 ? 6 : t > 3 ? 3 : t > 2 ? 2 : 1;
}
function bfe(t) {
  return t /= $l, t > 12 ? 12 : t > 6 ? 6 : t > 3.5 ? 4 : t > 2 ? 2 : 1;
}
function N3(t, e) {
  return t /= e ? m7 : g7, t > 30 ? 30 : t > 20 ? 20 : t > 15 ? 15 : t > 10 ? 10 : t > 5 ? 5 : t > 2 ? 2 : 1;
}
function _fe(t) {
  return Xv(t, !0);
}
function xfe(t, e, r) {
  var n = new Date(t);
  switch (ci(e)) {
    case "year":
    case "month":
      n[u_(r)](0);
    case "day":
      n[d_(r)](1);
    case "hour":
      n[f_(r)](0);
    case "minute":
      n[h_(r)](0);
    case "second":
      n[v_(r)](0), n[p_(r)](0);
  }
  return n.getTime();
}
function Cfe(t, e, r, n) {
  var a = 1e4, o = s_, i = 0;
  function l(A, k, L, T, O, D, P) {
    for (var F = new Date(k), B = k, N = F[T](); B < L && B <= n[1]; )
      P.push({
        value: B
      }), N += A, F[O](N), B = F.getTime();
    P.push({
      value: B,
      notAdd: !0
    });
  }
  function c(A, k, L) {
    var T = [], O = !k.length;
    if (!mfe(ci(A), n[0], n[1], r)) {
      O && (k = [{
        // TODO Optimize. Not include so may ticks.
        value: xfe(new Date(n[0]), A, r)
      }, {
        value: n[1]
      }]);
      for (var D = 0; D < k.length - 1; D++) {
        var P = k[D].value, F = k[D + 1].value;
        if (P !== F) {
          var B = void 0, N = void 0, $ = void 0, V = !1;
          switch (A) {
            case "year":
              B = Math.max(1, Math.round(e / vr / 365)), N = w7(r), $ = Fue(r);
              break;
            case "half-year":
            case "quarter":
            case "month":
              B = yfe(e), N = ui(r), $ = u_(r);
              break;
            case "week":
            case "half-week":
            case "day":
              B = wfe(e), N = F1(r), $ = d_(r), V = !0;
              break;
            case "half-day":
            case "quarter-day":
            case "hour":
              B = bfe(e), N = ls(r), $ = f_(r);
              break;
            case "minute":
              B = N3(e, !0), N = $1(r), $ = h_(r);
              break;
            case "second":
              B = N3(e, !1), N = V1(r), $ = v_(r);
              break;
            case "millisecond":
              B = _fe(e), N = Z1(r), $ = p_(r);
              break;
          }
          l(B, P, F, N, $, V, T), A === "year" && L.length > 1 && D === 0 && L.unshift({
            value: L[0].value - B
          });
        }
      }
      for (var D = 0; D < T.length; D++)
        L.push(T[D]);
      return T;
    }
  }
  for (var u = [], d = [], f = 0, h = 0, v = 0; v < o.length && i++ < a; ++v) {
    var p = ci(o[v]);
    if (Due(o[v])) {
      c(o[v], u[u.length - 1] || [], d);
      var g = o[v + 1] ? ci(o[v + 1]) : null;
      if (p !== g) {
        if (d.length) {
          h = f, d.sort(function(A, k) {
            return A.value - k.value;
          });
          for (var m = [], w = 0; w < d.length; ++w) {
            var y = d[w].value;
            (w === 0 || d[w - 1].value !== y) && (m.push(d[w]), y >= n[0] && y <= n[1] && f++);
          }
          var b = (n[1] - n[0]) / e;
          if (f > b * 1.5 && h > b / 1.5 || (u.push(m), f > b || t === o[v]))
            break;
        }
        d = [];
      }
    }
  }
  process.env.NODE_ENV !== "production" && i >= a && pt("Exceed safe limit.");
  for (var _ = ot(J(u, function(A) {
    return ot(A, function(k) {
      return k.value >= n[0] && k.value <= n[1] && !k.notAdd;
    });
  }), function(A) {
    return A.length > 0;
  }), x = [], E = _.length - 1, v = 0; v < _.length; ++v)
    for (var S = _[v], M = 0; M < S.length; ++M)
      x.push({
        value: S[M].value,
        level: E - v
      });
  x.sort(function(A, k) {
    return A.value - k.value;
  });
  for (var R = [], v = 0; v < x.length; ++v)
    (v === 0 || x[v].value !== x[v - 1].value) && R.push(x[v]);
  return R;
}
on.registerClass(Px);
var B3 = on.prototype, jl = Gi.prototype, Efe = Qe, Sfe = Math.floor, Rfe = Math.ceil, Bc = Math.pow, Ar = Math.log, U7 = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = "log", r.base = 10, r._originalScale = new Gi(), r._interval = 0, r;
    }
    return e.prototype.getTicks = function(r) {
      var n = this._originalScale, a = this._extent, o = n.getExtent(), i = jl.getTicks.call(this, r);
      return J(i, function(l) {
        var c = l.value, u = Qe(Bc(this.base, c));
        return u = c === a[0] && this._fixMin ? Fc(u, o[0]) : u, u = c === a[1] && this._fixMax ? Fc(u, o[1]) : u, {
          value: u
        };
      }, this);
    }, e.prototype.setExtent = function(r, n) {
      var a = Ar(this.base);
      r = Ar(Math.max(0, r)) / a, n = Ar(Math.max(0, n)) / a, jl.setExtent.call(this, r, n);
    }, e.prototype.getExtent = function() {
      var r = this.base, n = B3.getExtent.call(this);
      n[0] = Bc(r, n[0]), n[1] = Bc(r, n[1]);
      var a = this._originalScale, o = a.getExtent();
      return this._fixMin && (n[0] = Fc(n[0], o[0])), this._fixMax && (n[1] = Fc(n[1], o[1])), n;
    }, e.prototype.unionExtent = function(r) {
      this._originalScale.unionExtent(r);
      var n = this.base;
      r[0] = Ar(r[0]) / Ar(n), r[1] = Ar(r[1]) / Ar(n), B3.unionExtent.call(this, r);
    }, e.prototype.unionExtentFromData = function(r, n) {
      this.unionExtent(r.getApproximateExtent(n));
    }, e.prototype.calcNiceTicks = function(r) {
      r = r || 10;
      var n = this._extent, a = n[1] - n[0];
      if (!(a === 1 / 0 || a <= 0)) {
        var o = u9(a), i = r / a * o;
        for (i <= 0.5 && (o *= 10); !isNaN(o) && Math.abs(o) < 1 && Math.abs(o) > 0; )
          o *= 10;
        var l = [Qe(Rfe(n[0] / o) * o), Qe(Sfe(n[1] / o) * o)];
        this._interval = o, this._niceExtent = l;
      }
    }, e.prototype.calcNiceExtent = function(r) {
      jl.calcNiceExtent.call(this, r), this._fixMin = r.fixMin, this._fixMax = r.fixMax;
    }, e.prototype.parse = function(r) {
      return r;
    }, e.prototype.contain = function(r) {
      return r = Ar(r) / Ar(this.base), K1(r, this._extent);
    }, e.prototype.normalize = function(r) {
      return r = Ar(r) / Ar(this.base), Q1(r, this._extent);
    }, e.prototype.scale = function(r) {
      return r = J1(r, this._extent), Bc(this.base, r);
    }, e.type = "log", e;
  }(on)
), Dx = U7.prototype;
Dx.getMinorTicks = jl.getMinorTicks;
Dx.getLabel = jl.getLabel;
function Fc(t, e) {
  return Efe(t, Pr(e));
}
on.registerClass(U7);
var Mfe = (
  /** @class */
  function() {
    function t(e, r, n) {
      this._prepareParams(e, r, n);
    }
    return t.prototype._prepareParams = function(e, r, n) {
      n[1] < n[0] && (n = [NaN, NaN]), this._dataMin = n[0], this._dataMax = n[1];
      var a = this._isOrdinal = e.type === "ordinal";
      this._needCrossZero = e.type === "interval" && r.getNeedCrossZero && r.getNeedCrossZero();
      var o = r.get("min", !0);
      o == null && (o = r.get("startValue", !0));
      var i = this._modelMinRaw = o;
      ie(i) ? this._modelMinNum = $c(e, i({
        min: n[0],
        max: n[1]
      })) : i !== "dataMin" && (this._modelMinNum = $c(e, i));
      var l = this._modelMaxRaw = r.get("max", !0);
      if (ie(l) ? this._modelMaxNum = $c(e, l({
        min: n[0],
        max: n[1]
      })) : l !== "dataMax" && (this._modelMaxNum = $c(e, l)), a)
        this._axisDataLen = r.getCategories().length;
      else {
        var c = r.get("boundaryGap"), u = z(c) ? c : [c || 0, c || 0];
        typeof u[0] == "boolean" || typeof u[1] == "boolean" ? (process.env.NODE_ENV !== "production" && console.warn('Boolean type for boundaryGap is only allowed for ordinal axis. Please use string in percentage instead, e.g., "20%". Currently, boundaryGap is set to be 0.'), this._boundaryGapInner = [0, 0]) : this._boundaryGapInner = [ca(u[0], 1), ca(u[1], 1)];
      }
    }, t.prototype.calculate = function() {
      var e = this._isOrdinal, r = this._dataMin, n = this._dataMax, a = this._axisDataLen, o = this._boundaryGapInner, i = e ? null : n - r || Math.abs(r), l = this._modelMinRaw === "dataMin" ? r : this._modelMinNum, c = this._modelMaxRaw === "dataMax" ? n : this._modelMaxNum, u = l != null, d = c != null;
      l == null && (l = e ? a ? 0 : NaN : r - o[0] * i), c == null && (c = e ? a ? a - 1 : NaN : n + o[1] * i), (l == null || !isFinite(l)) && (l = NaN), (c == null || !isFinite(c)) && (c = NaN);
      var f = _i(l) || _i(c) || e && !a;
      this._needCrossZero && (l > 0 && c > 0 && !u && (l = 0), l < 0 && c < 0 && !d && (c = 0));
      var h = this._determinedMin, v = this._determinedMax;
      return h != null && (l = h, u = !0), v != null && (c = v, d = !0), {
        min: l,
        max: c,
        minFixed: u,
        maxFixed: d,
        isBlank: f
      };
    }, t.prototype.modifyDataMinMax = function(e, r) {
      process.env.NODE_ENV !== "production" && ge(!this.frozen), this[kfe[e]] = r;
    }, t.prototype.setDeterminedMinMax = function(e, r) {
      var n = Afe[e];
      process.env.NODE_ENV !== "production" && ge(!this.frozen && this[n] == null), this[n] = r;
    }, t.prototype.freeze = function() {
      this.frozen = !0;
    }, t;
  }()
), Afe = {
  min: "_determinedMin",
  max: "_determinedMax"
}, kfe = {
  min: "_dataMin",
  max: "_dataMax"
};
function Nx(t, e, r) {
  var n = t.rawExtentInfo;
  return n || (n = new Mfe(t, e, r), t.rawExtentInfo = n, n);
}
function $c(t, e) {
  return e == null ? null : _i(e) ? NaN : t.parse(e);
}
function Bx(t, e) {
  var r = t.type, n = Nx(t, e, t.getExtent()).calculate();
  t.setBlank(n.isBlank);
  var a = n.min, o = n.max, i = e.ecModel;
  if (i && r === "time") {
    var l = Lx("bar", i), c = !1;
    if (I(l, function(f) {
      c = c || f.getBaseAxis() === e.axis;
    }), c) {
      var u = Tx(l), d = Lfe(a, o, e, u);
      a = d.min, o = d.max;
    }
  }
  return {
    extent: [a, o],
    // "fix" means "fixed", the value should not be
    // changed in the subsequent steps.
    fixMin: n.minFixed,
    fixMax: n.maxFixed
  };
}
function Lfe(t, e, r, n) {
  var a = r.axis.getExtent(), o = a[1] - a[0], i = ffe(n, r.axis);
  if (i === void 0)
    return {
      min: t,
      max: e
    };
  var l = 1 / 0;
  I(i, function(v) {
    l = Math.min(v.offset, l);
  });
  var c = -1 / 0;
  I(i, function(v) {
    c = Math.max(v.offset + v.width, c);
  }), l = Math.abs(l), c = Math.abs(c);
  var u = l + c, d = e - t, f = 1 - (l + c) / o, h = d / f - d;
  return e += h * (c / u), t -= h * (l / u), {
    min: t,
    max: e
  };
}
function i2(t, e) {
  var r = e, n = Bx(t, r), a = n.extent, o = r.get("splitNumber");
  t instanceof U7 && (t.base = r.get("logBase"));
  var i = t.type, l = r.get("interval"), c = i === "interval" || i === "time";
  t.setExtent(a[0], a[1]), t.calcNiceExtent({
    splitNumber: o,
    fixMin: n.fixMin,
    fixMax: n.fixMax,
    minInterval: c ? r.get("minInterval") : null,
    maxInterval: c ? r.get("maxInterval") : null
  }), l != null && t.setInterval && t.setInterval(l);
}
function Fx(t, e) {
  if (e = e || t.get("type"), e)
    switch (e) {
      case "category":
        return new W7({
          ordinalMeta: t.getOrdinalMeta ? t.getOrdinalMeta() : t.getCategories(),
          extent: [1 / 0, -1 / 0]
        });
      case "time":
        return new Px({
          locale: t.ecModel.getLocaleModel(),
          useUTC: t.ecModel.get("useUTC")
        });
      default:
        return new (on.getClass(e) || Gi)();
    }
}
function Tfe(t) {
  var e = t.scale.getExtent(), r = e[0], n = e[1];
  return !(r > 0 && n > 0 || r < 0 && n < 0);
}
function Ui(t) {
  var e = t.getLabelModel().get("formatter"), r = t.type === "category" ? t.scale.getExtent()[0] : null;
  return t.scale.type === "time" ? /* @__PURE__ */ function(n) {
    return function(a, o) {
      return t.scale.getFormattedLabel(a, o, n);
    };
  }(e) : Q(e) ? /* @__PURE__ */ function(n) {
    return function(a) {
      var o = t.scale.getLabel(a), i = n.replace("{value}", o ?? "");
      return i;
    };
  }(e) : ie(e) ? /* @__PURE__ */ function(n) {
    return function(a, o) {
      return r != null && (o = a.value - r), n(Y7(t, a), o, a.level != null ? {
        level: a.level
      } : null);
    };
  }(e) : function(n) {
    return t.scale.getLabel(n);
  };
}
function Y7(t, e) {
  return t.type === "category" ? t.scale.getLabel(e) : e.value;
}
function Ofe(t) {
  var e = t.model, r = t.scale;
  if (!(!e.get(["axisLabel", "show"]) || r.isBlank())) {
    var n, a, o = r.getExtent();
    r instanceof W7 ? a = r.count() : (n = r.getTicks(), a = n.length);
    var i = t.getLabelModel(), l = Ui(t), c, u = 1;
    a > 40 && (u = Math.ceil(a / 40));
    for (var d = 0; d < a; d += u) {
      var f = n ? n[d] : {
        value: o[0] + d
      }, h = l(f, d), v = i.getTextRect(h), p = Ife(v, i.get("rotate") || 0);
      c ? c.union(p) : c = p;
    }
    return c;
  }
}
function Ife(t, e) {
  var r = e * Math.PI / 180, n = t.width, a = t.height, o = n * Math.abs(Math.cos(r)) + Math.abs(a * Math.sin(r)), i = n * Math.abs(Math.sin(r)) + Math.abs(a * Math.cos(r)), l = new Le(t.x, t.y, o, i);
  return l;
}
function X7(t) {
  var e = t.get("interval");
  return e ?? "auto";
}
function $x(t) {
  return t.type === "category" && X7(t.getLabelModel()) === 0;
}
function Vx(t, e) {
  var r = {};
  return I(t.mapDimensionsAll(e), function(n) {
    r[j7(t, n)] = !0;
  }), Ze(r);
}
function Pfe(t, e, r) {
  e && I(Vx(e, r), function(n) {
    var a = e.getApproximateExtent(n);
    a[0] < t[0] && (t[0] = a[0]), a[1] > t[1] && (t[1] = a[1]);
  });
}
var Zx = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getNeedCrossZero = function() {
      var e = this.option;
      return !e.scale;
    }, t.prototype.getCoordSysModel = function() {
    }, t;
  }()
);
function Dfe(t) {
  return q1(null, t);
}
var Nfe = {
  isDimensionStacked: fa,
  enableDataStack: Mx,
  getStackedDimension: j7
};
function Bfe(t, e) {
  var r = e;
  e instanceof Ve || (r = new Ve(e));
  var n = Fx(r);
  return n.setExtent(t[0], t[1]), i2(n, r), n;
}
function Ffe(t) {
  tr(t, Zx);
}
function $fe(t, e) {
  return e = e || {}, jt(t, null, null, e.state !== "normal");
}
const Vfe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createDimensions: zde,
  createList: Dfe,
  createScale: Bfe,
  createSymbol: _r,
  createTextStyle: $fe,
  dataStack: Nfe,
  enableHoverEmphasis: as,
  getECData: Se,
  getLayoutRect: da,
  mixinAxisModelCommonMethods: Ffe
}, Symbol.toStringTag, { value: "Module" }));
var F3 = [], Zfe = {
  registerPreprocessor: F7,
  registerProcessor: $7,
  registerPostInit: px,
  registerPostUpdate: gx,
  registerUpdateLifecycle: X1,
  registerAction: ma,
  registerCoordinateSystem: mx,
  registerLayout: yx,
  registerVisual: wa,
  registerTransform: _x,
  registerLoading: Z7,
  registerMap: bx,
  registerImpl: ide,
  PRIORITY: ix,
  ComponentModel: Ee,
  ComponentView: _t,
  SeriesModel: Tt,
  ChartView: wt,
  // TODO Use ComponentModel and SeriesModel instead of Constructor
  registerComponentModel: function(t) {
    Ee.registerClass(t);
  },
  registerComponentView: function(t) {
    _t.registerClass(t);
  },
  registerSeriesModel: function(t) {
    Tt.registerClass(t);
  },
  registerChartView: function(t) {
    wt.registerClass(t);
  },
  registerSubTypeDefaulter: function(t, e) {
    Ee.registerSubTypeDefaulter(t, e);
  },
  registerPainter: function(t, e) {
    i9(t, e);
  }
};
function Gt(t) {
  if (z(t)) {
    I(t, function(e) {
      Gt(e);
    });
    return;
  }
  Re(F3, t) >= 0 || (F3.push(t), ie(t) && (t = {
    install: t
  }), t.install(Zfe));
}
var Hfe = 1e-8;
function $3(t, e) {
  return Math.abs(t - e) < Hfe;
}
function V3(t, e, r) {
  var n = 0, a = t[0];
  if (!a)
    return !1;
  for (var o = 1; o < t.length; o++) {
    var i = t[o];
    n += vn(a[0], a[1], i[0], i[1], e, r), a = i;
  }
  var l = t[0];
  return (!$3(a[0], l[0]) || !$3(a[1], l[1])) && (n += vn(a[0], a[1], l[0], l[1], e, r)), n !== 0;
}
var jfe = [];
function Ud(t, e) {
  for (var r = 0; r < t.length; r++)
    At(t[r], t[r], e);
}
function Z3(t, e, r, n) {
  for (var a = 0; a < t.length; a++) {
    var o = t[a];
    n && (o = n.project(o)), o && isFinite(o[0]) && isFinite(o[1]) && (jn(e, e, o), Wn(r, r, o));
  }
}
function Wfe(t) {
  for (var e = 0, r = 0, n = 0, a = t.length, o = t[a - 1][0], i = t[a - 1][1], l = 0; l < a; l++) {
    var c = t[l][0], u = t[l][1], d = o * u - c * i;
    e += d, r += (o + c) * d, n += (i + u) * d, o = c, i = u;
  }
  return e ? [r / e / 3, n / e / 3, e] : [t[0][0] || 0, t[0][1] || 0];
}
var Hx = (
  /** @class */
  function() {
    function t(e) {
      this.name = e;
    }
    return t.prototype.setCenter = function(e) {
      this._center = e;
    }, t.prototype.getCenter = function() {
      var e = this._center;
      return e || (e = this._center = this.calcCenter()), e;
    }, t;
  }()
), H3 = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e, r) {
      this.type = "polygon", this.exterior = e, this.interiors = r;
    }
    return t;
  }()
), j3 = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e) {
      this.type = "linestring", this.points = e;
    }
    return t;
  }()
), zfe = (
  /** @class */
  function(t) {
    K(e, t);
    function e(r, n, a) {
      var o = t.call(this, r) || this;
      return o.type = "geoJSON", o.geometries = n, o._center = a && [a[0], a[1]], o;
    }
    return e.prototype.calcCenter = function() {
      for (var r = this.geometries, n, a = 0, o = 0; o < r.length; o++) {
        var i = r[o], l = i.exterior, c = l && l.length;
        c > a && (n = i, a = c);
      }
      if (n)
        return Wfe(n.exterior);
      var u = this.getBoundingRect();
      return [u.x + u.width / 2, u.y + u.height / 2];
    }, e.prototype.getBoundingRect = function(r) {
      var n = this._rect;
      if (n && !r)
        return n;
      var a = [1 / 0, 1 / 0], o = [-1 / 0, -1 / 0], i = this.geometries;
      return I(i, function(l) {
        l.type === "polygon" ? Z3(l.exterior, a, o, r) : I(l.points, function(c) {
          Z3(c, a, o, r);
        });
      }), isFinite(a[0]) && isFinite(a[1]) && isFinite(o[0]) && isFinite(o[1]) || (a[0] = a[1] = o[0] = o[1] = 0), n = new Le(a[0], a[1], o[0] - a[0], o[1] - a[1]), r || (this._rect = n), n;
    }, e.prototype.contain = function(r) {
      var n = this.getBoundingRect(), a = this.geometries;
      if (!n.contain(r[0], r[1]))
        return !1;
      e: for (var o = 0, i = a.length; o < i; o++) {
        var l = a[o];
        if (l.type === "polygon") {
          var c = l.exterior, u = l.interiors;
          if (V3(c, r[0], r[1])) {
            for (var d = 0; d < (u ? u.length : 0); d++)
              if (V3(u[d], r[0], r[1]))
                continue e;
            return !0;
          }
        }
      }
      return !1;
    }, e.prototype.transformTo = function(r, n, a, o) {
      var i = this.getBoundingRect(), l = i.width / i.height;
      a ? o || (o = a / l) : a = l * o;
      for (var c = new Le(r, n, a, o), u = i.calculateTransform(c), d = this.geometries, f = 0; f < d.length; f++) {
        var h = d[f];
        h.type === "polygon" ? (Ud(h.exterior, u), I(h.interiors, function(v) {
          Ud(v, u);
        })) : I(h.points, function(v) {
          Ud(v, u);
        });
      }
      i = this._rect, i.copy(c), this._center = [i.x + i.width / 2, i.y + i.height / 2];
    }, e.prototype.cloneShallow = function(r) {
      r == null && (r = this.name);
      var n = new e(r, this.geometries, this._center);
      return n._rect = this._rect, n.transformTo = null, n;
    }, e;
  }(Hx)
);
(function(t) {
  K(e, t);
  function e(r, n) {
    var a = t.call(this, r) || this;
    return a.type = "geoSVG", a._elOnlyForCalculate = n, a;
  }
  return e.prototype.calcCenter = function() {
    for (var r = this._elOnlyForCalculate, n = r.getBoundingRect(), a = [n.x + n.width / 2, n.y + n.height / 2], o = Ls(jfe), i = r; i && !i.isGeoSVGGraphicRoot; )
      ra(o, i.getLocalTransform(), o), i = i.parent;
    return Ts(o, o), At(a, a, o), a;
  }, e;
})(Hx);
function Gfe(t) {
  if (!t.UTF8Encoding)
    return t;
  var e = t, r = e.UTF8Scale;
  r == null && (r = 1024);
  var n = e.features;
  return I(n, function(a) {
    var o = a.geometry, i = o.encodeOffsets, l = o.coordinates;
    if (i)
      switch (o.type) {
        case "LineString":
          o.coordinates = jx(l, i, r);
          break;
        case "Polygon":
          Yd(l, i, r);
          break;
        case "MultiLineString":
          Yd(l, i, r);
          break;
        case "MultiPolygon":
          I(l, function(c, u) {
            return Yd(c, i[u], r);
          });
      }
  }), e.UTF8Encoding = !1, e;
}
function Yd(t, e, r) {
  for (var n = 0; n < t.length; n++)
    t[n] = jx(t[n], e[n], r);
}
function jx(t, e, r) {
  for (var n = [], a = e[0], o = e[1], i = 0; i < t.length; i += 2) {
    var l = t.charCodeAt(i) - 64, c = t.charCodeAt(i + 1) - 64;
    l = l >> 1 ^ -(l & 1), c = c >> 1 ^ -(c & 1), l += a, c += o, a = l, o = c, n.push([l / r, c / r]);
  }
  return n;
}
function W3(t, e) {
  return t = Gfe(t), J(ot(t.features, function(r) {
    return r.geometry && r.properties && r.geometry.coordinates.length > 0;
  }), function(r) {
    var n = r.properties, a = r.geometry, o = [];
    switch (a.type) {
      case "Polygon":
        var i = a.coordinates;
        o.push(new H3(i[0], i.slice(1)));
        break;
      case "MultiPolygon":
        I(a.coordinates, function(c) {
          c[0] && o.push(new H3(c[0], c.slice(1)));
        });
        break;
      case "LineString":
        o.push(new j3([a.coordinates]));
        break;
      case "MultiLineString":
        o.push(new j3(a.coordinates));
    }
    var l = new zfe(n[e || "name"], o, n.cp);
    return l.properties = n, l;
  });
}
const Ufe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MAX_SAFE_INTEGER: ece,
  asc: Jo,
  getPercentWithPrecision: Qse,
  getPixelPrecision: Uv,
  getPrecision: Pr,
  getPrecisionSafe: K0,
  isNumeric: qv,
  isRadianAroundZero: Jl,
  linearMap: Ge,
  nice: Xv,
  numericToNumber: es,
  parseDate: wr,
  quantile: rce,
  quantity: u9,
  quantityExponent: Is,
  reformIntervals: nce,
  remRadian: Yv,
  round: Qe
}, Symbol.toStringTag, { value: "Module" })), Yfe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  format: js,
  parse: wr
}, Symbol.toStringTag, { value: "Module" })), Xfe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Arc: Vs,
  BezierCurve: $s,
  BoundingRect: Le,
  Circle: Bs,
  CompoundPath: j9,
  Ellipse: T1,
  Group: Xe,
  Image: nn,
  IncrementalDisplayable: G9,
  Line: br,
  LinearGradient: i7,
  Polygon: Fs,
  Polyline: mo,
  RadialGradient: z9,
  Rect: He,
  Ring: O1,
  Sector: $r,
  Text: Ye,
  clipPointsByRect: e_,
  clipRectByRect: t_,
  createIcon: P1,
  extendPath: Y9,
  extendShape: U9,
  getShapeClass: X9,
  getTransform: d7,
  initProps: dt,
  makeImage: c7,
  makePath: I1,
  mergePath: K9,
  registerShape: xr,
  resizePath: u7,
  updateProps: rt
}, Symbol.toStringTag, { value: "Module" })), qfe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addCommas: y7,
  capitalFirst: Zue,
  encodeHTML: Ft,
  formatTime: Vue,
  formatTpl: _7,
  getTextRect: $ue,
  getTooltipMarker: g_,
  normalizeCssArray: Ws,
  toCamelCase: b7,
  truncateText: b9
}, Symbol.toStringTag, { value: "Module" })), Kfe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bind: le,
  clone: be,
  curry: Oe,
  defaults: Te,
  each: I,
  extend: H,
  filter: ot,
  indexOf: Re,
  inherits: Pv,
  isArray: z,
  isFunction: ie,
  isObject: re,
  isString: Q,
  map: J,
  merge: Ce,
  reduce: tn
}, Symbol.toStringTag, { value: "Module" }));
var fs = je();
function Wx(t, e) {
  var r = J(e, function(n) {
    return t.scale.parse(n);
  });
  return t.type === "time" && r.length > 0 && (r.sort(), r.unshift(r[0]), r.push(r[r.length - 1])), r;
}
function Qfe(t) {
  var e = t.getLabelModel().get("customValues");
  if (e) {
    var r = Ui(t);
    return {
      labels: Wx(t, e).map(function(n) {
        var a = {
          value: n
        };
        return {
          formattedLabel: r(a),
          rawLabel: t.scale.getLabel(a),
          tickValue: n
        };
      })
    };
  }
  return t.type === "category" ? ehe(t) : rhe(t);
}
function Jfe(t, e) {
  var r = t.getTickModel().get("customValues");
  return r ? {
    ticks: Wx(t, r)
  } : t.type === "category" ? the(t, e) : {
    ticks: J(t.scale.getTicks(), function(n) {
      return n.value;
    })
  };
}
function ehe(t) {
  var e = t.getLabelModel(), r = zx(t, e);
  return !e.get("show") || t.scale.isBlank() ? {
    labels: [],
    labelCategoryInterval: r.labelCategoryInterval
  } : r;
}
function zx(t, e) {
  var r = Gx(t, "labels"), n = X7(e), a = Ux(r, n);
  if (a)
    return a;
  var o, i;
  return ie(n) ? o = qx(t, n) : (i = n === "auto" ? nhe(t) : n, o = Xx(t, i)), Yx(r, n, {
    labels: o,
    labelCategoryInterval: i
  });
}
function the(t, e) {
  var r = Gx(t, "ticks"), n = X7(e), a = Ux(r, n);
  if (a)
    return a;
  var o, i;
  if ((!e.get("show") || t.scale.isBlank()) && (o = []), ie(n))
    o = qx(t, n, !0);
  else if (n === "auto") {
    var l = zx(t, t.getLabelModel());
    i = l.labelCategoryInterval, o = J(l.labels, function(c) {
      return c.tickValue;
    });
  } else
    i = n, o = Xx(t, i, !0);
  return Yx(r, n, {
    ticks: o,
    tickCategoryInterval: i
  });
}
function rhe(t) {
  var e = t.scale.getTicks(), r = Ui(t);
  return {
    labels: J(e, function(n, a) {
      return {
        level: n.level,
        formattedLabel: r(n, a),
        rawLabel: t.scale.getLabel(n),
        tickValue: n.value
      };
    })
  };
}
function Gx(t, e) {
  return fs(t)[e] || (fs(t)[e] = []);
}
function Ux(t, e) {
  for (var r = 0; r < t.length; r++)
    if (t[r].key === e)
      return t[r].value;
}
function Yx(t, e, r) {
  return t.push({
    key: e,
    value: r
  }), r;
}
function nhe(t) {
  var e = fs(t).autoInterval;
  return e ?? (fs(t).autoInterval = t.calculateCategoryInterval());
}
function ahe(t) {
  var e = ohe(t), r = Ui(t), n = (e.axisRotate - e.labelRotate) / 180 * Math.PI, a = t.scale, o = a.getExtent(), i = a.count();
  if (o[1] - o[0] < 1)
    return 0;
  var l = 1;
  i > 40 && (l = Math.max(1, Math.floor(i / 40)));
  for (var c = o[0], u = t.dataToCoord(c + 1) - t.dataToCoord(c), d = Math.abs(u * Math.cos(n)), f = Math.abs(u * Math.sin(n)), h = 0, v = 0; c <= o[1]; c += l) {
    var p = 0, g = 0, m = zv(r({
      value: c
    }), e.font, "center", "top");
    p = m.width * 1.3, g = m.height * 1.3, h = Math.max(h, p, 7), v = Math.max(v, g, 7);
  }
  var w = h / d, y = v / f;
  isNaN(w) && (w = 1 / 0), isNaN(y) && (y = 1 / 0);
  var b = Math.max(0, Math.floor(Math.min(w, y))), _ = fs(t.model), x = t.getExtent(), E = _.lastAutoInterval, S = _.lastTickCount;
  return E != null && S != null && Math.abs(E - b) <= 1 && Math.abs(S - i) <= 1 && E > b && _.axisExtent0 === x[0] && _.axisExtent1 === x[1] ? b = E : (_.lastTickCount = i, _.lastAutoInterval = b, _.axisExtent0 = x[0], _.axisExtent1 = x[1]), b;
}
function ohe(t) {
  var e = t.getLabelModel();
  return {
    axisRotate: t.getRotate ? t.getRotate() : t.isHorizontal && !t.isHorizontal() ? 90 : 0,
    labelRotate: e.get("rotate") || 0,
    font: e.getFont()
  };
}
function Xx(t, e, r) {
  var n = Ui(t), a = t.scale, o = a.getExtent(), i = t.getLabelModel(), l = [], c = Math.max((e || 0) + 1, 1), u = o[0], d = a.count();
  u !== 0 && c > 1 && d / c > 2 && (u = Math.round(Math.ceil(u / c) * c));
  var f = $x(t), h = i.get("showMinLabel") || f, v = i.get("showMaxLabel") || f;
  h && u !== o[0] && g(o[0]);
  for (var p = u; p <= o[1]; p += c)
    g(p);
  v && p - c !== o[1] && g(o[1]);
  function g(m) {
    var w = {
      value: m
    };
    l.push(r ? m : {
      formattedLabel: n(w),
      rawLabel: a.getLabel(w),
      tickValue: m
    });
  }
  return l;
}
function qx(t, e, r) {
  var n = t.scale, a = Ui(t), o = [];
  return I(n.getTicks(), function(i) {
    var l = n.getLabel(i), c = i.value;
    e(i.value, l) && o.push(r ? c : {
      formattedLabel: a(i),
      rawLabel: l,
      tickValue: c
    });
  }), o;
}
var z3 = [0, 1], Kx = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.onBand = !1, this.inverse = !1, this.dim = e, this.scale = r, this._extent = n || [0, 0];
    }
    return t.prototype.contain = function(e) {
      var r = this._extent, n = Math.min(r[0], r[1]), a = Math.max(r[0], r[1]);
      return e >= n && e <= a;
    }, t.prototype.containData = function(e) {
      return this.scale.contain(e);
    }, t.prototype.getExtent = function() {
      return this._extent.slice();
    }, t.prototype.getPixelPrecision = function(e) {
      return Uv(e || this.scale.getExtent(), this._extent);
    }, t.prototype.setExtent = function(e, r) {
      var n = this._extent;
      n[0] = e, n[1] = r;
    }, t.prototype.dataToCoord = function(e, r) {
      var n = this._extent, a = this.scale;
      return e = a.normalize(e), this.onBand && a.type === "ordinal" && (n = n.slice(), G3(n, a.count())), Ge(e, z3, n, r);
    }, t.prototype.coordToData = function(e, r) {
      var n = this._extent, a = this.scale;
      this.onBand && a.type === "ordinal" && (n = n.slice(), G3(n, a.count()));
      var o = Ge(e, n, z3, r);
      return this.scale.scale(o);
    }, t.prototype.pointToData = function(e, r) {
    }, t.prototype.getTicksCoords = function(e) {
      e = e || {};
      var r = e.tickModel || this.getTickModel(), n = Jfe(this, r), a = n.ticks, o = J(a, function(l) {
        return {
          coord: this.dataToCoord(this.scale.type === "ordinal" ? this.scale.getRawOrdinalNumber(l) : l),
          tickValue: l
        };
      }, this), i = r.get("alignWithLabel");
      return ihe(this, o, i, e.clamp), o;
    }, t.prototype.getMinorTicksCoords = function() {
      if (this.scale.type === "ordinal")
        return [];
      var e = this.model.getModel("minorTick"), r = e.get("splitNumber");
      r > 0 && r < 100 || (r = 5);
      var n = this.scale.getMinorTicks(r), a = J(n, function(o) {
        return J(o, function(i) {
          return {
            coord: this.dataToCoord(i),
            tickValue: i
          };
        }, this);
      }, this);
      return a;
    }, t.prototype.getViewLabels = function() {
      return Qfe(this).labels;
    }, t.prototype.getLabelModel = function() {
      return this.model.getModel("axisLabel");
    }, t.prototype.getTickModel = function() {
      return this.model.getModel("axisTick");
    }, t.prototype.getBandWidth = function() {
      var e = this._extent, r = this.scale.getExtent(), n = r[1] - r[0] + (this.onBand ? 1 : 0);
      n === 0 && (n = 1);
      var a = Math.abs(e[1] - e[0]);
      return Math.abs(a) / n;
    }, t.prototype.calculateCategoryInterval = function() {
      return ahe(this);
    }, t;
  }()
);
function G3(t, e) {
  var r = t[1] - t[0], n = e, a = r / n / 2;
  t[0] += a, t[1] -= a;
}
function ihe(t, e, r, n) {
  var a = e.length;
  if (!t.onBand || r || !a)
    return;
  var o = t.getExtent(), i, l;
  if (a === 1)
    e[0].coord = o[0], i = e[1] = {
      coord: o[1]
    };
  else {
    var c = e[a - 1].tickValue - e[0].tickValue, u = (e[a - 1].coord - e[0].coord) / c;
    I(e, function(v) {
      v.coord -= u / 2;
    });
    var d = t.scale.getExtent();
    l = 1 + d[1] - e[a - 1].tickValue, i = {
      coord: e[a - 1].coord + u * l
    }, e.push(i);
  }
  var f = o[0] > o[1];
  h(e[0].coord, o[0]) && (n ? e[0].coord = o[0] : e.shift()), n && h(o[0], e[0].coord) && e.unshift({
    coord: o[0]
  }), h(o[1], i.coord) && (n ? i.coord = o[1] : e.pop()), n && h(i.coord, o[1]) && e.push({
    coord: o[1]
  });
  function h(v, p) {
    return v = Qe(v), p = Qe(p), f ? v > p : v < p;
  }
}
function lhe(t) {
  var e = Ee.extend(t);
  return Ee.registerClass(e), e;
}
function she(t) {
  var e = _t.extend(t);
  return _t.registerClass(e), e;
}
function che(t) {
  var e = Tt.extend(t);
  return Tt.registerClass(e), e;
}
function uhe(t) {
  var e = wt.extend(t);
  return wt.registerClass(e), e;
}
function Qx(t, e, r, n, a, o, i, l) {
  var c = a - t, u = o - e, d = r - t, f = n - e, h = Math.sqrt(d * d + f * f);
  d /= h, f /= h;
  var v = c * d + u * f, p = v / h;
  p *= h;
  var g = i[0] = t + p * d, m = i[1] = e + p * f;
  return Math.sqrt((g - a) * (g - a) + (m - o) * (m - o));
}
var Un = new he(), Je = new he(), ct = new he(), Yn = new he(), qr = new he(), bu = [], Mt = new he();
function dhe(t, e) {
  if (e <= 180 && e > 0) {
    e = e / 180 * Math.PI, Un.fromArray(t[0]), Je.fromArray(t[1]), ct.fromArray(t[2]), he.sub(Yn, Un, Je), he.sub(qr, ct, Je);
    var r = Yn.len(), n = qr.len();
    if (!(r < 1e-3 || n < 1e-3)) {
      Yn.scale(1 / r), qr.scale(1 / n);
      var a = Yn.dot(qr), o = Math.cos(e);
      if (o < a) {
        var i = Qx(Je.x, Je.y, ct.x, ct.y, Un.x, Un.y, bu);
        Mt.fromArray(bu), Mt.scaleAndAdd(qr, i / Math.tan(Math.PI - e));
        var l = ct.x !== Je.x ? (Mt.x - Je.x) / (ct.x - Je.x) : (Mt.y - Je.y) / (ct.y - Je.y);
        if (isNaN(l))
          return;
        l < 0 ? he.copy(Mt, Je) : l > 1 && he.copy(Mt, ct), Mt.toArray(t[1]);
      }
    }
  }
}
function fhe(t, e, r) {
  if (r <= 180 && r > 0) {
    r = r / 180 * Math.PI, Un.fromArray(t[0]), Je.fromArray(t[1]), ct.fromArray(t[2]), he.sub(Yn, Je, Un), he.sub(qr, ct, Je);
    var n = Yn.len(), a = qr.len();
    if (!(n < 1e-3 || a < 1e-3)) {
      Yn.scale(1 / n), qr.scale(1 / a);
      var o = Yn.dot(e), i = Math.cos(r);
      if (o < i) {
        var l = Qx(Je.x, Je.y, ct.x, ct.y, Un.x, Un.y, bu);
        Mt.fromArray(bu);
        var c = Math.PI / 2, u = Math.acos(qr.dot(e)), d = c + u - r;
        if (d >= c)
          he.copy(Mt, ct);
        else {
          Mt.scaleAndAdd(qr, l / Math.tan(Math.PI / 2 - d));
          var f = ct.x !== Je.x ? (Mt.x - Je.x) / (ct.x - Je.x) : (Mt.y - Je.y) / (ct.y - Je.y);
          if (isNaN(f))
            return;
          f < 0 ? he.copy(Mt, Je) : f > 1 && he.copy(Mt, ct);
        }
        Mt.toArray(t[1]);
      }
    }
  }
}
function Xd(t, e, r, n) {
  var a = r === "normal", o = a ? t : t.ensureState(r);
  o.ignore = e;
  var i = n.get("smooth");
  i && i === !0 && (i = 0.3), o.shape = o.shape || {}, i > 0 && (o.shape.smooth = i);
  var l = n.getModel("lineStyle").getLineStyle();
  a ? t.useStyle(l) : o.style = l;
}
function hhe(t, e) {
  var r = e.smooth, n = e.points;
  if (n)
    if (t.moveTo(n[0][0], n[0][1]), r > 0 && n.length >= 3) {
      var a = H0(n[0], n[1]), o = H0(n[1], n[2]);
      if (!a || !o) {
        t.lineTo(n[1][0], n[1][1]), t.lineTo(n[2][0], n[2][1]);
        return;
      }
      var i = Math.min(a, o) * r, l = f0([], n[1], n[0], i / a), c = f0([], n[1], n[2], i / o), u = f0([], l, c, 0.5);
      t.bezierCurveTo(l[0], l[1], l[0], l[1], u[0], u[1]), t.bezierCurveTo(c[0], c[1], c[0], c[1], n[2][0], n[2][1]);
    } else
      for (var d = 1; d < n.length; d++)
        t.lineTo(n[d][0], n[d][1]);
}
function vhe(t, e, r) {
  var n = t.getTextGuideLine(), a = t.getTextContent();
  if (!a) {
    n && t.removeTextGuideLine();
    return;
  }
  for (var o = e.normal, i = o.get("show"), l = a.ignore, c = 0; c < tu.length; c++) {
    var u = tu[c], d = e[u], f = u === "normal";
    if (d) {
      var h = d.get("show"), v = f ? l : de(a.states[u] && a.states[u].ignore, l);
      if (v || !de(h, i)) {
        var p = f ? n : n && n.states[u];
        p && (p.ignore = !0), n && Xd(n, !0, u, d);
        continue;
      }
      n || (n = new mo(), t.setTextGuideLine(n), !f && (l || !i) && Xd(n, !0, "normal", e.normal), t.stateProxy && (n.stateProxy = t.stateProxy)), Xd(n, !1, u, d);
    }
  }
  if (n) {
    Te(n.style, r), n.style.fill = null;
    var g = o.get("showAbove"), m = t.textGuideLineConfig = t.textGuideLineConfig || {};
    m.showAbove = g || !1, n.buildPath = hhe;
  }
}
function phe(t, e) {
  e = e || "labelLine";
  for (var r = {
    normal: t.getModel(e)
  }, n = 0; n < Wt.length; n++) {
    var a = Wt[n];
    r[a] = t.getModel([a, e]);
  }
  return r;
}
function ghe(t) {
  for (var e = [], r = 0; r < t.length; r++) {
    var n = t[r];
    if (!n.defaultAttr.ignore) {
      var a = n.label, o = a.getComputedTransform(), i = a.getBoundingRect(), l = !o || o[1] < 1e-5 && o[2] < 1e-5, c = a.style.margin || 0, u = i.clone();
      u.applyTransform(o), u.x -= c / 2, u.y -= c / 2, u.width += c, u.height += c;
      var d = l ? new ru(i, o) : null;
      e.push({
        label: a,
        labelLine: n.labelLine,
        rect: u,
        localRect: i,
        obb: d,
        priority: n.priority,
        defaultAttr: n.defaultAttr,
        layoutOption: n.computedLayoutOption,
        axisAligned: l,
        transform: o
      });
    }
  }
  return e;
}
function mhe(t, e, r, n, a, o) {
  var i = t.length;
  if (i < 2)
    return;
  t.sort(function(M, R) {
    return M.rect[e] - R.rect[e];
  });
  for (var l = 0, c, u = !1, d = 0, f = 0; f < i; f++) {
    var h = t[f], v = h.rect;
    c = v[e] - l, c < 0 && (v[e] -= c, h.label[e] -= c, u = !0);
    var p = Math.max(-c, 0);
    d += p, l = v[e] + v[r];
  }
  d > 0 && o && x(-d / i, 0, i);
  var g = t[0], m = t[i - 1], w, y;
  b(), w < 0 && E(-w, 0.8), y < 0 && E(y, 0.8), b(), _(w, y, 1), _(y, w, -1), b(), w < 0 && S(-w), y < 0 && S(y);
  function b() {
    w = g.rect[e] - n, y = a - m.rect[e] - m.rect[r];
  }
  function _(M, R, A) {
    if (M < 0) {
      var k = Math.min(R, -M);
      if (k > 0) {
        x(k * A, 0, i);
        var L = k + M;
        L < 0 && E(-L * A, 1);
      } else
        E(-M * A, 1);
    }
  }
  function x(M, R, A) {
    M !== 0 && (u = !0);
    for (var k = R; k < A; k++) {
      var L = t[k], T = L.rect;
      T[e] += M, L.label[e] += M;
    }
  }
  function E(M, R) {
    for (var A = [], k = 0, L = 1; L < i; L++) {
      var T = t[L - 1].rect, O = Math.max(t[L].rect[e] - T[e] - T[r], 0);
      A.push(O), k += O;
    }
    if (k) {
      var D = Math.min(Math.abs(M) / k, R);
      if (M > 0)
        for (var L = 0; L < i - 1; L++) {
          var P = A[L] * D;
          x(P, 0, L + 1);
        }
      else
        for (var L = i - 1; L > 0; L--) {
          var P = A[L - 1] * D;
          x(-P, L, i);
        }
    }
  }
  function S(M) {
    var R = M < 0 ? -1 : 1;
    M = Math.abs(M);
    for (var A = Math.ceil(M / (i - 1)), k = 0; k < i - 1; k++)
      if (R > 0 ? x(A, 0, k + 1) : x(-A, i - k - 1, i), M -= A, M <= 0)
        return;
  }
  return u;
}
function whe(t, e, r, n) {
  return mhe(t, "y", "height", e, r, n);
}
function yhe(t) {
  var e = [];
  t.sort(function(g, m) {
    return m.priority - g.priority;
  });
  var r = new Le(0, 0, 0, 0);
  function n(g) {
    if (!g.ignore) {
      var m = g.ensureState("emphasis");
      m.ignore == null && (m.ignore = !1);
    }
    g.ignore = !0;
  }
  for (var a = 0; a < t.length; a++) {
    var o = t[a], i = o.axisAligned, l = o.localRect, c = o.transform, u = o.label, d = o.labelLine;
    r.copy(o.rect), r.width -= 0.1, r.height -= 0.1, r.x += 0.05, r.y += 0.05;
    for (var f = o.obb, h = !1, v = 0; v < e.length; v++) {
      var p = e[v];
      if (r.intersect(p.rect)) {
        if (i && p.axisAligned) {
          h = !0;
          break;
        }
        if (p.obb || (p.obb = new ru(p.localRect, p.transform)), f || (f = new ru(l, c)), f.intersect(p.obb)) {
          h = !0;
          break;
        }
      }
    }
    h ? (n(u), d && n(d)) : (u.attr("ignore", o.defaultAttr.ignore), d && d.attr("ignore", o.defaultAttr.labelGuideIgnore), e.push(o));
  }
}
const e5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Axis: Kx,
  ChartView: wt,
  ComponentModel: Ee,
  ComponentView: _t,
  List: fi,
  Model: Ve,
  PRIORITY: ix,
  SeriesModel: Tt,
  color: wse,
  connect: Rde,
  dataTool: Ide,
  dependencies: sde,
  disConnect: Mde,
  disconnect: vx,
  dispose: Ade,
  env: ue,
  extendChartView: uhe,
  extendComponentModel: lhe,
  extendComponentView: she,
  extendSeriesModel: che,
  format: qfe,
  getCoordinateSystemDimensions: Lde,
  getInstanceByDom: N7,
  getInstanceById: kde,
  getMap: Ode,
  graphic: Xfe,
  helper: Vfe,
  init: Sde,
  innerDrawElementOnCanvas: O7,
  matrix: Gle,
  number: Ufe,
  parseGeoJSON: W3,
  parseGeoJson: W3,
  registerAction: ma,
  registerCoordinateSystem: mx,
  registerLayout: yx,
  registerLoading: Z7,
  registerLocale: p7,
  registerMap: bx,
  registerPostInit: px,
  registerPostUpdate: gx,
  registerPreprocessor: F7,
  registerProcessor: $7,
  registerTheme: B7,
  registerTransform: _x,
  registerUpdateLifecycle: X1,
  registerVisual: wa,
  setCanvasCreator: Tde,
  setPlatformAPI: Lb,
  throttle: z1,
  time: Yfe,
  use: Gt,
  util: Kfe,
  vector: Lle,
  version: lde,
  zrUtil: ble,
  zrender: qse
}, Symbol.toStringTag, { value: "Module" }));
var bhe = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = e.type, r.hasSymbolVisual = !0, r;
    }
    return e.prototype.getInitialData = function(r) {
      if (process.env.NODE_ENV !== "production") {
        var n = r.coordinateSystem;
        if (n !== "polar" && n !== "cartesian2d")
          throw new Error("Line not support coordinateSystem besides cartesian and polar");
      }
      return q1(null, this, {
        useEncodeDefaulter: !0
      });
    }, e.prototype.getLegendIcon = function(r) {
      var n = new Xe(), a = _r("line", 0, r.itemHeight / 2, r.itemWidth, 0, r.lineStyle.stroke, !1);
      n.add(a), a.setStyle(r.lineStyle);
      var o = this.getData().getVisual("symbol"), i = this.getData().getVisual("symbolRotate"), l = o === "none" ? "circle" : o, c = r.itemHeight * 0.8, u = _r(l, (r.itemWidth - c) / 2, (r.itemHeight - c) / 2, c, c, r.itemStyle.fill);
      n.add(u), u.setStyle(r.itemStyle);
      var d = r.iconRotate === "inherit" ? i : r.iconRotate || 0;
      return u.rotation = d * Math.PI / 180, u.setOrigin([r.itemWidth / 2, r.itemHeight / 2]), l.indexOf("empty") > -1 && (u.style.stroke = u.style.fill, u.style.fill = "#fff", u.style.lineWidth = 2), n;
    }, e.type = "series.line", e.dependencies = ["grid", "polar"], e.defaultOption = {
      // zlevel: 0,
      z: 3,
      coordinateSystem: "cartesian2d",
      legendHoverLink: !0,
      clip: !0,
      label: {
        position: "top"
      },
      // itemStyle: {
      // },
      endLabel: {
        show: !1,
        valueAnimation: !0,
        distance: 8
      },
      lineStyle: {
        width: 2,
        type: "solid"
      },
      emphasis: {
        scale: !0
      },
      // areaStyle: {
      // origin of areaStyle. Valid values:
      // `'auto'/null/undefined`: from axisLine to data
      // `'start'`: from min to data
      // `'end'`: from data to max
      // origin: 'auto'
      // },
      // false, 'start', 'end', 'middle'
      step: !1,
      // Disabled if step is true
      smooth: !1,
      smoothMonotone: null,
      symbol: "emptyCircle",
      symbolSize: 4,
      symbolRotate: null,
      showSymbol: !0,
      // `false`: follow the label interval strategy.
      // `true`: show all symbols.
      // `'auto'`: If possible, show all symbols, otherwise
      //           follow the label interval strategy.
      showAllSymbol: "auto",
      // Whether to connect break point.
      connectNulls: !1,
      // Sampling for large data. Can be: 'average', 'max', 'min', 'sum', 'lttb'.
      sampling: "none",
      animationEasing: "linear",
      // Disable progressive
      progressive: 0,
      hoverLayerThreshold: 1 / 0,
      universalTransition: {
        divideShape: "clone"
      },
      triggerLineEvent: !1
    }, e;
  }(Tt)
);
function q7(t, e) {
  var r = t.mapDimensionsAll("defaultedLabel"), n = r.length;
  if (n === 1) {
    var a = Mi(t, e, r[0]);
    return a != null ? a + "" : null;
  } else if (n) {
    for (var o = [], i = 0; i < r.length; i++)
      o.push(Mi(t, e, r[i]));
    return o.join(" ");
  }
}
function Jx(t, e) {
  var r = t.mapDimensionsAll("defaultedLabel");
  if (!z(e))
    return e + "";
  for (var n = [], a = 0; a < r.length; a++) {
    var o = t.getDimensionIndex(r[a]);
    o >= 0 && n.push(e[o]);
  }
  return n.join(" ");
}
var K7 = (
  /** @class */
  function(t) {
    K(e, t);
    function e(r, n, a, o) {
      var i = t.call(this) || this;
      return i.updateData(r, n, a, o), i;
    }
    return e.prototype._createSymbol = function(r, n, a, o, i) {
      this.removeAll();
      var l = _r(r, -1, -1, 2, 2, null, i);
      l.attr({
        z2: 100,
        culling: !0,
        scaleX: o[0] / 2,
        scaleY: o[1] / 2
      }), l.drift = _he, this._symbolType = r, this.add(l);
    }, e.prototype.stopSymbolAnimation = function(r) {
      this.childAt(0).stopAnimation(null, r);
    }, e.prototype.getSymbolType = function() {
      return this._symbolType;
    }, e.prototype.getSymbolPath = function() {
      return this.childAt(0);
    }, e.prototype.highlight = function() {
      rs(this.childAt(0));
    }, e.prototype.downplay = function() {
      ns(this.childAt(0));
    }, e.prototype.setZ = function(r, n) {
      var a = this.childAt(0);
      a.zlevel = r, a.z = n;
    }, e.prototype.setDraggable = function(r, n) {
      var a = this.childAt(0);
      a.draggable = r, a.cursor = !n && r ? "move" : a.cursor;
    }, e.prototype.updateData = function(r, n, a, o) {
      this.silent = !1;
      var i = r.getItemVisual(n, "symbol") || "circle", l = r.hostModel, c = e.getSymbolSize(r, n), u = i !== this._symbolType, d = o && o.disableAnimation;
      if (u) {
        var f = r.getItemVisual(n, "symbolKeepAspect");
        this._createSymbol(i, r, n, c, f);
      } else {
        var h = this.childAt(0);
        h.silent = !1;
        var v = {
          scaleX: c[0] / 2,
          scaleY: c[1] / 2
        };
        d ? h.attr(v) : rt(h, v, l, n), s7(h);
      }
      if (this._updateCommon(r, n, c, a, o), u) {
        var h = this.childAt(0);
        if (!d) {
          var v = {
            scaleX: this._sizeX,
            scaleY: this._sizeY,
            style: {
              // Always fadeIn. Because it has fadeOut animation when symbol is removed..
              opacity: h.style.opacity
            }
          };
          h.scaleX = h.scaleY = 0, h.style.opacity = 0, dt(h, v, l, n);
        }
      }
      d && this.childAt(0).stopAnimation("leave");
    }, e.prototype._updateCommon = function(r, n, a, o, i) {
      var l = this.childAt(0), c = r.hostModel, u, d, f, h, v, p, g, m, w;
      if (o && (u = o.emphasisItemStyle, d = o.blurItemStyle, f = o.selectItemStyle, h = o.focus, v = o.blurScope, g = o.labelStatesModels, m = o.hoverScale, w = o.cursorStyle, p = o.emphasisDisabled), !o || r.hasItemOption) {
        var y = o && o.itemModel ? o.itemModel : r.getItemModel(n), b = y.getModel("emphasis");
        u = b.getModel("itemStyle").getItemStyle(), f = y.getModel(["select", "itemStyle"]).getItemStyle(), d = y.getModel(["blur", "itemStyle"]).getItemStyle(), h = b.get("focus"), v = b.get("blurScope"), p = b.get("disabled"), g = wo(y), m = b.getShallow("scale"), w = y.getShallow("cursor");
      }
      var _ = r.getItemVisual(n, "symbolRotate");
      l.attr("rotation", (_ || 0) * Math.PI / 180 || 0);
      var x = U1(r.getItemVisual(n, "symbolOffset"), a);
      x && (l.x = x[0], l.y = x[1]), w && l.attr("cursor", w);
      var E = r.getItemVisual(n, "style"), S = E.fill;
      if (l instanceof nn) {
        var M = l.style;
        l.useStyle(H({
          // TODO other properties like x, y ?
          image: M.image,
          x: M.x,
          y: M.y,
          width: M.width,
          height: M.height
        }, E));
      } else
        l.__isEmptyBrush ? l.useStyle(H({}, E)) : l.useStyle(E), l.style.decal = null, l.setColor(S, i && i.symbolInnerColor), l.style.strokeNoScale = !0;
      var R = r.getItemVisual(n, "liftZ"), A = this._z2;
      R != null ? A == null && (this._z2 = l.z2, l.z2 += R) : A != null && (l.z2 = A, this._z2 = null);
      var k = i && i.useNameLabel;
      Wi(l, g, {
        labelFetcher: c,
        labelDataIndex: n,
        defaultText: L,
        inheritColor: S,
        defaultOpacity: E.opacity
      });
      function L(D) {
        return k ? r.getName(D) : q7(r, D);
      }
      this._sizeX = a[0] / 2, this._sizeY = a[1] / 2;
      var T = l.ensureState("emphasis");
      T.style = u, l.ensureState("select").style = f, l.ensureState("blur").style = d;
      var O = m == null || m === !0 ? Math.max(1.1, 3 / this._sizeY) : isFinite(m) && m > 0 ? +m : 1;
      T.scaleX = this._sizeX * O, T.scaleY = this._sizeY * O, this.setSymbolScale(1), ua(this, h, v, p);
    }, e.prototype.setSymbolScale = function(r) {
      this.scaleX = this.scaleY = r;
    }, e.prototype.fadeOut = function(r, n, a) {
      var o = this.childAt(0), i = Se(this).dataIndex, l = a && a.animation;
      if (this.silent = o.silent = !0, a && a.fadeLabel) {
        var c = o.getTextContent();
        c && nu(c, {
          style: {
            opacity: 0
          }
        }, n, {
          dataIndex: i,
          removeOpt: l,
          cb: function() {
            o.removeTextContent();
          }
        });
      } else
        o.removeTextContent();
      nu(o, {
        style: {
          opacity: 0
        },
        scaleX: 0,
        scaleY: 0
      }, n, {
        dataIndex: i,
        cb: r,
        removeOpt: l
      });
    }, e.getSymbolSize = function(r, n) {
      return T7(r.getItemVisual(n, "symbolSize"));
    }, e;
  }(Xe)
);
function _he(t, e) {
  this.parent.drift(t, e);
}
function qd(t, e, r, n) {
  return e && !isNaN(e[0]) && !isNaN(e[1]) && !(n.isIgnore && n.isIgnore(r)) && !(n.clipShape && !n.clipShape.contain(e[0], e[1])) && t.getItemVisual(r, "symbol") !== "none";
}
function U3(t) {
  return t != null && !re(t) && (t = {
    isIgnore: t
  }), t || {};
}
function Y3(t) {
  var e = t.hostModel, r = e.getModel("emphasis");
  return {
    emphasisItemStyle: r.getModel("itemStyle").getItemStyle(),
    blurItemStyle: e.getModel(["blur", "itemStyle"]).getItemStyle(),
    selectItemStyle: e.getModel(["select", "itemStyle"]).getItemStyle(),
    focus: r.get("focus"),
    blurScope: r.get("blurScope"),
    emphasisDisabled: r.get("disabled"),
    hoverScale: r.get("scale"),
    labelStatesModels: wo(e),
    cursorStyle: e.get("cursor")
  };
}
var xhe = (
  /** @class */
  function() {
    function t(e) {
      this.group = new Xe(), this._SymbolCtor = e || K7;
    }
    return t.prototype.updateData = function(e, r) {
      this._progressiveEls = null, r = U3(r);
      var n = this.group, a = e.hostModel, o = this._data, i = this._SymbolCtor, l = r.disableAnimation, c = Y3(e), u = {
        disableAnimation: l
      }, d = r.getSymbolPoint || function(f) {
        return e.getItemLayout(f);
      };
      o || n.removeAll(), e.diff(o).add(function(f) {
        var h = d(f);
        if (qd(e, h, f, r)) {
          var v = new i(e, f, c, u);
          v.setPosition(h), e.setItemGraphicEl(f, v), n.add(v);
        }
      }).update(function(f, h) {
        var v = o.getItemGraphicEl(h), p = d(f);
        if (!qd(e, p, f, r)) {
          n.remove(v);
          return;
        }
        var g = e.getItemVisual(f, "symbol") || "circle", m = v && v.getSymbolType && v.getSymbolType();
        if (!v || m && m !== g)
          n.remove(v), v = new i(e, f, c, u), v.setPosition(p);
        else {
          v.updateData(e, f, c, u);
          var w = {
            x: p[0],
            y: p[1]
          };
          l ? v.attr(w) : rt(v, w, a);
        }
        n.add(v), e.setItemGraphicEl(f, v);
      }).remove(function(f) {
        var h = o.getItemGraphicEl(f);
        h && h.fadeOut(function() {
          n.remove(h);
        }, a);
      }).execute(), this._getSymbolPoint = d, this._data = e;
    }, t.prototype.updateLayout = function() {
      var e = this, r = this._data;
      r && r.eachItemGraphicEl(function(n, a) {
        var o = e._getSymbolPoint(a);
        n.setPosition(o), n.markRedraw();
      });
    }, t.prototype.incrementalPrepareUpdate = function(e) {
      this._seriesScope = Y3(e), this._data = null, this.group.removeAll();
    }, t.prototype.incrementalUpdate = function(e, r, n) {
      this._progressiveEls = [], n = U3(n);
      function a(c) {
        c.isGroup || (c.incremental = !0, c.ensureState("emphasis").hoverLayer = !0);
      }
      for (var o = e.start; o < e.end; o++) {
        var i = r.getItemLayout(o);
        if (qd(r, i, o, n)) {
          var l = new this._SymbolCtor(r, o, this._seriesScope);
          l.traverse(a), l.setPosition(i), this.group.add(l), r.setItemGraphicEl(o, l), this._progressiveEls.push(l);
        }
      }
    }, t.prototype.eachRendered = function(e) {
      Zs(this._progressiveEls || this.group, e);
    }, t.prototype.remove = function(e) {
      var r = this.group, n = this._data;
      n && e ? n.eachItemGraphicEl(function(a) {
        a.fadeOut(function() {
          r.remove(a);
        }, n.hostModel);
      }) : r.removeAll();
    }, t;
  }()
);
function eC(t, e, r) {
  var n = t.getBaseAxis(), a = t.getOtherAxis(n), o = Che(a, r), i = n.dim, l = a.dim, c = e.mapDimension(l), u = e.mapDimension(i), d = l === "x" || l === "radius" ? 1 : 0, f = J(t.dimensions, function(p) {
    return e.mapDimension(p);
  }), h = !1, v = e.getCalculationInfo("stackResultDimension");
  return fa(
    e,
    f[0]
    /* , dims[1] */
  ) && (h = !0, f[0] = v), fa(
    e,
    f[1]
    /* , dims[0] */
  ) && (h = !0, f[1] = v), {
    dataDimsForPoint: f,
    valueStart: o,
    valueAxisDim: l,
    baseAxisDim: i,
    stacked: !!h,
    valueDim: c,
    baseDim: u,
    baseDataOffset: d,
    stackedOverDimension: e.getCalculationInfo("stackedOverDimension")
  };
}
function Che(t, e) {
  var r = 0, n = t.scale.getExtent();
  return e === "start" ? r = n[0] : e === "end" ? r = n[1] : De(e) && !isNaN(e) ? r = e : n[0] > 0 ? r = n[0] : n[1] < 0 && (r = n[1]), r;
}
function tC(t, e, r, n) {
  var a = NaN;
  t.stacked && (a = r.get(r.getCalculationInfo("stackedOverDimension"), n)), isNaN(a) && (a = t.valueStart);
  var o = t.baseDataOffset, i = [];
  return i[o] = r.get(t.baseDim, n), i[1 - o] = a, e.dataToPoint(i);
}
function Ehe(t, e) {
  var r = [];
  return e.diff(t).add(function(n) {
    r.push({
      cmd: "+",
      idx: n
    });
  }).update(function(n, a) {
    r.push({
      cmd: "=",
      idx: a,
      idx1: n
    });
  }).remove(function(n) {
    r.push({
      cmd: "-",
      idx: n
    });
  }).execute(), r;
}
function She(t, e, r, n, a, o, i, l) {
  for (var c = Ehe(t, e), u = [], d = [], f = [], h = [], v = [], p = [], g = [], m = eC(a, e, i), w = t.getLayout("points") || [], y = e.getLayout("points") || [], b = 0; b < c.length; b++) {
    var _ = c[b], x = !0, E = void 0, S = void 0;
    switch (_.cmd) {
      case "=":
        E = _.idx * 2, S = _.idx1 * 2;
        var M = w[E], R = w[E + 1], A = y[S], k = y[S + 1];
        (isNaN(M) || isNaN(R)) && (M = A, R = k), u.push(M, R), d.push(A, k), f.push(r[E], r[E + 1]), h.push(n[S], n[S + 1]), g.push(e.getRawIndex(_.idx1));
        break;
      case "+":
        var L = _.idx, T = m.dataDimsForPoint, O = a.dataToPoint([e.get(T[0], L), e.get(T[1], L)]);
        S = L * 2, u.push(O[0], O[1]), d.push(y[S], y[S + 1]);
        var D = tC(m, a, e, L);
        f.push(D[0], D[1]), h.push(n[S], n[S + 1]), g.push(e.getRawIndex(L));
        break;
      case "-":
        x = !1;
    }
    x && (v.push(_), p.push(p.length));
  }
  p.sort(function(we, pe) {
    return g[we] - g[pe];
  });
  for (var P = u.length, F = pn(P), B = pn(P), N = pn(P), $ = pn(P), V = [], b = 0; b < p.length; b++) {
    var W = p[b], ee = b * 2, ne = W * 2;
    F[ee] = u[ne], F[ee + 1] = u[ne + 1], B[ee] = d[ne], B[ee + 1] = d[ne + 1], N[ee] = f[ne], N[ee + 1] = f[ne + 1], $[ee] = h[ne], $[ee + 1] = h[ne + 1], V[b] = v[W];
  }
  return {
    current: F,
    next: B,
    stackedOnCurrent: N,
    stackedOnNext: $,
    status: V
  };
}
var Dn = Math.min, Nn = Math.max;
function Ja(t, e) {
  return isNaN(t) || isNaN(e);
}
function l2(t, e, r, n, a, o, i, l, c) {
  for (var u, d, f, h, v, p, g = r, m = 0; m < n; m++) {
    var w = e[g * 2], y = e[g * 2 + 1];
    if (g >= a || g < 0)
      break;
    if (Ja(w, y)) {
      if (c) {
        g += o;
        continue;
      }
      break;
    }
    if (g === r)
      t[o > 0 ? "moveTo" : "lineTo"](w, y), f = w, h = y;
    else {
      var b = w - u, _ = y - d;
      if (b * b + _ * _ < 0.5) {
        g += o;
        continue;
      }
      if (i > 0) {
        for (var x = g + o, E = e[x * 2], S = e[x * 2 + 1]; E === w && S === y && m < n; )
          m++, x += o, g += o, E = e[x * 2], S = e[x * 2 + 1], w = e[g * 2], y = e[g * 2 + 1], b = w - u, _ = y - d;
        var M = m + 1;
        if (c)
          for (; Ja(E, S) && M < n; )
            M++, x += o, E = e[x * 2], S = e[x * 2 + 1];
        var R = 0.5, A = 0, k = 0, L = void 0, T = void 0;
        if (M >= n || Ja(E, S))
          v = w, p = y;
        else {
          A = E - u, k = S - d;
          var O = w - u, D = E - w, P = y - d, F = S - y, B = void 0, N = void 0;
          if (l === "x") {
            B = Math.abs(O), N = Math.abs(D);
            var $ = A > 0 ? 1 : -1;
            v = w - $ * B * i, p = y, L = w + $ * N * i, T = y;
          } else if (l === "y") {
            B = Math.abs(P), N = Math.abs(F);
            var V = k > 0 ? 1 : -1;
            v = w, p = y - V * B * i, L = w, T = y + V * N * i;
          } else
            B = Math.sqrt(O * O + P * P), N = Math.sqrt(D * D + F * F), R = N / (N + B), v = w - A * i * (1 - R), p = y - k * i * (1 - R), L = w + A * i * R, T = y + k * i * R, L = Dn(L, Nn(E, w)), T = Dn(T, Nn(S, y)), L = Nn(L, Dn(E, w)), T = Nn(T, Dn(S, y)), A = L - w, k = T - y, v = w - A * B / N, p = y - k * B / N, v = Dn(v, Nn(u, w)), p = Dn(p, Nn(d, y)), v = Nn(v, Dn(u, w)), p = Nn(p, Dn(d, y)), A = w - v, k = y - p, L = w + A * N / B, T = y + k * N / B;
        }
        t.bezierCurveTo(f, h, v, p, w, y), f = L, h = T;
      } else
        t.lineTo(w, y);
    }
    u = w, d = y, g += o;
  }
  return m;
}
var rC = (
  /** @class */
  /* @__PURE__ */ function() {
    function t() {
      this.smooth = 0, this.smoothConstraint = !0;
    }
    return t;
  }()
), Rhe = (
  /** @class */
  function(t) {
    K(e, t);
    function e(r) {
      var n = t.call(this, r) || this;
      return n.type = "ec-polyline", n;
    }
    return e.prototype.getDefaultStyle = function() {
      return {
        stroke: "#000",
        fill: null
      };
    }, e.prototype.getDefaultShape = function() {
      return new rC();
    }, e.prototype.buildPath = function(r, n) {
      var a = n.points, o = 0, i = a.length / 2;
      if (n.connectNulls) {
        for (; i > 0 && Ja(a[i * 2 - 2], a[i * 2 - 1]); i--)
          ;
        for (; o < i && Ja(a[o * 2], a[o * 2 + 1]); o++)
          ;
      }
      for (; o < i; )
        o += l2(r, a, o, i, i, 1, n.smooth, n.smoothMonotone, n.connectNulls) + 1;
    }, e.prototype.getPointOn = function(r, n) {
      this.path || (this.createPathProxy(), this.buildPath(this.path, this.shape));
      for (var a = this.path, o = a.data, i = io.CMD, l, c, u = n === "x", d = [], f = 0; f < o.length; ) {
        var h = o[f++], v = void 0, p = void 0, g = void 0, m = void 0, w = void 0, y = void 0, b = void 0;
        switch (h) {
          case i.M:
            l = o[f++], c = o[f++];
            break;
          case i.L:
            if (v = o[f++], p = o[f++], b = u ? (r - l) / (v - l) : (r - c) / (p - c), b <= 1 && b >= 0) {
              var _ = u ? (p - c) * b + c : (v - l) * b + l;
              return u ? [r, _] : [_, r];
            }
            l = v, c = p;
            break;
          case i.C:
            v = o[f++], p = o[f++], g = o[f++], m = o[f++], w = o[f++], y = o[f++];
            var x = u ? G0(l, v, g, w, r, d) : G0(c, p, m, y, r, d);
            if (x > 0)
              for (var E = 0; E < x; E++) {
                var S = d[E];
                if (S <= 1 && S >= 0) {
                  var _ = u ? ut(c, p, m, y, S) : ut(l, v, g, w, S);
                  return u ? [r, _] : [_, r];
                }
              }
            l = w, c = y;
            break;
        }
      }
    }, e;
  }(Ie)
), Mhe = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e;
  }(rC)
), Ahe = (
  /** @class */
  function(t) {
    K(e, t);
    function e(r) {
      var n = t.call(this, r) || this;
      return n.type = "ec-polygon", n;
    }
    return e.prototype.getDefaultShape = function() {
      return new Mhe();
    }, e.prototype.buildPath = function(r, n) {
      var a = n.points, o = n.stackedOnPoints, i = 0, l = a.length / 2, c = n.smoothMonotone;
      if (n.connectNulls) {
        for (; l > 0 && Ja(a[l * 2 - 2], a[l * 2 - 1]); l--)
          ;
        for (; i < l && Ja(a[i * 2], a[i * 2 + 1]); i++)
          ;
      }
      for (; i < l; ) {
        var u = l2(r, a, i, l, l, 1, n.smooth, c, n.connectNulls);
        l2(r, o, i + u - 1, u, l, -1, n.stackedOnSmooth, c, n.connectNulls), i += u + 1, r.closePath();
      }
    }, e;
  }(Ie)
);
function nC(t, e, r, n, a) {
  var o = t.getArea(), i = o.x, l = o.y, c = o.width, u = o.height, d = r.get(["lineStyle", "width"]) || 2;
  i -= d / 2, l -= d / 2, c += d, u += d, c = Math.ceil(c), i !== Math.floor(i) && (i = Math.floor(i), c++);
  var f = new He({
    shape: {
      x: i,
      y: l,
      width: c,
      height: u
    }
  });
  if (e) {
    var h = t.getBaseAxis(), v = h.isHorizontal(), p = h.inverse;
    v ? (p && (f.shape.x += c), f.shape.width = 0) : (p || (f.shape.y += u), f.shape.height = 0);
    var g = ie(a) ? function(m) {
      a(m, f);
    } : null;
    dt(f, {
      shape: {
        width: c,
        height: u,
        x: i,
        y: l
      }
    }, r, null, n, g);
  }
  return f;
}
function aC(t, e, r) {
  var n = t.getArea(), a = Qe(n.r0, 1), o = Qe(n.r, 1), i = new $r({
    shape: {
      cx: Qe(t.cx, 1),
      cy: Qe(t.cy, 1),
      r0: a,
      r: o,
      startAngle: n.startAngle,
      endAngle: n.endAngle,
      clockwise: n.clockwise
    }
  });
  if (e) {
    var l = t.getBaseAxis().dim === "angle";
    l ? i.shape.endAngle = n.startAngle : i.shape.r = a, dt(i, {
      shape: {
        endAngle: n.endAngle,
        r: o
      }
    }, r);
  }
  return i;
}
function khe(t, e, r, n, a) {
  if (t) {
    if (t.type === "polar")
      return aC(t, e, r);
    if (t.type === "cartesian2d")
      return nC(t, e, r, n, a);
  } else return null;
  return null;
}
function t5(t, e) {
  return t.type === e;
}
function X3(t, e) {
  if (t.length === e.length) {
    for (var r = 0; r < t.length; r++)
      if (t[r] !== e[r])
        return;
    return !0;
  }
}
function q3(t) {
  for (var e = 1 / 0, r = 1 / 0, n = -1 / 0, a = -1 / 0, o = 0; o < t.length; ) {
    var i = t[o++], l = t[o++];
    isNaN(i) || (e = Math.min(i, e), n = Math.max(i, n)), isNaN(l) || (r = Math.min(l, r), a = Math.max(l, a));
  }
  return [[e, r], [n, a]];
}
function K3(t, e) {
  var r = q3(t), n = r[0], a = r[1], o = q3(e), i = o[0], l = o[1];
  return Math.max(Math.abs(n[0] - i[0]), Math.abs(n[1] - i[1]), Math.abs(a[0] - l[0]), Math.abs(a[1] - l[1]));
}
function Q3(t) {
  return De(t) ? t : t ? 0.5 : 0;
}
function Lhe(t, e, r) {
  if (!r.valueDim)
    return [];
  for (var n = e.count(), a = pn(n * 2), o = 0; o < n; o++) {
    var i = tC(r, t, e, o);
    a[o * 2] = i[0], a[o * 2 + 1] = i[1];
  }
  return a;
}
function Bn(t, e, r, n) {
  var a = e.getBaseAxis(), o = a.dim === "x" || a.dim === "radius" ? 0 : 1, i = [], l = 0, c = [], u = [], d = [], f = [];
  if (n) {
    for (l = 0; l < t.length; l += 2)
      !isNaN(t[l]) && !isNaN(t[l + 1]) && f.push(t[l], t[l + 1]);
    t = f;
  }
  for (l = 0; l < t.length - 2; l += 2)
    switch (d[0] = t[l + 2], d[1] = t[l + 3], u[0] = t[l], u[1] = t[l + 1], i.push(u[0], u[1]), r) {
      case "end":
        c[o] = d[o], c[1 - o] = u[1 - o], i.push(c[0], c[1]);
        break;
      case "middle":
        var h = (u[o] + d[o]) / 2, v = [];
        c[o] = v[o] = h, c[1 - o] = u[1 - o], v[1 - o] = d[1 - o], i.push(c[0], c[1]), i.push(v[0], v[1]);
        break;
      default:
        c[o] = u[o], c[1 - o] = d[1 - o], i.push(c[0], c[1]);
    }
  return i.push(t[l++], t[l++]), i;
}
function The(t, e) {
  var r = [], n = t.length, a, o;
  function i(d, f, h) {
    var v = d.coord, p = (h - v) / (f.coord - v), g = Hv(p, [d.color, f.color]);
    return {
      coord: h,
      color: g
    };
  }
  for (var l = 0; l < n; l++) {
    var c = t[l], u = c.coord;
    if (u < 0)
      a = c;
    else if (u > e) {
      o ? r.push(i(o, c, e)) : a && r.push(i(a, c, 0), i(a, c, e));
      break;
    } else
      a && (r.push(i(a, c, 0)), a = null), r.push(c), o = c;
  }
  return r;
}
function Ohe(t, e, r) {
  var n = t.getVisual("visualMeta");
  if (!(!n || !n.length || !t.count())) {
    if (e.type !== "cartesian2d") {
      process.env.NODE_ENV !== "production" && console.warn("Visual map on line style is only supported on cartesian2d.");
      return;
    }
    for (var a, o, i = n.length - 1; i >= 0; i--) {
      var l = t.getDimensionInfo(n[i].dimension);
      if (a = l && l.coordDim, a === "x" || a === "y") {
        o = n[i];
        break;
      }
    }
    if (!o) {
      process.env.NODE_ENV !== "production" && console.warn("Visual map on line style only support x or y dimension.");
      return;
    }
    var c = e.getAxis(a), u = J(o.stops, function(b) {
      return {
        coord: c.toGlobalCoord(c.dataToCoord(b.value)),
        color: b.color
      };
    }), d = u.length, f = o.outerColors.slice();
    d && u[0].coord > u[d - 1].coord && (u.reverse(), f.reverse());
    var h = The(u, a === "x" ? r.getWidth() : r.getHeight()), v = h.length;
    if (!v && d)
      return u[0].coord < 0 ? f[1] ? f[1] : u[d - 1].color : f[0] ? f[0] : u[0].color;
    var p = 10, g = h[0].coord - p, m = h[v - 1].coord + p, w = m - g;
    if (w < 1e-3)
      return "transparent";
    I(h, function(b) {
      b.offset = (b.coord - g) / w;
    }), h.push({
      // NOTE: inRangeStopLen may still be 0 if stoplen is zero.
      offset: v ? h[v - 1].offset : 0.5,
      color: f[1] || "transparent"
    }), h.unshift({
      offset: v ? h[0].offset : 0.5,
      color: f[0] || "transparent"
    });
    var y = new i7(0, 0, 0, 0, h, !0);
    return y[a] = g, y[a + "2"] = m, y;
  }
}
function Ihe(t, e, r) {
  var n = t.get("showAllSymbol"), a = n === "auto";
  if (!(n && !a)) {
    var o = r.getAxesByScale("ordinal")[0];
    if (o && !(a && Phe(o, e))) {
      var i = e.mapDimension(o.dim), l = {};
      return I(o.getViewLabels(), function(c) {
        var u = o.scale.getRawOrdinalNumber(c.tickValue);
        l[u] = 1;
      }), function(c) {
        return !l.hasOwnProperty(e.get(i, c));
      };
    }
  }
}
function Phe(t, e) {
  var r = t.getExtent(), n = Math.abs(r[1] - r[0]) / t.scale.count();
  isNaN(n) && (n = 0);
  for (var a = e.count(), o = Math.max(1, Math.round(a / 5)), i = 0; i < a; i += o)
    if (K7.getSymbolSize(
      e,
      i
      // Only for cartesian, where `isHorizontal` exists.
    )[t.isHorizontal() ? 1 : 0] * 1.5 > n)
      return !1;
  return !0;
}
function Dhe(t, e) {
  return isNaN(t) || isNaN(e);
}
function Nhe(t) {
  for (var e = t.length / 2; e > 0 && Dhe(t[e * 2 - 2], t[e * 2 - 1]); e--)
    ;
  return e - 1;
}
function J3(t, e) {
  return [t[e * 2], t[e * 2 + 1]];
}
function Bhe(t, e, r) {
  for (var n = t.length / 2, a = r === "x" ? 0 : 1, o, i, l = 0, c = -1, u = 0; u < n; u++)
    if (i = t[u * 2 + a], !(isNaN(i) || isNaN(t[u * 2 + 1 - a]))) {
      if (u === 0) {
        o = i;
        continue;
      }
      if (o <= e && i >= e || o >= e && i <= e) {
        c = u;
        break;
      }
      l = u, o = i;
    }
  return {
    range: [l, c],
    t: (e - o) / (i - o)
  };
}
function oC(t) {
  if (t.get(["endLabel", "show"]))
    return !0;
  for (var e = 0; e < Wt.length; e++)
    if (t.get([Wt[e], "endLabel", "show"]))
      return !0;
  return !1;
}
function Kd(t, e, r, n) {
  if (t5(e, "cartesian2d")) {
    var a = n.getModel("endLabel"), o = a.get("valueAnimation"), i = n.getData(), l = {
      lastFrameIndex: 0
    }, c = oC(n) ? function(v, p) {
      t._endLabelOnDuring(v, p, i, l, o, a, e);
    } : null, u = e.getBaseAxis().isHorizontal(), d = nC(e, r, n, function() {
      var v = t._endLabel;
      v && r && l.originalX != null && v.attr({
        x: l.originalX,
        y: l.originalY
      });
    }, c);
    if (!n.get("clip", !0)) {
      var f = d.shape, h = Math.max(f.width, f.height);
      u ? (f.y -= h, f.height += h * 2) : (f.x -= h, f.width += h * 2);
    }
    return c && c(1, d), d;
  } else
    return process.env.NODE_ENV !== "production" && n.get(["endLabel", "show"]) && console.warn("endLabel is not supported for lines in polar systems."), aC(e, r, n);
}
function Fhe(t, e) {
  var r = e.getBaseAxis(), n = r.isHorizontal(), a = r.inverse, o = n ? a ? "right" : "left" : "center", i = n ? "middle" : a ? "top" : "bottom";
  return {
    normal: {
      align: t.get("align") || o,
      verticalAlign: t.get("verticalAlign") || i
    }
  };
}
var $he = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.init = function() {
      var r = new Xe(), n = new xhe();
      this.group.add(n.group), this._symbolDraw = n, this._lineGroup = r;
    }, e.prototype.render = function(r, n, a) {
      var o = this, i = r.coordinateSystem, l = this.group, c = r.getData(), u = r.getModel("lineStyle"), d = r.getModel("areaStyle"), f = c.getLayout("points") || [], h = i.type === "polar", v = this._coordSys, p = this._symbolDraw, g = this._polyline, m = this._polygon, w = this._lineGroup, y = !n.ssr && r.get("animation"), b = !d.isEmpty(), _ = d.get("origin"), x = eC(i, c, _), E = b && Lhe(i, c, x), S = r.get("showSymbol"), M = r.get("connectNulls"), R = S && !h && Ihe(r, c, i), A = this._data;
      A && A.eachItemGraphicEl(function(pe, X) {
        pe.__temp && (l.remove(pe), A.setItemGraphicEl(X, null));
      }), S || p.remove(), l.add(w);
      var k = h ? !1 : r.get("step"), L;
      i && i.getArea && r.get("clip", !0) && (L = i.getArea(), L.width != null ? (L.x -= 0.1, L.y -= 0.1, L.width += 0.2, L.height += 0.2) : L.r0 && (L.r0 -= 0.5, L.r += 0.5)), this._clipShapeForSymbol = L;
      var T = Ohe(c, i, a) || c.getVisual("style")[c.getVisual("drawType")];
      if (!(g && v.type === i.type && k === this._step))
        S && p.updateData(c, {
          isIgnore: R,
          clipShape: L,
          disableAnimation: !0,
          getSymbolPoint: function(pe) {
            return [f[pe * 2], f[pe * 2 + 1]];
          }
        }), y && this._initSymbolLabelAnimation(c, i, L), k && (f = Bn(f, i, k, M), E && (E = Bn(E, i, k, M))), g = this._newPolyline(f), b ? m = this._newPolygon(f, E) : m && (w.remove(m), m = this._polygon = null), h || this._initOrUpdateEndLabel(r, i, lo(T)), w.setClipPath(Kd(this, i, !0, r));
      else {
        b && !m ? m = this._newPolygon(f, E) : m && !b && (w.remove(m), m = this._polygon = null), h || this._initOrUpdateEndLabel(r, i, lo(T));
        var O = w.getClipPath();
        if (O) {
          var D = Kd(this, i, !1, r);
          dt(O, {
            shape: D.shape
          }, r);
        } else
          w.setClipPath(Kd(this, i, !0, r));
        S && p.updateData(c, {
          isIgnore: R,
          clipShape: L,
          disableAnimation: !0,
          getSymbolPoint: function(pe) {
            return [f[pe * 2], f[pe * 2 + 1]];
          }
        }), (!X3(this._stackedOnPoints, E) || !X3(this._points, f)) && (y ? this._doUpdateAnimation(c, E, i, a, k, _, M) : (k && (f = Bn(f, i, k, M), E && (E = Bn(E, i, k, M))), g.setShape({
          points: f
        }), m && m.setShape({
          points: f,
          stackedOnPoints: E
        })));
      }
      var P = r.getModel("emphasis"), F = P.get("focus"), B = P.get("blurScope"), N = P.get("disabled");
      if (g.useStyle(Te(
        // Use color in lineStyle first
        u.getLineStyle(),
        {
          fill: "none",
          stroke: T,
          lineJoin: "bevel"
        }
      )), Ei(g, r, "lineStyle"), g.style.lineWidth > 0 && r.get(["emphasis", "lineStyle", "width"]) === "bolder") {
        var $ = g.getState("emphasis").style;
        $.lineWidth = +g.style.lineWidth + 1;
      }
      Se(g).seriesIndex = r.seriesIndex, ua(g, F, B, N);
      var V = Q3(r.get("smooth")), W = r.get("smoothMonotone");
      if (g.setShape({
        smooth: V,
        smoothMonotone: W,
        connectNulls: M
      }), m) {
        var ee = c.getCalculationInfo("stackedOnSeries"), ne = 0;
        m.useStyle(Te(d.getAreaStyle(), {
          fill: T,
          opacity: 0.7,
          lineJoin: "bevel",
          decal: c.getVisual("style").decal
        })), ee && (ne = Q3(ee.get("smooth"))), m.setShape({
          smooth: V,
          stackedOnSmooth: ne,
          smoothMonotone: W,
          connectNulls: M
        }), Ei(m, r, "areaStyle"), Se(m).seriesIndex = r.seriesIndex, ua(m, F, B, N);
      }
      var we = function(pe) {
        o._changePolyState(pe);
      };
      c.eachItemGraphicEl(function(pe) {
        pe && (pe.onHoverStateChange = we);
      }), this._polyline.onHoverStateChange = we, this._data = c, this._coordSys = i, this._stackedOnPoints = E, this._points = f, this._step = k, this._valueOrigin = _, r.get("triggerLineEvent") && (this.packEventData(r, g), m && this.packEventData(r, m));
    }, e.prototype.packEventData = function(r, n) {
      Se(n).eventData = {
        componentType: "series",
        componentSubType: "line",
        componentIndex: r.componentIndex,
        seriesIndex: r.seriesIndex,
        seriesName: r.name,
        seriesType: "line"
      };
    }, e.prototype.highlight = function(r, n, a, o) {
      var i = r.getData(), l = oo(i, o);
      if (this._changePolyState("emphasis"), !(l instanceof Array) && l != null && l >= 0) {
        var c = i.getLayout("points"), u = i.getItemGraphicEl(l);
        if (!u) {
          var d = c[l * 2], f = c[l * 2 + 1];
          if (isNaN(d) || isNaN(f) || this._clipShapeForSymbol && !this._clipShapeForSymbol.contain(d, f))
            return;
          var h = r.get("zlevel") || 0, v = r.get("z") || 0;
          u = new K7(i, l), u.x = d, u.y = f, u.setZ(h, v);
          var p = u.getSymbolPath().getTextContent();
          p && (p.zlevel = h, p.z = v, p.z2 = this._polyline.z2 + 1), u.__temp = !0, i.setItemGraphicEl(l, u), u.stopSymbolAnimation(!0), this.group.add(u);
        }
        u.highlight();
      } else
        wt.prototype.highlight.call(this, r, n, a, o);
    }, e.prototype.downplay = function(r, n, a, o) {
      var i = r.getData(), l = oo(i, o);
      if (this._changePolyState("normal"), l != null && l >= 0) {
        var c = i.getItemGraphicEl(l);
        c && (c.__temp ? (i.setItemGraphicEl(l, null), this.group.remove(c)) : c.downplay());
      } else
        wt.prototype.downplay.call(this, r, n, a, o);
    }, e.prototype._changePolyState = function(r) {
      var n = this._polygon;
      im(this._polyline, r), n && im(n, r);
    }, e.prototype._newPolyline = function(r) {
      var n = this._polyline;
      return n && this._lineGroup.remove(n), n = new Rhe({
        shape: {
          points: r
        },
        segmentIgnoreThreshold: 2,
        z2: 10
      }), this._lineGroup.add(n), this._polyline = n, n;
    }, e.prototype._newPolygon = function(r, n) {
      var a = this._polygon;
      return a && this._lineGroup.remove(a), a = new Ahe({
        shape: {
          points: r,
          stackedOnPoints: n
        },
        segmentIgnoreThreshold: 2
      }), this._lineGroup.add(a), this._polygon = a, a;
    }, e.prototype._initSymbolLabelAnimation = function(r, n, a) {
      var o, i, l = n.getBaseAxis(), c = l.inverse;
      n.type === "cartesian2d" ? (o = l.isHorizontal(), i = !1) : n.type === "polar" && (o = l.dim === "angle", i = !0);
      var u = r.hostModel, d = u.get("animationDuration");
      ie(d) && (d = d(null));
      var f = u.get("animationDelay") || 0, h = ie(f) ? f(null) : f;
      r.eachItemGraphicEl(function(v, p) {
        var g = v;
        if (g) {
          var m = [v.x, v.y], w = void 0, y = void 0, b = void 0;
          if (a)
            if (i) {
              var _ = a, x = n.pointToCoord(m);
              o ? (w = _.startAngle, y = _.endAngle, b = -x[1] / 180 * Math.PI) : (w = _.r0, y = _.r, b = x[0]);
            } else {
              var E = a;
              o ? (w = E.x, y = E.x + E.width, b = v.x) : (w = E.y + E.height, y = E.y, b = v.y);
            }
          var S = y === w ? 0 : (b - w) / (y - w);
          c && (S = 1 - S);
          var M = ie(f) ? f(p) : d * S + h, R = g.getSymbolPath(), A = R.getTextContent();
          g.attr({
            scaleX: 0,
            scaleY: 0
          }), g.animateTo({
            scaleX: 1,
            scaleY: 1
          }, {
            duration: 200,
            setToFinal: !0,
            delay: M
          }), A && A.animateFrom({
            style: {
              opacity: 0
            }
          }, {
            duration: 300,
            delay: M
          }), R.disableLabelAnimation = !0;
        }
      });
    }, e.prototype._initOrUpdateEndLabel = function(r, n, a) {
      var o = r.getModel("endLabel");
      if (oC(r)) {
        var i = r.getData(), l = this._polyline, c = i.getLayout("points");
        if (!c) {
          l.removeTextContent(), this._endLabel = null;
          return;
        }
        var u = this._endLabel;
        u || (u = this._endLabel = new Ye({
          z2: 200
          // should be higher than item symbol
        }), u.ignoreClip = !0, l.setTextContent(this._endLabel), l.disableLabelAnimation = !0);
        var d = Nhe(c);
        d >= 0 && (Wi(l, wo(r, "endLabel"), {
          inheritColor: a,
          labelFetcher: r,
          labelDataIndex: d,
          defaultText: function(f, h, v) {
            return v != null ? Jx(i, v) : q7(i, f);
          },
          enableTextSetter: !0
        }, Fhe(o, n)), l.textConfig.position = null);
      } else this._endLabel && (this._polyline.removeTextContent(), this._endLabel = null);
    }, e.prototype._endLabelOnDuring = function(r, n, a, o, i, l, c) {
      var u = this._endLabel, d = this._polyline;
      if (u) {
        r < 1 && o.originalX == null && (o.originalX = u.x, o.originalY = u.y);
        var f = a.getLayout("points"), h = a.hostModel, v = h.get("connectNulls"), p = l.get("precision"), g = l.get("distance") || 0, m = c.getBaseAxis(), w = m.isHorizontal(), y = m.inverse, b = n.shape, _ = y ? w ? b.x : b.y + b.height : w ? b.x + b.width : b.y, x = (w ? g : 0) * (y ? -1 : 1), E = (w ? 0 : -g) * (y ? -1 : 1), S = w ? "x" : "y", M = Bhe(f, _, S), R = M.range, A = R[1] - R[0], k = void 0;
        if (A >= 1) {
          if (A > 1 && !v) {
            var L = J3(f, R[0]);
            u.attr({
              x: L[0] + x,
              y: L[1] + E
            }), i && (k = h.getRawValue(R[0]));
          } else {
            var L = d.getPointOn(_, S);
            L && u.attr({
              x: L[0] + x,
              y: L[1] + E
            });
            var T = h.getRawValue(R[0]), O = h.getRawValue(R[1]);
            i && (k = g9(a, p, T, O, M.t));
          }
          o.lastFrameIndex = R[0];
        } else {
          var D = r === 1 || o.lastFrameIndex > 0 ? R[0] : 0, L = J3(f, D);
          i && (k = h.getRawValue(D)), u.attr({
            x: L[0] + x,
            y: L[1] + E
          });
        }
        if (i) {
          var P = Hs(u);
          typeof P.setLabelText == "function" && P.setLabelText(k);
        }
      }
    }, e.prototype._doUpdateAnimation = function(r, n, a, o, i, l, c) {
      var u = this._polyline, d = this._polygon, f = r.hostModel, h = She(this._data, r, this._stackedOnPoints, n, this._coordSys, a, this._valueOrigin), v = h.current, p = h.stackedOnCurrent, g = h.next, m = h.stackedOnNext;
      if (i && (v = Bn(h.current, a, i, c), p = Bn(h.stackedOnCurrent, a, i, c), g = Bn(h.next, a, i, c), m = Bn(h.stackedOnNext, a, i, c)), K3(v, g) > 3e3 || d && K3(p, m) > 3e3) {
        u.stopAnimation(), u.setShape({
          points: g
        }), d && (d.stopAnimation(), d.setShape({
          points: g,
          stackedOnPoints: m
        }));
        return;
      }
      u.shape.__points = h.current, u.shape.points = v;
      var w = {
        shape: {
          points: g
        }
      };
      h.current !== v && (w.shape.__points = h.next), u.stopAnimation(), rt(u, w, f), d && (d.setShape({
        // Reuse the points with polyline.
        points: v,
        stackedOnPoints: p
      }), d.stopAnimation(), rt(d, {
        shape: {
          stackedOnPoints: m
        }
      }, f), u.shape.points !== d.shape.points && (d.shape.points = u.shape.points));
      for (var y = [], b = h.status, _ = 0; _ < b.length; _++) {
        var x = b[_].cmd;
        if (x === "=") {
          var E = r.getItemGraphicEl(b[_].idx1);
          E && y.push({
            el: E,
            ptIdx: _
            // Index of points
          });
        }
      }
      u.animators && u.animators.length && u.animators[0].during(function() {
        d && d.dirtyShape();
        for (var S = u.shape.__points, M = 0; M < y.length; M++) {
          var R = y[M].el, A = y[M].ptIdx * 2;
          R.x = S[A], R.y = S[A + 1], R.markRedraw();
        }
      });
    }, e.prototype.remove = function(r) {
      var n = this.group, a = this._data;
      this._lineGroup.removeAll(), this._symbolDraw.remove(!0), a && a.eachItemGraphicEl(function(o, i) {
        o.__temp && (n.remove(o), a.setItemGraphicEl(i, null));
      }), this._polyline = this._polygon = this._coordSys = this._points = this._stackedOnPoints = this._endLabel = this._data = null;
    }, e.type = "line", e;
  }(wt)
);
function Vhe(t, e) {
  return {
    seriesType: t,
    plan: L7(),
    reset: function(r) {
      var n = r.getData(), a = r.coordinateSystem;
      if (r.pipelineContext, !!a) {
        var o = J(a.dimensions, function(f) {
          return n.mapDimension(f);
        }).slice(0, 2), i = o.length, l = n.getCalculationInfo("stackResultDimension");
        fa(n, o[0]) && (o[0] = l), fa(n, o[1]) && (o[1] = l);
        var c = n.getStore(), u = n.getDimensionIndex(o[0]), d = n.getDimensionIndex(o[1]);
        return i && {
          progress: function(f, h) {
            for (var v = f.end - f.start, p = pn(v * i), g = [], m = [], w = f.start, y = 0; w < f.end; w++) {
              var b = void 0;
              if (i === 1) {
                var _ = c.get(u, w);
                b = a.dataToPoint(_, null, m);
              } else
                g[0] = c.get(u, w), g[1] = c.get(d, w), b = a.dataToPoint(g, null, m);
              p[y++] = b[0], p[y++] = b[1];
            }
            h.setLayout("points", p);
          }
        };
      }
    }
  };
}
var Zhe = {
  average: function(t) {
    for (var e = 0, r = 0, n = 0; n < t.length; n++)
      isNaN(t[n]) || (e += t[n], r++);
    return r === 0 ? NaN : e / r;
  },
  sum: function(t) {
    for (var e = 0, r = 0; r < t.length; r++)
      e += t[r] || 0;
    return e;
  },
  max: function(t) {
    for (var e = -1 / 0, r = 0; r < t.length; r++)
      t[r] > e && (e = t[r]);
    return isFinite(e) ? e : NaN;
  },
  min: function(t) {
    for (var e = 1 / 0, r = 0; r < t.length; r++)
      t[r] < e && (e = t[r]);
    return isFinite(e) ? e : NaN;
  },
  minmax: function(t) {
    for (var e = -1 / 0, r = -1 / 0, n = 0; n < t.length; n++) {
      var a = t[n], o = Math.abs(a);
      o > e && (e = o, r = a);
    }
    return isFinite(r) ? r : NaN;
  },
  // TODO
  // Median
  nearest: function(t) {
    return t[0];
  }
}, Hhe = function(t) {
  return Math.round(t.length / 2);
};
function iC(t) {
  return {
    seriesType: t,
    // FIXME:TS never used, so comment it
    // modifyOutputEnd: true,
    reset: function(e, r, n) {
      var a = e.getData(), o = e.get("sampling"), i = e.coordinateSystem, l = a.count();
      if (l > 10 && i.type === "cartesian2d" && o) {
        var c = i.getBaseAxis(), u = i.getOtherAxis(c), d = c.getExtent(), f = n.getDevicePixelRatio(), h = Math.abs(d[1] - d[0]) * (f || 1), v = Math.round(l / h);
        if (isFinite(v) && v > 1) {
          o === "lttb" && e.setData(a.lttbDownSample(a.mapDimension(u.dim), 1 / v));
          var p = void 0;
          Q(o) ? p = Zhe[o] : ie(o) && (p = o), p && e.setData(a.downSample(a.mapDimension(u.dim), 1 / v, p, Hhe));
        }
      }
    }
  };
}
function lC(t) {
  t.registerChartView($he), t.registerSeriesModel(bhe), t.registerLayout(Vhe("line")), t.registerVisual({
    seriesType: "line",
    reset: function(e) {
      var r = e.getData(), n = e.getModel("lineStyle").getLineStyle();
      n && !n.stroke && (n.stroke = r.getVisual("style").fill), r.setVisual("legendLineStyle", n);
    }
  }), t.registerProcessor(t.PRIORITY.PROCESSOR.STATISTIC, iC("line"));
}
var s2 = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = e.type, r;
    }
    return e.prototype.getInitialData = function(r, n) {
      return q1(null, this, {
        useEncodeDefaulter: !0
      });
    }, e.prototype.getMarkerPosition = function(r, n, a) {
      var o = this.coordinateSystem;
      if (o && o.clampData) {
        var i = o.clampData(r), l = o.dataToPoint(i);
        if (a)
          I(o.getAxes(), function(h, v) {
            if (h.type === "category" && n != null) {
              var p = h.getTicksCoords(), g = h.getTickModel().get("alignWithLabel"), m = i[v], w = n[v] === "x1" || n[v] === "y1";
              if (w && !g && (m += 1), p.length < 2)
                return;
              if (p.length === 2) {
                l[v] = h.toGlobalCoord(h.getExtent()[w ? 1 : 0]);
                return;
              }
              for (var y = void 0, b = void 0, _ = 1, x = 0; x < p.length; x++) {
                var E = p[x].coord, S = x === p.length - 1 ? p[x - 1].tickValue + _ : p[x].tickValue;
                if (S === m) {
                  b = E;
                  break;
                } else if (S < m)
                  y = E;
                else if (y != null && S > m) {
                  b = (E + y) / 2;
                  break;
                }
                x === 1 && (_ = S - p[0].tickValue);
              }
              b == null && (y ? y && (b = p[p.length - 1].coord) : b = p[0].coord), l[v] = h.toGlobalCoord(b);
            }
          });
        else {
          var c = this.getData(), u = c.getLayout("offset"), d = c.getLayout("size"), f = o.getBaseAxis().isHorizontal() ? 0 : 1;
          l[f] += u + d / 2;
        }
        return l;
      }
      return [NaN, NaN];
    }, e.type = "series.__base_bar__", e.defaultOption = {
      // zlevel: 0,
      z: 2,
      coordinateSystem: "cartesian2d",
      legendHoverLink: !0,
      // stack: null
      // Cartesian coordinate system
      // xAxisIndex: 0,
      // yAxisIndex: 0,
      barMinHeight: 0,
      barMinAngle: 0,
      // cursor: null,
      large: !1,
      largeThreshold: 400,
      progressive: 3e3,
      progressiveChunkMode: "mod"
    }, e;
  }(Tt)
);
Tt.registerClass(s2);
var jhe = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = e.type, r;
    }
    return e.prototype.getInitialData = function() {
      return q1(null, this, {
        useEncodeDefaulter: !0,
        createInvertedIndices: !!this.get("realtimeSort", !0) || null
      });
    }, e.prototype.getProgressive = function() {
      return this.get("large") ? this.get("progressive") : !1;
    }, e.prototype.getProgressiveThreshold = function() {
      var r = this.get("progressiveThreshold"), n = this.get("largeThreshold");
      return n > r && (r = n), r;
    }, e.prototype.brushSelector = function(r, n, a) {
      return a.rect(n.getItemLayout(r));
    }, e.type = "series.bar", e.dependencies = ["grid", "polar"], e.defaultOption = B1(s2.defaultOption, {
      // If clipped
      // Only available on cartesian2d
      clip: !0,
      roundCap: !1,
      showBackground: !1,
      backgroundStyle: {
        color: "rgba(180, 180, 180, 0.2)",
        borderColor: null,
        borderWidth: 0,
        borderType: "solid",
        borderRadius: 0,
        shadowBlur: 0,
        shadowColor: null,
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        opacity: 1
      },
      select: {
        itemStyle: {
          borderColor: "#212121"
        }
      },
      realtimeSort: !1
    }), e;
  }(s2)
), Whe = (
  /** @class */
  /* @__PURE__ */ function() {
    function t() {
      this.cx = 0, this.cy = 0, this.r0 = 0, this.r = 0, this.startAngle = 0, this.endAngle = Math.PI * 2, this.clockwise = !0;
    }
    return t;
  }()
), _u = (
  /** @class */
  function(t) {
    K(e, t);
    function e(r) {
      var n = t.call(this, r) || this;
      return n.type = "sausage", n;
    }
    return e.prototype.getDefaultShape = function() {
      return new Whe();
    }, e.prototype.buildPath = function(r, n) {
      var a = n.cx, o = n.cy, i = Math.max(n.r0 || 0, 0), l = Math.max(n.r, 0), c = (l - i) * 0.5, u = i + c, d = n.startAngle, f = n.endAngle, h = n.clockwise, v = Math.PI * 2, p = h ? f - d < v : d - f < v;
      p || (d = f - (h ? v : -v));
      var g = Math.cos(d), m = Math.sin(d), w = Math.cos(f), y = Math.sin(f);
      p ? (r.moveTo(g * i + a, m * i + o), r.arc(g * u + a, m * u + o, c, -Math.PI + d, d, !h)) : r.moveTo(g * l + a, m * l + o), r.arc(a, o, l, d, f, !h), r.arc(w * u + a, y * u + o, c, f - Math.PI * 2, f - Math.PI, !h), i !== 0 && r.arc(a, o, i, f, d, h);
    }, e;
  }(Ie)
);
function zhe(t, e) {
  e = e || {};
  var r = e.isRoundCap;
  return function(n, a, o) {
    var i = a.position;
    if (!i || i instanceof Array)
      return q0(n, a, o);
    var l = t(i), c = a.distance != null ? a.distance : 5, u = this.shape, d = u.cx, f = u.cy, h = u.r, v = u.r0, p = (h + v) / 2, g = u.startAngle, m = u.endAngle, w = (g + m) / 2, y = r ? Math.abs(h - v) / 2 : 0, b = Math.cos, _ = Math.sin, x = d + h * b(g), E = f + h * _(g), S = "left", M = "top";
    switch (l) {
      case "startArc":
        x = d + (v - c) * b(w), E = f + (v - c) * _(w), S = "center", M = "top";
        break;
      case "insideStartArc":
        x = d + (v + c) * b(w), E = f + (v + c) * _(w), S = "center", M = "bottom";
        break;
      case "startAngle":
        x = d + p * b(g) + Vc(g, c + y, !1), E = f + p * _(g) + Zc(g, c + y, !1), S = "right", M = "middle";
        break;
      case "insideStartAngle":
        x = d + p * b(g) + Vc(g, -c + y, !1), E = f + p * _(g) + Zc(g, -c + y, !1), S = "left", M = "middle";
        break;
      case "middle":
        x = d + p * b(w), E = f + p * _(w), S = "center", M = "middle";
        break;
      case "endArc":
        x = d + (h + c) * b(w), E = f + (h + c) * _(w), S = "center", M = "bottom";
        break;
      case "insideEndArc":
        x = d + (h - c) * b(w), E = f + (h - c) * _(w), S = "center", M = "top";
        break;
      case "endAngle":
        x = d + p * b(m) + Vc(m, c + y, !0), E = f + p * _(m) + Zc(m, c + y, !0), S = "left", M = "middle";
        break;
      case "insideEndAngle":
        x = d + p * b(m) + Vc(m, -c + y, !0), E = f + p * _(m) + Zc(m, -c + y, !0), S = "right", M = "middle";
        break;
      default:
        return q0(n, a, o);
    }
    return n = n || {}, n.x = x, n.y = E, n.align = S, n.verticalAlign = M, n;
  };
}
function Ghe(t, e, r, n) {
  if (De(n)) {
    t.setTextConfig({
      rotation: n
    });
    return;
  } else if (z(e)) {
    t.setTextConfig({
      rotation: 0
    });
    return;
  }
  var a = t.shape, o = a.clockwise ? a.startAngle : a.endAngle, i = a.clockwise ? a.endAngle : a.startAngle, l = (o + i) / 2, c, u = r(e);
  switch (u) {
    case "startArc":
    case "insideStartArc":
    case "middle":
    case "insideEndArc":
    case "endArc":
      c = l;
      break;
    case "startAngle":
    case "insideStartAngle":
      c = o;
      break;
    case "endAngle":
    case "insideEndAngle":
      c = i;
      break;
    default:
      t.setTextConfig({
        rotation: 0
      });
      return;
  }
  var d = Math.PI * 1.5 - c;
  u === "middle" && d > Math.PI / 2 && d < Math.PI * 1.5 && (d -= Math.PI), t.setTextConfig({
    rotation: d
  });
}
function Vc(t, e, r) {
  return e * Math.sin(t) * (r ? -1 : 1);
}
function Zc(t, e, r) {
  return e * Math.cos(t) * (r ? 1 : -1);
}
function Tl(t, e, r) {
  var n = t.get("borderRadius");
  if (n == null)
    return r ? {
      cornerRadius: 0
    } : null;
  z(n) || (n = [n, n, n, n]);
  var a = Math.abs(e.r || 0 - e.r0 || 0);
  return {
    cornerRadius: J(n, function(o) {
      return ca(o, a);
    })
  };
}
var Qd = Math.max, Jd = Math.min;
function Uhe(t, e) {
  var r = t.getArea && t.getArea();
  if (t5(t, "cartesian2d")) {
    var n = t.getBaseAxis();
    if (n.type !== "category" || !n.onBand) {
      var a = e.getLayout("bandWidth");
      n.isHorizontal() ? (r.x -= a, r.width += a * 2) : (r.y -= a, r.height += a * 2);
    }
  }
  return r;
}
var Yhe = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t.call(this) || this;
      return r.type = e.type, r._isFirstFrame = !0, r;
    }
    return e.prototype.render = function(r, n, a, o) {
      this._model = r, this._removeOnRenderedListener(a), this._updateDrawMode(r);
      var i = r.get("coordinateSystem");
      i === "cartesian2d" || i === "polar" ? (this._progressiveEls = null, this._isLargeDraw ? this._renderLarge(r, n, a) : this._renderNormal(r, n, a, o)) : process.env.NODE_ENV !== "production" && pt("Only cartesian2d and polar supported for bar.");
    }, e.prototype.incrementalPrepareRender = function(r) {
      this._clear(), this._updateDrawMode(r), this._updateLargeClip(r);
    }, e.prototype.incrementalRender = function(r, n) {
      this._progressiveEls = [], this._incrementalRenderLarge(r, n);
    }, e.prototype.eachRendered = function(r) {
      Zs(this._progressiveEls || this.group, r);
    }, e.prototype._updateDrawMode = function(r) {
      var n = r.pipelineContext.large;
      (this._isLargeDraw == null || n !== this._isLargeDraw) && (this._isLargeDraw = n, this._clear());
    }, e.prototype._renderNormal = function(r, n, a, o) {
      var i = this.group, l = r.getData(), c = this._data, u = r.coordinateSystem, d = u.getBaseAxis(), f;
      u.type === "cartesian2d" ? f = d.isHorizontal() : u.type === "polar" && (f = d.dim === "angle");
      var h = r.isAnimationEnabled() ? r : null, v = Xhe(r, u);
      v && this._enableRealtimeSort(v, l, a);
      var p = r.get("clip", !0) || v, g = Uhe(u, l);
      i.removeClipPath();
      var m = r.get("roundCap", !0), w = r.get("showBackground", !0), y = r.getModel("backgroundStyle"), b = y.get("borderRadius") || 0, _ = [], x = this._backgroundEls, E = o && o.isInitSort, S = o && o.type === "changeAxisOrder";
      function M(k) {
        var L = Hc[u.type](l, k), T = r2e(u, f, L);
        return T.useStyle(y.getItemStyle()), u.type === "cartesian2d" ? T.setShape("r", b) : T.setShape("cornerRadius", b), _[k] = T, T;
      }
      l.diff(c).add(function(k) {
        var L = l.getItemModel(k), T = Hc[u.type](l, k, L);
        if (w && M(k), !(!l.hasValue(k) || !a4[u.type](T))) {
          var O = !1;
          p && (O = e4[u.type](g, T));
          var D = t4[u.type](r, l, k, T, f, h, d.model, !1, m);
          v && (D.forceLabelAnimation = !0), o4(D, l, k, L, T, r, f, u.type === "polar"), E ? D.attr({
            shape: T
          }) : v ? r4(v, h, D, T, k, f, !1, !1) : dt(D, {
            shape: T
          }, r, k), l.setItemGraphicEl(k, D), i.add(D), D.ignore = O;
        }
      }).update(function(k, L) {
        var T = l.getItemModel(k), O = Hc[u.type](l, k, T);
        if (w) {
          var D = void 0;
          x.length === 0 ? D = M(L) : (D = x[L], D.useStyle(y.getItemStyle()), u.type === "cartesian2d" ? D.setShape("r", b) : D.setShape("cornerRadius", b), _[k] = D);
          var P = Hc[u.type](l, k), F = cC(f, P, u);
          rt(D, {
            shape: F
          }, h, k);
        }
        var B = c.getItemGraphicEl(L);
        if (!l.hasValue(k) || !a4[u.type](O)) {
          i.remove(B);
          return;
        }
        var N = !1;
        if (p && (N = e4[u.type](g, O), N && i.remove(B)), B ? s7(B) : B = t4[u.type](r, l, k, O, f, h, d.model, !!B, m), v && (B.forceLabelAnimation = !0), S) {
          var $ = B.getTextContent();
          if ($) {
            var V = Hs($);
            V.prevValue != null && (V.prevValue = V.value);
          }
        } else
          o4(B, l, k, T, O, r, f, u.type === "polar");
        E ? B.attr({
          shape: O
        }) : v ? r4(v, h, B, O, k, f, !0, S) : rt(B, {
          shape: O
        }, r, k, null), l.setItemGraphicEl(k, B), B.ignore = N, i.add(B);
      }).remove(function(k) {
        var L = c.getItemGraphicEl(k);
        L && au(L, r, k);
      }).execute();
      var R = this._backgroundGroup || (this._backgroundGroup = new Xe());
      R.removeAll();
      for (var A = 0; A < _.length; ++A)
        R.add(_[A]);
      i.add(R), this._backgroundEls = _, this._data = l;
    }, e.prototype._renderLarge = function(r, n, a) {
      this._clear(), l4(r, this.group), this._updateLargeClip(r);
    }, e.prototype._incrementalRenderLarge = function(r, n) {
      this._removeBackground(), l4(n, this.group, this._progressiveEls, !0);
    }, e.prototype._updateLargeClip = function(r) {
      var n = r.get("clip", !0) && khe(r.coordinateSystem, !1, r), a = this.group;
      n ? a.setClipPath(n) : a.removeClipPath();
    }, e.prototype._enableRealtimeSort = function(r, n, a) {
      var o = this;
      if (n.count()) {
        var i = r.baseAxis;
        if (this._isFirstFrame)
          this._dispatchInitSort(n, r, a), this._isFirstFrame = !1;
        else {
          var l = function(c) {
            var u = n.getItemGraphicEl(c), d = u && u.shape;
            return d && // The result should be consistent with the initial sort by data value.
            // Do not support the case that both positive and negative exist.
            Math.abs(i.isHorizontal() ? d.height : d.width) || 0;
          };
          this._onRendered = function() {
            o._updateSortWithinSameData(n, l, i, a);
          }, a.getZr().on("rendered", this._onRendered);
        }
      }
    }, e.prototype._dataSort = function(r, n, a) {
      var o = [];
      return r.each(r.mapDimension(n.dim), function(i, l) {
        var c = a(l);
        c = c ?? NaN, o.push({
          dataIndex: l,
          mappedValue: c,
          ordinalNumber: i
        });
      }), o.sort(function(i, l) {
        return l.mappedValue - i.mappedValue;
      }), {
        ordinalNumbers: J(o, function(i) {
          return i.ordinalNumber;
        })
      };
    }, e.prototype._isOrderChangedWithinSameData = function(r, n, a) {
      for (var o = a.scale, i = r.mapDimension(a.dim), l = Number.MAX_VALUE, c = 0, u = o.getOrdinalMeta().categories.length; c < u; ++c) {
        var d = r.rawIndexOf(i, o.getRawOrdinalNumber(c)), f = d < 0 ? Number.MIN_VALUE : n(r.indexOfRawIndex(d));
        if (f > l)
          return !0;
        l = f;
      }
      return !1;
    }, e.prototype._isOrderDifferentInView = function(r, n) {
      for (var a = n.scale, o = a.getExtent(), i = Math.max(0, o[0]), l = Math.min(o[1], a.getOrdinalMeta().categories.length - 1); i <= l; ++i)
        if (r.ordinalNumbers[i] !== a.getRawOrdinalNumber(i))
          return !0;
    }, e.prototype._updateSortWithinSameData = function(r, n, a, o) {
      if (this._isOrderChangedWithinSameData(r, n, a)) {
        var i = this._dataSort(r, a, n);
        this._isOrderDifferentInView(i, a) && (this._removeOnRenderedListener(o), o.dispatchAction({
          type: "changeAxisOrder",
          componentType: a.dim + "Axis",
          axisId: a.index,
          sortInfo: i
        }));
      }
    }, e.prototype._dispatchInitSort = function(r, n, a) {
      var o = n.baseAxis, i = this._dataSort(r, o, function(l) {
        return r.get(r.mapDimension(n.otherAxis.dim), l);
      });
      a.dispatchAction({
        type: "changeAxisOrder",
        componentType: o.dim + "Axis",
        isInitSort: !0,
        axisId: o.index,
        sortInfo: i
      });
    }, e.prototype.remove = function(r, n) {
      this._clear(this._model), this._removeOnRenderedListener(n);
    }, e.prototype.dispose = function(r, n) {
      this._removeOnRenderedListener(n);
    }, e.prototype._removeOnRenderedListener = function(r) {
      this._onRendered && (r.getZr().off("rendered", this._onRendered), this._onRendered = null);
    }, e.prototype._clear = function(r) {
      var n = this.group, a = this._data;
      r && r.isAnimationEnabled() && a && !this._isLargeDraw ? (this._removeBackground(), this._backgroundEls = [], a.eachItemGraphicEl(function(o) {
        au(o, r, Se(o).dataIndex);
      })) : n.removeAll(), this._data = null, this._isFirstFrame = !0;
    }, e.prototype._removeBackground = function() {
      this.group.remove(this._backgroundGroup), this._backgroundGroup = null;
    }, e.type = "bar", e;
  }(wt)
), e4 = {
  cartesian2d: function(t, e) {
    var r = e.width < 0 ? -1 : 1, n = e.height < 0 ? -1 : 1;
    r < 0 && (e.x += e.width, e.width = -e.width), n < 0 && (e.y += e.height, e.height = -e.height);
    var a = t.x + t.width, o = t.y + t.height, i = Qd(e.x, t.x), l = Jd(e.x + e.width, a), c = Qd(e.y, t.y), u = Jd(e.y + e.height, o), d = l < i, f = u < c;
    return e.x = d && i > a ? l : i, e.y = f && c > o ? u : c, e.width = d ? 0 : l - i, e.height = f ? 0 : u - c, r < 0 && (e.x += e.width, e.width = -e.width), n < 0 && (e.y += e.height, e.height = -e.height), d || f;
  },
  polar: function(t, e) {
    var r = e.r0 <= e.r ? 1 : -1;
    if (r < 0) {
      var n = e.r;
      e.r = e.r0, e.r0 = n;
    }
    var a = Jd(e.r, t.r), o = Qd(e.r0, t.r0);
    e.r = a, e.r0 = o;
    var i = a - o < 0;
    if (r < 0) {
      var n = e.r;
      e.r = e.r0, e.r0 = n;
    }
    return i;
  }
}, t4 = {
  cartesian2d: function(t, e, r, n, a, o, i, l, c) {
    var u = new He({
      shape: H({}, n),
      z2: 1
    });
    if (u.__dataIndex = r, u.name = "item", o) {
      var d = u.shape, f = a ? "height" : "width";
      d[f] = 0;
    }
    return u;
  },
  polar: function(t, e, r, n, a, o, i, l, c) {
    var u = !a && c ? _u : $r, d = new u({
      shape: n,
      z2: 1
    });
    d.name = "item";
    var f = sC(a);
    if (d.calculateTextPosition = zhe(f, {
      isRoundCap: u === _u
    }), o) {
      var h = d.shape, v = a ? "r" : "endAngle", p = {};
      h[v] = a ? n.r0 : n.startAngle, p[v] = n[v], (l ? rt : dt)(d, {
        shape: p
        // __value: typeof dataValue === 'string' ? parseInt(dataValue, 10) : dataValue
      }, o);
    }
    return d;
  }
};
function Xhe(t, e) {
  var r = t.get("realtimeSort", !0), n = e.getBaseAxis();
  if (process.env.NODE_ENV !== "production" && r && (n.type !== "category" && pt("`realtimeSort` will not work because this bar series is not based on a category axis."), e.type !== "cartesian2d" && pt("`realtimeSort` will not work because this bar series is not on cartesian2d.")), r && n.type === "category" && e.type === "cartesian2d")
    return {
      baseAxis: n,
      otherAxis: e.getOtherAxis(n)
    };
}
function r4(t, e, r, n, a, o, i, l) {
  var c, u;
  o ? (u = {
    x: n.x,
    width: n.width
  }, c = {
    y: n.y,
    height: n.height
  }) : (u = {
    y: n.y,
    height: n.height
  }, c = {
    x: n.x,
    width: n.width
  }), l || (i ? rt : dt)(r, {
    shape: c
  }, e, a, null);
  var d = e ? t.baseAxis.model : null;
  (i ? rt : dt)(r, {
    shape: u
  }, d, a);
}
function n4(t, e) {
  for (var r = 0; r < e.length; r++)
    if (!isFinite(t[e[r]]))
      return !0;
  return !1;
}
var qhe = ["x", "y", "width", "height"], Khe = ["cx", "cy", "r", "startAngle", "endAngle"], a4 = {
  cartesian2d: function(t) {
    return !n4(t, qhe);
  },
  polar: function(t) {
    return !n4(t, Khe);
  }
}, Hc = {
  // itemModel is only used to get borderWidth, which is not needed
  // when calculating bar background layout.
  cartesian2d: function(t, e, r) {
    var n = t.getItemLayout(e), a = r ? Jhe(r, n) : 0, o = n.width > 0 ? 1 : -1, i = n.height > 0 ? 1 : -1;
    return {
      x: n.x + o * a / 2,
      y: n.y + i * a / 2,
      width: n.width - o * a,
      height: n.height - i * a
    };
  },
  polar: function(t, e, r) {
    var n = t.getItemLayout(e);
    return {
      cx: n.cx,
      cy: n.cy,
      r0: n.r0,
      r: n.r,
      startAngle: n.startAngle,
      endAngle: n.endAngle,
      clockwise: n.clockwise
    };
  }
};
function Qhe(t) {
  return t.startAngle != null && t.endAngle != null && t.startAngle === t.endAngle;
}
function sC(t) {
  return /* @__PURE__ */ function(e) {
    var r = e ? "Arc" : "Angle";
    return function(n) {
      switch (n) {
        case "start":
        case "insideStart":
        case "end":
        case "insideEnd":
          return n + r;
        default:
          return n;
      }
    };
  }(t);
}
function o4(t, e, r, n, a, o, i, l) {
  var c = e.getItemVisual(r, "style");
  if (l) {
    if (!o.get("roundCap")) {
      var d = t.shape, f = Tl(n.getModel("itemStyle"), d, !0);
      H(d, f), t.setShape(d);
    }
  } else {
    var u = n.get(["itemStyle", "borderRadius"]) || 0;
    t.setShape("r", u);
  }
  t.useStyle(c);
  var h = n.getShallow("cursor");
  h && t.attr("cursor", h);
  var v = l ? i ? a.r >= a.r0 ? "endArc" : "startArc" : a.endAngle >= a.startAngle ? "endAngle" : "startAngle" : i ? a.height >= 0 ? "bottom" : "top" : a.width >= 0 ? "right" : "left", p = wo(n);
  Wi(t, p, {
    labelFetcher: o,
    labelDataIndex: r,
    defaultText: q7(o.getData(), r),
    inheritColor: c.fill,
    defaultOpacity: c.opacity,
    defaultOutsidePosition: v
  });
  var g = t.getTextContent();
  if (l && g) {
    var m = n.get(["label", "position"]);
    t.textConfig.inside = m === "middle" ? !0 : null, Ghe(t, m === "outside" ? v : m, sC(i), n.get(["label", "rotate"]));
  }
  a_(g, p, o.getRawValue(r), function(y) {
    return Jx(e, y);
  });
  var w = n.getModel(["emphasis"]);
  ua(t, w.get("focus"), w.get("blurScope"), w.get("disabled")), Ei(t, n), Qhe(a) && (t.style.fill = "none", t.style.stroke = "none", I(t.states, function(y) {
    y.style && (y.style.fill = y.style.stroke = "none");
  }));
}
function Jhe(t, e) {
  var r = t.get(["itemStyle", "borderColor"]);
  if (!r || r === "none")
    return 0;
  var n = t.get(["itemStyle", "borderWidth"]) || 0, a = isNaN(e.width) ? Number.MAX_VALUE : Math.abs(e.width), o = isNaN(e.height) ? Number.MAX_VALUE : Math.abs(e.height);
  return Math.min(n, a, o);
}
var e2e = (
  /** @class */
  /* @__PURE__ */ function() {
    function t() {
    }
    return t;
  }()
), i4 = (
  /** @class */
  function(t) {
    K(e, t);
    function e(r) {
      var n = t.call(this, r) || this;
      return n.type = "largeBar", n;
    }
    return e.prototype.getDefaultShape = function() {
      return new e2e();
    }, e.prototype.buildPath = function(r, n) {
      for (var a = n.points, o = this.baseDimIdx, i = 1 - this.baseDimIdx, l = [], c = [], u = this.barWidth, d = 0; d < a.length; d += 3)
        c[o] = u, c[i] = a[d + 2], l[o] = a[d + o], l[i] = a[d + i], r.rect(l[0], l[1], c[0], c[1]);
    }, e;
  }(Ie)
);
function l4(t, e, r, n) {
  var a = t.getData(), o = a.getLayout("valueAxisHorizontal") ? 1 : 0, i = a.getLayout("largeDataIndices"), l = a.getLayout("size"), c = t.getModel("backgroundStyle"), u = a.getLayout("largeBackgroundPoints");
  if (u) {
    var d = new i4({
      shape: {
        points: u
      },
      incremental: !!n,
      silent: !0,
      z2: 0
    });
    d.baseDimIdx = o, d.largeDataIndices = i, d.barWidth = l, d.useStyle(c.getItemStyle()), e.add(d), r && r.push(d);
  }
  var f = new i4({
    shape: {
      points: a.getLayout("largePoints")
    },
    incremental: !!n,
    ignoreCoarsePointer: !0,
    z2: 1
  });
  f.baseDimIdx = o, f.largeDataIndices = i, f.barWidth = l, e.add(f), f.useStyle(a.getVisual("style")), Se(f).seriesIndex = t.seriesIndex, t.get("silent") || (f.on("mousedown", s4), f.on("mousemove", s4)), r && r.push(f);
}
var s4 = z1(function(t) {
  var e = this, r = t2e(e, t.offsetX, t.offsetY);
  Se(e).dataIndex = r >= 0 ? r : null;
}, 30, !1);
function t2e(t, e, r) {
  for (var n = t.baseDimIdx, a = 1 - n, o = t.shape.points, i = t.largeDataIndices, l = [], c = [], u = t.barWidth, d = 0, f = o.length / 3; d < f; d++) {
    var h = d * 3;
    if (c[n] = u, c[a] = o[h + 2], l[n] = o[h + n], l[a] = o[h + a], c[a] < 0 && (l[a] += c[a], c[a] = -c[a]), e >= l[0] && e <= l[0] + c[0] && r >= l[1] && r <= l[1] + c[1])
      return i[d];
  }
  return -1;
}
function cC(t, e, r) {
  if (t5(r, "cartesian2d")) {
    var n = e, a = r.getArea();
    return {
      x: t ? n.x : a.x,
      y: t ? a.y : n.y,
      width: t ? n.width : a.width,
      height: t ? a.height : n.height
    };
  } else {
    var a = r.getArea(), o = e;
    return {
      cx: a.cx,
      cy: a.cy,
      r0: t ? a.r0 : o.r0,
      r: t ? a.r : o.r,
      startAngle: t ? o.startAngle : 0,
      endAngle: t ? o.endAngle : Math.PI * 2
    };
  }
}
function r2e(t, e, r) {
  var n = t.type === "polar" ? $r : He;
  return new n({
    shape: cC(e, r, t),
    silent: !0,
    z2: 0
  });
}
function n2e(t) {
  t.registerChartView(Yhe), t.registerSeriesModel(jhe), t.registerLayout(t.PRIORITY.VISUAL.LAYOUT, Oe(hfe, "bar")), t.registerLayout(t.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, vfe("bar")), t.registerProcessor(t.PRIORITY.PROCESSOR.STATISTIC, iC("bar")), t.registerAction({
    type: "changeAxisOrder",
    event: "changeAxisOrder",
    update: "update"
  }, function(e, r) {
    var n = e.componentType || "series";
    r.eachComponent({
      mainType: n,
      query: e
    }, function(a) {
      e.sortInfo && a.axis.setCategorySortInfo(e.sortInfo);
    });
  });
}
var c4 = Math.PI * 2, jc = Math.PI / 180;
function uC(t, e) {
  return da(t.getBoxLayoutParams(), {
    width: e.getWidth(),
    height: e.getHeight()
  });
}
function dC(t, e) {
  var r = uC(t, e), n = t.get("center"), a = t.get("radius");
  z(a) || (a = [0, a]);
  var o = fe(r.width, e.getWidth()), i = fe(r.height, e.getHeight()), l = Math.min(o, i), c = fe(a[0], l / 2), u = fe(a[1], l / 2), d, f, h = t.coordinateSystem;
  if (h) {
    var v = h.dataToPoint(n);
    d = v[0] || 0, f = v[1] || 0;
  } else
    z(n) || (n = [n, n]), d = fe(n[0], o) + r.x, f = fe(n[1], i) + r.y;
  return {
    cx: d,
    cy: f,
    r0: c,
    r: u
  };
}
function a2e(t, e, r) {
  e.eachSeriesByType(t, function(n) {
    var a = n.getData(), o = a.mapDimension("value"), i = uC(n, r), l = dC(n, r), c = l.cx, u = l.cy, d = l.r, f = l.r0, h = -n.get("startAngle") * jc, v = n.get("endAngle"), p = n.get("padAngle") * jc;
    v = v === "auto" ? h - c4 : -v * jc;
    var g = n.get("minAngle") * jc, m = g + p, w = 0;
    a.each(o, function(F) {
      !isNaN(F) && w++;
    });
    var y = a.getSum(o), b = Math.PI / (y || w) * 2, _ = n.get("clockwise"), x = n.get("roseType"), E = n.get("stillShowZeroSum"), S = a.getDataExtent(o);
    S[0] = 0;
    var M = _ ? 1 : -1, R = [h, v], A = M * p / 2;
    e7(R, !_), h = R[0], v = R[1];
    var k = fC(n);
    k.startAngle = h, k.endAngle = v, k.clockwise = _;
    var L = Math.abs(v - h), T = L, O = 0, D = h;
    if (a.setLayout({
      viewRect: i,
      r: d
    }), a.each(o, function(F, B) {
      var N;
      if (isNaN(F)) {
        a.setItemLayout(B, {
          angle: NaN,
          startAngle: NaN,
          endAngle: NaN,
          clockwise: _,
          cx: c,
          cy: u,
          r0: f,
          r: x ? NaN : d
        });
        return;
      }
      x !== "area" ? N = y === 0 && E ? b : F * b : N = L / w, N < m ? (N = m, T -= m) : O += F;
      var $ = D + M * N, V = 0, W = 0;
      p > N ? (V = D + M * N / 2, W = V) : (V = D + A, W = $ - A), a.setItemLayout(B, {
        angle: N,
        startAngle: V,
        endAngle: W,
        clockwise: _,
        cx: c,
        cy: u,
        r0: f,
        r: x ? Ge(F, S, [f, d]) : d
      }), D = $;
    }), T < c4 && w)
      if (T <= 1e-3) {
        var P = L / w;
        a.each(o, function(F, B) {
          if (!isNaN(F)) {
            var N = a.getItemLayout(B);
            N.angle = P;
            var $ = 0, V = 0;
            P < p ? ($ = h + M * (B + 1 / 2) * P, V = $) : ($ = h + M * B * P + A, V = h + M * (B + 1) * P - A), N.startAngle = $, N.endAngle = V;
          }
        });
      } else
        b = T / O, D = h, a.each(o, function(F, B) {
          if (!isNaN(F)) {
            var N = a.getItemLayout(B), $ = N.angle === m ? m : F * b, V = 0, W = 0;
            $ < p ? (V = D + M * $ / 2, W = V) : (V = D + A, W = D + M * $ - A), N.startAngle = V, N.endAngle = W, D += M * $;
          }
        });
  });
}
var fC = je();
function o2e(t) {
  return {
    seriesType: t,
    reset: function(e, r) {
      var n = r.findComponents({
        mainType: "legend"
      });
      if (!(!n || !n.length)) {
        var a = e.getData();
        a.filterSelf(function(o) {
          for (var i = a.getName(o), l = 0; l < n.length; l++)
            if (!n[l].isSelected(i))
              return !1;
          return !0;
        });
      }
    }
  };
}
var i2e = Math.PI / 180;
function u4(t, e, r, n, a, o, i, l, c, u) {
  if (t.length < 2)
    return;
  function d(g) {
    for (var m = g.rB, w = m * m, y = 0; y < g.list.length; y++) {
      var b = g.list[y], _ = Math.abs(b.label.y - r), x = n + b.len, E = x * x, S = Math.sqrt((1 - Math.abs(_ * _ / w)) * E), M = e + (S + b.len2) * a, R = M - b.label.x, A = b.targetTextWidth - R * a;
      hC(b, A, !0), b.label.x = M;
    }
  }
  function f(g) {
    for (var m = {
      list: [],
      maxY: 0
    }, w = {
      list: [],
      maxY: 0
    }, y = 0; y < g.length; y++)
      if (g[y].labelAlignTo === "none") {
        var b = g[y], _ = b.label.y > r ? w : m, x = Math.abs(b.label.y - r);
        if (x >= _.maxY) {
          var E = b.label.x - e - b.len2 * a, S = n + b.len, M = Math.abs(E) < S ? Math.sqrt(x * x / (1 - E * E / S / S)) : S;
          _.rB = M, _.maxY = x;
        }
        _.list.push(b);
      }
    d(m), d(w);
  }
  for (var h = t.length, v = 0; v < h; v++)
    if (t[v].position === "outer" && t[v].labelAlignTo === "labelLine") {
      var p = t[v].label.x - u;
      t[v].linePoints[1][0] += p, t[v].label.x = u;
    }
  whe(t, c, c + i) && f(t);
}
function l2e(t, e, r, n, a, o, i, l) {
  for (var c = [], u = [], d = Number.MAX_VALUE, f = -Number.MAX_VALUE, h = 0; h < t.length; h++) {
    var v = t[h].label;
    ef(t[h]) || (v.x < e ? (d = Math.min(d, v.x), c.push(t[h])) : (f = Math.max(f, v.x), u.push(t[h])));
  }
  for (var h = 0; h < t.length; h++) {
    var p = t[h];
    if (!ef(p) && p.linePoints) {
      if (p.labelStyleWidth != null)
        continue;
      var v = p.label, g = p.linePoints, m = void 0;
      p.labelAlignTo === "edge" ? v.x < e ? m = g[2][0] - p.labelDistance - i - p.edgeDistance : m = i + a - p.edgeDistance - g[2][0] - p.labelDistance : p.labelAlignTo === "labelLine" ? v.x < e ? m = d - i - p.bleedMargin : m = i + a - f - p.bleedMargin : v.x < e ? m = v.x - i - p.bleedMargin : m = i + a - v.x - p.bleedMargin, p.targetTextWidth = m, hC(p, m);
    }
  }
  u4(u, e, r, n, 1, a, o, i, l, f), u4(c, e, r, n, -1, a, o, i, l, d);
  for (var h = 0; h < t.length; h++) {
    var p = t[h];
    if (!ef(p) && p.linePoints) {
      var v = p.label, g = p.linePoints, w = p.labelAlignTo === "edge", y = v.style.padding, b = y ? y[1] + y[3] : 0, _ = v.style.backgroundColor ? 0 : b, x = p.rect.width + _, E = g[1][0] - g[2][0];
      w ? v.x < e ? g[2][0] = i + p.edgeDistance + x + p.labelDistance : g[2][0] = i + a - p.edgeDistance - x - p.labelDistance : (v.x < e ? g[2][0] = v.x + p.labelDistance : g[2][0] = v.x - p.labelDistance, g[1][0] = g[2][0] + E), g[1][1] = g[2][1] = v.y;
    }
  }
}
function hC(t, e, r) {
  if (r === void 0 && (r = !1), t.labelStyleWidth == null) {
    var n = t.label, a = n.style, o = t.rect, i = a.backgroundColor, l = a.padding, c = l ? l[1] + l[3] : 0, u = a.overflow, d = o.width + (i ? 0 : c);
    if (e < d || r) {
      var f = o.height;
      if (u && u.match("break")) {
        n.setStyle("backgroundColor", null), n.setStyle("width", e - c);
        var h = n.getBoundingRect();
        n.setStyle("width", Math.ceil(h.width)), n.setStyle("backgroundColor", i);
      } else {
        var v = e - c, p = e < d ? v : (
          // Current available width is enough, but the text may have
          // already been wrapped with a smaller available width.
          r ? v > t.unconstrainedWidth ? null : v : null
        );
        n.setStyle("width", p);
      }
      var g = n.getBoundingRect();
      o.width = g.width;
      var m = (n.style.margin || 0) + 2.1;
      o.height = g.height + m, o.y -= (o.height - f) / 2;
    }
  }
}
function ef(t) {
  return t.position === "center";
}
function s2e(t) {
  var e = t.getData(), r = [], n, a, o = !1, i = (t.get("minShowLabelAngle") || 0) * i2e, l = e.getLayout("viewRect"), c = e.getLayout("r"), u = l.width, d = l.x, f = l.y, h = l.height;
  function v(E) {
    E.ignore = !0;
  }
  function p(E) {
    if (!E.ignore)
      return !0;
    for (var S in E.states)
      if (E.states[S].ignore === !1)
        return !0;
    return !1;
  }
  e.each(function(E) {
    var S = e.getItemGraphicEl(E), M = S.shape, R = S.getTextContent(), A = S.getTextGuideLine(), k = e.getItemModel(E), L = k.getModel("label"), T = L.get("position") || k.get(["emphasis", "label", "position"]), O = L.get("distanceToLabelLine"), D = L.get("alignTo"), P = fe(L.get("edgeDistance"), u), F = L.get("bleedMargin"), B = k.getModel("labelLine"), N = B.get("length");
    N = fe(N, u);
    var $ = B.get("length2");
    if ($ = fe($, u), Math.abs(M.endAngle - M.startAngle) < i) {
      I(R.states, v), R.ignore = !0, A && (I(A.states, v), A.ignore = !0);
      return;
    }
    if (p(R)) {
      var V = (M.startAngle + M.endAngle) / 2, W = Math.cos(V), ee = Math.sin(V), ne, we, pe, X;
      n = M.cx, a = M.cy;
      var me = T === "inside" || T === "inner";
      if (T === "center")
        ne = M.cx, we = M.cy, X = "center";
      else {
        var ve = (me ? (M.r + M.r0) / 2 * W : M.r * W) + n, ae = (me ? (M.r + M.r0) / 2 * ee : M.r * ee) + a;
        if (ne = ve + W * 3, we = ae + ee * 3, !me) {
          var Y = ve + W * (N + c - M.r), q = ae + ee * (N + c - M.r), We = Y + (W < 0 ? -1 : 1) * $, Ne = q;
          D === "edge" ? ne = W < 0 ? d + P : d + u - P : ne = We + (W < 0 ? -O : O), we = Ne, pe = [[ve, ae], [Y, q], [We, Ne]];
        }
        X = me ? "center" : D === "edge" ? W > 0 ? "right" : "left" : W > 0 ? "left" : "right";
      }
      var It = Math.PI, xt = 0, Sr = L.get("rotate");
      if (De(Sr))
        xt = Sr * (It / 180);
      else if (T === "center")
        xt = 0;
      else if (Sr === "radial" || Sr === !0) {
        var m5 = W < 0 ? -V + It : -V;
        xt = m5;
      } else if (Sr === "tangential" && T !== "outside" && T !== "outer") {
        var Rr = Math.atan2(W, ee);
        Rr < 0 && (Rr = It * 2 + Rr);
        var xS = ee > 0;
        xS && (Rr = It + Rr), xt = Rr - It;
      }
      if (o = !!xt, R.x = ne, R.y = we, R.rotation = xt, R.setStyle({
        verticalAlign: "middle"
      }), me) {
        R.setStyle({
          align: X
        });
        var w5 = R.states.select;
        w5 && (w5.x += R.x, w5.y += R.y);
      } else {
        var Yi = R.getBoundingRect().clone();
        Yi.applyTransform(R.getComputedTransform());
        var vp = (R.style.margin || 0) + 2.1;
        Yi.y -= vp / 2, Yi.height += vp, r.push({
          label: R,
          labelLine: A,
          position: T,
          len: N,
          len2: $,
          minTurnAngle: B.get("minTurnAngle"),
          maxSurfaceAngle: B.get("maxSurfaceAngle"),
          surfaceNormal: new he(W, ee),
          linePoints: pe,
          textAlign: X,
          labelDistance: O,
          labelAlignTo: D,
          edgeDistance: P,
          bleedMargin: F,
          rect: Yi,
          unconstrainedWidth: Yi.width,
          labelStyleWidth: R.style.width
        });
      }
      S.setTextConfig({
        inside: me
      });
    }
  }), !o && t.get("avoidLabelOverlap") && l2e(r, n, a, c, u, h, d, f);
  for (var g = 0; g < r.length; g++) {
    var m = r[g], w = m.label, y = m.labelLine, b = isNaN(w.x) || isNaN(w.y);
    if (w) {
      w.setStyle({
        align: m.textAlign
      }), b && (I(w.states, v), w.ignore = !0);
      var _ = w.states.select;
      _ && (_.x += w.x, _.y += w.y);
    }
    if (y) {
      var x = m.linePoints;
      b || !x ? (I(y.states, v), y.ignore = !0) : (dhe(x, m.minTurnAngle), fhe(x, m.surfaceNormal, m.maxSurfaceAngle), y.setShape({
        points: x
      }), w.__hostTarget.textGuideLineConfig = {
        anchor: new he(x[0][0], x[0][1])
      });
    }
  }
}
var c2e = (
  /** @class */
  function(t) {
    K(e, t);
    function e(r, n, a) {
      var o = t.call(this) || this;
      o.z2 = 2;
      var i = new Ye();
      return o.setTextContent(i), o.updateData(r, n, a, !0), o;
    }
    return e.prototype.updateData = function(r, n, a, o) {
      var i = this, l = r.hostModel, c = r.getItemModel(n), u = c.getModel("emphasis"), d = r.getItemLayout(n), f = H(Tl(c.getModel("itemStyle"), d, !0), d);
      if (isNaN(f.startAngle)) {
        i.setShape(f);
        return;
      }
      if (o) {
        i.setShape(f);
        var h = l.getShallow("animationType");
        l.ecModel.ssr ? (dt(i, {
          scaleX: 0,
          scaleY: 0
        }, l, {
          dataIndex: n,
          isFrom: !0
        }), i.originX = f.cx, i.originY = f.cy) : h === "scale" ? (i.shape.r = d.r0, dt(i, {
          shape: {
            r: d.r
          }
        }, l, n)) : a != null ? (i.setShape({
          startAngle: a,
          endAngle: a
        }), dt(i, {
          shape: {
            startAngle: d.startAngle,
            endAngle: d.endAngle
          }
        }, l, n)) : (i.shape.endAngle = d.startAngle, rt(i, {
          shape: {
            endAngle: d.endAngle
          }
        }, l, n));
      } else
        s7(i), rt(i, {
          shape: f
        }, l, n);
      i.useStyle(r.getItemVisual(n, "style")), Ei(i, c);
      var v = (d.startAngle + d.endAngle) / 2, p = l.get("selectedOffset"), g = Math.cos(v) * p, m = Math.sin(v) * p, w = c.getShallow("cursor");
      w && i.attr("cursor", w), this._updateLabel(l, r, n), i.ensureState("emphasis").shape = H({
        r: d.r + (u.get("scale") && u.get("scaleSize") || 0)
      }, Tl(u.getModel("itemStyle"), d)), H(i.ensureState("select"), {
        x: g,
        y: m,
        shape: Tl(c.getModel(["select", "itemStyle"]), d)
      }), H(i.ensureState("blur"), {
        shape: Tl(c.getModel(["blur", "itemStyle"]), d)
      });
      var y = i.getTextGuideLine(), b = i.getTextContent();
      y && H(y.ensureState("select"), {
        x: g,
        y: m
      }), H(b.ensureState("select"), {
        x: g,
        y: m
      }), ua(this, u.get("focus"), u.get("blurScope"), u.get("disabled"));
    }, e.prototype._updateLabel = function(r, n, a) {
      var o = this, i = n.getItemModel(a), l = i.getModel("labelLine"), c = n.getItemVisual(a, "style"), u = c && c.fill, d = c && c.opacity;
      Wi(o, wo(i), {
        labelFetcher: n.hostModel,
        labelDataIndex: a,
        inheritColor: u,
        defaultOpacity: d,
        defaultText: r.getFormattedLabel(a, "normal") || n.getName(a)
      });
      var f = o.getTextContent();
      o.setTextConfig({
        // reset position, rotation
        position: null,
        rotation: null
      }), f.attr({
        z2: 10
      });
      var h = r.get(["label", "position"]);
      if (h !== "outside" && h !== "outer")
        o.removeTextGuideLine();
      else {
        var v = this.getTextGuideLine();
        v || (v = new mo(), this.setTextGuideLine(v)), vhe(this, phe(i), {
          stroke: u,
          opacity: ea(l.get(["lineStyle", "opacity"]), d, 1)
        });
      }
    }, e;
  }($r)
), u2e = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.ignoreLabelLineUpdate = !0, r;
    }
    return e.prototype.render = function(r, n, a, o) {
      var i = r.getData(), l = this._data, c = this.group, u;
      if (!l && i.count() > 0) {
        for (var d = i.getItemLayout(0), f = 1; isNaN(d && d.startAngle) && f < i.count(); ++f)
          d = i.getItemLayout(f);
        d && (u = d.startAngle);
      }
      if (this._emptyCircleSector && c.remove(this._emptyCircleSector), i.count() === 0 && r.get("showEmptyCircle")) {
        var h = fC(r), v = new $r({
          shape: H(dC(r, a), h)
        });
        v.useStyle(r.getModel("emptyCircleStyle").getItemStyle()), this._emptyCircleSector = v, c.add(v);
      }
      i.diff(l).add(function(p) {
        var g = new c2e(i, p, u);
        i.setItemGraphicEl(p, g), c.add(g);
      }).update(function(p, g) {
        var m = l.getItemGraphicEl(g);
        m.updateData(i, p, u), m.off("click"), c.add(m), i.setItemGraphicEl(p, m);
      }).remove(function(p) {
        var g = l.getItemGraphicEl(p);
        au(g, r, p);
      }).execute(), s2e(r), r.get("animationTypeUpdate") !== "expansion" && (this._data = i);
    }, e.prototype.dispose = function() {
    }, e.prototype.containPoint = function(r, n) {
      var a = n.getData(), o = a.getItemLayout(0);
      if (o) {
        var i = r[0] - o.cx, l = r[1] - o.cy, c = Math.sqrt(i * i + l * l);
        return c <= o.r && c >= o.r0;
      }
    }, e.type = "pie", e;
  }(wt)
);
function vC(t, e, r) {
  e = z(e) && {
    coordDimensions: e
  } || H({
    encodeDefine: t.getEncode()
  }, e);
  var n = t.getSource(), a = H7(n, e).dimensions, o = new fi(a, t);
  return o.initData(n, r), o;
}
var d2e = (
  /** @class */
  function() {
    function t(e, r) {
      this._getDataWithEncodedVisual = e, this._getRawData = r;
    }
    return t.prototype.getAllNames = function() {
      var e = this._getRawData();
      return e.mapArray(e.getName);
    }, t.prototype.containName = function(e) {
      var r = this._getRawData();
      return r.indexOfName(e) >= 0;
    }, t.prototype.indexOfName = function(e) {
      var r = this._getDataWithEncodedVisual();
      return r.indexOfName(e);
    }, t.prototype.getItemVisual = function(e, r) {
      var n = this._getDataWithEncodedVisual();
      return n.getItemVisual(e, r);
    }, t;
  }()
), f2e = je(), h2e = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.init = function(r) {
      t.prototype.init.apply(this, arguments), this.legendVisualProvider = new d2e(le(this.getData, this), le(this.getRawData, this)), this._defaultLabelLine(r);
    }, e.prototype.mergeOption = function() {
      t.prototype.mergeOption.apply(this, arguments);
    }, e.prototype.getInitialData = function() {
      return vC(this, {
        coordDimensions: ["value"],
        encodeDefaulter: Oe(Xue, this)
      });
    }, e.prototype.getDataParams = function(r) {
      var n = this.getData(), a = f2e(n), o = a.seats;
      if (!o) {
        var i = [];
        n.each(n.mapDimension("value"), function(c) {
          i.push(c);
        }), o = a.seats = c9(i, n.hostModel.get("percentPrecision"));
      }
      var l = t.prototype.getDataParams.call(this, r);
      return l.percent = o[r] || 0, l.$vars.push("percent"), l;
    }, e.prototype._defaultLabelLine = function(r) {
      J0(r, "labelLine", ["show"]);
      var n = r.labelLine, a = r.emphasis.labelLine;
      n.show = n.show && r.label.show, a.show = a.show && r.emphasis.label.show;
    }, e.type = "series.pie", e.defaultOption = {
      // zlevel: 0,
      z: 2,
      legendHoverLink: !0,
      colorBy: "data",
      // 默认全局居中
      center: ["50%", "50%"],
      radius: [0, "75%"],
      // 默认顺时针
      clockwise: !0,
      startAngle: 90,
      endAngle: "auto",
      padAngle: 0,
      // 最小角度改为0
      minAngle: 0,
      // If the angle of a sector less than `minShowLabelAngle`,
      // the label will not be displayed.
      minShowLabelAngle: 0,
      // 选中时扇区偏移量
      selectedOffset: 10,
      // 选择模式，默认关闭，可选single，multiple
      // selectedMode: false,
      // 南丁格尔玫瑰图模式，'radius'（半径） | 'area'（面积）
      // roseType: null,
      percentPrecision: 2,
      // If still show when all data zero.
      stillShowZeroSum: !0,
      // cursor: null,
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      width: null,
      height: null,
      label: {
        // color: 'inherit',
        // If rotate around circle
        rotate: 0,
        show: !0,
        overflow: "truncate",
        // 'outer', 'inside', 'center'
        position: "outer",
        // 'none', 'labelLine', 'edge'. Works only when position is 'outer'
        alignTo: "none",
        // Closest distance between label and chart edge.
        // Works only position is 'outer' and alignTo is 'edge'.
        edgeDistance: "25%",
        // Works only position is 'outer' and alignTo is not 'edge'.
        bleedMargin: 10,
        // Distance between text and label line.
        distanceToLabelLine: 5
        // formatter: 标签文本格式器，同 tooltip.formatter，不支持异步回调
        // 默认使用全局文本样式，详见 textStyle
        // distance: 当position为inner时有效，为label位置到圆心的距离与圆半径(环状图为内外半径和)的比例系数
      },
      // Enabled when label.normal.position is 'outer'
      labelLine: {
        show: !0,
        // 引导线两段中的第一段长度
        length: 15,
        // 引导线两段中的第二段长度
        length2: 15,
        smooth: !1,
        minTurnAngle: 90,
        maxSurfaceAngle: 90,
        lineStyle: {
          // color: 各异,
          width: 1,
          type: "solid"
        }
      },
      itemStyle: {
        borderWidth: 1,
        borderJoin: "round"
      },
      showEmptyCircle: !0,
      emptyCircleStyle: {
        color: "lightgray",
        opacity: 1
      },
      labelLayout: {
        // Hide the overlapped label.
        hideOverlap: !0
      },
      emphasis: {
        scale: !0,
        scaleSize: 5
      },
      // If use strategy to avoid label overlapping
      avoidLabelOverlap: !0,
      // Animation type. Valid values: expansion, scale
      animationType: "expansion",
      animationDuration: 1e3,
      // Animation type when update. Valid values: transition, expansion
      animationTypeUpdate: "transition",
      animationEasingUpdate: "cubicInOut",
      animationDurationUpdate: 500,
      animationEasing: "cubicInOut"
    }, e;
  }(Tt)
);
function v2e(t) {
  return {
    seriesType: t,
    reset: function(e, r) {
      var n = e.getData();
      n.filterSelf(function(a) {
        var o = n.mapDimension("value"), i = n.get(o, a);
        return !(De(i) && !isNaN(i) && i < 0);
      });
    }
  };
}
function p2e(t) {
  t.registerChartView(u2e), t.registerSeriesModel(h2e), T5e("pie", t.registerAction), t.registerLayout(Oe(a2e, "pie")), t.registerProcessor(o2e("pie")), t.registerProcessor(v2e("pie"));
}
var g2e = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.type = "grid", e.dependencies = ["xAxis", "yAxis"], e.layoutMode = "box", e.defaultOption = {
      show: !1,
      // zlevel: 0,
      z: 0,
      left: "10%",
      top: 60,
      right: "10%",
      bottom: 70,
      // If grid size contain label
      containLabel: !1,
      // width: {totalWidth} - left - right,
      // height: {totalHeight} - top - bottom,
      backgroundColor: "rgba(0,0,0,0)",
      borderWidth: 1,
      borderColor: "#ccc"
    }, e;
  }(Ee)
), c2 = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.getCoordSysModel = function() {
      return this.getReferringComponents("grid", Ht).models[0];
    }, e.type = "cartesian2dAxis", e;
  }(Ee)
);
tr(c2, Zx);
var pC = {
  show: !0,
  // zlevel: 0,
  z: 0,
  // Inverse the axis.
  inverse: !1,
  // Axis name displayed.
  name: "",
  // 'start' | 'middle' | 'end'
  nameLocation: "end",
  // By degree. By default auto rotate by nameLocation.
  nameRotate: null,
  nameTruncate: {
    maxWidth: null,
    ellipsis: "...",
    placeholder: "."
  },
  // Use global text style by default.
  nameTextStyle: {},
  // The gap between axisName and axisLine.
  nameGap: 15,
  // Default `false` to support tooltip.
  silent: !1,
  // Default `false` to avoid legacy user event listener fail.
  triggerEvent: !1,
  tooltip: {
    show: !1
  },
  axisPointer: {},
  axisLine: {
    show: !0,
    onZero: !0,
    onZeroAxisIndex: null,
    lineStyle: {
      color: "#6E7079",
      width: 1,
      type: "solid"
    },
    // The arrow at both ends the the axis.
    symbol: ["none", "none"],
    symbolSize: [10, 15]
  },
  axisTick: {
    show: !0,
    // Whether axisTick is inside the grid or outside the grid.
    inside: !1,
    // The length of axisTick.
    length: 5,
    lineStyle: {
      width: 1
    }
  },
  axisLabel: {
    show: !0,
    // Whether axisLabel is inside the grid or outside the grid.
    inside: !1,
    rotate: 0,
    // true | false | null/undefined (auto)
    showMinLabel: null,
    // true | false | null/undefined (auto)
    showMaxLabel: null,
    margin: 8,
    // formatter: null,
    fontSize: 12
  },
  splitLine: {
    show: !0,
    lineStyle: {
      color: ["#E0E6F1"],
      width: 1,
      type: "solid"
    }
  },
  splitArea: {
    show: !1,
    areaStyle: {
      color: ["rgba(250,250,250,0.2)", "rgba(210,219,238,0.2)"]
    }
  }
}, m2e = Ce({
  // The gap at both ends of the axis. For categoryAxis, boolean.
  boundaryGap: !0,
  // Set false to faster category collection.
  deduplication: null,
  // splitArea: {
  // show: false
  // },
  splitLine: {
    show: !1
  },
  axisTick: {
    // If tick is align with label when boundaryGap is true
    alignWithLabel: !1,
    interval: "auto"
  },
  axisLabel: {
    interval: "auto"
  }
}, pC), Q7 = Ce({
  boundaryGap: [0, 0],
  axisLine: {
    // Not shown when other axis is categoryAxis in cartesian
    show: "auto"
  },
  axisTick: {
    // Not shown when other axis is categoryAxis in cartesian
    show: "auto"
  },
  // TODO
  // min/max: [30, datamin, 60] or [20, datamin] or [datamin, 60]
  splitNumber: 5,
  minorTick: {
    // Minor tick, not available for cateogry axis.
    show: !1,
    // Split number of minor ticks. The value should be in range of (0, 100)
    splitNumber: 5,
    // Length of minor tick
    length: 3,
    // Line style
    lineStyle: {
      // Default to be same with axisTick
    }
  },
  minorSplitLine: {
    show: !1,
    lineStyle: {
      color: "#F4F7FD",
      width: 1
    }
  }
}, pC), w2e = Ce({
  splitNumber: 6,
  axisLabel: {
    // To eliminate labels that are not nice
    showMinLabel: !1,
    showMaxLabel: !1,
    rich: {
      primary: {
        fontWeight: "bold"
      }
    }
  },
  splitLine: {
    show: !1
  }
}, Q7), y2e = Te({
  logBase: 10
}, Q7);
const b2e = {
  category: m2e,
  value: Q7,
  time: w2e,
  log: y2e
};
var _2e = {
  value: 1,
  category: 1,
  time: 1,
  log: 1
};
function d4(t, e, r, n) {
  I(_2e, function(a, o) {
    var i = Ce(Ce({}, b2e[o], !0), n, !0), l = (
      /** @class */
      function(c) {
        K(u, c);
        function u() {
          var d = c !== null && c.apply(this, arguments) || this;
          return d.type = e + "Axis." + o, d;
        }
        return u.prototype.mergeDefaultAndTheme = function(d, f) {
          var h = ss(this), v = h ? zs(d) : {}, p = f.getTheme();
          Ce(d, p.get(o + "Axis")), Ce(d, this.getDefaultOption()), d.type = f4(d), h && Ri(d, v, h);
        }, u.prototype.optionUpdated = function() {
          var d = this.option;
          d.type === "category" && (this.__ordinalMeta = a2.createByAxisModel(this));
        }, u.prototype.getCategories = function(d) {
          var f = this.option;
          if (f.type === "category")
            return d ? f.data : this.__ordinalMeta.categories;
        }, u.prototype.getOrdinalMeta = function() {
          return this.__ordinalMeta;
        }, u.type = e + "Axis." + o, u.defaultOption = i, u;
      }(r)
    );
    t.registerComponentModel(l);
  }), t.registerSubTypeDefaulter(e + "Axis", f4);
}
function f4(t) {
  return t.type || (t.data ? "category" : "value");
}
var x2e = (
  /** @class */
  function() {
    function t(e) {
      this.type = "cartesian", this._dimList = [], this._axes = {}, this.name = e || "";
    }
    return t.prototype.getAxis = function(e) {
      return this._axes[e];
    }, t.prototype.getAxes = function() {
      return J(this._dimList, function(e) {
        return this._axes[e];
      }, this);
    }, t.prototype.getAxesByScale = function(e) {
      return e = e.toLowerCase(), ot(this.getAxes(), function(r) {
        return r.scale.type === e;
      });
    }, t.prototype.addAxis = function(e) {
      var r = e.dim;
      this._axes[r] = e, this._dimList.push(r);
    }, t;
  }()
), u2 = ["x", "y"];
function h4(t) {
  return t.type === "interval" || t.type === "time";
}
var C2e = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = "cartesian2d", r.dimensions = u2, r;
    }
    return e.prototype.calcAffineTransform = function() {
      this._transform = this._invTransform = null;
      var r = this.getAxis("x").scale, n = this.getAxis("y").scale;
      if (!(!h4(r) || !h4(n))) {
        var a = r.getExtent(), o = n.getExtent(), i = this.dataToPoint([a[0], o[0]]), l = this.dataToPoint([a[1], o[1]]), c = a[1] - a[0], u = o[1] - o[0];
        if (!(!c || !u)) {
          var d = (l[0] - i[0]) / c, f = (l[1] - i[1]) / u, h = i[0] - a[0] * d, v = i[1] - o[0] * f, p = this._transform = [d, 0, 0, f, h, v];
          this._invTransform = Ts([], p);
        }
      }
    }, e.prototype.getBaseAxis = function() {
      return this.getAxesByScale("ordinal")[0] || this.getAxesByScale("time")[0] || this.getAxis("x");
    }, e.prototype.containPoint = function(r) {
      var n = this.getAxis("x"), a = this.getAxis("y");
      return n.contain(n.toLocalCoord(r[0])) && a.contain(a.toLocalCoord(r[1]));
    }, e.prototype.containData = function(r) {
      return this.getAxis("x").containData(r[0]) && this.getAxis("y").containData(r[1]);
    }, e.prototype.containZone = function(r, n) {
      var a = this.dataToPoint(r), o = this.dataToPoint(n), i = this.getArea(), l = new Le(a[0], a[1], o[0] - a[0], o[1] - a[1]);
      return i.intersect(l);
    }, e.prototype.dataToPoint = function(r, n, a) {
      a = a || [];
      var o = r[0], i = r[1];
      if (this._transform && o != null && isFinite(o) && i != null && isFinite(i))
        return At(a, r, this._transform);
      var l = this.getAxis("x"), c = this.getAxis("y");
      return a[0] = l.toGlobalCoord(l.dataToCoord(o, n)), a[1] = c.toGlobalCoord(c.dataToCoord(i, n)), a;
    }, e.prototype.clampData = function(r, n) {
      var a = this.getAxis("x").scale, o = this.getAxis("y").scale, i = a.getExtent(), l = o.getExtent(), c = a.parse(r[0]), u = o.parse(r[1]);
      return n = n || [], n[0] = Math.min(Math.max(Math.min(i[0], i[1]), c), Math.max(i[0], i[1])), n[1] = Math.min(Math.max(Math.min(l[0], l[1]), u), Math.max(l[0], l[1])), n;
    }, e.prototype.pointToData = function(r, n) {
      var a = [];
      if (this._invTransform)
        return At(a, r, this._invTransform);
      var o = this.getAxis("x"), i = this.getAxis("y");
      return a[0] = o.coordToData(o.toLocalCoord(r[0]), n), a[1] = i.coordToData(i.toLocalCoord(r[1]), n), a;
    }, e.prototype.getOtherAxis = function(r) {
      return this.getAxis(r.dim === "x" ? "y" : "x");
    }, e.prototype.getArea = function(r) {
      r = r || 0;
      var n = this.getAxis("x").getGlobalExtent(), a = this.getAxis("y").getGlobalExtent(), o = Math.min(n[0], n[1]) - r, i = Math.min(a[0], a[1]) - r, l = Math.max(n[0], n[1]) - o + r, c = Math.max(a[0], a[1]) - i + r;
      return new Le(o, i, l, c);
    }, e;
  }(x2e)
), E2e = (
  /** @class */
  function(t) {
    K(e, t);
    function e(r, n, a, o, i) {
      var l = t.call(this, r, n, a) || this;
      return l.index = 0, l.type = o || "value", l.position = i || "bottom", l;
    }
    return e.prototype.isHorizontal = function() {
      var r = this.position;
      return r === "top" || r === "bottom";
    }, e.prototype.getGlobalExtent = function(r) {
      var n = this.getExtent();
      return n[0] = this.toGlobalCoord(n[0]), n[1] = this.toGlobalCoord(n[1]), r && n[0] > n[1] && n.reverse(), n;
    }, e.prototype.pointToData = function(r, n) {
      return this.coordToData(this.toLocalCoord(r[this.dim === "x" ? 0 : 1]), n);
    }, e.prototype.setCategorySortInfo = function(r) {
      if (this.type !== "category")
        return !1;
      this.model.option.categorySortInfo = r, this.scale.setSortInfo(r);
    }, e;
  }(Kx)
);
function d2(t, e, r) {
  r = r || {};
  var n = t.coordinateSystem, a = e.axis, o = {}, i = a.getAxesOnZeroOf()[0], l = a.position, c = i ? "onZero" : l, u = a.dim, d = n.getRect(), f = [d.x, d.x + d.width, d.y, d.y + d.height], h = {
    left: 0,
    right: 1,
    top: 0,
    bottom: 1,
    onZero: 2
  }, v = e.get("offset") || 0, p = u === "x" ? [f[2] - v, f[3] + v] : [f[0] - v, f[1] + v];
  if (i) {
    var g = i.toGlobalCoord(i.dataToCoord(0));
    p[h.onZero] = Math.max(Math.min(g, p[1]), p[0]);
  }
  o.position = [u === "y" ? p[h[c]] : f[0], u === "x" ? p[h[c]] : f[3]], o.rotation = Math.PI / 2 * (u === "x" ? 0 : 1);
  var m = {
    top: -1,
    bottom: 1,
    left: -1,
    right: 1
  };
  o.labelDirection = o.tickDirection = o.nameDirection = m[l], o.labelOffset = i ? p[h[l]] - p[h.onZero] : 0, e.get(["axisTick", "inside"]) && (o.tickDirection = -o.tickDirection), Cn(r.labelInside, e.get(["axisLabel", "inside"])) && (o.labelDirection = -o.labelDirection);
  var w = e.get(["axisLabel", "rotate"]);
  return o.labelRotate = c === "top" ? -w : w, o.z2 = 1, o;
}
function v4(t) {
  return t.get("coordinateSystem") === "cartesian2d";
}
function p4(t) {
  var e = {
    xAxisModel: null,
    yAxisModel: null
  };
  return I(e, function(r, n) {
    var a = n.replace(/Model$/, ""), o = t.getReferringComponents(a, Ht).models[0];
    if (process.env.NODE_ENV !== "production" && !o)
      throw new Error(a + ' "' + ea(t.get(a + "Index"), t.get(a + "Id"), 0) + '" not found');
    e[n] = o;
  }), e;
}
var tf = Math.log;
function S2e(t, e, r) {
  var n = Gi.prototype, a = n.getTicks.call(r), o = n.getTicks.call(r, !0), i = a.length - 1, l = n.getInterval.call(r), c = Bx(t, e), u = c.extent, d = c.fixMin, f = c.fixMax;
  if (t.type === "log") {
    var h = tf(t.base);
    u = [tf(u[0]) / h, tf(u[1]) / h];
  }
  t.setExtent(u[0], u[1]), t.calcNiceExtent({
    splitNumber: i,
    fixMin: d,
    fixMax: f
  });
  var v = n.getExtent.call(t);
  d && (u[0] = v[0]), f && (u[1] = v[1]);
  var p = n.getInterval.call(t), g = u[0], m = u[1];
  if (d && f)
    p = (m - g) / i;
  else if (d)
    for (m = u[0] + p * i; m < u[1] && isFinite(m) && isFinite(u[1]); )
      p = Gd(p), m = u[0] + p * i;
  else if (f)
    for (g = u[1] - p * i; g > u[0] && isFinite(g) && isFinite(u[0]); )
      p = Gd(p), g = u[1] - p * i;
  else {
    var w = t.getTicks().length - 1;
    w > i && (p = Gd(p));
    var y = p * i;
    m = Math.ceil(u[1] / p) * p, g = Qe(m - y), g < 0 && u[0] >= 0 ? (g = 0, m = Qe(y)) : m > 0 && u[1] <= 0 && (m = 0, g = -Qe(y));
  }
  var b = (a[0].value - o[0].value) / l, _ = (a[i].value - o[i].value) / l;
  if (n.setExtent.call(t, g + p * b, m + p * _), n.setInterval.call(t, p), (b || _) && n.setNiceExtent.call(t, g + p, m - p), process.env.NODE_ENV !== "production") {
    var x = n.getTicks.call(t);
    x[1] && (!ofe(p) || K0(x[1].value) > K0(p)) && pt(
      // eslint-disable-next-line
      "The ticks may be not readable when set min: " + e.get("min") + ", max: " + e.get("max") + " and alignTicks: true"
    );
  }
}
var R2e = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.type = "grid", this._coordsMap = {}, this._coordsList = [], this._axesMap = {}, this._axesList = [], this.axisPointerEnabled = !0, this.dimensions = u2, this._initCartesian(e, r, n), this.model = e;
    }
    return t.prototype.getRect = function() {
      return this._rect;
    }, t.prototype.update = function(e, r) {
      var n = this._axesMap;
      this._updateScale(e, this.model);
      function a(i) {
        var l, c = Ze(i), u = c.length;
        if (u) {
          for (var d = [], f = u - 1; f >= 0; f--) {
            var h = +c[f], v = i[h], p = v.model, g = v.scale;
            // Only value and log axis without interval support alignTicks.
            o2(g) && p.get("alignTicks") && p.get("interval") == null ? d.push(v) : (i2(g, p), o2(g) && (l = v));
          }
          d.length && (l || (l = d.pop(), i2(l.scale, l.model)), I(d, function(m) {
            S2e(m.scale, m.model, l.scale);
          }));
        }
      }
      a(n.x), a(n.y);
      var o = {};
      I(n.x, function(i) {
        g4(n, "y", i, o);
      }), I(n.y, function(i) {
        g4(n, "x", i, o);
      }), this.resize(this.model, r);
    }, t.prototype.resize = function(e, r, n) {
      var a = e.getBoxLayoutParams(), o = !n && e.get("containLabel"), i = da(a, {
        width: r.getWidth(),
        height: r.getHeight()
      });
      this._rect = i;
      var l = this._axesList;
      c(), o && (I(l, function(u) {
        if (!u.model.get(["axisLabel", "inside"])) {
          var d = Ofe(u);
          if (d) {
            var f = u.isHorizontal() ? "height" : "width", h = u.model.get(["axisLabel", "margin"]);
            i[f] -= d[f] + h, u.position === "top" ? i.y += d.height + h : u.position === "left" && (i.x += d.width + h);
          }
        }
      }), c()), I(this._coordsList, function(u) {
        u.calcAffineTransform();
      });
      function c() {
        I(l, function(u) {
          var d = u.isHorizontal(), f = d ? [0, i.width] : [0, i.height], h = u.inverse ? 1 : 0;
          u.setExtent(f[h], f[1 - h]), M2e(u, d ? i.x : i.y);
        });
      }
    }, t.prototype.getAxis = function(e, r) {
      var n = this._axesMap[e];
      if (n != null)
        return n[r || 0];
    }, t.prototype.getAxes = function() {
      return this._axesList.slice();
    }, t.prototype.getCartesian = function(e, r) {
      if (e != null && r != null) {
        var n = "x" + e + "y" + r;
        return this._coordsMap[n];
      }
      re(e) && (r = e.yAxisIndex, e = e.xAxisIndex);
      for (var a = 0, o = this._coordsList; a < o.length; a++)
        if (o[a].getAxis("x").index === e || o[a].getAxis("y").index === r)
          return o[a];
    }, t.prototype.getCartesians = function() {
      return this._coordsList.slice();
    }, t.prototype.convertToPixel = function(e, r, n) {
      var a = this._findConvertTarget(r);
      return a.cartesian ? a.cartesian.dataToPoint(n) : a.axis ? a.axis.toGlobalCoord(a.axis.dataToCoord(n)) : null;
    }, t.prototype.convertFromPixel = function(e, r, n) {
      var a = this._findConvertTarget(r);
      return a.cartesian ? a.cartesian.pointToData(n) : a.axis ? a.axis.coordToData(a.axis.toLocalCoord(n)) : null;
    }, t.prototype._findConvertTarget = function(e) {
      var r = e.seriesModel, n = e.xAxisModel || r && r.getReferringComponents("xAxis", Ht).models[0], a = e.yAxisModel || r && r.getReferringComponents("yAxis", Ht).models[0], o = e.gridModel, i = this._coordsList, l, c;
      if (r)
        l = r.coordinateSystem, Re(i, l) < 0 && (l = null);
      else if (n && a)
        l = this.getCartesian(n.componentIndex, a.componentIndex);
      else if (n)
        c = this.getAxis("x", n.componentIndex);
      else if (a)
        c = this.getAxis("y", a.componentIndex);
      else if (o) {
        var u = o.coordinateSystem;
        u === this && (l = this._coordsList[0]);
      }
      return {
        cartesian: l,
        axis: c
      };
    }, t.prototype.containPoint = function(e) {
      var r = this._coordsList[0];
      if (r)
        return r.containPoint(e);
    }, t.prototype._initCartesian = function(e, r, n) {
      var a = this, o = this, i = {
        left: !1,
        right: !1,
        top: !1,
        bottom: !1
      }, l = {
        x: {},
        y: {}
      }, c = {
        x: 0,
        y: 0
      };
      if (r.eachComponent("xAxis", u("x"), this), r.eachComponent("yAxis", u("y"), this), !c.x || !c.y) {
        this._axesMap = {}, this._axesList = [];
        return;
      }
      this._axesMap = l, I(l.x, function(d, f) {
        I(l.y, function(h, v) {
          var p = "x" + f + "y" + v, g = new C2e(p);
          g.master = a, g.model = e, a._coordsMap[p] = g, a._coordsList.push(g), g.addAxis(d), g.addAxis(h);
        });
      });
      function u(d) {
        return function(f, h) {
          if (rf(f, e)) {
            var v = f.get("position");
            d === "x" ? v !== "top" && v !== "bottom" && (v = i.bottom ? "top" : "bottom") : v !== "left" && v !== "right" && (v = i.left ? "right" : "left"), i[v] = !0;
            var p = new E2e(d, Fx(f), [0, 0], f.get("type"), v), g = p.type === "category";
            p.onBand = g && f.get("boundaryGap"), p.inverse = f.get("inverse"), f.axis = p, p.model = f, p.grid = o, p.index = h, o._axesList.push(p), l[d][h] = p, c[d]++;
          }
        };
      }
    }, t.prototype._updateScale = function(e, r) {
      I(this._axesList, function(a) {
        if (a.scale.setExtent(1 / 0, -1 / 0), a.type === "category") {
          var o = a.model.get("categorySortInfo");
          a.scale.setSortInfo(o);
        }
      }), e.eachSeries(function(a) {
        if (v4(a)) {
          var o = p4(a), i = o.xAxisModel, l = o.yAxisModel;
          if (!rf(i, r) || !rf(l, r))
            return;
          var c = this.getCartesian(i.componentIndex, l.componentIndex), u = a.getData(), d = c.getAxis("x"), f = c.getAxis("y");
          n(u, d), n(u, f);
        }
      }, this);
      function n(a, o) {
        I(Vx(a, o.dim), function(i) {
          o.scale.unionExtentFromData(a, i);
        });
      }
    }, t.prototype.getTooltipAxes = function(e) {
      var r = [], n = [];
      return I(this.getCartesians(), function(a) {
        var o = e != null && e !== "auto" ? a.getAxis(e) : a.getBaseAxis(), i = a.getOtherAxis(o);
        Re(r, o) < 0 && r.push(o), Re(n, i) < 0 && n.push(i);
      }), {
        baseAxes: r,
        otherAxes: n
      };
    }, t.create = function(e, r) {
      var n = [];
      return e.eachComponent("grid", function(a, o) {
        var i = new t(a, e, r);
        i.name = "grid_" + o, i.resize(a, r, !0), a.coordinateSystem = i, n.push(i);
      }), e.eachSeries(function(a) {
        if (v4(a)) {
          var o = p4(a), i = o.xAxisModel, l = o.yAxisModel, c = i.getCoordSysModel();
          if (process.env.NODE_ENV !== "production") {
            if (!c)
              throw new Error('Grid "' + ea(i.get("gridIndex"), i.get("gridId"), 0) + '" not found');
            if (i.getCoordSysModel() !== l.getCoordSysModel())
              throw new Error("xAxis and yAxis must use the same grid");
          }
          var u = c.coordinateSystem;
          a.coordinateSystem = u.getCartesian(i.componentIndex, l.componentIndex);
        }
      }), n;
    }, t.dimensions = u2, t;
  }()
);
function rf(t, e) {
  return t.getCoordSysModel() === e;
}
function g4(t, e, r, n) {
  r.getAxesOnZeroOf = function() {
    return o ? [o] : [];
  };
  var a = t[e], o, i = r.model, l = i.get(["axisLine", "onZero"]), c = i.get(["axisLine", "onZeroAxisIndex"]);
  if (!l)
    return;
  if (c != null)
    m4(a[c]) && (o = a[c]);
  else
    for (var u in a)
      if (a.hasOwnProperty(u) && m4(a[u]) && !n[d(a[u])]) {
        o = a[u];
        break;
      }
  o && (n[d(o)] = !0);
  function d(f) {
    return f.dim + "_" + f.index;
  }
}
function m4(t) {
  return t && t.type !== "category" && t.type !== "time" && Tfe(t);
}
function M2e(t, e) {
  var r = t.getExtent(), n = r[0] + r[1];
  t.toGlobalCoord = t.dim === "x" ? function(a) {
    return a + e;
  } : function(a) {
    return n - a + e;
  }, t.toLocalCoord = t.dim === "x" ? function(a) {
    return a - e;
  } : function(a) {
    return n - a + e;
  };
}
var Xn = Math.PI, aa = (
  /** @class */
  function() {
    function t(e, r) {
      this.group = new Xe(), this.opt = r, this.axisModel = e, Te(r, {
        labelOffset: 0,
        nameDirection: 1,
        tickDirection: 1,
        labelDirection: 1,
        silent: !0,
        handleAutoShown: function() {
          return !0;
        }
      });
      var n = new Xe({
        x: r.position[0],
        y: r.position[1],
        rotation: r.rotation
      });
      n.updateTransform(), this._transformGroup = n;
    }
    return t.prototype.hasBuilder = function(e) {
      return !!w4[e];
    }, t.prototype.add = function(e) {
      w4[e](this.opt, this.axisModel, this.group, this._transformGroup);
    }, t.prototype.getGroup = function() {
      return this.group;
    }, t.innerTextLayout = function(e, r, n) {
      var a = Yv(r - e), o, i;
      return Jl(a) ? (i = n > 0 ? "top" : "bottom", o = "center") : Jl(a - Xn) ? (i = n > 0 ? "bottom" : "top", o = "center") : (i = "middle", a > 0 && a < Xn ? o = n > 0 ? "right" : "left" : o = n > 0 ? "left" : "right"), {
        rotation: a,
        textAlign: o,
        textVerticalAlign: i
      };
    }, t.makeAxisEventDataBase = function(e) {
      var r = {
        componentType: e.mainType,
        componentIndex: e.componentIndex
      };
      return r[e.mainType + "Index"] = e.componentIndex, r;
    }, t.isLabelSilent = function(e) {
      var r = e.get("tooltip");
      return e.get("silent") || !(e.get("triggerEvent") || r && r.show);
    }, t;
  }()
), w4 = {
  axisLine: function(t, e, r, n) {
    var a = e.get(["axisLine", "show"]);
    if (a === "auto" && t.handleAutoShown && (a = t.handleAutoShown("axisLine")), !!a) {
      var o = e.axis.getExtent(), i = n.transform, l = [o[0], 0], c = [o[1], 0], u = l[0] > c[0];
      i && (At(l, l, i), At(c, c, i));
      var d = H({
        lineCap: "round"
      }, e.getModel(["axisLine", "lineStyle"]).getLineStyle()), f = new br({
        shape: {
          x1: l[0],
          y1: l[1],
          x2: c[0],
          y2: c[1]
        },
        style: d,
        strokeContainThreshold: t.strokeContainThreshold || 5,
        silent: !0,
        z2: 1
      });
      os(f.shape, f.style.lineWidth), f.anid = "line", r.add(f);
      var h = e.get(["axisLine", "symbol"]);
      if (h != null) {
        var v = e.get(["axisLine", "symbolSize"]);
        Q(h) && (h = [h, h]), (Q(v) || De(v)) && (v = [v, v]);
        var p = U1(e.get(["axisLine", "symbolOffset"]) || 0, v), g = v[0], m = v[1];
        I([{
          rotate: t.rotation + Math.PI / 2,
          offset: p[0],
          r: 0
        }, {
          rotate: t.rotation - Math.PI / 2,
          offset: p[1],
          r: Math.sqrt((l[0] - c[0]) * (l[0] - c[0]) + (l[1] - c[1]) * (l[1] - c[1]))
        }], function(w, y) {
          if (h[y] !== "none" && h[y] != null) {
            var b = _r(h[y], -g / 2, -m / 2, g, m, d.stroke, !0), _ = w.r + w.offset, x = u ? c : l;
            b.attr({
              rotation: w.rotate,
              x: x[0] + _ * Math.cos(t.rotation),
              y: x[1] - _ * Math.sin(t.rotation),
              silent: !0,
              z2: 11
            }), r.add(b);
          }
        });
      }
    }
  },
  axisTickLabel: function(t, e, r, n) {
    var a = L2e(r, n, e, t), o = O2e(r, n, e, t);
    if (k2e(e, o, a), T2e(r, n, e, t.tickDirection), e.get(["axisLabel", "hideOverlap"])) {
      var i = ghe(J(o, function(l) {
        return {
          label: l,
          priority: l.z2,
          defaultAttr: {
            ignore: l.ignore
          }
        };
      }));
      yhe(i);
    }
  },
  axisName: function(t, e, r, n) {
    var a = Cn(t.axisName, e.get("name"));
    if (a) {
      var o = e.get("nameLocation"), i = t.nameDirection, l = e.getModel("nameTextStyle"), c = e.get("nameGap") || 0, u = e.axis.getExtent(), d = u[0] > u[1] ? -1 : 1, f = [
        o === "start" ? u[0] - d * c : o === "end" ? u[1] + d * c : (u[0] + u[1]) / 2,
        // Reuse labelOffset.
        b4(o) ? t.labelOffset + i * c : 0
      ], h, v = e.get("nameRotate");
      v != null && (v = v * Xn / 180);
      var p;
      b4(o) ? h = aa.innerTextLayout(
        t.rotation,
        v ?? t.rotation,
        // Adapt to axis.
        i
      ) : (h = A2e(t.rotation, o, v || 0, u), p = t.axisNameAvailableWidth, p != null && (p = Math.abs(p / Math.sin(h.rotation)), !isFinite(p) && (p = null)));
      var g = l.getFont(), m = e.get("nameTruncate", !0) || {}, w = m.ellipsis, y = Cn(t.nameTruncateMaxWidth, m.maxWidth, p), b = new Ye({
        x: f[0],
        y: f[1],
        rotation: h.rotation,
        silent: aa.isLabelSilent(e),
        style: jt(l, {
          text: a,
          font: g,
          overflow: "truncate",
          width: y,
          ellipsis: w,
          fill: l.getTextColor() || e.get(["axisLine", "lineStyle", "color"]),
          align: l.get("align") || h.textAlign,
          verticalAlign: l.get("verticalAlign") || h.textVerticalAlign
        }),
        z2: 1
      });
      if (f7({
        el: b,
        componentModel: e,
        itemName: a
      }), b.__fullText = a, b.anid = "name", e.get("triggerEvent")) {
        var _ = aa.makeAxisEventDataBase(e);
        _.targetType = "axisName", _.name = a, Se(b).eventData = _;
      }
      n.add(b), b.updateTransform(), r.add(b), b.decomposeTransform();
    }
  }
};
function A2e(t, e, r, n) {
  var a = Yv(r - t), o, i, l = n[0] > n[1], c = e === "start" && !l || e !== "start" && l;
  return Jl(a - Xn / 2) ? (i = c ? "bottom" : "top", o = "center") : Jl(a - Xn * 1.5) ? (i = c ? "top" : "bottom", o = "center") : (i = "middle", a < Xn * 1.5 && a > Xn / 2 ? o = c ? "left" : "right" : o = c ? "right" : "left"), {
    rotation: a,
    textAlign: o,
    textVerticalAlign: i
  };
}
function k2e(t, e, r) {
  if (!$x(t.axis)) {
    var n = t.get(["axisLabel", "showMinLabel"]), a = t.get(["axisLabel", "showMaxLabel"]);
    e = e || [], r = r || [];
    var o = e[0], i = e[1], l = e[e.length - 1], c = e[e.length - 2], u = r[0], d = r[1], f = r[r.length - 1], h = r[r.length - 2];
    n === !1 ? (ar(o), ar(u)) : y4(o, i) && (n ? (ar(i), ar(d)) : (ar(o), ar(u))), a === !1 ? (ar(l), ar(f)) : y4(c, l) && (a ? (ar(c), ar(h)) : (ar(l), ar(f)));
  }
}
function ar(t) {
  t && (t.ignore = !0);
}
function y4(t, e) {
  var r = t && t.getBoundingRect().clone(), n = e && e.getBoundingRect().clone();
  if (!(!r || !n)) {
    var a = Ls([]);
    return x1(a, a, -t.rotation), r.applyTransform(ra([], a, t.getLocalTransform())), n.applyTransform(ra([], a, e.getLocalTransform())), r.intersect(n);
  }
}
function b4(t) {
  return t === "middle" || t === "center";
}
function gC(t, e, r, n, a) {
  for (var o = [], i = [], l = [], c = 0; c < t.length; c++) {
    var u = t[c].coord;
    i[0] = u, i[1] = 0, l[0] = u, l[1] = r, e && (At(i, i, e), At(l, l, e));
    var d = new br({
      shape: {
        x1: i[0],
        y1: i[1],
        x2: l[0],
        y2: l[1]
      },
      style: n,
      z2: 2,
      autoBatch: !0,
      silent: !0
    });
    os(d.shape, d.style.lineWidth), d.anid = a + "_" + t[c].tickValue, o.push(d);
  }
  return o;
}
function L2e(t, e, r, n) {
  var a = r.axis, o = r.getModel("axisTick"), i = o.get("show");
  if (i === "auto" && n.handleAutoShown && (i = n.handleAutoShown("axisTick")), !(!i || a.scale.isBlank())) {
    for (var l = o.getModel("lineStyle"), c = n.tickDirection * o.get("length"), u = a.getTicksCoords(), d = gC(u, e.transform, c, Te(l.getLineStyle(), {
      stroke: r.get(["axisLine", "lineStyle", "color"])
    }), "ticks"), f = 0; f < d.length; f++)
      t.add(d[f]);
    return d;
  }
}
function T2e(t, e, r, n) {
  var a = r.axis, o = r.getModel("minorTick");
  if (!(!o.get("show") || a.scale.isBlank())) {
    var i = a.getMinorTicksCoords();
    if (i.length)
      for (var l = o.getModel("lineStyle"), c = n * o.get("length"), u = Te(l.getLineStyle(), Te(r.getModel("axisTick").getLineStyle(), {
        stroke: r.get(["axisLine", "lineStyle", "color"])
      })), d = 0; d < i.length; d++)
        for (var f = gC(i[d], e.transform, c, u, "minorticks_" + d), h = 0; h < f.length; h++)
          t.add(f[h]);
  }
}
function O2e(t, e, r, n) {
  var a = r.axis, o = Cn(n.axisLabelShow, r.get(["axisLabel", "show"]));
  if (!(!o || a.scale.isBlank())) {
    var i = r.getModel("axisLabel"), l = i.get("margin"), c = a.getViewLabels(), u = (Cn(n.labelRotate, i.get("rotate")) || 0) * Xn / 180, d = aa.innerTextLayout(n.rotation, u, n.labelDirection), f = r.getCategories && r.getCategories(!0), h = [], v = aa.isLabelSilent(r), p = r.get("triggerEvent");
    return I(c, function(g, m) {
      var w = a.scale.type === "ordinal" ? a.scale.getRawOrdinalNumber(g.tickValue) : g.tickValue, y = g.formattedLabel, b = g.rawLabel, _ = i;
      if (f && f[w]) {
        var x = f[w];
        re(x) && x.textStyle && (_ = new Ve(x.textStyle, i, r.ecModel));
      }
      var E = _.getTextColor() || r.get(["axisLine", "lineStyle", "color"]), S = a.dataToCoord(w), M = _.getShallow("align", !0) || d.textAlign, R = de(_.getShallow("alignMinLabel", !0), M), A = de(_.getShallow("alignMaxLabel", !0), M), k = _.getShallow("verticalAlign", !0) || _.getShallow("baseline", !0) || d.textVerticalAlign, L = de(_.getShallow("verticalAlignMinLabel", !0), k), T = de(_.getShallow("verticalAlignMaxLabel", !0), k), O = new Ye({
        x: S,
        y: n.labelOffset + n.labelDirection * l,
        rotation: d.rotation,
        silent: v,
        z2: 10 + (g.level || 0),
        style: jt(_, {
          text: y,
          align: m === 0 ? R : m === c.length - 1 ? A : M,
          verticalAlign: m === 0 ? L : m === c.length - 1 ? T : k,
          fill: ie(E) ? E(
            // (1) In category axis with data zoom, tick is not the original
            // index of axis.data. So tick should not be exposed to user
            // in category axis.
            // (2) Compatible with previous version, which always use formatted label as
            // input. But in interval scale the formatted label is like '223,445', which
            // maked user replace ','. So we modify it to return original val but remain
            // it as 'string' to avoid error in replacing.
            a.type === "category" ? b : a.type === "value" ? w + "" : w,
            m
          ) : E
        })
      });
      if (O.anid = "label_" + w, p) {
        var D = aa.makeAxisEventDataBase(r);
        D.targetType = "axisLabel", D.value = b, D.tickIndex = m, a.type === "category" && (D.dataIndex = w), Se(O).eventData = D;
      }
      e.add(O), O.updateTransform(), h.push(O), t.add(O), O.decomposeTransform();
    }), h;
  }
}
function I2e(t, e) {
  var r = {
    /**
     * key: makeKey(axis.model)
     * value: {
     *      axis,
     *      coordSys,
     *      axisPointerModel,
     *      triggerTooltip,
     *      triggerEmphasis,
     *      involveSeries,
     *      snap,
     *      seriesModels,
     *      seriesDataCount
     * }
     */
    axesInfo: {},
    seriesInvolved: !1,
    /**
     * key: makeKey(coordSys.model)
     * value: Object: key makeKey(axis.model), value: axisInfo
     */
    coordSysAxesInfo: {},
    coordSysMap: {}
  };
  return P2e(r, t, e), r.seriesInvolved && N2e(r, t), r;
}
function P2e(t, e, r) {
  var n = e.getComponent("tooltip"), a = e.getComponent("axisPointer"), o = a.get("link", !0) || [], i = [];
  I(r.getCoordinateSystems(), function(l) {
    if (!l.axisPointerEnabled)
      return;
    var c = hs(l.model), u = t.coordSysAxesInfo[c] = {};
    t.coordSysMap[c] = l;
    var d = l.model, f = d.getModel("tooltip", n);
    if (I(l.getAxes(), Oe(g, !1, null)), l.getTooltipAxes && n && f.get("show")) {
      var h = f.get("trigger") === "axis", v = f.get(["axisPointer", "type"]) === "cross", p = l.getTooltipAxes(f.get(["axisPointer", "axis"]));
      (h || v) && I(p.baseAxes, Oe(g, v ? "cross" : !0, h)), v && I(p.otherAxes, Oe(g, "cross", !1));
    }
    function g(m, w, y) {
      var b = y.model.getModel("axisPointer", a), _ = b.get("show");
      if (!(!_ || _ === "auto" && !m && !f2(b))) {
        w == null && (w = b.get("triggerTooltip")), b = m ? D2e(y, f, a, e, m, w) : b;
        var x = b.get("snap"), E = b.get("triggerEmphasis"), S = hs(y.model), M = w || x || y.type === "category", R = t.axesInfo[S] = {
          key: S,
          axis: y,
          coordSys: l,
          axisPointerModel: b,
          triggerTooltip: w,
          triggerEmphasis: E,
          involveSeries: M,
          snap: x,
          useHandle: f2(b),
          seriesModels: [],
          linkGroup: null
        };
        u[S] = R, t.seriesInvolved = t.seriesInvolved || M;
        var A = B2e(o, y);
        if (A != null) {
          var k = i[A] || (i[A] = {
            axesInfo: {}
          });
          k.axesInfo[S] = R, k.mapper = o[A].mapper, R.linkGroup = k;
        }
      }
    }
  });
}
function D2e(t, e, r, n, a, o) {
  var i = e.getModel("axisPointer"), l = ["type", "snap", "lineStyle", "shadowStyle", "label", "animation", "animationDurationUpdate", "animationEasingUpdate", "z"], c = {};
  I(l, function(h) {
    c[h] = be(i.get(h));
  }), c.snap = t.type !== "category" && !!o, i.get("type") === "cross" && (c.type = "line");
  var u = c.label || (c.label = {});
  if (u.show == null && (u.show = !1), a === "cross") {
    var d = i.get(["label", "show"]);
    if (u.show = d ?? !0, !o) {
      var f = c.lineStyle = i.get("crossStyle");
      f && Te(u, f.textStyle);
    }
  }
  return t.model.getModel("axisPointer", new Ve(c, r, n));
}
function N2e(t, e) {
  e.eachSeries(function(r) {
    var n = r.coordinateSystem, a = r.get(["tooltip", "trigger"], !0), o = r.get(["tooltip", "show"], !0);
    !n || a === "none" || a === !1 || a === "item" || o === !1 || r.get(["axisPointer", "show"], !0) === !1 || I(t.coordSysAxesInfo[hs(n.model)], function(i) {
      var l = i.axis;
      n.getAxis(l.dim) === l && (i.seriesModels.push(r), i.seriesDataCount == null && (i.seriesDataCount = 0), i.seriesDataCount += r.getData().count());
    });
  });
}
function B2e(t, e) {
  for (var r = e.model, n = e.dim, a = 0; a < t.length; a++) {
    var o = t[a] || {};
    if (nf(o[n + "AxisId"], r.id) || nf(o[n + "AxisIndex"], r.componentIndex) || nf(o[n + "AxisName"], r.name))
      return a;
  }
}
function nf(t, e) {
  return t === "all" || z(t) && Re(t, e) >= 0 || t === e;
}
function F2e(t) {
  var e = J7(t);
  if (e) {
    var r = e.axisPointerModel, n = e.axis.scale, a = r.option, o = r.get("status"), i = r.get("value");
    i != null && (i = n.parse(i));
    var l = f2(r);
    o == null && (a.status = l ? "show" : "hide");
    var c = n.getExtent().slice();
    c[0] > c[1] && c.reverse(), // Pick a value on axis when initializing.
    (i == null || i > c[1]) && (i = c[1]), i < c[0] && (i = c[0]), a.value = i, l && (a.status = e.axis.scale.isBlank() ? "hide" : "show");
  }
}
function J7(t) {
  var e = (t.ecModel.getComponent("axisPointer") || {}).coordSysAxesInfo;
  return e && e.axesInfo[hs(t)];
}
function $2e(t) {
  var e = J7(t);
  return e && e.axisPointerModel;
}
function f2(t) {
  return !!t.get(["handle", "show"]);
}
function hs(t) {
  return t.type + "||" + t.id;
}
var af = {}, mC = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = e.type, r;
    }
    return e.prototype.render = function(r, n, a, o) {
      this.axisPointerClass && F2e(r), t.prototype.render.apply(this, arguments), this._doUpdateAxisPointerClass(r, a, !0);
    }, e.prototype.updateAxisPointer = function(r, n, a, o) {
      this._doUpdateAxisPointerClass(r, a, !1);
    }, e.prototype.remove = function(r, n) {
      var a = this._axisPointer;
      a && a.remove(n);
    }, e.prototype.dispose = function(r, n) {
      this._disposeAxisPointer(n), t.prototype.dispose.apply(this, arguments);
    }, e.prototype._doUpdateAxisPointerClass = function(r, n, a) {
      var o = e.getAxisPointerClass(this.axisPointerClass);
      if (o) {
        var i = $2e(r);
        i ? (this._axisPointer || (this._axisPointer = new o())).render(r, i, n, a) : this._disposeAxisPointer(n);
      }
    }, e.prototype._disposeAxisPointer = function(r) {
      this._axisPointer && this._axisPointer.dispose(r), this._axisPointer = null;
    }, e.registerAxisPointerClass = function(r, n) {
      if (process.env.NODE_ENV !== "production" && af[r])
        throw new Error("axisPointer " + r + " exists");
      af[r] = n;
    }, e.getAxisPointerClass = function(r) {
      return r && af[r];
    }, e.type = "axis", e;
  }(_t)
), h2 = je();
function V2e(t, e, r, n) {
  var a = r.axis;
  if (!a.scale.isBlank()) {
    var o = r.getModel("splitArea"), i = o.getModel("areaStyle"), l = i.get("color"), c = n.coordinateSystem.getRect(), u = a.getTicksCoords({
      tickModel: o,
      clamp: !0
    });
    if (u.length) {
      var d = l.length, f = h2(t).splitAreaColors, h = se(), v = 0;
      if (f)
        for (var p = 0; p < u.length; p++) {
          var g = f.get(u[p].tickValue);
          if (g != null) {
            v = (g + (d - 1) * p) % d;
            break;
          }
        }
      var m = a.toGlobalCoord(u[0].coord), w = i.getAreaStyle();
      l = z(l) ? l : [l];
      for (var p = 1; p < u.length; p++) {
        var y = a.toGlobalCoord(u[p].coord), b = void 0, _ = void 0, x = void 0, E = void 0;
        a.isHorizontal() ? (b = m, _ = c.y, x = y - b, E = c.height, m = b + x) : (b = c.x, _ = m, x = c.width, E = y - _, m = _ + E);
        var S = u[p - 1].tickValue;
        S != null && h.set(S, v), e.add(new He({
          anid: S != null ? "area_" + S : null,
          shape: {
            x: b,
            y: _,
            width: x,
            height: E
          },
          style: Te({
            fill: l[v]
          }, w),
          autoBatch: !0,
          silent: !0
        })), v = (v + 1) % d;
      }
      h2(t).splitAreaColors = h;
    }
  }
}
function Z2e(t) {
  h2(t).splitAreaColors = null;
}
var H2e = ["axisLine", "axisTickLabel", "axisName"], j2e = ["splitArea", "splitLine", "minorSplitLine"], wC = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = e.type, r.axisPointerClass = "CartesianAxisPointer", r;
    }
    return e.prototype.render = function(r, n, a, o) {
      this.group.removeAll();
      var i = this._axisGroup;
      if (this._axisGroup = new Xe(), this.group.add(this._axisGroup), !!r.get("show")) {
        var l = r.getCoordSysModel(), c = d2(l, r), u = new aa(r, H({
          handleAutoShown: function(f) {
            for (var h = l.coordinateSystem.getCartesians(), v = 0; v < h.length; v++)
              if (o2(h[v].getOtherAxis(r.axis).scale))
                return !0;
            return !1;
          }
        }, c));
        I(H2e, u.add, u), this._axisGroup.add(u.getGroup()), I(j2e, function(f) {
          r.get([f, "show"]) && W2e[f](this, this._axisGroup, r, l);
        }, this);
        var d = o && o.type === "changeAxisOrder" && o.isInitSort;
        d || J9(i, this._axisGroup, r), t.prototype.render.call(this, r, n, a, o);
      }
    }, e.prototype.remove = function() {
      Z2e(this);
    }, e.type = "cartesianAxis", e;
  }(mC)
), W2e = {
  splitLine: function(t, e, r, n) {
    var a = r.axis;
    if (!a.scale.isBlank()) {
      var o = r.getModel("splitLine"), i = o.getModel("lineStyle"), l = i.get("color");
      l = z(l) ? l : [l];
      for (var c = n.coordinateSystem.getRect(), u = a.isHorizontal(), d = 0, f = a.getTicksCoords({
        tickModel: o
      }), h = [], v = [], p = i.getLineStyle(), g = 0; g < f.length; g++) {
        var m = a.toGlobalCoord(f[g].coord);
        u ? (h[0] = m, h[1] = c.y, v[0] = m, v[1] = c.y + c.height) : (h[0] = c.x, h[1] = m, v[0] = c.x + c.width, v[1] = m);
        var w = d++ % l.length, y = f[g].tickValue, b = new br({
          anid: y != null ? "line_" + f[g].tickValue : null,
          autoBatch: !0,
          shape: {
            x1: h[0],
            y1: h[1],
            x2: v[0],
            y2: v[1]
          },
          style: Te({
            stroke: l[w]
          }, p),
          silent: !0
        });
        os(b.shape, p.lineWidth), e.add(b);
      }
    }
  },
  minorSplitLine: function(t, e, r, n) {
    var a = r.axis, o = r.getModel("minorSplitLine"), i = o.getModel("lineStyle"), l = n.coordinateSystem.getRect(), c = a.isHorizontal(), u = a.getMinorTicksCoords();
    if (u.length)
      for (var d = [], f = [], h = i.getLineStyle(), v = 0; v < u.length; v++)
        for (var p = 0; p < u[v].length; p++) {
          var g = a.toGlobalCoord(u[v][p].coord);
          c ? (d[0] = g, d[1] = l.y, f[0] = g, f[1] = l.y + l.height) : (d[0] = l.x, d[1] = g, f[0] = l.x + l.width, f[1] = g);
          var m = new br({
            anid: "minor_line_" + u[v][p].tickValue,
            autoBatch: !0,
            shape: {
              x1: d[0],
              y1: d[1],
              x2: f[0],
              y2: f[1]
            },
            style: h,
            silent: !0
          });
          os(m.shape, h.lineWidth), e.add(m);
        }
  },
  splitArea: function(t, e, r, n) {
    V2e(t, e, r, n);
  }
}, yC = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = e.type, r;
    }
    return e.type = "xAxis", e;
  }(wC)
), z2e = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = yC.type, r;
    }
    return e.type = "yAxis", e;
  }(wC)
), G2e = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = "grid", r;
    }
    return e.prototype.render = function(r, n) {
      this.group.removeAll(), r.get("show") && this.group.add(new He({
        shape: r.coordinateSystem.getRect(),
        style: Te({
          fill: r.get("backgroundColor")
        }, r.getItemStyle()),
        silent: !0,
        z2: -1
      }));
    }, e.type = "grid", e;
  }(_t)
), _4 = {
  // gridIndex: 0,
  // gridId: '',
  offset: 0
};
function U2e(t) {
  t.registerComponentView(G2e), t.registerComponentModel(g2e), t.registerCoordinateSystem("cartesian2d", R2e), d4(t, "x", c2, _4), d4(t, "y", c2, _4), t.registerComponentView(yC), t.registerComponentView(z2e), t.registerPreprocessor(function(e) {
    e.xAxis && e.yAxis && !e.grid && (e.grid = {});
  });
}
var x4 = "\0_ec_interaction_mutex";
function C4(t, e) {
  return !!Y2e(t)[e];
}
function Y2e(t) {
  return t[x4] || (t[x4] = {});
}
ma({
  type: "takeGlobalCursor",
  event: "globalCursorTaken",
  update: "update"
}, mt);
var X2e = (
  /** @class */
  function(t) {
    K(e, t);
    function e(r) {
      var n = t.call(this) || this;
      n._zr = r;
      var a = le(n._mousedownHandler, n), o = le(n._mousemoveHandler, n), i = le(n._mouseupHandler, n), l = le(n._mousewheelHandler, n), c = le(n._pinchHandler, n);
      return n.enable = function(u, d) {
        this.disable(), this._opt = Te(be(d) || {}, {
          zoomOnMouseWheel: !0,
          moveOnMouseMove: !0,
          // By default, wheel do not trigger move.
          moveOnMouseWheel: !1,
          preventDefaultMouseMove: !0
        }), u == null && (u = !0), (u === !0 || u === "move" || u === "pan") && (r.on("mousedown", a), r.on("mousemove", o), r.on("mouseup", i)), (u === !0 || u === "scale" || u === "zoom") && (r.on("mousewheel", l), r.on("pinch", c));
      }, n.disable = function() {
        r.off("mousedown", a), r.off("mousemove", o), r.off("mouseup", i), r.off("mousewheel", l), r.off("pinch", c);
      }, n;
    }
    return e.prototype.isDragging = function() {
      return this._dragging;
    }, e.prototype.isPinching = function() {
      return this._pinching;
    }, e.prototype.setPointerChecker = function(r) {
      this.pointerChecker = r;
    }, e.prototype.dispose = function() {
      this.disable();
    }, e.prototype._mousedownHandler = function(r) {
      if (!fg(r)) {
        for (var n = r.target; n; ) {
          if (n.draggable)
            return;
          n = n.__hostTarget || n.parent;
        }
        var a = r.offsetX, o = r.offsetY;
        this.pointerChecker && this.pointerChecker(r, a, o) && (this._x = a, this._y = o, this._dragging = !0);
      }
    }, e.prototype._mousemoveHandler = function(r) {
      if (!(!this._dragging || !C0("moveOnMouseMove", r, this._opt) || r.gestureEvent === "pinch" || C4(this._zr, "globalPan"))) {
        var n = r.offsetX, a = r.offsetY, o = this._x, i = this._y, l = n - o, c = a - i;
        this._x = n, this._y = a, this._opt.preventDefaultMouseMove && xi(r.event), bC(this, "pan", "moveOnMouseMove", r, {
          dx: l,
          dy: c,
          oldX: o,
          oldY: i,
          newX: n,
          newY: a,
          isAvailableBehavior: null
        });
      }
    }, e.prototype._mouseupHandler = function(r) {
      fg(r) || (this._dragging = !1);
    }, e.prototype._mousewheelHandler = function(r) {
      var n = C0("zoomOnMouseWheel", r, this._opt), a = C0("moveOnMouseWheel", r, this._opt), o = r.wheelDelta, i = Math.abs(o), l = r.offsetX, c = r.offsetY;
      if (!(o === 0 || !n && !a)) {
        if (n) {
          var u = i > 3 ? 1.4 : i > 1 ? 1.2 : 1.1, d = o > 0 ? u : 1 / u;
          of(this, "zoom", "zoomOnMouseWheel", r, {
            scale: d,
            originX: l,
            originY: c,
            isAvailableBehavior: null
          });
        }
        if (a) {
          var f = Math.abs(o), h = (o > 0 ? 1 : -1) * (f > 3 ? 0.4 : f > 1 ? 0.15 : 0.05);
          of(this, "scrollMove", "moveOnMouseWheel", r, {
            scrollDelta: h,
            originX: l,
            originY: c,
            isAvailableBehavior: null
          });
        }
      }
    }, e.prototype._pinchHandler = function(r) {
      if (!C4(this._zr, "globalPan")) {
        var n = r.pinchScale > 1 ? 1.1 : 1 / 1.1;
        of(this, "zoom", null, r, {
          scale: n,
          originX: r.pinchX,
          originY: r.pinchY,
          isAvailableBehavior: null
        });
      }
    }, e;
  }(Vr)
);
function of(t, e, r, n, a) {
  t.pointerChecker && t.pointerChecker(n, a.originX, a.originY) && (xi(n.event), bC(t, e, r, n, a));
}
function bC(t, e, r, n, a) {
  a.isAvailableBehavior = le(C0, null, r, n), t.trigger(e, a);
}
function C0(t, e, r) {
  var n = r[t];
  return !t || n && (!Q(n) || e.event[n + "Key"]);
}
var E4 = br.prototype, lf = $s.prototype, _C = (
  /** @class */
  /* @__PURE__ */ function() {
    function t() {
      this.x1 = 0, this.y1 = 0, this.x2 = 0, this.y2 = 0, this.percent = 1;
    }
    return t;
  }()
);
(function(t) {
  K(e, t);
  function e() {
    return t !== null && t.apply(this, arguments) || this;
  }
  return e;
})(_C);
function sf(t) {
  return isNaN(+t.cpx1) || isNaN(+t.cpy1);
}
var q2e = (
  /** @class */
  function(t) {
    K(e, t);
    function e(r) {
      var n = t.call(this, r) || this;
      return n.type = "ec-line", n;
    }
    return e.prototype.getDefaultStyle = function() {
      return {
        stroke: "#000",
        fill: null
      };
    }, e.prototype.getDefaultShape = function() {
      return new _C();
    }, e.prototype.buildPath = function(r, n) {
      sf(n) ? E4.buildPath.call(this, r, n) : lf.buildPath.call(this, r, n);
    }, e.prototype.pointAt = function(r) {
      return sf(this.shape) ? E4.pointAt.call(this, r) : lf.pointAt.call(this, r);
    }, e.prototype.tangentAt = function(r) {
      var n = this.shape, a = sf(n) ? [n.x2 - n.x1, n.y2 - n.y1] : lf.tangentAt.call(this, r);
      return _1(a, a);
    }, e;
  }(Ie)
), cf = ["fromSymbol", "toSymbol"];
function S4(t) {
  return "_" + t + "Type";
}
function R4(t, e, r) {
  var n = e.getItemVisual(r, t);
  if (!n || n === "none")
    return n;
  var a = e.getItemVisual(r, t + "Size"), o = e.getItemVisual(r, t + "Rotate"), i = e.getItemVisual(r, t + "Offset"), l = e.getItemVisual(r, t + "KeepAspect"), c = T7(a), u = U1(i || 0, c);
  return n + c + u + (o || "") + (l || "");
}
function M4(t, e, r) {
  var n = e.getItemVisual(r, t);
  if (!(!n || n === "none")) {
    var a = e.getItemVisual(r, t + "Size"), o = e.getItemVisual(r, t + "Rotate"), i = e.getItemVisual(r, t + "Offset"), l = e.getItemVisual(r, t + "KeepAspect"), c = T7(a), u = U1(i || 0, c), d = _r(n, -c[0] / 2 + u[0], -c[1] / 2 + u[1], c[0], c[1], null, l);
    return d.__specifiedRotation = o == null || isNaN(o) ? void 0 : +o * Math.PI / 180 || 0, d.name = t, d;
  }
}
function K2e(t) {
  var e = new q2e({
    name: "line",
    subPixelOptimize: !0
  });
  return v2(e.shape, t), e;
}
function v2(t, e) {
  t.x1 = e[0][0], t.y1 = e[0][1], t.x2 = e[1][0], t.y2 = e[1][1], t.percent = 1;
  var r = e[2];
  r ? (t.cpx1 = r[0], t.cpy1 = r[1]) : (t.cpx1 = NaN, t.cpy1 = NaN);
}
var Q2e = (
  /** @class */
  function(t) {
    K(e, t);
    function e(r, n, a) {
      var o = t.call(this) || this;
      return o._createLine(r, n, a), o;
    }
    return e.prototype._createLine = function(r, n, a) {
      var o = r.hostModel, i = r.getItemLayout(n), l = K2e(i);
      l.shape.percent = 0, dt(l, {
        shape: {
          percent: 1
        }
      }, o, n), this.add(l), I(cf, function(c) {
        var u = M4(c, r, n);
        this.add(u), this[S4(c)] = R4(c, r, n);
      }, this), this._updateCommonStl(r, n, a);
    }, e.prototype.updateData = function(r, n, a) {
      var o = r.hostModel, i = this.childOfName("line"), l = r.getItemLayout(n), c = {
        shape: {}
      };
      v2(c.shape, l), rt(i, c, o, n), I(cf, function(u) {
        var d = R4(u, r, n), f = S4(u);
        if (this[f] !== d) {
          this.remove(this.childOfName(u));
          var h = M4(u, r, n);
          this.add(h);
        }
        this[f] = d;
      }, this), this._updateCommonStl(r, n, a);
    }, e.prototype.getLinePath = function() {
      return this.childAt(0);
    }, e.prototype._updateCommonStl = function(r, n, a) {
      var o = r.hostModel, i = this.childOfName("line"), l = a && a.emphasisLineStyle, c = a && a.blurLineStyle, u = a && a.selectLineStyle, d = a && a.labelStatesModels, f = a && a.emphasisDisabled, h = a && a.focus, v = a && a.blurScope;
      if (!a || r.hasItemOption) {
        var p = r.getItemModel(n), g = p.getModel("emphasis");
        l = g.getModel("lineStyle").getLineStyle(), c = p.getModel(["blur", "lineStyle"]).getLineStyle(), u = p.getModel(["select", "lineStyle"]).getLineStyle(), f = g.get("disabled"), h = g.get("focus"), v = g.get("blurScope"), d = wo(p);
      }
      var m = r.getItemVisual(n, "style"), w = m.stroke;
      i.useStyle(m), i.style.fill = null, i.style.strokeNoScale = !0, i.ensureState("emphasis").style = l, i.ensureState("blur").style = c, i.ensureState("select").style = u, I(cf, function(E) {
        var S = this.childOfName(E);
        if (S) {
          S.setColor(w), S.style.opacity = m.opacity;
          for (var M = 0; M < Wt.length; M++) {
            var R = Wt[M], A = i.getState(R);
            if (A) {
              var k = A.style || {}, L = S.ensureState(R), T = L.style || (L.style = {});
              k.stroke != null && (T[S.__isEmptyBrush ? "stroke" : "fill"] = k.stroke), k.opacity != null && (T.opacity = k.opacity);
            }
          }
          S.markRedraw();
        }
      }, this);
      var y = o.getRawValue(n);
      Wi(this, d, {
        labelDataIndex: n,
        labelFetcher: {
          getFormattedLabel: function(E, S) {
            return o.getFormattedLabel(E, S, r.dataType);
          }
        },
        inheritColor: w || "#000",
        defaultOpacity: m.opacity,
        defaultText: (y == null ? r.getName(n) : isFinite(y) ? Qe(y) : y) + ""
      });
      var b = this.getTextContent();
      if (b) {
        var _ = d.normal;
        b.__align = b.style.align, b.__verticalAlign = b.style.verticalAlign, b.__position = _.get("position") || "middle";
        var x = _.get("distance");
        z(x) || (x = [x, x]), b.__labelDistance = x;
      }
      this.setTextConfig({
        position: null,
        local: !0,
        inside: !1
        // Can't be inside for stroke element.
      }), ua(this, h, v, f);
    }, e.prototype.highlight = function() {
      rs(this);
    }, e.prototype.downplay = function() {
      ns(this);
    }, e.prototype.updateLayout = function(r, n) {
      this.setLinePoints(r.getItemLayout(n));
    }, e.prototype.setLinePoints = function(r) {
      var n = this.childOfName("line");
      v2(n.shape, r), n.dirty();
    }, e.prototype.beforeUpdate = function() {
      var r = this, n = r.childOfName("fromSymbol"), a = r.childOfName("toSymbol"), o = r.getTextContent();
      if (!n && !a && (!o || o.ignore))
        return;
      for (var i = 1, l = this.parent; l; )
        l.scaleX && (i /= l.scaleX), l = l.parent;
      var c = r.childOfName("line");
      if (!this.__dirty && !c.__dirty)
        return;
      var u = c.shape.percent, d = c.pointAt(0), f = c.pointAt(u), h = Bv([], f, d);
      _1(h, h);
      function v(A, k) {
        var L = A.__specifiedRotation;
        if (L == null) {
          var T = c.tangentAt(k);
          A.attr("rotation", (k === 1 ? -1 : 1) * Math.PI / 2 - Math.atan2(T[1], T[0]));
        } else
          A.attr("rotation", L);
      }
      if (n && (n.setPosition(d), v(n, 0), n.scaleX = n.scaleY = i * u, n.markRedraw()), a && (a.setPosition(f), v(a, 1), a.scaleX = a.scaleY = i * u, a.markRedraw()), o && !o.ignore) {
        o.x = o.y = 0, o.originX = o.originY = 0;
        var p = void 0, g = void 0, m = o.__labelDistance, w = m[0] * i, y = m[1] * i, b = u / 2, _ = c.tangentAt(b), x = [_[1], -_[0]], E = c.pointAt(b);
        x[1] > 0 && (x[0] = -x[0], x[1] = -x[1]);
        var S = _[0] < 0 ? -1 : 1;
        if (o.__position !== "start" && o.__position !== "end") {
          var M = -Math.atan2(_[1], _[0]);
          f[0] < d[0] && (M = Math.PI + M), o.rotation = M;
        }
        var R = void 0;
        switch (o.__position) {
          case "insideStartTop":
          case "insideMiddleTop":
          case "insideEndTop":
          case "middle":
            R = -y, g = "bottom";
            break;
          case "insideStartBottom":
          case "insideMiddleBottom":
          case "insideEndBottom":
            R = y, g = "top";
            break;
          default:
            R = 0, g = "middle";
        }
        switch (o.__position) {
          case "end":
            o.x = h[0] * w + f[0], o.y = h[1] * y + f[1], p = h[0] > 0.8 ? "left" : h[0] < -0.8 ? "right" : "center", g = h[1] > 0.8 ? "top" : h[1] < -0.8 ? "bottom" : "middle";
            break;
          case "start":
            o.x = -h[0] * w + d[0], o.y = -h[1] * y + d[1], p = h[0] > 0.8 ? "right" : h[0] < -0.8 ? "left" : "center", g = h[1] > 0.8 ? "bottom" : h[1] < -0.8 ? "top" : "middle";
            break;
          case "insideStartTop":
          case "insideStart":
          case "insideStartBottom":
            o.x = w * S + d[0], o.y = d[1] + R, p = _[0] < 0 ? "right" : "left", o.originX = -w * S, o.originY = -R;
            break;
          case "insideMiddleTop":
          case "insideMiddle":
          case "insideMiddleBottom":
          case "middle":
            o.x = E[0], o.y = E[1] + R, p = "center", o.originY = -R;
            break;
          case "insideEndTop":
          case "insideEnd":
          case "insideEndBottom":
            o.x = -w * S + f[0], o.y = f[1] + R, p = _[0] >= 0 ? "right" : "left", o.originX = w * S, o.originY = -R;
            break;
        }
        o.scaleX = o.scaleY = i, o.setStyle({
          // Use the user specified text align and baseline first
          verticalAlign: o.__verticalAlign || g,
          align: o.__align || p
        });
      }
    }, e;
  }(Xe)
), J2e = (
  /** @class */
  function() {
    function t(e) {
      this.group = new Xe(), this._LineCtor = e || Q2e;
    }
    return t.prototype.updateData = function(e) {
      var r = this;
      this._progressiveEls = null;
      var n = this, a = n.group, o = n._lineData;
      n._lineData = e, o || a.removeAll();
      var i = A4(e);
      e.diff(o).add(function(l) {
        r._doAdd(e, l, i);
      }).update(function(l, c) {
        r._doUpdate(o, e, c, l, i);
      }).remove(function(l) {
        a.remove(o.getItemGraphicEl(l));
      }).execute();
    }, t.prototype.updateLayout = function() {
      var e = this._lineData;
      e && e.eachItemGraphicEl(function(r, n) {
        r.updateLayout(e, n);
      }, this);
    }, t.prototype.incrementalPrepareUpdate = function(e) {
      this._seriesScope = A4(e), this._lineData = null, this.group.removeAll();
    }, t.prototype.incrementalUpdate = function(e, r) {
      this._progressiveEls = [];
      function n(l) {
        !l.isGroup && !eve(l) && (l.incremental = !0, l.ensureState("emphasis").hoverLayer = !0);
      }
      for (var a = e.start; a < e.end; a++) {
        var o = r.getItemLayout(a);
        if (uf(o)) {
          var i = new this._LineCtor(r, a, this._seriesScope);
          i.traverse(n), this.group.add(i), r.setItemGraphicEl(a, i), this._progressiveEls.push(i);
        }
      }
    }, t.prototype.remove = function() {
      this.group.removeAll();
    }, t.prototype.eachRendered = function(e) {
      Zs(this._progressiveEls || this.group, e);
    }, t.prototype._doAdd = function(e, r, n) {
      var a = e.getItemLayout(r);
      if (uf(a)) {
        var o = new this._LineCtor(e, r, n);
        e.setItemGraphicEl(r, o), this.group.add(o);
      }
    }, t.prototype._doUpdate = function(e, r, n, a, o) {
      var i = e.getItemGraphicEl(n);
      if (!uf(r.getItemLayout(a))) {
        this.group.remove(i);
        return;
      }
      i ? i.updateData(r, a, o) : i = new this._LineCtor(r, a, o), r.setItemGraphicEl(a, i), this.group.add(i);
    }, t;
  }()
);
function eve(t) {
  return t.animators && t.animators.length > 0;
}
function A4(t) {
  var e = t.hostModel, r = e.getModel("emphasis");
  return {
    lineStyle: e.getModel("lineStyle").getLineStyle(),
    emphasisLineStyle: r.getModel(["lineStyle"]).getLineStyle(),
    blurLineStyle: e.getModel(["blur", "lineStyle"]).getLineStyle(),
    selectLineStyle: e.getModel(["select", "lineStyle"]).getLineStyle(),
    emphasisDisabled: r.get("disabled"),
    blurScope: r.get("blurScope"),
    focus: r.get("focus"),
    labelStatesModels: wo(e)
  };
}
function k4(t) {
  return isNaN(t[0]) || isNaN(t[1]);
}
function uf(t) {
  return t && !k4(t[0]) && !k4(t[1]);
}
var tve = (
  /** @class */
  /* @__PURE__ */ function() {
    function t() {
      this.angle = 0, this.width = 10, this.r = 10, this.x = 0, this.y = 0;
    }
    return t;
  }()
), rve = (
  /** @class */
  function(t) {
    K(e, t);
    function e(r) {
      var n = t.call(this, r) || this;
      return n.type = "pointer", n;
    }
    return e.prototype.getDefaultShape = function() {
      return new tve();
    }, e.prototype.buildPath = function(r, n) {
      var a = Math.cos, o = Math.sin, i = n.r, l = n.width, c = n.angle, u = n.x - a(c) * l * (l >= i / 3 ? 1 : 2), d = n.y - o(c) * l * (l >= i / 3 ? 1 : 2);
      c = n.angle - Math.PI / 2, r.moveTo(u, d), r.lineTo(n.x + a(c) * l, n.y + o(c) * l), r.lineTo(n.x + a(n.angle) * i, n.y + o(n.angle) * i), r.lineTo(n.x - a(c) * l, n.y - o(c) * l), r.lineTo(u, d);
    }, e;
  }(Ie)
);
function nve(t, e) {
  var r = t.get("center"), n = e.getWidth(), a = e.getHeight(), o = Math.min(n, a), i = fe(r[0], e.getWidth()), l = fe(r[1], e.getHeight()), c = fe(t.get("radius"), o / 2);
  return {
    cx: i,
    cy: l,
    r: c
  };
}
function Wc(t, e) {
  var r = t == null ? "" : t + "";
  return e && (Q(e) ? r = e.replace("{value}", r) : ie(e) && (r = e(t))), r;
}
var ave = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = e.type, r;
    }
    return e.prototype.render = function(r, n, a) {
      this.group.removeAll();
      var o = r.get(["axisLine", "lineStyle", "color"]), i = nve(r, a);
      this._renderMain(r, n, a, o, i), this._data = r.getData();
    }, e.prototype.dispose = function() {
    }, e.prototype._renderMain = function(r, n, a, o, i) {
      var l = this.group, c = r.get("clockwise"), u = -r.get("startAngle") / 180 * Math.PI, d = -r.get("endAngle") / 180 * Math.PI, f = r.getModel("axisLine"), h = f.get("roundCap"), v = h ? _u : $r, p = f.get("show"), g = f.getModel("lineStyle"), m = g.get("width"), w = [u, d];
      e7(w, !c), u = w[0], d = w[1];
      for (var y = d - u, b = u, _ = [], x = 0; p && x < o.length; x++) {
        var E = Math.min(Math.max(o[x][0], 0), 1);
        d = u + y * E;
        var S = new v({
          shape: {
            startAngle: b,
            endAngle: d,
            cx: i.cx,
            cy: i.cy,
            clockwise: c,
            r0: i.r - m,
            r: i.r
          },
          silent: !0
        });
        S.setStyle({
          fill: o[x][1]
        }), S.setStyle(g.getLineStyle(
          // Because we use sector to simulate arc
          // so the properties for stroking are useless
          ["color", "width"]
        )), _.push(S), b = d;
      }
      _.reverse(), I(_, function(R) {
        return l.add(R);
      });
      var M = function(R) {
        if (R <= 0)
          return o[0][1];
        var A;
        for (A = 0; A < o.length; A++)
          if (o[A][0] >= R && (A === 0 ? 0 : o[A - 1][0]) < R)
            return o[A][1];
        return o[A - 1][1];
      };
      this._renderTicks(r, n, a, M, i, u, d, c, m), this._renderTitleAndDetail(r, n, a, M, i), this._renderAnchor(r, i), this._renderPointer(r, n, a, M, i, u, d, c, m);
    }, e.prototype._renderTicks = function(r, n, a, o, i, l, c, u, d) {
      for (var f = this.group, h = i.cx, v = i.cy, p = i.r, g = +r.get("min"), m = +r.get("max"), w = r.getModel("splitLine"), y = r.getModel("axisTick"), b = r.getModel("axisLabel"), _ = r.get("splitNumber"), x = y.get("splitNumber"), E = fe(w.get("length"), p), S = fe(y.get("length"), p), M = l, R = (c - l) / _, A = R / x, k = w.getModel("lineStyle").getLineStyle(), L = y.getModel("lineStyle").getLineStyle(), T = w.get("distance"), O, D, P = 0; P <= _; P++) {
        if (O = Math.cos(M), D = Math.sin(M), w.get("show")) {
          var F = T ? T + d : d, B = new br({
            shape: {
              x1: O * (p - F) + h,
              y1: D * (p - F) + v,
              x2: O * (p - E - F) + h,
              y2: D * (p - E - F) + v
            },
            style: k,
            silent: !0
          });
          k.stroke === "auto" && B.setStyle({
            stroke: o(P / _)
          }), f.add(B);
        }
        if (b.get("show")) {
          var F = b.get("distance") + T, N = Wc(Qe(P / _ * (m - g) + g), b.get("formatter")), $ = o(P / _), V = O * (p - E - F) + h, W = D * (p - E - F) + v, ee = b.get("rotate"), ne = 0;
          ee === "radial" ? (ne = -M + 2 * Math.PI, ne > Math.PI / 2 && (ne += Math.PI)) : ee === "tangential" ? ne = -M - Math.PI / 2 : De(ee) && (ne = ee * Math.PI / 180), ne === 0 ? f.add(new Ye({
            style: jt(b, {
              text: N,
              x: V,
              y: W,
              verticalAlign: D < -0.8 ? "top" : D > 0.8 ? "bottom" : "middle",
              align: O < -0.4 ? "left" : O > 0.4 ? "right" : "center"
            }, {
              inheritColor: $
            }),
            silent: !0
          })) : f.add(new Ye({
            style: jt(b, {
              text: N,
              x: V,
              y: W,
              verticalAlign: "middle",
              align: "center"
            }, {
              inheritColor: $
            }),
            silent: !0,
            originX: V,
            originY: W,
            rotation: ne
          }));
        }
        if (y.get("show") && P !== _) {
          var F = y.get("distance");
          F = F ? F + d : d;
          for (var we = 0; we <= x; we++) {
            O = Math.cos(M), D = Math.sin(M);
            var pe = new br({
              shape: {
                x1: O * (p - F) + h,
                y1: D * (p - F) + v,
                x2: O * (p - S - F) + h,
                y2: D * (p - S - F) + v
              },
              silent: !0,
              style: L
            });
            L.stroke === "auto" && pe.setStyle({
              stroke: o((P + we / x) / _)
            }), f.add(pe), M += A;
          }
          M -= A;
        } else
          M += R;
      }
    }, e.prototype._renderPointer = function(r, n, a, o, i, l, c, u, d) {
      var f = this.group, h = this._data, v = this._progressEls, p = [], g = r.get(["pointer", "show"]), m = r.getModel("progress"), w = m.get("show"), y = r.getData(), b = y.mapDimension("value"), _ = +r.get("min"), x = +r.get("max"), E = [_, x], S = [l, c];
      function M(A, k) {
        var L = y.getItemModel(A), T = L.getModel("pointer"), O = fe(T.get("width"), i.r), D = fe(T.get("length"), i.r), P = r.get(["pointer", "icon"]), F = T.get("offsetCenter"), B = fe(F[0], i.r), N = fe(F[1], i.r), $ = T.get("keepAspect"), V;
        return P ? V = _r(P, B - O / 2, N - D, O, D, null, $) : V = new rve({
          shape: {
            angle: -Math.PI / 2,
            width: O,
            r: D,
            x: B,
            y: N
          }
        }), V.rotation = -(k + Math.PI / 2), V.x = i.cx, V.y = i.cy, V;
      }
      function R(A, k) {
        var L = m.get("roundCap"), T = L ? _u : $r, O = m.get("overlap"), D = O ? m.get("width") : d / y.count(), P = O ? i.r - D : i.r - (A + 1) * D, F = O ? i.r : i.r - A * D, B = new T({
          shape: {
            startAngle: l,
            endAngle: k,
            cx: i.cx,
            cy: i.cy,
            clockwise: u,
            r0: P,
            r: F
          }
        });
        return O && (B.z2 = x - y.get(b, A) % x), B;
      }
      (w || g) && (y.diff(h).add(function(A) {
        var k = y.get(b, A);
        if (g) {
          var L = M(A, l);
          dt(L, {
            rotation: -((isNaN(+k) ? S[0] : Ge(k, E, S, !0)) + Math.PI / 2)
          }, r), f.add(L), y.setItemGraphicEl(A, L);
        }
        if (w) {
          var T = R(A, l), O = m.get("clip");
          dt(T, {
            shape: {
              endAngle: Ge(k, E, S, O)
            }
          }, r), f.add(T), Bh(r.seriesIndex, y.dataType, A, T), p[A] = T;
        }
      }).update(function(A, k) {
        var L = y.get(b, A);
        if (g) {
          var T = h.getItemGraphicEl(k), O = T ? T.rotation : l, D = M(A, O);
          D.rotation = O, rt(D, {
            rotation: -((isNaN(+L) ? S[0] : Ge(L, E, S, !0)) + Math.PI / 2)
          }, r), f.add(D), y.setItemGraphicEl(A, D);
        }
        if (w) {
          var P = v[k], F = P ? P.shape.endAngle : l, B = R(A, F), N = m.get("clip");
          rt(B, {
            shape: {
              endAngle: Ge(L, E, S, N)
            }
          }, r), f.add(B), Bh(r.seriesIndex, y.dataType, A, B), p[A] = B;
        }
      }).execute(), y.each(function(A) {
        var k = y.getItemModel(A), L = k.getModel("emphasis"), T = L.get("focus"), O = L.get("blurScope"), D = L.get("disabled");
        if (g) {
          var P = y.getItemGraphicEl(A), F = y.getItemVisual(A, "style"), B = F.fill;
          if (P instanceof nn) {
            var N = P.style;
            P.useStyle(H({
              image: N.image,
              x: N.x,
              y: N.y,
              width: N.width,
              height: N.height
            }, F));
          } else
            P.useStyle(F), P.type !== "pointer" && P.setColor(B);
          P.setStyle(k.getModel(["pointer", "itemStyle"]).getItemStyle()), P.style.fill === "auto" && P.setStyle("fill", o(Ge(y.get(b, A), E, [0, 1], !0))), P.z2EmphasisLift = 0, Ei(P, k), ua(P, T, O, D);
        }
        if (w) {
          var $ = p[A];
          $.useStyle(y.getItemVisual(A, "style")), $.setStyle(k.getModel(["progress", "itemStyle"]).getItemStyle()), $.z2EmphasisLift = 0, Ei($, k), ua($, T, O, D);
        }
      }), this._progressEls = p);
    }, e.prototype._renderAnchor = function(r, n) {
      var a = r.getModel("anchor"), o = a.get("show");
      if (o) {
        var i = a.get("size"), l = a.get("icon"), c = a.get("offsetCenter"), u = a.get("keepAspect"), d = _r(l, n.cx - i / 2 + fe(c[0], n.r), n.cy - i / 2 + fe(c[1], n.r), i, i, null, u);
        d.z2 = a.get("showAbove") ? 1 : 0, d.setStyle(a.getModel("itemStyle").getItemStyle()), this.group.add(d);
      }
    }, e.prototype._renderTitleAndDetail = function(r, n, a, o, i) {
      var l = this, c = r.getData(), u = c.mapDimension("value"), d = +r.get("min"), f = +r.get("max"), h = new Xe(), v = [], p = [], g = r.isAnimationEnabled(), m = r.get(["pointer", "showAbove"]);
      c.diff(this._data).add(function(w) {
        v[w] = new Ye({
          silent: !0
        }), p[w] = new Ye({
          silent: !0
        });
      }).update(function(w, y) {
        v[w] = l._titleEls[y], p[w] = l._detailEls[y];
      }).execute(), c.each(function(w) {
        var y = c.getItemModel(w), b = c.get(u, w), _ = new Xe(), x = o(Ge(b, [d, f], [0, 1], !0)), E = y.getModel("title");
        if (E.get("show")) {
          var S = E.get("offsetCenter"), M = i.cx + fe(S[0], i.r), R = i.cy + fe(S[1], i.r), A = v[w];
          A.attr({
            z2: m ? 0 : 2,
            style: jt(E, {
              x: M,
              y: R,
              text: c.getName(w),
              align: "center",
              verticalAlign: "middle"
            }, {
              inheritColor: x
            })
          }), _.add(A);
        }
        var k = y.getModel("detail");
        if (k.get("show")) {
          var L = k.get("offsetCenter"), T = i.cx + fe(L[0], i.r), O = i.cy + fe(L[1], i.r), D = fe(k.get("width"), i.r), P = fe(k.get("height"), i.r), F = r.get(["progress", "show"]) ? c.getItemVisual(w, "style").fill : x, A = p[w], B = k.get("formatter");
          A.attr({
            z2: m ? 0 : 2,
            style: jt(k, {
              x: T,
              y: O,
              text: Wc(b, B),
              width: isNaN(D) ? null : D,
              height: isNaN(P) ? null : P,
              align: "center",
              verticalAlign: "middle"
            }, {
              inheritColor: F
            })
          }), a_(A, {
            normal: k
          }, b, function($) {
            return Wc($, B);
          }), g && bue(A, w, c, r, {
            getFormattedLabel: function($, V, W, ee, ne, we) {
              return Wc(we ? we.interpolatedValue : b, B);
            }
          }), _.add(A);
        }
        h.add(_);
      }), this.group.add(h), this._titleEls = v, this._detailEls = p;
    }, e.type = "gauge", e;
  }(wt)
), ove = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = e.type, r.visualStyleAccessPath = "itemStyle", r;
    }
    return e.prototype.getInitialData = function(r, n) {
      return vC(this, ["value"]);
    }, e.type = "series.gauge", e.defaultOption = {
      // zlevel: 0,
      z: 2,
      colorBy: "data",
      // 默认全局居中
      center: ["50%", "50%"],
      legendHoverLink: !0,
      radius: "75%",
      startAngle: 225,
      endAngle: -45,
      clockwise: !0,
      // 最小值
      min: 0,
      // 最大值
      max: 100,
      // 分割段数，默认为10
      splitNumber: 10,
      // 坐标轴线
      axisLine: {
        // 默认显示，属性show控制显示与否
        show: !0,
        roundCap: !1,
        lineStyle: {
          color: [[1, "#E6EBF8"]],
          width: 10
        }
      },
      // 坐标轴线
      progress: {
        // 默认显示，属性show控制显示与否
        show: !1,
        overlap: !0,
        width: 10,
        roundCap: !1,
        clip: !0
      },
      // 分隔线
      splitLine: {
        // 默认显示，属性show控制显示与否
        show: !0,
        // 属性length控制线长
        length: 10,
        distance: 10,
        // 属性lineStyle（详见lineStyle）控制线条样式
        lineStyle: {
          color: "#63677A",
          width: 3,
          type: "solid"
        }
      },
      // 坐标轴小标记
      axisTick: {
        // 属性show控制显示与否，默认不显示
        show: !0,
        // 每份split细分多少段
        splitNumber: 5,
        // 属性length控制线长
        length: 6,
        distance: 10,
        // 属性lineStyle控制线条样式
        lineStyle: {
          color: "#63677A",
          width: 1,
          type: "solid"
        }
      },
      axisLabel: {
        show: !0,
        distance: 15,
        // formatter: null,
        color: "#464646",
        fontSize: 12,
        rotate: 0
      },
      pointer: {
        icon: null,
        offsetCenter: [0, 0],
        show: !0,
        showAbove: !0,
        length: "60%",
        width: 6,
        keepAspect: !1
      },
      anchor: {
        show: !1,
        showAbove: !1,
        size: 6,
        icon: "circle",
        offsetCenter: [0, 0],
        keepAspect: !1,
        itemStyle: {
          color: "#fff",
          borderWidth: 0,
          borderColor: "#5470c6"
        }
      },
      title: {
        show: !0,
        // x, y，单位px
        offsetCenter: [0, "20%"],
        // 其余属性默认使用全局文本样式，详见TEXTSTYLE
        color: "#464646",
        fontSize: 16,
        valueAnimation: !1
      },
      detail: {
        show: !0,
        backgroundColor: "rgba(0,0,0,0)",
        borderWidth: 0,
        borderColor: "#ccc",
        width: 100,
        height: null,
        padding: [5, 10],
        // x, y，单位px
        offsetCenter: [0, "40%"],
        // formatter: null,
        // 其余属性默认使用全局文本样式，详见TEXTSTYLE
        color: "#464646",
        fontSize: 30,
        fontWeight: "bold",
        lineHeight: 30,
        valueAnimation: !1
      }
    }, e;
  }(Tt)
);
function ive(t) {
  t.registerChartView(ave), t.registerSeriesModel(ove);
}
function r5(t, e, r, n, a, o) {
  t = t || 0;
  var i = r[1] - r[0];
  if (a != null && (a = jo(a, [0, i])), o != null && (o = Math.max(o, a ?? 0)), n === "all") {
    var l = Math.abs(e[1] - e[0]);
    l = jo(l, [0, i]), a = o = jo(l, [a, o]), n = 0;
  }
  e[0] = jo(e[0], r), e[1] = jo(e[1], r);
  var c = df(e, n);
  e[n] += t;
  var u = a || 0, d = r.slice();
  c.sign < 0 ? d[0] += u : d[1] -= u, e[n] = jo(e[n], d);
  var f;
  return f = df(e, n), a != null && (f.sign !== c.sign || f.span < a) && (e[1 - n] = e[n] + c.sign * a), f = df(e, n), o != null && f.span > o && (e[1 - n] = e[n] + f.sign * o), e;
}
function df(t, e) {
  var r = t[e] - t[1 - e];
  return {
    span: Math.abs(r),
    sign: r > 0 ? -1 : r < 0 ? 1 : e ? -1 : 1
  };
}
function jo(t, e) {
  return Math.min(e[1] != null ? e[1] : 1 / 0, Math.max(e[0] != null ? e[0] : -1 / 0, t));
}
var ja = je(), L4 = be, ff = le, lve = (
  /** @class */
  function() {
    function t() {
      this._dragging = !1, this.animationThreshold = 15;
    }
    return t.prototype.render = function(e, r, n, a) {
      var o = r.get("value"), i = r.get("status");
      if (this._axisModel = e, this._axisPointerModel = r, this._api = n, !(!a && this._lastValue === o && this._lastStatus === i)) {
        this._lastValue = o, this._lastStatus = i;
        var l = this._group, c = this._handle;
        if (!i || i === "hide") {
          l && l.hide(), c && c.hide();
          return;
        }
        l && l.show(), c && c.show();
        var u = {};
        this.makeElOption(u, o, e, r, n);
        var d = u.graphicKey;
        d !== this._lastGraphicKey && this.clear(n), this._lastGraphicKey = d;
        var f = this._moveAnimation = this.determineAnimation(e, r);
        if (!l)
          l = this._group = new Xe(), this.createPointerEl(l, u, e, r), this.createLabelEl(l, u, e, r), n.getZr().add(l);
        else {
          var h = Oe(T4, r, f);
          this.updatePointerEl(l, u, h), this.updateLabelEl(l, u, h, r);
        }
        I4(l, r, !0), this._renderHandle(o);
      }
    }, t.prototype.remove = function(e) {
      this.clear(e);
    }, t.prototype.dispose = function(e) {
      this.clear(e);
    }, t.prototype.determineAnimation = function(e, r) {
      var n = r.get("animation"), a = e.axis, o = a.type === "category", i = r.get("snap");
      if (!i && !o)
        return !1;
      if (n === "auto" || n == null) {
        var l = this.animationThreshold;
        if (o && a.getBandWidth() > l)
          return !0;
        if (i) {
          var c = J7(e).seriesDataCount, u = a.getExtent();
          return Math.abs(u[0] - u[1]) / c > l;
        }
        return !1;
      }
      return n === !0;
    }, t.prototype.makeElOption = function(e, r, n, a, o) {
    }, t.prototype.createPointerEl = function(e, r, n, a) {
      var o = r.pointer;
      if (o) {
        var i = ja(e).pointerEl = new gue[o.type](L4(r.pointer));
        e.add(i);
      }
    }, t.prototype.createLabelEl = function(e, r, n, a) {
      if (r.label) {
        var o = ja(e).labelEl = new Ye(L4(r.label));
        e.add(o), O4(o, a);
      }
    }, t.prototype.updatePointerEl = function(e, r, n) {
      var a = ja(e).pointerEl;
      a && r.pointer && (a.setStyle(r.pointer.style), n(a, {
        shape: r.pointer.shape
      }));
    }, t.prototype.updateLabelEl = function(e, r, n, a) {
      var o = ja(e).labelEl;
      o && (o.setStyle(r.label.style), n(o, {
        // Consider text length change in vertical axis, animation should
        // be used on shape, otherwise the effect will be weird.
        // TODOTODO
        // shape: elOption.label.shape,
        x: r.label.x,
        y: r.label.y
      }), O4(o, a));
    }, t.prototype._renderHandle = function(e) {
      if (!(this._dragging || !this.updateHandleTransform)) {
        var r = this._axisPointerModel, n = this._api.getZr(), a = this._handle, o = r.getModel("handle"), i = r.get("status");
        if (!o.get("show") || !i || i === "hide") {
          a && n.remove(a), this._handle = null;
          return;
        }
        var l;
        this._handle || (l = !0, a = this._handle = P1(o.get("icon"), {
          cursor: "move",
          draggable: !0,
          onmousemove: function(u) {
            xi(u.event);
          },
          onmousedown: ff(this._onHandleDragMove, this, 0, 0),
          drift: ff(this._onHandleDragMove, this),
          ondragend: ff(this._onHandleDragEnd, this)
        }), n.add(a)), I4(a, r, !1), a.setStyle(o.getItemStyle(null, ["color", "borderColor", "borderWidth", "opacity", "shadowColor", "shadowBlur", "shadowOffsetX", "shadowOffsetY"]));
        var c = o.get("size");
        z(c) || (c = [c, c]), a.scaleX = c[0] / 2, a.scaleY = c[1] / 2, G1(this, "_doDispatchAxisPointer", o.get("throttle") || 0, "fixRate"), this._moveHandleToValue(e, l);
      }
    }, t.prototype._moveHandleToValue = function(e, r) {
      T4(this._axisPointerModel, !r && this._moveAnimation, this._handle, hf(this.getHandleTransform(e, this._axisModel, this._axisPointerModel)));
    }, t.prototype._onHandleDragMove = function(e, r) {
      var n = this._handle;
      if (n) {
        this._dragging = !0;
        var a = this.updateHandleTransform(hf(n), [e, r], this._axisModel, this._axisPointerModel);
        this._payloadInfo = a, n.stopAnimation(), n.attr(hf(a)), ja(n).lastProp = null, this._doDispatchAxisPointer();
      }
    }, t.prototype._doDispatchAxisPointer = function() {
      var e = this._handle;
      if (e) {
        var r = this._payloadInfo, n = this._axisModel;
        this._api.dispatchAction({
          type: "updateAxisPointer",
          x: r.cursorPoint[0],
          y: r.cursorPoint[1],
          tooltipOption: r.tooltipOption,
          axesInfo: [{
            axisDim: n.axis.dim,
            axisIndex: n.componentIndex
          }]
        });
      }
    }, t.prototype._onHandleDragEnd = function() {
      this._dragging = !1;
      var e = this._handle;
      if (e) {
        var r = this._axisPointerModel.get("value");
        this._moveHandleToValue(r), this._api.dispatchAction({
          type: "hideTip"
        });
      }
    }, t.prototype.clear = function(e) {
      this._lastValue = null, this._lastStatus = null;
      var r = e.getZr(), n = this._group, a = this._handle;
      r && n && (this._lastGraphicKey = null, n && r.remove(n), a && r.remove(a), this._group = null, this._handle = null, this._payloadInfo = null), uu(this, "_doDispatchAxisPointer");
    }, t.prototype.doClear = function() {
    }, t.prototype.buildLabel = function(e, r, n) {
      return n = n || 0, {
        x: e[n],
        y: e[1 - n],
        width: r[n],
        height: r[1 - n]
      };
    }, t;
  }()
);
function T4(t, e, r, n) {
  xC(ja(r).lastProp, n) || (ja(r).lastProp = n, e ? rt(r, n, t) : (r.stopAnimation(), r.attr(n)));
}
function xC(t, e) {
  if (re(t) && re(e)) {
    var r = !0;
    return I(e, function(n, a) {
      r = r && xC(t[a], n);
    }), !!r;
  } else
    return t === e;
}
function O4(t, e) {
  t[e.get(["label", "show"]) ? "show" : "hide"]();
}
function hf(t) {
  return {
    x: t.x || 0,
    y: t.y || 0,
    rotation: t.rotation || 0
  };
}
function I4(t, e, r) {
  var n = e.get("z"), a = e.get("zlevel");
  t && t.traverse(function(o) {
    o.type !== "group" && (n != null && (o.z = n), a != null && (o.zlevel = a), o.silent = r);
  });
}
function sve(t) {
  var e = t.get("type"), r = t.getModel(e + "Style"), n;
  return e === "line" ? (n = r.getLineStyle(), n.fill = null) : e === "shadow" && (n = r.getAreaStyle(), n.stroke = null), n;
}
function cve(t, e, r, n, a) {
  var o = r.get("value"), i = CC(o, e.axis, e.ecModel, r.get("seriesDataIndices"), {
    precision: r.get(["label", "precision"]),
    formatter: r.get(["label", "formatter"])
  }), l = r.getModel("label"), c = Ws(l.get("padding") || 0), u = l.getFont(), d = zv(i, u), f = a.position, h = d.width + c[1] + c[3], v = d.height + c[0] + c[2], p = a.align;
  p === "right" && (f[0] -= h), p === "center" && (f[0] -= h / 2);
  var g = a.verticalAlign;
  g === "bottom" && (f[1] -= v), g === "middle" && (f[1] -= v / 2), uve(f, h, v, n);
  var m = l.get("backgroundColor");
  (!m || m === "auto") && (m = e.get(["axisLine", "lineStyle", "color"])), t.label = {
    // shape: {x: 0, y: 0, width: width, height: height, r: labelModel.get('borderRadius')},
    x: f[0],
    y: f[1],
    style: jt(l, {
      text: i,
      font: u,
      fill: l.getTextColor(),
      padding: c,
      backgroundColor: m
    }),
    // Label should be over axisPointer.
    z2: 10
  };
}
function uve(t, e, r, n) {
  var a = n.getWidth(), o = n.getHeight();
  t[0] = Math.min(t[0] + e, a) - e, t[1] = Math.min(t[1] + r, o) - r, t[0] = Math.max(t[0], 0), t[1] = Math.max(t[1], 0);
}
function CC(t, e, r, n, a) {
  t = e.scale.parse(t);
  var o = e.scale.getLabel({
    value: t
  }, {
    // If `precision` is set, width can be fixed (like '12.00500'), which
    // helps to debounce when when moving label.
    precision: a.precision
  }), i = a.formatter;
  if (i) {
    var l = {
      value: Y7(e, {
        value: t
      }),
      axisDimension: e.dim,
      axisIndex: e.index,
      seriesData: []
    };
    I(n, function(c) {
      var u = r.getSeriesByIndex(c.seriesIndex), d = c.dataIndexInside, f = u && u.getDataParams(d);
      f && l.seriesData.push(f);
    }), Q(i) ? o = i.replace("{value}", o) : ie(i) && (o = i(l));
  }
  return o;
}
function EC(t, e, r) {
  var n = ta();
  return x1(n, n, r.rotation), j0(n, n, r.position), is([t.dataToCoord(e), (r.labelOffset || 0) + (r.labelDirection || 1) * (r.labelMargin || 0)], n);
}
function dve(t, e, r, n, a, o) {
  var i = aa.innerTextLayout(r.rotation, 0, r.labelDirection);
  r.labelMargin = a.get(["label", "margin"]), cve(e, n, a, o, {
    position: EC(n.axis, t, r),
    align: i.textAlign,
    verticalAlign: i.textVerticalAlign
  });
}
function fve(t, e, r) {
  return r = r || 0, {
    x1: t[r],
    y1: t[1 - r],
    x2: e[r],
    y2: e[1 - r]
  };
}
function hve(t, e, r) {
  return r = r || 0, {
    x: t[r],
    y: t[1 - r],
    width: e[r],
    height: e[1 - r]
  };
}
var vve = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.makeElOption = function(r, n, a, o, i) {
      var l = a.axis, c = l.grid, u = o.get("type"), d = P4(c, l).getOtherAxis(l).getGlobalExtent(), f = l.toGlobalCoord(l.dataToCoord(n, !0));
      if (u && u !== "none") {
        var h = sve(o), v = pve[u](l, f, d);
        v.style = h, r.graphicKey = v.type, r.pointer = v;
      }
      var p = d2(c.model, a);
      dve(
        // @ts-ignore
        n,
        r,
        p,
        a,
        o,
        i
      );
    }, e.prototype.getHandleTransform = function(r, n, a) {
      var o = d2(n.axis.grid.model, n, {
        labelInside: !1
      });
      o.labelMargin = a.get(["handle", "margin"]);
      var i = EC(n.axis, r, o);
      return {
        x: i[0],
        y: i[1],
        rotation: o.rotation + (o.labelDirection < 0 ? Math.PI : 0)
      };
    }, e.prototype.updateHandleTransform = function(r, n, a, o) {
      var i = a.axis, l = i.grid, c = i.getGlobalExtent(!0), u = P4(l, i).getOtherAxis(i).getGlobalExtent(), d = i.dim === "x" ? 0 : 1, f = [r.x, r.y];
      f[d] += n[d], f[d] = Math.min(c[1], f[d]), f[d] = Math.max(c[0], f[d]);
      var h = (u[1] + u[0]) / 2, v = [h, h];
      v[d] = f[d];
      var p = [{
        verticalAlign: "middle"
      }, {
        align: "center"
      }];
      return {
        x: f[0],
        y: f[1],
        rotation: r.rotation,
        cursorPoint: v,
        tooltipOption: p[d]
      };
    }, e;
  }(lve)
);
function P4(t, e) {
  var r = {};
  return r[e.dim + "AxisIndex"] = e.index, t.getCartesian(r);
}
var pve = {
  line: function(t, e, r) {
    var n = fve([e, r[0]], [e, r[1]], D4(t));
    return {
      type: "Line",
      subPixelOptimize: !0,
      shape: n
    };
  },
  shadow: function(t, e, r) {
    var n = Math.max(1, t.getBandWidth()), a = r[1] - r[0];
    return {
      type: "Rect",
      shape: hve([e - n / 2, r[0]], [n, a], D4(t))
    };
  }
};
function D4(t) {
  return t.dim === "x" ? 0 : 1;
}
var gve = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = e.type, r;
    }
    return e.type = "axisPointer", e.defaultOption = {
      // 'auto' means that show when triggered by tooltip or handle.
      show: "auto",
      // zlevel: 0,
      z: 50,
      type: "line",
      // axispointer triggered by tootip determine snap automatically,
      // see `modelHelper`.
      snap: !1,
      triggerTooltip: !0,
      triggerEmphasis: !0,
      value: null,
      status: null,
      link: [],
      // Do not set 'auto' here, otherwise global animation: false
      // will not effect at this axispointer.
      animation: null,
      animationDurationUpdate: 200,
      lineStyle: {
        color: "#B9BEC9",
        width: 1,
        type: "dashed"
      },
      shadowStyle: {
        color: "rgba(210,219,238,0.2)"
      },
      label: {
        show: !0,
        formatter: null,
        precision: "auto",
        margin: 3,
        color: "#fff",
        padding: [5, 7, 5, 7],
        backgroundColor: "auto",
        borderColor: null,
        borderWidth: 0,
        borderRadius: 3
      },
      handle: {
        show: !1,
        // eslint-disable-next-line
        icon: "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z",
        size: 45,
        // handle margin is from symbol center to axis, which is stable when circular move.
        margin: 50,
        // color: '#1b8bbd'
        // color: '#2f4554'
        color: "#333",
        shadowBlur: 3,
        shadowColor: "#aaa",
        shadowOffsetX: 0,
        shadowOffsetY: 2,
        // For mobile performance
        throttle: 40
      }
    }, e;
  }(Ee)
), gn = je(), mve = I;
function SC(t, e, r) {
  if (!ue.node) {
    var n = e.getZr();
    gn(n).records || (gn(n).records = {}), wve(n, e);
    var a = gn(n).records[t] || (gn(n).records[t] = {});
    a.handler = r;
  }
}
function wve(t, e) {
  if (gn(t).initialized)
    return;
  gn(t).initialized = !0, r("click", Oe(N4, "click")), r("mousemove", Oe(N4, "mousemove")), r("globalout", bve);
  function r(n, a) {
    t.on(n, function(o) {
      var i = _ve(e);
      mve(gn(t).records, function(l) {
        l && a(l, o, i.dispatchAction);
      }), yve(i.pendings, e);
    });
  }
}
function yve(t, e) {
  var r = t.showTip.length, n = t.hideTip.length, a;
  r ? a = t.showTip[r - 1] : n && (a = t.hideTip[n - 1]), a && (a.dispatchAction = null, e.dispatchAction(a));
}
function bve(t, e, r) {
  t.handler("leave", null, r);
}
function N4(t, e, r, n) {
  e.handler(t, r, n);
}
function _ve(t) {
  var e = {
    showTip: [],
    hideTip: []
  }, r = function(n) {
    var a = e[n.type];
    a ? a.push(n) : (n.dispatchAction = r, t.dispatchAction(n));
  };
  return {
    dispatchAction: r,
    pendings: e
  };
}
function p2(t, e) {
  if (!ue.node) {
    var r = e.getZr(), n = (gn(r).records || {})[t];
    n && (gn(r).records[t] = null);
  }
}
var xve = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = e.type, r;
    }
    return e.prototype.render = function(r, n, a) {
      var o = n.getComponent("tooltip"), i = r.get("triggerOn") || o && o.get("triggerOn") || "mousemove|click";
      SC("axisPointer", a, function(l, c, u) {
        i !== "none" && (l === "leave" || i.indexOf(l) >= 0) && u({
          type: "updateAxisPointer",
          currTrigger: l,
          x: c && c.offsetX,
          y: c && c.offsetY
        });
      });
    }, e.prototype.remove = function(r, n) {
      p2("axisPointer", n);
    }, e.prototype.dispose = function(r, n) {
      p2("axisPointer", n);
    }, e.type = "axisPointer", e;
  }(_t)
);
function RC(t, e) {
  var r = [], n = t.seriesIndex, a;
  if (n == null || !(a = e.getSeriesByIndex(n)))
    return {
      point: []
    };
  var o = a.getData(), i = oo(o, t);
  if (i == null || i < 0 || z(i))
    return {
      point: []
    };
  var l = o.getItemGraphicEl(i), c = a.coordinateSystem;
  if (a.getTooltipPosition)
    r = a.getTooltipPosition(i) || [];
  else if (c && c.dataToPoint)
    if (t.isStacked) {
      var u = c.getBaseAxis(), d = c.getOtherAxis(u), f = d.dim, h = u.dim, v = f === "x" || f === "radius" ? 1 : 0, p = o.mapDimension(h), g = [];
      g[v] = o.get(p, i), g[1 - v] = o.get(o.getCalculationInfo("stackResultDimension"), i), r = c.dataToPoint(g) || [];
    } else
      r = c.dataToPoint(o.getValues(J(c.dimensions, function(w) {
        return o.mapDimension(w);
      }), i)) || [];
  else if (l) {
    var m = l.getBoundingRect().clone();
    m.applyTransform(l.transform), r = [m.x + m.width / 2, m.y + m.height / 2];
  }
  return {
    point: r,
    el: l
  };
}
var B4 = je();
function Cve(t, e, r) {
  var n = t.currTrigger, a = [t.x, t.y], o = t, i = t.dispatchAction || le(r.dispatchAction, r), l = e.getComponent("axisPointer").coordSysAxesInfo;
  if (l) {
    E0(a) && (a = RC({
      seriesIndex: o.seriesIndex,
      // Do not use dataIndexInside from other ec instance.
      // FIXME: auto detect it?
      dataIndex: o.dataIndex
    }, e).point);
    var c = E0(a), u = o.axesInfo, d = l.axesInfo, f = n === "leave" || E0(a), h = {}, v = {}, p = {
      list: [],
      map: {}
    }, g = {
      showPointer: Oe(Sve, v),
      showTooltip: Oe(Rve, p)
    };
    I(l.coordSysMap, function(w, y) {
      var b = c || w.containPoint(a);
      I(l.coordSysAxesInfo[y], function(_, x) {
        var E = _.axis, S = Lve(u, _);
        if (!f && b && (!u || S)) {
          var M = S && S.value;
          M == null && !c && (M = E.pointToData(a)), M != null && F4(_, M, g, !1, h);
        }
      });
    });
    var m = {};
    return I(d, function(w, y) {
      var b = w.linkGroup;
      b && !v[y] && I(b.axesInfo, function(_, x) {
        var E = v[x];
        if (_ !== w && E) {
          var S = E.value;
          b.mapper && (S = w.axis.scale.parse(b.mapper(S, $4(_), $4(w)))), m[w.key] = S;
        }
      });
    }), I(m, function(w, y) {
      F4(d[y], w, g, !0, h);
    }), Mve(v, d, h), Ave(p, a, t, i), kve(d, i, r), h;
  }
}
function F4(t, e, r, n, a) {
  var o = t.axis;
  if (!(o.scale.isBlank() || !o.containData(e))) {
    if (!t.involveSeries) {
      r.showPointer(t, e);
      return;
    }
    var i = Eve(e, t), l = i.payloadBatch, c = i.snapToValue;
    l[0] && a.seriesIndex == null && H(a, l[0]), !n && t.snap && o.containData(c) && c != null && (e = c), r.showPointer(t, e, l), r.showTooltip(t, i, c);
  }
}
function Eve(t, e) {
  var r = e.axis, n = r.dim, a = t, o = [], i = Number.MAX_VALUE, l = -1;
  return I(e.seriesModels, function(c, u) {
    var d = c.getData().mapDimensionsAll(n), f, h;
    if (c.getAxisTooltipData) {
      var v = c.getAxisTooltipData(d, t, r);
      h = v.dataIndices, f = v.nestestValue;
    } else {
      if (h = c.getData().indicesOfNearest(
        d[0],
        t,
        // Add a threshold to avoid find the wrong dataIndex
        // when data length is not same.
        // false,
        r.type === "category" ? 0.5 : null
      ), !h.length)
        return;
      f = c.getData().get(d[0], h[0]);
    }
    if (!(f == null || !isFinite(f))) {
      var p = t - f, g = Math.abs(p);
      g <= i && ((g < i || p >= 0 && l < 0) && (i = g, l = p, a = f, o.length = 0), I(h, function(m) {
        o.push({
          seriesIndex: c.seriesIndex,
          dataIndexInside: m,
          dataIndex: c.getData().getRawIndex(m)
        });
      }));
    }
  }), {
    payloadBatch: o,
    snapToValue: a
  };
}
function Sve(t, e, r, n) {
  t[e.key] = {
    value: r,
    payloadBatch: n
  };
}
function Rve(t, e, r, n) {
  var a = r.payloadBatch, o = e.axis, i = o.model, l = e.axisPointerModel;
  if (!(!e.triggerTooltip || !a.length)) {
    var c = e.coordSys.model, u = hs(c), d = t.map[u];
    d || (d = t.map[u] = {
      coordSysId: c.id,
      coordSysIndex: c.componentIndex,
      coordSysType: c.type,
      coordSysMainType: c.mainType,
      dataByAxis: []
    }, t.list.push(d)), d.dataByAxis.push({
      axisDim: o.dim,
      axisIndex: i.componentIndex,
      axisType: i.type,
      axisId: i.id,
      value: n,
      // Caustion: viewHelper.getValueLabel is actually on "view stage", which
      // depends that all models have been updated. So it should not be performed
      // here. Considering axisPointerModel used here is volatile, which is hard
      // to be retrieve in TooltipView, we prepare parameters here.
      valueLabelOpt: {
        precision: l.get(["label", "precision"]),
        formatter: l.get(["label", "formatter"])
      },
      seriesDataIndices: a.slice()
    });
  }
}
function Mve(t, e, r) {
  var n = r.axesInfo = [];
  I(e, function(a, o) {
    var i = a.axisPointerModel.option, l = t[o];
    l ? (!a.useHandle && (i.status = "show"), i.value = l.value, i.seriesDataIndices = (l.payloadBatch || []).slice()) : !a.useHandle && (i.status = "hide"), i.status === "show" && n.push({
      axisDim: a.axis.dim,
      axisIndex: a.axis.model.componentIndex,
      value: i.value
    });
  });
}
function Ave(t, e, r, n) {
  if (E0(e) || !t.list.length) {
    n({
      type: "hideTip"
    });
    return;
  }
  var a = ((t.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
  n({
    type: "showTip",
    escapeConnect: !0,
    x: e[0],
    y: e[1],
    tooltipOption: r.tooltipOption,
    position: r.position,
    dataIndexInside: a.dataIndexInside,
    dataIndex: a.dataIndex,
    seriesIndex: a.seriesIndex,
    dataByCoordSys: t.list
  });
}
function kve(t, e, r) {
  var n = r.getZr(), a = "axisPointerLastHighlights", o = B4(n)[a] || {}, i = B4(n)[a] = {};
  I(t, function(u, d) {
    var f = u.axisPointerModel.option;
    f.status === "show" && u.triggerEmphasis && I(f.seriesDataIndices, function(h) {
      var v = h.seriesIndex + " | " + h.dataIndex;
      i[v] = h;
    });
  });
  var l = [], c = [];
  I(o, function(u, d) {
    !i[d] && c.push(u);
  }), I(i, function(u, d) {
    !o[d] && l.push(u);
  }), c.length && r.dispatchAction({
    type: "downplay",
    escapeConnect: !0,
    // Not blur others when highlight in axisPointer.
    notBlur: !0,
    batch: c
  }), l.length && r.dispatchAction({
    type: "highlight",
    escapeConnect: !0,
    // Not blur others when highlight in axisPointer.
    notBlur: !0,
    batch: l
  });
}
function Lve(t, e) {
  for (var r = 0; r < (t || []).length; r++) {
    var n = t[r];
    if (e.axis.dim === n.axisDim && e.axis.model.componentIndex === n.axisIndex)
      return n;
  }
}
function $4(t) {
  var e = t.axis.model, r = {}, n = r.axisDim = t.axis.dim;
  return r.axisIndex = r[n + "AxisIndex"] = e.componentIndex, r.axisName = r[n + "AxisName"] = e.name, r.axisId = r[n + "AxisId"] = e.id, r;
}
function E0(t) {
  return !t || t[0] == null || isNaN(t[0]) || t[1] == null || isNaN(t[1]);
}
function MC(t) {
  mC.registerAxisPointerClass("CartesianAxisPointer", vve), t.registerComponentModel(gve), t.registerComponentView(xve), t.registerPreprocessor(function(e) {
    if (e) {
      (!e.axisPointer || e.axisPointer.length === 0) && (e.axisPointer = {});
      var r = e.axisPointer.link;
      r && !z(r) && (e.axisPointer.link = [r]);
    }
  }), t.registerProcessor(t.PRIORITY.PROCESSOR.STATISTIC, function(e, r) {
    e.getComponent("axisPointer").coordSysAxesInfo = I2e(e, r);
  }), t.registerAction({
    type: "updateAxisPointer",
    event: "updateAxisPointer",
    update: ":updateAxisPointer"
  }, Cve);
}
function n5(t) {
  Gt(U2e), Gt(MC);
}
var V4 = ["x", "y", "radius", "angle", "single"], Tve = ["cartesian2d", "polar", "singleAxis"];
function Ove(t) {
  var e = t.get("coordinateSystem");
  return Re(Tve, e) >= 0;
}
function qn(t) {
  return process.env.NODE_ENV !== "production" && ge(t), t + "Axis";
}
function Ive(t, e) {
  var r = se(), n = [], a = se();
  t.eachComponent({
    mainType: "dataZoom",
    query: e
  }, function(d) {
    a.get(d.uid) || l(d);
  });
  var o;
  do
    o = !1, t.eachComponent("dataZoom", i);
  while (o);
  function i(d) {
    !a.get(d.uid) && c(d) && (l(d), o = !0);
  }
  function l(d) {
    a.set(d.uid, !0), n.push(d), u(d);
  }
  function c(d) {
    var f = !1;
    return d.eachTargetAxis(function(h, v) {
      var p = r.get(h);
      p && p[v] && (f = !0);
    }), f;
  }
  function u(d) {
    d.eachTargetAxis(function(f, h) {
      (r.get(f) || r.set(f, []))[h] = !0;
    });
  }
  return n;
}
function AC(t) {
  var e = t.ecModel, r = {
    infoList: [],
    infoMap: se()
  };
  return t.eachTargetAxis(function(n, a) {
    var o = e.getComponent(qn(n), a);
    if (o) {
      var i = o.getCoordSysModel();
      if (i) {
        var l = i.uid, c = r.infoMap.get(l);
        c || (c = {
          model: i,
          axisModels: []
        }, r.infoList.push(c), r.infoMap.set(l, c)), c.axisModels.push(o);
      }
    }
  }), r;
}
var vf = (
  /** @class */
  function() {
    function t() {
      this.indexList = [], this.indexMap = [];
    }
    return t.prototype.add = function(e) {
      this.indexMap[e] || (this.indexList.push(e), this.indexMap[e] = !0);
    }, t;
  }()
), xu = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = e.type, r._autoThrottle = !0, r._noTarget = !0, r._rangePropMode = ["percent", "percent"], r;
    }
    return e.prototype.init = function(r, n, a) {
      var o = Z4(r);
      this.settledOption = o, this.mergeDefaultAndTheme(r, a), this._doInit(o);
    }, e.prototype.mergeOption = function(r) {
      var n = Z4(r);
      Ce(this.option, r, !0), Ce(this.settledOption, n, !0), this._doInit(n);
    }, e.prototype._doInit = function(r) {
      var n = this.option;
      this._setDefaultThrottle(r), this._updateRangeUse(r);
      var a = this.settledOption;
      I([["start", "startValue"], ["end", "endValue"]], function(o, i) {
        this._rangePropMode[i] === "value" && (n[o[0]] = a[o[0]] = null);
      }, this), this._resetTarget();
    }, e.prototype._resetTarget = function() {
      var r = this.get("orient", !0), n = this._targetAxisInfoMap = se(), a = this._fillSpecifiedTargetAxis(n);
      a ? this._orient = r || this._makeAutoOrientByTargetAxis() : (this._orient = r || "horizontal", this._fillAutoTargetAxisByOrient(n, this._orient)), this._noTarget = !0, n.each(function(o) {
        o.indexList.length && (this._noTarget = !1);
      }, this);
    }, e.prototype._fillSpecifiedTargetAxis = function(r) {
      var n = !1;
      return I(V4, function(a) {
        var o = this.getReferringComponents(qn(a), yce);
        if (o.specified) {
          n = !0;
          var i = new vf();
          I(o.models, function(l) {
            i.add(l.componentIndex);
          }), r.set(a, i);
        }
      }, this), n;
    }, e.prototype._fillAutoTargetAxisByOrient = function(r, n) {
      var a = this.ecModel, o = !0;
      if (o) {
        var i = n === "vertical" ? "y" : "x", l = a.findComponents({
          mainType: i + "Axis"
        });
        c(l, i);
      }
      if (o) {
        var l = a.findComponents({
          mainType: "singleAxis",
          filter: function(d) {
            return d.get("orient", !0) === n;
          }
        });
        c(l, "single");
      }
      function c(u, d) {
        var f = u[0];
        if (f) {
          var h = new vf();
          if (h.add(f.componentIndex), r.set(d, h), o = !1, d === "x" || d === "y") {
            var v = f.getReferringComponents("grid", Ht).models[0];
            v && I(u, function(p) {
              f.componentIndex !== p.componentIndex && v === p.getReferringComponents("grid", Ht).models[0] && h.add(p.componentIndex);
            });
          }
        }
      }
      o && I(V4, function(u) {
        if (o) {
          var d = a.findComponents({
            mainType: qn(u),
            filter: function(h) {
              return h.get("type", !0) === "category";
            }
          });
          if (d[0]) {
            var f = new vf();
            f.add(d[0].componentIndex), r.set(u, f), o = !1;
          }
        }
      }, this);
    }, e.prototype._makeAutoOrientByTargetAxis = function() {
      var r;
      return this.eachTargetAxis(function(n) {
        !r && (r = n);
      }, this), r === "y" ? "vertical" : "horizontal";
    }, e.prototype._setDefaultThrottle = function(r) {
      if (r.hasOwnProperty("throttle") && (this._autoThrottle = !1), this._autoThrottle) {
        var n = this.ecModel.option;
        this.option.throttle = n.animation && n.animationDurationUpdate > 0 ? 100 : 20;
      }
    }, e.prototype._updateRangeUse = function(r) {
      var n = this._rangePropMode, a = this.get("rangeMode");
      I([["start", "startValue"], ["end", "endValue"]], function(o, i) {
        var l = r[o[0]] != null, c = r[o[1]] != null;
        l && !c ? n[i] = "percent" : !l && c ? n[i] = "value" : a ? n[i] = a[i] : l && (n[i] = "percent");
      });
    }, e.prototype.noTarget = function() {
      return this._noTarget;
    }, e.prototype.getFirstTargetAxisModel = function() {
      var r;
      return this.eachTargetAxis(function(n, a) {
        r == null && (r = this.ecModel.getComponent(qn(n), a));
      }, this), r;
    }, e.prototype.eachTargetAxis = function(r, n) {
      this._targetAxisInfoMap.each(function(a, o) {
        I(a.indexList, function(i) {
          r.call(n, o, i);
        });
      });
    }, e.prototype.getAxisProxy = function(r, n) {
      var a = this.getAxisModel(r, n);
      if (a)
        return a.__dzAxisProxy;
    }, e.prototype.getAxisModel = function(r, n) {
      process.env.NODE_ENV !== "production" && ge(r && n != null);
      var a = this._targetAxisInfoMap.get(r);
      if (a && a.indexMap[n])
        return this.ecModel.getComponent(qn(r), n);
    }, e.prototype.setRawRange = function(r) {
      var n = this.option, a = this.settledOption;
      I([["start", "startValue"], ["end", "endValue"]], function(o) {
        (r[o[0]] != null || r[o[1]] != null) && (n[o[0]] = a[o[0]] = r[o[0]], n[o[1]] = a[o[1]] = r[o[1]]);
      }, this), this._updateRangeUse(r);
    }, e.prototype.setCalculatedRange = function(r) {
      var n = this.option;
      I(["start", "startValue", "end", "endValue"], function(a) {
        n[a] = r[a];
      });
    }, e.prototype.getPercentRange = function() {
      var r = this.findRepresentativeAxisProxy();
      if (r)
        return r.getDataPercentWindow();
    }, e.prototype.getValueRange = function(r, n) {
      if (r == null && n == null) {
        var a = this.findRepresentativeAxisProxy();
        if (a)
          return a.getDataValueWindow();
      } else
        return this.getAxisProxy(r, n).getDataValueWindow();
    }, e.prototype.findRepresentativeAxisProxy = function(r) {
      if (r)
        return r.__dzAxisProxy;
      for (var n, a = this._targetAxisInfoMap.keys(), o = 0; o < a.length; o++)
        for (var i = a[o], l = this._targetAxisInfoMap.get(i), c = 0; c < l.indexList.length; c++) {
          var u = this.getAxisProxy(i, l.indexList[c]);
          if (u.hostedBy(this))
            return u;
          n || (n = u);
        }
      return n;
    }, e.prototype.getRangePropMode = function() {
      return this._rangePropMode.slice();
    }, e.prototype.getOrient = function() {
      return process.env.NODE_ENV !== "production" && ge(this._orient), this._orient;
    }, e.type = "dataZoom", e.dependencies = ["xAxis", "yAxis", "radiusAxis", "angleAxis", "singleAxis", "series", "toolbox"], e.defaultOption = {
      // zlevel: 0,
      z: 4,
      filterMode: "filter",
      start: 0,
      end: 100
    }, e;
  }(Ee)
);
function Z4(t) {
  var e = {};
  return I(["start", "end", "startValue", "endValue", "throttle"], function(r) {
    t.hasOwnProperty(r) && (e[r] = t[r]);
  }), e;
}
var kC = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = e.type, r;
    }
    return e.prototype.render = function(r, n, a, o) {
      this.dataZoomModel = r, this.ecModel = n, this.api = a;
    }, e.type = "dataZoom", e;
  }(_t)
), Ko = I, H4 = Jo, Pve = (
  /** @class */
  function() {
    function t(e, r, n, a) {
      this._dimName = e, this._axisIndex = r, this.ecModel = a, this._dataZoomModel = n;
    }
    return t.prototype.hostedBy = function(e) {
      return this._dataZoomModel === e;
    }, t.prototype.getDataValueWindow = function() {
      return this._valueWindow.slice();
    }, t.prototype.getDataPercentWindow = function() {
      return this._percentWindow.slice();
    }, t.prototype.getTargetSeriesModels = function() {
      var e = [];
      return this.ecModel.eachSeries(function(r) {
        if (Ove(r)) {
          var n = qn(this._dimName), a = r.getReferringComponents(n, Ht).models[0];
          a && this._axisIndex === a.componentIndex && e.push(r);
        }
      }, this), e;
    }, t.prototype.getAxisModel = function() {
      return this.ecModel.getComponent(this._dimName + "Axis", this._axisIndex);
    }, t.prototype.getMinMaxSpan = function() {
      return be(this._minMaxSpan);
    }, t.prototype.calculateDataWindow = function(e) {
      var r = this._dataExtent, n = this.getAxisModel(), a = n.axis.scale, o = this._dataZoomModel.getRangePropMode(), i = [0, 100], l = [], c = [], u;
      Ko(["start", "end"], function(h, v) {
        var p = e[h], g = e[h + "Value"];
        o[v] === "percent" ? (p == null && (p = i[v]), g = a.parse(Ge(p, i, r))) : (u = !0, g = g == null ? r[v] : a.parse(g), p = Ge(g, r, i)), c[v] = g == null || isNaN(g) ? r[v] : g, l[v] = p == null || isNaN(p) ? i[v] : p;
      }), H4(c), H4(l);
      var d = this._minMaxSpan;
      u ? f(c, l, r, i, !1) : f(l, c, i, r, !0);
      function f(h, v, p, g, m) {
        var w = m ? "Span" : "ValueSpan";
        r5(0, h, p, "all", d["min" + w], d["max" + w]);
        for (var y = 0; y < 2; y++)
          v[y] = Ge(h[y], p, g, !0), m && (v[y] = a.parse(v[y]));
      }
      return {
        valueWindow: c,
        percentWindow: l
      };
    }, t.prototype.reset = function(e) {
      if (e === this._dataZoomModel) {
        var r = this.getTargetSeriesModels();
        this._dataExtent = Dve(this, this._dimName, r), this._updateMinMaxSpan();
        var n = this.calculateDataWindow(e.settledOption);
        this._valueWindow = n.valueWindow, this._percentWindow = n.percentWindow, this._setAxisModel();
      }
    }, t.prototype.filterData = function(e, r) {
      if (e !== this._dataZoomModel)
        return;
      var n = this._dimName, a = this.getTargetSeriesModels(), o = e.get("filterMode"), i = this._valueWindow;
      if (o === "none")
        return;
      Ko(a, function(c) {
        var u = c.getData(), d = u.mapDimensionsAll(n);
        if (d.length) {
          if (o === "weakFilter") {
            var f = u.getStore(), h = J(d, function(v) {
              return u.getDimensionIndex(v);
            }, u);
            u.filterSelf(function(v) {
              for (var p, g, m, w = 0; w < d.length; w++) {
                var y = f.get(h[w], v), b = !isNaN(y), _ = y < i[0], x = y > i[1];
                if (b && !_ && !x)
                  return !0;
                b && (m = !0), _ && (p = !0), x && (g = !0);
              }
              return m && p && g;
            });
          } else
            Ko(d, function(v) {
              if (o === "empty")
                c.setData(u = u.map(v, function(g) {
                  return l(g) ? g : NaN;
                }));
              else {
                var p = {};
                p[v] = i, u.selectRange(p);
              }
            });
          Ko(d, function(v) {
            u.setApproximateExtent(i, v);
          });
        }
      });
      function l(c) {
        return c >= i[0] && c <= i[1];
      }
    }, t.prototype._updateMinMaxSpan = function() {
      var e = this._minMaxSpan = {}, r = this._dataZoomModel, n = this._dataExtent;
      Ko(["min", "max"], function(a) {
        var o = r.get(a + "Span"), i = r.get(a + "ValueSpan");
        i != null && (i = this.getAxisModel().axis.scale.parse(i)), i != null ? o = Ge(n[0] + i, n, [0, 100], !0) : o != null && (i = Ge(o, [0, 100], n, !0) - n[0]), e[a + "Span"] = o, e[a + "ValueSpan"] = i;
      }, this);
    }, t.prototype._setAxisModel = function() {
      var e = this.getAxisModel(), r = this._percentWindow, n = this._valueWindow;
      if (r) {
        var a = Uv(n, [0, 500]);
        a = Math.min(a, 20);
        var o = e.axis.scale.rawExtentInfo;
        r[0] !== 0 && o.setDeterminedMinMax("min", +n[0].toFixed(a)), r[1] !== 100 && o.setDeterminedMinMax("max", +n[1].toFixed(a)), o.freeze();
      }
    }, t;
  }()
);
function Dve(t, e, r) {
  var n = [1 / 0, -1 / 0];
  Ko(r, function(i) {
    Pfe(n, i.getData(), e);
  });
  var a = t.getAxisModel(), o = Nx(a.axis.scale, a, n).calculate();
  return [o.min, o.max];
}
var Nve = {
  // `dataZoomProcessor` will only be performed in needed series. Consider if
  // there is a line series and a pie series, it is better not to update the
  // line series if only pie series is needed to be updated.
  getTargetSeries: function(t) {
    function e(a) {
      t.eachComponent("dataZoom", function(o) {
        o.eachTargetAxis(function(i, l) {
          var c = t.getComponent(qn(i), l);
          a(i, l, c, o);
        });
      });
    }
    e(function(a, o, i, l) {
      i.__dzAxisProxy = null;
    });
    var r = [];
    e(function(a, o, i, l) {
      i.__dzAxisProxy || (i.__dzAxisProxy = new Pve(a, o, l, t), r.push(i.__dzAxisProxy));
    });
    var n = se();
    return I(r, function(a) {
      I(a.getTargetSeriesModels(), function(o) {
        n.set(o.uid, o);
      });
    }), n;
  },
  // Consider appendData, where filter should be performed. Because data process is
  // in block mode currently, it is not need to worry about that the overallProgress
  // execute every frame.
  overallReset: function(t, e) {
    t.eachComponent("dataZoom", function(r) {
      r.eachTargetAxis(function(n, a) {
        r.getAxisProxy(n, a).reset(r);
      }), r.eachTargetAxis(function(n, a) {
        r.getAxisProxy(n, a).filterData(r, e);
      });
    }), t.eachComponent("dataZoom", function(r) {
      var n = r.findRepresentativeAxisProxy();
      if (n) {
        var a = n.getDataPercentWindow(), o = n.getDataValueWindow();
        r.setCalculatedRange({
          start: a[0],
          end: a[1],
          startValue: o[0],
          endValue: o[1]
        });
      }
    });
  }
};
function Bve(t) {
  t.registerAction("dataZoom", function(e, r) {
    var n = Ive(r, e);
    I(n, function(a) {
      a.setRawRange({
        start: e.start,
        end: e.end,
        startValue: e.startValue,
        endValue: e.endValue
      });
    });
  });
}
var j4 = !1;
function LC(t) {
  j4 || (j4 = !0, t.registerProcessor(t.PRIORITY.PROCESSOR.FILTER, Nve), Bve(t), t.registerSubTypeDefaulter("dataZoom", function() {
    return "slider";
  }));
}
function Fve(t, e) {
  var r = Ws(e.get("padding")), n = e.getItemStyle(["color", "opacity"]);
  return n.fill = e.get("backgroundColor"), t = new He({
    shape: {
      x: t.x - r[3],
      y: t.y - r[0],
      width: t.width + r[1] + r[3],
      height: t.height + r[0] + r[2],
      r: e.get("borderRadius")
    },
    style: n,
    silent: !0,
    z2: -1
  }), t;
}
var $ve = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = e.type, r;
    }
    return e.type = "tooltip", e.dependencies = ["axisPointer"], e.defaultOption = {
      // zlevel: 0,
      z: 60,
      show: !0,
      // tooltip main content
      showContent: !0,
      // 'trigger' only works on coordinate system.
      // 'item' | 'axis' | 'none'
      trigger: "item",
      // 'click' | 'mousemove' | 'none'
      triggerOn: "mousemove|click",
      alwaysShowContent: !1,
      displayMode: "single",
      renderMode: "auto",
      // whether restraint content inside viewRect.
      // If renderMode: 'richText', default true.
      // If renderMode: 'html', defaut false (for backward compat).
      confine: null,
      showDelay: 0,
      hideDelay: 100,
      // Animation transition time, unit is second
      transitionDuration: 0.4,
      enterable: !1,
      backgroundColor: "#fff",
      // box shadow
      shadowBlur: 10,
      shadowColor: "rgba(0, 0, 0, .2)",
      shadowOffsetX: 1,
      shadowOffsetY: 2,
      // tooltip border radius, unit is px, default is 4
      borderRadius: 4,
      // tooltip border width, unit is px, default is 0 (no border)
      borderWidth: 1,
      // Tooltip inside padding, default is 5 for all direction
      // Array is allowed to set up, right, bottom, left, same with css
      // The default value: See `tooltip/tooltipMarkup.ts#getPaddingFromTooltipModel`.
      padding: null,
      // Extra css text
      extraCssText: "",
      // axis indicator, trigger by axis
      axisPointer: {
        // default is line
        // legal values: 'line' | 'shadow' | 'cross'
        type: "line",
        // Valid when type is line, appoint tooltip line locate on which line. Optional
        // legal values: 'x' | 'y' | 'angle' | 'radius' | 'auto'
        // default is 'auto', chose the axis which type is category.
        // for multiply y axis, cartesian coord chose x axis, polar chose angle axis
        axis: "auto",
        animation: "auto",
        animationDurationUpdate: 200,
        animationEasingUpdate: "exponentialOut",
        crossStyle: {
          color: "#999",
          width: 1,
          type: "dashed",
          // TODO formatter
          textStyle: {}
        }
        // lineStyle and shadowStyle should not be specified here,
        // otherwise it will always override those styles on option.axisPointer.
      },
      textStyle: {
        color: "#666",
        fontSize: 14
      }
    }, e;
  }(Ee)
);
function TC(t) {
  var e = t.get("confine");
  return e != null ? !!e : t.get("renderMode") === "richText";
}
function OC(t) {
  if (ue.domSupported) {
    for (var e = document.documentElement.style, r = 0, n = t.length; r < n; r++)
      if (t[r] in e)
        return t[r];
  }
}
var IC = OC(["transform", "webkitTransform", "OTransform", "MozTransform", "msTransform"]), Vve = OC(["webkitTransition", "transition", "OTransition", "MozTransition", "msTransition"]);
function PC(t, e) {
  if (!t)
    return e;
  e = b7(e, !0);
  var r = t.indexOf(e);
  return t = r === -1 ? e : "-" + t.slice(0, r) + "-" + e, t.toLowerCase();
}
function Zve(t, e) {
  var r = t.currentStyle || document.defaultView && document.defaultView.getComputedStyle(t);
  return r ? r[e] : null;
}
var Hve = PC(Vve, "transition"), ep = PC(IC, "transform"), jve = "position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;" + (ue.transform3dSupported ? "will-change:transform;" : "");
function Wve(t) {
  return t = t === "left" ? "right" : t === "right" ? "left" : t === "top" ? "bottom" : "top", t;
}
function zve(t, e, r) {
  if (!Q(r) || r === "inside")
    return "";
  var n = t.get("backgroundColor"), a = t.get("borderWidth");
  e = lo(e);
  var o = Wve(r), i = Math.max(Math.round(a) * 1.5, 6), l = "", c = ep + ":", u;
  Re(["left", "right"], o) > -1 ? (l += "top:50%", c += "translateY(-50%) rotate(" + (u = o === "left" ? -225 : -45) + "deg)") : (l += "left:50%", c += "translateX(-50%) rotate(" + (u = o === "top" ? 225 : 45) + "deg)");
  var d = u * Math.PI / 180, f = i + a, h = f * Math.abs(Math.cos(d)) + f * Math.abs(Math.sin(d)), v = Math.round(((h - Math.SQRT2 * a) / 2 + Math.SQRT2 * a - (h - f) / 2) * 100) / 100;
  l += ";" + o + ":-" + v + "px";
  var p = e + " solid " + a + "px;", g = ["position:absolute;width:" + i + "px;height:" + i + "px;z-index:-1;", l + ";" + c + ";", "border-bottom:" + p, "border-right:" + p, "background-color:" + n + ";"];
  return '<div style="' + g.join("") + '"></div>';
}
function Gve(t, e) {
  var r = "cubic-bezier(0.23,1,0.32,1)", n = " " + t / 2 + "s " + r, a = "opacity" + n + ",visibility" + n;
  return e || (n = " " + t + "s " + r, a += ue.transformSupported ? "," + ep + n : ",left" + n + ",top" + n), Hve + ":" + a;
}
function W4(t, e, r) {
  var n = t.toFixed(0) + "px", a = e.toFixed(0) + "px";
  if (!ue.transformSupported)
    return r ? "top:" + a + ";left:" + n + ";" : [["top", a], ["left", n]];
  var o = ue.transform3dSupported, i = "translate" + (o ? "3d" : "") + "(" + n + "," + a + (o ? ",0" : "") + ")";
  return r ? "top:0;left:0;" + ep + ":" + i + ";" : [["top", 0], ["left", 0], [IC, i]];
}
function Uve(t) {
  var e = [], r = t.get("fontSize"), n = t.getTextColor();
  n && e.push("color:" + n), e.push("font:" + t.getFont()), r && e.push("line-height:" + Math.round(r * 3 / 2) + "px");
  var a = t.get("textShadowColor"), o = t.get("textShadowBlur") || 0, i = t.get("textShadowOffsetX") || 0, l = t.get("textShadowOffsetY") || 0;
  return a && o && e.push("text-shadow:" + i + "px " + l + "px " + o + "px " + a), I(["decoration", "align"], function(c) {
    var u = t.get(c);
    u && e.push("text-" + c + ":" + u);
  }), e.join(";");
}
function Yve(t, e, r) {
  var n = [], a = t.get("transitionDuration"), o = t.get("backgroundColor"), i = t.get("shadowBlur"), l = t.get("shadowColor"), c = t.get("shadowOffsetX"), u = t.get("shadowOffsetY"), d = t.getModel("textStyle"), f = V_(t, "html"), h = c + "px " + u + "px " + i + "px " + l;
  return n.push("box-shadow:" + h), e && a && n.push(Gve(a, r)), o && n.push("background-color:" + o), I(["width", "color", "radius"], function(v) {
    var p = "border-" + v, g = b7(p), m = t.get(g);
    m != null && n.push(p + ":" + m + (v === "color" ? "" : "px"));
  }), n.push(Uve(d)), f != null && n.push("padding:" + Ws(f).join("px ") + "px"), n.join(";") + ";";
}
function z4(t, e, r, n, a) {
  var o = e && e.painter;
  if (r) {
    var i = o && o.getViewportRoot();
    i && Ile(t, i, r, n, a);
  } else {
    t[0] = n, t[1] = a;
    var l = o && o.getViewportRootOffset();
    l && (t[0] += l.offsetLeft, t[1] += l.offsetTop);
  }
  t[2] = t[0] / e.getWidth(), t[3] = t[1] / e.getHeight();
}
var Xve = (
  /** @class */
  function() {
    function t(e, r) {
      if (this._show = !1, this._styleCoord = [0, 0, 0, 0], this._enterable = !0, this._alwaysShowContent = !1, this._firstShow = !0, this._longHide = !0, ue.wxa)
        return null;
      var n = document.createElement("div");
      n.domBelongToZr = !0, this.el = n;
      var a = this._zr = e.getZr(), o = r.appendTo, i = o && (Q(o) ? document.querySelector(o) : no(o) ? o : ie(o) && o(e.getDom()));
      z4(this._styleCoord, a, i, e.getWidth() / 2, e.getHeight() / 2), (i || e.getDom()).appendChild(n), this._api = e, this._container = i;
      var l = this;
      n.onmouseenter = function() {
        l._enterable && (clearTimeout(l._hideTimeout), l._show = !0), l._inContent = !0;
      }, n.onmousemove = function(c) {
        if (c = c || window.event, !l._enterable) {
          var u = a.handler, d = a.painter.getViewportRoot();
          sr(d, c, !0), u.dispatch("mousemove", c);
        }
      }, n.onmouseleave = function() {
        l._inContent = !1, l._enterable && l._show && l.hideLater(l._hideDelay);
      };
    }
    return t.prototype.update = function(e) {
      if (!this._container) {
        var r = this._api.getDom(), n = Zve(r, "position"), a = r.style;
        a.position !== "absolute" && n !== "absolute" && (a.position = "relative");
      }
      var o = e.get("alwaysShowContent");
      o && this._moveIfResized(), this._alwaysShowContent = o, this.el.className = e.get("className") || "";
    }, t.prototype.show = function(e, r) {
      clearTimeout(this._hideTimeout), clearTimeout(this._longHideTimeout);
      var n = this.el, a = n.style, o = this._styleCoord;
      n.innerHTML ? a.cssText = jve + Yve(e, !this._firstShow, this._longHide) + W4(o[0], o[1], !0) + ("border-color:" + lo(r) + ";") + (e.get("extraCssText") || "") + (";pointer-events:" + (this._enterable ? "auto" : "none")) : a.display = "none", this._show = !0, this._firstShow = !1, this._longHide = !1;
    }, t.prototype.setContent = function(e, r, n, a, o) {
      var i = this.el;
      if (e == null) {
        i.innerHTML = "";
        return;
      }
      var l = "";
      if (Q(o) && n.get("trigger") === "item" && !TC(n) && (l = zve(n, a, o)), Q(e))
        i.innerHTML = e + l;
      else if (e) {
        i.innerHTML = "", z(e) || (e = [e]);
        for (var c = 0; c < e.length; c++)
          no(e[c]) && e[c].parentNode !== i && i.appendChild(e[c]);
        if (l && i.childNodes.length) {
          var u = document.createElement("div");
          u.innerHTML = l, i.appendChild(u);
        }
      }
    }, t.prototype.setEnterable = function(e) {
      this._enterable = e;
    }, t.prototype.getSize = function() {
      var e = this.el;
      return [e.offsetWidth, e.offsetHeight];
    }, t.prototype.moveTo = function(e, r) {
      var n = this._styleCoord;
      if (z4(n, this._zr, this._container, e, r), n[0] != null && n[1] != null) {
        var a = this.el.style, o = W4(n[0], n[1]);
        I(o, function(i) {
          a[i[0]] = i[1];
        });
      }
    }, t.prototype._moveIfResized = function() {
      var e = this._styleCoord[2], r = this._styleCoord[3];
      this.moveTo(e * this._zr.getWidth(), r * this._zr.getHeight());
    }, t.prototype.hide = function() {
      var e = this, r = this.el.style;
      r.visibility = "hidden", r.opacity = "0", ue.transform3dSupported && (r.willChange = ""), this._show = !1, this._longHideTimeout = setTimeout(function() {
        return e._longHide = !0;
      }, 500);
    }, t.prototype.hideLater = function(e) {
      this._show && !(this._inContent && this._enterable) && !this._alwaysShowContent && (e ? (this._hideDelay = e, this._show = !1, this._hideTimeout = setTimeout(le(this.hide, this), e)) : this.hide());
    }, t.prototype.isShow = function() {
      return this._show;
    }, t.prototype.dispose = function() {
      clearTimeout(this._hideTimeout), clearTimeout(this._longHideTimeout);
      var e = this.el.parentNode;
      e && e.removeChild(this.el), this.el = this._container = null;
    }, t;
  }()
), qve = (
  /** @class */
  function() {
    function t(e) {
      this._show = !1, this._styleCoord = [0, 0, 0, 0], this._alwaysShowContent = !1, this._enterable = !0, this._zr = e.getZr(), U4(this._styleCoord, this._zr, e.getWidth() / 2, e.getHeight() / 2);
    }
    return t.prototype.update = function(e) {
      var r = e.get("alwaysShowContent");
      r && this._moveIfResized(), this._alwaysShowContent = r;
    }, t.prototype.show = function() {
      this._hideTimeout && clearTimeout(this._hideTimeout), this.el.show(), this._show = !0;
    }, t.prototype.setContent = function(e, r, n, a, o) {
      var i = this;
      re(e) && Vt(process.env.NODE_ENV !== "production" ? "Passing DOM nodes as content is not supported in richText tooltip!" : ""), this.el && this._zr.remove(this.el);
      var l = n.getModel("textStyle");
      this.el = new Ye({
        style: {
          rich: r.richTextStyles,
          text: e,
          lineHeight: 22,
          borderWidth: 1,
          borderColor: a,
          textShadowColor: l.get("textShadowColor"),
          fill: n.get(["textStyle", "color"]),
          padding: V_(n, "richText"),
          verticalAlign: "top",
          align: "left"
        },
        z: n.get("z")
      }), I(["backgroundColor", "borderRadius", "shadowColor", "shadowBlur", "shadowOffsetX", "shadowOffsetY"], function(u) {
        i.el.style[u] = n.get(u);
      }), I(["textShadowBlur", "textShadowOffsetX", "textShadowOffsetY"], function(u) {
        i.el.style[u] = l.get(u) || 0;
      }), this._zr.add(this.el);
      var c = this;
      this.el.on("mouseover", function() {
        c._enterable && (clearTimeout(c._hideTimeout), c._show = !0), c._inContent = !0;
      }), this.el.on("mouseout", function() {
        c._enterable && c._show && c.hideLater(c._hideDelay), c._inContent = !1;
      });
    }, t.prototype.setEnterable = function(e) {
      this._enterable = e;
    }, t.prototype.getSize = function() {
      var e = this.el, r = this.el.getBoundingRect(), n = G4(e.style);
      return [r.width + n.left + n.right, r.height + n.top + n.bottom];
    }, t.prototype.moveTo = function(e, r) {
      var n = this.el;
      if (n) {
        var a = this._styleCoord;
        U4(a, this._zr, e, r), e = a[0], r = a[1];
        var o = n.style, i = Vn(o.borderWidth || 0), l = G4(o);
        n.x = e + i + l.left, n.y = r + i + l.top, n.markRedraw();
      }
    }, t.prototype._moveIfResized = function() {
      var e = this._styleCoord[2], r = this._styleCoord[3];
      this.moveTo(e * this._zr.getWidth(), r * this._zr.getHeight());
    }, t.prototype.hide = function() {
      this.el && this.el.hide(), this._show = !1;
    }, t.prototype.hideLater = function(e) {
      this._show && !(this._inContent && this._enterable) && !this._alwaysShowContent && (e ? (this._hideDelay = e, this._show = !1, this._hideTimeout = setTimeout(le(this.hide, this), e)) : this.hide());
    }, t.prototype.isShow = function() {
      return this._show;
    }, t.prototype.dispose = function() {
      this._zr.remove(this.el);
    }, t;
  }()
);
function Vn(t) {
  return Math.max(0, t);
}
function G4(t) {
  var e = Vn(t.shadowBlur || 0), r = Vn(t.shadowOffsetX || 0), n = Vn(t.shadowOffsetY || 0);
  return {
    left: Vn(e - r),
    right: Vn(e + r),
    top: Vn(e - n),
    bottom: Vn(e + n)
  };
}
function U4(t, e, r, n) {
  t[0] = r, t[1] = n, t[2] = t[0] / e.getWidth(), t[3] = t[1] / e.getHeight();
}
var Kve = new He({
  shape: {
    x: -1,
    y: -1,
    width: 2,
    height: 2
  }
}), Qve = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = e.type, r;
    }
    return e.prototype.init = function(r, n) {
      if (!(ue.node || !n.getDom())) {
        var a = r.getComponent("tooltip"), o = this._renderMode = _ce(a.get("renderMode"));
        this._tooltipContent = o === "richText" ? new qve(n) : new Xve(n, {
          appendTo: a.get("appendToBody", !0) ? "body" : a.get("appendTo", !0)
        });
      }
    }, e.prototype.render = function(r, n, a) {
      if (!(ue.node || !a.getDom())) {
        this.group.removeAll(), this._tooltipModel = r, this._ecModel = n, this._api = a;
        var o = this._tooltipContent;
        o.update(r), o.setEnterable(r.get("enterable")), this._initGlobalListener(), this._keepShow(), this._renderMode !== "richText" && r.get("transitionDuration") ? G1(this, "_updatePosition", 50, "fixRate") : uu(this, "_updatePosition");
      }
    }, e.prototype._initGlobalListener = function() {
      var r = this._tooltipModel, n = r.get("triggerOn");
      SC("itemTooltip", this._api, le(function(a, o, i) {
        n !== "none" && (n.indexOf(a) >= 0 ? this._tryShow(o, i) : a === "leave" && this._hide(i));
      }, this));
    }, e.prototype._keepShow = function() {
      var r = this._tooltipModel, n = this._ecModel, a = this._api, o = r.get("triggerOn");
      if (this._lastX != null && this._lastY != null && o !== "none" && o !== "click") {
        var i = this;
        clearTimeout(this._refreshUpdateTimeout), this._refreshUpdateTimeout = setTimeout(function() {
          !a.isDisposed() && i.manuallyShowTip(r, n, a, {
            x: i._lastX,
            y: i._lastY,
            dataByCoordSys: i._lastDataByCoordSys
          });
        });
      }
    }, e.prototype.manuallyShowTip = function(r, n, a, o) {
      if (!(o.from === this.uid || ue.node || !a.getDom())) {
        var i = Y4(o, a);
        this._ticket = "";
        var l = o.dataByCoordSys, c = r7e(o, n, a);
        if (c) {
          var u = c.el.getBoundingRect().clone();
          u.applyTransform(c.el.transform), this._tryShow({
            offsetX: u.x + u.width / 2,
            offsetY: u.y + u.height / 2,
            target: c.el,
            position: o.position,
            // When manully trigger, the mouse is not on the el, so we'd better to
            // position tooltip on the bottom of the el and display arrow is possible.
            positionDefault: "bottom"
          }, i);
        } else if (o.tooltip && o.x != null && o.y != null) {
          var d = Kve;
          d.x = o.x, d.y = o.y, d.update(), Se(d).tooltipConfig = {
            name: null,
            option: o.tooltip
          }, this._tryShow({
            offsetX: o.x,
            offsetY: o.y,
            target: d
          }, i);
        } else if (l)
          this._tryShow({
            offsetX: o.x,
            offsetY: o.y,
            position: o.position,
            dataByCoordSys: l,
            tooltipOption: o.tooltipOption
          }, i);
        else if (o.seriesIndex != null) {
          if (this._manuallyAxisShowTip(r, n, a, o))
            return;
          var f = RC(o, n), h = f.point[0], v = f.point[1];
          h != null && v != null && this._tryShow({
            offsetX: h,
            offsetY: v,
            target: f.el,
            position: o.position,
            // When manully trigger, the mouse is not on the el, so we'd better to
            // position tooltip on the bottom of the el and display arrow is possible.
            positionDefault: "bottom"
          }, i);
        } else o.x != null && o.y != null && (a.dispatchAction({
          type: "updateAxisPointer",
          x: o.x,
          y: o.y
        }), this._tryShow({
          offsetX: o.x,
          offsetY: o.y,
          position: o.position,
          target: a.getZr().findHover(o.x, o.y).target
        }, i));
      }
    }, e.prototype.manuallyHideTip = function(r, n, a, o) {
      var i = this._tooltipContent;
      this._tooltipModel && i.hideLater(this._tooltipModel.get("hideDelay")), this._lastX = this._lastY = this._lastDataByCoordSys = null, o.from !== this.uid && this._hide(Y4(o, a));
    }, e.prototype._manuallyAxisShowTip = function(r, n, a, o) {
      var i = o.seriesIndex, l = o.dataIndex, c = n.getComponent("axisPointer").coordSysAxesInfo;
      if (!(i == null || l == null || c == null)) {
        var u = n.getSeriesByIndex(i);
        if (u) {
          var d = u.getData(), f = gl([d.getItemModel(l), u, (u.coordinateSystem || {}).model], this._tooltipModel);
          if (f.get("trigger") === "axis")
            return a.dispatchAction({
              type: "updateAxisPointer",
              seriesIndex: i,
              dataIndex: l,
              position: o.position
            }), !0;
        }
      }
    }, e.prototype._tryShow = function(r, n) {
      var a = r.target, o = this._tooltipModel;
      if (o) {
        this._lastX = r.offsetX, this._lastY = r.offsetY;
        var i = r.dataByCoordSys;
        if (i && i.length)
          this._showAxisTooltip(i, r);
        else if (a) {
          var l = Se(a);
          if (l.ssrType === "legend")
            return;
          this._lastDataByCoordSys = null;
          var c, u;
          Ll(a, function(d) {
            if (Se(d).dataIndex != null)
              return c = d, !0;
            if (Se(d).tooltipConfig != null)
              return u = d, !0;
          }, !0), c ? this._showSeriesItemTooltip(r, c, n) : u ? this._showComponentItemTooltip(r, u, n) : this._hide(n);
        } else
          this._lastDataByCoordSys = null, this._hide(n);
      }
    }, e.prototype._showOrMove = function(r, n) {
      var a = r.get("showDelay");
      n = le(n, this), clearTimeout(this._showTimout), a > 0 ? this._showTimout = setTimeout(n, a) : n();
    }, e.prototype._showAxisTooltip = function(r, n) {
      var a = this._ecModel, o = this._tooltipModel, i = [n.offsetX, n.offsetY], l = gl([n.tooltipOption], o), c = this._renderMode, u = [], d = so("section", {
        blocks: [],
        noHeader: !0
      }), f = [], h = new Pd();
      I(r, function(y) {
        I(y.dataByAxis, function(b) {
          var _ = a.getComponent(b.axisDim + "Axis", b.axisIndex), x = b.value;
          if (!(!_ || x == null)) {
            var E = CC(x, _.axis, a, b.seriesDataIndices, b.valueLabelOpt), S = so("section", {
              header: E,
              noHeader: !Ir(E),
              sortBlocks: !0,
              blocks: []
            });
            d.blocks.push(S), I(b.seriesDataIndices, function(M) {
              var R = a.getSeriesByIndex(M.seriesIndex), A = M.dataIndexInside, k = R.getDataParams(A);
              if (!(k.dataIndex < 0)) {
                k.axisDim = b.axisDim, k.axisIndex = b.axisIndex, k.axisType = b.axisType, k.axisId = b.axisId, k.axisValue = Y7(_.axis, {
                  value: x
                }), k.axisValueLabel = E, k.marker = h.makeTooltipMarker("item", lo(k.color), c);
                var L = Ym(R.formatTooltip(A, !0, null)), T = L.frag;
                if (T) {
                  var O = gl([R], o).get("valueFormatter");
                  S.blocks.push(O ? H({
                    valueFormatter: O
                  }, T) : T);
                }
                L.text && f.push(L.text), u.push(k);
              }
            });
          }
        });
      }), d.blocks.reverse(), f.reverse();
      var v = n.position, p = l.get("order"), g = Jm(d, h, c, p, a.get("useUTC"), l.get("textStyle"));
      g && f.unshift(g);
      var m = c === "richText" ? `

` : "<br/>", w = f.join(m);
      this._showOrMove(l, function() {
        this._updateContentNotChangedOnAxis(r, u) ? this._updatePosition(l, v, i[0], i[1], this._tooltipContent, u) : this._showTooltipContent(l, w, u, Math.random() + "", i[0], i[1], v, null, h);
      });
    }, e.prototype._showSeriesItemTooltip = function(r, n, a) {
      var o = this._ecModel, i = Se(n), l = i.seriesIndex, c = o.getSeriesByIndex(l), u = i.dataModel || c, d = i.dataIndex, f = i.dataType, h = u.getData(f), v = this._renderMode, p = r.positionDefault, g = gl([h.getItemModel(d), u, c && (c.coordinateSystem || {}).model], this._tooltipModel, p ? {
        position: p
      } : null), m = g.get("trigger");
      if (!(m != null && m !== "item")) {
        var w = u.getDataParams(d, f), y = new Pd();
        w.marker = y.makeTooltipMarker("item", lo(w.color), v);
        var b = Ym(u.formatTooltip(d, !1, f)), _ = g.get("order"), x = g.get("valueFormatter"), E = b.frag, S = E ? Jm(x ? H({
          valueFormatter: x
        }, E) : E, y, v, _, o.get("useUTC"), g.get("textStyle")) : b.text, M = "item_" + u.name + "_" + d;
        this._showOrMove(g, function() {
          this._showTooltipContent(g, S, w, M, r.offsetX, r.offsetY, r.position, r.target, y);
        }), a({
          type: "showTip",
          dataIndexInside: d,
          dataIndex: h.getRawIndex(d),
          seriesIndex: l,
          from: this.uid
        });
      }
    }, e.prototype._showComponentItemTooltip = function(r, n, a) {
      var o = this._renderMode === "html", i = Se(n), l = i.tooltipConfig, c = l.option || {}, u = c.encodeHTMLContent;
      if (Q(c)) {
        var d = c;
        c = {
          content: d,
          // Fixed formatter
          formatter: d
        }, u = !0;
      }
      u && o && c.content && (c = be(c), c.content = Ft(c.content));
      var f = [c], h = this._ecModel.getComponent(i.componentMainType, i.componentIndex);
      h && f.push(h), f.push({
        formatter: c.content
      });
      var v = r.positionDefault, p = gl(f, this._tooltipModel, v ? {
        position: v
      } : null), g = p.get("content"), m = Math.random() + "", w = new Pd();
      this._showOrMove(p, function() {
        var y = be(p.get("formatterParams") || {});
        this._showTooltipContent(p, g, y, m, r.offsetX, r.offsetY, r.position, n, w);
      }), a({
        type: "showTip",
        from: this.uid
      });
    }, e.prototype._showTooltipContent = function(r, n, a, o, i, l, c, u, d) {
      if (this._ticket = "", !(!r.get("showContent") || !r.get("show"))) {
        var f = this._tooltipContent;
        f.setEnterable(r.get("enterable"));
        var h = r.get("formatter");
        c = c || r.get("position");
        var v = n, p = this._getNearestPoint([i, l], a, r.get("trigger"), r.get("borderColor")), g = p.color;
        if (h)
          if (Q(h)) {
            var m = r.ecModel.get("useUTC"), w = z(a) ? a[0] : a, y = w && w.axisType && w.axisType.indexOf("time") >= 0;
            v = h, y && (v = js(w.axisValue, v, m)), v = _7(v, a, !0);
          } else if (ie(h)) {
            var b = le(function(_, x) {
              _ === this._ticket && (f.setContent(x, d, r, g, c), this._updatePosition(r, c, i, l, f, a, u));
            }, this);
            this._ticket = o, v = h(a, o, b);
          } else
            v = h;
        f.setContent(v, d, r, g, c), f.show(r, g), this._updatePosition(r, c, i, l, f, a, u);
      }
    }, e.prototype._getNearestPoint = function(r, n, a, o) {
      if (a === "axis" || z(n))
        return {
          color: o || (this._renderMode === "html" ? "#fff" : "none")
        };
      if (!z(n))
        return {
          color: o || n.color || n.borderColor
        };
    }, e.prototype._updatePosition = function(r, n, a, o, i, l, c) {
      var u = this._api.getWidth(), d = this._api.getHeight();
      n = n || r.get("position");
      var f = i.getSize(), h = r.get("align"), v = r.get("verticalAlign"), p = c && c.getBoundingRect().clone();
      if (c && p.applyTransform(c.transform), ie(n) && (n = n([a, o], l, i.el, p, {
        viewSize: [u, d],
        contentSize: f.slice()
      })), z(n))
        a = fe(n[0], u), o = fe(n[1], d);
      else if (re(n)) {
        var g = n;
        g.width = f[0], g.height = f[1];
        var m = da(g, {
          width: u,
          height: d
        });
        a = m.x, o = m.y, h = null, v = null;
      } else if (Q(n) && c) {
        var w = t7e(n, p, f, r.get("borderWidth"));
        a = w[0], o = w[1];
      } else {
        var w = Jve(a, o, i, u, d, h ? null : 20, v ? null : 20);
        a = w[0], o = w[1];
      }
      if (h && (a -= X4(h) ? f[0] / 2 : h === "right" ? f[0] : 0), v && (o -= X4(v) ? f[1] / 2 : v === "bottom" ? f[1] : 0), TC(r)) {
        var w = e7e(a, o, i, u, d);
        a = w[0], o = w[1];
      }
      i.moveTo(a, o);
    }, e.prototype._updateContentNotChangedOnAxis = function(r, n) {
      var a = this._lastDataByCoordSys, o = this._cbParamsList, i = !!a && a.length === r.length;
      return i && I(a, function(l, c) {
        var u = l.dataByAxis || [], d = r[c] || {}, f = d.dataByAxis || [];
        i = i && u.length === f.length, i && I(u, function(h, v) {
          var p = f[v] || {}, g = h.seriesDataIndices || [], m = p.seriesDataIndices || [];
          i = i && h.value === p.value && h.axisType === p.axisType && h.axisId === p.axisId && g.length === m.length, i && I(g, function(w, y) {
            var b = m[y];
            i = i && w.seriesIndex === b.seriesIndex && w.dataIndex === b.dataIndex;
          }), o && I(h.seriesDataIndices, function(w) {
            var y = w.seriesIndex, b = n[y], _ = o[y];
            b && _ && _.data !== b.data && (i = !1);
          });
        });
      }), this._lastDataByCoordSys = r, this._cbParamsList = n, !!i;
    }, e.prototype._hide = function(r) {
      this._lastDataByCoordSys = null, r({
        type: "hideTip",
        from: this.uid
      });
    }, e.prototype.dispose = function(r, n) {
      ue.node || !n.getDom() || (uu(this, "_updatePosition"), this._tooltipContent.dispose(), p2("itemTooltip", n));
    }, e.type = "tooltip", e;
  }(_t)
);
function gl(t, e, r) {
  var n = e.ecModel, a;
  r ? (a = new Ve(r, n, n), a = new Ve(e.option, a, n)) : a = e;
  for (var o = t.length - 1; o >= 0; o--) {
    var i = t[o];
    i && (i instanceof Ve && (i = i.get("tooltip", !0)), Q(i) && (i = {
      formatter: i
    }), i && (a = new Ve(i, a, n)));
  }
  return a;
}
function Y4(t, e) {
  return t.dispatchAction || le(e.dispatchAction, e);
}
function Jve(t, e, r, n, a, o, i) {
  var l = r.getSize(), c = l[0], u = l[1];
  return o != null && (t + c + o + 2 > n ? t -= c + o : t += o), i != null && (e + u + i > a ? e -= u + i : e += i), [t, e];
}
function e7e(t, e, r, n, a) {
  var o = r.getSize(), i = o[0], l = o[1];
  return t = Math.min(t + i, n) - i, e = Math.min(e + l, a) - l, t = Math.max(t, 0), e = Math.max(e, 0), [t, e];
}
function t7e(t, e, r, n) {
  var a = r[0], o = r[1], i = Math.ceil(Math.SQRT2 * n) + 8, l = 0, c = 0, u = e.width, d = e.height;
  switch (t) {
    case "inside":
      l = e.x + u / 2 - a / 2, c = e.y + d / 2 - o / 2;
      break;
    case "top":
      l = e.x + u / 2 - a / 2, c = e.y - o - i;
      break;
    case "bottom":
      l = e.x + u / 2 - a / 2, c = e.y + d + i;
      break;
    case "left":
      l = e.x - a - i, c = e.y + d / 2 - o / 2;
      break;
    case "right":
      l = e.x + u + i, c = e.y + d / 2 - o / 2;
  }
  return [l, c];
}
function X4(t) {
  return t === "center" || t === "middle";
}
function r7e(t, e, r) {
  var n = Qv(t).queryOptionMap, a = n.keys()[0];
  if (!(!a || a === "series")) {
    var o = Ds(e, a, n.get(a), {
      useDefault: !1,
      enableAll: !1,
      enableNone: !1
    }), i = o.models[0];
    if (i) {
      var l = r.getViewOfComponentModel(i), c;
      if (l.group.traverse(function(u) {
        var d = Se(u).tooltipConfig;
        if (d && d.name === t.name)
          return c = u, !0;
      }), c)
        return {
          componentMainType: a,
          componentIndex: i.componentIndex,
          el: c
        };
    }
  }
}
function a5(t) {
  Gt(MC), t.registerComponentModel($ve), t.registerComponentView(Qve), t.registerAction({
    type: "showTip",
    event: "showTip",
    update: "tooltip:manuallyShowTip"
  }, mt), t.registerAction({
    type: "hideTip",
    event: "hideTip",
    update: "tooltip:manuallyHideTip"
  }, mt);
}
var n7e = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = e.type, r.layoutMode = {
        type: "box",
        ignoreSize: !0
      }, r;
    }
    return e.type = "title", e.defaultOption = {
      // zlevel: 0,
      z: 6,
      show: !0,
      text: "",
      target: "blank",
      subtext: "",
      subtarget: "blank",
      left: 0,
      top: 0,
      backgroundColor: "rgba(0,0,0,0)",
      borderColor: "#ccc",
      borderWidth: 0,
      padding: 5,
      itemGap: 10,
      textStyle: {
        fontSize: 18,
        fontWeight: "bold",
        color: "#464646"
      },
      subtextStyle: {
        fontSize: 12,
        color: "#6E7079"
      }
    }, e;
  }(Ee)
), a7e = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = e.type, r;
    }
    return e.prototype.render = function(r, n, a) {
      if (this.group.removeAll(), !!r.get("show")) {
        var o = this.group, i = r.getModel("textStyle"), l = r.getModel("subtextStyle"), c = r.get("textAlign"), u = de(r.get("textBaseline"), r.get("textVerticalAlign")), d = new Ye({
          style: jt(i, {
            text: r.get("text"),
            fill: i.getTextColor()
          }, {
            disableBox: !0
          }),
          z2: 10
        }), f = d.getBoundingRect(), h = r.get("subtext"), v = new Ye({
          style: jt(l, {
            text: h,
            fill: l.getTextColor(),
            y: f.height + r.get("itemGap"),
            verticalAlign: "top"
          }, {
            disableBox: !0
          }),
          z2: 10
        }), p = r.get("link"), g = r.get("sublink"), m = r.get("triggerEvent", !0);
        d.silent = !p && !m, v.silent = !g && !m, p && d.on("click", function() {
          Lm(p, "_" + r.get("target"));
        }), g && v.on("click", function() {
          Lm(g, "_" + r.get("subtarget"));
        }), Se(d).eventData = Se(v).eventData = m ? {
          componentType: "title",
          componentIndex: r.componentIndex
        } : null, o.add(d), h && o.add(v);
        var w = o.getBoundingRect(), y = r.getBoxLayoutParams();
        y.width = w.width, y.height = w.height;
        var b = da(y, {
          width: a.getWidth(),
          height: a.getHeight()
        }, r.get("padding"));
        c || (c = r.get("left") || r.get("right"), c === "middle" && (c = "center"), c === "right" ? b.x += b.width : c === "center" && (b.x += b.width / 2)), u || (u = r.get("top") || r.get("bottom"), u === "center" && (u = "middle"), u === "bottom" ? b.y += b.height : u === "middle" && (b.y += b.height / 2), u = u || "top"), o.x = b.x, o.y = b.y, o.markRedraw();
        var _ = {
          align: c,
          verticalAlign: u
        };
        d.setStyle(_), v.setStyle(_), w = o.getBoundingRect();
        var x = b.margin, E = r.getItemStyle(["color", "opacity"]);
        E.fill = r.get("backgroundColor");
        var S = new He({
          shape: {
            x: w.x - x[3],
            y: w.y - x[0],
            width: w.width + x[1] + x[3],
            height: w.height + x[0] + x[2],
            r: r.get("borderRadius")
          },
          style: E,
          subPixelOptimize: !0,
          silent: !0
        });
        o.add(S);
      }
    }, e.type = "title", e;
  }(_t)
);
function o5(t) {
  t.registerComponentModel(n7e), t.registerComponentView(a7e);
}
function o7e(t, e) {
  if (!t)
    return !1;
  for (var r = z(t) ? t : [t], n = 0; n < r.length; n++)
    if (r[n] && r[n][e])
      return !0;
  return !1;
}
function zc(t) {
  J0(t, "label", ["show"]);
}
var Gc = je(), vs = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = e.type, r.createdBySelf = !1, r;
    }
    return e.prototype.init = function(r, n, a) {
      if (process.env.NODE_ENV !== "production" && this.type === "marker")
        throw new Error("Marker component is abstract component. Use markLine, markPoint, markArea instead.");
      this.mergeDefaultAndTheme(r, a), this._mergeOption(r, a, !1, !0);
    }, e.prototype.isAnimationEnabled = function() {
      if (ue.node)
        return !1;
      var r = this.__hostSeries;
      return this.getShallow("animation") && r && r.isAnimationEnabled();
    }, e.prototype.mergeOption = function(r, n) {
      this._mergeOption(r, n, !1, !1);
    }, e.prototype._mergeOption = function(r, n, a, o) {
      var i = this.mainType;
      a || n.eachSeries(function(l) {
        var c = l.get(this.mainType, !0), u = Gc(l)[i];
        if (!c || !c.data) {
          Gc(l)[i] = null;
          return;
        }
        u ? u._mergeOption(c, n, !0) : (o && zc(c), I(c.data, function(d) {
          d instanceof Array ? (zc(d[0]), zc(d[1])) : zc(d);
        }), u = this.createMarkerModelFromSeries(c, this, n), H(u, {
          mainType: this.mainType,
          // Use the same series index and name
          seriesIndex: l.seriesIndex,
          name: l.name,
          createdBySelf: !0
        }), u.__hostSeries = l), Gc(l)[i] = u;
      }, this);
    }, e.prototype.formatTooltip = function(r, n, a) {
      var o = this.getData(), i = this.getRawValue(r), l = o.getName(r);
      return so("section", {
        header: this.name,
        blocks: [so("nameValue", {
          name: l,
          value: i,
          noName: !l,
          noValue: i == null
        })]
      });
    }, e.prototype.getData = function() {
      return this._data;
    }, e.prototype.setData = function(r) {
      this._data = r;
    }, e.prototype.getDataParams = function(r, n) {
      var a = A7.prototype.getDataParams.call(this, r, n), o = this.__hostSeries;
      return o && (a.seriesId = o.id, a.seriesName = o.name, a.seriesType = o.subType), a;
    }, e.getMarkerModelFromSeries = function(r, n) {
      return Gc(r)[n];
    }, e.type = "marker", e.dependencies = ["series", "grid", "polar", "geo"], e;
  }(Ee)
);
tr(vs, A7.prototype);
function i7e(t) {
  return !(isNaN(parseFloat(t.x)) && isNaN(parseFloat(t.y)));
}
function l7e(t) {
  return !isNaN(parseFloat(t.x)) && !isNaN(parseFloat(t.y));
}
function Uc(t, e, r, n, a, o) {
  var i = [], l = fa(
    e,
    n
    /* , otherDataDim */
  ), c = l ? e.getCalculationInfo("stackResultDimension") : n, u = tp(e, c, t), d = e.indicesOfNearest(c, u)[0];
  i[a] = e.get(r, d), i[o] = e.get(c, d);
  var f = e.get(n, d), h = Pr(e.get(n, d));
  return h = Math.min(h, 20), h >= 0 && (i[o] = +i[o].toFixed(h)), [i, f];
}
var pf = {
  min: Oe(Uc, "min"),
  max: Oe(Uc, "max"),
  average: Oe(Uc, "average"),
  median: Oe(Uc, "median")
};
function q4(t, e) {
  if (e) {
    var r = t.getData(), n = t.coordinateSystem, a = n && n.dimensions;
    if (!l7e(e) && !z(e.coord) && z(a)) {
      var o = DC(e, r, n, t);
      if (e = be(e), e.type && pf[e.type] && o.baseAxis && o.valueAxis) {
        var i = Re(a, o.baseAxis.dim), l = Re(a, o.valueAxis.dim), c = pf[e.type](r, o.baseDataDim, o.valueDataDim, i, l);
        e.coord = c[0], e.value = c[1];
      } else
        e.coord = [e.xAxis != null ? e.xAxis : e.radiusAxis, e.yAxis != null ? e.yAxis : e.angleAxis];
    }
    if (e.coord == null || !z(a))
      e.coord = [];
    else
      for (var u = e.coord, d = 0; d < 2; d++)
        pf[u[d]] && (u[d] = tp(r, r.mapDimension(a[d]), u[d]));
    return e;
  }
}
function DC(t, e, r, n) {
  var a = {};
  return t.valueIndex != null || t.valueDim != null ? (a.valueDataDim = t.valueIndex != null ? e.getDimension(t.valueIndex) : t.valueDim, a.valueAxis = r.getAxis(s7e(n, a.valueDataDim)), a.baseAxis = r.getOtherAxis(a.valueAxis), a.baseDataDim = e.mapDimension(a.baseAxis.dim)) : (a.baseAxis = n.getBaseAxis(), a.valueAxis = r.getOtherAxis(a.baseAxis), a.baseDataDim = e.mapDimension(a.baseAxis.dim), a.valueDataDim = e.mapDimension(a.valueAxis.dim)), a;
}
function s7e(t, e) {
  var r = t.getData().getDimensionInfo(e);
  return r && r.coordDim;
}
function K4(t, e) {
  return t && t.containData && e.coord && !i7e(e) ? t.containData(e.coord) : !0;
}
function c7e(t, e) {
  return t ? function(r, n, a, o) {
    var i = o < 2 ? r.coord && r.coord[o] : r.value;
    return di(i, e[o]);
  } : function(r, n, a, o) {
    return di(r.value, e[o]);
  };
}
function tp(t, e, r) {
  if (r === "average") {
    var n = 0, a = 0;
    return t.each(e, function(o, i) {
      isNaN(o) || (n += o, a++);
    }), n / a;
  } else return r === "median" ? t.getMedian(e) : t.getDataExtent(e)[r === "max" ? 1 : 0];
}
var gf = je(), u7e = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = e.type, r;
    }
    return e.prototype.init = function() {
      this.markerGroupMap = se();
    }, e.prototype.render = function(r, n, a) {
      var o = this, i = this.markerGroupMap;
      i.each(function(l) {
        gf(l).keep = !1;
      }), n.eachSeries(function(l) {
        var c = vs.getMarkerModelFromSeries(l, o.type);
        c && o.renderSeries(l, c, n, a);
      }), i.each(function(l) {
        !gf(l).keep && o.group.remove(l.group);
      });
    }, e.prototype.markKeep = function(r) {
      gf(r).keep = !0;
    }, e.prototype.toggleBlurSeries = function(r, n) {
      var a = this;
      I(r, function(o) {
        var i = vs.getMarkerModelFromSeries(o, a.type);
        if (i) {
          var l = i.getData();
          l.eachItemGraphicEl(function(c) {
            c && (n ? O9(c) : a7(c));
          });
        }
      });
    }, e.type = "marker", e;
  }(_t)
), d7e = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = e.type, r;
    }
    return e.prototype.createMarkerModelFromSeries = function(r, n, a) {
      return new e(r, n, a);
    }, e.type = "markLine", e.defaultOption = {
      // zlevel: 0,
      z: 5,
      symbol: ["circle", "arrow"],
      symbolSize: [8, 16],
      // symbolRotate: 0,
      symbolOffset: 0,
      precision: 2,
      tooltip: {
        trigger: "item"
      },
      label: {
        show: !0,
        position: "end",
        distance: 5
      },
      lineStyle: {
        type: "dashed"
      },
      emphasis: {
        label: {
          show: !0
        },
        lineStyle: {
          width: 3
        }
      },
      animationEasing: "linear"
    }, e;
  }(vs)
), Yc = je(), f7e = function(t, e, r, n) {
  var a = t.getData(), o;
  if (z(n))
    o = n;
  else {
    var i = n.type;
    if (i === "min" || i === "max" || i === "average" || i === "median" || n.xAxis != null || n.yAxis != null) {
      var l = void 0, c = void 0;
      if (n.yAxis != null || n.xAxis != null)
        l = e.getAxis(n.yAxis != null ? "y" : "x"), c = Cn(n.yAxis, n.xAxis);
      else {
        var u = DC(n, a, e, t);
        l = u.valueAxis;
        var d = j7(a, u.valueDataDim);
        c = tp(a, d, i);
      }
      var f = l.dim === "x" ? 0 : 1, h = 1 - f, v = be(n), p = {
        coord: []
      };
      v.type = null, v.coord = [], v.coord[h] = -1 / 0, p.coord[h] = 1 / 0;
      var g = r.get("precision");
      g >= 0 && De(c) && (c = +c.toFixed(Math.min(g, 20))), v.coord[f] = p.coord[f] = c, o = [v, p, {
        type: i,
        valueIndex: n.valueIndex,
        // Force to use the value of calculated value.
        value: c
      }];
    } else
      process.env.NODE_ENV !== "production" && mn("Invalid markLine data."), o = [];
  }
  var m = [q4(t, o[0]), q4(t, o[1]), H({}, o[2])];
  return m[2].type = m[2].type || null, Ce(m[2], m[0]), Ce(m[2], m[1]), m;
};
function Cu(t) {
  return !isNaN(t) && !isFinite(t);
}
function Q4(t, e, r, n) {
  var a = 1 - t, o = n.dimensions[t];
  return Cu(e[a]) && Cu(r[a]) && e[t] === r[t] && n.getAxis(o).containData(e[t]);
}
function h7e(t, e) {
  if (t.type === "cartesian2d") {
    var r = e[0].coord, n = e[1].coord;
    if (r && n && (Q4(1, r, n, t) || Q4(0, r, n, t)))
      return !0;
  }
  return K4(t, e[0]) && K4(t, e[1]);
}
function mf(t, e, r, n, a) {
  var o = n.coordinateSystem, i = t.getItemModel(e), l, c = fe(i.get("x"), a.getWidth()), u = fe(i.get("y"), a.getHeight());
  if (!isNaN(c) && !isNaN(u))
    l = [c, u];
  else {
    if (n.getMarkerPosition)
      l = n.getMarkerPosition(t.getValues(t.dimensions, e));
    else {
      var d = o.dimensions, f = t.get(d[0], e), h = t.get(d[1], e);
      l = o.dataToPoint([f, h]);
    }
    if (t5(o, "cartesian2d")) {
      var v = o.getAxis("x"), p = o.getAxis("y"), d = o.dimensions;
      Cu(t.get(d[0], e)) ? l[0] = v.toGlobalCoord(v.getExtent()[r ? 0 : 1]) : Cu(t.get(d[1], e)) && (l[1] = p.toGlobalCoord(p.getExtent()[r ? 0 : 1]));
    }
    isNaN(c) || (l[0] = c), isNaN(u) || (l[1] = u);
  }
  t.setItemLayout(e, l);
}
var v7e = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = e.type, r;
    }
    return e.prototype.updateTransform = function(r, n, a) {
      n.eachSeries(function(o) {
        var i = vs.getMarkerModelFromSeries(o, "markLine");
        if (i) {
          var l = i.getData(), c = Yc(i).from, u = Yc(i).to;
          c.each(function(d) {
            mf(c, d, !0, o, a), mf(u, d, !1, o, a);
          }), l.each(function(d) {
            l.setItemLayout(d, [c.getItemLayout(d), u.getItemLayout(d)]);
          }), this.markerGroupMap.get(o.id).updateLayout();
        }
      }, this);
    }, e.prototype.renderSeries = function(r, n, a, o) {
      var i = r.coordinateSystem, l = r.id, c = r.getData(), u = this.markerGroupMap, d = u.get(l) || u.set(l, new J2e());
      this.group.add(d.group);
      var f = p7e(i, r, n), h = f.from, v = f.to, p = f.line;
      Yc(n).from = h, Yc(n).to = v, n.setData(p);
      var g = n.get("symbol"), m = n.get("symbolSize"), w = n.get("symbolRotate"), y = n.get("symbolOffset");
      z(g) || (g = [g, g]), z(m) || (m = [m, m]), z(w) || (w = [w, w]), z(y) || (y = [y, y]), f.from.each(function(_) {
        b(h, _, !0), b(v, _, !1);
      }), p.each(function(_) {
        var x = p.getItemModel(_).getModel("lineStyle").getLineStyle();
        p.setItemLayout(_, [h.getItemLayout(_), v.getItemLayout(_)]), x.stroke == null && (x.stroke = h.getItemVisual(_, "style").fill), p.setItemVisual(_, {
          fromSymbolKeepAspect: h.getItemVisual(_, "symbolKeepAspect"),
          fromSymbolOffset: h.getItemVisual(_, "symbolOffset"),
          fromSymbolRotate: h.getItemVisual(_, "symbolRotate"),
          fromSymbolSize: h.getItemVisual(_, "symbolSize"),
          fromSymbol: h.getItemVisual(_, "symbol"),
          toSymbolKeepAspect: v.getItemVisual(_, "symbolKeepAspect"),
          toSymbolOffset: v.getItemVisual(_, "symbolOffset"),
          toSymbolRotate: v.getItemVisual(_, "symbolRotate"),
          toSymbolSize: v.getItemVisual(_, "symbolSize"),
          toSymbol: v.getItemVisual(_, "symbol"),
          style: x
        });
      }), d.updateData(p), f.line.eachItemGraphicEl(function(_) {
        Se(_).dataModel = n, _.traverse(function(x) {
          Se(x).dataModel = n;
        });
      });
      function b(_, x, E) {
        var S = _.getItemModel(x);
        mf(_, x, E, r, o);
        var M = S.getModel("itemStyle").getItemStyle();
        M.fill == null && (M.fill = X_(c, "color")), _.setItemVisual(x, {
          symbolKeepAspect: S.get("symbolKeepAspect"),
          // `0` should be considered as a valid value, so use `retrieve2` instead of `||`
          symbolOffset: de(S.get("symbolOffset", !0), y[E ? 0 : 1]),
          symbolRotate: de(S.get("symbolRotate", !0), w[E ? 0 : 1]),
          // TODO: when 2d array is supported, it should ignore parent
          symbolSize: de(S.get("symbolSize"), m[E ? 0 : 1]),
          symbol: de(S.get("symbol", !0), g[E ? 0 : 1]),
          style: M
        });
      }
      this.markKeep(d), d.group.silent = n.get("silent") || r.get("silent");
    }, e.type = "markLine", e;
  }(u7e)
);
function p7e(t, e, r) {
  var n;
  t ? n = J(t && t.dimensions, function(u) {
    var d = e.getData().getDimensionInfo(e.getData().mapDimension(u)) || {};
    return H(H({}, d), {
      name: u,
      // DON'T use ordinalMeta to parse and collect ordinal.
      ordinalMeta: null
    });
  }) : n = [{
    name: "value",
    type: "float"
  }];
  var a = new fi(n, r), o = new fi(n, r), i = new fi([], r), l = J(r.get("data"), Oe(f7e, e, t, r));
  t && (l = ot(l, Oe(h7e, t)));
  var c = c7e(!!t, n);
  return a.initData(J(l, function(u) {
    return u[0];
  }), null, c), o.initData(J(l, function(u) {
    return u[1];
  }), null, c), i.initData(J(l, function(u) {
    return u[2];
  })), i.hasItemOption = !0, {
    from: a,
    to: o,
    line: i
  };
}
function NC(t) {
  t.registerComponentModel(d7e), t.registerComponentView(v7e), t.registerPreprocessor(function(e) {
    o7e(e.series, "markLine") && (e.markLine = e.markLine || {});
  });
}
var g7e = function(t, e) {
  if (e === "all")
    return {
      type: "all",
      title: t.getLocaleModel().get(["legend", "selector", "all"])
    };
  if (e === "inverse")
    return {
      type: "inverse",
      title: t.getLocaleModel().get(["legend", "selector", "inverse"])
    };
}, g2 = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = e.type, r.layoutMode = {
        type: "box",
        // legend.width/height are maxWidth/maxHeight actually,
        // whereas real width/height is calculated by its content.
        // (Setting {left: 10, right: 10} does not make sense).
        // So consider the case:
        // `setOption({legend: {left: 10});`
        // then `setOption({legend: {right: 10});`
        // The previous `left` should be cleared by setting `ignoreSize`.
        ignoreSize: !0
      }, r;
    }
    return e.prototype.init = function(r, n, a) {
      this.mergeDefaultAndTheme(r, a), r.selected = r.selected || {}, this._updateSelector(r);
    }, e.prototype.mergeOption = function(r, n) {
      t.prototype.mergeOption.call(this, r, n), this._updateSelector(r);
    }, e.prototype._updateSelector = function(r) {
      var n = r.selector, a = this.ecModel;
      n === !0 && (n = r.selector = ["all", "inverse"]), z(n) && I(n, function(o, i) {
        Q(o) && (o = {
          type: o
        }), n[i] = Ce(o, g7e(a, o.type));
      });
    }, e.prototype.optionUpdated = function() {
      this._updateData(this.ecModel);
      var r = this._data;
      if (r[0] && this.get("selectedMode") === "single") {
        for (var n = !1, a = 0; a < r.length; a++) {
          var o = r[a].get("name");
          if (this.isSelected(o)) {
            this.select(o), n = !0;
            break;
          }
        }
        !n && this.select(r[0].get("name"));
      }
    }, e.prototype._updateData = function(r) {
      var n = [], a = [];
      r.eachRawSeries(function(c) {
        var u = c.name;
        a.push(u);
        var d;
        if (c.legendVisualProvider) {
          var f = c.legendVisualProvider, h = f.getAllNames();
          r.isSeriesFiltered(c) || (a = a.concat(h)), h.length ? n = n.concat(h) : d = !0;
        } else
          d = !0;
        d && Kv(c) && n.push(c.name);
      }), this._availableNames = a;
      var o = this.get("data") || n, i = se(), l = J(o, function(c) {
        return (Q(c) || De(c)) && (c = {
          name: c
        }), i.get(c.name) ? null : (i.set(c.name, !0), new Ve(c, this, this.ecModel));
      }, this);
      this._data = ot(l, function(c) {
        return !!c;
      });
    }, e.prototype.getData = function() {
      return this._data;
    }, e.prototype.select = function(r) {
      var n = this.option.selected, a = this.get("selectedMode");
      if (a === "single") {
        var o = this._data;
        I(o, function(i) {
          n[i.get("name")] = !1;
        });
      }
      n[r] = !0;
    }, e.prototype.unSelect = function(r) {
      this.get("selectedMode") !== "single" && (this.option.selected[r] = !1);
    }, e.prototype.toggleSelected = function(r) {
      var n = this.option.selected;
      n.hasOwnProperty(r) || (n[r] = !0), this[n[r] ? "unSelect" : "select"](r);
    }, e.prototype.allSelect = function() {
      var r = this._data, n = this.option.selected;
      I(r, function(a) {
        n[a.get("name", !0)] = !0;
      });
    }, e.prototype.inverseSelect = function() {
      var r = this._data, n = this.option.selected;
      I(r, function(a) {
        var o = a.get("name", !0);
        n.hasOwnProperty(o) || (n[o] = !0), n[o] = !n[o];
      });
    }, e.prototype.isSelected = function(r) {
      var n = this.option.selected;
      return !(n.hasOwnProperty(r) && !n[r]) && Re(this._availableNames, r) >= 0;
    }, e.prototype.getOrient = function() {
      return this.get("orient") === "vertical" ? {
        index: 1,
        name: "vertical"
      } : {
        index: 0,
        name: "horizontal"
      };
    }, e.type = "legend.plain", e.dependencies = ["series"], e.defaultOption = {
      // zlevel: 0,
      z: 4,
      show: !0,
      orient: "horizontal",
      left: "center",
      // right: 'center',
      top: 0,
      // bottom: null,
      align: "auto",
      backgroundColor: "rgba(0,0,0,0)",
      borderColor: "#ccc",
      borderRadius: 0,
      borderWidth: 0,
      padding: 5,
      itemGap: 10,
      itemWidth: 25,
      itemHeight: 14,
      symbolRotate: "inherit",
      symbolKeepAspect: !0,
      inactiveColor: "#ccc",
      inactiveBorderColor: "#ccc",
      inactiveBorderWidth: "auto",
      itemStyle: {
        color: "inherit",
        opacity: "inherit",
        borderColor: "inherit",
        borderWidth: "auto",
        borderCap: "inherit",
        borderJoin: "inherit",
        borderDashOffset: "inherit",
        borderMiterLimit: "inherit"
      },
      lineStyle: {
        width: "auto",
        color: "inherit",
        inactiveColor: "#ccc",
        inactiveWidth: 2,
        opacity: "inherit",
        type: "inherit",
        cap: "inherit",
        join: "inherit",
        dashOffset: "inherit",
        miterLimit: "inherit"
      },
      textStyle: {
        color: "#333"
      },
      selectedMode: !0,
      selector: !1,
      selectorLabel: {
        show: !0,
        borderRadius: 10,
        padding: [3, 5, 3, 5],
        fontSize: 12,
        fontFamily: "sans-serif",
        color: "#666",
        borderWidth: 1,
        borderColor: "#666"
      },
      emphasis: {
        selectorLabel: {
          show: !0,
          color: "#eee",
          backgroundColor: "#666"
        }
      },
      selectorPosition: "auto",
      selectorItemGap: 7,
      selectorButtonGap: 10,
      tooltip: {
        show: !1
      }
    }, e;
  }(Ee)
), Wo = Oe, m2 = I, Xc = Xe, BC = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = e.type, r.newlineDisabled = !1, r;
    }
    return e.prototype.init = function() {
      this.group.add(this._contentGroup = new Xc()), this.group.add(this._selectorGroup = new Xc()), this._isFirstRender = !0;
    }, e.prototype.getContentGroup = function() {
      return this._contentGroup;
    }, e.prototype.getSelectorGroup = function() {
      return this._selectorGroup;
    }, e.prototype.render = function(r, n, a) {
      var o = this._isFirstRender;
      if (this._isFirstRender = !1, this.resetInner(), !!r.get("show", !0)) {
        var i = r.get("align"), l = r.get("orient");
        (!i || i === "auto") && (i = r.get("left") === "right" && l === "vertical" ? "right" : "left");
        var c = r.get("selector", !0), u = r.get("selectorPosition", !0);
        c && (!u || u === "auto") && (u = l === "horizontal" ? "end" : "start"), this.renderInner(i, r, n, a, c, l, u);
        var d = r.getBoxLayoutParams(), f = {
          width: a.getWidth(),
          height: a.getHeight()
        }, h = r.get("padding"), v = da(d, f, h), p = this.layoutInner(r, i, v, o, c, u), g = da(Te({
          width: p.width,
          height: p.height
        }, d), f, h);
        this.group.x = g.x - p.x, this.group.y = g.y - p.y, this.group.markRedraw(), this.group.add(this._backgroundEl = Fve(p, r));
      }
    }, e.prototype.resetInner = function() {
      this.getContentGroup().removeAll(), this._backgroundEl && this.group.remove(this._backgroundEl), this.getSelectorGroup().removeAll();
    }, e.prototype.renderInner = function(r, n, a, o, i, l, c) {
      var u = this.getContentGroup(), d = se(), f = n.get("selectedMode"), h = [];
      a.eachRawSeries(function(v) {
        !v.get("legendHoverLink") && h.push(v.id);
      }), m2(n.getData(), function(v, p) {
        var g = v.get("name");
        if (!this.newlineDisabled && (g === "" || g === `
`)) {
          var m = new Xc();
          m.newline = !0, u.add(m);
          return;
        }
        var w = a.getSeriesByName(g)[0];
        if (!d.get(g)) {
          if (w) {
            var y = w.getData(), b = y.getVisual("legendLineStyle") || {}, _ = y.getVisual("legendIcon"), x = y.getVisual("style"), E = this._createItem(w, g, p, v, n, r, b, x, _, f, o);
            E.on("click", Wo(J4, g, null, o, h)).on("mouseover", Wo(w2, w.name, null, o, h)).on("mouseout", Wo(y2, w.name, null, o, h)), a.ssr && E.eachChild(function(S) {
              var M = Se(S);
              M.seriesIndex = w.seriesIndex, M.dataIndex = p, M.ssrType = "legend";
            }), d.set(g, !0);
          } else
            a.eachRawSeries(function(S) {
              if (!d.get(g) && S.legendVisualProvider) {
                var M = S.legendVisualProvider;
                if (!M.containName(g))
                  return;
                var R = M.indexOfName(g), A = M.getItemVisual(R, "style"), k = M.getItemVisual(R, "legendIcon"), L = Jt(A.fill);
                L && L[3] === 0 && (L[3] = 0.2, A = H(H({}, A), {
                  fill: ga(L, "rgba")
                }));
                var T = this._createItem(S, g, p, v, n, r, {}, A, k, f, o);
                T.on("click", Wo(J4, null, g, o, h)).on("mouseover", Wo(w2, null, g, o, h)).on("mouseout", Wo(y2, null, g, o, h)), a.ssr && T.eachChild(function(O) {
                  var D = Se(O);
                  D.seriesIndex = S.seriesIndex, D.dataIndex = p, D.ssrType = "legend";
                }), d.set(g, !0);
              }
            }, this);
          process.env.NODE_ENV !== "production" && (d.get(g) || console.warn(g + " series not exists. Legend data should be same with series name or data name."));
        }
      }, this), i && this._createSelector(i, n, o, l, c);
    }, e.prototype._createSelector = function(r, n, a, o, i) {
      var l = this.getSelectorGroup();
      m2(r, function(u) {
        var d = u.type, f = new Ye({
          style: {
            x: 0,
            y: 0,
            align: "center",
            verticalAlign: "middle"
          },
          onclick: function() {
            a.dispatchAction({
              type: d === "all" ? "legendAllSelect" : "legendInverseSelect"
            });
          }
        });
        l.add(f);
        var h = n.getModel("selectorLabel"), v = n.getModel(["emphasis", "selectorLabel"]);
        Wi(f, {
          normal: h,
          emphasis: v
        }, {
          defaultText: u.title
        }), as(f);
      });
    }, e.prototype._createItem = function(r, n, a, o, i, l, c, u, d, f, h) {
      var v = r.visualDrawType, p = i.get("itemWidth"), g = i.get("itemHeight"), m = i.isSelected(n), w = o.get("symbolRotate"), y = o.get("symbolKeepAspect"), b = o.get("icon");
      d = b || d || "roundRect";
      var _ = m7e(d, o, c, u, v, m, h), x = new Xc(), E = o.getModel("textStyle");
      if (ie(r.getLegendIcon) && (!b || b === "inherit"))
        x.add(r.getLegendIcon({
          itemWidth: p,
          itemHeight: g,
          icon: d,
          iconRotate: w,
          itemStyle: _.itemStyle,
          lineStyle: _.lineStyle,
          symbolKeepAspect: y
        }));
      else {
        var S = b === "inherit" && r.getData().getVisual("symbol") ? w === "inherit" ? r.getData().getVisual("symbolRotate") : w : 0;
        x.add(w7e({
          itemWidth: p,
          itemHeight: g,
          icon: d,
          iconRotate: S,
          itemStyle: _.itemStyle,
          lineStyle: _.lineStyle,
          symbolKeepAspect: y
        }));
      }
      var M = l === "left" ? p + 5 : -5, R = l, A = i.get("formatter"), k = n;
      Q(A) && A ? k = A.replace("{name}", n ?? "") : ie(A) && (k = A(n));
      var L = m ? E.getTextColor() : o.get("inactiveColor");
      x.add(new Ye({
        style: jt(E, {
          text: k,
          x: M,
          y: g / 2,
          fill: L,
          align: R,
          verticalAlign: "middle"
        }, {
          inheritColor: L
        })
      }));
      var T = new He({
        shape: x.getBoundingRect(),
        style: {
          // Cannot use 'invisible' because SVG SSR will miss the node
          fill: "transparent"
        }
      }), O = o.getModel("tooltip");
      return O.get("show") && f7({
        el: T,
        componentModel: i,
        itemName: n,
        itemTooltipOption: O.option
      }), x.add(T), x.eachChild(function(D) {
        D.silent = !0;
      }), T.silent = !f, this.getContentGroup().add(x), as(x), x.__legendDataIndex = a, x;
    }, e.prototype.layoutInner = function(r, n, a, o, i, l) {
      var c = this.getContentGroup(), u = this.getSelectorGroup();
      Vl(r.get("orient"), c, r.get("itemGap"), a.width, a.height);
      var d = c.getBoundingRect(), f = [-d.x, -d.y];
      if (u.markRedraw(), c.markRedraw(), i) {
        Vl(
          // Buttons in selectorGroup always layout horizontally
          "horizontal",
          u,
          r.get("selectorItemGap", !0)
        );
        var h = u.getBoundingRect(), v = [-h.x, -h.y], p = r.get("selectorButtonGap", !0), g = r.getOrient().index, m = g === 0 ? "width" : "height", w = g === 0 ? "height" : "width", y = g === 0 ? "y" : "x";
        l === "end" ? v[g] += d[m] + p : f[g] += h[m] + p, v[1 - g] += d[w] / 2 - h[w] / 2, u.x = v[0], u.y = v[1], c.x = f[0], c.y = f[1];
        var b = {
          x: 0,
          y: 0
        };
        return b[m] = d[m] + p + h[m], b[w] = Math.max(d[w], h[w]), b[y] = Math.min(0, h[y] + v[1 - g]), b;
      } else
        return c.x = f[0], c.y = f[1], this.group.getBoundingRect();
    }, e.prototype.remove = function() {
      this.getContentGroup().removeAll(), this._isFirstRender = !0;
    }, e.type = "legend.plain", e;
  }(_t)
);
function m7e(t, e, r, n, a, o, i) {
  function l(m, w) {
    m.lineWidth === "auto" && (m.lineWidth = w.lineWidth > 0 ? 2 : 0), m2(m, function(y, b) {
      m[b] === "inherit" && (m[b] = w[b]);
    });
  }
  var c = e.getModel("itemStyle"), u = c.getItemStyle(), d = t.lastIndexOf("empty", 0) === 0 ? "fill" : "stroke", f = c.getShallow("decal");
  u.decal = !f || f === "inherit" ? n.decal : e2(f, i), u.fill === "inherit" && (u.fill = n[a]), u.stroke === "inherit" && (u.stroke = n[d]), u.opacity === "inherit" && (u.opacity = (a === "fill" ? n : r).opacity), l(u, n);
  var h = e.getModel("lineStyle"), v = h.getLineStyle();
  if (l(v, r), u.fill === "auto" && (u.fill = n.fill), u.stroke === "auto" && (u.stroke = n.fill), v.stroke === "auto" && (v.stroke = n.fill), !o) {
    var p = e.get("inactiveBorderWidth"), g = u[d];
    u.lineWidth = p === "auto" ? n.lineWidth > 0 && g ? 2 : 0 : u.lineWidth, u.fill = e.get("inactiveColor"), u.stroke = e.get("inactiveBorderColor"), v.stroke = h.get("inactiveColor"), v.lineWidth = h.get("inactiveWidth");
  }
  return {
    itemStyle: u,
    lineStyle: v
  };
}
function w7e(t) {
  var e = t.icon || "roundRect", r = _r(e, 0, 0, t.itemWidth, t.itemHeight, t.itemStyle.fill, t.symbolKeepAspect);
  return r.setStyle(t.itemStyle), r.rotation = (t.iconRotate || 0) * Math.PI / 180, r.setOrigin([t.itemWidth / 2, t.itemHeight / 2]), e.indexOf("empty") > -1 && (r.style.stroke = r.style.fill, r.style.fill = "#fff", r.style.lineWidth = 2), r;
}
function J4(t, e, r, n) {
  y2(t, e, r, n), r.dispatchAction({
    type: "legendToggleSelect",
    name: t ?? e
  }), w2(t, e, r, n);
}
function FC(t) {
  for (var e = t.getZr().storage.getDisplayList(), r, n = 0, a = e.length; n < a && !(r = e[n].states.emphasis); )
    n++;
  return r && r.hoverLayer;
}
function w2(t, e, r, n) {
  FC(r) || r.dispatchAction({
    type: "highlight",
    seriesName: t,
    name: e,
    excludeSeriesId: n
  });
}
function y2(t, e, r, n) {
  FC(r) || r.dispatchAction({
    type: "downplay",
    seriesName: t,
    name: e,
    excludeSeriesId: n
  });
}
function y7e(t) {
  var e = t.findComponents({
    mainType: "legend"
  });
  e && e.length && t.filterSeries(function(r) {
    for (var n = 0; n < e.length; n++)
      if (!e[n].isSelected(r.name))
        return !1;
    return !0;
  });
}
function ml(t, e, r) {
  var n = {}, a = t === "toggleSelected", o;
  return r.eachComponent("legend", function(i) {
    a && o != null ? i[o ? "select" : "unSelect"](e.name) : t === "allSelect" || t === "inverseSelect" ? i[t]() : (i[t](e.name), o = i.isSelected(e.name));
    var l = i.getData();
    I(l, function(c) {
      var u = c.get("name");
      if (!(u === `
` || u === "")) {
        var d = i.isSelected(u);
        n.hasOwnProperty(u) ? n[u] = n[u] && d : n[u] = d;
      }
    });
  }), t === "allSelect" || t === "inverseSelect" ? {
    selected: n
  } : {
    name: e.name,
    selected: n
  };
}
function b7e(t) {
  t.registerAction("legendToggleSelect", "legendselectchanged", Oe(ml, "toggleSelected")), t.registerAction("legendAllSelect", "legendselectall", Oe(ml, "allSelect")), t.registerAction("legendInverseSelect", "legendinverseselect", Oe(ml, "inverseSelect")), t.registerAction("legendSelect", "legendselected", Oe(ml, "select")), t.registerAction("legendUnSelect", "legendunselected", Oe(ml, "unSelect"));
}
function $C(t) {
  t.registerComponentModel(g2), t.registerComponentView(BC), t.registerProcessor(t.PRIORITY.PROCESSOR.SERIES_FILTER, y7e), t.registerSubTypeDefaulter("legend", function() {
    return "plain";
  }), b7e(t);
}
var _7e = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = e.type, r;
    }
    return e.prototype.setScrollDataIndex = function(r) {
      this.option.scrollDataIndex = r;
    }, e.prototype.init = function(r, n, a) {
      var o = zs(r);
      t.prototype.init.call(this, r, n, a), ew(this, r, o);
    }, e.prototype.mergeOption = function(r, n) {
      t.prototype.mergeOption.call(this, r, n), ew(this, this.option, r);
    }, e.type = "legend.scroll", e.defaultOption = B1(g2.defaultOption, {
      scrollDataIndex: 0,
      pageButtonItemGap: 5,
      pageButtonGap: null,
      pageButtonPosition: "end",
      pageFormatter: "{current}/{total}",
      pageIcons: {
        horizontal: ["M0,0L12,-10L12,10z", "M0,0L-12,-10L-12,10z"],
        vertical: ["M0,0L20,0L10,-20z", "M0,0L20,0L10,20z"]
      },
      pageIconColor: "#2f4554",
      pageIconInactiveColor: "#aaa",
      pageIconSize: 15,
      pageTextStyle: {
        color: "#333"
      },
      animationDurationUpdate: 800
    }), e;
  }(g2)
);
function ew(t, e, r) {
  var n = t.getOrient(), a = [1, 1];
  a[n.index] = 0, Ri(e, r, {
    type: "box",
    ignoreSize: !!a
  });
}
var tw = Xe, wf = ["width", "height"], yf = ["x", "y"], x7e = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = e.type, r.newlineDisabled = !0, r._currentIndex = 0, r;
    }
    return e.prototype.init = function() {
      t.prototype.init.call(this), this.group.add(this._containerGroup = new tw()), this._containerGroup.add(this.getContentGroup()), this.group.add(this._controllerGroup = new tw());
    }, e.prototype.resetInner = function() {
      t.prototype.resetInner.call(this), this._controllerGroup.removeAll(), this._containerGroup.removeClipPath(), this._containerGroup.__rectSize = null;
    }, e.prototype.renderInner = function(r, n, a, o, i, l, c) {
      var u = this;
      t.prototype.renderInner.call(this, r, n, a, o, i, l, c);
      var d = this._controllerGroup, f = n.get("pageIconSize", !0), h = z(f) ? f : [f, f];
      p("pagePrev", 0);
      var v = n.getModel("pageTextStyle");
      d.add(new Ye({
        name: "pageText",
        style: {
          // Placeholder to calculate a proper layout.
          text: "xx/xx",
          fill: v.getTextColor(),
          font: v.getFont(),
          verticalAlign: "middle",
          align: "center"
        },
        silent: !0
      })), p("pageNext", 1);
      function p(g, m) {
        var w = g + "DataIndex", y = P1(n.get("pageIcons", !0)[n.getOrient().name][m], {
          // Buttons will be created in each render, so we do not need
          // to worry about avoiding using legendModel kept in scope.
          onclick: le(u._pageGo, u, w, n, o)
        }, {
          x: -h[0] / 2,
          y: -h[1] / 2,
          width: h[0],
          height: h[1]
        });
        y.name = g, d.add(y);
      }
    }, e.prototype.layoutInner = function(r, n, a, o, i, l) {
      var c = this.getSelectorGroup(), u = r.getOrient().index, d = wf[u], f = yf[u], h = wf[1 - u], v = yf[1 - u];
      i && Vl(
        // Buttons in selectorGroup always layout horizontally
        "horizontal",
        c,
        r.get("selectorItemGap", !0)
      );
      var p = r.get("selectorButtonGap", !0), g = c.getBoundingRect(), m = [-g.x, -g.y], w = be(a);
      i && (w[d] = a[d] - g[d] - p);
      var y = this._layoutContentAndController(r, o, w, u, d, h, v, f);
      if (i) {
        if (l === "end")
          m[u] += y[d] + p;
        else {
          var b = g[d] + p;
          m[u] -= b, y[f] -= b;
        }
        y[d] += g[d] + p, m[1 - u] += y[v] + y[h] / 2 - g[h] / 2, y[h] = Math.max(y[h], g[h]), y[v] = Math.min(y[v], g[v] + m[1 - u]), c.x = m[0], c.y = m[1], c.markRedraw();
      }
      return y;
    }, e.prototype._layoutContentAndController = function(r, n, a, o, i, l, c, u) {
      var d = this.getContentGroup(), f = this._containerGroup, h = this._controllerGroup;
      Vl(r.get("orient"), d, r.get("itemGap"), o ? a.width : null, o ? null : a.height), Vl(
        // Buttons in controller are layout always horizontally.
        "horizontal",
        h,
        r.get("pageButtonItemGap", !0)
      );
      var v = d.getBoundingRect(), p = h.getBoundingRect(), g = this._showController = v[i] > a[i], m = [-v.x, -v.y];
      n || (m[o] = d[u]);
      var w = [0, 0], y = [-p.x, -p.y], b = de(r.get("pageButtonGap", !0), r.get("itemGap", !0));
      if (g) {
        var _ = r.get("pageButtonPosition", !0);
        _ === "end" ? y[o] += a[i] - p[i] : w[o] += p[i] + b;
      }
      y[1 - o] += v[l] / 2 - p[l] / 2, d.setPosition(m), f.setPosition(w), h.setPosition(y);
      var x = {
        x: 0,
        y: 0
      };
      if (x[i] = g ? a[i] : v[i], x[l] = Math.max(v[l], p[l]), x[c] = Math.min(0, p[c] + y[1 - o]), f.__rectSize = a[i], g) {
        var E = {
          x: 0,
          y: 0
        };
        E[i] = Math.max(a[i] - p[i] - b, 0), E[l] = x[l], f.setClipPath(new He({
          shape: E
        })), f.__rectSize = E[i];
      } else
        h.eachChild(function(M) {
          M.attr({
            invisible: !0,
            silent: !0
          });
        });
      var S = this._getPageInfo(r);
      return S.pageIndex != null && rt(
        d,
        {
          x: S.contentPosition[0],
          y: S.contentPosition[1]
        },
        // When switch from "show controller" to "not show controller", view should be
        // updated immediately without animation, otherwise causes weird effect.
        g ? r : null
      ), this._updatePageInfoView(r, S), x;
    }, e.prototype._pageGo = function(r, n, a) {
      var o = this._getPageInfo(n)[r];
      o != null && a.dispatchAction({
        type: "legendScroll",
        scrollDataIndex: o,
        legendId: n.id
      });
    }, e.prototype._updatePageInfoView = function(r, n) {
      var a = this._controllerGroup;
      I(["pagePrev", "pageNext"], function(d) {
        var f = d + "DataIndex", h = n[f] != null, v = a.childOfName(d);
        v && (v.setStyle("fill", h ? r.get("pageIconColor", !0) : r.get("pageIconInactiveColor", !0)), v.cursor = h ? "pointer" : "default");
      });
      var o = a.childOfName("pageText"), i = r.get("pageFormatter"), l = n.pageIndex, c = l != null ? l + 1 : 0, u = n.pageCount;
      o && i && o.setStyle("text", Q(i) ? i.replace("{current}", c == null ? "" : c + "").replace("{total}", u == null ? "" : u + "") : i({
        current: c,
        total: u
      }));
    }, e.prototype._getPageInfo = function(r) {
      var n = r.get("scrollDataIndex", !0), a = this.getContentGroup(), o = this._containerGroup.__rectSize, i = r.getOrient().index, l = wf[i], c = yf[i], u = this._findTargetItemIndex(n), d = a.children(), f = d[u], h = d.length, v = h ? 1 : 0, p = {
        contentPosition: [a.x, a.y],
        pageCount: v,
        pageIndex: v - 1,
        pagePrevDataIndex: null,
        pageNextDataIndex: null
      };
      if (!f)
        return p;
      var g = _(f);
      p.contentPosition[i] = -g.s;
      for (var m = u + 1, w = g, y = g, b = null; m <= h; ++m)
        b = _(d[m]), // Half of the last item is out of the window.
        (!b && y.e > w.s + o || b && !x(b, w.s)) && (y.i > w.i ? w = y : w = b, w && (p.pageNextDataIndex == null && (p.pageNextDataIndex = w.i), ++p.pageCount)), y = b;
      for (var m = u - 1, w = g, y = g, b = null; m >= -1; --m)
        b = _(d[m]), // If the the end item does not intersect with the window started
        // from the current item, a page can be settled.
        (!b || !x(y, b.s)) && w.i < y.i && (y = w, p.pagePrevDataIndex == null && (p.pagePrevDataIndex = w.i), ++p.pageCount, ++p.pageIndex), w = b;
      return p;
      function _(E) {
        if (E) {
          var S = E.getBoundingRect(), M = S[c] + E[c];
          return {
            s: M,
            e: M + S[l],
            i: E.__legendDataIndex
          };
        }
      }
      function x(E, S) {
        return E.e >= S && E.s <= S + o;
      }
    }, e.prototype._findTargetItemIndex = function(r) {
      if (!this._showController)
        return 0;
      var n, a = this.getContentGroup(), o;
      return a.eachChild(function(i, l) {
        var c = i.__legendDataIndex;
        o == null && c != null && (o = l), c === r && (n = l);
      }), n ?? o;
    }, e.type = "legend.scroll", e;
  }(BC)
);
function C7e(t) {
  t.registerAction("legendScroll", "legendscroll", function(e, r) {
    var n = e.scrollDataIndex;
    n != null && r.eachComponent({
      mainType: "legend",
      subType: "scroll",
      query: e
    }, function(a) {
      a.setScrollDataIndex(n);
    });
  });
}
function E7e(t) {
  Gt($C), t.registerComponentModel(_7e), t.registerComponentView(x7e), C7e(t);
}
function i5(t) {
  Gt($C), Gt(E7e);
}
var S7e = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = e.type, r;
    }
    return e.type = "dataZoom.inside", e.defaultOption = B1(xu.defaultOption, {
      disabled: !1,
      zoomLock: !1,
      zoomOnMouseWheel: !0,
      moveOnMouseMove: !0,
      moveOnMouseWheel: !1,
      preventDefaultMouseMove: !0
    }), e;
  }(xu)
), rp = je();
function R7e(t, e, r) {
  rp(t).coordSysRecordMap.each(function(n) {
    var a = n.dataZoomInfoMap.get(e.uid);
    a && (a.getRange = r);
  });
}
function M7e(t, e) {
  for (var r = rp(t).coordSysRecordMap, n = r.keys(), a = 0; a < n.length; a++) {
    var o = n[a], i = r.get(o), l = i.dataZoomInfoMap;
    if (l) {
      var c = e.uid, u = l.get(c);
      u && (l.removeKey(c), l.keys().length || VC(r, i));
    }
  }
}
function VC(t, e) {
  if (e) {
    t.removeKey(e.model.uid);
    var r = e.controller;
    r && r.dispose();
  }
}
function A7e(t, e) {
  var r = {
    model: e,
    containsPoint: Oe(L7e, e),
    dispatchAction: Oe(k7e, t),
    dataZoomInfoMap: null,
    controller: null
  }, n = r.controller = new X2e(t.getZr());
  return I(["pan", "zoom", "scrollMove"], function(a) {
    n.on(a, function(o) {
      var i = [];
      r.dataZoomInfoMap.each(function(l) {
        if (o.isAvailableBehavior(l.model.option)) {
          var c = (l.getRange || {})[a], u = c && c(l.dzReferCoordSysInfo, r.model.mainType, r.controller, o);
          !l.model.get("disabled", !0) && u && i.push({
            dataZoomId: l.model.id,
            start: u[0],
            end: u[1]
          });
        }
      }), i.length && r.dispatchAction(i);
    });
  }), r;
}
function k7e(t, e) {
  t.isDisposed() || t.dispatchAction({
    type: "dataZoom",
    animation: {
      easing: "cubicOut",
      duration: 100
    },
    batch: e
  });
}
function L7e(t, e, r, n) {
  return t.coordinateSystem.containPoint([r, n]);
}
function T7e(t) {
  var e, r = "type_", n = {
    type_true: 2,
    type_move: 1,
    type_false: 0,
    type_undefined: -1
  }, a = !0;
  return t.each(function(o) {
    var i = o.model, l = i.get("disabled", !0) ? !1 : i.get("zoomLock", !0) ? "move" : !0;
    n[r + l] > n[r + e] && (e = l), a = a && i.get("preventDefaultMouseMove", !0);
  }), {
    controlType: e,
    opt: {
      // RoamController will enable all of these functionalities,
      // and the final behavior is determined by its event listener
      // provided by each inside zoom.
      zoomOnMouseWheel: !0,
      moveOnMouseMove: !0,
      moveOnMouseWheel: !0,
      preventDefaultMouseMove: !!a
    }
  };
}
function O7e(t) {
  t.registerProcessor(t.PRIORITY.PROCESSOR.FILTER, function(e, r) {
    var n = rp(r), a = n.coordSysRecordMap || (n.coordSysRecordMap = se());
    a.each(function(o) {
      o.dataZoomInfoMap = null;
    }), e.eachComponent({
      mainType: "dataZoom",
      subType: "inside"
    }, function(o) {
      var i = AC(o);
      I(i.infoList, function(l) {
        var c = l.model.uid, u = a.get(c) || a.set(c, A7e(r, l.model)), d = u.dataZoomInfoMap || (u.dataZoomInfoMap = se());
        d.set(o.uid, {
          dzReferCoordSysInfo: l,
          model: o,
          getRange: null
        });
      });
    }), a.each(function(o) {
      var i = o.controller, l, c = o.dataZoomInfoMap;
      if (c) {
        var u = c.keys()[0];
        u != null && (l = c.get(u));
      }
      if (!l) {
        VC(a, o);
        return;
      }
      var d = T7e(c);
      i.enable(d.controlType, d.opt), i.setPointerChecker(o.containsPoint), G1(o, "dispatchAction", l.model.get("throttle", !0), "fixRate");
    });
  });
}
var I7e = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = "dataZoom.inside", r;
    }
    return e.prototype.render = function(r, n, a) {
      if (t.prototype.render.apply(this, arguments), r.noTarget()) {
        this._clear();
        return;
      }
      this.range = r.getPercentRange(), R7e(a, r, {
        pan: le(bf.pan, this),
        zoom: le(bf.zoom, this),
        scrollMove: le(bf.scrollMove, this)
      });
    }, e.prototype.dispose = function() {
      this._clear(), t.prototype.dispose.apply(this, arguments);
    }, e.prototype._clear = function() {
      M7e(this.api, this.dataZoomModel), this.range = null;
    }, e.type = "dataZoom.inside", e;
  }(kC)
), bf = {
  zoom: function(t, e, r, n) {
    var a = this.range, o = a.slice(), i = t.axisModels[0];
    if (i) {
      var l = _f[e](null, [n.originX, n.originY], i, r, t), c = (l.signal > 0 ? l.pixelStart + l.pixelLength - l.pixel : l.pixel - l.pixelStart) / l.pixelLength * (o[1] - o[0]) + o[0], u = Math.max(1 / n.scale, 0);
      o[0] = (o[0] - c) * u + c, o[1] = (o[1] - c) * u + c;
      var d = this.dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
      if (r5(0, o, [0, 100], 0, d.minSpan, d.maxSpan), this.range = o, a[0] !== o[0] || a[1] !== o[1])
        return o;
    }
  },
  pan: rw(function(t, e, r, n, a, o) {
    var i = _f[n]([o.oldX, o.oldY], [o.newX, o.newY], e, a, r);
    return i.signal * (t[1] - t[0]) * i.pixel / i.pixelLength;
  }),
  scrollMove: rw(function(t, e, r, n, a, o) {
    var i = _f[n]([0, 0], [o.scrollDelta, o.scrollDelta], e, a, r);
    return i.signal * (t[1] - t[0]) * o.scrollDelta;
  })
};
function rw(t) {
  return function(e, r, n, a) {
    var o = this.range, i = o.slice(), l = e.axisModels[0];
    if (l) {
      var c = t(i, l, e, r, n, a);
      if (r5(c, i, [0, 100], "all"), this.range = i, o[0] !== i[0] || o[1] !== i[1])
        return i;
    }
  };
}
var _f = {
  grid: function(t, e, r, n, a) {
    var o = r.axis, i = {}, l = a.model.coordinateSystem.getRect();
    return t = t || [0, 0], o.dim === "x" ? (i.pixel = e[0] - t[0], i.pixelLength = l.width, i.pixelStart = l.x, i.signal = o.inverse ? 1 : -1) : (i.pixel = e[1] - t[1], i.pixelLength = l.height, i.pixelStart = l.y, i.signal = o.inverse ? -1 : 1), i;
  },
  polar: function(t, e, r, n, a) {
    var o = r.axis, i = {}, l = a.model.coordinateSystem, c = l.getRadiusAxis().getExtent(), u = l.getAngleAxis().getExtent();
    return t = t ? l.pointToCoord(t) : [0, 0], e = l.pointToCoord(e), r.mainType === "radiusAxis" ? (i.pixel = e[0] - t[0], i.pixelLength = c[1] - c[0], i.pixelStart = c[0], i.signal = o.inverse ? 1 : -1) : (i.pixel = e[1] - t[1], i.pixelLength = u[1] - u[0], i.pixelStart = u[0], i.signal = o.inverse ? -1 : 1), i;
  },
  singleAxis: function(t, e, r, n, a) {
    var o = r.axis, i = a.model.coordinateSystem.getRect(), l = {};
    return t = t || [0, 0], o.orient === "horizontal" ? (l.pixel = e[0] - t[0], l.pixelLength = i.width, l.pixelStart = i.x, l.signal = o.inverse ? 1 : -1) : (l.pixel = e[1] - t[1], l.pixelLength = i.height, l.pixelStart = i.y, l.signal = o.inverse ? -1 : 1), l;
  }
};
function P7e(t) {
  LC(t), t.registerComponentModel(S7e), t.registerComponentView(I7e), O7e(t);
}
var D7e = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = e.type, r;
    }
    return e.type = "dataZoom.slider", e.layoutMode = "box", e.defaultOption = B1(xu.defaultOption, {
      show: !0,
      // deault value can only be drived in view stage.
      right: "ph",
      top: "ph",
      width: "ph",
      height: "ph",
      left: null,
      bottom: null,
      borderColor: "#d2dbee",
      borderRadius: 3,
      backgroundColor: "rgba(47,69,84,0)",
      // dataBackgroundColor: '#ddd',
      dataBackground: {
        lineStyle: {
          color: "#d2dbee",
          width: 0.5
        },
        areaStyle: {
          color: "#d2dbee",
          opacity: 0.2
        }
      },
      selectedDataBackground: {
        lineStyle: {
          color: "#8fb0f7",
          width: 0.5
        },
        areaStyle: {
          color: "#8fb0f7",
          opacity: 0.2
        }
      },
      // Color of selected window.
      fillerColor: "rgba(135,175,274,0.2)",
      handleIcon: "path://M-9.35,34.56V42m0-40V9.5m-2,0h4a2,2,0,0,1,2,2v21a2,2,0,0,1-2,2h-4a2,2,0,0,1-2-2v-21A2,2,0,0,1-11.35,9.5Z",
      // Percent of the slider height
      handleSize: "100%",
      handleStyle: {
        color: "#fff",
        borderColor: "#ACB8D1"
      },
      moveHandleSize: 7,
      moveHandleIcon: "path://M-320.9-50L-320.9-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-348-41-339-50-320.9-50z M-212.3-50L-212.3-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-239.4-41-230.4-50-212.3-50z M-103.7-50L-103.7-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-130.9-41-121.8-50-103.7-50z",
      moveHandleStyle: {
        color: "#D2DBEE",
        opacity: 0.7
      },
      showDetail: !0,
      showDataShadow: "auto",
      realtime: !0,
      zoomLock: !1,
      textStyle: {
        color: "#6E7079"
      },
      brushSelect: !0,
      brushStyle: {
        color: "rgba(135,175,274,0.15)"
      },
      emphasis: {
        handleStyle: {
          borderColor: "#8FB0F7"
        },
        moveHandleStyle: {
          color: "#8FB0F7"
        }
      }
    }), e;
  }(xu)
), wl = He, nw = 7, N7e = 1, xf = 30, B7e = 7, yl = "horizontal", aw = "vertical", F7e = 5, $7e = ["line", "bar", "candlestick", "scatter"], V7e = {
  easing: "cubicOut",
  duration: 100,
  delay: 0
}, Z7e = (
  /** @class */
  function(t) {
    K(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.type = e.type, r._displayables = {}, r;
    }
    return e.prototype.init = function(r, n) {
      this.api = n, this._onBrush = le(this._onBrush, this), this._onBrushEnd = le(this._onBrushEnd, this);
    }, e.prototype.render = function(r, n, a, o) {
      if (t.prototype.render.apply(this, arguments), G1(this, "_dispatchZoomAction", r.get("throttle"), "fixRate"), this._orient = r.getOrient(), r.get("show") === !1) {
        this.group.removeAll();
        return;
      }
      if (r.noTarget()) {
        this._clear(), this.group.removeAll();
        return;
      }
      (!o || o.type !== "dataZoom" || o.from !== this.uid) && this._buildView(), this._updateView();
    }, e.prototype.dispose = function() {
      this._clear(), t.prototype.dispose.apply(this, arguments);
    }, e.prototype._clear = function() {
      uu(this, "_dispatchZoomAction");
      var r = this.api.getZr();
      r.off("mousemove", this._onBrush), r.off("mouseup", this._onBrushEnd);
    }, e.prototype._buildView = function() {
      var r = this.group;
      r.removeAll(), this._brushing = !1, this._displayables.brushRect = null, this._resetLocation(), this._resetInterval();
      var n = this._displayables.sliderGroup = new Xe();
      this._renderBackground(), this._renderHandle(), this._renderDataShadow(), r.add(n), this._positionGroup();
    }, e.prototype._resetLocation = function() {
      var r = this.dataZoomModel, n = this.api, a = r.get("brushSelect"), o = a ? B7e : 0, i = this._findCoordRect(), l = {
        width: n.getWidth(),
        height: n.getHeight()
      }, c = this._orient === yl ? {
        // Why using 'right', because right should be used in vertical,
        // and it is better to be consistent for dealing with position param merge.
        right: l.width - i.x - i.width,
        top: l.height - xf - nw - o,
        width: i.width,
        height: xf
      } : {
        right: nw,
        top: i.y,
        width: xf,
        height: i.height
      }, u = zs(r.option);
      I(["right", "top", "width", "height"], function(f) {
        u[f] === "ph" && (u[f] = c[f]);
      });
      var d = da(u, l);
      this._location = {
        x: d.x,
        y: d.y
      }, this._size = [d.width, d.height], this._orient === aw && this._size.reverse();
    }, e.prototype._positionGroup = function() {
      var r = this.group, n = this._location, a = this._orient, o = this.dataZoomModel.getFirstTargetAxisModel(), i = o && o.get("inverse"), l = this._displayables.sliderGroup, c = (this._dataShadowInfo || {}).otherAxisInverse;
      l.attr(a === yl && !i ? {
        scaleY: c ? 1 : -1,
        scaleX: 1
      } : a === yl && i ? {
        scaleY: c ? 1 : -1,
        scaleX: -1
      } : a === aw && !i ? {
        scaleY: c ? -1 : 1,
        scaleX: 1,
        rotation: Math.PI / 2
      } : {
        scaleY: c ? -1 : 1,
        scaleX: -1,
        rotation: Math.PI / 2
      });
      var u = r.getBoundingRect([l]);
      r.x = n.x - u.x, r.y = n.y - u.y, r.markRedraw();
    }, e.prototype._getViewExtent = function() {
      return [0, this._size[0]];
    }, e.prototype._renderBackground = function() {
      var r = this.dataZoomModel, n = this._size, a = this._displayables.sliderGroup, o = r.get("brushSelect");
      a.add(new wl({
        silent: !0,
        shape: {
          x: 0,
          y: 0,
          width: n[0],
          height: n[1]
        },
        style: {
          fill: r.get("backgroundColor")
        },
        z2: -40
      }));
      var i = new wl({
        shape: {
          x: 0,
          y: 0,
          width: n[0],
          height: n[1]
        },
        style: {
          fill: "transparent"
        },
        z2: 0,
        onclick: le(this._onClickPanel, this)
      }), l = this.api.getZr();
      o ? (i.on("mousedown", this._onBrushStart, this), i.cursor = "crosshair", l.on("mousemove", this._onBrush), l.on("mouseup", this._onBrushEnd)) : (l.off("mousemove", this._onBrush), l.off("mouseup", this._onBrushEnd)), a.add(i);
    }, e.prototype._renderDataShadow = function() {
      var r = this._dataShadowInfo = this._prepareDataShadowInfo();
      if (this._displayables.dataShadowSegs = [], !r)
        return;
      var n = this._size, a = this._shadowSize || [], o = r.series, i = o.getRawData(), l = o.getShadowDim && o.getShadowDim(), c = l && i.getDimensionInfo(l) ? o.getShadowDim() : r.otherDim;
      if (c == null)
        return;
      var u = this._shadowPolygonPts, d = this._shadowPolylinePts;
      if (i !== this._shadowData || c !== this._shadowDim || n[0] !== a[0] || n[1] !== a[1]) {
        var f = i.getDataExtent(c), h = (f[1] - f[0]) * 0.3;
        f = [f[0] - h, f[1] + h];
        var v = [0, n[1]], p = [0, n[0]], g = [[n[0], 0], [0, 0]], m = [], w = p[1] / (i.count() - 1), y = 0, b = Math.round(i.count() / n[0]), _;
        i.each([c], function(R, A) {
          if (b > 0 && A % b) {
            y += w;
            return;
          }
          var k = R == null || isNaN(R) || R === "", L = k ? 0 : Ge(R, f, v, !0);
          k && !_ && A ? (g.push([g[g.length - 1][0], 0]), m.push([m[m.length - 1][0], 0])) : !k && _ && (g.push([y, 0]), m.push([y, 0])), g.push([y, L]), m.push([y, L]), y += w, _ = k;
        }), u = this._shadowPolygonPts = g, d = this._shadowPolylinePts = m;
      }
      this._shadowData = i, this._shadowDim = c, this._shadowSize = [n[0], n[1]];
      var x = this.dataZoomModel;
      function E(R) {
        var A = x.getModel(R ? "selectedDataBackground" : "dataBackground"), k = new Xe(), L = new Fs({
          shape: {
            points: u
          },
          segmentIgnoreThreshold: 1,
          style: A.getModel("areaStyle").getAreaStyle(),
          silent: !0,
          z2: -20
        }), T = new mo({
          shape: {
            points: d
          },
          segmentIgnoreThreshold: 1,
          style: A.getModel("lineStyle").getLineStyle(),
          silent: !0,
          z2: -19
        });
        return k.add(L), k.add(T), k;
      }
      for (var S = 0; S < 3; S++) {
        var M = E(S === 1);
        this._displayables.sliderGroup.add(M), this._displayables.dataShadowSegs.push(M);
      }
    }, e.prototype._prepareDataShadowInfo = function() {
      var r = this.dataZoomModel, n = r.get("showDataShadow");
      if (n !== !1) {
        var a, o = this.ecModel;
        return r.eachTargetAxis(function(i, l) {
          var c = r.getAxisProxy(i, l).getTargetSeriesModels();
          I(c, function(u) {
            if (!a && !(n !== !0 && Re($7e, u.get("type")) < 0)) {
              var d = o.getComponent(qn(i), l).axis, f = H7e(i), h, v = u.coordinateSystem;
              f != null && v.getOtherAxis && (h = v.getOtherAxis(d).inverse), f = u.getData().mapDimension(f), a = {
                thisAxis: d,
                series: u,
                thisDim: i,
                otherDim: f,
                otherAxisInverse: h
              };
            }
          }, this);
        }, this), a;
      }
    }, e.prototype._renderHandle = function() {
      var r = this.group, n = this._displayables, a = n.handles = [null, null], o = n.handleLabels = [null, null], i = this._displayables.sliderGroup, l = this._size, c = this.dataZoomModel, u = this.api, d = c.get("borderRadius") || 0, f = c.get("brushSelect"), h = n.filler = new wl({
        silent: f,
        style: {
          fill: c.get("fillerColor")
        },
        textConfig: {
          position: "inside"
        }
      });
      i.add(h), i.add(new wl({
        silent: !0,
        subPixelOptimize: !0,
        shape: {
          x: 0,
          y: 0,
          width: l[0],
          height: l[1],
          r: d
        },
        style: {
          // deprecated option
          stroke: c.get("dataBackgroundColor") || c.get("borderColor"),
          lineWidth: N7e,
          fill: "rgba(0,0,0,0)"
        }
      })), I([0, 1], function(b) {
        var _ = c.get("handleIcon");
        !fu[_] && _.indexOf("path://") < 0 && _.indexOf("image://") < 0 && (_ = "path://" + _, process.env.NODE_ENV !== "production" && yr("handleIcon now needs 'path://' prefix when using a path string"));
        var x = _r(_, -1, 0, 2, 2, null, !0);
        x.attr({
          cursor: ow(this._orient),
          draggable: !0,
          drift: le(this._onDragMove, this, b),
          ondragend: le(this._onDragEnd, this),
          onmouseover: le(this._showDataInfo, this, !0),
          onmouseout: le(this._showDataInfo, this, !1),
          z2: 5
        });
        var E = x.getBoundingRect(), S = c.get("handleSize");
        this._handleHeight = fe(S, this._size[1]), this._handleWidth = E.width / E.height * this._handleHeight, x.setStyle(c.getModel("handleStyle").getItemStyle()), x.style.strokeNoScale = !0, x.rectHover = !0, x.ensureState("emphasis").style = c.getModel(["emphasis", "handleStyle"]).getItemStyle(), as(x);
        var M = c.get("handleColor");
        M != null && (x.style.fill = M), i.add(a[b] = x);
        var R = c.getModel("textStyle");
        r.add(o[b] = new Ye({
          silent: !0,
          invisible: !0,
          style: jt(R, {
            x: 0,
            y: 0,
            text: "",
            verticalAlign: "middle",
            align: "center",
            fill: R.getTextColor(),
            font: R.getFont()
          }),
          z2: 10
        }));
      }, this);
      var v = h;
      if (f) {
        var p = fe(c.get("moveHandleSize"), l[1]), g = n.moveHandle = new He({
          style: c.getModel("moveHandleStyle").getItemStyle(),
          silent: !0,
          shape: {
            r: [0, 0, 2, 2],
            y: l[1] - 0.5,
            height: p
          }
        }), m = p * 0.8, w = n.moveHandleIcon = _r(c.get("moveHandleIcon"), -m / 2, -m / 2, m, m, "#fff", !0);
        w.silent = !0, w.y = l[1] + p / 2 - 0.5, g.ensureState("emphasis").style = c.getModel(["emphasis", "moveHandleStyle"]).getItemStyle();
        var y = Math.min(l[1] / 2, Math.max(p, 10));
        v = n.moveZone = new He({
          invisible: !0,
          shape: {
            y: l[1] - y,
            height: p + y
          }
        }), v.on("mouseover", function() {
          u.enterEmphasis(g);
        }).on("mouseout", function() {
          u.leaveEmphasis(g);
        }), i.add(g), i.add(w), i.add(v);
      }
      v.attr({
        draggable: !0,
        cursor: ow(this._orient),
        drift: le(this._onDragMove, this, "all"),
        ondragstart: le(this._showDataInfo, this, !0),
        ondragend: le(this._onDragEnd, this),
        onmouseover: le(this._showDataInfo, this, !0),
        onmouseout: le(this._showDataInfo, this, !1)
      });
    }, e.prototype._resetInterval = function() {
      var r = this._range = this.dataZoomModel.getPercentRange(), n = this._getViewExtent();
      this._handleEnds = [Ge(r[0], [0, 100], n, !0), Ge(r[1], [0, 100], n, !0)];
    }, e.prototype._updateInterval = function(r, n) {
      var a = this.dataZoomModel, o = this._handleEnds, i = this._getViewExtent(), l = a.findRepresentativeAxisProxy().getMinMaxSpan(), c = [0, 100];
      r5(n, o, i, a.get("zoomLock") ? "all" : r, l.minSpan != null ? Ge(l.minSpan, c, i, !0) : null, l.maxSpan != null ? Ge(l.maxSpan, c, i, !0) : null);
      var u = this._range, d = this._range = Jo([Ge(o[0], i, c, !0), Ge(o[1], i, c, !0)]);
      return !u || u[0] !== d[0] || u[1] !== d[1];
    }, e.prototype._updateView = function(r) {
      var n = this._displayables, a = this._handleEnds, o = Jo(a.slice()), i = this._size;
      I([0, 1], function(v) {
        var p = n.handles[v], g = this._handleHeight;
        p.attr({
          scaleX: g / 2,
          scaleY: g / 2,
          // This is a trick, by adding an extra tiny offset to let the default handle's end point align to the drag window.
          // NOTE: It may affect some custom shapes a bit. But we prefer to have better result by default.
          x: a[v] + (v ? -1 : 1),
          y: i[1] / 2 - g / 2
        });
      }, this), n.filler.setShape({
        x: o[0],
        y: 0,
        width: o[1] - o[0],
        height: i[1]
      });
      var l = {
        x: o[0],
        width: o[1] - o[0]
      };
      n.moveHandle && (n.moveHandle.setShape(l), n.moveZone.setShape(l), n.moveZone.getBoundingRect(), n.moveHandleIcon && n.moveHandleIcon.attr("x", l.x + l.width / 2));
      for (var c = n.dataShadowSegs, u = [0, o[0], o[1], i[0]], d = 0; d < c.length; d++) {
        var f = c[d], h = f.getClipPath();
        h || (h = new He(), f.setClipPath(h)), h.setShape({
          x: u[d],
          y: 0,
          width: u[d + 1] - u[d],
          height: i[1]
        });
      }
      this._updateDataInfo(r);
    }, e.prototype._updateDataInfo = function(r) {
      var n = this.dataZoomModel, a = this._displayables, o = a.handleLabels, i = this._orient, l = ["", ""];
      if (n.get("showDetail")) {
        var c = n.findRepresentativeAxisProxy();
        if (c) {
          var u = c.getAxisModel().axis, d = this._range, f = r ? c.calculateDataWindow({
            start: d[0],
            end: d[1]
          }).valueWindow : c.getDataValueWindow();
          l = [this._formatLabel(f[0], u), this._formatLabel(f[1], u)];
        }
      }
      var h = Jo(this._handleEnds.slice());
      v.call(this, 0), v.call(this, 1);
      function v(p) {
        var g = d7(a.handles[p].parent, this.group), m = Q9(p === 0 ? "right" : "left", g), w = this._handleWidth / 2 + F7e, y = is([h[p] + (p === 0 ? -w : w), this._size[1] / 2], g);
        o[p].setStyle({
          x: y[0],
          y: y[1],
          verticalAlign: i === yl ? "middle" : m,
          align: i === yl ? m : "center",
          text: l[p]
        });
      }
    }, e.prototype._formatLabel = function(r, n) {
      var a = this.dataZoomModel, o = a.get("labelFormatter"), i = a.get("labelPrecision");
      (i == null || i === "auto") && (i = n.getPixelPrecision());
      var l = r == null || isNaN(r) ? "" : n.type === "category" || n.type === "time" ? n.scale.getLabel({
        value: Math.round(r)
      }) : r.toFixed(Math.min(i, 20));
      return ie(o) ? o(r, l) : Q(o) ? o.replace("{value}", l) : l;
    }, e.prototype._showDataInfo = function(r) {
      r = this._dragging || r;
      var n = this._displayables, a = n.handleLabels;
      a[0].attr("invisible", !r), a[1].attr("invisible", !r), n.moveHandle && this.api[r ? "enterEmphasis" : "leaveEmphasis"](n.moveHandle, 1);
    }, e.prototype._onDragMove = function(r, n, a, o) {
      this._dragging = !0, xi(o.event);
      var i = this._displayables.sliderGroup.getLocalTransform(), l = is([n, a], i, !0), c = this._updateInterval(r, l[0]), u = this.dataZoomModel.get("realtime");
      this._updateView(!u), c && u && this._dispatchZoomAction(!0);
    }, e.prototype._onDragEnd = function() {
      this._dragging = !1, this._showDataInfo(!1);
      var r = this.dataZoomModel.get("realtime");
      !r && this._dispatchZoomAction(!1);
    }, e.prototype._onClickPanel = function(r) {
      var n = this._size, a = this._displayables.sliderGroup.transformCoordToLocal(r.offsetX, r.offsetY);
      if (!(a[0] < 0 || a[0] > n[0] || a[1] < 0 || a[1] > n[1])) {
        var o = this._handleEnds, i = (o[0] + o[1]) / 2, l = this._updateInterval("all", a[0] - i);
        this._updateView(), l && this._dispatchZoomAction(!1);
      }
    }, e.prototype._onBrushStart = function(r) {
      var n = r.offsetX, a = r.offsetY;
      this._brushStart = new he(n, a), this._brushing = !0, this._brushStartTime = +/* @__PURE__ */ new Date();
    }, e.prototype._onBrushEnd = function(r) {
      if (this._brushing) {
        var n = this._displayables.brushRect;
        if (this._brushing = !1, !!n) {
          n.attr("ignore", !0);
          var a = n.shape, o = +/* @__PURE__ */ new Date();
          if (!(o - this._brushStartTime < 200 && Math.abs(a.width) < 5)) {
            var i = this._getViewExtent(), l = [0, 100];
            this._range = Jo([Ge(a.x, i, l, !0), Ge(a.x + a.width, i, l, !0)]), this._handleEnds = [a.x, a.x + a.width], this._updateView(), this._dispatchZoomAction(!1);
          }
        }
      }
    }, e.prototype._onBrush = function(r) {
      this._brushing && (xi(r.event), this._updateBrushRect(r.offsetX, r.offsetY));
    }, e.prototype._updateBrushRect = function(r, n) {
      var a = this._displayables, o = this.dataZoomModel, i = a.brushRect;
      i || (i = a.brushRect = new wl({
        silent: !0,
        style: o.getModel("brushStyle").getItemStyle()
      }), a.sliderGroup.add(i)), i.attr("ignore", !1);
      var l = this._brushStart, c = this._displayables.sliderGroup, u = c.transformCoordToLocal(r, n), d = c.transformCoordToLocal(l.x, l.y), f = this._size;
      u[0] = Math.max(Math.min(f[0], u[0]), 0), i.setShape({
        x: d[0],
        y: 0,
        width: u[0] - d[0],
        height: f[1]
      });
    }, e.prototype._dispatchZoomAction = function(r) {
      var n = this._range;
      this.api.dispatchAction({
        type: "dataZoom",
        from: this.uid,
        dataZoomId: this.dataZoomModel.id,
        animation: r ? V7e : null,
        start: n[0],
        end: n[1]
      });
    }, e.prototype._findCoordRect = function() {
      var r, n = AC(this.dataZoomModel).infoList;
      if (!r && n.length) {
        var a = n[0].model.coordinateSystem;
        r = a.getRect && a.getRect();
      }
      if (!r) {
        var o = this.api.getWidth(), i = this.api.getHeight();
        r = {
          x: o * 0.2,
          y: i * 0.2,
          width: o * 0.6,
          height: i * 0.6
        };
      }
      return r;
    }, e.type = "dataZoom.slider", e;
  }(kC)
);
function H7e(t) {
  var e = {
    x: "y",
    y: "x",
    radius: "angle",
    angle: "radius"
  };
  return e[t];
}
function ow(t) {
  return t === "vertical" ? "ns-resize" : "ew-resize";
}
function j7e(t) {
  t.registerComponentModel(D7e), t.registerComponentView(Z7e), LC(t);
}
function ZC(t) {
  Gt(P7e), Gt(j7e);
}
function iw(t, e, r) {
  var n = xn.createCanvas(), a = e.getWidth(), o = e.getHeight(), i = n.style;
  return i && (i.position = "absolute", i.left = "0", i.top = "0", i.width = a + "px", i.height = o + "px", n.setAttribute("data-zr-dom-id", t)), n.width = a * r, n.height = o * r, n;
}
var Cf = function(t) {
  Be(e, t);
  function e(r, n, a) {
    var o = t.call(this) || this;
    o.motionBlur = !1, o.lastFrameAlpha = 0.7, o.dpr = 1, o.virtual = !1, o.config = {}, o.incremental = !1, o.zlevel = 0, o.maxRepaintRectCount = 5, o.__dirty = !0, o.__firstTimePaint = !0, o.__used = !1, o.__drawIndex = 0, o.__startIndex = 0, o.__endIndex = 0, o.__prevStartIndex = null, o.__prevEndIndex = null;
    var i;
    a = a || X0, typeof r == "string" ? i = iw(r, n, a) : re(r) && (i = r, r = i.id), o.id = r, o.dom = i;
    var l = i.style;
    return l && (Nv(i), i.onselectstart = function() {
      return !1;
    }, l.padding = "0", l.margin = "0", l.borderWidth = "0"), o.painter = n, o.dpr = a, o;
  }
  return e.prototype.getElementCount = function() {
    return this.__endIndex - this.__startIndex;
  }, e.prototype.afterBrush = function() {
    this.__prevStartIndex = this.__startIndex, this.__prevEndIndex = this.__endIndex;
  }, e.prototype.initContext = function() {
    this.ctx = this.dom.getContext("2d"), this.ctx.dpr = this.dpr;
  }, e.prototype.setUnpainted = function() {
    this.__firstTimePaint = !0;
  }, e.prototype.createBackBuffer = function() {
    var r = this.dpr;
    this.domBack = iw("back-" + this.id, this.painter, r), this.ctxBack = this.domBack.getContext("2d"), r !== 1 && this.ctxBack.scale(r, r);
  }, e.prototype.createRepaintRects = function(r, n, a, o) {
    if (this.__firstTimePaint)
      return this.__firstTimePaint = !1, null;
    var i = [], l = this.maxRepaintRectCount, c = !1, u = new Le(0, 0, 0, 0);
    function d(y) {
      if (!(!y.isFinite() || y.isZero()))
        if (i.length === 0) {
          var b = new Le(0, 0, 0, 0);
          b.copy(y), i.push(b);
        } else {
          for (var _ = !1, x = 1 / 0, E = 0, S = 0; S < i.length; ++S) {
            var M = i[S];
            if (M.intersect(y)) {
              var R = new Le(0, 0, 0, 0);
              R.copy(M), R.union(y), i[S] = R, _ = !0;
              break;
            } else if (c) {
              u.copy(y), u.union(M);
              var A = y.width * y.height, k = M.width * M.height, L = u.width * u.height, T = L - A - k;
              T < x && (x = T, E = S);
            }
          }
          if (c && (i[E].union(y), _ = !0), !_) {
            var b = new Le(0, 0, 0, 0);
            b.copy(y), i.push(b);
          }
          c || (c = i.length >= l);
        }
    }
    for (var f = this.__startIndex; f < this.__endIndex; ++f) {
      var h = r[f];
      if (h) {
        var v = h.shouldBePainted(a, o, !0, !0), p = h.__isRendered && (h.__dirty & qt || !v) ? h.getPrevPaintRect() : null;
        p && d(p);
        var g = v && (h.__dirty & qt || !h.__isRendered) ? h.getPaintRect() : null;
        g && d(g);
      }
    }
    for (var f = this.__prevStartIndex; f < this.__prevEndIndex; ++f) {
      var h = n[f], v = h && h.shouldBePainted(a, o, !0, !0);
      if (h && (!v || !h.__zr) && h.__isRendered) {
        var p = h.getPrevPaintRect();
        p && d(p);
      }
    }
    var m;
    do {
      m = !1;
      for (var f = 0; f < i.length; ) {
        if (i[f].isZero()) {
          i.splice(f, 1);
          continue;
        }
        for (var w = f + 1; w < i.length; )
          i[f].intersect(i[w]) ? (m = !0, i[f].union(i[w]), i.splice(w, 1)) : w++;
        f++;
      }
    } while (m);
    return this._paintRects = i, i;
  }, e.prototype.debugGetPaintRects = function() {
    return (this._paintRects || []).slice();
  }, e.prototype.resize = function(r, n) {
    var a = this.dpr, o = this.dom, i = o.style, l = this.domBack;
    i && (i.width = r + "px", i.height = n + "px"), o.width = r * a, o.height = n * a, l && (l.width = r * a, l.height = n * a, a !== 1 && this.ctxBack.scale(a, a));
  }, e.prototype.clear = function(r, n, a) {
    var o = this.dom, i = this.ctx, l = o.width, c = o.height;
    n = n || this.clearColor;
    var u = this.motionBlur && !r, d = this.lastFrameAlpha, f = this.dpr, h = this;
    u && (this.domBack || this.createBackBuffer(), this.ctxBack.globalCompositeOperation = "copy", this.ctxBack.drawImage(o, 0, 0, l / f, c / f));
    var v = this.domBack;
    function p(g, m, w, y) {
      if (i.clearRect(g, m, w, y), n && n !== "transparent") {
        var b = void 0;
        if (As(n)) {
          var _ = n.global || n.__width === w && n.__height === y;
          b = _ && n.__canvasGradient || Qh(i, n, {
            x: 0,
            y: 0,
            width: w,
            height: y
          }), n.__canvasGradient = b, n.__width = w, n.__height = y;
        } else Ib(n) && (n.scaleX = n.scaleX || f, n.scaleY = n.scaleY || f, b = Jh(i, n, {
          dirty: function() {
            h.setUnpainted(), h.painter.refresh();
          }
        }));
        i.save(), i.fillStyle = b || n, i.fillRect(g, m, w, y), i.restore();
      }
      u && (i.save(), i.globalAlpha = d, i.drawImage(v, g, m, w, y), i.restore());
    }
    !a || u ? p(0, 0, l, c) : a.length && I(a, function(g) {
      p(g.x * f, g.y * f, g.width * f, g.height * f);
    });
  }, e;
}(Vr), lw = 1e5, Za = 314159, qc = 0.01, W7e = 1e-3;
function z7e(t) {
  return t ? t.__builtin__ ? !0 : !(typeof t.resize != "function" || typeof t.refresh != "function") : !1;
}
function G7e(t, e) {
  var r = document.createElement("div");
  return r.style.cssText = [
    "position:relative",
    "width:" + t + "px",
    "height:" + e + "px",
    "padding:0",
    "margin:0",
    "border-width:0"
  ].join(";") + ";", r;
}
var U7e = function() {
  function t(e, r, n, a) {
    this.type = "canvas", this._zlevelList = [], this._prevDisplayList = [], this._layers = {}, this._layerConfig = {}, this._needsManuallyCompositing = !1, this.type = "canvas";
    var o = !e.nodeName || e.nodeName.toUpperCase() === "CANVAS";
    this._opts = n = H({}, n || {}), this.dpr = n.devicePixelRatio || X0, this._singleCanvas = o, this.root = e;
    var i = e.style;
    i && (Nv(e), e.innerHTML = ""), this.storage = r;
    var l = this._zlevelList;
    this._prevDisplayList = [];
    var c = this._layers;
    if (o) {
      var d = e, f = d.width, h = d.height;
      n.width != null && (f = n.width), n.height != null && (h = n.height), this.dpr = n.devicePixelRatio || 1, d.width = f * this.dpr, d.height = h * this.dpr, this._width = f, this._height = h;
      var v = new Cf(d, this, this.dpr);
      v.__builtin__ = !0, v.initContext(), c[Za] = v, v.zlevel = Za, l.push(Za), this._domRoot = e;
    } else {
      this._width = Tc(e, 0, n), this._height = Tc(e, 1, n);
      var u = this._domRoot = G7e(this._width, this._height);
      e.appendChild(u);
    }
  }
  return t.prototype.getType = function() {
    return "canvas";
  }, t.prototype.isSingleCanvas = function() {
    return this._singleCanvas;
  }, t.prototype.getViewportRoot = function() {
    return this._domRoot;
  }, t.prototype.getViewportRootOffset = function() {
    var e = this.getViewportRoot();
    if (e)
      return {
        offsetLeft: e.offsetLeft || 0,
        offsetTop: e.offsetTop || 0
      };
  }, t.prototype.refresh = function(e) {
    var r = this.storage.getDisplayList(!0), n = this._prevDisplayList, a = this._zlevelList;
    this._redrawId = Math.random(), this._paintList(r, n, e, this._redrawId);
    for (var o = 0; o < a.length; o++) {
      var i = a[o], l = this._layers[i];
      if (!l.__builtin__ && l.refresh) {
        var c = o === 0 ? this._backgroundColor : null;
        l.refresh(c);
      }
    }
    return this._opts.useDirtyRect && (this._prevDisplayList = r.slice()), this;
  }, t.prototype.refreshHover = function() {
    this._paintHoverList(this.storage.getDisplayList(!1));
  }, t.prototype._paintHoverList = function(e) {
    var r = e.length, n = this._hoverlayer;
    if (n && n.clear(), !!r) {
      for (var a = {
        inHover: !0,
        viewWidth: this._width,
        viewHeight: this._height
      }, o, i = 0; i < r; i++) {
        var l = e[i];
        l.__inHover && (n || (n = this._hoverlayer = this.getLayer(lw)), o || (o = n.ctx, o.save()), Ua(o, l, a, i === r - 1));
      }
      o && o.restore();
    }
  }, t.prototype.getHoverLayer = function() {
    return this.getLayer(lw);
  }, t.prototype.paintOne = function(e, r) {
    O7(e, r);
  }, t.prototype._paintList = function(e, r, n, a) {
    if (this._redrawId === a) {
      n = n || !1, this._updateLayerStatus(e);
      var o = this._doPaintList(e, r, n), i = o.finished, l = o.needsRefreshHover;
      if (this._needsManuallyCompositing && this._compositeManually(), l && this._paintHoverList(e), i)
        this.eachLayer(function(u) {
          u.afterBrush && u.afterBrush();
        });
      else {
        var c = this;
        W0(function() {
          c._paintList(e, r, n, a);
        });
      }
    }
  }, t.prototype._compositeManually = function() {
    var e = this.getLayer(Za).ctx, r = this._domRoot.width, n = this._domRoot.height;
    e.clearRect(0, 0, r, n), this.eachBuiltinLayer(function(a) {
      a.virtual && e.drawImage(a.dom, 0, 0, r, n);
    });
  }, t.prototype._doPaintList = function(e, r, n) {
    for (var a = this, o = [], i = this._opts.useDirtyRect, l = 0; l < this._zlevelList.length; l++) {
      var c = this._zlevelList[l], u = this._layers[c];
      u.__builtin__ && u !== this._hoverlayer && (u.__dirty || n) && o.push(u);
    }
    for (var d = !0, f = !1, h = function(g) {
      var m = o[g], w = m.ctx, y = i && m.createRepaintRects(e, r, v._width, v._height), b = n ? m.__startIndex : m.__drawIndex, _ = !n && m.incremental && Date.now, x = _ && Date.now(), E = m.zlevel === v._zlevelList[0] ? v._backgroundColor : null;
      if (m.__startIndex === m.__endIndex)
        m.clear(!1, E, y);
      else if (b === m.__startIndex) {
        var S = e[b];
        (!S.incremental || !S.notClear || n) && m.clear(!1, E, y);
      }
      b === -1 && (console.error("For some unknown reason. drawIndex is -1"), b = m.__startIndex);
      var M, R = function(T) {
        var O = {
          inHover: !1,
          allClipped: !1,
          prevEl: null,
          viewWidth: a._width,
          viewHeight: a._height
        };
        for (M = b; M < m.__endIndex; M++) {
          var D = e[M];
          if (D.__inHover && (f = !0), a._doPaintEl(D, m, i, T, O, M === m.__endIndex - 1), _) {
            var P = Date.now() - x;
            if (P > 15)
              break;
          }
        }
        O.prevElClipPaths && w.restore();
      };
      if (y)
        if (y.length === 0)
          M = m.__endIndex;
        else
          for (var A = v.dpr, k = 0; k < y.length; ++k) {
            var L = y[k];
            w.save(), w.beginPath(), w.rect(L.x * A, L.y * A, L.width * A, L.height * A), w.clip(), R(L), w.restore();
          }
      else
        w.save(), R(), w.restore();
      m.__drawIndex = M, m.__drawIndex < m.__endIndex && (d = !1);
    }, v = this, p = 0; p < o.length; p++)
      h(p);
    return ue.wxa && I(this._layers, function(g) {
      g && g.ctx && g.ctx.draw && g.ctx.draw();
    }), {
      finished: d,
      needsRefreshHover: f
    };
  }, t.prototype._doPaintEl = function(e, r, n, a, o, i) {
    var l = r.ctx;
    if (n) {
      var c = e.getPaintRect();
      (!a || c && c.intersect(a)) && (Ua(l, e, o, i), e.setPrevPaintRect(c));
    } else
      Ua(l, e, o, i);
  }, t.prototype.getLayer = function(e, r) {
    this._singleCanvas && !this._needsManuallyCompositing && (e = Za);
    var n = this._layers[e];
    return n || (n = new Cf("zr_" + e, this, this.dpr), n.zlevel = e, n.__builtin__ = !0, this._layerConfig[e] ? Ce(n, this._layerConfig[e], !0) : this._layerConfig[e - qc] && Ce(n, this._layerConfig[e - qc], !0), r && (n.virtual = r), this.insertLayer(e, n), n.initContext()), n;
  }, t.prototype.insertLayer = function(e, r) {
    var n = this._layers, a = this._zlevelList, o = a.length, i = this._domRoot, l = null, c = -1;
    if (n[e]) {
      process.env.NODE_ENV !== "production" && mn("ZLevel " + e + " has been used already");
      return;
    }
    if (!z7e(r)) {
      process.env.NODE_ENV !== "production" && mn("Layer of zlevel " + e + " is not valid");
      return;
    }
    if (o > 0 && e > a[0]) {
      for (c = 0; c < o - 1 && !(a[c] < e && a[c + 1] > e); c++)
        ;
      l = n[a[c]];
    }
    if (a.splice(c + 1, 0, e), n[e] = r, !r.virtual)
      if (l) {
        var u = l.dom;
        u.nextSibling ? i.insertBefore(r.dom, u.nextSibling) : i.appendChild(r.dom);
      } else
        i.firstChild ? i.insertBefore(r.dom, i.firstChild) : i.appendChild(r.dom);
    r.painter || (r.painter = this);
  }, t.prototype.eachLayer = function(e, r) {
    for (var n = this._zlevelList, a = 0; a < n.length; a++) {
      var o = n[a];
      e.call(r, this._layers[o], o);
    }
  }, t.prototype.eachBuiltinLayer = function(e, r) {
    for (var n = this._zlevelList, a = 0; a < n.length; a++) {
      var o = n[a], i = this._layers[o];
      i.__builtin__ && e.call(r, i, o);
    }
  }, t.prototype.eachOtherLayer = function(e, r) {
    for (var n = this._zlevelList, a = 0; a < n.length; a++) {
      var o = n[a], i = this._layers[o];
      i.__builtin__ || e.call(r, i, o);
    }
  }, t.prototype.getLayers = function() {
    return this._layers;
  }, t.prototype._updateLayerStatus = function(e) {
    this.eachBuiltinLayer(function(f, h) {
      f.__dirty = f.__used = !1;
    });
    function r(f) {
      o && (o.__endIndex !== f && (o.__dirty = !0), o.__endIndex = f);
    }
    if (this._singleCanvas)
      for (var n = 1; n < e.length; n++) {
        var a = e[n];
        if (a.zlevel !== e[n - 1].zlevel || a.incremental) {
          this._needsManuallyCompositing = !0;
          break;
        }
      }
    var o = null, i = 0, l, c;
    for (c = 0; c < e.length; c++) {
      var a = e[c], u = a.zlevel, d = void 0;
      l !== u && (l = u, i = 0), a.incremental ? (d = this.getLayer(u + W7e, this._needsManuallyCompositing), d.incremental = !0, i = 1) : d = this.getLayer(u + (i > 0 ? qc : 0), this._needsManuallyCompositing), d.__builtin__ || mn("ZLevel " + u + " has been used by unkown layer " + d.id), d !== o && (d.__used = !0, d.__startIndex !== c && (d.__dirty = !0), d.__startIndex = c, d.incremental ? d.__drawIndex = -1 : d.__drawIndex = c, r(c), o = d), a.__dirty & qt && !a.__inHover && (d.__dirty = !0, d.incremental && d.__drawIndex < 0 && (d.__drawIndex = c));
    }
    r(c), this.eachBuiltinLayer(function(f, h) {
      !f.__used && f.getElementCount() > 0 && (f.__dirty = !0, f.__startIndex = f.__endIndex = f.__drawIndex = 0), f.__dirty && f.__drawIndex < 0 && (f.__drawIndex = f.__startIndex);
    });
  }, t.prototype.clear = function() {
    return this.eachBuiltinLayer(this._clearLayer), this;
  }, t.prototype._clearLayer = function(e) {
    e.clear();
  }, t.prototype.setBackgroundColor = function(e) {
    this._backgroundColor = e, I(this._layers, function(r) {
      r.setUnpainted();
    });
  }, t.prototype.configLayer = function(e, r) {
    if (r) {
      var n = this._layerConfig;
      n[e] ? Ce(n[e], r, !0) : n[e] = r;
      for (var a = 0; a < this._zlevelList.length; a++) {
        var o = this._zlevelList[a];
        if (o === e || o === e + qc) {
          var i = this._layers[o];
          Ce(i, n[e], !0);
        }
      }
    }
  }, t.prototype.delLayer = function(e) {
    var r = this._layers, n = this._zlevelList, a = r[e];
    a && (a.dom.parentNode.removeChild(a.dom), delete r[e], n.splice(Re(n, e), 1));
  }, t.prototype.resize = function(e, r) {
    if (this._domRoot.style) {
      var n = this._domRoot;
      n.style.display = "none";
      var a = this._opts, o = this.root;
      if (e != null && (a.width = e), r != null && (a.height = r), e = Tc(o, 0, a), r = Tc(o, 1, a), n.style.display = "", this._width !== e || r !== this._height) {
        n.style.width = e + "px", n.style.height = r + "px";
        for (var i in this._layers)
          this._layers.hasOwnProperty(i) && this._layers[i].resize(e, r);
        this.refresh(!0);
      }
      this._width = e, this._height = r;
    } else {
      if (e == null || r == null)
        return;
      this._width = e, this._height = r, this.getLayer(Za).resize(e, r);
    }
    return this;
  }, t.prototype.clearLayer = function(e) {
    var r = this._layers[e];
    r && r.clear();
  }, t.prototype.dispose = function() {
    this.root.innerHTML = "", this.root = this.storage = this._domRoot = this._layers = null;
  }, t.prototype.getRenderedCanvas = function(e) {
    if (e = e || {}, this._singleCanvas && !this._compositeManually)
      return this._layers[Za].dom;
    var r = new Cf("image", this, e.pixelRatio || this.dpr);
    r.initContext(), r.clear(!1, e.backgroundColor || this._backgroundColor);
    var n = r.ctx;
    if (e.pixelRatio <= this.dpr) {
      this.refresh();
      var a = r.dom.width, o = r.dom.height;
      this.eachLayer(function(f) {
        f.__builtin__ ? n.drawImage(f.dom, 0, 0, a, o) : f.renderToCanvas && (n.save(), f.renderToCanvas(n), n.restore());
      });
    } else
      for (var i = {
        inHover: !1,
        viewWidth: this._width,
        viewHeight: this._height
      }, l = this.storage.getDisplayList(!0), c = 0, u = l.length; c < u; c++) {
        var d = l[c];
        Ua(n, d, i, c === u - 1);
      }
    return r.dom;
  }, t.prototype.getWidth = function() {
    return this._width;
  }, t.prototype.getHeight = function() {
    return this._height;
  }, t;
}();
function l5(t) {
  t.registerPainter("canvas", U7e);
}
var np = /* @__PURE__ */ ((t) => (t.UNKNOWN = "UNKNOWN", t.UNIX = "UNIX", t.MACOS = "MACOS", t.LINUX = "LINUX", t.WINDOWS = "WINDOWS", t))(np || {});
const Y7e = (t) => {
  const e = t.toLowerCase();
  return e.includes("win") ? "WINDOWS" : e.includes("mac") ? "MACOS" : e.includes("x11") ? "UNIX" : e.includes("linux") ? "LINUX" : "UNKNOWN";
}, HC = () => {
  var n;
  const t = window.navigator;
  let e = "";
  return "userAgentData" in t && (e = ((n = t.userAgentData) == null ? void 0 : n.platform) ?? ""), !e && "platform" in t && (e = t.platform ?? ""), !e && "userAgent" in t && (e = (t == null ? void 0 : t.userAgent) ?? ""), { operatingSystem: Y7e(e) };
}, lr = {
  title: {
    color: "#222222",
    fontWeight: "bold",
    fontFamily: "Poppins"
  },
  colors: {
    gray2: "#404040",
    gray4: "#818181",
    gray5: "#9C9C9B",
    gray6: "#C5C5C5",
    gray7: "#E8E8E8",
    light20: "#FAFAFA"
  }
}, jC = (t, e, r) => {
  const n = [];
  if (t.length > 0)
    for (let a of t)
      n.push({
        type: "line",
        name: a.name,
        data: [],
        color: a.color,
        markLine: {
          symbol: "none",
          data: [
            {
              name: a.name,
              xAxis: a.x !== void 0 && a.x !== null ? a.x : void 0,
              yAxis: a.y !== void 0 && a.y !== null ? a.y : void 0
            }
          ],
          label: {
            show: !0,
            formatter: `${e ?? ""}{c}${r ?? ""}`,
            color: lr.colors.gray4,
            position: "insideEndTop"
          },
          lineStyle: {
            type: "solid",
            width: 2,
            color: a.color
          }
        }
      });
  return n;
}, X7e = (t, e) => {
  var n, a, o, i;
  const r = [];
  for (let l of t) {
    let c = {
      name: l.name ? l.name : void 0,
      symbol: ((n = l.symbol) == null ? void 0 : n.type) ?? "emptyCircle",
      symbolSize: 12,
      showSymbol: ((a = l.symbol) == null ? void 0 : a.show) ?? !1,
      data: l.values,
      type: "line",
      smooth: !0,
      lineStyle: {
        color: l.color,
        width: l.width
      },
      itemStyle: {
        color: e ? (o = l.colors) == null ? void 0 : o.start : l.color
      }
    };
    e && (c.areaStyle = {
      color: {
        type: "linear",
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [
          {
            offset: 0,
            color: l.colors ? (i = l.colors) == null ? void 0 : i.start : "green"
          },
          {
            offset: 1,
            color: l.colors ? l.colors.end : "blue"
          }
        ]
      },
      opacity: 1
    }), r.push(c);
  }
  return r;
}, q7e = (t) => `<h3 style="font-size: 16px; font-weight: bold; font-family: Poppins;">${t}</h3>`, ap = (t, e, r, n) => {
  let a = 0;
  if (Array.isArray(t)) {
    const i = t[1];
    a = typeof i == "string" ? parseFloat(i) : i;
  } else
    a = t;
  const o = new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: n ?? 0,
    maximumFractionDigits: n ?? 2
  }).format(a);
  return `${e ?? ""}${o}${r ?? ""}`;
}, K7e = (t, e, r, n, a, o) => {
  const i = ap(e, n, a, o);
  return `<div style="display: flex; align-items: center">
                <span style="width: 15px;
                    height: 15px;
                    border-radius: 20px;
                    display: inline-block;
                    background-color: ${r}";
                ></span>
                <span style="margin-left: 5px">${t}</span>: 
                <strong style="margin-left: 3px">${i}</strong>
            </div>`;
}, WC = (t, e, r, n) => {
  let a = "";
  if (Array.isArray(t)) {
    const o = t[0].axisValue;
    a = q7e(o), t.forEach((i) => {
      var l;
      a += K7e(
        i.seriesName,
        i.value,
        i.color,
        n.prefix ?? "",
        n.suffix ?? "",
        (l = n == null ? void 0 : n.yAxisLabel) == null ? void 0 : l.decimalPlaces
      );
    });
  }
  return a;
}, Q7e = ({ title: t, labels: e, series: r, lines: n = [], options: a = {} }) => {
  var d, f;
  const { operatingSystem: o } = HC(), i = r.filter((h) => h.area && h.area === !0).length > 0, l = [];
  l.push(...X7e(r, i)), l.push(...jC(n, a.prefix ?? "", a.suffix ?? ""));
  const c = o == np.WINDOWS ? 10 : 0, u = {
    grid: {
      containLabel: !0,
      left: a.autoScale ? c : a.leftSpace ?? 64,
      right: a.autoScale ? 0 : a.rightSpace ?? 80
    },
    dataZoom: [
      {
        type: "inside",
        xAxisIndex: [0],
        minValueSpan: (d = a == null ? void 0 : a.zoom) == null ? void 0 : d.minElements,
        maxValueSpan: (f = a == null ? void 0 : a.zoom) == null ? void 0 : f.maxElements
      }
    ],
    xAxis: {
      type: "category",
      data: e,
      axisTick: {
        show: !0,
        alignWithLabel: !0,
        lineStyle: {
          color: lr.colors.gray4
        }
      },
      nameLocation: "middle",
      axisLine: {
        show: !1,
        lineStyle: {
          color: lr.colors.gray4
        }
      }
    },
    yAxis: {
      type: "value",
      nameLocation: "middle",
      axisLabel: {
        formatter: (h) => ap(h, a.prefix, a.suffix),
        margin: 4,
        overflow: "break",
        hideOverlap: !0
      },
      axisLine: {
        lineStyle: {
          color: lr.colors.gray4
        }
      },
      splitLine: {
        show: !0,
        lineStyle: {
          color: lr.colors.gray7
        }
      }
    },
    series: l,
    // @ts-ignore
    tooltip: {
      trigger: "axis",
      axisPointer: {
        label: {
          show: !1
        },
        lineStyle: {
          color: i ? lr.colors.light20 : lr.colors.gray5,
          width: 3
        }
      },
      backgroundColor: lr.colors.gray2,
      padding: 16,
      borderWidth: 0,
      textStyle: {
        color: lr.colors.light20
      },
      formatter: (h, v, p) => WC(h, v, p, a),
      extraCssText: "border-radius: 20px;"
    }
  };
  return t && (u.title = {
    text: t,
    textStyle: {
      color: lr.title.color,
      fontWeight: lr.title.fontWeight,
      fontFamily: lr.title.fontFamily
    }
  }), a.legend && a.legend.show && (u.legend = {
    show: !0,
    icon: "path://M8 0h16s8 0 8 8v0s0 8 -8 8h-16s-8 0 -8 -8v0s0 -8 8 -8",
    itemStyle: {
      borderWidth: 3
    },
    bottom: a.legend.bottom ?? 0
  }), Gt([
    lC,
    l5,
    n5,
    a5,
    o5,
    i5,
    NC,
    ZC
  ]), /* @__PURE__ */ C(w1, { echarts: e5, option: u, notMerge: !0, lazyUpdate: !0 });
}, J7e = {
  start: "#00DF7C",
  end: "#DEFCCF"
}, C6e = ({
  title: t,
  labels: e,
  series: r,
  lines: n = [],
  options: a = {}
}) => {
  const o = [r[0]];
  return o[0].area = !0, "colors" in r[0] || (r[0].colors = J7e), /* @__PURE__ */ C(
    Q7e,
    {
      title: t,
      labels: e,
      series: o,
      lines: n,
      options: a
    }
  );
}, epe = "foton__layoutNavigationLinksHistory___3c1u-", tpe = {
  layoutNavigationLinksHistory: epe
}, rpe = ({ navigationHistoryLinks: t, colors: e }) => /* @__PURE__ */ C("div", { className: tpe.layoutNavigationLinksHistory, children: t == null ? void 0 : t.map((r, n) => {
  const a = n + 1 === t.length;
  return /* @__PURE__ */ C(
    "a",
    {
      href: r.url,
      className: G(
        "whitespace-nowrap",
        a ? "font-bold" : "font-regular",
        a ? e == null ? void 0 : e.current : e == null ? void 0 : e.previous
      ),
      children: `${r.label} ${a ? "" : ">"}`
    },
    n
  );
}) }), npe = "foton__layoutHeaderContainer___nvWJD", ape = "foton__layoutHeader___BwiPS", ope = "foton__titleContainer___atxk4", ipe = "foton__title___uiMwj", Kc = {
  layoutHeaderContainer: npe,
  layoutHeader: ape,
  titleContainer: ope,
  title: ipe
}, lpe = ({
  title: t,
  breadCrumbLinks: e,
  children: r,
  breadCrumbColors: n,
  displayLogo: a = !1,
  ...o
}) => {
  const { className: i, ...l } = o;
  return /* @__PURE__ */ Z("header", { className: G(Kc.layoutHeader, i), ...o, children: [
    e && /* @__PURE__ */ C(rpe, { navigationHistoryLinks: e, colors: n }),
    /* @__PURE__ */ Z("div", { className: Kc.layoutHeaderContainer, children: [
      /* @__PURE__ */ Z("div", { className: Kc.titleContainer, children: [
        a && /* @__PURE__ */ C(D8, {}),
        /* @__PURE__ */ C("h1", { className: Kc.title, children: t })
      ] }),
      r
    ] })
  ] });
}, spe = "foton__container___SKcnh", cpe = "foton__headerContainer___4GiKz", upe = "foton__headerItemsContainer___g7W9N", dpe = "foton__contentContainer___ynEAk", Qc = {
  container: spe,
  headerContainer: cpe,
  headerItemsContainer: upe,
  contentContainer: dpe
}, E6e = ({ headerProps: t, menuProps: e, children: r }) => {
  const { displayDesktop: n, ...a } = { ...t };
  return /* @__PURE__ */ Z("div", { className: Qc.container, children: [
    /* @__PURE__ */ C("aside", { className: "hidden md:grid", children: /* @__PURE__ */ C(Zne, { ...e, className: e.className }) }),
    /* @__PURE__ */ Z("div", { className: Qc.headerContainer, children: [
      /* @__PURE__ */ C(
        lpe,
        {
          ...a,
          className: G(t.className, t.displayDesktop ? "" : "md:hidden"),
          children: /* @__PURE__ */ Z("div", { className: Qc.headerItemsContainer, children: [
            t.children,
            /* @__PURE__ */ C("div", { className: "block md:hidden", children: /* @__PURE__ */ C(oie, { ...e }) })
          ] })
        }
      ),
      /* @__PURE__ */ C("main", { className: Qc.contentContainer, children: r })
    ] })
  ] });
}, fpe = "foton__container___HMY2y", hpe = "foton__indicators___GIZhb", vpe = "foton__indicator___-3tJU", ppe = "foton__icon___xg5pb", ti = {
  container: fpe,
  "indicator-container": "foton__indicator-container___ozIia",
  indicators: hpe,
  indicator: vpe,
  icon: ppe
}, gpe = ({
  title: t,
  color: e,
  value: r,
  size: n = 50,
  suffix: a,
  prefix: o,
  valueFormatter: i = (l) => l
}) => /* @__PURE__ */ Z("div", { className: ti["indicator-container"], children: [
  /* @__PURE__ */ C("span", { className: ti.indicator, style: {
    width: n,
    height: n,
    backgroundColor: e
  } }),
  /* @__PURE__ */ C("div", { children: /* @__PURE__ */ C("h2", { children: t }) }),
  /* @__PURE__ */ C("div", { children: /* @__PURE__ */ Z("p", { children: [
    o ?? "",
    i(r),
    a ?? ""
  ] }) })
] }), mpe = {
  icon: "LightBulbIcon"
};
function sw() {
  const { innerWidth: t, innerHeight: e } = window;
  return {
    width: t,
    height: e
  };
}
function zC() {
  const [t, e] = gt(sw());
  return En(() => {
    function r() {
      e(sw());
    }
    return window.addEventListener("resize", r), () => window.removeEventListener("resize", r);
  }, []), t;
}
const S6e = ({
  title: t,
  amountValue: e,
  progressLine: r,
  data: n,
  progress: a,
  indicator: o,
  icon: i
}) => {
  const l = {
    progressWidth: r.width,
    titleFontSize: t.size || 40,
    valueFontSize: e ? e.size : 64,
    iconSize: i ? i.size : 0,
    iconTop: i ? 30 : 0
  }, [c, u] = gt(l), { width: d } = zC();
  En(() => {
    let p = l;
    d <= 515 && (p = {
      ...p,
      titleFontSize: l.titleFontSize - 5,
      valueFontSize: l.valueFontSize - 5
    }), d <= 470 && (p = {
      ...p,
      iconSize: i ? i.size - 10 : 0
    }), d <= 440 && (p = {
      ...p,
      progressWidth: l.progressWidth - 5
    }), d <= 420 && (p = {
      ...p,
      iconSize: i ? i.size - 20 : 0,
      iconTop: l.iconTop + 2
    }), d <= 385 && (p = {
      ...p,
      titleFontSize: l.titleFontSize - 5,
      valueFontSize: l.valueFontSize - 5,
      iconTop: l.iconTop + 5
    }), u((g) => ({
      ...g,
      ...p
    }));
  }, [d]);
  const f = (p) => p && p.pattern === "linear" ? {
    type: "linear",
    x: 199.812 / 200,
    y: 204.095 / 205,
    x2: 11.5074 / 200,
    y2: 129.795 / 205,
    colorStops: [
      // @ts-ignore
      { offset: 0, color: at.colors.primary[50] },
      // @ts-ignore
      { offset: 1, color: at.colors.primary[35] }
    ]
  } : at.colors.primary[0], h = {
    width: c.iconSize,
    height: c.iconSize,
    left: `calc(50% - ${c.iconSize / 2}px)`,
    top: c.iconTop + "%"
  }, v = {
    grid: {
      left: 0,
      top: 0
    },
    textStyle: {
      fontFamily: at.fontFamily.sans[0],
      fontWeight: "normal"
    },
    series: [
      {
        type: "gauge",
        endAngle: a.endAngle,
        startAngle: a.startAngle,
        progress: {
          show: !0,
          roundCap: !0,
          width: c.progressWidth,
          itemStyle: {
            // @ts-ignore
            color: f(n.color)
          }
        },
        axisLine: {
          show: !0,
          roundCap: !0,
          lineStyle: {
            width: c.progressWidth,
            // @ts-ignore
            color: [[1, at.colors.gray[10]]]
          }
        },
        axisTick: {
          show: !1
        },
        splitLine: {
          show: !1
        },
        axisLabel: {
          show: !1
        },
        anchor: {
          show: !1
        },
        pointer: {
          show: !1
        },
        data: [
          {
            title: {
              show: !0,
              // @ts-ignore
              color: t.color,
              fontSize: c.titleFontSize + "px",
              offsetCenter: t.offsetCenter ?? [0, "44%"],
              width: t.width ?? 300,
              overflow: t.overflow ?? "none"
            },
            detail: {
              // @ts-ignore
              color: e.color || at.colors.gray[80],
              formatter: (p) => `${a.prefix ?? ""}${p.toFixed(0)}${a.suffix ?? ""}`,
              fontSize: c.valueFontSize + "px",
              offsetCenter: [0, "20%"]
            },
            value: n.value,
            name: t.value
          }
        ]
      }
    ]
  };
  return Gt([ive, l5, n5, a5, o5, i5]), /* @__PURE__ */ Z("div", { className: ti.container, children: [
    /* @__PURE__ */ Z("div", { className: "w-full relative", children: [
      /* @__PURE__ */ C(
        w1,
        {
          echarts: e5,
          style: {
            minHeight: "200px",
            width: "100%"
          },
          option: v,
          notMerge: !0,
          lazyUpdate: !0
        }
      ),
      i && /* @__PURE__ */ C(Me, { style: h, extraClassNames: ti.icon, icon: i.name ?? mpe.icon })
    ] }),
    /* @__PURE__ */ C("div", { className: G(ti.container, ti.indicators), children: o ? /* @__PURE__ */ C(
      gpe,
      {
        title: n.name,
        value: n.value,
        color: f(n.color),
        ...o
      },
      n.name
    ) : null })
  ] });
}, R6e = ({ prefix: t, suffix: e, data: r, options: n, autoScale: a }) => {
  var u;
  const { colors: o } = at, c = {
    color: Object.keys(o.primary).map((d) => o.primary[d]).sort(),
    series: [
      {
        type: "pie",
        center: ["50%", "40%"],
        radius: ["40%", "70%"],
        avoidLabelOverlap: !0,
        itemStyle: {
          borderRadius: 10,
          borderColor: "#fff",
          borderWidth: 2
        },
        label: {
          show: !1
        },
        emphasis: {
          label: {
            show: !1
          }
        },
        labelLine: {
          show: !0
        },
        data: r
      }
    ],
    tooltip: {
      trigger: "item",
      valueFormatter: (d, f) => `${t ?? ""}${d}${e ?? ""}`,
      borderWidth: 0
    },
    legend: {
      bottom: ((u = n == null ? void 0 : n.legend) == null ? void 0 : u.bottom) || a && "0" || "5%",
      left: "center"
    }
  };
  return Gt([p2e, l5, n5, a5, o5, i5]), /* @__PURE__ */ C(
    w1,
    {
      echarts: e5,
      option: c,
      notMerge: !0,
      lazyUpdate: !0,
      style: a ? {
        height: "100%",
        width: "100%"
      } : void 0
    }
  );
}, wpe = (t) => {
  if (t.length == 0)
    return {};
  const e = {};
  if (t[0].data)
    for (let r = 0; r < t[0].data.length; ++r)
      for (let n = 0; n < t.length; ++n) {
        const a = t[n].stack;
        if (!a)
          continue;
        e[a] || (e[a] = {
          stackStart: [],
          stackEnd: []
        });
        const o = e[a], i = t[n].data[r];
        i && i !== "-" && (o.stackStart[r] == null && (o.stackStart[r] = n), o.stackEnd[r] = n);
      }
  return e;
}, ype = (t, e) => {
  let r = [];
  if (e) {
    const n = [];
    t.forEach((o) => {
      let i = JSON.parse(JSON.stringify(o));
      i.stack = "any", n.push(i);
    });
    const a = wpe(n);
    for (let o = 0; o < n.length; ++o) {
      const i = n[o].data, l = a[n[o].stack ?? "any"];
      if (i)
        for (let c = 0; c < i.length; ++c) {
          const d = l.stackEnd[c] === o ? 20 : 0;
          i[c] = {
            value: i[c],
            itemStyle: {
              borderRadius: [d, d, 0, 0]
            }
          };
        }
    }
    n.forEach((o, i) => {
      r.push({
        type: "bar",
        stack: e ? "any" : void 0,
        roundCap: !0,
        data: o.data,
        name: o.name,
        color: o.color
      });
    });
  } else
    t.forEach((n, a) => {
      r.push({
        type: "bar",
        stack: e ? "any" : void 0,
        roundCap: !0,
        data: n.data,
        name: n.name,
        itemStyle: {
          borderRadius: [50, 50, 0, 0]
        },
        color: n.color
      });
    });
  return r;
}, bpe = (t) => {
  const e = [];
  if (t.length > 0)
    for (const r of t)
      e.push({
        type: "line",
        data: r.data,
        color: r.color,
        name: r.name,
        smooth: !0,
        symbol: "none",
        lineStyle: (r == null ? void 0 : r.lineStyle) ?? {
          type: "dashed"
        },
        markLine: r.markLineData ? {
          silent: !0,
          label: { show: !1 },
          symbol: "none",
          lineStyle: {
            color: r.color,
            ...r.lineStyle ? r == null ? void 0 : r.lineStyle : {
              type: "dashed"
            }
          },
          data: r.markLineData.map((n) => ({
            ...n
          }))
        } : void 0
      });
  return e;
}, M6e = ({
  title: t,
  labels: e,
  series: r,
  lines: n = [],
  options: a = {},
  lineSeries: o = [],
  stack: i = !1,
  yAxisMax: l,
  yAxisMin: c,
  xAxisMax: u
}) => {
  var p, g;
  const { operatingSystem: d } = HC(), f = [];
  f.push(...ype(r, i)), f.push(...bpe(o)), f.push(...jC(n, a.prefix ?? "", a.suffix ?? ""));
  const h = d == np.WINDOWS ? 10 : 0, v = {
    grid: {
      containLabel: !0,
      left: a.autoScale ? h : a.leftSpace ?? 64,
      right: a.autoScale ? 0 : a.rightSpace ?? 80
    },
    dataZoom: [
      {
        type: "inside",
        xAxisIndex: [0],
        minValueSpan: (p = a == null ? void 0 : a.zoom) == null ? void 0 : p.minElements,
        maxValueSpan: (g = a == null ? void 0 : a.zoom) == null ? void 0 : g.maxElements
      }
    ],
    xAxis: {
      type: "category",
      data: e,
      max: u,
      axisTick: {
        show: !0,
        alignWithLabel: !0,
        lineStyle: {
          // @ts-ignore
          color: at.colors.gray[40]
        }
      },
      nameLocation: "middle",
      axisLine: {
        show: !1,
        lineStyle: {
          // @ts-ignore
          color: at.colors.gray[40]
        }
      }
    },
    yAxis: {
      type: "value",
      nameLocation: "middle",
      max: l,
      min: c,
      axisLabel: {
        formatter: (m) => {
          var w;
          return ap(m, a.prefix, a.suffix, (w = a.yAxisLabel) == null ? void 0 : w.decimalPlaces);
        },
        margin: 4,
        overflow: "break",
        hideOverlap: !0
      },
      axisLine: {
        lineStyle: {
          // @ts-ignore
          color: at.colors.gray[40]
        }
      },
      splitLine: {
        lineStyle: {
          // @ts-ignore
          color: at.colors.gray[10]
        }
      }
    },
    series: f,
    // @ts-ignore
    tooltip: {
      trigger: "axis",
      confine: !0,
      axisPointer: {
        label: {
          show: !1
        },
        lineStyle: {
          // @ts-ignore
          color: at.colors.gray[30],
          width: 3
        }
      },
      // @ts-ignore
      backgroundColor: at.colors.gray[60],
      padding: 16,
      borderWidth: 0,
      textStyle: {
        // @ts-ignore
        color: at.colors.light[20]
      },
      extraCssText: "border-radius: 20px;",
      formatter: (m, w, y) => WC(m, w, y, a)
    }
  };
  return t && (v.title = {
    text: t,
    textStyle: {
      // @ts-ignore
      color: at.colors.gray[80],
      fontWeight: "bold",
      fontFamily: at.fontFamily.sans[0]
    }
  }), a.legend && a.legend.show && (v.legend = {
    show: !0,
    icon: "path://M8 0h16s8 0 8 8v0s0 8 -8 8h-16s-8 0 -8 -8v0s0 -8 8 -8",
    itemStyle: {
      borderWidth: 3
    },
    bottom: a.legend.bottom ?? 0
  }), Gt([
    n2e,
    lC,
    l5,
    n5,
    a5,
    o5,
    i5,
    NC,
    ZC
  ]), /* @__PURE__ */ C(w1, { echarts: e5, option: v, notMerge: !0, lazyUpdate: !0 });
}, A6e = ({
  size: t = 32,
  // @ts-ignore
  color: e = at.colors.primary[60],
  backgroundColorClassname: r = "bg-primary-10"
}) => /* @__PURE__ */ C("div", { className: G("p-2 rounded-2xl", r), children: /* @__PURE__ */ C("svg", { width: t, height: t, viewBox: "0 0 14 15", fill: "none", children: /* @__PURE__ */ C("path", { d: "M9.80932 9.24129C9.24163 10.164 8.26346 10.7157 7.20087 10.7157C5.49199 10.7157 4.10626 9.26843 4.10626 7.49849C4.10626 5.72855 5.49199 4.28426 7.19796 4.28426C8.31004 4.28426 9.3377 4.89937 9.89374 5.88535M7 1.5C10.3137 1.5 13 4.18629 13 7.5C13 10.8137 10.3137 13.5 7 13.5C3.68629 13.5 1 10.8137 1 7.5C1 4.18629 3.68629 1.5 7 1.5Z", stroke: e, strokeWidth: 1.25, strokeMiterlimit: 10, strokeLinecap: "round" }) }) }), _pe = "foton__container___alpt6", xpe = "foton__icon___jo-Aq", Cpe = "foton__iconSmall___SomQm", Epe = "foton__iconLarge___ezPf-", Eu = {
  container: _pe,
  icon: xpe,
  iconSmall: Cpe,
  iconLarge: Epe
}, Spe = (t) => t ? {
  sm: Eu.iconSmall,
  md: "",
  lg: Eu.iconLarge
}[t] ?? "" : "", GC = ({ icon: t, colors: e, className: r }) => {
  const n = Spe(t.size ?? "md");
  return /* @__PURE__ */ C("div", { className: G(e.backgroundColor, Eu.container), children: /* @__PURE__ */ C(
    Me,
    {
      solid: t.solid ?? !1,
      icon: t.icon,
      extraClassNames: G(Eu.icon, e.color, n, r)
    }
  ) });
}, Rpe = (t) => {
  const e = {
    color: "text-primary-60",
    backgroundColorClassname: "bg-primary-10"
  };
  return {
    primary: e,
    secondary: {
      color: "text-secondary-0",
      backgroundColorClassname: "bg-secondary-10"
    },
    danger: {
      color: "text-orange-30",
      backgroundColorClassname: "bg-orange-10"
    },
    warning: {
      color: "text-yellow-40",
      backgroundColorClassname: "bg-yellow-10"
    }
  }[t] ?? e;
}, Mpe = "foton__cardInfoRoot___Z7LMW", Ape = "foton__innerCardInfoIconContainer___0VPMS", kpe = "foton__cardInfoHeader___vMN4t", Lpe = "foton__cardInfoMessage___aBGim", Tpe = "foton__cardInfoContent___1FyAv", Ope = "foton__cardSubtitle___rzCe2", zo = {
  cardInfoRoot: Mpe,
  innerCardInfoIconContainer: Ape,
  cardInfoHeader: kpe,
  cardInfoMessage: Lpe,
  cardInfoContent: Tpe,
  cardSubtitle: Ope
}, Ipe = ({ type: t, message: e, title: r, subtitle: n, icon: a, variant: o = "normal", ...i }) => {
  const l = Rpe(t), c = o === "compact";
  return /* @__PURE__ */ Z("div", { className: G(zo.cardInfoRoot, i.className ?? ""), children: [
    /* @__PURE__ */ C("div", { className: G(c ? "w-auto" : "w-full"), children: /* @__PURE__ */ C("div", { className: zo.innerCardInfoIconContainer, children: /* @__PURE__ */ C(
      GC,
      {
        icon: {
          icon: a.icon,
          size: a.size ?? "md"
        },
        colors: {
          color: l.color,
          backgroundColor: l.backgroundColorClassname
        }
      }
    ) }) }),
    /* @__PURE__ */ Z("div", { className: G(zo.cardInfoContent, r ? "" : "content-center"), children: [
      r && /* @__PURE__ */ C("h2", { className: zo.cardInfoHeader, children: r }),
      n && /* @__PURE__ */ C("h6", { className: zo.cardSubtitle, children: n }),
      /* @__PURE__ */ C("p", { className: zo.cardInfoMessage, children: e })
    ] })
  ] });
}, Ppe = "foton__cardRootContainer___F-fTV", Dpe = {
  cardRootContainer: Ppe
}, Npe = (t) => {
  const { children: e } = t, r = Dpe.cardRootContainer;
  return /* @__PURE__ */ C("div", { className: G(r, t.className), children: e });
}, Bpe = "foton__cardInfoList___ZOTMj", Fpe = {
  cardInfoList: Bpe
}, $pe = ({ children: t, direction: e, shouldWrap: r, className: n }) => {
  const a = e == "col" ? "flex-col" : "flex-row";
  return /* @__PURE__ */ C("div", { className: G(Fpe.cardInfoList, a, r ? "flex-wrap" : "", n), children: t });
}, Vpe = "foton__cardTitle___Lcoid", Zpe = {
  cardTitle: Vpe
}, Hpe = ({ title: t, props: e }) => {
  const r = Zpe.cardTitle;
  return /* @__PURE__ */ C("h4", { ...e, className: G(r, e == null ? void 0 : e.className), children: t });
}, jpe = (t) => /* @__PURE__ */ C("div", { className: G("flex flex-wrap gap-2", t == null ? void 0 : t.className), children: t.children }), Wpe = (t) => /* @__PURE__ */ C("div", { className: t == null ? void 0 : t.className, children: t.children }), Or = {
  Root: Npe,
  InfoList: $pe,
  Info: Ipe,
  Title: Hpe,
  Header: jpe,
  Content: Wpe
};
function zpe(t, e) {
  return s.useReducer((r, n) => e[r][n] ?? r, t);
}
var Gs = (t) => {
  const { present: e, children: r } = t, n = Gpe(e), a = typeof r == "function" ? r({ present: n.isPresent }) : s.Children.only(r), o = ce(n.ref, Upe(a));
  return typeof r == "function" || n.isPresent ? s.cloneElement(a, { ref: o }) : null;
};
Gs.displayName = "Presence";
function Gpe(t) {
  const [e, r] = s.useState(), n = s.useRef({}), a = s.useRef(t), o = s.useRef("none"), i = t ? "mounted" : "unmounted", [l, c] = zpe(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return s.useEffect(() => {
    const u = Jc(n.current);
    o.current = l === "mounted" ? u : "none";
  }, [l]), Fe(() => {
    const u = n.current, d = a.current;
    if (d !== t) {
      const h = o.current, v = Jc(u);
      t ? c("MOUNT") : v === "none" || (u == null ? void 0 : u.display) === "none" ? c("UNMOUNT") : c(d && h !== v ? "ANIMATION_OUT" : "UNMOUNT"), a.current = t;
    }
  }, [t, c]), Fe(() => {
    if (e) {
      let u;
      const d = e.ownerDocument.defaultView ?? window, f = (v) => {
        const g = Jc(n.current).includes(v.animationName);
        if (v.target === e && g && (c("ANIMATION_END"), !a.current)) {
          const m = e.style.animationFillMode;
          e.style.animationFillMode = "forwards", u = d.setTimeout(() => {
            e.style.animationFillMode === "forwards" && (e.style.animationFillMode = m);
          });
        }
      }, h = (v) => {
        v.target === e && (o.current = Jc(n.current));
      };
      return e.addEventListener("animationstart", h), e.addEventListener("animationcancel", f), e.addEventListener("animationend", f), () => {
        d.clearTimeout(u), e.removeEventListener("animationstart", h), e.removeEventListener("animationcancel", f), e.removeEventListener("animationend", f);
      };
    } else
      c("ANIMATION_END");
  }, [e, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(l),
    ref: s.useCallback((u) => {
      u && (n.current = getComputedStyle(u)), r(u);
    }, [])
  };
}
function Jc(t) {
  return (t == null ? void 0 : t.animationName) || "none";
}
function Upe(t) {
  var n, a;
  let e = (n = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : n.get, r = e && "isReactWarning" in e && e.isReactWarning;
  return r ? t.ref : (e = (a = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : a.get, r = e && "isReactWarning" in e && e.isReactWarning, r ? t.props.ref : t.props.ref || t.ref);
}
function Ype(t, e = []) {
  let r = [];
  function n(o, i) {
    const l = s.createContext(i), c = r.length;
    r = [...r, i];
    const u = (f) => {
      var w;
      const { scope: h, children: v, ...p } = f, g = ((w = h == null ? void 0 : h[t]) == null ? void 0 : w[c]) || l, m = s.useMemo(() => p, Object.values(p));
      return /* @__PURE__ */ C(g.Provider, { value: m, children: v });
    };
    u.displayName = o + "Provider";
    function d(f, h) {
      var g;
      const v = ((g = h == null ? void 0 : h[t]) == null ? void 0 : g[c]) || l, p = s.useContext(v);
      if (p) return p;
      if (i !== void 0) return i;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [u, d];
  }
  const a = () => {
    const o = r.map((i) => s.createContext(i));
    return function(l) {
      const c = (l == null ? void 0 : l[t]) || o;
      return s.useMemo(
        () => ({ [`__scope${t}`]: { ...l, [t]: c } }),
        [l, c]
      );
    };
  };
  return a.scopeName = t, [n, Xpe(a, ...e)];
}
function Xpe(...t) {
  const e = t[0];
  if (t.length === 1) return e;
  const r = () => {
    const n = t.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(o) {
      const i = n.reduce((l, { useScope: c, scopeName: u }) => {
        const f = c(o)[`__scope${u}`];
        return { ...l, ...f };
      }, {});
      return s.useMemo(() => ({ [`__scope${e.scopeName}`]: i }), [i]);
    };
  };
  return r.scopeName = e.scopeName, r;
}
function qpe(t, e) {
  return s.useReducer((r, n) => e[r][n] ?? r, t);
}
var op = "ScrollArea", [UC, k6e] = Ype(op), [Kpe, Er] = UC(op), YC = s.forwardRef(
  (t, e) => {
    const {
      __scopeScrollArea: r,
      type: n = "hover",
      dir: a,
      scrollHideDelay: o = 600,
      ...i
    } = t, [l, c] = s.useState(null), [u, d] = s.useState(null), [f, h] = s.useState(null), [v, p] = s.useState(null), [g, m] = s.useState(null), [w, y] = s.useState(0), [b, _] = s.useState(0), [x, E] = s.useState(!1), [S, M] = s.useState(!1), R = ce(e, (k) => c(k)), A = $i(a);
    return /* @__PURE__ */ C(
      Kpe,
      {
        scope: r,
        type: n,
        dir: A,
        scrollHideDelay: o,
        scrollArea: l,
        viewport: u,
        onViewportChange: d,
        content: f,
        onContentChange: h,
        scrollbarX: v,
        onScrollbarXChange: p,
        scrollbarXEnabled: x,
        onScrollbarXEnabledChange: E,
        scrollbarY: g,
        onScrollbarYChange: m,
        scrollbarYEnabled: S,
        onScrollbarYEnabledChange: M,
        onCornerWidthChange: y,
        onCornerHeightChange: _,
        children: /* @__PURE__ */ C(
          te.div,
          {
            dir: A,
            ...i,
            ref: R,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": w + "px",
              "--radix-scroll-area-corner-height": b + "px",
              ...t.style
            }
          }
        )
      }
    );
  }
);
YC.displayName = op;
var XC = "ScrollAreaViewport", qC = s.forwardRef(
  (t, e) => {
    const { __scopeScrollArea: r, children: n, asChild: a, nonce: o, ...i } = t, l = Er(XC, r), c = s.useRef(null), u = ce(e, c, l.onViewportChange);
    return /* @__PURE__ */ Z(gr, { children: [
      /* @__PURE__ */ C(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: `
[data-radix-scroll-area-viewport] {
  scrollbar-width: none;
  -ms-overflow-style: none;
  -webkit-overflow-scrolling: touch;
}
[data-radix-scroll-area-viewport]::-webkit-scrollbar {
  display: none;
}
:where([data-radix-scroll-area-viewport]) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
:where([data-radix-scroll-area-content]) {
  flex-grow: 1;
}
`
          },
          nonce: o
        }
      ),
      /* @__PURE__ */ C(
        te.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...i,
          asChild: a,
          ref: u,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: l.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: l.scrollbarYEnabled ? "scroll" : "hidden",
            ...t.style
          },
          children: lge({ asChild: a, children: n }, (d) => /* @__PURE__ */ C(
            "div",
            {
              "data-radix-scroll-area-content": "",
              ref: l.onContentChange,
              style: { minWidth: l.scrollbarXEnabled ? "fit-content" : void 0 },
              children: d
            }
          ))
        }
      )
    ] });
  }
);
qC.displayName = XC;
var ln = "ScrollAreaScrollbar", KC = s.forwardRef(
  (t, e) => {
    const { forceMount: r, ...n } = t, a = Er(ln, t.__scopeScrollArea), { onScrollbarXEnabledChange: o, onScrollbarYEnabledChange: i } = a, l = t.orientation === "horizontal";
    return s.useEffect(() => (l ? o(!0) : i(!0), () => {
      l ? o(!1) : i(!1);
    }), [l, o, i]), a.type === "hover" ? /* @__PURE__ */ C(Qpe, { ...n, ref: e, forceMount: r }) : a.type === "scroll" ? /* @__PURE__ */ C(Jpe, { ...n, ref: e, forceMount: r }) : a.type === "auto" ? /* @__PURE__ */ C(QC, { ...n, ref: e, forceMount: r }) : a.type === "always" ? /* @__PURE__ */ C(ip, { ...n, ref: e }) : null;
  }
);
KC.displayName = ln;
var Qpe = s.forwardRef((t, e) => {
  const { forceMount: r, ...n } = t, a = Er(ln, t.__scopeScrollArea), [o, i] = s.useState(!1);
  return s.useEffect(() => {
    const l = a.scrollArea;
    let c = 0;
    if (l) {
      const u = () => {
        window.clearTimeout(c), i(!0);
      }, d = () => {
        c = window.setTimeout(() => i(!1), a.scrollHideDelay);
      };
      return l.addEventListener("pointerenter", u), l.addEventListener("pointerleave", d), () => {
        window.clearTimeout(c), l.removeEventListener("pointerenter", u), l.removeEventListener("pointerleave", d);
      };
    }
  }, [a.scrollArea, a.scrollHideDelay]), /* @__PURE__ */ C(Gs, { present: r || o, children: /* @__PURE__ */ C(
    QC,
    {
      "data-state": o ? "visible" : "hidden",
      ...n,
      ref: e
    }
  ) });
}), Jpe = s.forwardRef((t, e) => {
  const { forceMount: r, ...n } = t, a = Er(ln, t.__scopeScrollArea), o = t.orientation === "horizontal", i = c5(() => c("SCROLL_END"), 100), [l, c] = qpe("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return s.useEffect(() => {
    if (l === "idle") {
      const u = window.setTimeout(() => c("HIDE"), a.scrollHideDelay);
      return () => window.clearTimeout(u);
    }
  }, [l, a.scrollHideDelay, c]), s.useEffect(() => {
    const u = a.viewport, d = o ? "scrollLeft" : "scrollTop";
    if (u) {
      let f = u[d];
      const h = () => {
        const v = u[d];
        f !== v && (c("SCROLL"), i()), f = v;
      };
      return u.addEventListener("scroll", h), () => u.removeEventListener("scroll", h);
    }
  }, [a.viewport, o, c, i]), /* @__PURE__ */ C(Gs, { present: r || l !== "hidden", children: /* @__PURE__ */ C(
    ip,
    {
      "data-state": l === "hidden" ? "hidden" : "visible",
      ...n,
      ref: e,
      onPointerEnter: j(t.onPointerEnter, () => c("POINTER_ENTER")),
      onPointerLeave: j(t.onPointerLeave, () => c("POINTER_LEAVE"))
    }
  ) });
}), QC = s.forwardRef((t, e) => {
  const r = Er(ln, t.__scopeScrollArea), { forceMount: n, ...a } = t, [o, i] = s.useState(!1), l = t.orientation === "horizontal", c = c5(() => {
    if (r.viewport) {
      const u = r.viewport.offsetWidth < r.viewport.scrollWidth, d = r.viewport.offsetHeight < r.viewport.scrollHeight;
      i(l ? u : d);
    }
  }, 10);
  return Ai(r.viewport, c), Ai(r.content, c), /* @__PURE__ */ C(Gs, { present: n || o, children: /* @__PURE__ */ C(
    ip,
    {
      "data-state": o ? "visible" : "hidden",
      ...a,
      ref: e
    }
  ) });
}), ip = s.forwardRef((t, e) => {
  const { orientation: r = "vertical", ...n } = t, a = Er(ln, t.__scopeScrollArea), o = s.useRef(null), i = s.useRef(0), [l, c] = s.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), u = nE(l.viewport, l.content), d = {
    ...n,
    sizes: l,
    onSizesChange: c,
    hasThumb: u > 0 && u < 1,
    onThumbChange: (h) => o.current = h,
    onThumbPointerUp: () => i.current = 0,
    onThumbPointerDown: (h) => i.current = h
  };
  function f(h, v) {
    return oge(h, i.current, l, v);
  }
  return r === "horizontal" ? /* @__PURE__ */ C(
    ege,
    {
      ...d,
      ref: e,
      onThumbPositionChange: () => {
        if (a.viewport && o.current) {
          const h = a.viewport.scrollLeft, v = cw(h, l, a.dir);
          o.current.style.transform = `translate3d(${v}px, 0, 0)`;
        }
      },
      onWheelScroll: (h) => {
        a.viewport && (a.viewport.scrollLeft = h);
      },
      onDragScroll: (h) => {
        a.viewport && (a.viewport.scrollLeft = f(h, a.dir));
      }
    }
  ) : r === "vertical" ? /* @__PURE__ */ C(
    tge,
    {
      ...d,
      ref: e,
      onThumbPositionChange: () => {
        if (a.viewport && o.current) {
          const h = a.viewport.scrollTop, v = cw(h, l);
          o.current.style.transform = `translate3d(0, ${v}px, 0)`;
        }
      },
      onWheelScroll: (h) => {
        a.viewport && (a.viewport.scrollTop = h);
      },
      onDragScroll: (h) => {
        a.viewport && (a.viewport.scrollTop = f(h));
      }
    }
  ) : null;
}), ege = s.forwardRef((t, e) => {
  const { sizes: r, onSizesChange: n, ...a } = t, o = Er(ln, t.__scopeScrollArea), [i, l] = s.useState(), c = s.useRef(null), u = ce(e, c, o.onScrollbarXChange);
  return s.useEffect(() => {
    c.current && l(getComputedStyle(c.current));
  }, [c]), /* @__PURE__ */ C(
    eE,
    {
      "data-orientation": "horizontal",
      ...a,
      ref: u,
      sizes: r,
      style: {
        bottom: 0,
        left: o.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: o.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": s5(r) + "px",
        ...t.style
      },
      onThumbPointerDown: (d) => t.onThumbPointerDown(d.x),
      onDragScroll: (d) => t.onDragScroll(d.x),
      onWheelScroll: (d, f) => {
        if (o.viewport) {
          const h = o.viewport.scrollLeft + d.deltaX;
          t.onWheelScroll(h), oE(h, f) && d.preventDefault();
        }
      },
      onResize: () => {
        c.current && o.viewport && i && n({
          content: o.viewport.scrollWidth,
          viewport: o.viewport.offsetWidth,
          scrollbar: {
            size: c.current.clientWidth,
            paddingStart: Ru(i.paddingLeft),
            paddingEnd: Ru(i.paddingRight)
          }
        });
      }
    }
  );
}), tge = s.forwardRef((t, e) => {
  const { sizes: r, onSizesChange: n, ...a } = t, o = Er(ln, t.__scopeScrollArea), [i, l] = s.useState(), c = s.useRef(null), u = ce(e, c, o.onScrollbarYChange);
  return s.useEffect(() => {
    c.current && l(getComputedStyle(c.current));
  }, [c]), /* @__PURE__ */ C(
    eE,
    {
      "data-orientation": "vertical",
      ...a,
      ref: u,
      sizes: r,
      style: {
        top: 0,
        right: o.dir === "ltr" ? 0 : void 0,
        left: o.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": s5(r) + "px",
        ...t.style
      },
      onThumbPointerDown: (d) => t.onThumbPointerDown(d.y),
      onDragScroll: (d) => t.onDragScroll(d.y),
      onWheelScroll: (d, f) => {
        if (o.viewport) {
          const h = o.viewport.scrollTop + d.deltaY;
          t.onWheelScroll(h), oE(h, f) && d.preventDefault();
        }
      },
      onResize: () => {
        c.current && o.viewport && i && n({
          content: o.viewport.scrollHeight,
          viewport: o.viewport.offsetHeight,
          scrollbar: {
            size: c.current.clientHeight,
            paddingStart: Ru(i.paddingTop),
            paddingEnd: Ru(i.paddingBottom)
          }
        });
      }
    }
  );
}), [rge, JC] = UC(ln), eE = s.forwardRef((t, e) => {
  const {
    __scopeScrollArea: r,
    sizes: n,
    hasThumb: a,
    onThumbChange: o,
    onThumbPointerUp: i,
    onThumbPointerDown: l,
    onThumbPositionChange: c,
    onDragScroll: u,
    onWheelScroll: d,
    onResize: f,
    ...h
  } = t, v = Er(ln, r), [p, g] = s.useState(null), m = ce(e, (R) => g(R)), w = s.useRef(null), y = s.useRef(""), b = v.viewport, _ = n.content - n.viewport, x = Ke(d), E = Ke(c), S = c5(f, 10);
  function M(R) {
    if (w.current) {
      const A = R.clientX - w.current.left, k = R.clientY - w.current.top;
      u({ x: A, y: k });
    }
  }
  return s.useEffect(() => {
    const R = (A) => {
      const k = A.target;
      (p == null ? void 0 : p.contains(k)) && x(A, _);
    };
    return document.addEventListener("wheel", R, { passive: !1 }), () => document.removeEventListener("wheel", R, { passive: !1 });
  }, [b, p, _, x]), s.useEffect(E, [n, E]), Ai(p, S), Ai(v.content, S), /* @__PURE__ */ C(
    rge,
    {
      scope: r,
      scrollbar: p,
      hasThumb: a,
      onThumbChange: Ke(o),
      onThumbPointerUp: Ke(i),
      onThumbPositionChange: E,
      onThumbPointerDown: Ke(l),
      children: /* @__PURE__ */ C(
        te.div,
        {
          ...h,
          ref: m,
          style: { position: "absolute", ...h.style },
          onPointerDown: j(t.onPointerDown, (R) => {
            R.button === 0 && (R.target.setPointerCapture(R.pointerId), w.current = p.getBoundingClientRect(), y.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", v.viewport && (v.viewport.style.scrollBehavior = "auto"), M(R));
          }),
          onPointerMove: j(t.onPointerMove, M),
          onPointerUp: j(t.onPointerUp, (R) => {
            const A = R.target;
            A.hasPointerCapture(R.pointerId) && A.releasePointerCapture(R.pointerId), document.body.style.webkitUserSelect = y.current, v.viewport && (v.viewport.style.scrollBehavior = ""), w.current = null;
          })
        }
      )
    }
  );
}), Su = "ScrollAreaThumb", tE = s.forwardRef(
  (t, e) => {
    const { forceMount: r, ...n } = t, a = JC(Su, t.__scopeScrollArea);
    return /* @__PURE__ */ C(Gs, { present: r || a.hasThumb, children: /* @__PURE__ */ C(nge, { ref: e, ...n }) });
  }
), nge = s.forwardRef(
  (t, e) => {
    const { __scopeScrollArea: r, style: n, ...a } = t, o = Er(Su, r), i = JC(Su, r), { onThumbPositionChange: l } = i, c = ce(
      e,
      (f) => i.onThumbChange(f)
    ), u = s.useRef(), d = c5(() => {
      u.current && (u.current(), u.current = void 0);
    }, 100);
    return s.useEffect(() => {
      const f = o.viewport;
      if (f) {
        const h = () => {
          if (d(), !u.current) {
            const v = ige(f, l);
            u.current = v, l();
          }
        };
        return l(), f.addEventListener("scroll", h), () => f.removeEventListener("scroll", h);
      }
    }, [o.viewport, d, l]), /* @__PURE__ */ C(
      te.div,
      {
        "data-state": i.hasThumb ? "visible" : "hidden",
        ...a,
        ref: c,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...n
        },
        onPointerDownCapture: j(t.onPointerDownCapture, (f) => {
          const v = f.target.getBoundingClientRect(), p = f.clientX - v.left, g = f.clientY - v.top;
          i.onThumbPointerDown({ x: p, y: g });
        }),
        onPointerUp: j(t.onPointerUp, i.onThumbPointerUp)
      }
    );
  }
);
tE.displayName = Su;
var lp = "ScrollAreaCorner", rE = s.forwardRef(
  (t, e) => {
    const r = Er(lp, t.__scopeScrollArea), n = !!(r.scrollbarX && r.scrollbarY);
    return r.type !== "scroll" && n ? /* @__PURE__ */ C(age, { ...t, ref: e }) : null;
  }
);
rE.displayName = lp;
var age = s.forwardRef((t, e) => {
  const { __scopeScrollArea: r, ...n } = t, a = Er(lp, r), [o, i] = s.useState(0), [l, c] = s.useState(0), u = !!(o && l);
  return Ai(a.scrollbarX, () => {
    var f;
    const d = ((f = a.scrollbarX) == null ? void 0 : f.offsetHeight) || 0;
    a.onCornerHeightChange(d), c(d);
  }), Ai(a.scrollbarY, () => {
    var f;
    const d = ((f = a.scrollbarY) == null ? void 0 : f.offsetWidth) || 0;
    a.onCornerWidthChange(d), i(d);
  }), u ? /* @__PURE__ */ C(
    te.div,
    {
      ...n,
      ref: e,
      style: {
        width: o,
        height: l,
        position: "absolute",
        right: a.dir === "ltr" ? 0 : void 0,
        left: a.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...t.style
      }
    }
  ) : null;
});
function Ru(t) {
  return t ? parseInt(t, 10) : 0;
}
function nE(t, e) {
  const r = t / e;
  return isNaN(r) ? 0 : r;
}
function s5(t) {
  const e = nE(t.viewport, t.content), r = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, n = (t.scrollbar.size - r) * e;
  return Math.max(n, 18);
}
function oge(t, e, r, n = "ltr") {
  const a = s5(r), o = a / 2, i = e || o, l = a - i, c = r.scrollbar.paddingStart + i, u = r.scrollbar.size - r.scrollbar.paddingEnd - l, d = r.content - r.viewport, f = n === "ltr" ? [0, d] : [d * -1, 0];
  return aE([c, u], f)(t);
}
function cw(t, e, r = "ltr") {
  const n = s5(e), a = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, o = e.scrollbar.size - a, i = e.content - e.viewport, l = o - n, c = r === "ltr" ? [0, i] : [i * -1, 0], u = qf(t, c);
  return aE([0, i], [0, l])(u);
}
function aE(t, e) {
  return (r) => {
    if (t[0] === t[1] || e[0] === e[1]) return e[0];
    const n = (e[1] - e[0]) / (t[1] - t[0]);
    return e[0] + n * (r - t[0]);
  };
}
function oE(t, e) {
  return t > 0 && t < e;
}
var ige = (t, e = () => {
}) => {
  let r = { left: t.scrollLeft, top: t.scrollTop }, n = 0;
  return function a() {
    const o = { left: t.scrollLeft, top: t.scrollTop }, i = r.left !== o.left, l = r.top !== o.top;
    (i || l) && e(), r = o, n = window.requestAnimationFrame(a);
  }(), () => window.cancelAnimationFrame(n);
};
function c5(t, e) {
  const r = Ke(t), n = s.useRef(0);
  return s.useEffect(() => () => window.clearTimeout(n.current), []), s.useCallback(() => {
    window.clearTimeout(n.current), n.current = window.setTimeout(r, e);
  }, [r, e]);
}
function Ai(t, e) {
  const r = Ke(e);
  Fe(() => {
    let n = 0;
    if (t) {
      const a = new ResizeObserver(() => {
        cancelAnimationFrame(n), n = window.requestAnimationFrame(r);
      });
      return a.observe(t), () => {
        window.cancelAnimationFrame(n), a.unobserve(t);
      };
    }
  }, [t, r]);
}
function lge(t, e) {
  const { asChild: r, children: n } = t;
  if (!r) return typeof e == "function" ? e(n) : e;
  const a = s.Children.only(n);
  return s.cloneElement(a, {
    children: typeof e == "function" ? e(a.props.children) : e
  });
}
var sge = YC, cge = qC, uw = KC, dw = tE, uge = rE;
const dge = "foton__scrollAreaRoot___mncQn", fge = "foton__scrollAreaViewport___2-YKx", hge = "foton__scrollAreaScrollbar___jDtny", vge = "foton__scrollAreaThumb___QvWMm", pge = "foton__scrollAreaCorner___guvfu", Ha = {
  scrollAreaRoot: dge,
  scrollAreaViewport: fge,
  scrollAreaScrollbar: hge,
  scrollAreaThumb: vge,
  scrollAreaCorner: pge
}, gge = ({ children: t, width: e, height: r }) => /* @__PURE__ */ Z(sge, { className: Ha.scrollAreaRoot, style: {
  width: e,
  height: r
}, children: [
  /* @__PURE__ */ C(cge, { className: Ha.scrollAreaViewport, children: t }),
  /* @__PURE__ */ C(
    uw,
    {
      className: Ha.scrollAreaScrollbar,
      orientation: "vertical",
      children: /* @__PURE__ */ C(dw, { className: Ha.scrollAreaThumb })
    }
  ),
  /* @__PURE__ */ C(
    uw,
    {
      className: Ha.scrollAreaScrollbar,
      orientation: "horizontal",
      children: /* @__PURE__ */ C(dw, { className: Ha.scrollAreaThumb })
    }
  ),
  /* @__PURE__ */ C(uge, { className: Ha.scrollAreaCorner })
] }), L6e = ({ title: t, items: e = [], direction: r = "row", wrap: n }) => {
  const a = e.length > 4, o = a && r == "row", i = {
    width: "54rem",
    height: "20rem"
  };
  return /* @__PURE__ */ Z(Or.Root, { children: [
    /* @__PURE__ */ C(Or.Header, { className: "pb-4", children: /* @__PURE__ */ C(Or.Title, { title: t }) }),
    /* @__PURE__ */ C(
      gge,
      {
        height: a && r == "col" ? i.height : "auto",
        width: o ? i.width : "auto",
        children: /* @__PURE__ */ C(Or.InfoList, { direction: r, shouldWrap: n, className: o ? "pb-4" : "", children: e.map((l, c) => /* @__PURE__ */ C(Or.Info, { ...l }, c)) })
      }
    )
  ] });
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var b2 = function(t, e) {
  return b2 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var a in n) n.hasOwnProperty(a) && (r[a] = n[a]);
  }, b2(t, e);
};
function mge(t, e) {
  b2(t, e);
  function r() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
}
var wge = 100, yge = 100, fw = 50, _2 = 50, x2 = 50;
function hw(t) {
  var e = t.className, r = t.counterClockwise, n = t.dashRatio, a = t.pathRadius, o = t.strokeWidth, i = t.style;
  return Yo("path", { className: e, style: Object.assign({}, i, _ge({ pathRadius: a, dashRatio: n, counterClockwise: r })), d: bge({
    pathRadius: a,
    counterClockwise: r
  }), strokeWidth: o, fillOpacity: 0 });
}
function bge(t) {
  var e = t.pathRadius, r = t.counterClockwise, n = e, a = r ? 1 : 0;
  return `
      M ` + _2 + "," + x2 + `
      m 0,-` + n + `
      a ` + n + "," + n + " " + a + " 1 1 0," + 2 * n + `
      a ` + n + "," + n + " " + a + " 1 1 0,-" + 2 * n + `
    `;
}
function _ge(t) {
  var e = t.counterClockwise, r = t.dashRatio, n = t.pathRadius, a = Math.PI * 2 * n, o = (1 - r) * a;
  return {
    strokeDasharray: a + "px " + a + "px",
    strokeDashoffset: (e ? -o : o) + "px"
  };
}
var vw = function(t) {
  mge(e, t);
  function e() {
    return t !== null && t.apply(this, arguments) || this;
  }
  return e.prototype.getBackgroundPadding = function() {
    return this.props.background ? this.props.backgroundPadding : 0;
  }, e.prototype.getPathRadius = function() {
    return fw - this.props.strokeWidth / 2 - this.getBackgroundPadding();
  }, e.prototype.getPathRatio = function() {
    var r = this.props, n = r.value, a = r.minValue, o = r.maxValue, i = Math.min(Math.max(n, a), o);
    return (i - a) / (o - a);
  }, e.prototype.render = function() {
    var r = this.props, n = r.circleRatio, a = r.className, o = r.classes, i = r.counterClockwise, l = r.styles, c = r.strokeWidth, u = r.text, d = this.getPathRadius(), f = this.getPathRatio();
    return Yo(
      "svg",
      { className: o.root + " " + a, style: l.root, viewBox: "0 0 " + wge + " " + yge, "data-test-id": "CircularProgressbar" },
      this.props.background ? Yo("circle", { className: o.background, style: l.background, cx: _2, cy: x2, r: fw }) : null,
      Yo(hw, { className: o.trail, counterClockwise: i, dashRatio: n, pathRadius: d, strokeWidth: c, style: l.trail }),
      Yo(hw, { className: o.path, counterClockwise: i, dashRatio: f * n, pathRadius: d, strokeWidth: c, style: l.path }),
      u ? Yo("text", { className: o.text, style: l.text, x: _2, y: x2 }, u) : null
    );
  }, e.defaultProps = {
    background: !1,
    backgroundPadding: 0,
    circleRatio: 1,
    classes: {
      root: "CircularProgressbar",
      trail: "CircularProgressbar-trail",
      path: "CircularProgressbar-path",
      text: "CircularProgressbar-text",
      background: "CircularProgressbar-background"
    },
    counterClockwise: !1,
    className: "",
    maxValue: 100,
    minValue: 0,
    strokeWidth: 8,
    styles: {
      root: {},
      trail: {},
      path: {},
      text: {},
      background: {}
    },
    text: ""
  }, e;
}(ES);
const xge = "foton__path___jRXXE", Cge = "foton__trail___OJEfE", Ege = "foton__text___n0xyp", Sge = "foton__background___T8Ic8", e0 = {
  path: xge,
  trail: Cge,
  text: Ege,
  background: Sge
}, Rge = ({ progressValue: t, width: e = 10 }) => {
  const { classes: r } = vw.defaultProps;
  return r.text = G(r.text, e0.text), r.path = G(r.path, e0.path), r.trail = G(r.trail, e0.trail), r.background = G(r.background, e0.background), /* @__PURE__ */ C(
    vw,
    {
      value: t,
      text: `${t}%`,
      classes: r,
      strokeWidth: e
    }
  );
}, T6e = ({ title: t, value: e, children: r, icon: n }) => /* @__PURE__ */ Z(Or.Root, { children: [
  /* @__PURE__ */ Z(Or.Header, { className: "pb-3", children: [
    /* @__PURE__ */ C(Or.Title, { title: t }),
    n && /* @__PURE__ */ C(
      Gl,
      {
        ...n
      }
    )
  ] }),
  /* @__PURE__ */ Z(Or.Content, { className: "flex flex-wrap flex-row", children: [
    /* @__PURE__ */ C("div", { className: "w-full md:w-3/4", children: r }),
    /* @__PURE__ */ C("div", { className: "w-full md:w-1/4", style: { height: "auto" }, children: /* @__PURE__ */ C(Rge, { progressValue: e, width: 18 }) })
  ] })
] }), Mge = "foton__contentContainer___lqPHh", Age = "foton__contentInnerContainer___9KmfV", kge = "foton__mainContainer___s8DY2", Lge = "foton__iconContainer___TTCi4", Tge = "foton__outerIconContainer___7HlpK", Oge = "foton__tooltipContainer___ycPBE", Ige = "foton__infoContainer___Zfcwq", Pge = "foton__headerContainer___7ink4", Dge = "foton__header___2nj-M", Nge = "foton__tagContainer___S87ve", Bge = "foton__valueHeader___qpwvI", Fge = "foton__subtitle___blIId", or = {
  contentContainer: Mge,
  contentInnerContainer: Age,
  mainContainer: kge,
  iconContainer: Lge,
  outerIconContainer: Tge,
  tooltipContainer: Oge,
  infoContainer: Ige,
  headerContainer: Pge,
  header: Dge,
  tagContainer: Nge,
  valueHeader: Bge,
  subtitle: Fge
}, $ge = (t) => {
  let e = {
    icon: "InformationCircleIcon",
    color: "primaryLight"
  };
  switch (t) {
    case "up":
      e = {
        icon: "ArrowUpRightIcon",
        color: "primaryLight"
      };
      break;
    case "down":
      e = {
        icon: "ArrowDownRightIcon",
        color: "orangeLight"
      };
      break;
  }
  return e;
}, Vge = (t) => t ? /* @__PURE__ */ C(Gl, { content: t, side: "top", icon: { icon: "InformationCircleIcon" } }) : null, O6e = ({
  value: t,
  valueHeaderClassName: e,
  title: r,
  ratio: n,
  icon: a,
  subtitle: o,
  variant: i = "normal",
  tooltip: l,
  buttonIcon: c,
  action: u,
  ...d
}) => {
  var w, y;
  const { className: f, ...h } = d;
  let v = null;
  n && (v = $ge(n.direction));
  const p = i === "compact", g = i === "minimal";
  let m = null;
  return l && l.content && (m = Vge(l.content)), /* @__PURE__ */ C(Or.Root, { className: f, ...h, children: /* @__PURE__ */ Z(Or.Content, { className: G(or.contentContainer, p ? "gap-4" : ""), children: [
    /* @__PURE__ */ Z("div", { className: G(or.contentInnerContainer, p ? "gap-4" : ""), children: [
      /* @__PURE__ */ Z("div", { className: G(or.mainContainer, p ? "w-auto" : "w-full mb-3", g ? "mb-8" : ""), children: [
        /* @__PURE__ */ C("div", { className: or.outerIconContainer, children: /* @__PURE__ */ C("div", { className: G(or.iconContainer, a.containerClassName), children: /* @__PURE__ */ C(
          GC,
          {
            icon: {
              icon: a.name,
              solid: a.solid ?? !1,
              size: a.size ?? "md"
            },
            colors: {
              color: ((w = a.colors) == null ? void 0 : w.icon) ?? "text-primary-60",
              backgroundColor: ((y = a.colors) == null ? void 0 : y.background) ?? "bg-primary-10"
            }
          }
        ) }) }),
        !u && !p && !c && m && /* @__PURE__ */ C("div", { className: or.tooltipContainer, children: m }),
        !u && !p && c && /* @__PURE__ */ C("div", { children: /* @__PURE__ */ C(gi, { ...c }) })
      ] }),
      /* @__PURE__ */ Z("div", { className: p ? "w-auto" : "w-full", children: [
        /* @__PURE__ */ Z("div", { className: or.infoContainer, children: [
          /* @__PURE__ */ C("div", { className: or.headerContainer, children: /* @__PURE__ */ C("h2", { className: or.header, children: r }) }),
          n && v && /* @__PURE__ */ C(gr, { children: /* @__PURE__ */ C("div", { className: or.tagContainer, children: /* @__PURE__ */ C(
            I8,
            {
              color: v.color,
              kind: "icon",
              label: n.value,
              icon: { icon: v.icon, solid: !0 },
              position: "end"
            }
          ) }) }),
          !p && l && (u || c) && m,
          p && l && m
        ] }),
        o && /* @__PURE__ */ C("div", { className: "w-full", children: /* @__PURE__ */ C("p", { className: or.subtitle, children: o }) }),
        /* @__PURE__ */ C("h3", { className: G(or.valueHeader, e), children: t })
      ] })
    ] }),
    u && /* @__PURE__ */ C("div", { className: "justify-items-end flex-1", children: /* @__PURE__ */ C(Vu, { variant: "ghost", className: "h-full", onClick: u, children: /* @__PURE__ */ C(Me, { icon: "ArrowRightIcon", extraClassNames: "size-8 text-gray-70" }) }) })
  ] }) });
}, Zge = "foton__errorContainer___X8Qrz", Hge = "foton__errorText___CJyGE", jge = "foton__labelContent___oulZJ", Wge = "foton__labelContainer___E3-Ly", zge = "foton__selectTrigger___g81lD", Gge = "foton__selectTriggerStart___RtfxX", Uge = "foton__selectTriggerError___gW1TE", Yge = "foton__selectIcon___JngcJ", Xge = "foton__selectContent___LBiEM", qge = "foton__selectViewport___FIJvX", Kge = "foton__selectItem___prrxf", Qge = "foton__selectLabel___hFCYi", Jge = "foton__selectSeparator___6bM3i", eme = "foton__selectItemIndicator___-KK7d", tme = "foton__selectScrollButton___xtBjj", Bt = {
  errorContainer: Zge,
  errorText: Hge,
  labelContent: jge,
  labelContainer: Wge,
  selectTrigger: zge,
  selectTriggerStart: Gge,
  selectTriggerError: Uge,
  selectIcon: Yge,
  selectContent: Xge,
  selectViewport: qge,
  selectItem: Kge,
  selectLabel: Qge,
  selectSeparator: Jge,
  selectItemIndicator: eme,
  selectScrollButton: tme
}, rme = ({ error: t, ...e }) => /* @__PURE__ */ C(
  "span",
  {
    ...e,
    className: G(e.className, Bt.errorText, t ? "block" : "hidden"),
    children: t
  }
), nme = ({ content: t, required: e, className: r }) => /* @__PURE__ */ C("div", { className: Bt.labelContainer, children: /* @__PURE__ */ Z("label", { className: G(Bt.labelContent, r), children: [
  t,
  e && /* @__PURE__ */ C("span", { className: "text-orange-30", children: "*" })
] }) }), ame = ({
  options: t,
  placeholder: e,
  prependIcon: r,
  value: n,
  error: a,
  bordered: o = !1,
  appendIcon: i = "ChevronDownIcon",
  triggerClassName: l,
  onChange: c,
  emptyValue: u = "",
  container: d
}) => {
  var b;
  const [f, h] = gt(!1), v = (_) => {
    h(!!(_ && _ !== u));
  };
  En(() => {
    v(n ?? "");
  }, [n]);
  const p = !!a, g = o ? "border-gray-20 border" : "", m = p ? Bt.selectTriggerError : "", w = i || r ? "justify-between" : "justify-center", y = f ? "bg-gray-20" : "";
  return /* @__PURE__ */ Z(
    Bte,
    {
      onValueChange: (_) => {
        c ? c(_) : v(_);
      },
      value: n,
      children: [
        /* @__PURE__ */ Z(
          Fte,
          {
            className: G(
              "bg-light-20",
              Bt.selectTrigger,
              m,
              w,
              g,
              l,
              y
            ),
            children: [
              /* @__PURE__ */ Z("div", { className: Bt.selectTriggerStart, children: [
                r && /* @__PURE__ */ C(Zp, { className: Bt.selectIcon, children: /* @__PURE__ */ C(Me, { icon: r, extraClassNames: "size-5" }) }),
                /* @__PURE__ */ C($te, { placeholder: e })
              ] }),
              i && /* @__PURE__ */ C(Zp, { className: Bt.selectIcon, children: /* @__PURE__ */ C(Me, { icon: i, extraClassNames: "size-5" }) })
            ]
          }
        ),
        /* @__PURE__ */ C(Vte, { children: /* @__PURE__ */ Z(Zte, { className: G(Bt.selectContent, ((b = d == null ? void 0 : d.content) == null ? void 0 : b.className) ?? ""), children: [
          /* @__PURE__ */ C(Gte, { className: Bt.selectScrollButton, children: /* @__PURE__ */ C(Me, { icon: "ChevronUpIcon", extraClassNames: "h-full" }) }),
          /* @__PURE__ */ C(Hte, { className: Bt.selectViewport, children: t.map((_) => /* @__PURE__ */ C(ome, { value: _.value, children: _.label }, `select-item-${_.value}`)) }),
          /* @__PURE__ */ C(Ute, { className: Bt.selectScrollButton, children: /* @__PURE__ */ C(Me, { icon: "ChevronDownIcon", extraClassNames: "h-full" }) })
        ] }) })
      ]
    }
  );
}, ome = ke.forwardRef(
  ({ children: t, value: e, ...r }, n) => /* @__PURE__ */ Z(jte, { ...r, className: Bt.selectItem, value: e, ref: n, children: [
    /* @__PURE__ */ C(Wte, { children: t }),
    /* @__PURE__ */ C(zte, { className: Bt.selectItemIndicator, children: /* @__PURE__ */ C(Me, { icon: "CheckIcon", extraClassNames: "h-full" }) })
  ] })
), ime = ({ children: t, ...e }) => /* @__PURE__ */ C(
  "div",
  {
    ...e,
    className: G("flex flex-col gap-2", e.className ?? ""),
    children: t
  }
), I6e = {
  Root: ime,
  Input: ame,
  Label: nme,
  Error: rme
};
function lme(t, e) {
  const r = s.createContext(e), n = (o) => {
    const { children: i, ...l } = o, c = s.useMemo(() => l, Object.values(l));
    return /* @__PURE__ */ C(r.Provider, { value: c, children: i });
  };
  n.displayName = t + "Provider";
  function a(o) {
    const i = s.useContext(r);
    if (i) return i;
    if (e !== void 0) return e;
    throw new Error(`\`${o}\` must be used within \`${t}\``);
  }
  return [n, a];
}
function sme(t, e = []) {
  let r = [];
  function n(o, i) {
    const l = s.createContext(i), c = r.length;
    r = [...r, i];
    const u = (f) => {
      var w;
      const { scope: h, children: v, ...p } = f, g = ((w = h == null ? void 0 : h[t]) == null ? void 0 : w[c]) || l, m = s.useMemo(() => p, Object.values(p));
      return /* @__PURE__ */ C(g.Provider, { value: m, children: v });
    };
    u.displayName = o + "Provider";
    function d(f, h) {
      var g;
      const v = ((g = h == null ? void 0 : h[t]) == null ? void 0 : g[c]) || l, p = s.useContext(v);
      if (p) return p;
      if (i !== void 0) return i;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [u, d];
  }
  const a = () => {
    const o = r.map((i) => s.createContext(i));
    return function(l) {
      const c = (l == null ? void 0 : l[t]) || o;
      return s.useMemo(
        () => ({ [`__scope${t}`]: { ...l, [t]: c } }),
        [l, c]
      );
    };
  };
  return a.scopeName = t, [n, cme(a, ...e)];
}
function cme(...t) {
  const e = t[0];
  if (t.length === 1) return e;
  const r = () => {
    const n = t.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(o) {
      const i = n.reduce((l, { useScope: c, scopeName: u }) => {
        const f = c(o)[`__scope${u}`];
        return { ...l, ...f };
      }, {});
      return s.useMemo(() => ({ [`__scope${e.scopeName}`]: i }), [i]);
    };
  };
  return r.scopeName = e.scopeName, r;
}
var ume = "DismissableLayer", C2 = "dismissableLayer.update", dme = "dismissableLayer.pointerDownOutside", fme = "dismissableLayer.focusOutside", pw, iE = s.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), lE = s.forwardRef(
  (t, e) => {
    const {
      disableOutsidePointerEvents: r = !1,
      onEscapeKeyDown: n,
      onPointerDownOutside: a,
      onFocusOutside: o,
      onInteractOutside: i,
      onDismiss: l,
      ...c
    } = t, u = s.useContext(iE), [d, f] = s.useState(null), h = (d == null ? void 0 : d.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, v] = s.useState({}), p = ce(e, (S) => f(S)), g = Array.from(u.layers), [m] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), w = g.indexOf(m), y = d ? g.indexOf(d) : -1, b = u.layersWithOutsidePointerEventsDisabled.size > 0, _ = y >= w, x = pme((S) => {
      const M = S.target, R = [...u.branches].some((A) => A.contains(M));
      !_ || R || (a == null || a(S), i == null || i(S), S.defaultPrevented || l == null || l());
    }, h), E = gme((S) => {
      const M = S.target;
      [...u.branches].some((A) => A.contains(M)) || (o == null || o(S), i == null || i(S), S.defaultPrevented || l == null || l());
    }, h);
    return W2((S) => {
      y === u.layers.size - 1 && (n == null || n(S), !S.defaultPrevented && l && (S.preventDefault(), l()));
    }, h), s.useEffect(() => {
      if (d)
        return r && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (pw = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), gw(), () => {
          r && u.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = pw);
        };
    }, [d, h, r, u]), s.useEffect(() => () => {
      d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), gw());
    }, [d, u]), s.useEffect(() => {
      const S = () => v({});
      return document.addEventListener(C2, S), () => document.removeEventListener(C2, S);
    }, []), /* @__PURE__ */ C(
      te.div,
      {
        ...c,
        ref: p,
        style: {
          pointerEvents: b ? _ ? "auto" : "none" : void 0,
          ...t.style
        },
        onFocusCapture: j(t.onFocusCapture, E.onFocusCapture),
        onBlurCapture: j(t.onBlurCapture, E.onBlurCapture),
        onPointerDownCapture: j(
          t.onPointerDownCapture,
          x.onPointerDownCapture
        )
      }
    );
  }
);
lE.displayName = ume;
var hme = "DismissableLayerBranch", vme = s.forwardRef((t, e) => {
  const r = s.useContext(iE), n = s.useRef(null), a = ce(e, n);
  return s.useEffect(() => {
    const o = n.current;
    if (o)
      return r.branches.add(o), () => {
        r.branches.delete(o);
      };
  }, [r.branches]), /* @__PURE__ */ C(te.div, { ...t, ref: a });
});
vme.displayName = hme;
function pme(t, e = globalThis == null ? void 0 : globalThis.document) {
  const r = Ke(t), n = s.useRef(!1), a = s.useRef(() => {
  });
  return s.useEffect(() => {
    const o = (l) => {
      if (l.target && !n.current) {
        let c = function() {
          sE(
            dme,
            r,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: l };
        l.pointerType === "touch" ? (e.removeEventListener("click", a.current), a.current = c, e.addEventListener("click", a.current, { once: !0 })) : c();
      } else
        e.removeEventListener("click", a.current);
      n.current = !1;
    }, i = window.setTimeout(() => {
      e.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(i), e.removeEventListener("pointerdown", o), e.removeEventListener("click", a.current);
    };
  }, [e, r]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => n.current = !0
  };
}
function gme(t, e = globalThis == null ? void 0 : globalThis.document) {
  const r = Ke(t), n = s.useRef(!1);
  return s.useEffect(() => {
    const a = (o) => {
      o.target && !n.current && sE(fme, r, { originalEvent: o }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", a), () => e.removeEventListener("focusin", a);
  }, [e, r]), {
    onFocusCapture: () => n.current = !0,
    onBlurCapture: () => n.current = !1
  };
}
function gw() {
  const t = new CustomEvent(C2);
  document.dispatchEvent(t);
}
function sE(t, e, r, { discrete: n }) {
  const a = r.originalEvent.target, o = new CustomEvent(t, { bubbles: !1, cancelable: !0, detail: r });
  e && a.addEventListener(t, e, { once: !0 }), n ? $u(a, o) : a.dispatchEvent(o);
}
var mme = "Portal", cE = s.forwardRef((t, e) => {
  var l;
  const { container: r, ...n } = t, [a, o] = s.useState(!1);
  Fe(() => o(!0), []);
  const i = r || a && ((l = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : l.body);
  return i ? D2.createPortal(/* @__PURE__ */ C(te.div, { ...n, ref: e }), i) : null;
});
cE.displayName = mme;
function wme(t, e) {
  return s.useReducer((r, n) => e[r][n] ?? r, t);
}
var u5 = (t) => {
  const { present: e, children: r } = t, n = yme(e), a = typeof r == "function" ? r({ present: n.isPresent }) : s.Children.only(r), o = ce(n.ref, bme(a));
  return typeof r == "function" || n.isPresent ? s.cloneElement(a, { ref: o }) : null;
};
u5.displayName = "Presence";
function yme(t) {
  const [e, r] = s.useState(), n = s.useRef({}), a = s.useRef(t), o = s.useRef("none"), i = t ? "mounted" : "unmounted", [l, c] = wme(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return s.useEffect(() => {
    const u = t0(n.current);
    o.current = l === "mounted" ? u : "none";
  }, [l]), Fe(() => {
    const u = n.current, d = a.current;
    if (d !== t) {
      const h = o.current, v = t0(u);
      t ? c("MOUNT") : v === "none" || (u == null ? void 0 : u.display) === "none" ? c("UNMOUNT") : c(d && h !== v ? "ANIMATION_OUT" : "UNMOUNT"), a.current = t;
    }
  }, [t, c]), Fe(() => {
    if (e) {
      let u;
      const d = e.ownerDocument.defaultView ?? window, f = (v) => {
        const g = t0(n.current).includes(v.animationName);
        if (v.target === e && g && (c("ANIMATION_END"), !a.current)) {
          const m = e.style.animationFillMode;
          e.style.animationFillMode = "forwards", u = d.setTimeout(() => {
            e.style.animationFillMode === "forwards" && (e.style.animationFillMode = m);
          });
        }
      }, h = (v) => {
        v.target === e && (o.current = t0(n.current));
      };
      return e.addEventListener("animationstart", h), e.addEventListener("animationcancel", f), e.addEventListener("animationend", f), () => {
        d.clearTimeout(u), e.removeEventListener("animationstart", h), e.removeEventListener("animationcancel", f), e.removeEventListener("animationend", f);
      };
    } else
      c("ANIMATION_END");
  }, [e, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(l),
    ref: s.useCallback((u) => {
      u && (n.current = getComputedStyle(u)), r(u);
    }, [])
  };
}
function t0(t) {
  return (t == null ? void 0 : t.animationName) || "none";
}
function bme(t) {
  var n, a;
  let e = (n = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : n.get, r = e && "isReactWarning" in e && e.isReactWarning;
  return r ? t.ref : (e = (a = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : a.get, r = e && "isReactWarning" in e && e.isReactWarning, r ? t.props.ref : t.props.ref || t.ref);
}
var Ef = 0;
function _me() {
  s.useEffect(() => {
    const t = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", t[0] ?? mw()), document.body.insertAdjacentElement("beforeend", t[1] ?? mw()), Ef++, () => {
      Ef === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((e) => e.remove()), Ef--;
    };
  }, []);
}
function mw() {
  const t = document.createElement("span");
  return t.setAttribute("data-radix-focus-guard", ""), t.tabIndex = 0, t.style.outline = "none", t.style.opacity = "0", t.style.position = "fixed", t.style.pointerEvents = "none", t;
}
var S0 = "right-scroll-bar-position", R0 = "width-before-scroll-bar", xme = "with-scroll-bars-hidden", Cme = "--removed-body-scroll-bar-size", uE = Y2(), Sf = function() {
}, d5 = s.forwardRef(function(t, e) {
  var r = s.useRef(null), n = s.useState({
    onScrollCapture: Sf,
    onWheelCapture: Sf,
    onTouchMoveCapture: Sf
  }), a = n[0], o = n[1], i = t.forwardProps, l = t.children, c = t.className, u = t.removeScrollBar, d = t.enabled, f = t.shards, h = t.sideCar, v = t.noIsolation, p = t.inert, g = t.allowPinchZoom, m = t.as, w = m === void 0 ? "div" : m, y = t.gapMode, b = Di(t, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), _ = h, x = U2([r, e]), E = Ue(Ue({}, b), a);
  return s.createElement(
    s.Fragment,
    null,
    d && s.createElement(_, { sideCar: uE, removeScrollBar: u, shards: f, noIsolation: v, inert: p, setCallbacks: o, allowPinchZoom: !!g, lockRef: r, gapMode: y }),
    i ? s.cloneElement(s.Children.only(l), Ue(Ue({}, E), { ref: x })) : s.createElement(w, Ue({}, E, { className: c, ref: x }), l)
  );
});
d5.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
d5.classNames = {
  fullWidth: R0,
  zeroRight: S0
};
var Eme = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Rf = function(t) {
  return parseInt(t || "", 10) || 0;
}, Sme = function(t) {
  var e = window.getComputedStyle(document.body), r = e[t === "padding" ? "paddingLeft" : "marginLeft"], n = e[t === "padding" ? "paddingTop" : "marginTop"], a = e[t === "padding" ? "paddingRight" : "marginRight"];
  return [Rf(r), Rf(n), Rf(a)];
}, Rme = function(t) {
  if (t === void 0 && (t = "margin"), typeof window > "u")
    return Eme;
  var e = Sme(t), r = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: e[0],
    top: e[1],
    right: e[2],
    gap: Math.max(0, n - r + e[2] - e[0])
  };
}, Mme = Ni(), hi = "data-scroll-locked", Ame = function(t, e, r, n) {
  var a = t.left, o = t.top, i = t.right, l = t.gap;
  return r === void 0 && (r = "margin"), `
  .`.concat(xme, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(l, "px ").concat(n, `;
  }
  body[`).concat(hi, `] {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    e && "position: relative ".concat(n, ";"),
    r === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(o, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(l, "px ").concat(n, `;
    `),
    r === "padding" && "padding-right: ".concat(l, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(S0, ` {
    right: `).concat(l, "px ").concat(n, `;
  }
  
  .`).concat(R0, ` {
    margin-right: `).concat(l, "px ").concat(n, `;
  }
  
  .`).concat(S0, " .").concat(S0, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(R0, " .").concat(R0, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body[`).concat(hi, `] {
    `).concat(Cme, ": ").concat(l, `px;
  }
`);
}, ww = function() {
  var t = parseInt(document.body.getAttribute(hi) || "0", 10);
  return isFinite(t) ? t : 0;
}, kme = function() {
  s.useEffect(function() {
    return document.body.setAttribute(hi, (ww() + 1).toString()), function() {
      var t = ww() - 1;
      t <= 0 ? document.body.removeAttribute(hi) : document.body.setAttribute(hi, t.toString());
    };
  }, []);
}, Lme = function(t) {
  var e = t.noRelative, r = t.noImportant, n = t.gapMode, a = n === void 0 ? "margin" : n;
  kme();
  var o = s.useMemo(function() {
    return Rme(a);
  }, [a]);
  return s.createElement(Mme, { styles: Ame(o, !e, a, r ? "" : "!important") });
}, E2 = !1;
if (typeof window < "u")
  try {
    var r0 = Object.defineProperty({}, "passive", {
      get: function() {
        return E2 = !0, !0;
      }
    });
    window.addEventListener("test", r0, r0), window.removeEventListener("test", r0, r0);
  } catch {
    E2 = !1;
  }
var Go = E2 ? { passive: !1 } : !1, Tme = function(t) {
  return t.tagName === "TEXTAREA";
}, dE = function(t, e) {
  if (!(t instanceof Element))
    return !1;
  var r = window.getComputedStyle(t);
  return (
    // not-not-scrollable
    r[e] !== "hidden" && // contains scroll inside self
    !(r.overflowY === r.overflowX && !Tme(t) && r[e] === "visible")
  );
}, Ome = function(t) {
  return dE(t, "overflowY");
}, Ime = function(t) {
  return dE(t, "overflowX");
}, yw = function(t, e) {
  var r = e.ownerDocument, n = e;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var a = fE(t, n);
    if (a) {
      var o = hE(t, n), i = o[1], l = o[2];
      if (i > l)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== r.body);
  return !1;
}, Pme = function(t) {
  var e = t.scrollTop, r = t.scrollHeight, n = t.clientHeight;
  return [
    e,
    r,
    n
  ];
}, Dme = function(t) {
  var e = t.scrollLeft, r = t.scrollWidth, n = t.clientWidth;
  return [
    e,
    r,
    n
  ];
}, fE = function(t, e) {
  return t === "v" ? Ome(e) : Ime(e);
}, hE = function(t, e) {
  return t === "v" ? Pme(e) : Dme(e);
}, Nme = function(t, e) {
  return t === "h" && e === "rtl" ? -1 : 1;
}, Bme = function(t, e, r, n, a) {
  var o = Nme(t, window.getComputedStyle(e).direction), i = o * n, l = r.target, c = e.contains(l), u = !1, d = i > 0, f = 0, h = 0;
  do {
    var v = hE(t, l), p = v[0], g = v[1], m = v[2], w = g - m - o * p;
    (p || w) && fE(t, l) && (f += w, h += p), l instanceof ShadowRoot ? l = l.host : l = l.parentNode;
  } while (
    // portaled content
    !c && l !== document.body || // self content
    c && (e.contains(l) || e === l)
  );
  return (d && (Math.abs(f) < 1 || !a) || !d && (Math.abs(h) < 1 || !a)) && (u = !0), u;
}, n0 = function(t) {
  return "changedTouches" in t ? [t.changedTouches[0].clientX, t.changedTouches[0].clientY] : [0, 0];
}, bw = function(t) {
  return [t.deltaX, t.deltaY];
}, _w = function(t) {
  return t && "current" in t ? t.current : t;
}, Fme = function(t, e) {
  return t[0] === e[0] && t[1] === e[1];
}, $me = function(t) {
  return `
  .block-interactivity-`.concat(t, ` {pointer-events: none;}
  .allow-interactivity-`).concat(t, ` {pointer-events: all;}
`);
}, Vme = 0, Uo = [];
function Zme(t) {
  var e = s.useRef([]), r = s.useRef([0, 0]), n = s.useRef(), a = s.useState(Vme++)[0], o = s.useState(Ni)[0], i = s.useRef(t);
  s.useEffect(function() {
    i.current = t;
  }, [t]), s.useEffect(function() {
    if (t.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var g = ys([t.lockRef.current], (t.shards || []).map(_w), !0).filter(Boolean);
      return g.forEach(function(m) {
        return m.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), g.forEach(function(m) {
          return m.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [t.inert, t.lockRef.current, t.shards]);
  var l = s.useCallback(function(g, m) {
    if ("touches" in g && g.touches.length === 2 || g.type === "wheel" && g.ctrlKey)
      return !i.current.allowPinchZoom;
    var w = n0(g), y = r.current, b = "deltaX" in g ? g.deltaX : y[0] - w[0], _ = "deltaY" in g ? g.deltaY : y[1] - w[1], x, E = g.target, S = Math.abs(b) > Math.abs(_) ? "h" : "v";
    if ("touches" in g && S === "h" && E.type === "range")
      return !1;
    var M = yw(S, E);
    if (!M)
      return !0;
    if (M ? x = S : (x = S === "v" ? "h" : "v", M = yw(S, E)), !M)
      return !1;
    if (!n.current && "changedTouches" in g && (b || _) && (n.current = x), !x)
      return !0;
    var R = n.current || x;
    return Bme(R, m, g, R === "h" ? b : _, !0);
  }, []), c = s.useCallback(function(g) {
    var m = g;
    if (!(!Uo.length || Uo[Uo.length - 1] !== o)) {
      var w = "deltaY" in m ? bw(m) : n0(m), y = e.current.filter(function(x) {
        return x.name === m.type && (x.target === m.target || m.target === x.shadowParent) && Fme(x.delta, w);
      })[0];
      if (y && y.should) {
        m.cancelable && m.preventDefault();
        return;
      }
      if (!y) {
        var b = (i.current.shards || []).map(_w).filter(Boolean).filter(function(x) {
          return x.contains(m.target);
        }), _ = b.length > 0 ? l(m, b[0]) : !i.current.noIsolation;
        _ && m.cancelable && m.preventDefault();
      }
    }
  }, []), u = s.useCallback(function(g, m, w, y) {
    var b = { name: g, delta: m, target: w, should: y, shadowParent: Hme(w) };
    e.current.push(b), setTimeout(function() {
      e.current = e.current.filter(function(_) {
        return _ !== b;
      });
    }, 1);
  }, []), d = s.useCallback(function(g) {
    r.current = n0(g), n.current = void 0;
  }, []), f = s.useCallback(function(g) {
    u(g.type, bw(g), g.target, l(g, t.lockRef.current));
  }, []), h = s.useCallback(function(g) {
    u(g.type, n0(g), g.target, l(g, t.lockRef.current));
  }, []);
  s.useEffect(function() {
    return Uo.push(o), t.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", c, Go), document.addEventListener("touchmove", c, Go), document.addEventListener("touchstart", d, Go), function() {
      Uo = Uo.filter(function(g) {
        return g !== o;
      }), document.removeEventListener("wheel", c, Go), document.removeEventListener("touchmove", c, Go), document.removeEventListener("touchstart", d, Go);
    };
  }, []);
  var v = t.removeScrollBar, p = t.inert;
  return s.createElement(
    s.Fragment,
    null,
    p ? s.createElement(o, { styles: $me(a) }) : null,
    v ? s.createElement(Lme, { gapMode: t.gapMode }) : null
  );
}
function Hme(t) {
  for (var e = null; t !== null; )
    t instanceof ShadowRoot && (e = t.host, t = t.host), t = t.parentNode;
  return e;
}
const jme = X2(uE, Zme);
var vE = s.forwardRef(function(t, e) {
  return s.createElement(d5, Ue({}, t, { ref: e, sideCar: jme }));
});
vE.classNames = d5.classNames;
var sp = "Dialog", [pE, P6e] = sme(sp), [Wme, Hr] = pE(sp), gE = (t) => {
  const {
    __scopeDialog: e,
    children: r,
    open: n,
    defaultOpen: a,
    onOpenChange: o,
    modal: i = !0
  } = t, l = s.useRef(null), c = s.useRef(null), [u = !1, d] = mr({
    prop: n,
    defaultProp: a,
    onChange: o
  });
  return /* @__PURE__ */ C(
    Wme,
    {
      scope: e,
      triggerRef: l,
      contentRef: c,
      contentId: Kt(),
      titleId: Kt(),
      descriptionId: Kt(),
      open: u,
      onOpenChange: d,
      onOpenToggle: s.useCallback(() => d((f) => !f), [d]),
      modal: i,
      children: r
    }
  );
};
gE.displayName = sp;
var mE = "DialogTrigger", zme = s.forwardRef(
  (t, e) => {
    const { __scopeDialog: r, ...n } = t, a = Hr(mE, r), o = ce(e, a.triggerRef);
    return /* @__PURE__ */ C(
      te.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": a.open,
        "aria-controls": a.contentId,
        "data-state": dp(a.open),
        ...n,
        ref: o,
        onClick: j(t.onClick, a.onOpenToggle)
      }
    );
  }
);
zme.displayName = mE;
var cp = "DialogPortal", [Gme, wE] = pE(cp, {
  forceMount: void 0
}), yE = (t) => {
  const { __scopeDialog: e, forceMount: r, children: n, container: a } = t, o = Hr(cp, e);
  return /* @__PURE__ */ C(Gme, { scope: e, forceMount: r, children: s.Children.map(n, (i) => /* @__PURE__ */ C(u5, { present: r || o.open, children: /* @__PURE__ */ C(cE, { asChild: !0, container: a, children: i }) })) });
};
yE.displayName = cp;
var Mu = "DialogOverlay", bE = s.forwardRef(
  (t, e) => {
    const r = wE(Mu, t.__scopeDialog), { forceMount: n = r.forceMount, ...a } = t, o = Hr(Mu, t.__scopeDialog);
    return o.modal ? /* @__PURE__ */ C(u5, { present: n || o.open, children: /* @__PURE__ */ C(Ume, { ...a, ref: e }) }) : null;
  }
);
bE.displayName = Mu;
var Ume = s.forwardRef(
  (t, e) => {
    const { __scopeDialog: r, ...n } = t, a = Hr(Mu, r);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ C(vE, { as: Nr, allowPinchZoom: !0, shards: [a.contentRef], children: /* @__PURE__ */ C(
        te.div,
        {
          "data-state": dp(a.open),
          ...n,
          ref: e,
          style: { pointerEvents: "auto", ...n.style }
        }
      ) })
    );
  }
), co = "DialogContent", _E = s.forwardRef(
  (t, e) => {
    const r = wE(co, t.__scopeDialog), { forceMount: n = r.forceMount, ...a } = t, o = Hr(co, t.__scopeDialog);
    return /* @__PURE__ */ C(u5, { present: n || o.open, children: o.modal ? /* @__PURE__ */ C(Yme, { ...a, ref: e }) : /* @__PURE__ */ C(Xme, { ...a, ref: e }) });
  }
);
_E.displayName = co;
var Yme = s.forwardRef(
  (t, e) => {
    const r = Hr(co, t.__scopeDialog), n = s.useRef(null), a = ce(e, r.contentRef, n);
    return s.useEffect(() => {
      const o = n.current;
      if (o) return zu(o);
    }, []), /* @__PURE__ */ C(
      xE,
      {
        ...t,
        ref: a,
        trapFocus: r.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: j(t.onCloseAutoFocus, (o) => {
          var i;
          o.preventDefault(), (i = r.triggerRef.current) == null || i.focus();
        }),
        onPointerDownOutside: j(t.onPointerDownOutside, (o) => {
          const i = o.detail.originalEvent, l = i.button === 0 && i.ctrlKey === !0;
          (i.button === 2 || l) && o.preventDefault();
        }),
        onFocusOutside: j(
          t.onFocusOutside,
          (o) => o.preventDefault()
        )
      }
    );
  }
), Xme = s.forwardRef(
  (t, e) => {
    const r = Hr(co, t.__scopeDialog), n = s.useRef(!1), a = s.useRef(!1);
    return /* @__PURE__ */ C(
      xE,
      {
        ...t,
        ref: e,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (o) => {
          var i, l;
          (i = t.onCloseAutoFocus) == null || i.call(t, o), o.defaultPrevented || (n.current || (l = r.triggerRef.current) == null || l.focus(), o.preventDefault()), n.current = !1, a.current = !1;
        },
        onInteractOutside: (o) => {
          var c, u;
          (c = t.onInteractOutside) == null || c.call(t, o), o.defaultPrevented || (n.current = !0, o.detail.originalEvent.type === "pointerdown" && (a.current = !0));
          const i = o.target;
          ((u = r.triggerRef.current) == null ? void 0 : u.contains(i)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && a.current && o.preventDefault();
        }
      }
    );
  }
), xE = s.forwardRef(
  (t, e) => {
    const { __scopeDialog: r, trapFocus: n, onOpenAutoFocus: a, onCloseAutoFocus: o, ...i } = t, l = Hr(co, r), c = s.useRef(null), u = ce(e, c);
    return _me(), /* @__PURE__ */ Z(gr, { children: [
      /* @__PURE__ */ C(
        ws,
        {
          asChild: !0,
          loop: !0,
          trapped: n,
          onMountAutoFocus: a,
          onUnmountAutoFocus: o,
          children: /* @__PURE__ */ C(
            lE,
            {
              role: "dialog",
              id: l.contentId,
              "aria-describedby": l.descriptionId,
              "aria-labelledby": l.titleId,
              "data-state": dp(l.open),
              ...i,
              ref: u,
              onDismiss: () => l.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ Z(gr, { children: [
        /* @__PURE__ */ C(qme, { titleId: l.titleId }),
        /* @__PURE__ */ C(Qme, { contentRef: c, descriptionId: l.descriptionId })
      ] })
    ] });
  }
), up = "DialogTitle", CE = s.forwardRef(
  (t, e) => {
    const { __scopeDialog: r, ...n } = t, a = Hr(up, r);
    return /* @__PURE__ */ C(te.h2, { id: a.titleId, ...n, ref: e });
  }
);
CE.displayName = up;
var EE = "DialogDescription", SE = s.forwardRef(
  (t, e) => {
    const { __scopeDialog: r, ...n } = t, a = Hr(EE, r);
    return /* @__PURE__ */ C(te.p, { id: a.descriptionId, ...n, ref: e });
  }
);
SE.displayName = EE;
var RE = "DialogClose", ME = s.forwardRef(
  (t, e) => {
    const { __scopeDialog: r, ...n } = t, a = Hr(RE, r);
    return /* @__PURE__ */ C(
      te.button,
      {
        type: "button",
        ...n,
        ref: e,
        onClick: j(t.onClick, () => a.onOpenChange(!1))
      }
    );
  }
);
ME.displayName = RE;
function dp(t) {
  return t ? "open" : "closed";
}
var AE = "DialogTitleWarning", [D6e, kE] = lme(AE, {
  contentName: co,
  titleName: up,
  docsSlug: "dialog"
}), qme = ({ titleId: t }) => {
  const e = kE(AE), r = `\`${e.contentName}\` requires a \`${e.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${e.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${e.docsSlug}`;
  return s.useEffect(() => {
    t && (document.getElementById(t) || console.error(r));
  }, [r, t]), null;
}, Kme = "DialogDescriptionWarning", Qme = ({ contentRef: t, descriptionId: e }) => {
  const n = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${kE(Kme).contentName}}.`;
  return s.useEffect(() => {
    var o;
    const a = (o = t.current) == null ? void 0 : o.getAttribute("aria-describedby");
    e && a && (document.getElementById(e) || console.warn(n));
  }, [n, t, e]), null;
}, LE = gE, Jme = yE, TE = bE, OE = _E, IE = CE, e3e = SE, PE = ME;
const t3e = "foton__dialogOverlay___4S8i7", r3e = "foton__dialogContent___1h7o4", n3e = "foton__contentShow___KLbwi", a3e = "foton__innerContent___DZfE4", o3e = "foton__titleContainer___qAVrW", i3e = "foton__dialogDescription___Hunh0", l3e = "foton__withHeaderElements___QZmyu", s3e = "foton__buttonTagContainer___8UhVQ", c3e = "foton__dialogContentAction___58kkY", u3e = "foton__iconButton___i4D5E", d3e = "foton__iconSizeCenter___2p6Qq", f3e = "foton__dialogIconStatus___0d-5I", h3e = "foton__dialogIconStatusAppearance_Green___Rj8Ek", v3e = "foton__dialogIconStatusAppearance_Yellow___zPZ4J", p3e = "foton__dialogIconStatusAppearance_Red___lYnv7", g3e = "foton__dialogIconTitleStatus___0SLqn", m3e = "foton__dialogTitleStatus___gllV4", w3e = "foton__dialogContentActionScroll___nh5Ua", y3e = "foton__buttonsContainer___CGSlM", b3e = "foton__ButtonExtraClassNoIcon___totBr", _3e = "foton__ButtonExtraClassWithIcon___os7pW", nt = {
  dialogOverlay: t3e,
  dialogContent: r3e,
  contentShow: n3e,
  innerContent: a3e,
  titleContainer: o3e,
  dialogDescription: i3e,
  withHeaderElements: l3e,
  buttonTagContainer: s3e,
  dialogContentAction: c3e,
  iconButton: u3e,
  iconSizeCenter: d3e,
  dialogIconStatus: f3e,
  dialogIconStatusAppearance_Green: h3e,
  dialogIconStatusAppearance_Yellow: v3e,
  dialogIconStatusAppearance_Red: p3e,
  dialogIconTitleStatus: g3e,
  dialogTitleStatus: m3e,
  dialogContentActionScroll: w3e,
  buttonsContainer: y3e,
  ButtonExtraClassNoIcon: b3e,
  ButtonExtraClassWithIcon: _3e
}, N6e = ({
  icon: t,
  iconColor: e = "green",
  modalIcon: r,
  title: n,
  description: a,
  children: o,
  // TODO: change this to handleClose
  setOpen: i,
  isOpen: l,
  buttonsProps: c,
  className: u,
  buttonsTitle: d,
  tagTitle: f,
  ...h
}) => {
  const v = r ? nt.dialogIconStatus : "", p = r ? nt.dialogIconTitleStatus : nt.dialogTitleStatus, g = {
    red: nt.dialogIconStatusAppearance_Red,
    green: nt.dialogIconStatusAppearance_Green,
    yellow: nt.dialogIconStatusAppearance_Yellow
  };
  return /* @__PURE__ */ C(LE, { open: l, onOpenChange: i, children: /* @__PURE__ */ Z(Jme, { children: [
    /* @__PURE__ */ C(TE, { className: nt.dialogOverlay, onClick: () => i(!1) }),
    /* @__PURE__ */ C(
      OE,
      {
        className: G(nt.dialogContent, d || f ? nt.withHeaderElements : "", u),
        onOpenAutoFocus: (m) => m.preventDefault(),
        children: /* @__PURE__ */ Z("div", { className: nt.innerContent, children: [
          /* @__PURE__ */ Z("div", { children: [
            t && /* @__PURE__ */ C("div", { className: v, children: /* @__PURE__ */ C(
              Me,
              {
                icon: t,
                extraClassNames: G(nt.iconSizeCenter, g[e])
              }
            ) }),
            /* @__PURE__ */ Z("div", { className: nt.titleContainer, children: [
              /* @__PURE__ */ C(IE, { className: G(p, n.extraClassName), children: n.text }),
              (f || d) && /* @__PURE__ */ Z("div", { className: nt.buttonTagContainer, children: [
                f && /* @__PURE__ */ C(I8, { ...f }),
                d && d.map((m, w) => /* @__PURE__ */ C(gi, { ...m }, `icon-button-${w}`))
              ] })
            ] }),
            a ? /* @__PURE__ */ C(e3e, { className: G(nt.dialogDescription, r ? "text-center" : ""), children: a }) : null
          ] }),
          o && /* @__PURE__ */ C("div", { className: nt.dialogContentActionScroll, children: /* @__PURE__ */ C("div", { className: G(nt.dialogContentAction, !o && nt.hidden), ...h, children: o }) }),
          c && /* @__PURE__ */ C("div", { children: /* @__PURE__ */ C("div", { className: nt.buttonsContainer, children: c.length > 0 && c.map((m, w) => /* @__PURE__ */ C(k0, { ...m }, w)) }) }),
          /* @__PURE__ */ C(PE, { asChild: !0, children: /* @__PURE__ */ C(
            gi,
            {
              icon: "XMarkIcon",
              className: nt.iconButton,
              kind: "secondary",
              onClick: () => i(!1)
            }
          ) })
        ] })
      }
    )
  ] }) });
}, x3e = ({ id: t, label: e, required: r, disabledClass: n, tooltipContent: a }) => /* @__PURE__ */ Z("div", { className: "flex gap-2 mb-2 items-center", children: [
  /* @__PURE__ */ Z("label", { htmlFor: t, className: `text-paragraph-medium ${n}`, children: [
    e,
    r && /* @__PURE__ */ C("span", { className: "text-orange-30", children: "*" })
  ] }),
  a && /* @__PURE__ */ C(O8, { content: a })
] });
var DE = { exports: {} };
/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */
(function(t) {
  (function(e, r) {
    t.exports ? t.exports = r() : e.numeral = r();
  })(bl, function() {
    var e, r, n = "2.0.6", a = {}, o = {}, i = {
      currentLocale: "en",
      zeroFormat: null,
      nullFormat: null,
      defaultFormat: "0,0",
      scalePercentBy100: !0
    }, l = {
      currentLocale: i.currentLocale,
      zeroFormat: i.zeroFormat,
      nullFormat: i.nullFormat,
      defaultFormat: i.defaultFormat,
      scalePercentBy100: i.scalePercentBy100
    };
    function c(u, d) {
      this._input = u, this._value = d;
    }
    return e = function(u) {
      var d, f, h, v;
      if (e.isNumeral(u))
        d = u.value();
      else if (u === 0 || typeof u > "u")
        d = 0;
      else if (u === null || r.isNaN(u))
        d = null;
      else if (typeof u == "string")
        if (l.zeroFormat && u === l.zeroFormat)
          d = 0;
        else if (l.nullFormat && u === l.nullFormat || !u.replace(/[^0-9]+/g, "").length)
          d = null;
        else {
          for (f in a)
            if (v = typeof a[f].regexps.unformat == "function" ? a[f].regexps.unformat() : a[f].regexps.unformat, v && u.match(v)) {
              h = a[f].unformat;
              break;
            }
          h = h || e._.stringToNumber, d = h(u);
        }
      else
        d = Number(u) || null;
      return new c(u, d);
    }, e.version = n, e.isNumeral = function(u) {
      return u instanceof c;
    }, e._ = r = {
      // formats numbers separators, decimals places, signs, abbreviations
      numberToFormat: function(u, d, f) {
        var h = o[e.options.currentLocale], v = !1, p = !1, g = 0, m = "", w = 1e12, y = 1e9, b = 1e6, _ = 1e3, x = "", E = !1, S, M, R, A, k, L, T;
        if (u = u || 0, M = Math.abs(u), e._.includes(d, "(") ? (v = !0, d = d.replace(/[\(|\)]/g, "")) : (e._.includes(d, "+") || e._.includes(d, "-")) && (k = e._.includes(d, "+") ? d.indexOf("+") : u < 0 ? d.indexOf("-") : -1, d = d.replace(/[\+|\-]/g, "")), e._.includes(d, "a") && (S = d.match(/a(k|m|b|t)?/), S = S ? S[1] : !1, e._.includes(d, " a") && (m = " "), d = d.replace(new RegExp(m + "a[kmbt]?"), ""), M >= w && !S || S === "t" ? (m += h.abbreviations.trillion, u = u / w) : M < w && M >= y && !S || S === "b" ? (m += h.abbreviations.billion, u = u / y) : M < y && M >= b && !S || S === "m" ? (m += h.abbreviations.million, u = u / b) : (M < b && M >= _ && !S || S === "k") && (m += h.abbreviations.thousand, u = u / _)), e._.includes(d, "[.]") && (p = !0, d = d.replace("[.]", ".")), R = u.toString().split(".")[0], A = d.split(".")[1], L = d.indexOf(","), g = (d.split(".")[0].split(",")[0].match(/0/g) || []).length, A ? (e._.includes(A, "[") ? (A = A.replace("]", ""), A = A.split("["), x = e._.toFixed(u, A[0].length + A[1].length, f, A[1].length)) : x = e._.toFixed(u, A.length, f), R = x.split(".")[0], e._.includes(x, ".") ? x = h.delimiters.decimal + x.split(".")[1] : x = "", p && Number(x.slice(1)) === 0 && (x = "")) : R = e._.toFixed(u, 0, f), m && !S && Number(R) >= 1e3 && m !== h.abbreviations.trillion)
          switch (R = String(Number(R) / 1e3), m) {
            case h.abbreviations.thousand:
              m = h.abbreviations.million;
              break;
            case h.abbreviations.million:
              m = h.abbreviations.billion;
              break;
            case h.abbreviations.billion:
              m = h.abbreviations.trillion;
              break;
          }
        if (e._.includes(R, "-") && (R = R.slice(1), E = !0), R.length < g)
          for (var O = g - R.length; O > 0; O--)
            R = "0" + R;
        return L > -1 && (R = R.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + h.delimiters.thousands)), d.indexOf(".") === 0 && (R = ""), T = R + x + (m || ""), v ? T = (v && E ? "(" : "") + T + (v && E ? ")" : "") : k >= 0 ? T = k === 0 ? (E ? "-" : "+") + T : T + (E ? "-" : "+") : E && (T = "-" + T), T;
      },
      // unformats numbers separators, decimals places, signs, abbreviations
      stringToNumber: function(u) {
        var d = o[l.currentLocale], f = u, h = {
          thousand: 3,
          million: 6,
          billion: 9,
          trillion: 12
        }, v, p, g;
        if (l.zeroFormat && u === l.zeroFormat)
          p = 0;
        else if (l.nullFormat && u === l.nullFormat || !u.replace(/[^0-9]+/g, "").length)
          p = null;
        else {
          p = 1, d.delimiters.decimal !== "." && (u = u.replace(/\./g, "").replace(d.delimiters.decimal, "."));
          for (v in h)
            if (g = new RegExp("[^a-zA-Z]" + d.abbreviations[v] + "(?:\\)|(\\" + d.currency.symbol + ")?(?:\\))?)?$"), f.match(g)) {
              p *= Math.pow(10, h[v]);
              break;
            }
          p *= (u.split("-").length + Math.min(u.split("(").length - 1, u.split(")").length - 1)) % 2 ? 1 : -1, u = u.replace(/[^0-9\.]+/g, ""), p *= Number(u);
        }
        return p;
      },
      isNaN: function(u) {
        return typeof u == "number" && isNaN(u);
      },
      includes: function(u, d) {
        return u.indexOf(d) !== -1;
      },
      insert: function(u, d, f) {
        return u.slice(0, f) + d + u.slice(f);
      },
      reduce: function(u, d) {
        if (this === null)
          throw new TypeError("Array.prototype.reduce called on null or undefined");
        if (typeof d != "function")
          throw new TypeError(d + " is not a function");
        var f = Object(u), h = f.length >>> 0, v = 0, p;
        if (arguments.length === 3)
          p = arguments[2];
        else {
          for (; v < h && !(v in f); )
            v++;
          if (v >= h)
            throw new TypeError("Reduce of empty array with no initial value");
          p = f[v++];
        }
        for (; v < h; v++)
          v in f && (p = d(p, f[v], v, f));
        return p;
      },
      /**
       * Computes the multiplier necessary to make x >= 1,
       * effectively eliminating miscalculations caused by
       * finite precision.
       */
      multiplier: function(u) {
        var d = u.toString().split(".");
        return d.length < 2 ? 1 : Math.pow(10, d[1].length);
      },
      /**
       * Given a variable number of arguments, returns the maximum
       * multiplier that must be used to normalize an operation involving
       * all of them.
       */
      correctionFactor: function() {
        var u = Array.prototype.slice.call(arguments);
        return u.reduce(function(d, f) {
          var h = r.multiplier(f);
          return d > h ? d : h;
        }, 1);
      },
      /**
       * Implementation of toFixed() that treats floats more like decimals
       *
       * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
       * problems for accounting- and finance-related software.
       */
      toFixed: function(u, d, f, h) {
        var v = u.toString().split("."), p = d - (h || 0), g, m, w, y;
        return v.length === 2 ? g = Math.min(Math.max(v[1].length, p), d) : g = p, w = Math.pow(10, g), y = (f(u + "e+" + g) / w).toFixed(g), h > d - g && (m = new RegExp("\\.?0{1," + (h - (d - g)) + "}$"), y = y.replace(m, "")), y;
      }
    }, e.options = l, e.formats = a, e.locales = o, e.locale = function(u) {
      return u && (l.currentLocale = u.toLowerCase()), l.currentLocale;
    }, e.localeData = function(u) {
      if (!u)
        return o[l.currentLocale];
      if (u = u.toLowerCase(), !o[u])
        throw new Error("Unknown locale : " + u);
      return o[u];
    }, e.reset = function() {
      for (var u in i)
        l[u] = i[u];
    }, e.zeroFormat = function(u) {
      l.zeroFormat = typeof u == "string" ? u : null;
    }, e.nullFormat = function(u) {
      l.nullFormat = typeof u == "string" ? u : null;
    }, e.defaultFormat = function(u) {
      l.defaultFormat = typeof u == "string" ? u : "0.0";
    }, e.register = function(u, d, f) {
      if (d = d.toLowerCase(), this[u + "s"][d])
        throw new TypeError(d + " " + u + " already registered.");
      return this[u + "s"][d] = f, f;
    }, e.validate = function(u, d) {
      var f, h, v, p, g, m, w, y;
      if (typeof u != "string" && (u += "", console.warn && console.warn("Numeral.js: Value is not string. It has been co-erced to: ", u)), u = u.trim(), u.match(/^\d+$/))
        return !0;
      if (u === "")
        return !1;
      try {
        w = e.localeData(d);
      } catch {
        w = e.localeData(e.locale());
      }
      return v = w.currency.symbol, g = w.abbreviations, f = w.delimiters.decimal, w.delimiters.thousands === "." ? h = "\\." : h = w.delimiters.thousands, y = u.match(/^[^\d]+/), y !== null && (u = u.substr(1), y[0] !== v) || (y = u.match(/[^\d]+$/), y !== null && (u = u.slice(0, -1), y[0] !== g.thousand && y[0] !== g.million && y[0] !== g.billion && y[0] !== g.trillion)) ? !1 : (m = new RegExp(h + "{2}"), u.match(/[^\d.,]/g) ? !1 : (p = u.split(f), p.length > 2 ? !1 : p.length < 2 ? !!p[0].match(/^\d+.*\d$/) && !p[0].match(m) : p[0].length === 1 ? !!p[0].match(/^\d+$/) && !p[0].match(m) && !!p[1].match(/^\d+$/) : !!p[0].match(/^\d+.*\d$/) && !p[0].match(m) && !!p[1].match(/^\d+$/)));
    }, e.fn = c.prototype = {
      clone: function() {
        return e(this);
      },
      format: function(u, d) {
        var f = this._value, h = u || l.defaultFormat, v, p, g;
        if (d = d || Math.round, f === 0 && l.zeroFormat !== null)
          p = l.zeroFormat;
        else if (f === null && l.nullFormat !== null)
          p = l.nullFormat;
        else {
          for (v in a)
            if (h.match(a[v].regexps.format)) {
              g = a[v].format;
              break;
            }
          g = g || e._.numberToFormat, p = g(f, h, d);
        }
        return p;
      },
      value: function() {
        return this._value;
      },
      input: function() {
        return this._input;
      },
      set: function(u) {
        return this._value = Number(u), this;
      },
      add: function(u) {
        var d = r.correctionFactor.call(null, this._value, u);
        function f(h, v, p, g) {
          return h + Math.round(d * v);
        }
        return this._value = r.reduce([this._value, u], f, 0) / d, this;
      },
      subtract: function(u) {
        var d = r.correctionFactor.call(null, this._value, u);
        function f(h, v, p, g) {
          return h - Math.round(d * v);
        }
        return this._value = r.reduce([u], f, Math.round(this._value * d)) / d, this;
      },
      multiply: function(u) {
        function d(f, h, v, p) {
          var g = r.correctionFactor(f, h);
          return Math.round(f * g) * Math.round(h * g) / Math.round(g * g);
        }
        return this._value = r.reduce([this._value, u], d, 1), this;
      },
      divide: function(u) {
        function d(f, h, v, p) {
          var g = r.correctionFactor(f, h);
          return Math.round(f * g) / Math.round(h * g);
        }
        return this._value = r.reduce([this._value, u], d), this;
      },
      difference: function(u) {
        return Math.abs(e(this._value).subtract(u).value());
      }
    }, e.register("locale", "en", {
      delimiters: {
        thousands: ",",
        decimal: "."
      },
      abbreviations: {
        thousand: "k",
        million: "m",
        billion: "b",
        trillion: "t"
      },
      ordinal: function(u) {
        var d = u % 10;
        return ~~(u % 100 / 10) === 1 ? "th" : d === 1 ? "st" : d === 2 ? "nd" : d === 3 ? "rd" : "th";
      },
      currency: {
        symbol: "$"
      }
    }), function() {
      e.register("format", "bps", {
        regexps: {
          format: /(BPS)/,
          unformat: /(BPS)/
        },
        format: function(u, d, f) {
          var h = e._.includes(d, " BPS") ? " " : "", v;
          return u = u * 1e4, d = d.replace(/\s?BPS/, ""), v = e._.numberToFormat(u, d, f), e._.includes(v, ")") ? (v = v.split(""), v.splice(-1, 0, h + "BPS"), v = v.join("")) : v = v + h + "BPS", v;
        },
        unformat: function(u) {
          return +(e._.stringToNumber(u) * 1e-4).toFixed(15);
        }
      });
    }(), function() {
      var u = {
        base: 1e3,
        suffixes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
      }, d = {
        base: 1024,
        suffixes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
      }, f = u.suffixes.concat(d.suffixes.filter(function(v) {
        return u.suffixes.indexOf(v) < 0;
      })), h = f.join("|");
      h = "(" + h.replace("B", "B(?!PS)") + ")", e.register("format", "bytes", {
        regexps: {
          format: /([0\s]i?b)/,
          unformat: new RegExp(h)
        },
        format: function(v, p, g) {
          var m, w = e._.includes(p, "ib") ? d : u, y = e._.includes(p, " b") || e._.includes(p, " ib") ? " " : "", b, _, x;
          for (p = p.replace(/\s?i?b/, ""), b = 0; b <= w.suffixes.length; b++)
            if (_ = Math.pow(w.base, b), x = Math.pow(w.base, b + 1), v === null || v === 0 || v >= _ && v < x) {
              y += w.suffixes[b], _ > 0 && (v = v / _);
              break;
            }
          return m = e._.numberToFormat(v, p, g), m + y;
        },
        unformat: function(v) {
          var p = e._.stringToNumber(v), g, m;
          if (p) {
            for (g = u.suffixes.length - 1; g >= 0; g--) {
              if (e._.includes(v, u.suffixes[g])) {
                m = Math.pow(u.base, g);
                break;
              }
              if (e._.includes(v, d.suffixes[g])) {
                m = Math.pow(d.base, g);
                break;
              }
            }
            p *= m || 1;
          }
          return p;
        }
      });
    }(), function() {
      e.register("format", "currency", {
        regexps: {
          format: /(\$)/
        },
        format: function(u, d, f) {
          var h = e.locales[e.options.currentLocale], v = {
            before: d.match(/^([\+|\-|\(|\s|\$]*)/)[0],
            after: d.match(/([\+|\-|\)|\s|\$]*)$/)[0]
          }, p, g, m;
          for (d = d.replace(/\s?\$\s?/, ""), p = e._.numberToFormat(u, d, f), u >= 0 ? (v.before = v.before.replace(/[\-\(]/, ""), v.after = v.after.replace(/[\-\)]/, "")) : u < 0 && !e._.includes(v.before, "-") && !e._.includes(v.before, "(") && (v.before = "-" + v.before), m = 0; m < v.before.length; m++)
            switch (g = v.before[m], g) {
              case "$":
                p = e._.insert(p, h.currency.symbol, m);
                break;
              case " ":
                p = e._.insert(p, " ", m + h.currency.symbol.length - 1);
                break;
            }
          for (m = v.after.length - 1; m >= 0; m--)
            switch (g = v.after[m], g) {
              case "$":
                p = m === v.after.length - 1 ? p + h.currency.symbol : e._.insert(p, h.currency.symbol, -(v.after.length - (1 + m)));
                break;
              case " ":
                p = m === v.after.length - 1 ? p + " " : e._.insert(p, " ", -(v.after.length - (1 + m) + h.currency.symbol.length - 1));
                break;
            }
          return p;
        }
      });
    }(), function() {
      e.register("format", "exponential", {
        regexps: {
          format: /(e\+|e-)/,
          unformat: /(e\+|e-)/
        },
        format: function(u, d, f) {
          var h, v = typeof u == "number" && !e._.isNaN(u) ? u.toExponential() : "0e+0", p = v.split("e");
          return d = d.replace(/e[\+|\-]{1}0/, ""), h = e._.numberToFormat(Number(p[0]), d, f), h + "e" + p[1];
        },
        unformat: function(u) {
          var d = e._.includes(u, "e+") ? u.split("e+") : u.split("e-"), f = Number(d[0]), h = Number(d[1]);
          h = e._.includes(u, "e-") ? h *= -1 : h;
          function v(p, g, m, w) {
            var y = e._.correctionFactor(p, g), b = p * y * (g * y) / (y * y);
            return b;
          }
          return e._.reduce([f, Math.pow(10, h)], v, 1);
        }
      });
    }(), function() {
      e.register("format", "ordinal", {
        regexps: {
          format: /(o)/
        },
        format: function(u, d, f) {
          var h = e.locales[e.options.currentLocale], v, p = e._.includes(d, " o") ? " " : "";
          return d = d.replace(/\s?o/, ""), p += h.ordinal(u), v = e._.numberToFormat(u, d, f), v + p;
        }
      });
    }(), function() {
      e.register("format", "percentage", {
        regexps: {
          format: /(%)/,
          unformat: /(%)/
        },
        format: function(u, d, f) {
          var h = e._.includes(d, " %") ? " " : "", v;
          return e.options.scalePercentBy100 && (u = u * 100), d = d.replace(/\s?\%/, ""), v = e._.numberToFormat(u, d, f), e._.includes(v, ")") ? (v = v.split(""), v.splice(-1, 0, h + "%"), v = v.join("")) : v = v + h + "%", v;
        },
        unformat: function(u) {
          var d = e._.stringToNumber(u);
          return e.options.scalePercentBy100 ? d * 0.01 : d;
        }
      });
    }(), function() {
      e.register("format", "time", {
        regexps: {
          format: /(:)/,
          unformat: /(:)/
        },
        format: function(u, d, f) {
          var h = Math.floor(u / 60 / 60), v = Math.floor((u - h * 60 * 60) / 60), p = Math.round(u - h * 60 * 60 - v * 60);
          return h + ":" + (v < 10 ? "0" + v : v) + ":" + (p < 10 ? "0" + p : p);
        },
        unformat: function(u) {
          var d = u.split(":"), f = 0;
          return d.length === 3 ? (f = f + Number(d[0]) * 60 * 60, f = f + Number(d[1]) * 60, f = f + Number(d[2])) : d.length === 2 && (f = f + Number(d[0]) * 60, f = f + Number(d[1])), Number(f);
        }
      });
    }(), e;
  });
})(DE);
var C3e = DE.exports;
const E3e = /* @__PURE__ */ ms(C3e), NE = () => /* @__PURE__ */ Z("svg", { "data-cy": "loading-icon", className: "mr-3 w-5 h-5 animate-spin", viewBox: "0 0 24 24", children: [
  /* @__PURE__ */ C("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }),
  /* @__PURE__ */ C(
    "path",
    {
      className: "opacity-75",
      fill: "currentColor",
      d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    }
  )
] }), BE = {
  primary: "bg-primary-60",
  secondary: "bg-white",
  chip: "bg-black",
  ghost: "bg-transparent"
}, Kn = {
  primary: {
    hover: "bg-primary-70",
    active: "bg-primary-80",
    focus: "bg-primary-60",
    disabled: "bg-neutral-10"
  },
  secondary: {
    hover: "bg-neutral-10",
    active: "bg-neutral-30",
    focus: "bg-white",
    disabled: "bg-neutral-10"
  },
  chip: {
    hover: "bg-neutral-70",
    active: "bg-primary-90",
    focus: "bg-black",
    disabled: "bg-neutral-10"
  },
  ghost: {
    hover: "bg-neutral-10",
    active: "bg-neutral-30",
    focus: "bg-white",
    disabled: "bg-neutral-10"
  }
}, xw = {
  xSmall: {
    verticalSize: "h-[1.5rem]",
    typography: "text-paragraph-small"
  },
  small: {
    verticalSize: "h-[2rem]",
    typography: "text-paragraph-medium"
  },
  medium: {
    verticalSize: "h-8",
    typography: "text-paragraph-large"
  }
}, FE = ({
  label: t,
  kind: e = "primary",
  disabled: r,
  icon: n,
  iconPosition: a,
  loading: o,
  size: i = "medium",
  customAttrs: l,
  ...c
}) => {
  const { className: u, ...d } = c, f = r ? "text-neutral-50" : e === "chip" ? "text-white" : "text-black", h = e === "ghost" ? "border-none" : r ? "border border-neutral-50" : "border border-black", v = BE[e], p = `hover:${Kn[e].hover}`, g = `focus:${Kn[e].focus}`, m = `active:${Kn[e].active}`, w = `disabled:${Kn[e].disabled}`, y = xw[i].typography, b = xw[i].verticalSize, _ = [
    f,
    h,
    v,
    p,
    g,
    m,
    w,
    y,
    b,
    u
  ].join(" ");
  return /* @__PURE__ */ C(
    "button",
    {
      disabled: r,
      ...l,
      className: `focus:ring-2 focus:ring-offset-2 focus:ring-primary-60 rounded-pill ${t && "px-5"} ${_}`,
      ...d,
      children: o ? /* @__PURE__ */ Z("div", { className: "flex gap-2 justify-center items-center", children: [
        /* @__PURE__ */ C(NE, {}),
        /* @__PURE__ */ C("p", { children: "Carregando" }, 2)
      ] }) : /* @__PURE__ */ Z(
        "div",
        {
          className: `flex truncate justify-center gap-4 items-center ${a === "right" && "flex-row-reverse"}`,
          children: [
            n && n !== "None" && /* @__PURE__ */ C(Me, { icon: n, extraClassNames: i === "medium" ? "w-5" : "w-[12px]" }),
            t
          ]
        }
      )
    }
  );
}, $E = (t) => {
  if (!t) return;
  const e = ["B", "kB", "MB", "GB", "TB"], r = Math.floor(Math.log(t) / Math.log(1024));
  return `${(t / Math.pow(1024, r)).toFixed(2)} ${e[r]}`;
}, VE = (t) => {
  var e;
  return (e = t == null ? void 0 : t.split(".").pop()) == null ? void 0 : e.toUpperCase();
}, S3e = ({ progress: t }) => /* @__PURE__ */ C("div", { className: "w-full h-4 bg-neutral-10 rounded", children: /* @__PURE__ */ C("div", { className: "h-4 bg-primary-60 rounded", style: { width: E3e(t).format("% 0") } }) }), R3e = ({ maximumFileSizeInMB: t }) => /* @__PURE__ */ C("span", { className: "text-orange-30 text-paragraph-small", children: `Tamanho do arquivo superior ao limite de ${t}MB` }), M3e = ({ fileUploadProgress: t, file: e }) => /* @__PURE__ */ Z(gr, { children: [
  /* @__PURE__ */ C("span", { children: e == null ? void 0 : e.name }),
  t >= 1 && /* @__PURE__ */ Z("div", { children: [
    /* @__PURE__ */ Z("span", { children: [
      VE(e == null ? void 0 : e.name),
      ", "
    ] }),
    /* @__PURE__ */ C("span", { children: $E(e == null ? void 0 : e.size) })
  ] })
] }), A3e = ({
  file: t,
  fileIndex: e,
  handleRemoveFile: r,
  maximumFileSizeInMB: n,
  fileUploadProgress: a = 0
}) => {
  const o = a >= 1 && n && t && (t == null ? void 0 : t.size) > n * 1e6;
  return /* @__PURE__ */ Z("div", { className: "flex items-center justify-between w-full gap-6 px-4", children: [
    /* @__PURE__ */ Z("div", { className: "w-full", children: [
      /* @__PURE__ */ Z("div", { className: "flex flex-col text-paragraph-medium", children: [
        /* @__PURE__ */ C(M3e, { file: t, fileUploadProgress: a }),
        o && /* @__PURE__ */ C(R3e, { maximumFileSizeInMB: n })
      ] }),
      a < 1 && /* @__PURE__ */ C(S3e, { progress: a })
    ] }),
    a >= 1 && /* @__PURE__ */ C(
      FE,
      {
        label: "Cancelar",
        kind: "secondary",
        type: "button",
        onClick: () => e !== void 0 && r(e)
      }
    )
  ] });
}, k3e = ({
  disabled: t,
  icon: e,
  customAttrs: r,
  kind: n = "primary",
  shape: a = "circle",
  ...o
}) => {
  const { className: i, ...l } = o, c = "text-black", u = n === "ghost" ? "border-none" : t ? "border border-neutral-50" : "border border-black", d = a === "square" ? "rounded-none" : a === "circle" && "rounded-pill", f = BE[n], h = `hover:${Kn[n].hover}`, v = `focus:${Kn[n].focus}`, p = `active:${Kn[n].active}`, g = `disabled:${Kn[n].disabled}`, m = [
    c,
    u,
    d,
    f,
    h,
    v,
    p,
    g,
    i
  ].join(" ");
  return /* @__PURE__ */ C(
    "button",
    {
      disabled: t,
      ...r,
      className: `flex items-center justify-center p-4 text-paragraph-large focus:ring-2 focus:ring-offset-2 focus:ring-primary-60 ${m}`,
      ...l,
      children: e && e !== "None" && /* @__PURE__ */ C(Me, { icon: e, extraClassNames: "size-5" })
    }
  );
}, L3e = ({ filename: t, fileSize: e }) => /* @__PURE__ */ Z(gr, { children: [
  /* @__PURE__ */ C("span", { children: t }),
  /* @__PURE__ */ Z("div", { children: [
    /* @__PURE__ */ Z("span", { children: [
      VE(t),
      ", "
    ] }),
    /* @__PURE__ */ C("span", { children: $E(e) })
  ] })
] }), T3e = ({
  storedFile: t,
  handleRemoveStoredFile: e,
  loading: r,
  fileIndex: n,
  clickedFileIndex: a,
  setClickedFileIndex: o
}) => /* @__PURE__ */ Z("div", { className: "flex items-center justify-between w-full gap-6", children: [
  /* @__PURE__ */ C("div", { className: "w-full", children: /* @__PURE__ */ C("div", { className: "flex flex-col text-paragraph-medium", children: /* @__PURE__ */ C(L3e, { filename: t.filename, fileSize: t.fileSize }) }) }),
  r && n === a ? /* @__PURE__ */ C(NE, {}) : /* @__PURE__ */ C(
    k3e,
    {
      icon: "XMarkIcon",
      kind: "secondary",
      type: "button",
      disabled: r && n !== a,
      onClick: () => {
        e == null || e(t.id), o(n);
      }
    }
  )
] }), O3e = () => /* @__PURE__ */ C("div", { className: "flex justify-center items-center size-12 rounded-2xl bg-gray-10", children: /* @__PURE__ */ C(Me, { className: "w-5", icon: "DocumentIcon" }) }), I3e = ({
  storedFile: t,
  handleRemoveStoredFile: e,
  loading: r,
  fileIndex: n,
  clickedFileIndex: a,
  setClickedFileIndex: o
}) => {
  const [i, l] = gt(0);
  return En(() => {
    i < 1 && setTimeout(() => {
      l(i + 0.05);
    }, 20);
  }, [i]), /* @__PURE__ */ Z("div", { className: "flex gap-5 items-center py-4 rounded", children: [
    /* @__PURE__ */ C(O3e, {}),
    /* @__PURE__ */ C(
      T3e,
      {
        storedFile: t,
        handleRemoveStoredFile: e,
        loading: r,
        fileIndex: n,
        setClickedFileIndex: o,
        clickedFileIndex: a
      }
    )
  ] });
}, P3e = ({ fileSize: t, fileUploadProgress: e, maximumFileSizeInMB: r }) => {
  const a = `flex justify-center items-center size-12 rounded-2xl ${((o, i, l) => {
    if (!o || !i || !l) return "bg-gray-10";
    const c = o && o > i * 1e6 ? "bg-danger-10" : "bg-primary-10";
    return l >= 1 ? c : "bg-gray-10";
  })(
    t,
    r,
    e
  )}`;
  return /* @__PURE__ */ C("div", { className: a, children: /* @__PURE__ */ C(
    Me,
    {
      solid: !!t,
      className: t ? "text-primary-0 w-5" : "size-7",
      icon: "DocumentIcon"
    }
  ) });
}, D3e = ({
  allowedFileTypes: t,
  description: e,
  handleOnChange: r,
  inputFileRef: n,
  multipleFiles: a
}) => {
  const o = t == null ? void 0 : t.join(", ");
  return /* @__PURE__ */ Z("div", { className: "flex justify-between items-center w-full gap-4", children: [
    /* @__PURE__ */ C("span", { className: "w-4/5 text-paragraph-medium", children: e }),
    /* @__PURE__ */ C(
      "input",
      {
        ref: n,
        type: "file",
        style: { display: "none" },
        onChange: r,
        multiple: a,
        accept: o
      }
    ),
    /* @__PURE__ */ C(
      FE,
      {
        label: "Enviar",
        kind: "secondary",
        size: "small",
        type: "button",
        onClick: () => {
          var i;
          (i = n.current) == null || i.click();
        }
      }
    )
  ] });
}, Cw = ({
  allowedFileTypes: t,
  description: e,
  file: r,
  fileIndex: n,
  handleOnChange: a,
  handleRemoveFile: o,
  inputFileRef: i,
  maximumFileSizeInMB: l,
  multipleFiles: c
}) => {
  const [u, d] = gt(0);
  return En(() => {
    u < 1 && setTimeout(() => {
      d(u + 0.05);
    }, 20);
  }, [u]), /* @__PURE__ */ Z("div", { className: "flex gap-5 items-center py-4 rounded", children: [
    /* @__PURE__ */ C(
      P3e,
      {
        fileSize: r == null ? void 0 : r.size,
        fileUploadProgress: u,
        maximumFileSizeInMB: l
      }
    ),
    i ? /* @__PURE__ */ C(
      D3e,
      {
        description: e,
        handleOnChange: a,
        inputFileRef: i,
        multipleFiles: c,
        allowedFileTypes: t
      }
    ) : /* @__PURE__ */ C(
      A3e,
      {
        file: r,
        fileIndex: n,
        fileUploadProgress: u,
        handleRemoveFile: o,
        maximumFileSizeInMB: l
      }
    )
  ] });
}, N3e = ({ ...t }) => {
  const e = Ww(null), { uploadedFiles: r, multipleFiles: n, storedFiles: a, handleRemoveStoredFile: o, loading: i } = t, l = r && r.length > 0, c = a && a.length > 0, u = l || c, [d, f] = gt(), h = n || !r || r && (r == null ? void 0 : r.length) < 1;
  return /* @__PURE__ */ Z("div", { className: "flex flex-col gap-4", children: [
    h && /* @__PURE__ */ C("div", { className: "rounded-2xl bg-white px-6 py-4", children: /* @__PURE__ */ C(Cw, { inputFileRef: e, ...t }) }),
    u && /* @__PURE__ */ Z("div", { className: "flex flex-col rounded-2xl bg-white px-6 py-4 overflow-y-auto", children: [
      r == null ? void 0 : r.map((v, p) => /* @__PURE__ */ C(Cw, { fileIndex: p, file: v, ...t }, `uploaded-file-${p}`)),
      a == null ? void 0 : a.map((v, p) => /* @__PURE__ */ C(
        I3e,
        {
          storedFile: v,
          handleRemoveStoredFile: o,
          loading: i,
          clickedFileIndex: d,
          fileIndex: p,
          setClickedFileIndex: f
        },
        `stored-file-${p}`
      ))
    ] })
  ] });
}, B3e = ke.forwardRef(
  ({
    label: t,
    description: e,
    error: r,
    required: n,
    maximumFileSizeInMB: a,
    allowedFileTypes: o,
    customAttrs: i,
    tooltipContent: l,
    multipleFiles: c,
    onChangeFiles: u,
    ...d
  }, f) => {
    const [h, v] = gt(), { id: p, disabled: g, className: m, storedFiles: w, handleRemoveStoredFile: y, loading: b, ..._ } = d, x = g ? "text-neutral-40" : "text-black", E = (M) => {
      const R = M.target.files;
      if (R) {
        const A = h ? [...h, ...R] : [...R];
        v(A);
      }
      M.target.value = "";
    }, S = (M) => {
      const R = h == null ? void 0 : h.filter((A, k) => k !== M);
      v(R);
    };
    return En(() => {
      if (h && u) {
        const M = c ? h : h[0];
        u(M);
      }
    }, [h]), /* @__PURE__ */ Z("div", { className: `flex relative flex-col ${m}`, children: [
      /* @__PURE__ */ C(x3e, { id: p, label: t, required: n, disabledClass: x, tooltipContent: l }),
      /* @__PURE__ */ C(
        N3e,
        {
          allowedFileTypes: o,
          description: e,
          handleOnChange: E,
          handleRemoveFile: S,
          inputAttrs: { ...i, ..._ },
          maximumFileSizeInMB: a,
          multipleFiles: c,
          uploadedFiles: h,
          storedFiles: w,
          handleRemoveStoredFile: y,
          loading: b
        }
      ),
      r && /* @__PURE__ */ C("span", { className: "text-paragraph-small text-orange-30", children: r })
    ] });
  }
);
B3e.displayName = "FileInput";
const F3e = "foton__root___PUt7D", $3e = "foton__progressRoot___YMVWa", V3e = "foton__progressIndicator___p-Gky", Z3e = "foton__label___1sHWA", H3e = "foton__rightLabelContainer___5nfPm", M0 = {
  root: F3e,
  progressRoot: $3e,
  progressIndicator: V3e,
  label: Z3e,
  rightLabelContainer: H3e
}, Ew = ({ value: t, position: e, color: r }) => /* @__PURE__ */ C(
  "div",
  {
    className: G(e === "inside" && M0.label, "font-bold"),
    style: {
      left: e === "inside" ? `${t / 2}%` : "auto",
      color: r || (e === "inside" ? "#f7fee7" : "black")
    },
    children: `${t}%`
  }
), B6e = ({
  value: t,
  size: e,
  color: r,
  label: n = {
    color: void 0,
    position: "inside"
  }
}) => {
  const o = G({
    small: "h-2",
    medium: "h-3 text-caption-small",
    large: "h-4 text-caption-medium"
  }[e]);
  return /* @__PURE__ */ Z("div", { children: [
    n.position === "right" && /* @__PURE__ */ C("div", { className: M0.rightLabelContainer, children: /* @__PURE__ */ C(Ew, { value: t, position: n.position, color: n.color }) }),
    /* @__PURE__ */ C(lte, { className: G(M0.progressRoot, o), value: t, children: /* @__PURE__ */ Z("span", { children: [
      /* @__PURE__ */ C(
        ste,
        {
          className: M0.progressIndicator,
          style: {
            backgroundColor: r || "#22c55e",
            transform: `translateX(-${100 - t}%)`
          },
          "aria-valuetext": `${t}%`
        }
      ),
      e !== "small" && n.position === "inside" && /* @__PURE__ */ C(Ew, { value: t, position: n.position, color: n.color })
    ] }) })
  ] });
};
var ZE = {}, HE = {}, f5 = {}, jE = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var e = {
    animating: !1,
    autoplaying: null,
    currentDirection: 0,
    currentLeft: null,
    currentSlide: 0,
    direction: 1,
    dragging: !1,
    edgeDragged: !1,
    initialized: !1,
    lazyLoadedList: [],
    listHeight: null,
    listWidth: null,
    scrolling: !1,
    slideCount: null,
    slideHeight: null,
    slideWidth: null,
    swipeLeft: null,
    swiped: !1,
    // used by swipeEvent. differentites between touch and swipe.
    swiping: !1,
    touchObject: {
      startX: 0,
      startY: 0,
      curX: 0,
      curY: 0
    },
    trackStyle: {},
    trackWidth: 0,
    targetSlide: 0
  };
  t.default = e;
})(jE);
var j3e = "Expected a function", Sw = NaN, W3e = "[object Symbol]", z3e = /^\s+|\s+$/g, G3e = /^[-+]0x[0-9a-f]+$/i, U3e = /^0b[01]+$/i, Y3e = /^0o[0-7]+$/i, X3e = parseInt, q3e = typeof bl == "object" && bl && bl.Object === Object && bl, K3e = typeof self == "object" && self && self.Object === Object && self, Q3e = q3e || K3e || Function("return this")(), J3e = Object.prototype, e4e = J3e.toString, t4e = Math.max, r4e = Math.min, Mf = function() {
  return Q3e.Date.now();
};
function n4e(t, e, r) {
  var n, a, o, i, l, c, u = 0, d = !1, f = !1, h = !0;
  if (typeof t != "function")
    throw new TypeError(j3e);
  e = Rw(e) || 0, S2(r) && (d = !!r.leading, f = "maxWait" in r, o = f ? t4e(Rw(r.maxWait) || 0, e) : o, h = "trailing" in r ? !!r.trailing : h);
  function v(E) {
    var S = n, M = a;
    return n = a = void 0, u = E, i = t.apply(M, S), i;
  }
  function p(E) {
    return u = E, l = setTimeout(w, e), d ? v(E) : i;
  }
  function g(E) {
    var S = E - c, M = E - u, R = e - S;
    return f ? r4e(R, o - M) : R;
  }
  function m(E) {
    var S = E - c, M = E - u;
    return c === void 0 || S >= e || S < 0 || f && M >= o;
  }
  function w() {
    var E = Mf();
    if (m(E))
      return y(E);
    l = setTimeout(w, g(E));
  }
  function y(E) {
    return l = void 0, h && n ? v(E) : (n = a = void 0, i);
  }
  function b() {
    l !== void 0 && clearTimeout(l), u = 0, n = c = a = l = void 0;
  }
  function _() {
    return l === void 0 ? i : y(Mf());
  }
  function x() {
    var E = Mf(), S = m(E);
    if (n = arguments, a = this, c = E, S) {
      if (l === void 0)
        return p(c);
      if (f)
        return l = setTimeout(w, e), v(c);
    }
    return l === void 0 && (l = setTimeout(w, e)), i;
  }
  return x.cancel = b, x.flush = _, x;
}
function S2(t) {
  var e = typeof t;
  return !!t && (e == "object" || e == "function");
}
function a4e(t) {
  return !!t && typeof t == "object";
}
function o4e(t) {
  return typeof t == "symbol" || a4e(t) && e4e.call(t) == W3e;
}
function Rw(t) {
  if (typeof t == "number")
    return t;
  if (o4e(t))
    return Sw;
  if (S2(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = S2(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = t.replace(z3e, "");
  var r = U3e.test(t);
  return r || Y3e.test(t) ? X3e(t.slice(2), r ? 2 : 8) : G3e.test(t) ? Sw : +t;
}
var i4e = n4e, WE = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(t) {
  (function() {
    var e = {}.hasOwnProperty;
    function r() {
      for (var o = "", i = 0; i < arguments.length; i++) {
        var l = arguments[i];
        l && (o = a(o, n(l)));
      }
      return o;
    }
    function n(o) {
      if (typeof o == "string" || typeof o == "number")
        return o;
      if (typeof o != "object")
        return "";
      if (Array.isArray(o))
        return r.apply(null, o);
      if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
        return o.toString();
      var i = "";
      for (var l in o)
        e.call(o, l) && o[l] && (i = a(i, l));
      return i;
    }
    function a(o, i) {
      return i ? o ? o + " " + i : o + i : o;
    }
    t.exports ? (r.default = r, t.exports = r) : window.classNames = r;
  })();
})(WE);
var h5 = WE.exports, U = {}, fp = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var e = r(ke);
  function r(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var n = {
    accessibility: !0,
    adaptiveHeight: !1,
    afterChange: null,
    appendDots: function(o) {
      return /* @__PURE__ */ e.default.createElement("ul", {
        style: {
          display: "block"
        }
      }, o);
    },
    arrows: !0,
    autoplay: !1,
    autoplaySpeed: 3e3,
    beforeChange: null,
    centerMode: !1,
    centerPadding: "50px",
    className: "",
    cssEase: "ease",
    customPaging: function(o) {
      return /* @__PURE__ */ e.default.createElement("button", null, o + 1);
    },
    dots: !1,
    dotsClass: "slick-dots",
    draggable: !0,
    easing: "linear",
    edgeFriction: 0.35,
    fade: !1,
    focusOnSelect: !1,
    infinite: !0,
    initialSlide: 0,
    lazyLoad: null,
    nextArrow: null,
    onEdge: null,
    onInit: null,
    onLazyLoadError: null,
    onReInit: null,
    pauseOnDotsHover: !1,
    pauseOnFocus: !1,
    pauseOnHover: !0,
    prevArrow: null,
    responsive: null,
    rows: 1,
    rtl: !1,
    slide: "div",
    slidesPerRow: 1,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 500,
    swipe: !0,
    swipeEvent: null,
    swipeToSlide: !1,
    touchMove: !0,
    touchThreshold: 5,
    useCSS: !0,
    useTransform: !0,
    variableWidth: !1,
    vertical: !1,
    waitForAnimate: !0,
    asNavFor: null
  };
  t.default = n;
})(fp);
Object.defineProperty(U, "__esModule", {
  value: !0
});
U.checkSpecKeys = U.checkNavigable = U.changeSlide = U.canUseDOM = U.canGoNext = void 0;
U.clamp = GE;
U.extractObject = void 0;
U.filterSettings = _4e;
U.validSettings = U.swipeStart = U.swipeMove = U.swipeEnd = U.slidesOnRight = U.slidesOnLeft = U.slideHandler = U.siblingDirection = U.safePreventDefault = U.lazyStartIndex = U.lazySlidesOnRight = U.lazySlidesOnLeft = U.lazyEndIndex = U.keyHandler = U.initializedState = U.getWidth = U.getTrackLeft = U.getTrackCSS = U.getTrackAnimateCSS = U.getTotalSlides = U.getSwipeDirection = U.getSlideCount = U.getRequiredLazySlides = U.getPreClones = U.getPostClones = U.getOnDemandLazySlides = U.getNavigableIndexes = U.getHeight = void 0;
var l4e = zE(ke), s4e = zE(fp);
function zE(t) {
  return t && t.__esModule ? t : { default: t };
}
function ps(t) {
  "@babel/helpers - typeof";
  return ps = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ps(t);
}
function Mw(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ze(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Mw(Object(r), !0).forEach(function(n) {
      c4e(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Mw(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function c4e(t, e, r) {
  return e = u4e(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function u4e(t) {
  var e = d4e(t, "string");
  return ps(e) == "symbol" ? e : String(e);
}
function d4e(t, e) {
  if (ps(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (ps(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function GE(t, e, r) {
  return Math.max(e, Math.min(t, r));
}
var vi = U.safePreventDefault = function(e) {
  var r = ["onTouchStart", "onTouchMove", "onWheel"];
  r.includes(e._reactName) || e.preventDefault();
}, UE = U.getOnDemandLazySlides = function(e) {
  for (var r = [], n = YE(e), a = XE(e), o = n; o < a; o++)
    e.lazyLoadedList.indexOf(o) < 0 && r.push(o);
  return r;
};
U.getRequiredLazySlides = function(e) {
  for (var r = [], n = YE(e), a = XE(e), o = n; o < a; o++)
    r.push(o);
  return r;
};
var YE = U.lazyStartIndex = function(e) {
  return e.currentSlide - f4e(e);
}, XE = U.lazyEndIndex = function(e) {
  return e.currentSlide + h4e(e);
}, f4e = U.lazySlidesOnLeft = function(e) {
  return e.centerMode ? Math.floor(e.slidesToShow / 2) + (parseInt(e.centerPadding) > 0 ? 1 : 0) : 0;
}, h4e = U.lazySlidesOnRight = function(e) {
  return e.centerMode ? Math.floor((e.slidesToShow - 1) / 2) + 1 + (parseInt(e.centerPadding) > 0 ? 1 : 0) : e.slidesToShow;
}, R2 = U.getWidth = function(e) {
  return e && e.offsetWidth || 0;
}, qE = U.getHeight = function(e) {
  return e && e.offsetHeight || 0;
}, KE = U.getSwipeDirection = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n, a, o, i;
  return n = e.startX - e.curX, a = e.startY - e.curY, o = Math.atan2(a, n), i = Math.round(o * 180 / Math.PI), i < 0 && (i = 360 - Math.abs(i)), i <= 45 && i >= 0 || i <= 360 && i >= 315 ? "left" : i >= 135 && i <= 225 ? "right" : r === !0 ? i >= 35 && i <= 135 ? "up" : "down" : "vertical";
}, QE = U.canGoNext = function(e) {
  var r = !0;
  return e.infinite || (e.centerMode && e.currentSlide >= e.slideCount - 1 || e.slideCount <= e.slidesToShow || e.currentSlide >= e.slideCount - e.slidesToShow) && (r = !1), r;
};
U.extractObject = function(e, r) {
  var n = {};
  return r.forEach(function(a) {
    return n[a] = e[a];
  }), n;
};
U.initializedState = function(e) {
  var r = l4e.default.Children.count(e.children), n = e.listRef, a = Math.ceil(R2(n)), o = e.trackRef && e.trackRef.node, i = Math.ceil(R2(o)), l;
  if (e.vertical)
    l = a;
  else {
    var c = e.centerMode && parseInt(e.centerPadding) * 2;
    typeof e.centerPadding == "string" && e.centerPadding.slice(-1) === "%" && (c *= a / 100), l = Math.ceil((a - c) / e.slidesToShow);
  }
  var u = n && qE(n.querySelector('[data-index="0"]')), d = u * e.slidesToShow, f = e.currentSlide === void 0 ? e.initialSlide : e.currentSlide;
  e.rtl && e.currentSlide === void 0 && (f = r - 1 - e.initialSlide);
  var h = e.lazyLoadedList || [], v = UE(ze(ze({}, e), {}, {
    currentSlide: f,
    lazyLoadedList: h
  }));
  h = h.concat(v);
  var p = {
    slideCount: r,
    slideWidth: l,
    listWidth: a,
    trackWidth: i,
    currentSlide: f,
    slideHeight: u,
    listHeight: d,
    lazyLoadedList: h
  };
  return e.autoplaying === null && e.autoplay && (p.autoplaying = "playing"), p;
};
U.slideHandler = function(e) {
  var r = e.waitForAnimate, n = e.animating, a = e.fade, o = e.infinite, i = e.index, l = e.slideCount, c = e.lazyLoad, u = e.currentSlide, d = e.centerMode, f = e.slidesToScroll, h = e.slidesToShow, v = e.useCSS, p = e.lazyLoadedList;
  if (r && n) return {};
  var g = i, m, w, y, b = {}, _ = {}, x = o ? i : GE(i, 0, l - 1);
  if (a) {
    if (!o && (i < 0 || i >= l)) return {};
    i < 0 ? g = i + l : i >= l && (g = i - l), c && p.indexOf(g) < 0 && (p = p.concat(g)), b = {
      animating: !0,
      currentSlide: g,
      lazyLoadedList: p,
      targetSlide: g
    }, _ = {
      animating: !1,
      targetSlide: g
    };
  } else
    m = g, g < 0 ? (m = g + l, o ? l % f !== 0 && (m = l - l % f) : m = 0) : !QE(e) && g > u ? g = m = u : d && g >= l ? (g = o ? l : l - 1, m = o ? 0 : l - 1) : g >= l && (m = g - l, o ? l % f !== 0 && (m = 0) : m = l - h), !o && g + h >= l && (m = l - h), w = ku(ze(ze({}, e), {}, {
      slideIndex: g
    })), y = ku(ze(ze({}, e), {}, {
      slideIndex: m
    })), o || (w === y && (g = m), w = y), c && (p = p.concat(UE(ze(ze({}, e), {}, {
      currentSlide: g
    })))), v ? (b = {
      animating: !0,
      currentSlide: m,
      trackStyle: JE(ze(ze({}, e), {}, {
        left: w
      })),
      lazyLoadedList: p,
      targetSlide: x
    }, _ = {
      animating: !1,
      currentSlide: m,
      trackStyle: Au(ze(ze({}, e), {}, {
        left: y
      })),
      swipeLeft: null,
      targetSlide: x
    }) : b = {
      currentSlide: m,
      trackStyle: Au(ze(ze({}, e), {}, {
        left: y
      })),
      lazyLoadedList: p,
      targetSlide: x
    };
  return {
    state: b,
    nextState: _
  };
};
U.changeSlide = function(e, r) {
  var n, a, o, i, l, c = e.slidesToScroll, u = e.slidesToShow, d = e.slideCount, f = e.currentSlide, h = e.targetSlide, v = e.lazyLoad, p = e.infinite;
  if (i = d % c !== 0, n = i ? 0 : (d - f) % c, r.message === "previous")
    o = n === 0 ? c : u - n, l = f - o, v && !p && (a = f - o, l = a === -1 ? d - 1 : a), p || (l = h - c);
  else if (r.message === "next")
    o = n === 0 ? c : n, l = f + o, v && !p && (l = (f + c) % d + n), p || (l = h + c);
  else if (r.message === "dots")
    l = r.index * r.slidesToScroll;
  else if (r.message === "children") {
    if (l = r.index, p) {
      var g = m4e(ze(ze({}, e), {}, {
        targetSlide: l
      }));
      l > r.currentSlide && g === "left" ? l = l - d : l < r.currentSlide && g === "right" && (l = l + d);
    }
  } else r.message === "index" && (l = Number(r.index));
  return l;
};
U.keyHandler = function(e, r, n) {
  return e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !r ? "" : e.keyCode === 37 ? n ? "next" : "previous" : e.keyCode === 39 ? n ? "previous" : "next" : "";
};
U.swipeStart = function(e, r, n) {
  return e.target.tagName === "IMG" && vi(e), !r || !n && e.type.indexOf("mouse") !== -1 ? "" : {
    dragging: !0,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};
U.swipeMove = function(e, r) {
  var n = r.scrolling, a = r.animating, o = r.vertical, i = r.swipeToSlide, l = r.verticalSwiping, c = r.rtl, u = r.currentSlide, d = r.edgeFriction, f = r.edgeDragged, h = r.onEdge, v = r.swiped, p = r.swiping, g = r.slideCount, m = r.slidesToScroll, w = r.infinite, y = r.touchObject, b = r.swipeEvent, _ = r.listHeight, x = r.listWidth;
  if (!n) {
    if (a) return vi(e);
    o && i && l && vi(e);
    var E, S = {}, M = ku(r);
    y.curX = e.touches ? e.touches[0].pageX : e.clientX, y.curY = e.touches ? e.touches[0].pageY : e.clientY, y.swipeLength = Math.round(Math.sqrt(Math.pow(y.curX - y.startX, 2)));
    var R = Math.round(Math.sqrt(Math.pow(y.curY - y.startY, 2)));
    if (!l && !p && R > 10)
      return {
        scrolling: !0
      };
    l && (y.swipeLength = R);
    var A = (c ? -1 : 1) * (y.curX > y.startX ? 1 : -1);
    l && (A = y.curY > y.startY ? 1 : -1);
    var k = Math.ceil(g / m), L = KE(r.touchObject, l), T = y.swipeLength;
    return w || (u === 0 && (L === "right" || L === "down") || u + 1 >= k && (L === "left" || L === "up") || !QE(r) && (L === "left" || L === "up")) && (T = y.swipeLength * d, f === !1 && h && (h(L), S.edgeDragged = !0)), !v && b && (b(L), S.swiped = !0), o ? E = M + T * (_ / x) * A : c ? E = M - T * A : E = M + T * A, l && (E = M + T * A), S = ze(ze({}, S), {}, {
      touchObject: y,
      swipeLeft: E,
      trackStyle: Au(ze(ze({}, r), {}, {
        left: E
      }))
    }), Math.abs(y.curX - y.startX) < Math.abs(y.curY - y.startY) * 0.8 || y.swipeLength > 10 && (S.swiping = !0, vi(e)), S;
  }
};
U.swipeEnd = function(e, r) {
  var n = r.dragging, a = r.swipe, o = r.touchObject, i = r.listWidth, l = r.touchThreshold, c = r.verticalSwiping, u = r.listHeight, d = r.swipeToSlide, f = r.scrolling, h = r.onSwipe, v = r.targetSlide, p = r.currentSlide, g = r.infinite;
  if (!n)
    return a && vi(e), {};
  var m = c ? u / l : i / l, w = KE(o, c), y = {
    dragging: !1,
    edgeDragged: !1,
    scrolling: !1,
    swiping: !1,
    swiped: !1,
    swipeLeft: null,
    touchObject: {}
  };
  if (f || !o.swipeLength)
    return y;
  if (o.swipeLength > m) {
    vi(e), h && h(w);
    var b, _, x = g ? p : v;
    switch (w) {
      case "left":
      case "up":
        _ = x + kw(r), b = d ? Aw(r, _) : _, y.currentDirection = 0;
        break;
      case "right":
      case "down":
        _ = x - kw(r), b = d ? Aw(r, _) : _, y.currentDirection = 1;
        break;
      default:
        b = x;
    }
    y.triggerSlideHandler = b;
  } else {
    var E = ku(r);
    y.trackStyle = JE(ze(ze({}, r), {}, {
      left: E
    }));
  }
  return y;
};
var v4e = U.getNavigableIndexes = function(e) {
  for (var r = e.infinite ? e.slideCount * 2 : e.slideCount, n = e.infinite ? e.slidesToShow * -1 : 0, a = e.infinite ? e.slidesToShow * -1 : 0, o = []; n < r; )
    o.push(n), n = a + e.slidesToScroll, a += Math.min(e.slidesToScroll, e.slidesToShow);
  return o;
}, Aw = U.checkNavigable = function(e, r) {
  var n = v4e(e), a = 0;
  if (r > n[n.length - 1])
    r = n[n.length - 1];
  else
    for (var o in n) {
      if (r < n[o]) {
        r = a;
        break;
      }
      a = n[o];
    }
  return r;
}, kw = U.getSlideCount = function(e) {
  var r = e.centerMode ? e.slideWidth * Math.floor(e.slidesToShow / 2) : 0;
  if (e.swipeToSlide) {
    var n, a = e.listRef, o = a.querySelectorAll && a.querySelectorAll(".slick-slide") || [];
    if (Array.from(o).every(function(c) {
      if (e.vertical) {
        if (c.offsetTop + qE(c) / 2 > e.swipeLeft * -1)
          return n = c, !1;
      } else if (c.offsetLeft - r + R2(c) / 2 > e.swipeLeft * -1)
        return n = c, !1;
      return !0;
    }), !n)
      return 0;
    var i = e.rtl === !0 ? e.slideCount - e.currentSlide : e.currentSlide, l = Math.abs(n.dataset.index - i) || 1;
    return l;
  } else
    return e.slidesToScroll;
}, hp = U.checkSpecKeys = function(e, r) {
  return r.reduce(function(n, a) {
    return n && e.hasOwnProperty(a);
  }, !0) ? null : console.error("Keys Missing:", e);
}, Au = U.getTrackCSS = function(e) {
  hp(e, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var r, n, a = e.slideCount + 2 * e.slidesToShow;
  e.vertical ? n = a * e.slideHeight : r = g4e(e) * e.slideWidth;
  var o = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };
  if (e.useTransform) {
    var i = e.vertical ? "translate3d(0px, " + e.left + "px, 0px)" : "translate3d(" + e.left + "px, 0px, 0px)", l = e.vertical ? "translate3d(0px, " + e.left + "px, 0px)" : "translate3d(" + e.left + "px, 0px, 0px)", c = e.vertical ? "translateY(" + e.left + "px)" : "translateX(" + e.left + "px)";
    o = ze(ze({}, o), {}, {
      WebkitTransform: i,
      transform: l,
      msTransform: c
    });
  } else
    e.vertical ? o.top = e.left : o.left = e.left;
  return e.fade && (o = {
    opacity: 1
  }), r && (o.width = r), n && (o.height = n), window && !window.addEventListener && window.attachEvent && (e.vertical ? o.marginTop = e.left + "px" : o.marginLeft = e.left + "px"), o;
}, JE = U.getTrackAnimateCSS = function(e) {
  hp(e, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var r = Au(e);
  return e.useTransform ? (r.WebkitTransition = "-webkit-transform " + e.speed + "ms " + e.cssEase, r.transition = "transform " + e.speed + "ms " + e.cssEase) : e.vertical ? r.transition = "top " + e.speed + "ms " + e.cssEase : r.transition = "left " + e.speed + "ms " + e.cssEase, r;
}, ku = U.getTrackLeft = function(e) {
  if (e.unslick)
    return 0;
  hp(e, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
  var r = e.slideIndex, n = e.trackRef, a = e.infinite, o = e.centerMode, i = e.slideCount, l = e.slidesToShow, c = e.slidesToScroll, u = e.slideWidth, d = e.listWidth, f = e.variableWidth, h = e.slideHeight, v = e.fade, p = e.vertical, g = 0, m, w, y = 0;
  if (v || e.slideCount === 1)
    return 0;
  var b = 0;
  if (a ? (b = -A0(e), i % c !== 0 && r + c > i && (b = -(r > i ? l - (r - i) : i % c)), o && (b += parseInt(l / 2))) : (i % c !== 0 && r + c > i && (b = l - i % c), o && (b = parseInt(l / 2))), g = b * u, y = b * h, p ? m = r * h * -1 + y : m = r * u * -1 + g, f === !0) {
    var _, x = n && n.node;
    if (_ = r + A0(e), w = x && x.childNodes[_], m = w ? w.offsetLeft * -1 : 0, o === !0) {
      _ = a ? r + A0(e) : r, w = x && x.children[_], m = 0;
      for (var E = 0; E < _; E++)
        m -= x && x.children[E] && x.children[E].offsetWidth;
      m -= parseInt(e.centerPadding), m += w && (d - w.offsetWidth) / 2;
    }
  }
  return m;
}, A0 = U.getPreClones = function(e) {
  return e.unslick || !e.infinite ? 0 : e.variableWidth ? e.slideCount : e.slidesToShow + (e.centerMode ? 1 : 0);
}, p4e = U.getPostClones = function(e) {
  return e.unslick || !e.infinite ? 0 : e.slideCount;
}, g4e = U.getTotalSlides = function(e) {
  return e.slideCount === 1 ? 1 : A0(e) + e.slideCount + p4e(e);
}, m4e = U.siblingDirection = function(e) {
  return e.targetSlide > e.currentSlide ? e.targetSlide > e.currentSlide + w4e(e) ? "left" : "right" : e.targetSlide < e.currentSlide - y4e(e) ? "right" : "left";
}, w4e = U.slidesOnRight = function(e) {
  var r = e.slidesToShow, n = e.centerMode, a = e.rtl, o = e.centerPadding;
  if (n) {
    var i = (r - 1) / 2 + 1;
    return parseInt(o) > 0 && (i += 1), a && r % 2 === 0 && (i += 1), i;
  }
  return a ? 0 : r - 1;
}, y4e = U.slidesOnLeft = function(e) {
  var r = e.slidesToShow, n = e.centerMode, a = e.rtl, o = e.centerPadding;
  if (n) {
    var i = (r - 1) / 2 + 1;
    return parseInt(o) > 0 && (i += 1), !a && r % 2 === 0 && (i += 1), i;
  }
  return a ? r - 1 : 0;
};
U.canUseDOM = function() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
};
var b4e = U.validSettings = Object.keys(s4e.default);
function _4e(t) {
  return b4e.reduce(function(e, r) {
    return t.hasOwnProperty(r) && (e[r] = t[r]), e;
  }, {});
}
var v5 = {};
Object.defineProperty(v5, "__esModule", {
  value: !0
});
v5.Track = void 0;
var Zn = eS(ke), Af = eS(h5), kf = U;
function eS(t) {
  return t && t.__esModule ? t : { default: t };
}
function ki(t) {
  "@babel/helpers - typeof";
  return ki = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ki(t);
}
function M2() {
  return M2 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, M2.apply(this, arguments);
}
function x4e(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function C4e(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, rS(n.key), n);
  }
}
function E4e(t, e, r) {
  return e && C4e(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function S4e(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && A2(t, e);
}
function A2(t, e) {
  return A2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, A2(t, e);
}
function R4e(t) {
  var e = tS();
  return function() {
    var n = Lu(t), a;
    if (e) {
      var o = Lu(this).constructor;
      a = Reflect.construct(n, arguments, o);
    } else
      a = n.apply(this, arguments);
    return M4e(this, a);
  };
}
function M4e(t, e) {
  if (e && (ki(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return k2(t);
}
function k2(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function tS() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (tS = function() {
    return !!t;
  })();
}
function Lu(t) {
  return Lu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Lu(t);
}
function Lw(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Nt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Lw(Object(r), !0).forEach(function(n) {
      L2(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Lw(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function L2(t, e, r) {
  return e = rS(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function rS(t) {
  var e = A4e(t, "string");
  return ki(e) == "symbol" ? e : String(e);
}
function A4e(t, e) {
  if (ki(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (ki(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var Lf = function(e) {
  var r, n, a, o, i;
  e.rtl ? i = e.slideCount - 1 - e.index : i = e.index, a = i < 0 || i >= e.slideCount, e.centerMode ? (o = Math.floor(e.slidesToShow / 2), n = (i - e.currentSlide) % e.slideCount === 0, i > e.currentSlide - o - 1 && i <= e.currentSlide + o && (r = !0)) : r = e.currentSlide <= i && i < e.currentSlide + e.slidesToShow;
  var l;
  e.targetSlide < 0 ? l = e.targetSlide + e.slideCount : e.targetSlide >= e.slideCount ? l = e.targetSlide - e.slideCount : l = e.targetSlide;
  var c = i === l;
  return {
    "slick-slide": !0,
    "slick-active": r,
    "slick-center": n,
    "slick-cloned": a,
    "slick-current": c
    // dubious in case of RTL
  };
}, k4e = function(e) {
  var r = {};
  return (e.variableWidth === void 0 || e.variableWidth === !1) && (r.width = e.slideWidth), e.fade && (r.position = "relative", e.vertical ? r.top = -e.index * parseInt(e.slideHeight) : r.left = -e.index * parseInt(e.slideWidth), r.opacity = e.currentSlide === e.index ? 1 : 0, r.zIndex = e.currentSlide === e.index ? 999 : 998, e.useCSS && (r.transition = "opacity " + e.speed + "ms " + e.cssEase + ", visibility " + e.speed + "ms " + e.cssEase)), r;
}, Tf = function(e, r) {
  return e.key || r;
}, L4e = function(e) {
  var r, n = [], a = [], o = [], i = Zn.default.Children.count(e.children), l = (0, kf.lazyStartIndex)(e), c = (0, kf.lazyEndIndex)(e);
  return Zn.default.Children.forEach(e.children, function(u, d) {
    var f, h = {
      message: "children",
      index: d,
      slidesToScroll: e.slidesToScroll,
      currentSlide: e.currentSlide
    };
    !e.lazyLoad || e.lazyLoad && e.lazyLoadedList.indexOf(d) >= 0 ? f = u : f = /* @__PURE__ */ Zn.default.createElement("div", null);
    var v = k4e(Nt(Nt({}, e), {}, {
      index: d
    })), p = f.props.className || "", g = Lf(Nt(Nt({}, e), {}, {
      index: d
    }));
    if (n.push(/* @__PURE__ */ Zn.default.cloneElement(f, {
      key: "original" + Tf(f, d),
      "data-index": d,
      className: (0, Af.default)(g, p),
      tabIndex: "-1",
      "aria-hidden": !g["slick-active"],
      style: Nt(Nt({
        outline: "none"
      }, f.props.style || {}), v),
      onClick: function(y) {
        f.props && f.props.onClick && f.props.onClick(y), e.focusOnSelect && e.focusOnSelect(h);
      }
    })), e.infinite && e.fade === !1) {
      var m = i - d;
      m <= (0, kf.getPreClones)(e) && (r = -m, r >= l && (f = u), g = Lf(Nt(Nt({}, e), {}, {
        index: r
      })), a.push(/* @__PURE__ */ Zn.default.cloneElement(f, {
        key: "precloned" + Tf(f, r),
        "data-index": r,
        tabIndex: "-1",
        className: (0, Af.default)(g, p),
        "aria-hidden": !g["slick-active"],
        style: Nt(Nt({}, f.props.style || {}), v),
        onClick: function(y) {
          f.props && f.props.onClick && f.props.onClick(y), e.focusOnSelect && e.focusOnSelect(h);
        }
      }))), r = i + d, r < c && (f = u), g = Lf(Nt(Nt({}, e), {}, {
        index: r
      })), o.push(/* @__PURE__ */ Zn.default.cloneElement(f, {
        key: "postcloned" + Tf(f, r),
        "data-index": r,
        tabIndex: "-1",
        className: (0, Af.default)(g, p),
        "aria-hidden": !g["slick-active"],
        style: Nt(Nt({}, f.props.style || {}), v),
        onClick: function(y) {
          f.props && f.props.onClick && f.props.onClick(y), e.focusOnSelect && e.focusOnSelect(h);
        }
      }));
    }
  }), e.rtl ? a.concat(n, o).reverse() : a.concat(n, o);
};
v5.Track = /* @__PURE__ */ function(t) {
  S4e(r, t);
  var e = R4e(r);
  function r() {
    var n;
    x4e(this, r);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return n = e.call.apply(e, [this].concat(o)), L2(k2(n), "node", null), L2(k2(n), "handleRef", function(l) {
      n.node = l;
    }), n;
  }
  return E4e(r, [{
    key: "render",
    value: function() {
      var a = L4e(this.props), o = this.props, i = o.onMouseEnter, l = o.onMouseOver, c = o.onMouseLeave, u = {
        onMouseEnter: i,
        onMouseOver: l,
        onMouseLeave: c
      };
      return /* @__PURE__ */ Zn.default.createElement("div", M2({
        ref: this.handleRef,
        className: "slick-track",
        style: this.props.trackStyle
      }, u), a);
    }
  }]), r;
}(Zn.default.PureComponent);
var p5 = {};
function Li(t) {
  "@babel/helpers - typeof";
  return Li = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Li(t);
}
Object.defineProperty(p5, "__esModule", {
  value: !0
});
p5.Dots = void 0;
var a0 = nS(ke), T4e = nS(h5), Tw = U;
function nS(t) {
  return t && t.__esModule ? t : { default: t };
}
function Ow(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function O4e(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Ow(Object(r), !0).forEach(function(n) {
      I4e(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Ow(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function I4e(t, e, r) {
  return e = aS(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function P4e(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function D4e(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, aS(n.key), n);
  }
}
function N4e(t, e, r) {
  return e && D4e(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function aS(t) {
  var e = B4e(t, "string");
  return Li(e) == "symbol" ? e : String(e);
}
function B4e(t, e) {
  if (Li(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (Li(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function F4e(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && T2(t, e);
}
function T2(t, e) {
  return T2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, T2(t, e);
}
function $4e(t) {
  var e = oS();
  return function() {
    var n = Tu(t), a;
    if (e) {
      var o = Tu(this).constructor;
      a = Reflect.construct(n, arguments, o);
    } else
      a = n.apply(this, arguments);
    return V4e(this, a);
  };
}
function V4e(t, e) {
  if (e && (Li(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Z4e(t);
}
function Z4e(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function oS() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (oS = function() {
    return !!t;
  })();
}
function Tu(t) {
  return Tu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Tu(t);
}
var H4e = function(e) {
  var r;
  return e.infinite ? r = Math.ceil(e.slideCount / e.slidesToScroll) : r = Math.ceil((e.slideCount - e.slidesToShow) / e.slidesToScroll) + 1, r;
};
p5.Dots = /* @__PURE__ */ function(t) {
  F4e(r, t);
  var e = $4e(r);
  function r() {
    return P4e(this, r), e.apply(this, arguments);
  }
  return N4e(r, [{
    key: "clickHandler",
    value: function(a, o) {
      o.preventDefault(), this.props.clickHandler(a);
    }
  }, {
    key: "render",
    value: function() {
      for (var a = this.props, o = a.onMouseEnter, i = a.onMouseOver, l = a.onMouseLeave, c = a.infinite, u = a.slidesToScroll, d = a.slidesToShow, f = a.slideCount, h = a.currentSlide, v = H4e({
        slideCount: f,
        slidesToScroll: u,
        slidesToShow: d,
        infinite: c
      }), p = {
        onMouseEnter: o,
        onMouseOver: i,
        onMouseLeave: l
      }, g = [], m = 0; m < v; m++) {
        var w = (m + 1) * u - 1, y = c ? w : (0, Tw.clamp)(w, 0, f - 1), b = y - (u - 1), _ = c ? b : (0, Tw.clamp)(b, 0, f - 1), x = (0, T4e.default)({
          "slick-active": c ? h >= _ && h <= y : h === _
        }), E = {
          message: "dots",
          index: m,
          slidesToScroll: u,
          currentSlide: h
        }, S = this.clickHandler.bind(this, E);
        g = g.concat(/* @__PURE__ */ a0.default.createElement("li", {
          key: m,
          className: x
        }, /* @__PURE__ */ a0.default.cloneElement(this.props.customPaging(m), {
          onClick: S
        })));
      }
      return /* @__PURE__ */ a0.default.cloneElement(this.props.appendDots(g), O4e({
        className: this.props.dotsClass
      }, p));
    }
  }]), r;
}(a0.default.PureComponent);
var Ti = {};
function Oi(t) {
  "@babel/helpers - typeof";
  return Oi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Oi(t);
}
Object.defineProperty(Ti, "__esModule", {
  value: !0
});
Ti.PrevArrow = Ti.NextArrow = void 0;
var pi = lS(ke), iS = lS(h5), j4e = U;
function lS(t) {
  return t && t.__esModule ? t : { default: t };
}
function Ou() {
  return Ou = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Ou.apply(this, arguments);
}
function Iw(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Iu(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Iw(Object(r), !0).forEach(function(n) {
      W4e(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Iw(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function W4e(t, e, r) {
  return e = uS(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function sS(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function z4e(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, uS(n.key), n);
  }
}
function cS(t, e, r) {
  return e && z4e(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function uS(t) {
  var e = G4e(t, "string");
  return Oi(e) == "symbol" ? e : String(e);
}
function G4e(t, e) {
  if (Oi(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (Oi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function dS(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && O2(t, e);
}
function O2(t, e) {
  return O2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, O2(t, e);
}
function fS(t) {
  var e = hS();
  return function() {
    var n = Pu(t), a;
    if (e) {
      var o = Pu(this).constructor;
      a = Reflect.construct(n, arguments, o);
    } else
      a = n.apply(this, arguments);
    return U4e(this, a);
  };
}
function U4e(t, e) {
  if (e && (Oi(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Y4e(t);
}
function Y4e(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function hS() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (hS = function() {
    return !!t;
  })();
}
function Pu(t) {
  return Pu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Pu(t);
}
Ti.PrevArrow = /* @__PURE__ */ function(t) {
  dS(r, t);
  var e = fS(r);
  function r() {
    return sS(this, r), e.apply(this, arguments);
  }
  return cS(r, [{
    key: "clickHandler",
    value: function(a, o) {
      o && o.preventDefault(), this.props.clickHandler(a, o);
    }
  }, {
    key: "render",
    value: function() {
      var a = {
        "slick-arrow": !0,
        "slick-prev": !0
      }, o = this.clickHandler.bind(this, {
        message: "previous"
      });
      !this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow) && (a["slick-disabled"] = !0, o = null);
      var i = {
        key: "0",
        "data-role": "none",
        className: (0, iS.default)(a),
        style: {
          display: "block"
        },
        onClick: o
      }, l = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      }, c;
      return this.props.prevArrow ? c = /* @__PURE__ */ pi.default.cloneElement(this.props.prevArrow, Iu(Iu({}, i), l)) : c = /* @__PURE__ */ pi.default.createElement("button", Ou({
        key: "0",
        type: "button"
      }, i), " ", "Previous"), c;
    }
  }]), r;
}(pi.default.PureComponent);
Ti.NextArrow = /* @__PURE__ */ function(t) {
  dS(r, t);
  var e = fS(r);
  function r() {
    return sS(this, r), e.apply(this, arguments);
  }
  return cS(r, [{
    key: "clickHandler",
    value: function(a, o) {
      o && o.preventDefault(), this.props.clickHandler(a, o);
    }
  }, {
    key: "render",
    value: function() {
      var a = {
        "slick-arrow": !0,
        "slick-next": !0
      }, o = this.clickHandler.bind(this, {
        message: "next"
      });
      (0, j4e.canGoNext)(this.props) || (a["slick-disabled"] = !0, o = null);
      var i = {
        key: "1",
        "data-role": "none",
        className: (0, iS.default)(a),
        style: {
          display: "block"
        },
        onClick: o
      }, l = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      }, c;
      return this.props.nextArrow ? c = /* @__PURE__ */ pi.default.cloneElement(this.props.nextArrow, Iu(Iu({}, i), l)) : c = /* @__PURE__ */ pi.default.createElement("button", Ou({
        key: "1",
        type: "button"
      }, i), " ", "Next"), c;
    }
  }]), r;
}(pi.default.PureComponent);
var vS = function() {
  if (typeof Map < "u")
    return Map;
  function t(e, r) {
    var n = -1;
    return e.some(function(a, o) {
      return a[0] === r ? (n = o, !0) : !1;
    }), n;
  }
  return (
    /** @class */
    function() {
      function e() {
        this.__entries__ = [];
      }
      return Object.defineProperty(e.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.get = function(r) {
        var n = t(this.__entries__, r), a = this.__entries__[n];
        return a && a[1];
      }, e.prototype.set = function(r, n) {
        var a = t(this.__entries__, r);
        ~a ? this.__entries__[a][1] = n : this.__entries__.push([r, n]);
      }, e.prototype.delete = function(r) {
        var n = this.__entries__, a = t(n, r);
        ~a && n.splice(a, 1);
      }, e.prototype.has = function(r) {
        return !!~t(this.__entries__, r);
      }, e.prototype.clear = function() {
        this.__entries__.splice(0);
      }, e.prototype.forEach = function(r, n) {
        n === void 0 && (n = null);
        for (var a = 0, o = this.__entries__; a < o.length; a++) {
          var i = o[a];
          r.call(n, i[1], i[0]);
        }
      }, e;
    }()
  );
}(), I2 = typeof window < "u" && typeof document < "u" && window.document === document, Du = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), X4e = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(Du) : function(t) {
    return setTimeout(function() {
      return t(Date.now());
    }, 1e3 / 60);
  };
}(), q4e = 2;
function K4e(t, e) {
  var r = !1, n = !1, a = 0;
  function o() {
    r && (r = !1, t()), n && l();
  }
  function i() {
    X4e(o);
  }
  function l() {
    var c = Date.now();
    if (r) {
      if (c - a < q4e)
        return;
      n = !0;
    } else
      r = !0, n = !1, setTimeout(i, e);
    a = c;
  }
  return l;
}
var Q4e = 20, J4e = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], ewe = typeof MutationObserver < "u", twe = (
  /** @class */
  function() {
    function t() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = K4e(this.refresh.bind(this), Q4e);
    }
    return t.prototype.addObserver = function(e) {
      ~this.observers_.indexOf(e) || this.observers_.push(e), this.connected_ || this.connect_();
    }, t.prototype.removeObserver = function(e) {
      var r = this.observers_, n = r.indexOf(e);
      ~n && r.splice(n, 1), !r.length && this.connected_ && this.disconnect_();
    }, t.prototype.refresh = function() {
      var e = this.updateObservers_();
      e && this.refresh();
    }, t.prototype.updateObservers_ = function() {
      var e = this.observers_.filter(function(r) {
        return r.gatherActive(), r.hasActive();
      });
      return e.forEach(function(r) {
        return r.broadcastActive();
      }), e.length > 0;
    }, t.prototype.connect_ = function() {
      !I2 || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), ewe ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, t.prototype.disconnect_ = function() {
      !I2 || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, t.prototype.onTransitionEnd_ = function(e) {
      var r = e.propertyName, n = r === void 0 ? "" : r, a = J4e.some(function(o) {
        return !!~n.indexOf(o);
      });
      a && this.refresh();
    }, t.getInstance = function() {
      return this.instance_ || (this.instance_ = new t()), this.instance_;
    }, t.instance_ = null, t;
  }()
), pS = function(t, e) {
  for (var r = 0, n = Object.keys(e); r < n.length; r++) {
    var a = n[r];
    Object.defineProperty(t, a, {
      value: e[a],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return t;
}, Ii = function(t) {
  var e = t && t.ownerDocument && t.ownerDocument.defaultView;
  return e || Du;
}, gS = g5(0, 0, 0, 0);
function Nu(t) {
  return parseFloat(t) || 0;
}
function Pw(t) {
  for (var e = [], r = 1; r < arguments.length; r++)
    e[r - 1] = arguments[r];
  return e.reduce(function(n, a) {
    var o = t["border-" + a + "-width"];
    return n + Nu(o);
  }, 0);
}
function rwe(t) {
  for (var e = ["top", "right", "bottom", "left"], r = {}, n = 0, a = e; n < a.length; n++) {
    var o = a[n], i = t["padding-" + o];
    r[o] = Nu(i);
  }
  return r;
}
function nwe(t) {
  var e = t.getBBox();
  return g5(0, 0, e.width, e.height);
}
function awe(t) {
  var e = t.clientWidth, r = t.clientHeight;
  if (!e && !r)
    return gS;
  var n = Ii(t).getComputedStyle(t), a = rwe(n), o = a.left + a.right, i = a.top + a.bottom, l = Nu(n.width), c = Nu(n.height);
  if (n.boxSizing === "border-box" && (Math.round(l + o) !== e && (l -= Pw(n, "left", "right") + o), Math.round(c + i) !== r && (c -= Pw(n, "top", "bottom") + i)), !iwe(t)) {
    var u = Math.round(l + o) - e, d = Math.round(c + i) - r;
    Math.abs(u) !== 1 && (l -= u), Math.abs(d) !== 1 && (c -= d);
  }
  return g5(a.left, a.top, l, c);
}
var owe = /* @__PURE__ */ function() {
  return typeof SVGGraphicsElement < "u" ? function(t) {
    return t instanceof Ii(t).SVGGraphicsElement;
  } : function(t) {
    return t instanceof Ii(t).SVGElement && typeof t.getBBox == "function";
  };
}();
function iwe(t) {
  return t === Ii(t).document.documentElement;
}
function lwe(t) {
  return I2 ? owe(t) ? nwe(t) : awe(t) : gS;
}
function swe(t) {
  var e = t.x, r = t.y, n = t.width, a = t.height, o = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, i = Object.create(o.prototype);
  return pS(i, {
    x: e,
    y: r,
    width: n,
    height: a,
    top: r,
    right: e + n,
    bottom: a + r,
    left: e
  }), i;
}
function g5(t, e, r, n) {
  return { x: t, y: e, width: r, height: n };
}
var cwe = (
  /** @class */
  function() {
    function t(e) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = g5(0, 0, 0, 0), this.target = e;
    }
    return t.prototype.isActive = function() {
      var e = lwe(this.target);
      return this.contentRect_ = e, e.width !== this.broadcastWidth || e.height !== this.broadcastHeight;
    }, t.prototype.broadcastRect = function() {
      var e = this.contentRect_;
      return this.broadcastWidth = e.width, this.broadcastHeight = e.height, e;
    }, t;
  }()
), uwe = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e, r) {
      var n = swe(r);
      pS(this, { target: e, contentRect: n });
    }
    return t;
  }()
), dwe = (
  /** @class */
  function() {
    function t(e, r, n) {
      if (this.activeObservations_ = [], this.observations_ = new vS(), typeof e != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = e, this.controller_ = r, this.callbackCtx_ = n;
    }
    return t.prototype.observe = function(e) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(e instanceof Ii(e).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var r = this.observations_;
        r.has(e) || (r.set(e, new cwe(e)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, t.prototype.unobserve = function(e) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(e instanceof Ii(e).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var r = this.observations_;
        r.has(e) && (r.delete(e), r.size || this.controller_.removeObserver(this));
      }
    }, t.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, t.prototype.gatherActive = function() {
      var e = this;
      this.clearActive(), this.observations_.forEach(function(r) {
        r.isActive() && e.activeObservations_.push(r);
      });
    }, t.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var e = this.callbackCtx_, r = this.activeObservations_.map(function(n) {
          return new uwe(n.target, n.broadcastRect());
        });
        this.callback_.call(e, r, e), this.clearActive();
      }
    }, t.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, t.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, t;
  }()
), mS = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new vS(), wS = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e) {
      if (!(this instanceof t))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var r = twe.getInstance(), n = new dwe(e, r, this);
      mS.set(this, n);
    }
    return t;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(t) {
  wS.prototype[t] = function() {
    var e;
    return (e = mS.get(this))[t].apply(e, arguments);
  };
});
var fwe = function() {
  return typeof Du.ResizeObserver < "u" ? Du.ResizeObserver : wS;
}();
const hwe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: fwe
}, Symbol.toStringTag, { value: "Module" })), vwe = /* @__PURE__ */ zw(hwe);
Object.defineProperty(f5, "__esModule", {
  value: !0
});
f5.InnerSlider = void 0;
var Ct = Us(ke), pwe = Us(jE), gwe = Us(i4e), mwe = Us(h5), qe = U, wwe = v5, ywe = p5, Dw = Ti, bwe = Us(vwe);
function Us(t) {
  return t && t.__esModule ? t : { default: t };
}
function uo(t) {
  "@babel/helpers - typeof";
  return uo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, uo(t);
}
function Bu() {
  return Bu = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Bu.apply(this, arguments);
}
function _we(t, e) {
  if (t == null) return {};
  var r = xwe(t, e), n, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (a = 0; a < o.length; a++)
      n = o[a], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function xwe(t, e) {
  if (t == null) return {};
  var r = {}, n = Object.keys(t), a, o;
  for (o = 0; o < n.length; o++)
    a = n[o], !(e.indexOf(a) >= 0) && (r[a] = t[a]);
  return r;
}
function Nw(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function oe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Nw(Object(r), !0).forEach(function(n) {
      xe(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Nw(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function Cwe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Ewe(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, bS(n.key), n);
  }
}
function Swe(t, e, r) {
  return e && Ewe(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function Rwe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && P2(t, e);
}
function P2(t, e) {
  return P2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, P2(t, e);
}
function Mwe(t) {
  var e = yS();
  return function() {
    var n = Fu(t), a;
    if (e) {
      var o = Fu(this).constructor;
      a = Reflect.construct(n, arguments, o);
    } else
      a = n.apply(this, arguments);
    return Awe(this, a);
  };
}
function Awe(t, e) {
  if (e && (uo(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _e(t);
}
function _e(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function yS() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (yS = function() {
    return !!t;
  })();
}
function Fu(t) {
  return Fu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Fu(t);
}
function xe(t, e, r) {
  return e = bS(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function bS(t) {
  var e = kwe(t, "string");
  return uo(e) == "symbol" ? e : String(e);
}
function kwe(t, e) {
  if (uo(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (uo(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
f5.InnerSlider = /* @__PURE__ */ function(t) {
  Rwe(r, t);
  var e = Mwe(r);
  function r(n) {
    var a;
    Cwe(this, r), a = e.call(this, n), xe(_e(a), "listRefHandler", function(i) {
      return a.list = i;
    }), xe(_e(a), "trackRefHandler", function(i) {
      return a.track = i;
    }), xe(_e(a), "adaptHeight", function() {
      if (a.props.adaptiveHeight && a.list) {
        var i = a.list.querySelector('[data-index="'.concat(a.state.currentSlide, '"]'));
        a.list.style.height = (0, qe.getHeight)(i) + "px";
      }
    }), xe(_e(a), "componentDidMount", function() {
      if (a.props.onInit && a.props.onInit(), a.props.lazyLoad) {
        var i = (0, qe.getOnDemandLazySlides)(oe(oe({}, a.props), a.state));
        i.length > 0 && (a.setState(function(c) {
          return {
            lazyLoadedList: c.lazyLoadedList.concat(i)
          };
        }), a.props.onLazyLoad && a.props.onLazyLoad(i));
      }
      var l = oe({
        listRef: a.list,
        trackRef: a.track
      }, a.props);
      a.updateState(l, !0, function() {
        a.adaptHeight(), a.props.autoplay && a.autoPlay("update");
      }), a.props.lazyLoad === "progressive" && (a.lazyLoadTimer = setInterval(a.progressiveLazyLoad, 1e3)), a.ro = new bwe.default(function() {
        a.state.animating ? (a.onWindowResized(!1), a.callbackTimers.push(setTimeout(function() {
          return a.onWindowResized();
        }, a.props.speed))) : a.onWindowResized();
      }), a.ro.observe(a.list), document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function(c) {
        c.onfocus = a.props.pauseOnFocus ? a.onSlideFocus : null, c.onblur = a.props.pauseOnFocus ? a.onSlideBlur : null;
      }), window.addEventListener ? window.addEventListener("resize", a.onWindowResized) : window.attachEvent("onresize", a.onWindowResized);
    }), xe(_e(a), "componentWillUnmount", function() {
      a.animationEndCallback && clearTimeout(a.animationEndCallback), a.lazyLoadTimer && clearInterval(a.lazyLoadTimer), a.callbackTimers.length && (a.callbackTimers.forEach(function(i) {
        return clearTimeout(i);
      }), a.callbackTimers = []), window.addEventListener ? window.removeEventListener("resize", a.onWindowResized) : window.detachEvent("onresize", a.onWindowResized), a.autoplayTimer && clearInterval(a.autoplayTimer), a.ro.disconnect();
    }), xe(_e(a), "componentDidUpdate", function(i) {
      if (a.checkImagesLoad(), a.props.onReInit && a.props.onReInit(), a.props.lazyLoad) {
        var l = (0, qe.getOnDemandLazySlides)(oe(oe({}, a.props), a.state));
        l.length > 0 && (a.setState(function(d) {
          return {
            lazyLoadedList: d.lazyLoadedList.concat(l)
          };
        }), a.props.onLazyLoad && a.props.onLazyLoad(l));
      }
      a.adaptHeight();
      var c = oe(oe({
        listRef: a.list,
        trackRef: a.track
      }, a.props), a.state), u = a.didPropsChange(i);
      u && a.updateState(c, u, function() {
        a.state.currentSlide >= Ct.default.Children.count(a.props.children) && a.changeSlide({
          message: "index",
          index: Ct.default.Children.count(a.props.children) - a.props.slidesToShow,
          currentSlide: a.state.currentSlide
        }), a.props.autoplay ? a.autoPlay("update") : a.pause("paused");
      });
    }), xe(_e(a), "onWindowResized", function(i) {
      a.debouncedResize && a.debouncedResize.cancel(), a.debouncedResize = (0, gwe.default)(function() {
        return a.resizeWindow(i);
      }, 50), a.debouncedResize();
    }), xe(_e(a), "resizeWindow", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0, l = !!(a.track && a.track.node);
      if (l) {
        var c = oe(oe({
          listRef: a.list,
          trackRef: a.track
        }, a.props), a.state);
        a.updateState(c, i, function() {
          a.props.autoplay ? a.autoPlay("update") : a.pause("paused");
        }), a.setState({
          animating: !1
        }), clearTimeout(a.animationEndCallback), delete a.animationEndCallback;
      }
    }), xe(_e(a), "updateState", function(i, l, c) {
      var u = (0, qe.initializedState)(i);
      i = oe(oe(oe({}, i), u), {}, {
        slideIndex: u.currentSlide
      });
      var d = (0, qe.getTrackLeft)(i);
      i = oe(oe({}, i), {}, {
        left: d
      });
      var f = (0, qe.getTrackCSS)(i);
      (l || Ct.default.Children.count(a.props.children) !== Ct.default.Children.count(i.children)) && (u.trackStyle = f), a.setState(u, c);
    }), xe(_e(a), "ssrInit", function() {
      if (a.props.variableWidth) {
        var i = 0, l = 0, c = [], u = (0, qe.getPreClones)(oe(oe(oe({}, a.props), a.state), {}, {
          slideCount: a.props.children.length
        })), d = (0, qe.getPostClones)(oe(oe(oe({}, a.props), a.state), {}, {
          slideCount: a.props.children.length
        }));
        a.props.children.forEach(function(S) {
          c.push(S.props.style.width), i += S.props.style.width;
        });
        for (var f = 0; f < u; f++)
          l += c[c.length - 1 - f], i += c[c.length - 1 - f];
        for (var h = 0; h < d; h++)
          i += c[h];
        for (var v = 0; v < a.state.currentSlide; v++)
          l += c[v];
        var p = {
          width: i + "px",
          left: -l + "px"
        };
        if (a.props.centerMode) {
          var g = "".concat(c[a.state.currentSlide], "px");
          p.left = "calc(".concat(p.left, " + (100% - ").concat(g, ") / 2 ) ");
        }
        return {
          trackStyle: p
        };
      }
      var m = Ct.default.Children.count(a.props.children), w = oe(oe(oe({}, a.props), a.state), {}, {
        slideCount: m
      }), y = (0, qe.getPreClones)(w) + (0, qe.getPostClones)(w) + m, b = 100 / a.props.slidesToShow * y, _ = 100 / y, x = -_ * ((0, qe.getPreClones)(w) + a.state.currentSlide) * b / 100;
      a.props.centerMode && (x += (100 - _ * b / 100) / 2);
      var E = {
        width: b + "%",
        left: x + "%"
      };
      return {
        slideWidth: _ + "%",
        trackStyle: E
      };
    }), xe(_e(a), "checkImagesLoad", function() {
      var i = a.list && a.list.querySelectorAll && a.list.querySelectorAll(".slick-slide img") || [], l = i.length, c = 0;
      Array.prototype.forEach.call(i, function(u) {
        var d = function() {
          return ++c && c >= l && a.onWindowResized();
        };
        if (!u.onclick)
          u.onclick = function() {
            return u.parentNode.focus();
          };
        else {
          var f = u.onclick;
          u.onclick = function(h) {
            f(h), u.parentNode.focus();
          };
        }
        u.onload || (a.props.lazyLoad ? u.onload = function() {
          a.adaptHeight(), a.callbackTimers.push(setTimeout(a.onWindowResized, a.props.speed));
        } : (u.onload = d, u.onerror = function() {
          d(), a.props.onLazyLoadError && a.props.onLazyLoadError();
        }));
      });
    }), xe(_e(a), "progressiveLazyLoad", function() {
      for (var i = [], l = oe(oe({}, a.props), a.state), c = a.state.currentSlide; c < a.state.slideCount + (0, qe.getPostClones)(l); c++)
        if (a.state.lazyLoadedList.indexOf(c) < 0) {
          i.push(c);
          break;
        }
      for (var u = a.state.currentSlide - 1; u >= -(0, qe.getPreClones)(l); u--)
        if (a.state.lazyLoadedList.indexOf(u) < 0) {
          i.push(u);
          break;
        }
      i.length > 0 ? (a.setState(function(d) {
        return {
          lazyLoadedList: d.lazyLoadedList.concat(i)
        };
      }), a.props.onLazyLoad && a.props.onLazyLoad(i)) : a.lazyLoadTimer && (clearInterval(a.lazyLoadTimer), delete a.lazyLoadTimer);
    }), xe(_e(a), "slideHandler", function(i) {
      var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, c = a.props, u = c.asNavFor, d = c.beforeChange, f = c.onLazyLoad, h = c.speed, v = c.afterChange, p = a.state.currentSlide, g = (0, qe.slideHandler)(oe(oe(oe({
        index: i
      }, a.props), a.state), {}, {
        trackRef: a.track,
        useCSS: a.props.useCSS && !l
      })), m = g.state, w = g.nextState;
      if (m) {
        d && d(p, m.currentSlide);
        var y = m.lazyLoadedList.filter(function(b) {
          return a.state.lazyLoadedList.indexOf(b) < 0;
        });
        f && y.length > 0 && f(y), !a.props.waitForAnimate && a.animationEndCallback && (clearTimeout(a.animationEndCallback), v && v(p), delete a.animationEndCallback), a.setState(m, function() {
          u && a.asNavForIndex !== i && (a.asNavForIndex = i, u.innerSlider.slideHandler(i)), w && (a.animationEndCallback = setTimeout(function() {
            var b = w.animating, _ = _we(w, ["animating"]);
            a.setState(_, function() {
              a.callbackTimers.push(setTimeout(function() {
                return a.setState({
                  animating: b
                });
              }, 10)), v && v(m.currentSlide), delete a.animationEndCallback;
            });
          }, h));
        });
      }
    }), xe(_e(a), "changeSlide", function(i) {
      var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, c = oe(oe({}, a.props), a.state), u = (0, qe.changeSlide)(c, i);
      if (!(u !== 0 && !u) && (l === !0 ? a.slideHandler(u, l) : a.slideHandler(u), a.props.autoplay && a.autoPlay("update"), a.props.focusOnSelect)) {
        var d = a.list.querySelectorAll(".slick-current");
        d[0] && d[0].focus();
      }
    }), xe(_e(a), "clickHandler", function(i) {
      a.clickable === !1 && (i.stopPropagation(), i.preventDefault()), a.clickable = !0;
    }), xe(_e(a), "keyHandler", function(i) {
      var l = (0, qe.keyHandler)(i, a.props.accessibility, a.props.rtl);
      l !== "" && a.changeSlide({
        message: l
      });
    }), xe(_e(a), "selectHandler", function(i) {
      a.changeSlide(i);
    }), xe(_e(a), "disableBodyScroll", function() {
      var i = function(c) {
        c = c || window.event, c.preventDefault && c.preventDefault(), c.returnValue = !1;
      };
      window.ontouchmove = i;
    }), xe(_e(a), "enableBodyScroll", function() {
      window.ontouchmove = null;
    }), xe(_e(a), "swipeStart", function(i) {
      a.props.verticalSwiping && a.disableBodyScroll();
      var l = (0, qe.swipeStart)(i, a.props.swipe, a.props.draggable);
      l !== "" && a.setState(l);
    }), xe(_e(a), "swipeMove", function(i) {
      var l = (0, qe.swipeMove)(i, oe(oe(oe({}, a.props), a.state), {}, {
        trackRef: a.track,
        listRef: a.list,
        slideIndex: a.state.currentSlide
      }));
      l && (l.swiping && (a.clickable = !1), a.setState(l));
    }), xe(_e(a), "swipeEnd", function(i) {
      var l = (0, qe.swipeEnd)(i, oe(oe(oe({}, a.props), a.state), {}, {
        trackRef: a.track,
        listRef: a.list,
        slideIndex: a.state.currentSlide
      }));
      if (l) {
        var c = l.triggerSlideHandler;
        delete l.triggerSlideHandler, a.setState(l), c !== void 0 && (a.slideHandler(c), a.props.verticalSwiping && a.enableBodyScroll());
      }
    }), xe(_e(a), "touchEnd", function(i) {
      a.swipeEnd(i), a.clickable = !0;
    }), xe(_e(a), "slickPrev", function() {
      a.callbackTimers.push(setTimeout(function() {
        return a.changeSlide({
          message: "previous"
        });
      }, 0));
    }), xe(_e(a), "slickNext", function() {
      a.callbackTimers.push(setTimeout(function() {
        return a.changeSlide({
          message: "next"
        });
      }, 0));
    }), xe(_e(a), "slickGoTo", function(i) {
      var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      if (i = Number(i), isNaN(i)) return "";
      a.callbackTimers.push(setTimeout(function() {
        return a.changeSlide({
          message: "index",
          index: i,
          currentSlide: a.state.currentSlide
        }, l);
      }, 0));
    }), xe(_e(a), "play", function() {
      var i;
      if (a.props.rtl)
        i = a.state.currentSlide - a.props.slidesToScroll;
      else if ((0, qe.canGoNext)(oe(oe({}, a.props), a.state)))
        i = a.state.currentSlide + a.props.slidesToScroll;
      else
        return !1;
      a.slideHandler(i);
    }), xe(_e(a), "autoPlay", function(i) {
      a.autoplayTimer && clearInterval(a.autoplayTimer);
      var l = a.state.autoplaying;
      if (i === "update") {
        if (l === "hovered" || l === "focused" || l === "paused")
          return;
      } else if (i === "leave") {
        if (l === "paused" || l === "focused")
          return;
      } else if (i === "blur" && (l === "paused" || l === "hovered"))
        return;
      a.autoplayTimer = setInterval(a.play, a.props.autoplaySpeed + 50), a.setState({
        autoplaying: "playing"
      });
    }), xe(_e(a), "pause", function(i) {
      a.autoplayTimer && (clearInterval(a.autoplayTimer), a.autoplayTimer = null);
      var l = a.state.autoplaying;
      i === "paused" ? a.setState({
        autoplaying: "paused"
      }) : i === "focused" ? (l === "hovered" || l === "playing") && a.setState({
        autoplaying: "focused"
      }) : l === "playing" && a.setState({
        autoplaying: "hovered"
      });
    }), xe(_e(a), "onDotsOver", function() {
      return a.props.autoplay && a.pause("hovered");
    }), xe(_e(a), "onDotsLeave", function() {
      return a.props.autoplay && a.state.autoplaying === "hovered" && a.autoPlay("leave");
    }), xe(_e(a), "onTrackOver", function() {
      return a.props.autoplay && a.pause("hovered");
    }), xe(_e(a), "onTrackLeave", function() {
      return a.props.autoplay && a.state.autoplaying === "hovered" && a.autoPlay("leave");
    }), xe(_e(a), "onSlideFocus", function() {
      return a.props.autoplay && a.pause("focused");
    }), xe(_e(a), "onSlideBlur", function() {
      return a.props.autoplay && a.state.autoplaying === "focused" && a.autoPlay("blur");
    }), xe(_e(a), "render", function() {
      var i = (0, mwe.default)("slick-slider", a.props.className, {
        "slick-vertical": a.props.vertical,
        "slick-initialized": !0
      }), l = oe(oe({}, a.props), a.state), c = (0, qe.extractObject)(l, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding", "targetSlide", "useCSS"]), u = a.props.pauseOnHover;
      c = oe(oe({}, c), {}, {
        onMouseEnter: u ? a.onTrackOver : null,
        onMouseLeave: u ? a.onTrackLeave : null,
        onMouseOver: u ? a.onTrackOver : null,
        focusOnSelect: a.props.focusOnSelect && a.clickable ? a.selectHandler : null
      });
      var d;
      if (a.props.dots === !0 && a.state.slideCount >= a.props.slidesToShow) {
        var f = (0, qe.extractObject)(l, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]), h = a.props.pauseOnDotsHover;
        f = oe(oe({}, f), {}, {
          clickHandler: a.changeSlide,
          onMouseEnter: h ? a.onDotsLeave : null,
          onMouseOver: h ? a.onDotsOver : null,
          onMouseLeave: h ? a.onDotsLeave : null
        }), d = /* @__PURE__ */ Ct.default.createElement(ywe.Dots, f);
      }
      var v, p, g = (0, qe.extractObject)(l, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      g.clickHandler = a.changeSlide, a.props.arrows && (v = /* @__PURE__ */ Ct.default.createElement(Dw.PrevArrow, g), p = /* @__PURE__ */ Ct.default.createElement(Dw.NextArrow, g));
      var m = null;
      a.props.vertical && (m = {
        height: a.state.listHeight
      });
      var w = null;
      a.props.vertical === !1 ? a.props.centerMode === !0 && (w = {
        padding: "0px " + a.props.centerPadding
      }) : a.props.centerMode === !0 && (w = {
        padding: a.props.centerPadding + " 0px"
      });
      var y = oe(oe({}, m), w), b = a.props.touchMove, _ = {
        className: "slick-list",
        style: y,
        onClick: a.clickHandler,
        onMouseDown: b ? a.swipeStart : null,
        onMouseMove: a.state.dragging && b ? a.swipeMove : null,
        onMouseUp: b ? a.swipeEnd : null,
        onMouseLeave: a.state.dragging && b ? a.swipeEnd : null,
        onTouchStart: b ? a.swipeStart : null,
        onTouchMove: a.state.dragging && b ? a.swipeMove : null,
        onTouchEnd: b ? a.touchEnd : null,
        onTouchCancel: a.state.dragging && b ? a.swipeEnd : null,
        onKeyDown: a.props.accessibility ? a.keyHandler : null
      }, x = {
        className: i,
        dir: "ltr",
        style: a.props.style
      };
      return a.props.unslick && (_ = {
        className: "slick-list"
      }, x = {
        className: i
      }), /* @__PURE__ */ Ct.default.createElement("div", x, a.props.unslick ? "" : v, /* @__PURE__ */ Ct.default.createElement("div", Bu({
        ref: a.listRefHandler
      }, _), /* @__PURE__ */ Ct.default.createElement(wwe.Track, Bu({
        ref: a.trackRefHandler
      }, c), a.props.children)), a.props.unslick ? "" : p, a.props.unslick ? "" : d);
    }), a.list = null, a.track = null, a.state = oe(oe({}, pwe.default), {}, {
      currentSlide: a.props.initialSlide,
      targetSlide: a.props.initialSlide ? a.props.initialSlide : 0,
      slideCount: Ct.default.Children.count(a.props.children)
    }), a.callbackTimers = [], a.clickable = !0, a.debouncedResize = null;
    var o = a.ssrInit();
    return a.state = oe(oe({}, a.state), o), a;
  }
  return Swe(r, [{
    key: "didPropsChange",
    value: function(a) {
      for (var o = !1, i = 0, l = Object.keys(this.props); i < l.length; i++) {
        var c = l[i];
        if (!a.hasOwnProperty(c)) {
          o = !0;
          break;
        }
        if (!(uo(a[c]) === "object" || typeof a[c] == "function" || isNaN(a[c])) && a[c] !== this.props[c]) {
          o = !0;
          break;
        }
      }
      return o || Ct.default.Children.count(this.props.children) !== Ct.default.Children.count(a.children);
    }
  }]), r;
}(Ct.default.Component);
var Lwe = function(t) {
  return t.replace(/[A-Z]/g, function(e) {
    return "-" + e.toLowerCase();
  }).toLowerCase();
}, Twe = Lwe, Owe = Twe, Iwe = function(t) {
  var e = /[height|width]$/;
  return e.test(t);
}, Bw = function(t) {
  var e = "", r = Object.keys(t);
  return r.forEach(function(n, a) {
    var o = t[n];
    n = Owe(n), Iwe(n) && typeof o == "number" && (o = o + "px"), o === !0 ? e += n : o === !1 ? e += "not " + n : e += "(" + n + ": " + o + ")", a < r.length - 1 && (e += " and ");
  }), e;
}, Pwe = function(t) {
  var e = "";
  return typeof t == "string" ? t : t instanceof Array ? (t.forEach(function(r, n) {
    e += Bw(r), n < t.length - 1 && (e += ", ");
  }), e) : Bw(t);
}, Dwe = Pwe, Of, Fw;
function Nwe() {
  if (Fw) return Of;
  Fw = 1;
  function t(e) {
    this.options = e, !e.deferSetup && this.setup();
  }
  return t.prototype = {
    constructor: t,
    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup: function() {
      this.options.setup && this.options.setup(), this.initialised = !0;
    },
    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on: function() {
      !this.initialised && this.setup(), this.options.match && this.options.match();
    },
    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off: function() {
      this.options.unmatch && this.options.unmatch();
    },
    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy: function() {
      this.options.destroy ? this.options.destroy() : this.off();
    },
    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals: function(e) {
      return this.options === e || this.options.match === e;
    }
  }, Of = t, Of;
}
var If, $w;
function _S() {
  if ($w) return If;
  $w = 1;
  function t(n, a) {
    var o = 0, i = n.length, l;
    for (o; o < i && (l = a(n[o], o), l !== !1); o++)
      ;
  }
  function e(n) {
    return Object.prototype.toString.apply(n) === "[object Array]";
  }
  function r(n) {
    return typeof n == "function";
  }
  return If = {
    isFunction: r,
    isArray: e,
    each: t
  }, If;
}
var Pf, Vw;
function Bwe() {
  if (Vw) return Pf;
  Vw = 1;
  var t = Nwe(), e = _S().each;
  function r(n, a) {
    this.query = n, this.isUnconditional = a, this.handlers = [], this.mql = window.matchMedia(n);
    var o = this;
    this.listener = function(i) {
      o.mql = i.currentTarget || i, o.assess();
    }, this.mql.addListener(this.listener);
  }
  return r.prototype = {
    constuctor: r,
    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler: function(n) {
      var a = new t(n);
      this.handlers.push(a), this.matches() && a.on();
    },
    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler: function(n) {
      var a = this.handlers;
      e(a, function(o, i) {
        if (o.equals(n))
          return o.destroy(), !a.splice(i, 1);
      });
    },
    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches: function() {
      return this.mql.matches || this.isUnconditional;
    },
    /**
     * Clears all handlers and unbinds events
     */
    clear: function() {
      e(this.handlers, function(n) {
        n.destroy();
      }), this.mql.removeListener(this.listener), this.handlers.length = 0;
    },
    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess: function() {
      var n = this.matches() ? "on" : "off";
      e(this.handlers, function(a) {
        a[n]();
      });
    }
  }, Pf = r, Pf;
}
var Df, Zw;
function Fwe() {
  if (Zw) return Df;
  Zw = 1;
  var t = Bwe(), e = _S(), r = e.each, n = e.isFunction, a = e.isArray;
  function o() {
    if (!window.matchMedia)
      throw new Error("matchMedia not present, legacy browsers require a polyfill");
    this.queries = {}, this.browserIsIncapable = !window.matchMedia("only all").matches;
  }
  return o.prototype = {
    constructor: o,
    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register: function(i, l, c) {
      var u = this.queries, d = c && this.browserIsIncapable;
      return u[i] || (u[i] = new t(i, d)), n(l) && (l = { match: l }), a(l) || (l = [l]), r(l, function(f) {
        n(f) && (f = { match: f }), u[i].addHandler(f);
      }), this;
    },
    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister: function(i, l) {
      var c = this.queries[i];
      return c && (l ? c.removeHandler(l) : (c.clear(), delete this.queries[i])), this;
    }
  }, Df = o, Df;
}
var Nf, Hw;
function $we() {
  if (Hw) return Nf;
  Hw = 1;
  var t = Fwe();
  return Nf = new t(), Nf;
}
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var e = i(ke), r = f5, n = i(Dwe), a = i(fp), o = U;
  function i(R) {
    return R && R.__esModule ? R : { default: R };
  }
  function l(R) {
    "@babel/helpers - typeof";
    return l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(A) {
      return typeof A;
    } : function(A) {
      return A && typeof Symbol == "function" && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
    }, l(R);
  }
  function c() {
    return c = Object.assign ? Object.assign.bind() : function(R) {
      for (var A = 1; A < arguments.length; A++) {
        var k = arguments[A];
        for (var L in k)
          Object.prototype.hasOwnProperty.call(k, L) && (R[L] = k[L]);
      }
      return R;
    }, c.apply(this, arguments);
  }
  function u(R, A) {
    var k = Object.keys(R);
    if (Object.getOwnPropertySymbols) {
      var L = Object.getOwnPropertySymbols(R);
      A && (L = L.filter(function(T) {
        return Object.getOwnPropertyDescriptor(R, T).enumerable;
      })), k.push.apply(k, L);
    }
    return k;
  }
  function d(R) {
    for (var A = 1; A < arguments.length; A++) {
      var k = arguments[A] != null ? arguments[A] : {};
      A % 2 ? u(Object(k), !0).forEach(function(L) {
        x(R, L, k[L]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(R, Object.getOwnPropertyDescriptors(k)) : u(Object(k)).forEach(function(L) {
        Object.defineProperty(R, L, Object.getOwnPropertyDescriptor(k, L));
      });
    }
    return R;
  }
  function f(R, A) {
    if (!(R instanceof A))
      throw new TypeError("Cannot call a class as a function");
  }
  function h(R, A) {
    for (var k = 0; k < A.length; k++) {
      var L = A[k];
      L.enumerable = L.enumerable || !1, L.configurable = !0, "value" in L && (L.writable = !0), Object.defineProperty(R, E(L.key), L);
    }
  }
  function v(R, A, k) {
    return A && h(R.prototype, A), Object.defineProperty(R, "prototype", { writable: !1 }), R;
  }
  function p(R, A) {
    if (typeof A != "function" && A !== null)
      throw new TypeError("Super expression must either be null or a function");
    R.prototype = Object.create(A && A.prototype, { constructor: { value: R, writable: !0, configurable: !0 } }), Object.defineProperty(R, "prototype", { writable: !1 }), A && g(R, A);
  }
  function g(R, A) {
    return g = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(L, T) {
      return L.__proto__ = T, L;
    }, g(R, A);
  }
  function m(R) {
    var A = b();
    return function() {
      var L = _(R), T;
      if (A) {
        var O = _(this).constructor;
        T = Reflect.construct(L, arguments, O);
      } else
        T = L.apply(this, arguments);
      return w(this, T);
    };
  }
  function w(R, A) {
    if (A && (l(A) === "object" || typeof A == "function"))
      return A;
    if (A !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return y(R);
  }
  function y(R) {
    if (R === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return R;
  }
  function b() {
    try {
      var R = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (b = function() {
      return !!R;
    })();
  }
  function _(R) {
    return _ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(k) {
      return k.__proto__ || Object.getPrototypeOf(k);
    }, _(R);
  }
  function x(R, A, k) {
    return A = E(A), A in R ? Object.defineProperty(R, A, { value: k, enumerable: !0, configurable: !0, writable: !0 }) : R[A] = k, R;
  }
  function E(R) {
    var A = S(R, "string");
    return l(A) == "symbol" ? A : String(A);
  }
  function S(R, A) {
    if (l(R) != "object" || !R) return R;
    var k = R[Symbol.toPrimitive];
    if (k !== void 0) {
      var L = k.call(R, A || "default");
      if (l(L) != "object") return L;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (A === "string" ? String : Number)(R);
  }
  var M = (0, o.canUseDOM)() && $we();
  t.default = /* @__PURE__ */ function(R) {
    p(k, R);
    var A = m(k);
    function k(L) {
      var T;
      return f(this, k), T = A.call(this, L), x(y(T), "innerSliderRefHandler", function(O) {
        return T.innerSlider = O;
      }), x(y(T), "slickPrev", function() {
        return T.innerSlider.slickPrev();
      }), x(y(T), "slickNext", function() {
        return T.innerSlider.slickNext();
      }), x(y(T), "slickGoTo", function(O) {
        var D = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
        return T.innerSlider.slickGoTo(O, D);
      }), x(y(T), "slickPause", function() {
        return T.innerSlider.pause("paused");
      }), x(y(T), "slickPlay", function() {
        return T.innerSlider.autoPlay("play");
      }), T.state = {
        breakpoint: null
      }, T._responsiveMediaHandlers = [], T;
    }
    return v(k, [{
      key: "media",
      value: function(T, O) {
        M.register(T, O), this._responsiveMediaHandlers.push({
          query: T,
          handler: O
        });
      }
      // handles responsive breakpoints
    }, {
      key: "componentDidMount",
      value: function() {
        var T = this;
        if (this.props.responsive) {
          var O = this.props.responsive.map(function(P) {
            return P.breakpoint;
          });
          O.sort(function(P, F) {
            return P - F;
          }), O.forEach(function(P, F) {
            var B;
            F === 0 ? B = (0, n.default)({
              minWidth: 0,
              maxWidth: P
            }) : B = (0, n.default)({
              minWidth: O[F - 1] + 1,
              maxWidth: P
            }), (0, o.canUseDOM)() && T.media(B, function() {
              T.setState({
                breakpoint: P
              });
            });
          });
          var D = (0, n.default)({
            minWidth: O.slice(-1)[0]
          });
          (0, o.canUseDOM)() && this.media(D, function() {
            T.setState({
              breakpoint: null
            });
          });
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this._responsiveMediaHandlers.forEach(function(T) {
          M.unregister(T.query, T.handler);
        });
      }
    }, {
      key: "render",
      value: function() {
        var T = this, O, D;
        this.state.breakpoint ? (D = this.props.responsive.filter(function(we) {
          return we.breakpoint === T.state.breakpoint;
        }), O = D[0].settings === "unslick" ? "unslick" : d(d(d({}, a.default), this.props), D[0].settings)) : O = d(d({}, a.default), this.props), O.centerMode && (O.slidesToScroll > 1 && process.env.NODE_ENV !== "production" && console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(O.slidesToScroll)), O.slidesToScroll = 1), O.fade && (O.slidesToShow > 1 && process.env.NODE_ENV !== "production" && console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(O.slidesToShow)), O.slidesToScroll > 1 && process.env.NODE_ENV !== "production" && console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(O.slidesToScroll)), O.slidesToShow = 1, O.slidesToScroll = 1);
        var P = e.default.Children.toArray(this.props.children);
        P = P.filter(function(we) {
          return typeof we == "string" ? !!we.trim() : !!we;
        }), O.variableWidth && (O.rows > 1 || O.slidesPerRow > 1) && (console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1"), O.variableWidth = !1);
        for (var F = [], B = null, N = 0; N < P.length; N += O.rows * O.slidesPerRow) {
          for (var $ = [], V = N; V < N + O.rows * O.slidesPerRow; V += O.slidesPerRow) {
            for (var W = [], ee = V; ee < V + O.slidesPerRow && (O.variableWidth && P[ee].props.style && (B = P[ee].props.style.width), !(ee >= P.length)); ee += 1)
              W.push(/* @__PURE__ */ e.default.cloneElement(P[ee], {
                key: 100 * N + 10 * V + ee,
                tabIndex: -1,
                style: {
                  width: "".concat(100 / O.slidesPerRow, "%"),
                  display: "inline-block"
                }
              }));
            $.push(/* @__PURE__ */ e.default.createElement("div", {
              key: 10 * N + V
            }, W));
          }
          O.variableWidth ? F.push(/* @__PURE__ */ e.default.createElement("div", {
            key: N,
            style: {
              width: B
            }
          }, $)) : F.push(/* @__PURE__ */ e.default.createElement("div", {
            key: N
          }, $));
        }
        if (O === "unslick") {
          var ne = "regular slider " + (this.props.className || "");
          return /* @__PURE__ */ e.default.createElement("div", {
            className: ne
          }, P);
        } else F.length <= O.slidesToShow && !O.infinite && (O.unslick = !0);
        return /* @__PURE__ */ e.default.createElement(r.InnerSlider, c({
          style: this.props.style,
          ref: this.innerSliderRefHandler
        }, (0, o.filterSettings)(O)), F);
      }
    }]), k;
  }(e.default.Component);
})(HE);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var e = r(HE);
  function r(n) {
    return n && n.__esModule ? n : { default: n };
  }
  t.default = e.default;
})(ZE);
const Vwe = /* @__PURE__ */ ms(ZE), Zwe = "foton__button___PruNS", jw = {
  button: Zwe
}, Hwe = ({ onClickPreview: t, onClickNext: e }) => /* @__PURE__ */ Z("div", { className: "flex gap-[8px] h-8", children: [
  /* @__PURE__ */ C("button", { className: jw.button, onClick: t, children: /* @__PURE__ */ C("span", { children: "<" }) }),
  /* @__PURE__ */ C("button", { className: jw.button, onClick: e, children: /* @__PURE__ */ C("span", { children: ">" }) })
] }), jwe = "foton__arrowsContainer___hTta9", Wwe = {
  arrowsContainer: jwe
}, F6e = (t) => {
  const [e, r] = gt(0), n = Ww(null), a = {
    dots: !t.useArrows,
    arrows: !1,
    infinite: !1,
    speed: 500,
    slidesToScroll: t.slidesToShow || 1,
    slidesToShow: t.slidesToShow || 1,
    afterChange: (i) => r(i)
  }, o = (i) => {
    n.current && n.current.slickGoTo(i);
  };
  return /* @__PURE__ */ Z(
    "div",
    {
      style: {
        width: "100%",
        maxWidth: "100vw",
        // Limit the slider component to not break in width
        display: "block"
      },
      children: [
        /* @__PURE__ */ C(Vwe, { ...a, ref: n, children: t.children }),
        t.useArrows && /* @__PURE__ */ C("div", { className: Wwe.arrowsContainer, children: /* @__PURE__ */ C(
          Hwe,
          {
            onClickPreview: () => o(e - 1),
            onClickNext: () => o(e + 1)
          }
        ) })
      ]
    }
  );
};
var zwe = /* @__PURE__ */ ((t) => (t.SM = "SM", t.MD = "MD", t.LG = "LG", t.XL = "XL", t.XXL = "XXL", t))(zwe || {}), Gwe = /* @__PURE__ */ ((t) => (t.MOBILE = "MOBILE", t.TABLET = "TABLET", t.NOTEBOOK = "NOTEBOOK", t.DESKTOP = "DESKTOP", t.LARGE_DESKTOP = "LARGE_DESKTOP", t.EXTRA_LARGE_DESKTOP = "EXTRA_LARGE_DESKTOP", t))(Gwe || {});
const Uwe = () => {
  const { width: t } = zC();
  return t <= 576 ? {
    size: "SM",
    device: "MOBILE"
    /* MOBILE */
  } : t <= 768 ? {
    size: "MD",
    device: "TABLET"
    /* TABLET */
  } : t <= 992 ? {
    size: "LG",
    device: "NOTEBOOK"
    /* NOTEBOOK */
  } : t <= 1280 ? {
    size: "XL",
    device: "DESKTOP"
    /* DESKTOP */
  } : t <= 1536 ? {
    size: "XL",
    device: "LARGE_DESKTOP"
    /* LARGE_DESKTOP */
  } : {
    size: "XXL",
    device: "EXTRA_LARGE_DESKTOP"
    /* EXTRA_LARGE_DESKTOP */
  };
}, Ywe = "foton__title___fgVXJ", Xwe = "foton__drawerContainerContent___PYaPY", qwe = "foton__slideIn___Do8UP", Kwe = "foton__slideOut___p5yWO", Qwe = "foton__drawerOverlay___0ickf", Jwe = "foton__contentShow___v-TFW", e6e = "foton__contentHide___r-27V", t6e = "foton__icon___KpfUk", o0 = {
  title: Ywe,
  drawerContainerContent: Xwe,
  slideIn: qwe,
  slideOut: Kwe,
  drawerOverlay: Qwe,
  contentShow: Jwe,
  contentHide: e6e,
  icon: t6e
}, $6e = ({ children: t, openDrawer: e, setOpenDrawer: r, title: n }) => /* @__PURE__ */ Z(LE, { open: e, onOpenChange: r, children: [
  /* @__PURE__ */ C(TE, { className: o0.drawerOverlay }),
  /* @__PURE__ */ Z(OE, { className: o0.drawerContainerContent, children: [
    /* @__PURE__ */ C(PE, { children: /* @__PURE__ */ C("span", { onClick: () => {
      r(!1);
    }, children: /* @__PURE__ */ C(Me, { icon: "XMarkIcon", extraClassNames: o0.icon }) }) }),
    /* @__PURE__ */ C(IE, { className: o0.title, children: n }),
    t
  ] })
] }), V6e = {
  useBreakpoints: Uwe
};
export {
  s6e as Accordion,
  C6e as AreaChart,
  M6e as BarChart,
  Gwe as BreakpointsDevice,
  zwe as BreakpointsSize,
  k0 as Button,
  Or as Card,
  O6e as CardNumber,
  T6e as CardProgress,
  F6e as Carousel,
  A6e as ClarkeIcon,
  GC as ColoredIcon,
  $8 as Combobox,
  R6e as DonutChart,
  $6e as Drawer,
  g6e as FabButton,
  B3e as FileInput,
  S6e as GaugeChart,
  lpe as Header,
  Me as HeroIcon,
  gi as IconButton,
  qp as Input,
  E6e as Layout,
  Q7e as LineChart,
  Zne as Menu,
  oie as MenuMobile,
  N6e as Modal,
  L6e as NotificationCard,
  w6e as NuggetInfo,
  P8 as Profile,
  B6e as ProgressBar,
  gge as Scroll,
  m6e as SegmentedButtons,
  I6e as Select,
  _6e as Switch,
  x6e as Table,
  I8 as Tag,
  Gl as TooltipComponent,
  i6e as fotonTailwind,
  V6e as hooks
};
